import "./module.css";
import {createSlice as $cURGa$createSlice, combineReducers as $cURGa$combineReducers, configureStore as $cURGa$configureStore} from "@reduxjs/toolkit";
import {jsx as $cURGa$jsx, jsxs as $cURGa$jsxs, Fragment as $cURGa$Fragment} from "react/jsx-runtime";
import $cURGa$react, {createContext as $cURGa$createContext, useReducer as $cURGa$useReducer, useCallback as $cURGa$useCallback, useMemo as $cURGa$useMemo, useContext as $cURGa$useContext, useRef as $cURGa$useRef, useEffect as $cURGa$useEffect, useState as $cURGa$useState, useLayoutEffect as $cURGa$useLayoutEffect, memo as $cURGa$memo} from "react";
import {sanitize as $cURGa$sanitize} from "dompurify";
import {Logger as $cURGa$Logger, localize as $cURGa$localize, useOutsideClickEffect as $cURGa$useOutsideClickEffect, Global404 as $cURGa$Global404, useResponsiveValueState as $cURGa$useResponsiveValueState} from "@saviynt/common";
import $cURGa$axios from "axios";
import {Cookies as $cURGa$Cookies, useCookies as $cURGa$useCookies} from "react-cookie";
import {Loader as $cURGa$Loader, InputField as $cURGa$InputField, Icon as $cURGa$Icon, ButtonIcon as $cURGa$ButtonIcon, Tooltip as $cURGa$Tooltip, LottiePlayer as $cURGa$LottiePlayer, Button as $cURGa$Button, ModalIsland as $cURGa$ModalIsland, Illustration as $cURGa$Illustration, Chip as $cURGa$Chip, ToggleButtonGroup as $cURGa$ToggleButtonGroup, ToggleButton as $cURGa$ToggleButton, Box as $cURGa$Box, useTooltipText as $cURGa$useTooltipText, ButtonSelect as $cURGa$ButtonSelect, InlineMessage as $cURGa$InlineMessage, Menu as $cURGa$Menu, Typography as $cURGa$Typography, TableSortable as $cURGa$TableSortable, Link as $cURGa$Link, AlertBanner as $cURGa$AlertBanner, OverlayProvider as $cURGa$OverlayProvider, SkeletonLoader as $cURGa$SkeletonLoader, FooterActionBar as $cURGa$FooterActionBar, Switch as $cURGa$Switch, Avatar as $cURGa$Avatar, ApplicationIcon as $cURGa$ApplicationIcon, Badge as $cURGa$Badge, Popover as $cURGa$Popover, TabContent as $cURGa$TabContent, MenuMulti as $cURGa$MenuMulti, MenuItem as $cURGa$MenuItem, Checkbox as $cURGa$Checkbox, TabGroup as $cURGa$TabGroup, TabItem as $cURGa$TabItem, SidePanel as $cURGa$SidePanel, DateAndTimePicker as $cURGa$DateAndTimePicker} from "@saviynt/ispm-design-system";
import {useIntl as $cURGa$useIntl} from "react-intl";
import $cURGa$classnames from "classnames";
import {useDispatch as $cURGa$useDispatch, useSelector as $cURGa$useSelector} from "react-redux";
import {useQuery as $cURGa$useQuery, useMutation as $cURGa$useMutation, QueryClient as $cURGa$QueryClient, QueryClientProvider as $cURGa$QueryClientProvider} from "@tanstack/react-query";
import {format as $cURGa$format} from "sql-formatter";
import {toPng as $cURGa$toPng} from "html-to-image";
import $cURGa$vegaembed from "vega-embed";
import {useHistory as $cURGa$useHistory, Switch as $cURGa$Switch1, Route as $cURGa$Route} from "react-router-dom";
import {VegaLite as $cURGa$VegaLite} from "react-vega";
import {select as $cURGa$select} from "d3";

const $c08172123993c9f9$export$c5a7bfe2fe9f01d4 = {
    conversationId: null,
    messageId: null,
    text: ""
};



const $27fb994cf82006a6$var$initialState = {
    messageId: null,
    conversationId: null
};
const $27fb994cf82006a6$var$copilotSlice = (0, $cURGa$createSlice)({
    name: "ispmCopilot",
    initialState: $27fb994cf82006a6$var$initialState,
    reducers: {
        setMessageId: (state, action)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.messageId = action.payload;
        },
        setConversationId: (state, action)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.conversationId = action.payload;
        },
        // Reset all state to initial
        resetCopilotContext: ()=>$27fb994cf82006a6$var$initialState
    }
});
const { setConversationId: $27fb994cf82006a6$export$58213391a19e392, setMessageId: $27fb994cf82006a6$export$a175e86c8914494f, resetCopilotContext: $27fb994cf82006a6$export$c532342b9f4e5a00 } = $27fb994cf82006a6$var$copilotSlice.actions;
var $27fb994cf82006a6$export$2e2bcd8739ae039 = $27fb994cf82006a6$var$copilotSlice.reducer;









const $8ff2252602deef38$export$ec8a6426516240fc = window.location.hostname === "localhost" || window.location.hostname === "loopback" || window.location.port.startsWith("300");
function $8ff2252602deef38$export$1519e7005d222d47(str) {
    if (!str || str.length === 0) return false;
    if (str === "true") return true;
    if (str === "false") return false;
    throw new Error("Invalid input: must be 'true' or 'false'");
}
function $8ff2252602deef38$export$bef94a5618bf18bf(url) {
    if (!url || url.length === 0) return false;
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    return urlPattern.test(url);
}
const $8ff2252602deef38$var$CHATBOT_BASE_URL = `${window.location.origin}/ECMv6/api/ispm`;
const $8ff2252602deef38$var$COPILOT_BASE_URL = `${window.location.origin}/ECMv6/api/copilot/v1/chat`;
const $8ff2252602deef38$export$39a0dbedf3ff0424 = "/ECMv6/identityMatchAndMerge/home";
let $8ff2252602deef38$var$config = {
    BASE_URL_ISPM_NHI: ""
};
const $8ff2252602deef38$export$9e36388f371f5829 = (env)=>{
    $8ff2252602deef38$var$config = {
        ...$8ff2252602deef38$var$config,
        ...env
    };
};
const $8ff2252602deef38$export$c5ec815c70e9c37a = ()=>$8ff2252602deef38$var$config.BASE_URL_ISPM_NHI && $8ff2252602deef38$var$config.BASE_URL_ISPM_NHI.length > 0 ? `${$8ff2252602deef38$var$config.BASE_URL_ISPM_NHI}/ECMv6/api` : `${window.location.origin}/ECMv6/api`;
const $8ff2252602deef38$export$50c4654fc4355968 = 100;
const $8ff2252602deef38$export$f106b8109d5aa095 = 5000;
const $8ff2252602deef38$export$49f8c0682d814829 = 500;
const $8ff2252602deef38$export$d57962bd0a7623ea = ":userId";
const $8ff2252602deef38$export$4ce9b36f5872a886 = ":accountId";
const $8ff2252602deef38$export$cd4e913e17de0f = ":filterId";
const $8ff2252602deef38$export$89bbc91416db6670 = ":eventId";
const $8ff2252602deef38$export$798e79f5d60ac5ed = 4;
const $8ff2252602deef38$export$ca6dda5263526f75 = "/ECMv6/api/idw/resource/image/app/";
const $8ff2252602deef38$export$9c04fe193594da37 = (imageId)=>{
    if (!imageId) return "";
     // Handle empty or undefined imageId
    return imageId.startsWith("http") ? imageId : `${$8ff2252602deef38$export$ca6dda5263526f75}${imageId}`;
};
const $8ff2252602deef38$var$isHTMLString = (str)=>{
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node)=>node.nodeType === 1);
};
function $8ff2252602deef38$export$881f1645f5c6e7a7({ htmlString: htmlString }) {
    const sanitizedHtml = (0, $cURGa$sanitize)(htmlString, {
        ALLOWED_TAGS: [
            "b",
            "i",
            "em",
            "span",
            "strong",
            "a",
            "div"
        ],
        ALLOWED_ATTR: [
            "href"
        ]
    });
    return $8ff2252602deef38$var$isHTMLString(htmlString) ? // TODO: Need to move this method to common package in workspace. and use a library like `html-react-parser`
    // eslint-disable-next-line react/no-danger
    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: sanitizedHtml
        }
    }) : htmlString;
}
const $8ff2252602deef38$export$3bd61fd385cbb93e = ()=>({
        INSIGHTS_IGA_TAB: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/insights/iga`,
        INSIGHTS_AND_ANALYTICS_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/metrics`,
        IDENTITY_INSIGHTS_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/insights`,
        RECOMMENDATIONS_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/recommendation`,
        GOVERNANCE_INSIGHTS_CERTS_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/posture-insights/governance/dashboard`,
        GOVERNANCE_INSIGHTS_CERTS_REVOCATION_CAMPAIGN_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/revocations/campaigns`,
        GOVERNANCE_INSIGHTS_CERTS_REVOCATION_SUMMARYCARD_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/revocations/stats`,
        GOVERNANCE_INSIGHTS_ACCESS_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/posture-insights/access-data/dashboard`,
        GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_CAMPAIGN_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/expiring/campaigns`,
        GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_SUMMARYCARD_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/expiring/campaigns/stats`,
        GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_CAMPAIGN_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/snapshot/campaigns`,
        GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_SUMMARYCARD_ENDPOINT: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/governance/certifications/snapshot/stats`
    });
const $8ff2252602deef38$export$b370277fd33ab630 = ()=>({
        USER_TIMELINE_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}/timeline`,
        USER_FAT_ACCESS_PATH_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/access-path/user/${$8ff2252602deef38$export$d57962bd0a7623ea}/accounts?slim=false`,
        USER_ACCESS_PATH_ACCOUNT_LIST_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/access-path/user/${$8ff2252602deef38$export$d57962bd0a7623ea}/accounts`,
        USER_ACCESS_PATH_ACCOUNT_DETAIL_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/access-path/user/${$8ff2252602deef38$export$d57962bd0a7623ea}/account/${$8ff2252602deef38$export$4ce9b36f5872a886}`,
        USER_IDENTITY_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity`,
        USER_IDENTITY_BY_ID_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}`,
        IDENTITY_ACCESS_SUMMARY_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}/accessSummary`,
        IDENTITY_FILTERS_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/filters`,
        IDENTITY_FILTER_VALUES_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/filter/values`,
        TIMELINE_FILTER_VALUES_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}/timeline/filters/${$8ff2252602deef38$export$cd4e913e17de0f}/values`,
        SIDE_CAR_ACTIVITIES_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}/timeline/${$8ff2252602deef38$export$89bbc91416db6670}/sidecar/activities`,
        SIDE_CAR_SUMMARY_URL: `${$8ff2252602deef38$export$c5ec815c70e9c37a()}/ispm/v1/identity/${$8ff2252602deef38$export$d57962bd0a7623ea}/timeline/${$8ff2252602deef38$export$89bbc91416db6670}/sidecar/summary`
    });
const $8ff2252602deef38$export$2483ee2755c8377 = `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/v1/user/permissions?include_license_display_info=true`;
const $8ff2252602deef38$export$ce5854d6503a4f78 = `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/v1/tenant/entitlements/check/copilot`;
const $8ff2252602deef38$export$741965b27aa5110d = (useMockServer)=>({
        CHAT_SUGGESTIONS_URL: useMockServer ? `${$8ff2252602deef38$var$COPILOT_BASE_URL}/mock/suggestions` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/suggestions`,
        CHAT_ASK_URL: useMockServer ? `${$8ff2252602deef38$var$COPILOT_BASE_URL}/mock/chat/ask` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/ask`,
        CHAT_ASK_STREAM_URL: useMockServer ? `${$8ff2252602deef38$var$COPILOT_BASE_URL}/mock/chat/ask/stream` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/ask/stream`,
        DATA_SAMPLE_URL: useMockServer ? `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/mock/data/sample` : `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/data/sample`,
        DATA_DOWNLOAD_URL: useMockServer ? `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/mock/data/download` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/messages`,
        DASHBOARD_LIST_URL: useMockServer ? `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/mock/dashboard/list` : `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/dashboard/list`,
        DASHBOARD_URL: useMockServer ? `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/mock/dashboard` : `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/dashboard`,
        RECCOMENDATION_URL: useMockServer ? `${$8ff2252602deef38$var$CHATBOT_BASE_URL}/mock/reccomendation` : "N/A",
        CHAT_FEEDBACK_URL: useMockServer ? `${$8ff2252602deef38$var$COPILOT_BASE_URL}/mock/feedback` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/messages`,
        CHAT_HISTORY_URL: useMockServer ? `${$8ff2252602deef38$var$COPILOT_BASE_URL}/mock/history` : `${$8ff2252602deef38$var$COPILOT_BASE_URL}/history?messagesCount=20&visualisationCount=10`
    });
const $8ff2252602deef38$export$61fc7d43ac8f84b0 = (func, delay)=>{
    let timeoutId = null;
    const debouncedFunction = (...args)=>{
        if (timeoutId !== null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func(...args);
        }, delay);
    };
    debouncedFunction.cancel = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    return debouncedFunction;
};
const $8ff2252602deef38$export$29d95a5fba76aeb4 = "Copy";
const $8ff2252602deef38$export$fac9e12d2d376b6 = "Copied";
const $8ff2252602deef38$export$631fa4d8cbe19f59 = 3000;
const $8ff2252602deef38$export$a0fedebb9f9d9205 = (l)=>({
        [l("Analyzing Data...")]: [
            " "
        ]
    });
const $8ff2252602deef38$export$978a778a4893a71a = (l)=>({
        [l("Generating SQL")]: [
            l("Capturing user input"),
            l("Identifying schema")
        ],
        [l("Generating Table Data")]: [
            l("Executing SQL"),
            l("Fetching data")
        ]
    });
const $8ff2252602deef38$export$7c5865ddae060245 = (l)=>{
    const generatingContentLoadingMsgs = $8ff2252602deef38$export$a0fedebb9f9d9205(l);
    const generatingContentLoadingMsgsForTesting = $8ff2252602deef38$export$978a778a4893a71a(l);
    return generatingContentLoadingMsgs;
};
const $8ff2252602deef38$export$73bab687a662941a = ()=>$8ff2252602deef38$export$f106b8109d5aa095;
const $8ff2252602deef38$export$7401928161f894d4 = 100; // Adjust scroll visibility threshold (in px)
const $8ff2252602deef38$export$19c67bce64a84510 = [
    "80PercentWidth",
    "30PercentWidth",
    "80PercentWidth",
    "50PercentWidth",
    "80PercentWidth",
    "40PercentWidth",
    "80PercentWidth",
    "30PercentWidth",
    "80PercentWidth"
];
const $8ff2252602deef38$export$40d87027a9f6fd1c = 800;
const $8ff2252602deef38$export$c836f42be213d87c = 8;
const $8ff2252602deef38$export$bb71cd537d29e96c = 16;
const $8ff2252602deef38$export$db483fdae44ebd03 = 250;
const $8ff2252602deef38$export$8fec9643a87f15ca = 180000; // 3 minutes
const $8ff2252602deef38$export$6d85febd8168744c = 300000; // 5 minutes in milliseconds
const $8ff2252602deef38$export$ba157c81a75b4920 = 260;
var $8ff2252602deef38$export$b718b0d2e31b8ab7;
(function(SeverityTypeEnum) {
    SeverityTypeEnum["critical"] = "critical";
    SeverityTypeEnum["High"] = "high";
    SeverityTypeEnum["Medium"] = "medium";
    SeverityTypeEnum["Low"] = "low";
})($8ff2252602deef38$export$b718b0d2e31b8ab7 || ($8ff2252602deef38$export$b718b0d2e31b8ab7 = {}));
var $8ff2252602deef38$export$2a4af54e34d28b63;
(function(FeedbackTypeEnum) {
    FeedbackTypeEnum["like"] = "like";
    FeedbackTypeEnum["dislike"] = "dislike";
})($8ff2252602deef38$export$2a4af54e34d28b63 || ($8ff2252602deef38$export$2a4af54e34d28b63 = {}));
const $8ff2252602deef38$export$6a9978fc3f20cdf0 = 10;
const $8ff2252602deef38$export$fe10ecaa6c2229c0 = {
    accounts: {
        color: "#0294F7",
        offset1: "rgba(2, 148, 247, 0.3)",
        offset2: "rgba(2, 148, 247, 0)"
    },
    applications: {
        color: "#D057FF",
        offset1: "rgba(208, 87, 255, 0.3)",
        offset2: "rgba(208, 87, 255, 0)"
    }
};
const $8ff2252602deef38$export$3c823f97330055c9 = {
    data: [
        {
            text: "Top 15 managers with the most reportees",
            category: "management",
            id: "CS-733486969"
        },
        {
            text: "Top 10 users with the most active accounts",
            category: "accounts",
            id: "CS-1896386366"
        },
        {
            text: "Top 10 users with the most inactive accounts",
            category: "accounts",
            id: "CS-1909787641"
        },
        {
            text: "Top 10 users with the most inactive roles",
            category: "roles",
            id: "CS-1328255094"
        }
    ]
};
// Helper function to truncate a number to given decimal places
const $8ff2252602deef38$var$truncateToDecimal = (value, decimalPlaces = 1)=>{
    const factor = 10 ** decimalPlaces;
    return Math.floor(value * factor) / factor;
};
const $8ff2252602deef38$export$6dbb2be3cc20ac53 = (number, decimalPlaces = 1)=>{
    if (!number) return "0";
    const absNumber = Math.abs(number);
    if (absNumber >= 1e9) {
        const truncated = $8ff2252602deef38$var$truncateToDecimal(number / 1e9, decimalPlaces);
        return `${truncated.toString()}B`;
    }
    if (absNumber >= 1e6) {
        const truncated = $8ff2252602deef38$var$truncateToDecimal(number / 1e6, decimalPlaces);
        return `${truncated.toString()}M`;
    }
    if (absNumber >= 1e3) {
        const truncated = $8ff2252602deef38$var$truncateToDecimal(number / 1e3, decimalPlaces);
        return `${truncated.toString()}K`;
    }
    return $8ff2252602deef38$var$truncateToDecimal(number, decimalPlaces).toString();
};
const $8ff2252602deef38$export$163141b91a9d3a48 = (change)=>{
    if (change > 0) return "+";
    return "";
};
const $8ff2252602deef38$export$278437eb5dd4122c = (change)=>{
    const changeSign = $8ff2252602deef38$export$163141b91a9d3a48(change);
    if (!change) return "0%";
    if (Math.abs(change) < 0.1) return `${changeSign || "-"} <0.1%`;
    return `${changeSign} ${change.toFixed(1)}%`;
};





/**
 * The customLogger object serves as a custom wrapper around the Logger from @saviynt/common, 
 * replicating its logging methods (info, warn, error, etc.) while allowing the flexibility to 
 * introduce additional custom logic. By dynamically mapping all methods from Logger, 
 * customLogger enables you to call logging functions in the same way (customLogger.info(...)), 
 * making it easy to extend or modify logging behavior without changing the core API.

 * Key Benefits:
 * Event Validation: Allows you to implement specific logic to validate or modify events before logging, ensuring 
 *              that events are correctly processed according to your application's needs.
 * Chaining: You can create logs like Logger.info().error() and so on
 * Consistency: Maintains the same API as the original Logger, allowing you to use customLogger seamlessly 
 *              without modifying existing log calls.
 * Extensibility: Acts as a centralized point to introduce custom logic for logging, such as additional checks 
 *              or processing before calling the Logger method.
 * Dynamic Updates: Automatically maps methods from Logger, ensuring that any updates or new methods are 
 *              reflected in customLogger without manual intervention.
 */ // Pass this event to common logger. We can write specific logic there if log event is coming from ispm
const $68023e09bcf60e96$var$event = "ispm-event";
// Initialise an object to create your logger. It will be used by array reducer function
const $68023e09bcf60e96$var$LoggerInit = {};
// Create an object that behaves like Logger
const $68023e09bcf60e96$var$Logger = Object.keys((0, $cURGa$Logger)).reduce((acc, key)=>{
    const fn = key;
    // Check if the Logger key is a function
    if (typeof (0, $cURGa$Logger)[fn] === "function") // Create a proxy method on customLogger
    acc[fn] = (...data)=>{
        (0, $cURGa$Logger)[fn]($68023e09bcf60e96$var$event, ...data); // Call the original Logger method with multiple arguments
        return acc;
    };
    return acc;
}, $68023e09bcf60e96$var$LoggerInit);
var $68023e09bcf60e96$export$2e2bcd8739ae039 = $68023e09bcf60e96$var$Logger;





class $b61aec14f139c0af$export$2e2bcd8739ae039 extends Error {
    constructor(code, message, originalError){
        super(message);
        this.code = code;
        this.originalError = originalError;
        Object.setPrototypeOf(this, $b61aec14f139c0af$export$2e2bcd8739ae039.prototype);
    }
}


const $eef70c85d72aa603$export$5bbd851fc4d41f2f = {
    HEADER: "header",
    EXPONENTIAL: "exponential"
};
const $eef70c85d72aa603$export$ac63876658e9bcb5 = {
    UNAUTHORIZED: "UNAUTHORIZED",
    ABORTED: "ABORTED",
    RATE_LIMITED: "RATE_LIMITED",
    RETRY_EXHAUSTED: "RETRY_EXHAUSTED",
    UNEXPECTED_FORMAT: "UNEXPECTED_FORMAT",
    HTTP_ERROR: "HTTP_ERROR",
    NETWORK_ERROR: "NETWORK_ERROR",
    UNKNOWN: "UNKNOWN"
};


class $c39f0bc9a2002995$export$2e2bcd8739ae039 extends (0, $b61aec14f139c0af$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $eef70c85d72aa603$export$ac63876658e9bcb5).ABORTED, "Request aborted");
        Object.setPrototypeOf(this, $c39f0bc9a2002995$export$2e2bcd8739ae039.prototype);
    }
}





class $78cc6b7b57a4e4aa$export$2e2bcd8739ae039 extends (0, $b61aec14f139c0af$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $eef70c85d72aa603$export$ac63876658e9bcb5).RETRY_EXHAUSTED, "Maximum retries exceeded");
        Object.setPrototypeOf(this, $78cc6b7b57a4e4aa$export$2e2bcd8739ae039.prototype);
    }
}




class $7b86ab419d6f5a2e$export$2e2bcd8739ae039 extends (0, $b61aec14f139c0af$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $eef70c85d72aa603$export$ac63876658e9bcb5).UNAUTHORIZED, "Unauthorized access");
        Object.setPrototypeOf(this, $7b86ab419d6f5a2e$export$2e2bcd8739ae039.prototype);
    }
}




class $f3b08586e442149f$export$2e2bcd8739ae039 extends (0, $b61aec14f139c0af$export$2e2bcd8739ae039) {
    constructor(){
        super((0, $eef70c85d72aa603$export$ac63876658e9bcb5).UNEXPECTED_FORMAT, "Unexpected response format");
        Object.setPrototypeOf(this, $f3b08586e442149f$export$2e2bcd8739ae039.prototype);
    }
}


const $87464e6d2e7fbff1$export$a33b0d78a5ef829 = {
    maxRetries: 5,
    baseDelay: 1000,
    maxDelay: 30000,
    manualRetryThreshold: 30000
};


function* $c29b43e1aed0aa33$export$790af6279e6aa506(config = {}) {
    const effectiveConfig = {
        ...(0, $87464e6d2e7fbff1$export$a33b0d78a5ef829),
        ...config
    };
    let retryCount = 0;
    while(retryCount < effectiveConfig.maxRetries){
        const rateLimitInfo = yield retryCount;
        retryCount += 1;
        // check header
        if (rateLimitInfo.strategy === "header" && rateLimitInfo.retryAfter) {
            const retryAfterMs = rateLimitInfo.retryAfter * 1000;
            if (retryAfterMs >= effectiveConfig.maxDelay) return; // Terminate generator
            yield retryAfterMs;
        } else {
            // else exponential backoff
            const calculatedDelay = effectiveConfig.baseDelay * 2 ** retryCount;
            if (calculatedDelay >= effectiveConfig.maxDelay) return; // Terminate generator
            yield calculatedDelay;
        }
    }
}



const $09eb0c2e34916250$var$cookies = new (0, $cURGa$Cookies)();
function $09eb0c2e34916250$export$2dabafa86f11ed64(data, typeGuard) {
    return typeGuard(data);
}
async function $09eb0c2e34916250$export$adb4bb4243526aef(url, options, typeGuard, signal, config) {
    const retryGenerator = (0, $c29b43e1aed0aa33$export$790af6279e6aa506)(config);
    let retryInfo = {
        strategy: (0, $eef70c85d72aa603$export$5bbd851fc4d41f2f).EXPONENTIAL,
        retryCount: 0
    };
    const controller = signal ? {
        signal: signal
    } : new AbortController();
    const effectiveSignal = controller.signal;
    // Token is added from cookies dynamically for each request
    const token = $09eb0c2e34916250$var$cookies.get("access_token");
    // passing true to while loop - to handle 429 retry call.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, no-constant-condition
    while(true){
        const { value: retryCount, done: done } = retryGenerator.next(retryInfo);
        if (done) throw new (0, $78cc6b7b57a4e4aa$export$2e2bcd8739ae039)();
        try {
            // We intentionally await between retries to respect rate limits (e.g., exponential backoff or Retry-After header).
            // Parallel execution is not appropriate here since retries must happen sequentially with delay between attempts.
            // eslint-disable-next-line no-await-in-loop
            const response = await (0, $cURGa$axios)({
                url: url,
                ...options,
                signal: effectiveSignal,
                headers: {
                    "Content-Type": "application/json",
                    tenantId: "dummy-tenant-id",
                    ...options.headers ?? {},
                    Authorization: `Bearer ${token}`
                }
            });
            if (!$09eb0c2e34916250$export$2dabafa86f11ed64(response.data, typeGuard)) throw new (0, $f3b08586e442149f$export$2e2bcd8739ae039)();
            return response.data;
        } catch (err) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("apiClient -> fetchApi - Error fetching API:", {
                err: err
            });
            if (err instanceof (0, $f3b08586e442149f$export$2e2bcd8739ae039)) // handle error
            throw err;
            // Handle abort first
            if ((0, $cURGa$axios).isCancel(err)) throw new (0, $c39f0bc9a2002995$export$2e2bcd8739ae039)();
            if (!(0, $cURGa$axios).isAxiosError(err)) throw err;
            if (err.response?.status === 401) {
                // redirect to login page
                window.location.href = window.location.origin;
                // throw an error that can be caught by consuming code if needed
                throw new (0, $7b86ab419d6f5a2e$export$2e2bcd8739ae039)();
            }
            if (err.response?.status !== 429) throw new (0, $b61aec14f139c0af$export$2e2bcd8739ae039)(err.response?.status ? err.response.status.toString() : (0, $eef70c85d72aa603$export$ac63876658e9bcb5).UNKNOWN, err instanceof Error ? err.message : "Unknown error occurred", err);
            const retryAfter = err.response.headers["retry-after"] ? Number(err.response.headers["retry-after"]) : undefined;
            retryInfo = {
                strategy: retryAfter ? "header" : "exponential",
                retryAfter: retryAfter,
                retryCount: retryCount,
                lastError: err
            };
            const { value: delay, done: retriesExhausted } = retryGenerator.next(retryInfo);
            if (retriesExhausted) throw new (0, $78cc6b7b57a4e4aa$export$2e2bcd8739ae039)();
            // Proper signal handling during delay
            // We intentionally await between retries to respect rate limits (e.g., exponential backoff or Retry-After header).
            // Parallel execution is not appropriate here since retries must happen sequentially with delay between attempts.
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve, reject)=>{
                const timer = setTimeout(resolve, delay);
                signal?.addEventListener("abort", ()=>{
                    clearTimeout(timer);
                    reject(new (0, $c39f0bc9a2002995$export$2e2bcd8739ae039)());
                });
            });
        }
    }
}




const $0d5b88fa22f3ae70$export$d4c72bab9d6cc13a = {
    ispmInputValue: "",
    isChatOverlayVisible: false,
    isIspmEnabled: false,
    isSuggestionVisible: false,
    userQuery: "",
    useMockServerApis: false,
    isMenuPinned: false
};
// Reducer function that infers the key and value types
const $0d5b88fa22f3ae70$var$reducer = (state, action)=>({
        ...state,
        [action.type]: action.value
    });
// Create the context with a default value
const $0d5b88fa22f3ae70$var$IspmContext = /*#__PURE__*/ (0, $cURGa$createContext)(undefined);
function $0d5b88fa22f3ae70$export$980acd09afd54813({ children: children }) {
    const [ispmState, dispatch] = (0, $cURGa$useReducer)($0d5b88fa22f3ae70$var$reducer, $0d5b88fa22f3ae70$export$d4c72bab9d6cc13a);
    // Function to dispatch actions based on key and value, with no hardcoding
    const updateIspmState = (0, $cURGa$useCallback)((key, value)=>{
        dispatch({
            type: key,
            value: value
        }); // No hardcoded strings!
    }, []);
    // Memoize the context value to avoid unnecessary re-renders
    const value = (0, $cURGa$useMemo)(()=>({
            ispmState: ispmState,
            updateIspmState: updateIspmState
        }), [
        ispmState,
        updateIspmState
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)($0d5b88fa22f3ae70$var$IspmContext.Provider, {
        value: value,
        children: children
    });
}
const $0d5b88fa22f3ae70$export$1c36bb3ceee805ed = ()=>{
    const context = (0, $cURGa$useContext)($0d5b88fa22f3ae70$var$IspmContext);
    if (!context) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("useIspmContext not within an IspmProvider, returning default values.");
        return {
            ispmState: $0d5b88fa22f3ae70$export$d4c72bab9d6cc13a,
            updateIspmState: ()=>{}
        };
    }
    return context;
};




const $6232c3747a1d613b$var$GeneratedContentTypeValues = [
    "generatingContent",
    "table",
    "chart",
    "highConfidence",
    "lowConfidence",
    "SQLError"
];
const $6232c3747a1d613b$export$950a020027fa5a0b = {
    GENERATING_CONTENT: $6232c3747a1d613b$var$GeneratedContentTypeValues[0],
    TABLE: $6232c3747a1d613b$var$GeneratedContentTypeValues[1],
    CHART: $6232c3747a1d613b$var$GeneratedContentTypeValues[2],
    HIGH_CONFIDENCE: $6232c3747a1d613b$var$GeneratedContentTypeValues[3],
    LOW_CONFIDENCE: $6232c3747a1d613b$var$GeneratedContentTypeValues[4],
    SQL_ERROR: $6232c3747a1d613b$var$GeneratedContentTypeValues[5]
};
const $6232c3747a1d613b$export$51ad9cfdf1b80724 = {
    CHART: 1,
    VISUALIZATION: 2,
    SQL: 3
}; // `as const` ensures the object is treated as readonly and exact



const $a66d5c0d230a0c38$export$d4c72bab9d6cc13a = {
    saviInputText: "",
    showGeneratedContent: false,
    messages: [],
    clearChat: false,
    contentPanelKind: (0, $6232c3747a1d613b$export$950a020027fa5a0b).GENERATING_CONTENT,
    contentPanelData: (0, $c08172123993c9f9$export$c5a7bfe2fe9f01d4),
    inputDisabled: false,
    isApiCallInProgress: false,
    isWarningModalOpen: false,
    isDataPanelFullScreen: false,
    dashboardLists: [],
    successAction: undefined
};
// Reducer function that infers the key and value types
const $a66d5c0d230a0c38$var$reducer = (state, action)=>({
        ...state,
        [action.type]: action.value
    });
// Create the context with a default value
const $a66d5c0d230a0c38$var$ChatOverlayContext = /*#__PURE__*/ (0, $cURGa$createContext)(undefined);
function $a66d5c0d230a0c38$export$895d3cdbd46a9ff6({ children: children }) {
    const [chatOverlayState, dispatch] = (0, $cURGa$useReducer)($a66d5c0d230a0c38$var$reducer, $a66d5c0d230a0c38$export$d4c72bab9d6cc13a);
    // Function to dispatch actions based on key and value, with no hardcoding
    const updateChatOverlayState = (0, $cURGa$useCallback)((key, value)=>{
        dispatch({
            type: key,
            value: value
        }); // No hardcoded strings!
    }, []);
    // Memoize the context value to avoid unnecessary re-renders
    const value = (0, $cURGa$useMemo)(()=>({
            chatOverlayState: chatOverlayState,
            updateChatOverlayState: updateChatOverlayState
        }), [
        chatOverlayState,
        updateChatOverlayState
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)($a66d5c0d230a0c38$var$ChatOverlayContext.Provider, {
        value: value,
        children: children
    });
}
const $a66d5c0d230a0c38$export$d205fc98d1ecdbce = ()=>{
    const context = (0, $cURGa$useContext)($a66d5c0d230a0c38$var$ChatOverlayContext);
    if (!context) throw new Error("useChatOverlayContext must be used within an ChatOverlayProvider");
    return context;
};




const $4402fe0eef725aae$export$d4c72bab9d6cc13a = {};
// Reducer function that infers the key and value types
const $4402fe0eef725aae$var$reducer = (state, action)=>({
        ...state,
        [action.type]: action.value
    });
// Create the context with a default value
const $4402fe0eef725aae$var$IspmErrorContext = /*#__PURE__*/ (0, $cURGa$createContext)(undefined);
function $4402fe0eef725aae$export$c2ba84d3b46f6625({ children: children }) {
    const [ispmErrorState, dispatch] = (0, $cURGa$useReducer)($4402fe0eef725aae$var$reducer, $4402fe0eef725aae$export$d4c72bab9d6cc13a);
    // Function to dispatch actions based on key and value, with no hardcoding
    const updateIspmErrorState = (0, $cURGa$useCallback)((key, value)=>{
        dispatch({
            type: key,
            value: value
        }); // No hardcoded strings!
    }, []);
    // Memoize the context value to avoid unnecessary re-renders
    const value = (0, $cURGa$useMemo)(()=>({
            ispmErrorState: ispmErrorState,
            updateIspmErrorState: updateIspmErrorState
        }), [
        ispmErrorState,
        updateIspmErrorState
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)($4402fe0eef725aae$var$IspmErrorContext.Provider, {
        value: value,
        children: children
    });
}
const $4402fe0eef725aae$export$7975d440ef8e87a = ()=>{
    const context = (0, $cURGa$useContext)($4402fe0eef725aae$var$IspmErrorContext);
    if (!context) throw new Error("useIspmErrorContext must be used within an IspmErrorProvider");
    return context;
};




const $08bb17136b599311$var$AbortControllerContext = /*#__PURE__*/ (0, $cURGa$createContext)(null);
function $08bb17136b599311$export$88fc6c4dc1f0adcc({ children: children }) {
    const controllerRef = (0, $cURGa$useRef)(null);
    const value = (0, $cURGa$useMemo)(()=>({
            controllerRef: controllerRef
        }), [
        controllerRef
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)($08bb17136b599311$var$AbortControllerContext.Provider, {
        value: value,
        children: children
    });
}
const $08bb17136b599311$export$4db023b7660421fa = ()=>{
    const context = (0, $cURGa$useContext)($08bb17136b599311$var$AbortControllerContext);
    if (!context) throw new Error("useAbortController must be used within an AbortControllerProvider");
    return context;
};



const $f618e3351c7ca235$export$be7a380669c72f48 = 4;
const $f618e3351c7ca235$export$73c14af2a262eb05 = "#SEP#";
const $f618e3351c7ca235$export$65cf17a55b364e8 = "Ispm-TimelineItem";
const $f618e3351c7ca235$export$12bfde30afe7dcf1 = [
    {
        query: "(max-width: 599px)",
        value: 110,
        label: "MobileXLarge"
    },
    {
        query: "(max-width: 833px)",
        value: 100,
        label: "TabletMedium"
    }
];
const $f618e3351c7ca235$export$98e7b536029f5094 = {
    IDENTITY_SOURCE: "Identity Source",
    EMPLOYEE_ID: "Employee ID",
    JOB_TITLE: "Job Title",
    EMPLOYEE_TYPE: "Employee Type",
    USERNAME: "Username"
};
const $f618e3351c7ca235$export$33936cb096312b35 = {
    RESOURCE: "Resource",
    OWNER: "Owner",
    TRUST: "Trust",
    DISCOVERED: "Discovered"
};
const $f618e3351c7ca235$export$1223afa8114de519 = {
    humans: Object.values($f618e3351c7ca235$export$98e7b536029f5094),
    machines: Object.values($f618e3351c7ca235$export$33936cb096312b35)
};
var $f618e3351c7ca235$export$5d73826f230727a6;
(function(CustomizeViewTabs) {
    CustomizeViewTabs["HUMANS"] = "humans";
    CustomizeViewTabs["MACHINES"] = "machines";
})($f618e3351c7ca235$export$5d73826f230727a6 || ($f618e3351c7ca235$export$5d73826f230727a6 = {}));
const $f618e3351c7ca235$export$d95b5f8ae12844bf = 3;


const $8939fb7be58f56d0$var$initialState = {
    selectedUser: undefined,
    customizeViewFields: {
        ...(0, $f618e3351c7ca235$export$1223afa8114de519)
    }
};
const $8939fb7be58f56d0$var$identitySlice = (0, $cURGa$createSlice)({
    name: "identity",
    initialState: $8939fb7be58f56d0$var$initialState,
    reducers: {
        setselectedUser: (state, action)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.selectedUser = action.payload;
        },
        // Reset all state to initial
        resetIdentityState: ()=>$8939fb7be58f56d0$var$initialState,
        setCustomizeViewFields: (state, action)=>{
            // eslint-disable-next-line no-param-reassign
            state.customizeViewFields[action.payload.tab] = action.payload.fields;
        },
        resetCustomizeViewFields: (state)=>{
            // eslint-disable-next-line no-param-reassign
            state.customizeViewFields = {
                humans: [
                    ...$8939fb7be58f56d0$var$initialState.customizeViewFields.humans
                ],
                machines: [
                    ...$8939fb7be58f56d0$var$initialState.customizeViewFields.machines
                ]
            };
        }
    }
});
const { setselectedUser: $8939fb7be58f56d0$export$6d06ea42ee2ef64, resetIdentityState: $8939fb7be58f56d0$export$a48d3e6407bbda0d, setCustomizeViewFields: $8939fb7be58f56d0$export$618dc9a39f8a471c, resetCustomizeViewFields: $8939fb7be58f56d0$export$d5d220339cb95d48 } = $8939fb7be58f56d0$var$identitySlice.actions;
var $8939fb7be58f56d0$export$2e2bcd8739ae039 = $8939fb7be58f56d0$var$identitySlice.reducer;



const $e7b59df9ea8eb4ea$var$initialState = {
    showSaviInputInHeader: false
};
const $e7b59df9ea8eb4ea$var$ispmSlice = (0, $cURGa$createSlice)({
    name: "ispm",
    initialState: $e7b59df9ea8eb4ea$var$initialState,
    reducers: {
        setShowSaviInputInHeader: (state, action)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.showSaviInputInHeader = action.payload;
        },
        // Reset all state to initial
        resetIspmState: ()=>$e7b59df9ea8eb4ea$var$initialState
    }
});
const { setShowSaviInputInHeader: $e7b59df9ea8eb4ea$export$6607a8b96012a46d, resetIspmState: $e7b59df9ea8eb4ea$export$d910764b32296744 } = $e7b59df9ea8eb4ea$var$ispmSlice.actions;
var $e7b59df9ea8eb4ea$export$2e2bcd8739ae039 = $e7b59df9ea8eb4ea$var$ispmSlice.reducer;



const $01a22c0ef0c16d4a$export$b05a9bf47c1f6958 = {
    EQ: "EQ",
    IN: "IN"
};
const $01a22c0ef0c16d4a$export$bb86ee402385b2d6 = {
    ASC: "ASC",
    DESC: "DESC"
};



const $1d3288d13a1a1df7$export$bd8b1d638ec01b5f = {
    ACCESS_REQUEST: "ACCESS_REQUEST",
    USER_ATTRIBUTES_CHANGE: "USER_ATTRIBUTES_CHANGE",
    OWNER_ENTITLEMENT_CHANGE: "OWNER_ENTITLEMENT_CHANGE",
    OWNER_APPLICATION_CHANGE: "OWNER_APPLICATION_CHANGE",
    ACCESS: "ACCESS",
    CERTIFICATION: "CERTIFICATION",
    RULE_TRIGGER: "RULE_TRIGGER"
};
const $1d3288d13a1a1df7$export$67c3899dbcdb9c37 = {
    ADD: "ADD",
    REMOVE: "REMOVE"
};
const $1d3288d13a1a1df7$export$8aa510828f6962f3 = {
    ADD: "Add",
    REMOVE: "Remove",
    UPDATE: "Update"
};
const $1d3288d13a1a1df7$export$9b546f7bc7594956 = {
    BIRTHRIGHT_RULE: "Birthright Rule",
    USER_UPDATE_RULE: "User Update Rule"
};
const $1d3288d13a1a1df7$export$58ae321f0d7a32a8 = {
    ENTITLEMENT: "ENTITLEMENT",
    ROLE: "ROLE",
    ACCOUNT: "ACCOUNT",
    ORGANIZATION: "ORGANIZATION",
    USER: "USER",
    RULE: "RULE",
    ROLEBASEDENTITLEMENT: "ROLE_BASED_ENTITLEMENT",
    FFID: "FFID",
    FFIDACCESS: "FFID_ACCESS",
    T2P: "T2P",
    ORGANIZATIONBASEDROLE: "ORGANIZATION_BASED_ROLE",
    ORGANIZATIONBASEDENTITLEMENT: "ORGANIZATION_BASED_ENTITLEMENT",
    ORGANIZATIONBASEDASSOCIATEDENTITLEMENT: "ORGANIZATION_BASED_ASSOCIATED_ENTITLEMENT",
    ORGANIZATIONBASEDENDPOINT: "ORGANIZATION_BASED_ENDPOINT",
    ORGANIZATIONBASEDOWNER: "ORGANIZATION_BASED_OWNER",
    BULKUSERUPLOAD: "BULK_USER_UPLOAD"
};
const $1d3288d13a1a1df7$export$e941d2741632791c = {
    ADD: "Add",
    DELETE: "Delete"
};
const $1d3288d13a1a1df7$export$22bafe9b8f865bcb = {
    Certification: "Certification",
    UserUpdateRule: "User Update Rule",
    BirthrightRule: "Birthright Rule",
    OutOfBand: "Out Of Band"
};
const $1d3288d13a1a1df7$export$6224a42e8b66c937 = {
    AccessAdded: "Access Added",
    AccessRemoved: "Access Removed",
    PendingAccessProvisioning: "Pending Access Provisioning",
    PendingAccessDeprovisioning: "Pending Access De-provisioning",
    AccessRejected: "Access Rejected",
    AccessProvisionFailed: "Access Provision Failed",
    AccessProvisionError: "Access Provision Error"
};
const $1d3288d13a1a1df7$export$bb37a0268154d48c = {
    APPROVED: "Approved",
    REJECTED: "Rejected",
    PENDING: "Pending"
};
const $1d3288d13a1a1df7$export$a25b33e9b93d2d85 = {
    NEW: "New",
    COMPLETED: "Complete",
    INPROGRESS: "In Progress",
    NO_ACTION_REQUIRED: "No Action Required",
    ERROR: "Error",
    PROVISION_FAILED: "Provision Failed"
};
const $1d3288d13a1a1df7$export$600e7c1f9e0414e1 = {
    REJECTED: "REJECTED",
    COMPLETED: "COMPLETED",
    DISCONTINUE: "DISCONTINUE",
    FAILED: "FAILED",
    ERROR: "ERROR",
    PENDING: "PENDING",
    IN_PROGRESS: "IN PROGRESS"
};
const $1d3288d13a1a1df7$export$dde867dc2e19cdfb = {
    DEFAULT: "default",
    APPROVED: "Access Approved",
    REQUESTED: "Access Requested",
    PENDING_EXECUTION: "Pending Execution",
    PENDING_APPROVAL: "Pending Approval",
    PENDING_PROVISIONING: "Pending Provisioning",
    PENDING_ACCESS_DEPROVISIONING: "Pending Access De-Provisioning",
    TASKCREATED: "Task Created",
    CERTIFICATION_COMPLETED: "Certification Completed"
};
const $1d3288d13a1a1df7$export$bb115dbb5c52277f = {
    removed: "removed",
    added: "added",
    pendingAdd: "pendingAdd",
    pendingDelete: "pendingDelete",
    check: "check",
    time: "time",
    update: "update",
    error: "error",
    failed: "failed",
    unknown: "unknown",
    trigger: "trigger",
    reject: "reject",
    certificationCompleted: "certificationCompleted",
    certificationPending: "certificationPending"
};





const $44de1ef6914f57b9$export$648c3bb98a25624b = (status)=>{
    const errorStatuses = new Set([
        (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).ERROR,
        (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).FAILED,
        (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).DISCONTINUE
    ]);
    return errorStatuses.has(status);
};
const $44de1ef6914f57b9$export$9a737817ea506705 = (requestType, labels)=>requestType === (0, $1d3288d13a1a1df7$export$67c3899dbcdb9c37).REMOVE.toUpperCase() ? labels.PENDING_ACCESS_REMOVAL : labels.PENDING_ACCESS_ADDITION;
const $44de1ef6914f57b9$export$f9b0305e03c949cc = (requestType)=>requestType === (0, $1d3288d13a1a1df7$export$67c3899dbcdb9c37).REMOVE.toUpperCase() ? (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).pendingDelete : (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).pendingAdd;
const $44de1ef6914f57b9$export$b496a0c8ea13dbb7 = (status, requestType, labels)=>{
    if (status === (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).REJECTED) return {
        label: labels.ACCESS_REJECTED,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).reject
    };
    if (requestType === (0, $1d3288d13a1a1df7$export$67c3899dbcdb9c37).ADD.toUpperCase()) return {
        label: labels.ACCESS_ADDED,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).added
    };
    if (requestType === (0, $1d3288d13a1a1df7$export$67c3899dbcdb9c37).REMOVE.toUpperCase()) return {
        label: labels.ACCESS_REMOVED,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).removed
    };
    return null;
};




const $413a08a89bb5cfa8$export$1376b46cd95aeff4 = (tasks)=>{
    const uniqueAccounts = new Set();
    const uniqueRoles = new Set();
    const uniqueEntitlements = new Set();
    tasks.forEach((task)=>{
        // Get accounts if available
        const accountIdentifier = task.account?.name || task.account?.key;
        if (accountIdentifier) uniqueAccounts.add(accountIdentifier);
        // Add entitlement if available
        const entitlementIdentifier = task.entitlement?.value || task.entitlement?.type;
        if (entitlementIdentifier) uniqueEntitlements.add(entitlementIdentifier);
        // Get roles if available
        const roleIdentifier = task.role?.name ?? task.role?.key;
        if (roleIdentifier) uniqueRoles.add(roleIdentifier);
    });
    return {
        uniqueAccounts: uniqueAccounts,
        uniqueEntitlements: uniqueEntitlements,
        uniqueRoles: uniqueRoles
    };
};
function $413a08a89bb5cfa8$export$43ff05505a0d6eed(event) {
    const statusChanges = event.request ? event.request.statusChanges : event.accessDetails?.statusChanges;
    const status = event.request ? event.request.status.toUpperCase() : event.accessDetails?.status?.toUpperCase();
    if (statusChanges?.nextAction?.action && statusChanges.nextAction.action.length > 0 && status !== "ERROR" && status !== "FAILED" || status === "PENDING") return true;
    return false;
}
const $413a08a89bb5cfa8$export$6107eae07387fcd = (l)=>({
        ACCESS_ADDED: l("Access Added"),
        ACCESS_REMOVED: l("Access Removed"),
        ACCESS_REJECTED: l("Access Rejected"),
        ACCESS_PROVISION_FAILED: l("Access Provision Failed"),
        PENDING_ACCESS_ADDITION: l("Pending Access Addition"),
        PENDING_ACCESS_REMOVAL: l("Pending Access Removal"),
        APPLICATION_OWNER_ADDED: l("Assigned as Application Owner"),
        APPLICATION_OWNER_REMOVED: l("Unassigned as Application Owner"),
        ENTITLEMENT_OWNER_ASSIGNED: l("Assigned as Entitlement Owner"),
        ENTITLEMENT_OWNER_REMOVED: l("Unassigned as Entitlement Owner"),
        PENDING_CERTIFICATION: l("Pending Certification"),
        CERTIFICATION_COMPLETED: l("Certification Completed"),
        BIRTHRIGHT_RULE_TRIGGER: l("Birthright Rule Trigger"),
        USER_UPDATE_RULE_TRIGGER: l("User Update Rule Trigger"),
        USER_ATTRIBUTE_UPDATE: l("User Attribute Update")
    });
const $413a08a89bb5cfa8$export$e75cf43d5d0a9444 = {
    removed: {
        icon: "Delete",
        colorLight: "coral-700",
        colorDark: "coral-300"
    },
    added: {
        icon: "AddCircle",
        colorDark: "green-500",
        colorLight: "green-500"
    },
    pendingAdd: {
        icon: "AddCircle",
        colorDark: "green-500",
        colorLight: "green-500"
    },
    pendingDelete: {
        icon: "Delete",
        colorLight: "coral-700",
        colorDark: "coral-300"
    },
    check: {
        icon: "check",
        colorLight: "green-300",
        colorDark: "green-300"
    },
    time: {
        icon: "time",
        colorLight: "neutral-200",
        colorDark: "neutral-200"
    },
    update: {
        icon: "Refresh",
        colorLight: "blue-500",
        colorDark: "blue-500"
    },
    error: {
        icon: "AlertCriticalOutline",
        colorLight: "coral-300",
        colorDark: "coral-700"
    },
    failed: {
        icon: "AlertCriticalOutline",
        colorLight: "coral-300",
        colorDark: "coral-700"
    },
    unknown: {
        icon: "AlertCriticalOutline",
        colorLight: "coral-300",
        colorDark: "coral-700"
    },
    trigger: {
        icon: "AddCircle",
        colorDark: "green-500",
        colorLight: "green-500"
    },
    reject: {
        icon: "Reject",
        colorLight: "coral-700",
        colorDark: "coral-300"
    },
    certificationCompleted: {
        icon: "Certification",
        colorLight: "blue-500",
        colorDark: "blue-500"
    },
    certificationPending: {
        icon: "Certification",
        colorLight: "green-500",
        colorDark: "green-500"
    }
};


const $39242309050b57fe$export$ae65b2e880ab4476 = (event)=>{
    let columnNumber = 0;
    const { applications: applications, statusChanges: statusChanges, accessType: accessType, businessJustification: businessJustification } = event.accessDetails;
    const getNextColumn = ()=>columnNumber % (0, $f618e3351c7ca235$export$be7a380669c72f48) + 1;
    const response = [];
    const addSection = (section, defaultColumn)=>{
        if (section) {
            columnNumber = defaultColumn ?? getNextColumn();
            response.push({
                ...section,
                column: columnNumber
            });
        }
    };
    if (applications?.length) addSection($39242309050b57fe$var$createSection("Application", applications));
    addSection($39242309050b57fe$var$getAccessTypeSection(event, getNextColumn));
    if (accessType) addSection($39242309050b57fe$var$createSection("Access Type", [
        accessType
    ]));
    if (businessJustification) addSection($39242309050b57fe$var$createSection("Business Justification", [
        businessJustification
    ]));
    if (statusChanges && (0, $413a08a89bb5cfa8$export$43ff05505a0d6eed)(event)) addSection($39242309050b57fe$var$getStatusHistorySection(statusChanges), 1);
    addSection($39242309050b57fe$var$getFailedProvisioningComments(event));
    $39242309050b57fe$var$getFailedDetailsSections(event).forEach((item)=>{
        addSection(item);
    });
    addSection($39242309050b57fe$var$getAccessRejectedReviewer(event));
    return response;
};
const $39242309050b57fe$var$createSection = (heading, details)=>details?.length ? {
        heading: heading,
        details: details,
        column: 0
    } : null;
const $39242309050b57fe$var$getAccessTypeSection = (event, getNextColumn)=>{
    const { accessType: accessType, entitlements: entitlements, roles: roles, accounts: accounts } = event.accessDetails;
    if (!accessType) return null;
    const accessTypes = accessType.split(",").map((item)=>item.split("(")[0].trim());
    if (accessTypes.length !== 1) return null;
    const accessTypeMap = {
        Account: {
            heading: "Account Names",
            details: accounts ?? []
        },
        Role: {
            heading: "Role Names",
            details: roles ?? []
        },
        Entitlement: {
            heading: "Entitlement Names",
            details: entitlements ?? []
        }
    };
    const selectedAccess = accessTypeMap[accessTypes[0]];
    return selectedAccess.details?.length ? {
        heading: selectedAccess.heading,
        details: selectedAccess.details,
        column: getNextColumn()
    } : null;
};
const $39242309050b57fe$var$getStatusHistorySection = (statusChanges)=>{
    if (!statusChanges || !statusChanges.history.length && !statusChanges.nextAction?.action) return null;
    return {
        heading: "",
        details: [
            ...statusChanges.history.map(({ status: status })=>({
                    icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).check,
                    text: status ?? ""
                })),
            ...statusChanges.nextAction?.action ? [
                {
                    icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).time,
                    text: statusChanges.nextAction.action
                }
            ] : []
        ],
        column: 1
    };
};
const $39242309050b57fe$var$getFailedDetailsSections = (event)=>{
    if (![
        "error",
        "failed"
    ].includes(event.accessDetails.status?.toLowerCase() ?? "")) return [];
    return [
        Array.isArray(event.accessDetails.taskIds) && event.accessDetails.taskIds.length > 0 ? $39242309050b57fe$var$createSection("Task ID", event.accessDetails.taskIds.map((id)=>`#${id}`)) : null,
        event.accessDetails.requestDetails?.requestKey ? $39242309050b57fe$var$createSection("Request ID", [
            `#${event.accessDetails.requestDetails.requestKey}`
        ]) : null
    ].filter(Boolean);
};
const $39242309050b57fe$var$getFailedProvisioningComments = (event)=>event.accessDetails.provisioningComments && [
        "error",
        "failed"
    ].includes(event.accessDetails.status?.toLowerCase() ?? "") ? $39242309050b57fe$var$createSection("Provisioning Comments", [
        event.accessDetails.provisioningComments
    ]) : null;
const $39242309050b57fe$var$getAccessRejectedReviewer = (event)=>event.accessDetails.status?.toLowerCase() === "rejected" && event.accessDetails.requestDetails?.reviewer ? $39242309050b57fe$var$createSection("Reviewed by", [
        event.accessDetails.requestDetails.reviewer.toString()
    ]) : null;



function $2da227a80723acea$export$2e2bcd8739ae039(event, eventTypeLabels) {
    const heading = event.accessDetails.heading?.value;
    const section = (0, $39242309050b57fe$export$ae65b2e880ab4476)(event);
    if (event.accessDetails.status && typeof event.accessDetails.status === "string") {
        const requestStatus = event.accessDetails.status.toUpperCase();
        if ((0, $44de1ef6914f57b9$export$648c3bb98a25624b)(requestStatus)) return {
            label: heading ?? eventTypeLabels.ACCESS_PROVISION_FAILED,
            icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).failed,
            section: section
        };
        if ((0, $413a08a89bb5cfa8$export$43ff05505a0d6eed)(event)) return {
            label: heading ?? (0, $44de1ef6914f57b9$export$9a737817ea506705)(event.accessDetails.type ?? undefined, eventTypeLabels),
            icon: (0, $44de1ef6914f57b9$export$f9b0305e03c949cc)(event.accessDetails.type ?? undefined),
            section: section
        };
        const finalStatus = (0, $44de1ef6914f57b9$export$b496a0c8ea13dbb7)(event.accessDetails.status.toUpperCase(), event.accessDetails.type ?? undefined, eventTypeLabels);
        if (finalStatus) return {
            ...finalStatus,
            section: section,
            ...heading && {
                label: heading
            }
        };
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Timeline event type - Access Request. Unknown event", {
            event: event
        });
    }
    return {
        label: heading ?? event.type,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).unknown,
        section: section
    };
}


// handlers/accessRequestHandler.ts






const $b771a926de35d4ea$var$parseAccessRequestSections = (event)=>{
    let columnNumber = 0;
    const application = event.request.tasks?.[0]?.application?.name ?? "Unknown";
    const { statusChanges: statusChanges } = event.request;
    const { uniqueAccounts: uniqueAccounts, uniqueEntitlements: uniqueEntitlements, uniqueRoles: uniqueRoles } = (0, $413a08a89bb5cfa8$export$1376b46cd95aeff4)(event.request.tasks ?? []);
    const getNextColumn = ()=>columnNumber % (0, $f618e3351c7ca235$export$be7a380669c72f48) + 1; // Keeps column between 1 and 4
    const response = [];
    const addSection = (section, defaultColumn)=>{
        if (section) {
            columnNumber = defaultColumn ?? getNextColumn();
            response.push({
                ...section,
                column: columnNumber
            });
        }
    };
    addSection($b771a926de35d4ea$var$getApplicationSection(application, columnNumber));
    addSection($b771a926de35d4ea$var$getAccessTypeSection(uniqueAccounts, uniqueEntitlements, uniqueRoles, columnNumber));
    addSection($b771a926de35d4ea$var$getAccessTypeDetails(uniqueAccounts, uniqueEntitlements, uniqueRoles, columnNumber));
    addSection($b771a926de35d4ea$var$getBusinessJustificationSection(event.request.businessJustification ?? "", columnNumber));
    if ((0, $413a08a89bb5cfa8$export$43ff05505a0d6eed)(event)) {
        const statusChangeColumn = 1;
        addSection(statusChanges ? $b771a926de35d4ea$var$getStatusHistorySection(statusChanges) : null, statusChangeColumn);
    }
    addSection($b771a926de35d4ea$var$getFailedProvisioningComments(event));
    // We have to get fixed column number for below. so , not using addSection here
    $b771a926de35d4ea$var$getFailedDetailsSections(event).forEach((details)=>{
        addSection(details);
    });
    addSection($b771a926de35d4ea$var$getAccessRejectedReviewer(event));
    return response;
};
const $b771a926de35d4ea$var$getApplicationSection = (application, columnNumber)=>({
        heading: "Application",
        details: [
            application
        ],
        column: columnNumber
    });
const $b771a926de35d4ea$var$getAccessTypeDetails = (uniqueAccounts, uniqueEntitlements, uniqueRoles, columnNumber)=>({
        heading: "Access Type",
        details: [
            uniqueAccounts.size > 0 ? `Accounts(${uniqueAccounts.size})` : "",
            uniqueEntitlements.size > 0 ? `Entitlements(${uniqueEntitlements.size})` : "",
            uniqueRoles.size > 0 ? `Roles(${uniqueRoles.size})` : ""
        ].filter(Boolean),
        column: columnNumber
    });
const $b771a926de35d4ea$var$getAccessTypeSection = (uniqueAccounts, uniqueEntitlements, uniqueRoles, columnNumber)=>{
    if (uniqueEntitlements.size > 0 && !uniqueRoles.size && !uniqueAccounts.size) return {
        heading: "Entitlement Names",
        details: Array.from(uniqueEntitlements),
        column: columnNumber
    };
    if (uniqueRoles.size > 0 && !uniqueEntitlements.size && !uniqueAccounts.size) return {
        heading: "Role Names",
        details: Array.from(uniqueRoles),
        column: columnNumber
    };
    if (uniqueAccounts.size > 0 && !uniqueEntitlements.size && !uniqueRoles.size) return {
        heading: "Account Names",
        details: Array.from(uniqueAccounts),
        column: columnNumber
    };
    return null;
};
const $b771a926de35d4ea$var$getStatusHistorySection = (statusChanges)=>{
    if (!statusChanges || !statusChanges.history.length && !statusChanges.nextAction?.action?.length) return null;
    return {
        heading: "",
        details: [
            ...statusChanges.history.map((history)=>({
                    icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).check,
                    text: history.status ?? ""
                })) ?? [],
            ...statusChanges.nextAction?.action?.length ? [
                {
                    icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).time,
                    text: statusChanges.nextAction.action
                }
            ] : []
        ],
        column: 1
    };
};
const $b771a926de35d4ea$var$getBusinessJustificationSection = (justification, columnNumber)=>justification.trim() ? {
        heading: "Business Justification",
        details: [
            justification
        ],
        column: columnNumber
    } : null;
const $b771a926de35d4ea$var$getFailedDetailsSections = (event)=>{
    if (![
        "error",
        "failed"
    ].includes(event.request.status.toLowerCase())) return [];
    return [
        ...event.request.tasks?.length ? [
            {
                heading: "Task ID",
                details: event.request.tasks.map((task)=>task.taskKey != null ? `#${task.taskKey.toString()}` : ""),
                column: 1
            }
        ] : [],
        ...event.request.requestKey ? [
            {
                heading: "Request ID",
                details: [
                    `#${event.request.requestKey}`
                ],
                column: 3
            }
        ] : []
    ];
};
const $b771a926de35d4ea$var$getFailedProvisioningComments = (event)=>{
    if (![
        "error",
        "failed"
    ].includes(event.request.status.toLowerCase())) return null;
    const comments = event.request.tasks?.length ? {
        heading: "Provisioning Comments",
        details: event.request.tasks.map((task)=>task.provisioningComments != null ? `${task.provisioningComments.toString()}` : ""),
        column: 4
    } : {};
    if (comments.details && comments.details.length > 0) return comments;
    return null;
};
const $b771a926de35d4ea$var$getAccessRejectedReviewer = (event)=>{
    if (event.request.status.toLowerCase() !== "rejected") return null;
    const firstTask = event.request.tasks?.[0]; // Get the first task
    const reviewer = firstTask?.approvalDetails?.approver != null ? {
        heading: "Reviewed by",
        details: [
            `${firstTask.approvalDetails.approver.userName.toString()}`
        ],
        column: 4
    } : null;
    return reviewer;
};
var $b771a926de35d4ea$export$2e2bcd8739ae039 = $b771a926de35d4ea$var$parseAccessRequestSections;


function $8b95a6178e61cc15$export$2e2bcd8739ae039(event, isPendingApproval, eventTypeLabels) {
    const section = (0, $b771a926de35d4ea$export$2e2bcd8739ae039)(event);
    const requestStatus = event.request.status.toUpperCase();
    const requestType = event.request.type?.toUpperCase();
    if ((0, $44de1ef6914f57b9$export$648c3bb98a25624b)(requestStatus)) return {
        label: eventTypeLabels.ACCESS_PROVISION_FAILED,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).failed,
        section: section
    };
    if (isPendingApproval) return {
        label: (0, $44de1ef6914f57b9$export$9a737817ea506705)(requestType, eventTypeLabels),
        icon: (0, $44de1ef6914f57b9$export$f9b0305e03c949cc)(requestType),
        section: section
    };
    const finalStatus = (0, $44de1ef6914f57b9$export$b496a0c8ea13dbb7)(requestStatus, requestType, eventTypeLabels);
    if (finalStatus) return {
        ...finalStatus,
        section: section
    };
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Timeline event type - Access Request. Unknown event", {
        event: event
    });
    return {
        label: event.type,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).unknown,
        section: section
    };
}



const $df717dcf0f0f7626$var$parseCertificationSection = (certificationDetails)=>[
        {
            heading: "Certification Type",
            details: [
                certificationDetails.type ?? ""
            ],
            column: 1
        },
        {
            heading: "Start Date",
            // TODO: Check how to get completion Date. Right now - we are getting only start Date
            details: certificationDetails.startDate ? [
                new Date(certificationDetails.startDate).toLocaleDateString("en-GB")
            ] : [
                ""
            ],
            column: 2
        },
        {
            heading: "Campaign Name",
            details: [
                certificationDetails.campaign ?? ""
            ],
            column: 3
        },
        {
            heading: "Certifier",
            details: [
                certificationDetails.reviewer ?? ""
            ],
            column: 4
        }
    ];
var $df717dcf0f0f7626$export$2e2bcd8739ae039 = $df717dcf0f0f7626$var$parseCertificationSection;


function $4299faf8ea0edafe$export$2e2bcd8739ae039(certificationDetails, eventTypeLabels, heading) {
    const section = (0, $df717dcf0f0f7626$export$2e2bcd8739ae039)(certificationDetails);
    const status = certificationDetails.status?.toUpperCase();
    return {
        label: heading?.value ?? $4299faf8ea0edafe$var$getCertificationStatusLabel(status, eventTypeLabels),
        icon: $4299faf8ea0edafe$var$getCertificationStatusIcon(status),
        section: section
    };
}
const $4299faf8ea0edafe$var$getCertificationStatusLabel = (status, labels)=>status === (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).COMPLETED ? labels.CERTIFICATION_COMPLETED : labels.PENDING_CERTIFICATION;
const $4299faf8ea0edafe$var$getCertificationStatusIcon = (status)=>status === (0, $1d3288d13a1a1df7$export$600e7c1f9e0414e1).COMPLETED ? (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).certificationCompleted : (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).certificationPending;



function $bfc00de38425ab95$export$2e2bcd8739ae039(event, eventTypeLabels) {
    let labelText = "";
    let iconType;
    if (event.appOwnerChanges.type?.toLowerCase() === (0, $1d3288d13a1a1df7$export$8aa510828f6962f3).ADD.toLowerCase()) {
        labelText = eventTypeLabels.APPLICATION_OWNER_ADDED;
        iconType = (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).added;
    } else {
        labelText = eventTypeLabels.APPLICATION_OWNER_REMOVED;
        iconType = (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).removed;
    }
    return {
        label: labelText,
        icon: iconType,
        section: [
            {
                heading: "Application Name",
                details: [
                    event.appOwnerChanges.name ?? ""
                ],
                column: 1
            }
        ]
    };
}



function $b287ba7bb2e4604e$export$2e2bcd8739ae039(event, eventTypeLabels) {
    let labelText = "";
    let iconType;
    if (event.entitlementOwnerChanges.type?.toLowerCase() === (0, $1d3288d13a1a1df7$export$8aa510828f6962f3).ADD.toLowerCase()) {
        labelText = eventTypeLabels.ENTITLEMENT_OWNER_ASSIGNED;
        iconType = (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).added;
    } else {
        labelText = eventTypeLabels.ENTITLEMENT_OWNER_REMOVED;
        iconType = (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).removed;
    }
    return {
        label: labelText,
        icon: iconType,
        section: [
            {
                heading: "Entitlement Names",
                details: [
                    event.entitlementOwnerChanges.name ?? ""
                ],
                column: 1
            }
        ]
    };
}



function $b08580520a5c2cba$export$2e2bcd8739ae039(event, eventTypeLabels) {
    return {
        label: event.ruleDetails.type?.toLowerCase() === (0, $1d3288d13a1a1df7$export$9b546f7bc7594956).BIRTHRIGHT_RULE.toLowerCase() ? eventTypeLabels.BIRTHRIGHT_RULE_TRIGGER : eventTypeLabels.USER_UPDATE_RULE_TRIGGER,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).trigger,
        section: [
            {
                heading: "Rule Name",
                details: [
                    event.ruleDetails.name ?? ""
                ],
                column: 1
            },
            {
                heading: "Rule Type",
                details: [
                    event.ruleDetails.type ?? ""
                ],
                column: 1
            }
        ]
    };
}



const $0923e45515334177$var$parseUserAttributeChangeSections = (event)=>[
        {
            heading: "Attribute",
            details: event.attributeChanges.attributes,
            column: 1
        }
    ];
var $0923e45515334177$export$2e2bcd8739ae039 = $0923e45515334177$var$parseUserAttributeChangeSections;


function $8e0ece2857761bd3$export$2e2bcd8739ae039(event, eventTypeLabels) {
    const section = (0, $0923e45515334177$export$2e2bcd8739ae039)(event);
    return {
        label: eventTypeLabels.USER_ATTRIBUTE_UPDATE,
        icon: (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).update,
        section: section
    };
}



function $10a04991e0e365ed$export$cded5b49f4b8d5db(event, isPendingApproval, l) {
    const eventTypeLabels = (0, $413a08a89bb5cfa8$export$6107eae07387fcd)(l);
    switch(event.type){
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).ACCESS_REQUEST:
            return (0, $8b95a6178e61cc15$export$2e2bcd8739ae039)(event, isPendingApproval, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_APPLICATION_CHANGE:
            return (0, $bfc00de38425ab95$export$2e2bcd8739ae039)(event, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_ENTITLEMENT_CHANGE:
            return (0, $b287ba7bb2e4604e$export$2e2bcd8739ae039)(event, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).USER_ATTRIBUTES_CHANGE:
            return (0, $8e0ece2857761bd3$export$2e2bcd8739ae039)(event, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).CERTIFICATION:
            return (0, $4299faf8ea0edafe$export$2e2bcd8739ae039)(event.certificationDetails, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).RULE_TRIGGER:
            return (0, $b08580520a5c2cba$export$2e2bcd8739ae039)(event, eventTypeLabels);
        case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).ACCESS:
            return (0, $2da227a80723acea$export$2e2bcd8739ae039)(event, eventTypeLabels);
        default:
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Unknown event type in timeline:", {
                event: event
            });
            return null;
    }
}
const $10a04991e0e365ed$export$701bdd18c9155fab = (events)=>events.reduce((acc, event)=>{
        if (!event.timestamp || Number.isNaN(event.timestamp)) return acc;
         // Ignore invalid timestamps
        // Convert to UTC format "13 Feb, 2024"
        const date = $10a04991e0e365ed$export$dc8184c5b424c91d(event.timestamp);
        if (!acc[date]) acc[date] = [];
        acc[date].push(event);
        return acc;
    }, {});
function $10a04991e0e365ed$export$9cf498f669120905(value) {
    return Object.values((0, $1d3288d13a1a1df7$export$bb115dbb5c52277f)).includes(value);
}
const $10a04991e0e365ed$export$8fb536984ec8b4d7 = (input)=>btoa(input);
const $10a04991e0e365ed$export$94fdf11bafc8de6b = (input)=>atob(input);
const $10a04991e0e365ed$export$1dc50bd8baa2cf4b = ()=>{
    const currentUtcTimestamp = Date.now(); // Current UTC time in milliseconds
    const oneYearBackTimestamp = currentUtcTimestamp - 31536000000; // 1 year back in milliseconds
    return {
        startDate: oneYearBackTimestamp,
        endDate: currentUtcTimestamp
    };
};
const $10a04991e0e365ed$export$dc8184c5b424c91d = (timestamp)=>new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "short",
        year: "numeric"
    }).format(new Date(timestamp));
const $10a04991e0e365ed$export$bcd63b170efd80b4 = (isoDate, isStartDate = false)=>{
    const date = new Date(isoDate);
    if (isStartDate) date.setHours(0, 0, 0, 0);
    else date.setHours(23, 59, 59, 999);
    return date;
};
const $10a04991e0e365ed$export$3ae94a2503e890a1 = (timestamp)=>{
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};
function $10a04991e0e365ed$export$463c4185935d5f9b(startDate, endDate) {
    const today = new Date();
    const threeYearsAgo = new Date(today.getFullYear() - 3, today.getMonth(), today.getDate());
    let startDateMin = threeYearsAgo;
    let startDateMax = today;
    let endDateMin = threeYearsAgo;
    let endDateMax = today;
    let validatedStartDate = startDate;
    let validatedEndDate = endDate;
    if (startDate && !endDate) {
        const oneYearAfter = new Date(startDate);
        oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);
        endDateMin = startDate;
        endDateMax = oneYearAfter > today ? today : oneYearAfter;
    }
    if (!startDate && endDate) {
        const oneYearBefore = new Date(endDate);
        oneYearBefore.setFullYear(oneYearBefore.getFullYear() - 1);
        startDateMin = oneYearBefore < threeYearsAgo ? threeYearsAgo : oneYearBefore;
        startDateMax = endDate;
    }
    // Validate and clear out-of-bound dates
    if (startDate && endDate) {
        const oneYearAfterStart = new Date(startDate);
        oneYearAfterStart.setFullYear(oneYearAfterStart.getFullYear() + 1);
        if (endDate > oneYearAfterStart) validatedEndDate = null;
        const oneYearBeforeEnd = new Date(endDate);
        oneYearBeforeEnd.setFullYear(oneYearBeforeEnd.getFullYear() - 1);
        if (startDate < oneYearBeforeEnd) validatedStartDate = null;
    }
    return {
        startDateMin: startDateMin,
        startDateMax: startDateMax,
        endDateMin: endDateMin,
        endDateMax: endDateMax,
        validatedStartDate: validatedStartDate,
        validatedEndDate: validatedEndDate
    };
}


const $270ea330992dc44e$var$initialState = {
    selectedSortDirection: "",
    selectedFilters: [],
    userSearchInput: "",
    selectedSortField: "timestamp",
    selectedDateFilter: (0, $10a04991e0e365ed$export$1dc50bd8baa2cf4b)()
};
/**
 * TODO: Rename to TimelineFilterSlice - something like that. its related to filters.
 */ const $270ea330992dc44e$var$IdentityTimelineSlice = (0, $cURGa$createSlice)({
    name: "IdentityTimeline",
    initialState: $270ea330992dc44e$var$initialState,
    reducers: {
        setSelectedSortDirection: (state, action)=>{
            // TODO: instead of checking logic here - action.payload === sortValues.ASC ? 'Asc' : 'Desc' - check if this can be done from component level whicle reading sort butoon click
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.selectedSortDirection = action.payload === (0, $01a22c0ef0c16d4a$export$bb86ee402385b2d6).ASC ? "Asc" : "Desc";
        },
        setUserInput: (state, action)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.userSearchInput = action.payload;
        },
        setSelectedFilters: (state, action)=>{
            // eslint-disable-next-line no-param-reassign
            state.selectedFilters = action.payload;
        },
        setselectedDateFilter: (state, action)=>{
            // eslint-disable-next-line no-param-reassign
            state.selectedDateFilter = action.payload;
        },
        resetUserInput: (state)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.userSearchInput = "";
        },
        // Reset all state to initial
        resetSelectedSortDirection: (state)=>{
            // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
            // eslint-disable-next-line no-param-reassign
            state.selectedSortDirection = "";
        },
        resetSelectedFilters: (state)=>{
            // eslint-disable-next-line no-param-reassign
            state.selectedFilters = [];
        },
        resetselectedDateFilter: (state)=>{
            // eslint-disable-next-line no-param-reassign
            state.selectedDateFilter = $270ea330992dc44e$var$initialState.selectedDateFilter;
        },
        resetToInitial: ()=>// eslint-disable-next-line no-param-reassign
            $270ea330992dc44e$var$initialState
    }
});
const { setSelectedFilters: $270ea330992dc44e$export$c086c216e40488ac, setSelectedSortDirection: $270ea330992dc44e$export$7ffaa548ac035555, setUserInput: $270ea330992dc44e$export$3688e9a8427cc7de, resetSelectedFilters: $270ea330992dc44e$export$b4016158c566c11c, resetSelectedSortDirection: $270ea330992dc44e$export$81a10a2fce3a5072, resetUserInput: $270ea330992dc44e$export$8f4b8c896e5a0519, resetToInitial: $270ea330992dc44e$export$5b34066567dd8694, setselectedDateFilter: $270ea330992dc44e$export$c687fcc9fc793779, resetselectedDateFilter: $270ea330992dc44e$export$edef0fcdb8e4fa90 } = $270ea330992dc44e$var$IdentityTimelineSlice.actions;
var $270ea330992dc44e$export$2e2bcd8739ae039 = $270ea330992dc44e$var$IdentityTimelineSlice.reducer;


// store/slice/userSlice.ts

const $57ce99207e363761$var$initialState = {
    domainInfo: {
        ISPM_SERVICES_ENABLED: false
    }
};
const $57ce99207e363761$var$userSlice = (0, $cURGa$createSlice)({
    name: "user",
    initialState: $57ce99207e363761$var$initialState,
    reducers: {
        setISPMEnabled (state, action) {
            // eslint-disable-next-line no-param-reassign
            state.domainInfo.ISPM_SERVICES_ENABLED = action.payload; // ✅ Safe update
        }
    }
});
const { setISPMEnabled: $57ce99207e363761$export$924231a5883007f9 } = $57ce99207e363761$var$userSlice.actions;
var $57ce99207e363761$export$2e2bcd8739ae039 = $57ce99207e363761$var$userSlice.reducer;



const $ec34473eca2d3d1f$var$initialState = {
    isRelevantActivitiesHidden: false
};
const $ec34473eca2d3d1f$var$identityTimelineSideCarSlice = (0, $cURGa$createSlice)({
    name: "identitySideCarSummary",
    initialState: $ec34473eca2d3d1f$var$initialState,
    reducers: {
        setIsRelevantActivitiesHidden: (state, action)=>{
            // eslint-disable-next-line no-param-reassign
            state.isRelevantActivitiesHidden = action.payload;
        },
        resetSideCarFlags: ()=>$ec34473eca2d3d1f$var$initialState
    }
});
const { setIsRelevantActivitiesHidden: $ec34473eca2d3d1f$export$aebfc16d2f2ef6de, resetSideCarFlags: $ec34473eca2d3d1f$export$225eff1920d91399 } = $ec34473eca2d3d1f$var$identityTimelineSideCarSlice.actions;
var $ec34473eca2d3d1f$export$2e2bcd8739ae039 = $ec34473eca2d3d1f$var$identityTimelineSideCarSlice.reducer;








// Define the base reducers as an object (not combined yet)
const $3b5e9729b763d3ce$var$baseReducers = {
    ispm: (0, $e7b59df9ea8eb4ea$export$2e2bcd8739ae039),
    ispmIdentity: (0, $8939fb7be58f56d0$export$2e2bcd8739ae039),
    ispmCopilot: (0, $27fb994cf82006a6$export$2e2bcd8739ae039),
    ispmIdentityTimeline: (0, $270ea330992dc44e$export$2e2bcd8739ae039),
    identityTimelineSideCar: (0, $ec34473eca2d3d1f$export$2e2bcd8739ae039)
};
const $3b5e9729b763d3ce$export$a8a69c316169e623 = (0, $cURGa$combineReducers)($3b5e9729b763d3ce$var$baseReducers);
const $3b5e9729b763d3ce$export$6fec604aa7293d0c = ({ reducers: reducers, preloadedState: preloadedState } = {})=>{
    // Combine base reducers with any custom reducers
    const extendedReducer = (0, $cURGa$combineReducers)({
        ...$3b5e9729b763d3ce$var$baseReducers,
        ...reducers && Object.keys(reducers).length > 0 ? reducers : {}
    });
    return (0, $cURGa$configureStore)({
        reducer: extendedReducer,
        preloadedState: preloadedState
    });
};







/* eslint-disable import/prefer-default-export */ // Make sure test cases are passing when you make this change.
// packages\ispm\src\tests\unit-tests\utils\messages.test.ts
const $806e6a38034fc517$export$223b8efb77cb35fb = {
    "The generated content may have errors or may not show at all.": "Ispm.ContentNotAccurate.lowConfidenceText",
    "What can I help you with?": "Ispm.SaviChatInput.inputPlaceholder",
    "Loading Dashboard": "Ispm.dashboard.loading",
    "This may take several seconds": "Ispm.dashboard.loadingTitle",
    "Reset Chat": "Ispm.chatOverlay.resetChat",
    "Sure, How can I help?": "Ispm.chatOverlay.resetChatResponse",
    Close: "Ispm.chatOverlay.closeTitle",
    "Another Session in Progress": "Ispm.SaviChat.tabsErrorModalTitle",
    "Another Copilot session is open in another tab. Close this session to navigate out of Copilot and continue, or close any duplicate tabs.": "Ispm.SaviChat.tabsErrorModalSubtitle",
    "Close Session": "Ispm.SaviChat.tabsErrorModalButtonLabel",
    "Sorry, there was an error or interruption while processing your prompt. When the service becomes available again, you can either enter your original prompt or try a new one": "Ispm.systemError.message",
    "Sorry, there was an error or interruption while processing your prompt. You can either reprocess your original prompt or try a new one.": "Ispm.copilotError.message",
    "Service temporary unavailable.": "Ispm.systemError.serviceUnavailableTitle",
    "There was an error while processing your prompt. Please try again later.": "Ispm.systemError.serviceUnavailableDescription",
    "Reprocess Request": "Ispm.copilotError.reprocessRequest",
    "Stop processing on generated content": "Ispm.chatOverlay.stopProcessing",
    "Sure, I've stopped processing the content.": "Ispm.chatOverlay.stoppedProcessingResponse",
    "There was an error processing the request. Try a different request for better results.": "Ispm.sqlError.description",
    "Content can't be displayed": "Ispm.sqlError.title",
    "System Error Alert": "Ispm.alertBanner.systemError",
    "Your data is being generated and will be available in the Downloads section of your profile menu when finished.": "Ispm.alertBanner.downloadPending",
    "Iframe container": "Ispm.iframe.container",
    "Toggle button group for switching views": "Ispm.dataPanel.toggler",
    "Data panel with sql and visualization content": "Ispm.dataPanel",
    "Generating Content": "Ispm.GeneratingContent.generatingContent",
    "retrieving data": "Ispm.GeneratingContent.retrievingData",
    "Stop Processing": "Ispm.GeneratingContent.stopProcessingButtonLabel",
    "Are you sure?": "Ispm.GeneratingContent.modalTitle",
    "Do you want to stop the process?": "Ispm.GeneratingContent.modalSubtitle",
    Cancel: "Ispm.global.cancel",
    "Savi is always learning new things. Results may vary.": "Ispm.saviInput.description",
    "Generating SQL": "Ispm.sidePanelLoadinfText.generatingSql",
    "Capturing user input": "Ispm.sidePanelLoadinfText.capturingUserInput",
    "Identifying schema": "Ispm.sidePanelLoadinfText.identifyingSchema",
    "Parsing parameters": "Ispm.sidePanelLoadinfText.parsingParameters",
    "Constructing SQL query": "Ispm.sidePanelLoadinfText.constructingSqlQuery",
    "Validating generated SQL": "Ispm.sidePanelLoadinfText.validatingGeneratedSql",
    "Generating Table Data": "Ispm.sidePanelLoadinfText.generatingTableData",
    "Executing SQL": "Ispm.sidePanelLoadinfText.executingSql",
    "Fetching data": "Ispm.sidePanelLoadinfText.fetchingData",
    "Formatting data": "Ispm.sidePanelLoadinfText.formattingData",
    "Transforming data": "Ispm.sidePanelLoadinfText.transformingData",
    "Finalizing table": "Ispm.sidePanelLoadinfText.finalizingTable",
    "Generating Chart": "Ispm.sidePanelLoadinfText.GeneratingChart",
    "Selecting chart type": "Ispm.sidePanelLoadinfText.selectingChartType",
    "Configuring chart": "Ispm.sidePanelLoadinfText.configuringChart",
    "Mapping data": "Ispm.sidePanelLoadinfText.mappingData",
    "Styling chart": "Ispm.sidePanelLoadinfText.stylingChart",
    "Generating visualization": "Ispm.sidePanelLoadinfText.generatingVisualization",
    "Savi Copilot": "Ispm.header.title",
    "Save to Dashboard": "Ispm.chartPanel.dashboardIcon",
    "Add Chart": "Ispm.chartPanel.addChart",
    "Loading Chart": "Ispm.chartPanel.loaderTitle",
    "Save to the Intelligence Dashboard": "Ispm.chartPanel.saveChart.userMessage",
    "Take me to Intelligence Dashboard": "Ispm.chartPanel.saveChart.link",
    "This chart has been pinned to your dashboard": "Ispm.chartPanel.saveChart.responseMessage",
    "Copied to clipboard": "Ispm.clipboardCopySuccessTitle",
    "The SQL code was copied to your clipboard.": "Ispm.clipboardCopySuccessDesc",
    "Dashboards unavailable. Try refreshing the page to connect to our dashboards list.": "Ispm.chartPnael.dashboardError",
    Refresh: "Ispm.refresh",
    "New Chart": "Ispm.chart.defaultTtitle",
    "New Table": "Ispm.table.defaultTtitle",
    "SQL Error": "Ispm.error.sql.defaultTtitle",
    "Low Confidence": "Ispm.error.lowConfidence.defaultTtitle",
    "Take me to the Intelligence Dashboard": "Ispm.saveChart.responseLink",
    "Number of records": "Ispm.table.totalRecords",
    Access: "Ispm.defaultDashboard.access",
    Certifications: "Ispm.defaultDashboard.certifications",
    Request: "Ispm.defaultDashboard.request",
    Onboarding: "Ispm.defaultDashboard.onboarding",
    Machines: "Ispm.defaultDashboard.machines",
    "Analyzing Data...": "Ispm.defaultDashboard.processingData",
    "Show Anyway": "Ispm.ContentNotAccurate.showAnywayText",
    Recommendations: "Ispm.Dashboard.Recommendations.recommendationsText",
    Review: "Ispm.Dashboard.Recommendations.review",
    "Show All": "Ispm.Dashboard.Recommendations.showAllText",
    "Additional Recommendations": "Ispm.Dashboard.Recommendations.additionalRecommendationsText",
    "The feature for this data is not set up.": "Ispm.Dashboard.Recommendations.disabledText",
    "Great job, no issues were detected": "Ispm.Dashboard.Recommendations.noIssuesText",
    "Great job! There weren\u2019t any issues detected for all recommendations.": "Ispm.Dashboard.Recommendations.anyIssuesText",
    "Loading recommendation items": "Ispm.Dashboard.Recommendations.loadingResponseText",
    "Posture Insights": "Ispm.ootbDashboard.governanceInsights.postureInsights",
    "Campaigns Expiring Soon": "Ispm.governanceInsights.campaignsExpiringSoon",
    "Affected Certifications": "Ispm.governanceInsights.affectedCertifications",
    "Certification Snapshot": "Ispm.governanceInsights.certificationSnapshot",
    "Revocation Effectiveness": "Ispm.governanceInsights.revocationEffectiveness",
    "Tracks certification effectiveness by measuring access revocations. Get insights on revoke delays or failures.": "Ispm.governanceInsights.revocationEffectiveness.tooltip",
    "Displays soon-to-expire certification campaigns. Get insights on certification trends, workload, and status spikes to optimize scheduling.": "Ispm.governanceInsights.revocationEffectiveness.drilldown.tooltip",
    "Provides a cross-section of past certification activity including overruled trust scores and birthright access.": "Ispm.governanceInsights.certificationSnapshot.tooltip",
    "There are no insights currently available for this data.": "Ispm.governanceInsights.certifications.noInsights",
    Campaigns: "Ispm.governanceInsights.revocationEffectiveness.revocationSummaryCard.Campaigns",
    Campaign: "Ispm.governanceInsights.revocationEffectiveness.revocationSummaryCard.Campaign",
    Effectiveness: "Ispm.governanceInsights.revocationEffectiveness.revocationSummaryCard.Effectiveness",
    Insights: "Ispm.governanceInsights.revocationEffectiveness.revocationSummaryCard.Insights",
    "Median revokes per campaign": "Ispm.governanceInsights.revocationEffectiveness.median",
    "CURRENT REVOCATIONS (ALL CAMPAIGNS)": "Ispm.governanceInsights.revocationEffectiveness.current",
    "Revoke Jobs": "Ispm.governanceInsights.revocationEffectiveness.revokeJobs",
    "Orphan Accounts": "Ispm.governanceInsights.orphanAccounts",
    Revokes: "Ispm.governanceInsights.revocationEffectiveness.revokes",
    "Data couldn\u2019t be retrieved.": "Ispm.Dashboard.Recommendations.dataErrorText",
    "Access Added": "Ispm.userTimeline.AccessAdded",
    "Access Removed": "Ispm.userTimeline.AccessRemoved",
    "Access Rejected": "Ispm.userTimeline.AccessRejected",
    "Pending Access Addition": "Ispm.userTimeline.PendingAccessAddition",
    "Pending Access Removal": "Ispm.userTimeline.PendingAccessRemoval",
    "Access Provision Failed": "Ispm.userTimeline.AccessProvisionFailed",
    "Assigned as Application Owner": "Ispm.userTimeline.ApplicationOwnerAdded",
    "Unassigned as Application Owner": "Ispm.userTimeline.ApplicationOwnerRemoved",
    "Assigned as Entitlement Owner": "Ispm.userTimeline.EntitlementOwnerRemoved",
    "Unassigned as Entitlement Owner": "Ispm.userTimeline.EntitlementOwnerAssigned",
    "Pending Certification": "Ispm.userTimeline.PendingCertification",
    "Certification Completed": "Ispm.userTimeline.CertificationCompleted",
    "Birthright Rule Trigger": "Ispm.userTimeline.BirthrightRuleTrigger",
    "User Update Rule Trigger": "Ispm.userTimeline.UserUpdateRuleTrigger",
    "User Attribute Update": "Ispm.userTimeline.UserAttributeUpdate",
    Dashboard: "Ispm.ootbDashboard.ispmdashboard",
    "Manage Dashboards": "Ispm.ootbDashboard.manageDashboards",
    "Dormant Accounts": "Ispm.ootbDashboard.governanceInsights.access.dormatAccounts",
    "Last 30 days": "Ispm.ootbDashboard.governanceInsights.access.Last30days",
    "Last 30 Days": "Ispm.ootbDashboard.governanceInsights.access.Last30Days",
    "Active Users with Inactive Managers": "Ispm.ootbDashboard.governanceInsights.access.activeUsersWithInactiveManagers",
    "Roles with Missing Owners": "Ispm.ootbDashboard.governanceInsights.access.rolesWithMissingOwners",
    "Service Accounts with Missing Owners": "Ispm.ootbDashboard.governanceInsights.access.serviceAccountsWithMissingOwners",
    "Inactive Roles with Active Assignments": "Ispm.ootbDashboard.governanceInsights.access.inactiveRolesWithActiveAssignments",
    "Out-of-Band Access": "Ispm.ootbDashboard.governanceInsights.access.outOfBandAccess",
    "Top Requested Entitlements Without Descriptions": "Ispm.ootbDashboard.governanceInsights.access.topRequestedEntitlementsWithoutDescriptionsTitle",
    Accounts: "Ispm.ootbDashboard.governanceInsights.access.outOfBandAccounts",
    Applications: "Ispm.ootbDashboard.governanceInsights.access.outOfBandApplications",
    "Completed campaigns": "Ispm.governanceInsights.campaigns",
    "Year to date": "Ispm.governanceInsights.yeartodate",
    INACTIVITY: "Ispm.ootbDashboard.governanceInsights.access.inactivity",
    "90 Days +": "Ispm.90Days",
    "120 Days +": "Ispm.120Days",
    "Over 6 months": "Ispm.6Months",
    "Over 9 months": "Ispm.9Months",
    "Active Users": "Ispm.ootbDashboard.governanceInsights.access.active-users",
    "Inactive Managers": "Ispm.ootbDashboard.governanceInsights.access.inactive.managers",
    "Report to": "Ispm.ootbDashboard.governanceInsights.access.report.to",
    "Low Trust Detection": "Ispm.ootbDashboard.low.trust.detection",
    "Risk Detection": "Ispm.ootbDashboard.risk.detection",
    "COMING SOON": "Ispm.ootbDashboard.coming.soon",
    "Users will soon visualize low-trust items across identities, workloads, and apps, with insights into contributing factors.": "Ispm.ootbDasboard.trustItem.message",
    "Take Action": "Ispm.ootbDashboard.recommendation.takeActionButton",
    "This is a sample of 100 records from the dataset. Download to view the full dataset.": "Ispm.TopHeaderPanel.sample100RecordsMessage",
    "Security Posture Index": "Ispm.ootbDashboard.security.posture.index",
    "Get insights into your organization\u2019s security health to help strengthen your defenses. An index score will give you a quick look at your organization\u2019s overall security posture.": "Ispm.ootbDashboard.security.posture.message",
    "No Data Available": "Ispm.ootbDashboard.campaignError.noDataAvailable",
    Submit: "Ispm.global.submit",
    "Didn't fully follow instructions": "Ispm.Copilot.Feedback.didntFullyFollowInstructions",
    "Not factually correct": "Ispm.Copilot.Feedback.notFactuallyCorrect",
    "Didn't like the style": "Ispm.Copilot.Feedback.didntLikeTheStyle",
    "(Optional) Add specific details": "Ispm.Copilot.Feedback.optionalAddSpecificDetails",
    Like: "Ispm.global.like",
    Dislike: "Ispm.global.dislike",
    "Thank you! Your feedback has been sent.": "Ispm.Copilot.Feedback.thankYouYourFeedbackHasBeenSent",
    "Share why this was a bad response:": "Ispm.Copilot.Feedback.shareWhyThisWasABadResponse",
    "Give additional feedback": "Ispm.Copilot.Feedback.giveAdditionalFeedback",
    "See More": "Ispm.ootbDashboard.lowTrustDetection.seeMore",
    "Filtering and sorting will be available in Control Center after you click `Take Action\u2019.": "Ispm.ootbDashboard.recommendation.takeActionButton.tooltip",
    "Feature coming soon. If you\u2019d like to view more information, please visit the Identity Repository.": "Ispm.ootbDashboard.cockpit.notUsedTiles.tooltip",
    "ENTITLEMENT & APP": "Ispm.ootbDashboard.entitlementAndApp",
    "# OF REQUESTS": "Ispm.ootbDashboard.#ofrequest",
    Dismiss: "Ispm.global.dismiss",
    "You're nearing your monthly prompt limit. Continued use may incur additional charges.": "Ispm.alertBanner.usageAlert",
    "You've used half your limit of monthly prompts for your current license.": "Ispm.alertBanner.usageAlertHalfLimit"
};
const $806e6a38034fc517$export$b8ec51749481adbb = {
    "Ispm.Copilot.License.Warning": `You're nearing your monthly prompt limit ({planUsed}/{planLimit}). Continued use may incur additional charges. See the Licensing & Usage page for more details.`,
    "Ispm.Copilot.License.Half": `You've used half your limit ({planUsed}/{planLimit}) of monthly prompts for your current license.`
};


const $b673ba598f0efd75$export$49d43829e15d438a = "ispm-dashboard-header-saviEngageIcon";
const $b673ba598f0efd75$export$29cbcba6abba7b2a = "ispm-dashboard-header-saviResumeIcon";
const $b673ba598f0efd75$export$13d72b4208596249 = "ispm-dashboard-header-saviInputBox";
const $b673ba598f0efd75$export$be75bfbd87031fce = "ispm-chatOverlay-header-closeIcon";
const $b673ba598f0efd75$export$de6a5a831ebdc1d3 = "ispm-chatOverlay-header-resetIcon";
const $b673ba598f0efd75$export$5e613fde55f77105 = "ispm-dashboard-body";
const $b673ba598f0efd75$export$71a7c17545cbc03a = "ispm-suggestions";
const $b673ba598f0efd75$export$87123cb886178228 = "ispm-dashboard-loader";
const $b673ba598f0efd75$export$cfca711824ae744a = "ispm-DataSectionHeader-detailedStepsTooltip";
const $b673ba598f0efd75$export$d42dbbce211dd111 = "ispm-ChartPanel-sql";
const $b673ba598f0efd75$export$c46de8d9a27574bc = "ispm-ChartPanel-visualization";
const $b673ba598f0efd75$export$5031e205504ecda1 = "ispm-TabelPanel-sql";
const $b673ba598f0efd75$export$e9534a9d5efca98d = "ispm-TablePanel-visualization";




const $10bf676d992f37e7$export$917bfb70a1457f2 = ()=>{
    const intl = (0, $cURGa$useIntl)();
    return (key, placeholders)=>(0, $cURGa$localize)(intl, key, placeholders);
};
const $10bf676d992f37e7$export$b544502b42f276ba = (invertedLookup)=>{
    const intl = (0, $cURGa$useIntl)();
    return (defaultMessage, placeholders)=>{
        const id = invertedLookup[defaultMessage];
        if (!id) return defaultMessage;
        return (0, $cURGa$localize)(intl, {
            id: id,
            defaultMessage: defaultMessage
        }, placeholders);
    };
};



$18c71440a95f3692$var$DashboardLoader.default = {
    testId: ""
};
function $18c71440a95f3692$var$DashboardLoader({ title: title, subTitle: subTitle }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Ispm-DashboardLoader",
        "data-testid": (0, $b673ba598f0efd75$export$87123cb886178228),
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "loop",
                format: "main",
                color: "brand",
                className: "Ispm-DashboardLoader-loader"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                className: "Ispm-DashboardLoader-text",
                children: l(title)
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                className: "Ispm-DashboardLoader-caption",
                children: l(subTitle)
            })
        ]
    });
}
var $18c71440a95f3692$export$2e2bcd8739ae039 = $18c71440a95f3692$var$DashboardLoader;












$842e7eb45efe0ce1$var$SaviInputField.default = {
    isMenuPinned: false
};
function $842e7eb45efe0ce1$var$SaviInputField({ isMenuPinned: isMenuPinned }) {
    // ISPM related context values
    const { ispmState: ispmState, updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const inputRef = (0, $cURGa$useRef)(null);
    const setIspmInputValue = (inputText)=>{
        updateIspmState("ispmInputValue", inputText);
    };
    function handleUserQuerySearch() {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info('Handling header savi icon or "input enter" click', {
            text: ispmState.ispmInputValue
        });
        updateIspmState("isChatOverlayVisible", true);
        updateIspmState("isSuggestionVisible", false);
        updateIspmState("userQuery", ispmState.ispmInputValue);
    }
    (0, $cURGa$useEffect)(()=>{
        const inputElement = inputRef.current;
        // Function to handle focus event
        const handleFocus = ()=>{
            updateIspmState("isSuggestionVisible", true);
        };
        if (inputElement) // Add event listeners for focus and blur
        inputElement.addEventListener("focus", handleFocus);
        return ()=>{
            if (inputElement) inputElement.removeEventListener("focus", handleFocus);
        };
    }, [
        updateIspmState
    ]);
    const handleKeyDown = (event)=>{
        if (event.key === "Enter") handleUserQuerySearch();
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: (0, $cURGa$classnames)("Ispm-SaviInputfieldContainer", isMenuPinned && "Ispm-SaviInputfieldContainer--isSideMenuPinned"),
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-SaviInputfieldWrapper",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InputField), {
                    ref: inputRef,
                    name: "Ispm-SaviInputfield",
                    size: "small",
                    placeholder: l("What can I help you with?"),
                    prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "Comment",
                        color: "purple-700",
                        size: "smallMedium"
                    }),
                    className: "Ispm-SaviInputfield",
                    value: ispmState.ispmInputValue,
                    setValue: setIspmInputValue,
                    onKeyDown: handleKeyDown,
                    dataTestId: (0, $b673ba598f0efd75$export$13d72b4208596249)
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-SaviInputfield-icon",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                    size: "medium",
                    kind: "saviGhost",
                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "SaviCompanion",
                        size: "medium",
                        color: "purple-700"
                    }),
                    dataTestId: (0, $b673ba598f0efd75$export$29cbcba6abba7b2a),
                    onClick: ()=>{
                        handleUserQuerySearch();
                    }
                })
            })
        ]
    });
}
var $842e7eb45efe0ce1$export$2e2bcd8739ae039 = $842e7eb45efe0ce1$var$SaviInputField;








/**
 * TODO: NodeJS upgrade with microfrontend architecture - Move these to environemnt variables once a separate pod will be created for this.
 */ const $8f460a89aa4ee4ee$var$config = {
    USE_LOCAL_MOCK_API: false,
    URL_INTELLIGENCE: "/intelligence",
    URL_ISPM_DASHBOARD: "/intelligence/ispm",
    URL_ISPM_IDENTITIES: "/intelligence/ispm/identities",
    RESET_ENTRY: {
        userQuery: "Reset chat",
        response: "Sure, How can I help?"
    },
    STOP_PROCESSING: {
        userQuery: "Stop processing on generated content",
        response: "Sure, I've stopped processing the content."
    },
    RECENT_CHART_STORAGE: 2,
    RECENT_TABLE_STORAGE: 1,
    MAX_CHARTS_TO_STORE: 10,
    MAX_TABLES_TO_STORE: 10
};
const $8f460a89aa4ee4ee$export$1e3fa289c11cc7 = {
    ENABLE_DATA_DOWNLOAD: true,
    ENABLE_RENAME_QUERY: false,
    SHOW_SQL_TOGGLE_BUTTON: false,
    ENABLE_SAVE_TO_DASHBOARD: false
};
const $8f460a89aa4ee4ee$export$8bb82470130b1445 = [
    (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_ENTITLEMENT_CHANGE,
    (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_APPLICATION_CHANGE
];
var $8f460a89aa4ee4ee$export$2e2bcd8739ae039 = $8f460a89aa4ee4ee$var$config;


// chatHistory.ts
const $84076bccc3151b37$var$CHAT_HISTORY_KEY = "chatHistory";
const $84076bccc3151b37$export$e864ef1d0432b4ba = ()=>{
    const history = sessionStorage.getItem($84076bccc3151b37$var$CHAT_HISTORY_KEY);
    return history ? JSON.parse(history) : [];
};
const $84076bccc3151b37$export$f783cf703394eac5 = ()=>{
    sessionStorage.removeItem($84076bccc3151b37$var$CHAT_HISTORY_KEY);
};
const $84076bccc3151b37$export$c8bdd0616cd6b3b1 = (chatHistory)=>{
    sessionStorage.setItem($84076bccc3151b37$var$CHAT_HISTORY_KEY, JSON.stringify(chatHistory));
};
const $84076bccc3151b37$export$8f827adf405a2374 = (message)=>$84076bccc3151b37$export$e03e0735febc3993(message);
const $84076bccc3151b37$export$e03e0735febc3993 = (message)=>{
    // Parse existing chat history from session storage
    const chatHistory = $84076bccc3151b37$export$e864ef1d0432b4ba();
    chatHistory.push(message);
    // Track the latest indices
    const recentSampleDataIndices = [];
    const recentChartIndices = [];
    // Traverse the chat history in reverse order
    for(let currentIndex = chatHistory.length - 1; currentIndex >= 0; currentIndex -= 1){
        const currentEntry = chatHistory[currentIndex];
        if (!currentEntry.isUser) {
            // Handle "sampleData" entries
            if (currentEntry.data.contentType === "sampleData") {
                if (recentSampleDataIndices.length < (0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).MAX_TABLES_TO_STORE) // Track the last 2 "sampleData" entries
                recentSampleDataIndices.push(currentIndex);
                else {
                    // Set content to an empty array for older "sampleData" entries (keeping only 2)
                    currentEntry.data.data = []; // Empty content of the older "sampleData" entry
                    currentEntry.data.links = [];
                }
            }
            // Handle "chart" entries
            if (currentEntry.data.contentType === "chart") {
                if (recentChartIndices.length < (0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).MAX_CHARTS_TO_STORE) // Keep track of the two most recent "chart" entries
                recentChartIndices.push(currentIndex);
                else {
                    // Remove content for older "chart" entries
                    currentEntry.data.data = [];
                    currentEntry.data.links = [];
                }
            }
        }
    }
    // Save the updated chat history back to session storage
    $84076bccc3151b37$export$c8bdd0616cd6b3b1(chatHistory);
    return chatHistory;
};






function $928329e8d2562c97$var$SaviMenuIconButton() {
    const { ispmState: ispmState, updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // Toggle the chat overlay visibility
    const toggleChatOverlayVisibility = ()=>{
        updateIspmState("isChatOverlayVisible", !ispmState.isChatOverlayVisible);
        updateIspmState("isSuggestionVisible", false);
        (0, $84076bccc3151b37$export$f783cf703394eac5)();
    };
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: (0, $cURGa$classnames)("SaviMenuIconButton", ispmState.isChatOverlayVisible && "SaviMenuIconButton--isActive"),
        "data-testid": (0, $b673ba598f0efd75$export$49d43829e15d438a),
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
            text: l("Savi Copilot"),
            placement: "left",
            trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                size: "large",
                kind: "saviGhost",
                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "SaviCompanion",
                    size: "medium",
                    color: "purple-700"
                }),
                onClick: toggleChatOverlayVisibility,
                dataTestId: "ispm-saviCompanion-icon"
            })
        })
    });
}
var $928329e8d2562c97$export$2e2bcd8739ae039 = $928329e8d2562c97$var$SaviMenuIconButton;












// Base URL for the API (replace with your actual API endpoint)
const { CHAT_SUGGESTIONS_URL: $9fd72ad2eb50d05b$var$CHAT_SUGGESTIONS_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $9fd72ad2eb50d05b$var$isSuggestionsResponse(data) {
    return typeof data === "object" && data !== null && "data" in data && Array.isArray(data.data) && data.data.every((item)=>typeof item === "object" && typeof item.text === "string" && typeof item.id === "string");
}
// Function to fetch ISPM suggestions
const $9fd72ad2eb50d05b$var$getSuggestionsApi = async (url)=>{
    const suggestionUrl = url ?? $9fd72ad2eb50d05b$var$CHAT_SUGGESTIONS_URL;
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(suggestionUrl, config, $9fd72ad2eb50d05b$var$isSuggestionsResponse);
    return response;
};
var $9fd72ad2eb50d05b$export$2e2bcd8739ae039 = $9fd72ad2eb50d05b$var$getSuggestionsApi;






$f4da21f6a9594cee$var$SaviSuggestionItem.default = {
    testId: ""
};
function $f4da21f6a9594cee$var$SaviSuggestionItem({ suggestion: suggestion, onClick: onClick, testId: testId }) {
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") onClick(suggestion);
    };
    return /*#__PURE__*/ (0, $cURGa$jsx)("article", {
        className: "Ispm-SaviSuggestionItem",
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            role: "button",
            tabIndex: 0,
            className: "Ispm-SaviSuggestionItem-content",
            title: suggestion,
            onKeyDown: handleKeyDown,
            onClick: ()=>{
                onClick(suggestion);
            },
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "Comment",
                    color: "purple-200",
                    size: "xLarge"
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-SaviSuggestionItem-content-text",
                    children: suggestion
                })
            ]
        })
    });
}
var $f4da21f6a9594cee$export$2e2bcd8739ae039 = $f4da21f6a9594cee$var$SaviSuggestionItem;



function $12a238da3b06d4cc$var$SaviSuggestions() {
    // ISPM related context values
    const { ispmState: ispmState, updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const suggestionRef = (0, $cURGa$useRef)(null);
    const [sessionData, setSessionData] = (0, $cURGa$useState)(null);
    const { CHAT_SUGGESTIONS_URL: CHAT_SUGGESTIONS_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(ispmState.useMockServerApis);
    const [isLoading, setIsLoading] = (0, $cURGa$useState)(false); // loading state
    const [isError, setIsError] = (0, $cURGa$useState)(null); // error state
    const [suggestionData, setSuggestionData] = (0, $cURGa$useState)(null); // error state
    const handleBlur = ()=>{
        updateIspmState("isSuggestionVisible", false);
    };
    const localize = (0, $10bf676d992f37e7$export$917bfb70a1457f2)();
    (0, $cURGa$useEffect)(()=>{
        window.addEventListener("blur", handleBlur);
        return ()=>{
            window.removeEventListener("blur", handleBlur);
        };
    });
    (0, $cURGa$useEffect)(()=>{
        const fetchSuggestion = async ()=>{
            try {
                setIsLoading(true); // set loading to true when API call starts
                const fetchedData = await (0, $9fd72ad2eb50d05b$export$2e2bcd8739ae039)(CHAT_SUGGESTIONS_URL);
                if (fetchedData) setSuggestionData(fetchedData); // Setting fetched data
            } catch (err) {
                setIsError("Error fetching suggestions");
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(err);
            } finally{
                setIsLoading(false); // turn off loading state once done
            }
        };
        fetchSuggestion().then(()=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Fetched new suggestions")).catch((err)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error in SaviSuggestion call", err));
    }, [
        CHAT_SUGGESTIONS_URL
    ]); // Minimal dependency array to trigger the API call
    (0, $cURGa$useEffect)(()=>{
        // Store fetched data in sessionStorage
        if (suggestionData) {
            sessionStorage.setItem("Ispm-Suggestions", JSON.stringify(suggestionData));
            setSessionData(suggestionData);
        } else {
            // If suggestionData is null, fetch from stored session data or use default
            const storedData = sessionStorage.getItem("Ispm-Suggestions");
            if (storedData) setSessionData(JSON.parse(storedData)); // Type assertion to avoid TypeScript error
            else setSessionData((0, $8ff2252602deef38$export$3c823f97330055c9));
        }
    }, [
        suggestionData
    ]); // Only update when `suggestionData` changes
    const handleClickOutside = (0, $cURGa$useCallback)((event)=>{
        const target = event.target; // improve 'as' assertion later
        const inputField = document.querySelector(// access element in a more 'react type' way.
        '[data-testid="ispm-dashboard-header-saviInputBox"]');
        // if click is on inputfield or within suggestions, keep suggestions open
        if (inputField === target) return;
        // otherwise close suggestions
        updateIspmState("isSuggestionVisible", false);
    }, [
        updateIspmState
    ]);
    (0, $cURGa$useOutsideClickEffect)(suggestionRef, handleClickOutside, true);
    const handleSuggestionClick = (text)=>{
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Handling suggestion click", {
            text: text
        });
        updateIspmState("isChatOverlayVisible", true);
        updateIspmState("isSuggestionVisible", false);
        updateIspmState("userQuery", text);
    };
    // Make suggestion api in background. We store this data irrespective of ispmState.isSuggestionVisible
    if (isLoading || isError || !ispmState.isSuggestionVisible || !Array.isArray(sessionData?.data)) // Don't display anything
    return null;
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-SaviSuggestions",
        ref: suggestionRef,
        "data-testid": (0, $b673ba598f0efd75$export$71a7c17545cbc03a),
        children: sessionData.data.map((ele)=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-SaviSuggestionsChild",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $f4da21f6a9594cee$export$2e2bcd8739ae039), {
                    suggestion: localize({
                        id: ele.id,
                        defaultMessage: ele.text
                    }),
                    onClick: handleSuggestionClick,
                    testId: `${(0, $b673ba598f0efd75$export$71a7c17545cbc03a)}-${ele.id}`
                })
            }, ele.id))
    });
}
var $12a238da3b06d4cc$export$2e2bcd8739ae039 = $12a238da3b06d4cc$var$SaviSuggestions;







// useClickOutside.tsx

/**
 * Handle Hide and show of the suggestion box.
 * The closest method is used to determine if the click happened
 * inside either the input container or the button container.
 * If not, the button is hidden.
 */ const $3548749b3798b00c$var$useClickInsideChecker = (callback, classNames)=>{
    (0, $cURGa$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const target = event.target;
            const isOutside = classNames.every((className)=>!target.closest(`.${className}`));
            if (isOutside) callback();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        callback,
        classNames
    ]);
};
var $3548749b3798b00c$export$2e2bcd8739ae039 = $3548749b3798b00c$var$useClickInsideChecker;






// Type definition for a single suggestion
/**
 * API - /chat/ask
 */ /**
 * API - /data/sample
 */ const $3b7091d4a3b49a26$export$164c971ebd50d6c4 = [
    "high",
    "low"
];
const $3b7091d4a3b49a26$export$231825b30414b761 = {
    HIGH: $3b7091d4a3b49a26$export$164c971ebd50d6c4[0],
    LOW: $3b7091d4a3b49a26$export$164c971ebd50d6c4[1]
};
const $3b7091d4a3b49a26$export$a377fac581ad525e = [
    "query",
    "sampleData",
    "text",
    "chart"
];
const $3b7091d4a3b49a26$export$69bd26c0ea27316c = {
    QUERY: $3b7091d4a3b49a26$export$a377fac581ad525e[0],
    SAMPLE_DATA: $3b7091d4a3b49a26$export$a377fac581ad525e[1],
    TEXT: $3b7091d4a3b49a26$export$a377fac581ad525e[2],
    CHART: $3b7091d4a3b49a26$export$a377fac581ad525e[3]
};
var $3b7091d4a3b49a26$export$55d956129a53d1d;
(function(ErrorTypeEnum) {
    ErrorTypeEnum["SaviCopilot"] = "Savi Copilot";
    ErrorTypeEnum["SQL"] = "SQL";
    ErrorTypeEnum["System"] = "System";
    ErrorTypeEnum["Aborted"] = "Abort";
})($3b7091d4a3b49a26$export$55d956129a53d1d || ($3b7091d4a3b49a26$export$55d956129a53d1d = {}));
const $3b7091d4a3b49a26$export$c23794c9fd9100cd = {
    chatuuid: "",
    contentType: $3b7091d4a3b49a26$export$69bd26c0ea27316c.TEXT,
    text: ""
};
var $3b7091d4a3b49a26$export$b718b0d2e31b8ab7;
(function(SeverityTypeEnum) {
    SeverityTypeEnum["critical"] = "critical";
    SeverityTypeEnum["High"] = "high";
    SeverityTypeEnum["Medium"] = "medium";
    SeverityTypeEnum["Low"] = "low";
})($3b7091d4a3b49a26$export$b718b0d2e31b8ab7 || ($3b7091d4a3b49a26$export$b718b0d2e31b8ab7 = {}));


const { CHAT_ASK_STREAM_URL: $6c83244d4b7ea351$var$CHAT_ASK_STREAM_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
class $6c83244d4b7ea351$export$1b5d820b5ca8d1fc extends Error {
    constructor(message, code, details){
        super(message);
        this.code = code;
        this.details = details;
        this.name = "StreamError";
    }
}
const $6c83244d4b7ea351$var$callChatAskStreamApi = async (request)=>{
    const response = await fetch($6c83244d4b7ea351$var$CHAT_ASK_STREAM_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "text/event-stream"
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let partialLine = "";
    let resultBuffer = ""; // Buffer to accumulate result data
    let streamData = {};
    let hasError = false; // Flag to track if an error event has occurred
    if (reader) {
        let readerDone = false;
        while(!readerDone){
            // eslint-disable-next-line no-await-in-loop
            const { done: done, value: value } = await reader.read();
            readerDone = done;
            if (done) break;
            const chunk = decoder.decode(value);
            const lines = (partialLine + chunk).split("\n");
            partialLine = lines.pop() ?? "";
            for(let i = 0; i < lines.length; i += 1){
                const line = lines[i];
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Call chatAsk API stream Loop started - ", {
                    line: line,
                    resultBuffer: resultBuffer
                });
                if (line.startsWith("data:")) {
                    const messageContent = line.substring(line.indexOf(":") + 1).trim();
                    if (messageContent.length > 0) resultBuffer += messageContent;
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Call chatAsk API stream Loop - data capturing - ", {
                        resultBuffer: resultBuffer
                    });
                }
                if (line.startsWith("event:")) {
                    const eventType = line.substring(line.indexOf(":") + 1).trim();
                    const dataLine = lines[i + 1];
                    const messageContent = dataLine && dataLine.startsWith("data:") ? dataLine.substring(dataLine.indexOf(":") + 1).trim() : null;
                    if (!messageContent) continue;
                    try {
                        switch(eventType){
                            case "heartbeat":
                                break;
                            case "error":
                                {
                                    const parsedData = JSON.parse(messageContent);
                                    // Set the error flag and clear the buffer
                                    hasError = true;
                                    resultBuffer = "";
                                    throw new $6c83244d4b7ea351$export$1b5d820b5ca8d1fc(parsedData.message ?? "Unknown error", parsedData.code ?? 500, parsedData);
                                }
                            case "result":
                                break;
                            case "close":
                                // If an error occurred, skip processing the result buffer
                                if (hasError) break;
                                // Parse the accumulated result data when the stream is closed
                                try {
                                    const parsedData = JSON.parse(resultBuffer);
                                    streamData = parsedData;
                                    // Add contentType and links
                                    if (!streamData.contentType) streamData.contentType = Array.isArray(streamData.data) ? (0, $3b7091d4a3b49a26$export$69bd26c0ea27316c).SAMPLE_DATA : (0, $3b7091d4a3b49a26$export$69bd26c0ea27316c).TEXT;
                                    if (!streamData.links) {
                                        if (streamData.chartSpec && Array.isArray(streamData.data)) streamData.links = [
                                            {
                                                text: "View Chart",
                                                id: "View_Data"
                                            }
                                        ];
                                        else if (Array.isArray(streamData.data)) streamData.links = [
                                            {
                                                text: "View Table",
                                                id: "View_Table"
                                            }
                                        ];
                                        else if (streamData.chartSpec) streamData.links = [
                                            {
                                                text: "View Chart",
                                                id: "View_Chart"
                                            }
                                        ];
                                    }
                                } catch (error) {
                                    throw new Error("Failed to parse accumulated result data");
                                }
                                // Returning from here. No new line will be parsed.
                                return streamData;
                            default:
                        }
                    } catch (error) {
                        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error processing event:", {
                            eventType: eventType,
                            messageContent: messageContent,
                            error: error
                        });
                    }
                }
            }
        }
    }
    if (partialLine) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Partial line remaining:", partialLine);
    return streamData;
};
var $6c83244d4b7ea351$export$2e2bcd8739ae039 = $6c83244d4b7ea351$var$callChatAskStreamApi;





// hooks/useApiCall.ts







// hooks/useContextManagement.ts





// hooks/useMessageHandlers.ts






const $f4af97ac92900bf2$var$useMessageHandlers = ()=>{
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const updateAutomatedUserMessageInSession = (0, $cURGa$useCallback)((message, options)=>{
        if (message.length > 0) {
            const userMessage = {
                id: `${Date.now()}-user`,
                text: l(message),
                isUser: true,
                timestamp: Date.now(),
                isDividerRequired: options?.isDividerRequired ?? false,
                ParentMessageId: null,
                conversationId: null
            };
            updateChatOverlayState("messages", (0, $84076bccc3151b37$export$8f827adf405a2374)(userMessage));
        }
    }, [
        updateChatOverlayState,
        l
    ]);
    const updateUserMessageInSession = (0, $cURGa$useCallback)((request)=>{
        if (typeof request === "object" && "freeText" in request) {
            const userMessage = {
                id: `${Date.now()}-user`,
                text: request.freeText,
                isUser: true,
                timestamp: Date.now(),
                ParentMessageId: request.parentMessageId,
                conversationId: request.conversationId
            };
            updateChatOverlayState("messages", (0, $84076bccc3151b37$export$8f827adf405a2374)(userMessage));
        }
    }, [
        updateChatOverlayState
    ]);
    const updateApiResponseInSession = (0, $cURGa$useCallback)((response)=>{
        if (!response.messageId || !response.conversationId) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("updateApiResponseInSession - message or conversation id is missing.");
        const botMessage = {
            id: `${Date.now()}-bot`,
            data: response,
            isUser: false,
            timestamp: Date.now(),
            messageId: response.messageId ?? null,
            conversationId: response.conversationId ?? null
        };
        updateChatOverlayState("messages", (0, $84076bccc3151b37$export$8f827adf405a2374)(botMessage));
    }, [
        updateChatOverlayState
    ]);
    const updateAutomatedApiResponseInSession = (0, $cURGa$useCallback)((message, options)=>{
        const botMessage = {
            id: `${Date.now()}-bot`,
            data: {
                text: l(message)
            },
            isUser: false,
            timestamp: Date.now(),
            ...options?.isSaveToChart && {
                isSaveToChart: options.isSaveToChart
            },
            messageId: null,
            conversationId: null
        };
        updateChatOverlayState("messages", (0, $84076bccc3151b37$export$8f827adf405a2374)(botMessage));
    }, [
        l,
        updateChatOverlayState
    ]);
    return {
        updateUserMessageInSession: updateUserMessageInSession,
        updateApiResponseInSession: updateApiResponseInSession,
        updateAutomatedUserMessageInSession: updateAutomatedUserMessageInSession,
        updateAutomatedApiResponseInSession: updateAutomatedApiResponseInSession
    };
};
var $f4af97ac92900bf2$export$2e2bcd8739ae039 = $f4af97ac92900bf2$var$useMessageHandlers;


/**
 * A custom hook that manages the application context before and after making API calls.
 * It handles updates to the chat overlay and ISPM states, manages session-related messages,
 * and prepares the UI for API requests and responses.
 *
 * @returns {Object} - An object containing functions to update context before and after API calls.
 */ const $be51bd10ca33face$var$useContextManagement = ()=>{
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const { updateApiResponseInSession: updateApiResponseInSession, updateUserMessageInSession: updateUserMessageInSession } = (0, $f4af97ac92900bf2$export$2e2bcd8739ae039)();
    const { updateIspmErrorState: updateIspmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    const dispatch = (0, $cURGa$useDispatch)();
    /**
   * Updates the application context before making an API call.
   * This function:
   * - Resets certain UI inputs.
   * - Disables the input field and displays a loading screen.
   * - Marks the API call as "in progress."
   * - Saves the user's message in the session.
   *
   * @param {AskApiRequest} request - The API request payload.
   */ const updateContextBeforeMakingApiCall = (0, $cURGa$useCallback)((request)=>{
        // Reset the input value in ISPM state
        updateIspmState("ispmInputValue", "");
        updateChatOverlayState("saviInputText", "");
        // Disable user input and show loading screen
        updateChatOverlayState("inputDisabled", true);
        // Enable left hand side content panel
        updateChatOverlayState("showGeneratedContent", true);
        // Display loading screen there
        updateChatOverlayState("contentPanelKind", (0, $6232c3747a1d613b$export$950a020027fa5a0b).GENERATING_CONTENT);
        // Mark API call as in progress
        updateChatOverlayState("isApiCallInProgress", true);
        // Reset current error type
        updateIspmErrorState("errorType", undefined);
        // Store user's message in the session
        updateUserMessageInSession(request);
    }, [
        updateChatOverlayState,
        updateIspmErrorState,
        updateIspmState,
        updateUserMessageInSession
    ]);
    /**
   * Updates the application context after receiving an API response.
   * This function:
   * - Resets certain states like `userQuery`.
   * - Marks the API call as complete and re-enables the input field.
   * - Updates the session with the response.
   * - Handles cases where there is an error in the response.
   *
   * @param {AskApiResponse | undefined} response - The API response payload.
   * @param {AskApiRequest} request - The original API request payload.
   */ const updateContextAfterMakingApiCall = (0, $cURGa$useCallback)((response, request)=>{
        if (!response) return;
        // reset userQuery. Based on its value change - we are making calls to savi
        updateIspmState("userQuery", "");
        // Reset api call  progress to false.
        updateChatOverlayState("isApiCallInProgress", false);
        updateChatOverlayState("inputDisabled", false);
        let tempRequest;
        if ("request" in response) tempRequest = response.request;
        // Combine the response with the request for future reference
        const updatedResponseWithRequest = {
            ...response,
            request: {
                ...tempRequest,
                ...request
            }
        };
        // Store the updated response with the request in the session
        updateApiResponseInSession(updatedResponseWithRequest);
        // If the response indicates a error other than ispm server error, return early.
        // don't update the session chatuuid
        if (!response.messageId || !response.conversationId || response.messageId === "error") return;
        // Update ISPM state with the latest `chatuuid` from the response
        dispatch((0, $27fb994cf82006a6$export$a175e86c8914494f)(response.messageId));
        dispatch((0, $27fb994cf82006a6$export$58213391a19e392)(response.conversationId));
        // Update the chat overlay content panel with the new response data
        updateChatOverlayState("contentPanelData", updatedResponseWithRequest);
    }, [
        dispatch,
        updateApiResponseInSession,
        updateChatOverlayState,
        updateIspmState
    ]);
    return {
        updateContextBeforeMakingApiCall: updateContextBeforeMakingApiCall,
        updateContextAfterMakingApiCall: updateContextAfterMakingApiCall
    };
};
var $be51bd10ca33face$export$2e2bcd8739ae039 = $be51bd10ca33face$var$useContextManagement;


// hooks/useResponseHandlers.ts






/**
 * A custom hook that handles different types of responses and updates the chat overlay context accordingly.
 * Each handler manages specific types of content or error responses by modifying the context state.
 *
 * @returns {Object} - An object containing various response handlers to manage UI updates based on the response type.
 */ const $da522b3e166499ff$var$useResponseHandlers = ()=>{
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { updateIspmErrorState: updateIspmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    const { updateAutomatedUserMessageInSession: updateAutomatedUserMessageInSession, updateAutomatedApiResponseInSession: updateAutomatedApiResponseInSession } = (0, $f4af97ac92900bf2$export$2e2bcd8739ae039)();
    /**
   * Handles a random response by hiding the generated content panel.
   */ const handleRandomResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("showGeneratedContent", false);
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a high-confidence response that requires a table display.
   * Updates the content panel kind to 'table'.
   */ const handleHighConfidenceTableResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "table");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a high-confidence response that requires a chart display.
   * Updates the content panel kind to 'chart'.
   */ const handleHighConfidenceChartResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "chart");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a sample data chart response by updating the content panel kind to 'chart'.
   */ const handleSampleDataChartResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "chart");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a low-confidence response that is displayed in a tabular format.
   * Updates the content panel kind to 'lowConfidence'.
   */ const handleLowConfidenceTabularResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "lowConfidence");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a low-confidence response that is displayed as a chart.
   * Updates the content panel kind to 'lowConfidence'.
   */ const handleLowConfidenceChartResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "lowConfidence");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a sample data table response by updating the content panel kind to 'table'.
   */ const handleSampleDataTableResponse = (0, $cURGa$useCallback)(()=>{
        updateChatOverlayState("contentPanelKind", "table");
    }, [
        updateChatOverlayState
    ]);
    /**
   * Handles a generic error response by hiding the generated content panel.
   */ const handleErrorResponse = (0, $cURGa$useCallback)((errorType)=>{
        updateChatOverlayState("showGeneratedContent", false);
        updateIspmErrorState("errorType", errorType);
        if (errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System) updateChatOverlayState("inputDisabled", false);
        else if (errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).SQL) {
            updateChatOverlayState("showGeneratedContent", true);
            updateChatOverlayState("contentPanelKind", (0, $6232c3747a1d613b$export$950a020027fa5a0b).SQL_ERROR);
        } else if (errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).Aborted) {
            updateChatOverlayState("inputDisabled", false);
            updateChatOverlayState("isApiCallInProgress", false);
            updateChatOverlayState("isWarningModalOpen", false);
            updateChatOverlayState("showGeneratedContent", false);
            updateAutomatedUserMessageInSession((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).STOP_PROCESSING.userQuery, {
                isDividerRequired: false
            });
            updateAutomatedApiResponseInSession((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).STOP_PROCESSING.response);
        }
    }, [
        updateAutomatedApiResponseInSession,
        updateAutomatedUserMessageInSession,
        updateChatOverlayState,
        updateIspmErrorState
    ]);
    return {
        handleRandomResponse: handleRandomResponse,
        handleHighConfidenceTableResponse: handleHighConfidenceTableResponse,
        handleSampleDataTableResponse: handleSampleDataTableResponse,
        handleErrorResponse: handleErrorResponse,
        handleHighConfidenceChartResponse: handleHighConfidenceChartResponse,
        handleSampleDataChartResponse: handleSampleDataChartResponse,
        handleLowConfidenceTabularResponse: handleLowConfidenceTabularResponse,
        handleLowConfidenceChartResponse: handleLowConfidenceChartResponse
    };
};
var $da522b3e166499ff$export$2e2bcd8739ae039 = $da522b3e166499ff$var$useResponseHandlers;


/**
 * A custom hook that provides a unified API call handler for handling various API requests
 * (e.g., Ask API or Sample Data API). This hook manages the request lifecycle, updates
 * context before and after the API call, and handles different response types.
 *
 * @returns {Object} - The handleApiCall function to execute API requests.
 */ const $26ce4e7809bb3256$var$isAbortedError = (err)=>{
    if ((0, $cURGa$axios).isCancel(err)) return true;
    return false;
};
const $26ce4e7809bb3256$var$useApiCall = ()=>{
    const { updateContextAfterMakingApiCall: updateContextAfterMakingApiCall, updateContextBeforeMakingApiCall: updateContextBeforeMakingApiCall } = (0, $be51bd10ca33face$export$2e2bcd8739ae039)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { handleErrorResponse: handleErrorResponse, handleHighConfidenceChartResponse: handleHighConfidenceChartResponse, handleHighConfidenceTableResponse: handleHighConfidenceTableResponse, handleLowConfidenceChartResponse: handleLowConfidenceChartResponse, handleLowConfidenceTabularResponse: handleLowConfidenceTabularResponse, handleRandomResponse: handleRandomResponse, handleSampleDataChartResponse: handleSampleDataChartResponse, handleSampleDataTableResponse: handleSampleDataTableResponse } = (0, $da522b3e166499ff$export$2e2bcd8739ae039)();
    /**
   * Handles an API call, processing the request and response. This function performs
   * the following steps:
   * 1. Updates the context before making the API call.
   * 2. Makes the API request using the provided `apiCall` function.
   * 3. Handles different types of responses based on the content type or confidence level.
   * 4. Updates the context after the API call and logs relevant information.
   * 5. Catches and handles errors during the API request.
   *
   * @template TRequest - The type of the request object (e.g., AskApiRequest, SampleDataApiRequest).
   * @template TResponse - The type of the response object (e.g., AskApiResponse, SampleDataAPIResponse).
   *
   * @param {TRequest} request - The API request payload.
   * @param {(request: TRequest, url: string) => Promise<TResponse>} apiCall - The API function to be called.
   * @param {string} url - The URL to which the API request is sent.
   *
   * @returns {Promise<void>} A promise that resolves when the API call completes or fails.
   */ const handleApiCall = (0, $cURGa$useCallback)(async (request, apiCall, url, signal)=>{
        if (chatOverlayState.isApiCallInProgress) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("handleApiCall --> Api call is in progress. blocking api call");
            return;
        }
        updateContextBeforeMakingApiCall(request);
        try {
            const response = await apiCall(request, url, signal);
            // To mock the api call, comment above line. uncomment below 2 linwa.
            // await Promise.resolve(() => console.log({ apiCall, url, request }));
            // const response = highConfidenceSQLError as TResponse;
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("RESPONSE from API call", {
                chatData: response
            });
            if ("contentType" in response) {
                updateContextAfterMakingApiCall(response, request);
                switch(response.contentType){
                    case "text":
                        // If content type is text - it means general response
                        if ("error" in response && response.error) {
                            handleErrorResponse(response.error.type ?? (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
                            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("Error scenario, There can be any type of error that can happen.");
                        } else handleRandomResponse();
                        break;
                    case "sampleData":
                        if (response.confidence === "low") handleSampleDataTableResponse();
                        else handleHighConfidenceTableResponse();
                        break;
                    case "chart":
                        if (response.confidence === "low") handleSampleDataChartResponse();
                        else handleHighConfidenceChartResponse();
                        break;
                    case "query":
                        if ("error" in response) {
                            handleErrorResponse(response.error?.type ?? (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
                            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("Error scenario, There can be any type of error that can happen.");
                        } else if ("confidence" in response) {
                            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("no error - low confidence scenario");
                            if ("chartSpec" in response) {
                                handleLowConfidenceChartResponse();
                                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("handle chart low confidence ask api response");
                            } else {
                                handleLowConfidenceTabularResponse();
                                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("handle table low confidence ask api response");
                            }
                        }
                        break;
                    default:
                        // Handle generic error
                        handleErrorResponse((0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
                        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Unexpected content type:", response);
                        break;
                }
            } else if ("error" in response) {
                updateContextAfterMakingApiCall(response, request);
                // Handle generic error
                handleErrorResponse(response.error?.type ?? (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Response does not have contentType property:", response);
            } else throw Error("Response structure not recognised");
        } catch (err) {
            if ($26ce4e7809bb3256$var$isAbortedError(err)) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Request was aborted");
                handleErrorResponse((0, $3b7091d4a3b49a26$export$55d956129a53d1d).Aborted);
                return;
            }
            const errResponse = {
                // Update with current chatuuid because server will have this chatuuid.
                // code will reach here if we are not able to hit server.
                chatuuid: "error",
                error: {
                    errorCode: "I1001",
                    errorMsg: l("Sorry, there was an error or interruption while processing your prompt. When the service becomes available again, you can either enter your original prompt or try a new one"),
                    type: (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System
                }
            };
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error in API call", {
                err: err,
                errResponse: errResponse
            });
            updateContextAfterMakingApiCall(errResponse, request);
            handleErrorResponse(errResponse.error.type);
        }
    }, [
        chatOverlayState.isApiCallInProgress,
        updateContextBeforeMakingApiCall,
        updateContextAfterMakingApiCall,
        handleRandomResponse,
        handleErrorResponse,
        handleSampleDataTableResponse,
        handleHighConfidenceTableResponse,
        handleSampleDataChartResponse,
        handleHighConfidenceChartResponse,
        handleLowConfidenceChartResponse,
        handleLowConfidenceTabularResponse,
        l
    ]);
    return {
        handleApiCall: handleApiCall
    };
};
var $26ce4e7809bb3256$export$2e2bcd8739ae039 = $26ce4e7809bb3256$var$useApiCall;


/**
 * Custom hook that provides access to various API calls used in the chat overlay.
 *
 * This hook utilizes the chat and ISPM contexts and integrates with specific API services.
 * It handles chat history, low confidence responses, and general chat API requests.
 *
 * @returns {object} - An object containing two functions for handling chat API and sample data API requests:
 *   - `handleChatAskApiInChatOverlay`: Handles making a chat ask API call.
 *   - `handleLowConfidenceSampleDataApi`: Handles making a sample data API call for low-confidence responses.
 */ const $ae1dd58e52a4b09a$var$useSaviApi = ()=>{
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { handleApiCall: handleApiCall } = (0, $26ce4e7809bb3256$export$2e2bcd8739ae039)();
    const { controllerRef: controllerRef } = (0, $08bb17136b599311$export$4db023b7660421fa)();
    const { CHAT_ASK_STREAM_URL: CHAT_ASK_STREAM_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
    if (!controllerRef.current) controllerRef.current = new AbortController();
    const { signal: signal } = controllerRef.current;
    (0, $cURGa$useEffect)(()=>{
        updateChatOverlayState("messages", []);
        (0, $84076bccc3151b37$export$f783cf703394eac5)();
    }, [
        updateChatOverlayState
    ]);
    /**
   * Makes a chat ask API call within the chat overlay.
   *
   * This function is responsible for making the chat ask API call when the user submits a query
   * in the chat overlay. It checks for empty queries and logs appropriate information.
   *
   * @function handleChatAskApiInChatOverlay
   *
   * @param {AskApiRequestv2} askRequest - The request payload containing the user's free text query and chat UUID.
   *
   * @returns {void}
   */ const handleChatAskApiInChatOverlay = (0, $cURGa$useCallback)((askRequest)=>{
        if (askRequest.freeText.length === 0) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("handleChatAskApiInChatOverlay --> No query text available to call chatask");
            return;
        }
        // Make the API call to process the chat query
        handleApiCall(askRequest, (0, $6c83244d4b7ea351$export$2e2bcd8739ae039), CHAT_ASK_STREAM_URL, signal).then(()=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("call chat Ask request succeded")).catch((error)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("call chat ask request failed", {
                error: error
            }));
    }, [
        CHAT_ASK_STREAM_URL,
        handleApiCall,
        signal
    ]);
    // Return both API handling functions for use in the component
    return {
        handleChatAskApiInChatOverlay: handleChatAskApiInChatOverlay
    };
};
var $ae1dd58e52a4b09a$export$2e2bcd8739ae039 = $ae1dd58e52a4b09a$var$useSaviApi;




/**
 * Custom hook to manage the responsive behavior of the Data Panel
 * based on the screen size (mobile vs desktop).
 *
 * @param {number} [breakpoint=768] - The screen width (in pixels) at which
 * the layout switches between mobile and desktop views. Default is 768px.
 *
 * This hook adds event listeners to handle screen resizing and updates
 * the chat overlay state accordingly.
 *
 * The hook consists of two useEffect calls:
 * 1. Monitors the `chatOverlayState.isDataPanelFullScreen`. If this state is false,
 *    it hides the generated content by updating `showGeneratedContent` to false,
 *    effectively skipping the 60% width for the Data Panel.
 * 2. Monitors the `chatOverlayState.showGeneratedContent`. If this state is true
 *    on mobile screens, it updates `isDataPanelFullScreen` to true to ensure the
 *    Data Panel expands to 100% width, skipping the intermediate 60% width.
 *
 * Note: The event listeners are cleaned up when the component using
 * this hook unmounts.
 */ function $de50f43fd19289fe$var$useResponsiveDataPanelFullScreen(breakpoint = 768) {
    const { updateChatOverlayState: updateChatOverlayState, chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    (0, $cURGa$useEffect)(()=>{
        // Helper function to handle resizing logic for mobile (< 768px) vs desktop (>= 768px)
        const handleResize = ()=>{
            const isMobile = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
            if (isMobile) // On mobile, the Data Panel is either 100% or 0%, skip 60% width.
            {
                if (!chatOverlayState.isDataPanelFullScreen) // If showGeneratedContent is true, make Data Panel 100% (isDataPanelFullScreen true)
                updateChatOverlayState("showGeneratedContent", false);
            }
        };
        // Check the initial screen size on mount and handle resize accordingly
        handleResize();
        // Add resize event listener
        window.addEventListener("resize", handleResize);
        // Cleanup the event listener on component unmount
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        breakpoint,
        chatOverlayState.isDataPanelFullScreen,
        updateChatOverlayState
    ]);
    (0, $cURGa$useEffect)(()=>{
        // Helper function to handle resizing logic for mobile (< 768px) vs desktop (>= 768px)
        const handleResize = ()=>{
            const isMobile = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
            if (isMobile) // On mobile, the Data Panel is either 100% or 0%, skip 60% width.
            {
                if (chatOverlayState.showGeneratedContent) // If showGeneratedContent is true, make Data Panel 100% (isDataPanelFullScreen true)
                updateChatOverlayState("isDataPanelFullScreen", true);
            }
        };
        // Check the initial screen size on mount and handle resize accordingly
        handleResize();
        // Add resize event listener
        window.addEventListener("resize", handleResize);
        // Cleanup the event listener on component unmount
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        breakpoint,
        chatOverlayState.showGeneratedContent,
        updateChatOverlayState
    ]);
}
var $de50f43fd19289fe$export$2e2bcd8739ae039 = $de50f43fd19289fe$var$useResponsiveDataPanelFullScreen;




const $21de21e1dc30b11d$var$ACTIVE_TAB_ID_KEY = "savichat_active_tab";
const $21de21e1dc30b11d$var$useMultipleTabCheck = ()=>{
    const [isActiveTab, setIsActiveTab] = (0, $cURGa$useState)(false);
    const [showModal, setShowModal] = (0, $cURGa$useState)(false);
    // generate a unique tab ID when the hook initializes
    const tabIdRef = (0, $cURGa$useRef)(`${Date.now()}_${Math.random()}`);
    const isActiveTabRef = (0, $cURGa$useRef)(false);
    const [cookies, setCookie, removeCookie] = (0, $cURGa$useCookies)([
        $21de21e1dc30b11d$var$ACTIVE_TAB_ID_KEY
    ]);
    // use session cookies in case of a browser crash.
    // the user won't be locked out because the browser will not retain the cookie.
    const setSessionCookie = (value)=>{
        setCookie($21de21e1dc30b11d$var$ACTIVE_TAB_ID_KEY, value, {
            path: "/"
        });
    // No 'expires' or 'maxAge' makes it a session cookie
    };
    const getSessionCookie = (key)=>cookies[key];
    const removeSessionCookie = (key)=>{
        removeCookie(key, {
            path: "/"
        });
    };
    const checkActiveTabStatus = ()=>{
        // check and update the active tab status
        const activeTabId = getSessionCookie($21de21e1dc30b11d$var$ACTIVE_TAB_ID_KEY);
        if (!activeTabId) {
            setSessionCookie(tabIdRef.current);
            setIsActiveTab(true);
            isActiveTabRef.current = true;
            setShowModal(false);
        } else if (activeTabId === tabIdRef.current) {
            setIsActiveTab(true);
            isActiveTabRef.current = true;
            setShowModal(false);
        } else {
            setIsActiveTab(false);
            isActiveTabRef.current = false;
            setShowModal(true);
        }
    };
    // clean up on tab closure
    const handleDeleteActiveTabCookie = ()=>{
        if (isActiveTabRef.current) removeSessionCookie($21de21e1dc30b11d$var$ACTIVE_TAB_ID_KEY);
    };
    const handleBeforeUnload = ()=>{
        handleDeleteActiveTabCookie();
    };
    (0, $cURGa$useEffect)(()=>{
        // initial check on component mount
        checkActiveTabStatus();
        window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            handleDeleteActiveTabCookie();
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // empty dependency array to run only once on mount
    return {
        isActiveTab: isActiveTab,
        showModal: showModal
    };
};
var $21de21e1dc30b11d$export$2e2bcd8739ae039 = $21de21e1dc30b11d$var$useMultipleTabCheck;







const { DASHBOARD_URL: $54d397881d836571$var$DASHBOARD_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $54d397881d836571$var$isSaveChartResponse(data) {
    return typeof data === "object" && data !== null;
}
// Function to fetch ISPM suggestions
const $54d397881d836571$var$saveChartToDashboard = async (request, url)=>{
    const dashboardUrl = url ?? $54d397881d836571$var$DASHBOARD_URL;
    const config = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        data: request
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(dashboardUrl, config, $54d397881d836571$var$isSaveChartResponse);
    return response;
};
var $54d397881d836571$export$2e2bcd8739ae039 = $54d397881d836571$var$saveChartToDashboard;





const { DATA_DOWNLOAD_URL: $a0baa086930702ca$var$DATA_DOWNLOAD_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
const $a0baa086930702ca$var$callDownloadApi = async (request, url)=>{
    if (!request.messageId) throw new Error("messageId is required for download");
    const baseDownloadUrl = url ?? $a0baa086930702ca$var$DATA_DOWNLOAD_URL;
    const downloadUrl = `${baseDownloadUrl}/${request.messageId}/download`;
    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
        responseType: "blob"
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(downloadUrl, options, (data)=>data instanceof Blob);
        if (!(response instanceof Blob)) throw new Error("Invalid response format: Expected Blob");
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error during file download:", error);
        return {
            status: "error",
            error: {
                errorCode: "DOWNLOAD_ERROR",
                errorMsg: "Failed to download the file",
                type: (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System
            }
        };
    }
};
var $a0baa086930702ca$export$2e2bcd8739ae039 = $a0baa086930702ca$var$callDownloadApi;




const { DASHBOARD_LIST_URL: $590c9a6ca81591fc$var$DASHBOARD_LIST_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $590c9a6ca81591fc$var$isDashboardListResponse(data) {
    return typeof data === "object" && data !== null;
}
// Function to fetch ISPM suggestions
const $590c9a6ca81591fc$var$getDashboardList = async (url)=>{
    const dashboardListUrl = url ?? $590c9a6ca81591fc$var$DASHBOARD_LIST_URL;
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(dashboardListUrl, config, $590c9a6ca81591fc$var$isDashboardListResponse);
    return response;
};
var $590c9a6ca81591fc$export$2e2bcd8739ae039 = $590c9a6ca81591fc$var$getDashboardList;





const { DATA_SAMPLE_URL: $7b426b3c77c848e8$var$DATA_SAMPLE_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $7b426b3c77c848e8$var$isChatAskResponse(data) {
    return typeof data === "object" && data !== null && "chatuuid" in data;
}
const $7b426b3c77c848e8$var$callSampleDataApi = async (request, url, signal)=>{
    const sampleDataUrl = url ?? $7b426b3c77c848e8$var$DATA_SAMPLE_URL;
    const options = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        data: request
    };
    let response;
    try {
        response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(sampleDataUrl, options, $7b426b3c77c848e8$var$isChatAskResponse, signal);
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info(error);
        throw error;
    }
    return response;
};
var $7b426b3c77c848e8$export$2e2bcd8739ae039 = $7b426b3c77c848e8$var$callSampleDataApi;







const $5da53bdd33fdabaa$var$useDownloadApi = ()=>{
    /**
   * handles file download requests and returns the result.
   * @param query query string for the download request
   * @returns Promise<DownloadResult> result of the download operation
   */ const { ispmState: ispmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const { DATA_DOWNLOAD_URL: DATA_DOWNLOAD_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(ispmState.useMockServerApis);
    const handleDownload = (0, $cURGa$useCallback)(async (messageId)=>{
        try {
            const request = {
                messageId: messageId
            };
            const response = await (0, $a0baa086930702ca$export$2e2bcd8739ae039)(request, DATA_DOWNLOAD_URL);
            if ("error" in response) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Download failed:", response.error);
                return {
                    success: false,
                    error: response.error
                };
            }
            if (response instanceof Blob) try {
                // If the response is raw binary data, create a Blob directly
                const blob = response instanceof Blob ? response : new Blob([
                    response
                ], {
                    type: "text/csv"
                });
                const link = document.createElement("a");
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.download = `${messageId}.gz`; // Default filename with .gz extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url); // Clean up the object URL
                return {
                    success: true
                };
            } catch (error) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error processing file content:", error);
                return {
                    success: false,
                    error: {
                        errorCode: "UI-E04",
                        errorMsg: "Failed to process file content",
                        type: "UI"
                    }
                };
            }
            // Unexpected response format
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Unexpected response format:", response);
            return {
                success: false,
                error: {
                    errorCode: "UI-E03",
                    errorMsg: "Unexpected response format",
                    type: "UI"
                }
            };
        } catch (error) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error in download:", error);
            return {
                success: false,
                error: {
                    errorCode: "UI-E02",
                    errorMsg: "Failed to download data",
                    type: "UI"
                }
            };
        }
    }, [
        DATA_DOWNLOAD_URL
    ]);
    return {
        handleDownload: handleDownload
    };
};
var $5da53bdd33fdabaa$export$2e2bcd8739ae039 = $5da53bdd33fdabaa$var$useDownloadApi;




const $c638973f33534342$var$useGeneratingContentLoadingMessages = (sidePanelDataLoaderTexts)=>{
    const [loaderTitleIndex, setLoaderTitleIndex] = (0, $cURGa$useState)(0); // Track the current parent index
    const [loaderDescriptionIndex, setLoaderDescriptionIndex] = (0, $cURGa$useState)(0); // Track the current child index
    const keys = (0, $cURGa$useMemo)(()=>Object.keys(sidePanelDataLoaderTexts), [
        sidePanelDataLoaderTexts
    ]); // Extract keys from data
    const loaderTitleText = (0, $cURGa$useMemo)(()=>keys[loaderTitleIndex], [
        keys,
        loaderTitleIndex
    ]); // Get current parent text
    const loaderDescriptionText = (0, $cURGa$useMemo)(()=>sidePanelDataLoaderTexts[loaderTitleText][loaderDescriptionIndex], [
        sidePanelDataLoaderTexts,
        loaderTitleText,
        loaderDescriptionIndex
    ]);
    (0, $cURGa$useEffect)(()=>{
        let interval;
        if (sidePanelDataLoaderTexts && keys.length > 0) interval = setTimeout(()=>{
            const currentChildArray = sidePanelDataLoaderTexts[loaderTitleText]; // Get the current child array based on parent text
            if (currentChildArray && currentChildArray.length > 0 && loaderDescriptionIndex < currentChildArray.length - 1) // Move to the next child
            setLoaderDescriptionIndex((prev)=>prev + 1);
            else if (loaderTitleIndex < keys.length - 1) {
                // Move to the next parent and reset child index
                setLoaderDescriptionIndex(0);
                setLoaderTitleIndex((prev)=>prev + 1);
            }
            clearTimeout(interval);
        }, (0, $8ff2252602deef38$export$73bab687a662941a)()); // Update every 5 seconds
        return ()=>clearTimeout(interval); // Cleanup interval on unmount
    }, [
        loaderDescriptionIndex,
        loaderTitleIndex,
        loaderTitleText,
        sidePanelDataLoaderTexts,
        keys
    ]);
    return {
        loaderTitleText: loaderTitleText,
        loaderDescriptionText: loaderDescriptionText
    };
};
var $c638973f33534342$export$2e2bcd8739ae039 = $c638973f33534342$var$useGeneratingContentLoadingMessages;




/**
 * Hook to manage low-trust detection animations.
 *
 * @param setIsAnimate - Function to update the animate state.
 * @param setIsOpen - Function to update the open state.
 * @returns An object containing handlers for "see more" and "close" actions.
 */ function $42764b6024b73500$var$useLowTrustDetectionAnimationHandlers(setIsAnimate, setIsOpen) {
    const leftNavPinned = localStorage.getItem("gen2.layout.isMenuPinned") || false;
    const [windowWidth, setWindowWidth] = (0, $cURGa$useState)(window.innerWidth);
    (0, $cURGa$useEffect)(()=>{
        const handleResize = ()=>{
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const isSmallScreen = windowWidth <= 1100;
    /**
   * Applies a CSS animation to the given element.
   *
   * Resets any existing animation, forces a reflow to ensure the new animation starts,
   * and then applies the new animation.
   *
   * @param element — The target HTML or SVG element.
   * @param animation - The CSS animation string to be applied.
   */ const applyAnimation = (element, animation)=>{
        // Use a local reference for the element's style to avoid directly modifying a parameter.
        const { style: style } = element;
        style.animation = "none";
        // Force a reflow by immediately invoking a function that reads a layout property.
        if (element instanceof HTMLElement) (()=>element.offsetWidth)();
        else (()=>element.getBoundingClientRect().width)();
        // Apply the new animation.
        style.animation = animation;
    };
    /**
   * Retrieves the required DOM elements for low-trust detection animations.
   *
   * @param includeButton - Whether to include the "see more" button element.
   * @returns An object containing the relevant DOM elements.
   */ const getElements = (includeButton = false)=>{
        const elements = {
            svgElement: document.querySelector(".Ispm-LowTrustDetection-content svg"),
            comingSoonElement: document.querySelector(".Ispm-LowTrustDetection-comingSoon"),
            trustContentElement: document.querySelector(".Ispm-LowTrustDetection-trustContent"),
            leftContainer: document.querySelector(".Ispm-Ootb-Section2-LeftContainer"),
            rightContainer: document.querySelector(".Ispm-Ootb-Section2-RightContainer"),
            closeButtonElement: document.querySelector(".Ispm-LowTrustDetection-close")
        };
        if (includeButton) elements.seeMoreButtonElement = document.querySelector(".Ispm-LowTrustDetection-seeMore");
        return elements;
    };
    /**
   * Handles the "See More" button click.
   * Applies animations to various elements and then updates the open and animate states.
   */ const handleSeeMoreClick = ()=>{
        const { svgElement: svgElement, comingSoonElement: comingSoonElement, trustContentElement: trustContentElement, leftContainer: leftContainer, rightContainer: rightContainer, seeMoreButtonElement: seeMoreButtonElement, closeButtonElement: closeButtonElement } = getElements(true);
        if (svgElement && comingSoonElement && trustContentElement && seeMoreButtonElement && leftContainer && rightContainer && closeButtonElement) {
            // Animate the SVG and content elements
            applyAnimation(svgElement, "svgAnimation 400ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards, opacityChange 266ms cubic-bezier(0.66, 0.00, 0.34, 1.00) forwards");
            applyAnimation(comingSoonElement, "slideUpFade 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
            applyAnimation(trustContentElement, "slideUpFade 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
            applyAnimation(seeMoreButtonElement, "slideUpFade 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
            // After a short delay, update container classes to trigger keyframe animations
            setTimeout(()=>{
                leftContainer.classList.remove("animateOut");
                rightContainer.classList.remove("animateOut");
                leftContainer.classList.add("animateIn");
                rightContainer.classList.add("animateIn");
                if (isSmallScreen && leftNavPinned) applyAnimation(svgElement, "svgAnimation4 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
                else if (isSmallScreen) applyAnimation(svgElement, "svgAnimation3 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
                else if (leftNavPinned !== "true") applyAnimation(svgElement, "svgAnimation1 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
                else applyAnimation(svgElement, "svgAnimation2 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
                applyAnimation(closeButtonElement, "closeButtonOpacityChange 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards");
            }, 400);
        }
        // Update state to reflect that the section is now open and animating
        setTimeout(()=>{
            setIsOpen(true);
            setIsAnimate(true);
            const element = document.querySelector(".Ispm-Ootb");
            if (element) element.scroll(0, (0, $8ff2252602deef38$export$ba157c81a75b4920));
            if (svgElement) {
                svgElement.style.animation = "none";
                svgElement.style.opacity = "0";
            }
        }, 1000);
    };
    /**
   * Handles the "Close" button click.
   * Reverses the animations applied to the elements and then updates the animate state.
   */ const handleCloseClick = ()=>{
        // Immediately mark the section as closed
        setIsOpen(false);
        const { svgElement: svgElement, comingSoonElement: comingSoonElement, trustContentElement: trustContentElement, leftContainer: leftContainer, rightContainer: rightContainer, closeButtonElement: closeButtonElement } = getElements();
        if (svgElement && comingSoonElement && trustContentElement && leftContainer && rightContainer && closeButtonElement) {
            // Step 1: Hide the svgElement initially.
            svgElement.style.animation = "none";
            svgElement.style.opacity = "0";
            applyAnimation(closeButtonElement, "closeButtonOpacityChange 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) reverse forwards");
            // Reverse container animations by updating CSS classes
            leftContainer.classList.remove("animateIn");
            rightContainer.classList.remove("animateIn");
            leftContainer.classList.add("animateOut");
            rightContainer.classList.add("animateOut");
            setTimeout(()=>{
                applyAnimation(comingSoonElement, "slideUpFade 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) reverse forwards");
                applyAnimation(trustContentElement, "slideUpFade 266ms cubic-bezier(0.32, 0.94, 0.60, 1.00) reverse forwards");
                applyAnimation(svgElement, "slideUpRotate 500ms cubic-bezier(0.32, 0.94, 0.60, 1.00) forwards 266ms");
            }, 200);
        }
        // After animations complete, update the animate state
        setTimeout(()=>{
            setIsAnimate(false);
        }, 1000);
    };
    return {
        handleSeeMoreClick: handleSeeMoreClick,
        handleCloseClick: handleCloseClick
    };
}
var $42764b6024b73500$export$2e2bcd8739ae039 = $42764b6024b73500$var$useLowTrustDetectionAnimationHandlers;




const $e2b7858b7b737466$export$fd53012187cd5fa6 = {
    ACCOUNT: "account",
    ENTITILEMENT: "entitilement",
    PRIVILLEGES: "privelleges",
    ROLE: "role"
};
const $e2b7858b7b737466$export$fb7c00e1e45223e = 15;
const $e2b7858b7b737466$export$e5cb5c9cbef7496a = {
    purple: "var(--color-background-purple-subtle, #f9eefc)",
    pink: "var(--color-background-pink-subtle, #FCEEF4)"
};
const $e2b7858b7b737466$export$7123d693f38eb73b = {
    purple: "--color-background-purple-medium",
    pink: "--color-background-pink-medium"
};


function $02f35f2692bf806b$export$8ff250f26e2e3c9c(data) {
    if (typeof data !== "object" || data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountDetailResponse - Invalid response: Expected an object");
        return false;
    }
    // Check required properties exist
    const requiredProps = [
        "accountId",
        "userId"
    ];
    if (!requiredProps.every((prop)=>prop in data)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountDetailResponse - Invalid response: Missing required properties", {
            requiredProps: requiredProps
        });
        return false;
    }
    // Check entitlements array
    if (!Array.isArray(data.entitlements)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountDetailResponse - Invalid response: entitlements must be an array");
        return false;
    }
    // Check roles array
    if (!Array.isArray(data.roles)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountDetailResponse - Invalid response: roles must be an array");
        return false;
    }
    return true;
}
const $02f35f2692bf806b$var$getUserAccessPathAccountDetail = async ({ userId: userId, accountId: accountId })=>{
    const { USER_ACCESS_PATH_ACCOUNT_DETAIL_URL: USER_ACCESS_PATH_ACCOUNT_DETAIL_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const accessPathUrl = USER_ACCESS_PATH_ACCOUNT_DETAIL_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId).replace((0, $8ff2252602deef38$export$4ce9b36f5872a886), accountId);
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(accessPathUrl, {
            timeout: 30000,
            method: "GET"
        }, $02f35f2692bf806b$export$8ff250f26e2e3c9c);
        const totalEntitlements = Array.isArray(response.entitlements) ? response.entitlements.length : 0;
        const totalRoles = Array.isArray(response.roles) ? response.roles.length : 0;
        const enrichedEntitlements = Array.isArray(response.entitlements) ? response.entitlements.slice(0, (0, $e2b7858b7b737466$export$fb7c00e1e45223e)).map((entitlement)=>{
            const privileges = entitlement.privileges ?? [];
            const childEntitlements = entitlement.childEntitlements ?? [];
            return {
                ...entitlement,
                privileges: privileges.slice(0, (0, $e2b7858b7b737466$export$fb7c00e1e45223e)),
                childEntitlements: childEntitlements.slice(0, (0, $e2b7858b7b737466$export$fb7c00e1e45223e)),
                meta: {
                    totalPrivileges: privileges.length,
                    totalChildEntitlements: childEntitlements.length
                }
            };
        }) : [];
        const cappedRoles = Array.isArray(response.roles) ? response.roles.slice(0, (0, $e2b7858b7b737466$export$fb7c00e1e45223e)) : [];
        return {
            ...response,
            entitlements: enrichedEntitlements,
            roles: cappedRoles,
            totalEntitlements: totalEntitlements,
            totalRoles: totalRoles
        };
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching getUserAccessPathAccountDetail data:", {
            error: error
        });
        throw error;
    }
};
var $02f35f2692bf806b$export$2e2bcd8739ae039 = $02f35f2692bf806b$var$getUserAccessPathAccountDetail;




function $8365263162b965b7$export$584bb2adafe1fba9(data) {
    if (typeof data !== "object" || data === null || !("accounts" in data) || !Array.isArray(data.accounts)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountListResponse - Invalid response: Expected an object amd account as its attribute.");
        return false;
    }
    // Check if all elements in the accounts array are strings
    if (!data.accounts.every((account)=>typeof account === "string")) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isAccountListResponse - Invalid response: All account list must be strings");
        return false;
    }
    return true;
}
const $8365263162b965b7$var$getUserAccessPathAccountList = async ({ userId: userId })=>{
    const { USER_ACCESS_PATH_ACCOUNT_LIST_URL: USER_ACCESS_PATH_ACCOUNT_LIST_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const accessPathUrl = USER_ACCESS_PATH_ACCOUNT_LIST_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId);
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(accessPathUrl, {
            timeout: 30000,
            method: "GET"
        }, $8365263162b965b7$export$584bb2adafe1fba9);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching getUserAccessPathAccountList data:", {
            error: error
        });
        throw error;
    }
};
var $8365263162b965b7$export$2e2bcd8739ae039 = $8365263162b965b7$var$getUserAccessPathAccountList;




function $87cbdd892c8b6fd9$export$543496c2196862ab(data) {
    if (typeof data !== "object" || data === null || !("accounts" in data) || !Array.isArray(data.accounts)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isFatAccessPathResponse - Invalid response: Expected an object amd account as its attribute.");
        return false;
    }
    return true;
}
const $87cbdd892c8b6fd9$var$getUserAccessPathFatData = async ({ userId: userId })=>{
    const { USER_FAT_ACCESS_PATH_URL: USER_FAT_ACCESS_PATH_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const accessPathUrl = USER_FAT_ACCESS_PATH_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId);
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(accessPathUrl, {
            timeout: 30000,
            method: "GET"
        }, $87cbdd892c8b6fd9$export$543496c2196862ab);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching getUserAccessPathFatData data:", {
            error: error
        });
        throw error;
    }
};
var $87cbdd892c8b6fd9$export$2e2bcd8739ae039 = $87cbdd892c8b6fd9$var$getUserAccessPathFatData;




/**
 * A custom React hook for fetching data from an API with flexible control over re-fetching.
 *
 * @template T - The type of the data returned by the API call.
 * @template P - A tuple representing the parameters passed to the API function.
 * @param fetchFunction - The API function to be executed (e.g., getUserTimeline).
 * @param params - Optional parameters to be passed to the fetch function.
 * @returns {UseFetchResult<T>} - Contains the fetched data, loading state, error, and a refetch function.
 */ const $bc60925424d51d08$var$useFetch = (fetchFunction, params = [] // Parameters for the API call (defaulting to an empty array)
)=>{
    // State variables to manage the fetched data, loading state, and errors
    const [data, setData] = (0, $cURGa$useState)(null);
    const [isLoading, setIsLoading] = (0, $cURGa$useState)(false);
    const [error, setError] = (0, $cURGa$useState)(null);
    const lastParamsRef = (0, $cURGa$useRef)(null); // Tracks the last set of parameters to detect changes
    const triggerRef = (0, $cURGa$useRef)(0); // A counter to trigger manual re-fetches
    /**
   * Fetches data from the provided API function.
   * Wrapped in `useCallback` to avoid unnecessary re-creations unless dependencies change.
   */ const fetchData = (0, $cURGa$useCallback)(async ()=>{
        setIsLoading(true); // Set loading state to true before making the API call
        setError(null); // Clear any previous error state
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("useFetch - Fetching data", {
            params: params
        }); // Log the fetch event with parameters
        /**
     * Added a type check: typeof memoizedFetchFunction !== 'function'.
     * If invalid, it sets an error and stops further execution
     */ if (typeof fetchFunction !== "function") {
            setError(new Error("Invalid fetch function"));
            setIsLoading(false);
            return;
        }
        try {
            const result = await fetchFunction(...params); // Execute the API call with the provided parameters
            setData(result); // Store the fetched data in the state
        } catch (err) {
            setError(err); // Capture and set any error encountered
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("useFetch - Error during API fetch", {
                err: err
            }); // Log the error
        } finally{
            setIsLoading(false); // Set loading state to false after the API call completes
        }
    }, [
        fetchFunction,
        params
    ]); // Dependencies: triggers re-creation if `fetchFunction` or `params` change
    (0, $cURGa$useEffect)(()=>{
        /**
     * Checks if the current parameters are different from the last API call.
     * Prevents unnecessary API calls if parameters haven't changed.
     */ const paramsChanged = JSON.stringify(lastParamsRef.current) !== JSON.stringify(params);
        // Fetch data if parameters have changed or a manual refetch has been triggered
        if (paramsChanged || triggerRef.current > 0) {
            lastParamsRef.current = params; // Update the reference with current parameters
            fetchData().catch((err)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("useFetch - Error while executing fetch", {
                    err: err
                })); // Execute the API call
        }
    }, [
        fetchData,
        params
    ]); // Dependencies: re-run effect when these change
    /**
   * Manually triggers a re-fetch of the data.
   * Increments `triggerRef` to signal that a new fetch should occur.
   */ const refetch = ()=>{
        triggerRef.current += 1; // Increment the trigger count to force a re-fetch
        fetchData().catch((err)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("useFetch - Error while executing fetch", {
                err: err
            })); // Execute the API call immediately
    };
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        refetch: refetch
    }; // Return the API response data, loading state, error, and manual refetch function
};
var $bc60925424d51d08$export$2e2bcd8739ae039 = $bc60925424d51d08$var$useFetch;


const $f3f2738ca096f034$export$2e4ac24c02808700 = (userId)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $87cbdd892c8b6fd9$export$2e2bcd8739ae039), [
        {
            userId: userId
        }
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $f3f2738ca096f034$export$c3aaabc589cc5349 = (userId)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $8365263162b965b7$export$2e2bcd8739ae039), [
        {
            userId: userId
        }
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $f3f2738ca096f034$export$783294d8d5a33b75 = (userId, accountId)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $02f35f2692bf806b$export$2e2bcd8739ae039), [
        {
            userId: userId,
            accountId: accountId
        }
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};




const $e95e1a5b1863583b$var$ispmKeys = {
    all: [
        "ispm"
    ],
    permissions: ()=>[
            ...$e95e1a5b1863583b$var$ispmKeys.all,
            "permissions"
        ],
    governanceInsightsCertsKeys: ()=>[
            ...$e95e1a5b1863583b$var$ispmKeys.all,
            "governanceInsightsCerts"
        ],
    governanceInsightsAccessKeys: ()=>[
            ...$e95e1a5b1863583b$var$ispmKeys.all,
            "governanceInsightsAccess"
        ],
    chatHistory: ()=>[
            ...$e95e1a5b1863583b$var$ispmKeys.all,
            "chatHistory"
        ],
    copilotLicenseUsage: (userQuery)=>[
            ...$e95e1a5b1863583b$var$ispmKeys.all,
            "copilotLicenseUsage",
            userQuery
        ]
};
var $e95e1a5b1863583b$export$2e2bcd8739ae039 = $e95e1a5b1863583b$var$ispmKeys;





/**
 * Type guard for LicenseDisplayMetadata.
 */ function $7ec97c2213c33181$var$isValidLicenseDisplayMetadata(value) {
    if (typeof value !== "object" || value === null) return false;
    const meta = value;
    return typeof meta.showPlanHighlightLabel === "boolean" && typeof meta.planHighlightLabelValue === "string";
}
/**
 * Type guard for a Permission.
 */ function $7ec97c2213c33181$var$isValidPermission(permission) {
    if (typeof permission !== "object" || permission === null) return false;
    const perm = permission;
    if (typeof perm.enabled !== "boolean") return false;
    if (perm.reason !== undefined && typeof perm.reason !== "string") return false;
    if (perm.licenseDisplayMetadata !== undefined && !$7ec97c2213c33181$var$isValidLicenseDisplayMetadata(perm.licenseDisplayMetadata)) return false;
    return true;
}
/**
 * Type guard for PermissionsAPIResponse.
 */ function $7ec97c2213c33181$var$isValidPermissionsResponse(response) {
    if (typeof response !== "object" || response === null) return false;
    const { data: data } = response;
    if (typeof data !== "object" || data === null) return false;
    const { permissions: permissions } = data;
    if (typeof permissions !== "object" || permissions === null) return false;
    return Object.values(permissions).every($7ec97c2213c33181$var$isValidPermission);
}
// Cache for API responses.
const $7ec97c2213c33181$var$permissionsCache = new Map();
/**
 * Fetches ISPM permissions with caching and error handling.
 *
 * @param url - Optional URL override.
 * @returns A promise that resolves to a valid PermissionsAPIResponse.
 */ const $7ec97c2213c33181$var$getPermissionsAPI = async (url)=>{
    if (typeof (0, $8ff2252602deef38$export$2483ee2755c8377) !== "string") throw new Error("PERMISSIONS_URL must be a string");
    const permissionsUrl = typeof url === "string" ? url : (0, $8ff2252602deef38$export$2483ee2755c8377);
    // Return the cached response if it's still valid.
    const cached = $7ec97c2213c33181$var$permissionsCache.get(permissionsUrl);
    if (cached && Date.now() - cached.timestamp < (0, $8ff2252602deef38$export$6d85febd8168744c)) return cached.data;
    const config = {
        timeout: 30000,
        headers: {
            Accept: "application/json",
            "Cache-Control": "no-cache"
        }
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(permissionsUrl, config, $7ec97c2213c33181$var$isValidPermissionsResponse);
        // Update the cache.
        $7ec97c2213c33181$var$permissionsCache.set(permissionsUrl, {
            data: response,
            timestamp: Date.now()
        });
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to fetch permissions:", error);
        if (error instanceof Error) throw new Error(`Failed to fetch permissions: ${error.message}`);
        throw new Error("Failed to fetch permissions: Unknown error");
    }
};
var $7ec97c2213c33181$export$2e2bcd8739ae039 = $7ec97c2213c33181$var$getPermissionsAPI;


const $f368c544e3051320$var$useGetIspmUserPermissions = (permissionKey)=>{
    const { data: permissionsData, isLoading: isLoading, isError: isError } = (0, $cURGa$useQuery)({
        queryKey: (0, $e95e1a5b1863583b$export$2e2bcd8739ae039).permissions(),
        queryFn: ()=>(0, $7ec97c2213c33181$export$2e2bcd8739ae039)()
    });
    const permission = (0, $cURGa$useMemo)(()=>permissionsData?.data.permissions[permissionKey], [
        permissionsData,
        permissionKey
    ]);
    return {
        permission: permission,
        isLoading: isLoading,
        isError: isError
    };
};
var $f368c544e3051320$export$2e2bcd8739ae039 = $f368c544e3051320$var$useGetIspmUserPermissions;






function $dbbe4e22d5fe032b$var$isCopilotLicenseUsageResponse(data) {
    return typeof data === "object" && data !== null;
}
const $dbbe4e22d5fe032b$var$getCopilotLicenseUsage = async ()=>{
    const options = {
        method: "GET"
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)((0, $8ff2252602deef38$export$ce5854d6503a4f78), options, $dbbe4e22d5fe032b$var$isCopilotLicenseUsageResponse);
    return response;
};
var $dbbe4e22d5fe032b$export$2e2bcd8739ae039 = $dbbe4e22d5fe032b$var$getCopilotLicenseUsage;


const $c1852d0a39e03ea6$var$useGetIspmCopilotLicenseUsage = ({ isUserQueryPresent: isUserQueryPresent, userQuery: userQuery })=>(0, $cURGa$useQuery)({
        queryKey: (0, $e95e1a5b1863583b$export$2e2bcd8739ae039).copilotLicenseUsage(userQuery),
        queryFn: ()=>(0, $dbbe4e22d5fe032b$export$2e2bcd8739ae039)(),
        enabled: isUserQueryPresent
    });
var $c1852d0a39e03ea6$export$2e2bcd8739ae039 = $c1852d0a39e03ea6$var$useGetIspmCopilotLicenseUsage;





class $c6c5f9c12aae617c$export$1b5d820b5ca8d1fc extends Error {
    constructor(message, code, details){
        super(message);
        this.code = code;
        this.details = details;
        this.name = "StreamError";
    }
}
const { CHAT_ASK_STREAM_URL: $c6c5f9c12aae617c$var$CHAT_ASK_STREAM_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $c6c5f9c12aae617c$export$2e2bcd8739ae039() {
    return (0, $cURGa$useMutation)({
        mutationFn: async ({ data: data })=>{
            const response = await fetch($c6c5f9c12aae617c$var$CHAT_ASK_STREAM_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "text/event-stream"
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            let partialLine = "";
            let streamData = {};
            if (reader) while(true){
                // eslint-disable-next-line no-await-in-loop
                const { done: done, value: value } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value);
                const lines = (partialLine + chunk).split("\n");
                partialLine = lines.pop() ?? "";
                for(let i = 0; i < lines.length; i += 1){
                    const line = lines[i];
                    if (line.startsWith("event:")) {
                        const eventType = line.substring(line.indexOf(":") + 1).trim();
                        const dataLine = lines[i + 1];
                        const messageContent = dataLine.startsWith("data:") ? dataLine.substring(dataLine.indexOf(":") + 1).trim() : null;
                        if (messageContent) try {
                            const parsedData = JSON.parse(messageContent);
                            // Handle the parsed data based on the event type
                            switch(eventType){
                                case "heartbeat":
                                    // Handle heartbeat event
                                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("Heartbeat event received:", parsedData);
                                    break;
                                case "error":
                                    {
                                        // Handle error event
                                        const error = parsedData;
                                        throw new $c6c5f9c12aae617c$export$1b5d820b5ca8d1fc(error.message ?? "Unknown error", error.code ?? 500, parsedData);
                                    }
                                case "result":
                                    streamData = parsedData;
                                    break;
                                default:
                                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Unknown event type:", eventType);
                            }
                        } catch (error) {
                            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(eventType, messageContent);
                        }
                    }
                }
            }
            if (partialLine) // Handle any remaining data after the stream ends
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Partial line remaining:", partialLine);
            return streamData;
        },
        onSuccess: ()=>{
            // Handle successful stream completion if necessary
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("Stream completed successfully");
        },
        onError: (error)=>{
            // Handle errors during the stream
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error during stream:", error);
        }
    });
}







function $9e69af25b4683479$var$GeneratingContent() {
    const { chatOverlayState: chatOverlayState, updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { controllerRef: controllerRef } = (0, $08bb17136b599311$export$4db023b7660421fa)();
    const handleStopProcessing = ()=>{
        if (controllerRef.current) {
            controllerRef.current.abort();
            controllerRef.current = null;
        }
    };
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { loaderTitleText: loaderTitleText, loaderDescriptionText: loaderDescriptionText } = (0, $c638973f33534342$export$2e2bcd8739ae039)((0, $8ff2252602deef38$export$7c5865ddae060245)(l));
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-GeneratingContent",
                children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-GeneratingContent-contentWrapper",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-GeneratingContent-contentWrapper-loader",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$LottiePlayer), {
                                kind: "saviLoader",
                                style: {
                                    width: "7.5rem",
                                    height: "7.5rem"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-GeneratingContent-contentWrapper-text",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-GeneratingContent-contentWrapper-text-primary",
                                    children: loaderTitleText
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-GeneratingContent-contentWrapper-text-secondary",
                                    children: loaderDescriptionText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-GeneratingContent-contentWrapper-button",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                size: "medium",
                                kind: "outlined",
                                leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "StopProcess",
                                    size: "medium",
                                    color: "indigo-700"
                                }),
                                onClick: ()=>{
                                    updateChatOverlayState("isWarningModalOpen", true);
                                },
                                dataTestId: "ispm-stopProcessing-button",
                                children: l("Stop Processing")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
                kind: "warning",
                alertTitle: l("Are you sure?"),
                alertSubtitle: l("Do you want to stop the process?"),
                onClose: ()=>updateChatOverlayState("isWarningModalOpen", false),
                isOpen: chatOverlayState.isWarningModalOpen,
                primaryButton: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                    type: "button",
                    kind: "outlined",
                    size: "medium",
                    dataTestId: "Ispm-Modal-StopProcessing",
                    onClick: handleStopProcessing,
                    children: l("Stop Processing")
                }),
                secondaryButton: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                    type: "button",
                    kind: "ghost",
                    size: "medium",
                    onClick: ()=>{
                        updateChatOverlayState("isWarningModalOpen", false);
                    },
                    dataTestId: "ispm-warningModal-closing",
                    children: l("Cancel")
                }),
                className: "Ispm-GeneratingContent-warningModal"
            })
        ]
    });
}
var $9e69af25b4683479$export$2e2bcd8739ae039 = $9e69af25b4683479$var$GeneratingContent;












$dfe6d965355ce299$var$LowConfidenceHeader.defaultProps = {
    toggleSelection: (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION,
    setToggleSelection: ()=>{}
};
function $dfe6d965355ce299$var$LowConfidenceHeader({ toggleSelection: toggleSelection, setToggleSelection: setToggleSelection }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-LowConfidenceHeader",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-LowConfidenceHeader-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    className: "Ispm-LowConfidenceHeader-contentWrapper-confidence",
                    children: "Confidence:"
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    className: "Ispm-LowConfidenceHeader-contentWrapper-chip",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                        kind: "outlined",
                        color: "critical",
                        size: "small",
                        label: "Low"
                    })
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    className: "Ispm-LowConfidenceHeader-contentWrapper-confidenceText",
                    children: l("The generated content may have errors or may not show at all.")
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    className: "Ispm-LowConfidenceHeader-contentWrapper-toggleGroup",
                    children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$ToggleButtonGroup), {
                        selection: toggleSelection,
                        setSelection: setToggleSelection,
                        isPill: true,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    className: "InputField-suffixButton-icon",
                                    kind: "DataAnalyze",
                                    size: "small",
                                    color: "navy-900"
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "Code",
                                    size: "small",
                                    color: "navy-900"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $dfe6d965355ce299$export$2e2bcd8739ae039 = $dfe6d965355ce299$var$LowConfidenceHeader;



function $b8d807f2d4e3026c$var$CantBeDisplayed() {
    // const l = useInvertedLocalize(invertedMessages);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Ispm-CantBeDisplayed",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-CantBeDisplayed-lowConfidence",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $dfe6d965355ce299$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-CantBeDisplayed-contentWrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-CantBeDisplayed-contentWrapper-icon",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Illustration), {
                            kind: "Error",
                            dataTestId: "Error"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-CantBeDisplayed-contentWrapper-text",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-CantBeDisplayed-contentWrapper-text-primary",
                                children: "Content can't be displayed"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-CantBeDisplayed-contentWrapper-text-secondary",
                                children: "There was an error processing the request. Try a different request for better results."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $b8d807f2d4e3026c$export$2e2bcd8739ae039 = $b8d807f2d4e3026c$var$CantBeDisplayed;








$181efe26917a4858$var$ContentNotAccurate.defaultProps = {
    panelHeader: /*#__PURE__*/ (0, $cURGa$jsx)("div", {}),
    toggleSelection: 1,
    query: "default query",
    onClick: ()=>{}
};
function $181efe26917a4858$var$ContentNotAccurate({ panelHeader: panelHeader, toggleSelection: toggleSelection, query: query, onClick: handleClick }) {
    const formattedQuery = (0, $cURGa$format)(query ?? "");
    const { updateAutomatedUserMessageInSession: updateAutomatedUserMessageInSession } = (0, $f4af97ac92900bf2$export$2e2bcd8739ae039)();
    const handleShowAnywayButtonClick = ()=>{
        updateAutomatedUserMessageInSession("Show Anyway");
        if (handleClick) handleClick();
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Ispm-ContentNotAccurate",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-CantBeDisplayed-lowConfidence",
                children: panelHeader
            }),
            toggleSelection === 1 ? /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-ContentNotAccurate-contentWrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-ContentNotAccurate-contentWrapper-text",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-ContentNotAccurate-contentWrapper-text-primary",
                                children: "Content May Be Inaccurate"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-ContentNotAccurate-contentWrapper-text-secondary",
                                children: "The generated content may have errors or may not show at all. Do you still want to view it?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-GeneratingContent-contentWrapper-button",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                            size: "medium",
                            kind: "filled",
                            onClick: handleShowAnywayButtonClick,
                            dataTestId: "ispm-contentNotAccurate-showAnyway",
                            children: "Show Anyway"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-ContentNotAccurate-lowConfidence-sql",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("pre", {
                    className: "Ispm-ContentNotAccurate-lowConfidence-sql-content",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("code", {
                        children: formattedQuery
                    })
                })
            })
        ]
    });
}
var $181efe26917a4858$export$2e2bcd8739ae039 = $181efe26917a4858$var$ContentNotAccurate;














$a5d805b3406f4556$var$DataSectionHeader.defaultProps = {
    toggleSelection: undefined,
    setToggleSelection: ()=>{},
    numRecords: undefined
};
function $a5d805b3406f4556$var$DataSectionHeader({ numRecords: numRecords, toggleSelection: toggleSelection, setToggleSelection: setToggleSelection }) {
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const detailedSteps = "detailedSteps" in chatOverlayState.contentPanelData ? chatOverlayState.contentPanelData.detailedSteps : [];
    const tooltipSteps = Array.isArray(detailedSteps) ? detailedSteps.join(" ") : "";
    const hasChartData = Boolean(chatOverlayState.contentPanelData.chartSpec);
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-DataSectionHeader",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-DataSectionHeader-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                    className: "Ispm-DataSectionHeader-contentWrapper-toggleGroup",
                    children: [
                        toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).SQL && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            text: tooltipSteps,
                            placement: "left",
                            dataTestId: (0, $b673ba598f0efd75$export$cfca711824ae744a),
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "Info",
                                color: "--color-foreground-info-medium",
                                size: "xSmall"
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$ToggleButtonGroup), {
                            selection: toggleSelection,
                            setSelection: setToggleSelection,
                            isPill: true,
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                    isDisabled: !hasChartData,
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: "View Chart",
                                        placement: "top",
                                        offset: 16,
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: "DataAnalyze",
                                            size: "small"
                                        })
                                    }),
                                    dataTestId: "ispm-data-section-header-chart-button"
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: "View Table",
                                        placement: "top",
                                        offset: 16,
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: "DataTable",
                                            size: "small"
                                        })
                                    }),
                                    dataTestId: "ispm-data-section-header-table-button"
                                }),
                                (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).SHOW_SQL_TOGGLE_BUTTON && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: "View SQL",
                                        placement: "top",
                                        offset: 16,
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: "Code",
                                            size: "small"
                                        })
                                    }),
                                    dataTestId: "ispm-data-section-header-sql-button"
                                })
                            ]
                        })
                    ]
                }),
                Boolean(numRecords) && /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                    className: (0, $cURGa$classnames)("Ispm-DataSectionHeader-contentWrapper-numRecords", ((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION, "Ispm-DataSectionHeader-contentWrapper-numRecords--isHidden")),
                    children: [
                        l("Number of records"),
                        ": ",
                        numRecords
                    ]
                })
            ]
        })
    });
}
var $a5d805b3406f4556$export$2e2bcd8739ae039 = $a5d805b3406f4556$var$DataSectionHeader;












function $d2f29977ef83b8b0$var$CantBeDisplayedSqlError() {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-CantBeDisplayedSqlError",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-CantBeDisplayedSqlError-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-CantBeDisplayedSqlError-contentWrapper-icon",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Illustration), {
                        kind: "Error"
                    })
                }),
                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-CantBeDisplayedSqlError-contentWrapper-text",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-CantBeDisplayedSqlError-contentWrapper-text-primary",
                            children: l("Content can't be displayed")
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-CantBeDisplayedSqlError-contentWrapper-text-secondary",
                            children: l("There was an error processing the request. Try a different request for better results.")
                        })
                    ]
                })
            ]
        })
    });
}
var $d2f29977ef83b8b0$export$2e2bcd8739ae039 = $d2f29977ef83b8b0$var$CantBeDisplayedSqlError;






























/**
 * Custom hook used by component to get access to api calls.
 * @returns
 */ const $2f326624061e22b1$var$useDashboardApi = ()=>{
    const { ispmState: ispmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { DASHBOARD_LIST_URL: DASHBOARD_LIST_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(ispmState.useMockServerApis);
    const { updateAutomatedApiResponseInSession: updateAutomatedApiResponseInSession, updateAutomatedUserMessageInSession: updateAutomatedUserMessageInSession } = (0, $f4af97ac92900bf2$export$2e2bcd8739ae039)();
    const fetchDashboards = (0, $cURGa$useCallback)(()=>{
        (0, $590c9a6ca81591fc$export$2e2bcd8739ae039)(DASHBOARD_LIST_URL).then((data)=>{
            if ("dashboards" in data) updateChatOverlayState("dashboardLists", data.dashboards);
        }).catch((err)=>{
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error({
                err: err
            });
        });
    }, [
        DASHBOARD_LIST_URL,
        updateChatOverlayState
    ]);
    const saveChart = (0, $cURGa$useCallback)(async (request, url)=>{
        try {
            updateAutomatedUserMessageInSession("Save to the Intelligence Dashboard");
            updateChatOverlayState("isApiCallInProgress", true);
            updateChatOverlayState("inputDisabled", true);
            const response = await (0, $54d397881d836571$export$2e2bcd8739ae039)(request, url);
            updateChatOverlayState("isApiCallInProgress", false);
            updateChatOverlayState("inputDisabled", false);
            // Localization is happening inside this method
            updateAutomatedApiResponseInSession("This chart has been pinned to your dashboard", {
                isSaveToChart: true
            });
            return response;
        } catch (err) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error({
                err: err
            });
            updateChatOverlayState("isApiCallInProgress", false);
            updateChatOverlayState("inputDisabled", false);
            // Localization is happening inside this method
            updateAutomatedApiResponseInSession("Sorry, there was an error or interruption while processing your prompt. When the service becomes available again, you can either enter your original prompt or try a new one");
            throw err;
        }
    }, [
        updateAutomatedApiResponseInSession,
        updateAutomatedUserMessageInSession,
        updateChatOverlayState
    ]);
    return {
        fetchDashboards: fetchDashboards,
        saveChart: saveChart
    };
};
var $2f326624061e22b1$export$2e2bcd8739ae039 = $2f326624061e22b1$var$useDashboardApi;






function $6b11d7f72b7b2a82$export$2e2bcd8739ae039({ chartName: chartName }) {
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { saveChart: saveChart } = (0, $2f326624061e22b1$export$2e2bcd8739ae039)();
    const { ispmState: ispmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const handleSaveChart = async (dashboard)=>{
        const data = chatOverlayState.contentPanelData;
        if (!dashboard.value || !("chartSpec" in data) || !data.chartSpec) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("No dashboard to save this chart");
            return;
        }
        const request = {
            dashboard_id: +dashboard.value,
            ...data.datasource_id && {
                datasource_id: data.datasource_id
            },
            chart_name: chartName,
            chartSpec: data.chartSpec
        };
        const { DASHBOARD_URL: DASHBOARD_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(ispmState.useMockServerApis);
        try {
            await saveChart(request, DASHBOARD_URL);
        } catch (err) {
            // TODO: https://saviyntars.atlassian.net/browse/IN-12515
            // Handle error as confirmed by PO.right now, its not finalised.
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error({
                err: err
            });
        }
    };
    function getCustomContent() {
        return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InlineMessage), {
                    text: l("Dashboards unavailable. Try refreshing the page to connect to our dashboards list."),
                    colorTheme: "critical",
                    size: "small",
                    leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "AlertCriticalFilled",
                        color: "critical-700"
                    })
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                    className: "flexBox",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "small",
                        onClick: ()=>window.location.reload(),
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Refresh",
                            size: "medium",
                            color: "neutral-100"
                        }),
                        dataTestId: "ispm-saveToDashboard-refresh",
                        children: l("Refresh")
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Menu), {
        options: chatOverlayState.dashboardLists.map((ele)=>({
                label: ele.name,
                value: ele.id.toString(),
                isDisabled: false,
                isChecked: false
            })),
        // By default one dashboard is available. If not, show error
        CustomMenu: chatOverlayState.dashboardLists.length === 0 ? getCustomContent() : undefined,
        onChange: async (data)=>{
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("User selected dashboard - ", {
                data: data
            });
            await handleSaveChart(data);
        },
        className: "Ispm-SaveToDashboard-Menu",
        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
            text: l("Save to Dashboard"),
            placement: "top",
            trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                kind: "icon",
                size: "medium",
                prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "Dashboard",
                    size: "medium",
                    color: "info-500",
                    className: "Ispm-SaveToDashboard-Menu-icon"
                }),
                onClick: ()=>{},
                dataTestId: "ispm-saveToDashboard"
            })
        }),
        size: "medium",
        minOptionsForSearch: 0
    });
}




$8f8171e832d5bb70$export$2e2bcd8739ae039.defaultProps = {
    numRecords: undefined,
    headerText: "",
    toggleSelection: undefined
};
function $8f8171e832d5bb70$export$2e2bcd8739ae039({ headerText: headerText, numRecords: numRecords, toggleSelection: toggleSelection, panelType: panelType }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // TODO: display icons based on props/state.
    const { chatOverlayState: chatOverlayState, updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const [showInput, setShowInput] = (0, $cURGa$useState)(false);
    const [splitHeader, setSplitHeader] = (0, $cURGa$useState)();
    const [showTooltip, setShowTooltip] = (0, $cURGa$useState)(false);
    const tooltipRef = (0, $cURGa$useRef)(null);
    const { updateIspmErrorState: updateIspmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    const [isDataDownloading, setIsDataDownloading] = (0, $cURGa$useState)(false);
    const isPanelLoading = panelType === (0, $6232c3747a1d613b$export$950a020027fa5a0b).GENERATING_CONTENT;
    const isTablePanel = panelType === (0, $6232c3747a1d613b$export$950a020027fa5a0b).TABLE;
    const isChartPanel = panelType === (0, $6232c3747a1d613b$export$950a020027fa5a0b).CHART;
    const SHOW_DOWNLOAD_BUTTON = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- FEATURE_FLAGS is defined as const
    (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).ENABLE_DATA_DOWNLOAD && (isTablePanel || isChartPanel) && (toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART || toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION);
    const ENABLE_SAVE_TO_DASHBOARD = (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).ENABLE_SAVE_TO_DASHBOARD && isChartPanel && toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART;
    const CHART_DOWNLOAD_DELAY = 900;
    const overflowingText = ()=>{
        if (tooltipRef.current) {
            const element = tooltipRef.current;
            const actualWidth = element.clientWidth;
            const computedStyle = window.getComputedStyle(element);
            const cssWidth = parseFloat(computedStyle.width);
            setShowTooltip(actualWidth < cssWidth);
        }
    };
    (0, $cURGa$useLayoutEffect)(()=>{
        overflowingText();
    }, [
        showInput
    ]);
    (0, $cURGa$useEffect)(()=>{
        setSplitHeader(headerText);
    }, [
        headerText
    ]);
    // type guard to ensure query exists in contentPanelData
    const query = "query" in chatOverlayState.contentPanelData ? chatOverlayState.contentPanelData.query : "";
    const handleCopyTextToClipboard = async ()=>{
        if (!query) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("No query to copy to clipboard");
            return;
        }
        try {
            await navigator.clipboard.writeText(query);
            updateChatOverlayState("successAction", {
                type: "clipboardCopy"
            });
        } catch (error) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to copy text to clipboard:", error);
        // TODO: are we showing an error banner here?
        }
    };
    // TODO: update hook to return the updatedText to be used as a var.
    const { tooltipText: tooltipText, handleTooltipTriggerClick: handleTooltipTriggerClick, handleTooltipClose: handleTooltipClose, tooltipCloseDelayAfterClick: tooltipCloseDelayAfterClick } = (0, $cURGa$useTooltipText)({
        initialText: "Copy to Clipboard",
        updatedText: "Copied",
        closeDelayAfterClick: 5000
    });
    const { handleDownload: handleDownload } = (0, $5da53bdd33fdabaa$export$2e2bcd8739ae039)();
    const isSaviMessage = (item)=>"data" in item;
    const handleKeyDownHeader = (event)=>{
        if (event.key === "Enter") {
            const prevHeader = headerText;
            const chatHistory = (0, $84076bccc3151b37$export$e864ef1d0432b4ba)();
            if (chatHistory.length > 0 && prevHeader !== splitHeader && splitHeader !== "") {
                const currentData = chatOverlayState.contentPanelData;
                if (!currentData.request) return;
                const currentRequest = currentData.request;
                const updatedChatHistory = chatHistory.map((item)=>{
                    if (item.isUser || !isSaviMessage(item)) return item;
                    const itemCompleteData = item.data;
                    const itemRequest = itemCompleteData.request;
                    if (itemRequest) {
                        const checkSameTitle = itemRequest.freeText === currentRequest.freeText;
                        if (checkSameTitle) return {
                            ...item,
                            data: {
                                ...item.data,
                                request: {
                                    ...itemRequest,
                                    freeText: splitHeader
                                }
                            }
                        };
                    }
                    return item;
                });
                (0, $84076bccc3151b37$export$c8bdd0616cd6b3b1)(updatedChatHistory);
                updateChatOverlayState("messages", updatedChatHistory);
            } else setSplitHeader(headerText);
            setShowInput(false);
        }
    };
    const handleHeaderChange = (e)=>{
        const { value: value } = e.target;
        setSplitHeader(value);
    };
    const handleChartDownload = async ()=>{
        const startTime = Date.now();
        const { chartSpec: chartSpec } = chatOverlayState.contentPanelData;
        if (!chartSpec) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Chart download failed: Missing chart spec");
            updateIspmErrorState("errorType", (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
            return;
        }
        try {
            const chartCanvas = document.querySelector(".Ispm-SaviContentPanel-chart canvas");
            if (!chartCanvas) throw new Error("Chart canvas element not found");
            const dataUrl = await (0, $cURGa$toPng)(chartCanvas, {
                cacheBust: true,
                pixelRatio: 1,
                skipFonts: true,
                fontEmbedCSS: "",
                imagePlaceholder: "..."
            });
            // calculate remaining time to complete minimum delay
            const processingTime = Date.now() - startTime;
            const remainingDelay = Math.max(0, CHART_DOWNLOAD_DELAY - processingTime);
            // wait for the remaining delay time
            await new Promise((resolve)=>{
                setTimeout(resolve, remainingDelay);
            });
            // create the download link
            const link = document.createElement("a");
            link.download = `${splitHeader ?? "chart"}.png`;
            link.href = dataUrl;
            link.click();
        } catch (error) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Chart download failed:", error);
            updateIspmErrorState("errorType", (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
        }
    };
    const handleTableDownload = async ()=>{
        const { messageId: messageId } = chatOverlayState.contentPanelData;
        if (typeof messageId !== "string") {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Download failed: Missing query or messageId");
            updateIspmErrorState("errorType", (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
            return;
        }
        const result = await handleDownload(messageId);
        if (!result.success) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Download failed:", result.error);
            updateIspmErrorState("errorType", (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System);
        }
    };
    const handleDownloadClick = async ()=>{
        setIsDataDownloading(true);
        try {
            if (toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART) await handleChartDownload();
            else await handleTableDownload();
        } finally{
            setIsDataDownloading(false);
        }
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("header", {
        className: "Ispm-TopHeaderPanel-container",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-TopHeaderPanel",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-TopHeaderPanel-title",
                        children: showInput ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-TopHeaderPanel-title--isEditing",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InputField), {
                                className: "Ispm-TopHeaderPanel-title--isEditing-input",
                                name: "basic",
                                placeholder: "Placeholder",
                                value: splitHeader,
                                setValue: setSplitHeader,
                                onChange: handleHeaderChange,
                                onKeyDown: handleKeyDownHeader
                            })
                        }) : /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    ref: tooltipRef,
                                    "data-testid": "title",
                                    className: "Ispm-TopHeaderPanel-title-tooltip",
                                    children: showTooltip ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: splitHeader,
                                        placement: "top",
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                            "data-testid": "title",
                                            className: "Ispm-TopHeaderPanel-title-tooltip",
                                            children: splitHeader
                                        })
                                    }) : splitHeader
                                }),
                                splitHeader && (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).ENABLE_RENAME_QUERY && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    text: "Rename",
                                    placement: "top",
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                        kind: "ghost",
                                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: "Edit",
                                            color: "neutral-1000"
                                        }),
                                        onClick: ()=>{
                                            setShowInput(true);
                                        },
                                        dataTestId: "ispm-rename-button"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-TopHeaderPanel-controls",
                        children: [
                            !isPanelLoading && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                                children: [
                                    SHOW_DOWNLOAD_BUTTON && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: "Download",
                                        placement: "bottom",
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                                            kind: "icon",
                                            size: "medium",
                                            prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                kind: "Download",
                                                size: "medium",
                                                color: "info-500"
                                            }),
                                            isDisabled: isDataDownloading,
                                            onClick: handleDownloadClick,
                                            dataTestId: "ispm-download-button"
                                        })
                                    }),
                                    ENABLE_SAVE_TO_DASHBOARD && // only show download icon when the sql is showing
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $6b11d7f72b7b2a82$export$2e2bcd8739ae039), {
                                        chartName: splitHeader ?? headerText ?? ""
                                    }),
                                    toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).SQL && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        text: tooltipText,
                                        placement: "bottom",
                                        closeDelayAfterClick: tooltipCloseDelayAfterClick,
                                        onClose: handleTooltipClose,
                                        isDisabled: tooltipText === "Copied",
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                                            kind: "icon",
                                            size: "medium",
                                            prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                kind: tooltipText === "Copied" ? "check" : "Copy",
                                                color: "neutral-1000"
                                            }),
                                            onClick: async ()=>{
                                                handleTooltipTriggerClick();
                                                await handleCopyTextToClipboard();
                                            },
                                            dataTestId: "ispm-copy-button"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                text: "Collapse",
                                placement: "bottom",
                                trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                    kind: "ghost",
                                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "ExpandLeft",
                                        color: "neutral-1000"
                                    }),
                                    onClick: ()=>{
                                        if (chatOverlayState.isDataPanelFullScreen) updateChatOverlayState("isDataPanelFullScreen", false);
                                        else updateChatOverlayState("showGeneratedContent", false);
                                    },
                                    dataTestId: "expandLeft-button"
                                })
                            }),
                            !chatOverlayState.isDataPanelFullScreen && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                text: "Expand",
                                placement: "bottom",
                                trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                    kind: "ghost",
                                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "ExpandRight",
                                        color: "neutral-1000"
                                    }),
                                    onClick: ()=>{
                                        updateChatOverlayState("isDataPanelFullScreen", true);
                                    },
                                    dataTestId: "expandRight-button"
                                })
                            })
                        ]
                    })
                ]
            }),
            Boolean(toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION && numRecords && numRecords >= (0, $8ff2252602deef38$export$50c4654fc4355968)) && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-TopHeaderPanel-iconInfoWrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                        text: "Filter for inactive users by checking status...",
                        placement: "bottom",
                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Info",
                            color: "--color-foreground-info-medium",
                            size: "xSmall"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                        className: "Ispm-TopHeaderPanel-iconInfoWrapper-infoText",
                        children: l("This is a sample of 100 records from the dataset. Download to view the full dataset.")
                    })
                ]
            })
        ]
    });
}











function $73cf05f39fc180b5$export$2e2bcd8739ae039({ query: query }) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const formattedQuery = (0, $cURGa$format)(query);
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        "data-testid": (0, $b673ba598f0efd75$export$d42dbbce211dd111),
        className: "Ispm-ChartSql",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("pre", {
            className: "Ispm-ChartPanel-content",
            children: /*#__PURE__*/ (0, $cURGa$jsx)("code", {
                children: formattedQuery
            })
        })
    });
}









const $8a5084ff6f43a837$export$c3256e39d849f16b = false;
const $8a5084ff6f43a837$export$e363d7242400e222 = true;
const $8a5084ff6f43a837$export$572f87cc538a45a = ()=>[
        "#0294F7",
        "#D057FF",
        "#FC3DA6",
        "#00A3A9",
        "#E19701",
        "#01AE66",
        "#F25A00",
        "#FF4451"
    ];
const $8a5084ff6f43a837$export$20890d43e702257e = ()=>[
        "#0294F7",
        "#D057FF",
        "#FC3DA6",
        "#00A3A9",
        "#E19701",
        "#01AE66",
        "#F25A00",
        "#FF4451"
    ];
const $8a5084ff6f43a837$export$1b0fe2b75c1a919c = ()=>[
        "#0294F7",
        "#D057FF",
        "#FC3DA6",
        "#00A3A9",
        "#E19701",
        "#01AE66",
        "#F25A00",
        "#FF4451"
    ];
const $8a5084ff6f43a837$export$45f34f1cb2907697 = (data, categoryField)=>{
    if (!data || data.length <= 1 || !categoryField) return false;
    // count occurrences of each category value
    const categoryCounts = new Map();
    // eslint-disable-next-line no-restricted-syntax
    for (const item of data)if (categoryField in item) {
        // cet the category value as string (for consistent Map keys)
        const value = String(item[categoryField]);
        // increment count for this category
        const currentCount = categoryCounts.get(value) ?? 0;
        const newCount = currentCount + 1;
        categoryCounts.set(value, newCount);
        // early exit if category found with multiple records
        if (newCount > 1) return true;
    }
    return false; // no categories had multiple records
};
const $8a5084ff6f43a837$export$3301771ffa55bd3e = (data)=>{
    const isStacked = $8a5084ff6f43a837$export$45f34f1cb2907697(data.data, data.chartSpec?.encoding?.x?.field);
    // stacked bar charts have multiple colors per bar
    if (isStacked) return {
        color: {
            // field: 'dim_request_status',
            field: data.chartSpec?.encoding?.y?.field,
            // the above only colors the first bar with multiple slices properly
            type: "nominal",
            scale: {
                type: "ordinal",
                range: $8a5084ff6f43a837$export$572f87cc538a45a()
            }
        }
    };
    // standard coloring below for non-stacked charts
    // after transformation, categorical data is always on x-axis for bar charts
    const isVerticalBar = data.chartSpec?.encoding?.x?.type === "nominal" || data.chartSpec?.encoding?.x?.type === "ordinal";
    // get the field to use for color encoding
    const categoryField = isVerticalBar ? data.chartSpec?.encoding?.x?.field // for vertical bars (after transformation)
     : data.chartSpec?.encoding?.y?.field; // for horizontal bars (should not occur after transformation)
    const categoryType = isVerticalBar ? data.chartSpec?.encoding?.x?.type : data.chartSpec?.encoding?.y?.type;
    return {
        color: {
            field: categoryField,
            type: categoryType,
            scale: {
                type: "ordinal",
                range: $8a5084ff6f43a837$export$572f87cc538a45a()
            },
            legend: {
                titleFontSize: 14,
                labelFontSize: 13,
                symbolSize: 80,
                symbolType: "circle",
                titlePadding: 10,
                labelLimit: 200,
                padding: 0,
                titleFont: "Rubik",
                labelFont: "Rubik"
            }
        }
    };
};
const $8a5084ff6f43a837$export$9ae33e9662607bc5 = (// eslint-disable-next-line no-unused-vars
_data, // eslint-disable-next-line no-unused-vars
isDarkMode)=>({
        // define the line color
        color: {
        }
    });
const $8a5084ff6f43a837$export$f225b68be2a82c3b = (spec, isDarkMode)=>({
        ...spec,
        mark: {
            type: "line",
            // enable point markers on the line
            point: {
                filled: true,
                // set point size (12px diameter as specified)
                size: 144,
                fill: "#F25A00",
                stroke: isDarkMode ? "#131D2D" : "#F2F4F8",
                strokeWidth: 2
            },
            strokeWidth: 2,
            tooltip: true,
            interpolate: "monotone"
        },
        // configure chart axes
        ...spec.config,
        config: {
            // retain all existing config properties
            ...spec.config,
            // configure axis for horizontal grid lines only
            axisY: {
                grid: true,
                // set grid color for horizontal lines
                gridColor: isDarkMode ? "rgba(113, 128, 150, 0.6)" : "rgba(203, 213, 224, 0.8)",
                // control grid dash pattern (solid lines)
                gridDash: [
                    0
                ],
                gridWidth: 1,
                gridOpacity: 0.7
            },
            // explicitly disable grid lines for x-axis
            axisX: {
                grid: false
            }
        }
    });
const $8a5084ff6f43a837$export$7b61b114c1f6ee83 = (data, isDarkMode)=>({
        color: {
            field: data.chartSpec?.encoding?.color?.field,
            type: data.chartSpec?.encoding?.color?.type,
            title: data.chartSpec?.encoding?.color?.title,
            sort: data.chartSpec?.encoding?.color?.sort,
            scale: {
                type: "ordinal",
                range: $8a5084ff6f43a837$export$20890d43e702257e()
            },
            // legend config for donut charts
            legend: {
                titleFontSize: 15,
                labelFontSize: 13,
                symbolSize: 80,
                titlePadding: 10,
                labelLimit: 200,
                padding: 15,
                titleFont: "Rubik",
                labelFont: "Rubik",
                titleColor: isDarkMode ? "#E2E8F0" : "#1A202C",
                labelColor: isDarkMode ? "#CBD5E0" : "#2D3748"
            }
        }
    });
const $8a5084ff6f43a837$export$f6bf254573e632aa = (spec)=>({
        ...spec,
        layer: [
            {
                // first layer: donut chart
                mark: {
                    type: "arc",
                    innerRadius: {
                        expr: "min(width, height) * 0.35"
                    },
                    outerRadius: {
                        expr: "min(width, height) * 0.47"
                    },
                    tooltip: true
                },
                encoding: spec.encoding
            }
        ]
    });
const $8a5084ff6f43a837$export$a384f837f141d2d1 = (data, isDarkMode)=>({
        color: {
            field: data.chartSpec?.encoding?.color?.field,
            type: data.chartSpec?.encoding?.color?.type,
            title: data.chartSpec?.encoding?.color?.title,
            sort: data.chartSpec?.encoding?.color?.sort,
            scale: {
                type: "ordinal",
                range: $8a5084ff6f43a837$export$1b0fe2b75c1a919c()
            },
            // add legend configs for pie charts
            legend: {
                titleFontSize: 14,
                labelFontSize: 13,
                symbolSize: 80,
                orient: "right",
                titlePadding: 10,
                labelLimit: 200,
                padding: 15,
                titleFont: "Rubik",
                labelFont: "Rubik",
                titleColor: isDarkMode ? "#E2E8F0" : "#1A202C",
                labelColor: isDarkMode ? "#CBD5E0" : "#2D3748"
            }
        }
    });
const $8a5084ff6f43a837$export$8b3c9edc612e23c1 = (spec)=>({
        ...spec,
        mark: {
            ...spec.mark,
            tooltip: true
        },
        // add selection/highlighting capability
        selection: {
            // create a selection that activates on legend click
            legendHover: {
                type: "single",
                fields: [
                    typeof spec.encoding === "object" && spec.encoding !== null && "color" in spec.encoding && typeof spec.encoding.color === "object" && spec.encoding.color !== null && "field" in spec.encoding.color ? String(spec.encoding.color.field) : "category"
                ],
                bind: "legend"
            }
        },
        // add condition to highlight the selected slice
        encoding: {
            ...spec.encoding,
            fillOpacity: {
                condition: {
                    selection: "legendHover",
                    value: 1
                },
                value: 0.5
            }
        }
    });


const $efb150225f5f698f$export$2d1502080f0583ca = (data)=>{
    if (!data.chartSpec || Object.entries(data.chartSpec).length === 0) return data; // return data if no chart spec or empty
    // clone the data to avoid mutating the original
    const processedData = {
        ...data,
        chartSpec: {
            ...data.chartSpec
        }
    };
    const chartType = processedData.chartSpec.mark?.type;
    if (chartType === "bar") {
        // detect if this is a horizontal bar chart (categories on y-axis)
        const isHorizontalBar = processedData.chartSpec.encoding?.y?.type === "nominal" || processedData.chartSpec.encoding?.y?.type === "ordinal";
        // transform horizontal bar charts to vertical
        if (isHorizontalBar) {
            // create a new encoding object
            const encoding = {
                ...processedData.chartSpec.encoding
            };
            // preserve the original color encoding before swap
            const originalColor = encoding.color;
            // swap x and y using a temporary variable
            const tempX = encoding.x;
            encoding.x = encoding.y;
            encoding.y = tempX;
            // update sort references if they exist
            if (encoding.x && encoding.x.sort === "-x") encoding.x.sort = "-y";
            if (encoding.y && encoding.y.sort === "-y") encoding.y.sort = "-x";
            // restore the original color encoding
            encoding.color = originalColor;
            // apply the new encoding with type assertion
            processedData.chartSpec.encoding = encoding;
        }
    }
    // transformations for other chart types as needed
    // if (chartType === 'line') {
    return processedData;
};
const $efb150225f5f698f$export$3fd2a8393c4470ad = (data, containerSize, isDarkMode = false)=>{
    if ("chartSpec" in data && Object.entries(data.chartSpec ?? {}).length === 0) return {};
    const isBarChart = data.chartSpec?.mark?.type ? [
        "bar"
    ].includes(data.chartSpec.mark.type) : false;
    const isLineChart = data.chartSpec?.mark?.type ? [
        "line"
    ].includes(data.chartSpec.mark.type) : false;
    const isArcChart = data.chartSpec?.mark?.type === "arc";
    const isDonutChart = isArcChart && // check if innerRadius exists either on mark or encoding
    (typeof data.chartSpec?.mark === "object" && "innerRadius" in data.chartSpec.mark || typeof data.chartSpec?.encoding === "object" && "innerRadius" in data.chartSpec.encoding);
    const isPieChart = isArcChart && !isDonutChart;
    // determine the data source based on api response
    let dataSource;
    // TODO: double-check below: when waii_data.json is not loaded correctly, it doesn't cause an error.
    // the chart simply doesn't render data.
    if (data.data && data.data.length > 0) dataSource = {
        values: data.data
    }; // use inline data if available
    else if (data.chartSpec?.data?.url) dataSource = data.chartSpec.data; // fallback to url-based data (i.e. waii_data.json)
    else dataSource = {
        values: []
    }; // set empty array as last resort
    let spec = {
        ...data.chartSpec,
        autosize: {
            type: "fit",
            contains: "padding"
        },
        width: containerSize.width,
        height: containerSize.height,
        data: dataSource,
        config: {
            axis: {
                domain: false,
                domainColor: isDarkMode ? "#4A5568" : "white",
                domainWidth: 0,
                ticks: true,
                tickColor: isDarkMode ? "#718096" : "black",
                tickWidth: 1,
                grid: false,
                labelFont: "Rubik",
                labelFontSize: 12,
                labelColor: isDarkMode ? "#CBD5E0" : "#2D3748",
                titleFont: "Rubik",
                titleFontSize: 14,
                titlePadding: 10,
                titleColor: isDarkMode ? "#E2E8F0" : "#1A202C"
            },
            view: {
                stroke: isDarkMode ? "#2D3748" : "#F7F9FC",
                strokeWidth: 1,
                cornerRadius: 5
            },
            legend: {
                padding: 10,
                labelColor: isDarkMode ? "#E2E8F0" : "#2D3748",
                titleColor: isDarkMode ? "#E2E8F0" : "#1A202C"
            },
            background: isDarkMode ? "#0d0f1c" : "#F7F9FC",
            title: {
                color: isDarkMode ? "#E2E8F0" : "#1A202C",
                font: "Rubik",
                fontSize: 16
            }
        },
        encoding: {
            ...data.chartSpec?.encoding ?? {},
            ...isBarChart && (0, $8a5084ff6f43a837$export$3301771ffa55bd3e)(data),
            ...isLineChart && (0, $8a5084ff6f43a837$export$9ae33e9662607bc5)(data, isDarkMode),
            ...isDonutChart && (0, $8a5084ff6f43a837$export$7b61b114c1f6ee83)(data, isDarkMode),
            ...isPieChart && (0, $8a5084ff6f43a837$export$a384f837f141d2d1)(data, isDarkMode)
        }
    };
    if (isLineChart) spec = (0, $8a5084ff6f43a837$export$f225b68be2a82c3b)(spec, isDarkMode);
    if (isDonutChart) spec = (0, $8a5084ff6f43a837$export$f6bf254573e632aa)(spec);
    if (isPieChart) spec = (0, $8a5084ff6f43a837$export$8b3c9edc612e23c1)(spec);
    const isChartStacked = (0, $8a5084ff6f43a837$export$45f34f1cb2907697)(data.data, data.chartSpec?.encoding?.x?.field);
    if (isBarChart && isChartStacked && (0, $8a5084ff6f43a837$export$e363d7242400e222)) spec.encoding.color = {
        ...spec.encoding.color,
        legend: null
    };
    if (isBarChart && !isChartStacked && (0, $8a5084ff6f43a837$export$c3256e39d849f16b)) {
        if (spec.encoding.color) spec.encoding.color = {
            ...spec.encoding.color,
            legend: null
        };
    }
    // all of the code below (until return layeredSpec) is for adding totals to the top of each bar
    // it should be safe to remove if any totals are incorrect as there wasn't a lot of data to test with
    const SHOW_BAR_TOTALS = true;
    if (isBarChart && SHOW_BAR_TOTALS) {
        // check if we have the necessary fields for adding totals
        const xField = spec.encoding.x?.field;
        const yField = spec.encoding.y?.field;
        if (xField && yField) {
            // since we need to change the structure significantly,
            // let's create a new object with the right type
            // keep all the original properties except mark and encoding
            const { mark: originalMark, encoding: originalEncoding, ...restProps } = spec;
            // create a new layered spec with proper typing
            const layeredSpec = {
                ...restProps,
                // the layer property will replace mark and encoding
                layer: [
                    {
                        // first layer: the original bar chart
                        mark: originalMark,
                        encoding: originalEncoding
                    },
                    {
                        // second layer: text labels for the bar totals
                        mark: {
                            type: "text",
                            align: "center",
                            baseline: "bottom",
                            dy: -5,
                            font: "Rubik",
                            fontSize: 12,
                            fontWeight: "bold",
                            color: isDarkMode ? "#E2E8F0" : "#1A202C"
                        },
                        encoding: {
                            x: originalEncoding.x,
                            // position the total at the top of each bar
                            y: {
                                aggregate: "sum",
                                field: yField,
                                type: "quantitative"
                            },
                            // display the total value
                            text: {
                                aggregate: "sum",
                                field: yField,
                                type: "quantitative",
                                format: ",d"
                            }
                        }
                    }
                ]
            };
            // type assertion to tell TypeScript this is intentional
            return layeredSpec;
        }
    }
    return spec;
};





/**
 * ThemeProvider component that manages and provides the current theme (light or dark) across the app.
 *
 * Features:
 * - Uses React Context to share the theme state with child components via `useTheme` hook.
 * - Persists the theme across sessions using `localStorage`.
 * - Syncs the React state with the `data-theme` attribute on the <body> element.
 * - Listens for manual changes to `data-theme` using a MutationObserver and updates the context state accordingly.
 * - Provides a `setTheme` function to toggle the theme between light (false) and dark (true).
 *
 * Props:
 * - `children`: React nodes that will have access to the theme context.
 *
 * Behavior:
 * - On load, initializes theme from `localStorage` (or defaults to light if not set).
 * - Applies the `data-theme` attribute to `<body>` for CSS-based theming.
 * - Updates localStorage and DOM when the theme is changed.
 */ const $670c946906b8a505$var$THEME_STORAGE_KEY = "app-theme"; // Stored as 'light' or 'dark'
const $670c946906b8a505$var$ThemeContext = /*#__PURE__*/ (0, $cURGa$createContext)(undefined);
const $670c946906b8a505$export$93d4e7f90805808f = ()=>{
    const context = (0, $cURGa$useContext)($670c946906b8a505$var$ThemeContext);
    if (!context) throw new Error("useTheme must be used within a ThemeProvider");
    return context;
};
function $670c946906b8a505$var$ThemeProvider({ children: children }) {
    const [theme, setThemeState] = (0, $cURGa$useState)(()=>{
        // Initial theme from localStorage or fallback to light
        if (typeof window !== "undefined") {
            const storedTheme = localStorage.getItem($670c946906b8a505$var$THEME_STORAGE_KEY);
            return storedTheme === "dark";
        }
        return false;
    });
    // Effect to sync body attribute with state and watch DOM changes
    (0, $cURGa$useEffect)(()=>{
        const bodyElement = document.body;
        const applyTheme = (isDark)=>{
            const next = isDark ? "dark" : "light";
            bodyElement.setAttribute("data-theme", next);
            localStorage.setItem($670c946906b8a505$var$THEME_STORAGE_KEY, next);
        };
        applyTheme(theme);
        const handleThemeChange = ()=>{
            const current = bodyElement.getAttribute("data-theme");
            if (current === "dark") {
                setThemeState(true);
                localStorage.setItem($670c946906b8a505$var$THEME_STORAGE_KEY, "dark");
            } else {
                setThemeState(false);
                localStorage.setItem($670c946906b8a505$var$THEME_STORAGE_KEY, "light");
            }
        };
        // Create a MutationObserver to observe changes in the `data-theme` attribute
        const observer = new MutationObserver(handleThemeChange);
        observer.observe(bodyElement, {
            attributes: true,
            attributeFilter: [
                "data-theme"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    // Function to toggle theme between light and dark
    const toggleTheme = (newTheme)=>{
        setThemeState((prevTheme)=>{
            if (prevTheme !== newTheme) {
                const bodyElement = document.body;
                const next = newTheme ? "dark" : "light";
                bodyElement.setAttribute("data-theme", next);
                localStorage.setItem($670c946906b8a505$var$THEME_STORAGE_KEY, next);
            }
            return newTheme;
        });
    };
    // Wrap the context value in useMemo to prevent unnecessary re-renders
    const value = (0, $cURGa$useMemo)(()=>({
            theme: theme,
            setTheme: toggleTheme
        }), [
        theme
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)($670c946906b8a505$var$ThemeContext.Provider, {
        value: value,
        children: children
    });
}
var $670c946906b8a505$export$2e2bcd8739ae039 = $670c946906b8a505$var$ThemeProvider;



// TODO: localize these error messages
const $5208aabe3e42fa00$var$chartRenderingError = "Error rendering chart. Please try again.";
const $5208aabe3e42fa00$var$generalError = "Your question returned no results. Please rephrase your question and I will be happy to assist you!";
const $5208aabe3e42fa00$var$chartResizeDelay = 50;
const $5208aabe3e42fa00$var$CONTAINER_PADDING = {
    WIDTH: 16,
    HEIGHT: 16
};
function $5208aabe3e42fa00$export$2e2bcd8739ae039({ data: data }) {
    const [error, setError] = (0, $cURGa$useState)(null);
    const containerRef = (0, $cURGa$useRef)(null);
    const chartRef = (0, $cURGa$useRef)(null);
    const [containerSize, setContainerSize] = (0, $cURGa$useState)({
        width: 0,
        height: 0
    });
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    // Memoize the data preprocessing
    const preprocessedData = (0, $cURGa$useMemo)(()=>(0, $efb150225f5f698f$export$2d1502080f0583ca)(data), [
        data
    ]);
    // Memoize chart spec creation to avoid recalculating on every render
    const chartSpec = (0, $cURGa$useMemo)(()=>(0, $efb150225f5f698f$export$3fd2a8393c4470ad)(preprocessedData, containerSize, theme), [
        preprocessedData,
        containerSize,
        theme
    ]);
    // update size when data panel expands or contracts
    (0, $cURGa$useEffect)(()=>{
        const timer = setTimeout(()=>{
            if (containerRef.current) setContainerSize({
                width: containerRef.current.offsetWidth - $5208aabe3e42fa00$var$CONTAINER_PADDING.WIDTH,
                height: containerRef.current.offsetHeight - $5208aabe3e42fa00$var$CONTAINER_PADDING.HEIGHT
            });
        // add a slight delay to allow the css transition to complete
        }, $5208aabe3e42fa00$var$chartResizeDelay);
        return ()=>clearTimeout(timer);
    }, [
        chatOverlayState.isDataPanelFullScreen
    ]);
    // standard resize handler for window resizing
    (0, $cURGa$useEffect)(()=>{
        const updateSize = ()=>{
            if (containerRef.current) setContainerSize({
                width: containerRef.current.offsetWidth - $5208aabe3e42fa00$var$CONTAINER_PADDING.WIDTH,
                height: containerRef.current.offsetHeight - $5208aabe3e42fa00$var$CONTAINER_PADDING.HEIGHT
            });
        };
        // initial size calculation
        updateSize();
        window.addEventListener("resize", updateSize);
        return ()=>{
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    (0, $cURGa$useEffect)(()=>{
        if (chartRef.current && Object.keys(chartSpec).length > 0) try {
            // clear any previous chart
            chartRef.current.innerHTML = "";
            // ensure width and height are set in the spec
            const responsiveSpec = {
                ...chartSpec,
                width: containerSize.width > 0 ? containerSize.width : undefined,
                height: containerSize.height > 0 ? containerSize.height : undefined
            };
            // render chart with vegaEmbed (no controls)
            (0, $cURGa$vegaembed)(chartRef.current, responsiveSpec, {
                actions: false,
                renderer: "canvas",
                hover: true
            }).catch((err)=>{
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("error rendering chart with vegaEmbed", err);
                setError($5208aabe3e42fa00$var$chartRenderingError);
            });
        } catch (err) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("error in vegaEmbed rendering", err);
            setError($5208aabe3e42fa00$var$chartRenderingError);
        }
    }, [
        chartSpec,
        containerSize
    ]);
    const renderChart = ()=>{
        try {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("calculated chart spec", {
                chartSpec: chartSpec
            });
            // return an element for vegaEmbed to render into
            return /*#__PURE__*/ (0, $cURGa$jsx)("figure", {
                ref: chartRef,
                className: "Ispm-PlotChart-renderedChart"
            });
        // keep the original VegaLite as a fallback if needed
        // return <VegaLite spec={chartSpec} />;
        } catch (err) {
            setError($5208aabe3e42fa00$var$generalError);
            return null;
        }
    };
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        ref: containerRef,
        style: {
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "auto"
        },
        children: error || Object.keys(chartSpec).length === 0 ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            style: {
                textAlign: "center",
                padding: "20px"
            },
            children: /*#__PURE__*/ (0, $cURGa$jsx)("h4", {
                children: error ?? $5208aabe3e42fa00$var$generalError
            })
        }) : renderChart()
    });
}



function $51b6efdbfc9e386a$export$2e2bcd8739ae039({ data: data }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        "data-testid": (0, $b673ba598f0efd75$export$c46de8d9a27574bc),
        className: "Ispm-ChartVisualization",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: "Ispm-ChartVisualization-chart",
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $5208aabe3e42fa00$export$2e2bcd8739ae039), {
                data: data
            })
        })
    });
}





function $90d162d6bee579eb$export$2e2bcd8739ae039({ data: data }) {
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const [toggleSelection, setToggleSelection] = (0, $cURGa$useState)((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART);
    const { fetchDashboards: fetchDashboards } = (0, $2f326624061e22b1$export$2e2bcd8739ae039)();
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    (0, $cURGa$useEffect)(()=>{
        if (chatOverlayState.dashboardLists.length > 0) return;
        fetchDashboards();
    }, [
        chatOverlayState.dashboardLists.length,
        fetchDashboards
    ]);
    if (!("content" in data) || data.contentType !== "chart" || !Array.isArray(data.content)) {
        updateChatOverlayState("showGeneratedContent", false);
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("ChartPanel --> panel kind - chart  --> no content present in response", {
            data: data
        });
        return null;
    }
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Ispm-ChartPanel",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $8f8171e832d5bb70$export$2e2bcd8739ae039), {
                headerText: data.request?.freeText ?? l("New Chart"),
                toggleSelection: toggleSelection,
                panelType: (0, $6232c3747a1d613b$export$950a020027fa5a0b).CHART
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-ChartPanel-headerContentContainer",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $a5d805b3406f4556$export$2e2bcd8739ae039), {
                        toggleSelection: toggleSelection,
                        setToggleSelection: setToggleSelection
                    }),
                    toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $51b6efdbfc9e386a$export$2e2bcd8739ae039), {
                        data: data
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $73cf05f39fc180b5$export$2e2bcd8739ae039), {
                        query: data.query ?? ""
                    })
                ]
            })
        ]
    });
}















$88611cbba26f6284$var$SqlErrorToggle.defaultProps = {
    detailedSteps: [],
    toggleSelection: undefined,
    setToggleSelection: ()=>{},
    sqlQuery: ""
};
function $88611cbba26f6284$var$SqlErrorToggle({ toggleSelection: toggleSelection, setToggleSelection: setToggleSelection, detailedSteps: detailedSteps, sqlQuery: sqlQuery }) {
    const tooltipSteps = Array.isArray(detailedSteps) ? detailedSteps.join("\n") : "";
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-SqlErrorToggle",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: "Ispm-SqlErrorToggle-contentWrapper",
            children: /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                className: "Ispm-SqlErrorToggle-contentWrapper-toggleGroup",
                "aria-label": l("Toggle button group for switching views"),
                children: [
                    (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).SHOW_SQL_TOGGLE_BUTTON && toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).SQL && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                        text: tooltipSteps,
                        placement: "left",
                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Info",
                            color: "--color-foreground-info-medium",
                            size: "xSmall"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$ToggleButtonGroup), {
                        selection: toggleSelection,
                        setSelection: setToggleSelection,
                        isPill: true,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    text: "View Visualization",
                                    placement: "top",
                                    offset: 20,
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "DataAnalyze",
                                        size: "small",
                                        color: "--color-foreground-secondary-bold"
                                    })
                                }),
                                isDisabled: true
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    text: "View Table",
                                    placement: "top",
                                    offset: 20,
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "DataTable",
                                        size: "small",
                                        color: "--color-foreground-secondary-bold"
                                    })
                                }),
                                isDisabled: true
                            }),
                            (0, $8f460a89aa4ee4ee$export$1e3fa289c11cc7).SHOW_SQL_TOGGLE_BUTTON && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    text: "View SQL",
                                    placement: "top",
                                    offset: 20,
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "Code",
                                        size: "small",
                                        color: "--color-foreground-secondary-bold"
                                    })
                                }),
                                isDisabled: !sqlQuery?.length
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $88611cbba26f6284$export$2e2bcd8739ae039 = $88611cbba26f6284$var$SqlErrorToggle;



// eslint-disable-next-line import/prefer-default-export
const $0be758b64bb47b5b$export$bd887b31a0b6db0d = 100;













function $5e06cfb0f708930d$var$SaviTableData({ data: data }) {
    const tableData = (0, $cURGa$useMemo)(()=>{
        const isValidRows = (rows)=>Array.isArray(rows) && rows.every((r)=>typeof r === "object" && r !== null);
        const rawRows = isValidRows(data) ? data : [];
        return rawRows.slice(0, (0, $0be758b64bb47b5b$export$bd887b31a0b6db0d)).map((row)=>{
            const flatRow = {};
            Object.entries(row).forEach(([key, value])=>{
                flatRow[key] = typeof value === "string" || typeof value === "number" ? value : String(value) ?? "";
            });
            return flatRow;
        });
    }, [
        data
    ]);
    const initialColumns = (0, $cURGa$useMemo)(()=>{
        if (!tableData.length) return [];
        return Object.keys(tableData[0]).map((key)=>({
                key: key,
                label: key,
                value: key,
                isSortable: true,
                isChecked: true,
                width: "-webkit-fill-available",
                minWidth: "10rem",
                maxWidth: "30rem",
                render: (row)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body2",
                        lineLimit: 2,
                        children: String(row[key])
                    })
            }));
    }, [
        tableData
    ]);
    const [columns, setColumns] = (0, $cURGa$useState)(initialColumns);
    // Data Error
    if (!Array.isArray(data)) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $d2f29977ef83b8b0$export$2e2bcd8739ae039), {});
    // Empty Records
    if (!data.length) return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SaviTableData-edgeCase",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: "Ispm-SaviTableData-edgeCase-primaryText",
            children: "No Records Found!"
        })
    });
    const sortOptions = [
        {
            label: "Ascending",
            value: "asc",
            isDisabled: false,
            isChecked: false,
            icon: "ArrowUp",
            shouldShowCheckIcon: true
        },
        {
            label: "Descending",
            value: "desc",
            isDisabled: false,
            isChecked: false,
            icon: "ArrowDown",
            shouldShowCheckIcon: true
        }
    ];
    const sortConfigs = columns.map((column)=>({
            key: column.key,
            sortOptions: sortOptions
        }));
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TableSortable), {
        data: tableData,
        columns: columns,
        setColumns: setColumns,
        sortConfigs: sortConfigs,
        tableHeight: 600,
        className: "Ispm-SaviTableData-table",
        isVirtualizationEnabled: false,
        columnConfigs: {
            isHeaderSticky: true,
            isHorizontalScroll: false,
            isDndDisabled: true
        },
        dataTestId: "Ispm-SaviTableData"
    });
}
var $5e06cfb0f708930d$export$2e2bcd8739ae039 = $5e06cfb0f708930d$var$SaviTableData;




function $f2f3b08511fd9915$var$SaviContentPanel({ kind: kind, data: data }) {
    const { updateChatOverlayState: updateChatOverlayState, chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    // TODO (ISPM): header font size is different (smaller) for tables
    const [toggleSelection, setToggleSelection] = (0, $cURGa$useState)((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION);
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { controllerRef: controllerRef } = (0, $08bb17136b599311$export$4db023b7660421fa)();
    if (!controllerRef.current) controllerRef.current = new AbortController();
    (0, $cURGa$useEffect)(()=>{
        // Check is its low confidence ask api response
        if (data.contentType === "query" && !("error" in data)) setToggleSelection((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).SQL);
        else if ("chartSpec" in data && data.chartSpec) // if chartSpec is present, default to chart view
        setToggleSelection((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART);
        else // default to table view if no chart
        setToggleSelection((0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION);
    }, [
        data
    ]);
    const renderContent = ()=>{
        switch(kind){
            case (0, $6232c3747a1d613b$export$950a020027fa5a0b).GENERATING_CONTENT:
                return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                    className: "Ispm-SaviContentPanel",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $8f8171e832d5bb70$export$2e2bcd8739ae039), {
                            panelType: (0, $6232c3747a1d613b$export$950a020027fa5a0b).GENERATING_CONTENT
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $9e69af25b4683479$export$2e2bcd8739ae039), {})
                    ]
                });
            case (0, $6232c3747a1d613b$export$950a020027fa5a0b).CHART:
                return /*#__PURE__*/ (0, $cURGa$jsx)((0, $90d162d6bee579eb$export$2e2bcd8739ae039), {
                    data: data
                });
            case (0, $6232c3747a1d613b$export$950a020027fa5a0b).SQL_ERROR:
                {
                    let formattedQuery = "";
                    if (data.query && typeof data.query === "string") formattedQuery = (0, $cURGa$format)(data.query);
                    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                        className: "Ispm-SaviContentPanel",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $8f8171e832d5bb70$export$2e2bcd8739ae039), {
                                headerText: "ask" in data ? data.ask : data.request?.freeText ?? l("SQL Error"),
                                toggleSelection: toggleSelection,
                                panelType: (0, $6232c3747a1d613b$export$950a020027fa5a0b).SQL_ERROR
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                className: "Ispm-SaviContentPanel-headerContentContainer",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $88611cbba26f6284$export$2e2bcd8739ae039), {
                                        detailedSteps: data.detailedSteps ? data.detailedSteps : [],
                                        toggleSelection: toggleSelection,
                                        setToggleSelection: setToggleSelection,
                                        sqlQuery: formattedQuery
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $d2f29977ef83b8b0$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    });
                }
            case (0, $6232c3747a1d613b$export$950a020027fa5a0b).TABLE:
                {
                    const formattedQuery = (0, $cURGa$format)(data.query ?? "");
                    const hasChartData = Boolean(chatOverlayState.contentPanelData.chartSpec);
                    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                        className: "Ispm-SaviContentPanel",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $8f8171e832d5bb70$export$2e2bcd8739ae039), {
                                headerText: "ask" in data ? data.ask : data.request?.freeText ?? l("New Table"),
                                numRecords: Array.isArray(data.data) ? data.data.length : 0,
                                toggleSelection: toggleSelection,
                                panelType: (0, $6232c3747a1d613b$export$950a020027fa5a0b).TABLE
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                className: "Ispm-SaviContentPanel-headerContentContainer",
                                children: [
                                    Array.isArray(data.data) && /*#__PURE__*/ (0, $cURGa$jsx)((0, $a5d805b3406f4556$export$2e2bcd8739ae039), {
                                        numRecords: Math.min(data.data.length, (0, $0be758b64bb47b5b$export$bd887b31a0b6db0d)),
                                        toggleSelection: toggleSelection,
                                        setToggleSelection: setToggleSelection
                                    }),
                                    toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).CHART && hasChartData && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-SaviContentPanel-chart",
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $51b6efdbfc9e386a$export$2e2bcd8739ae039), {
                                            data: chatOverlayState.contentPanelData
                                        })
                                    }),
                                    toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).VISUALIZATION && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-SaviContentPanel-table",
                                        "data-testid": (0, $b673ba598f0efd75$export$e9534a9d5efca98d),
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $5e06cfb0f708930d$export$2e2bcd8739ae039), {
                                            data: data.data
                                        })
                                    }),
                                    toggleSelection === (0, $6232c3747a1d613b$export$51ad9cfdf1b80724).SQL && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-SaviContentPanel-sql",
                                        "data-testid": (0, $b673ba598f0efd75$export$5031e205504ecda1),
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)("pre", {
                                            className: "Ispm-SaviContentPanel-sql-content",
                                            children: /*#__PURE__*/ (0, $cURGa$jsx)("code", {
                                                children: formattedQuery
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            case (0, $6232c3747a1d613b$export$950a020027fa5a0b).LOW_CONFIDENCE:
                // case GeneratedContentTypeEnum.HIGH_CONFIDENCE: {
                if (!("contentType" in data) || data.contentType !== "query" || "error" in data) {
                    updateChatOverlayState("showGeneratedContent", false);
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("SaviContentPanel --> panel kind - low confidence  --> contentType is not query");
                    return null;
                }
                return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                    className: "Ispm-SaviContentPanel",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $8f8171e832d5bb70$export$2e2bcd8739ae039), {
                            headerText: "ask" in data ? data.ask : data.request?.freeText ?? l("Low Confidence"),
                            panelType: (0, $6232c3747a1d613b$export$950a020027fa5a0b).LOW_CONFIDENCE
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-SaviContentPanel-table",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $181efe26917a4858$export$2e2bcd8739ae039), {
                                panelHeader: /*#__PURE__*/ (0, $cURGa$jsx)((0, $dfe6d965355ce299$export$2e2bcd8739ae039), {
                                    toggleSelection: toggleSelection,
                                    setToggleSelection: setToggleSelection
                                }),
                                toggleSelection: toggleSelection,
                                query: data.query ?? "",
                                onClick: ()=>{
                                // handle low confidence sample data api
                                }
                            })
                        })
                    ]
                });
            default:
                return null;
        }
    };
    return renderContent() ?? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SaviContentPanel--noContent"
    });
}
var $f2f3b08511fd9915$export$2e2bcd8739ae039 = $f2f3b08511fd9915$var$SaviContentPanel;










const $592e551b2d406944$var$MAX_INPUT_LENGTH = 500;
const $592e551b2d406944$var$MAX_HEIGHT_PX = 116; // This is the Maximum height in pixels
const $592e551b2d406944$var$PIXELS_PER_REM = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16; // This is converting from pixels to rem
const $592e551b2d406944$var$MIN_SCROLL_HEIGHT = 48; // This is Minimum scroll height to display text count
function $592e551b2d406944$var$SaviChatInput() {
    const [isTextCountVisible, setisTextCountVisible] = (0, $cURGa$useState)(false);
    const { chatOverlayState: chatOverlayState, updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const saviChatInputRef = (0, $cURGa$useRef)(null);
    const saviChatInputTextSize = chatOverlayState.saviInputText.trim().length;
    (0, $cURGa$useEffect)(()=>{
        if (!saviChatInputRef.current) return;
        saviChatInputRef.current.style.height = "0px";
        const { scrollHeight: scrollHeight } = saviChatInputRef.current;
        if (scrollHeight > $592e551b2d406944$var$MIN_SCROLL_HEIGHT) setisTextCountVisible(true);
        else setisTextCountVisible(false);
        saviChatInputRef.current.style.height = `${Math.min(scrollHeight, $592e551b2d406944$var$MAX_HEIGHT_PX) / $592e551b2d406944$var$PIXELS_PER_REM}rem`;
    }, [
        chatOverlayState.saviInputText
    ]);
    const setOverlayInputValue = (inputText)=>{
        updateChatOverlayState("saviInputText", inputText);
    };
    const callChatAskApi = ()=>{
        // Change in below userquery will trigger the api call
        updateIspmState("userQuery", chatOverlayState.saviInputText);
        updateIspmState("isChatOverlayVisible", true);
        updateIspmState("isSuggestionVisible", false);
    };
    const handleKeyDown = (event)=>{
        if (saviChatInputTextSize > $592e551b2d406944$var$MAX_INPUT_LENGTH) return;
        if (event.key === "Enter") {
            event.preventDefault();
            callChatAskApi();
        }
    };
    const handleSuffixIconClick = ()=>{
        if (saviChatInputTextSize > $592e551b2d406944$var$MAX_INPUT_LENGTH) return;
        if (chatOverlayState.isApiCallInProgress) updateChatOverlayState("isWarningModalOpen", true);
        else callChatAskApi();
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: (0, $cURGa$classnames)(chatOverlayState.showGeneratedContent ? "Ispm-SaviChatInput--small" : "Ispm-SaviChatInput--large", isTextCountVisible && "Ispm-SaviChatInput--hasCount"),
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SaviInputField-prefixIcon",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("i", {
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "Comment",
                                color: "purple-700",
                                size: "smallMedium"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-SaviInputfieldMain",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InputField), {
                                className: "Ispm-SaviInputfield",
                                kind: "multiline",
                                name: "chat-input",
                                placeholder: l("What can I help you with?"),
                                isResetButtonVisible: false,
                                value: chatOverlayState.saviInputText,
                                setValue: setOverlayInputValue,
                                onKeyDown: handleKeyDown,
                                isDisabled: chatOverlayState.inputDisabled,
                                ref: saviChatInputRef,
                                dataTestId: "ispm-savi-chat-input-field"
                            }),
                            isTextCountVisible && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: saviChatInputTextSize <= $592e551b2d406944$var$MAX_INPUT_LENGTH ? "Ispm-SaviChatInput-saviTextCount" : "Ispm-SaviChatInput-saviTextCount--isDisabled",
                                children: [
                                    saviChatInputTextSize,
                                    "/",
                                    $592e551b2d406944$var$MAX_INPUT_LENGTH
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SaviInputField-suffixButton",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                            size: "medium",
                            kind: "saviGhost",
                            isDisabled: saviChatInputTextSize > $592e551b2d406944$var$MAX_INPUT_LENGTH || saviChatInputTextSize === 0,
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: chatOverlayState.isApiCallInProgress ? "Stop" : "ArrowUp",
                                className: saviChatInputTextSize > $592e551b2d406944$var$MAX_INPUT_LENGTH ? "Ispm-saviSuffixButtonIcon--isDisabled" : "",
                                size: "small"
                            }),
                            onClick: handleSuffixIconClick,
                            dataTestId: "ispm-savi-suffix-button"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-SaviChatInput-caption",
                children: l("Savi is always learning new things. Results may vary.")
            })
        ]
    });
}
var $592e551b2d406944$export$2e2bcd8739ae039 = $592e551b2d406944$var$SaviChatInput;






function $3bb6d3cd24c272ef$var$UserRequest({ message: message }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-UserRequest",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
            kind: "body2",
            className: "Ispm-UserRequest-text",
            children: typeof message === "string" ? message : message.text
        })
    });
}
var $3bb6d3cd24c272ef$export$2e2bcd8739ae039 = $3bb6d3cd24c272ef$var$UserRequest;











function $eaee16874b6f88fd$var$SaviChatHeader({ onChatClose: onChatClose, onChatReset: onChatReset }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { ispmErrorState: ispmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    return /*#__PURE__*/ (0, $cURGa$jsxs)("nav", {
        className: "Ispm-SaviChatHeader",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SaviChatHeader-logo",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "SaviCompanion",
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SaviChatHeader-logo-text",
                        children: l("Savi Copilot")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SaviChatHeader-controls",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                        text: l("Reset Chat"),
                        placement: "bottom",
                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-SaviChatHeader-controls-buttonIcon",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                size: "large",
                                kind: "saviGhost",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "SaviResetChat",
                                    size: "large"
                                }),
                                onClick: onChatReset,
                                dataTestId: (0, $b673ba598f0efd75$export$de6a5a831ebdc1d3),
                                isDisabled: chatOverlayState.isApiCallInProgress || ispmErrorState.errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                        text: l("Close"),
                        placement: "bottom",
                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-SaviChatHeader-controls-buttonIcon",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                size: "large",
                                kind: "saviGhost",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "Close",
                                    size: "large"
                                }),
                                onClick: onChatClose,
                                dataTestId: (0, $b673ba598f0efd75$export$be75bfbd87031fce)
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $eaee16874b6f88fd$export$2e2bcd8739ae039 = $eaee16874b6f88fd$var$SaviChatHeader;






function $fde1f23586659cf5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-LoaderResponse",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "dots",
                format: "inline",
                color: "info"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                kind: "body2",
                className: "Ispm-LoaderResponse-text",
                children: "Responding. This may take a moment"
            })
        ]
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 









$fe145213c8c858d0$export$2e2bcd8739ae039.defaultProps = {
    isSaveToChart: false
};
function $fe145213c8c858d0$export$2e2bcd8739ae039({ data: data, isSaveToChart: isSaveToChart }) {
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const localize = (0, $10bf676d992f37e7$export$917bfb70a1457f2)();
    const contentType = (0, $cURGa$useMemo)(()=>{
        if (!data.contentType) return Array.isArray(data.data) ? (0, $3b7091d4a3b49a26$export$69bd26c0ea27316c).SAMPLE_DATA : (0, $3b7091d4a3b49a26$export$69bd26c0ea27316c).TEXT;
        return data.contentType;
    }, [
        data
    ]);
    const handleShowData = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (!data.error) {
            updateChatOverlayState("showGeneratedContent", true);
            updateChatOverlayState("contentPanelData", data);
            const contentTypeToPanelKindMap = {
                sampleData: (0, $6232c3747a1d613b$export$950a020027fa5a0b).TABLE,
                chart: (0, $6232c3747a1d613b$export$950a020027fa5a0b).CHART,
                query: (0, $6232c3747a1d613b$export$950a020027fa5a0b).LOW_CONFIDENCE,
                text: null
            };
            const panelKind = contentTypeToPanelKindMap[contentType];
            if (panelKind) updateChatOverlayState("contentPanelKind", panelKind);
            else (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Unknown content type:", data.contentType);
        } else (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Content type is not present in the data");
    };
    // Handle click of reprocessAttemp
    const handleReprocessAttempt = (0, $cURGa$useCallback)(()=>{
        if ("request" in data && data.request?.freeText && data.request.freeText.length > 0) updateIspmState("userQuery", data.request.freeText);
    }, [
        data,
        updateIspmState
    ]);
    const formatStringToReact = (text)=>{
        if (!text) return null;
        return text.split("\n\n").map((block)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                kind: "body2",
                className: "Ispm-SaviDataResponse-text",
                children: block.trim()
            }, block));
    };
    const links = (0, $cURGa$useMemo)(()=>{
        let linksLabel = [
            {
                text: "",
                id: ""
            }
        ];
        if (!data.links) {
            // both chart and table data exist
            if (data.chartSpec && Array.isArray(data.data)) linksLabel = [
                {
                    text: "View Chart",
                    id: "View_Data"
                }
            ];
            else if (Array.isArray(data.data)) linksLabel = [
                {
                    text: "View Table",
                    id: "View_Table"
                }
            ];
            else if (data.chartSpec) linksLabel = [
                {
                    text: "View Chart",
                    id: "View_Chart"
                }
            ];
            else return null;
        } else {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("callChatAskApi -> link(s) already exist:", data.links);
            return data.links;
        }
        return linksLabel;
    }, [
        data.chartSpec,
        data.data,
        data.links
    ]);
    const getResponseNode = ()=>{
        if (data.error) {
            if (data.error.type === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).SaviCopilot) return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-reprocessPrompt",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body2",
                        className: "Ispm-reprocessPrompt-text",
                        children: "text" in data ? data.text : localize({
                            id: data.error.errorCode ? data.error.errorCode : "",
                            defaultMessage: data.error.errorMsg ? data.error.errorMsg : ""
                        })
                    }),
                    data.request && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "filled",
                        size: "medium",
                        onClick: handleReprocessAttempt,
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "frontIcon",
                            size: "medium",
                            color: "neutral-100"
                        }),
                        dataTestId: "ispm-reprocess-button",
                        children: l("Reprocess Request")
                    })
                ]
            });
            return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                kind: "body2",
                className: "Ispm-SaviDataResponse-error-text",
                children: "text" in data ? data.text : localize({
                    id: data.error.errorCode ? data.error.errorCode : "",
                    defaultMessage: data.error.errorMsg ? data.error.errorMsg : ""
                })
            });
        }
        const formattedElements = formatStringToReact(data.text ?? "");
        const isTextPropertyPresentInData = "text" in data;
        return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
            children: [
                isTextPropertyPresentInData && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-SaviDataResponse-container",
                    children: formattedElements
                }),
                Array.isArray(links) && links.length > 0 && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                    "data-testid": "responseLink",
                    text: links[0].text,
                    color: "neutral",
                    onClick: handleShowData,
                    prefixIconKind: "ArrowLeft",
                    size: "small",
                    className: "Ispm-SaviDataResponse-link"
                }),
                isSaveToChart && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                    "data-testid": "responseLink",
                    text: l("Take me to Intelligence Dashboard"),
                    color: "neutral",
                    onClick: ()=>{
                        // TODO: IN-12515 Update below logic based on confirmation from PO
                        updateIspmState("isChatOverlayVisible", false);
                    },
                    suffixIconKind: "Jump",
                    size: "small",
                    className: "Ispm-SaviDataResponse-saveToChart-link"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SaviDataResponse",
        children: getResponseNode()
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 





function $9240b54db630bf79$export$2e2bcd8739ae039({ data: data }) {
    const { updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const handleShowData = ()=>{
        updateChatOverlayState("contentPanelKind", (0, $6232c3747a1d613b$export$950a020027fa5a0b).TABLE);
    // updateChatOverlayState('contentPanelData', data);
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-SaviLowConfidenceResponse",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                kind: "body2",
                className: "Ispm-SaviLowConfidenceResponse-text",
                children: data.text
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                text: data.links[0].text,
                color: "neutral",
                onClick: handleShowData,
                prefixIconKind: "LeftArrow",
                size: "small"
            })
        ]
    });
}











function $dbc835d97b11e0c7$var$AlertBannerContainer() {
    const { ispmErrorState: ispmErrorState, updateIspmErrorState: updateIspmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    const { chatOverlayState: chatOverlayState, updateChatOverlayState: updateChatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { ispmState: ispmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const AlertBannerWrapper = (0, $cURGa$useCallback)(({ children: children, role: role, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
            className: (0, $cURGa$classnames)("Ispm-AlertBannerContainer", ispmState.isMenuPinned && "Ispm-AlertBannerContainer--isMenuPinned"),
            role: role,
            "aria-label": ariaLabel,
            children: children
        }), [
        ispmState
    ]);
    function getAlertBanner() {
        // check for successes first.
        if (chatOverlayState.successAction) switch(chatOverlayState.successAction.type){
            case "clipboardCopy":
                return /*#__PURE__*/ (0, $cURGa$jsx)(AlertBannerWrapper, {
                    role: "alert",
                    ariaLabel: l("Copied to clipboard"),
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$AlertBanner), {
                        kind: "high",
                        colorTheme: "Information",
                        title: l("Copied to clipboard"),
                        description: l("The SQL code was copied to your clipboard."),
                        // TODO: update copy above when we finalize the link.
                        onCancel: ()=>{
                            updateChatOverlayState("successAction", undefined);
                        },
                        isVisible: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 7000
                    })
                });
            case "downloadPending":
                return /*#__PURE__*/ (0, $cURGa$jsx)(AlertBannerWrapper, {
                    role: "alert",
                    ariaLabel: "Download in Progress",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$AlertBanner), {
                        kind: "high",
                        colorTheme: "Information",
                        title: "Generating Data",
                        description: l("Your data is being generated and will be available in the Downloads section of your profile menu when finished."),
                        onCancel: ()=>{
                            updateChatOverlayState("successAction", undefined);
                        },
                        isVisible: true,
                        shouldAutoDismiss: true
                    })
                });
            default:
                return null;
        }
        else if (ispmErrorState.errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System) return /*#__PURE__*/ (0, $cURGa$jsx)(AlertBannerWrapper, {
            role: "alert",
            "aria-label": l("System Error Alert"),
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$AlertBanner), {
                kind: "high",
                colorTheme: "Critical",
                title: l("Service temporary unavailable."),
                description: l("There was an error while processing your prompt. Please try again later."),
                onCancel: ()=>{
                    updateIspmErrorState("errorType", undefined);
                },
                isColonVisible: false,
                isVisible: true
            })
        });
        return null;
    }
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Fragment), {
        children: getAlertBanner()
    });
}
var $dbc835d97b11e0c7$export$2e2bcd8739ae039 = $dbc835d97b11e0c7$var$AlertBannerContainer;







function $e2ea88e8ee0cb0f8$var$ErrorPage({ title: title, description: description, iconKind: iconKind }) {
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Error page icon type - ", {
        iconKind: iconKind
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "ISPM-ErrorPage",
        "data-testid": "ISPM-ErrorPage",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Illustration), {
                kind: "Error",
                dataTestId: "Error",
                className: "ISPM-ErrorPage-identityWarning"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-ErrorPage-content",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h2",
                        className: "ISPM-ErrorPage-title",
                        "data-testid": "ISPM-ErrorPage-title",
                        color: "--color-foreground-neutral-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body1",
                        className: "ISPM-ErrorPage-description",
                        "data-testid": "ISPM-ErrorPage-description",
                        color: "--color-foreground-neutral-subtle",
                        children: description
                    })
                ]
            })
        ]
    });
}
$e2ea88e8ee0cb0f8$var$ErrorPage.defaultProps = {
    title: "Something went wrong while loading the page.",
    description: "Try refreshing, or check back later. If the issue persists, contact your administrator.",
    iconKind: "IdentityWarning"
};
var $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039 = $e2ea88e8ee0cb0f8$var$ErrorPage;







function $b632ad964f82823d$var$NoRecordFound({ title: title, description: description, iconKind: iconKind, isDisplayIcon: isDisplayIcon }) {
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info({
        iconKind: iconKind
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "ISPM-NoRecordFound",
        "data-testid": "ISPM-NoRecordFound",
        children: [
            isDisplayIcon && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Illustration), {
                kind: "Error",
                dataTestId: "Error",
                className: "ISPM-NoRecordFound-identityWarning"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-NoRecordFound-content",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h2",
                        className: "ISPM-NoRecordFound-title",
                        "data-testid": "ISPM-NoRecordFound-title",
                        color: "--color-foreground-neutral-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body1",
                        className: "ISPM-NoRecordFound-description",
                        "data-testid": "ISPM-NoRecordFound-description",
                        color: "--color-foreground-neutral-subtle",
                        children: description
                    })
                ]
            })
        ]
    });
}
$b632ad964f82823d$var$NoRecordFound.defaultProps = {
    title: "No Data Available",
    description: "There are no records to display at the moment. Please check back later or contact support if you need assistance.",
    iconKind: "IdentityWarning",
    isDisplayIcon: false
};
var $b632ad964f82823d$export$2e2bcd8739ae039 = $b632ad964f82823d$var$NoRecordFound;




$2998b537cc21621c$export$21e76ed09a093e97.defaultProps = {
    className: "",
    clickHandler: ()=>{},
    dataTestId: ""
};
$2998b537cc21621c$export$5665775b26e26c5d.defaultProps = {
    className: ""
};
$2998b537cc21621c$export$851de33184ecdac4.defaultProps = {
    className: ""
};
$2998b537cc21621c$export$e9897d434e0741ee.defaultProps = {
    className: ""
};
// Card Layout Component
function $2998b537cc21621c$export$21e76ed09a093e97({ children: children, className: className = "", clickHandler: clickHandler, dataTestId: dataTestId }) {
    const handleKeyDown = (e)=>{
        // Trigger onClick for "Enter" or "Space" keys
        if ((e.key === "Enter" || e.key === " ") && clickHandler) {
            e.preventDefault();
            // Call onClick; type cast as any if necessary
            clickHandler(e);
        }
    };
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: `card ${className}`,
        tabIndex: 0,
        role: "button" // Inform assistive technologies that this div behaves like a button
        ,
        "data-testid": dataTestId,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        children: children
    });
}
// Card Header Component
function $2998b537cc21621c$export$5665775b26e26c5d({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: `${className}`,
        children: children
    });
}
// Card Body Component
function $2998b537cc21621c$export$851de33184ecdac4({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: `${className}`,
        children: children
    });
}
// Card Footer Component
function $2998b537cc21621c$export$e9897d434e0741ee({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: `${className}`,
        children: children
    });
}










// Represents the nested license display metadata for permissions like "ispm.timeline.view".
// Known permission keys in one place
const $e93470e5e98f2427$export$e08c7aae438e15b4 = {
    COPILOT: "copilot",
    NHI: "nhi",
    RECOMMENDATIONS_VIEW: "ispm:recommendations:view",
    DASHBOARD_VIEW: "ispm:dashboard:view",
    LICENSE_ENTITLEMENTS_VIEW: "saviynt:license_entitlements:view",
    ACCESS_PATH_VIEW: "ispm:accessPath:view",
    EIC_RECOMMENDATIONS_ACTION: "ispm:eicRecommendations:action",
    LEFT_NAV_VIEW: "ispm:leftNav:view",
    POSTURE_INSIGHTS_GOVERNANCE_DASHBOARD_VIEW: "ispm:postureInsightsGovernanceDashboard:view",
    IDENTITIES_VIEW: "ispm:identities:view",
    GOVERNANCE_CERTIFICATIONS_VIEW: "ispm:governanceCertifications:view",
    POSTURE_INSIGHTS_ACCESS_DATA_VIEW: "ispm:postureInsightsAccessData:view",
    HUMAN_IDENTITY_TIMELINE_VIEW: "ispm:humanIdentityTimeline.view"
};
























const $31e402a3522b1407$var$iconMap = {
    info: "AlertInfoFilled",
    warning: "AlertWarningFilled"
};
const $31e402a3522b1407$var$iconColorMap = {
    info: "--color-foreground-info-medium",
    warning: "--color-foreground-warning-subtle"
};
const $31e402a3522b1407$var$typographyColorMap = {
    info: "--color-foreground-info-bold",
    warning: "--color-foreground-warning-bold"
};
/**
 * SaviAlertBanner component
 * This component displays a warning alert banner.
 *
 * @returns {JSX.Element} The rendered component.
 */ function $31e402a3522b1407$var$SaviAlertBanner({ type: type, isVisible: isVisible, description: description, actions: actions }) {
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "SaviAlertBanner",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: (0, $cURGa$classnames)("SaviAlertBanner-indicator", `SaviAlertBanner-indicator--${type}`)
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "SaviAlertBanner-content-container",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "SaviAlertBanner-content",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "SaviAlertBanner-icon",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: $31e402a3522b1407$var$iconMap[type],
                                    color: $31e402a3522b1407$var$iconColorMap[type]
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "SaviAlertBanner-text",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    desktop: "body2-d",
                                    mobile: "body2-d",
                                    color: $31e402a3522b1407$var$typographyColorMap[type],
                                    className: "AlertBanner-description",
                                    children: description
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "SaviAlertBanner-actions",
                        children: actions
                    })
                ]
            })
        ]
    });
}
$31e402a3522b1407$var$SaviAlertBanner.defaultProps = {
    actions: null
};
var $31e402a3522b1407$export$2e2bcd8739ae039 = $31e402a3522b1407$var$SaviAlertBanner;









function $f71a65f4e8b7a728$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $cURGa$jsx)("footer", {
        className: "Ispm-SaviChatFooter",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $592e551b2d406944$export$2e2bcd8739ae039), {})
    });
}











const { CHAT_HISTORY_URL: $550d0bb89e0fd1be$var$CHAT_HISTORY_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
function $550d0bb89e0fd1be$var$isChatHistoryResponse(data) {
    return typeof data === "object" && data !== null;
}
const $550d0bb89e0fd1be$var$getChatHistoryApi = async (url)=>{
    const chatHistoryUrl = url ?? $550d0bb89e0fd1be$var$CHAT_HISTORY_URL;
    const options = {
        method: "GET"
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(chatHistoryUrl, options, $550d0bb89e0fd1be$var$isChatHistoryResponse);
    return response; // Returning an array of HistoryApiResponse
};
var $550d0bb89e0fd1be$export$2e2bcd8739ae039 = $550d0bb89e0fd1be$var$getChatHistoryApi;



const $a0e2805fb8495171$var$useGetCopilotChatHistory = ()=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $cURGa$useQuery)({
        queryKey: (0, $e95e1a5b1863583b$export$2e2bcd8739ae039).chatHistory(),
        queryFn: ()=>(0, $550d0bb89e0fd1be$export$2e2bcd8739ae039)(),
        refetchOnWindowFocus: false,
        refetchOnMount: "always",
        retry: 0
    });
    return {
        chatHistory: data,
        isLoading: isLoading,
        isError: isError
    };
};
var $a0e2805fb8495171$export$2e2bcd8739ae039 = $a0e2805fb8495171$var$useGetCopilotChatHistory;





















// Response is 204 no content. So typeguard retruning true when no data
const $44b5e89f372e3607$var$isVoidResponse = (data)=>!data;
const $44b5e89f372e3607$var$SaviFeedbackApi = async (feedback)=>{
    const { CHAT_FEEDBACK_URL: CHAT_FEEDBACK_URL } = (0, $8ff2252602deef38$export$741965b27aa5110d)(false);
    const feedbackByMessageIdUrl = `${CHAT_FEEDBACK_URL}/${feedback.messageId ?? ""}/feedback`;
    const config = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(feedback)
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(feedbackByMessageIdUrl, config, $44b5e89f372e3607$var$isVoidResponse);
        if (!$44b5e89f372e3607$var$isVoidResponse(response)) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Unexpected non-void response from feedback API:", response);
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error in SaviFeedbackApi:", error instanceof Error ? error : new Error(String(error)));
        throw error;
    }
};
var $44b5e89f372e3607$export$2e2bcd8739ae039 = $44b5e89f372e3607$var$SaviFeedbackApi;



function $f7d3b4345fe39405$var$getFeedbackOptions(l) {
    return {
        1: l("Didn't fully follow instructions"),
        2: l("Not factually correct"),
        3: l("Didn't like the style")
    };
}
function $f7d3b4345fe39405$var$FooterBar({ setIsModalOpen: setIsModalOpen, handleSubmit: handleSubmit }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$FooterActionBar), {
        size: "small",
        className: "Ispm-Feedback-ModalIsland-footer",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-Feedback-ModalIsland-footerButtons",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                    kind: "ghost",
                    size: "medium",
                    onClick: ()=>setIsModalOpen(false),
                    dataTestId: "ispm-feedback-cancel",
                    children: l("Cancel")
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                    kind: "outlined",
                    size: "medium",
                    onClick: handleSubmit,
                    dataTestId: "ispm-feedback-submit",
                    children: l("Submit")
                })
            ]
        })
    });
}
function $f7d3b4345fe39405$var$ModalIslandBody({ inputValue: inputValue, setInputValue: setInputValue, handleFeedback: handleFeedback }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
        className: "Ispm-Feedback-ModalIsland-body",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                className: "Ispm-Feedback-ModalIsland-body-comments",
                children: Object.values($f7d3b4345fe39405$var$getFeedbackOptions(l)).map((label)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                        size: "small",
                        kind: "outlined",
                        label: label,
                        onClick: ()=>{
                            try {
                                handleFeedback(undefined, label);
                            } catch (error) {
                                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Feedback submission failed:", error);
                            }
                        }
                    }, label))
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                className: "Ispm-Feedback-ModalIsland-body-inputBox",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InputField), {
                    name: "InputField1",
                    placeholder: l("(Optional) Add specific details"),
                    value: inputValue,
                    setValue: setInputValue,
                    kind: "multiline"
                })
            })
        ]
    });
}
function $f7d3b4345fe39405$var$FeedbackButton({ type: type, feedback: feedback, handleClick: handleClick }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const isSelected = feedback === type;
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
        text: type === (0, $8ff2252602deef38$export$2a4af54e34d28b63).like ? l("Like") : l("Dislike"),
        placement: "bottom",
        trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: (0, $cURGa$classnames)("Ispm-SaviResponse-feedback", {
                "Ispm-SaviResponse-feedback-selected": isSelected
            }),
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                size: "small",
                kind: "saviGhost",
                dataTheme: theme ? "dark" : "light",
                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "ThumbsUp",
                    size: "large",
                    rotate: type === (0, $8ff2252602deef38$export$2a4af54e34d28b63).dislike ? "180" : "0"
                }),
                onClick: ()=>handleClick(type),
                dataTestId: "ispm-saviResponse-feedback"
            })
        })
    });
}
const $f7d3b4345fe39405$var$FeedbackActions = /*#__PURE__*/ (0, $cURGa$react).memo(({ feedback: feedback, setFeedback: setFeedback, messageId: messageId })=>{
    const [isThankyouMessage, setIsThankyouMessage] = (0, $cURGa$useState)(false);
    const [messageText, setMessageText] = (0, $cURGa$useState)("");
    const [showDislikeDetails, setShowDislikeDetails] = (0, $cURGa$useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, $cURGa$useState)(false);
    const [inputValue, setInputValue] = (0, $cURGa$useState)("");
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const handleLikeClick = ()=>{
        handleFeedback((0, $8ff2252602deef38$export$2a4af54e34d28b63).like).catch((0, $68023e09bcf60e96$export$2e2bcd8739ae039).error);
    };
    const handleDislikeClick = ()=>{
        handleFeedback((0, $8ff2252602deef38$export$2a4af54e34d28b63).dislike).catch((0, $68023e09bcf60e96$export$2e2bcd8739ae039).error);
    };
    const handleSubmitFeedback = ()=>{
        handleFeedback(undefined, inputValue).catch((0, $68023e09bcf60e96$export$2e2bcd8739ae039).error);
    };
    const handleFeedback = async (reaction, feedbackMessage)=>{
        if (!messageId) return;
        if (reaction) {
            if (feedback === reaction) {
                setFeedback(null);
                setIsThankyouMessage(false);
                setShowDislikeDetails(false);
                // API Call for Reset Feedback
                await (0, $44b5e89f372e3607$export$2e2bcd8739ae039)({
                    messageId: messageId,
                    isHelpful: false,
                    comment: "",
                    reset: true
                });
            } else {
                setFeedback(reaction);
                setIsThankyouMessage(true);
                if (reaction === (0, $8ff2252602deef38$export$2a4af54e34d28b63).like) {
                    setMessageText(l("Thank you! Your feedback has been sent."));
                    setShowDislikeDetails(false);
                    setTimeout(()=>{
                        setIsThankyouMessage(false);
                        setMessageText("");
                    }, 5000);
                    await (0, $44b5e89f372e3607$export$2e2bcd8739ae039)({
                        messageId: messageId,
                        isHelpful: true,
                        comment: "",
                        reset: false
                    });
                } else {
                    setMessageText(l("Share why this was a bad response:"));
                    setShowDislikeDetails(true);
                    await (0, $44b5e89f372e3607$export$2e2bcd8739ae039)({
                        messageId: messageId,
                        isHelpful: false,
                        comment: "",
                        reset: false
                    });
                    setTimeout(()=>{
                        setShowDislikeDetails(false);
                        setMessageText("");
                    }, 5000);
                }
            }
        } else if (feedbackMessage !== null) {
            setIsModalOpen(false);
            setMessageText(l("Thank you! Your feedback has been sent."));
            setIsThankyouMessage(true);
            setShowDislikeDetails(false);
            setTimeout(()=>{
                setIsThankyouMessage(false);
                setMessageText("");
            }, 5000);
            await (0, $44b5e89f372e3607$export$2e2bcd8739ae039)({
                messageId: messageId,
                isHelpful: false,
                comment: feedbackMessage,
                reset: false
            });
        }
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SaviResponse-feedback",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-SaviResponse-feedback-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)($f7d3b4345fe39405$var$FeedbackButton, {
                                type: (0, $8ff2252602deef38$export$2a4af54e34d28b63).like,
                                feedback: feedback,
                                handleClick: handleLikeClick
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)($f7d3b4345fe39405$var$FeedbackButton, {
                                type: (0, $8ff2252602deef38$export$2a4af54e34d28b63).dislike,
                                feedback: feedback,
                                handleClick: handleDislikeClick
                            }),
                            isThankyouMessage && /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                className: "Ispm-SaviResponse-feedback-message",
                                children: messageText
                            })
                        ]
                    }),
                    showDislikeDetails && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-SaviResponse-feedback-dislikeDetails",
                        children: [
                            Object.values($f7d3b4345fe39405$var$getFeedbackOptions(l)).map((label)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                    size: "small",
                                    kind: "outlined",
                                    label: label,
                                    onClick: async ()=>{
                                        try {
                                            await handleFeedback(undefined, label);
                                        } catch (error) {
                                            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Feedback submission failed:", error);
                                        }
                                    }
                                }, label)),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                size: "small",
                                kind: "outlined",
                                label: "More...",
                                onClick: ()=>setIsModalOpen(true)
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                type: "button",
                                kind: "ghost",
                                size: "small",
                                rightIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "Close"
                                }),
                                className: "Ispm-SaviResponse-feedback-closeButton",
                                onClick: ()=>{
                                    setFeedback(null);
                                    setIsThankyouMessage(false);
                                    setShowDislikeDetails(false);
                                    setMessageText("");
                                },
                                dataTestId: "ispm-saviResponse-feedback-closeButton"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
                onClose: ()=>setIsModalOpen(false),
                isOpen: isModalOpen,
                title: l("Give additional feedback"),
                contentBody: /*#__PURE__*/ (0, $cURGa$jsx)($f7d3b4345fe39405$var$ModalIslandBody, {
                    inputValue: inputValue,
                    setInputValue: setInputValue,
                    handleFeedback: (reaction, label)=>{
                        handleFeedback(reaction, label).catch((0, $68023e09bcf60e96$export$2e2bcd8739ae039).error);
                    }
                }),
                FooterActionBarComp: /*#__PURE__*/ (0, $cURGa$jsx)($f7d3b4345fe39405$var$FooterBar, {
                    setIsModalOpen: setIsModalOpen,
                    handleSubmit: handleSubmitFeedback
                }),
                className: "Ispm-Feedback-ModalIsland-header"
            })
        ]
    });
});
var $f7d3b4345fe39405$export$2e2bcd8739ae039 = $f7d3b4345fe39405$var$FeedbackActions;



$db31c5b0567cd1d0$export$2e2bcd8739ae039.defaultProps = {
    message: null,
    isLatestResponse: null
};
function $db31c5b0567cd1d0$export$2e2bcd8739ae039({ message: message, isLatestResponse: isLatestResponse }) {
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const [isHovered, setIsHovered] = (0, $cURGa$useState)(false);
    const [feedback, setFeedback] = (0, $cURGa$useState)(()=>{
        if (message && "feedback" in message) {
            if (!message.feedback) return null;
            return message.feedback.isHelpful ? (0, $8ff2252602deef38$export$2a4af54e34d28b63).like : (0, $8ff2252602deef38$export$2a4af54e34d28b63).dislike;
        }
        return null;
    });
    const serverMessageNodes = (0, $cURGa$useMemo)(()=>{
        if (message) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $fe145213c8c858d0$export$2e2bcd8739ae039), {
            data: "ask" in message ? message : message.data,
            isSaveToChart: "isSaveToChart" in message ? message.isSaveToChart : false
        });
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $fde1f23586659cf5$export$2e2bcd8739ae039), {});
    }, [
        message
    ]);
    let shouldRenderFeedback = false;
    if (!chatOverlayState.isApiCallInProgress && message && (message.messageId || !("ask" in message) && message.data.messageId)) {
        if (isLatestResponse || feedback !== null || isHovered) shouldRenderFeedback = true;
    }
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-SaviResponse",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                kind: "SaviCompanion",
                className: "Ispm-SaviResponse-Icon"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                "data-testid": "saviResponseTest",
                className: "Ispm-SaviResponse-Content",
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    serverMessageNodes,
                    shouldRenderFeedback ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $f7d3b4345fe39405$export$2e2bcd8739ae039), {
                        feedback: feedback,
                        setFeedback: setFeedback,
                        messageId: message && !("ask" in message) ? message.data.messageId : message?.messageId
                    }) : null
                ]
            })
        ]
    });
}



function $c4007f44ace9a6ac$export$2e2bcd8739ae039() {
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { ispmErrorState: ispmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    const { chatHistory: chatHistory = [], isLoading: isLoading } = (0, $a0e2805fb8495171$export$2e2bcd8739ae039)();
    const messagesEndRef = (0, $cURGa$useRef)(null);
    const [showScrollToBottomButton, setShowScrollToBottomButton] = (0, $cURGa$useState)(false);
    const reversedMessagesFromCurrentSession = [
        ...chatOverlayState.messages
    ].reverse();
    const showLoader = (reversedMessagesFromCurrentSession.length > 0 || chatHistory.length === 0) && isLoading;
    // Scroll to the bottom function
    const scrollToBottom = ()=>{
        if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    const handleScroll = ()=>{
        if (messagesEndRef.current) {
            const rect = messagesEndRef.current.getBoundingClientRect();
            // isVisible: Controls scroll-to-bottom button visibility based on chat bottom.
            const isDownArrowVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight - (0, $8ff2252602deef38$export$7401928161f894d4) || document.documentElement.clientHeight - (0, $8ff2252602deef38$export$7401928161f894d4)) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            setShowScrollToBottomButton(!isDownArrowVisible); // Show button when bottom is not visible
        }
    };
    // Handle scroll to bottom when button is clicked
    const handleScrollToBottom = ()=>{
        scrollToBottom();
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: (0, $cURGa$classnames)({
            "Ispm-SaviChatHistory": true,
            "Ispm-SaviChatHistory--isSplitView": chatOverlayState.showGeneratedContent,
            "Ispm-SaviChatHistory--isAlertBannerVisible": ispmErrorState.errorType === (0, $3b7091d4a3b49a26$export$55d956129a53d1d).System || Boolean(chatOverlayState.successAction)
        }),
        onScroll: handleScroll,
        "data-testid": "chatHistory",
        children: [
            showLoader && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                className: "Ispm-SaviChatHistory-loader",
                children: (0, $8ff2252602deef38$export$19c67bce64a84510).map((width, index)=>// eslint-disable-next-line react/no-array-index-key -- index needed as width is not unique
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$react).Fragment, {
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                            className: "Ispm-SaviChatHistory-loader-SkeletonLoader",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$SkeletonLoader), {
                                shape: "square",
                                animationStyle: "wave",
                                height: "1.5rem",
                                width: "100%"
                            })
                        })
                    }, `loader-${width}-${index}`))
            }),
            !showLoader && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                children: [
                    chatOverlayState.isApiCallInProgress && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SaviChatHistory-message",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $db31c5b0567cd1d0$export$2e2bcd8739ae039), {})
                    }),
                    reversedMessagesFromCurrentSession.map((message, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: (0, $cURGa$classnames)("Ispm-SaviChatHistory-message", {
                                        "Ispm-SaviChatHistory-message--isNewSaviResponse": index === 0 && !message.isUser
                                    }),
                                    children: message.isUser ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $3bb6d3cd24c272ef$export$2e2bcd8739ae039), {
                                        message: message
                                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $db31c5b0567cd1d0$export$2e2bcd8739ae039), {
                                        message: message,
                                        isLatestResponse: index === 0
                                    })
                                }),
                                message.isUser && message.isDividerRequired && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-SaviChatHistory-resetDivider",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "800",
                                        height: "2",
                                        viewBox: "0 0 800 2",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                            d: "M0 1.25391H800",
                                            stroke: "#CFD9E9",
                                            strokeLinecap: "round"
                                        })
                                    })
                                })
                            ]
                        }, message.id)),
                    chatHistory.map(({ conversationId: conversationId, messages: messages })=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-SaviChatHistory-resetDivider",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "800",
                                        height: "2",
                                        viewBox: "0 0 800 2",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                            d: "M0 1.25391H800",
                                            stroke: "#CFD9E9",
                                            strokeLinecap: "round"
                                        })
                                    })
                                }),
                                messages.map((message, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$react).Fragment, {
                                        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: (0, $cURGa$classnames)("Ispm-SaviChatHistory-message", {
                                                "Ispm-SaviChatHistory-message--isNewSaviResponse": index === 0 && !message.ask
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $3bb6d3cd24c272ef$export$2e2bcd8739ae039), {
                                                    message: message.ask
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $db31c5b0567cd1d0$export$2e2bcd8739ae039), {
                                                    message: message
                                                })
                                            ]
                                        })
                                    }, message.messageId))
                            ]
                        }, conversationId)),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SaviChatHistory--scrollToBottomRef",
                        ref: messagesEndRef
                    })
                ]
            }),
            showScrollToBottomButton && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-SaviChatHistory--scrollToBottom",
                "data-testid": "scrollToBottomButton",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                    icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "ArrowDown",
                        size: "large"
                    }),
                    onClick: handleScrollToBottom,
                    dataTestId: "ispm-scroll-to-bottom"
                })
            })
        ]
    });
}









function $12c51e736b1437e7$export$2e2bcd8739ae039() {
    // Extract ISPM and Chat Overlay states and their corresponding update functions
    const { ispmState: ispmState, updateIspmState: updateIspmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    const { chatOverlayState: chatOverlayState } = (0, $a66d5c0d230a0c38$export$d205fc98d1ecdbce)();
    const { isActiveTab: isActiveChatTab, showModal: isErrorModalVisible } = (0, $21de21e1dc30b11d$export$2e2bcd8739ae039)();
    const localize = (0, $10bf676d992f37e7$export$917bfb70a1457f2)();
    const localizeWarningId = "Ispm.Copilot.License.Warning";
    const localizeInfoId = "Ispm.Copilot.License.Half";
    const { data: copilotLicenceUsageData, isLoading: isLoading } = (0, $c1852d0a39e03ea6$export$2e2bcd8739ae039)({
        isUserQueryPresent: !!ispmState.userQuery || ispmState.isChatOverlayVisible,
        userQuery: ispmState.userQuery
    });
    const consumptionReachedLimitLabel = localize({
        id: localizeWarningId,
        defaultMessage: (0, $806e6a38034fc517$export$b8ec51749481adbb)[localizeWarningId]
    }, {
        planUsed: copilotLicenceUsageData?.data.planUsed,
        planLimit: copilotLicenceUsageData?.data.planLimit
    });
    const consumptionReachedHalfLabel = localize({
        id: localizeInfoId,
        defaultMessage: (0, $806e6a38034fc517$export$b8ec51749481adbb)[localizeInfoId]
    }, {
        planUsed: copilotLicenceUsageData?.data.planUsed,
        planLimit: copilotLicenceUsageData?.data.planLimit
    });
    const [isAlertWarningVisible, setIsAlertWarningVisible] = (0, $cURGa$useState)(false);
    const [isAlertInformationVisible, setIsAlertInformationVisible] = (0, $cURGa$useState)(false);
    const dispatch = (0, $cURGa$useDispatch)();
    const conversationId = (0, $cURGa$useSelector)((state)=>state.ispmCopilot.conversationId);
    const messageId = (0, $cURGa$useSelector)((state)=>state.ispmCopilot.messageId);
    const history = (0, $cURGa$useHistory)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // Extract the function to handle chat ask API in the chat overlay
    const { handleChatAskApiInChatOverlay: handleChatAskApiInChatOverlay } = (0, $ae1dd58e52a4b09a$export$2e2bcd8739ae039)();
    const { updateAutomatedUserMessageInSession: updateAutomatedUserMessageInSession, updateAutomatedApiResponseInSession: updateAutomatedApiResponseInSession } = (0, $f4af97ac92900bf2$export$2e2bcd8739ae039)();
    // TabletSmall breakpoint to make data panel by default full screen once open
    (0, $de50f43fd19289fe$export$2e2bcd8739ae039)(834);
    const { updateIspmErrorState: updateIspmErrorState } = (0, $4402fe0eef725aae$export$7975d440ef8e87a)();
    /**
   * useEffect hook to trigger the chat API call when the chatuuid or user query in ISPM state changes.
   *
   * @effect
   * @param {string} ispmState.chatuuid - The unique identifier for the chat session.
   * @param {string} ispmState.userQuery - The query submitted by the user.
   */ (0, $cURGa$useEffect)(()=>{
        if (!isActiveChatTab) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Current tab is not active tab. blocking api request.");
            return;
        }
        if (chatOverlayState.isApiCallInProgress) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Chat ask API in progress. blocking the api call request");
            return;
        }
        if (ispmState.userQuery.length === 0) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("User query is empty string. Blocking the api call");
            return;
        }
        // remove userQuery as call will be made below
        updateIspmState("userQuery", "");
        handleChatAskApiInChatOverlay({
            conversationId: conversationId ?? null,
            parentMessageId: messageId ?? null,
            freeText: ispmState.userQuery
        });
    }, [
        chatOverlayState.isApiCallInProgress,
        conversationId,
        handleChatAskApiInChatOverlay,
        isActiveChatTab,
        ispmState.userQuery,
        messageId,
        updateIspmState
    ]);
    /**
   * Add and entry in chat history - to tell user - context has been refresh
   *
   * @function onChatReset
   */ const handleChatReset = ()=>{
        // refresh the context
        dispatch((0, $27fb994cf82006a6$export$c532342b9f4e5a00)());
        updateIspmErrorState("errorType", undefined);
        // TODO: get confirmation from @Ashish/@Sagar
        // JIRA: https://saviyntars.atlassian.net/browse/IN-12517?focusedCommentId=1349027
        // updateChatOverlayState('inputDisabled', false);
        // updateChatOverlayState('isApiCallInProgress', false);
        updateAutomatedUserMessageInSession((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).RESET_ENTRY.userQuery, {
            isDividerRequired: true
        });
        updateAutomatedApiResponseInSession((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).RESET_ENTRY.response);
    };
    const handleChatClose = ()=>{
        updateIspmErrorState("errorType", undefined);
        updateIspmState("isChatOverlayVisible", false);
    };
    const hasCopliotLicenseUsageReachedLimit = (0, $cURGa$useMemo)(()=>(copilotLicenceUsageData?.data.planUsed ?? 0) >= Math.round((copilotLicenceUsageData?.data.planLimit ?? 0) * 0.9) && (copilotLicenceUsageData?.data.planUsed ?? 0) <= Math.round((copilotLicenceUsageData?.data.planLimit ?? 0) * 0.92), [
        copilotLicenceUsageData?.data.planLimit,
        copilotLicenceUsageData?.data.planUsed
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (!isLoading) setIsAlertWarningVisible(hasCopliotLicenseUsageReachedLimit);
    }, [
        hasCopliotLicenseUsageReachedLimit,
        isLoading
    ]);
    const hasCopliotLicenseUsageReachedHalf = (0, $cURGa$useMemo)(()=>(copilotLicenceUsageData?.data.planUsed ?? 0) === Math.round((copilotLicenceUsageData?.data.planLimit ?? 0) * 0.5), [
        copilotLicenceUsageData?.data.planLimit,
        copilotLicenceUsageData?.data.planUsed
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (!isLoading) setIsAlertInformationVisible(hasCopliotLicenseUsageReachedHalf);
    }, [
        hasCopliotLicenseUsageReachedHalf,
        isLoading
    ]);
    // render the blocking modal if this is not the active chat tab
    if (isErrorModalVisible) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        kind: "warning",
        alertTitle: l("Another Session in Progress"),
        alertSubtitle: l("Another Copilot session is open in another tab. Close this session to navigate out of Copilot and continue, or close any duplicate tabs."),
        onClose: ()=>{},
        isOpen: true,
        primaryButton: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
            type: "button",
            kind: "outlined",
            size: "medium",
            onClick: ()=>history.push("/"),
            dataTestId: "ispm-saviChatPage-closeSession",
            children: l("Close Session")
        }),
        secondaryButton: null,
        // lock down the modal
        isCloseButtonVisible: false,
        isCloseOnEscapeKeyEnabled: false,
        className: "Ispm-SaviChatPage-duplicateSessionWarningModal"
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Ispm-SaviChatPage",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $eaee16874b6f88fd$export$2e2bcd8739ae039), {
                onChatClose: handleChatClose,
                onChatReset: handleChatReset
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SaviChatPage-content",
                children: [
                    chatOverlayState.showGeneratedContent && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                        className: (0, $cURGa$classnames)({
                            "Ispm-SaviChatPage-content-dataPanel": true,
                            "Ispm-SaviChatPage-content-dataPanel--isExpanded": chatOverlayState.isDataPanelFullScreen
                        }),
                        "aria-label": l("Data panel with sql and visualization content"),
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $f2f3b08511fd9915$export$2e2bcd8739ae039), {
                            kind: chatOverlayState.contentPanelKind,
                            data: chatOverlayState.contentPanelData
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                        className: (0, $cURGa$classnames)({
                            "Ispm-SaviChatPage-content-chatpanel": true,
                            "Ispm-SaviChatPage-content-chatpanel--isSplitView": chatOverlayState.showGeneratedContent,
                            "Ispm-SaviChatPage-content-chatpanel--isSplitView--isMenuPinned": chatOverlayState.showGeneratedContent && ispmState.isMenuPinned
                        }),
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $c4007f44ace9a6ac$export$2e2bcd8739ae039), {}),
                            isAlertInformationVisible && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: (0, $cURGa$classnames)({
                                    "Ispm-SaviChatPage-alertContainer": true,
                                    "Ispm-SaviChatPage-alertContainer--isSplitView": chatOverlayState.showGeneratedContent
                                }),
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $31e402a3522b1407$export$2e2bcd8739ae039), {
                                    isVisible: isAlertInformationVisible,
                                    type: "info",
                                    description: consumptionReachedHalfLabel
                                })
                            }),
                            isAlertWarningVisible && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: (0, $cURGa$classnames)({
                                    "Ispm-SaviChatPage-alertContainer": true,
                                    "Ispm-SaviChatPage-alertContainer--isSplitView": chatOverlayState.showGeneratedContent
                                }),
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $31e402a3522b1407$export$2e2bcd8739ae039), {
                                    isVisible: isAlertWarningVisible,
                                    type: "warning",
                                    description: consumptionReachedLimitLabel,
                                    actions: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                        type: "button",
                                        kind: "ghost",
                                        size: "small",
                                        onClick: ()=>{
                                            setIsAlertWarningVisible(false);
                                        },
                                        dataTestId: "ispm-dismiss-usage-alert",
                                        children: l("Dismiss")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $f71a65f4e8b7a728$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * IspmDashboard Component
 *
 * This component renders the ISP Management Dashboard that includes:
 * - A header with dashboard title and theme toggle.
 * - An analytics section.
 * - Main content sections for recommendations, security posture, and low-trust detection.
 * - A tabs section for switching between posture insights (Access and Certifications).
 *
 * ESLint rules have been taken into consideration, and all functions include JSDoc comments.
 */ 






const $31415264ab98c97b$export$1a517009088eb7d6 = [
    {
        title: "Firefighter Roles with Unlimited Validity",
        startColor: "#0294F7",
        endColor: "#F25A00",
        shadow: "#F25A00"
    },
    {
        title: "Orphan Accounts",
        startColor: "#0294F7",
        endColor: "#01AE66",
        shadow: "#01AE66"
    },
    {
        title: "Orphan Service Accounts",
        startColor: "#0294F7",
        endColor: "#F25A00",
        shadow: "#F25A00"
    },
    {
        title: "Terminated Users with Active Access",
        startColor: "#0294F7",
        endColor: "#01AE66",
        shadow: "#01AE66"
    },
    {
        title: "Duplicate Identities",
        startColor: "#0294F7",
        endColor: "#01AE66",
        shadow: "#01AE66"
    },
    {
        title: "Roles with Missing Owners",
        startColor: "#0294F7",
        endColor: "#01AE66",
        shadow: "#01AE66"
    }
];
function $31415264ab98c97b$var$convertDaysPhrase(input) {
    const regex = /^last (\d+) days?$/i; // Matches "last X day" or "last X days"
    const match = input.match(regex);
    if (match) {
        const days = parseInt(match[1], 10);
        const messages = {
            1: "Since Yesterday",
            7: "Since Last Week"
        };
        return messages[days] || (days >= 30 ? "Since Last Month" : `Since ${days} days`);
    }
    // Return input unchanged if it doesn't match the pattern
    return input;
}
const $31415264ab98c97b$export$c5003b59551efc0f = (start, end)=>{
    const diffInMs = end - start;
    const diffInDays = Math.floor(diffInMs / 86400000) + 1;
    return $31415264ab98c97b$var$convertDaysPhrase(`last ${diffInDays} day${diffInDays > 1 ? "s" : ""}`);
};
const $31415264ab98c97b$export$9822e799bcba6669 = (widgetData)=>{
    const sortedData = widgetData.sort((a, b)=>b.timestamp - a.timestamp);
    const widgetMap = {};
    sortedData.forEach((entry)=>{
        const date = new Date(entry.timestamp).toISOString().split("T")[0];
        Object.entries(entry).forEach(([key, value])=>{
            if (key === "timestamp") return;
            if (!widgetMap[key]) widgetMap[key] = {
                title: key,
                value: 0,
                change: 0,
                history: [],
                dateRange: ""
            };
            widgetMap[key].history.push({
                x: date,
                y: value
            });
            if (!widgetMap[key].value) widgetMap[key].value = value; // Set the latest day value
        });
    });
    Object.values(widgetMap).forEach((widget)=>{
        const dates = widget.history.map((obj)=>new Date(obj.x).getTime());
        const oldestDate = Math.min(...dates);
        const latestDate = Math.max(...dates);
        const latestValue = widget.history.find((entry)=>new Date(entry.x).toISOString().split("T")[0] === new Date(latestDate).toISOString().split("T")[0])?.y;
        const oldestValue = widget.history.find((entry)=>new Date(entry.x).toISOString().split("T")[0] === new Date(oldestDate).toISOString().split("T")[0])?.y;
        if (latestValue && oldestValue) // eslint-disable-next-line no-param-reassign
        widget.change = parseFloat(((latestValue - oldestValue) / oldestValue * 100 || 0).toFixed(1));
        // eslint-disable-next-line no-param-reassign
        widget.dateRange = $31415264ab98c97b$export$c5003b59551efc0f(oldestDate, latestDate);
    });
    return Object.values(widgetMap);
};
const $31415264ab98c97b$export$94ff436332796f1f = (latest = 0, oldest = 0, decimalPoint = 1)=>{
    if (latest === 0 && oldest === 0) return 0;
    if (latest > 0 && oldest === 0) return 100;
    // Calculate the percentage change
    const percentageChange = (latest - oldest) / Math.abs(oldest) * 100;
    // Round to 2 decimal places and return as a number
    return Number(percentageChange.toFixed(decimalPoint));
};
const $31415264ab98c97b$export$2225f83a32dd2a64 = (InsightAnalyticsData)=>{
    const sortedData = InsightAnalyticsData.data.sort((a, b)=>b.timestamp - a.timestamp);
    const finalData = {};
    Object.entries(sortedData[0]).forEach(([key, value])=>{
        if (key === "timestamp") return;
         // Skip the timestamp key
        // Ensure the key exists in both sortedData[0] and sortedData[1]
        if (key in sortedData[1]) {
            const currentValue = value;
            const previousValue = sortedData[1][key];
            finalData[key] = {
                count: currentValue,
                momChange: currentValue - previousValue,
                perMomChange: $31415264ab98c97b$export$94ff436332796f1f(currentValue, previousValue, 5)
            };
        }
    });
    return finalData;
};
const $31415264ab98c97b$export$704e01e8cfc6ba8a = (insightsData)=>{
    const widgetOrder = [
        "Identities",
        "Accounts",
        "Entitlements",
        "Roles",
        "Resources"
    ];
    const sortedInsights = Object.entries(insightsData).sort(([keyA], [keyB])=>{
        const indexA = widgetOrder.indexOf(keyA.charAt(0).toUpperCase() + keyA.slice(1));
        const indexB = widgetOrder.indexOf(keyB.charAt(0).toUpperCase() + keyB.slice(1));
        return (indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA) - (indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB);
    });
    return sortedInsights;
};
const $31415264ab98c97b$export$8c0273a111847579 = [
    {
        value: 1,
        label: "IGA",
        disabled: false
    },
    {
        value: 2,
        label: "AAG",
        disabled: true
    },
    {
        value: 3,
        label: "PAM",
        disabled: true
    },
    {
        value: 4,
        label: "External",
        disabled: true
    },
    {
        value: 5,
        label: "NHI",
        disabled: true
    }
];
const $31415264ab98c97b$export$6025e095d3a5b8e = [
    {
        value: 1,
        type: "access",
        label: "Access & Data",
        disabled: false,
        tooltipText: "Advanced tier feature"
    },
    {
        value: 2,
        type: "governance",
        label: "Governance",
        disabled: false,
        tooltipText: "Advanced tier feature"
    }
];
const $31415264ab98c97b$export$18e2284b0212a9ee = (width)=>{
    // width for chart in rem
    if (width < 900) return 12;
    if (width < 1100) return 15;
    if (width < 1250) return 20;
    if (width < 1350) return 23;
    if (width < 1450) return 25;
    return 27;
};
const $31415264ab98c97b$export$f1165a238165ad91 = 4;
const $31415264ab98c97b$export$d133d6e26bb0f6fe = {
    IGA: {
        icon: "Account",
        fillColor: "--color-foreground-blue-medium"
    },
    PAM: {
        icon: "PrivilgedAccess",
        fillColor: "--color-data-teal-medium"
    },
    AAG: {
        icon: "SOD",
        fillColor: "--color-data-purple-medium"
    }
};
const $31415264ab98c97b$export$a774e6d73f253a89 = [
    "3 Days",
    "1 Week",
    "2 Weeks",
    "1 Month",
    "zeroCampaigns"
];
const $31415264ab98c97b$export$4b55535b14b833ae = [
    "#0294F7",
    "#D057FF",
    "#FC3DA6",
    "#00A3A9",
    "#5C5E6E"
];
const $31415264ab98c97b$export$a2c0215fc34a08c3 = [
    "days",
    "week",
    "weeks",
    "month"
];
const $31415264ab98c97b$export$d09912a30ccb7d65 = {
    Range1: "#0294F7",
    Range2: "#D057FF",
    Range3: "#FC3DA6",
    Range4: "#FFA4D2"
};
const $31415264ab98c97b$export$5254969b1129ce7e = (l)=>({
        90: {
            range: l("90 Days +"),
            borderClass: "borderBlueMedium",
            mapping: "Range1"
        },
        120: {
            range: l("120 Days +"),
            borderClass: "borderPurpleMedium",
            mapping: "Range2"
        },
        180: {
            range: l("Over 6 months"),
            borderClass: "borderPinkMedium",
            mapping: "Range3"
        },
        270: {
            range: l("Over 9 months"),
            borderClass: "borderPinkBold",
            mapping: "Range4"
        }
    });
const $31415264ab98c97b$export$a4c54d344edf09d8 = {
    revocationsProcessing: "#0294F7",
    revocationsFailed: "#D057FF",
    revocationsCompleted: "#FC3DA6",
    totalCertsPreview: "#FC3DA6",
    totalCertsNew: "#0294F7",
    totalCertsInProgress: "#D057FF",
    totalCertsComplete: "#01AE66",
    totalCertsLocked: "#E19701",
    totalCertsDiscontinued: "#00A3A9",
    totalCertsExpired: "#FF4451",
    totalCertifiedEntitlements: "#0294F7",
    totalRevokedEntitlements: "#D057FF",
    totalUndecidedEntitlements: "#FC3DA6",
    totalApprovedRecentlyButRevokedEntitlements: "#F25A00",
    totalBirthrightGrantedRevokedEntitlements: "#FF4451",
    totalTrustScoreOverruledEntitlements: "#00A3A9",
    zeroCampaigns: "#5C5E6E"
};
const $31415264ab98c97b$export$827b953b70c0e9f = {
    revocationsProcessing: "Processing",
    revocationsFailed: "Failed",
    revocationsCompleted: "Completed",
    totalCertsPreview: "Preview",
    totalCertsNew: "New",
    totalCertsInProgress: "In Progress",
    totalCertsComplete: "Complete",
    totalCertsLocked: "Locked",
    totalCertsDiscontinued: "Discontinued",
    totalCertsExpired: "Expired",
    totalCertifiedEntitlements: "Certified",
    totalRevokedEntitlements: "Revokes",
    totalUndecidedEntitlements: "Undecided",
    totalApprovedRecentlyButRevokedEntitlements: "Approved recently but revoked",
    totalBirthrightGrantedRevokedEntitlements: "Granted via birthright but revoked",
    totalTrustScoreOverruledEntitlements: "Trust Score overruled"
};
const $31415264ab98c97b$export$17382f8e98d727e7 = [
    "revocationsProcessing",
    "revocationsFailed",
    "revocationsCompleted"
];
const $31415264ab98c97b$export$c3e0f520a0aee8fc = (numerator, denominator)=>{
    if (denominator === 0) return "0";
    const percentage = numerator / denominator * 100;
    return percentage === 0 ? "0" : `${parseFloat(percentage.toFixed(1))}`;
};
const $31415264ab98c97b$export$5eb0c58c8af5c758 = "Access & Data";
const $31415264ab98c97b$export$282a633f41834647 = "Governance";
const $31415264ab98c97b$export$8de1f5d0f7d1b88e = {
    COLOR: {
        SUCCESS: "success",
        WARNING: "warning",
        CRITICAL: "critical"
    },
    KIND: {
        HAPPY: "happy",
        NEUTRAL: "neutral",
        SAD: "sad"
    },
    CLASSIFICATION: {
        HIGH: "High",
        MEDIUM: "Medium",
        LOW: "Low"
    }
};
const $31415264ab98c97b$export$7a810838d74c869b = {
    CERTIFIERS: "Certifiers",
    USER_BASE: "User Base",
    ACCOUNTS: "Accounts",
    APPLICATIONS: "Applications"
};
const $31415264ab98c97b$export$1afcf11a27cbbadc = [
    "totalCertsPreview",
    "totalCertsNew",
    "totalCertsInProgress",
    "totalCertsComplete",
    "totalCertsLocked",
    "totalCertsDiscontinued",
    "totalCertsExpired"
];
const $31415264ab98c97b$export$cc622da8d324ace1 = [
    "totalCertifiedEntitlements",
    "totalRevokedEntitlements",
    "totalUndecidedEntitlements",
    "totalApprovedRecentlyButRevokedEntitlements",
    "totalBirthrightGrantedRevokedEntitlements",
    "totalTrustScoreOverruledEntitlements"
];


// Import necessary modules and types



/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $8eed8d52bacd30af$var$isValidGovernanceInsightsAccessApiResponse(response) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    // Ensure response is an object and contains "data"
    if (!response || typeof response !== "object" || !("data" in response) || typeof response.data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'data' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $8eed8d52bacd30af$var$getGovernanceInsightsAccessData = async ()=>{
    const { GOVERNANCE_INSIGHTS_ACCESS_ENDPOINT: GOVERNANCE_INSIGHTS_ACCESS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const url = GOVERNANCE_INSIGHTS_ACCESS_ENDPOINT;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $8eed8d52bacd30af$var$isValidGovernanceInsightsAccessApiResponse);
    return response.data;
};
var $8eed8d52bacd30af$export$2e2bcd8739ae039 = $8eed8d52bacd30af$var$getGovernanceInsightsAccessData;





/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $02ac53dc2b8d29b0$var$isValidGovernanceInsightsCertsApiResponse(response) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    // Ensure response is an object and contains "data"
    if (!response || typeof response !== "object" || !("data" in response) || typeof response.data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'data' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $02ac53dc2b8d29b0$var$getGovernanceInsightsCertificationsData = async ()=>{
    const { GOVERNANCE_INSIGHTS_CERTS_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const url = GOVERNANCE_INSIGHTS_CERTS_ENDPOINT;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $02ac53dc2b8d29b0$var$isValidGovernanceInsightsCertsApiResponse);
    return response.data;
};
var $02ac53dc2b8d29b0$export$2e2bcd8739ae039 = $02ac53dc2b8d29b0$var$getGovernanceInsightsCertificationsData;





function $729b4864e9e64106$var$isRecommendationsResponse(data) {
    return typeof data === "object" && data !== null && "value" in data && Array.isArray(data.value) && data.value?.every((item)=>typeof item === "object" && typeof item.displayText === "string" && typeof item.id === "string") || false;
}
// Function to fetch OOTB Recommendations
const $729b4864e9e64106$export$358779cacf74ee7a = async ()=>{
    const { RECOMMENDATIONS_ENDPOINT: RECOMMENDATIONS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(RECOMMENDATIONS_ENDPOINT, config, $729b4864e9e64106$var$isRecommendationsResponse);
    return response;
};
function $729b4864e9e64106$var$isRecommendationsReviewData(data) {
    return typeof data === "object" && data !== null && "data" in data && typeof data.data === "object" && data.data !== null && "tableTitle" in data.data && "controlUrl" in data.data && typeof data.data.tableTitle === "string" && typeof data.data.controlUrl === "string";
}
const $729b4864e9e64106$export$7d424e5ae7ed4e5e = async (id)=>{
    const { RECOMMENDATIONS_ENDPOINT: RECOMMENDATIONS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        timeout: 30000
    };
    const url = `${RECOMMENDATIONS_ENDPOINT}/${id.toString()}`;
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $729b4864e9e64106$var$isRecommendationsReviewData);
    return response.data;
};
function $729b4864e9e64106$var$isIdentityInsightsResponse(data) {
    return typeof data === "object" && data !== null && "data" in data && Array.isArray(data.data) && data.data.every((item)=>typeof item === "object" && typeof item.totalOrphanAccounts === "number" && typeof item.totalRolesWithMissingOwners === "number" && typeof item.totalFirefighterRolesWithUnlimitedValidity === "number" && typeof item.totalOrphanServiceAccounts === "number" && typeof item.totalActiveUsersWithInactiveManagers === "number" && typeof item.totalMissingEntitlementDescriptions === "number" && typeof item.timestamp === "number");
}
const $729b4864e9e64106$export$48d4b7895fcdd44f = async ()=>{
    const { IDENTITY_INSIGHTS_ENDPOINT: IDENTITY_INSIGHTS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(IDENTITY_INSIGHTS_ENDPOINT, config, $729b4864e9e64106$var$isIdentityInsightsResponse);
    const transformedWidgets = (0, $31415264ab98c97b$export$9822e799bcba6669)(response.data);
    return transformedWidgets;
};
function $729b4864e9e64106$var$isIdentityAnalyticsResponse(data) {
    return typeof data === "object" && data !== null && "data" in data;
}
const $729b4864e9e64106$export$35461ef3f287074e = async ()=>{
    const { INSIGHTS_AND_ANALYTICS_ENDPOINT: INSIGHTS_AND_ANALYTICS_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(INSIGHTS_AND_ANALYTICS_ENDPOINT, config, $729b4864e9e64106$var$isIdentityAnalyticsResponse);
    const transformedInsightsAnalyticsData = (0, $31415264ab98c97b$export$2225f83a32dd2a64)(response);
    return transformedInsightsAnalyticsData;
};




function $2397e057d0b2ea6b$var$isInsightsIgaResponse(data) {
    if (typeof data !== "object" || data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("API Response Validation Failed: Data is not an object or is null");
        return false;
    }
    const response = data;
    // Check if "data" key exists and is an object
    if (!response.data) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error('API Response Validation Failed: "data" key missing or not an object');
        return false;
    }
    // Validate "data" as an array
    if (!Array.isArray(response.data)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error('API Response Validation Failed: "data" should be an array');
        return false;
    }
    // Validate each insightIgaItem object
    const identityErrors = response.data.some((insightIgaItem, index)=>{
        if (typeof insightIgaItem.id !== "string" || typeof insightIgaItem.title !== "string") {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`API Response Validation Failed: Id should be of type number ${index}`, insightIgaItem);
            return true;
        }
        if (typeof insightIgaItem.title !== "string" || typeof insightIgaItem.value !== "string" || !Array.isArray(insightIgaItem.timeSeriesData)) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn(`API Response Validation Failed: Invalid structure in identity at index ${index}`, insightIgaItem);
        return false;
    });
    if (identityErrors) return false;
    return true;
}
const $2397e057d0b2ea6b$var$getIgaInsights = async ()=>{
    const { INSIGHTS_IGA_TAB: INSIGHTS_IGA_TAB } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const url = INSIGHTS_IGA_TAB;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $2397e057d0b2ea6b$var$isInsightsIgaResponse);
    return response;
};
var $2397e057d0b2ea6b$export$2e2bcd8739ae039 = $2397e057d0b2ea6b$var$getIgaInsights;








/**
 * A custom hook for fetching data using @tanstack/react-query.
 *
 * @template T - The type returned by the API call.
 * @template P - A tuple type representing the parameters for the API function.
 *
 * @param fetchFunction - The API function that returns a promise.
 * @param params - Parameters to be passed to the API function. Defaults to an empty array.
 * @param shouldCache - When true, the response is cached. Defaults to false.
 * @param cacheKeys - Additional keys used for caching.
 * @returns An object containing the fetched data, loading state, error, and a refetch function.
 */ const $50df23daac590f34$var$useTanstackApiQuery = (fetchFunction, params = [], shouldCache = false, cacheKeys = [])=>{
    // Memoize the query key to avoid unnecessary recomputation
    const queryKey = (0, $cURGa$useMemo)(()=>[
            fetchFunction.name,
            ...params,
            ...cacheKeys
        ], [
        fetchFunction.name,
        params,
        cacheKeys
    ]);
    // Memoize the query options
    const queryOptions = (0, $cURGa$useMemo)(()=>{
        if (shouldCache) return {
            cacheTime: (0, $8ff2252602deef38$export$6d85febd8168744c),
            staleTime: (0, $8ff2252602deef38$export$8fec9643a87f15ca)
        };
        return {
            cacheTime: 0,
            staleTime: 0
        };
    }, [
        shouldCache
    ]);
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $cURGa$useQuery)({
        queryKey: queryKey,
        queryFn: async ()=>{
            try {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("useFetch - Fetching data", {
                    functionName: fetchFunction.name,
                    params: params
                });
                const result = await fetchFunction(...params);
                return result;
            } catch (err) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("useFetch - Error fetching data", {
                    error: err,
                    functionName: fetchFunction.name,
                    params: params
                });
                throw err;
            }
        },
        ...queryOptions,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        refetch: refetch
    };
};
var $50df23daac590f34$export$2e2bcd8739ae039 = $50df23daac590f34$var$useTanstackApiQuery;


const $3ac793aa418a359a$export$788b091f1602dba3 = ()=>{
    // Use the custom `useFetch` hook to call the `getInsightsAndAnalytics` API function.
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $729b4864e9e64106$export$35461ef3f287074e), [] // No additional parameters are passed for this API call
    );
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $3ac793aa418a359a$export$9e04cd9a8ab60f8e = ()=>{
    // Use the custom `useFetch` hook to call the `getInsightsAndAnalytics` API function.
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $729b4864e9e64106$export$358779cacf74ee7a), [] // No additional parameters are passed for this API call
    );
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $3ac793aa418a359a$export$df2883877f8bfced = (id)=>{
    const validId = id ?? ""; // Ensure it's always a string
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(()=>validId ? (0, $729b4864e9e64106$export$7d424e5ae7ed4e5e)(validId) : Promise.resolve({}), [
        validId
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $3ac793aa418a359a$export$5040aa8ad7d6a1b7 = ()=>{
    // Use the custom `useFetch` hook to call the `getInsightsAndAnalytics` API function.
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $2397e057d0b2ea6b$export$2e2bcd8739ae039), [] // No additional parameters are passed for this API call
    );
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $3ac793aa418a359a$export$11181267b7052d14 = ()=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $50df23daac590f34$export$2e2bcd8739ae039)((0, $02ac53dc2b8d29b0$export$2e2bcd8739ae039), [], true, [
        ...(0, $e95e1a5b1863583b$export$2e2bcd8739ae039).governanceInsightsCertsKeys()
    ] // Call the function to get the key tuple
    );
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $3ac793aa418a359a$export$43ddd7fc79c95e7 = ()=>{
    // Use the custom `useFetch` hook to call the `getInsightsAndAnalytics` API function.
    const { data: data, isLoading: isLoading, error: error } = (0, $50df23daac590f34$export$2e2bcd8739ae039)((0, $8eed8d52bacd30af$export$2e2bcd8739ae039), [], true, [
        ...(0, $e95e1a5b1863583b$export$2e2bcd8739ae039).governanceInsightsAccessKeys()
    ]);
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};









function $5aaf565c175c9bcd$var$CockpitTileItem({ keyProp: keyProp, value: value }) {
    const history = (0, $cURGa$useHistory)();
    const { perMomChange: perMomChange, count: count, momChange: momChange } = value;
    const getChangeClassName = ()=>perMomChange === 0 ? "zeroChange" : "nonZeroChange";
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-InsightAndAnalytics-WidgetsItem",
        id: keyProp,
        role: "button",
        tabIndex: 0,
        style: {
            cursor: keyProp === "identities" ? "pointer" : "default"
        },
        onKeyDown: (event)=>{
            if ((event.key === "Enter" || event.key === " ") && keyProp === "identities") history.push((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES);
        },
        onClick: ()=>{
            if (keyProp === "identities") history.push((0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES);
        },
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-InsightAndAnalytics-WidgetsItem-textWithSubtext",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-InsightAndAnalytics-WidgetsItem-insightValue",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            className: "Ispm-InsightAndAnalytics-WidgetsItem-insightValue-tooltip",
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-InsightAndAnalytics-WidgetsItem-text",
                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(count ?? 0)
                            }),
                            text: `${count?.toLocaleString() || 0}`,
                            placement: "top",
                            isDisabled: !count
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-InsightAndAnalytics-WidgetsItem-subText",
                            "data-testid": "widget-text",
                            children: keyProp.charAt(0).toUpperCase() + keyProp.slice(1)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-InsightAndAnalytics-WidgetsItem-potentialRisk",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            className: "Ispm-InsightAndAnalytics-WidgetsItem-potentialRisk-tooltip",
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                className: `Ispm-InsightAndAnalytics-WidgetsItem-insightNumberValue ${getChangeClassName()}`,
                                children: (0, $8ff2252602deef38$export$278437eb5dd4122c)(perMomChange)
                            }),
                            text: `${Math.abs(perMomChange) && Math.abs(perMomChange) < 0.1 ? `${Math.abs(perMomChange)}% (${Math.abs(momChange ?? 0)})` : Math.abs(momChange ?? 0)}`,
                            placement: "top",
                            isDisabled: !momChange
                        }),
                        perMomChange !== 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-InsightAndAnalytics-WidgetsItem-widgetIcons",
                            children: perMomChange > 0 ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "TrendUp",
                                size: "xxSmall"
                            }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "TrendDown",
                                size: "xxSmall"
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                            className: `Ispm-InsightAndAnalytics-WidgetsItem-riskPotentialValue ${getChangeClassName()}`,
                            children: "MoM"
                        })
                    ]
                })
            ]
        })
    }, keyProp);
}
var $5aaf565c175c9bcd$export$2e2bcd8739ae039 = $5aaf565c175c9bcd$var$CockpitTileItem;



function $4880d7c2b4a903d4$var$InsightAndAnalytics() {
    const { data: insightsData = {} } = (0, $3ac793aa418a359a$export$788b091f1602dba3)();
    const sortedInsights = (0, $cURGa$useMemo)(()=>{
        if (insightsData) return (0, $31415264ab98c97b$export$704e01e8cfc6ba8a)(insightsData);
        return [];
    }, [
        insightsData
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-InsightAndAnalytics",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: "Ispm-InsightAndAnalytics-Widgets",
            children: sortedInsights.map(([key, value])=>{
                const isIdentities = key === "identities";
                return isIdentities ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-InsightAndAnalytics-Wrapper",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $5aaf565c175c9bcd$export$2e2bcd8739ae039), {
                        keyProp: key,
                        value: value
                    })
                }, key) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                    className: "Ispm-InsightAndAnalytics-comingSoon-tooltip",
                    text: "Feature coming soon. If you\u2019d like to view more information, please visit the Identity Repository.",
                    placement: "bottom",
                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-InsightAndAnalytics-Wrapper",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $5aaf565c175c9bcd$export$2e2bcd8739ae039), {
                            keyProp: key,
                            value: value
                        })
                    })
                }, key);
            })
        })
    });
}
var $4880d7c2b4a903d4$export$2e2bcd8739ae039 = $4880d7c2b4a903d4$var$InsightAndAnalytics;















function $72d4b5f37be62507$var$DashboardDataError() {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
        className: "Ispm-DashboardDataError",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                kind: "StopProcess",
                size: "xxLarge",
                color: "--color-foreground-critical-medium"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                color: "--color-foreground-critical-medium",
                className: "Ispm-Insights-Iga-Error-Content-Text",
                children: l("Data couldn\u2019t be retrieved.")
            })
        ]
    });
}
var $72d4b5f37be62507$export$2e2bcd8739ae039 = $72d4b5f37be62507$var$DashboardDataError;


















function $e7b7d9445a7db430$var$PercentageChange({ timeSeriesData: timeSeriesData }) {
    timeSeriesData.sort((a, b)=>a.timestamp - b.timestamp);
    const firstDay = timeSeriesData[0].value;
    const lastDay = timeSeriesData[timeSeriesData.length - 1].value;
    const percentageChange = (0, $31415264ab98c97b$export$94ff436332796f1f)(lastDay, firstDay);
    const isPositive = Number(percentageChange) > 0;
    const isZero = Number(percentageChange) === 0;
    const getSignChangeClass = ()=>{
        if (isZero) return "noChange";
        if (isPositive) return "positive";
        return "negative";
    };
    const percentageChangeContainerClass = (0, $cURGa$classnames)("Insights-Percentage-Change", getSignChangeClass());
    return /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
        className: percentageChangeContainerClass,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                className: "Insights-Percentage-Change-Number",
                children: [
                    `${(0, $8ff2252602deef38$export$163141b91a9d3a48)(Number(percentageChange))}${percentageChange}`,
                    "%"
                ]
            }),
            !isZero && /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                className: "Insights-Percentage-Change-Icon",
                children: isPositive ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "TrendUp",
                    size: "xSmall",
                    color: "--color-foreground-orange-medium"
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "TrendDown",
                    size: "xSmall",
                    color: "--color-foreground-green-medium"
                })
            })
        ]
    });
}
var $e7b7d9445a7db430$export$2e2bcd8739ae039 = $e7b7d9445a7db430$var$PercentageChange;



function $83b1b78c3327dc02$var$ActiveAndInactiveUserManagers({ activeUsersWithInactiveManagersData: activeUsersWithInactiveManagersData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { activeUsers: activeUsers, inactiveMangers: inactiveMangers } = activeUsersWithInactiveManagersData;
    if (!activeUsers || !Array.isArray(activeUsers.timeSeriesData) || activeUsers.timeSeriesData.length === 0 || !inactiveMangers || !Array.isArray(inactiveMangers.timeSeriesData) || inactiveMangers.timeSeriesData.length === 0) return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-ActiveUsersWithInactiveManagers",
        dataTestId: "ispm-dashboard-activeUsersWithInactiveManagers",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                    kind: "h3",
                    lineLimit: 1,
                    color: "--color-foreground-secondary-bold",
                    className: "Ispm-ActiveUsersWithInactiveManagers-header",
                    children: [
                        activeUsersWithInactiveManagersData.title || l("Active Users with Inactive Managers"),
                        "\xa0",
                        `(${l("Last 30 Days")})`
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-ActiveUsersWithInactiveManagers",
        dataTestId: "ispm-dashboard-activeUsersWithInactiveManagers",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                    kind: "h3",
                    lineLimit: 1,
                    color: "--color-foreground-secondary-bold",
                    className: "Ispm-ActiveUsersWithInactiveManagers-header",
                    children: [
                        activeUsersWithInactiveManagersData.title || l("Active Users with Inactive Managers"),
                        " ",
                        "\xa0",
                        `(${l("Last 30 Days")})`
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-ActiveUsersWithInactiveManagers-activeManagersItems",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-ActiveUsersWithInactiveManagers-activeManagers",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: "Ispm-ActiveUsersWithInactiveManagers-activeManagersValues",
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "display4",
                                            color: "--color-foreground-secondary-bold",
                                            className: "Ispm-ActiveUsersWithInactiveManagers-activeManagersUserValues",
                                            children: activeUsers.value ? (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(activeUsers.value) : 0
                                        }),
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                            timeSeriesData: activeUsers.timeSeriesData
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    color: "--color-foreground-neutral-subtle",
                                    className: "Ispm-ActiveUsersWithInactiveManagers-activeManagersHeader",
                                    children: activeUsersWithInactiveManagersData.activeUsers?.title || l("Active Users")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-ActiveUsersWithInactiveManagers-inactiveItems",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    color: "--color-foreground-secondary-medium",
                                    className: "Ispm-ActiveUsersWithInactiveManagers-activeReportTo",
                                    children: [
                                        " ",
                                        l("Report to")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-ActiveUsersWithInactiveManagers-activeManagerIcons",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "ArrowRight",
                                        size: "medium",
                                        color: "--color-foreground-secondary-medium"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-ActiveUsersWithInactiveManagers-InactiveManagersItems",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: "Ispm-ActiveUsersWithInactiveManagers-InactiveManagers",
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "display4",
                                            color: "--color-foreground-secondary-bold",
                                            className: "Ispm-ActiveUsersWithInactiveManagers-InactiveManagersValue",
                                            children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(inactiveMangers.value)
                                        }),
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                            timeSeriesData: inactiveMangers.timeSeriesData
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    color: "--color-foreground-neutral-subtle",
                                    className: "Ispm-ActiveUsersWithInactiveManagers-InactiveManagersDate",
                                    children: activeUsersWithInactiveManagersData.inactiveMangers?.title || l("Inactive Managers")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $83b1b78c3327dc02$export$2e2bcd8739ae039 = $83b1b78c3327dc02$var$ActiveAndInactiveUserManagers;









function $074a3236c52fafae$var$Chart({ spec: spec }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$VegaLite), {
        spec: spec,
        actions: false,
        renderer: "svg"
    });
}
var $074a3236c52fafae$export$2e2bcd8739ae039 = $074a3236c52fafae$var$Chart;










const $2637c374a626a456$var$getDormatAccountsDonutChartSpec = ({ expiringDormatAccounts: expiringDormatAccounts, data: data })=>({
        autosize: {
            type: "fit",
            contains: "padding"
        },
        background: "transparent",
        width: 136,
        height: 136,
        data: {
            values: data
        },
        layer: [
            {
                // Donut chart layer with custom colors
                mark: {
                    type: "arc",
                    innerRadius: 55
                },
                encoding: {
                    theta: {
                        field: "value",
                        type: "quantitative"
                    },
                    color: {
                        field: "category",
                        type: "nominal",
                        scale: {
                            domain: data.map((obj)=>obj.category),
                            range: data.map((obj)=>(0, $31415264ab98c97b$export$d09912a30ccb7d65)[obj.range])
                        },
                        legend: null
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    dy: 0
                },
                encoding: {
                    text: {
                        value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(expiringDormatAccounts)
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    dy: 15
                },
                encoding: {
                    text: {
                        value: "Accounts"
                    }
                }
            }
        ],
        view: {
            stroke: null
        }
    });
var $2637c374a626a456$export$2e2bcd8739ae039 = $2637c374a626a456$var$getDormatAccountsDonutChartSpec;



function $a2f6ac8d454d9e11$var$DormatAccounts({ dormatAccountsData: dormatAccountsData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const dormatAccountMappings = (0, $31415264ab98c97b$export$5254969b1129ce7e)(l);
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-DormatAccounts",
        dataTestId: "ispm-dashboard-dormatAccounts",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h1",
                    color: "--color-foreground-secondary-bold",
                    className: "Ispm-DormatAccounts-header",
                    children: l("Dormant Accounts")
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                className: "Ispm-DormatAccounts-body",
                children: dormatAccountsData.dormantAccountsTimeSeriesData.length > 0 ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-DormatAccounts-body-stats",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: "Ispm-DormatAccounts-body-stats-counts",
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "display4",
                                            color: "--color-foreground-neutral-bold",
                                            className: "Ispm-DormatAccounts-body-stats-counts-dormantValue",
                                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                                timeSeriesData: dormatAccountsData.dormantAccountsTimeSeriesData
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "body1",
                                            color: "--color-foreground-neutral-subtle",
                                            children: l("Last 30 days")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-DormatAccounts-body-stats-chart",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $074a3236c52fafae$export$2e2bcd8739ae039), {
                                        spec: (0, $2637c374a626a456$export$2e2bcd8739ae039)({
                                            expiringDormatAccounts: dormatAccountsData.dormantAccountsCount,
                                            data: dormatAccountsData.inactivityTimeSeriesData.map((obj)=>({
                                                    category: dormatAccountMappings[obj.days].range,
                                                    value: obj.value,
                                                    range: dormatAccountMappings[obj.days].mapping
                                                }))
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-DormatAccounts-body-inactivity",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body1",
                                    color: "--color-foreground-neutral-medium",
                                    children: l("INACTIVITY")
                                }),
                                dormatAccountsData.inactivityTimeSeriesData.map((inactiveRow)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: `Ispm-DormatAccounts-body-inactivity-row ${dormatAccountMappings[inactiveRow.days].borderClass}`,
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                className: "Ispm-DormatAccounts-body-inactivity-row-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body1",
                                                        color: "--color-foreground-neutral-bold",
                                                        children: dormatAccountMappings[inactiveRow.days].range
                                                    }),
                                                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                        kind: "body3",
                                                        color: "--color-foreground-secondary-medium",
                                                        children: [
                                                            (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(inactiveRow.value),
                                                            " ",
                                                            l("Accounts")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                kind: "h1",
                                                color: "--color-foreground-neutral-bold",
                                                children: [
                                                    (0, $31415264ab98c97b$export$c3e0f520a0aee8fc)(inactiveRow.value, dormatAccountsData.dormantAccountsCount),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }))
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $a2f6ac8d454d9e11$export$2e2bcd8739ae039 = $a2f6ac8d454d9e11$var$DormatAccounts;











// Function Declaration Style for React Functional Component
function $6b99f2ae49f6545c$var$OrphanAccountCard({ title: title, value: value, timeSeriesData: timeSeriesData, subtitle: subtitle = "", dataTestId: dataTestId = "" }) {
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-OrphanAccountCard",
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                className: "Ispm-Access-OrphanAccountCard-header",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h3",
                    color: "--color-foreground-secondary-bold",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                children: timeSeriesData ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "display",
                            color: "--color-foreground-neutral-bold",
                            className: "Ispm-Access-OrphanAccountCard-row-orphanNumber",
                            children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(Number(value))
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-Access-OrphanAccountCard-row",
                            children: [
                                timeSeriesData && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                    timeSeriesData: timeSeriesData
                                }),
                                subtitle && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                                    className: "Ispm-OrphanAccountCard-subOrphantitle",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        kind: "body2",
                                        color: "--color-foreground-neutral-subtle",
                                        children: subtitle
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
// Add defaultProps to provide a fallback value for optional props
$6b99f2ae49f6545c$var$OrphanAccountCard.defaultProps = {
    subtitle: "Last 30 days"
};
var $6b99f2ae49f6545c$export$2e2bcd8739ae039 = $6b99f2ae49f6545c$var$OrphanAccountCard;



function $64b565b458f8576a$var$InactiveRolesActiveAssignments({ inactiveRolesWithActiveAssignmentsData: inactiveRolesWithActiveAssignmentsData }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $6b99f2ae49f6545c$export$2e2bcd8739ae039), {
        title: inactiveRolesWithActiveAssignmentsData.title,
        value: inactiveRolesWithActiveAssignmentsData.value,
        timeSeriesData: inactiveRolesWithActiveAssignmentsData.timeSeriesData,
        dataTestId: "ispm-dashboard-inactiveRolesWithActiveAssignments"
    });
}
var $64b565b458f8576a$export$2e2bcd8739ae039 = $64b565b458f8576a$var$InactiveRolesActiveAssignments;











function $41b1927f1a0f58fe$var$MultiLineChart({ data: data, width: width, height: height }) {
    // Filter categories once and store them for reuse
    const categories = Object.keys(data).filter((key)=>key !== "title" && typeof data[key] !== "string");
    // Format data for the chart
    const formatData = ()=>categories.flatMap((category)=>{
            const categoryData = data[category];
            // Return empty array if no timeSeriesData
            if (!Array.isArray(categoryData.timeSeriesData) || !categoryData.timeSeriesData.length) return [];
            return categoryData.timeSeriesData.map((item)=>({
                    x: new Date(item.timestamp).toISOString().split("T")[0],
                    y: item.value,
                    type: categoryData.title
                }));
        });
    // Generate chart spec
    const generateChartSpec = ()=>({
            background: "transparent",
            width: width,
            height: height,
            data: {
                values: formatData()
            },
            config: {
                axis: {
                    domain: false,
                    grid: false
                },
                view: {
                    stroke: "transparent"
                }
            },
            layer: categories.flatMap((category)=>{
                const categoryData = data[category];
                if (!categoryData.timeSeriesData) return [];
                // Destructure color and offset from constants
                const { color: color, offset1: offset1, offset2: offset2 } = (0, $8ff2252602deef38$export$fe10ecaa6c2229c0)[category] || {};
                // Return empty array if colors are not defined
                if (!color || !offset1 || !offset2) return [];
                // Create the chart layers
                return [
                    {
                        transform: [
                            {
                                filter: `datum.type === '${categoryData.title}'`
                            }
                        ],
                        mark: {
                            type: "area",
                            opacity: 0.5,
                            gradient: "linear",
                            color: {
                                gradient: "linear",
                                stops: [
                                    {
                                        offset: 0,
                                        color: offset1
                                    },
                                    {
                                        offset: 1,
                                        color: offset2
                                    }
                                ]
                            }
                        },
                        encoding: {
                            x: {
                                field: "x",
                                type: "temporal"
                            },
                            y: {
                                field: "y",
                                type: "quantitative"
                            },
                            y1: {
                                field: "y1"
                            }
                        }
                    },
                    {
                        transform: [
                            {
                                filter: `datum.type === '${categoryData.title}'`
                            }
                        ],
                        mark: {
                            type: "line",
                            strokeWidth: 2
                        },
                        encoding: {
                            x: {
                                field: "x",
                                type: "temporal",
                                axis: {
                                    title: null,
                                    labels: false,
                                    ticks: false
                                }
                            },
                            y: {
                                field: "y",
                                type: "quantitative",
                                axis: {
                                    title: null,
                                    labels: false,
                                    ticks: false
                                }
                            },
                            color: {
                                value: color
                            }
                        }
                    }
                ];
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$VegaLite), {
        spec: generateChartSpec(),
        actions: false
    });
}
var $41b1927f1a0f58fe$export$2e2bcd8739ae039 = $41b1927f1a0f58fe$var$MultiLineChart;








function $a2e5f9c2fa28d56a$var$OutOfBandAccessOverview({ outOfBandAccessData: outOfBandAccessData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-OutOfBandAccess",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h3",
                    color: "--color-foreground-secondary-bold",
                    children: l("Out-of-Band Access")
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                children: (outOfBandAccessData.accounts.value > 0 || outOfBandAccessData.applications.value > 0) && Array.isArray(outOfBandAccessData.accounts.timeSeriesData) && outOfBandAccessData.accounts.timeSeriesData.length > 0 && Array.isArray(outOfBandAccessData.applications.timeSeriesData) && outOfBandAccessData.applications.timeSeriesData.length > 0 ? /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-Certs-CampExpSoon-stats",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-Certs-CampExpSoon-stats-labelsColumn",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: `Ispm-Access-OutOfBandAccess-accounts-row ${(0, $31415264ab98c97b$export$a2c0215fc34a08c3)[0]}`,
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: "Ispm-Access-OutOfBandAccess-accounts-row-content",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body1",
                                                    color: "--color-foreground-neutral-bold",
                                                    children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(outOfBandAccessData.accounts.value)
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body2",
                                                    color: "--color-foreground-neutral-bold",
                                                    children: l("Accounts")
                                                })
                                            ]
                                        }),
                                        outOfBandAccessData.accounts.timeSeriesData && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                            timeSeriesData: outOfBandAccessData.accounts.timeSeriesData
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: `Ispm-Access-OutOfBandAccess-applications-row ${(0, $31415264ab98c97b$export$a2c0215fc34a08c3)[1]}`,
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: "Ispm-Access-OutOfBandAccess-applications-row-content",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body1",
                                                    color: "--color-foreground-neutral-bold",
                                                    children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(outOfBandAccessData.applications.value)
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body2",
                                                    color: "--color-foreground-neutral-bold",
                                                    children: l("Applications")
                                                })
                                            ]
                                        }),
                                        outOfBandAccessData.applications.timeSeriesData && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                            timeSeriesData: outOfBandAccessData.applications.timeSeriesData
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-Certs-CampExpSoon-stats-trendColumn",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $41b1927f1a0f58fe$export$2e2bcd8739ae039), {
                                data: {
                                    accounts: outOfBandAccessData.accounts,
                                    applications: outOfBandAccessData.applications
                                },
                                width: 200,
                                height: 100
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $a2e5f9c2fa28d56a$export$2e2bcd8739ae039 = $a2e5f9c2fa28d56a$var$OutOfBandAccessOverview;










function $d2746f7f919911f8$var$LineChart({ history: history, lineStartColor: lineStartColor, lineEndColor: lineEndColor, graphShadow: graphShadow, width: width, height: height }) {
    const remToPx = (rem)=>rem * 16;
    const generateChartSpec = (lineData, startColor, endColor, shadow)=>({
            background: "transparent",
            border: "1px solid transparent",
            width: remToPx(width),
            height: remToPx(height),
            autosize: {
                type: "fit",
                contains: "padding"
            },
            data: {
                values: lineData
            },
            config: {
                axis: {
                    domain: false,
                    grid: false
                },
                view: {
                    stroke: "transparent"
                }
            },
            layer: [
                {
                    mark: {
                        type: "area",
                        encoding: {
                            x: {
                                field: "x",
                                type: "ordinal"
                            },
                            y: {
                                field: "y",
                                type: "quantitative"
                            }
                        },
                        opacity: 0.5,
                        color: {
                            x1: 1,
                            y1: 1,
                            x2: 1,
                            y2: 0,
                            gradient: "linear",
                            stops: [
                                {
                                    offset: 0.0,
                                    color: "transparent"
                                },
                                {
                                    offset: 1.0,
                                    color: shadow
                                }
                            ]
                        }
                    },
                    encoding: {
                        x: {
                            field: "x",
                            type: "ordinal",
                            axis: {
                                title: null,
                                labels: false,
                                ticks: false
                            }
                        },
                        y: {
                            field: "y",
                            type: "quantitative",
                            axis: {
                                title: null,
                                labels: false,
                                ticks: false
                            }
                        }
                    }
                },
                {
                    mark: {
                        type: "line",
                        strokeWidth: 2,
                        stroke: {
                            gradient: "linear",
                            stops: [
                                {
                                    offset: 0,
                                    color: startColor
                                },
                                {
                                    offset: 1,
                                    color: endColor
                                }
                            ]
                        }
                    },
                    encoding: {
                        x: {
                            field: "x",
                            type: "ordinal"
                        },
                        y: {
                            field: "y",
                            type: "quantitative"
                        }
                    }
                }
            ]
        });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$VegaLite), {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        spec: generateChartSpec(history, lineStartColor, lineEndColor, graphShadow),
        actions: false
    });
}
var $d2746f7f919911f8$export$2e2bcd8739ae039 = $d2746f7f919911f8$var$LineChart;







/**
 * Custom hook to track and update chart width dynamically.
 * @returns The current chart width based on window size.
 */ const $ff8ec132d0ebb3bb$var$useChartWidth = ()=>{
    const [chartWidth, setChartWidth] = (0, $cURGa$useState)(()=>(0, $31415264ab98c97b$export$18e2284b0212a9ee)(window.innerWidth));
    (0, $cURGa$useEffect)(()=>{
        const handleResize = ()=>{
            setChartWidth((0, $31415264ab98c97b$export$18e2284b0212a9ee)(window.innerWidth));
        };
        window.addEventListener("resize", handleResize);
        handleResize(); // Run initially
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return chartWidth;
};
var $ff8ec132d0ebb3bb$export$2e2bcd8739ae039 = $ff8ec132d0ebb3bb$var$useChartWidth;





function $c7bbc6474984a9ae$var$RolesWithMissingOwners({ rolesWithMissingOwnersData: rolesWithMissingOwnersData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const chartWidth = (0, $ff8ec132d0ebb3bb$export$2e2bcd8739ae039)();
    function generateChart(card, timeSeries) {
        const cardConfig = (0, $31415264ab98c97b$export$1a517009088eb7d6).filter((IgaCard)=>IgaCard.title === card);
        const sortedData = timeSeries.sort((a, b)=>a.timestamp - b.timestamp);
        const chartData = sortedData.map((entry)=>{
            const date = new Date(entry.timestamp).toISOString().split("T")[0];
            return {
                x: date,
                y: entry.value
            };
        });
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $d2746f7f919911f8$export$2e2bcd8739ae039), {
            width: chartWidth,
            height: 7,
            lineStartColor: cardConfig[0].startColor,
            lineEndColor: cardConfig[0].endColor,
            graphShadow: cardConfig[0].shadow,
            history: chartData
        });
    }
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-Access-MissingOwnersRoles",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h4",
                    color: "--color-foreground-secondary-bold",
                    className: "Ispm-Access-MissingOwnersRoles-header",
                    children: l("Roles with Missing Owners")
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                className: "Ispm-Access-MissingOwnersRoles-body",
                children: Array.isArray(rolesWithMissingOwnersData.timeSeriesData) && rolesWithMissingOwnersData.timeSeriesData.length > 0 ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                            className: "Ispm-Access-MissingOwnersRoles-body-stats",
                            children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                className: "Ispm-Access-MissingOwnersRoles-body-stats-values",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        kind: "display",
                                        color: "--color-foreground-secondary-bold",
                                        children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(rolesWithMissingOwnersData.value)
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                        timeSeriesData: rolesWithMissingOwnersData.timeSeriesData
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                            className: "Ispm-Access-MissingOwnersRoles-body-graph",
                            children: generateChart(rolesWithMissingOwnersData.title, rolesWithMissingOwnersData.timeSeriesData)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $c7bbc6474984a9ae$export$2e2bcd8739ae039 = $c7bbc6474984a9ae$var$RolesWithMissingOwners;






function $18411effa6c62fc5$var$OrphanAccount({ orphanAccountData: orphanAccountData }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $6b99f2ae49f6545c$export$2e2bcd8739ae039), {
        title: orphanAccountData.title,
        value: orphanAccountData.value,
        timeSeriesData: orphanAccountData.timeSeriesData,
        dataTestId: "ispm-dashboard-orphanAccount"
    });
}
var $18411effa6c62fc5$export$2e2bcd8739ae039 = $18411effa6c62fc5$var$OrphanAccount;












function $dd1631becfeec996$var$TopRequestedEntitlements({ topRequestedEntitlementsData: topRequestedEntitlementsData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
        className: "Ispm-TopRequestedEntitlements",
        dataTestId: "ispm-dashboard-topRequestedEntitlements",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h1",
                    color: "--color-foreground-secondary-bold",
                    className: "Ispm-TopRequestedEntitlements-header",
                    lineLimit: 2,
                    children: l("Top Requested Entitlements Without Descriptions")
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-TopRequestedEntitlements-subTitleTopRequested",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body2",
                                color: "--color-foreground-neutral-medium",
                                className: "Ispm-TopRequestedEntitlements-entitlementApp",
                                children: l("ENTITLEMENT & APP")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body2",
                                color: "--color-foreground-neutral-medium",
                                className: "Ispm-TopRequestedEntitlements-request",
                                children: l("# OF REQUESTS")
                            })
                        ]
                    }),
                    topRequestedEntitlementsData.entitlements ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        children: topRequestedEntitlementsData.entitlements.map((entitlement, index)=>{
                            /**
                 * Rendering each entitlement with icon and data
                 * applicationImage is coming from api for each entitlement,
                 * We are using createImageUrlFromId function to get avatarSrc
                 * Example: if imageId is Applicatio.svg then avatarSrc will be baseUrl/ECMv6/api/idw/resource/image/app/Application.svg
                 * If iamageId is available then we render svg from API else <ApplicationIcon/> will be rendered
                 */ const imageId = entitlement.applicationImage;
                            const avatarSrc = imageId && (0, $8ff2252602deef38$export$9c04fe193594da37)(imageId);
                            return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: index % 2 === 0 ? "Ispm-TopRequestedEntitlements-entitlementlight" : "Ispm-TopRequestedEntitlements-entitlementdark",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-TopRequestedEntitlements-entitlementContent",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                className: "Ispm-TopRequestedEntitlements-entitlementIcons",
                                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                    kind: "Entitlement",
                                                    color: "--color-foreground-secondary-medium",
                                                    size: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                className: "Ispm-TopRequestedEntitlements-entitlementApplications",
                                                children: [
                                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                        className: "Ispm-TopRequestedEntitlements-entitlementNumber",
                                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                            kind: "body1",
                                                            lineLimit: 1,
                                                            color: "--color-foreground-neutral-bold",
                                                            className: "Ispm-TopRequestedEntitlements-entitlementName",
                                                            children: entitlement.entitlementName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                        className: "Ispm-TopRequestedEntitlements-subtitleIcon",
                                                        children: [
                                                            avatarSrc ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                                                                size: "xxSmall",
                                                                src: avatarSrc,
                                                                alt: `${entitlement.applicationName}'s avatar`
                                                            }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ApplicationIcon), {
                                                                size: "xxSmall"
                                                            }),
                                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                kind: "body3",
                                                                lineLimit: 1,
                                                                className: "Ispm-TopRequestedEntitlements-entitlementApplicationName",
                                                                color: "--color-foreground-neutral-subtle",
                                                                children: entitlement.applicationName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-TopRequestedEntitlements-entitlementData",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "h1",
                                                color: "--color-foreground-secondary-bold",
                                                className: "Ispm-TopRequestedEntitlements-applicationName",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(entitlement.value)
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                className: "Ispm-TopRequestedEntitlements-percentChange",
                                                children: entitlement.timeSeriesData && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                                    timeSeriesData: entitlement.timeSeriesData
                                                })
                                            })
                                        ]
                                    })
                                ]
                            });
                        })
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $dd1631becfeec996$export$2e2bcd8739ae039 = $dd1631becfeec996$var$TopRequestedEntitlements;



















function $6e72cb30179af2a1$var$IgaTab({ data: data, dataTestId: dataTestId = "" }) {
    const chartWidth = (0, $ff8ec132d0ebb3bb$export$2e2bcd8739ae039)();
    const leftNavPinned = localStorage.getItem("gen2.layout.isMenuPinned") ?? false;
    const handleRedirect = ()=>{
        try {
            const newTab = window.open((0, $8ff2252602deef38$export$39a0dbedf3ff0424), "_blank");
            if (!newTab) (0, $cURGa$Logger).warn("Popup blocked");
        } catch (error) {
            (0, $cURGa$Logger).error("Failed to open review:", error);
        }
    };
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    function generateChart(card, timeSeries) {
        const cardConfig = (0, $31415264ab98c97b$export$1a517009088eb7d6).filter((IgaCard)=>IgaCard.title === card);
        const sortedData = timeSeries.sort((a, b)=>a.timestamp - b.timestamp);
        const chartData = sortedData.map((entry)=>{
            const date = new Date(entry.timestamp).toISOString().split("T")[0];
            return {
                x: date,
                y: entry.value
            };
        });
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $d2746f7f919911f8$export$2e2bcd8739ae039), {
            width: chartWidth,
            height: 7,
            lineStartColor: cardConfig[0].startColor,
            lineEndColor: cardConfig[0].endColor,
            graphShadow: cardConfig[0].shadow,
            history: chartData
        });
    }
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-Insights-Iga",
        "data-testid": dataTestId,
        children: data?.map((insight)=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                className: "Ispm-Insights-Iga-Card",
                clickHandler: handleRedirect,
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                            kind: "h3",
                            color: "--color-foreground-secondary-bold",
                            className: "Ispm-Insights-Iga-Card-Title",
                            children: [
                                insight.title,
                                "\xa0",
                                `(${l("Last 30 Days")})`
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                        children: insight.timeSeriesData ? /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-Insights-Iga-Card-Content",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-Insights-Iga-Card-Content-Numbers",
                                    children: /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                                        className: "Ispm-Insights-Iga-Card-Content-Numbers-Section",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                                className: "Ispm-Insights-Iga-Card-Content-Numbers-Section-Value",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(insight.value)
                                            }),
                                            insight.timeSeriesData && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e7b7d9445a7db430$export$2e2bcd8739ae039), {
                                                timeSeriesData: insight.timeSeriesData
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: (0, $cURGa$classnames)("Ispm-Insights-Iga-Card-Content-InsightGraph", leftNavPinned === "true" && "leftNavPinned"),
                                    children: generateChart(insight.title, insight.timeSeriesData)
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                    })
                ]
            }, insight.id))
    });
}
var $6e72cb30179af2a1$export$2e2bcd8739ae039 = $6e72cb30179af2a1$var$IgaTab;



function $7fc2d8fe52aa8ca9$var$Access() {
    const { data: accessData, isLoading: isAccessDataLoading, error: isAccessDataError } = (0, $3ac793aa418a359a$export$43ddd7fc79c95e7)();
    const leftNavPinned = localStorage.getItem("gen2.layout.isMenuPinned") || false;
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-Access",
        children: isAccessDataLoading ? /*#__PURE__*/ (0, $cURGa$jsx)("section", {
            className: "Certs-Loader",
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "loop",
                format: "main",
                color: "brand"
            })
        }) : /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
            className: (0, $cURGa$classnames)("Ispm-Access-content", leftNavPinned === "true" && "leftNavPinned"),
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Ispm-Access-content-section1",
                    children: !isAccessDataError && accessData?.dormantAccountsSummary ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $a2f6ac8d454d9e11$export$2e2bcd8739ae039), {
                        dormatAccountsData: accessData.dormantAccountsSummary
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                        className: "Ispm-DormatAccounts",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                    className: "Ispm-Access-content-section2",
                    children: [
                        !isAccessDataError && accessData?.activeUsersWithInactiveManagers ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $83b1b78c3327dc02$export$2e2bcd8739ae039), {
                            activeUsersWithInactiveManagersData: accessData.activeUsersWithInactiveManagers
                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                            className: "Ispm-ActiveUsersWithInactiveManagers",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                        }),
                        !isAccessDataError && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                            className: "Ispm-Access-content-section2-row2",
                            children: [
                                !isAccessDataError && accessData?.orphanAccounts && /*#__PURE__*/ (0, $cURGa$jsx)((0, $18411effa6c62fc5$export$2e2bcd8739ae039), {
                                    orphanAccountData: accessData.orphanAccounts
                                }),
                                !isAccessDataError && accessData?.inactiveRolesWithActiveAssignments && /*#__PURE__*/ (0, $cURGa$jsx)((0, $64b565b458f8576a$export$2e2bcd8739ae039), {
                                    inactiveRolesWithActiveAssignmentsData: accessData.inactiveRolesWithActiveAssignments
                                })
                            ]
                        }),
                        !isAccessDataError && accessData?.duplicateIdentities ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $6e72cb30179af2a1$export$2e2bcd8739ae039), {
                            data: [
                                accessData.duplicateIdentities
                            ],
                            dataTestId: "ispm-dashboard-duplicateIdentities"
                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                            className: "Ispm-OutOfBandAccess",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: (0, $cURGa$classnames)("Ispm-Access-content-section3", leftNavPinned === "true" && "leftNavPinned"),
                    children: !isAccessDataError && accessData?.entitlementsWithoutDescription ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $dd1631becfeec996$export$2e2bcd8739ae039), {
                        topRequestedEntitlementsData: accessData.entitlementsWithoutDescription
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                        className: "Ispm-TopRequestedEntitlements",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        })
    });
}
var $7fc2d8fe52aa8ca9$export$2e2bcd8739ae039 = $7fc2d8fe52aa8ca9$var$Access;






























function $e280fb9f6095ebf3$var$ChartLegends({ legendList: legendList, showLegendValues: showLegendValues }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
        className: "Ispm-ChartLegend-wrapper",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-ChartLegend-wrapper-lengend",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    style: {
                        background: `${(0, $31415264ab98c97b$export$a4c54d344edf09d8)[legendList.name || "revocation_processing"]}`
                    },
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                        kind: "dot",
                        size: "small",
                        color: "neutral"
                    })
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                    className: "Ispm-ChartLegend-wrapper-lengend-details",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body3",
                        lineLimit: 1,
                        color: "--color-foreground-neutral-subtle",
                        children: `${(0, $31415264ab98c97b$export$827b953b70c0e9f)[legendList.name || "revocation_processing"]}`
                    })
                }),
                showLegendValues && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "h5",
                    color: "--color-foreground-neutral-bold",
                    children: [
                        legendList.value
                    ]
                })
            ]
        })
    });
}
$e280fb9f6095ebf3$var$ChartLegends.defaultProps = {
    showLegendValues: false
};
var $e280fb9f6095ebf3$export$2e2bcd8739ae039 = $e280fb9f6095ebf3$var$ChartLegends;










function $0ad40c91a0c246cc$var$PolarBar({ isPolarBarClicked: isPolarBarClicked, title: title, subTitle: subTitle, timestamp: timestamp, barList: barList, count: count = 0, dataTestId: dataTestId = "", refreshSummaryCard: refreshSummaryCard }) {
    const [showTooltip, setShowTooltip] = (0, $cURGa$useState)(false);
    const getWidth = (value)=>{
        const numericValue = value ?? 0;
        return numericValue > 0 ? numericValue / Number(count) * 100 : 0;
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
        dataTestId: dataTestId,
        className: (0, $cURGa$classnames)("Ispm-PolarBar-wrapper", {
            "Ispm-PolarBar-wrapper--clicked": isPolarBarClicked
        }),
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-PolarBar-wrapper-details",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        className: "Ispm-PolarBar-wrapper-details-title",
                        lineLimit: 1,
                        tooltipConfig: {
                            maxWidth: "15rem",
                            isWordBreak: false
                        },
                        kind: "body2-bold",
                        children: title
                    }),
                    subTitle && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        className: "Ispm-PolarBar-wrapper-details-subTitle",
                        lineLimit: 1,
                        tooltipConfig: {
                            maxWidth: "10rem",
                            isWordBreak: false
                        },
                        kind: "body3",
                        children: subTitle
                    }),
                    timestamp && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-PolarBar-wrapper-details-timestamp",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "Time",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                lineLimit: 1,
                                kind: "body4",
                                children: `${timestamp}d Left`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Popover), {
                trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-PolarBar-wrapper-bar",
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>refreshSummaryCard(title ?? ""),
                    onKeyDown: (event)=>{
                        if (event.key === "Enter" || event.key === " ") refreshSummaryCard(title ?? "");
                    },
                    children: barList.map((item, index)=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-PolarBar-wrapper-bar-progress",
                            style: {
                                width: `${getWidth(item.value)}%`,
                                display: item.value === 0 ? "none" : "block",
                                background: `${(0, $31415264ab98c97b$export$a4c54d344edf09d8)[item.name || "#0294F7"]}`
                            },
                            "data-testid": item.name
                        }, item.name || `${index}`))
                }),
                popoverContent: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                    className: "Ispm-PolarBar-wrapper-legends-tooltip",
                    dataTestId: "PolarBar-tooltip",
                    children: barList.map((item, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                            legendList: item,
                            showLegendValues: true
                        }, item.name || `${index}`))
                }),
                isOpen: showTooltip,
                setIsOpen: setShowTooltip,
                isOpenOnHover: true
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                className: "Ispm-PolarBar-wrapper-count",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "body1-bold",
                    lineLimit: 1,
                    children: String(count)
                })
            })
        ]
    });
}
$0ad40c91a0c246cc$var$PolarBar.defaultProps = {
    subTitle: "",
    timestamp: ""
};
var $0ad40c91a0c246cc$export$2e2bcd8739ae039 = $0ad40c91a0c246cc$var$PolarBar;










function $9b654484cc1973d6$var$CampaignError() {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
        className: "Certs-CampaignError",
        children: [
            theme ? /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                width: "120",
                height: "121",
                viewBox: "0 0 120 121",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                    id: "empty",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            id: "--color-foreground-primary-subtle",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M48.548 15.4024C47.6914 15.3107 46.8545 15.3404 46.043 15.4766C45.226 15.6137 44.4526 15.0625 44.3155 14.2455C44.1784 13.4285 44.7295 12.655 45.5465 12.5179C46.6226 12.3373 47.7339 12.2981 48.8671 12.4194C50.044 12.5453 51.1479 12.8344 52.1876 13.2446C52.9582 13.5487 53.3364 14.4199 53.0324 15.1905C52.7283 15.9611 51.8571 16.3393 51.0865 16.0352C50.2764 15.7156 49.435 15.4973 48.548 15.4024ZM84.4393 16.1099C84.8767 15.4067 85.8013 15.1911 86.5047 15.6283C87.2083 16.0656 87.4242 16.9905 86.9868 17.6941L85.7129 16.9023C86.9868 17.6941 86.9868 17.6941 86.9868 17.6941L86.9862 17.6952L86.9853 17.6967L86.9824 17.7013L86.9729 17.7164L86.9391 17.7699C86.91 17.8157 86.8679 17.8814 86.8134 17.9651C86.7044 18.1324 86.5457 18.372 86.3419 18.6688C85.9346 19.2617 85.3453 20.0857 84.6114 21.0184C84.0991 21.6695 83.156 21.782 82.505 21.2697C81.8539 20.7574 81.7414 19.8143 82.2537 19.1633C82.9404 18.2906 83.4912 17.5203 83.869 16.9703C84.0577 16.6956 84.2027 16.4766 84.2993 16.3281C84.3476 16.2539 84.3838 16.1975 84.4073 16.1605L84.4329 16.1201L84.4384 16.1113L84.4393 16.1099ZM40.1037 16.5698C40.6844 17.1605 40.6763 18.1103 40.0855 18.691C38.8586 19.8971 37.7997 21.3726 36.9778 23.0157C36.6071 23.7566 35.7061 24.0568 34.9652 23.6862C34.2243 23.3156 33.9241 22.4145 34.2947 21.6736C35.2537 19.7565 36.5027 18.0063 37.9825 16.5516C38.5732 15.9708 39.5229 15.979 40.1037 16.5698ZM57.105 18.2307C57.6816 17.6358 58.6312 17.6209 59.2261 18.1975C59.9736 18.9219 60.7009 19.6687 61.4061 20.3943L61.499 20.4899C62.1763 21.187 62.8325 21.8622 63.4907 22.5056C64.0831 23.0847 64.0939 24.0344 63.5148 24.6268C62.9357 25.2192 61.986 25.23 61.3936 24.6509C60.707 23.9797 60.0262 23.2791 59.3563 22.5896L59.2547 22.4851C58.5468 21.7567 57.849 21.0406 57.1382 20.3518C56.5434 19.7752 56.5285 18.8256 57.105 18.2307ZM77.0834 26.4098C77.4801 27.1371 77.2123 28.0483 76.485 28.445C75.1573 29.1694 73.7083 29.7016 72.1922 29.8338C70.9434 29.9426 69.7655 29.8091 68.6512 29.4895C67.8549 29.261 67.3945 28.4303 67.623 27.634C67.8514 26.8377 68.6821 26.3773 69.4784 26.6058C70.2582 26.8295 71.0676 26.9204 71.9316 26.8451C72.9234 26.7586 73.9701 26.3997 75.0482 25.8115C75.7754 25.4147 76.6866 25.6826 77.0834 26.4098ZM33.7204 28.3235C34.5477 28.3661 35.1839 29.0713 35.1413 29.8986C35.0955 30.7886 35.1234 31.6789 35.2301 32.5577C35.3513 33.5557 35.5762 34.3623 35.87 35.0168C36.2094 35.7726 35.8718 36.6603 35.116 36.9996C34.3603 37.3389 33.4726 37.0014 33.1332 36.2456C32.6958 35.2714 32.4031 34.1644 32.252 32.9193C32.1236 31.862 32.091 30.799 32.1453 29.7445C32.1879 28.9171 32.893 28.2809 33.7204 28.3235ZM54.7156 37.8392C56.8429 37.7406 58.9887 37.7537 60.994 38.0719C61.8122 38.2018 62.3702 38.9703 62.2404 39.7885C62.1106 40.6067 61.3421 41.1647 60.5239 41.0349C58.8111 40.7631 56.8977 40.7413 54.8545 40.8359C54.027 40.8743 53.325 40.2345 53.2867 39.407C53.2483 38.5794 53.8881 37.8775 54.7156 37.8392ZM39.3623 39.604C39.4806 38.784 40.2413 38.2153 41.0612 38.3337C42.7127 38.5721 44.6262 38.5525 46.733 38.425C47.56 38.375 48.2709 39.0047 48.3209 39.8317C48.3709 40.6586 47.7411 41.3695 46.9142 41.4195C44.7519 41.5503 42.5932 41.5859 40.6326 41.3029C39.8126 41.1845 39.2439 40.4239 39.3623 39.604ZM66.6798 42.0711C67.3478 41.5812 68.2865 41.7255 68.7764 42.3936C69.4194 43.2703 69.9472 44.2824 70.3526 45.439C70.7985 46.7112 70.9753 47.9762 70.9583 49.1968C70.9468 50.0252 70.266 50.6873 69.4376 50.6758C68.6093 50.6643 67.9471 49.9835 67.9586 49.1552C67.9711 48.2571 67.8417 47.3449 67.5215 46.4314C67.205 45.5285 66.8097 44.7846 66.3572 44.1677C65.8673 43.4997 66.0117 42.561 66.6798 42.0711ZM67.3005 56.0743C67.9772 56.5521 68.1384 57.4881 67.6606 58.1648C67.0676 59.0046 66.5063 59.6817 66.0905 60.1518C65.8822 60.3873 65.7093 60.572 65.5859 60.7004C65.5242 60.7646 65.4748 60.8148 65.4393 60.8504L65.3969 60.8927L65.3839 60.9054L65.3796 60.9096L65.3779 60.9112L65.377 60.9122C65.377 60.9122 65.3767 60.9124 64.429 59.9358L65.377 60.9122C64.7824 61.4891 63.8325 61.4751 63.2556 60.8806C62.6791 60.2865 62.6929 59.3378 63.2862 58.7607L63.287 58.76L63.2901 58.7569L63.3144 58.7327C63.3376 58.7095 63.3743 58.6722 63.4229 58.6216C63.5202 58.5203 63.6648 58.366 63.8434 58.1641C64.2014 57.7595 64.6917 57.1684 65.2099 56.4344C65.6878 55.7577 66.6237 55.5964 67.3005 56.0743Z",
                            fill: "#5E6DFF"
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                            id: "--color-foreground-secondary-bold",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M83.1166 13.1586C81.1405 10.5173 77.1075 10.7569 75.4581 13.6137C73.8087 16.4705 75.6177 20.083 78.8932 20.4737L80.4244 20.6563C80.5392 21.2972 80.9026 21.8928 81.4845 22.2864C82.1588 22.7426 82.9759 22.8255 83.6916 22.5823L84.563 23.747C86.5391 26.3884 90.5721 26.1487 92.2215 23.2919C93.8708 20.4351 92.0619 16.8226 88.7863 16.432L88.2078 16.363C88.3393 15.4453 87.953 14.4901 87.1336 13.9358C86.1148 13.2466 84.7701 13.4094 83.9418 14.2616L83.1166 13.1586ZM82.138 16.8586L80.7144 14.9558C80.0285 14.039 78.6287 14.1221 78.0562 15.1137C77.4837 16.1053 78.1116 17.3592 79.2485 17.4948L81.524 17.7662L82.138 16.8586ZM86.5961 19.192L85.7916 20.3813L86.9651 21.9499C87.651 22.8667 89.0509 22.7835 89.6234 21.7919C90.1959 20.8003 89.568 19.5464 88.4311 19.4108L86.5961 19.192Z",
                                    fill: "#F3F4F7"
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M14.3273 46.7656C14.1434 46.8576 13.9866 46.9823 13.8605 47.1291L4.43936 56.5502C4.09842 56.8911 3.94215 57.3752 4.01939 57.8511C4.09662 58.327 4.39794 58.7368 4.8292 58.9525L13.498 63.2869V85.6552C13.498 86.2233 13.8191 86.7427 14.3272 86.9968L59.3608 109.514C59.5325 109.604 59.7237 109.661 59.9264 109.678C59.9694 109.682 60.0124 109.684 60.0555 109.684C60.0721 109.684 60.0889 109.684 60.1054 109.683C60.1175 109.683 60.1296 109.682 60.1417 109.681C60.3624 109.669 60.5703 109.609 60.7553 109.511L105.784 86.9968C106.292 86.7427 106.613 86.2233 106.613 85.6552V63.1147L115.171 58.8358C115.602 58.6202 115.903 58.2104 115.981 57.7345C116.058 57.2585 115.902 56.7745 115.561 56.4335L106.31 47.1829C106.288 47.1608 106.265 47.1394 106.242 47.1189C106.117 46.9765 105.964 46.8555 105.784 46.7656L80.0655 33.9064C79.3246 33.5359 78.4235 33.8363 78.0531 34.5772C77.6826 35.3182 77.9829 36.2192 78.7239 36.5897L101.759 48.1073L60.0555 68.959L18.3522 48.1073L28.9211 42.8228C29.6621 42.4524 29.9624 41.5513 29.5919 40.8104C29.2214 40.0694 28.3204 39.7691 27.5794 40.1396L14.3273 46.7656ZM61.5557 78.41V105.757L103.613 84.7281V64.6147L70.1133 81.3646C69.5358 81.6533 68.8384 81.5401 68.3818 81.0836L60.0583 72.7601L51.6182 81.2002C51.1616 81.6568 50.4642 81.77 49.8867 81.4812L16.498 64.7869V84.7281L58.5557 105.757V78.41C58.5557 77.5815 59.2272 76.91 60.0557 76.91C60.8841 76.91 61.5557 77.5815 61.5557 78.41ZM104.817 49.9324L62.5878 71.0469L69.7387 78.1978L111.968 57.0833L104.817 49.9324ZM15.2979 49.9343L57.527 71.0488L50.2613 78.3144L8.03227 57.1999L15.2979 49.9343Z",
                                    fill: "#F3F4F7"
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                width: "120",
                height: "120",
                viewBox: "0 0 120 120",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                    id: "empty",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            id: "--color-foreground-primary-subtle",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M48.548 14.9024C47.6914 14.8107 46.8545 14.8404 46.043 14.9766C45.226 15.1137 44.4526 14.5625 44.3155 13.7455C44.1784 12.9285 44.7295 12.155 45.5465 12.0179C46.6226 11.8373 47.7339 11.7981 48.8671 11.9194C50.044 12.0453 51.1479 12.3344 52.1876 12.7446C52.9582 13.0487 53.3364 13.9199 53.0324 14.6905C52.7283 15.4611 51.8571 15.8393 51.0865 15.5352C50.2764 15.2156 49.435 14.9973 48.548 14.9024ZM84.4393 15.6099C84.8767 14.9067 85.8013 14.6911 86.5047 15.1283C87.2083 15.5656 87.4242 16.4905 86.9868 17.1941L85.7129 16.4023C86.9868 17.1941 86.9868 17.1941 86.9868 17.1941L86.9862 17.1952L86.9853 17.1967L86.9824 17.2013L86.9729 17.2164L86.9391 17.2699C86.91 17.3157 86.8679 17.3814 86.8134 17.4651C86.7044 17.6324 86.5457 17.872 86.3419 18.1688C85.9346 18.7617 85.3453 19.5857 84.6114 20.5184C84.0991 21.1695 83.156 21.282 82.505 20.7697C81.8539 20.2574 81.7414 19.3143 82.2537 18.6633C82.9404 17.7906 83.4912 17.0203 83.869 16.4703C84.0577 16.1956 84.2027 15.9766 84.2993 15.8281C84.3476 15.7539 84.3838 15.6975 84.4073 15.6605L84.4329 15.6201L84.4384 15.6113L84.4393 15.6099ZM40.1037 16.0698C40.6844 16.6605 40.6763 17.6103 40.0855 18.191C38.8586 19.3971 37.7997 20.8726 36.9778 22.5157C36.6071 23.2566 35.7061 23.5568 34.9652 23.1862C34.2243 22.8156 33.9241 21.9145 34.2947 21.1736C35.2537 19.2565 36.5027 17.5063 37.9825 16.0516C38.5732 15.4708 39.5229 15.479 40.1037 16.0698ZM57.105 17.7307C57.6816 17.1358 58.6312 17.1209 59.2261 17.6975C59.9736 18.4219 60.7009 19.1687 61.4061 19.8943L61.499 19.9899C62.1763 20.687 62.8325 21.3622 63.4907 22.0056C64.0831 22.5847 64.0939 23.5344 63.5148 24.1268C62.9357 24.7192 61.986 24.73 61.3936 24.1509C60.707 23.4797 60.0262 22.7791 59.3563 22.0896L59.2547 21.9851C58.5468 21.2567 57.849 20.5406 57.1382 19.8518C56.5434 19.2752 56.5285 18.3256 57.105 17.7307ZM77.0834 25.9098C77.4801 26.6371 77.2123 27.5483 76.485 27.945C75.1573 28.6694 73.7083 29.2016 72.1922 29.3338C70.9434 29.4426 69.7655 29.3091 68.6512 28.9895C67.8549 28.761 67.3945 27.9303 67.623 27.134C67.8514 26.3377 68.6821 25.8773 69.4784 26.1058C70.2582 26.3295 71.0676 26.4204 71.9316 26.3451C72.9234 26.2586 73.9701 25.8997 75.0482 25.3115C75.7754 24.9147 76.6866 25.1826 77.0834 25.9098ZM33.7204 27.8235C34.5477 27.8661 35.1839 28.5713 35.1413 29.3986C35.0955 30.2886 35.1234 31.1789 35.2301 32.0577C35.3513 33.0557 35.5762 33.8623 35.87 34.5168C36.2094 35.2726 35.8718 36.1603 35.116 36.4996C34.3603 36.8389 33.4726 36.5014 33.1332 35.7456C32.6958 34.7714 32.4031 33.6644 32.252 32.4193C32.1236 31.362 32.091 30.299 32.1453 29.2445C32.1879 28.4171 32.893 27.7809 33.7204 27.8235ZM54.7156 37.3392C56.8429 37.2406 58.9887 37.2537 60.994 37.5719C61.8122 37.7018 62.3702 38.4703 62.2404 39.2885C62.1106 40.1067 61.3421 40.6647 60.5239 40.5349C58.8111 40.2631 56.8977 40.2413 54.8545 40.3359C54.027 40.3743 53.325 39.7345 53.2867 38.907C53.2483 38.0794 53.8881 37.3775 54.7156 37.3392ZM39.3623 39.104C39.4806 38.284 40.2413 37.7153 41.0612 37.8337C42.7127 38.0721 44.6262 38.0525 46.733 37.925C47.56 37.875 48.2709 38.5047 48.3209 39.3317C48.3709 40.1586 47.7411 40.8695 46.9142 40.9195C44.7519 41.0503 42.5932 41.0859 40.6326 40.8029C39.8126 40.6845 39.2439 39.9239 39.3623 39.104ZM66.6798 41.5711C67.3478 41.0812 68.2865 41.2255 68.7764 41.8936C69.4194 42.7703 69.9472 43.7824 70.3526 44.939C70.7985 46.2112 70.9753 47.4762 70.9583 48.6968C70.9468 49.5252 70.266 50.1873 69.4376 50.1758C68.6093 50.1643 67.9471 49.4835 67.9586 48.6552C67.9711 47.7571 67.8417 46.8449 67.5215 45.9314C67.205 45.0285 66.8097 44.2846 66.3572 43.6677C65.8673 42.9997 66.0117 42.061 66.6798 41.5711ZM67.3005 55.5743C67.9772 56.0521 68.1384 56.9881 67.6606 57.6648C67.0676 58.5046 66.5063 59.1817 66.0905 59.6518C65.8822 59.8873 65.7093 60.072 65.5859 60.2004C65.5242 60.2646 65.4748 60.3148 65.4393 60.3504L65.3969 60.3927L65.3839 60.4054L65.3796 60.4096L65.3779 60.4112L65.377 60.4122C65.377 60.4122 65.3767 60.4124 64.429 59.4358L65.377 60.4122C64.7824 60.9891 63.8325 60.9751 63.2556 60.3806C62.6791 59.7865 62.6929 58.8378 63.2862 58.2607L63.287 58.26L63.2901 58.2569L63.3144 58.2327C63.3376 58.2095 63.3743 58.1722 63.4229 58.1216C63.5202 58.0203 63.6648 57.866 63.8434 57.6641C64.2014 57.2595 64.6917 56.6684 65.2099 55.9344C65.6878 55.2577 66.6237 55.0964 67.3005 55.5743Z",
                            fill: "#6E7FFF"
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                            id: "--color-foreground-secondary-bold",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M83.1166 12.6586C81.1405 10.0173 77.1075 10.2569 75.4581 13.1137C73.8087 15.9705 75.6177 19.583 78.8932 19.9737L80.4244 20.1563C80.5392 20.7972 80.9026 21.3928 81.4845 21.7864C82.1588 22.2426 82.9759 22.3255 83.6916 22.0823L84.563 23.247C86.5391 25.8884 90.5721 25.6487 92.2215 22.7919C93.8708 19.9351 92.0619 16.3226 88.7863 15.932L88.2078 15.863C88.3393 14.9453 87.953 13.9901 87.1336 13.4358C86.1148 12.7466 84.7701 12.9094 83.9418 13.7616L83.1166 12.6586ZM82.138 16.3586L80.7144 14.4558C80.0285 13.539 78.6287 13.6221 78.0562 14.6137C77.4837 15.6053 78.1116 16.8592 79.2485 16.9948L81.524 17.2662L82.138 16.3586ZM86.5961 18.692L85.7916 19.8813L86.9651 21.4499C87.651 22.3667 89.0509 22.2835 89.6234 21.2919C90.1959 20.3003 89.568 19.0464 88.4311 18.9108L86.5961 18.692Z",
                                    fill: "#00245B"
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M14.3273 46.2656C14.1434 46.3576 13.9866 46.4823 13.8605 46.6291L4.43936 56.0502C4.09842 56.3911 3.94215 56.8752 4.01939 57.3511C4.09662 57.827 4.39794 58.2368 4.8292 58.4525L13.498 62.7869V85.1552C13.498 85.7233 13.8191 86.2427 14.3272 86.4968L59.3608 109.014C59.5325 109.104 59.7237 109.161 59.9264 109.178C59.9694 109.182 60.0124 109.184 60.0555 109.184C60.0721 109.184 60.0889 109.184 60.1054 109.183C60.1175 109.183 60.1296 109.182 60.1417 109.181C60.3624 109.169 60.5703 109.109 60.7553 109.011L105.784 86.4968C106.292 86.2427 106.613 85.7233 106.613 85.1552V62.6147L115.171 58.3358C115.602 58.1202 115.903 57.7104 115.981 57.2345C116.058 56.7585 115.902 56.2745 115.561 55.9335L106.31 46.6829C106.288 46.6608 106.265 46.6394 106.242 46.6189C106.117 46.4765 105.964 46.3555 105.784 46.2656L80.0655 33.4064C79.3246 33.0359 78.4235 33.3363 78.0531 34.0772C77.6826 34.8182 77.9829 35.7192 78.7239 36.0897L101.759 47.6073L60.0555 68.459L18.3522 47.6073L28.9211 42.3228C29.6621 41.9524 29.9624 41.0513 29.5919 40.3104C29.2214 39.5694 28.3204 39.2691 27.5794 39.6396L14.3273 46.2656ZM61.5557 77.91V105.257L103.613 84.2281V64.1147L70.1133 80.8646C69.5358 81.1533 68.8384 81.0401 68.3818 80.5836L60.0583 72.2601L51.6182 80.7002C51.1616 81.1568 50.4642 81.27 49.8867 80.9812L16.498 64.2869V84.2281L58.5557 105.257V77.91C58.5557 77.0815 59.2272 76.41 60.0557 76.41C60.8841 76.41 61.5557 77.0815 61.5557 77.91ZM104.817 49.4324L62.5878 70.5469L69.7387 77.6978L111.968 56.5833L104.817 49.4324ZM15.2979 49.4343L57.527 70.5488L50.2613 77.8144L8.03227 56.6999L15.2979 49.4343Z",
                                    fill: "#00245B"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                className: "Certs-CampaignError-NoDataText",
                children: l("No Data Available")
            })
        ]
    });
}
var $9b654484cc1973d6$export$2e2bcd8739ae039 = $9b654484cc1973d6$var$CampaignError;



/**
 * Custom hook to process campaign data and generate a legend list based on drill-down keys.
 *
 * @param campaigns - Array of campaign data to be processed.
 * @param campaignsExpiringSoonDrillDownKeys - Keys to filter and process relevant values from the campaign data.
 *
 * @returns {
 *    processedCampaigns: Array of objects with campaign data and processed bar list.
 *    legendList: Array of PolarBarItem objects with names from `campaignsExpiringSoonDrillDownKeys` and values set to 0.
 * }
 *
 * Uses `useMemo` for performance optimization to recalculate only when inputs change.
 */ const $915d5dc100e37431$var$useCampaignsExpiringChartData = (campaigns, campaignsExpiringSoonDrillDownKeys)=>{
    // Memoize the processedCampaigns to avoid recalculating on every render
    const processedCampaigns = (0, $cURGa$useMemo)(()=>campaigns.map((campaign)=>{
            // Create the processedBarList for each campaign
            const processedBarList = Object.entries(campaign).filter(([key, value])=>campaignsExpiringSoonDrillDownKeys.includes(key) && typeof value === "number" && value > 0).map(([key, value])=>({
                    name: key,
                    value: value
                }));
            return {
                campaign: campaign,
                processedBarList: processedBarList
            };
        }), [
        campaigns,
        campaignsExpiringSoonDrillDownKeys
    ]);
    // Memoize the legendList to avoid recalculating on every render
    const legendList = (0, $cURGa$useMemo)(()=>campaignsExpiringSoonDrillDownKeys.map((key)=>({
                name: key,
                value: 0
            })), [
        campaignsExpiringSoonDrillDownKeys
    ]);
    return {
        processedCampaigns: processedCampaigns,
        legendList: legendList
    };
};
var $915d5dc100e37431$export$2e2bcd8739ae039 = $915d5dc100e37431$var$useCampaignsExpiringChartData;







/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $eb266be182a6900c$var$isValidCertsExpiringSoonCampaignsApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $eb266be182a6900c$export$7ca5e734123b240b = (pageNumber, pageSize, sortBy)=>{
    const fetchFunction = (0, $cURGa$useCallback)(()=>$eb266be182a6900c$var$getExpiringCampaignsData(pageNumber, pageSize, sortBy), [
        pageNumber,
        pageSize,
        sortBy
    ] // Ensures refetching when params change
    );
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(fetchFunction, [
        pageNumber
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        fetchFunction: fetchFunction
    };
};
const $eb266be182a6900c$var$getExpiringCampaignsData = async (pageNumber, pageSize, sortBy)=>{
    const { GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_CAMPAIGN_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_CAMPAIGN_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    let url = GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_CAMPAIGN_ENDPOINT;
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        ...pageNumber != null && {
            next_page_token: pageNumber.toString()
        },
        page_size: pageSize.toString(),
        sort_by: sortBy.toString(),
        time_period: "THIS_MONTH"
    });
    url = `${url}?${queryParams.toString()}`;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $eb266be182a6900c$var$isValidCertsExpiringSoonCampaignsApiResponse);
    return response.data;
};
var $eb266be182a6900c$export$2e2bcd8739ae039 = $eb266be182a6900c$var$getExpiringCampaignsData;


function $b35dda91de808f6a$var$CampaignsPolarBars({ refreshSummaryCard: refreshSummaryCard, isPolarBarClicked: isPolarBarClicked }) {
    const [campaigns, setCampaigns] = (0, $cURGa$useState)([]);
    const [nextPageToken, setNextPageToken] = (0, $cURGa$useState)(null);
    const [isInitialLoading, setIsInitialLoading] = (0, $cURGa$useState)(true);
    const observer = (0, $cURGa$useRef)(null);
    const { data: campaignsResponse, isLoading: campaignsDataLoading, error: campaignsDataError } = (0, $eb266be182a6900c$export$7ca5e734123b240b)(nextPageToken, 10, "LARGEST_TO_SMALLEST");
    const campaignsData = (0, $cURGa$useMemo)(()=>campaignsResponse?.campaigns || [], [
        campaignsResponse?.campaigns
    ]);
    const { processedCampaigns: processedCampaigns, legendList: legendList } = (0, $915d5dc100e37431$export$2e2bcd8739ae039)(campaigns, (0, $31415264ab98c97b$export$1afcf11a27cbbadc));
    const lastElementRef = (0, $cURGa$useCallback)((node)=>{
        if (!node || campaignsDataLoading || !campaignsResponse?.nextPageToken) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setNextPageToken(campaignsResponse.nextPageToken);
        }, {
            threshold: 1.0
        });
        observer.current.observe(node);
    }, [
        campaignsResponse,
        campaignsDataLoading
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (campaignsData.length) setCampaigns((prevData)=>{
            const existingIds = new Set(prevData.map((item)=>item.id));
            const newData = campaignsData.filter((item)=>!existingIds.has(item.id));
            return [
                ...prevData,
                ...newData
            ];
        });
        if (isInitialLoading && campaignsData.length > 0) setIsInitialLoading(false);
    }, [
        campaignsData,
        isInitialLoading
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-CampignsExpSoon-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Certs-Loader",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                        kind: "loop",
                        format: "main",
                        color: "brand",
                        dataTestId: "campaignLoader"
                    })
                })
            }),
            campaignsDataError && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-CampignsExpSoon-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            }),
            !campaignsDataLoading && !campaignsDataError && !campaigns.length && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-CampignsExpSoon-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $9b654484cc1973d6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            }),
            processedCampaigns.length > 0 && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-CampignsExpSoon-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Certs-CampignsExpSoon-drillDownModal-contentWrapper-chartViz-polarBar",
                        children: [
                            processedCampaigns.map(({ campaign: campaign, processedBarList: processedBarList }, index)=>{
                                const isLastElement = index === processedCampaigns.length - 1;
                                return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    ref: isLastElement ? lastElementRef : null,
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $0ad40c91a0c246cc$export$2e2bcd8739ae039), {
                                        title: campaign.name || "",
                                        subTitle: campaign.type || "",
                                        barList: processedBarList,
                                        count: campaign.totalCerts || 0,
                                        isPolarBarClicked: isPolarBarClicked === campaign.id,
                                        refreshSummaryCard: ()=>refreshSummaryCard(campaign),
                                        timestamp: campaign.daysUntilExpiry,
                                        dataTestId: `ispm-dashboard-campExpSoon-campaign-${campaign.name || ""}`
                                    })
                                }, campaign.id || `${index}`);
                            }),
                            !isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityList-loader",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                                    kind: "loop",
                                    format: "main",
                                    color: "brand"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            })
        ]
    });
}
var $b35dda91de808f6a$export$2e2bcd8739ae039 = $b35dda91de808f6a$var$CampaignsPolarBars;




/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 





/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 




function $d0a645ba1ad76040$var$Effectiveness({ title: title, classification: classification, percentage: percentage }) {
    let effectivenessColor;
    let kind;
    if (classification === (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).CLASSIFICATION.HIGH) {
        effectivenessColor = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).COLOR.SUCCESS;
        kind = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).KIND.HAPPY;
    } else if (classification === (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).CLASSIFICATION.MEDIUM) {
        effectivenessColor = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).COLOR.WARNING;
        kind = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).KIND.NEUTRAL;
    } else {
        effectivenessColor = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).COLOR.CRITICAL;
        kind = (0, $31415264ab98c97b$export$8de1f5d0f7d1b88e).KIND.SAD;
    }
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-Effectiveness-wrapper",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-Effectiveness-wrapper-content",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "body2",
                    color: "--color-foreground-secondary-bold",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Effectiveness-wrapper-effectivenessIcon",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                        dataTestId: effectivenessColor,
                        size: "xSmall",
                        label: classification,
                        color: effectivenessColor,
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: kind,
                            color: "--color-foreground-warning-medium"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                        children: [
                            Number(percentage) > 0 ? Number(percentage).toFixed(1) : Number(percentage),
                            "%"
                        ]
                    })
                ]
            })
        ]
    });
}
var $d0a645ba1ad76040$export$2e2bcd8739ae039 = $d0a645ba1ad76040$var$Effectiveness;


/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 








function $641e695249580926$var$Carousel({ reviewCompaignData: reviewCompaignData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-Carousel-container",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-Carousel-container-containerData",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-Carousel-container-containerData-scrollableContainer",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Carousel-container-containerData-scrollableContainer-scrollableItem",
                        children: reviewCompaignData?.text ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                            className: "Ispm-Carousel-container-containerData-scrollableContainer-scrollableItem-statInsightData",
                            kind: "body-2",
                            children: [
                                reviewCompaignData.text,
                                " "
                            ]
                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            className: "Ispm-Carousel-container-containerData-scrollableContainer-scrollableItem-noInsights",
                            kind: "body-2",
                            children: l("There are no insights currently available for this data.")
                        })
                    })
                }),
                reviewCompaignData?.text && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-Carousel-container-containerData-statInsightIconButton",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        className: "",
                        type: "button",
                        kind: "outlined",
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Search"
                        }),
                        dataTestId: "ispm-carousel-container-containerData-statInsightIconButton",
                        children: l("Review")
                    })
                })
            ]
        })
    });
}
var $641e695249580926$export$2e2bcd8739ae039 = $641e695249580926$var$Carousel;



function $20581865194beca7$var$Insights({ title: title, insightsList: insightsList }) {
    const [insightIndex, setInsightIndex] = (0, $cURGa$useState)(0);
    const handleNextInsight = ()=>{
        if (insightIndex >= Number(insightsList.length) - 1) return;
        setInsightIndex(insightIndex + 1);
    };
    const handlePreviousInsight = ()=>{
        if (insightIndex <= 0) return;
        setInsightIndex(insightIndex - 1);
    };
    const handleDotClick = (cardIndex)=>{
        setInsightIndex(cardIndex);
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-Insights-wrapper",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Insights-wrapper-insightIcon",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Spark",
                            color: "--color-foreground-neutral-bold"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h3",
                        color: "--color-foreground-neutral-bold",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $641e695249580926$export$2e2bcd8739ae039), {
                    reviewCompaignData: insightsList[insightIndex]
                })
            }),
            insightIndex > 0 && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Insights-wrapper-arrowIcon",
                children: [
                    insightIndex > 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Insights-wrapper-leftArrowIcon",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                            dataTestId: "ArrowLeft",
                            kind: "saviGhost",
                            onClick: handlePreviousInsight,
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "ArrowLeft",
                                color: "--color-foreground-neutral-bold"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Insights-wrapper-dotRevocation",
                        children: insightsList.slice(0, 3).map((_, idx)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                dataTestId: `dotButton-${idx + 1}`,
                                kind: "saviGhost",
                                onClick: ()=>handleDotClick(idx),
                                className: "Ispm-Insights-wrapper-revocationButton",
                                children: insightIndex === idx ? /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "8",
                                    height: "9",
                                    viewBox: "0 0 8 9",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                        cx: "4",
                                        cy: "4.5",
                                        r: "4",
                                        fill: "#B2BCFF"
                                    })
                                }) : /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "8",
                                    height: "9",
                                    viewBox: "0 0 8 9",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                        cx: "4",
                                        cy: "4.5",
                                        r: "4",
                                        fill: "#9EA1B1"
                                    })
                                })
                            }, `dotButton-${idx + 1}`))
                    }),
                    insightIndex < Number(insightsList.length) - 1 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Insights-wrapper-rightArrowIcon",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                            dataTestId: "ArrowRight",
                            kind: "saviGhost",
                            onClick: handleNextInsight,
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "ArrowRight",
                                color: "--color-foreground-neutral-bold"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $20581865194beca7$export$2e2bcd8739ae039 = $20581865194beca7$var$Insights;


/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 



function $e15ad698ba7a87fc$var$StatsTable({ statsList: statsList }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SummaryCard-Stats-wrapper",
        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
            className: "Ispm-SummaryCard-Stats-wrapper-campaignList",
            children: statsList.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-SummaryCard-Stats-wrapper-campaignItemList",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body2",
                            color: "--color-foreground-secondary-medium",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body-bold-1",
                            color: "--color-foreground-neutral-bold",
                            className: "Ispm-SummaryCard-Stats-wrapper-value",
                            children: value ?? 0
                        })
                    ]
                }, label ?? `${index}`))
        })
    });
}
var $e15ad698ba7a87fc$export$2e2bcd8739ae039 = $e15ad698ba7a87fc$var$StatsTable;




function $22ed29309658eb8a$var$getCompaignChartSpec({ data: data, label: label, value: value, showCustomTooltip: showCustomTooltip }) {
    return {
        autosize: {
            type: "fit",
            contains: "padding"
        },
        background: "transparent",
        width: 160,
        height: 160,
        data: {
            values: data
        },
        transform: [
            {
                window: [
                    {
                        op: "sum",
                        field: "value",
                        as: "total_value"
                    }
                ],
                frame: [
                    null,
                    null
                ]
            },
            {
                calculate: "(datum.value / datum.total_value) * 100",
                as: "percentage"
            },
            {
                calculate: "datum.category + ': ' + datum.value + ' (' + format(datum.percentage, '.1f') + '%)'",
                as: "customTooltip"
            }
        ],
        layer: [
            {
                mark: {
                    type: "arc",
                    innerRadius: 70,
                    outerRadius: 80
                },
                encoding: {
                    theta: {
                        field: "value",
                        type: "quantitative"
                    },
                    color: {
                        field: "range",
                        type: "nominal",
                        scale: null,
                        legend: null
                    },
                    ...showCustomTooltip && {
                        tooltip: {
                            field: "customTooltip",
                            type: "nominal",
                            formatType: "html"
                        }
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    fontWeight: "bold",
                    dy: -3
                },
                encoding: {
                    text: {
                        value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(Number(value))
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    align: "center",
                    fontSize: 12,
                    fontWeight: "normal",
                    dy: 22
                },
                encoding: {
                    text: {
                        value: label
                    }
                }
            }
        ]
    };
}
$22ed29309658eb8a$var$getCompaignChartSpec.defaultProps = {
    showCustomTooltip: true
};
var $22ed29309658eb8a$export$2e2bcd8739ae039 = $22ed29309658eb8a$var$getCompaignChartSpec;



function $80d18a0d8697fa1b$var$SummaryCard({ isLoading: isLoading, error: error, totalCompaign: totalCompaign, title: title, statsList: statsList, insightsData: insightsData, effectivenessData: effectivenessData, summaryChartData: summaryChartData }) {
    if (error) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {});
    if (isLoading) return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Certs-Loader",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
            kind: "loop",
            format: "main",
            color: "brand"
        })
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-SummaryCard-wrapper",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SummaryCard-wrapper-campaignsData",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-SummaryCard-wrapper-totalCampaigns",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "display4",
                                    color: "--color-foreground-neutral-bold",
                                    children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(totalCompaign)
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body1",
                                color: "--color-foreground-neutral-subtle",
                                className: "Ispm-SummaryCard-wrapper-campaigns",
                                children: title
                            })
                        ]
                    }),
                    summaryChartData && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SummaryCard-wrapper-vegaContainer",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $074a3236c52fafae$export$2e2bcd8739ae039), {
                            spec: (0, $22ed29309658eb8a$export$2e2bcd8739ae039)(summaryChartData ?? 0)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-SummaryCard-wrapper-details",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $e15ad698ba7a87fc$export$2e2bcd8739ae039), {
                        statsList: statsList
                    }),
                    effectivenessData?.classification && typeof effectivenessData.percentage === "number" && /*#__PURE__*/ (0, $cURGa$jsx)((0, $d0a645ba1ad76040$export$2e2bcd8739ae039), {
                        title: effectivenessData.title,
                        classification: effectivenessData.classification,
                        percentage: effectivenessData.percentage
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $20581865194beca7$export$2e2bcd8739ae039), {
                        title: insightsData?.title ?? "",
                        insightsList: insightsData?.insightsList ?? []
                    })
                ]
            })
        ]
    });
}
$80d18a0d8697fa1b$var$SummaryCard.defaultProps = {
    effectivenessData: null,
    insightsData: null,
    summaryChartData: null
};
var $80d18a0d8697fa1b$export$2e2bcd8739ae039 = $80d18a0d8697fa1b$var$SummaryCard;









/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $51ee9ef4cf6934f5$var$isValidCertsExpiringCampaignsSummaryCardApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $51ee9ef4cf6934f5$export$fa1bb9af062a2f6d = ()=>{
    // Use the custom `useFetch` hook to call the `getRevocationSummaryCardData` API function
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(// Passing the function and not the result directly
    ()=>$51ee9ef4cf6934f5$var$getExpiringCampaignsSummaryCardData());
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
// Fetch function to call the API and retrieve the revocation summary card data
const $51ee9ef4cf6934f5$var$getExpiringCampaignsSummaryCardData = async ()=>{
    const { GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_SUMMARYCARD_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_SUMMARYCARD_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        method: "GET",
        timeout: 30000
    };
    let url = GOVERNANCE_INSIGHTS_CERTS_EXPIRING_SOON_SUMMARYCARD_ENDPOINT;
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        time_period: "THIS_MONTH"
    });
    url = `${url}?${queryParams.toString()}`;
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $51ee9ef4cf6934f5$var$isValidCertsExpiringCampaignsSummaryCardApiResponse);
    return response.data;
};
var $51ee9ef4cf6934f5$export$2e2bcd8739ae039 = $51ee9ef4cf6934f5$var$getExpiringCampaignsSummaryCardData;


function $fb191a4220e61d15$var$CampaignsSummaryCard({ statsResponseData: statsResponseData, isStatsLoading: isStatsLoading }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { data: statsResponseAPIData, isLoading: isLoading, error: error } = (0, $51ee9ef4cf6934f5$export$fa1bb9af062a2f6d)();
    const statsSummaryData = statsResponseData ?? statsResponseAPIData;
    const totalCompaign = statsSummaryData?.totalCampaigns;
    // Memoized effectiveness data
    const effectivenessData = (0, $cURGa$useMemo)(()=>({
            title: l("Effectiveness"),
            classification: statsSummaryData?.effectiveness?.classification,
            percentage: statsSummaryData?.effectiveness?.percentage
        }), [
        l,
        statsSummaryData?.effectiveness
    ]);
    // Memoized summary chart data
    const summaryChartData = (0, $cURGa$useMemo)(()=>{
        if (statsSummaryData?.totalCerts === 0) return {
            label: l("Certifications"),
            value: statsSummaryData.totalCerts,
            data: [
                {
                    category: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns,
                    value: 100,
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns
                }
            ],
            showCustomTooltip: false
        };
        return {
            label: l("Certifications"),
            value: statsSummaryData?.totalCerts,
            data: (0, $31415264ab98c97b$export$1afcf11a27cbbadc).map((key)=>({
                    category: (0, $31415264ab98c97b$export$827b953b70c0e9f)[key],
                    value: statsSummaryData?.[key],
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8)[key]
                })),
            showCustomTooltip: true
        };
    }, [
        l,
        statsSummaryData
    ]);
    // Memoized stats list
    const statsList = (0, $cURGa$useMemo)(()=>[
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).CERTIFIERS,
                value: statsSummaryData?.totalCertifiers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).USER_BASE,
                value: statsSummaryData?.totalUsers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).ACCOUNTS,
                value: statsSummaryData?.totalAccounts
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).APPLICATIONS,
                value: statsSummaryData?.totalApps
            }
        ], [
        statsSummaryData
    ]);
    // Memoized insights data
    const insightsData = (0, $cURGa$useMemo)(()=>({
            title: l("Insights"),
            insightsList: statsSummaryData?.insights
        }), [
        l,
        statsSummaryData?.insights
    ]);
    // Early return for loading/error states
    if (isLoading || error) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        error: error,
        totalCompaign: 0,
        title: l("Campaigns"),
        statsList: [],
        insightsData: {
            title: "",
            insightsList: []
        },
        effectivenessData: {
            title: "",
            classification: "",
            percentage: 0
        },
        summaryChartData: {
            label: "",
            value: 0,
            data: [],
            showCustomTooltip: false
        }
    });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isStatsLoading ?? isLoading,
        error: error,
        totalCompaign: Number(totalCompaign),
        title: l("Campaigns"),
        statsList: statsList,
        insightsData: insightsData,
        effectivenessData: effectivenessData,
        summaryChartData: summaryChartData
    });
}
var $fb191a4220e61d15$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cURGa$react).memo($fb191a4220e61d15$var$CampaignsSummaryCard);



function $805f56299ca51a4f$var$CampaignsExpSoonDrillDownModal({ showCampaignsExpSoonModal: showCampaignsExpSoonModal, handleShowCampaignsExpSoonModalClose: handleShowCampaignsExpSoonModalClose }) {
    const [overriddenStats, setOverriddenStats] = (0, $cURGa$useState)(null);
    const [isLoadingOverrideStats, setIsLoadingOverrideStats] = (0, $cURGa$useState)(false);
    const [polarBarClickedId, setPolarBarClickedId] = (0, $cURGa$useState)(null);
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // Summary Card data computing
    const overrideStats = (newValues)=>{
        setOverriddenStats(newValues);
        setIsLoadingOverrideStats(false); // Reset loading after update
    };
    const refreshSummaryCard = (campaign)=>{
        setIsLoadingOverrideStats(true); // Start loading state
        setTimeout(()=>{
            if (!campaign) {
                setIsLoadingOverrideStats(false);
                return;
            }
            setPolarBarClickedId(campaign.id ?? "");
            const updatedStats = {
                ...campaign,
                totalCampaigns: 1,
                effectiveness: {},
                insights: []
            };
            overrideStats(updatedStats);
        }, 500); // Simulating API delay
    };
    const renderContent = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Certs-CampaignsExpSoon-drillDownModal-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $b35dda91de808f6a$export$2e2bcd8739ae039), {
                    refreshSummaryCard: refreshSummaryCard,
                    isPolarBarClicked: polarBarClickedId
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Ispm-Certs-CampaignsExpSoon-drillDownModal-contentWrapper-drillDownCard",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Certs-CampaignsExpSoon-drillDownModal-contentWrapper-summaryCard",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $fb191a4220e61d15$export$2e2bcd8739ae039), {
                            statsResponseData: overriddenStats,
                            isStatsLoading: isLoadingOverrideStats
                        })
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        className: "Ispm-Certs-CampaignsExpSoon-drillDownModal",
        isOpen: showCampaignsExpSoonModal,
        onClose: handleShowCampaignsExpSoonModalClose,
        isOutsideClickEnabled: true,
        title: l("Campaigns Expiring Soon"),
        contentBody: renderContent()
    });
}
var $805f56299ca51a4f$export$2e2bcd8739ae039 = $805f56299ca51a4f$var$CampaignsExpSoonDrillDownModal;




const $214787afe040c883$var$getCampaignsExpiringSoonDonutChartSpec = ({ expiringCampaignsCount: expiringCampaignsCount, data: data })=>({
        autosize: {
            type: "fit",
            contains: "padding"
        },
        background: "transparent",
        width: 136,
        height: 136,
        data: {
            values: data
        },
        layer: [
            {
                // Donut chart layer with custom colors
                mark: {
                    type: "arc",
                    innerRadius: 55
                },
                encoding: {
                    theta: {
                        field: "value",
                        type: "quantitative"
                    },
                    color: {
                        field: "category",
                        type: "nominal",
                        scale: {
                            domain: (0, $31415264ab98c97b$export$a774e6d73f253a89),
                            range: (0, $31415264ab98c97b$export$4b55535b14b833ae)
                        },
                        legend: null
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    dy: 0
                },
                encoding: {
                    text: {
                        value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(expiringCampaignsCount)
                    }
                }
            },
            {
                mark: {
                    type: "text",
                    dy: 15
                },
                encoding: {
                    text: {
                        value: "Campaigns"
                    }
                }
            }
        ],
        view: {
            stroke: null
        }
    });
var $214787afe040c883$export$2e2bcd8739ae039 = $214787afe040c883$var$getCampaignsExpiringSoonDonutChartSpec;



function $20817670f4c4cdf1$var$CampaignsExpiringSoon({ data: data }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const [showDrillDown, setShowDrillDown] = (0, $cURGa$useState)(false);
    const renderCampaignsExpiringSoonDrillDownModal = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $805f56299ca51a4f$export$2e2bcd8739ae039), {
            showCampaignsExpSoonModal: showDrillDown,
            handleShowCampaignsExpSoonModalClose: ()=>setShowDrillDown(false)
        });
    const getChartDataCategoryValueMapping = ()=>{
        if (data.expiringCampaignsCount === 0) return [
            {
                category: "zeroCampaigns",
                value: 100
            }
        ];
        return data.campaignExpiryTimeline.map((obj, index)=>({
                category: (0, $31415264ab98c97b$export$a774e6d73f253a89)[index],
                value: obj.count
            }));
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                dataTestId: "ispm-dashboard-campaignsExpiringSoon",
                className: "Ispm-Certs-CampExpSoon",
                clickHandler: ()=>setShowDrillDown(true),
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                        className: "Ispm-Certs-CampExpSoon-header",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "h1",
                                color: "--color-foreground-secondary-bold",
                                className: "Ispm-Certs-CampExpSoon-header-title",
                                children: l("Campaigns Expiring Soon")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                                className: "Ispm-Certs-CampExpSoon-header-infoTooltip",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "AlertInfoFilled",
                                        color: "info-600",
                                        size: "small"
                                    }),
                                    text: l("Displays soon-to-expire certification campaigns. Get insights on certification trends, workload, and status spikes to optimize scheduling."),
                                    placement: "left-start"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-Certs-CampExpSoon-stats",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-Certs-CampExpSoon-stats-labelsColumn",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "display4",
                                                color: "--color-foreground-neutral-bold",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(data.expiringCertificationsCount)
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body1",
                                                color: "--color-foreground-neutral-subtle",
                                                children: l("Affected Certifications")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-Certs-CampExpSoon-stats-trendColumn",
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $074a3236c52fafae$export$2e2bcd8739ae039), {
                                            spec: (0, $214787afe040c883$export$2e2bcd8739ae039)({
                                                expiringCampaignsCount: data.expiringCampaignsCount,
                                                data: getChartDataCategoryValueMapping()
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-Certs-CampExpSoon-timeUntilExpiration",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        kind: "body1",
                                        color: "--color-foreground-neutral-medium",
                                        children: "TIME UNTIL EXPIRATION"
                                    }),
                                    data.campaignExpiryTimeline.map((campaign, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: `Ispm-Certs-CampExpSoon-timeUntilExpiration-row ${(0, $31415264ab98c97b$export$a2c0215fc34a08c3)[index]}`,
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                    className: "Ispm-Certs-CampExpSoon-timeUntilExpiration-row-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                            kind: "body1",
                                                            color: "--color-foreground-neutral-bold",
                                                            children: (0, $31415264ab98c97b$export$a774e6d73f253a89)[index]
                                                        }),
                                                        /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                            kind: "body3",
                                                            color: "--color-foreground-secondary-medium",
                                                            children: [
                                                                (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(campaign.count),
                                                                " Campaigns"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                    kind: "h1",
                                                    color: "--color-foreground-neutral-bold",
                                                    children: [
                                                        (0, $31415264ab98c97b$export$c3e0f520a0aee8fc)(campaign.count, data.expiringCampaignsCount),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }))
                                ]
                            })
                        ]
                    })
                ]
            }),
            showDrillDown && renderCampaignsExpiringSoonDrillDownModal()
        ]
    });
}
var $20817670f4c4cdf1$export$2e2bcd8739ae039 = $20817670f4c4cdf1$var$CampaignsExpiringSoon;



























/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $e392e407fde18f9a$var$isValidCertsSnapshotCampaignsApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $e392e407fde18f9a$export$dab627a3bed6898f = (pageNumber, pageSize, sortBy)=>{
    const fetchFunction = (0, $cURGa$useCallback)(()=>$e392e407fde18f9a$var$getCertsSnapshotCampaignsData(pageNumber, pageSize, sortBy), [
        pageNumber,
        pageSize,
        sortBy
    ] // Ensures refetching when params change
    );
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(fetchFunction, [
        pageNumber
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        fetchFunction: fetchFunction
    };
};
const $e392e407fde18f9a$var$getCertsSnapshotCampaignsData = async (pageNumber, pageSize, sortBy)=>{
    const { GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_CAMPAIGN_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_CAMPAIGN_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    let url = GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_CAMPAIGN_ENDPOINT;
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        ...pageNumber != null && {
            next_page_token: pageNumber.toString()
        },
        page_size: pageSize.toString(),
        sort_by: sortBy.toString(),
        time_period: "LAST_YEAR"
    });
    url = `${url}?${queryParams.toString()}`;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $e392e407fde18f9a$var$isValidCertsSnapshotCampaignsApiResponse);
    return response.data;
};
var $e392e407fde18f9a$export$2e2bcd8739ae039 = $e392e407fde18f9a$var$getCertsSnapshotCampaignsData;



/**
 * Custom hook to process campaign data and generate a legend list based on drill-down keys.
 *
 * @param campaigns - Array of campaign data to be processed.
 * @param certificationsSnapshotDrillDownKeys - Keys to filter and process relevant values from the campaign data.
 *
 * @returns {
 *    processedCampaigns: Array of objects with campaign data and processed bar list.
 *    legendList: Array of PolarBarItem objects with names from `certificationsSnapshotDrillDownKeys` and values set to 0.
 * }
 *
 * Uses `useMemo` for performance optimization to recalculate only when inputs change.
 */ const $840a2ab1910b4fed$var$useCertificationsSnapshotCampaignsChartData = (campaigns, certificationsSnapshotDrillDownKeys)=>{
    // Memoize the processedCampaigns to avoid recalculating on every render
    const processedCampaigns = (0, $cURGa$useMemo)(()=>campaigns.map((campaign)=>{
            // Create the processedBarList for each campaign
            const processedBarList = Object.entries(campaign).filter(([key, value])=>certificationsSnapshotDrillDownKeys.includes(key) && typeof value === "number" && value > 0).map(([key, value])=>({
                    name: key,
                    value: value
                }));
            return {
                campaign: campaign,
                processedBarList: processedBarList
            };
        }), [
        campaigns,
        certificationsSnapshotDrillDownKeys
    ]);
    // Memoize the legendList to avoid recalculating on every render
    const legendList = (0, $cURGa$useMemo)(()=>certificationsSnapshotDrillDownKeys.map((key)=>({
                name: key,
                value: 0
            })), [
        certificationsSnapshotDrillDownKeys
    ]);
    return {
        processedCampaigns: processedCampaigns,
        legendList: legendList
    };
};
var $840a2ab1910b4fed$export$2e2bcd8739ae039 = $840a2ab1910b4fed$var$useCertificationsSnapshotCampaignsChartData;


function $2dd1e8659c3c2138$var$CertificationsSnapshotPolarBars({ refreshSummaryCard: refreshSummaryCard, isPolarBarClicked: isPolarBarClicked }) {
    const [campaigns, setCampaigns] = (0, $cURGa$useState)([]);
    const [nextPageToken, setNextPageToken] = (0, $cURGa$useState)(null);
    const [isInitialLoading, setIsInitialLoading] = (0, $cURGa$useState)(true);
    const observer = (0, $cURGa$useRef)(null);
    const { data: campaignsResponse, isLoading: campaignsDataLoading, error: campaignsDataError } = (0, $e392e407fde18f9a$export$dab627a3bed6898f)(nextPageToken, 10, "LARGEST_TO_SMALLEST");
    const campaignsData = (0, $cURGa$useMemo)(()=>campaignsResponse?.campaigns || [], [
        campaignsResponse?.campaigns
    ]);
    const { processedCampaigns: processedCampaigns, legendList: legendList } = (0, $840a2ab1910b4fed$export$2e2bcd8739ae039)(campaigns, (0, $31415264ab98c97b$export$cc622da8d324ace1));
    const lastElementRef = (0, $cURGa$useCallback)((node)=>{
        if (!node || campaignsDataLoading || !campaignsResponse?.nextPageToken) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setNextPageToken(campaignsResponse.nextPageToken);
        }, {
            threshold: 1.0
        });
        observer.current.observe(node);
    }, [
        campaignsResponse,
        campaignsDataLoading
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (campaignsData.length) setCampaigns((prevData)=>{
            const existingIds = new Set(prevData.map((item)=>item.id));
            const newData = campaignsData.filter((item)=>!existingIds.has(item.id));
            return [
                ...prevData,
                ...newData
            ];
        });
        if (isInitialLoading && campaignsData.length > 0) setIsInitialLoading(false);
    }, [
        campaignsData,
        isInitialLoading
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Certs-Loader",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                        kind: "loop",
                        format: "main",
                        color: "brand",
                        dataTestId: "campaignLoader"
                    })
                })
            }),
            campaignsDataError && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            }),
            !campaignsDataLoading && !campaignsDataError && !campaigns.length && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $9b654484cc1973d6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            }),
            !campaignsDataError && processedCampaigns.length > 0 && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-chartViz-polarBar",
                        children: [
                            processedCampaigns.map(({ campaign: campaign, processedBarList: processedBarList }, index)=>{
                                const isLastElement = index === processedCampaigns.length - 1;
                                return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    ref: isLastElement ? lastElementRef : null,
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $0ad40c91a0c246cc$export$2e2bcd8739ae039), {
                                        title: campaign.name || "",
                                        subTitle: campaign.type || "",
                                        barList: processedBarList,
                                        count: campaign.totalEntitlements || 0,
                                        isPolarBarClicked: isPolarBarClicked === campaign.id,
                                        refreshSummaryCard: ()=>refreshSummaryCard(campaign),
                                        dataTestId: `ispm-dashboard-certificationSnapshot-campaign-${campaign.name || ""}`
                                    })
                                }, campaign.id || `${index}`);
                            }),
                            !isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityList-loader",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                                    kind: "loop",
                                    format: "main",
                                    color: "brand"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            })
        ]
    });
}
var $2dd1e8659c3c2138$export$2e2bcd8739ae039 = $2dd1e8659c3c2138$var$CertificationsSnapshotPolarBars;












/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $839aebfe8b319469$var$isValidCertsSnapshotCampaignsSummaryCardApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $839aebfe8b319469$export$c6d274de87eadf83 = ()=>{
    // Use the custom `useFetch` hook to call the `getCertificationsSnapshotCampaignsSummaryCardData` API function
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(// Passing the function and not the result directly
    ()=>$839aebfe8b319469$var$getCertificationsSnapshotCampaignsSummaryCardData());
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
// Fetch function to call the API and retrieve the snapshot summary card data
const $839aebfe8b319469$var$getCertificationsSnapshotCampaignsSummaryCardData = async ()=>{
    const { GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_SUMMARYCARD_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_SUMMARYCARD_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        method: "GET",
        timeout: 30000
    };
    let url = GOVERNANCE_INSIGHTS_CERTS_CERTIFICATIONS_SNAPSHOT_SUMMARYCARD_ENDPOINT;
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        time_period: "LAST_YEAR"
    });
    url = `${url}?${queryParams.toString()}`;
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $839aebfe8b319469$var$isValidCertsSnapshotCampaignsSummaryCardApiResponse);
    return response.data;
};
var $839aebfe8b319469$export$2e2bcd8739ae039 = $839aebfe8b319469$var$getCertificationsSnapshotCampaignsSummaryCardData;


function $36ffe7ae75996366$var$CertificationsSnapshotSummaryCard({ statsResponseData: statsResponseData, isStatsLoading: isStatsLoading }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { data: statsResponseAPIData, isLoading: isLoading, error: error } = (0, $839aebfe8b319469$export$c6d274de87eadf83)();
    const statsSummaryData = statsResponseData ?? statsResponseAPIData;
    const totalCompaign = statsSummaryData?.totalCampaigns;
    // Memoized effectiveness data
    const effectivenessData = (0, $cURGa$useMemo)(()=>({
            title: l("Effectiveness"),
            classification: statsSummaryData?.effectiveness?.classification,
            percentage: statsSummaryData?.effectiveness?.percentage
        }), [
        l,
        statsSummaryData?.effectiveness
    ]);
    // Memoized summary chart data
    const summaryChartData = (0, $cURGa$useMemo)(()=>{
        if (statsSummaryData?.totalCertifiers === 0) return {
            label: l("Certifications"),
            value: statsSummaryData.totalCerts,
            data: [
                {
                    category: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns,
                    value: 100,
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns
                }
            ],
            showCustomTooltip: false
        };
        return {
            label: l("Certifications"),
            value: statsSummaryData?.totalCerts,
            data: (0, $31415264ab98c97b$export$cc622da8d324ace1).map((key)=>({
                    category: (0, $31415264ab98c97b$export$827b953b70c0e9f)[key],
                    value: statsSummaryData?.[key],
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8)[key]
                })),
            showCustomTooltip: true
        };
    }, [
        l,
        statsSummaryData
    ]);
    // Memoized stats list
    const statsList = (0, $cURGa$useMemo)(()=>[
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).CERTIFIERS,
                value: statsSummaryData?.totalCertifiers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).USER_BASE,
                value: statsSummaryData?.totalUsers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).ACCOUNTS,
                value: statsSummaryData?.totalAccounts
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).APPLICATIONS,
                value: statsSummaryData?.totalApps
            }
        ], [
        statsSummaryData
    ]);
    // Memoized insights data
    const insightsData = (0, $cURGa$useMemo)(()=>({
            title: l("Insights"),
            insightsList: statsSummaryData?.insights
        }), [
        l,
        statsSummaryData?.insights
    ]);
    // Early return for loading/error states
    if (isLoading || error) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        error: error,
        totalCompaign: 0,
        title: l("Campaigns"),
        statsList: [],
        insightsData: {
            title: "",
            insightsList: []
        },
        effectivenessData: {
            title: "",
            classification: "",
            percentage: 0
        },
        summaryChartData: {
            label: "",
            value: 0,
            data: [],
            showCustomTooltip: false
        }
    });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isStatsLoading ?? isLoading,
        error: error,
        totalCompaign: Number(totalCompaign),
        title: l("Campaigns"),
        statsList: statsList,
        insightsData: insightsData,
        effectivenessData: effectivenessData,
        summaryChartData: summaryChartData
    });
}
var $36ffe7ae75996366$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cURGa$react).memo($36ffe7ae75996366$var$CertificationsSnapshotSummaryCard);



function $d4cf1eb6b1cb4d67$var$CertificationsSnapshotDrillDownModal({ showCertificationsSnapshotModal: showCertificationsSnapshotModal, handleShowCertificationsSnapshotModalClose: handleShowCertificationsSnapshotModalClose }) {
    const [overriddenStats, setOverriddenStats] = (0, $cURGa$useState)(null);
    const [isLoadingOverrideStats, setIsLoadingOverrideStats] = (0, $cURGa$useState)(false);
    const [polarBarClickedId, setPolarBarClickedId] = (0, $cURGa$useState)(null);
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // Summary Card data computing
    const overrideStats = (newValues)=>{
        setOverriddenStats(newValues);
        setIsLoadingOverrideStats(false); // Reset loading after update
    };
    const refreshSummaryCard = (campaign)=>{
        setIsLoadingOverrideStats(true); // Start loading state
        setTimeout(()=>{
            if (!campaign) {
                setIsLoadingOverrideStats(false);
                return;
            }
            setPolarBarClickedId(campaign.id ?? "");
            const updatedStats = {
                ...campaign,
                totalCampaigns: 1,
                effectiveness: {},
                insights: []
            };
            overrideStats(updatedStats);
        }, 500); // Simulating API delay
    };
    const renderContent = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $2dd1e8659c3c2138$export$2e2bcd8739ae039), {
                    refreshSummaryCard: refreshSummaryCard,
                    isPolarBarClicked: polarBarClickedId
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-drillDownCard",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Certs-CertsSnapshot-drillDownModal-contentWrapper-summaryCard",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $36ffe7ae75996366$export$2e2bcd8739ae039), {
                            statsResponseData: overriddenStats,
                            isStatsLoading: isLoadingOverrideStats
                        })
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        className: "Ispm-Certs-CertsSnapshot-drillDownModal",
        isOpen: showCertificationsSnapshotModal,
        onClose: handleShowCertificationsSnapshotModalClose,
        isOutsideClickEnabled: true,
        title: l("Certification Snapshot"),
        contentBody: renderContent()
    });
}
var $d4cf1eb6b1cb4d67$export$2e2bcd8739ae039 = $d4cf1eb6b1cb4d67$var$CertificationsSnapshotDrillDownModal;



function $2e411e2791502678$var$CertificationSnapshot({ certificationSnapshotData: certificationSnapshotData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const [showDrillDown, setShowDrillDown] = (0, $cURGa$useState)(false);
    const renderCertificationSnapshotDrillDownModal = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $d4cf1eb6b1cb4d67$export$2e2bcd8739ae039), {
            showCertificationsSnapshotModal: showDrillDown,
            handleShowCertificationsSnapshotModalClose: ()=>setShowDrillDown(false)
        });
    const currentYearValue = certificationSnapshotData.campaignsTimeSeriesData[0].completedCampaignsCount;
    const prevYearValue = certificationSnapshotData.campaignsTimeSeriesData[1].completedCampaignsCount;
    // const pecentageYearToDateValue =
    //   ((currentYearValue - prevYearValue) * 100) / prevYearValue;
    let pecentageYearToDateValue = 0;
    if (currentYearValue === 0) pecentageYearToDateValue = 0;
    else if (prevYearValue === 0) pecentageYearToDateValue = 100;
    else pecentageYearToDateValue = (currentYearValue - prevYearValue) / prevYearValue * 100;
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                className: "Ispm-Certs-CertsSnapshot",
                dataTestId: "ispm-dashboard-certificationSnapshot",
                clickHandler: ()=>setShowDrillDown(true),
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                        className: "Ispm-Certs-CertsSnapshot-header",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "h1",
                                color: "--color-foreground-secondary-bold",
                                className: "Ispm-Certs-CertsSnapshot-header-title",
                                children: l("Certification Snapshot")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                                className: "Ispm-Certs-CertsSnapshot-header-infoTooltip",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "AlertInfoFilled",
                                        color: "info-600",
                                        size: "small"
                                    }),
                                    text: l("Provides a cross-section of past certification activity including overruled trust scores and birthright access."),
                                    placement: "left-start"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-Certs-CertsSnapshot-completedCampaigns",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-Certs-CertsSnapshot-campaignsCertification",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "display4",
                                                color: "--color-foreground-neutral-bold",
                                                className: "Ispm-Certs-CertsSnapshot-campaignsCount",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(certificationSnapshotData.completedCampaignsCount)
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body1",
                                                color: "--color-foreground-neutral-subtle",
                                                className: "Ispm-Certs-CertsSnapshot-campaignsHeading",
                                                children: l("Completed campaigns")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-Certs-CertsSnapshot-campaignsDivider"
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-Certs-CertsSnapshot-snapshotPervalue",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                className: "Ispm-Certs-CertsSnapshot-yearToDate",
                                                children: [
                                                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                        kind: "display4",
                                                        className: "Ispm-Certs-CertsSnapshot-campaignsPercentage",
                                                        children: [
                                                            pecentageYearToDateValue > 0 ? "+" : "",
                                                            " ",
                                                            pecentageYearToDateValue === 0 ? 0 : pecentageYearToDateValue.toFixed(1),
                                                            "%"
                                                        ]
                                                    }),
                                                    pecentageYearToDateValue !== 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                        className: "Ispm-Certs-CertsSnapshot-campaignsIcon",
                                                        children: pecentageYearToDateValue > 0 ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                            kind: "TrendUp",
                                                            size: "xxSmall",
                                                            color: "--color-foreground-purple-medium"
                                                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                            kind: "TrendDown",
                                                            size: "xxSmall",
                                                            color: "--color-foreground-purple-medium"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body1",
                                                color: "--color-foreground-neutral-subtle",
                                                className: "Ispm-Certs-CertsSnapshot-campaignsDate",
                                                children: l("Year to date")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-Certs-CertsSnapshot-certificationsummary",
                                children: certificationSnapshotData.certificationsSummary.map((item, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: index % 2 === 0 ? "Ispm-Certs-CertsSnapshot-campaignsCategorylight" : "Ispm-Certs-CertsSnapshot-campaignsCategorydark",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                className: "Ispm-Certs-CertsSnapshot-categoryItems",
                                                children: [
                                                    /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                                                        className: "Ispm-Certs-CertsSnapshot-bullet",
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                                                                width: "9",
                                                                height: "9",
                                                                viewBox: "0 0 9 9",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                                                    id: "Bullet",
                                                                    cx: "4.7124",
                                                                    cy: "4.77344",
                                                                    r: "4",
                                                                    fill: "#66ACFF"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body1",
                                                        className: "Ispm-Certs-CertsSnapshot-categoryItemscampaigns",
                                                        children: item.category
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body1",
                                                className: "Ispm-Certs-CertsSnapshot-categoryCount",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(item.count)
                                            })
                                        ]
                                    }))
                            })
                        ]
                    })
                ]
            }),
            showDrillDown && renderCertificationSnapshotDrillDownModal()
        ]
    });
}
var $2e411e2791502678$export$2e2bcd8739ae039 = $2e411e2791502678$var$CertificationSnapshot;




























/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $a8823beca1a7aae6$var$isValidCertsRevocationCampaignsApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $a8823beca1a7aae6$export$dc871bbe27735217 = (pageNumber, pageSize, sortBy)=>{
    const fetchFunction = (0, $cURGa$useCallback)(()=>$a8823beca1a7aae6$var$getRevocationCampaignsData(pageNumber, pageSize, sortBy), [
        pageNumber,
        pageSize,
        sortBy
    ] // Ensures refetching when params change
    );
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(fetchFunction, [
        pageNumber
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        fetchFunction: fetchFunction
    };
};
const $a8823beca1a7aae6$var$getRevocationCampaignsData = async (pageNumber, pageSize, sortBy)=>{
    const { GOVERNANCE_INSIGHTS_CERTS_REVOCATION_CAMPAIGN_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_REVOCATION_CAMPAIGN_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    let url = GOVERNANCE_INSIGHTS_CERTS_REVOCATION_CAMPAIGN_ENDPOINT;
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        ...pageNumber != null && {
            next_page_token: pageNumber.toString()
        },
        page_size: pageSize.toString(),
        sort_by: sortBy.toString()
    });
    url = `${url}?${queryParams.toString()}`;
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(url, config, $a8823beca1a7aae6$var$isValidCertsRevocationCampaignsApiResponse);
    return response.data;
};
var $a8823beca1a7aae6$export$2e2bcd8739ae039 = $a8823beca1a7aae6$var$getRevocationCampaignsData;



/**
 * Custom hook to process campaign data and generate a legend list based on drill-down keys.
 *
 * @param campaigns - Array of campaign data to be processed.
 * @param revocationEffectivenessDrillDownKeys - Keys to filter and process relevant values from the campaign data.
 *
 * @returns {
 *    processedCampaigns: Array of objects with campaign data and processed bar list.
 *    legendList: Array of PolarBarItem objects with names from `revocationEffectivenessDrillDownKeys` and values set to 0.
 * }
 *
 * Uses `useMemo` for performance optimization to recalculate only when inputs change.
 */ const $d72ee9aebb4e7f86$var$useRevocationChartData = (campaigns, revocationEffectivenessDrillDownKeys)=>{
    // Memoize the processedCampaigns to avoid recalculating on every render
    const processedCampaigns = (0, $cURGa$useMemo)(()=>campaigns.map((campaign)=>{
            // Create the processedBarList for each campaign
            const processedBarList = Object.entries(campaign).filter(([key, value])=>revocationEffectivenessDrillDownKeys.includes(key) && typeof value === "number" && value > 0).map(([key, value])=>({
                    name: key,
                    value: value
                }));
            return {
                campaign: campaign,
                processedBarList: processedBarList
            };
        }), [
        campaigns,
        revocationEffectivenessDrillDownKeys
    ]);
    // Memoize the legendList to avoid recalculating on every render
    const legendList = (0, $cURGa$useMemo)(()=>revocationEffectivenessDrillDownKeys.map((key)=>({
                name: key,
                value: 0
            })), [
        revocationEffectivenessDrillDownKeys
    ]);
    return {
        processedCampaigns: processedCampaigns,
        legendList: legendList
    };
};
var $d72ee9aebb4e7f86$export$2e2bcd8739ae039 = $d72ee9aebb4e7f86$var$useRevocationChartData;


function $4a862802e95095ef$var$RevocationEffectivenessPolarBar({ refreshSummaryCard: refreshSummaryCard, isPolarBarClicked: isPolarBarClicked }) {
    const [campaigns, setCampaigns] = (0, $cURGa$useState)([]);
    const [nextPageToken, setNextPageToken] = (0, $cURGa$useState)(null);
    const [isInitialLoading, setIsInitialLoading] = (0, $cURGa$useState)(true);
    const observer = (0, $cURGa$useRef)(null);
    const { data: campaignsResponse, isLoading: campaignsDataLoading, error: campaignsDataError } = (0, $a8823beca1a7aae6$export$dc871bbe27735217)(nextPageToken, 10, "LARGEST_TO_SMALLEST");
    const campaignsData = (0, $cURGa$useMemo)(()=>campaignsResponse?.campaigns || [], [
        campaignsResponse?.campaigns
    ]);
    const { processedCampaigns: processedCampaigns, legendList: legendList } = (0, $d72ee9aebb4e7f86$export$2e2bcd8739ae039)(campaigns, (0, $31415264ab98c97b$export$17382f8e98d727e7));
    const lastElementRef = (0, $cURGa$useCallback)((node)=>{
        if (!node || campaignsDataLoading || !campaignsResponse?.nextPageToken) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setNextPageToken(campaignsResponse.nextPageToken);
        }, {
            threshold: 1.0
        });
        observer.current.observe(node);
    }, [
        campaignsResponse,
        campaignsDataLoading
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (campaignsData.length) setCampaigns((prevData)=>{
            const existingIds = new Set(prevData.map((item)=>item.id));
            const newData = campaignsData.filter((item)=>!existingIds.has(item.id));
            return [
                ...prevData,
                ...newData
            ];
        });
        if (isInitialLoading && campaignsData.length > 0) setIsInitialLoading(false);
    }, [
        campaignsData,
        isInitialLoading
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Certs-Loader",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                        kind: "loop",
                        format: "main",
                        color: "brand",
                        dataTestId: "campaignLoader"
                    })
                })
            }),
            campaignsDataError && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-chartViz",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
            }),
            !campaignsDataLoading && !campaignsDataError && !campaigns.length && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $9b654484cc1973d6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            }),
            !campaignsDataError && processedCampaigns.length > 0 && /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
                className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-chartViz",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-chartViz-polarBar",
                        children: [
                            processedCampaigns.map(({ campaign: campaign, processedBarList: processedBarList }, index)=>{
                                const isLastElement = index === processedCampaigns.length - 1;
                                return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    ref: isLastElement ? lastElementRef : null,
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $0ad40c91a0c246cc$export$2e2bcd8739ae039), {
                                        title: campaign.name || "",
                                        subTitle: campaign.type || "",
                                        barList: processedBarList,
                                        count: campaign.revocationsTotal || 0,
                                        isPolarBarClicked: isPolarBarClicked === campaign.id,
                                        refreshSummaryCard: ()=>refreshSummaryCard(campaign),
                                        dataTestId: `ispm-dashboard-revocationEfectiveness-campaign-${campaign.name || ""}`
                                    })
                                }, campaign.id || `${index}`);
                            }),
                            !isInitialLoading && campaignsDataLoading && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityList-loader",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                                    kind: "loop",
                                    format: "main",
                                    color: "brand"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-ChartLegend-wrapper",
                        children: legendList.map((legend, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e280fb9f6095ebf3$export$2e2bcd8739ae039), {
                                legendList: legend
                            }, legend.name || `${index}`))
                    })
                ]
            })
        ]
    });
}
var $4a862802e95095ef$export$2e2bcd8739ae039 = $4a862802e95095ef$var$RevocationEffectivenessPolarBar;












/**
 * Function to validate the API response structure.
 * @param response - API response to validate.
 * @returns True if valid, false otherwise.
 */ function $41bc4f42ab59e856$var$isValidCertsRevocationSummaryCardApiResponse(data) {
    (0, $cURGa$Logger).log("Validating API response structure...");
    if (!data || typeof data !== "object" || !("data" in data) || typeof data !== "object") {
        (0, $cURGa$Logger).error("Validation failed: Response is not an object or missing 'campaigns' key.");
        return false;
    }
    (0, $cURGa$Logger).log("Validation successful: API response structure is valid.");
    return true;
}
const $41bc4f42ab59e856$export$e373012b67da724 = ()=>{
    // Use the custom `useFetch` hook to call the `getRevocationSummaryCardData` API function
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)(// Passing the function and not the result directly
    ()=>$41bc4f42ab59e856$var$getRevocationSummaryCardData());
    // Return the API response, loading state, and error for further use
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
// Fetch function to call the API and retrieve the revocation summary card data
const $41bc4f42ab59e856$var$getRevocationSummaryCardData = async ()=>{
    const { GOVERNANCE_INSIGHTS_CERTS_REVOCATION_SUMMARYCARD_ENDPOINT: GOVERNANCE_INSIGHTS_CERTS_REVOCATION_SUMMARYCARD_ENDPOINT } = (0, $8ff2252602deef38$export$3bd61fd385cbb93e)();
    const config = {
        method: "GET",
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(GOVERNANCE_INSIGHTS_CERTS_REVOCATION_SUMMARYCARD_ENDPOINT, config, $41bc4f42ab59e856$var$isValidCertsRevocationSummaryCardApiResponse);
    return response.data;
};
var $41bc4f42ab59e856$export$2e2bcd8739ae039 = $41bc4f42ab59e856$var$getRevocationSummaryCardData;


function $75329d298b320477$var$RevocationSummaryCard({ statsResponseData: statsResponseData, isStatsLoading: isStatsLoading }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { data: statsResponseAPIData, isLoading: isLoading, error: error } = (0, $41bc4f42ab59e856$export$e373012b67da724)();
    const statsSummaryData = statsResponseData ?? statsResponseAPIData;
    const totalCompaign = statsSummaryData?.totalCampaigns;
    // Memoized effectiveness data
    const effectivenessData = (0, $cURGa$useMemo)(()=>({
            title: l("Effectiveness"),
            classification: statsSummaryData?.effectiveness?.classification,
            percentage: statsSummaryData?.effectiveness?.percentage
        }), [
        l,
        statsSummaryData?.effectiveness
    ]);
    // Memoized summary chart data
    const summaryChartData = (0, $cURGa$useMemo)(()=>{
        if (statsSummaryData?.revocationsTotal === 0) return {
            label: l("Certifications"),
            value: statsSummaryData.revocationsTotal,
            data: [
                {
                    category: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns,
                    value: 100,
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8).zeroCampaigns
                }
            ],
            showCustomTooltip: false
        };
        return {
            label: l("Certifications"),
            value: statsSummaryData?.revocationsTotal,
            data: (0, $31415264ab98c97b$export$17382f8e98d727e7).map((key)=>({
                    category: (0, $31415264ab98c97b$export$827b953b70c0e9f)[key],
                    value: statsSummaryData?.[key],
                    range: (0, $31415264ab98c97b$export$a4c54d344edf09d8)[key]
                })),
            showCustomTooltip: true
        };
    }, [
        l,
        statsSummaryData
    ]);
    // Memoized stats list
    const statsList = (0, $cURGa$useMemo)(()=>[
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).CERTIFIERS,
                value: statsSummaryData?.totalCertifiers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).USER_BASE,
                value: statsSummaryData?.totalUsers
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).ACCOUNTS,
                value: statsSummaryData?.totalAccounts
            },
            {
                label: (0, $31415264ab98c97b$export$7a810838d74c869b).APPLICATIONS,
                value: statsSummaryData?.totalApps
            }
        ], [
        statsSummaryData
    ]);
    // Memoized insights data
    const insightsData = (0, $cURGa$useMemo)(()=>({
            title: l("Insights"),
            insightsList: statsSummaryData?.insights
        }), [
        l,
        statsSummaryData?.insights
    ]);
    // Early return for loading/error states
    if (isLoading || error) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        error: error,
        totalCompaign: 0,
        title: l("Campaigns"),
        statsList: [],
        insightsData: {
            title: "",
            insightsList: []
        },
        effectivenessData: {
            title: "",
            classification: "",
            percentage: 0
        },
        summaryChartData: {
            label: "",
            value: 0,
            data: [],
            showCustomTooltip: false
        }
    });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $80d18a0d8697fa1b$export$2e2bcd8739ae039), {
        isLoading: isStatsLoading ?? isLoading,
        error: error,
        totalCompaign: Number(totalCompaign),
        title: l("Campaigns"),
        statsList: statsList,
        insightsData: insightsData,
        effectivenessData: effectivenessData,
        summaryChartData: summaryChartData
    });
}
var $75329d298b320477$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cURGa$react).memo($75329d298b320477$var$RevocationSummaryCard);



function $ce5b61607d0c793c$var$RevocationEffectivenessDrillDownModal({ showRevocationModal: showRevocationModal, handleShowRevocationModalClose: handleShowRevocationModalClose }) {
    const [overriddenStats, setOverriddenStats] = (0, $cURGa$useState)(null);
    const [isLoadingOverrideStats, setIsLoadingOverrideStats] = (0, $cURGa$useState)(false);
    const [polarBarClickedId, setPolarBarClickedId] = (0, $cURGa$useState)(null);
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // Summary Card data computing
    const overrideStats = (newValues)=>{
        setOverriddenStats(newValues);
        setIsLoadingOverrideStats(false); // Reset loading after update
    };
    const refreshSummaryCard = (campaign)=>{
        setIsLoadingOverrideStats(true); // Start loading state
        setTimeout(()=>{
            if (!campaign) {
                setIsLoadingOverrideStats(false);
                return;
            }
            setPolarBarClickedId(campaign.id ?? "");
            const updatedStats = {
                ...campaign,
                totalCampaigns: 1,
                // effectiveness: {}, // Ensure this matches the expected type
                insights: []
            };
            overrideStats(updatedStats);
        }, 500); // Simulating API delay
    };
    const renderContent = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $4a862802e95095ef$export$2e2bcd8739ae039), {
                    refreshSummaryCard: refreshSummaryCard,
                    isPolarBarClicked: polarBarClickedId
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                    className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-drillDownCard",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Certs-RevocEffect-drillDownModal-contentWrapper-summaryCard",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $75329d298b320477$export$2e2bcd8739ae039), {
                            statsResponseData: overriddenStats,
                            isStatsLoading: isLoadingOverrideStats
                        })
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        className: "Ispm-Certs-RevocEffect-drillDownModal",
        isOpen: showRevocationModal,
        onClose: handleShowRevocationModalClose,
        isOutsideClickEnabled: true,
        title: l("Revocation Effectiveness"),
        contentBody: renderContent()
    });
}
var $ce5b61607d0c793c$export$2e2bcd8739ae039 = $ce5b61607d0c793c$var$RevocationEffectivenessDrillDownModal;



function $6e90d9e96a9837be$var$RevocationEffectiveness({ revocationData: revocationData }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const [showDrillDown, setShowDrillDown] = (0, $cURGa$useState)(false);
    // Precompute percentages for progress bars
    const revocationPercentages = revocationData.revocationsSummary.map((item)=>{
        let percentage = "0";
        if (item.revokeCount === 0) percentage = "0";
        else if (revocationData.totalRevokeJobs === 0) percentage = "100";
        else percentage = (item.revokeCount / revocationData.totalRevokeJobs * 100).toFixed(1);
        return percentage;
    });
    // Precompute the revocation data rows with category and revoke count
    const revocationRows = revocationData.revocationsSummary.map((campaign, index)=>{
        let percentage = "0";
        if (campaign.revokeCount === 0) percentage = "0";
        else if (revocationData.totalRevokeJobs === 0) percentage = "100";
        else percentage = (campaign.revokeCount / revocationData.totalRevokeJobs * 100).toFixed(1);
        return {
            category: campaign.category,
            revokeCount: campaign.revokeCount,
            percentage: percentage,
            borderLeftClass: (0, $31415264ab98c97b$export$a2c0215fc34a08c3)[index],
            rangeColor: (0, $31415264ab98c97b$export$a774e6d73f253a89)[index]
        };
    });
    const renderRevocationEffectivenessDrillDownModal = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $ce5b61607d0c793c$export$2e2bcd8739ae039), {
            showRevocationModal: showDrillDown,
            handleShowRevocationModalClose: ()=>setShowDrillDown(false)
        });
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                className: "Ispm-Certs-RevocationEffectiveness",
                dataTestId: "ispm-dashboard-revocationEffectiveness",
                clickHandler: ()=>setShowDrillDown(true),
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$5665775b26e26c5d), {
                        className: "Ispm-Certs-RevocationEffectiveness-header",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "h1",
                                color: "--color-foreground-secondary-bold",
                                className: "Ispm-Certs-RevocationEffectiveness-header-title",
                                children: l("Revocation Effectiveness")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                                className: "Ispm-Certs-RevocationEffectiveness-header-infoTooltip",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "AlertInfoFilled",
                                        color: "info-600",
                                        size: "small"
                                    }),
                                    text: l("Tracks certification effectiveness by measuring access revocations. Get insights on revoke delays or failures."),
                                    placement: "left-start"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $2998b537cc21621c$export$851de33184ecdac4), {
                        className: "Ispm-Certs-RevocationEffectiveness-cardBody",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-Certs-CampExpSoon-stats",
                                children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    className: "Ispm-Certs-CampExpSoon-stats-dataRow",
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "display4",
                                            color: "--color-foreground-neutral-bold",
                                            children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(revocationData.averageRevokesPerCampaign)
                                        }),
                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                            kind: "body1",
                                            color: "--color-foreground-neutral-subtle",
                                            children: l("Median revokes per campaign")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body1",
                                color: "--color-foreground-neutral-medium",
                                children: l("CURRENT REVOCATIONS (ALL CAMPAIGNS)")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-Certs-CampExpSoon-stats-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-Certs-CampExpSoon-stats-dataRow",
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                            className: "Ispm-Certs-CampExpSoon-stats-dataRow-progressBar",
                                            children: revocationPercentages.map((percentage, index)=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                    className: "Ispm-Certs-CampExpSoon-stats-dataRow-progressBar-progress",
                                                    style: {
                                                        width: `${percentage}%`,
                                                        display: percentage === "0" || 0 ? "none" : "block",
                                                        background: `${(0, $31415264ab98c97b$export$4b55535b14b833ae)[index]}`
                                                    }
                                                }, `percentageValue${percentage}` || `${index}`))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-Certs-CampExpSoon-stats-trendColumn",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body1",
                                                color: "--color-foreground-secondary-bold",
                                                children: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(revocationData.totalRevokeJobs)
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body3",
                                                color: "--color-foreground-secondary-medium",
                                                children: l("Revoke Jobs")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-Certs-CampExpSoon-timeUntilExpiration",
                                children: revocationRows.map((row, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: `Ispm-Certs-CampExpSoon-timeUntilExpiration-row ${row.borderLeftClass}`,
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                className: "Ispm-Certs-CampExpSoon-timeUntilExpiration-row-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body1",
                                                        color: "--color-foreground-neutral-bold",
                                                        children: row.category
                                                    }),
                                                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                        kind: "body3",
                                                        color: "--color-foreground-secondary-medium",
                                                        children: [
                                                            (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(row.revokeCount),
                                                            " ",
                                                            l("Revokes")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                kind: "h1",
                                                color: "--color-foreground-neutral-bold",
                                                children: [
                                                    row.percentage,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, row.category || `${index}`))
                            })
                        ]
                    })
                ]
            }),
            showDrillDown && renderRevocationEffectivenessDrillDownModal()
        ]
    });
}
var $6e90d9e96a9837be$export$2e2bcd8739ae039 = $6e90d9e96a9837be$var$RevocationEffectiveness;



function $c42a2e2fbc5d9d56$var$Certifications() {
    const { data: certsData, isLoading: isCertsDataLoading, error: isCertsDataError } = (0, $3ac793aa418a359a$export$11181267b7052d14)();
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Certs",
        children: isCertsDataLoading ? /*#__PURE__*/ (0, $cURGa$jsx)("section", {
            className: "Certs-Loader",
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "loop",
                format: "main",
                color: "brand"
            })
        }) : /*#__PURE__*/ (0, $cURGa$jsxs)("section", {
            className: "Certs-Content",
            children: [
                !isCertsDataError && certsData?.expiringCampaigns ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $20817670f4c4cdf1$export$2e2bcd8739ae039), {
                    data: certsData.expiringCampaigns
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                    className: "Ispm-ActiveUsersWithInactiveManagers",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                }),
                !isCertsDataError && certsData?.campaignsRevocationOverview ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $6e90d9e96a9837be$export$2e2bcd8739ae039), {
                    revocationData: certsData.campaignsRevocationOverview
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                    className: "Ispm-Certs-RevocationEffectiveness",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                }),
                !isCertsDataError && certsData?.certificationInsights ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $2e411e2791502678$export$2e2bcd8739ae039), {
                    certificationSnapshotData: certsData.certificationInsights
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $2998b537cc21621c$export$21e76ed09a093e97), {
                    className: "Ispm-Certs-CertsSnapshot",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $c42a2e2fbc5d9d56$export$2e2bcd8739ae039 = $c42a2e2fbc5d9d56$var$Certifications;













function $2fc442ead903fb00$var$DarkTheme() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: 600,
        height: 626,
        viewBox: "0 0 600 626",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask0_10967_101901",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: -4,
                y: -2,
                width: 629,
                height: 627,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M-3.48242 -1.73633L-3.48242 624.264H624.982V-1.73633L-3.48242 -1.73633ZM310.759 478.423C213.823 478.423 135.232 400.141 135.232 303.585C135.232 207.029 213.823 128.746 310.759 128.746C407.695 128.746 486.285 207.029 486.285 303.585C486.285 400.141 407.695 478.423 310.759 478.423Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask0_10967_101901)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M353.071 32.4685C346.398 31.5314 339.656 30.8025 332.827 30.334L312.966 313.234L353.071 32.4685Z",
                                fill: "url(#paint0_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.507 313.304L312.444 313.2L332.34 29.7617L332.88 29.7964C339.605 30.265 346.417 30.9938 353.16 31.9309L353.682 32.0003L353.613 32.521L313.507 313.286V313.304ZM333.333 30.8897L314.552 298.414L352.463 32.9201C346.104 32.035 339.675 31.3582 333.333 30.8897Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M374.52 27.2107C367.725 25.7703 360.844 24.5382 353.857 23.5664L312.985 313.234L374.52 27.228V27.2107Z",
                                fill: "url(#paint1_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.509 313.338L312.464 313.148L353.406 22.959L353.928 23.0284C360.81 23.9829 367.761 25.215 374.643 26.69L375.166 26.7941L313.509 313.338ZM354.312 24.1738L315.6 298.57L373.894 27.6271C367.396 26.2562 360.81 25.0935 354.312 24.1738Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M390.391 46.004C384.05 44.1819 377.586 42.568 371.035 41.1797L312.985 313.234L390.409 46.0214L390.391 46.004Z",
                                fill: "url(#paint2_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.492 313.372L312.464 313.112L370.636 40.5371L371.159 40.6412C377.622 42.0122 384.138 43.6434 390.567 45.4829L391.072 45.6391L390.915 46.1424L313.492 313.372ZM371.437 41.8039L316.61 298.777L389.73 46.3679C383.685 44.6499 377.535 43.1055 371.437 41.8039Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M407.727 55.2904C401.594 53.0518 395.357 51.0214 388.981 49.1992L312.969 313.218L407.71 55.2904H407.727Z",
                                fill: "url(#paint3_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.474 313.409L312.464 313.079L388.615 48.5391L389.138 48.6779C395.41 50.4654 401.717 52.5131 407.919 54.7691L408.424 54.96L408.233 55.4632L313.492 313.391L313.474 313.409ZM389.347 49.8753L317.603 299.074L407.031 55.6194C401.194 53.5022 395.253 51.576 389.347 49.8753Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M431.647 48.9542C425.375 46.1602 418.946 43.5571 412.395 41.1797L312.985 313.234L431.647 48.9542Z",
                                fill: "url(#paint4_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.473 313.443L312.48 313.043L412.065 40.4863L412.57 40.6599C419.033 43.0026 425.532 45.623 431.856 48.4517L432.344 48.6599L432.135 49.1458L313.473 313.425V313.443ZM412.709 41.8573L318.596 299.421L430.933 49.2152C424.94 46.5601 418.807 44.0786 412.709 41.8573Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M442.831 70.9412C437.082 67.8869 431.176 65.0062 425.131 62.3164L312.985 313.234L442.849 70.9412H442.831Z",
                                fill: "url(#paint5_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.455 313.477L312.497 313.009L424.869 61.6055L425.357 61.8311C431.315 64.4688 437.291 67.3843 443.092 70.4732L443.563 70.7162L443.319 71.1847L313.455 313.477ZM425.409 63.0112L319.553 299.837L442.117 71.15C436.629 68.2519 431.019 65.5101 425.409 63.0112Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.782 88.0176C449.433 84.6857 443.928 81.4926 438.266 78.5078L312.967 313.234L454.782 88.0176Z",
                                fill: "url(#paint6_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.438 313.512L312.515 312.974L438.058 77.7793L438.528 78.0223C444.103 80.9724 449.661 84.1828 455.079 87.5494L455.532 87.8271L455.253 88.2783L313.438 313.495V313.512ZM438.493 79.2197L320.459 300.341L454.051 88.1915C448.964 85.0331 443.737 82.0136 438.493 79.2197Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M464.173 106.672C459.259 103.115 454.207 99.6961 448.981 96.4336L312.984 313.233L464.19 106.672H464.173Z",
                                fill: "url(#paint7_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.403 313.546L312.515 312.956L448.79 95.7051L449.243 95.9827C454.382 99.1758 459.504 102.629 464.469 106.239L464.905 106.551L464.591 106.985L313.386 313.546H313.403ZM449.155 97.1628L321.365 300.878L463.442 106.777C458.772 103.41 453.981 100.182 449.155 97.1628Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M490.568 103.133C485.585 98.9504 480.411 94.907 475.045 91.0371L312.968 313.234L490.568 103.133Z",
                                fill: "url(#paint8_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.386 313.564L312.55 312.904L474.94 90.2734L475.376 90.5858C480.655 94.4036 485.881 98.4817 490.934 102.716L491.335 103.063L490.986 103.462L313.386 313.564ZM475.167 91.7658L322.184 301.503L489.819 103.202C485.063 99.2279 480.132 95.3928 475.167 91.7832V91.7658Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M509.906 110.786C505.098 106.153 500.098 101.641 494.888 97.2852L312.985 313.235L509.924 110.786H509.906Z",
                                fill: "url(#paint9_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.369 313.599L312.567 312.888L494.819 96.5391L495.22 96.8862C500.359 101.173 505.412 105.719 510.273 110.405L510.656 110.769L313.352 313.599H313.369ZM494.959 98.0315L323.003 302.163L509.158 110.786C504.576 106.379 499.802 102.092 494.959 98.0315Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M518.199 129.788C513.844 124.946 509.279 120.243 504.523 115.645L312.985 313.216L518.217 129.788H518.199Z",
                                fill: "url(#paint10_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.333 313.633L312.584 312.87L504.505 114.916L504.888 115.28C509.575 119.792 514.192 124.565 518.599 129.441L518.965 129.84L518.565 130.205L313.333 313.651V313.633ZM504.54 116.408L323.752 302.891L517.45 129.753C513.286 125.155 508.948 120.677 504.54 116.408Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M517.887 154.309C514.106 149.485 510.134 144.747 505.97 140.131L312.969 313.217L517.887 154.309Z",
                                fill: "url(#paint11_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.3 313.651L312.62 312.835L506.005 139.385L506.371 139.784C510.482 144.331 514.507 149.12 518.322 153.997L518.653 154.413L313.317 313.651H313.3ZM505.935 140.895L324.45 303.672L517.155 154.222C513.566 149.658 509.802 145.181 505.952 140.895H505.935Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M532.486 166.283C529.002 161.112 525.308 156.027 521.389 151.029L312.986 313.217L532.486 166.283Z",
                                fill: "url(#paint12_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.281 313.668L312.654 312.801L521.475 150.283L521.806 150.7C525.656 155.611 529.402 160.747 532.921 165.971L533.217 166.405L532.764 166.7L313.264 313.634L313.281 313.668ZM521.283 151.793L325.076 304.488L531.736 166.145C528.409 161.233 524.889 156.409 521.283 151.793Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M551.998 176.296C548.74 170.674 545.273 165.103 541.562 159.637L312.968 313.217L551.998 176.296Z",
                                fill: "url(#paint13_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.247 313.686L312.689 312.783L541.737 158.891L542.033 159.324C545.674 164.704 549.193 170.327 552.486 176.019L552.747 176.487L552.277 176.748L313.247 313.668V313.686ZM541.44 160.383L325.669 305.356L551.284 176.105C548.183 170.743 544.873 165.468 541.44 160.383Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M568.811 189.468C565.867 183.446 562.696 177.476 559.281 171.576L312.969 313.217L568.811 189.45V189.468Z",
                                fill: "url(#paint14_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.212 313.703L312.707 312.766L559.473 170.848L559.734 171.316C563.096 177.112 566.302 183.151 569.281 189.243L569.508 189.728L569.02 189.954L313.177 313.721L313.212 313.703ZM559.089 172.305L326.192 306.241L568.096 189.225C565.274 183.481 562.26 177.789 559.089 172.305Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M568.81 210.76C566.371 204.738 563.706 198.751 560.814 192.816L312.985 313.216L568.828 210.76H568.81Z",
                                fill: "url(#paint15_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.178 313.72L312.742 312.748L561.058 192.105L561.285 192.591C564.142 198.44 566.842 204.496 569.299 210.57L569.49 211.056L569.003 211.247L313.16 313.703L313.178 313.72ZM560.57 193.546L326.645 307.195L568.114 210.483C565.797 204.756 563.253 199.064 560.57 193.546Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.525 225.841C582.452 219.437 580.135 213.068 577.574 206.734L312.985 313.217L584.542 225.841H584.525Z",
                                fill: "url(#paint16_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.142 313.738L312.776 312.732L577.87 206.041L578.079 206.527C580.605 212.757 582.957 219.195 585.048 225.668L585.205 226.171L313.142 313.721V313.738ZM577.278 207.447L327.045 308.15L583.863 225.512C581.877 219.421 579.664 213.347 577.278 207.447Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M593.479 244.064C591.841 237.453 589.942 230.858 587.799 224.281L312.967 313.236L593.479 244.064Z",
                                fill: "url(#paint17_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.107 313.739L312.811 312.715L588.148 223.604L588.305 224.107C590.413 230.58 592.329 237.244 593.985 243.925L594.107 244.445L593.584 244.567L313.072 313.739H313.107ZM587.469 224.957L327.358 309.14L592.835 243.682C591.249 237.365 589.455 231.083 587.469 224.957Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.612 265.998C583.497 259.594 582.138 253.191 580.535 246.787L312.985 313.234L584.612 265.998Z",
                                fill: "url(#paint18_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.072 313.755L312.846 312.713L580.918 246.145L581.04 246.665C582.626 252.965 584.002 259.437 585.135 265.91L585.222 266.431L584.699 266.518L313.072 313.755ZM580.134 247.429L327.602 310.145L583.985 265.563C582.904 259.472 581.615 253.381 580.134 247.429Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M541.022 289.738C540.464 284.358 539.715 278.979 538.757 273.564L312.968 313.218L541.022 289.738Z",
                                fill: "url(#paint19_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.038 313.756L312.898 312.697L539.21 272.957L539.297 273.478C540.238 278.805 541.005 284.254 541.562 289.686L541.615 290.224L313.038 313.773V313.756ZM538.322 274.189L327.777 311.17L540.43 289.27C539.89 284.22 539.176 279.152 538.322 274.189Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M538.425 305.773C538.251 300.463 537.885 295.118 537.31 289.756L312.967 313.235L538.425 305.773Z",
                                fill: "url(#paint20_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.002 313.756L312.933 312.697L537.816 289.148L537.868 289.686C538.426 294.979 538.809 300.394 538.983 305.756V306.294L313.02 313.773L313.002 313.756ZM536.84 290.328L327.881 312.211L537.868 305.253C537.694 300.272 537.346 295.257 536.84 290.328Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M578.983 322.589C579.209 316.324 579.226 310.007 578.983 303.639L312.966 312.888L578.965 322.589H578.983Z",
                                fill: "url(#paint21_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M579.489 323.143H578.949L312.949 313.425V312.367L579.506 303.1V303.638C579.75 309.902 579.733 316.288 579.506 322.623V323.16L579.489 323.143ZM327.932 312.904L578.461 322.033C578.67 316.08 578.67 310.076 578.461 304.176L327.915 312.887L327.932 312.904Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.897 340.985C574.559 334.841 574.995 328.629 575.221 322.347L312.985 313.219L573.897 340.985Z",
                                fill: "url(#paint22_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M574.368 341.574L573.828 341.522L312.916 313.756L312.986 312.697L575.762 321.843V322.381C575.518 328.558 575.082 334.841 574.42 341.053L574.368 341.574ZM327.899 314.276L573.427 340.394C574.037 334.546 574.455 328.663 574.682 322.849L327.899 314.259V314.276Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.457 361.372C585.607 354.968 586.53 348.495 587.21 341.935L312.987 313.232L584.457 361.389V361.372Z",
                                fill: "url(#paint23_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.874 361.997L584.352 361.91L312.882 313.754L313.039 312.695L587.801 341.468L587.749 342.006C587.07 348.461 586.129 355.021 584.979 361.477L584.892 361.997H584.874ZM327.778 315.316L584.003 360.765C585.083 354.674 585.955 348.513 586.617 342.422L327.778 315.316Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M589.229 382.337C590.866 375.829 592.295 369.217 593.48 362.501L312.968 313.234L589.229 382.337Z",
                                fill: "url(#paint24_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M589.629 382.978L589.107 382.857L312.846 313.754L313.072 312.713L594.107 362.067L594.02 362.587C592.852 369.199 591.424 375.88 589.751 382.457L589.629 382.978ZM327.602 316.34L588.845 381.694C590.396 375.481 591.755 369.182 592.87 362.934L327.602 316.34Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M566.161 395.647C568.112 389.677 569.872 383.604 571.422 377.426L312.967 313.234L566.161 395.647Z",
                                fill: "url(#paint25_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M566.51 396.306L566.005 396.149L312.811 313.737L313.107 312.713L572.068 377.026L571.946 377.546C570.43 383.62 568.653 389.763 566.667 395.802L566.51 396.306ZM327.341 317.346L565.813 394.969C567.66 389.277 569.332 383.516 570.778 377.807L327.341 317.346Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.41 418.537C575.901 412.393 578.218 406.129 580.291 399.743L312.985 313.234L573.41 418.554V418.537Z",
                                fill: "url(#paint26_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.689 419.232L573.201 419.023L312.776 313.704L313.142 312.697L580.954 399.379L580.797 399.882C578.741 406.182 576.424 412.516 573.898 418.711L573.689 419.197V419.232ZM327.028 318.337L573.114 417.843C575.483 411.995 577.678 406.008 579.63 400.073L327.045 318.32L327.028 318.337Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M569.579 438.424C572.558 432.385 575.328 426.189 577.906 419.838L312.987 313.217L569.579 438.406V438.424Z",
                                fill: "url(#paint27_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M569.821 439.135L312.742 313.702L313.178 312.73L578.602 419.543L578.411 420.028C575.867 426.276 573.062 432.54 570.065 438.649L569.821 439.135ZM326.627 319.29L569.334 437.694C572.156 431.933 574.804 426.033 577.208 420.115L326.645 319.273L326.627 319.29Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M543.827 446.493C546.998 441.061 549.994 435.474 552.799 429.73L312.985 313.217L543.827 446.493Z",
                                fill: "url(#paint28_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M544.019 447.222L312.707 313.685L313.212 312.748L553.514 429.486L553.27 429.972C550.5 435.612 547.486 441.27 544.28 446.771L544.019 447.239V447.222ZM326.174 320.227L543.618 445.764C546.615 440.593 549.455 435.282 552.068 429.972L326.174 320.227Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M531.039 460.272C534.523 455.136 537.868 449.843 541.022 444.376L312.968 313.234L531.022 460.272H531.039Z",
                                fill: "url(#paint29_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M531.179 461.001L530.743 460.706L312.689 313.668L313.264 312.766L541.772 444.185L541.51 444.654C538.392 450.033 535.029 455.378 531.493 460.584L531.196 461.018L531.179 461.001ZM325.651 321.13L530.9 459.526C534.21 454.632 537.364 449.617 540.308 444.567L325.669 321.13H325.651Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.383 486.129C538.495 480.906 542.432 475.509 546.213 469.938L312.967 313.234L534.383 486.147V486.129Z",
                                fill: "url(#paint30_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.489 486.893L534.071 486.563L312.654 313.651L313.281 312.783L546.98 469.799L546.684 470.233C542.956 475.734 538.966 481.201 534.82 486.459L534.489 486.876V486.893ZM325.076 321.998L534.315 485.4C538.217 480.42 541.963 475.283 545.5 470.094L325.076 321.998Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M526.214 505.131C530.779 500.099 535.187 494.893 539.438 489.461L312.969 313.217L526.214 505.114V505.131Z",
                                fill: "url(#paint31_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M526.266 505.878L525.866 505.514L312.62 313.616L313.3 312.801L540.187 489.357L539.856 489.774C535.674 495.119 531.214 500.394 526.615 505.462L526.249 505.861L526.266 505.878ZM324.432 322.814L526.197 504.386C530.535 499.579 534.733 494.598 538.706 489.566L324.432 322.814Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M475.968 481.912C479.975 478.077 483.878 474.068 487.658 469.886L312.985 313.217L475.986 481.912H475.968Z",
                                fill: "url(#paint32_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M475.95 482.677L475.584 482.295L312.584 313.6L313.333 312.836L488.407 469.852L488.041 470.251C484.313 474.364 480.375 478.425 476.334 482.312L475.95 482.677ZM323.734 323.595L475.985 481.167C479.748 477.54 483.407 473.774 486.891 469.939L323.717 323.595H323.734Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M493.32 528.038C498.425 523.787 503.408 519.327 508.269 514.659L312.985 313.217L493.32 528.038Z",
                                fill: "url(#paint33_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M493.251 528.801L492.903 528.385L312.567 313.563L313.369 312.852L509.036 514.675L508.652 515.04C503.861 519.638 498.826 524.15 493.669 528.437L493.251 528.784V528.801ZM322.968 324.305L493.391 527.291C498.251 523.23 502.99 518.979 507.52 514.64L322.986 324.305H322.968Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M463.842 520.802C468.773 517.244 473.616 513.496 478.337 509.539L312.968 313.234L463.842 520.819V520.802Z",
                                fill: "url(#paint34_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M463.738 521.547L463.424 521.114L312.55 313.529L313.386 312.869L479.104 509.591L478.686 509.938C474.034 513.825 469.139 517.625 464.156 521.218L463.72 521.53L463.738 521.547ZM322.167 324.965L463.964 520.055C468.633 516.671 473.216 513.113 477.589 509.469L322.167 324.965Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.434 539.561C459.817 536.229 465.096 532.689 470.305 528.923L312.967 313.234L454.416 539.579L454.434 539.561Z",
                                fill: "url(#paint35_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.259 540.307L453.981 539.856L312.531 313.512L313.42 312.922L471.072 529.045L470.636 529.357C465.514 533.071 460.165 536.646 454.73 540.03L454.277 540.307H454.259ZM321.329 325.59L454.608 538.85C459.712 535.674 464.73 532.307 469.556 528.819L321.329 325.59Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M450.759 572.394C456.909 569.149 462.989 565.661 468.999 561.93L312.985 313.234L450.759 572.394Z",
                                fill: "url(#paint36_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M450.532 573.106L312.497 313.477L313.42 312.939L469.713 562.087L469.26 562.364C463.372 566.043 457.222 569.566 450.985 572.846L450.514 573.089L450.532 573.106ZM320.441 326.128L450.967 571.666C456.856 568.542 462.657 565.21 468.25 561.757L320.441 326.146V326.128Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M436.349 590.496C442.935 587.581 449.468 584.44 455.914 581.004L312.967 313.219L436.332 590.496H436.349Z",
                                fill: "url(#paint37_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M436.071 591.206L435.862 590.721L312.497 313.443L313.455 312.975L456.647 581.228L456.176 581.471C449.817 584.838 443.214 588.031 436.577 590.981L436.089 591.189L436.071 591.206ZM319.518 326.615L436.612 589.783C442.901 586.99 449.155 583.97 455.183 580.777L319.501 326.615H319.518Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M398.458 548.414C404.05 546.401 409.59 544.179 415.113 541.732L312.985 313.236L398.475 548.414H398.458Z",
                                fill: "url(#paint38_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M398.144 549.089L397.97 548.586L312.48 313.409L313.473 313.01L415.828 541.992L415.34 542.2C409.922 544.612 404.294 546.868 398.65 548.899L398.144 549.072V549.089ZM318.561 327.049L398.772 547.736C404.051 545.81 409.312 543.71 414.399 541.471L318.561 327.066V327.049Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M384.851 564.481C390.81 562.78 396.768 560.871 402.691 558.72L312.985 313.217L384.851 564.464V564.481Z",
                                fill: "url(#paint39_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M384.486 565.14L312.464 313.373L313.474 313.043L403.355 559.049L402.849 559.223C397.013 561.34 391.002 563.283 384.974 564.984L384.469 565.123L384.486 565.14ZM317.586 327.395L385.218 563.821C390.88 562.207 396.525 560.385 401.996 558.407L317.586 327.395Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M371.645 590.477C378.231 589.089 384.816 587.475 391.384 585.601L312.985 313.234L371.663 590.477H371.645Z",
                                fill: "url(#paint40_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M371.246 591.102L371.141 590.581L312.464 313.338L313.492 313.078L392.048 585.948L391.542 586.104C385.061 587.943 378.424 589.592 371.768 590.998L371.246 591.102ZM316.593 327.69L372.065 589.852C378.336 588.516 384.609 586.972 390.724 585.236L316.575 327.69H316.593Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M348.524 568.334C354.587 567.501 360.65 566.442 366.73 565.158L312.966 313.234L348.524 568.334Z",
                                fill: "url(#paint41_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M348.072 568.924L348.003 568.404L312.444 313.304L313.49 313.113L367.359 565.557L366.836 565.662C360.86 566.928 354.71 568.004 348.595 568.855L348.072 568.924ZM315.563 327.899L348.996 567.727C354.728 566.911 360.494 565.922 366.104 564.742L315.563 327.899Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M331.276 580.429C337.618 579.995 343.994 579.336 350.388 578.451L312.966 313.234L331.276 580.429Z",
                                fill: "url(#paint42_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M330.79 580.985L330.755 580.447L312.444 313.253L313.507 313.148L350.999 578.886L350.477 578.955C344.187 579.84 337.741 580.499 331.33 580.951L330.79 580.985ZM314.535 328.038L331.783 579.84C337.811 579.424 343.874 578.781 349.797 577.966L314.535 328.02V328.038Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.48 602.505C319.345 602.505 326.261 602.28 333.23 601.811L312.968 313.254L312.48 602.523V602.505Z",
                                fill: "url(#paint43_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.915 603.025C312.776 603.025 312.636 603.025 312.48 603.025H311.939V602.487L312.427 313.218L313.49 313.184L333.787 602.279L333.247 602.314C326.539 602.782 319.692 603.025 312.898 603.025H312.915ZM313.49 328.108L313.02 601.949C319.57 601.949 326.173 601.724 332.654 601.29L313.473 328.108H313.49Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M294.674 567.676C300.719 568.11 306.817 568.336 312.967 568.336V313.236L294.674 567.676Z",
                                fill: "url(#paint44_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.508 568.856H312.968C306.905 568.856 300.737 568.63 294.64 568.196L294.1 568.161L294.134 567.624L312.428 313.184L313.49 313.218V568.856H313.508ZM295.25 567.19C300.981 567.589 306.748 567.797 312.445 567.797V328.125L295.25 567.19Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M272.931 593.603C279.586 594.54 286.328 595.269 293.14 595.737L312.967 313.236L272.931 593.603Z",
                                fill: "url(#paint45_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M293.646 596.309L293.106 596.274C286.399 595.806 279.569 595.094 272.862 594.14L272.339 594.07L272.409 593.55L312.444 313.184L313.507 313.288L293.629 596.327L293.646 596.309ZM273.541 593.151C279.883 594.036 286.311 594.713 292.653 595.164L311.399 328.038L273.541 593.151Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M264.482 538.624C269.831 539.77 275.267 540.724 280.772 541.505L312.985 313.234L264.482 538.624Z",
                                fill: "url(#paint46_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M281.225 542.096L280.703 542.026C275.284 541.263 269.796 540.291 264.378 539.145L263.855 539.041L312.463 313.131L313.508 313.322L281.225 542.113V542.096ZM265.11 538.208C270.145 539.267 275.267 540.169 280.302 540.898L310.355 327.899L265.11 538.208Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M245.057 547.648C250.632 549.244 256.294 550.667 262.043 551.882L312.968 313.217L245.057 547.648Z",
                                fill: "url(#paint47_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M262.462 552.524L261.939 552.42C256.277 551.223 250.545 549.8 244.917 548.169L244.412 548.012L244.569 547.509L312.48 313.078L313.508 313.338L262.462 552.524ZM245.719 547.284C250.98 548.776 256.329 550.112 261.625 551.258L309.344 327.673L245.719 547.284Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M230.354 538.156C235.702 540.099 241.138 541.869 246.695 543.466L312.969 313.234L230.354 538.173V538.156Z",
                                fill: "url(#paint48_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M247.061 544.125L246.538 543.986C241.068 542.424 235.562 540.637 230.162 538.676L229.656 538.485L229.848 537.982L312.463 313.061L313.474 313.39L247.043 544.142L247.061 544.125ZM231.05 537.843C236.085 539.665 241.225 541.331 246.347 542.806L308.352 327.395L231.05 537.843Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M218.228 524.238C223.245 526.477 228.367 528.542 233.611 530.451L312.986 313.234L218.245 524.238H218.228Z",
                                fill: "url(#paint49_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M233.924 531.127L233.419 530.953C228.262 529.079 223.07 526.996 218.001 524.74L217.513 524.515L217.739 524.029L312.48 313.025L313.473 313.424L233.924 531.127ZM218.941 523.96C223.663 526.042 228.488 528.003 233.297 529.756L307.375 327.03L218.959 523.96H218.941Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M193.471 536.214C198.767 539.025 204.203 541.68 209.76 544.144L312.986 313.219L193.471 536.196V536.214Z",
                                fill: "url(#paint50_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M210.039 544.855L209.551 544.647C204.064 542.217 198.558 539.528 193.227 536.699L192.757 536.456L193.001 535.987L312.516 313.01L313.474 313.478L210.039 544.89V544.855ZM194.185 536.005C199.203 538.66 204.342 541.159 209.482 543.449L306.401 326.615L194.168 536.005H194.185Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M157.041 560.854C162.93 564.533 168.975 568.021 175.195 571.318L312.968 313.217L157.041 560.854Z",
                                fill: "url(#paint51_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M175.421 572.048L174.951 571.805C168.818 568.56 162.703 565.037 156.763 561.323L156.31 561.046L156.588 560.594L312.515 312.957L313.439 313.495L175.421 572.065V572.048ZM157.79 560.699C163.418 564.204 169.202 567.536 174.986 570.608L305.494 326.129L157.79 560.699Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M159.081 523.474C164.081 527.101 169.238 530.572 174.552 533.887L312.97 313.234L159.081 523.474Z",
                                fill: "url(#paint52_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M174.725 534.615L174.272 534.338C169.028 531.075 163.802 527.552 158.767 523.908L158.331 523.596L158.645 523.162L312.533 312.922L313.422 313.512L174.708 534.615H174.725ZM159.829 523.353C164.568 526.771 169.464 530.069 174.377 533.158L304.606 325.573L159.829 523.353Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M144.741 512.264C149.463 516.221 154.376 520.056 159.446 523.735L312.986 313.234L144.741 512.264Z",
                                fill: "url(#paint53_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M159.55 524.481L159.114 524.168C154.114 520.541 149.149 516.671 144.375 512.68L143.975 512.333L144.323 511.934L312.567 312.904L313.404 313.564L159.55 524.498V524.481ZM145.49 512.194C149.985 515.942 154.619 519.569 159.323 522.988L303.769 324.965L145.49 512.211V512.194Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M121.098 510.476C125.784 514.988 130.662 519.379 135.732 523.631L312.966 313.234L121.08 510.476H121.098Z",
                                fill: "url(#paint54_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M135.802 524.376L135.401 524.029C130.401 519.864 125.471 515.421 120.732 510.857L120.349 510.493L312.601 312.852L313.402 313.563L135.819 524.376H135.802ZM121.847 510.458C126.324 514.762 130.959 518.927 135.663 522.866L302.949 324.27L121.847 510.441V510.458Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M118.556 487.014C122.685 491.596 127.005 496.056 131.518 500.411L312.968 313.234L118.556 487.014Z",
                                fill: "url(#paint55_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M131.534 501.158L131.151 500.794C126.708 496.507 122.335 491.996 118.171 487.379L117.806 486.98L118.206 486.616L312.619 312.836L313.368 313.6L131.534 501.158ZM119.321 487.05C123.241 491.388 127.335 495.622 131.517 499.649L302.218 323.578L119.321 487.05Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M86.5869 488.802C90.7508 494.129 95.1412 499.353 99.7581 504.472L312.986 313.234L86.5869 488.802Z",
                                fill: "url(#paint56_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M99.7222 505.219L99.3562 504.82C94.8091 499.787 90.3665 494.512 86.1678 489.132L85.8369 488.715L312.654 312.818L313.334 313.634L99.7222 505.219ZM87.3352 488.889C91.3248 493.974 95.5059 498.954 99.7918 503.709L301.504 322.797L87.3177 488.889H87.3352Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.1113 466.433C87.7525 471.83 91.6028 477.123 95.6796 482.329L312.967 313.234L84.1113 466.433Z",
                                fill: "url(#paint57_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M95.5927 483.075L95.2616 482.659C91.2371 477.539 87.3345 472.177 83.6759 466.728L83.3799 466.294L83.8154 465.999L312.671 312.801L313.298 313.668L95.5927 483.093V483.075ZM84.8607 466.572C88.3277 471.691 92.0038 476.741 95.7844 481.566L300.876 321.963L84.8607 466.572Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M73.9551 450.155C77.213 455.778 80.68 461.348 84.3908 466.815L312.985 313.234L73.9551 450.155Z",
                                fill: "url(#paint58_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.2345 467.561L83.9382 467.127C80.297 461.747 76.7778 456.125 73.485 450.433L73.2236 449.964L73.6941 449.704L312.724 312.783L313.299 313.686L84.2519 467.578L84.2345 467.561ZM74.6872 450.346C77.7884 455.708 81.0986 460.984 84.5307 466.068L300.302 321.096L74.6872 450.346Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M77.9971 426.901C80.6975 432.437 83.6068 437.921 86.7427 443.335L312.968 313.234L77.9971 426.901Z",
                                fill: "url(#paint59_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M86.5684 444.046L86.307 443.577C83.2233 438.25 80.2617 432.714 77.5439 427.109L77.3174 426.623L77.805 426.397L312.776 312.73L313.281 313.668L86.6032 444.029L86.5684 444.046ZM78.711 427.143C81.2895 432.384 84.0595 437.59 86.9516 442.606L299.762 320.21L78.711 427.143Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.1415 415.691C59.5805 421.712 62.2463 427.699 65.1383 433.634L312.967 313.234L57.124 415.691H57.1415Z",
                                fill: "url(#paint60_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M64.8953 434.345L64.6688 433.86C61.8116 428.029 59.1112 421.99 56.6547 415.881L56.4629 415.395L56.9508 415.204L312.793 312.748L313.229 313.72L64.9127 434.363L64.8953 434.345ZM57.8393 415.985C60.1738 421.729 62.7174 427.421 65.383 432.922L299.308 319.273L57.8393 415.985Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M37.4033 401.912C39.5114 408.402 41.8634 414.875 44.4593 421.296L312.967 313.234L37.4033 401.912Z",
                                fill: "url(#paint61_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M44.162 421.99L43.9704 421.504C41.4094 415.17 39.0225 408.645 36.897 402.085L36.7402 401.582L312.827 312.748L313.193 313.755L44.1795 422.007L44.162 421.99ZM38.0818 402.241C40.1027 408.436 42.3501 414.597 44.7718 420.584L298.924 318.301L38.0818 402.241Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M74.1825 372.115C75.5762 377.738 77.1965 383.361 79.0084 388.949L312.969 313.234L74.165 372.115H74.1825Z",
                                fill: "url(#paint62_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M78.6775 389.624L78.5033 389.121C76.7089 383.603 75.0711 377.928 73.6599 372.236L73.5381 371.715L74.0608 371.594L312.864 312.713L313.161 313.737L78.6775 389.624ZM74.8273 372.496C76.1514 377.807 77.6845 383.117 79.357 388.288L298.596 317.329L74.8273 372.496Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M41.3408 360.471C42.4558 366.875 43.8147 373.278 45.4175 379.682L312.968 313.234L41.3408 360.471Z",
                                fill: "url(#paint63_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.0337 380.323L44.9116 379.802C43.3262 373.485 41.9499 367.013 40.8175 360.557L40.7305 360.036L41.253 359.95L312.88 312.713L313.106 313.754L45.0337 380.323ZM41.9674 360.904C43.0475 366.978 44.3367 373.069 45.8176 379.039L298.35 316.322L41.9674 360.904Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M55.0186 339.801C55.6457 345.875 56.4994 351.983 57.5795 358.092L312.987 313.232L55.0186 339.801Z",
                                fill: "url(#paint64_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.1436 358.7L57.0567 358.179C55.9939 352.158 55.1227 345.997 54.4955 339.854L54.4434 339.316L54.9833 339.264L312.951 312.695L313.108 313.754L57.1785 358.7H57.1436ZM55.5931 340.27C56.2028 346.032 57.0217 351.811 57.9973 357.468L298.16 315.281L55.5931 340.27Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M33.3965 322.484C33.623 329.078 34.076 335.69 34.7729 342.354L312.985 313.234L33.3965 322.484Z",
                                fill: "url(#paint65_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M34.3025 342.943L34.2502 342.423C33.5533 335.846 33.1005 329.147 32.874 322.518V321.98H33.3966L312.985 312.73L313.055 313.789L34.32 342.978L34.3025 342.943ZM33.9542 323.004C34.1807 329.269 34.6162 335.568 35.2608 341.781L298.072 314.258L33.9542 323.004Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M37.4205 303.186C37.1766 309.676 37.1766 316.218 37.4031 322.813L312.967 313.233L37.4205 303.186Z",
                                fill: "url(#paint66_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M36.8812 323.368V322.83C36.6373 316.323 36.6373 309.711 36.8812 303.151V302.613L37.4388 302.631L312.985 312.678V313.737L36.8812 323.334V323.368ZM37.9439 303.724C37.7348 309.902 37.7176 316.132 37.9267 322.258L298.037 313.216L37.9439 303.724Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M66.395 286.996C65.7678 292.81 65.3497 298.675 65.1406 304.61L312.969 313.235L66.395 286.996Z",
                                fill: "url(#paint67_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.951 313.755L64.583 305.113V304.575C64.8095 298.727 65.2276 292.792 65.8548 286.927L65.9071 286.389L66.4473 286.441L313.021 312.68L312.951 313.738V313.755ZM65.698 304.089L298.055 312.176L66.8654 287.586C66.2905 293.087 65.8897 298.623 65.698 304.107V304.089Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.6134 267.941C56.5333 273.963 55.6622 280.054 55.0176 286.232L312.986 313.235L57.6134 267.941Z",
                                fill: "url(#paint68_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.916 313.755L54.4258 286.7L54.4781 286.163C55.1227 280.089 55.9938 273.928 57.074 267.837L57.1609 267.316L57.6837 267.403L313.056 312.696L312.899 313.755H312.916ZM55.5929 285.746L298.16 311.134L58.032 268.549C57.0216 274.258 56.2027 280.037 55.5929 285.746Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.5395 246.336C43.9541 252.635 42.5776 259.039 41.4277 265.529L312.985 313.217L45.557 246.318L45.5395 246.336Z",
                                fill: "url(#paint69_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.881 313.754L40.8008 265.962L40.888 265.442C42.0204 259.021 43.4142 252.565 45.017 246.196L45.1388 245.676L45.6616 245.815L313.09 312.713L312.863 313.754H312.881ZM42.0379 265.095L298.351 310.11L45.923 246.977C44.4247 252.964 43.1181 259.055 42.0379 265.095Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M39.0935 224.072C36.9855 230.528 35.069 237.105 33.3965 243.786L312.985 313.218L39.0935 224.072Z",
                                fill: "url(#paint70_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.846 313.738L32.752 244.167L32.874 243.646C34.5291 237.069 36.4456 230.423 38.5711 223.898L38.7278 223.395L39.2331 223.551L313.125 312.697L312.828 313.721L312.846 313.738ZM34.0412 243.403L298.612 309.104L39.4422 224.748C37.4386 230.909 35.6266 237.191 34.0586 243.403H34.0412Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.4922 209.908C55.0357 215.93 52.7882 222.073 50.7324 228.355L312.986 313.232L57.4922 209.908Z",
                                fill: "url(#paint71_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.812 313.736L50.0527 228.703L50.2095 228.2C52.213 222.039 54.4953 215.809 56.9867 209.718L57.1957 209.232L57.6836 209.441L313.178 312.765L312.812 313.771V313.736ZM51.4117 228.009L298.926 308.114L57.788 210.603C55.4535 216.347 53.3107 222.196 51.4117 228.009Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.9058 182.926C42.8046 189.225 39.9126 195.663 37.2471 202.258L312.985 313.235L45.9058 182.926Z",
                                fill: "url(#paint72_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.777 313.721L36.5332 202.553L36.7423 202.067C39.373 195.577 42.2998 189.052 45.4184 182.701L45.6449 182.215L46.1328 182.44L313.212 312.749L312.777 313.721ZM37.927 201.963L299.309 307.161L46.1328 183.638C43.1884 189.66 40.4184 195.82 37.927 201.963Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M50.3821 161.633C46.7758 167.828 43.3785 174.18 40.1729 180.705L312.967 313.235L50.3647 161.633H50.3821Z",
                                fill: "url(#paint73_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.741 313.703L39.459 180.948L39.6853 180.462C42.8387 174.041 46.271 167.603 49.9122 161.355L50.1734 160.887L50.6438 161.147L313.246 312.749L312.741 313.686V313.703ZM40.8875 180.462L299.779 306.241L50.574 162.379C47.1419 168.314 43.8841 174.388 40.8875 180.479V180.462Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.6339 159.254C80.9753 164.634 77.4908 170.187 74.1807 175.896L312.984 313.233L84.6513 159.271L84.6339 159.254Z",
                                fill: "url(#paint74_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.706 313.685L73.4492 176.087L73.7106 175.619C76.9685 169.996 80.5052 164.391 84.1987 158.942L84.4949 158.508L84.9305 158.803L313.263 312.765L312.689 313.667L312.706 313.685ZM74.9128 175.705L300.301 305.32L84.7735 160C81.3066 165.137 77.9791 170.413 74.8954 175.705H74.9128Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M105.334 151.064C101.484 155.958 97.773 161.025 94.2363 166.249L312.987 313.217L105.334 151.064Z",
                                fill: "url(#paint75_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.673 313.669L93.4863 166.405L93.7826 165.972C97.267 160.817 101.013 155.698 104.898 150.752L105.229 150.336L105.647 150.666L313.3 312.819L312.673 313.686V313.669ZM94.9674 166.11L300.878 304.454L105.421 151.811C101.779 156.462 98.2601 161.269 94.9674 166.11Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M125.942 144.902C121.952 149.31 118.067 153.892 114.339 158.646L312.985 313.233L125.942 144.92V144.902Z",
                                fill: "url(#paint76_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.653 313.65L113.589 158.733L113.92 158.317C117.596 153.631 121.498 148.998 125.54 144.555L125.906 144.156L126.307 144.521L313.35 312.852L312.67 313.667L312.653 313.65ZM115.087 158.56L301.52 303.654L125.958 145.666C122.178 149.848 118.519 154.187 115.07 158.56H115.087Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M141.934 136.209C137.735 140.235 133.641 144.452 129.669 148.825L312.966 313.216L141.917 136.191L141.934 136.209Z",
                                fill: "url(#paint77_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.619 313.633L128.921 148.877L129.287 148.478C133.189 144.157 137.318 139.905 141.569 135.827L141.953 135.463L142.318 135.845L313.368 312.87L312.619 313.633ZM130.437 148.791L302.235 302.874L141.918 136.955C137.945 140.773 134.095 144.747 130.419 148.791H130.437Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M146.484 114.916C141.78 118.838 137.163 122.951 132.686 127.272L312.969 313.234L146.484 114.916Z",
                                fill: "url(#paint78_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.584 313.599L131.936 127.255L132.319 126.89C136.744 122.639 141.396 118.474 146.152 114.517L146.57 114.17L146.918 114.586L313.403 312.905L312.602 313.616L312.584 313.599ZM133.451 127.289L302.985 302.163L146.431 115.68C141.971 119.411 137.615 123.315 133.451 127.289Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M181.763 132.686C177.477 135.775 173.261 139.037 169.149 142.49L312.986 313.233L181.763 132.686Z",
                                fill: "url(#paint79_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.567 313.563L168.383 142.421L168.783 142.074C172.843 138.69 177.094 135.376 181.432 132.252L181.867 131.939L182.181 132.373L313.404 312.921L312.567 313.581V313.563ZM169.899 142.56L303.787 301.485L181.641 133.432C177.616 136.347 173.679 139.402 169.899 142.56Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M197.668 128.73C193.295 131.455 188.975 134.336 184.724 137.407L312.967 313.235L197.651 128.73H197.668Z",
                                fill: "url(#paint80_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.549 313.548L183.992 137.286L184.428 136.974C188.609 133.954 192.964 131.022 197.407 128.28L197.86 128.002L198.139 128.453L313.455 312.958L312.567 313.548H312.549ZM185.473 137.529L304.622 300.88L197.494 129.46C193.4 132.011 189.358 134.718 185.473 137.512V137.529Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M204.829 109.797C200.003 112.348 195.229 115.09 190.508 118.005L312.967 313.217L204.811 109.779L204.829 109.797Z",
                                fill: "url(#paint81_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.532 313.513L189.776 117.85L190.229 117.572C194.864 114.691 199.689 111.915 204.585 109.346L205.056 109.104L313.455 313.009L312.532 313.547V313.513ZM191.24 118.179L305.511 300.324L204.603 110.509C200.055 112.921 195.578 115.49 191.24 118.179Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M212.059 86.4041C206.675 88.7815 201.327 91.3672 196.048 94.1612L312.985 313.217L212.059 86.3867V86.4041Z",
                                fill: "url(#paint82_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.497 313.476L195.316 93.9522L195.787 93.7092C200.996 90.95 206.379 88.3296 211.832 85.9348L212.32 85.7266L212.529 86.2125L313.455 313.043L312.497 313.511V313.476ZM196.762 94.386L306.434 299.836L211.78 87.1148C206.693 89.3708 201.641 91.8177 196.762 94.386Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M219.098 54.9785C212.965 57.1998 206.868 59.6293 200.822 62.3191L312.968 313.236L219.098 54.9785Z",
                                fill: "url(#paint83_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.497 313.444L200.125 62.0405L200.613 61.8323C206.571 59.1945 212.738 56.713 218.923 54.4743L219.429 54.3008L219.603 54.8041L313.473 313.062L312.48 313.461L312.497 313.444ZM201.536 62.5785L307.392 299.404L218.784 55.6544C212.948 57.7715 207.146 60.097 201.536 62.5785Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M241.851 64.5742C235.945 66.2575 230.056 68.1491 224.202 70.2662L312.985 313.235L241.851 64.5742Z",
                                fill: "url(#paint84_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.48 313.408L223.523 69.9356L224.029 69.7447C229.795 67.6622 235.754 65.736 241.712 64.0353L242.217 63.8965L313.491 313.061L312.48 313.391V313.408ZM224.882 70.5777L308.369 299.056L241.486 65.2328C235.893 66.8293 230.301 68.6341 224.882 70.595V70.5777Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M258.209 54.4219C252.059 55.706 245.926 57.2332 239.794 58.9859L312.984 313.235L258.209 54.4219Z",
                                fill: "url(#paint85_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.462 313.373L239.115 58.6036L239.62 58.4474C245.666 56.7294 251.868 55.1849 258.088 53.8834L258.61 53.7793L258.715 54.2999L313.49 313.113L312.462 313.373ZM240.439 59.3324L309.361 298.761L257.774 55.0288C251.938 56.2609 246.119 57.7012 240.422 59.3151L240.439 59.3324Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M278.367 64.9199C272.479 65.7355 266.555 66.7594 260.649 68.0089L312.985 313.234L278.385 64.9199H278.367Z",
                                fill: "url(#paint86_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.463 313.338L260.022 67.5923L260.545 67.4882C266.364 66.2561 272.34 65.2149 278.298 64.3819L278.821 64.3125L278.89 64.8331L313.491 313.147L312.445 313.338H312.463ZM261.277 68.4253L310.389 298.57L277.915 65.5272C272.34 66.3081 266.747 67.28 261.277 68.4253Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M296.329 70.3164C290.562 70.7155 284.761 71.3056 278.959 72.1212L312.984 313.216L296.346 70.3164H296.329Z",
                                fill: "url(#paint87_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.445 313.304L278.351 71.6706L278.873 71.6012C284.605 70.8029 290.459 70.1955 296.295 69.7964L296.835 69.7617L296.87 70.2997L313.508 313.199L312.445 313.304ZM279.57 72.5904L311.435 298.414L295.842 70.8897C290.406 71.2715 284.936 71.8442 279.57 72.573V72.5904Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.438 38.5762C306.922 38.5762 300.354 38.7844 293.733 39.2356L312.967 313.233L313.438 38.5762Z",
                                fill: "url(#paint88_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.445 313.269L293.176 38.7506L293.716 38.7159C300.092 38.2647 306.591 38.0391 313.054 38.0391H313.995V38.577L313.525 313.234L312.462 313.269H312.445ZM294.308 39.7397L312.462 298.345L312.898 39.0976C306.695 39.0976 300.441 39.3059 294.308 39.7224V39.7397Z",
                                fill: "#131D2D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "screen"
                        },
                        opacity: 0.32,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M332.026 48.2783C325.736 47.8271 319.377 47.6016 312.983 47.6016V313.235L332.026 48.2957V48.2783Z",
                                fill: "url(#paint89_linear_10967_101901)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.507 313.268L312.444 313.234V47.0801H312.985C319.291 47.0801 325.72 47.3057 332.079 47.7569L332.619 47.7916L332.584 48.3295L313.542 313.268H313.507ZM313.507 48.1387V298.344L331.452 48.7808C325.476 48.3643 319.448 48.156 313.507 48.1387Z",
                                fill: "#131D2D"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask1_10967_101901",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 629,
                height: 626,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M0 0L0 626H628.46V0L0 0ZM314.239 480.16C217.303 480.16 138.713 401.877 138.713 305.321C138.713 208.765 217.303 130.482 314.239 130.482C411.174 130.482 489.764 208.765 489.764 305.321C489.764 401.877 411.174 480.16 314.239 480.16Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask1_10967_101901)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M507.248 505.247C613.848 399.064 613.848 226.908 507.248 120.726C400.648 14.5429 227.815 14.5428 121.216 120.726C14.6156 226.908 14.6155 399.064 121.215 505.247C227.815 611.43 400.648 611.43 507.248 505.247Z",
                            fill: "url(#paint90_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M291.202 286.867C320.729 215.862 286.878 134.458 215.594 105.047C144.31 75.6355 62.5858 109.354 33.0589 180.359C3.53196 251.365 37.3831 332.768 108.667 362.18C179.952 391.591 261.675 357.873 291.202 286.867Z",
                            fill: "url(#paint91_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M220.891 548.065C314.867 548.065 391.051 472.18 391.051 378.572C391.051 284.963 314.867 209.078 220.891 209.078C126.914 209.078 50.7314 284.963 50.7314 378.572C50.7314 472.18 126.914 548.065 220.891 548.065Z",
                            fill: "url(#paint92_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M461.601 477.811C516.159 423.465 516.159 335.355 461.601 281.01C407.042 226.665 318.585 226.664 264.026 281.01C209.468 335.355 209.468 423.466 264.026 477.811C318.585 532.156 407.042 532.156 461.601 477.811Z",
                            fill: "url(#paint93_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M481.194 445.652C556.288 427.997 602.796 353.048 585.073 278.248C567.349 203.447 492.105 157.121 417.01 174.776C341.916 192.43 295.408 267.38 313.132 342.18C330.856 416.981 406.1 463.306 481.194 445.652Z",
                            fill: "url(#paint94_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M371.903 339.89C446.482 339.89 506.94 279.669 506.94 205.382C506.94 131.095 446.482 70.873 371.903 70.873C297.324 70.873 236.866 131.095 236.866 205.382C236.866 279.669 297.324 339.89 371.903 339.89Z",
                            fill: "url(#paint95_radial_10967_101901)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask2_10967_101901",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: 56,
                y: 54,
                width: 514,
                height: 512,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M312.986 54.9766C171.519 54.9766 56.8477 169.199 56.8477 310.111C56.8477 451.023 171.519 565.245 312.986 565.245C454.453 565.245 569.125 451.023 569.125 310.111C569.125 169.199 454.453 54.9766 312.986 54.9766ZM312.986 414.858C254.919 414.858 207.844 367.968 207.844 310.128C207.844 252.288 254.919 205.398 312.986 205.398C371.054 205.398 418.128 252.288 418.128 310.128C418.128 367.968 371.054 414.858 312.986 414.858Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask2_10967_101901)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M423.581 159.775C423.39 159.619 423.18 159.48 422.989 159.341C422.989 159.341 422.989 159.341 422.971 159.341C419.679 156.964 416.281 154.673 412.779 152.469C412.57 152.331 412.361 152.209 412.17 152.087H412.152C408.703 149.936 405.149 147.888 401.507 145.944C401.298 145.823 401.072 145.719 400.863 145.597C400.863 145.597 400.863 145.597 400.845 145.597C397.239 143.688 393.563 141.901 389.8 140.2C389.573 140.096 389.347 139.992 389.138 139.905C389.138 139.905 389.12 139.905 389.103 139.905C385.375 138.257 381.577 136.712 377.709 135.289C377.482 135.202 377.256 135.116 377.029 135.029C377.029 135.029 377.03 135.029 376.995 135.029C373.162 133.641 369.259 132.374 365.304 131.228C365.078 131.159 364.834 131.09 364.608 131.02C364.608 131.02 364.59 131.02 364.573 131.02C360.653 129.909 356.681 128.903 352.639 128.035C352.395 127.966 352.168 127.931 351.924 127.879C351.924 127.879 351.907 127.879 351.89 127.879C347.9 127.046 343.858 126.317 339.781 125.727C339.537 125.675 339.294 125.658 339.067 125.623C339.067 125.623 339.05 125.623 339.032 125.623C334.99 125.068 330.913 124.634 326.802 124.322C326.558 124.287 326.314 124.287 326.07 124.27C326.07 124.27 326.053 124.27 326.035 124.27C321.715 123.975 317.377 123.818 312.986 123.818V310.215L433.843 167.914C430.533 165.138 427.118 162.448 423.581 159.879V159.775Z",
                        fill: "url(#paint96_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M462.153 177.407C461.978 177.199 461.804 177.025 461.63 176.834C461.63 176.834 461.63 176.834 461.612 176.817C458.703 173.589 455.654 170.448 452.483 167.377C452.292 167.186 452.1 167.012 451.926 166.838C451.926 166.838 451.926 166.839 451.908 166.821C448.581 163.628 445.131 160.522 441.542 157.52L312.968 310.145L471.09 188.114C468.25 184.487 465.271 180.912 462.153 177.424V177.407Z",
                        fill: "url(#paint97_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M510.098 276.305C510.045 276.045 510.011 275.802 509.958 275.541V275.507C509.192 271.238 508.303 266.951 507.241 262.682C507.171 262.422 507.119 262.179 507.049 261.936C507.049 261.936 507.049 261.919 507.049 261.901C505.934 257.442 504.645 252.982 503.199 248.539L312.968 310.11L511.979 290.084C511.509 285.502 510.882 280.904 510.08 276.305H510.098Z",
                        fill: "url(#paint98_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M516.649 229.103C516.544 228.842 516.44 228.582 516.318 228.322C516.318 228.322 516.318 228.305 516.318 228.287C514.523 223.879 512.572 219.506 510.481 215.15C510.359 214.89 510.22 214.63 510.098 214.369C510.098 214.369 510.098 214.369 510.098 214.352C508.007 210.083 505.76 205.849 503.338 201.649C503.199 201.389 503.042 201.163 502.903 200.903C502.903 200.903 502.903 200.886 502.903 200.868C500.516 196.756 497.973 192.677 495.272 188.669C495.115 188.426 494.959 188.2 494.785 187.957C494.785 187.957 494.785 187.94 494.767 187.922C491.927 183.74 488.931 179.627 485.778 175.584L312.956 310.075L521.823 243.402C520.272 238.595 518.547 233.806 516.631 229.051L516.649 229.103Z",
                        fill: "url(#paint99_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M448.842 415.845C451.299 412.722 453.65 409.494 455.915 406.145L312.968 310.109L403.754 456.123C407.134 454.024 410.479 451.802 413.754 449.46C413.928 449.338 414.12 449.199 414.294 449.078H414.312C417.343 446.856 420.34 444.548 423.249 442.119C423.423 441.98 423.58 441.841 423.754 441.702C423.754 441.702 423.754 441.702 423.772 441.702C426.646 439.29 429.469 436.774 432.204 434.154C432.361 434.015 432.518 433.841 432.674 433.702C432.674 433.702 432.674 433.702 432.692 433.685C435.392 431.082 438.023 428.375 440.584 425.581C440.741 425.425 440.88 425.251 441.037 425.095C441.037 425.095 441.037 425.095 441.054 425.078C443.563 422.301 446.002 419.42 448.354 416.435C448.494 416.262 448.633 416.088 448.755 415.915C448.755 415.915 448.755 415.915 448.755 415.897L448.842 415.845Z",
                        fill: "url(#paint100_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M486.649 366.318C487.956 362.327 489.123 358.249 490.168 354.118L312.986 310.109L463.965 412.444C466.335 408.973 468.6 405.381 470.76 401.702C470.882 401.511 470.986 401.303 471.108 401.095C471.108 401.095 471.108 401.095 471.108 401.077C473.094 397.641 474.976 394.136 476.771 390.526C476.875 390.318 476.98 390.11 477.084 389.902C478.826 386.309 480.464 382.683 481.98 378.951C482.067 378.743 482.154 378.518 482.241 378.292C482.241 378.292 482.241 378.292 482.241 378.257C483.722 374.578 485.098 370.847 486.37 367.029C486.44 366.804 486.509 366.578 486.579 366.353V366.318H486.649Z",
                        fill: "url(#paint101_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M512.869 317.068C513.026 312.73 513.026 308.357 512.886 303.966C512.886 303.706 512.869 303.446 512.851 303.185C512.851 303.185 512.851 303.168 512.851 303.151C512.695 298.552 512.364 293.919 511.876 289.285L312.951 310.11L506.841 359.099C507.973 354.639 508.949 350.11 509.785 345.511C509.837 345.268 509.872 345.008 509.924 344.748C509.924 344.748 509.924 344.73 509.924 344.713C510.674 340.444 511.301 336.123 511.771 331.75C511.806 331.489 511.823 331.229 511.841 330.986C511.841 330.986 511.841 330.969 511.841 330.951C512.294 326.63 512.607 322.275 512.782 317.884C512.782 317.624 512.782 317.363 512.799 317.103C512.799 317.103 512.799 317.086 512.799 317.068H512.869Z",
                        fill: "url(#paint102_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.11L222.217 138.412C218.245 140.512 214.307 142.751 210.422 145.145C210.213 145.267 209.987 145.406 209.778 145.545C206.189 147.783 202.635 150.161 199.15 152.659C198.941 152.798 198.75 152.954 198.541 153.093C198.541 153.093 198.541 153.093 198.523 153.093C194.882 155.731 191.31 158.508 187.809 161.44L313.021 310.092L312.986 310.11Z",
                        fill: "url(#paint103_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.987 310.11L272.184 115.055C267.655 115.992 263.142 117.102 258.63 118.369C258.386 118.421 258.142 118.508 257.881 118.577C257.881 118.577 257.863 118.577 257.846 118.577C253.665 119.775 249.483 121.111 245.337 122.604C245.093 122.673 244.849 122.777 244.605 122.864C244.605 122.864 244.588 122.864 244.57 122.864C240.476 124.356 236.417 125.988 232.375 127.758C232.131 127.844 231.905 127.966 231.661 128.07C231.661 128.07 231.643 128.07 231.626 128.07C227.41 129.944 223.228 131.975 219.082 134.161L312.987 310.076V310.11Z",
                        fill: "url(#paint104_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M299.362 104.504C299.101 104.504 298.822 104.538 298.561 104.556C298.561 104.556 298.544 104.556 298.526 104.556C294.031 104.868 289.519 105.337 284.989 105.944C284.728 105.961 284.467 106.013 284.188 106.048C284.188 106.048 284.17 106.048 284.153 106.048C279.414 106.708 274.675 107.541 269.937 108.547L312.952 310.11L313.788 104.035C309.014 104.035 304.188 104.174 299.362 104.486V104.504Z",
                        fill: "url(#paint105_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M411.838 495.273C416.124 493 420.375 490.553 424.556 487.95L312.986 310.109L297.445 519.239C302.289 519.586 307.184 519.777 312.132 519.794C312.411 519.794 312.672 519.794 312.951 519.794H312.986C317.568 519.794 322.185 519.638 326.819 519.326C327.098 519.326 327.359 519.291 327.638 519.273C327.638 519.273 327.655 519.273 327.672 519.273C332.237 518.944 336.836 518.475 341.436 517.85C341.697 517.833 341.976 517.781 342.237 517.746C342.237 517.746 342.255 517.746 342.272 517.746C346.819 517.104 351.366 516.323 355.913 515.369C356.175 515.317 356.454 515.265 356.715 515.213C356.715 515.213 356.733 515.213 356.75 515.213C361.227 514.258 365.722 513.165 370.182 511.898C370.444 511.829 370.705 511.759 370.966 511.673C370.966 511.673 370.984 511.673 371.001 511.673C375.409 510.406 379.799 509 384.172 507.438C384.433 507.351 384.677 507.265 384.939 507.161C384.939 507.161 384.956 507.161 384.974 507.161C389.277 505.599 393.563 503.881 397.814 502.007C398.057 501.902 398.301 501.798 398.563 501.677C398.563 501.677 398.58 501.677 398.597 501.677C402.779 499.82 406.943 497.807 411.054 495.655C411.298 495.534 411.525 495.412 411.769 495.273C411.769 495.273 411.786 495.273 411.803 495.273H411.838Z",
                        fill: "url(#paint106_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M127.266 399.411C129.34 403.68 131.587 407.915 133.974 412.097C134.113 412.34 134.253 412.566 134.375 412.791V412.826C136.622 416.696 139.009 420.514 141.535 424.297C141.692 424.522 141.831 424.748 141.988 424.956C141.988 424.956 141.988 424.973 141.988 424.991C144.497 428.704 147.145 432.349 149.932 435.924C150.089 436.149 150.263 436.358 150.438 436.566C150.438 436.566 150.438 436.566 150.438 436.583C153.208 440.106 156.1 443.559 159.131 446.943C159.305 447.152 159.497 447.342 159.671 447.533C159.671 447.533 159.671 447.533 159.689 447.551C162.877 451.073 166.205 454.509 169.689 457.859L312.933 310.109L127.231 399.411H127.266Z",
                        fill: "url(#paint107_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.985 310.11L161.814 464.784C165.403 468.254 169.149 471.638 173.017 474.901C173.226 475.092 173.452 475.265 173.661 475.439C173.661 475.439 173.661 475.439 173.679 475.456C177.303 478.476 181.031 481.391 184.899 484.22C185.125 484.393 185.352 484.55 185.578 484.723C185.578 484.723 185.578 484.723 185.613 484.74C189.428 487.5 193.366 490.155 197.408 492.688C197.651 492.845 197.878 492.984 198.122 493.14C198.122 493.14 198.139 493.14 198.157 493.157C202.164 495.639 206.275 498.016 210.491 500.272C210.735 500.411 210.997 500.55 211.241 500.671C211.241 500.671 211.258 500.671 211.276 500.671C215.439 502.875 219.708 504.958 224.081 506.919C224.342 507.04 224.603 507.161 224.847 507.266C224.847 507.266 224.865 507.266 224.882 507.266C229.203 509.175 233.593 510.962 238.088 512.61C238.349 512.715 238.611 512.801 238.872 512.906C238.872 512.906 238.889 512.906 238.907 512.906C243.349 514.502 247.862 515.977 252.461 517.313C252.722 517.4 253.001 517.47 253.28 517.556C253.28 517.556 253.298 517.556 253.315 517.556C257.845 518.841 262.461 520.003 267.13 521.01C267.409 521.079 267.688 521.131 267.949 521.183C267.949 521.183 267.967 521.183 267.984 521.183C272.601 522.155 277.27 522.988 282.009 523.665C282.288 523.717 282.566 523.752 282.845 523.786C282.845 523.786 282.863 523.786 282.88 523.786C287.845 524.48 292.845 525.001 297.915 525.366L313.037 310.023L312.985 310.11Z",
                        fill: "url(#paint108_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.985 310.109L119.095 261.119C117.963 265.579 116.987 270.108 116.151 274.707C116.098 274.95 116.064 275.21 116.029 275.471C116.029 275.471 116.029 275.488 116.029 275.505C115.28 279.774 114.652 284.095 114.182 288.469C114.147 288.729 114.13 288.989 114.112 289.232V289.267C113.659 293.588 113.346 297.944 113.172 302.334C113.172 302.594 113.171 302.855 113.154 303.115C113.154 303.115 113.154 303.132 113.154 303.15C112.997 307.488 112.997 311.861 113.137 316.252C113.137 316.512 113.154 316.773 113.172 317.033C113.172 317.033 113.172 317.05 113.172 317.067C113.328 321.666 113.659 326.3 114.147 330.933L313.072 310.109H312.985Z",
                        fill: "url(#paint109_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M105.716 330.968C106.238 336.018 106.935 341.068 107.824 346.136L312.968 310.109L105.698 330.968H105.716Z",
                        fill: "url(#paint110_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.985 310.109L105.715 345.65C106.551 350.422 107.544 355.194 108.729 359.967C108.799 360.227 108.868 360.487 108.938 360.765C108.938 360.765 108.938 360.782 108.938 360.799C110.053 365.225 111.307 369.65 112.736 374.04C112.823 374.301 112.91 374.561 112.997 374.821C112.997 374.821 112.997 374.839 112.997 374.856C114.409 379.194 115.976 383.515 117.701 387.802C117.806 388.062 117.91 388.305 118.015 388.565C118.015 388.565 118.015 388.583 118.015 388.6C119.844 393.077 121.83 397.537 123.991 401.963L313.019 310.127L312.985 310.109Z",
                        fill: "url(#paint111_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M122.997 247.775C121.482 252.391 120.105 257.111 118.903 261.901L312.985 310.092L122.997 247.758V247.775Z",
                        fill: "url(#paint112_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M111.239 227.974C109.235 232.885 107.388 237.901 105.716 243.02L312.986 310.092L111.256 227.957L111.239 227.974Z",
                        fill: "url(#paint113_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.11L162.234 129.684C158.052 133.154 153.958 136.799 149.968 140.616C149.742 140.825 149.533 141.033 149.306 141.259C145.613 144.816 142.024 148.512 138.522 152.348C138.313 152.556 138.121 152.799 137.912 153.024C137.912 153.024 137.913 153.024 137.895 153.059C134.254 157.102 131.617 160.786 128.219 165.124L313.021 310.127L312.986 310.11Z",
                        fill: "url(#paint114_linear_10967_101901)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.11L121.187 159.602C117.702 164.027 114.34 168.591 111.134 173.311C110.96 173.571 110.786 173.832 110.594 174.109C107.632 178.5 104.775 183.012 102.057 187.662C101.9 187.923 101.744 188.2 101.587 188.478C101.587 188.478 101.587 188.496 101.569 188.513C98.9212 193.094 96.3951 197.797 94.0083 202.621C93.8689 202.899 93.7296 203.177 93.5902 203.472C93.5902 203.472 93.5902 203.489 93.5902 203.506C91.1163 208.556 88.7992 213.728 86.6562 219.021L313.055 310.128L312.986 310.11Z",
                        fill: "url(#paint115_linear_10967_101901)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M267.079 315.199C266.812 315.199 266.586 315.119 266.399 314.959C266.239 314.773 266.159 314.546 266.159 314.279V312.999C266.159 312.759 266.226 312.493 266.359 312.199C266.492 311.906 266.759 311.586 267.159 311.239L275.639 302.759C276.999 301.613 278.066 300.639 278.839 299.839C279.639 299.013 280.199 298.226 280.519 297.479C280.866 296.733 281.039 295.959 281.039 295.159C281.039 293.639 280.612 292.439 279.759 291.559C278.906 290.653 277.639 290.199 275.959 290.199C274.892 290.199 273.972 290.426 273.199 290.879C272.426 291.306 271.826 291.906 271.399 292.679C270.972 293.426 270.679 294.279 270.519 295.239C270.466 295.586 270.319 295.826 270.079 295.959C269.866 296.093 269.666 296.159 269.479 296.159H267.399C267.159 296.159 266.959 296.093 266.799 295.959C266.639 295.799 266.559 295.613 266.559 295.399C266.586 294.386 266.799 293.373 267.199 292.359C267.599 291.319 268.186 290.386 268.959 289.559C269.759 288.706 270.732 288.026 271.879 287.519C273.052 287.013 274.412 286.759 275.959 286.759C278.066 286.759 279.786 287.146 281.119 287.919C282.479 288.666 283.479 289.666 284.119 290.919C284.759 292.173 285.079 293.546 285.079 295.039C285.079 296.213 284.879 297.293 284.479 298.279C284.079 299.239 283.492 300.186 282.719 301.119C281.972 302.026 281.039 302.959 279.919 303.919L272.239 311.719H284.719C285.012 311.719 285.239 311.799 285.399 311.959C285.586 312.119 285.679 312.346 285.679 312.639V314.279C285.679 314.546 285.586 314.773 285.399 314.959C285.239 315.119 285.012 315.199 284.719 315.199H267.079ZM290.356 318.199C290.142 318.199 289.969 318.119 289.836 317.959C289.729 317.799 289.689 317.599 289.716 317.359L290.636 311.639C290.689 311.319 290.796 311.053 290.956 310.839C291.142 310.599 291.409 310.479 291.756 310.479H294.436C294.622 310.479 294.769 310.546 294.876 310.679C295.009 310.813 295.076 310.973 295.076 311.159C295.076 311.373 295.036 311.586 294.956 311.799L292.836 317.279C292.729 317.546 292.582 317.759 292.396 317.919C292.236 318.106 291.996 318.199 291.676 318.199H290.356ZM309.317 315.599C307.21 315.599 305.423 315.239 303.957 314.519C302.517 313.773 301.41 312.813 300.637 311.639C299.89 310.466 299.49 309.226 299.437 307.919C299.41 307.679 299.477 307.493 299.637 307.359C299.797 307.199 299.997 307.119 300.237 307.119H302.397C302.637 307.119 302.85 307.186 303.037 307.319C303.223 307.426 303.37 307.653 303.477 307.999C303.743 308.986 304.17 309.799 304.757 310.439C305.37 311.053 306.063 311.506 306.837 311.799C307.637 312.066 308.463 312.199 309.317 312.199C310.463 312.199 311.503 311.973 312.437 311.519C313.397 311.039 314.157 310.346 314.717 309.439C315.277 308.506 315.557 307.386 315.557 306.079C315.557 304.879 315.277 303.853 314.717 302.999C314.183 302.119 313.437 301.453 312.477 300.999C311.543 300.519 310.49 300.279 309.317 300.279C308.437 300.279 307.717 300.386 307.157 300.599C306.597 300.813 306.117 301.066 305.717 301.359C305.343 301.653 304.997 301.906 304.677 302.119C304.383 302.333 304.05 302.439 303.677 302.439H301.597C301.357 302.439 301.143 302.359 300.957 302.199C300.77 302.013 300.69 301.799 300.717 301.559L301.997 288.199C302.023 287.879 302.117 287.639 302.277 287.479C302.463 287.293 302.703 287.199 302.997 287.199H316.957C317.223 287.199 317.437 287.293 317.597 287.479C317.783 287.639 317.877 287.853 317.877 288.119V289.679C317.877 289.973 317.783 290.199 317.597 290.359C317.437 290.519 317.223 290.599 316.957 290.599H305.437L304.677 298.479C305.077 298.239 305.677 297.959 306.477 297.639C307.303 297.293 308.437 297.119 309.877 297.119C311.21 297.119 312.45 297.319 313.597 297.719C314.77 298.119 315.797 298.706 316.677 299.479C317.583 300.253 318.29 301.199 318.797 302.319C319.303 303.413 319.557 304.679 319.557 306.119C319.557 308.146 319.117 309.866 318.237 311.279C317.357 312.693 316.143 313.773 314.597 314.519C313.05 315.239 311.29 315.599 309.317 315.599ZM333.707 315.599C331.493 315.599 329.613 315.159 328.067 314.279C326.52 313.373 325.333 312.199 324.507 310.759C323.707 309.293 323.307 307.706 323.307 305.999C323.307 305.199 323.4 304.439 323.587 303.719C323.8 302.973 324.053 302.279 324.347 301.639C324.667 300.973 324.973 300.386 325.267 299.879C325.587 299.346 325.867 298.919 326.107 298.599L333.707 287.999C333.84 287.866 334 287.706 334.187 287.519C334.373 287.306 334.653 287.199 335.027 287.199H337.147C337.387 287.199 337.573 287.293 337.707 287.479C337.867 287.639 337.947 287.839 337.947 288.079C337.947 288.186 337.933 288.293 337.907 288.399C337.88 288.479 337.84 288.546 337.787 288.599L331.947 296.759C332.267 296.653 332.64 296.586 333.067 296.559C333.493 296.506 333.88 296.479 334.227 296.479C335.693 296.506 337.027 296.773 338.227 297.279C339.427 297.786 340.453 298.479 341.307 299.359C342.187 300.213 342.853 301.213 343.307 302.359C343.76 303.479 343.987 304.679 343.987 305.959C343.987 307.639 343.587 309.213 342.787 310.679C341.987 312.146 340.813 313.333 339.267 314.239C337.747 315.146 335.893 315.599 333.707 315.599ZM333.667 312.199C334.787 312.199 335.827 311.959 336.787 311.479C337.747 310.999 338.52 310.306 339.107 309.399C339.72 308.466 340.027 307.319 340.027 305.959C340.027 304.626 339.733 303.506 339.147 302.599C338.56 301.666 337.773 300.973 336.787 300.519C335.827 300.039 334.787 299.799 333.667 299.799C332.547 299.799 331.507 300.039 330.547 300.519C329.587 300.973 328.8 301.666 328.187 302.599C327.6 303.506 327.307 304.626 327.307 305.959C327.307 307.319 327.6 308.466 328.187 309.399C328.8 310.306 329.587 310.999 330.547 311.479C331.507 311.959 332.547 312.199 333.667 312.199ZM355.552 315.199C355.285 315.199 355.058 315.119 354.872 314.959C354.712 314.773 354.632 314.546 354.632 314.279V291.879L347.992 296.999C347.778 297.159 347.552 297.226 347.312 297.199C347.072 297.173 346.872 297.053 346.712 296.839L345.672 295.519C345.512 295.279 345.445 295.039 345.472 294.799C345.525 294.559 345.658 294.359 345.872 294.199L354.592 287.479C354.778 287.346 354.952 287.266 355.112 287.239C355.272 287.213 355.445 287.199 355.632 287.199H357.672C357.938 287.199 358.152 287.293 358.312 287.479C358.498 287.639 358.592 287.853 358.592 288.119V314.279C358.592 314.546 358.498 314.773 358.312 314.959C358.152 315.119 357.938 315.199 357.672 315.199H355.552Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M262.438 346.199C262.332 346.199 262.241 346.167 262.166 346.103C262.102 346.029 262.07 345.938 262.07 345.831V336.423H258.998C258.892 336.423 258.801 336.391 258.726 336.327C258.662 336.253 258.63 336.162 258.63 336.055V335.383C258.63 335.266 258.662 335.175 258.726 335.111C258.801 335.037 258.892 334.999 258.998 334.999H266.71C266.828 334.999 266.918 335.037 266.982 335.111C267.057 335.175 267.094 335.266 267.094 335.383V336.055C267.094 336.162 267.057 336.253 266.982 336.327C266.918 336.391 266.828 336.423 266.71 336.423H263.654V345.831C263.654 345.938 263.617 346.029 263.542 346.103C263.478 346.167 263.388 346.199 263.27 346.199H262.438ZM270.557 346.359C269.746 346.359 269.069 346.205 268.525 345.895C267.981 345.586 267.565 345.159 267.277 344.615C266.989 344.061 266.829 343.431 266.797 342.727C266.786 342.546 266.781 342.317 266.781 342.039C266.781 341.751 266.786 341.522 266.797 341.351C266.829 340.637 266.989 340.007 267.277 339.463C267.575 338.919 267.997 338.493 268.541 338.183C269.085 337.874 269.757 337.719 270.557 337.719C271.357 337.719 272.029 337.874 272.573 338.183C273.117 338.493 273.533 338.919 273.821 339.463C274.119 340.007 274.285 340.637 274.317 341.351C274.327 341.522 274.333 341.751 274.333 342.039C274.333 342.317 274.327 342.546 274.317 342.727C274.285 343.431 274.125 344.061 273.837 344.615C273.549 345.159 273.133 345.586 272.589 345.895C272.045 346.205 271.367 346.359 270.557 346.359ZM270.557 345.127C271.218 345.127 271.746 344.919 272.141 344.503C272.535 344.077 272.749 343.458 272.781 342.647C272.791 342.487 272.797 342.285 272.797 342.039C272.797 341.794 272.791 341.591 272.781 341.431C272.749 340.621 272.535 340.007 272.141 339.591C271.746 339.165 271.218 338.951 270.557 338.951C269.895 338.951 269.362 339.165 268.957 339.591C268.562 340.007 268.354 340.621 268.333 341.431C268.322 341.591 268.317 341.794 268.317 342.039C268.317 342.285 268.322 342.487 268.333 342.647C268.354 343.458 268.562 344.077 268.957 344.503C269.362 344.919 269.895 345.127 270.557 345.127ZM276.72 349.239C276.614 349.239 276.523 349.202 276.448 349.127C276.384 349.063 276.352 348.978 276.352 348.871V338.247C276.352 338.141 276.384 338.055 276.448 337.991C276.523 337.917 276.614 337.879 276.72 337.879H277.456C277.563 337.879 277.648 337.917 277.712 337.991C277.787 338.055 277.824 338.141 277.824 338.247V338.951C278.08 338.599 278.422 338.306 278.848 338.071C279.275 337.837 279.808 337.719 280.448 337.719C281.046 337.719 281.552 337.821 281.968 338.023C282.395 338.226 282.742 338.503 283.008 338.855C283.286 339.207 283.494 339.607 283.632 340.055C283.771 340.503 283.851 340.983 283.872 341.495C283.883 341.666 283.888 341.847 283.888 342.039C283.888 342.231 283.883 342.413 283.872 342.583C283.851 343.085 283.771 343.565 283.632 344.023C283.494 344.471 283.286 344.871 283.008 345.223C282.742 345.565 282.395 345.842 281.968 346.055C281.552 346.258 281.046 346.359 280.448 346.359C279.83 346.359 279.307 346.247 278.88 346.023C278.464 345.789 278.123 345.501 277.856 345.159V348.871C277.856 348.978 277.824 349.063 277.76 349.127C277.696 349.202 277.611 349.239 277.504 349.239H276.72ZM280.112 345.063C280.667 345.063 281.099 344.946 281.408 344.711C281.728 344.466 281.958 344.151 282.096 343.767C282.235 343.373 282.315 342.951 282.336 342.503C282.347 342.194 282.347 341.885 282.336 341.575C282.315 341.127 282.235 340.711 282.096 340.327C281.958 339.933 281.728 339.618 281.408 339.383C281.099 339.138 280.667 339.015 280.112 339.015C279.59 339.015 279.163 339.138 278.832 339.383C278.512 339.629 278.272 339.943 278.112 340.327C277.963 340.701 277.878 341.085 277.856 341.479C277.846 341.65 277.84 341.853 277.84 342.087C277.84 342.322 277.846 342.53 277.856 342.711C277.867 343.085 277.952 343.453 278.112 343.815C278.283 344.178 278.534 344.477 278.864 344.711C279.195 344.946 279.611 345.063 280.112 345.063ZM292.407 346.199C292.3 346.199 292.21 346.167 292.135 346.103C292.071 346.029 292.039 345.938 292.039 345.831V336.423H288.967C288.86 336.423 288.77 336.391 288.695 336.327C288.631 336.253 288.599 336.162 288.599 336.055V335.383C288.599 335.266 288.631 335.175 288.695 335.111C288.77 335.037 288.86 334.999 288.967 334.999H296.679C296.796 334.999 296.887 335.037 296.951 335.111C297.026 335.175 297.063 335.266 297.063 335.383V336.055C297.063 336.162 297.026 336.253 296.951 336.327C296.887 336.391 296.796 336.423 296.679 336.423H293.623V345.831C293.623 345.938 293.586 346.029 293.511 346.103C293.447 346.167 293.356 346.199 293.239 346.199H292.407ZM297.72 346.199C297.613 346.199 297.523 346.167 297.448 346.103C297.384 346.029 297.352 345.938 297.352 345.831V338.263C297.352 338.157 297.384 338.066 297.448 337.991C297.523 337.917 297.613 337.879 297.72 337.879H298.456C298.563 337.879 298.653 337.917 298.728 337.991C298.803 338.066 298.84 338.157 298.84 338.263V338.967C299.053 338.605 299.347 338.333 299.72 338.151C300.093 337.97 300.547 337.879 301.08 337.879H301.704C301.811 337.879 301.896 337.917 301.96 337.991C302.035 338.055 302.072 338.141 302.072 338.247V338.903C302.072 339.01 302.035 339.095 301.96 339.159C301.896 339.223 301.811 339.255 301.704 339.255H300.744C300.168 339.255 299.715 339.426 299.384 339.767C299.053 340.098 298.888 340.551 298.888 341.127V345.831C298.888 345.938 298.851 346.029 298.776 346.103C298.701 346.167 298.611 346.199 298.504 346.199H297.72ZM306.534 346.359C305.851 346.359 305.27 346.21 304.79 345.911C304.321 345.602 303.963 345.175 303.718 344.631C303.473 344.087 303.35 343.463 303.35 342.759V338.247C303.35 338.141 303.382 338.055 303.446 337.991C303.521 337.917 303.611 337.879 303.718 337.879H304.518C304.625 337.879 304.71 337.917 304.774 337.991C304.849 338.055 304.886 338.141 304.886 338.247V342.679C304.886 344.269 305.579 345.063 306.966 345.063C307.627 345.063 308.155 344.855 308.55 344.439C308.955 344.013 309.158 343.426 309.158 342.679V338.247C309.158 338.141 309.19 338.055 309.254 337.991C309.329 337.917 309.419 337.879 309.526 337.879H310.326C310.433 337.879 310.518 337.917 310.582 337.991C310.646 338.055 310.678 338.141 310.678 338.247V345.831C310.678 345.938 310.646 346.029 310.582 346.103C310.518 346.167 310.433 346.199 310.326 346.199H309.574C309.467 346.199 309.377 346.167 309.302 346.103C309.238 346.029 309.206 345.938 309.206 345.831V345.127C308.918 345.501 308.566 345.799 308.15 346.023C307.745 346.247 307.206 346.359 306.534 346.359ZM315.935 346.359C315.338 346.359 314.826 346.285 314.399 346.135C313.972 345.986 313.626 345.805 313.359 345.591C313.092 345.378 312.89 345.165 312.751 344.951C312.623 344.738 312.554 344.567 312.543 344.439C312.532 344.322 312.57 344.231 312.655 344.167C312.74 344.103 312.826 344.071 312.911 344.071H313.631C313.684 344.071 313.727 344.082 313.759 344.103C313.802 344.114 313.855 344.157 313.919 344.231C314.058 344.381 314.212 344.53 314.383 344.679C314.554 344.829 314.762 344.951 315.007 345.047C315.263 345.143 315.578 345.191 315.951 345.191C316.495 345.191 316.943 345.09 317.295 344.887C317.647 344.674 317.823 344.365 317.823 343.959C317.823 343.693 317.748 343.479 317.599 343.319C317.46 343.159 317.204 343.015 316.831 342.887C316.468 342.759 315.967 342.626 315.327 342.487C314.687 342.338 314.18 342.157 313.807 341.943C313.434 341.719 313.167 341.458 313.007 341.159C312.847 340.85 312.767 340.503 312.767 340.119C312.767 339.725 312.884 339.346 313.119 338.983C313.354 338.61 313.695 338.306 314.143 338.071C314.602 337.837 315.172 337.719 315.855 337.719C316.41 337.719 316.884 337.789 317.279 337.927C317.674 338.066 317.999 338.242 318.255 338.455C318.511 338.658 318.703 338.861 318.831 339.063C318.959 339.266 319.028 339.437 319.039 339.575C319.05 339.682 319.018 339.773 318.943 339.847C318.868 339.911 318.783 339.943 318.687 339.943H318.015C317.94 339.943 317.876 339.927 317.823 339.895C317.78 339.863 317.738 339.826 317.695 339.783C317.588 339.645 317.46 339.506 317.311 339.367C317.172 339.229 316.986 339.117 316.751 339.031C316.527 338.935 316.228 338.887 315.855 338.887C315.322 338.887 314.922 338.999 314.655 339.223C314.388 339.447 314.255 339.73 314.255 340.071C314.255 340.274 314.314 340.455 314.431 340.615C314.548 340.775 314.772 340.919 315.103 341.047C315.434 341.175 315.924 341.314 316.575 341.463C317.279 341.602 317.834 341.789 318.239 342.023C318.644 342.258 318.932 342.53 319.103 342.839C319.274 343.149 319.359 343.506 319.359 343.911C319.359 344.359 319.231 344.77 318.975 345.143C318.719 345.517 318.335 345.815 317.823 346.039C317.311 346.253 316.682 346.359 315.935 346.359ZM324.444 346.199C323.846 346.199 323.361 346.087 322.988 345.863C322.614 345.629 322.342 345.303 322.172 344.887C322.001 344.461 321.916 343.959 321.916 343.383V339.159H320.668C320.561 339.159 320.47 339.127 320.396 339.063C320.332 338.989 320.3 338.898 320.3 338.791V338.247C320.3 338.141 320.332 338.055 320.396 337.991C320.47 337.917 320.561 337.879 320.668 337.879H321.916V335.207C321.916 335.101 321.948 335.015 322.012 334.951C322.086 334.877 322.177 334.839 322.284 334.839H323.036C323.142 334.839 323.228 334.877 323.292 334.951C323.366 335.015 323.404 335.101 323.404 335.207V337.879H325.388C325.505 337.879 325.596 337.917 325.66 337.991C325.724 338.055 325.756 338.141 325.756 338.247V338.791C325.756 338.898 325.724 338.989 325.66 339.063C325.596 339.127 325.505 339.159 325.388 339.159H323.404V343.271C323.404 343.773 323.489 344.167 323.66 344.455C323.83 344.743 324.134 344.887 324.572 344.887H325.548C325.654 344.887 325.74 344.925 325.804 344.999C325.878 345.063 325.916 345.149 325.916 345.255V345.831C325.916 345.938 325.878 346.029 325.804 346.103C325.74 346.167 325.654 346.199 325.548 346.199H324.444ZM335.655 346.359C334.706 346.359 333.901 346.183 333.239 345.831C332.589 345.479 332.087 344.983 331.735 344.343C331.394 343.703 331.202 342.951 331.159 342.087C331.149 341.618 331.143 341.122 331.143 340.599C331.143 340.066 331.149 339.559 331.159 339.079C331.202 338.215 331.394 337.469 331.735 336.839C332.087 336.199 332.594 335.709 333.255 335.367C333.917 335.015 334.717 334.839 335.655 334.839C336.402 334.839 337.053 334.946 337.607 335.159C338.162 335.373 338.615 335.645 338.967 335.975C339.33 336.295 339.597 336.631 339.767 336.983C339.949 337.335 340.045 337.645 340.055 337.911C340.066 338.007 340.039 338.087 339.975 338.151C339.911 338.205 339.826 338.231 339.719 338.231H338.775C338.669 338.231 338.589 338.21 338.535 338.167C338.493 338.125 338.45 338.05 338.407 337.943C338.311 337.666 338.151 337.394 337.927 337.127C337.714 336.861 337.421 336.642 337.047 336.471C336.685 336.29 336.221 336.199 335.655 336.199C334.802 336.199 334.114 336.429 333.591 336.887C333.079 337.346 332.802 338.103 332.759 339.159C332.727 340.109 332.727 341.058 332.759 342.007C332.802 343.074 333.085 343.842 333.607 344.311C334.13 344.77 334.813 344.999 335.655 344.999C336.221 344.999 336.722 344.893 337.159 344.679C337.607 344.466 337.959 344.146 338.215 343.719C338.471 343.282 338.599 342.727 338.599 342.055V341.383H336.199C336.093 341.383 336.002 341.351 335.927 341.287C335.863 341.213 335.831 341.117 335.831 340.999V340.487C335.831 340.37 335.863 340.279 335.927 340.215C336.002 340.141 336.093 340.103 336.199 340.103H339.815C339.933 340.103 340.023 340.141 340.087 340.215C340.151 340.279 340.183 340.37 340.183 340.487V342.023C340.183 342.898 340.002 343.661 339.639 344.311C339.287 344.962 338.77 345.469 338.087 345.831C337.405 346.183 336.594 346.359 335.655 346.359ZM344.578 346.359C344.045 346.359 343.559 346.253 343.122 346.039C342.685 345.826 342.333 345.538 342.066 345.175C341.799 344.813 341.666 344.402 341.666 343.943C341.666 343.207 341.965 342.621 342.562 342.183C343.159 341.746 343.938 341.458 344.898 341.319L347.282 340.983V340.519C347.282 340.007 347.133 339.607 346.834 339.319C346.546 339.031 346.071 338.887 345.41 338.887C344.941 338.887 344.557 338.983 344.258 339.175C343.959 339.367 343.751 339.613 343.634 339.911C343.57 340.071 343.458 340.151 343.298 340.151H342.578C342.461 340.151 342.37 340.119 342.306 340.055C342.253 339.981 342.226 339.895 342.226 339.799C342.226 339.639 342.285 339.442 342.402 339.207C342.53 338.973 342.722 338.743 342.978 338.519C343.234 338.295 343.559 338.109 343.954 337.959C344.359 337.799 344.85 337.719 345.426 337.719C346.066 337.719 346.605 337.805 347.042 337.975C347.479 338.135 347.821 338.354 348.066 338.631C348.322 338.909 348.503 339.223 348.61 339.575C348.727 339.927 348.786 340.285 348.786 340.647V345.831C348.786 345.938 348.749 346.029 348.674 346.103C348.61 346.167 348.525 346.199 348.418 346.199H347.682C347.565 346.199 347.474 346.167 347.41 346.103C347.346 346.029 347.314 345.938 347.314 345.831V345.143C347.175 345.335 346.989 345.527 346.754 345.719C346.519 345.901 346.226 346.055 345.874 346.183C345.522 346.301 345.09 346.359 344.578 346.359ZM344.914 345.159C345.351 345.159 345.751 345.069 346.114 344.887C346.477 344.695 346.759 344.402 346.962 344.007C347.175 343.613 347.282 343.117 347.282 342.519V342.071L345.426 342.343C344.669 342.45 344.098 342.631 343.714 342.887C343.33 343.133 343.138 343.447 343.138 343.831C343.138 344.13 343.223 344.381 343.394 344.583C343.575 344.775 343.799 344.919 344.066 345.015C344.343 345.111 344.626 345.159 344.914 345.159ZM351.47 349.239C351.364 349.239 351.273 349.202 351.198 349.127C351.134 349.063 351.102 348.978 351.102 348.871V338.247C351.102 338.141 351.134 338.055 351.198 337.991C351.273 337.917 351.364 337.879 351.47 337.879H352.206C352.313 337.879 352.398 337.917 352.462 337.991C352.537 338.055 352.574 338.141 352.574 338.247V338.951C352.83 338.599 353.172 338.306 353.598 338.071C354.025 337.837 354.558 337.719 355.198 337.719C355.796 337.719 356.302 337.821 356.718 338.023C357.145 338.226 357.492 338.503 357.758 338.855C358.036 339.207 358.244 339.607 358.382 340.055C358.521 340.503 358.601 340.983 358.622 341.495C358.633 341.666 358.638 341.847 358.638 342.039C358.638 342.231 358.633 342.413 358.622 342.583C358.601 343.085 358.521 343.565 358.382 344.023C358.244 344.471 358.036 344.871 357.758 345.223C357.492 345.565 357.145 345.842 356.718 346.055C356.302 346.258 355.796 346.359 355.198 346.359C354.58 346.359 354.057 346.247 353.63 346.023C353.214 345.789 352.873 345.501 352.606 345.159V348.871C352.606 348.978 352.574 349.063 352.51 349.127C352.446 349.202 352.361 349.239 352.254 349.239H351.47ZM354.862 345.063C355.417 345.063 355.849 344.946 356.158 344.711C356.478 344.466 356.708 344.151 356.846 343.767C356.985 343.373 357.065 342.951 357.086 342.503C357.097 342.194 357.097 341.885 357.086 341.575C357.065 341.127 356.985 340.711 356.846 340.327C356.708 339.933 356.478 339.618 356.158 339.383C355.849 339.138 355.417 339.015 354.862 339.015C354.34 339.015 353.913 339.138 353.582 339.383C353.262 339.629 353.022 339.943 352.862 340.327C352.713 340.701 352.628 341.085 352.606 341.479C352.596 341.65 352.59 341.853 352.59 342.087C352.59 342.322 352.596 342.53 352.606 342.711C352.617 343.085 352.702 343.453 352.862 343.815C353.033 344.178 353.284 344.477 353.614 344.711C353.945 344.946 354.361 345.063 354.862 345.063ZM363.498 346.359C362.9 346.359 362.388 346.285 361.962 346.135C361.535 345.986 361.188 345.805 360.922 345.591C360.655 345.378 360.452 345.165 360.314 344.951C360.186 344.738 360.116 344.567 360.106 344.439C360.095 344.322 360.132 344.231 360.218 344.167C360.303 344.103 360.388 344.071 360.474 344.071H361.194C361.247 344.071 361.29 344.082 361.322 344.103C361.364 344.114 361.418 344.157 361.482 344.231C361.62 344.381 361.775 344.53 361.946 344.679C362.116 344.829 362.324 344.951 362.57 345.047C362.826 345.143 363.14 345.191 363.514 345.191C364.058 345.191 364.506 345.09 364.858 344.887C365.21 344.674 365.386 344.365 365.386 343.959C365.386 343.693 365.311 343.479 365.162 343.319C365.023 343.159 364.767 343.015 364.394 342.887C364.031 342.759 363.53 342.626 362.89 342.487C362.25 342.338 361.743 342.157 361.37 341.943C360.996 341.719 360.73 341.458 360.57 341.159C360.41 340.85 360.33 340.503 360.33 340.119C360.33 339.725 360.447 339.346 360.682 338.983C360.916 338.61 361.258 338.306 361.706 338.071C362.164 337.837 362.735 337.719 363.418 337.719C363.972 337.719 364.447 337.789 364.842 337.927C365.236 338.066 365.562 338.242 365.818 338.455C366.074 338.658 366.266 338.861 366.394 339.063C366.522 339.266 366.591 339.437 366.602 339.575C366.612 339.682 366.58 339.773 366.506 339.847C366.431 339.911 366.346 339.943 366.25 339.943H365.578C365.503 339.943 365.439 339.927 365.386 339.895C365.343 339.863 365.3 339.826 365.258 339.783C365.151 339.645 365.023 339.506 364.874 339.367C364.735 339.229 364.548 339.117 364.314 339.031C364.09 338.935 363.791 338.887 363.418 338.887C362.884 338.887 362.484 338.999 362.218 339.223C361.951 339.447 361.818 339.73 361.818 340.071C361.818 340.274 361.876 340.455 361.994 340.615C362.111 340.775 362.335 340.919 362.666 341.047C362.996 341.175 363.487 341.314 364.138 341.463C364.842 341.602 365.396 341.789 365.802 342.023C366.207 342.258 366.495 342.53 366.666 342.839C366.836 343.149 366.922 343.506 366.922 343.911C366.922 344.359 366.794 344.77 366.538 345.143C366.282 345.517 365.898 345.815 365.386 346.039C364.874 346.253 364.244 346.359 363.498 346.359Z",
                fill: "#B9C3D1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M396.821 71.8433C396.732 71.8086 396.669 71.7499 396.633 71.6672C396.6 71.5745 396.599 71.4884 396.63 71.4089C396.65 71.3592 396.672 71.3165 396.698 71.2806L403.99 63.0725C404.062 62.9748 404.159 62.9035 404.28 62.8587C404.4 62.8138 404.54 62.8223 404.699 62.8839L406.609 63.6236C406.768 63.6853 406.877 63.7732 406.935 63.8874C406.994 64.0015 407.017 64.119 407.004 64.2399L406.813 75.1989C406.808 75.2425 406.795 75.2891 406.776 75.3388C406.745 75.4183 406.686 75.4813 406.599 75.5277C406.516 75.5642 406.43 75.5651 406.34 75.5304L404.789 74.9294C404.639 74.8716 404.544 74.7944 404.501 74.6979C404.459 74.6014 404.439 74.5195 404.442 74.4522L404.453 72.5344L400.245 70.9046L398.952 72.3254C398.909 72.3773 398.839 72.4246 398.742 72.4671C398.645 72.5097 398.522 72.5021 398.373 72.4443L396.821 71.8433ZM401.548 69.1958L404.636 70.3921L404.775 65.5043L401.548 69.1958Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M417.93 80.2615C417.824 80.2103 417.754 80.1348 417.72 80.0351C417.686 79.9354 417.694 79.8329 417.746 79.7275L422.32 70.3871C422.371 70.2817 422.447 70.2118 422.547 70.1774C422.647 70.143 422.75 70.1514 422.855 70.2027L426.784 72.1114C427.561 72.4889 428.174 72.935 428.623 73.4495C429.081 73.9686 429.349 74.5494 429.427 75.1918C429.518 75.8293 429.388 76.5073 429.036 77.2258C428.68 77.9538 428.221 78.4781 427.661 78.7986C427.114 79.1142 426.497 79.2472 425.809 79.1974C425.13 79.1523 424.402 78.941 423.625 78.5634L421.696 77.6266L420.106 80.8741C420.055 80.9795 419.979 81.0494 419.879 81.0839C419.779 81.1183 419.676 81.1099 419.571 81.0586L417.93 80.2615ZM422.526 75.8237L424.425 76.7466C424.915 76.9843 425.352 77.0487 425.738 76.9397C426.134 76.8354 426.449 76.5437 426.683 76.0648C426.89 75.6432 426.934 75.2378 426.816 74.8483C426.707 74.4636 426.38 74.1384 425.833 73.8727L423.933 72.9498L422.526 75.8237Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M436.369 89.4559C436.268 89.3963 436.204 89.3153 436.178 89.2132C436.152 89.1111 436.169 89.0096 436.229 88.9088L441.55 79.9727C441.61 79.8719 441.691 79.8084 441.793 79.7822C441.896 79.756 441.998 79.7728 442.099 79.8325L445.859 82.0541C446.603 82.4935 447.178 82.9878 447.583 83.5371C447.998 84.0917 448.218 84.6922 448.242 85.3387C448.282 85.9814 448.097 86.6465 447.688 87.3339C447.273 88.0304 446.773 88.5156 446.188 88.7894C445.618 89.0595 444.991 89.1417 444.309 89.0362C443.636 88.9361 442.928 88.6663 442.184 88.2268L440.338 87.1364L438.488 90.2434C438.428 90.3442 438.347 90.4077 438.245 90.4339C438.142 90.4601 438.04 90.4433 437.939 90.3836L436.369 89.4559ZM441.312 85.4072L443.13 86.4814C443.599 86.7581 444.03 86.8578 444.423 86.7806C444.826 86.7088 445.164 86.4438 445.437 85.9855C445.677 85.5823 445.754 85.1818 445.668 84.7841C445.591 84.3918 445.291 84.0411 444.767 83.7319L442.949 82.6577L441.312 85.4072Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M454.002 100.141C453.906 100.074 453.849 99.9884 453.831 99.8846C453.813 99.7807 453.838 99.6809 453.905 99.585L459.901 91.0873C459.969 90.9915 460.055 90.9344 460.159 90.9162C460.263 90.8981 460.363 90.9226 460.459 90.9899L461.914 92.0084C462.01 92.0757 462.068 92.1613 462.086 92.2651C462.104 92.3689 462.079 92.4688 462.011 92.5647L457.021 99.6373L461.084 102.482C461.18 102.549 461.238 102.635 461.256 102.739C461.274 102.842 461.249 102.942 461.181 103.038L460.407 104.136C460.339 104.232 460.253 104.289 460.149 104.307C460.045 104.326 459.944 104.301 459.848 104.234L454.002 100.141Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M468.804 110.815C468.712 110.742 468.66 110.653 468.648 110.549C468.635 110.444 468.666 110.346 468.739 110.254L475.209 102.111C475.282 102.019 475.371 101.967 475.476 101.955C475.581 101.943 475.679 101.973 475.772 102.046L477.191 103.165C477.284 103.238 477.336 103.326 477.348 103.431C477.36 103.536 477.33 103.634 477.257 103.726L470.787 111.868C470.714 111.96 470.625 112.012 470.52 112.025C470.415 112.037 470.316 112.007 470.224 111.934L468.804 110.815Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M480.003 120.161C479.256 119.492 478.731 118.8 478.428 118.085C478.141 117.369 478.068 116.646 478.211 115.914C478.361 115.175 478.731 114.447 479.321 113.729C479.606 113.398 479.917 113.046 480.252 112.674C480.588 112.302 480.914 111.949 481.229 111.615C481.876 110.963 482.556 110.527 483.271 110.308C484.001 110.089 484.743 110.087 485.496 110.303C486.249 110.52 486.991 110.955 487.722 111.61C488.255 112.087 488.678 112.588 488.994 113.114C489.309 113.64 489.512 114.172 489.601 114.71C489.69 115.248 489.668 115.766 489.536 116.263C489.403 116.76 489.156 117.225 488.793 117.659C488.728 117.73 488.647 117.765 488.548 117.762C488.458 117.767 488.377 117.738 488.305 117.674L486.947 116.457C486.851 116.371 486.797 116.28 486.784 116.183C486.772 116.085 486.799 115.967 486.868 115.828C487.17 115.254 487.261 114.755 487.14 114.332C487.019 113.909 486.752 113.512 486.339 113.142C485.847 112.701 485.336 112.487 484.807 112.5C484.278 112.513 483.719 112.821 483.13 113.425C482.52 114.053 481.92 114.718 481.329 115.421C480.788 116.068 480.539 116.654 480.583 117.179C480.626 117.705 480.893 118.188 481.386 118.629C481.799 118.999 482.223 119.222 482.659 119.296C483.109 119.371 483.597 119.228 484.123 118.868C484.262 118.778 484.377 118.738 484.469 118.748C484.567 118.75 484.664 118.794 484.759 118.88L486.118 120.096C486.19 120.161 486.228 120.238 486.233 120.328C486.245 120.425 486.22 120.509 486.155 120.581C485.761 120.986 485.322 121.281 484.84 121.465C484.358 121.649 483.844 121.725 483.297 121.694C482.75 121.662 482.198 121.518 481.639 121.262C481.081 121.005 480.535 120.638 480.003 120.161Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M491.928 130.757C491.862 130.688 491.83 130.608 491.833 130.517C491.843 130.42 491.88 130.342 491.942 130.283C491.981 130.247 492.02 130.218 492.058 130.197L502.18 125.931C502.288 125.874 502.406 125.851 502.534 125.862C502.662 125.874 502.785 125.942 502.902 126.066L504.308 127.555C504.425 127.679 504.486 127.805 504.489 127.933C504.493 128.061 504.463 128.177 504.399 128.28L499.506 138.083C499.483 138.12 499.451 138.157 499.412 138.193C499.35 138.252 499.27 138.283 499.171 138.288C499.081 138.285 499.002 138.249 498.936 138.179L497.794 136.969C497.684 136.853 497.631 136.742 497.634 136.637C497.637 136.531 497.655 136.449 497.687 136.39L498.522 134.664L495.424 131.384L493.644 132.109C493.583 132.137 493.499 132.15 493.394 132.146C493.288 132.143 493.18 132.083 493.07 131.967L491.928 130.757ZM497.337 130.403L499.611 132.811L501.842 128.462L497.337 130.403Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M507.509 147.756C507.435 147.665 507.403 147.567 507.414 147.462C507.425 147.357 507.476 147.268 507.567 147.194L514.232 141.797L512.39 139.541C512.323 139.458 512.295 139.365 512.305 139.26C512.316 139.155 512.363 139.069 512.446 139.002L513.565 138.096C513.656 138.022 513.754 137.99 513.86 138.001C513.965 138.012 514.051 138.059 514.119 138.141L519.42 144.637C519.494 144.727 519.526 144.825 519.515 144.93C519.504 145.035 519.453 145.124 519.362 145.198L518.243 146.104C518.16 146.172 518.066 146.2 517.961 146.189C517.855 146.178 517.766 146.127 517.692 146.036L515.86 143.793L509.196 149.19C509.104 149.263 509.006 149.295 508.901 149.284C508.796 149.273 508.706 149.222 508.632 149.131L507.509 147.756Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M517.797 160.771C517.728 160.676 517.702 160.576 517.719 160.472C517.736 160.368 517.792 160.282 517.887 160.214L526.335 154.147C526.43 154.079 526.53 154.053 526.634 154.07C526.739 154.087 526.825 154.143 526.894 154.238L527.954 155.703C528.023 155.798 528.049 155.897 528.032 156.001C528.015 156.105 527.959 156.192 527.864 156.26L519.416 162.326C519.321 162.395 519.221 162.421 519.117 162.404C519.012 162.387 518.926 162.331 518.857 162.236L517.797 160.771Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M525.998 172.789C525.479 171.968 525.167 171.176 525.062 170.41C524.957 169.645 525.07 168.926 525.402 168.252C525.742 167.573 526.319 166.959 527.133 166.411C527.516 166.158 527.897 165.912 528.277 165.674C528.665 165.431 529.061 165.189 529.465 164.948C530.295 164.465 531.091 164.217 531.853 164.205C532.63 164.197 533.347 164.402 534.003 164.821C534.665 165.249 535.25 165.865 535.757 166.667C536.259 167.461 536.558 168.243 536.654 169.014C536.755 169.793 536.634 170.53 536.291 171.224C535.956 171.913 535.388 172.521 534.586 173.049C534.2 173.316 533.813 173.572 533.424 173.816C533.045 174.054 532.655 174.286 532.255 174.511C531.406 175.006 530.601 175.259 529.839 175.271C529.086 175.278 528.386 175.068 527.739 174.643C527.091 174.218 526.511 173.6 525.998 172.789ZM527.747 171.692C528.077 172.215 528.506 172.544 529.033 172.679C529.575 172.818 530.204 172.675 530.92 172.251C531.329 172.02 531.706 171.796 532.049 171.581C532.401 171.36 532.766 171.118 533.143 170.857C533.607 170.553 533.937 170.226 534.133 169.877C534.329 169.528 534.409 169.175 534.373 168.82C534.352 168.468 534.231 168.116 534.009 167.764C533.786 167.412 533.517 167.147 533.202 166.967C532.895 166.781 532.542 166.701 532.141 166.726C531.746 166.76 531.308 166.915 530.826 167.192C530.432 167.426 530.059 167.654 529.706 167.875C529.363 168.091 528.995 168.328 528.603 168.586C527.916 169.055 527.515 169.559 527.4 170.096C527.295 170.628 527.41 171.16 527.747 171.692Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M535.341 187.646C535.287 187.542 535.276 187.44 535.308 187.339C535.34 187.239 535.408 187.162 535.513 187.108L544.759 182.348C544.864 182.295 544.966 182.284 545.067 182.316C545.168 182.348 545.245 182.416 545.299 182.52L545.97 183.813C546.043 183.955 546.064 184.076 546.032 184.176C546 184.277 545.97 184.346 545.942 184.385L541.977 191.23L547.81 188.228C547.914 188.174 548.017 188.163 548.118 188.196C548.218 188.228 548.293 188.291 548.342 188.386L549.094 189.834C549.148 189.939 549.159 190.041 549.127 190.141C549.095 190.242 549.027 190.319 548.923 190.373L539.676 195.133C539.581 195.181 539.478 195.192 539.368 195.165C539.267 195.133 539.19 195.065 539.136 194.961L538.458 193.654C538.384 193.512 538.363 193.391 538.395 193.29C538.442 193.194 538.472 193.125 538.486 193.082L542.273 186.346L536.625 189.253C536.521 189.307 536.418 189.317 536.318 189.285C536.217 189.253 536.139 189.185 536.085 189.081L535.341 187.646Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M546.455 210.605C546.061 209.661 545.868 208.811 545.876 208.057C545.889 207.313 546.049 206.686 546.357 206.178C546.664 205.669 547.065 205.301 547.56 205.073C547.638 205.04 547.72 205.041 547.803 205.075C547.897 205.106 547.962 205.165 547.999 205.254L548.66 206.834C548.713 206.962 548.725 207.072 548.694 207.166C548.674 207.255 548.636 207.345 548.582 207.437C548.444 207.576 548.326 207.751 548.23 207.964C548.138 208.187 548.094 208.454 548.097 208.764C548.109 209.071 548.198 209.421 548.362 209.815C548.629 210.455 548.932 210.889 549.271 211.118C549.614 211.357 549.962 211.403 550.317 211.256C550.573 211.15 550.743 210.975 550.827 210.733C550.914 210.5 550.944 210.17 550.916 209.743C550.892 209.326 550.826 208.782 550.719 208.11C550.568 207.307 550.507 206.593 550.535 205.969C550.578 205.351 550.74 204.828 551.023 204.399C551.32 203.975 551.765 203.641 552.356 203.396C552.947 203.151 553.537 203.097 554.126 203.233C554.725 203.366 555.276 203.675 555.779 204.159C556.292 204.639 556.719 205.288 557.06 206.105C557.336 206.764 557.49 207.381 557.522 207.957C557.558 208.542 557.504 209.061 557.358 209.515C557.216 209.977 557.02 210.365 556.768 210.677C556.517 210.989 556.241 211.213 555.94 211.35C555.861 211.382 555.775 211.383 555.681 211.353C555.597 211.318 555.537 211.257 555.5 211.168L554.809 209.515C554.768 209.416 554.75 209.32 554.757 209.225C554.763 209.129 554.806 209.037 554.884 208.947C555.115 208.782 555.263 208.513 555.327 208.14C555.404 207.773 555.347 207.358 555.153 206.895C554.952 206.413 554.703 206.066 554.406 205.854C554.114 205.652 553.785 205.626 553.421 205.778C553.184 205.876 553.011 206.028 552.901 206.236C552.805 206.449 552.763 206.749 552.775 207.137C552.8 207.53 552.856 208.038 552.943 208.66C553.128 209.6 553.21 210.391 553.19 211.035C553.17 211.678 553.016 212.21 552.729 212.629C552.451 213.044 552.017 213.374 551.426 213.619C550.766 213.893 550.121 213.941 549.492 213.763C548.867 213.595 548.29 213.239 547.763 212.696C547.249 212.159 546.813 211.462 546.455 210.605Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M438.443 499.848C500.189 459.17 540.921 389.355 540.921 310.058C540.921 184.505 438.811 82.7246 312.851 82.7246C259.642 82.7246 210.689 100.887 171.891 131.331C171.692 131.487 171.493 131.644 171.294 131.801",
                stroke: "#D057FF",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M71.2901 233.701C63.8689 257.405 59.8701 282.614 59.8701 308.754C59.8701 447.724 172.893 560.382 312.314 560.382C362.84 560.382 409.899 545.586 449.369 520.104",
                stroke: "#F25A00",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M201.186 560.654C201.341 560.725 201.447 560.827 201.503 560.959C201.55 561.086 201.554 561.217 201.515 561.352L198.847 571.416C198.848 571.439 198.844 571.461 198.835 571.48C198.826 571.5 198.819 571.514 198.814 571.524C198.778 571.601 198.718 571.656 198.633 571.687C198.543 571.728 198.455 571.728 198.368 571.688L196.842 570.984C196.59 570.868 196.497 570.702 196.563 570.485L198.326 563.845L195.375 567.118C195.31 567.182 195.224 567.242 195.115 567.298C195.007 567.354 194.876 567.346 194.721 567.274L193.805 566.852C193.65 566.78 193.559 566.686 193.532 566.567C193.504 566.449 193.499 566.347 193.516 566.26L194.092 561.909L190.17 567.536C190.046 567.726 189.854 567.76 189.592 567.64L188.067 566.936C187.98 566.896 187.923 566.828 187.896 566.734C187.865 566.649 187.868 566.568 187.903 566.491C187.908 566.481 187.915 566.466 187.924 566.447C187.933 566.428 187.947 566.411 187.965 566.396L193.945 557.86C194.023 557.743 194.131 557.663 194.268 557.621C194.396 557.574 194.537 557.587 194.692 557.658L195.869 558.201C196.024 558.272 196.127 558.367 196.178 558.485C196.215 558.607 196.228 558.719 196.217 558.819L195.68 564.034L199.311 560.247C199.381 560.173 199.479 560.113 199.607 560.066C199.72 560.025 199.859 560.042 200.024 560.118L201.186 560.654Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M177.897 549.129C178.742 549.606 179.392 550.156 179.847 550.78C180.302 551.404 180.543 552.092 180.571 552.842C180.593 553.601 180.375 554.415 179.918 555.284C179.701 555.688 179.481 556.085 179.26 556.474C179.033 556.873 178.799 557.274 178.558 557.676C178.055 558.495 177.471 559.09 176.806 559.462C176.126 559.838 175.398 559.996 174.621 559.938C173.835 559.874 173.029 559.609 172.202 559.142C171.384 558.681 170.751 558.134 170.301 557.5C169.842 556.862 169.6 556.155 169.574 555.381C169.542 554.617 169.755 553.812 170.211 552.967C170.424 552.548 170.644 552.14 170.871 551.741C171.092 551.352 171.326 550.963 171.571 550.575C172.084 549.737 172.673 549.133 173.339 548.761C173.999 548.399 174.714 548.251 175.486 548.319C176.257 548.387 177.061 548.657 177.897 549.129ZM176.877 550.923C176.338 550.619 175.804 550.532 175.276 550.663C174.733 550.797 174.247 551.221 173.817 551.934C173.566 552.331 173.341 552.706 173.14 553.058C172.935 553.42 172.728 553.805 172.52 554.215C172.255 554.702 172.119 555.146 172.112 555.546C172.105 555.946 172.202 556.295 172.401 556.591C172.586 556.891 172.86 557.144 173.222 557.348C173.585 557.553 173.947 557.659 174.31 557.668C174.668 557.686 175.018 557.59 175.359 557.378C175.691 557.161 176.003 556.817 176.296 556.345C176.532 555.952 176.753 555.574 176.958 555.213C177.159 554.86 177.37 554.478 177.593 554.064C177.977 553.325 178.091 552.692 177.937 552.164C177.778 551.646 177.425 551.232 176.877 550.923Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M163.856 541.211C163.953 541.276 164.012 541.36 164.033 541.464C164.053 541.567 164.03 541.668 163.965 541.765L158.156 550.392C158.091 550.489 158.006 550.548 157.902 550.568C157.798 550.589 157.698 550.566 157.6 550.501L154.075 548.146C152.966 547.405 152.265 546.565 151.972 545.625C151.673 544.694 151.845 543.751 152.489 542.795C152.924 542.149 153.442 541.713 154.045 541.487C154.647 541.261 155.281 541.217 155.947 541.354L156.306 536.783C156.315 536.712 156.334 536.654 156.364 536.61C156.412 536.539 156.483 536.491 156.578 536.464C156.667 536.447 156.751 536.465 156.831 536.518L158.308 537.505C158.468 537.611 158.561 537.731 158.587 537.864C158.607 538.006 158.611 538.124 158.599 538.218L158.175 542.342L159.785 543.418L161.85 540.352C161.915 540.254 162 540.196 162.104 540.175C162.207 540.155 162.308 540.177 162.406 540.242L163.856 541.211ZM158.65 545.103L156.947 543.965C156.46 543.639 156.026 543.51 155.646 543.577C155.258 543.638 154.93 543.868 154.662 544.266C154.393 544.664 154.297 545.056 154.373 545.44C154.449 545.824 154.735 546.182 155.232 546.514L156.935 547.651L158.65 545.103Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M147.662 530.219C147.754 530.291 147.807 530.379 147.82 530.484C147.833 530.588 147.803 530.687 147.73 530.779L141.312 538.962C141.24 539.055 141.151 539.107 141.046 539.12C140.941 539.133 140.842 539.103 140.749 539.031L139.411 537.99C139.318 537.918 139.266 537.829 139.253 537.725C139.24 537.62 139.27 537.522 139.342 537.429L141.594 534.559L136.682 535.481C136.609 535.505 136.514 535.513 136.399 535.504C136.269 535.497 136.136 535.441 136.002 535.337L134.474 534.148C134.398 534.089 134.358 534.01 134.354 533.912C134.343 533.822 134.363 533.744 134.416 533.677C134.462 533.618 134.518 533.581 134.585 533.565L140.812 532.288L140.606 525.397C140.598 525.337 140.621 525.273 140.674 525.206C140.726 525.139 140.801 525.096 140.898 525.076C140.988 525.065 141.07 525.089 141.146 525.148L142.725 526.377C142.876 526.495 142.963 526.617 142.986 526.743C143.01 526.869 143.024 526.954 143.029 526.999L143.292 532.394L145.761 529.246C145.833 529.154 145.922 529.101 146.027 529.088C146.132 529.076 146.231 529.105 146.323 529.177L147.662 530.219Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M133.108 518.705C133.195 518.783 133.242 518.875 133.248 518.98C133.253 519.085 133.217 519.181 133.139 519.269L126.182 527C126.104 527.087 126.011 527.133 125.906 527.139C125.8 527.145 125.704 527.109 125.616 527.03L124.291 525.848C124.204 525.77 124.157 525.678 124.151 525.573C124.146 525.467 124.182 525.371 124.26 525.284L130.05 518.849L126.35 515.546C126.263 515.468 126.216 515.376 126.21 515.271C126.205 515.166 126.241 515.07 126.32 514.982L127.219 513.983C127.297 513.896 127.389 513.85 127.495 513.844C127.6 513.838 127.697 513.874 127.785 513.952L133.108 518.705Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M118.017 504.559C118.695 505.254 119.164 505.964 119.426 506.691C119.688 507.418 119.726 508.145 119.542 508.872C119.35 509.607 118.912 510.327 118.229 511.033C117.907 511.359 117.585 511.678 117.263 511.99C116.934 512.309 116.596 512.628 116.252 512.946C115.539 513.591 114.812 513.998 114.069 514.168C113.31 514.338 112.567 514.286 111.837 514.012C111.101 513.73 110.401 513.249 109.738 512.57C109.083 511.898 108.628 511.195 108.374 510.461C108.113 509.719 108.079 508.973 108.271 508.223C108.455 507.481 108.885 506.768 109.56 506.085C109.883 505.743 110.209 505.413 110.538 505.094C110.86 504.783 111.193 504.475 111.538 504.171C112.265 503.512 113.001 503.097 113.744 502.927C114.479 502.765 115.208 502.824 115.929 503.106C116.651 503.387 117.347 503.872 118.017 504.559ZM116.534 505.994C116.102 505.551 115.614 505.318 115.07 505.295C114.511 505.272 113.925 505.542 113.312 506.106C112.96 506.417 112.639 506.713 112.347 506.995C112.048 507.284 111.741 507.596 111.427 507.93C111.036 508.324 110.781 508.711 110.662 509.094C110.543 509.476 110.537 509.837 110.646 510.177C110.739 510.518 110.931 510.837 111.222 511.134C111.512 511.432 111.83 511.636 112.176 511.747C112.515 511.865 112.877 511.87 113.264 511.762C113.644 511.648 114.041 511.405 114.454 511.034C114.791 510.723 115.109 510.423 115.408 510.134C115.699 509.852 116.01 509.544 116.34 509.21C116.915 508.608 117.203 508.033 117.204 507.483C117.197 506.941 116.973 506.445 116.534 505.994Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M107.713 494.176C107.774 494.249 107.801 494.331 107.793 494.421C107.777 494.518 107.736 494.594 107.671 494.648C107.63 494.682 107.589 494.709 107.55 494.728L97.1953 498.394C97.0845 498.444 96.9655 498.46 96.8382 498.441C96.711 498.422 96.5925 498.347 96.4828 498.216L95.1663 496.648C95.0566 496.517 95.0037 496.387 95.0076 496.259C95.0114 496.131 95.0482 496.017 95.1178 495.918L100.576 486.418C100.602 486.383 100.636 486.348 100.677 486.314C100.742 486.259 100.824 486.232 100.923 486.234C101.013 486.242 101.089 486.283 101.151 486.356L102.221 487.631C102.324 487.753 102.37 487.867 102.361 487.972C102.351 488.077 102.329 488.158 102.294 488.215L101.359 489.889L104.259 493.345L106.078 492.726C106.141 492.701 106.225 492.694 106.331 492.703C106.436 492.713 106.54 492.779 106.643 492.901L107.713 494.176ZM102.292 494.213L100.163 491.675L97.6813 495.886L102.292 494.213Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M94.174 477.806C94.2424 477.901 94.2678 478.001 94.2505 478.105C94.2331 478.208 94.1766 478.294 94.0809 478.362L85.604 484.387C85.5084 484.455 85.4084 484.481 85.304 484.463C85.1997 484.446 85.1133 484.389 85.045 484.294L82.7063 481.029C82.0851 480.162 81.7055 479.339 81.5675 478.561C81.4209 477.788 81.504 477.062 81.8169 476.381C82.115 475.698 82.6447 475.073 83.406 474.506C83.7824 474.225 84.114 473.983 84.4009 473.779C84.6878 473.575 85.0213 473.345 85.4014 473.087C86.2286 472.539 87.013 472.223 87.7545 472.141C88.4961 472.059 89.2023 472.212 89.8731 472.598C90.5352 472.992 91.1737 473.617 91.7887 474.476L94.174 477.806ZM91.2431 477.258L90.1529 475.737C89.8423 475.303 89.5225 474.994 89.1933 474.809C88.8641 474.624 88.5138 474.566 88.1424 474.633C87.7561 474.699 87.3338 474.887 86.8755 475.2C86.6171 475.371 86.3879 475.527 86.188 475.669C85.9818 475.803 85.7818 475.945 85.5881 476.095C85.3881 476.238 85.1695 476.4 84.9323 476.581C84.2926 477.062 83.9356 477.571 83.8611 478.108C83.7717 478.643 83.9631 479.24 84.4352 479.899L85.4788 481.355L91.2431 477.258Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M80.737 458.036C81.2705 458.91 81.5902 459.721 81.6959 460.467C81.7961 461.205 81.7327 461.848 81.5055 462.397C81.2783 462.946 80.9376 463.371 80.4834 463.671C80.4104 463.715 80.3299 463.726 80.2418 463.705C80.1446 463.689 80.071 463.64 80.0209 463.558L79.129 462.097C79.0567 461.978 79.0285 461.871 79.0444 461.774C79.0511 461.682 79.0743 461.587 79.1139 461.488C79.2301 461.331 79.3195 461.139 79.3822 460.914C79.4392 460.68 79.4429 460.41 79.3932 460.103C79.3344 459.802 79.1938 459.47 78.9715 459.106C78.6103 458.514 78.245 458.13 77.8755 457.955C77.5005 457.771 77.1488 457.778 76.8204 457.977C76.5831 458.12 76.4415 458.318 76.3956 458.571C76.3441 458.814 76.3646 459.144 76.4572 459.562C76.5442 459.971 76.6916 460.499 76.8993 461.146C77.1701 461.917 77.3387 462.613 77.4052 463.234C77.457 463.851 77.3754 464.393 77.1605 464.86C76.9309 465.323 76.5424 465.721 75.995 466.052C75.4475 466.384 74.8723 466.526 74.2692 466.48C73.657 466.439 73.0655 466.218 72.4948 465.815C71.9151 465.418 71.3945 464.842 70.9333 464.086C70.5609 463.476 70.3151 462.889 70.1959 462.325C70.0712 461.752 70.0466 461.231 70.1223 460.761C70.1923 460.282 70.3279 459.87 70.529 459.524C70.73 459.177 70.9692 458.914 71.2465 458.734C71.3195 458.689 71.4046 458.675 71.5018 458.691C71.5899 458.713 71.6589 458.764 71.7089 458.846L72.6426 460.376C72.6981 460.467 72.7299 460.56 72.7379 460.655C72.7458 460.75 72.7181 460.848 72.6547 460.948C72.4508 461.147 72.3455 461.435 72.3389 461.813C72.3176 462.188 72.4375 462.589 72.6987 463.017C72.971 463.463 73.2699 463.768 73.5953 463.933C73.9151 464.088 74.2438 464.064 74.5814 463.859C74.8004 463.727 74.9485 463.55 75.0258 463.328C75.0885 463.103 75.0846 462.8 75.0142 462.419C74.9292 462.034 74.7968 461.54 74.6168 460.939C74.292 460.038 74.0908 459.268 74.0133 458.629C73.9357 457.99 74.0071 457.442 74.2276 456.984C74.4389 456.532 74.8183 456.14 75.3658 455.809C75.9771 455.438 76.6073 455.294 77.2564 455.374C77.9 455.446 78.5238 455.71 79.1278 456.168C79.7171 456.621 80.2535 457.244 80.737 458.036Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M38.0298 210.995C37.9887 211.105 37.92 211.182 37.8238 211.226C37.7277 211.27 37.6246 211.271 37.5146 211.231L27.7654 207.609C27.6554 207.569 27.5785 207.5 27.5347 207.404C27.4908 207.308 27.4895 207.205 27.5306 207.096L28.1645 205.402C28.2057 205.292 28.2743 205.215 28.3705 205.172C28.4667 205.128 28.5697 205.126 28.6797 205.167L38.429 208.788C38.5389 208.829 38.6159 208.897 38.6597 208.993C38.7035 209.089 38.7048 209.192 38.6637 209.302L38.0298 210.995Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M41.1491 202.503C41.1025 202.61 41.0301 202.684 40.9319 202.723C40.8336 202.762 40.7306 202.758 40.6228 202.712L31.0651 198.612C30.9572 198.566 30.8838 198.494 30.8448 198.396C30.8059 198.298 30.8096 198.195 30.8562 198.087L32.45 194.401C32.8733 193.422 33.3836 192.672 33.9809 192.15C34.5684 191.625 35.2353 191.319 35.9814 191.233C36.7219 191.132 37.5327 191.26 38.4136 191.614C38.8491 191.79 39.2287 191.947 39.5522 192.085C39.8757 192.224 40.246 192.389 40.6633 192.579C41.5623 193 42.2388 193.505 42.6928 194.094C43.1469 194.684 43.3812 195.364 43.3959 196.137C43.4008 196.905 43.1937 197.774 42.7746 198.743L41.1491 202.503ZM40.1031 199.721L40.8461 198.003C41.0577 197.513 41.1578 197.08 41.1462 196.704C41.1346 196.327 41.0037 195.999 40.7535 195.717C40.4978 195.422 40.1171 195.16 39.6116 194.931C39.3316 194.8 39.0788 194.685 38.8533 194.589C38.6321 194.482 38.4066 194.385 38.177 194.298C37.9515 194.202 37.6994 194.099 37.4207 193.991C36.677 193.696 36.0553 193.655 35.5556 193.87C35.0503 194.071 34.6368 194.544 34.3151 195.288L33.6039 196.933L40.1031 199.721Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M49.3231 184.016C49.2695 184.121 49.1925 184.189 49.0918 184.222C48.9912 184.254 48.8886 184.244 48.784 184.191L39.515 179.474C39.4104 179.421 39.3419 179.344 39.3094 179.244C39.277 179.144 39.2875 179.041 39.3411 178.937L42.6486 172.488C42.7022 172.383 42.7792 172.315 42.8799 172.282C42.9805 172.25 43.0831 172.26 43.1877 172.313L44.3285 172.894C44.4235 172.942 44.4873 173.016 44.5198 173.117C44.5522 173.217 44.5417 173.319 44.4882 173.424L42.1225 178.036L44.3613 179.176L46.5664 174.876C46.6199 174.772 46.697 174.703 46.7976 174.671C46.8982 174.638 47.0008 174.648 47.1054 174.702L48.1606 175.239C48.2557 175.287 48.3195 175.361 48.3519 175.462C48.3844 175.562 48.3739 175.664 48.3203 175.769L46.1153 180.068L48.4254 181.244L50.8495 176.517C50.9031 176.413 50.9801 176.344 51.0808 176.311C51.1814 176.279 51.284 176.289 51.3886 176.342L52.5151 176.916C52.6197 176.969 52.6882 177.046 52.7207 177.146C52.7531 177.246 52.7426 177.349 52.6891 177.453L49.3231 184.016Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M57.636 167.984C57.5756 168.084 57.4941 168.148 57.3916 168.174C57.289 168.199 57.1873 168.182 57.0865 168.122L48.1506 162.802C48.0498 162.741 47.9865 162.66 47.9608 162.558C47.935 162.456 47.9524 162.354 48.0127 162.254L48.762 161.005C48.8443 160.868 48.9368 160.787 49.0393 160.761C49.1419 160.735 49.217 160.724 49.2647 160.727L57.1956 160.478L51.5592 157.122C51.4583 157.062 51.3951 156.981 51.3693 156.878C51.3436 156.776 51.3582 156.679 51.4131 156.588L52.2529 155.189C52.3132 155.088 52.3947 155.025 52.4973 154.999C52.5999 154.973 52.7016 154.99 52.8024 155.05L61.7383 160.371C61.8299 160.426 61.8932 160.507 61.9281 160.614C61.9538 160.717 61.9365 160.818 61.8761 160.919L61.1187 162.181C61.0363 162.318 60.9439 162.399 60.8413 162.425C60.735 162.436 60.6599 162.448 60.616 162.459L52.8719 162.801L58.3297 166.051C58.4305 166.111 58.4938 166.192 58.5195 166.294C58.5453 166.396 58.5279 166.498 58.4676 166.598L57.636 167.984Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M69.6765 148.58C69.6096 148.676 69.5242 148.734 69.4201 148.753C69.316 148.772 69.2157 148.748 69.119 148.682L62.0543 143.82L60.3946 146.213C60.3338 146.3 60.2514 146.354 60.1473 146.373C60.0433 146.392 59.9473 146.371 59.8594 146.31L58.6732 145.494C58.5765 145.428 58.5187 145.342 58.4998 145.239C58.4808 145.135 58.5017 145.039 58.5625 144.952L63.3408 138.063C63.4077 137.966 63.4932 137.909 63.5972 137.89C63.7013 137.871 63.8017 137.894 63.8983 137.961L65.0846 138.777C65.1724 138.838 65.2258 138.92 65.2448 139.023C65.2638 139.127 65.2398 139.227 65.1729 139.324L63.5224 141.703L70.5872 146.565C70.6838 146.631 70.7416 146.717 70.7606 146.82C70.7795 146.924 70.7556 147.024 70.6887 147.12L69.6765 148.58Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M78.3824 136.343C78.3112 136.437 78.2232 136.49 78.1183 136.504C78.0135 136.519 77.9143 136.49 77.8208 136.42L69.5327 130.137C69.4392 130.066 69.3854 129.979 69.3712 129.874C69.357 129.77 69.3855 129.671 69.4568 129.578L70.5544 128.141C70.6256 128.048 70.7136 127.994 70.8185 127.98C70.9233 127.966 71.0225 127.994 71.116 128.065L79.4041 134.347C79.4976 134.418 79.5514 134.506 79.5656 134.61C79.5798 134.714 79.5513 134.813 79.48 134.907L78.3824 136.343Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M85.4294 127.274C85.354 127.364 85.2636 127.414 85.1582 127.423C85.0528 127.433 84.955 127.4 84.8649 127.325L78.2751 121.836L76.4028 124.067C76.3343 124.149 76.2473 124.194 76.1419 124.203C76.0365 124.213 75.9429 124.183 75.8609 124.115L74.7544 123.194C74.6642 123.119 74.6145 123.029 74.6051 122.924C74.5957 122.819 74.6253 122.725 74.6939 122.644L80.0843 116.222C80.1597 116.132 80.2501 116.083 80.3555 116.073C80.4609 116.064 80.5586 116.097 80.6488 116.172L81.7553 117.093C81.8373 117.161 81.8829 117.248 81.8923 117.353C81.9017 117.458 81.8686 117.555 81.7932 117.645L79.9313 119.863L86.5211 125.352C86.6112 125.427 86.661 125.517 86.6704 125.622C86.6797 125.727 86.6467 125.824 86.5713 125.914L85.4294 127.274Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M95.2668 115.841C95.1873 115.928 95.0947 115.973 94.989 115.978C94.8833 115.982 94.7872 115.945 94.7006 115.866L87.0228 108.851C86.9362 108.772 86.8906 108.679 86.8861 108.574C86.8815 108.469 86.919 108.373 86.9985 108.287L88.2232 106.957C88.3027 106.87 88.3953 106.825 88.501 106.82C88.6067 106.816 88.7029 106.853 88.7895 106.932L96.4673 113.947C96.5539 114.027 96.5995 114.119 96.604 114.224C96.6085 114.329 96.5711 114.425 96.4916 114.512L95.2668 115.841Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M101.36 109.204C101.277 109.287 101.183 109.328 101.077 109.327C100.971 109.327 100.877 109.285 100.794 109.202L93.4485 101.84C93.3656 101.757 93.3243 101.662 93.3246 101.557C93.325 101.452 93.3668 101.358 93.4502 101.275L98.6014 96.1762C98.6848 96.0936 98.7794 96.0525 98.8852 96.0529C98.991 96.0532 99.0854 96.0949 99.1682 96.178L100.072 97.0841C100.148 97.1596 100.185 97.2501 100.185 97.3555C100.184 97.4609 100.143 97.5548 100.059 97.6374L96.3749 101.284L98.149 103.063L101.583 99.6633C101.667 99.5808 101.761 99.5397 101.867 99.54C101.973 99.5404 102.067 99.5821 102.15 99.6651L102.986 100.503C103.062 100.579 103.099 100.669 103.099 100.775C103.098 100.88 103.057 100.974 102.973 101.057L99.539 104.456L101.37 106.291L105.145 102.554C105.228 102.471 105.323 102.43 105.429 102.431C105.535 102.431 105.629 102.473 105.712 102.556L106.604 103.45C106.687 103.534 106.729 103.628 106.728 103.733C106.728 103.839 106.686 103.933 106.603 104.015L101.36 109.204Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M117.077 94.3492C116.306 95.0223 115.56 95.4746 114.84 95.7061C114.129 95.9305 113.482 95.9782 112.9 95.8491C112.317 95.72 111.839 95.4582 111.463 95.0637C111.407 94.9996 111.382 94.9225 111.388 94.8324C111.387 94.7342 111.422 94.6536 111.495 94.5905L112.785 93.4651C112.889 93.3739 112.991 93.3278 113.089 93.3268C113.181 93.3178 113.279 93.3243 113.383 93.3463C113.559 93.4334 113.764 93.4885 113.997 93.5115C114.239 93.5274 114.507 93.4848 114.801 93.3836C115.088 93.2744 115.393 93.0796 115.714 92.7991C116.237 92.3433 116.553 91.9192 116.662 91.5266C116.78 91.1269 116.711 90.7829 116.458 90.4945C116.275 90.2863 116.055 90.1811 115.797 90.1792C115.548 90.1702 115.225 90.2469 114.828 90.4092C114.439 90.5645 113.942 90.7994 113.338 91.114C112.623 91.5117 111.964 91.7962 111.362 91.9676C110.761 92.1239 110.211 92.1365 109.712 92.0054C109.214 91.8593 108.754 91.5459 108.331 91.0652C107.909 90.5846 107.668 90.0443 107.609 89.4444C107.544 88.8365 107.66 88.2181 107.96 87.5891C108.252 86.9521 108.731 86.3426 109.398 85.7606C109.937 85.2908 110.475 84.9492 111.011 84.7358C111.556 84.5154 112.067 84.4022 112.545 84.3961C113.03 84.383 113.462 84.4455 113.839 84.5836C114.216 84.7218 114.518 84.9115 114.744 85.1528C114.8 85.2169 114.829 85.298 114.83 85.3962C114.824 85.4863 114.785 85.5629 114.713 85.6261L113.362 86.804C113.282 86.8741 113.196 86.9212 113.103 86.9453C113.011 86.9693 112.909 86.9588 112.798 86.9138C112.567 86.7476 112.264 86.6935 111.889 86.7517C111.515 86.7948 111.139 86.9812 110.761 87.3107C110.367 87.6543 110.117 87.9998 110.011 88.3474C109.913 88.6879 109.994 89.0064 110.254 89.3028C110.423 89.495 110.624 89.6102 110.856 89.6482C111.09 89.6712 111.389 89.6156 111.754 89.4813C112.119 89.332 112.584 89.1176 113.148 88.8381C113.982 88.3653 114.708 88.0362 115.327 87.8508C115.945 87.6654 116.499 87.6418 116.99 87.7799C117.474 87.91 117.927 88.2154 118.349 88.696C118.821 89.2328 119.073 89.8266 119.106 90.4776C119.147 91.1215 118.993 91.7791 118.646 92.4501C118.3 93.1061 117.777 93.7392 117.077 94.3492Z",
                fill: "#9EA1B1"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M143.771 101.812C103.495 134.196 72.749 177.886 56.3887 228.043",
                stroke: "#0294F7",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M522.171 113.402C520.486 113.402 519.056 113.114 517.883 112.538C516.731 111.941 515.846 111.173 515.227 110.234C514.63 109.295 514.31 108.303 514.267 107.258C514.246 107.066 514.299 106.917 514.427 106.81C514.555 106.682 514.715 106.618 514.907 106.618H516.635C516.827 106.618 516.998 106.671 517.147 106.778C517.296 106.863 517.414 107.045 517.499 107.322C517.712 108.111 518.054 108.762 518.523 109.274C519.014 109.765 519.568 110.127 520.187 110.362C520.827 110.575 521.488 110.682 522.171 110.682C523.088 110.682 523.92 110.501 524.667 110.138C525.435 109.754 526.043 109.199 526.491 108.474C526.939 107.727 527.163 106.831 527.163 105.786C527.163 104.826 526.939 104.005 526.491 103.322C526.064 102.618 525.467 102.085 524.699 101.722C523.952 101.338 523.11 101.146 522.171 101.146C521.467 101.146 520.891 101.231 520.443 101.402C519.995 101.573 519.611 101.775 519.291 102.01C518.992 102.245 518.715 102.447 518.459 102.618C518.224 102.789 517.958 102.874 517.659 102.874H515.995C515.803 102.874 515.632 102.81 515.483 102.682C515.334 102.533 515.27 102.362 515.291 102.17L516.315 91.482C516.336 91.226 516.411 91.034 516.539 90.906C516.688 90.7567 516.88 90.682 517.115 90.682H528.283C528.496 90.682 528.667 90.7567 528.795 90.906C528.944 91.034 529.019 91.2047 529.019 91.418V92.666C529.019 92.9007 528.944 93.082 528.795 93.21C528.667 93.338 528.496 93.402 528.283 93.402H519.067L518.459 99.706C518.779 99.514 519.259 99.29 519.899 99.034C520.56 98.7567 521.467 98.618 522.619 98.618C523.686 98.618 524.678 98.778 525.595 99.098C526.534 99.418 527.355 99.8874 528.059 100.506C528.784 101.125 529.35 101.882 529.755 102.778C530.16 103.653 530.363 104.666 530.363 105.818C530.363 107.439 530.011 108.815 529.307 109.946C528.603 111.077 527.632 111.941 526.395 112.538C525.158 113.114 523.75 113.402 522.171 113.402ZM534.131 113.082C533.918 113.082 533.736 113.018 533.587 112.89C533.459 112.741 533.395 112.559 533.395 112.346V111.322C533.395 111.13 533.448 110.917 533.555 110.682C533.662 110.447 533.875 110.191 534.195 109.914L540.979 103.13C542.067 102.213 542.92 101.434 543.539 100.794C544.179 100.133 544.627 99.5034 544.883 98.906C545.16 98.3087 545.299 97.69 545.299 97.05C545.299 95.834 544.958 94.874 544.275 94.17C543.592 93.4447 542.579 93.082 541.235 93.082C540.382 93.082 539.646 93.2634 539.027 93.626C538.408 93.9674 537.928 94.4474 537.587 95.066C537.246 95.6634 537.011 96.346 536.883 97.114C536.84 97.3914 536.723 97.5834 536.531 97.69C536.36 97.7967 536.2 97.85 536.051 97.85H534.387C534.195 97.85 534.035 97.7967 533.907 97.69C533.779 97.562 533.715 97.4127 533.715 97.242C533.736 96.4314 533.907 95.6207 534.227 94.81C534.547 93.978 535.016 93.2314 535.635 92.57C536.275 91.8874 537.054 91.3434 537.971 90.938C538.91 90.5327 539.998 90.33 541.235 90.33C542.92 90.33 544.296 90.6394 545.363 91.258C546.451 91.8554 547.251 92.6554 547.763 93.658C548.275 94.6607 548.531 95.7594 548.531 96.954C548.531 97.8927 548.371 98.7567 548.051 99.546C547.731 100.314 547.262 101.071 546.643 101.818C546.046 102.543 545.299 103.29 544.403 104.058L538.259 110.298H548.243C548.478 110.298 548.659 110.362 548.787 110.49C548.936 110.618 549.011 110.799 549.011 111.034V112.346C549.011 112.559 548.936 112.741 548.787 112.89C548.659 113.018 548.478 113.082 548.243 113.082H534.131ZM554.096 113.082C553.648 113.082 553.424 112.869 553.424 112.442C553.424 112.314 553.467 112.197 553.552 112.09L569.36 91.29C569.51 91.098 569.648 90.9487 569.776 90.842C569.926 90.7354 570.139 90.682 570.416 90.682H571.472C571.92 90.682 572.144 90.8954 572.144 91.322C572.144 91.45 572.102 91.5674 572.016 91.674L556.24 112.474C556.091 112.666 555.942 112.815 555.792 112.922C555.664 113.029 555.451 113.082 555.152 113.082H554.096ZM568.752 113.274C567.366 113.274 566.267 112.879 565.456 112.09C564.667 111.301 564.23 110.266 564.144 108.986C564.123 108.431 564.112 107.962 564.112 107.578C564.112 107.173 564.123 106.671 564.144 106.074C564.23 104.794 564.646 103.759 565.392 102.97C566.16 102.159 567.28 101.754 568.752 101.754C570.246 101.754 571.366 102.159 572.112 102.97C572.88 103.759 573.307 104.794 573.392 106.074C573.435 106.671 573.456 107.173 573.456 107.578C573.456 107.962 573.435 108.431 573.392 108.986C573.307 110.266 572.859 111.301 572.048 112.09C571.259 112.879 570.16 113.274 568.752 113.274ZM568.752 111.162C569.328 111.162 569.776 111.045 570.096 110.81C570.416 110.575 570.651 110.287 570.8 109.946C570.95 109.583 571.035 109.221 571.056 108.858C571.099 108.282 571.12 107.823 571.12 107.482C571.12 107.141 571.099 106.714 571.056 106.202C571.035 105.626 570.854 105.093 570.512 104.602C570.171 104.111 569.584 103.866 568.752 103.866C567.942 103.866 567.366 104.111 567.024 104.602C566.704 105.093 566.523 105.626 566.48 106.202C566.459 106.714 566.448 107.141 566.448 107.482C566.448 107.823 566.459 108.282 566.48 108.858C566.523 109.221 566.608 109.583 566.736 109.946C566.886 110.287 567.12 110.575 567.44 110.81C567.782 111.045 568.219 111.162 568.752 111.162ZM556.784 101.914C555.376 101.914 554.278 101.541 553.488 100.794C552.699 100.047 552.262 99.034 552.176 97.754C552.155 97.1994 552.144 96.73 552.144 96.346C552.144 95.9407 552.155 95.4394 552.176 94.842C552.24 93.562 552.656 92.5274 553.424 91.738C554.192 90.9274 555.312 90.522 556.784 90.522C558.278 90.522 559.398 90.9274 560.144 91.738C560.912 92.5274 561.328 93.562 561.392 94.842C561.435 95.4394 561.456 95.9407 561.456 96.346C561.456 96.73 561.435 97.1994 561.392 97.754C561.328 99.034 560.891 100.047 560.08 100.794C559.291 101.541 558.192 101.914 556.784 101.914ZM556.784 99.93C557.339 99.93 557.776 99.8127 558.096 99.578C558.438 99.3434 558.683 99.0554 558.832 98.714C558.982 98.3514 559.067 97.9887 559.088 97.626C559.131 97.05 559.152 96.602 559.152 96.282C559.152 95.9407 559.131 95.5034 559.088 94.97C559.067 94.394 558.875 93.8607 558.512 93.37C558.171 92.8794 557.595 92.634 556.784 92.634C555.974 92.634 555.398 92.8794 555.056 93.37C554.736 93.8607 554.555 94.394 554.512 94.97C554.491 95.5034 554.48 95.9407 554.48 96.282C554.48 96.602 554.491 97.05 554.512 97.626C554.555 97.9887 554.64 98.3514 554.768 98.714C554.918 99.0554 555.152 99.3434 555.472 99.578C555.792 99.8127 556.23 99.93 556.784 99.93Z",
                fill: "#D057FF"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M31.0949 121.035C29.8576 121.035 28.7163 120.886 27.6709 120.587C26.6469 120.267 25.7616 119.808 25.0149 119.211C24.2896 118.614 23.7243 117.91 23.3189 117.099C22.9136 116.267 22.7109 115.328 22.7109 114.283C22.7109 112.982 23.0203 111.862 23.6389 110.923C24.2789 109.984 25.1216 109.27 26.1669 108.779C25.3349 108.288 24.6843 107.648 24.2149 106.859C23.7456 106.07 23.5109 105.131 23.5109 104.043C23.5109 102.763 23.8203 101.686 24.4389 100.811C25.0789 99.9148 25.9643 99.2215 27.0949 98.7308C28.2469 98.2402 29.5803 97.9948 31.0949 97.9948C32.5883 97.9948 33.9003 98.2402 35.0309 98.7308C36.1829 99.2002 37.0683 99.8828 37.6869 100.779C38.3269 101.675 38.6469 102.752 38.6469 104.011C38.6469 105.099 38.4123 106.048 37.9429 106.859C37.4736 107.648 36.8336 108.288 36.0229 108.779C37.0683 109.27 37.9003 109.984 38.5189 110.923C39.1589 111.862 39.4789 112.982 39.4789 114.283C39.4789 115.67 39.1269 116.875 38.4229 117.899C37.7189 118.902 36.7376 119.68 35.4789 120.235C34.2203 120.768 32.7589 121.035 31.0949 121.035ZM31.0949 118.475C32.0763 118.475 32.9616 118.304 33.7509 117.963C34.5403 117.622 35.1696 117.142 35.6389 116.523C36.1083 115.883 36.3429 115.136 36.3429 114.283C36.3429 113.408 36.1083 112.672 35.6389 112.075C35.1696 111.456 34.5403 110.987 33.7509 110.667C32.9616 110.326 32.0763 110.155 31.0949 110.155C30.1136 110.155 29.2176 110.326 28.4069 110.667C27.6176 110.987 26.9883 111.456 26.5189 112.075C26.0496 112.672 25.8149 113.408 25.8149 114.283C25.8149 115.136 26.0496 115.883 26.5189 116.523C26.9883 117.142 27.6176 117.622 28.4069 117.963C29.2176 118.304 30.1136 118.475 31.0949 118.475ZM31.0949 107.627C31.9056 107.627 32.6523 107.478 33.3349 107.179C34.0389 106.88 34.5936 106.475 34.9989 105.963C35.4256 105.451 35.6389 104.832 35.6389 104.107C35.6389 103.382 35.4363 102.752 35.0309 102.219C34.6469 101.686 34.1029 101.28 33.3989 101.003C32.7163 100.704 31.9483 100.555 31.0949 100.555C30.2416 100.555 29.4629 100.704 28.7589 101.003C28.0763 101.28 27.5323 101.686 27.1269 102.219C26.7216 102.752 26.5189 103.382 26.5189 104.107C26.5189 104.854 26.7216 105.494 27.1269 106.027C27.5323 106.539 28.0763 106.934 28.7589 107.211C29.4629 107.488 30.2416 107.627 31.0949 107.627ZM44.7507 120.715C44.3027 120.715 44.0787 120.502 44.0787 120.075C44.0787 119.947 44.1214 119.83 44.2067 119.723L60.0147 98.9228C60.164 98.7308 60.3027 98.5815 60.4307 98.4748C60.58 98.3682 60.7934 98.3148 61.0707 98.3148H62.1267C62.5747 98.3148 62.7987 98.5282 62.7987 98.9548C62.7987 99.0828 62.756 99.2002 62.6707 99.3068L46.8947 120.107C46.7454 120.299 46.596 120.448 46.4467 120.555C46.3187 120.662 46.1054 120.715 45.8067 120.715H44.7507ZM59.4067 120.907C58.02 120.907 56.9214 120.512 56.1107 119.723C55.3214 118.934 54.884 117.899 54.7987 116.619C54.7774 116.064 54.7667 115.595 54.7667 115.211C54.7667 114.806 54.7774 114.304 54.7987 113.707C54.884 112.427 55.3 111.392 56.0467 110.603C56.8147 109.792 57.9347 109.387 59.4067 109.387C60.9 109.387 62.02 109.792 62.7667 110.603C63.5347 111.392 63.9614 112.427 64.0467 113.707C64.0894 114.304 64.1107 114.806 64.1107 115.211C64.1107 115.595 64.0894 116.064 64.0467 116.619C63.9614 117.899 63.5134 118.934 62.7027 119.723C61.9134 120.512 60.8147 120.907 59.4067 120.907ZM59.4067 118.795C59.9827 118.795 60.4307 118.678 60.7507 118.443C61.0707 118.208 61.3054 117.92 61.4547 117.579C61.604 117.216 61.6894 116.854 61.7107 116.491C61.7534 115.915 61.7747 115.456 61.7747 115.115C61.7747 114.774 61.7534 114.347 61.7107 113.835C61.6894 113.259 61.508 112.726 61.1667 112.235C60.8254 111.744 60.2387 111.499 59.4067 111.499C58.596 111.499 58.02 111.744 57.6787 112.235C57.3587 112.726 57.1774 113.259 57.1347 113.835C57.1134 114.347 57.1027 114.774 57.1027 115.115C57.1027 115.456 57.1134 115.915 57.1347 116.491C57.1774 116.854 57.2627 117.216 57.3907 117.579C57.54 117.92 57.7747 118.208 58.0947 118.443C58.436 118.678 58.8734 118.795 59.4067 118.795ZM47.4387 109.547C46.0307 109.547 44.932 109.174 44.1427 108.427C43.3534 107.68 42.916 106.667 42.8307 105.387C42.8094 104.832 42.7987 104.363 42.7987 103.979C42.7987 103.574 42.8094 103.072 42.8307 102.475C42.8947 101.195 43.3107 100.16 44.0787 99.3708C44.8467 98.5602 45.9667 98.1548 47.4387 98.1548C48.932 98.1548 50.052 98.5602 50.7987 99.3708C51.5667 100.16 51.9827 101.195 52.0467 102.475C52.0894 103.072 52.1107 103.574 52.1107 103.979C52.1107 104.363 52.0894 104.832 52.0467 105.387C51.9827 106.667 51.5454 107.68 50.7347 108.427C49.9454 109.174 48.8467 109.547 47.4387 109.547ZM47.4387 107.563C47.9934 107.563 48.4307 107.446 48.7507 107.211C49.092 106.976 49.3374 106.688 49.4867 106.347C49.636 105.984 49.7214 105.622 49.7427 105.259C49.7854 104.683 49.8067 104.235 49.8067 103.915C49.8067 103.574 49.7854 103.136 49.7427 102.603C49.7214 102.027 49.5294 101.494 49.1667 101.003C48.8254 100.512 48.2494 100.267 47.4387 100.267C46.628 100.267 46.052 100.512 45.7107 101.003C45.3907 101.494 45.2094 102.027 45.1667 102.603C45.1454 103.136 45.1347 103.574 45.1347 103.915C45.1347 104.235 45.1454 104.683 45.1667 105.259C45.2094 105.622 45.2947 105.984 45.4227 106.347C45.572 106.688 45.8067 106.976 46.1267 107.211C46.4467 107.446 46.884 107.563 47.4387 107.563Z",
                fill: "#0294F7"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M65.5537 557.643C65.3403 557.643 65.159 557.579 65.0097 557.451C64.8817 557.301 64.8177 557.12 64.8177 556.907V552.299H54.4497C54.2363 552.299 54.055 552.235 53.9057 552.107C53.7777 551.957 53.7137 551.776 53.7137 551.563V550.283C53.7137 550.197 53.735 550.069 53.7777 549.899C53.8417 549.707 53.9377 549.515 54.0657 549.323L63.6657 535.787C63.9217 535.424 64.3163 535.243 64.8497 535.243H67.1537C67.367 535.243 67.5377 535.317 67.6657 535.467C67.815 535.595 67.8897 535.765 67.8897 535.979V549.515H70.7697C71.0043 549.515 71.1857 549.589 71.3137 549.739C71.463 549.867 71.5377 550.037 71.5377 550.251V551.563C71.5377 551.776 71.463 551.957 71.3137 552.107C71.1857 552.235 71.015 552.299 70.8017 552.299H67.8897V556.907C67.8897 557.12 67.815 557.301 67.6657 557.451C67.5377 557.579 67.367 557.643 67.1537 557.643H65.5537ZM57.1377 549.579H64.8497V538.603L57.1377 549.579ZM82.7407 557.963C81.2687 557.963 80.0207 557.739 78.9967 557.291C77.994 556.821 77.1727 556.181 76.5327 555.371C75.8927 554.56 75.4233 553.632 75.1247 552.587C74.8473 551.541 74.6873 550.432 74.6447 549.259C74.6233 548.683 74.602 548.075 74.5807 547.435C74.5807 546.795 74.5807 546.144 74.5807 545.483C74.602 544.821 74.6233 544.192 74.6447 543.595C74.666 542.421 74.826 541.312 75.1247 540.267C75.4447 539.221 75.9247 538.304 76.5647 537.515C77.2047 536.704 78.026 536.075 79.0287 535.627C80.0527 535.157 81.29 534.923 82.7407 534.923C84.2127 534.923 85.45 535.157 86.4527 535.627C87.4767 536.075 88.3087 536.704 88.9487 537.515C89.5887 538.304 90.058 539.221 90.3567 540.267C90.6767 541.312 90.8473 542.421 90.8687 543.595C90.89 544.192 90.9007 544.821 90.9007 545.483C90.922 546.144 90.922 546.795 90.9007 547.435C90.9007 548.075 90.89 548.683 90.8687 549.259C90.8473 550.432 90.6767 551.541 90.3567 552.587C90.058 553.632 89.5887 554.56 88.9487 555.371C88.33 556.181 87.5087 556.821 86.4847 557.291C85.482 557.739 84.234 557.963 82.7407 557.963ZM82.7407 555.211C84.4047 555.211 85.6313 554.667 86.4207 553.579C87.2313 552.491 87.6473 550.997 87.6687 549.099C87.7113 548.48 87.7327 547.883 87.7327 547.307C87.7327 546.709 87.7327 546.123 87.7327 545.547C87.7327 544.949 87.7113 544.363 87.6687 543.787C87.6473 541.931 87.2313 540.448 86.4207 539.339C85.6313 538.208 84.4047 537.643 82.7407 537.643C81.098 537.643 79.8713 538.208 79.0607 539.339C78.2713 540.448 77.8553 541.931 77.8127 543.787C77.8127 544.363 77.802 544.949 77.7807 545.547C77.7807 546.123 77.7807 546.709 77.7807 547.307C77.802 547.883 77.8127 548.48 77.8127 549.099C77.8553 550.997 78.282 552.491 79.0927 553.579C79.9033 554.667 81.1193 555.211 82.7407 555.211ZM96.3972 557.643C95.9492 557.643 95.7252 557.429 95.7252 557.003C95.7252 556.875 95.7678 556.757 95.8532 556.651L111.661 535.851C111.811 535.659 111.949 535.509 112.077 535.403C112.227 535.296 112.44 535.243 112.717 535.243H113.773C114.221 535.243 114.445 535.456 114.445 535.883C114.445 536.011 114.403 536.128 114.317 536.235L98.5412 557.035C98.3918 557.227 98.2425 557.376 98.0932 557.483C97.9652 557.589 97.7518 557.643 97.4532 557.643H96.3972ZM111.053 557.835C109.667 557.835 108.568 557.44 107.757 556.651C106.968 555.861 106.531 554.827 106.445 553.547C106.424 552.992 106.413 552.523 106.413 552.139C106.413 551.733 106.424 551.232 106.445 550.635C106.531 549.355 106.947 548.32 107.693 547.531C108.461 546.72 109.581 546.315 111.053 546.315C112.547 546.315 113.667 546.72 114.413 547.531C115.181 548.32 115.608 549.355 115.693 550.635C115.736 551.232 115.757 551.733 115.757 552.139C115.757 552.523 115.736 552.992 115.693 553.547C115.608 554.827 115.16 555.861 114.349 556.651C113.56 557.44 112.461 557.835 111.053 557.835ZM111.053 555.723C111.629 555.723 112.077 555.605 112.397 555.371C112.717 555.136 112.952 554.848 113.101 554.507C113.251 554.144 113.336 553.781 113.357 553.419C113.4 552.843 113.421 552.384 113.421 552.043C113.421 551.701 113.4 551.275 113.357 550.763C113.336 550.187 113.155 549.653 112.813 549.163C112.472 548.672 111.885 548.427 111.053 548.427C110.243 548.427 109.667 548.672 109.325 549.163C109.005 549.653 108.824 550.187 108.781 550.763C108.76 551.275 108.749 551.701 108.749 552.043C108.749 552.384 108.76 552.843 108.781 553.419C108.824 553.781 108.909 554.144 109.037 554.507C109.187 554.848 109.421 555.136 109.741 555.371C110.083 555.605 110.52 555.723 111.053 555.723ZM99.0852 546.475C97.6772 546.475 96.5785 546.101 95.7892 545.355C94.9998 544.608 94.5625 543.595 94.4772 542.315C94.4558 541.76 94.4452 541.291 94.4452 540.907C94.4452 540.501 94.4558 540 94.4772 539.403C94.5412 538.123 94.9572 537.088 95.7252 536.299C96.4932 535.488 97.6132 535.083 99.0852 535.083C100.579 535.083 101.699 535.488 102.445 536.299C103.213 537.088 103.629 538.123 103.693 539.403C103.736 540 103.757 540.501 103.757 540.907C103.757 541.291 103.736 541.76 103.693 542.315C103.629 543.595 103.192 544.608 102.381 545.355C101.592 546.101 100.493 546.475 99.0852 546.475ZM99.0852 544.491C99.6398 544.491 100.077 544.373 100.397 544.139C100.739 543.904 100.984 543.616 101.133 543.275C101.283 542.912 101.368 542.549 101.389 542.187C101.432 541.611 101.453 541.163 101.453 540.843C101.453 540.501 101.432 540.064 101.389 539.531C101.368 538.955 101.176 538.421 100.813 537.931C100.472 537.44 99.8958 537.195 99.0852 537.195C98.2745 537.195 97.6985 537.44 97.3572 537.931C97.0372 538.421 96.8558 538.955 96.8132 539.531C96.7918 540.064 96.7812 540.501 96.7812 540.843C96.7812 541.163 96.7918 541.611 96.8132 542.187C96.8558 542.549 96.9412 542.912 97.0692 543.275C97.2185 543.616 97.4532 543.904 97.7732 544.139C98.0932 544.373 98.5305 544.491 99.0852 544.491Z",
                fill: "#F25A00"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_10967_101901",
                        x1: 379.829,
                        y1: 44.2394,
                        x2: 269.177,
                        y2: 293.709,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_10967_101901",
                        x1: 401.178,
                        y1: 41.2929,
                        x2: 269.405,
                        y2: 290.109,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_10967_101901",
                        x1: 414.865,
                        y1: 61.2292,
                        x2: 273.361,
                        y2: 288.566,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint3_linear_10967_101901",
                        x1: 430.642,
                        y1: 71.9646,
                        x2: 275.571,
                        y2: 286.237,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint4_linear_10967_101901",
                        x1: 454.566,
                        y1: 68.1249,
                        x2: 275.726,
                        y2: 282.113,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint5_linear_10967_101901",
                        x1: 463.319,
                        y1: 90.5972,
                        x2: 279.834,
                        y2: 281.331,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint6_linear_10967_101901",
                        x1: 473.205,
                        y1: 108.339,
                        x2: 283.107,
                        y2: 280.16,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint7_linear_10967_101901",
                        x1: 480.462,
                        y1: 127.415,
                        x2: 286.535,
                        y2: 279.514,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint8_linear_10967_101901",
                        x1: 506.453,
                        y1: 126.576,
                        x2: 287.148,
                        y2: 275.079,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint9_linear_10967_101901",
                        x1: 524.467,
                        y1: 135.918,
                        x2: 289.227,
                        y2: 272.27,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint10_linear_10967_101901",
                        x1: 530.603,
                        y1: 155.249,
                        x2: 292.621,
                        y2: 271.775,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint11_linear_10967_101901",
                        x1: 527.897,
                        y1: 178.963,
                        x2: 296.573,
                        y2: 272.799,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint12_linear_10967_101901",
                        x1: 540.96,
                        y1: 192.094,
                        x2: 299.243,
                        y2: 270.947,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint13_linear_10967_101901",
                        x1: 558.902,
                        y1: 203.689,
                        x2: 301.702,
                        y2: 268.072,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint14_linear_10967_101901",
                        x1: 573.916,
                        y1: 218.154,
                        x2: 304.595,
                        y2: 265.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint15_linear_10967_101901",
                        x1: 571.852,
                        y1: 238.921,
                        x2: 308.147,
                        y2: 266.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint16_linear_10967_101901",
                        x1: 585.529,
                        y1: 255.156,
                        x2: 311.265,
                        y2: 264.763,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint17_linear_10967_101901",
                        x1: 592.393,
                        y1: 273.819,
                        x2: 314.664,
                        y2: 264.075,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint18_linear_10967_101901",
                        x1: 581.589,
                        y1: 294.146,
                        x2: 317.868,
                        y2: 266.322,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint19_linear_10967_101901",
                        x1: 536.767,
                        y1: 312.9,
                        x2: 319.67,
                        y2: 274.464,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint20_linear_10967_101901",
                        x1: 532.697,
                        y1: 328.169,
                        x2: 322.3,
                        y2: 275.501,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint21_linear_10967_101901",
                        x1: 570.529,
                        y1: 348.609,
                        x2: 327.24,
                        y2: 269.261,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint22_linear_10967_101901",
                        x1: 563.766,
                        y1: 365.995,
                        x2: 330.051,
                        y2: 271.179,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint23_linear_10967_101901",
                        x1: 572.086,
                        y1: 386.68,
                        x2: 334.088,
                        y2: 270.148,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint24_linear_10967_101901",
                        x1: 574.779,
                        y1: 407.552,
                        x2: 337.999,
                        y2: 270.309,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint25_linear_10967_101901",
                        x1: 550.922,
                        y1: 418.293,
                        x2: 339.071,
                        y2: 274.835,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint26_linear_10967_101901",
                        x1: 555.729,
                        y1: 441.436,
                        x2: 343.366,
                        y2: 274.874,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint27_linear_10967_101901",
                        x1: 549.95,
                        y1: 460.285,
                        x2: 346.469,
                        y2: 276.335,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint28_linear_10967_101901",
                        x1: 523.918,
                        y1: 465.601,
                        x2: 346.394,
                        y2: 281.054,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint29_linear_10967_101901",
                        x1: 510.192,
                        y1: 477.503,
                        x2: 348.167,
                        y2: 283.636,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint30_linear_10967_101901",
                        x1: 510.802,
                        y1: 502.927,
                        x2: 352.581,
                        y2: 284.292,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint31_linear_10967_101901",
                        x1: 500.878,
                        y1: 520.808,
                        x2: 355.239,
                        y2: 286.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint32_linear_10967_101901",
                        x1: 454.603,
                        y1: 492.901,
                        x2: 349.112,
                        y2: 293.728,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint33_linear_10967_101901",
                        x1: 467.221,
                        y1: 539.834,
                        x2: 357.973,
                        y2: 293.485,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint34_linear_10967_101901",
                        x1: 439.229,
                        y1: 529.721,
                        x2: 355.179,
                        y2: 297.912,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint35_linear_10967_101901",
                        x1: 428.079,
                        y1: 547.134,
                        x2: 357.649,
                        y2: 300.512,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint36_linear_10967_101901",
                        x1: 421.243,
                        y1: 578.348,
                        x2: 362.821,
                        y2: 302.379,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint37_linear_10967_101901",
                        x1: 405.667,
                        y1: 594.764,
                        x2: 365.233,
                        y2: 305.881,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint38_linear_10967_101901",
                        x1: 372.698,
                        y1: 549.799,
                        x2: 355.981,
                        y2: 309.82,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint39_linear_10967_101901",
                        x1: 357.697,
                        y1: 564.433,
                        x2: 357.694,
                        y2: 313.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint40_linear_10967_101901",
                        x1: 342.033,
                        y1: 588.494,
                        x2: 360.961,
                        y2: 316.662,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint41_linear_10967_101901",
                        x1: 322.301,
                        y1: 564.306,
                        x2: 356.645,
                        y2: 318.976,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint42_linear_10967_101901",
                        x1: 304.215,
                        y1: 574.996,
                        x2: 357.571,
                        y2: 322.992,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint43_linear_10967_101901",
                        x1: 283.878,
                        y1: 594.688,
                        x2: 360.288,
                        y2: 327.113,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint44_linear_10967_101901",
                        x1: 269.882,
                        y1: 558.687,
                        x2: 353.552,
                        y2: 327.932,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint45_linear_10967_101901",
                        x1: 245.748,
                        y1: 581.811,
                        x2: 356.235,
                        y2: 332.695,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint46_linear_10967_101901",
                        x1: 243.129,
                        y1: 527.603,
                        x2: 346.972,
                        y2: 331.53,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint47_linear_10967_101901",
                        x1: 223.918,
                        y1: 534.032,
                        x2: 348.057,
                        y2: 334.586,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint48_linear_10967_101901",
                        x1: 210.481,
                        y1: 524.062,
                        x2: 345.712,
                        y2: 337.205,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint49_linear_10967_101901",
                        x1: 200.045,
                        y1: 509.05,
                        x2: 342.853,
                        y2: 338.2,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint50_linear_10967_101901",
                        x1: 175.063,
                        y1: 517.88,
                        x2: 343.909,
                        y2: 342.339,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint51_linear_10967_101901",
                        x1: 136.71,
                        y1: 538.053,
                        x2: 345.703,
                        y2: 349.119,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint52_linear_10967_101901",
                        x1: 142.771,
                        y1: 502.024,
                        x2: 340.156,
                        y2: 347.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint53_linear_10967_101901",
                        x1: 129.602,
                        y1: 489.886,
                        x2: 337.362,
                        y2: 349.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint54_linear_10967_101901",
                        x1: 106.857,
                        y1: 485.602,
                        x2: 336.084,
                        y2: 352.752,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint55_linear_10967_101901",
                        x1: 106.484,
                        y1: 462.544,
                        x2: 331.927,
                        y2: 352.141,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint56_linear_10967_101901",
                        x1: 75.8872,
                        y1: 461.301,
                        x2: 331.47,
                        y2: 357.645,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint57_linear_10967_101901",
                        x1: 75.3904,
                        y1: 439.829,
                        x2: 327.416,
                        y2: 357.615,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint58_linear_10967_101901",
                        x1: 67.3692,
                        y1: 422.779,
                        x2: 324.569,
                        y2: 358.396,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint59_linear_10967_101901",
                        x1: 73.5328,
                        y1: 400.494,
                        x2: 320.878,
                        y2: 356.712,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint60_linear_10967_101901",
                        x1: 54.1436,
                        y1: 387.766,
                        x2: 317.849,
                        y2: 359.943,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint61_linear_10967_101901",
                        x1: 36.2263,
                        y1: 372.169,
                        x2: 314.567,
                        y2: 362.418,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint62_linear_10967_101901",
                        x1: 74.7243,
                        y1: 346.792,
                        x2: 311.165,
                        y2: 355.071,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint63_linear_10967_101901",
                        x1: 44.265,
                        y1: 332.174,
                        x2: 307.97,
                        y2: 360.002,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint64_linear_10967_101901",
                        x1: 59.644,
                        y1: 313.219,
                        x2: 305.218,
                        y2: 356.7,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint65_linear_10967_101901",
                        x1: 40.4599,
                        y1: 294.398,
                        x2: 301.384,
                        y2: 359.717,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint66_linear_10967_101901",
                        x1: 46.1417,
                        y1: 276.296,
                        x2: 298.153,
                        y2: 358.504,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint67_linear_10967_101901",
                        x1: 75.9004,
                        y1: 263.422,
                        x2: 296.789,
                        y2: 353.016,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint68_linear_10967_101901",
                        x1: 69.5341,
                        y1: 244.14,
                        x2: 293.404,
                        y2: 353.773,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint69_linear_10967_101901",
                        x1: 59.9002,
                        y1: 222.125,
                        x2: 289.117,
                        y2: 354.98,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint70_linear_10967_101901",
                        x1: 55.7117,
                        y1: 199.72,
                        x2: 284.89,
                        y2: 354.906,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint71_linear_10967_101901",
                        x1: 74.7752,
                        y1: 187.839,
                        x2: 283.116,
                        y2: 351.256,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint72_linear_10967_101901",
                        x1: 66.3378,
                        y1: 160.339,
                        x2: 278.127,
                        y2: 351.794,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint73_linear_10967_101901",
                        x1: 72.7624,
                        y1: 139.873,
                        x2: 274.693,
                        y2: 349.802,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint74_linear_10967_101901",
                        x1: 106.533,
                        y1: 140.995,
                        x2: 276.2,
                        y2: 343.997,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint75_linear_10967_101901",
                        x1: 127.467,
                        y1: 134.999,
                        x2: 275.853,
                        y2: 340.048,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint76_linear_10967_101901",
                        x1: 147.889,
                        y1: 130.991,
                        x2: 275.622,
                        y2: 336.215,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint77_linear_10967_101901",
                        x1: 164.642,
                        y1: 124.3,
                        x2: 275.342,
                        y2: 333.305,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint78_linear_10967_101901",
                        x1: 170.883,
                        y1: 104.363,
                        x2: 271.744,
                        y2: 331.788,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint79_linear_10967_101901",
                        x1: 203.511,
                        y1: 125.022,
                        x2: 276.609,
                        y2: 326.649,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint80_linear_10967_101901",
                        x1: 219.278,
                        y1: 122.66,
                        x2: 276.69,
                        y2: 323.703,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint81_linear_10967_101901",
                        x1: 228.315,
                        y1: 104.943,
                        x2: 274.177,
                        y2: 321.587,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint82_linear_10967_101901",
                        x1: 237.52,
                        y1: 83.0641,
                        x2: 270.602,
                        y2: 319.396,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint83_linear_10967_101901",
                        x1: 247.656,
                        y1: 52.9833,
                        x2: 266.015,
                        y2: 316.506,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint84_linear_10967_101901",
                        x1: 268.613,
                        y1: 64.4836,
                        x2: 268.611,
                        y2: 313.148,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint85_linear_10967_101901",
                        x1: 285.451,
                        y1: 56.1569,
                        x2: 267.777,
                        y2: 309.899,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint86_linear_10967_101901",
                        x1: 304.197,
                        y1: 68.545,
                        x2: 270.768,
                        y2: 307.345,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint87_linear_10967_101901",
                        x1: 320.845,
                        y1: 75.5669,
                        x2: 272.351,
                        y2: 304.674,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint88_linear_10967_101901",
                        x1: 340.607,
                        y1: 46.4339,
                        x2: 268.04,
                        y2: 300.492,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint89_linear_10967_101901",
                        x1: 357.845,
                        y1: 57.6494,
                        x2: 270.731,
                        y2: 297.905,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint90_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(314.244 312.991) scale(272.966 271.898)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#FC3DA6"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.96,
                                stopColor: "#FC3DA6",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint91_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(162.134 233.607) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#0294F7",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint92_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(220.891 378.572) scale(170.16 169.494)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#F25A00"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#F25A00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint93_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(362.812 379.417) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#D057FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint94_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(449.149 310.114) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#FC3DA6"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#FC3DA6",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint95_radial_10967_101901",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(365.72 205.5) scale(134.426 133.9)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#D057FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint96_linear_10967_101901",
                        x1: 312.986,
                        y1: 204.642,
                        x2: 419.473,
                        y2: 184.139,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint97_linear_10967_101901",
                        x1: 380.677,
                        y1: 230.061,
                        x2: 448.971,
                        y2: 204.498,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint98_linear_10967_101901",
                        x1: 412.474,
                        y1: 279.325,
                        x2: 481.562,
                        y2: 293.401,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint99_linear_10967_101901",
                        x1: 397.49,
                        y1: 245.561,
                        x2: 485.738,
                        y2: 254.506,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint100_linear_10967_101901",
                        x1: 399.171,
                        y1: 371.669,
                        x2: 391.482,
                        y2: 437.215,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint101_linear_10967_101901",
                        x1: 415.984,
                        y1: 338.152,
                        x2: 445.839,
                        y2: 400.172,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint102_linear_10967_101901",
                        x1: 418.086,
                        y1: 299.188,
                        x2: 474.979,
                        y2: 350.85,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint103_linear_10967_101901",
                        x1: 232.494,
                        y1: 212.188,
                        x2: 234.375,
                        y2: 163.889,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint104_linear_10967_101901",
                        x1: 266.034,
                        y1: 216.716,
                        x2: 275.964,
                        y2: 140.865,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint105_linear_10967_101901",
                        x1: 291.865,
                        y1: 207.073,
                        x2: 313.657,
                        y2: 125.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint106_linear_10967_101901",
                        x1: 349.773,
                        y1: 409.552,
                        x2: 297.707,
                        y2: 506.111,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint107_linear_10967_101901",
                        x1: 237.186,
                        y1: 383.984,
                        x2: 139.185,
                        y2: 392.105,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint108_linear_10967_101901",
                        x1: 270.958,
                        y1: 406.329,
                        x2: 176.352,
                        y2: 449.757,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint109_linear_10967_101901",
                        x1: 207.853,
                        y1: 317.001,
                        x2: 136.759,
                        y2: 266.63,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint110_linear_10967_101901",
                        x1: 209.333,
                        y1: 328.122,
                        x2: 126.31,
                        y2: 328.122,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint111_linear_10967_101901",
                        x1: 216.78,
                        y1: 356.036,
                        x2: 131.988,
                        y2: 341.675,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint112_linear_10967_101901",
                        x1: 209.766,
                        y1: 283.315,
                        x2: 126.909,
                        y2: 247.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint113_linear_10967_101901",
                        x1: 185.335,
                        y1: 269.025,
                        x2: 142.091,
                        y2: 240.081,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint114_linear_10967_101901",
                        x1: 216.972,
                        y1: 233.355,
                        x2: 177.293,
                        y2: 148.248,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint115_linear_10967_101901",
                        x1: 178.456,
                        y1: 247.753,
                        x2: 158.627,
                        y2: 186.015,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $2fc442ead903fb00$export$2e2bcd8739ae039 = $2fc442ead903fb00$var$DarkTheme;




function $90a43c2d6b04cfac$var$LightTheme() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: 600,
        height: 626,
        viewBox: "0 0 600 626",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask0_11830_83706",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: -4,
                y: -2,
                width: 629,
                height: 627,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M-3.48242 -1.73633L-3.48242 624.264H624.982V-1.73633L-3.48242 -1.73633ZM310.759 478.423C213.823 478.423 135.232 400.141 135.232 303.585C135.232 207.029 213.823 128.746 310.759 128.746C407.695 128.746 486.285 207.029 486.285 303.585C486.285 400.141 407.695 478.423 310.759 478.423Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask0_11830_83706)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M353.072 32.4685C346.399 31.5314 339.657 30.8025 332.828 30.334L312.967 313.234L353.072 32.4685Z",
                                fill: "url(#paint0_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.508 313.304L312.445 313.2L332.341 29.7617L332.881 29.7964C339.606 30.265 346.418 30.9938 353.161 31.9309L353.683 32.0003L353.614 32.521L313.508 313.286V313.304ZM333.334 30.8897L314.553 298.414L352.464 32.9201C346.105 32.035 339.676 31.3582 333.334 30.8897Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M374.519 27.2107C367.724 25.7703 360.843 24.5382 353.856 23.5664L312.984 313.234L374.519 27.228V27.2107Z",
                                fill: "url(#paint1_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.508 313.338L312.463 313.148L353.405 22.959L353.927 23.0284C360.809 23.9829 367.76 25.215 374.642 26.69L375.165 26.7941L313.508 313.338ZM354.311 24.1738L315.599 298.57L373.893 27.6271C367.395 26.2562 360.809 25.0935 354.311 24.1738Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M390.39 46.004C384.049 44.1819 377.585 42.568 371.034 41.1797L312.984 313.234L390.408 46.0214L390.39 46.004Z",
                                fill: "url(#paint2_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.491 313.372L312.463 313.112L370.635 40.5371L371.158 40.6412C377.621 42.0122 384.137 43.6434 390.566 45.4829L391.071 45.6391L390.914 46.1424L313.491 313.372ZM371.436 41.8039L316.609 298.777L389.729 46.3679C383.684 44.6499 377.534 43.1055 371.436 41.8039Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M407.727 55.2904C401.594 53.0518 395.357 51.0214 388.981 49.1992L312.969 313.218L407.71 55.2904H407.727Z",
                                fill: "url(#paint3_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.473 313.409L312.463 313.079L388.614 48.5391L389.137 48.6779C395.409 50.4654 401.716 52.5131 407.918 54.7691L408.423 54.96L408.232 55.4632L313.491 313.391L313.473 313.409ZM389.346 49.8753L317.602 299.074L407.03 55.6194C401.193 53.5022 395.252 51.576 389.346 49.8753Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M431.648 48.9542C425.376 46.1602 418.947 43.5571 412.396 41.1797L312.986 313.234L431.648 48.9542Z",
                                fill: "url(#paint4_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.473 313.443L312.48 313.043L412.065 40.4863L412.57 40.6599C419.033 43.0026 425.532 45.623 431.856 48.4517L432.344 48.6599L432.135 49.1458L313.473 313.425V313.443ZM412.709 41.8573L318.596 299.421L430.933 49.2152C424.94 46.5601 418.807 44.0786 412.709 41.8573Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M442.832 70.9412C437.083 67.8869 431.177 65.0062 425.132 62.3164L312.986 313.234L442.85 70.9412H442.832Z",
                                fill: "url(#paint5_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.456 313.477L312.498 313.009L424.87 61.6055L425.358 61.8311C431.316 64.4688 437.292 67.3843 443.093 70.4732L443.564 70.7162L443.32 71.1847L313.456 313.477ZM425.41 63.0112L319.554 299.837L442.118 71.15C436.63 68.2519 431.02 65.5101 425.41 63.0112Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.782 88.0176C449.433 84.6857 443.928 81.4926 438.266 78.5078L312.967 313.234L454.782 88.0176Z",
                                fill: "url(#paint6_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.437 313.512L312.514 312.974L438.057 77.7793L438.527 78.0223C444.102 80.9724 449.66 84.1828 455.078 87.5494L455.531 87.8271L455.252 88.2783L313.437 313.495V313.512ZM438.492 79.2197L320.458 300.341L454.05 88.1915C448.963 85.0331 443.736 82.0136 438.492 79.2197Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M464.171 106.672C459.258 103.115 454.205 99.6961 448.979 96.4336L312.982 313.233L464.188 106.672H464.171Z",
                                fill: "url(#paint7_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.402 313.546L312.514 312.956L448.789 95.7051L449.242 95.9827C454.381 99.1758 459.503 102.629 464.468 106.239L464.904 106.551L464.59 106.985L313.385 313.546H313.402ZM449.154 97.1628L321.364 300.878L463.441 106.777C458.772 103.41 453.98 100.182 449.154 97.1628Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M490.569 103.133C485.586 98.9504 480.412 94.907 475.046 91.0371L312.969 313.234L490.569 103.133Z",
                                fill: "url(#paint8_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.387 313.564L312.551 312.904L474.941 90.2734L475.377 90.5858C480.656 94.4036 485.882 98.4817 490.935 102.716L491.336 103.063L490.987 103.462L313.387 313.564ZM475.168 91.7658L322.185 301.503L489.82 103.202C485.064 99.2279 480.133 95.3928 475.168 91.7832V91.7658Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M509.905 110.786C505.097 106.153 500.097 101.641 494.887 97.2852L312.984 313.235L509.923 110.786H509.905Z",
                                fill: "url(#paint9_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.368 313.599L312.566 312.888L494.818 96.5391L495.219 96.8862C500.359 101.173 505.411 105.719 510.272 110.405L510.655 110.769L313.351 313.599H313.368ZM494.958 98.0315L323.002 302.163L509.157 110.786C504.575 106.379 499.801 102.092 494.958 98.0315Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M518.198 129.788C513.843 124.946 509.278 120.243 504.522 115.645L312.984 313.216L518.216 129.788H518.198Z",
                                fill: "url(#paint10_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.333 313.633L312.584 312.87L504.505 114.916L504.888 115.28C509.575 119.792 514.192 124.565 518.599 129.441L518.965 129.84L518.565 130.205L313.333 313.651V313.633ZM504.54 116.408L323.752 302.891L517.45 129.753C513.286 125.155 508.948 120.677 504.54 116.408Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M517.885 154.309C514.104 149.485 510.132 144.747 505.968 140.131L312.967 313.217L517.885 154.309Z",
                                fill: "url(#paint11_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.299 313.651L312.619 312.835L506.004 139.385L506.37 139.784C510.481 144.331 514.506 149.12 518.321 153.997L518.652 154.413L313.316 313.651H313.299ZM505.934 140.895L324.449 303.672L517.154 154.222C513.565 149.658 509.802 145.181 505.951 140.895H505.934Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M532.486 166.283C529.002 161.112 525.308 156.027 521.389 151.029L312.986 313.217L532.486 166.283Z",
                                fill: "url(#paint12_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.281 313.668L312.654 312.801L521.475 150.283L521.806 150.7C525.656 155.611 529.402 160.747 532.921 165.971L533.217 166.405L532.764 166.7L313.264 313.634L313.281 313.668ZM521.283 151.793L325.076 304.488L531.736 166.145C528.409 161.233 524.889 156.409 521.283 151.793Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M551.999 176.296C548.741 170.674 545.274 165.103 541.563 159.637L312.969 313.217L551.999 176.296Z",
                                fill: "url(#paint13_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.247 313.686L312.689 312.783L541.737 158.891L542.033 159.324C545.674 164.704 549.193 170.327 552.486 176.019L552.747 176.487L552.277 176.748L313.247 313.668V313.686ZM541.44 160.383L325.669 305.356L551.284 176.105C548.183 170.743 544.873 165.468 541.44 160.383Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M568.811 189.468C565.867 183.446 562.696 177.476 559.281 171.576L312.969 313.217L568.811 189.45V189.468Z",
                                fill: "url(#paint14_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.212 313.703L312.707 312.766L559.473 170.848L559.734 171.316C563.096 177.112 566.302 183.151 569.281 189.243L569.508 189.728L569.02 189.954L313.177 313.721L313.212 313.703ZM559.089 172.305L326.192 306.241L568.096 189.225C565.274 183.481 562.26 177.789 559.089 172.305Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M568.809 210.76C566.37 204.738 563.705 198.751 560.813 192.816L312.984 313.216L568.827 210.76H568.809Z",
                                fill: "url(#paint15_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.178 313.72L312.742 312.748L561.058 192.105L561.285 192.591C564.142 198.44 566.842 204.496 569.299 210.57L569.49 211.056L569.003 211.247L313.16 313.703L313.178 313.72ZM560.57 193.546L326.645 307.195L568.114 210.483C565.797 204.756 563.253 199.064 560.57 193.546Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.524 225.841C582.451 219.437 580.134 213.068 577.573 206.734L312.984 313.217L584.541 225.841H584.524Z",
                                fill: "url(#paint16_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.141 313.738L312.775 312.732L577.869 206.041L578.078 206.527C580.604 212.757 582.956 219.195 585.047 225.668L585.204 226.171L313.141 313.721V313.738ZM577.277 207.447L327.044 308.15L583.862 225.512C581.876 219.421 579.663 213.347 577.277 207.447Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M593.479 244.064C591.841 237.453 589.942 230.858 587.799 224.281L312.967 313.236L593.479 244.064Z",
                                fill: "url(#paint17_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.107 313.739L312.811 312.715L588.148 223.604L588.305 224.107C590.413 230.58 592.329 237.244 593.985 243.925L594.107 244.445L593.584 244.567L313.072 313.739H313.107ZM587.469 224.957L327.358 309.14L592.835 243.682C591.249 237.365 589.455 231.083 587.469 224.957Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.611 265.998C583.496 259.594 582.137 253.191 580.534 246.787L312.984 313.234L584.611 265.998Z",
                                fill: "url(#paint18_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.072 313.755L312.846 312.713L580.918 246.145L581.04 246.665C582.626 252.965 584.002 259.437 585.135 265.91L585.222 266.431L584.699 266.518L313.072 313.755ZM580.134 247.429L327.602 310.145L583.985 265.563C582.904 259.472 581.615 253.381 580.134 247.429Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M541.023 289.738C540.465 284.358 539.716 278.979 538.758 273.564L312.969 313.218L541.023 289.738Z",
                                fill: "url(#paint19_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.038 313.756L312.898 312.697L539.21 272.957L539.297 273.478C540.238 278.805 541.005 284.254 541.562 289.686L541.615 290.224L313.038 313.773V313.756ZM538.322 274.189L327.777 311.17L540.43 289.27C539.89 284.22 539.176 279.152 538.322 274.189Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M538.425 305.773C538.251 300.463 537.885 295.118 537.31 289.756L312.967 313.235L538.425 305.773Z",
                                fill: "url(#paint20_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.003 313.756L312.934 312.697L537.817 289.148L537.869 289.686C538.427 294.979 538.81 300.394 538.984 305.756V306.294L313.021 313.773L313.003 313.756ZM536.841 290.328L327.882 312.211L537.869 305.253C537.695 300.272 537.347 295.257 536.841 290.328Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M578.984 322.589C579.21 316.324 579.227 310.007 578.984 303.639L312.967 312.888L578.966 322.589H578.984Z",
                                fill: "url(#paint21_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M579.489 323.143H578.949L312.949 313.425V312.367L579.506 303.1V303.638C579.75 309.902 579.733 316.288 579.506 322.623V323.16L579.489 323.143ZM327.932 312.904L578.461 322.033C578.67 316.08 578.67 310.076 578.461 304.176L327.915 312.887L327.932 312.904Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.898 340.985C574.56 334.841 574.996 328.629 575.222 322.347L312.986 313.219L573.898 340.985Z",
                                fill: "url(#paint22_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M574.368 341.574L573.828 341.522L312.916 313.756L312.986 312.697L575.762 321.843V322.381C575.518 328.558 575.082 334.841 574.42 341.053L574.368 341.574ZM327.899 314.276L573.427 340.394C574.037 334.546 574.455 328.663 574.682 322.849L327.899 314.259V314.276Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.456 361.372C585.606 354.968 586.529 348.495 587.209 341.935L312.986 313.232L584.456 361.389V361.372Z",
                                fill: "url(#paint23_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M584.873 361.997L584.351 361.91L312.881 313.754L313.038 312.695L587.8 341.468L587.748 342.006C587.069 348.461 586.128 355.021 584.978 361.477L584.891 361.997H584.873ZM327.777 315.316L584.002 360.765C585.083 354.674 585.954 348.513 586.616 342.422L327.777 315.316Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M589.23 382.337C590.867 375.829 592.296 369.217 593.481 362.501L312.969 313.234L589.23 382.337Z",
                                fill: "url(#paint24_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M589.629 382.978L589.107 382.857L312.846 313.754L313.072 312.713L594.107 362.067L594.02 362.587C592.852 369.199 591.424 375.88 589.751 382.457L589.629 382.978ZM327.602 316.34L588.845 381.694C590.396 375.481 591.755 369.182 592.87 362.934L327.602 316.34Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M566.161 395.647C568.112 389.677 569.872 383.604 571.422 377.426L312.967 313.234L566.161 395.647Z",
                                fill: "url(#paint25_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M566.51 396.306L566.005 396.149L312.811 313.737L313.107 312.713L572.068 377.026L571.946 377.546C570.43 383.62 568.653 389.763 566.667 395.802L566.51 396.306ZM327.341 317.346L565.813 394.969C567.66 389.277 569.332 383.516 570.778 377.807L327.341 317.346Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.409 418.537C575.9 412.393 578.217 406.129 580.29 399.743L312.984 313.234L573.409 418.554V418.537Z",
                                fill: "url(#paint26_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M573.688 419.232L573.2 419.023L312.775 313.704L313.141 312.697L580.953 399.379L580.796 399.882C578.74 406.182 576.423 412.516 573.897 418.711L573.688 419.197V419.232ZM327.027 318.337L573.113 417.843C575.482 411.995 577.677 406.008 579.629 400.073L327.044 318.32L327.027 318.337Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M569.578 438.424C572.557 432.385 575.327 426.189 577.905 419.838L312.986 313.217L569.578 438.406V438.424Z",
                                fill: "url(#paint27_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M569.821 439.135L312.742 313.702L313.178 312.73L578.602 419.543L578.411 420.028C575.867 426.276 573.062 432.54 570.065 438.649L569.821 439.135ZM326.627 319.29L569.334 437.694C572.156 431.933 574.804 426.033 577.208 420.115L326.645 319.273L326.627 319.29Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M543.828 446.493C546.999 441.061 549.995 435.474 552.8 429.73L312.986 313.217L543.828 446.493Z",
                                fill: "url(#paint28_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M544.019 447.222L312.707 313.685L313.212 312.748L553.514 429.486L553.27 429.972C550.5 435.612 547.486 441.27 544.28 446.771L544.019 447.239V447.222ZM326.174 320.227L543.618 445.764C546.615 440.593 549.455 435.282 552.068 429.972L326.174 320.227Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M531.04 460.272C534.524 455.136 537.869 449.843 541.023 444.376L312.969 313.234L531.023 460.272H531.04Z",
                                fill: "url(#paint29_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M531.179 461.001L530.743 460.706L312.689 313.668L313.264 312.766L541.772 444.185L541.51 444.654C538.392 450.033 535.029 455.378 531.493 460.584L531.196 461.018L531.179 461.001ZM325.651 321.13L530.9 459.526C534.21 454.632 537.364 449.617 540.308 444.567L325.669 321.13H325.651Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.383 486.129C538.495 480.906 542.432 475.509 546.213 469.938L312.967 313.234L534.383 486.147V486.129Z",
                                fill: "url(#paint30_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.489 486.893L534.071 486.563L312.654 313.651L313.281 312.783L546.98 469.799L546.684 470.233C542.956 475.734 538.966 481.201 534.82 486.459L534.489 486.876V486.893ZM325.076 321.998L534.315 485.4C538.217 480.42 541.963 475.283 545.5 470.094L325.076 321.998Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M526.212 505.131C530.777 500.099 535.185 494.893 539.436 489.461L312.967 313.217L526.212 505.114V505.131Z",
                                fill: "url(#paint31_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M526.265 505.878L525.865 505.514L312.619 313.616L313.299 312.801L540.186 489.357L539.855 489.774C535.673 495.119 531.213 500.394 526.614 505.462L526.248 505.861L526.265 505.878ZM324.431 322.814L526.196 504.386C530.534 499.579 534.732 494.598 538.705 489.566L324.431 322.814Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M475.967 481.912C479.974 478.077 483.877 474.068 487.657 469.886L312.984 313.217L475.985 481.912H475.967Z",
                                fill: "url(#paint32_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M475.95 482.677L475.584 482.295L312.584 313.6L313.333 312.836L488.407 469.852L488.041 470.251C484.313 474.364 480.375 478.425 476.334 482.312L475.95 482.677ZM323.734 323.595L475.985 481.167C479.748 477.54 483.407 473.774 486.891 469.939L323.717 323.595H323.734Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M493.319 528.038C498.424 523.787 503.407 519.327 508.268 514.659L312.984 313.217L493.319 528.038Z",
                                fill: "url(#paint33_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M493.25 528.801L492.902 528.385L312.566 313.563L313.368 312.852L509.035 514.675L508.651 515.04C503.86 519.638 498.825 524.15 493.668 528.437L493.25 528.784V528.801ZM322.968 324.305L493.39 527.291C498.25 523.23 502.989 518.979 507.519 514.64L322.985 324.305H322.968Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M463.843 520.802C468.774 517.244 473.617 513.496 478.338 509.539L312.969 313.234L463.843 520.819V520.802Z",
                                fill: "url(#paint34_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M463.739 521.547L463.425 521.114L312.551 313.529L313.387 312.869L479.105 509.591L478.687 509.938C474.035 513.825 469.14 517.625 464.157 521.218L463.721 521.53L463.739 521.547ZM322.168 324.965L463.965 520.055C468.634 516.671 473.217 513.113 477.59 509.469L322.168 324.965Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.434 539.561C459.817 536.229 465.096 532.689 470.305 528.923L312.967 313.234L454.416 539.579L454.434 539.561Z",
                                fill: "url(#paint35_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M454.259 540.307L453.981 539.856L312.531 313.512L313.42 312.922L471.072 529.045L470.636 529.357C465.514 533.071 460.165 536.646 454.73 540.03L454.277 540.307H454.259ZM321.329 325.59L454.608 538.85C459.712 535.674 464.73 532.307 469.556 528.819L321.329 325.59Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M450.76 572.394C456.91 569.149 462.99 565.661 469 561.93L312.986 313.234L450.76 572.394Z",
                                fill: "url(#paint36_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M450.533 573.106L312.498 313.477L313.421 312.939L469.714 562.087L469.261 562.364C463.373 566.043 457.223 569.566 450.986 572.846L450.515 573.089L450.533 573.106ZM320.442 326.128L450.968 571.666C456.857 568.542 462.658 565.21 468.251 561.757L320.442 326.146V326.128Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M436.349 590.496C442.935 587.581 449.468 584.44 455.914 581.004L312.967 313.219L436.332 590.496H436.349Z",
                                fill: "url(#paint37_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M436.072 591.206L435.863 590.721L312.498 313.443L313.456 312.975L456.648 581.228L456.177 581.471C449.818 584.838 443.215 588.031 436.578 590.981L436.09 591.189L436.072 591.206ZM319.519 326.615L436.612 589.783C442.902 586.99 449.156 583.97 455.184 580.777L319.502 326.615H319.519Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M398.459 548.414C404.051 546.401 409.591 544.179 415.114 541.732L312.986 313.236L398.476 548.414H398.459Z",
                                fill: "url(#paint38_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M398.144 549.089L397.97 548.586L312.48 313.409L313.473 313.01L415.828 541.992L415.34 542.2C409.922 544.612 404.294 546.868 398.65 548.899L398.144 549.072V549.089ZM318.561 327.049L398.772 547.736C404.051 545.81 409.312 543.71 414.399 541.471L318.561 327.066V327.049Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M384.85 564.481C390.809 562.78 396.767 560.871 402.69 558.72L312.984 313.217L384.85 564.464V564.481Z",
                                fill: "url(#paint39_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M384.485 565.14L312.463 313.373L313.473 313.043L403.354 559.049L402.848 559.223C397.012 561.34 391.001 563.283 384.973 564.984L384.468 565.123L384.485 565.14ZM317.585 327.395L385.217 563.821C390.879 562.207 396.524 560.385 401.995 558.407L317.585 327.395Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M371.644 590.477C378.23 589.089 384.815 587.475 391.383 585.601L312.984 313.234L371.662 590.477H371.644Z",
                                fill: "url(#paint40_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M371.245 591.102L371.14 590.581L312.463 313.338L313.491 313.078L392.047 585.948L391.541 586.104C385.06 587.943 378.423 589.592 371.768 590.998L371.245 591.102ZM316.592 327.69L372.064 589.852C378.335 588.516 384.608 586.972 390.723 585.236L316.574 327.69H316.592Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M348.525 568.334C354.588 567.501 360.651 566.442 366.731 565.158L312.967 313.234L348.525 568.334Z",
                                fill: "url(#paint41_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M348.073 568.924L348.004 568.404L312.445 313.304L313.491 313.113L367.36 565.557L366.837 565.662C360.861 566.928 354.711 568.004 348.596 568.855L348.073 568.924ZM315.564 327.899L348.997 567.727C354.729 566.911 360.495 565.922 366.105 564.742L315.564 327.899Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M331.277 580.429C337.619 579.995 343.995 579.336 350.389 578.451L312.967 313.234L331.277 580.429Z",
                                fill: "url(#paint42_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M330.791 580.985L330.756 580.447L312.445 313.253L313.508 313.148L351 578.886L350.478 578.955C344.188 579.84 337.742 580.499 331.331 580.951L330.791 580.985ZM314.536 328.038L331.784 579.84C337.812 579.424 343.875 578.781 349.798 577.966L314.536 328.02V328.038Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.48 602.505C319.345 602.505 326.261 602.28 333.23 601.811L312.968 313.254L312.48 602.523V602.505Z",
                                fill: "url(#paint43_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.915 603.025C312.776 603.025 312.636 603.025 312.48 603.025H311.939V602.487L312.427 313.218L313.49 313.184L333.787 602.279L333.247 602.314C326.539 602.782 319.692 603.025 312.898 603.025H312.915ZM313.49 328.108L313.02 601.949C319.57 601.949 326.173 601.724 332.654 601.29L313.473 328.108H313.49Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M294.674 567.676C300.719 568.11 306.817 568.336 312.967 568.336V313.236L294.674 567.676Z",
                                fill: "url(#paint44_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.508 568.856H312.968C306.905 568.856 300.737 568.63 294.64 568.196L294.1 568.161L294.134 567.624L312.428 313.184L313.49 313.218V568.856H313.508ZM295.25 567.19C300.981 567.589 306.748 567.797 312.445 567.797V328.125L295.25 567.19Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M272.932 593.603C279.587 594.54 286.329 595.269 293.141 595.737L312.968 313.236L272.932 593.603Z",
                                fill: "url(#paint45_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M293.647 596.309L293.107 596.274C286.399 595.806 279.57 595.094 272.863 594.14L272.34 594.07L272.41 593.55L312.445 313.184L313.508 313.288L293.629 596.327L293.647 596.309ZM273.542 593.151C279.884 594.036 286.312 594.713 292.654 595.164L311.4 328.038L273.542 593.151Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M264.482 538.624C269.831 539.77 275.267 540.724 280.772 541.505L312.985 313.234L264.482 538.624Z",
                                fill: "url(#paint46_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M281.225 542.096L280.703 542.026C275.284 541.263 269.796 540.291 264.378 539.145L263.855 539.041L312.463 313.131L313.508 313.322L281.225 542.113V542.096ZM265.11 538.208C270.145 539.267 275.267 540.169 280.302 540.898L310.355 327.899L265.11 538.208Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M245.057 547.648C250.632 549.244 256.294 550.667 262.043 551.882L312.968 313.217L245.057 547.648Z",
                                fill: "url(#paint47_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M262.462 552.524L261.939 552.42C256.277 551.223 250.545 549.8 244.917 548.169L244.412 548.012L244.569 547.509L312.48 313.078L313.508 313.338L262.462 552.524ZM245.719 547.284C250.98 548.776 256.329 550.112 261.625 551.258L309.344 327.673L245.719 547.284Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M230.354 538.156C235.702 540.099 241.138 541.869 246.695 543.466L312.969 313.234L230.354 538.173V538.156Z",
                                fill: "url(#paint48_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M247.061 544.125L246.538 543.986C241.068 542.424 235.562 540.637 230.162 538.676L229.656 538.485L229.848 537.982L312.463 313.061L313.474 313.39L247.043 544.142L247.061 544.125ZM231.05 537.843C236.085 539.665 241.225 541.331 246.347 542.806L308.352 327.395L231.05 537.843Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M218.229 524.238C223.246 526.477 228.368 528.542 233.612 530.451L312.987 313.234L218.246 524.238H218.229Z",
                                fill: "url(#paint49_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M233.925 531.127L233.42 530.953C228.263 529.079 223.071 526.996 218.002 524.74L217.514 524.515L217.74 524.029L312.481 313.025L313.474 313.424L233.925 531.127ZM218.942 523.96C223.664 526.042 228.489 528.003 233.298 529.756L307.376 327.03L218.96 523.96H218.942Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M193.471 536.214C198.767 539.025 204.203 541.68 209.76 544.144L312.986 313.219L193.471 536.196V536.214Z",
                                fill: "url(#paint50_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M210.038 544.855L209.55 544.647C204.063 542.217 198.557 539.528 193.226 536.699L192.756 536.456L193 535.987L312.515 313.01L313.473 313.478L210.038 544.89V544.855ZM194.184 536.005C199.202 538.66 204.341 541.159 209.481 543.449L306.4 326.615L194.167 536.005H194.184Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M157.041 560.854C162.93 564.533 168.975 568.021 175.195 571.318L312.968 313.217L157.041 560.854Z",
                                fill: "url(#paint51_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M175.422 572.048L174.952 571.805C168.819 568.56 162.704 565.037 156.764 561.323L156.311 561.046L156.589 560.594L312.516 312.957L313.44 313.495L175.422 572.065V572.048ZM157.791 560.699C163.419 564.204 169.203 567.536 174.987 570.608L305.495 326.129L157.791 560.699Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M159.082 523.474C164.082 527.101 169.239 530.572 174.553 533.887L312.971 313.234L159.082 523.474Z",
                                fill: "url(#paint52_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M174.726 534.615L174.273 534.338C169.029 531.075 163.803 527.552 158.768 523.908L158.332 523.596L158.646 523.162L312.534 312.922L313.423 313.512L174.709 534.615H174.726ZM159.83 523.353C164.569 526.771 169.465 530.069 174.378 533.158L304.607 325.573L159.83 523.353Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M144.74 512.264C149.462 516.221 154.375 520.056 159.445 523.735L312.985 313.234L144.74 512.264Z",
                                fill: "url(#paint53_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M159.55 524.481L159.114 524.168C154.114 520.541 149.149 516.671 144.375 512.68L143.975 512.333L144.323 511.934L312.567 312.904L313.404 313.564L159.55 524.498V524.481ZM145.49 512.194C149.985 515.942 154.619 519.569 159.323 522.988L303.769 324.965L145.49 512.211V512.194Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M121.098 510.476C125.784 514.988 130.662 519.379 135.732 523.631L312.966 313.234L121.08 510.476H121.098Z",
                                fill: "url(#paint54_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M135.803 524.376L135.402 524.029C130.402 519.864 125.472 515.421 120.733 510.857L120.35 510.493L312.602 312.852L313.403 313.563L135.82 524.376H135.803ZM121.848 510.458C126.325 514.762 130.96 518.927 135.664 522.866L302.95 324.27L121.848 510.441V510.458Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M118.555 487.014C122.684 491.596 127.004 496.056 131.517 500.411L312.967 313.234L118.555 487.014Z",
                                fill: "url(#paint55_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M131.533 501.158L131.15 500.794C126.707 496.507 122.334 491.996 118.17 487.379L117.805 486.98L118.205 486.616L312.618 312.836L313.367 313.6L131.533 501.158ZM119.32 487.05C123.24 491.388 127.335 495.622 131.516 499.649L302.217 323.578L119.32 487.05Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M86.5859 488.802C90.7498 494.129 95.1402 499.353 99.7571 504.472L312.985 313.234L86.5859 488.802Z",
                                fill: "url(#paint56_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M99.7212 505.219L99.3552 504.82C94.8081 499.787 90.3656 494.512 86.1669 489.132L85.8359 488.715L312.653 312.818L313.333 313.634L99.7212 505.219ZM87.3342 488.889C91.3238 493.974 95.505 498.954 99.7908 503.709L301.503 322.797L87.3168 488.889H87.3342Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.1113 466.433C87.7525 471.83 91.6028 477.123 95.6796 482.329L312.967 313.234L84.1113 466.433Z",
                                fill: "url(#paint57_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M95.5937 483.075L95.2626 482.659C91.2381 477.539 87.3355 472.177 83.6769 466.728L83.3809 466.294L83.8164 465.999L312.672 312.801L313.299 313.668L95.5937 483.093V483.075ZM84.8617 466.572C88.3287 471.691 92.0048 476.741 95.7853 481.566L300.877 321.963L84.8617 466.572Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M73.9531 450.155C77.211 455.778 80.678 461.348 84.3889 466.815L312.983 313.234L73.9531 450.155Z",
                                fill: "url(#paint58_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.2335 467.561L83.9372 467.127C80.296 461.747 76.7768 456.125 73.484 450.433L73.2227 449.964L73.6931 449.704L312.723 312.783L313.298 313.686L84.2509 467.578L84.2335 467.561ZM74.6863 450.346C77.7874 455.708 81.0976 460.984 84.5297 466.068L300.301 321.096L74.6863 450.346Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M77.9961 426.901C80.6965 432.437 83.6058 437.921 86.7418 443.335L312.967 313.234L77.9961 426.901Z",
                                fill: "url(#paint59_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M86.5674 444.046L86.306 443.577C83.2223 438.25 80.2607 432.714 77.5429 427.109L77.3164 426.623L77.8041 426.397L312.775 312.73L313.28 313.668L86.6023 444.029L86.5674 444.046ZM78.71 427.143C81.2885 432.384 84.0586 437.59 86.9506 442.606L299.761 320.21L78.71 427.143Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.1424 415.691C59.5815 421.712 62.2472 427.699 65.1393 433.634L312.967 313.234L57.125 415.691H57.1424Z",
                                fill: "url(#paint60_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M64.8953 434.345L64.6688 433.86C61.8116 428.029 59.1112 421.99 56.6547 415.881L56.4629 415.395L56.9508 415.204L312.793 312.748L313.229 313.72L64.9127 434.363L64.8953 434.345ZM57.8393 415.985C60.1738 421.729 62.7174 427.421 65.383 432.922L299.308 319.273L57.8393 415.985Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M37.4023 401.912C39.5104 408.402 41.8625 414.875 44.4583 421.296L312.966 313.234L37.4023 401.912Z",
                                fill: "url(#paint61_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M44.162 421.99L43.9704 421.504C41.4094 415.17 39.0225 408.645 36.897 402.085L36.7402 401.582L312.827 312.748L313.193 313.755L44.1795 422.007L44.162 421.99ZM38.0818 402.241C40.1027 408.436 42.3501 414.597 44.7718 420.584L298.924 318.301L38.0818 402.241Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M74.1815 372.115C75.5753 377.738 77.1955 383.361 79.0074 388.949L312.968 313.234L74.1641 372.115H74.1815Z",
                                fill: "url(#paint62_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M78.6765 389.624L78.5023 389.121C76.7079 383.603 75.0702 377.928 73.659 372.236L73.5371 371.715L74.0599 371.594L312.863 312.713L313.16 313.737L78.6765 389.624ZM74.8263 372.496C76.1504 377.807 77.6835 383.117 79.356 388.288L298.595 317.329L74.8263 372.496Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M41.3418 360.471C42.4568 366.875 43.8157 373.278 45.4185 379.682L312.969 313.234L41.3418 360.471Z",
                                fill: "url(#paint63_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.0337 380.323L44.9116 379.802C43.3262 373.485 41.9499 367.013 40.8175 360.557L40.7305 360.036L41.253 359.95L312.88 312.713L313.106 313.754L45.0337 380.323ZM41.9674 360.904C43.0475 366.978 44.3367 373.069 45.8176 379.039L298.35 316.322L41.9674 360.904Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M55.0176 339.801C55.6448 345.875 56.4984 351.983 57.5786 358.092L312.986 313.232L55.0176 339.801Z",
                                fill: "url(#paint64_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.1436 358.7L57.0567 358.179C55.9939 352.158 55.1227 345.997 54.4955 339.854L54.4434 339.316L54.9833 339.264L312.951 312.695L313.108 313.754L57.1785 358.7H57.1436ZM55.5931 340.27C56.2028 346.032 57.0217 351.811 57.9973 357.468L298.16 315.281L55.5931 340.27Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M33.3965 322.484C33.623 329.078 34.076 335.69 34.7729 342.354L312.985 313.234L33.3965 322.484Z",
                                fill: "url(#paint65_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M34.3035 342.943L34.2512 342.423C33.5543 335.846 33.1015 329.147 32.875 322.518V321.98H33.3975L312.986 312.73L313.056 313.789L34.321 342.978L34.3035 342.943ZM33.9552 323.004C34.1816 329.269 34.6172 335.568 35.2618 341.781L298.073 314.258L33.9552 323.004Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M37.4196 303.186C37.1756 309.676 37.1756 316.218 37.4021 322.813L312.966 313.233L37.4196 303.186Z",
                                fill: "url(#paint66_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M36.8802 323.368V322.83C36.6363 316.323 36.6363 309.711 36.8802 303.151V302.613L37.4378 302.631L312.984 312.678V313.737L36.8802 323.334V323.368ZM37.9429 303.724C37.7339 309.902 37.7166 316.132 37.9257 322.258L298.036 313.216L37.9429 303.724Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M66.395 286.996C65.7678 292.81 65.3497 298.675 65.1406 304.61L312.969 313.235L66.395 286.996Z",
                                fill: "url(#paint67_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.95 313.755L64.582 305.113V304.575C64.8085 298.727 65.2266 292.792 65.8538 286.927L65.9061 286.389L66.4463 286.441L313.02 312.68L312.95 313.738V313.755ZM65.6971 304.089L298.055 312.176L66.8644 287.586C66.2895 293.087 65.8887 298.623 65.6971 304.107V304.089Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.6134 267.941C56.5333 273.963 55.6622 280.054 55.0176 286.232L312.986 313.235L57.6134 267.941Z",
                                fill: "url(#paint68_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.916 313.755L54.4258 286.7L54.4781 286.163C55.1227 280.089 55.9938 273.928 57.074 267.837L57.1609 267.316L57.6837 267.403L313.056 312.696L312.899 313.755H312.916ZM55.5929 285.746L298.16 311.134L58.032 268.549C57.0216 274.258 56.2027 280.037 55.5929 285.746Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.5395 246.336C43.9541 252.635 42.5776 259.039 41.4277 265.529L312.985 313.217L45.557 246.318L45.5395 246.336Z",
                                fill: "url(#paint69_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.881 313.754L40.8008 265.962L40.888 265.442C42.0204 259.021 43.4142 252.565 45.017 246.196L45.1388 245.676L45.6616 245.815L313.09 312.713L312.863 313.754H312.881ZM42.0379 265.095L298.351 310.11L45.923 246.977C44.4247 252.964 43.1181 259.055 42.0379 265.095Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M39.0935 224.072C36.9855 230.528 35.069 237.105 33.3965 243.786L312.985 313.218L39.0935 224.072Z",
                                fill: "url(#paint70_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.846 313.738L32.752 244.167L32.874 243.646C34.5291 237.069 36.4456 230.423 38.5711 223.898L38.7278 223.395L39.2331 223.551L313.125 312.697L312.828 313.721L312.846 313.738ZM34.0412 243.403L298.612 309.104L39.4422 224.748C37.4386 230.909 35.6266 237.191 34.0586 243.403H34.0412Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M57.4922 209.908C55.0357 215.93 52.7882 222.073 50.7324 228.355L312.986 313.232L57.4922 209.908Z",
                                fill: "url(#paint71_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.812 313.736L50.0527 228.703L50.2095 228.2C52.213 222.039 54.4953 215.809 56.9867 209.718L57.1957 209.232L57.6836 209.441L313.178 312.765L312.812 313.771V313.736ZM51.4117 228.009L298.926 308.114L57.788 210.603C55.4535 216.347 53.3107 222.196 51.4117 228.009Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M45.9048 182.926C42.8037 189.225 39.9117 195.663 37.2461 202.258L312.984 313.235L45.9048 182.926Z",
                                fill: "url(#paint72_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.777 313.721L36.5332 202.553L36.7423 202.067C39.373 195.577 42.2998 189.052 45.4184 182.701L45.6449 182.215L46.1328 182.44L313.212 312.749L312.777 313.721ZM37.927 201.963L299.309 307.161L46.1328 183.638C43.1884 189.66 40.4184 195.82 37.927 201.963Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M50.3831 161.633C46.7767 167.828 43.3795 174.18 40.1738 180.705L312.968 313.235L50.3657 161.633H50.3831Z",
                                fill: "url(#paint73_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.741 313.703L39.459 180.948L39.6853 180.462C42.8387 174.041 46.271 167.603 49.9122 161.355L50.1734 160.887L50.6438 161.147L313.246 312.749L312.741 313.686V313.703ZM40.8875 180.462L299.779 306.241L50.574 162.379C47.1419 168.314 43.8841 174.388 40.8875 180.479V180.462Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M84.6329 159.254C80.9743 164.634 77.4899 170.187 74.1797 175.896L312.983 313.233L84.6503 159.271L84.6329 159.254Z",
                                fill: "url(#paint74_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.706 313.685L73.4492 176.087L73.7106 175.619C76.9685 169.996 80.5052 164.391 84.1987 158.942L84.4949 158.508L84.9305 158.803L313.263 312.765L312.689 313.667L312.706 313.685ZM74.9128 175.705L300.301 305.32L84.7735 160C81.3066 165.137 77.9791 170.413 74.8954 175.705H74.9128Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M105.334 151.064C101.484 155.958 97.773 161.025 94.2363 166.249L312.987 313.217L105.334 151.064Z",
                                fill: "url(#paint75_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.673 313.669L93.4863 166.405L93.7826 165.972C97.267 160.817 101.013 155.698 104.898 150.752L105.229 150.336L105.647 150.666L313.3 312.819L312.673 313.686V313.669ZM94.9674 166.11L300.878 304.454L105.421 151.811C101.779 156.462 98.2601 161.269 94.9674 166.11Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M125.943 144.902C121.953 149.31 118.068 153.892 114.34 158.646L312.986 313.233L125.943 144.92V144.902Z",
                                fill: "url(#paint76_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.654 313.65L113.59 158.733L113.921 158.317C117.597 153.631 121.499 148.998 125.541 144.555L125.907 144.156L126.308 144.521L313.351 312.852L312.671 313.667L312.654 313.65ZM115.088 158.56L301.521 303.654L125.959 145.666C122.179 149.848 118.52 154.187 115.071 158.56H115.088Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M141.935 136.209C137.736 140.235 133.642 144.452 129.67 148.825L312.967 313.216L141.918 136.191L141.935 136.209Z",
                                fill: "url(#paint77_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.62 313.633L128.922 148.877L129.288 148.478C133.19 144.157 137.319 139.905 141.57 135.827L141.954 135.463L142.319 135.845L313.369 312.87L312.62 313.633ZM130.438 148.791L302.236 302.874L141.919 136.955C137.946 140.773 134.096 144.747 130.42 148.791H130.438Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M146.484 114.916C141.78 118.838 137.163 122.951 132.686 127.272L312.969 313.234L146.484 114.916Z",
                                fill: "url(#paint78_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.584 313.599L131.936 127.255L132.319 126.89C136.744 122.639 141.396 118.474 146.152 114.517L146.57 114.17L146.918 114.586L313.403 312.905L312.602 313.616L312.584 313.599ZM133.451 127.289L302.985 302.163L146.431 115.68C141.971 119.411 137.615 123.315 133.451 127.289Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M181.762 132.686C177.476 135.775 173.26 139.037 169.148 142.49L312.985 313.233L181.762 132.686Z",
                                fill: "url(#paint79_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.567 313.563L168.383 142.421L168.783 142.074C172.843 138.69 177.094 135.376 181.432 132.252L181.867 131.939L182.181 132.373L313.404 312.921L312.567 313.581V313.563ZM169.899 142.56L303.787 301.485L181.641 133.432C177.616 136.347 173.679 139.402 169.899 142.56Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M197.667 128.73C193.294 131.455 188.974 134.336 184.723 137.407L312.966 313.235L197.65 128.73H197.667Z",
                                fill: "url(#paint80_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.549 313.548L183.992 137.286L184.428 136.974C188.609 133.954 192.964 131.022 197.407 128.28L197.86 128.002L198.139 128.453L313.455 312.958L312.567 313.548H312.549ZM185.473 137.529L304.622 300.88L197.494 129.46C193.4 132.011 189.358 134.718 185.473 137.512V137.529Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M204.827 109.797C200.001 112.348 195.227 115.09 190.506 118.005L312.965 313.217L204.809 109.779L204.827 109.797Z",
                                fill: "url(#paint81_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.531 313.513L189.775 117.85L190.228 117.572C194.863 114.691 199.689 111.915 204.584 109.346L205.055 109.104L313.454 313.009L312.531 313.547V313.513ZM191.239 118.179L305.51 300.324L204.602 110.509C200.054 112.921 195.577 115.49 191.239 118.179Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M212.058 86.4041C206.674 88.7815 201.326 91.3672 196.047 94.1612L312.984 313.217L212.058 86.3867V86.4041Z",
                                fill: "url(#paint82_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.497 313.476L195.316 93.9522L195.787 93.7092C200.996 90.95 206.379 88.3296 211.832 85.9348L212.32 85.7266L212.529 86.2125L313.455 313.043L312.497 313.511V313.476ZM196.762 94.386L306.434 299.836L211.78 87.1148C206.693 89.3708 201.641 91.8177 196.762 94.386Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M219.098 54.9785C212.965 57.1998 206.868 59.6293 200.822 62.3191L312.968 313.236L219.098 54.9785Z",
                                fill: "url(#paint83_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.497 313.444L200.125 62.0405L200.613 61.8323C206.571 59.1945 212.738 56.713 218.923 54.4743L219.429 54.3008L219.603 54.8041L313.473 313.062L312.48 313.461L312.497 313.444ZM201.536 62.5785L307.392 299.404L218.784 55.6544C212.948 57.7715 207.146 60.097 201.536 62.5785Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M241.85 64.5742C235.944 66.2575 230.055 68.1491 224.201 70.2662L312.984 313.235L241.85 64.5742Z",
                                fill: "url(#paint84_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.48 313.408L223.523 69.9356L224.029 69.7447C229.795 67.6622 235.754 65.736 241.712 64.0353L242.217 63.8965L313.491 313.061L312.48 313.391V313.408ZM224.882 70.5777L308.369 299.056L241.486 65.2328C235.893 66.8293 230.301 68.6341 224.882 70.595V70.5777Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M258.208 54.4219C252.058 55.706 245.926 57.2332 239.793 58.9859L312.983 313.235L258.208 54.4219Z",
                                fill: "url(#paint85_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.462 313.373L239.115 58.6036L239.62 58.4474C245.666 56.7294 251.868 55.1849 258.088 53.8834L258.61 53.7793L258.715 54.2999L313.49 313.113L312.462 313.373ZM240.439 59.3324L309.361 298.761L257.774 55.0288C251.938 56.2609 246.119 57.7012 240.422 59.3151L240.439 59.3324Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M278.368 64.9199C272.48 65.7355 266.556 66.7594 260.65 68.0089L312.986 313.234L278.386 64.9199H278.368Z",
                                fill: "url(#paint86_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.464 313.338L260.023 67.5923L260.546 67.4882C266.365 66.2561 272.341 65.2149 278.299 64.3819L278.822 64.3125L278.891 64.8331L313.492 313.147L312.446 313.338H312.464ZM261.278 68.4253L310.39 298.57L277.916 65.5272C272.341 66.3081 266.748 67.28 261.278 68.4253Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M296.331 70.3164C290.564 70.7155 284.762 71.3056 278.961 72.1212L312.986 313.216L296.348 70.3164H296.331Z",
                                fill: "url(#paint87_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.446 313.304L278.352 71.6706L278.874 71.6012C284.606 70.8029 290.46 70.1955 296.296 69.7964L296.836 69.7617L296.871 70.2997L313.509 313.199L312.446 313.304ZM279.571 72.5904L311.436 298.414L295.843 70.8897C290.407 71.2715 284.937 71.8442 279.571 72.573V72.5904Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.439 38.5762C306.923 38.5762 300.355 38.7844 293.734 39.2356L312.968 313.233L313.439 38.5762Z",
                                fill: "url(#paint88_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M312.445 313.269L293.176 38.7506L293.716 38.7159C300.092 38.2647 306.591 38.0391 313.054 38.0391H313.995V38.577L313.525 313.234L312.462 313.269H312.445ZM294.308 39.7397L312.462 298.345L312.898 39.0976C306.695 39.0976 300.441 39.3059 294.308 39.7224V39.7397Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        opacity: 0.08,
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M332.027 48.2783C325.737 47.8271 319.378 47.6016 312.984 47.6016V313.235L332.027 48.2957V48.2783Z",
                                fill: "url(#paint89_linear_11830_83706)"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M313.508 313.268L312.445 313.234V47.0801H312.985C319.292 47.0801 325.721 47.3057 332.08 47.7569L332.62 47.7916L332.585 48.3295L313.543 313.268H313.508ZM313.508 48.1387V298.344L331.453 48.7808C325.477 48.3643 319.449 48.156 313.508 48.1387Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask1_11830_83706",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 629,
                height: 626,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M0 0L0 626H628.46V0L0 0ZM314.239 480.16C217.303 480.16 138.713 401.877 138.713 305.321C138.713 208.765 217.303 130.482 314.239 130.482C411.174 130.482 489.764 208.765 489.764 305.321C489.764 401.877 411.174 480.16 314.239 480.16Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask1_11830_83706)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M507.248 505.247C613.848 399.064 613.848 226.908 507.248 120.726C400.648 14.5429 227.815 14.5429 121.216 120.726C14.6156 226.908 14.6155 399.064 121.215 505.247C227.815 611.43 400.648 611.43 507.248 505.247Z",
                            fill: "url(#paint90_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M291.202 286.867C320.729 215.862 286.878 134.458 215.594 105.047C144.31 75.6355 62.5858 109.354 33.0589 180.359C3.53196 251.365 37.3831 332.768 108.667 362.18C179.952 391.591 261.675 357.873 291.202 286.867Z",
                            fill: "url(#paint91_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M220.89 548.065C314.866 548.065 391.05 472.18 391.05 378.572C391.05 284.963 314.866 209.078 220.89 209.078C126.913 209.078 50.7305 284.963 50.7305 378.572C50.7305 472.18 126.913 548.065 220.89 548.065Z",
                            fill: "url(#paint92_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M461.6 477.811C516.158 423.465 516.158 335.355 461.6 281.01C407.041 226.665 318.584 226.664 264.026 281.01C209.467 335.355 209.467 423.466 264.025 477.811C318.584 532.156 407.041 532.156 461.6 477.811Z",
                            fill: "url(#paint93_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M481.193 445.652C556.287 427.997 602.795 353.048 585.072 278.248C567.348 203.447 492.104 157.121 417.009 174.776C341.915 192.43 295.407 267.38 313.131 342.18C330.855 416.981 406.099 463.306 481.193 445.652Z",
                            fill: "url(#paint94_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("g", {
                        style: {
                            mixBlendMode: "darken"
                        },
                        opacity: 0.32,
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                            d: "M371.904 339.89C446.483 339.89 506.941 279.669 506.941 205.382C506.941 131.095 446.483 70.873 371.904 70.873C297.325 70.873 236.867 131.095 236.867 205.382C236.867 279.669 297.325 339.89 371.904 339.89Z",
                            fill: "url(#paint95_radial_11830_83706)",
                            style: {
                                mixBlendMode: "screen"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("mask", {
                id: "mask2_11830_83706",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: 56,
                y: 54,
                width: 514,
                height: 512,
                children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                    d: "M312.986 54.9766C171.519 54.9766 56.8477 169.199 56.8477 310.111C56.8477 451.023 171.519 565.245 312.986 565.245C454.453 565.245 569.125 451.023 569.125 310.111C569.125 169.199 454.453 54.9766 312.986 54.9766ZM312.986 414.858C254.919 414.858 207.844 367.968 207.844 310.128C207.844 252.288 254.919 205.398 312.986 205.398C371.054 205.398 418.128 252.288 418.128 310.128C418.128 367.968 371.054 414.858 312.986 414.858Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                mask: "url(#mask2_11830_83706)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M423.581 159.775C423.39 159.619 423.18 159.48 422.989 159.341C422.989 159.341 422.989 159.341 422.971 159.341C419.679 156.964 416.281 154.673 412.779 152.469C412.57 152.331 412.361 152.209 412.17 152.087H412.152C408.703 149.936 405.149 147.888 401.507 145.944C401.298 145.823 401.072 145.719 400.863 145.597C400.863 145.597 400.863 145.597 400.845 145.597C397.239 143.688 393.563 141.901 389.8 140.2C389.573 140.096 389.347 139.992 389.138 139.905C389.138 139.905 389.12 139.905 389.103 139.905C385.375 138.257 381.577 136.712 377.709 135.289C377.482 135.202 377.256 135.116 377.029 135.029C377.029 135.029 377.03 135.029 376.995 135.029C373.162 133.641 369.259 132.374 365.304 131.228C365.078 131.159 364.834 131.09 364.608 131.02C364.608 131.02 364.59 131.02 364.573 131.02C360.653 129.909 356.681 128.903 352.639 128.035C352.395 127.966 352.168 127.931 351.924 127.879C351.924 127.879 351.907 127.879 351.89 127.879C347.9 127.046 343.858 126.317 339.781 125.727C339.537 125.675 339.294 125.658 339.067 125.623C339.067 125.623 339.05 125.623 339.032 125.623C334.99 125.068 330.913 124.634 326.802 124.322C326.558 124.287 326.314 124.287 326.07 124.27C326.07 124.27 326.053 124.27 326.035 124.27C321.715 123.975 317.377 123.818 312.986 123.818V310.215L433.843 167.914C430.533 165.138 427.118 162.448 423.581 159.879V159.775Z",
                        fill: "url(#paint96_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M462.154 177.407C461.979 177.199 461.805 177.025 461.631 176.834C461.631 176.834 461.631 176.834 461.613 176.817C458.704 173.589 455.655 170.448 452.484 167.377C452.293 167.186 452.101 167.012 451.927 166.838C451.927 166.838 451.927 166.839 451.909 166.821C448.582 163.628 445.132 160.522 441.543 157.52L312.969 310.145L471.091 188.114C468.251 184.487 465.272 180.912 462.154 177.424V177.407Z",
                        fill: "url(#paint97_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M510.099 276.305C510.046 276.045 510.012 275.802 509.959 275.541V275.507C509.193 271.238 508.304 266.951 507.242 262.682C507.172 262.422 507.12 262.179 507.05 261.936C507.05 261.936 507.05 261.919 507.05 261.901C505.935 257.442 504.646 252.982 503.2 248.539L312.969 310.11L511.98 290.084C511.51 285.502 510.883 280.904 510.081 276.305H510.099Z",
                        fill: "url(#paint98_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M516.648 229.103C516.543 228.842 516.439 228.582 516.317 228.322C516.317 228.322 516.317 228.305 516.317 228.287C514.522 223.879 512.571 219.506 510.48 215.15C510.359 214.89 510.219 214.63 510.097 214.369C510.097 214.369 510.097 214.369 510.097 214.352C508.006 210.083 505.759 205.849 503.337 201.649C503.198 201.389 503.041 201.163 502.902 200.903C502.902 200.903 502.902 200.886 502.902 200.868C500.515 196.756 497.972 192.677 495.271 188.669C495.114 188.426 494.958 188.2 494.784 187.957C494.784 187.957 494.784 187.94 494.766 187.922C491.926 183.74 488.93 179.627 485.777 175.584L312.955 310.075L521.822 243.402C520.271 238.595 518.546 233.806 516.63 229.051L516.648 229.103Z",
                        fill: "url(#paint99_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M448.843 415.845C451.3 412.722 453.651 409.494 455.916 406.145L312.969 310.109L403.755 456.123C407.135 454.024 410.48 451.802 413.755 449.46C413.929 449.338 414.121 449.199 414.295 449.078H414.312C417.344 446.856 420.341 444.548 423.25 442.119C423.424 441.98 423.581 441.841 423.755 441.702C423.755 441.702 423.755 441.702 423.773 441.702C426.647 439.29 429.47 436.774 432.205 434.154C432.362 434.015 432.519 433.841 432.675 433.702C432.675 433.702 432.675 433.702 432.693 433.685C435.393 431.082 438.024 428.375 440.585 425.581C440.742 425.425 440.881 425.251 441.038 425.095C441.038 425.095 441.038 425.095 441.055 425.078C443.564 422.301 446.003 419.42 448.355 416.435C448.495 416.262 448.634 416.088 448.756 415.915C448.756 415.915 448.756 415.915 448.756 415.897L448.843 415.845Z",
                        fill: "url(#paint100_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M486.649 366.318C487.956 362.327 489.123 358.249 490.168 354.118L312.986 310.109L463.965 412.444C466.335 408.973 468.6 405.381 470.76 401.702C470.882 401.511 470.986 401.303 471.108 401.095C471.108 401.095 471.108 401.095 471.108 401.077C473.094 397.641 474.976 394.136 476.771 390.526C476.875 390.318 476.98 390.11 477.084 389.902C478.826 386.309 480.464 382.683 481.98 378.951C482.067 378.743 482.154 378.518 482.241 378.292C482.241 378.292 482.241 378.292 482.241 378.257C483.722 374.578 485.098 370.847 486.37 367.029C486.44 366.804 486.509 366.578 486.579 366.353V366.318H486.649Z",
                        fill: "url(#paint101_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M512.869 317.068C513.026 312.73 513.026 308.357 512.886 303.966C512.886 303.706 512.869 303.446 512.851 303.185C512.851 303.185 512.851 303.168 512.851 303.151C512.695 298.552 512.364 293.919 511.876 289.285L312.951 310.11L506.841 359.099C507.973 354.639 508.949 350.11 509.785 345.511C509.837 345.268 509.872 345.008 509.924 344.748C509.924 344.748 509.924 344.73 509.924 344.713C510.674 340.444 511.301 336.123 511.771 331.75C511.806 331.489 511.823 331.229 511.841 330.986C511.841 330.986 511.841 330.969 511.841 330.951C512.294 326.63 512.607 322.275 512.782 317.884C512.782 317.624 512.782 317.363 512.799 317.103C512.799 317.103 512.799 317.086 512.799 317.068H512.869Z",
                        fill: "url(#paint102_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.11L222.217 138.412C218.245 140.512 214.307 142.751 210.422 145.145C210.213 145.267 209.987 145.406 209.778 145.545C206.189 147.783 202.635 150.161 199.15 152.659C198.941 152.798 198.75 152.954 198.541 153.093C198.541 153.093 198.541 153.093 198.523 153.093C194.882 155.731 191.31 158.508 187.809 161.44L313.021 310.092L312.986 310.11Z",
                        fill: "url(#paint103_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.987 310.11L272.184 115.055C267.655 115.992 263.142 117.102 258.63 118.369C258.386 118.421 258.142 118.508 257.881 118.577C257.881 118.577 257.863 118.577 257.846 118.577C253.665 119.775 249.483 121.111 245.337 122.604C245.093 122.673 244.849 122.777 244.605 122.864C244.605 122.864 244.588 122.864 244.57 122.864C240.476 124.356 236.417 125.988 232.375 127.758C232.131 127.844 231.905 127.966 231.661 128.07C231.661 128.07 231.643 128.07 231.626 128.07C227.41 129.944 223.228 131.975 219.082 134.161L312.987 310.076V310.11Z",
                        fill: "url(#paint104_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M299.361 104.504C299.1 104.504 298.821 104.538 298.56 104.556C298.56 104.556 298.543 104.556 298.525 104.556C294.03 104.868 289.518 105.337 284.988 105.944C284.727 105.961 284.466 106.013 284.187 106.048C284.187 106.048 284.169 106.048 284.152 106.048C279.413 106.708 274.674 107.541 269.936 108.547L312.951 310.11L313.787 104.035C309.013 104.035 304.187 104.174 299.361 104.486V104.504Z",
                        fill: "url(#paint105_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M411.838 495.273C416.124 493 420.375 490.553 424.556 487.95L312.986 310.109L297.445 519.239C302.289 519.586 307.184 519.777 312.132 519.794C312.411 519.794 312.672 519.794 312.951 519.794H312.986C317.568 519.794 322.185 519.638 326.819 519.326C327.098 519.326 327.359 519.291 327.638 519.273C327.638 519.273 327.655 519.273 327.672 519.273C332.237 518.944 336.836 518.475 341.436 517.85C341.697 517.833 341.976 517.781 342.237 517.746C342.237 517.746 342.255 517.746 342.272 517.746C346.819 517.104 351.366 516.323 355.913 515.369C356.175 515.317 356.454 515.265 356.715 515.213C356.715 515.213 356.733 515.213 356.75 515.213C361.227 514.258 365.722 513.165 370.182 511.898C370.444 511.829 370.705 511.759 370.966 511.673C370.966 511.673 370.984 511.673 371.001 511.673C375.409 510.406 379.799 509 384.172 507.438C384.433 507.351 384.677 507.265 384.939 507.161C384.939 507.161 384.956 507.161 384.974 507.161C389.277 505.599 393.563 503.881 397.814 502.007C398.057 501.902 398.301 501.798 398.563 501.677C398.563 501.677 398.58 501.677 398.597 501.677C402.779 499.82 406.943 497.807 411.054 495.655C411.298 495.534 411.525 495.412 411.769 495.273C411.769 495.273 411.786 495.273 411.803 495.273H411.838Z",
                        fill: "url(#paint106_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M127.267 399.411C129.341 403.68 131.588 407.915 133.975 412.097C134.114 412.34 134.254 412.566 134.376 412.791V412.826C136.623 416.696 139.01 420.514 141.536 424.297C141.693 424.522 141.832 424.748 141.989 424.956C141.989 424.956 141.989 424.973 141.989 424.991C144.498 428.704 147.146 432.349 149.933 435.924C150.09 436.149 150.264 436.358 150.439 436.566C150.439 436.566 150.439 436.566 150.439 436.583C153.209 440.106 156.101 443.559 159.132 446.943C159.306 447.152 159.498 447.342 159.672 447.533C159.672 447.533 159.672 447.533 159.69 447.551C162.878 451.073 166.206 454.509 169.69 457.859L312.934 310.109L127.232 399.411H127.267Z",
                        fill: "url(#paint107_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.987 310.11L161.816 464.784C165.405 468.254 169.151 471.638 173.019 474.901C173.228 475.092 173.454 475.265 173.663 475.439C173.663 475.439 173.663 475.439 173.681 475.456C177.304 478.476 181.033 481.391 184.901 484.22C185.127 484.393 185.354 484.55 185.58 484.723C185.58 484.723 185.58 484.723 185.615 484.74C189.43 487.5 193.368 490.155 197.409 492.688C197.653 492.845 197.88 492.984 198.124 493.14C198.124 493.14 198.141 493.14 198.159 493.157C202.166 495.639 206.277 498.016 210.493 500.272C210.737 500.411 210.999 500.55 211.243 500.671C211.243 500.671 211.26 500.671 211.278 500.671C215.441 502.875 219.71 504.958 224.083 506.919C224.344 507.04 224.605 507.161 224.849 507.266C224.849 507.266 224.867 507.266 224.884 507.266C229.205 509.175 233.595 510.962 238.09 512.61C238.351 512.715 238.613 512.801 238.874 512.906C238.874 512.906 238.891 512.906 238.909 512.906C243.351 514.502 247.864 515.977 252.463 517.313C252.724 517.4 253.003 517.47 253.282 517.556C253.282 517.556 253.299 517.556 253.317 517.556C257.847 518.841 262.463 520.003 267.132 521.01C267.411 521.079 267.69 521.131 267.951 521.183C267.951 521.183 267.969 521.183 267.986 521.183C272.603 522.155 277.272 522.988 282.011 523.665C282.29 523.717 282.568 523.752 282.847 523.786C282.847 523.786 282.865 523.786 282.882 523.786C287.847 524.48 292.847 525.001 297.917 525.366L313.039 310.023L312.987 310.11Z",
                        fill: "url(#paint108_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.109L119.096 261.119C117.964 265.579 116.988 270.108 116.152 274.707C116.099 274.95 116.065 275.21 116.03 275.471C116.03 275.471 116.03 275.488 116.03 275.505C115.281 279.774 114.653 284.095 114.183 288.469C114.148 288.729 114.131 288.989 114.113 289.232V289.267C113.66 293.588 113.347 297.944 113.172 302.334C113.172 302.594 113.172 302.855 113.155 303.115C113.155 303.115 113.155 303.132 113.155 303.15C112.998 307.488 112.998 311.861 113.138 316.252C113.138 316.512 113.155 316.773 113.172 317.033C113.172 317.033 113.172 317.05 113.172 317.067C113.329 321.666 113.66 326.3 114.148 330.933L313.073 310.109H312.986Z",
                        fill: "url(#paint109_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M105.717 330.968C106.239 336.018 106.936 341.068 107.825 346.136L312.969 310.109L105.699 330.968H105.717Z",
                        fill: "url(#paint110_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.987 310.109L105.717 345.65C106.553 350.422 107.546 355.194 108.731 359.967C108.8 360.227 108.87 360.487 108.94 360.765C108.94 360.765 108.94 360.782 108.94 360.799C110.055 365.225 111.309 369.65 112.738 374.04C112.825 374.301 112.912 374.561 112.999 374.821C112.999 374.821 112.999 374.839 112.999 374.856C114.41 379.194 115.978 383.515 117.703 387.802C117.808 388.062 117.912 388.305 118.017 388.565C118.017 388.565 118.017 388.583 118.017 388.6C119.846 393.077 121.832 397.537 123.992 401.963L313.021 310.127L312.987 310.109Z",
                        fill: "url(#paint111_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M122.998 247.775C121.483 252.391 120.106 257.111 118.904 261.901L312.986 310.092L122.998 247.758V247.775Z",
                        fill: "url(#paint112_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M111.238 227.974C109.234 232.885 107.387 237.901 105.715 243.02L312.985 310.092L111.255 227.957L111.238 227.974Z",
                        fill: "url(#paint113_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.985 310.11L162.233 129.684C158.051 133.154 153.957 136.799 149.967 140.616C149.741 140.825 149.532 141.033 149.305 141.259C145.612 144.816 142.023 148.512 138.521 152.348C138.312 152.556 138.12 152.799 137.911 153.024C137.911 153.024 137.912 153.024 137.894 153.059C134.253 157.102 131.616 160.786 128.218 165.124L313.02 310.127L312.985 310.11Z",
                        fill: "url(#paint114_linear_11830_83706)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M312.986 310.11L121.187 159.602C117.702 164.027 114.34 168.591 111.134 173.311C110.96 173.571 110.786 173.832 110.594 174.109C107.632 178.5 104.775 183.012 102.057 187.662C101.9 187.923 101.744 188.2 101.587 188.478C101.587 188.478 101.587 188.496 101.569 188.513C98.9212 193.094 96.3951 197.797 94.0083 202.621C93.8689 202.899 93.7296 203.177 93.5902 203.472C93.5902 203.472 93.5902 203.489 93.5902 203.506C91.1163 208.556 88.7992 213.728 86.6562 219.021L313.055 310.128L312.986 310.11Z",
                        fill: "url(#paint115_linear_11830_83706)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M267.08 315.199C266.813 315.199 266.587 315.119 266.4 314.959C266.24 314.773 266.16 314.546 266.16 314.279V312.999C266.16 312.759 266.227 312.493 266.36 312.199C266.493 311.906 266.76 311.586 267.16 311.239L275.64 302.759C277 301.613 278.067 300.639 278.84 299.839C279.64 299.013 280.2 298.226 280.52 297.479C280.867 296.733 281.04 295.959 281.04 295.159C281.04 293.639 280.613 292.439 279.76 291.559C278.907 290.653 277.64 290.199 275.96 290.199C274.893 290.199 273.973 290.426 273.2 290.879C272.427 291.306 271.827 291.906 271.4 292.679C270.973 293.426 270.68 294.279 270.52 295.239C270.467 295.586 270.32 295.826 270.08 295.959C269.867 296.093 269.667 296.159 269.48 296.159H267.4C267.16 296.159 266.96 296.093 266.8 295.959C266.64 295.799 266.56 295.613 266.56 295.399C266.587 294.386 266.8 293.373 267.2 292.359C267.6 291.319 268.187 290.386 268.96 289.559C269.76 288.706 270.733 288.026 271.88 287.519C273.053 287.013 274.413 286.759 275.96 286.759C278.067 286.759 279.787 287.146 281.12 287.919C282.48 288.666 283.48 289.666 284.12 290.919C284.76 292.173 285.08 293.546 285.08 295.039C285.08 296.213 284.88 297.293 284.48 298.279C284.08 299.239 283.493 300.186 282.72 301.119C281.973 302.026 281.04 302.959 279.92 303.919L272.24 311.719H284.72C285.013 311.719 285.24 311.799 285.4 311.959C285.587 312.119 285.68 312.346 285.68 312.639V314.279C285.68 314.546 285.587 314.773 285.4 314.959C285.24 315.119 285.013 315.199 284.72 315.199H267.08ZM290.357 318.199C290.143 318.199 289.97 318.119 289.837 317.959C289.73 317.799 289.69 317.599 289.717 317.359L290.637 311.639C290.69 311.319 290.797 311.053 290.957 310.839C291.143 310.599 291.41 310.479 291.757 310.479H294.437C294.623 310.479 294.77 310.546 294.877 310.679C295.01 310.813 295.077 310.973 295.077 311.159C295.077 311.373 295.037 311.586 294.957 311.799L292.837 317.279C292.73 317.546 292.583 317.759 292.397 317.919C292.237 318.106 291.997 318.199 291.677 318.199H290.357ZM309.318 315.599C307.211 315.599 305.424 315.239 303.958 314.519C302.518 313.773 301.411 312.813 300.638 311.639C299.891 310.466 299.491 309.226 299.438 307.919C299.411 307.679 299.478 307.493 299.638 307.359C299.798 307.199 299.998 307.119 300.238 307.119H302.398C302.638 307.119 302.851 307.186 303.038 307.319C303.224 307.426 303.371 307.653 303.478 307.999C303.744 308.986 304.171 309.799 304.758 310.439C305.371 311.053 306.064 311.506 306.838 311.799C307.638 312.066 308.464 312.199 309.318 312.199C310.464 312.199 311.504 311.973 312.438 311.519C313.398 311.039 314.158 310.346 314.718 309.439C315.278 308.506 315.558 307.386 315.558 306.079C315.558 304.879 315.278 303.853 314.718 302.999C314.184 302.119 313.438 301.453 312.478 300.999C311.544 300.519 310.491 300.279 309.318 300.279C308.438 300.279 307.718 300.386 307.158 300.599C306.598 300.813 306.118 301.066 305.718 301.359C305.344 301.653 304.998 301.906 304.678 302.119C304.384 302.333 304.051 302.439 303.678 302.439H301.598C301.358 302.439 301.144 302.359 300.958 302.199C300.771 302.013 300.691 301.799 300.718 301.559L301.998 288.199C302.024 287.879 302.118 287.639 302.278 287.479C302.464 287.293 302.704 287.199 302.998 287.199H316.958C317.224 287.199 317.438 287.293 317.598 287.479C317.784 287.639 317.878 287.853 317.878 288.119V289.679C317.878 289.973 317.784 290.199 317.598 290.359C317.438 290.519 317.224 290.599 316.958 290.599H305.438L304.678 298.479C305.078 298.239 305.678 297.959 306.478 297.639C307.304 297.293 308.438 297.119 309.878 297.119C311.211 297.119 312.451 297.319 313.598 297.719C314.771 298.119 315.798 298.706 316.678 299.479C317.584 300.253 318.291 301.199 318.798 302.319C319.304 303.413 319.558 304.679 319.558 306.119C319.558 308.146 319.118 309.866 318.238 311.279C317.358 312.693 316.144 313.773 314.598 314.519C313.051 315.239 311.291 315.599 309.318 315.599ZM333.708 315.599C331.494 315.599 329.614 315.159 328.068 314.279C326.521 313.373 325.334 312.199 324.508 310.759C323.708 309.293 323.308 307.706 323.308 305.999C323.308 305.199 323.401 304.439 323.588 303.719C323.801 302.973 324.054 302.279 324.348 301.639C324.668 300.973 324.974 300.386 325.268 299.879C325.588 299.346 325.868 298.919 326.108 298.599L333.708 287.999C333.841 287.866 334.001 287.706 334.188 287.519C334.374 287.306 334.654 287.199 335.028 287.199H337.148C337.388 287.199 337.574 287.293 337.708 287.479C337.868 287.639 337.948 287.839 337.948 288.079C337.948 288.186 337.934 288.293 337.908 288.399C337.881 288.479 337.841 288.546 337.788 288.599L331.948 296.759C332.268 296.653 332.641 296.586 333.068 296.559C333.494 296.506 333.881 296.479 334.228 296.479C335.694 296.506 337.028 296.773 338.228 297.279C339.428 297.786 340.454 298.479 341.308 299.359C342.188 300.213 342.854 301.213 343.308 302.359C343.761 303.479 343.988 304.679 343.988 305.959C343.988 307.639 343.588 309.213 342.788 310.679C341.988 312.146 340.814 313.333 339.268 314.239C337.748 315.146 335.894 315.599 333.708 315.599ZM333.668 312.199C334.788 312.199 335.828 311.959 336.788 311.479C337.748 310.999 338.521 310.306 339.108 309.399C339.721 308.466 340.028 307.319 340.028 305.959C340.028 304.626 339.734 303.506 339.148 302.599C338.561 301.666 337.774 300.973 336.788 300.519C335.828 300.039 334.788 299.799 333.668 299.799C332.548 299.799 331.508 300.039 330.548 300.519C329.588 300.973 328.801 301.666 328.188 302.599C327.601 303.506 327.308 304.626 327.308 305.959C327.308 307.319 327.601 308.466 328.188 309.399C328.801 310.306 329.588 310.999 330.548 311.479C331.508 311.959 332.548 312.199 333.668 312.199ZM355.553 315.199C355.286 315.199 355.059 315.119 354.873 314.959C354.713 314.773 354.633 314.546 354.633 314.279V291.879L347.993 296.999C347.779 297.159 347.553 297.226 347.313 297.199C347.073 297.173 346.873 297.053 346.713 296.839L345.673 295.519C345.513 295.279 345.446 295.039 345.473 294.799C345.526 294.559 345.659 294.359 345.873 294.199L354.593 287.479C354.779 287.346 354.953 287.266 355.113 287.239C355.273 287.213 355.446 287.199 355.633 287.199H357.673C357.939 287.199 358.153 287.293 358.313 287.479C358.499 287.639 358.593 287.853 358.593 288.119V314.279C358.593 314.546 358.499 314.773 358.313 314.959C358.153 315.119 357.939 315.199 357.673 315.199H355.553Z",
                fill: "#212328"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M262.439 346.199C262.333 346.199 262.242 346.167 262.167 346.103C262.103 346.029 262.071 345.938 262.071 345.831V336.423H258.999C258.893 336.423 258.802 336.391 258.727 336.327C258.663 336.253 258.631 336.162 258.631 336.055V335.383C258.631 335.266 258.663 335.175 258.727 335.111C258.802 335.037 258.893 334.999 258.999 334.999H266.711C266.829 334.999 266.919 335.037 266.983 335.111C267.058 335.175 267.095 335.266 267.095 335.383V336.055C267.095 336.162 267.058 336.253 266.983 336.327C266.919 336.391 266.829 336.423 266.711 336.423H263.655V345.831C263.655 345.938 263.618 346.029 263.543 346.103C263.479 346.167 263.389 346.199 263.271 346.199H262.439ZM270.558 346.359C269.747 346.359 269.07 346.205 268.526 345.895C267.982 345.586 267.566 345.159 267.278 344.615C266.99 344.061 266.83 343.431 266.798 342.727C266.787 342.546 266.782 342.317 266.782 342.039C266.782 341.751 266.787 341.522 266.798 341.351C266.83 340.637 266.99 340.007 267.278 339.463C267.576 338.919 267.998 338.493 268.542 338.183C269.086 337.874 269.758 337.719 270.558 337.719C271.358 337.719 272.03 337.874 272.574 338.183C273.118 338.493 273.534 338.919 273.822 339.463C274.12 340.007 274.286 340.637 274.318 341.351C274.328 341.522 274.334 341.751 274.334 342.039C274.334 342.317 274.328 342.546 274.318 342.727C274.286 343.431 274.126 344.061 273.838 344.615C273.55 345.159 273.134 345.586 272.59 345.895C272.046 346.205 271.368 346.359 270.558 346.359ZM270.558 345.127C271.219 345.127 271.747 344.919 272.142 344.503C272.536 344.077 272.75 343.458 272.782 342.647C272.792 342.487 272.798 342.285 272.798 342.039C272.798 341.794 272.792 341.591 272.782 341.431C272.75 340.621 272.536 340.007 272.142 339.591C271.747 339.165 271.219 338.951 270.558 338.951C269.896 338.951 269.363 339.165 268.958 339.591C268.563 340.007 268.355 340.621 268.334 341.431C268.323 341.591 268.318 341.794 268.318 342.039C268.318 342.285 268.323 342.487 268.334 342.647C268.355 343.458 268.563 344.077 268.958 344.503C269.363 344.919 269.896 345.127 270.558 345.127ZM276.721 349.239C276.615 349.239 276.524 349.202 276.449 349.127C276.385 349.063 276.353 348.978 276.353 348.871V338.247C276.353 338.141 276.385 338.055 276.449 337.991C276.524 337.917 276.615 337.879 276.721 337.879H277.457C277.564 337.879 277.649 337.917 277.713 337.991C277.788 338.055 277.825 338.141 277.825 338.247V338.951C278.081 338.599 278.423 338.306 278.849 338.071C279.276 337.837 279.809 337.719 280.449 337.719C281.047 337.719 281.553 337.821 281.969 338.023C282.396 338.226 282.743 338.503 283.009 338.855C283.287 339.207 283.495 339.607 283.633 340.055C283.772 340.503 283.852 340.983 283.873 341.495C283.884 341.666 283.889 341.847 283.889 342.039C283.889 342.231 283.884 342.413 283.873 342.583C283.852 343.085 283.772 343.565 283.633 344.023C283.495 344.471 283.287 344.871 283.009 345.223C282.743 345.565 282.396 345.842 281.969 346.055C281.553 346.258 281.047 346.359 280.449 346.359C279.831 346.359 279.308 346.247 278.881 346.023C278.465 345.789 278.124 345.501 277.857 345.159V348.871C277.857 348.978 277.825 349.063 277.761 349.127C277.697 349.202 277.612 349.239 277.505 349.239H276.721ZM280.113 345.063C280.668 345.063 281.1 344.946 281.409 344.711C281.729 344.466 281.959 344.151 282.097 343.767C282.236 343.373 282.316 342.951 282.337 342.503C282.348 342.194 282.348 341.885 282.337 341.575C282.316 341.127 282.236 340.711 282.097 340.327C281.959 339.933 281.729 339.618 281.409 339.383C281.1 339.138 280.668 339.015 280.113 339.015C279.591 339.015 279.164 339.138 278.833 339.383C278.513 339.629 278.273 339.943 278.113 340.327C277.964 340.701 277.879 341.085 277.857 341.479C277.847 341.65 277.841 341.853 277.841 342.087C277.841 342.322 277.847 342.53 277.857 342.711C277.868 343.085 277.953 343.453 278.113 343.815C278.284 344.178 278.535 344.477 278.865 344.711C279.196 344.946 279.612 345.063 280.113 345.063ZM292.408 346.199C292.301 346.199 292.211 346.167 292.136 346.103C292.072 346.029 292.04 345.938 292.04 345.831V336.423H288.968C288.861 336.423 288.771 336.391 288.696 336.327C288.632 336.253 288.6 336.162 288.6 336.055V335.383C288.6 335.266 288.632 335.175 288.696 335.111C288.771 335.037 288.861 334.999 288.968 334.999H296.68C296.797 334.999 296.888 335.037 296.952 335.111C297.027 335.175 297.064 335.266 297.064 335.383V336.055C297.064 336.162 297.027 336.253 296.952 336.327C296.888 336.391 296.797 336.423 296.68 336.423H293.624V345.831C293.624 345.938 293.587 346.029 293.512 346.103C293.448 346.167 293.357 346.199 293.24 346.199H292.408ZM297.721 346.199C297.614 346.199 297.524 346.167 297.449 346.103C297.385 346.029 297.353 345.938 297.353 345.831V338.263C297.353 338.157 297.385 338.066 297.449 337.991C297.524 337.917 297.614 337.879 297.721 337.879H298.457C298.564 337.879 298.654 337.917 298.729 337.991C298.804 338.066 298.841 338.157 298.841 338.263V338.967C299.054 338.605 299.348 338.333 299.721 338.151C300.094 337.97 300.548 337.879 301.081 337.879H301.705C301.812 337.879 301.897 337.917 301.961 337.991C302.036 338.055 302.073 338.141 302.073 338.247V338.903C302.073 339.01 302.036 339.095 301.961 339.159C301.897 339.223 301.812 339.255 301.705 339.255H300.745C300.169 339.255 299.716 339.426 299.385 339.767C299.054 340.098 298.889 340.551 298.889 341.127V345.831C298.889 345.938 298.852 346.029 298.777 346.103C298.702 346.167 298.612 346.199 298.505 346.199H297.721ZM306.535 346.359C305.852 346.359 305.271 346.21 304.791 345.911C304.322 345.602 303.964 345.175 303.719 344.631C303.474 344.087 303.351 343.463 303.351 342.759V338.247C303.351 338.141 303.383 338.055 303.447 337.991C303.522 337.917 303.612 337.879 303.719 337.879H304.519C304.626 337.879 304.711 337.917 304.775 337.991C304.85 338.055 304.887 338.141 304.887 338.247V342.679C304.887 344.269 305.58 345.063 306.967 345.063C307.628 345.063 308.156 344.855 308.551 344.439C308.956 344.013 309.159 343.426 309.159 342.679V338.247C309.159 338.141 309.191 338.055 309.255 337.991C309.33 337.917 309.42 337.879 309.527 337.879H310.327C310.434 337.879 310.519 337.917 310.583 337.991C310.647 338.055 310.679 338.141 310.679 338.247V345.831C310.679 345.938 310.647 346.029 310.583 346.103C310.519 346.167 310.434 346.199 310.327 346.199H309.575C309.468 346.199 309.378 346.167 309.303 346.103C309.239 346.029 309.207 345.938 309.207 345.831V345.127C308.919 345.501 308.567 345.799 308.151 346.023C307.746 346.247 307.207 346.359 306.535 346.359ZM315.936 346.359C315.339 346.359 314.827 346.285 314.4 346.135C313.973 345.986 313.627 345.805 313.36 345.591C313.093 345.378 312.891 345.165 312.752 344.951C312.624 344.738 312.555 344.567 312.544 344.439C312.533 344.322 312.571 344.231 312.656 344.167C312.741 344.103 312.827 344.071 312.912 344.071H313.632C313.685 344.071 313.728 344.082 313.76 344.103C313.803 344.114 313.856 344.157 313.92 344.231C314.059 344.381 314.213 344.53 314.384 344.679C314.555 344.829 314.763 344.951 315.008 345.047C315.264 345.143 315.579 345.191 315.952 345.191C316.496 345.191 316.944 345.09 317.296 344.887C317.648 344.674 317.824 344.365 317.824 343.959C317.824 343.693 317.749 343.479 317.6 343.319C317.461 343.159 317.205 343.015 316.832 342.887C316.469 342.759 315.968 342.626 315.328 342.487C314.688 342.338 314.181 342.157 313.808 341.943C313.435 341.719 313.168 341.458 313.008 341.159C312.848 340.85 312.768 340.503 312.768 340.119C312.768 339.725 312.885 339.346 313.12 338.983C313.355 338.61 313.696 338.306 314.144 338.071C314.603 337.837 315.173 337.719 315.856 337.719C316.411 337.719 316.885 337.789 317.28 337.927C317.675 338.066 318 338.242 318.256 338.455C318.512 338.658 318.704 338.861 318.832 339.063C318.96 339.266 319.029 339.437 319.04 339.575C319.051 339.682 319.019 339.773 318.944 339.847C318.869 339.911 318.784 339.943 318.688 339.943H318.016C317.941 339.943 317.877 339.927 317.824 339.895C317.781 339.863 317.739 339.826 317.696 339.783C317.589 339.645 317.461 339.506 317.312 339.367C317.173 339.229 316.987 339.117 316.752 339.031C316.528 338.935 316.229 338.887 315.856 338.887C315.323 338.887 314.923 338.999 314.656 339.223C314.389 339.447 314.256 339.73 314.256 340.071C314.256 340.274 314.315 340.455 314.432 340.615C314.549 340.775 314.773 340.919 315.104 341.047C315.435 341.175 315.925 341.314 316.576 341.463C317.28 341.602 317.835 341.789 318.24 342.023C318.645 342.258 318.933 342.53 319.104 342.839C319.275 343.149 319.36 343.506 319.36 343.911C319.36 344.359 319.232 344.77 318.976 345.143C318.72 345.517 318.336 345.815 317.824 346.039C317.312 346.253 316.683 346.359 315.936 346.359ZM324.445 346.199C323.847 346.199 323.362 346.087 322.989 345.863C322.615 345.629 322.343 345.303 322.173 344.887C322.002 344.461 321.917 343.959 321.917 343.383V339.159H320.669C320.562 339.159 320.471 339.127 320.397 339.063C320.333 338.989 320.301 338.898 320.301 338.791V338.247C320.301 338.141 320.333 338.055 320.397 337.991C320.471 337.917 320.562 337.879 320.669 337.879H321.917V335.207C321.917 335.101 321.949 335.015 322.013 334.951C322.087 334.877 322.178 334.839 322.285 334.839H323.037C323.143 334.839 323.229 334.877 323.293 334.951C323.367 335.015 323.405 335.101 323.405 335.207V337.879H325.389C325.506 337.879 325.597 337.917 325.661 337.991C325.725 338.055 325.757 338.141 325.757 338.247V338.791C325.757 338.898 325.725 338.989 325.661 339.063C325.597 339.127 325.506 339.159 325.389 339.159H323.405V343.271C323.405 343.773 323.49 344.167 323.661 344.455C323.831 344.743 324.135 344.887 324.573 344.887H325.549C325.655 344.887 325.741 344.925 325.805 344.999C325.879 345.063 325.917 345.149 325.917 345.255V345.831C325.917 345.938 325.879 346.029 325.805 346.103C325.741 346.167 325.655 346.199 325.549 346.199H324.445ZM335.656 346.359C334.707 346.359 333.902 346.183 333.24 345.831C332.59 345.479 332.088 344.983 331.736 344.343C331.395 343.703 331.203 342.951 331.16 342.087C331.15 341.618 331.144 341.122 331.144 340.599C331.144 340.066 331.15 339.559 331.16 339.079C331.203 338.215 331.395 337.469 331.736 336.839C332.088 336.199 332.595 335.709 333.256 335.367C333.918 335.015 334.718 334.839 335.656 334.839C336.403 334.839 337.054 334.946 337.608 335.159C338.163 335.373 338.616 335.645 338.968 335.975C339.331 336.295 339.598 336.631 339.768 336.983C339.95 337.335 340.046 337.645 340.056 337.911C340.067 338.007 340.04 338.087 339.976 338.151C339.912 338.205 339.827 338.231 339.72 338.231H338.776C338.67 338.231 338.59 338.21 338.536 338.167C338.494 338.125 338.451 338.05 338.408 337.943C338.312 337.666 338.152 337.394 337.928 337.127C337.715 336.861 337.422 336.642 337.048 336.471C336.686 336.29 336.222 336.199 335.656 336.199C334.803 336.199 334.115 336.429 333.592 336.887C333.08 337.346 332.803 338.103 332.76 339.159C332.728 340.109 332.728 341.058 332.76 342.007C332.803 343.074 333.086 343.842 333.608 344.311C334.131 344.77 334.814 344.999 335.656 344.999C336.222 344.999 336.723 344.893 337.16 344.679C337.608 344.466 337.96 344.146 338.216 343.719C338.472 343.282 338.6 342.727 338.6 342.055V341.383H336.2C336.094 341.383 336.003 341.351 335.928 341.287C335.864 341.213 335.832 341.117 335.832 340.999V340.487C335.832 340.37 335.864 340.279 335.928 340.215C336.003 340.141 336.094 340.103 336.2 340.103H339.816C339.934 340.103 340.024 340.141 340.088 340.215C340.152 340.279 340.184 340.37 340.184 340.487V342.023C340.184 342.898 340.003 343.661 339.64 344.311C339.288 344.962 338.771 345.469 338.088 345.831C337.406 346.183 336.595 346.359 335.656 346.359ZM344.579 346.359C344.046 346.359 343.56 346.253 343.123 346.039C342.686 345.826 342.334 345.538 342.067 345.175C341.8 344.813 341.667 344.402 341.667 343.943C341.667 343.207 341.966 342.621 342.563 342.183C343.16 341.746 343.939 341.458 344.899 341.319L347.283 340.983V340.519C347.283 340.007 347.134 339.607 346.835 339.319C346.547 339.031 346.072 338.887 345.411 338.887C344.942 338.887 344.558 338.983 344.259 339.175C343.96 339.367 343.752 339.613 343.635 339.911C343.571 340.071 343.459 340.151 343.299 340.151H342.579C342.462 340.151 342.371 340.119 342.307 340.055C342.254 339.981 342.227 339.895 342.227 339.799C342.227 339.639 342.286 339.442 342.403 339.207C342.531 338.973 342.723 338.743 342.979 338.519C343.235 338.295 343.56 338.109 343.955 337.959C344.36 337.799 344.851 337.719 345.427 337.719C346.067 337.719 346.606 337.805 347.043 337.975C347.48 338.135 347.822 338.354 348.067 338.631C348.323 338.909 348.504 339.223 348.611 339.575C348.728 339.927 348.787 340.285 348.787 340.647V345.831C348.787 345.938 348.75 346.029 348.675 346.103C348.611 346.167 348.526 346.199 348.419 346.199H347.683C347.566 346.199 347.475 346.167 347.411 346.103C347.347 346.029 347.315 345.938 347.315 345.831V345.143C347.176 345.335 346.99 345.527 346.755 345.719C346.52 345.901 346.227 346.055 345.875 346.183C345.523 346.301 345.091 346.359 344.579 346.359ZM344.915 345.159C345.352 345.159 345.752 345.069 346.115 344.887C346.478 344.695 346.76 344.402 346.963 344.007C347.176 343.613 347.283 343.117 347.283 342.519V342.071L345.427 342.343C344.67 342.45 344.099 342.631 343.715 342.887C343.331 343.133 343.139 343.447 343.139 343.831C343.139 344.13 343.224 344.381 343.395 344.583C343.576 344.775 343.8 344.919 344.067 345.015C344.344 345.111 344.627 345.159 344.915 345.159ZM351.471 349.239C351.365 349.239 351.274 349.202 351.199 349.127C351.135 349.063 351.103 348.978 351.103 348.871V338.247C351.103 338.141 351.135 338.055 351.199 337.991C351.274 337.917 351.365 337.879 351.471 337.879H352.207C352.314 337.879 352.399 337.917 352.463 337.991C352.538 338.055 352.575 338.141 352.575 338.247V338.951C352.831 338.599 353.173 338.306 353.599 338.071C354.026 337.837 354.559 337.719 355.199 337.719C355.797 337.719 356.303 337.821 356.719 338.023C357.146 338.226 357.493 338.503 357.759 338.855C358.037 339.207 358.245 339.607 358.383 340.055C358.522 340.503 358.602 340.983 358.623 341.495C358.634 341.666 358.639 341.847 358.639 342.039C358.639 342.231 358.634 342.413 358.623 342.583C358.602 343.085 358.522 343.565 358.383 344.023C358.245 344.471 358.037 344.871 357.759 345.223C357.493 345.565 357.146 345.842 356.719 346.055C356.303 346.258 355.797 346.359 355.199 346.359C354.581 346.359 354.058 346.247 353.631 346.023C353.215 345.789 352.874 345.501 352.607 345.159V348.871C352.607 348.978 352.575 349.063 352.511 349.127C352.447 349.202 352.362 349.239 352.255 349.239H351.471ZM354.863 345.063C355.418 345.063 355.85 344.946 356.159 344.711C356.479 344.466 356.709 344.151 356.847 343.767C356.986 343.373 357.066 342.951 357.087 342.503C357.098 342.194 357.098 341.885 357.087 341.575C357.066 341.127 356.986 340.711 356.847 340.327C356.709 339.933 356.479 339.618 356.159 339.383C355.85 339.138 355.418 339.015 354.863 339.015C354.341 339.015 353.914 339.138 353.583 339.383C353.263 339.629 353.023 339.943 352.863 340.327C352.714 340.701 352.629 341.085 352.607 341.479C352.597 341.65 352.591 341.853 352.591 342.087C352.591 342.322 352.597 342.53 352.607 342.711C352.618 343.085 352.703 343.453 352.863 343.815C353.034 344.178 353.285 344.477 353.615 344.711C353.946 344.946 354.362 345.063 354.863 345.063ZM363.498 346.359C362.901 346.359 362.389 346.285 361.962 346.135C361.536 345.986 361.189 345.805 360.922 345.591C360.656 345.378 360.453 345.165 360.314 344.951C360.186 344.738 360.117 344.567 360.106 344.439C360.096 344.322 360.133 344.231 360.218 344.167C360.304 344.103 360.389 344.071 360.474 344.071H361.194C361.248 344.071 361.29 344.082 361.322 344.103C361.365 344.114 361.418 344.157 361.482 344.231C361.621 344.381 361.776 344.53 361.946 344.679C362.117 344.829 362.325 344.951 362.57 345.047C362.826 345.143 363.141 345.191 363.514 345.191C364.058 345.191 364.506 345.09 364.858 344.887C365.21 344.674 365.386 344.365 365.386 343.959C365.386 343.693 365.312 343.479 365.162 343.319C365.024 343.159 364.768 343.015 364.394 342.887C364.032 342.759 363.53 342.626 362.89 342.487C362.25 342.338 361.744 342.157 361.37 341.943C360.997 341.719 360.73 341.458 360.57 341.159C360.41 340.85 360.33 340.503 360.33 340.119C360.33 339.725 360.448 339.346 360.682 338.983C360.917 338.61 361.258 338.306 361.706 338.071C362.165 337.837 362.736 337.719 363.418 337.719C363.973 337.719 364.448 337.789 364.842 337.927C365.237 338.066 365.562 338.242 365.818 338.455C366.074 338.658 366.266 338.861 366.394 339.063C366.522 339.266 366.592 339.437 366.602 339.575C366.613 339.682 366.581 339.773 366.506 339.847C366.432 339.911 366.346 339.943 366.25 339.943H365.578C365.504 339.943 365.44 339.927 365.386 339.895C365.344 339.863 365.301 339.826 365.258 339.783C365.152 339.645 365.024 339.506 364.874 339.367C364.736 339.229 364.549 339.117 364.314 339.031C364.09 338.935 363.792 338.887 363.418 338.887C362.885 338.887 362.485 338.999 362.218 339.223C361.952 339.447 361.818 339.73 361.818 340.071C361.818 340.274 361.877 340.455 361.994 340.615C362.112 340.775 362.336 340.919 362.666 341.047C362.997 341.175 363.488 341.314 364.138 341.463C364.842 341.602 365.397 341.789 365.802 342.023C366.208 342.258 366.496 342.53 366.666 342.839C366.837 343.149 366.922 343.506 366.922 343.911C366.922 344.359 366.794 344.77 366.538 345.143C366.282 345.517 365.898 345.815 365.386 346.039C364.874 346.253 364.245 346.359 363.498 346.359Z",
                fill: "#254B86"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M396.824 71.8433C396.735 71.8086 396.672 71.7499 396.635 71.6672C396.603 71.5745 396.602 71.4884 396.633 71.4089C396.653 71.3592 396.675 71.3165 396.7 71.2806L403.993 63.0725C404.065 62.9748 404.162 62.9035 404.282 62.8587C404.403 62.8138 404.543 62.8223 404.702 62.8839L406.612 63.6236C406.771 63.6853 406.88 63.7732 406.938 63.8874C406.997 64.0015 407.02 64.119 407.007 64.2399L406.816 75.1989C406.811 75.2425 406.798 75.2891 406.779 75.3388C406.748 75.4183 406.689 75.4813 406.602 75.5277C406.519 75.5642 406.433 75.5651 406.343 75.5304L404.791 74.9294C404.642 74.8716 404.546 74.7944 404.504 74.6979C404.462 74.6014 404.442 74.5195 404.445 74.4522L404.456 72.5344L400.248 70.9046L398.955 72.3254C398.912 72.3773 398.842 72.4246 398.745 72.4671C398.648 72.5097 398.525 72.5021 398.376 72.4443L396.824 71.8433ZM401.551 69.1958L404.639 70.3921L404.778 65.5043L401.551 69.1958Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M417.932 80.2615C417.826 80.2103 417.756 80.1348 417.722 80.0351C417.688 79.9354 417.696 79.8329 417.748 79.7275L422.321 70.3871C422.373 70.2817 422.449 70.2118 422.549 70.1774C422.649 70.143 422.752 70.1514 422.857 70.2027L426.786 72.1114C427.563 72.4889 428.176 72.935 428.625 73.4495C429.083 73.9686 429.351 74.5494 429.429 75.1918C429.52 75.8293 429.39 76.5073 429.038 77.2258C428.682 77.9538 428.223 78.4781 427.663 78.7986C427.116 79.1142 426.499 79.2472 425.81 79.1974C425.132 79.1523 424.404 78.941 423.627 78.5634L421.698 77.6266L420.108 80.8741C420.057 80.9795 419.981 81.0494 419.881 81.0839C419.781 81.1183 419.678 81.1099 419.572 81.0586L417.932 80.2615ZM422.528 75.8237L424.427 76.7466C424.917 76.9843 425.354 77.0487 425.74 76.9397C426.136 76.8354 426.451 76.5437 426.685 76.0648C426.892 75.6432 426.936 75.2378 426.818 74.8483C426.709 74.4636 426.381 74.1384 425.835 73.8727L423.935 72.9498L422.528 75.8237Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M436.372 89.4559C436.271 89.3963 436.207 89.3153 436.181 89.2132C436.155 89.1111 436.172 89.0096 436.232 88.9088L441.552 79.9727C441.612 79.8719 441.694 79.8084 441.796 79.7822C441.899 79.756 442 79.7728 442.101 79.8325L445.862 82.0541C446.606 82.4935 447.181 82.9878 447.586 83.5371C448.001 84.0917 448.221 84.6922 448.245 85.3387C448.285 85.9814 448.1 86.6465 447.691 87.3339C447.276 88.0304 446.776 88.5156 446.191 88.7894C445.62 89.0595 444.994 89.1417 444.312 89.0362C443.639 88.9361 442.931 88.6663 442.187 88.2268L440.341 87.1364L438.491 90.2434C438.431 90.3442 438.35 90.4077 438.248 90.4339C438.145 90.4601 438.043 90.4433 437.942 90.3836L436.372 89.4559ZM441.315 85.4072L443.133 86.4814C443.602 86.7581 444.033 86.8578 444.426 86.7806C444.829 86.7088 445.167 86.4438 445.44 85.9855C445.68 85.5823 445.757 85.1818 445.671 84.7841C445.594 84.3918 445.294 84.0411 444.77 83.7319L442.952 82.6577L441.315 85.4072Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M454.003 100.141C453.907 100.074 453.85 99.9884 453.832 99.8846C453.814 99.7807 453.839 99.6809 453.906 99.585L459.902 91.0873C459.97 90.9915 460.056 90.9344 460.16 90.9162C460.264 90.8981 460.364 90.9226 460.46 90.9899L461.915 92.0084C462.011 92.0757 462.069 92.1613 462.087 92.2651C462.105 92.3689 462.08 92.4688 462.012 92.5647L457.022 99.6373L461.085 102.482C461.181 102.549 461.239 102.635 461.257 102.739C461.275 102.842 461.25 102.942 461.182 103.038L460.408 104.136C460.34 104.232 460.254 104.289 460.15 104.307C460.046 104.326 459.945 104.301 459.849 104.234L454.003 100.141Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M468.807 110.815C468.715 110.742 468.663 110.653 468.65 110.549C468.638 110.444 468.669 110.346 468.742 110.254L475.212 102.111C475.285 102.019 475.374 101.967 475.479 101.955C475.584 101.943 475.682 101.973 475.774 102.046L477.194 103.165C477.286 103.238 477.339 103.326 477.351 103.431C477.363 103.536 477.333 103.634 477.26 103.726L470.79 111.868C470.717 111.96 470.628 112.012 470.523 112.025C470.418 112.037 470.319 112.007 470.227 111.934L468.807 110.815Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M480.006 120.161C479.259 119.492 478.734 118.8 478.431 118.085C478.144 117.369 478.071 116.646 478.214 115.914C478.364 115.175 478.734 114.447 479.324 113.729C479.609 113.398 479.919 113.046 480.255 112.674C480.591 112.302 480.917 111.949 481.232 111.615C481.879 110.963 482.559 110.527 483.274 110.308C484.004 110.089 484.746 110.087 485.499 110.303C486.252 110.52 486.994 110.955 487.725 111.61C488.257 112.087 488.681 112.588 488.997 113.114C489.312 113.64 489.515 114.172 489.604 114.71C489.693 115.248 489.671 115.766 489.539 116.263C489.406 116.76 489.158 117.225 488.796 117.659C488.731 117.73 488.65 117.765 488.551 117.762C488.461 117.767 488.38 117.738 488.308 117.674L486.949 116.457C486.854 116.371 486.8 116.28 486.787 116.183C486.775 116.085 486.802 115.967 486.871 115.828C487.173 115.254 487.264 114.755 487.143 114.332C487.022 113.909 486.755 113.512 486.342 113.142C485.849 112.701 485.339 112.487 484.81 112.5C484.28 112.513 483.722 112.821 483.133 113.425C482.523 114.053 481.923 114.718 481.332 115.421C480.791 116.068 480.542 116.654 480.585 117.179C480.628 117.705 480.896 118.188 481.389 118.629C481.802 118.999 482.226 119.222 482.662 119.296C483.112 119.371 483.6 119.228 484.126 118.868C484.265 118.778 484.38 118.738 484.472 118.748C484.57 118.75 484.667 118.794 484.762 118.88L486.121 120.096C486.193 120.161 486.231 120.238 486.236 120.328C486.248 120.425 486.223 120.509 486.158 120.581C485.763 120.986 485.325 121.281 484.843 121.465C484.361 121.649 483.846 121.725 483.3 121.694C482.753 121.662 482.201 121.518 481.642 121.262C481.084 121.005 480.538 120.638 480.006 120.161Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M491.929 130.757C491.863 130.688 491.831 130.608 491.834 130.517C491.844 130.42 491.881 130.342 491.943 130.283C491.982 130.247 492.021 130.218 492.059 130.197L502.181 125.931C502.289 125.874 502.406 125.851 502.535 125.862C502.663 125.874 502.786 125.942 502.903 126.066L504.309 127.555C504.426 127.679 504.486 127.805 504.49 127.933C504.494 128.061 504.464 128.177 504.4 128.28L499.507 138.083C499.484 138.12 499.452 138.157 499.413 138.193C499.351 138.252 499.271 138.283 499.172 138.288C499.082 138.285 499.003 138.249 498.937 138.179L497.795 136.969C497.685 136.853 497.632 136.742 497.635 136.637C497.638 136.531 497.656 136.449 497.688 136.39L498.523 134.664L495.425 131.384L493.645 132.109C493.584 132.137 493.5 132.15 493.394 132.146C493.289 132.143 493.181 132.083 493.071 131.967L491.929 130.757ZM497.338 130.403L499.612 132.811L501.843 128.462L497.338 130.403Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M507.512 147.756C507.438 147.665 507.406 147.567 507.417 147.462C507.427 147.357 507.478 147.268 507.57 147.194L514.234 141.797L512.393 139.541C512.326 139.458 512.297 139.365 512.308 139.26C512.319 139.155 512.366 139.069 512.449 139.002L513.568 138.096C513.659 138.022 513.757 137.99 513.863 138.001C513.968 138.012 514.054 138.059 514.122 138.141L519.423 144.637C519.497 144.727 519.529 144.825 519.518 144.93C519.507 145.035 519.456 145.124 519.365 145.198L518.246 146.104C518.163 146.172 518.069 146.2 517.964 146.189C517.858 146.178 517.769 146.127 517.694 146.036L515.863 143.793L509.198 149.19C509.107 149.263 509.009 149.295 508.904 149.284C508.799 149.273 508.709 149.222 508.635 149.131L507.512 147.756Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M517.8 160.771C517.731 160.676 517.705 160.576 517.722 160.472C517.739 160.368 517.795 160.282 517.89 160.214L526.337 154.147C526.433 154.079 526.533 154.053 526.637 154.07C526.741 154.087 526.828 154.143 526.897 154.238L527.957 155.703C528.026 155.798 528.052 155.897 528.035 156.001C528.018 156.105 527.962 156.192 527.867 156.26L519.419 162.326C519.324 162.395 519.224 162.421 519.12 162.404C519.015 162.387 518.928 162.331 518.86 162.236L517.8 160.771Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M525.999 172.789C525.48 171.968 525.168 171.176 525.063 170.41C524.958 169.645 525.071 168.926 525.403 168.252C525.743 167.573 526.32 166.959 527.134 166.411C527.517 166.158 527.898 165.912 528.278 165.674C528.666 165.431 529.062 165.189 529.466 164.948C530.296 164.465 531.092 164.217 531.854 164.205C532.631 164.197 533.348 164.402 534.004 164.821C534.666 165.249 535.251 165.865 535.758 166.667C536.26 167.461 536.559 168.243 536.655 169.014C536.756 169.793 536.635 170.53 536.292 171.224C535.957 171.913 535.389 172.521 534.587 173.049C534.201 173.316 533.814 173.572 533.425 173.816C533.045 174.054 532.656 174.286 532.256 174.511C531.407 175.006 530.602 175.259 529.84 175.271C529.087 175.278 528.387 175.068 527.739 174.643C527.092 174.218 526.512 173.6 525.999 172.789ZM527.748 171.692C528.078 172.215 528.507 172.544 529.034 172.679C529.576 172.818 530.205 172.675 530.921 172.251C531.33 172.02 531.707 171.796 532.05 171.581C532.402 171.36 532.767 171.118 533.144 170.857C533.608 170.553 533.938 170.226 534.134 169.877C534.33 169.528 534.41 169.175 534.374 168.82C534.353 168.468 534.232 168.116 534.01 167.764C533.787 167.412 533.518 167.147 533.203 166.967C532.896 166.781 532.543 166.701 532.142 166.726C531.747 166.76 531.308 166.915 530.827 167.192C530.433 167.426 530.06 167.654 529.707 167.875C529.364 168.091 528.996 168.328 528.604 168.586C527.917 169.055 527.516 169.559 527.401 170.096C527.296 170.628 527.411 171.16 527.748 171.692Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M535.342 187.646C535.288 187.542 535.277 187.44 535.309 187.339C535.341 187.239 535.409 187.162 535.513 187.108L544.76 182.348C544.865 182.295 544.967 182.284 545.068 182.316C545.169 182.348 545.246 182.416 545.3 182.52L545.971 183.813C546.044 183.955 546.065 184.076 546.033 184.176C546.001 184.277 545.971 184.346 545.943 184.385L541.978 191.23L547.811 188.228C547.915 188.174 548.018 188.163 548.118 188.196C548.219 188.228 548.294 188.291 548.343 188.386L549.095 189.834C549.149 189.939 549.16 190.041 549.128 190.141C549.096 190.242 549.028 190.319 548.924 190.373L539.677 195.133C539.582 195.181 539.479 195.192 539.369 195.165C539.268 195.133 539.191 195.065 539.137 194.961L538.459 193.654C538.385 193.512 538.364 193.391 538.396 193.29C538.443 193.194 538.473 193.125 538.487 193.082L542.274 186.346L536.626 189.253C536.522 189.307 536.419 189.317 536.318 189.285C536.218 189.253 536.14 189.185 536.086 189.081L535.342 187.646Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M546.456 210.605C546.062 209.661 545.868 208.811 545.877 208.057C545.89 207.313 546.05 206.686 546.358 206.178C546.665 205.669 547.066 205.301 547.56 205.073C547.639 205.04 547.721 205.041 547.804 205.075C547.898 205.106 547.963 205.165 548 205.254L548.661 206.834C548.714 206.962 548.726 207.072 548.695 207.166C548.675 207.255 548.637 207.345 548.583 207.437C548.445 207.576 548.327 207.751 548.231 207.964C548.139 208.187 548.095 208.454 548.098 208.764C548.11 209.071 548.199 209.421 548.363 209.815C548.63 210.455 548.933 210.889 549.272 211.118C549.615 211.357 549.963 211.403 550.318 211.256C550.574 211.15 550.744 210.975 550.828 210.733C550.915 210.5 550.945 210.17 550.917 209.743C550.893 209.326 550.827 208.782 550.72 208.11C550.569 207.307 550.508 206.593 550.536 205.969C550.579 205.351 550.741 204.828 551.024 204.399C551.321 203.975 551.766 203.641 552.357 203.396C552.948 203.151 553.538 203.097 554.127 203.233C554.726 203.366 555.277 203.675 555.78 204.159C556.293 204.639 556.72 205.288 557.061 206.105C557.337 206.764 557.491 207.381 557.523 207.957C557.559 208.542 557.505 209.061 557.359 209.515C557.217 209.977 557.021 210.365 556.769 210.677C556.518 210.989 556.242 211.213 555.941 211.35C555.862 211.382 555.776 211.383 555.682 211.353C555.598 211.318 555.538 211.257 555.501 211.168L554.81 209.515C554.769 209.416 554.751 209.32 554.758 209.225C554.764 209.129 554.807 209.037 554.885 208.947C555.116 208.782 555.264 208.513 555.328 208.14C555.405 207.773 555.348 207.358 555.154 206.895C554.953 206.413 554.704 206.066 554.407 205.854C554.115 205.652 553.786 205.626 553.421 205.778C553.185 205.876 553.012 206.028 552.902 206.236C552.806 206.449 552.764 206.749 552.776 207.137C552.801 207.53 552.857 208.038 552.944 208.66C553.129 209.6 553.211 210.391 553.191 211.035C553.171 211.678 553.017 212.21 552.73 212.629C552.452 213.044 552.018 213.374 551.427 213.619C550.767 213.893 550.122 213.941 549.493 213.763C548.868 213.595 548.291 213.239 547.764 212.696C547.25 212.159 546.814 211.462 546.456 210.605Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M438.444 499.848C500.19 459.17 540.922 389.355 540.922 310.058C540.922 184.505 438.812 82.7246 312.852 82.7246C259.643 82.7246 210.69 100.887 171.892 131.331C171.693 131.487 171.494 131.644 171.295 131.801",
                stroke: "#D057FF",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M71.2911 233.701C63.8699 257.405 59.8711 282.614 59.8711 308.754C59.8711 447.724 172.894 560.382 312.315 560.382C362.841 560.382 409.9 545.586 449.37 520.104",
                stroke: "#F25A00",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M201.188 560.654C201.343 560.725 201.449 560.827 201.505 560.959C201.552 561.086 201.556 561.217 201.517 561.352L198.849 571.416C198.85 571.439 198.846 571.461 198.837 571.48C198.828 571.5 198.821 571.514 198.816 571.524C198.78 571.601 198.72 571.656 198.635 571.687C198.545 571.728 198.457 571.728 198.37 571.688L196.844 570.984C196.592 570.868 196.499 570.702 196.564 570.485L198.328 563.845L195.377 567.118C195.312 567.182 195.226 567.242 195.117 567.298C195.009 567.354 194.877 567.346 194.723 567.274L193.807 566.852C193.652 566.78 193.561 566.686 193.534 566.567C193.506 566.449 193.501 566.347 193.518 566.26L194.094 561.909L190.172 567.536C190.048 567.726 189.856 567.76 189.594 567.64L188.069 566.936C187.982 566.896 187.925 566.828 187.898 566.734C187.867 566.649 187.869 566.568 187.905 566.491C187.91 566.481 187.917 566.466 187.926 566.447C187.935 566.428 187.949 566.411 187.967 566.396L193.947 557.86C194.025 557.743 194.133 557.663 194.27 557.621C194.398 557.574 194.539 557.587 194.694 557.658L195.871 558.201C196.026 558.272 196.129 558.367 196.18 558.485C196.217 558.607 196.23 558.719 196.219 558.819L195.682 564.034L199.313 560.247C199.383 560.173 199.481 560.113 199.609 560.066C199.722 560.025 199.861 560.042 200.026 560.118L201.188 560.654Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M177.898 549.129C178.743 549.606 179.393 550.156 179.848 550.78C180.303 551.404 180.544 552.092 180.572 552.842C180.594 553.601 180.376 554.415 179.919 555.284C179.702 555.688 179.482 556.085 179.261 556.474C179.034 556.873 178.8 557.274 178.559 557.676C178.056 558.495 177.472 559.09 176.807 559.462C176.127 559.838 175.399 559.996 174.622 559.938C173.836 559.874 173.03 559.609 172.203 559.142C171.385 558.681 170.752 558.134 170.302 557.5C169.843 556.862 169.601 556.155 169.575 555.381C169.543 554.617 169.756 553.812 170.212 552.967C170.425 552.548 170.645 552.14 170.872 551.741C171.093 551.352 171.327 550.963 171.572 550.575C172.085 549.737 172.674 549.133 173.34 548.761C174 548.399 174.715 548.251 175.487 548.319C176.258 548.387 177.062 548.657 177.898 549.129ZM176.877 550.923C176.339 550.619 175.805 550.532 175.277 550.663C174.734 550.797 174.248 551.221 173.818 551.934C173.567 552.331 173.342 552.706 173.141 553.058C172.936 553.42 172.729 553.805 172.521 554.215C172.256 554.702 172.12 555.146 172.113 555.546C172.106 555.946 172.203 556.295 172.402 556.591C172.587 556.891 172.861 557.144 173.223 557.348C173.586 557.553 173.948 557.659 174.311 557.668C174.669 557.686 175.019 557.59 175.36 557.378C175.692 557.161 176.004 556.817 176.297 556.345C176.533 555.952 176.754 555.574 176.959 555.213C177.16 554.86 177.371 554.478 177.594 554.064C177.978 553.325 178.092 552.692 177.938 552.164C177.779 551.646 177.426 551.232 176.877 550.923Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M163.858 541.211C163.955 541.276 164.014 541.36 164.035 541.464C164.055 541.567 164.032 541.668 163.967 541.765L158.158 550.392C158.093 550.489 158.008 550.548 157.904 550.568C157.8 550.589 157.7 550.566 157.602 550.501L154.077 548.146C152.968 547.405 152.267 546.565 151.974 545.625C151.675 544.694 151.847 543.751 152.491 542.795C152.926 542.149 153.444 541.713 154.046 541.487C154.649 541.261 155.283 541.217 155.949 541.354L156.308 536.783C156.317 536.712 156.336 536.654 156.366 536.61C156.414 536.539 156.485 536.491 156.58 536.464C156.669 536.447 156.753 536.465 156.833 536.518L158.31 537.505C158.47 537.611 158.562 537.731 158.589 537.864C158.609 538.006 158.613 538.124 158.601 538.218L158.177 542.342L159.787 543.418L161.852 540.352C161.917 540.254 162.002 540.196 162.106 540.175C162.209 540.155 162.31 540.177 162.408 540.242L163.858 541.211ZM158.652 545.103L156.949 543.965C156.462 543.639 156.028 543.51 155.648 543.577C155.26 543.638 154.932 543.868 154.664 544.266C154.395 544.664 154.299 545.056 154.375 545.44C154.451 545.824 154.737 546.182 155.234 546.514L156.936 547.651L158.652 545.103Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M147.664 530.219C147.756 530.291 147.809 530.379 147.822 530.484C147.835 530.588 147.805 530.687 147.732 530.779L141.314 538.962C141.242 539.055 141.153 539.107 141.048 539.12C140.943 539.133 140.844 539.103 140.751 539.031L139.413 537.99C139.32 537.918 139.268 537.829 139.255 537.725C139.242 537.62 139.272 537.522 139.344 537.429L141.596 534.559L136.684 535.481C136.611 535.505 136.516 535.513 136.401 535.504C136.271 535.497 136.138 535.441 136.004 535.337L134.476 534.148C134.4 534.089 134.36 534.01 134.356 533.912C134.345 533.822 134.365 533.744 134.418 533.677C134.464 533.618 134.52 533.581 134.587 533.565L140.814 532.288L140.608 525.397C140.6 525.337 140.623 525.273 140.676 525.206C140.728 525.139 140.803 525.096 140.899 525.076C140.989 525.065 141.072 525.089 141.148 525.148L142.727 526.377C142.878 526.495 142.965 526.617 142.988 526.743C143.012 526.869 143.026 526.954 143.031 526.999L143.294 532.394L145.763 529.246C145.835 529.154 145.924 529.101 146.029 529.088C146.134 529.076 146.233 529.105 146.325 529.177L147.664 530.219Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M133.11 518.705C133.197 518.783 133.244 518.875 133.25 518.98C133.255 519.085 133.219 519.181 133.14 519.269L126.184 527C126.105 527.087 126.013 527.133 125.908 527.139C125.802 527.145 125.706 527.109 125.618 527.03L124.293 525.848C124.206 525.77 124.159 525.678 124.153 525.573C124.148 525.467 124.184 525.371 124.262 525.284L130.052 518.849L126.352 515.546C126.265 515.468 126.218 515.376 126.212 515.271C126.207 515.166 126.243 515.07 126.322 514.982L127.221 513.983C127.299 513.896 127.391 513.85 127.497 513.844C127.602 513.838 127.699 513.874 127.786 513.952L133.11 518.705Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M118.019 504.559C118.697 505.254 119.166 505.964 119.428 506.691C119.69 507.418 119.728 508.145 119.544 508.872C119.352 509.607 118.914 510.327 118.231 511.033C117.909 511.359 117.587 511.678 117.265 511.99C116.936 512.309 116.598 512.628 116.254 512.946C115.541 513.591 114.814 513.998 114.071 514.168C113.312 514.338 112.569 514.286 111.839 514.012C111.103 513.73 110.403 513.249 109.74 512.57C109.085 511.898 108.63 511.195 108.376 510.461C108.115 509.719 108.08 508.973 108.273 508.223C108.457 507.481 108.887 506.768 109.562 506.085C109.884 505.743 110.21 505.413 110.54 505.094C110.862 504.783 111.195 504.475 111.54 504.171C112.267 503.512 113.003 503.097 113.746 502.927C114.481 502.765 115.21 502.824 115.931 503.106C116.653 503.387 117.349 503.872 118.019 504.559ZM116.536 505.994C116.104 505.551 115.616 505.318 115.072 505.295C114.513 505.272 113.927 505.542 113.314 506.106C112.962 506.417 112.64 506.713 112.349 506.995C112.05 507.284 111.743 507.596 111.429 507.93C111.038 508.324 110.782 508.711 110.664 509.094C110.545 509.476 110.539 509.837 110.648 510.177C110.741 510.518 110.933 510.837 111.224 511.134C111.514 511.432 111.832 511.636 112.178 511.747C112.517 511.865 112.879 511.87 113.266 511.762C113.646 511.648 114.043 511.405 114.456 511.034C114.793 510.723 115.111 510.423 115.41 510.134C115.701 509.852 116.012 509.544 116.342 509.21C116.917 508.608 117.205 508.033 117.206 507.483C117.198 506.941 116.975 506.445 116.536 505.994Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M107.716 494.176C107.777 494.249 107.804 494.331 107.796 494.421C107.78 494.518 107.739 494.594 107.673 494.648C107.632 494.682 107.592 494.709 107.552 494.728L97.1982 498.394C97.0875 498.444 96.9685 498.46 96.8412 498.441C96.7139 498.422 96.5954 498.347 96.4857 498.216L95.1692 496.648C95.0595 496.517 95.0066 496.387 95.0105 496.259C95.0144 496.131 95.0511 496.017 95.1207 495.918L100.579 486.418C100.605 486.383 100.639 486.348 100.68 486.314C100.745 486.259 100.827 486.232 100.926 486.234C101.016 486.242 101.092 486.283 101.154 486.356L102.224 487.631C102.326 487.753 102.373 487.867 102.364 487.972C102.354 488.077 102.332 488.158 102.297 488.215L101.362 489.889L104.262 493.345L106.081 492.726C106.144 492.701 106.228 492.694 106.334 492.703C106.439 492.713 106.543 492.779 106.646 492.901L107.716 494.176ZM102.295 494.213L100.166 491.675L97.6842 495.886L102.295 494.213Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M94.175 477.806C94.2433 477.901 94.2688 478.001 94.2514 478.105C94.2341 478.208 94.1776 478.294 94.0819 478.362L85.605 484.387C85.5093 484.455 85.4093 484.481 85.305 484.463C85.2007 484.446 85.1143 484.389 85.046 484.294L82.7072 481.029C82.0861 480.162 81.7065 479.339 81.5685 478.561C81.4218 477.788 81.505 477.062 81.8179 476.381C82.1159 475.698 82.6456 475.073 83.407 474.506C83.7834 474.225 84.115 473.983 84.4019 473.779C84.6888 473.575 85.0223 473.345 85.4024 473.087C86.2296 472.539 87.0139 472.223 87.7555 472.141C88.4971 472.059 89.2032 472.212 89.874 472.598C90.5362 472.992 91.1747 473.617 91.7897 474.476L94.175 477.806ZM91.2441 477.258L90.1539 475.737C89.8433 475.303 89.5234 474.994 89.1942 474.809C88.865 474.624 88.5148 474.566 88.1434 474.633C87.7571 474.699 87.3347 474.887 86.8764 475.2C86.6181 475.371 86.3889 475.527 86.189 475.669C85.9828 475.803 85.7828 475.945 85.589 476.095C85.3891 476.238 85.1705 476.4 84.9333 476.581C84.2936 477.062 83.9365 477.571 83.8621 478.108C83.7727 478.643 83.9641 479.24 84.4362 479.899L85.4798 481.355L91.2441 477.258Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M80.7399 458.036C81.2735 458.91 81.5931 459.721 81.6989 460.467C81.7991 461.205 81.7356 461.848 81.5084 462.397C81.2812 462.946 80.9405 463.371 80.4863 463.671C80.4133 463.715 80.3328 463.726 80.2447 463.705C80.1475 463.689 80.0739 463.64 80.0239 463.558L79.1319 462.097C79.0597 461.978 79.0315 461.871 79.0473 461.774C79.054 461.682 79.0772 461.587 79.1168 461.488C79.233 461.331 79.3225 461.139 79.3851 460.914C79.4421 460.68 79.4458 460.41 79.3961 460.103C79.3373 459.802 79.1968 459.47 78.9745 459.106C78.6132 458.514 78.2479 458.13 77.8785 457.955C77.5035 457.771 77.1517 457.778 76.8233 457.977C76.5861 458.12 76.4445 458.318 76.3985 458.571C76.347 458.814 76.3676 459.144 76.4601 459.562C76.5471 459.971 76.6945 460.499 76.9022 461.146C77.173 461.917 77.3417 462.613 77.4081 463.234C77.4599 463.851 77.3783 464.393 77.1634 464.86C76.9338 465.323 76.5453 465.721 75.9979 466.052C75.4505 466.384 74.8752 466.526 74.2721 466.48C73.6599 466.439 73.0684 466.218 72.4978 465.815C71.918 465.418 71.3975 464.842 70.9362 464.086C70.5638 463.476 70.3181 462.889 70.1989 462.325C70.0741 461.752 70.0495 461.231 70.1252 460.761C70.1953 460.282 70.3308 459.87 70.5319 459.524C70.7329 459.177 70.9721 458.914 71.2494 458.734C71.3224 458.689 71.4075 458.675 71.5047 458.691C71.5928 458.713 71.6618 458.764 71.7119 458.846L72.6455 460.376C72.7011 460.467 72.7328 460.56 72.7408 460.655C72.7488 460.75 72.721 460.848 72.6576 460.948C72.4537 461.147 72.3485 461.435 72.3418 461.813C72.3205 462.188 72.4405 462.589 72.7017 463.017C72.974 463.463 73.2728 463.768 73.5982 463.933C73.9181 464.088 74.2468 464.064 74.5843 463.859C74.8033 463.727 74.9515 463.55 75.0288 463.328C75.0914 463.103 75.0875 462.8 75.0172 462.419C74.9322 462.034 74.7997 461.54 74.6198 460.939C74.2949 460.038 74.0937 459.268 74.0162 458.629C73.9386 457.99 74.0101 457.442 74.2305 456.984C74.4419 456.532 74.8213 456.14 75.3687 455.809C75.98 455.438 76.6102 455.294 77.2593 455.374C77.9029 455.446 78.5267 455.71 79.1307 456.168C79.72 456.621 80.2564 457.244 80.7399 458.036Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M38.0308 210.995C37.9897 211.105 37.921 211.182 37.8248 211.226C37.7287 211.27 37.6256 211.271 37.5156 211.231L27.7664 207.609C27.6564 207.569 27.5795 207.5 27.5356 207.404C27.4918 207.308 27.4905 207.205 27.5316 207.096L28.1655 205.402C28.2066 205.292 28.2753 205.215 28.3715 205.172C28.4676 205.128 28.5707 205.126 28.6807 205.167L38.4299 208.788C38.5399 208.829 38.6168 208.897 38.6606 208.993C38.7045 209.089 38.7058 209.192 38.6647 209.302L38.0308 210.995Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M41.1501 202.503C41.1035 202.61 41.0311 202.684 40.9329 202.723C40.8346 202.762 40.7316 202.758 40.6237 202.712L31.066 198.612C30.9582 198.566 30.8848 198.494 30.8458 198.396C30.8068 198.298 30.8106 198.195 30.8572 198.087L32.451 194.401C32.8743 193.422 33.3846 192.672 33.9819 192.15C34.5694 191.625 35.2362 191.319 35.9824 191.233C36.7229 191.132 37.5337 191.26 38.4146 191.614C38.8501 191.79 39.2296 191.947 39.5531 192.085C39.8766 192.224 40.247 192.389 40.6643 192.579C41.5633 193 42.2398 193.505 42.6938 194.094C43.1478 194.684 43.3822 195.364 43.3969 196.137C43.4018 196.905 43.1947 197.774 42.7756 198.743L41.1501 202.503ZM40.1041 199.721L40.847 198.003C41.0587 197.513 41.1587 197.08 41.1472 196.704C41.1356 196.327 41.0047 195.999 40.7545 195.717C40.4987 195.422 40.1181 195.16 39.6126 194.931C39.3325 194.8 39.0798 194.685 38.8543 194.589C38.6331 194.482 38.4076 194.385 38.1779 194.298C37.9525 194.202 37.7004 194.099 37.4217 193.991C36.678 193.696 36.0563 193.655 35.5566 193.87C35.0513 194.071 34.6378 194.544 34.3161 195.288L33.6049 196.933L40.1041 199.721Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M49.3241 184.016C49.2705 184.121 49.1934 184.189 49.0928 184.222C48.9922 184.254 48.8896 184.244 48.785 184.191L39.516 179.474C39.4114 179.421 39.3429 179.344 39.3104 179.244C39.2779 179.144 39.2885 179.041 39.342 178.937L42.6496 172.488C42.7031 172.383 42.7802 172.315 42.8808 172.282C42.9815 172.25 43.0841 172.26 43.1886 172.313L44.3294 172.894C44.4245 172.942 44.4883 173.016 44.5207 173.117C44.5532 173.217 44.5427 173.319 44.4891 173.424L42.1235 178.036L44.3623 179.176L46.5673 174.876C46.6209 174.772 46.698 174.703 46.7986 174.671C46.8992 174.638 47.0018 174.648 47.1064 174.702L48.1616 175.239C48.2567 175.287 48.3205 175.361 48.3529 175.462C48.3854 175.562 48.3749 175.664 48.3213 175.769L46.1163 180.068L48.4264 181.244L50.8505 176.517C50.904 176.413 50.9811 176.344 51.0817 176.311C51.1824 176.279 51.285 176.289 51.3895 176.342L52.5161 176.916C52.6206 176.969 52.6892 177.046 52.7216 177.146C52.7541 177.246 52.7436 177.349 52.69 177.453L49.3241 184.016Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M57.637 167.984C57.5766 168.084 57.4951 168.148 57.3925 168.174C57.29 168.199 57.1883 168.182 57.0875 168.122L48.1516 162.802C48.0508 162.741 47.9875 162.66 47.9618 162.558C47.936 162.456 47.9533 162.354 48.0137 162.254L48.7629 161.005C48.8453 160.868 48.9377 160.787 49.0403 160.761C49.1429 160.735 49.218 160.724 49.2656 160.727L57.1966 160.478L51.5601 157.122C51.4593 157.062 51.396 156.981 51.3703 156.878C51.3446 156.776 51.3592 156.679 51.414 156.588L52.2538 155.189C52.3142 155.088 52.3957 155.025 52.4983 154.999C52.6008 154.973 52.7025 154.99 52.8034 155.05L61.7392 160.371C61.8309 160.426 61.8942 160.507 61.9291 160.614C61.9548 160.717 61.9375 160.818 61.8771 160.919L61.1196 162.181C61.0373 162.318 60.9449 162.399 60.8423 162.425C60.736 162.436 60.6609 162.448 60.617 162.459L52.8729 162.801L58.3307 166.051C58.4315 166.111 58.4948 166.192 58.5205 166.294C58.5462 166.396 58.5289 166.498 58.4685 166.598L57.637 167.984Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M69.6775 148.58C69.6106 148.676 69.5251 148.734 69.4211 148.753C69.317 148.772 69.2167 148.748 69.12 148.682L62.0552 143.82L60.3956 146.213C60.3348 146.3 60.2524 146.354 60.1483 146.373C60.0443 146.392 59.9483 146.371 59.8604 146.31L58.6742 145.494C58.5775 145.428 58.5197 145.342 58.5008 145.239C58.4818 145.135 58.5027 145.039 58.5635 144.952L63.3418 138.063C63.4087 137.966 63.4941 137.909 63.5982 137.89C63.7023 137.871 63.8026 137.894 63.8993 137.961L65.0855 138.777C65.1734 138.838 65.2268 138.92 65.2458 139.023C65.2647 139.127 65.2408 139.227 65.1739 139.324L63.5234 141.703L70.5881 146.565C70.6848 146.631 70.7426 146.717 70.7616 146.82C70.7805 146.924 70.7565 147.024 70.6897 147.12L69.6775 148.58Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M78.3844 136.343C78.3132 136.437 78.2251 136.49 78.1203 136.504C78.0155 136.519 77.9163 136.49 77.8228 136.42L69.5347 130.137C69.4412 130.066 69.3873 129.979 69.3731 129.874C69.359 129.77 69.3875 129.671 69.4587 129.578L70.5563 128.141C70.6275 128.048 70.7156 127.994 70.8204 127.98C70.9252 127.966 71.0244 127.994 71.1179 128.065L79.406 134.347C79.4996 134.418 79.5534 134.506 79.5676 134.61C79.5817 134.714 79.5532 134.813 79.482 134.907L78.3844 136.343Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M85.4294 127.274C85.354 127.364 85.2636 127.414 85.1582 127.423C85.0528 127.433 84.955 127.4 84.8649 127.325L78.2751 121.836L76.4028 124.067C76.3343 124.149 76.2473 124.194 76.1419 124.203C76.0365 124.213 75.9429 124.183 75.8609 124.115L74.7544 123.194C74.6642 123.119 74.6145 123.029 74.6051 122.924C74.5957 122.819 74.6253 122.725 74.6939 122.644L80.0843 116.222C80.1597 116.132 80.2501 116.083 80.3555 116.073C80.4609 116.064 80.5586 116.097 80.6488 116.172L81.7553 117.093C81.8373 117.161 81.8829 117.248 81.8923 117.353C81.9017 117.458 81.8686 117.555 81.7932 117.645L79.9313 119.863L86.5211 125.352C86.6112 125.427 86.661 125.517 86.6704 125.622C86.6797 125.727 86.6467 125.824 86.5713 125.914L85.4294 127.274Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M95.2678 115.841C95.1883 115.928 95.0957 115.973 94.99 115.978C94.8843 115.982 94.7882 115.945 94.7015 115.866L87.0238 108.851C86.9372 108.772 86.8916 108.679 86.887 108.574C86.8825 108.469 86.92 108.373 86.9995 108.287L88.2242 106.957C88.3037 106.87 88.3963 106.825 88.502 106.82C88.6077 106.816 88.7039 106.853 88.7905 106.932L96.4682 113.947C96.5549 114.027 96.6004 114.119 96.605 114.224C96.6095 114.329 96.5721 114.425 96.4926 114.512L95.2678 115.841Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M101.36 109.204C101.277 109.287 101.183 109.328 101.077 109.327C100.971 109.327 100.877 109.285 100.794 109.202L93.4485 101.84C93.3656 101.757 93.3243 101.662 93.3246 101.557C93.325 101.452 93.3668 101.358 93.4502 101.275L98.6014 96.1762C98.6848 96.0936 98.7794 96.0525 98.8852 96.0529C98.991 96.0532 99.0854 96.0949 99.1682 96.178L100.072 97.0841C100.148 97.1596 100.185 97.2501 100.185 97.3555C100.184 97.4609 100.143 97.5548 100.059 97.6374L96.3749 101.284L98.149 103.063L101.583 99.6633C101.667 99.5808 101.761 99.5397 101.867 99.54C101.973 99.5404 102.067 99.5821 102.15 99.6651L102.986 100.503C103.062 100.579 103.099 100.669 103.099 100.775C103.098 100.88 103.057 100.974 102.973 101.057L99.539 104.456L101.37 106.291L105.145 102.554C105.228 102.471 105.323 102.43 105.429 102.431C105.535 102.431 105.629 102.473 105.712 102.556L106.604 103.45C106.687 103.534 106.729 103.628 106.728 103.733C106.728 103.839 106.686 103.933 106.603 104.015L101.36 109.204Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M117.077 94.3492C116.306 95.0223 115.56 95.4746 114.84 95.7061C114.129 95.9305 113.482 95.9782 112.9 95.8491C112.317 95.72 111.839 95.4582 111.463 95.0637C111.407 94.9996 111.382 94.9225 111.388 94.8324C111.387 94.7342 111.422 94.6536 111.495 94.5905L112.785 93.4651C112.889 93.3739 112.991 93.3278 113.089 93.3268C113.181 93.3178 113.279 93.3243 113.383 93.3463C113.559 93.4334 113.764 93.4885 113.997 93.5115C114.239 93.5274 114.507 93.4848 114.801 93.3836C115.088 93.2744 115.393 93.0796 115.714 92.7991C116.237 92.3433 116.553 91.9192 116.662 91.5266C116.78 91.1269 116.711 90.7829 116.458 90.4945C116.275 90.2863 116.055 90.1811 115.797 90.1792C115.548 90.1702 115.225 90.2469 114.828 90.4092C114.439 90.5645 113.942 90.7994 113.338 91.114C112.623 91.5117 111.964 91.7962 111.362 91.9676C110.761 92.1239 110.211 92.1365 109.712 92.0054C109.214 91.8593 108.754 91.5459 108.331 91.0652C107.909 90.5846 107.668 90.0443 107.609 89.4444C107.544 88.8365 107.66 88.2181 107.96 87.5891C108.252 86.9521 108.731 86.3426 109.398 85.7606C109.937 85.2908 110.475 84.9492 111.011 84.7358C111.556 84.5154 112.067 84.4022 112.545 84.3961C113.03 84.383 113.462 84.4455 113.839 84.5836C114.216 84.7218 114.518 84.9115 114.744 85.1528C114.8 85.2169 114.829 85.298 114.83 85.3962C114.824 85.4863 114.785 85.5629 114.713 85.6261L113.362 86.804C113.282 86.8741 113.196 86.9212 113.103 86.9453C113.011 86.9693 112.909 86.9588 112.798 86.9138C112.567 86.7476 112.264 86.6935 111.889 86.7517C111.515 86.7948 111.139 86.9812 110.761 87.3107C110.367 87.6543 110.117 87.9998 110.011 88.3474C109.913 88.6879 109.994 89.0064 110.254 89.3028C110.423 89.495 110.624 89.6102 110.856 89.6482C111.09 89.6712 111.389 89.6156 111.754 89.4813C112.119 89.332 112.584 89.1176 113.148 88.8381C113.982 88.3653 114.708 88.0362 115.327 87.8508C115.945 87.6654 116.499 87.6418 116.99 87.7799C117.474 87.91 117.927 88.2154 118.349 88.696C118.821 89.2328 119.073 89.8266 119.106 90.4776C119.147 91.1215 118.993 91.7791 118.646 92.4501C118.3 93.1061 117.777 93.7392 117.077 94.3492Z",
                fill: "#717385"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M143.771 101.812C103.495 134.196 72.749 177.886 56.3887 228.043",
                stroke: "#0294F7",
                strokeWidth: 3,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M522.172 113.402C520.487 113.402 519.057 113.114 517.884 112.538C516.732 111.941 515.847 111.173 515.228 110.234C514.631 109.295 514.311 108.303 514.268 107.258C514.247 107.066 514.3 106.917 514.428 106.81C514.556 106.682 514.716 106.618 514.908 106.618H516.636C516.828 106.618 516.999 106.671 517.148 106.778C517.297 106.863 517.415 107.045 517.5 107.322C517.713 108.111 518.055 108.762 518.524 109.274C519.015 109.765 519.569 110.127 520.188 110.362C520.828 110.575 521.489 110.682 522.172 110.682C523.089 110.682 523.921 110.501 524.668 110.138C525.436 109.754 526.044 109.199 526.492 108.474C526.94 107.727 527.164 106.831 527.164 105.786C527.164 104.826 526.94 104.005 526.492 103.322C526.065 102.618 525.468 102.085 524.7 101.722C523.953 101.338 523.111 101.146 522.172 101.146C521.468 101.146 520.892 101.231 520.444 101.402C519.996 101.573 519.612 101.775 519.292 102.01C518.993 102.245 518.716 102.447 518.46 102.618C518.225 102.789 517.959 102.874 517.66 102.874H515.996C515.804 102.874 515.633 102.81 515.484 102.682C515.335 102.533 515.271 102.362 515.292 102.17L516.316 91.482C516.337 91.226 516.412 91.034 516.54 90.906C516.689 90.7567 516.881 90.682 517.116 90.682H528.284C528.497 90.682 528.668 90.7567 528.796 90.906C528.945 91.034 529.02 91.2047 529.02 91.418V92.666C529.02 92.9007 528.945 93.082 528.796 93.21C528.668 93.338 528.497 93.402 528.284 93.402H519.068L518.46 99.706C518.78 99.514 519.26 99.29 519.9 99.034C520.561 98.7567 521.468 98.618 522.62 98.618C523.687 98.618 524.679 98.778 525.596 99.098C526.535 99.418 527.356 99.8874 528.06 100.506C528.785 101.125 529.351 101.882 529.756 102.778C530.161 103.653 530.364 104.666 530.364 105.818C530.364 107.439 530.012 108.815 529.308 109.946C528.604 111.077 527.633 111.941 526.396 112.538C525.159 113.114 523.751 113.402 522.172 113.402ZM534.132 113.082C533.919 113.082 533.737 113.018 533.588 112.89C533.46 112.741 533.396 112.559 533.396 112.346V111.322C533.396 111.13 533.449 110.917 533.556 110.682C533.663 110.447 533.876 110.191 534.196 109.914L540.98 103.13C542.068 102.213 542.921 101.434 543.54 100.794C544.18 100.133 544.628 99.5034 544.884 98.906C545.161 98.3087 545.3 97.69 545.3 97.05C545.3 95.834 544.959 94.874 544.276 94.17C543.593 93.4447 542.58 93.082 541.236 93.082C540.383 93.082 539.647 93.2634 539.028 93.626C538.409 93.9674 537.929 94.4474 537.588 95.066C537.247 95.6634 537.012 96.346 536.884 97.114C536.841 97.3914 536.724 97.5834 536.532 97.69C536.361 97.7967 536.201 97.85 536.052 97.85H534.388C534.196 97.85 534.036 97.7967 533.908 97.69C533.78 97.562 533.716 97.4127 533.716 97.242C533.737 96.4314 533.908 95.6207 534.228 94.81C534.548 93.978 535.017 93.2314 535.636 92.57C536.276 91.8874 537.055 91.3434 537.972 90.938C538.911 90.5327 539.999 90.33 541.236 90.33C542.921 90.33 544.297 90.6394 545.364 91.258C546.452 91.8554 547.252 92.6554 547.764 93.658C548.276 94.6607 548.532 95.7594 548.532 96.954C548.532 97.8927 548.372 98.7567 548.052 99.546C547.732 100.314 547.263 101.071 546.644 101.818C546.047 102.543 545.3 103.29 544.404 104.058L538.26 110.298H548.244C548.479 110.298 548.66 110.362 548.788 110.49C548.937 110.618 549.012 110.799 549.012 111.034V112.346C549.012 112.559 548.937 112.741 548.788 112.89C548.66 113.018 548.479 113.082 548.244 113.082H534.132ZM554.097 113.082C553.649 113.082 553.425 112.869 553.425 112.442C553.425 112.314 553.468 112.197 553.553 112.09L569.361 91.29C569.511 91.098 569.649 90.9487 569.777 90.842C569.927 90.7354 570.14 90.682 570.417 90.682H571.473C571.921 90.682 572.145 90.8954 572.145 91.322C572.145 91.45 572.103 91.5674 572.017 91.674L556.241 112.474C556.092 112.666 555.943 112.815 555.793 112.922C555.665 113.029 555.452 113.082 555.153 113.082H554.097ZM568.753 113.274C567.367 113.274 566.268 112.879 565.457 112.09C564.668 111.301 564.231 110.266 564.145 108.986C564.124 108.431 564.113 107.962 564.113 107.578C564.113 107.173 564.124 106.671 564.145 106.074C564.231 104.794 564.647 103.759 565.393 102.97C566.161 102.159 567.281 101.754 568.753 101.754C570.247 101.754 571.367 102.159 572.113 102.97C572.881 103.759 573.308 104.794 573.393 106.074C573.436 106.671 573.457 107.173 573.457 107.578C573.457 107.962 573.436 108.431 573.393 108.986C573.308 110.266 572.86 111.301 572.049 112.09C571.26 112.879 570.161 113.274 568.753 113.274ZM568.753 111.162C569.329 111.162 569.777 111.045 570.097 110.81C570.417 110.575 570.652 110.287 570.801 109.946C570.951 109.583 571.036 109.221 571.057 108.858C571.1 108.282 571.121 107.823 571.121 107.482C571.121 107.141 571.1 106.714 571.057 106.202C571.036 105.626 570.855 105.093 570.513 104.602C570.172 104.111 569.585 103.866 568.753 103.866C567.943 103.866 567.367 104.111 567.025 104.602C566.705 105.093 566.524 105.626 566.481 106.202C566.46 106.714 566.449 107.141 566.449 107.482C566.449 107.823 566.46 108.282 566.481 108.858C566.524 109.221 566.609 109.583 566.737 109.946C566.887 110.287 567.121 110.575 567.441 110.81C567.783 111.045 568.22 111.162 568.753 111.162ZM556.785 101.914C555.377 101.914 554.279 101.541 553.489 100.794C552.7 100.047 552.263 99.034 552.177 97.754C552.156 97.1994 552.145 96.73 552.145 96.346C552.145 95.9407 552.156 95.4394 552.177 94.842C552.241 93.562 552.657 92.5274 553.425 91.738C554.193 90.9274 555.313 90.522 556.785 90.522C558.279 90.522 559.399 90.9274 560.145 91.738C560.913 92.5274 561.329 93.562 561.393 94.842C561.436 95.4394 561.457 95.9407 561.457 96.346C561.457 96.73 561.436 97.1994 561.393 97.754C561.329 99.034 560.892 100.047 560.081 100.794C559.292 101.541 558.193 101.914 556.785 101.914ZM556.785 99.93C557.34 99.93 557.777 99.8127 558.097 99.578C558.439 99.3434 558.684 99.0554 558.833 98.714C558.983 98.3514 559.068 97.9887 559.089 97.626C559.132 97.05 559.153 96.602 559.153 96.282C559.153 95.9407 559.132 95.5034 559.089 94.97C559.068 94.394 558.876 93.8607 558.513 93.37C558.172 92.8794 557.596 92.634 556.785 92.634C555.975 92.634 555.399 92.8794 555.057 93.37C554.737 93.8607 554.556 94.394 554.513 94.97C554.492 95.5034 554.481 95.9407 554.481 96.282C554.481 96.602 554.492 97.05 554.513 97.626C554.556 97.9887 554.641 98.3514 554.769 98.714C554.919 99.0554 555.153 99.3434 555.473 99.578C555.793 99.8127 556.231 99.93 556.785 99.93Z",
                fill: "#D057FF"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M31.0959 121.035C29.8586 121.035 28.7173 120.886 27.6719 120.587C26.6479 120.267 25.7626 119.808 25.0159 119.211C24.2906 118.614 23.7253 117.91 23.3199 117.099C22.9146 116.267 22.7119 115.328 22.7119 114.283C22.7119 112.982 23.0213 111.862 23.6399 110.923C24.2799 109.984 25.1226 109.27 26.1679 108.779C25.3359 108.288 24.6853 107.648 24.2159 106.859C23.7466 106.07 23.5119 105.131 23.5119 104.043C23.5119 102.763 23.8213 101.686 24.4399 100.811C25.0799 99.9148 25.9653 99.2215 27.0959 98.7308C28.2479 98.2402 29.5813 97.9948 31.0959 97.9948C32.5893 97.9948 33.9013 98.2402 35.0319 98.7308C36.1839 99.2002 37.0693 99.8828 37.6879 100.779C38.3279 101.675 38.6479 102.752 38.6479 104.011C38.6479 105.099 38.4133 106.048 37.9439 106.859C37.4746 107.648 36.8346 108.288 36.0239 108.779C37.0693 109.27 37.9013 109.984 38.5199 110.923C39.1599 111.862 39.4799 112.982 39.4799 114.283C39.4799 115.67 39.1279 116.875 38.4239 117.899C37.7199 118.902 36.7386 119.68 35.4799 120.235C34.2213 120.768 32.7599 121.035 31.0959 121.035ZM31.0959 118.475C32.0773 118.475 32.9626 118.304 33.7519 117.963C34.5413 117.622 35.1706 117.142 35.6399 116.523C36.1093 115.883 36.3439 115.136 36.3439 114.283C36.3439 113.408 36.1093 112.672 35.6399 112.075C35.1706 111.456 34.5413 110.987 33.7519 110.667C32.9626 110.326 32.0773 110.155 31.0959 110.155C30.1146 110.155 29.2186 110.326 28.4079 110.667C27.6186 110.987 26.9893 111.456 26.5199 112.075C26.0506 112.672 25.8159 113.408 25.8159 114.283C25.8159 115.136 26.0506 115.883 26.5199 116.523C26.9893 117.142 27.6186 117.622 28.4079 117.963C29.2186 118.304 30.1146 118.475 31.0959 118.475ZM31.0959 107.627C31.9066 107.627 32.6533 107.478 33.3359 107.179C34.0399 106.88 34.5946 106.475 34.9999 105.963C35.4266 105.451 35.6399 104.832 35.6399 104.107C35.6399 103.382 35.4373 102.752 35.0319 102.219C34.6479 101.686 34.1039 101.28 33.3999 101.003C32.7173 100.704 31.9493 100.555 31.0959 100.555C30.2426 100.555 29.4639 100.704 28.7599 101.003C28.0773 101.28 27.5333 101.686 27.1279 102.219C26.7226 102.752 26.5199 103.382 26.5199 104.107C26.5199 104.854 26.7226 105.494 27.1279 106.027C27.5333 106.539 28.0773 106.934 28.7599 107.211C29.4639 107.488 30.2426 107.627 31.0959 107.627ZM44.7517 120.715C44.3037 120.715 44.0797 120.502 44.0797 120.075C44.0797 119.947 44.1223 119.83 44.2077 119.723L60.0157 98.9228C60.165 98.7308 60.3037 98.5815 60.4317 98.4748C60.581 98.3682 60.7943 98.3148 61.0717 98.3148H62.1277C62.5757 98.3148 62.7997 98.5282 62.7997 98.9548C62.7997 99.0828 62.757 99.2002 62.6717 99.3068L46.8957 120.107C46.7463 120.299 46.597 120.448 46.4477 120.555C46.3197 120.662 46.1063 120.715 45.8077 120.715H44.7517ZM59.4077 120.907C58.021 120.907 56.9223 120.512 56.1117 119.723C55.3223 118.934 54.885 117.899 54.7997 116.619C54.7783 116.064 54.7677 115.595 54.7677 115.211C54.7677 114.806 54.7783 114.304 54.7997 113.707C54.885 112.427 55.301 111.392 56.0477 110.603C56.8157 109.792 57.9357 109.387 59.4077 109.387C60.901 109.387 62.021 109.792 62.7677 110.603C63.5357 111.392 63.9623 112.427 64.0477 113.707C64.0903 114.304 64.1117 114.806 64.1117 115.211C64.1117 115.595 64.0903 116.064 64.0477 116.619C63.9623 117.899 63.5143 118.934 62.7037 119.723C61.9143 120.512 60.8157 120.907 59.4077 120.907ZM59.4077 118.795C59.9837 118.795 60.4317 118.678 60.7517 118.443C61.0717 118.208 61.3063 117.92 61.4557 117.579C61.605 117.216 61.6903 116.854 61.7117 116.491C61.7543 115.915 61.7757 115.456 61.7757 115.115C61.7757 114.774 61.7543 114.347 61.7117 113.835C61.6903 113.259 61.509 112.726 61.1677 112.235C60.8263 111.744 60.2397 111.499 59.4077 111.499C58.597 111.499 58.021 111.744 57.6797 112.235C57.3597 112.726 57.1783 113.259 57.1357 113.835C57.1143 114.347 57.1037 114.774 57.1037 115.115C57.1037 115.456 57.1143 115.915 57.1357 116.491C57.1783 116.854 57.2637 117.216 57.3917 117.579C57.541 117.92 57.7757 118.208 58.0957 118.443C58.437 118.678 58.8743 118.795 59.4077 118.795ZM47.4397 109.547C46.0317 109.547 44.933 109.174 44.1437 108.427C43.3543 107.68 42.917 106.667 42.8317 105.387C42.8103 104.832 42.7997 104.363 42.7997 103.979C42.7997 103.574 42.8103 103.072 42.8317 102.475C42.8957 101.195 43.3117 100.16 44.0797 99.3708C44.8477 98.5602 45.9677 98.1548 47.4397 98.1548C48.933 98.1548 50.053 98.5602 50.7997 99.3708C51.5677 100.16 51.9837 101.195 52.0477 102.475C52.0903 103.072 52.1117 103.574 52.1117 103.979C52.1117 104.363 52.0903 104.832 52.0477 105.387C51.9837 106.667 51.5463 107.68 50.7357 108.427C49.9463 109.174 48.8477 109.547 47.4397 109.547ZM47.4397 107.563C47.9943 107.563 48.4317 107.446 48.7517 107.211C49.093 106.976 49.3383 106.688 49.4877 106.347C49.637 105.984 49.7223 105.622 49.7437 105.259C49.7863 104.683 49.8077 104.235 49.8077 103.915C49.8077 103.574 49.7863 103.136 49.7437 102.603C49.7223 102.027 49.5303 101.494 49.1677 101.003C48.8263 100.512 48.2503 100.267 47.4397 100.267C46.629 100.267 46.053 100.512 45.7117 101.003C45.3917 101.494 45.2103 102.027 45.1677 102.603C45.1463 103.136 45.1357 103.574 45.1357 103.915C45.1357 104.235 45.1463 104.683 45.1677 105.259C45.2103 105.622 45.2957 105.984 45.4237 106.347C45.573 106.688 45.8077 106.976 46.1277 107.211C46.4477 107.446 46.885 107.563 47.4397 107.563Z",
                fill: "#0294F7"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                d: "M65.5547 557.643C65.3413 557.643 65.16 557.579 65.0107 557.451C64.8827 557.301 64.8187 557.12 64.8187 556.907V552.299H54.4507C54.2373 552.299 54.056 552.235 53.9067 552.107C53.7787 551.957 53.7147 551.776 53.7147 551.563V550.283C53.7147 550.197 53.736 550.069 53.7787 549.899C53.8427 549.707 53.9387 549.515 54.0667 549.323L63.6667 535.787C63.9227 535.424 64.3173 535.243 64.8507 535.243H67.1547C67.368 535.243 67.5387 535.317 67.6667 535.467C67.816 535.595 67.8907 535.765 67.8907 535.979V549.515H70.7707C71.0053 549.515 71.1867 549.589 71.3147 549.739C71.464 549.867 71.5387 550.037 71.5387 550.251V551.563C71.5387 551.776 71.464 551.957 71.3147 552.107C71.1867 552.235 71.016 552.299 70.8027 552.299H67.8907V556.907C67.8907 557.12 67.816 557.301 67.6667 557.451C67.5387 557.579 67.368 557.643 67.1547 557.643H65.5547ZM57.1387 549.579H64.8507V538.603L57.1387 549.579ZM82.7417 557.963C81.2697 557.963 80.0217 557.739 78.9977 557.291C77.995 556.821 77.1737 556.181 76.5337 555.371C75.8937 554.56 75.4243 553.632 75.1257 552.587C74.8483 551.541 74.6883 550.432 74.6457 549.259C74.6243 548.683 74.603 548.075 74.5817 547.435C74.5817 546.795 74.5817 546.144 74.5817 545.483C74.603 544.821 74.6243 544.192 74.6457 543.595C74.667 542.421 74.827 541.312 75.1257 540.267C75.4457 539.221 75.9257 538.304 76.5657 537.515C77.2057 536.704 78.027 536.075 79.0297 535.627C80.0537 535.157 81.291 534.923 82.7417 534.923C84.2137 534.923 85.451 535.157 86.4537 535.627C87.4777 536.075 88.3097 536.704 88.9497 537.515C89.5897 538.304 90.059 539.221 90.3577 540.267C90.6777 541.312 90.8483 542.421 90.8697 543.595C90.891 544.192 90.9017 544.821 90.9017 545.483C90.923 546.144 90.923 546.795 90.9017 547.435C90.9017 548.075 90.891 548.683 90.8697 549.259C90.8483 550.432 90.6777 551.541 90.3577 552.587C90.059 553.632 89.5897 554.56 88.9497 555.371C88.331 556.181 87.5097 556.821 86.4857 557.291C85.483 557.739 84.235 557.963 82.7417 557.963ZM82.7417 555.211C84.4057 555.211 85.6323 554.667 86.4217 553.579C87.2323 552.491 87.6483 550.997 87.6697 549.099C87.7123 548.48 87.7337 547.883 87.7337 547.307C87.7337 546.709 87.7337 546.123 87.7337 545.547C87.7337 544.949 87.7123 544.363 87.6697 543.787C87.6483 541.931 87.2323 540.448 86.4217 539.339C85.6323 538.208 84.4057 537.643 82.7417 537.643C81.099 537.643 79.8723 538.208 79.0617 539.339C78.2723 540.448 77.8563 541.931 77.8137 543.787C77.8137 544.363 77.803 544.949 77.7817 545.547C77.7817 546.123 77.7817 546.709 77.7817 547.307C77.803 547.883 77.8137 548.48 77.8137 549.099C77.8563 550.997 78.283 552.491 79.0937 553.579C79.9043 554.667 81.1203 555.211 82.7417 555.211ZM96.3982 557.643C95.9502 557.643 95.7262 557.429 95.7262 557.003C95.7262 556.875 95.7688 556.757 95.8542 556.651L111.662 535.851C111.811 535.659 111.95 535.509 112.078 535.403C112.227 535.296 112.441 535.243 112.718 535.243H113.774C114.222 535.243 114.446 535.456 114.446 535.883C114.446 536.011 114.403 536.128 114.318 536.235L98.5422 557.035C98.3928 557.227 98.2435 557.376 98.0942 557.483C97.9662 557.589 97.7528 557.643 97.4542 557.643H96.3982ZM111.054 557.835C109.667 557.835 108.569 557.44 107.758 556.651C106.969 555.861 106.531 554.827 106.446 553.547C106.425 552.992 106.414 552.523 106.414 552.139C106.414 551.733 106.425 551.232 106.446 550.635C106.531 549.355 106.947 548.32 107.694 547.531C108.462 546.72 109.582 546.315 111.054 546.315C112.547 546.315 113.667 546.72 114.414 547.531C115.182 548.32 115.609 549.355 115.694 550.635C115.737 551.232 115.758 551.733 115.758 552.139C115.758 552.523 115.737 552.992 115.694 553.547C115.609 554.827 115.161 555.861 114.35 556.651C113.561 557.44 112.462 557.835 111.054 557.835ZM111.054 555.723C111.63 555.723 112.078 555.605 112.398 555.371C112.718 555.136 112.953 554.848 113.102 554.507C113.251 554.144 113.337 553.781 113.358 553.419C113.401 552.843 113.422 552.384 113.422 552.043C113.422 551.701 113.401 551.275 113.358 550.763C113.337 550.187 113.155 549.653 112.814 549.163C112.473 548.672 111.886 548.427 111.054 548.427C110.243 548.427 109.667 548.672 109.326 549.163C109.006 549.653 108.825 550.187 108.782 550.763C108.761 551.275 108.75 551.701 108.75 552.043C108.75 552.384 108.761 552.843 108.782 553.419C108.825 553.781 108.91 554.144 109.038 554.507C109.187 554.848 109.422 555.136 109.742 555.371C110.083 555.605 110.521 555.723 111.054 555.723ZM99.0862 546.475C97.6782 546.475 96.5795 546.101 95.7902 545.355C95.0008 544.608 94.5635 543.595 94.4782 542.315C94.4568 541.76 94.4462 541.291 94.4462 540.907C94.4462 540.501 94.4568 540 94.4782 539.403C94.5422 538.123 94.9582 537.088 95.7262 536.299C96.4942 535.488 97.6142 535.083 99.0862 535.083C100.579 535.083 101.699 535.488 102.446 536.299C103.214 537.088 103.63 538.123 103.694 539.403C103.737 540 103.758 540.501 103.758 540.907C103.758 541.291 103.737 541.76 103.694 542.315C103.63 543.595 103.193 544.608 102.382 545.355C101.593 546.101 100.494 546.475 99.0862 546.475ZM99.0862 544.491C99.6408 544.491 100.078 544.373 100.398 544.139C100.739 543.904 100.985 543.616 101.134 543.275C101.283 542.912 101.369 542.549 101.39 542.187C101.433 541.611 101.454 541.163 101.454 540.843C101.454 540.501 101.433 540.064 101.39 539.531C101.369 538.955 101.177 538.421 100.814 537.931C100.473 537.44 99.8968 537.195 99.0862 537.195C98.2755 537.195 97.6995 537.44 97.3582 537.931C97.0382 538.421 96.8568 538.955 96.8142 539.531C96.7928 540.064 96.7822 540.501 96.7822 540.843C96.7822 541.163 96.7928 541.611 96.8142 542.187C96.8568 542.549 96.9422 542.912 97.0702 543.275C97.2195 543.616 97.4542 543.904 97.7742 544.139C98.0942 544.373 98.5315 544.491 99.0862 544.491Z",
                fill: "#F25A00"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_11830_83706",
                        x1: 379.83,
                        y1: 44.2394,
                        x2: 269.178,
                        y2: 293.709,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_11830_83706",
                        x1: 401.177,
                        y1: 41.2929,
                        x2: 269.404,
                        y2: 290.109,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_11830_83706",
                        x1: 414.864,
                        y1: 61.2292,
                        x2: 273.36,
                        y2: 288.566,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint3_linear_11830_83706",
                        x1: 430.642,
                        y1: 71.9646,
                        x2: 275.571,
                        y2: 286.237,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint4_linear_11830_83706",
                        x1: 454.567,
                        y1: 68.1249,
                        x2: 275.727,
                        y2: 282.113,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint5_linear_11830_83706",
                        x1: 463.32,
                        y1: 90.5972,
                        x2: 279.835,
                        y2: 281.331,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint6_linear_11830_83706",
                        x1: 473.205,
                        y1: 108.339,
                        x2: 283.107,
                        y2: 280.16,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint7_linear_11830_83706",
                        x1: 480.46,
                        y1: 127.415,
                        x2: 286.533,
                        y2: 279.514,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint8_linear_11830_83706",
                        x1: 506.454,
                        y1: 126.576,
                        x2: 287.149,
                        y2: 275.079,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint9_linear_11830_83706",
                        x1: 524.466,
                        y1: 135.918,
                        x2: 289.226,
                        y2: 272.27,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint10_linear_11830_83706",
                        x1: 530.602,
                        y1: 155.249,
                        x2: 292.62,
                        y2: 271.775,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint11_linear_11830_83706",
                        x1: 527.896,
                        y1: 178.963,
                        x2: 296.571,
                        y2: 272.799,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint12_linear_11830_83706",
                        x1: 540.96,
                        y1: 192.094,
                        x2: 299.243,
                        y2: 270.947,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint13_linear_11830_83706",
                        x1: 558.903,
                        y1: 203.689,
                        x2: 301.703,
                        y2: 268.072,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint14_linear_11830_83706",
                        x1: 573.916,
                        y1: 218.154,
                        x2: 304.595,
                        y2: 265.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint15_linear_11830_83706",
                        x1: 571.851,
                        y1: 238.921,
                        x2: 308.146,
                        y2: 266.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint16_linear_11830_83706",
                        x1: 585.528,
                        y1: 255.156,
                        x2: 311.264,
                        y2: 264.763,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint17_linear_11830_83706",
                        x1: 592.393,
                        y1: 273.819,
                        x2: 314.664,
                        y2: 264.075,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint18_linear_11830_83706",
                        x1: 581.588,
                        y1: 294.146,
                        x2: 317.867,
                        y2: 266.322,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint19_linear_11830_83706",
                        x1: 536.768,
                        y1: 312.9,
                        x2: 319.671,
                        y2: 274.464,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint20_linear_11830_83706",
                        x1: 532.697,
                        y1: 328.169,
                        x2: 322.3,
                        y2: 275.501,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint21_linear_11830_83706",
                        x1: 570.53,
                        y1: 348.609,
                        x2: 327.241,
                        y2: 269.261,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint22_linear_11830_83706",
                        x1: 563.767,
                        y1: 365.995,
                        x2: 330.052,
                        y2: 271.179,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint23_linear_11830_83706",
                        x1: 572.085,
                        y1: 386.68,
                        x2: 334.087,
                        y2: 270.148,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint24_linear_11830_83706",
                        x1: 574.78,
                        y1: 407.552,
                        x2: 338,
                        y2: 270.309,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint25_linear_11830_83706",
                        x1: 550.922,
                        y1: 418.293,
                        x2: 339.071,
                        y2: 274.835,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint26_linear_11830_83706",
                        x1: 555.728,
                        y1: 441.436,
                        x2: 343.365,
                        y2: 274.874,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint27_linear_11830_83706",
                        x1: 549.949,
                        y1: 460.285,
                        x2: 346.468,
                        y2: 276.335,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint28_linear_11830_83706",
                        x1: 523.919,
                        y1: 465.601,
                        x2: 346.395,
                        y2: 281.054,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint29_linear_11830_83706",
                        x1: 510.192,
                        y1: 477.503,
                        x2: 348.168,
                        y2: 283.636,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint30_linear_11830_83706",
                        x1: 510.802,
                        y1: 502.927,
                        x2: 352.581,
                        y2: 284.292,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint31_linear_11830_83706",
                        x1: 500.876,
                        y1: 520.808,
                        x2: 355.237,
                        y2: 286.841,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint32_linear_11830_83706",
                        x1: 454.602,
                        y1: 492.901,
                        x2: 349.111,
                        y2: 293.728,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint33_linear_11830_83706",
                        x1: 467.22,
                        y1: 539.834,
                        x2: 357.972,
                        y2: 293.485,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint34_linear_11830_83706",
                        x1: 439.23,
                        y1: 529.721,
                        x2: 355.18,
                        y2: 297.912,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint35_linear_11830_83706",
                        x1: 428.079,
                        y1: 547.134,
                        x2: 357.649,
                        y2: 300.512,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint36_linear_11830_83706",
                        x1: 421.244,
                        y1: 578.348,
                        x2: 362.822,
                        y2: 302.379,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint37_linear_11830_83706",
                        x1: 405.667,
                        y1: 594.764,
                        x2: 365.233,
                        y2: 305.881,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint38_linear_11830_83706",
                        x1: 372.699,
                        y1: 549.799,
                        x2: 355.982,
                        y2: 309.82,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint39_linear_11830_83706",
                        x1: 357.696,
                        y1: 564.433,
                        x2: 357.693,
                        y2: 313.167,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint40_linear_11830_83706",
                        x1: 342.032,
                        y1: 588.494,
                        x2: 360.96,
                        y2: 316.662,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint41_linear_11830_83706",
                        x1: 322.302,
                        y1: 564.306,
                        x2: 356.646,
                        y2: 318.976,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint42_linear_11830_83706",
                        x1: 304.215,
                        y1: 574.996,
                        x2: 357.572,
                        y2: 322.992,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint43_linear_11830_83706",
                        x1: 283.878,
                        y1: 594.688,
                        x2: 360.288,
                        y2: 327.113,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint44_linear_11830_83706",
                        x1: 269.882,
                        y1: 558.687,
                        x2: 353.552,
                        y2: 327.932,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint45_linear_11830_83706",
                        x1: 245.749,
                        y1: 581.811,
                        x2: 356.236,
                        y2: 332.695,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint46_linear_11830_83706",
                        x1: 243.129,
                        y1: 527.603,
                        x2: 346.972,
                        y2: 331.53,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint47_linear_11830_83706",
                        x1: 223.918,
                        y1: 534.032,
                        x2: 348.057,
                        y2: 334.586,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint48_linear_11830_83706",
                        x1: 210.481,
                        y1: 524.062,
                        x2: 345.712,
                        y2: 337.205,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint49_linear_11830_83706",
                        x1: 200.046,
                        y1: 509.05,
                        x2: 342.854,
                        y2: 338.2,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint50_linear_11830_83706",
                        x1: 175.063,
                        y1: 517.88,
                        x2: 343.909,
                        y2: 342.339,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint51_linear_11830_83706",
                        x1: 136.71,
                        y1: 538.053,
                        x2: 345.703,
                        y2: 349.119,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint52_linear_11830_83706",
                        x1: 142.772,
                        y1: 502.024,
                        x2: 340.157,
                        y2: 347.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint53_linear_11830_83706",
                        x1: 129.601,
                        y1: 489.886,
                        x2: 337.361,
                        y2: 349.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint54_linear_11830_83706",
                        x1: 106.857,
                        y1: 485.602,
                        x2: 336.084,
                        y2: 352.752,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint55_linear_11830_83706",
                        x1: 106.483,
                        y1: 462.544,
                        x2: 331.926,
                        y2: 352.141,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint56_linear_11830_83706",
                        x1: 75.8862,
                        y1: 461.301,
                        x2: 331.469,
                        y2: 357.645,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint57_linear_11830_83706",
                        x1: 75.3904,
                        y1: 439.829,
                        x2: 327.416,
                        y2: 357.615,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint58_linear_11830_83706",
                        x1: 67.3672,
                        y1: 422.779,
                        x2: 324.567,
                        y2: 358.396,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint59_linear_11830_83706",
                        x1: 73.5318,
                        y1: 400.494,
                        x2: 320.877,
                        y2: 356.712,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint60_linear_11830_83706",
                        x1: 54.1446,
                        y1: 387.766,
                        x2: 317.85,
                        y2: 359.943,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint61_linear_11830_83706",
                        x1: 36.2253,
                        y1: 372.169,
                        x2: 314.566,
                        y2: 362.418,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint62_linear_11830_83706",
                        x1: 74.7233,
                        y1: 346.792,
                        x2: 311.164,
                        y2: 355.071,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint63_linear_11830_83706",
                        x1: 44.2659,
                        y1: 332.174,
                        x2: 307.971,
                        y2: 360.002,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint64_linear_11830_83706",
                        x1: 59.643,
                        y1: 313.219,
                        x2: 305.217,
                        y2: 356.7,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint65_linear_11830_83706",
                        x1: 40.4599,
                        y1: 294.398,
                        x2: 301.384,
                        y2: 359.717,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint66_linear_11830_83706",
                        x1: 46.1408,
                        y1: 276.296,
                        x2: 298.152,
                        y2: 358.504,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint67_linear_11830_83706",
                        x1: 75.9004,
                        y1: 263.422,
                        x2: 296.789,
                        y2: 353.016,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint68_linear_11830_83706",
                        x1: 69.5341,
                        y1: 244.14,
                        x2: 293.404,
                        y2: 353.773,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint69_linear_11830_83706",
                        x1: 59.9002,
                        y1: 222.125,
                        x2: 289.117,
                        y2: 354.98,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint70_linear_11830_83706",
                        x1: 55.7117,
                        y1: 199.72,
                        x2: 284.89,
                        y2: 354.906,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint71_linear_11830_83706",
                        x1: 74.7752,
                        y1: 187.839,
                        x2: 283.116,
                        y2: 351.256,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint72_linear_11830_83706",
                        x1: 66.3368,
                        y1: 160.339,
                        x2: 278.126,
                        y2: 351.794,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint73_linear_11830_83706",
                        x1: 72.7634,
                        y1: 139.873,
                        x2: 274.694,
                        y2: 349.802,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint74_linear_11830_83706",
                        x1: 106.532,
                        y1: 140.995,
                        x2: 276.199,
                        y2: 343.997,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint75_linear_11830_83706",
                        x1: 127.467,
                        y1: 134.999,
                        x2: 275.853,
                        y2: 340.048,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint76_linear_11830_83706",
                        x1: 147.89,
                        y1: 130.991,
                        x2: 275.623,
                        y2: 336.215,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint77_linear_11830_83706",
                        x1: 164.643,
                        y1: 124.3,
                        x2: 275.343,
                        y2: 333.305,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint78_linear_11830_83706",
                        x1: 170.883,
                        y1: 104.363,
                        x2: 271.744,
                        y2: 331.788,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint79_linear_11830_83706",
                        x1: 203.51,
                        y1: 125.022,
                        x2: 276.608,
                        y2: 326.649,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint80_linear_11830_83706",
                        x1: 219.277,
                        y1: 122.66,
                        x2: 276.689,
                        y2: 323.703,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint81_linear_11830_83706",
                        x1: 228.313,
                        y1: 104.943,
                        x2: 274.175,
                        y2: 321.587,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint82_linear_11830_83706",
                        x1: 237.519,
                        y1: 83.0641,
                        x2: 270.601,
                        y2: 319.396,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint83_linear_11830_83706",
                        x1: 247.656,
                        y1: 52.9833,
                        x2: 266.015,
                        y2: 316.506,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint84_linear_11830_83706",
                        x1: 268.612,
                        y1: 64.4836,
                        x2: 268.61,
                        y2: 313.148,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint85_linear_11830_83706",
                        x1: 285.45,
                        y1: 56.1569,
                        x2: 267.776,
                        y2: 309.899,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint86_linear_11830_83706",
                        x1: 304.198,
                        y1: 68.545,
                        x2: 270.769,
                        y2: 307.345,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint87_linear_11830_83706",
                        x1: 320.847,
                        y1: 75.5669,
                        x2: 272.353,
                        y2: 304.674,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint88_linear_11830_83706",
                        x1: 340.608,
                        y1: 46.4339,
                        x2: 268.041,
                        y2: 300.492,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint89_linear_11830_83706",
                        x1: 357.846,
                        y1: 57.6494,
                        x2: 270.732,
                        y2: 297.905,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#39425F"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#292F44"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.23,
                                stopColor: "#171B26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.36,
                                stopColor: "#0A0C11"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#020304"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.61
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint90_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(314.244 312.991) scale(272.966 271.898)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#FC3DA6"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.96,
                                stopColor: "#FC3DA6",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint91_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(162.134 233.607) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#0294F7",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint92_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(220.89 378.572) scale(170.16 169.494)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#F25A00"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#F25A00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint93_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(362.811 379.417) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#D057FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint94_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(449.148 310.114) scale(139.706 139.159)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#FC3DA6"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#FC3DA6",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("radialGradient", {
                        id: "paint95_radial_11830_83706",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(365.721 205.5) scale(134.426 133.9)",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#D057FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint96_linear_11830_83706",
                        x1: 312.986,
                        y1: 204.642,
                        x2: 419.473,
                        y2: 184.139,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint97_linear_11830_83706",
                        x1: 380.678,
                        y1: 230.061,
                        x2: 448.972,
                        y2: 204.498,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint98_linear_11830_83706",
                        x1: 412.475,
                        y1: 279.325,
                        x2: 481.563,
                        y2: 293.401,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint99_linear_11830_83706",
                        x1: 397.489,
                        y1: 245.561,
                        x2: 485.737,
                        y2: 254.506,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint100_linear_11830_83706",
                        x1: 399.172,
                        y1: 371.669,
                        x2: 391.483,
                        y2: 437.215,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint101_linear_11830_83706",
                        x1: 415.984,
                        y1: 338.152,
                        x2: 445.839,
                        y2: 400.172,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint102_linear_11830_83706",
                        x1: 418.086,
                        y1: 299.188,
                        x2: 474.979,
                        y2: 350.85,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint103_linear_11830_83706",
                        x1: 232.494,
                        y1: 212.188,
                        x2: 234.375,
                        y2: 163.889,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint104_linear_11830_83706",
                        x1: 266.034,
                        y1: 216.716,
                        x2: 275.964,
                        y2: 140.865,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint105_linear_11830_83706",
                        x1: 291.864,
                        y1: 207.073,
                        x2: 313.656,
                        y2: 125.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#D057FF"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#DD80FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint106_linear_11830_83706",
                        x1: 349.773,
                        y1: 409.552,
                        x2: 297.707,
                        y2: 506.111,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint107_linear_11830_83706",
                        x1: 237.187,
                        y1: 383.984,
                        x2: 139.186,
                        y2: 392.105,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint108_linear_11830_83706",
                        x1: 270.96,
                        y1: 406.329,
                        x2: 176.354,
                        y2: 449.757,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint109_linear_11830_83706",
                        x1: 207.854,
                        y1: 317.001,
                        x2: 136.76,
                        y2: 266.63,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint110_linear_11830_83706",
                        x1: 209.334,
                        y1: 328.122,
                        x2: 126.311,
                        y2: 328.122,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint111_linear_11830_83706",
                        x1: 216.782,
                        y1: 356.036,
                        x2: 131.99,
                        y2: 341.675,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint112_linear_11830_83706",
                        x1: 209.767,
                        y1: 283.315,
                        x2: 126.91,
                        y2: 247.563,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#FF6F26"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#FFA97F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint113_linear_11830_83706",
                        x1: 185.334,
                        y1: 269.025,
                        x2: 142.09,
                        y2: 240.081,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint114_linear_11830_83706",
                        x1: 216.971,
                        y1: 233.355,
                        x2: 177.292,
                        y2: 148.248,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint115_linear_11830_83706",
                        x1: 178.456,
                        y1: 247.753,
                        x2: 158.627,
                        y2: 186.015,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#0294F7"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: 0.92,
                                stopColor: "#66ACFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $90a43c2d6b04cfac$export$2e2bcd8739ae039 = $90a43c2d6b04cfac$var$LightTheme;



function $d91b157793f73623$var$LowTrustDetection({ setIsAnimate: setIsAnimate }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const [isOpen, setIsOpen] = (0, $cURGa$useState)(false);
    const leftNavPinned = localStorage.getItem("gen2.layout.isMenuPinned") || false;
    const { handleSeeMoreClick: handleSeeMoreClick, handleCloseClick: handleCloseClick } = (0, $42764b6024b73500$export$2e2bcd8739ae039)(setIsAnimate, setIsOpen);
    const videoUrl = theme ? "/ECMv6/assets/videos/RiskDetection_Dark-Optimized.mp4" : "/ECMv6/assets/videos/RiskDetection_White-Optimized.mp4";
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: (0, $cURGa$classnames)("Ispm-LowTrustDetection", leftNavPinned === "true" && "leftNavPinned"),
        children: [
            isOpen && /*#__PURE__*/ (0, $cURGa$jsxs)("video", {
                width: "100%",
                height: "100%",
                // controls
                autoPlay: true,
                muted: true,
                playsInline: true,
                onError: (e)=>(0, $cURGa$Logger).error("Video loading error:", e),
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("source", {
                        src: videoUrl,
                        type: "video/mp4"
                    }),
                    "Your browser does not support HTML video."
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                type: "button",
                size: "medium",
                className: "Ispm-LowTrustDetection-close",
                dataTestId: "ispm-dashboard-lowTrustClose",
                onClick: handleCloseClick,
                children: l(`Close`)
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-LowTrustDetection-comingSoon",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body1",
                            lineLimit: 1,
                            color: "--color-foreground-info-medium",
                            children: l("COMING SOON")
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-LowTrustDetection-trustContent",
                        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                            className: "Ispm-LowTrustDetection-trustContent",
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "h1",
                                    className: "Ispm-LowTrustDetection-heading",
                                    lineLimit: 1,
                                    color: "--color-foreground-neutral-bold",
                                    children: l("Risk Detection")
                                }),
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    color: "--color-foreground-neutral-medium",
                                    lineLimit: 3,
                                    tooltipConfig: {
                                        text: l("Users will soon visualize low-trust items across identities, workloads, and apps, with insights into contributing factors."),
                                        placement: "left-start"
                                    },
                                    className: "Ispm-LowTrustDetection-userContent",
                                    children: l("Users will soon visualize low-trust items across identities, workloads, and apps, with insights into contributing factors.")
                                })
                            ]
                        })
                    }),
                    !isOpen && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        size: "medium",
                        className: "Ispm-LowTrustDetection-seeMore",
                        dataTestId: "ispm-dashboard-lowTrustSeeMore",
                        onClick: handleSeeMoreClick,
                        children: l(`See More`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-LowTrustDetection-content",
                children: theme ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $2fc442ead903fb00$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $90a43c2d6b04cfac$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $d91b157793f73623$export$2e2bcd8739ae039 = $d91b157793f73623$var$LowTrustDetection;











function $4c772b0940250d83$var$SecurityPostureDarkSvg() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: "361",
        height: "331",
        viewBox: "0 0 361 331",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                clipPath: "url(#clip0_11334_36775)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                        width: "360",
                        height: "331",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M264.805 512.811L209.159 305.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M347.048 417.811L291.402 210.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M76.2926 505.811L20.6465 298.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M17.9964 290.684C1.89526 299.366 -17.4554 317.496 -25.8631 325.747C-28.4089 328.246 -28.8794 332.128 -27.0959 335.217L42.5347 455.821C44.7438 459.647 49.6366 460.958 53.4629 458.749L540.923 177.314C544.749 175.105 546.06 170.212 543.851 166.386L456.059 14.3267C456.059 14.3267 428.013 65.1332 406.782 94.3666C386.357 122.49 374.505 138.106 349.955 161.332C317.933 191.626 291.456 196.299 258.523 225.367C229.171 251.274 231.131 301.327 189.431 299.591C165.864 298.61 151.83 278.276 127.608 272.389C81.073 261.078 55.069 270.695 17.9964 290.684Z",
                                fill: "url(#paint1_linear_11334_36775)",
                                fillOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M-30.1079 330C-30.1079 330 -3.23163 302.13 17.9964 290.684C55.069 270.695 81.073 261.078 127.608 272.389C151.83 278.276 165.864 298.61 189.431 299.591C231.131 301.327 229.171 251.274 258.523 225.367C291.456 196.299 317.933 191.626 349.955 161.332C374.505 138.106 386.357 122.49 406.782 94.3666C428.013 65.1332 456.059 14.3267 456.059 14.3267",
                                stroke: "url(#paint2_linear_11334_36775)",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "18.0266",
                                cy: "288.896",
                                r: "5",
                                transform: "rotate(-30 18.0266 288.896)",
                                fill: "#01AE66",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "206.649",
                                cy: "295.529",
                                r: "5",
                                transform: "rotate(-30 206.649 295.529)",
                                fill: "#E19701",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "288.422",
                                cy: "202.131",
                                r: "5",
                                transform: "rotate(-30 288.422 202.131)",
                                fill: "#E19701",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M302.095 214.358C308.614 214.267 315.035 215.954 320.666 219.239C326.298 222.523 330.928 227.28 334.059 232.999C337.19 238.717 338.703 245.181 338.436 251.695C338.168 258.209 336.131 264.527 332.542 269.97C332.066 270.692 331.322 271.195 330.475 271.369C329.628 271.543 328.746 271.373 328.024 270.897L327.752 270.717C326.249 269.726 325.834 267.703 326.825 266.2C329.729 261.796 331.377 256.684 331.593 251.414C331.81 246.144 330.586 240.914 328.052 236.287C325.519 231.66 321.773 227.811 317.217 225.154C312.66 222.497 307.465 221.131 302.191 221.205C296.917 221.279 291.762 222.789 287.281 225.572C282.801 228.356 279.164 232.308 276.761 237.003C274.358 241.699 273.28 246.961 273.643 252.223C274.007 257.486 275.797 262.549 278.823 266.87C279.319 267.579 279.513 268.455 279.363 269.307C279.213 270.159 278.731 270.916 278.022 271.412L277.755 271.599C276.28 272.632 274.246 272.273 273.214 270.798C269.474 265.458 267.261 259.199 266.812 252.695C266.363 246.191 267.695 239.688 270.665 233.884C273.635 228.08 278.13 223.196 283.668 219.755C289.206 216.315 295.576 214.449 302.095 214.358Z",
                                fill: "#373840"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M294.833 215.205C300.591 213.928 306.576 214.091 312.257 215.68C317.938 217.269 323.139 220.234 327.4 224.313C331.661 228.392 334.851 233.459 336.686 239.065C338.521 244.671 338.945 250.644 337.921 256.453C337.608 258.226 335.917 259.411 334.143 259.098L333.822 259.041C332.97 258.891 332.213 258.409 331.717 257.7C331.221 256.992 331.027 256.115 331.177 255.264C332.006 250.563 331.663 245.731 330.178 241.196C328.693 236.66 326.113 232.56 322.665 229.26C319.217 225.959 315.009 223.56 310.413 222.275C305.817 220.989 300.974 220.857 296.315 221.89C291.655 222.923 287.322 225.089 283.7 228.197C280.078 231.304 277.277 235.257 275.548 239.705C273.818 244.154 273.212 248.96 273.783 253.698C274.354 258.436 276.085 262.961 278.823 266.87C279.856 268.345 279.497 270.379 278.022 271.412L277.755 271.599C277.047 272.095 276.17 272.289 275.318 272.139C274.467 271.989 273.71 271.506 273.214 270.798C269.83 265.966 267.691 260.374 266.984 254.518C266.278 248.661 267.027 242.721 269.165 237.224C271.303 231.726 274.764 226.84 279.241 223C283.718 219.159 289.074 216.481 294.833 215.205Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M307.253 257.399C307.096 257.399 306.966 257.347 306.861 257.242C306.757 257.12 306.705 256.981 306.705 256.825C306.705 256.738 306.713 256.668 306.731 256.616C306.766 256.564 306.792 256.52 306.809 256.486L310.644 251.19C310.296 251.277 309.931 251.312 309.548 251.294C308.679 251.277 307.861 251.112 307.096 250.799C306.348 250.468 305.687 250.033 305.113 249.494C304.557 248.938 304.113 248.303 303.783 247.59C303.47 246.86 303.313 246.068 303.313 245.216C303.313 244.433 303.461 243.668 303.757 242.92C304.053 242.155 304.487 241.468 305.061 240.86C305.653 240.251 306.383 239.773 307.253 239.425C308.14 239.06 309.174 238.877 310.357 238.877C311.522 238.877 312.548 239.042 313.435 239.373C314.322 239.703 315.061 240.164 315.653 240.755C316.261 241.329 316.713 241.99 317.009 242.738C317.322 243.486 317.479 244.277 317.479 245.112C317.479 245.86 317.357 246.555 317.113 247.199C316.87 247.842 316.566 248.433 316.2 248.973C315.853 249.494 315.505 250.007 315.157 250.512L310.566 256.877C310.496 256.964 310.392 257.077 310.253 257.216C310.131 257.338 309.94 257.399 309.679 257.399H307.253ZM310.383 248.529C311.009 248.529 311.574 248.399 312.079 248.138C312.6 247.86 313.009 247.477 313.305 246.99C313.618 246.486 313.774 245.894 313.774 245.216C313.774 244.52 313.618 243.929 313.305 243.442C313.009 242.938 312.6 242.555 312.079 242.294C311.557 242.016 310.992 241.877 310.383 241.877C309.757 241.877 309.183 242.016 308.661 242.294C308.157 242.555 307.748 242.938 307.435 243.442C307.14 243.929 306.992 244.52 306.992 245.216C306.992 245.894 307.14 246.486 307.435 246.99C307.748 247.477 308.157 247.86 308.661 248.138C309.183 248.399 309.757 248.529 310.383 248.529Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M293.89 257.66C292.742 257.66 291.716 257.52 290.812 257.242C289.907 256.964 289.142 256.573 288.516 256.068C287.907 255.564 287.438 254.973 287.107 254.294C286.794 253.616 286.638 252.86 286.638 252.025C286.638 251.016 286.881 250.147 287.368 249.416C287.872 248.668 288.525 248.094 289.325 247.694C288.681 247.294 288.177 246.781 287.812 246.155C287.464 245.529 287.29 244.799 287.29 243.964C287.29 242.955 287.542 242.077 288.046 241.329C288.568 240.564 289.316 239.964 290.29 239.529C291.281 239.094 292.481 238.877 293.89 238.877C295.299 238.877 296.49 239.094 297.464 239.529C298.438 239.947 299.177 240.538 299.681 241.303C300.186 242.051 300.438 242.929 300.438 243.938C300.438 244.773 300.264 245.503 299.916 246.129C299.568 246.755 299.081 247.277 298.455 247.694C299.272 248.077 299.925 248.651 300.412 249.416C300.899 250.164 301.142 251.042 301.142 252.051C301.142 253.147 300.855 254.12 300.281 254.973C299.725 255.807 298.899 256.468 297.803 256.955C296.725 257.425 295.42 257.66 293.89 257.66ZM293.89 254.947C294.568 254.947 295.177 254.833 295.716 254.607C296.272 254.364 296.707 254.025 297.02 253.59C297.351 253.155 297.516 252.642 297.516 252.051C297.516 251.442 297.351 250.929 297.02 250.512C296.707 250.077 296.272 249.747 295.716 249.52C295.177 249.277 294.568 249.155 293.89 249.155C293.212 249.155 292.594 249.277 292.038 249.52C291.499 249.747 291.064 250.077 290.733 250.512C290.42 250.929 290.264 251.442 290.264 252.051C290.264 252.642 290.42 253.155 290.733 253.59C291.064 254.025 291.499 254.364 292.038 254.607C292.594 254.833 293.212 254.947 293.89 254.947ZM293.89 246.573C294.464 246.555 294.986 246.442 295.455 246.233C295.942 246.025 296.325 245.747 296.603 245.399C296.899 245.033 297.046 244.599 297.046 244.094C297.046 243.59 296.907 243.155 296.629 242.79C296.368 242.407 295.994 242.112 295.507 241.903C295.038 241.694 294.499 241.59 293.89 241.59C293.281 241.59 292.733 241.694 292.246 241.903C291.777 242.112 291.403 242.407 291.125 242.79C290.864 243.155 290.733 243.59 290.733 244.094C290.733 244.599 290.864 245.033 291.125 245.399C291.403 245.764 291.777 246.051 292.246 246.26C292.733 246.468 293.281 246.573 293.89 246.573Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M274.371 294.572C274.371 286.204 281.155 279.42 289.523 279.42H315.669C324.037 279.42 330.821 286.204 330.821 294.572C330.821 302.94 324.037 309.724 315.669 309.724H289.523C281.155 309.724 274.371 302.94 274.371 294.572Z",
                                fill: "#131D2D"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M274.371 294.572C274.371 286.204 281.155 279.42 289.523 279.42H315.669C324.037 279.42 330.821 286.204 330.821 294.572C330.821 302.94 324.037 309.724 315.669 309.724H289.523C281.155 309.724 274.371 302.94 274.371 294.572Z",
                                stroke: "#2A973C"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M311.375 298.462C311.27 298.462 311.182 298.43 311.109 298.368C311.046 298.295 311.015 298.206 311.015 298.102V287.709C311.015 287.604 311.046 287.521 311.109 287.458C311.182 287.385 311.27 287.349 311.375 287.349H312.157C312.272 287.349 312.361 287.385 312.423 287.458C312.486 287.521 312.517 287.604 312.517 287.709V291.356C312.799 291.001 313.143 290.714 313.55 290.495C313.957 290.276 314.474 290.166 315.1 290.166C315.778 290.166 316.352 290.317 316.822 290.62C317.302 290.912 317.662 291.324 317.902 291.856C318.152 292.378 318.277 292.989 318.277 293.688V298.102C318.277 298.206 318.246 298.295 318.183 298.368C318.121 298.43 318.032 298.462 317.917 298.462H317.135C317.03 298.462 316.942 298.43 316.869 298.368C316.806 298.295 316.775 298.206 316.775 298.102V293.766C316.775 293.036 316.597 292.467 316.242 292.06C315.888 291.643 315.366 291.434 314.677 291.434C314.03 291.434 313.509 291.643 313.112 292.06C312.716 292.467 312.517 293.036 312.517 293.766V298.102C312.517 298.206 312.486 298.295 312.423 298.368C312.361 298.43 312.272 298.462 312.157 298.462H311.375Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M304.994 301.905C304.284 301.905 303.7 301.811 303.241 301.623C302.792 301.436 302.437 301.206 302.176 300.935C301.926 300.674 301.743 300.408 301.629 300.136C301.524 299.876 301.467 299.667 301.456 299.51C301.446 299.406 301.477 299.317 301.55 299.244C301.634 299.171 301.722 299.135 301.816 299.135H302.568C302.662 299.135 302.74 299.156 302.802 299.197C302.865 299.239 302.917 299.328 302.959 299.463C303.022 299.62 303.115 299.792 303.241 299.98C303.366 300.178 303.559 300.345 303.82 300.481C304.081 300.627 304.446 300.7 304.915 300.7C305.406 300.7 305.818 300.632 306.152 300.496C306.486 300.371 306.736 300.142 306.903 299.808C307.081 299.484 307.169 299.036 307.169 298.462V297.397C306.919 297.721 306.59 297.992 306.183 298.211C305.776 298.42 305.265 298.524 304.649 298.524C304.065 298.524 303.564 298.425 303.147 298.227C302.729 298.018 302.385 297.742 302.114 297.397C301.853 297.043 301.655 296.641 301.519 296.192C301.394 295.743 301.321 295.274 301.3 294.783C301.289 294.491 301.289 294.204 301.3 293.923C301.321 293.432 301.394 292.963 301.519 292.514C301.655 292.065 301.853 291.663 302.114 291.309C302.385 290.954 302.729 290.677 303.147 290.479C303.564 290.27 304.065 290.166 304.649 290.166C305.275 290.166 305.792 290.286 306.199 290.526C306.616 290.756 306.955 291.037 307.216 291.371V290.698C307.216 290.594 307.248 290.505 307.31 290.432C307.383 290.359 307.472 290.323 307.576 290.323H308.296C308.401 290.323 308.489 290.359 308.562 290.432C308.635 290.505 308.672 290.594 308.672 290.698V298.289C308.672 298.989 308.552 299.609 308.312 300.152C308.082 300.695 307.696 301.123 307.154 301.436C306.622 301.749 305.902 301.905 304.994 301.905ZM304.962 297.272C305.484 297.272 305.902 297.152 306.215 296.912C306.538 296.672 306.773 296.369 306.919 296.004C307.075 295.639 307.159 295.269 307.169 294.893C307.18 294.747 307.185 294.569 307.185 294.361C307.185 294.142 307.18 293.959 307.169 293.813C307.159 293.437 307.075 293.067 306.919 292.702C306.773 292.336 306.538 292.034 306.215 291.794C305.902 291.554 305.484 291.434 304.962 291.434C304.441 291.434 304.023 291.554 303.71 291.794C303.397 292.023 303.173 292.331 303.037 292.717C302.902 293.093 302.823 293.5 302.802 293.938C302.792 294.209 302.792 294.486 302.802 294.768C302.823 295.206 302.902 295.618 303.037 296.004C303.173 296.38 303.397 296.688 303.71 296.928C304.023 297.157 304.441 297.272 304.962 297.272Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M298.229 298.462C298.125 298.462 298.036 298.431 297.963 298.368C297.901 298.295 297.869 298.206 297.869 298.102V290.683C297.869 290.578 297.901 290.495 297.963 290.432C298.036 290.359 298.125 290.323 298.229 290.323H298.981C299.085 290.323 299.168 290.359 299.231 290.432C299.294 290.495 299.325 290.578 299.325 290.683V298.102C299.325 298.206 299.294 298.295 299.231 298.368C299.168 298.431 299.085 298.462 298.981 298.462H298.229ZM298.104 288.804C298 288.804 297.911 288.773 297.838 288.711C297.775 288.638 297.744 288.549 297.744 288.444V287.599C297.744 287.495 297.775 287.411 297.838 287.349C297.911 287.276 298 287.239 298.104 287.239H299.09C299.195 287.239 299.278 287.276 299.341 287.349C299.414 287.411 299.45 287.495 299.45 287.599V288.444C299.45 288.549 299.414 288.638 299.341 288.711C299.278 288.773 299.195 288.804 299.09 288.804H298.104Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M287.274 298.461C287.159 298.461 287.071 298.43 287.008 298.367C286.945 298.294 286.914 298.206 286.914 298.101V287.881C286.914 287.766 286.945 287.677 287.008 287.614C287.071 287.541 287.159 287.505 287.274 287.505H288.072C288.187 287.505 288.276 287.541 288.338 287.614C288.411 287.677 288.448 287.766 288.448 287.881V292.201H293.832V287.881C293.832 287.766 293.864 287.677 293.926 287.614C293.999 287.541 294.088 287.505 294.192 287.505H294.991C295.105 287.505 295.194 287.541 295.257 287.614C295.33 287.677 295.366 287.766 295.366 287.881V298.101C295.366 298.206 295.33 298.294 295.257 298.367C295.194 298.43 295.105 298.461 294.991 298.461H294.192C294.088 298.461 293.999 298.43 293.926 298.367C293.864 298.294 293.832 298.206 293.832 298.101V293.609H288.448V298.101C288.448 298.206 288.411 298.294 288.338 298.367C288.276 298.43 288.187 298.461 288.072 298.461H287.274Z",
                                fill: "#8ACD8A"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_11334_36775",
                        x1: "0",
                        y1: "0",
                        x2: "404.139",
                        y2: "67.765",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.32",
                                stopColor: "#332196",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#332196",
                                stopOpacity: "0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_11334_36775",
                        x1: "171.968",
                        y1: "178.347",
                        x2: "256.26",
                        y2: "324.344",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#01AE66",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_11334_36775",
                        x1: "182.213",
                        y1: "118.881",
                        x2: "288.787",
                        y2: "303.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#E19701"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF4451"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("clipPath", {
                        id: "clip0_11334_36775",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                            x: "0.205078",
                            width: "360",
                            height: "331",
                            rx: "8",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
var $4c772b0940250d83$export$2e2bcd8739ae039 = $4c772b0940250d83$var$SecurityPostureDarkSvg;




function $035d20266e4aab5d$var$SecurityPostureDarkTheme() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: "843",
        height: "331",
        viewBox: "0 0 843 331",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                clipPath: "url(#clip0_10626_42003)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                        width: "843",
                        height: "331",
                        rx: "8",
                        transform: "matrix(1 0 0 -1 0 331)",
                        fill: "url(#paint0_linear_10626_42003)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M672.6 512.811L616.954 305.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M754.843 417.811L699.197 210.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M484.088 505.811L428.441 298.137",
                                stroke: "#576883",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M425.791 290.684C409.69 299.365 390.34 317.496 381.932 325.747C379.386 328.245 378.916 332.128 380.699 335.217L450.33 455.821C452.539 459.647 457.431 460.958 461.258 458.749L948.718 177.314C952.544 175.105 953.855 170.212 951.646 166.386L863.854 14.3262C863.854 14.3262 835.808 65.1327 814.576 94.3661C794.152 122.489 782.3 138.105 757.75 161.331C725.728 191.626 699.251 196.298 666.318 225.366C636.966 251.274 638.926 301.327 597.226 299.59C573.659 298.609 559.625 278.276 535.403 272.388C488.868 261.078 462.864 270.695 425.791 290.684Z",
                                fill: "url(#paint1_linear_10626_42003)",
                                fillOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M377.687 330C377.687 330 404.563 302.129 425.791 290.684C462.864 270.695 488.868 261.078 535.403 272.388C559.625 278.276 573.659 298.609 597.226 299.59C638.926 301.327 636.966 251.274 666.318 225.366C699.251 196.298 725.728 191.626 757.75 161.331C782.3 138.105 794.152 122.489 814.576 94.3661C835.808 65.1327 863.854 14.3262 863.854 14.3262",
                                stroke: "url(#paint2_linear_10626_42003)",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "425.822",
                                cy: "288.895",
                                r: "5",
                                transform: "rotate(-30 425.822 288.895)",
                                fill: "#01AE66",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "614.444",
                                cy: "295.528",
                                r: "5",
                                transform: "rotate(-30 614.444 295.528)",
                                fill: "#E19701",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "696.217",
                                cy: "202.131",
                                r: "5",
                                transform: "rotate(-30 696.217 202.131)",
                                fill: "#E19701",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "377.137",
                                cy: "329.704",
                                r: "5",
                                transform: "rotate(-30 377.137 329.704)",
                                fill: "#01AE66",
                                stroke: "#131D2D",
                                strokeWidth: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M530.869 108.175C537.142 106.4 543.78 106.368 550.07 108.083C556.36 109.798 562.064 113.195 566.568 117.908C571.072 122.621 574.206 128.473 575.634 134.835C577.062 141.196 576.729 147.826 574.671 154.012C574.398 154.833 573.81 155.511 573.037 155.898C572.264 156.286 571.368 156.35 570.548 156.077L570.238 155.974C568.529 155.405 567.605 153.559 568.173 151.85C569.838 146.845 570.108 141.481 568.952 136.334C567.797 131.187 565.261 126.453 561.617 122.639C557.973 118.826 553.358 116.077 548.269 114.69C543.18 113.303 537.809 113.328 532.733 114.765C527.658 116.201 523.069 118.993 519.462 122.842C515.854 126.69 513.364 131.449 512.258 136.606C511.153 141.764 511.473 147.125 513.186 152.114C514.899 157.103 517.94 161.531 521.98 164.922C522.643 165.478 523.057 166.274 523.133 167.135C523.208 167.997 522.938 168.853 522.382 169.516L522.173 169.766C521.015 171.145 518.958 171.325 517.579 170.167C512.584 165.977 508.827 160.504 506.71 154.338C504.593 148.172 504.196 141.545 505.563 135.171C506.929 128.796 510.007 122.915 514.466 118.158C518.925 113.402 524.595 109.951 530.869 108.175Z",
                                fill: "#373840"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M524.072 110.873C529.305 108.149 535.128 106.758 541.026 106.822C546.925 106.887 552.716 108.405 557.888 111.242C563.06 114.079 567.452 118.148 570.675 123.088C573.899 128.028 575.854 133.687 576.368 139.564C576.525 141.358 575.198 142.939 573.404 143.096L573.079 143.125C572.218 143.2 571.361 142.93 570.699 142.374C570.036 141.818 569.622 141.022 569.546 140.16C569.131 135.406 567.548 130.827 564.94 126.83C562.332 122.833 558.779 119.541 554.594 117.246C550.41 114.95 545.724 113.722 540.952 113.67C536.179 113.618 531.468 114.743 527.234 116.947C523.001 119.151 519.376 122.365 516.682 126.304C513.987 130.243 512.306 134.786 511.786 139.53C511.266 144.275 511.925 149.074 513.703 153.503C515.481 157.932 518.324 161.854 521.98 164.922C523.36 166.079 523.54 168.136 522.382 169.516L522.173 169.766C521.617 170.428 520.82 170.843 519.959 170.918C519.097 170.993 518.241 170.723 517.579 170.167C513.06 166.376 509.546 161.528 507.348 156.054C505.15 150.58 504.337 144.649 504.979 138.785C505.621 132.921 507.699 127.306 511.03 122.438C514.36 117.569 518.84 113.597 524.072 110.873Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M546.989 148.414C546.838 148.455 546.699 148.438 546.571 148.364C546.439 148.274 546.352 148.153 546.312 148.002C546.289 147.918 546.28 147.848 546.283 147.793C546.303 147.734 546.317 147.685 546.325 147.647L548.658 141.539C548.345 141.713 548.001 141.841 547.627 141.924C546.782 142.132 545.95 142.184 545.13 142.079C544.322 141.954 543.571 141.705 542.877 141.333C542.196 140.939 541.603 140.441 541.099 139.838C540.608 139.213 540.252 138.489 540.031 137.666C539.829 136.91 539.773 136.133 539.866 135.334C539.953 134.518 540.195 133.742 540.592 133.006C541.006 132.265 541.587 131.614 542.337 131.053C543.1 130.47 544.052 130.026 545.194 129.72C546.32 129.418 547.354 129.312 548.296 129.402C549.238 129.492 550.071 129.746 550.795 130.164C551.532 130.56 552.14 131.082 552.619 131.728C553.115 132.369 553.471 133.093 553.687 133.899C553.88 134.621 553.943 135.325 553.874 136.009C553.806 136.694 553.665 137.344 553.451 137.959C553.25 138.553 553.047 139.139 552.842 139.716L550.054 147.053C550.01 147.155 549.938 147.291 549.84 147.461C549.754 147.61 549.585 147.719 549.333 147.786L546.989 148.414ZM547.717 139.037C548.322 138.874 548.834 138.602 549.254 138.22C549.686 137.816 549.982 137.341 550.141 136.794C550.313 136.225 550.311 135.614 550.136 134.959C549.956 134.287 549.651 133.756 549.223 133.367C548.807 132.956 548.313 132.692 547.742 132.575C547.166 132.442 546.584 132.453 545.996 132.611C545.391 132.773 544.873 133.056 544.441 133.46C544.021 133.842 543.725 134.318 543.553 134.886C543.394 135.433 543.404 136.042 543.584 136.714C543.76 137.369 544.056 137.902 544.472 138.313C544.9 138.702 545.394 138.966 545.953 139.104C546.525 139.221 547.113 139.199 547.717 139.037Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.15 152.124C533.041 152.422 532.014 152.553 531.068 152.518C530.123 152.483 529.282 152.303 528.547 151.978C527.828 151.649 527.222 151.199 526.727 150.629C526.249 150.055 525.902 149.365 525.686 148.559C525.425 147.584 525.435 146.681 525.716 145.85C526.01 144.997 526.491 144.274 527.161 143.68C526.436 143.461 525.816 143.096 525.301 142.585C524.803 142.071 524.446 141.41 524.23 140.604C523.969 139.629 523.985 138.716 524.279 137.863C524.584 136.989 525.152 136.216 525.98 135.544C526.825 134.867 527.928 134.346 529.288 133.982C530.649 133.617 531.856 133.519 532.909 133.687C533.958 133.838 534.825 134.218 535.51 134.826C536.191 135.418 536.662 136.201 536.923 137.176C537.139 137.982 537.16 138.733 536.986 139.427C536.812 140.122 536.477 140.752 535.98 141.317C536.869 141.475 537.647 141.861 538.316 142.474C538.979 143.07 539.442 143.856 539.703 144.83C539.987 145.888 539.961 146.903 539.628 147.875C539.306 148.825 538.679 149.677 537.747 150.431C536.827 151.164 535.628 151.728 534.15 152.124ZM533.447 149.504C534.103 149.328 534.661 149.062 535.123 148.704C535.598 148.324 535.93 147.884 536.12 147.383C536.327 146.878 536.353 146.34 536.2 145.768C536.043 145.18 535.751 144.728 535.323 144.41C534.908 144.071 534.403 143.864 533.807 143.79C533.223 143.694 532.604 143.734 531.948 143.91C531.293 144.085 530.728 144.363 530.254 144.742C529.792 145.1 529.457 145.532 529.251 146.037C529.056 146.521 529.038 147.057 529.195 147.645C529.348 148.217 529.632 148.672 530.047 149.011C530.479 149.345 530.987 149.56 531.571 149.656C532.167 149.73 532.792 149.679 533.447 149.504ZM531.28 141.415C531.83 141.25 532.305 141.006 532.704 140.683C533.121 140.355 533.418 139.987 533.597 139.579C533.788 139.15 533.818 138.692 533.688 138.205C533.557 137.717 533.31 137.333 532.947 137.053C532.596 136.751 532.158 136.562 531.634 136.486C531.126 136.406 530.578 136.445 529.99 136.602C529.402 136.76 528.9 137.003 528.484 137.33C528.084 137.653 527.8 138.036 527.63 138.477C527.473 138.898 527.459 139.351 527.59 139.838C527.72 140.326 527.959 140.712 528.305 140.997C528.669 141.278 529.104 141.458 529.612 141.538C530.136 141.614 530.692 141.573 531.28 141.415Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M524.849 192.831C522.684 184.748 527.481 176.44 535.564 174.274L560.819 167.507C568.902 165.341 577.21 170.138 579.376 178.221C581.542 186.304 576.745 194.613 568.662 196.778L543.407 203.545C535.324 205.711 527.015 200.914 524.849 192.831Z",
                                fill: "#131D2D"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M524.849 192.831C522.684 184.748 527.481 176.44 535.564 174.274L560.819 167.507C568.902 165.341 577.21 170.138 579.376 178.221C581.542 186.304 576.745 194.613 568.662 196.778L543.407 203.545C535.324 205.711 527.015 200.914 524.849 192.831Z",
                                stroke: "#2A973C"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M561.599 187.011C561.498 187.038 561.404 187.031 561.318 186.989C561.238 186.935 561.185 186.858 561.158 186.757L558.468 176.718C558.441 176.617 558.45 176.528 558.494 176.452C558.546 176.362 558.622 176.304 558.723 176.277L559.479 176.074C559.59 176.045 559.685 176.057 559.764 176.111C559.841 176.156 559.893 176.228 559.92 176.329L560.863 179.852C561.044 179.436 561.302 179.07 561.639 178.753C561.975 178.436 562.445 178.196 563.05 178.034C563.705 177.859 564.299 177.856 564.831 178.027C565.37 178.185 565.824 178.49 566.194 178.942C566.571 179.381 566.85 179.938 567.031 180.614L568.173 184.877C568.2 184.978 568.193 185.072 568.151 185.158C568.107 185.235 568.03 185.288 567.919 185.318L567.163 185.521C567.062 185.548 566.968 185.54 566.881 185.499C566.802 185.444 566.749 185.367 566.722 185.266L565.6 181.078C565.411 180.372 565.092 179.869 564.644 179.568C564.193 179.256 563.635 179.19 562.97 179.368C562.345 179.536 561.895 179.872 561.62 180.378C561.343 180.874 561.298 181.474 561.487 182.18L562.61 186.368C562.637 186.469 562.629 186.562 562.588 186.649C562.543 186.726 562.466 186.779 562.355 186.809L561.599 187.011Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M556.327 191.989C555.641 192.173 555.053 192.233 554.561 192.171C554.079 192.105 553.676 191.975 553.354 191.781C553.045 191.594 552.8 191.384 552.618 191.152C552.45 190.927 552.341 190.74 552.29 190.591C552.253 190.493 552.26 190.399 552.312 190.31C552.374 190.218 552.45 190.16 552.541 190.135L553.266 189.941C553.357 189.917 553.438 189.916 553.509 189.941C553.581 189.965 553.654 190.037 553.729 190.157C553.83 190.292 553.966 190.434 554.135 190.583C554.307 190.742 554.537 190.853 554.824 190.917C555.114 190.991 555.486 190.967 555.939 190.845C556.413 190.718 556.794 190.546 557.081 190.328C557.371 190.121 557.554 189.835 557.628 189.469C557.716 189.11 557.686 188.654 557.537 188.1L557.262 187.072C557.103 187.449 556.856 187.796 556.52 188.113C556.181 188.42 555.714 188.653 555.119 188.812C554.555 188.964 554.045 188.998 553.591 188.914C553.134 188.821 552.729 188.643 552.378 188.38C552.034 188.105 551.739 187.768 551.492 187.37C551.255 186.969 551.063 186.534 550.916 186.066C550.83 185.786 550.756 185.509 550.693 185.234C550.586 184.755 550.535 184.283 550.54 183.817C550.555 183.348 550.642 182.909 550.802 182.499C550.973 182.086 551.234 181.73 551.585 181.43C551.935 181.121 552.391 180.89 552.956 180.739C553.561 180.577 554.091 180.559 554.546 180.686C555.008 180.799 555.409 180.984 555.747 181.239L555.573 180.589C555.546 180.488 555.553 180.394 555.595 180.307C555.647 180.218 555.723 180.16 555.824 180.133L556.519 179.946C556.62 179.919 556.715 179.932 556.804 179.983C556.894 180.035 556.952 180.111 556.979 180.212L558.944 187.545C559.125 188.22 559.17 188.851 559.078 189.437C558.997 190.02 558.735 190.534 558.292 190.976C557.859 191.416 557.204 191.754 556.327 191.989ZM555.097 187.522C555.601 187.387 555.974 187.163 556.214 186.85C556.464 186.535 556.613 186.181 556.659 185.791C556.716 185.398 556.701 185.018 556.613 184.653C556.586 184.509 556.545 184.336 556.491 184.135C556.434 183.923 556.382 183.748 556.334 183.609C556.227 183.249 556.05 182.913 555.804 182.601C555.569 182.286 555.264 182.054 554.889 181.906C554.525 181.755 554.09 181.748 553.586 181.883C553.082 182.018 552.71 182.242 552.47 182.554C552.227 182.857 552.09 183.213 552.059 183.621C552.025 184.019 552.055 184.432 552.148 184.861C552.208 185.125 552.28 185.392 552.363 185.662C552.496 186.08 552.679 186.458 552.91 186.796C553.138 187.123 553.434 187.363 553.799 187.513C554.161 187.654 554.593 187.657 555.097 187.522Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M548.902 190.414C548.801 190.441 548.707 190.434 548.62 190.392C548.541 190.338 548.488 190.26 548.461 190.159L546.541 182.993C546.514 182.892 546.522 182.803 546.566 182.727C546.618 182.637 546.694 182.579 546.795 182.552L547.521 182.358C547.622 182.331 547.712 182.344 547.791 182.399C547.868 182.443 547.92 182.515 547.947 182.616L549.867 189.783C549.894 189.883 549.886 189.977 549.845 190.064C549.801 190.141 549.728 190.192 549.627 190.219L548.902 190.414ZM546.281 181.118C546.18 181.145 546.087 181.138 546 181.096C545.92 181.042 545.867 180.964 545.84 180.863L545.621 180.047C545.594 179.946 545.603 179.857 545.647 179.781C545.699 179.691 545.775 179.633 545.876 179.606L546.829 179.351C546.929 179.324 547.019 179.337 547.099 179.392C547.186 179.433 547.242 179.505 547.269 179.605L547.488 180.422C547.515 180.523 547.503 180.618 547.451 180.707C547.407 180.784 547.334 180.836 547.234 180.863L546.281 181.118Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M538.32 193.249C538.209 193.279 538.116 193.271 538.039 193.227C537.96 193.173 537.906 193.095 537.879 192.994L535.234 183.122C535.204 183.011 535.212 182.917 535.256 182.84C535.297 182.754 535.374 182.695 535.484 182.666L536.256 182.459C536.366 182.429 536.462 182.442 536.541 182.496C536.628 182.538 536.686 182.614 536.716 182.725L537.834 186.897L543.035 185.504L541.916 181.331C541.887 181.22 541.894 181.126 541.938 181.05C541.99 180.96 542.066 180.902 542.167 180.875L542.938 180.668C543.049 180.639 543.144 180.651 543.223 180.705C543.31 180.747 543.368 180.823 543.398 180.934L546.043 190.807C546.07 190.907 546.058 191.003 546.007 191.092C545.962 191.169 545.885 191.222 545.774 191.252L545.003 191.458C544.902 191.485 544.808 191.478 544.721 191.436C544.642 191.382 544.589 191.304 544.562 191.204L543.399 186.865L538.198 188.258L539.361 192.597C539.388 192.698 539.376 192.793 539.324 192.883C539.28 192.959 539.202 193.012 539.091 193.042L538.32 193.249Z",
                                fill: "#8ACD8A"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M721.336 99.6344C720.126 99.9585 719.05 100.096 718.108 100.046C717.186 99.9903 716.396 99.8238 715.738 99.5464C715.08 99.2689 714.564 98.9536 714.188 98.6005C713.813 98.2473 713.577 97.9324 713.481 97.6556C713.402 97.4392 713.416 97.2517 713.525 97.0929C713.648 96.9086 713.801 96.7921 713.982 96.7435L716.371 96.1034C716.452 96.0818 716.525 96.073 716.591 96.077C716.657 96.0809 716.753 96.1198 716.881 96.1936C717.203 96.3451 717.537 96.504 717.884 96.6703C718.251 96.8312 718.661 96.9483 719.112 97.0217C719.559 97.0749 720.084 97.0205 720.689 96.8585C721.475 96.6478 722.09 96.3211 722.533 95.8783C722.991 95.4099 723.142 94.8834 722.985 94.2988C722.871 93.8755 722.659 93.5652 722.347 93.368C722.055 93.1653 721.569 93.0469 720.89 93.0128C720.206 92.9585 719.257 92.9643 718.043 93.0303C716.844 93.0707 715.817 92.9893 714.963 92.786C714.11 92.5827 713.42 92.2272 712.895 91.7197C712.37 91.2122 712 90.5553 711.784 89.7489C711.573 88.9627 711.605 88.1548 711.88 87.325C712.169 86.4696 712.715 85.6859 713.518 84.9738C714.342 84.2563 715.449 83.7112 716.84 83.3385C717.928 83.0468 718.913 82.9341 719.795 83.0002C720.672 83.0462 721.426 83.2006 722.058 83.4633C722.711 83.7206 723.235 84.0232 723.63 84.3709C724.021 84.6984 724.266 85.0107 724.367 85.3077C724.447 85.524 724.435 85.7216 724.332 85.9006C724.223 86.0593 724.078 86.163 723.897 86.2116L721.659 86.8112C721.558 86.8382 721.462 86.8423 721.371 86.8236C721.279 86.8049 721.185 86.7761 721.088 86.7372C720.813 86.5951 720.514 86.4482 720.193 86.2967C719.871 86.1452 719.497 86.0401 719.071 85.9815C718.66 85.8973 718.151 85.9362 717.547 86.0982C716.781 86.3035 716.242 86.6315 715.931 87.0822C715.614 87.5128 715.523 87.98 715.658 88.484C715.75 88.8267 715.922 89.1047 716.173 89.3182C716.44 89.5061 716.895 89.6326 717.539 89.6977C718.183 89.7628 719.132 89.7569 720.386 89.6801C721.802 89.5602 722.967 89.6367 723.883 89.9099C724.814 90.1575 725.524 90.5505 726.014 91.089C726.519 91.6019 726.871 92.2313 727.071 92.9772C727.314 93.8843 727.26 94.7736 726.911 95.6452C726.581 96.5113 725.949 97.2965 725.014 98.0007C724.094 98.6793 722.868 99.2239 721.336 99.6344Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M709.441 102.498C708.231 102.822 707.156 102.883 706.216 102.681C705.277 102.479 704.494 102.019 703.87 101.301C703.24 100.562 702.757 99.568 702.422 98.3182L700.583 91.4542L698.194 92.0943C697.993 92.1483 697.802 92.1237 697.624 92.0204C697.445 91.9171 697.328 91.7646 697.274 91.563L696.804 89.8092C696.75 89.6077 696.775 89.4174 696.878 89.2385C696.981 89.0596 697.134 88.9431 697.335 88.8891L699.724 88.249L698.379 83.2296C698.325 83.028 698.34 82.8404 698.423 82.6669C698.526 82.488 698.689 82.3688 698.91 82.3094L701.36 81.6531C701.561 81.5991 701.752 81.6238 701.93 81.7271C702.109 81.8304 702.226 81.9828 702.28 82.1844L703.625 87.2038L707.405 86.1911C707.606 86.1371 707.796 86.1617 707.975 86.265C708.154 86.3683 708.271 86.5207 708.325 86.7223L708.795 88.4761C708.849 88.6777 708.824 88.8679 708.721 89.0469C708.617 89.2258 708.465 89.3422 708.263 89.3963L704.484 90.409L706.242 96.9706C706.463 97.7971 706.777 98.4044 707.184 98.7924C707.61 99.175 708.186 99.2691 708.912 99.0746L710.999 98.5156C711.2 98.4616 711.39 98.4862 711.569 98.5895C711.748 98.6928 711.865 98.8453 711.919 99.0468L712.421 100.922C712.475 101.123 712.45 101.313 712.347 101.492C712.244 101.671 712.091 101.788 711.89 101.842L709.441 102.498Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M684.368 109.216C684.167 109.27 683.977 109.245 683.798 109.142C683.619 109.039 683.502 108.886 683.448 108.685L679.624 94.4124C679.57 94.2108 679.595 94.0205 679.698 93.8416C679.801 93.6627 679.954 93.5462 680.155 93.4922L682.635 92.8278C682.836 92.7738 683.027 92.7985 683.206 92.9018C683.385 93.0051 683.501 93.1575 683.555 93.3591L683.887 94.5988C684.238 93.8133 684.761 93.1009 685.453 92.4615C686.161 91.7965 687.12 91.302 688.329 90.9779C689.559 90.6484 690.703 90.6444 691.761 90.9658C692.814 91.267 693.718 91.8567 694.472 92.735C695.246 93.6079 695.822 94.7499 696.2 96.161L698.476 104.658C698.53 104.859 698.506 105.05 698.403 105.229C698.299 105.407 698.147 105.524 697.945 105.578L695.284 106.291C695.083 106.345 694.892 106.32 694.714 106.217C694.535 106.114 694.418 105.961 694.364 105.76L692.136 97.4443C691.823 96.2751 691.285 95.4362 690.522 94.9276C689.779 94.4136 688.864 94.3025 687.775 94.5942C686.727 94.875 685.979 95.4318 685.533 96.2645C685.086 97.0972 685.019 98.0981 685.333 99.2673L687.561 107.583C687.615 107.784 687.59 107.974 687.487 108.153C687.383 108.332 687.231 108.449 687.029 108.503L684.368 109.216Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M676.396 111.352C676.194 111.406 676.004 111.382 675.825 111.278C675.646 111.175 675.53 111.022 675.476 110.821L671.651 96.5487C671.597 96.3471 671.622 96.1569 671.725 95.978C671.829 95.799 671.981 95.6826 672.183 95.6286L674.692 94.9561C674.914 94.8967 675.104 94.9213 675.263 95.03C675.442 95.1333 675.559 95.2858 675.613 95.4873L679.437 109.76C679.491 109.961 679.466 110.151 679.363 110.33C679.28 110.504 679.127 110.62 678.906 110.68L676.396 111.352ZM671.365 93.0605C671.143 93.1199 670.946 93.1081 670.772 93.0249C670.613 92.9162 670.504 92.751 670.445 92.5293L669.861 90.3522C669.807 90.1506 669.822 89.963 669.905 89.7895C670.008 89.6106 670.171 89.4914 670.393 89.432L673.144 88.6947C673.366 88.6353 673.566 88.6572 673.745 88.7605C673.924 88.8638 674.041 89.0163 674.095 89.2179L674.678 91.395C674.737 91.6167 674.716 91.8171 674.612 91.996C674.504 92.1547 674.338 92.2638 674.117 92.3232L671.365 93.0605Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M664.812 114.78C663.199 115.212 661.763 115.295 660.503 115.027C659.263 114.754 658.213 114.182 657.353 113.311C656.513 112.434 655.869 111.321 655.421 109.972C655.304 109.614 655.175 109.174 655.034 108.65C654.894 108.125 654.785 107.679 654.708 107.311C654.416 105.898 654.427 104.61 654.742 103.445C655.071 102.255 655.704 101.232 656.642 100.376C657.599 99.5144 658.864 98.873 660.436 98.4517C662.009 98.0304 663.415 97.9561 664.655 98.2289C665.915 98.4962 666.975 99.0656 667.835 99.9371C668.709 100.783 669.374 101.891 669.827 103.26C669.944 103.617 670.073 104.058 670.214 104.582C670.354 105.106 670.463 105.553 670.54 105.921C670.826 107.313 670.815 108.602 670.506 109.786C670.217 110.966 669.594 111.986 668.636 112.848C667.699 113.704 666.424 114.348 664.812 114.78ZM664.009 111.787C665.078 111.5 665.815 110.946 666.222 110.124C666.622 109.282 666.678 108.198 666.387 106.872C666.326 106.564 666.231 106.168 666.101 105.684C665.972 105.2 665.856 104.81 665.755 104.513C665.349 103.239 664.762 102.338 663.993 101.809C663.225 101.28 662.307 101.159 661.238 101.445C660.17 101.732 659.435 102.296 659.034 103.138C658.633 103.98 658.576 105.054 658.861 106.36C658.922 106.668 659.017 107.064 659.147 107.548C659.276 108.031 659.392 108.422 659.493 108.719C659.904 110.013 660.494 110.924 661.263 111.453C662.025 111.962 662.941 112.073 664.009 111.787Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M641.497 126.861C641.295 126.915 641.105 126.89 640.926 126.787C640.747 126.684 640.631 126.531 640.577 126.33L635.213 106.312C635.159 106.111 635.184 105.92 635.287 105.742C635.39 105.563 635.543 105.446 635.744 105.392L638.133 104.752C638.355 104.693 638.545 104.717 638.704 104.826C638.883 104.929 638.999 105.082 639.053 105.283L639.377 106.493C639.688 105.718 640.18 105.014 640.853 104.38C641.526 103.746 642.447 103.272 643.616 102.959C644.684 102.673 645.657 102.595 646.535 102.728C647.413 102.86 648.201 103.178 648.898 103.683C649.589 104.167 650.192 104.805 650.707 105.596C651.221 106.387 651.639 107.302 651.96 108.339C652.072 108.676 652.177 109.026 652.274 109.389C652.371 109.752 652.459 110.118 652.536 110.486C652.786 111.499 652.885 112.477 652.836 113.419C652.78 114.342 652.567 115.198 652.195 115.989C651.839 116.755 651.316 117.424 650.627 117.998C649.938 118.571 649.059 119.001 647.991 119.287C646.902 119.579 645.924 119.636 645.055 119.458C644.181 119.26 643.416 118.904 642.759 118.388L644.598 125.252C644.652 125.454 644.628 125.644 644.524 125.823C644.441 125.996 644.289 126.113 644.067 126.172L641.497 126.861ZM646.005 116.352C646.872 116.119 647.499 115.757 647.885 115.264C648.266 114.752 648.477 114.166 648.516 113.507C648.576 112.843 648.529 112.143 648.375 111.406C648.253 110.791 648.091 110.186 647.889 109.592C647.654 108.877 647.344 108.247 646.961 107.702C646.597 107.151 646.125 106.759 645.544 106.526C644.957 106.272 644.231 106.262 643.364 106.494C642.537 106.716 641.913 107.088 641.492 107.611C641.091 108.129 640.85 108.723 640.77 109.393C640.705 110.037 640.736 110.677 640.863 111.312C640.94 111.681 641.033 112.066 641.141 112.47C641.249 112.873 641.364 113.263 641.487 113.641C641.669 114.24 641.967 114.787 642.38 115.281C642.788 115.755 643.293 116.106 643.894 116.334C644.495 116.562 645.199 116.568 646.005 116.352Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M618.262 126.929C618.081 126.977 617.913 126.957 617.76 126.869C617.601 126.76 617.497 126.615 617.449 126.434C617.427 126.353 617.423 126.257 617.436 126.145L620.268 107.562L610.773 110.106C610.551 110.165 610.351 110.143 610.172 110.04C610.013 109.931 609.907 109.776 609.853 109.575L609.286 107.458C609.226 107.236 609.238 107.039 609.321 106.865C609.424 106.686 609.587 106.567 609.809 106.508L623.083 102.951C623.305 102.891 623.495 102.916 623.654 103.025C623.833 103.128 623.952 103.291 624.011 103.512L624.514 105.387C624.589 105.669 624.624 105.919 624.617 106.137C624.626 106.329 624.617 106.537 624.59 106.76L621.787 125.206C621.764 125.364 621.697 125.555 621.584 125.779C621.486 125.978 621.296 126.116 621.014 126.191L618.262 126.929Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M604.949 129.427C604.747 129.481 604.557 129.456 604.378 129.353C604.199 129.249 604.083 129.097 604.029 128.895L602.449 122.999L596.643 124.555C596.442 124.609 596.251 124.584 596.072 124.481C595.893 124.377 595.777 124.225 595.723 124.023L595.294 122.421C595.234 122.199 595.259 122.009 595.367 121.85C595.471 121.671 595.623 121.555 595.825 121.501L601.63 119.945L600.091 114.2C600.037 113.998 600.062 113.808 600.165 113.629C600.268 113.45 600.421 113.334 600.622 113.28L602.376 112.81C602.598 112.75 602.788 112.775 602.947 112.884C603.126 112.987 603.242 113.139 603.296 113.341L604.836 119.086L610.641 117.53C610.843 117.476 611.033 117.501 611.212 117.604C611.386 117.688 611.502 117.84 611.561 118.062L611.991 119.664C612.045 119.866 612.02 120.056 611.917 120.235C611.814 120.414 611.661 120.53 611.46 120.584L605.654 122.14L607.234 128.036C607.288 128.238 607.263 128.428 607.16 128.607C607.077 128.781 606.924 128.897 606.703 128.957L604.949 129.427Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M718.535 132.577C717.783 132.778 717.113 132.857 716.525 132.813C715.937 132.769 715.439 132.658 715.031 132.479C714.623 132.3 714.295 132.1 714.049 131.878C713.815 131.652 713.67 131.461 713.614 131.303C713.561 131.159 713.577 131.032 713.663 130.922C713.749 130.813 713.846 130.744 713.953 130.715L714.84 130.477C714.921 130.456 714.985 130.453 715.032 130.469C715.09 130.468 715.171 130.504 715.277 130.576C715.502 130.718 715.747 130.854 716.013 130.984C716.278 131.115 716.582 131.199 716.923 131.237C717.278 131.272 717.691 131.226 718.161 131.1C718.847 130.916 719.377 130.637 719.752 130.263C720.123 129.875 720.241 129.426 720.104 128.916C720.014 128.58 719.848 128.336 719.606 128.185C719.377 128.03 719.006 127.935 718.492 127.9C717.992 127.861 717.315 127.862 716.462 127.904C715.605 127.932 714.906 127.874 714.364 127.731C713.818 127.575 713.393 127.336 713.091 127.014C712.785 126.678 712.567 126.268 712.437 125.784C712.304 125.287 712.324 124.771 712.497 124.234C712.667 123.685 712.994 123.187 713.48 122.74C713.978 122.289 714.658 121.949 715.518 121.718C716.217 121.531 716.838 121.458 717.382 121.5C717.926 121.541 718.395 121.653 718.79 121.835C719.181 122.004 719.491 122.195 719.721 122.407C719.951 122.619 720.096 122.811 720.156 122.982C720.205 123.112 720.196 123.238 720.127 123.357C720.054 123.463 719.958 123.532 719.837 123.564L718.99 123.791C718.896 123.816 718.81 123.818 718.732 123.795C718.667 123.769 718.601 123.737 718.533 123.697C718.352 123.559 718.144 123.427 717.909 123.303C717.687 123.175 717.414 123.097 717.09 123.069C716.775 123.023 716.382 123.064 715.912 123.19C715.24 123.37 714.774 123.646 714.514 124.018C714.253 124.39 714.181 124.792 714.296 125.222C714.364 125.477 714.5 125.686 714.701 125.848C714.903 126.01 715.234 126.115 715.694 126.165C716.154 126.215 716.819 126.224 717.689 126.192C718.623 126.129 719.385 126.177 719.974 126.336C720.564 126.495 721.019 126.74 721.338 127.072C721.658 127.405 721.886 127.826 722.023 128.337C722.174 128.901 722.145 129.463 721.935 130.024C721.738 130.581 721.355 131.087 720.786 131.542C720.226 131.98 719.476 132.325 718.535 132.577Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M706.926 139.577C706.818 139.606 706.714 139.591 706.611 139.532C706.509 139.473 706.444 139.389 706.415 139.282C706.4 139.228 706.393 139.173 706.392 139.115C706.391 139.058 706.4 138.983 706.418 138.892L706.982 134.787L700.696 126.727C700.585 126.584 700.521 126.479 700.503 126.412C700.471 126.291 700.484 126.179 700.543 126.077C700.602 125.975 700.692 125.907 700.813 125.875L701.801 125.61C701.935 125.574 702.052 125.579 702.15 125.625C702.249 125.67 702.324 125.736 702.376 125.823L707.407 132.34L708.585 124.16C708.6 124.055 708.632 123.96 708.682 123.874C708.744 123.786 708.849 123.721 708.997 123.682L709.945 123.428C710.066 123.396 710.177 123.409 710.28 123.468C710.382 123.527 710.447 123.61 710.476 123.718C710.494 123.785 710.493 123.915 710.473 124.108L708.285 138.845C708.27 138.95 708.232 139.047 708.169 139.136C708.12 139.221 708.021 139.284 707.873 139.323L706.926 139.577Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M696.136 138.579C695.464 138.759 694.817 138.788 694.194 138.667C693.571 138.546 693.03 138.302 692.572 137.935C692.113 137.568 691.807 137.096 691.652 136.518C691.403 135.591 691.582 134.751 692.187 133.998C692.792 133.245 693.675 132.62 694.838 132.121L697.728 130.893L697.572 130.308C697.399 129.663 697.076 129.209 696.602 128.947C696.142 128.682 695.495 128.661 694.662 128.884C694.057 129.046 693.599 129.298 693.288 129.641C692.99 129.98 692.817 130.358 692.77 130.774C692.744 130.997 692.63 131.135 692.428 131.189L691.521 131.432C691.373 131.472 691.248 131.462 691.146 131.403C691.053 131.327 690.991 131.229 690.959 131.108C690.904 130.906 690.912 130.638 690.98 130.303C691.062 129.964 691.227 129.61 691.474 129.241C691.721 128.873 692.068 128.528 692.514 128.206C692.971 127.868 693.562 127.601 694.288 127.407C695.094 127.191 695.802 127.117 696.41 127.184C697.015 127.238 697.519 127.398 697.922 127.665C698.338 127.928 698.673 128.263 698.926 128.67C699.193 129.074 699.387 129.505 699.51 129.962L701.26 136.493C701.296 136.627 701.279 136.754 701.211 136.873C701.152 136.976 701.055 137.045 700.92 137.081L699.993 137.329C699.845 137.369 699.72 137.359 699.618 137.3C699.512 137.228 699.441 137.124 699.405 136.99L699.173 136.123C699.063 136.412 698.893 136.717 698.662 137.038C698.427 137.346 698.11 137.639 697.71 137.92C697.306 138.186 696.781 138.406 696.136 138.579ZM696.155 136.953C696.706 136.806 697.179 136.557 697.575 136.206C697.967 135.841 698.224 135.376 698.346 134.811C698.482 134.241 698.448 133.58 698.247 132.828L698.096 132.263L695.849 133.233C694.931 133.623 694.273 134.044 693.876 134.496C693.475 134.935 693.339 135.396 693.469 135.88C693.57 136.256 693.762 136.543 694.045 136.741C694.338 136.922 694.669 137.027 695.038 137.058C695.419 137.086 695.792 137.051 696.155 136.953Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M685.055 141.548C684.315 141.746 683.643 141.79 683.037 141.678C682.427 141.554 681.888 141.316 681.42 140.966C680.962 140.599 680.568 140.15 680.238 139.619C679.922 139.085 679.664 138.498 679.464 137.861C679.393 137.649 679.333 137.449 679.282 137.261C679.232 137.073 679.185 136.87 679.14 136.651C678.998 136.012 678.93 135.382 678.936 134.761C678.956 134.137 679.073 133.551 679.287 133.004C679.514 132.453 679.862 131.978 680.331 131.579C680.796 131.166 681.399 130.861 682.138 130.663C682.931 130.45 683.627 130.415 684.227 130.557C684.826 130.698 685.35 130.933 685.798 131.259L684.555 126.623C684.519 126.488 684.531 126.37 684.59 126.268C684.659 126.148 684.76 126.071 684.895 126.035L685.862 125.775C685.997 125.739 686.117 125.758 686.223 125.83C686.338 125.886 686.414 125.981 686.45 126.115L690.037 139.5C690.073 139.635 690.056 139.761 689.988 139.881C689.929 139.983 689.832 140.052 689.697 140.088L688.79 140.331C688.642 140.371 688.517 140.361 688.415 140.302C688.309 140.229 688.238 140.126 688.202 139.992L687.976 139.145C687.755 139.665 687.415 140.145 686.957 140.585C686.495 141.011 685.861 141.332 685.055 141.548ZM685.04 139.802C685.712 139.622 686.208 139.323 686.529 138.906C686.849 138.489 687.047 138.018 687.123 137.494C687.195 136.956 687.171 136.437 687.051 135.936C687.007 135.717 686.945 135.46 686.866 135.164C686.783 134.855 686.706 134.595 686.635 134.384C686.495 133.917 686.257 133.484 685.92 133.085C685.596 132.682 685.186 132.388 684.69 132.204C684.207 132.017 683.644 132.009 682.999 132.182C682.313 132.366 681.81 132.666 681.49 133.083C681.166 133.487 680.983 133.961 680.942 134.505C680.897 135.035 680.936 135.586 681.061 136.158C681.152 136.551 681.256 136.941 681.374 137.327C681.552 137.885 681.795 138.388 682.103 138.839C682.407 139.276 682.803 139.595 683.289 139.796C683.771 139.984 684.355 139.986 685.04 139.802Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M668.386 146.015C667.459 146.263 666.635 146.333 665.914 146.223C665.203 146.097 664.578 145.832 664.038 145.43C663.498 145.027 663.045 144.522 662.681 143.914C662.33 143.302 662.042 142.63 661.817 141.898C661.706 141.539 661.59 141.159 661.468 140.76C661.36 140.357 661.252 139.954 661.144 139.55C661.046 139.13 660.953 138.73 660.866 138.35C660.681 137.607 660.595 136.882 660.607 136.173C660.628 135.447 660.767 134.783 661.024 134.181C661.29 133.563 661.708 133.026 662.277 132.571C662.843 132.102 663.583 131.745 664.497 131.501C665.424 131.252 666.243 131.191 666.954 131.317C667.675 131.427 668.305 131.683 668.845 132.086C669.382 132.475 669.834 132.98 670.202 133.602C670.58 134.206 670.875 134.876 671.086 135.612C671.201 135.984 671.314 136.379 671.425 136.796C671.547 137.195 671.655 137.598 671.749 138.005C671.857 138.408 671.953 138.793 672.037 139.16C672.222 139.902 672.301 140.63 672.276 141.342C672.264 142.051 672.125 142.715 671.859 143.334C671.606 143.949 671.197 144.491 670.631 144.959C670.075 145.411 669.327 145.763 668.386 146.015ZM667.927 144.301C668.975 144.02 669.656 143.471 669.97 142.652C670.293 141.816 670.301 140.799 669.994 139.599C669.917 139.202 669.829 138.822 669.732 138.459C669.631 138.083 669.532 137.713 669.435 137.351C669.334 136.974 669.222 136.608 669.097 136.253C668.771 135.087 668.258 134.223 667.56 133.661C666.872 133.082 666.004 132.933 664.956 133.214C663.921 133.491 663.244 134.054 662.924 134.904C662.614 135.736 662.602 136.74 662.889 137.916C662.986 138.279 663.078 138.651 663.166 139.03C663.263 139.393 663.362 139.763 663.463 140.139C663.573 140.498 663.681 140.873 663.785 141.263C664.133 142.451 664.655 143.327 665.353 143.889C666.048 144.437 666.905 144.575 667.927 144.301Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M655.896 149.361C655.05 149.588 654.284 149.686 653.598 149.653C652.909 149.607 652.302 149.467 651.778 149.233C651.255 148.999 650.823 148.704 650.483 148.349C650.156 147.99 649.927 147.59 649.794 147.151C649.762 147.03 649.777 146.925 649.84 146.836C649.902 146.747 649.994 146.687 650.115 146.654L651.103 146.389C651.224 146.357 651.339 146.355 651.447 146.384C651.556 146.412 651.667 146.505 651.781 146.662C652.045 147.109 652.374 147.424 652.769 147.607C653.177 147.786 653.61 147.871 654.069 147.863C654.538 147.839 654.994 147.767 655.437 147.648C656.364 147.399 657.058 146.976 657.517 146.378C657.976 145.779 658.09 145.05 657.86 144.19C657.626 143.317 657.196 142.762 656.571 142.526C655.946 142.29 655.17 142.296 654.243 142.545L652.328 143.058C652.193 143.094 652.068 143.084 651.953 143.029C651.85 142.97 651.779 142.867 651.74 142.719L651.594 142.174C651.562 142.053 651.555 141.947 651.573 141.856C651.602 141.747 651.634 141.652 651.67 141.571L654.435 136.249L648.489 137.843C648.354 137.879 648.229 137.869 648.114 137.814C648.011 137.755 647.94 137.651 647.901 137.503L647.696 136.737C647.656 136.589 647.666 136.464 647.725 136.362C647.794 136.243 647.895 136.165 648.03 136.129L656.073 133.974C656.221 133.934 656.347 133.951 656.453 134.023C656.569 134.079 656.647 134.18 656.686 134.328L656.881 135.054C656.906 135.148 656.902 135.243 656.87 135.338C656.848 135.416 656.819 135.495 656.783 135.577L654.054 140.953L654.382 140.887C655.276 140.676 656.092 140.631 656.83 140.75C657.581 140.865 658.217 141.17 658.738 141.664C659.27 142.141 659.654 142.823 659.892 143.71C660.133 144.611 660.118 145.443 659.848 146.207C659.573 146.957 659.091 147.605 658.402 148.15C657.713 148.695 656.877 149.099 655.896 149.361Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M642.603 152.707C641.85 152.909 641.201 152.931 640.655 152.775C640.106 152.606 639.653 152.288 639.298 151.821C638.938 151.341 638.662 150.738 638.467 150.013L637.041 144.691L635.469 145.112C635.335 145.148 635.209 145.138 635.094 145.083C634.988 145.01 634.917 144.907 634.881 144.773L634.697 144.087C634.661 143.953 634.673 143.835 634.732 143.732C634.801 143.613 634.902 143.535 635.037 143.499L636.609 143.078L635.707 139.712C635.671 139.577 635.683 139.459 635.742 139.357C635.811 139.237 635.912 139.16 636.047 139.124L636.994 138.87C637.128 138.834 637.248 138.852 637.354 138.924C637.47 138.98 637.546 139.075 637.582 139.209L638.484 142.576L640.984 141.906C641.118 141.87 641.238 141.888 641.344 141.961C641.46 142.016 641.535 142.111 641.571 142.245L641.755 142.931C641.791 143.065 641.775 143.192 641.706 143.311C641.647 143.413 641.55 143.483 641.416 143.519L638.916 144.188L640.304 149.369C640.473 150.001 640.714 150.469 641.026 150.774C641.339 151.08 641.77 151.158 642.321 151.011L643.551 150.681C643.685 150.645 643.805 150.664 643.911 150.736C644.027 150.791 644.103 150.886 644.139 151.021L644.333 151.746C644.369 151.881 644.353 152.008 644.284 152.127C644.225 152.229 644.128 152.298 643.994 152.334L642.603 152.707Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M631.937 155.781C631.184 155.983 630.514 156.061 629.926 156.017C629.338 155.973 628.84 155.862 628.432 155.683C628.024 155.504 627.697 155.304 627.45 155.082C627.217 154.856 627.072 154.665 627.015 154.507C626.962 154.363 626.978 154.236 627.064 154.126C627.15 154.017 627.247 153.948 627.354 153.919L628.241 153.681C628.322 153.66 628.386 153.657 628.434 153.673C628.491 153.672 628.573 153.708 628.678 153.78C628.904 153.922 629.149 154.058 629.414 154.188C629.68 154.319 629.983 154.403 630.325 154.441C630.68 154.476 631.092 154.43 631.563 154.304C632.248 154.12 632.778 153.841 633.153 153.467C633.525 153.08 633.642 152.63 633.505 152.12C633.415 151.784 633.249 151.54 633.007 151.389C632.778 151.234 632.407 151.139 631.894 151.104C631.393 151.065 630.717 151.066 629.864 151.108C629.007 151.136 628.307 151.078 627.765 150.936C627.219 150.779 626.795 150.54 626.492 150.218C626.186 149.882 625.968 149.472 625.839 148.989C625.706 148.491 625.726 147.975 625.899 147.438C626.068 146.889 626.396 146.391 626.881 145.944C627.38 145.493 628.059 145.153 628.919 144.922C629.618 144.735 630.239 144.662 630.784 144.704C631.328 144.745 631.797 144.857 632.191 145.039C632.582 145.208 632.893 145.399 633.122 145.611C633.352 145.823 633.497 146.015 633.557 146.186C633.607 146.317 633.597 146.442 633.528 146.561C633.456 146.667 633.359 146.736 633.238 146.768L632.391 146.995C632.297 147.02 632.211 147.022 632.133 146.999C632.069 146.974 632.002 146.941 631.934 146.902C631.753 146.763 631.545 146.631 631.31 146.507C631.088 146.379 630.815 146.301 630.491 146.273C630.176 146.227 629.784 146.268 629.313 146.394C628.642 146.574 628.175 146.85 627.915 147.222C627.655 147.595 627.582 147.996 627.697 148.426C627.766 148.681 627.901 148.89 628.103 149.052C628.305 149.214 628.635 149.32 629.095 149.369C629.555 149.419 630.22 149.428 631.09 149.396C632.024 149.333 632.786 149.381 633.376 149.54C633.966 149.699 634.42 149.944 634.74 150.277C635.059 150.609 635.287 151.03 635.424 151.541C635.575 152.105 635.546 152.668 635.336 153.228C635.14 153.785 634.757 154.291 634.187 154.746C633.628 155.184 632.877 155.529 631.937 155.781Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M620.109 158.95C619.437 159.13 618.79 159.16 618.167 159.039C617.544 158.918 617.003 158.674 616.544 158.307C616.086 157.94 615.779 157.467 615.625 156.889C615.376 155.962 615.554 155.122 616.159 154.37C616.764 153.617 617.648 152.991 618.811 152.492L621.701 151.264L621.544 150.68C621.371 150.035 621.048 149.581 620.575 149.319C620.115 149.053 619.468 149.032 618.635 149.255C618.03 149.418 617.572 149.67 617.26 150.013C616.962 150.352 616.79 150.729 616.743 151.145C616.716 151.368 616.602 151.507 616.401 151.561L615.493 151.804C615.346 151.844 615.221 151.834 615.118 151.775C615.026 151.699 614.964 151.6 614.931 151.479C614.877 151.278 614.884 151.009 614.953 150.674C615.035 150.335 615.2 149.981 615.447 149.613C615.693 149.244 616.04 148.899 616.487 148.578C616.944 148.239 617.535 147.973 618.261 147.779C619.067 147.562 619.774 147.488 620.383 147.556C620.988 147.609 621.492 147.77 621.895 148.036C622.311 148.299 622.646 148.635 622.899 149.042C623.165 149.446 623.36 149.876 623.482 150.333L625.232 156.865C625.268 156.999 625.252 157.126 625.183 157.245C625.124 157.347 625.027 157.416 624.893 157.452L623.966 157.701C623.818 157.741 623.693 157.731 623.591 157.672C623.485 157.599 623.414 157.496 623.378 157.361L623.146 156.495C623.036 156.783 622.865 157.088 622.635 157.409C622.4 157.717 622.083 158.011 621.682 158.291C621.279 158.558 620.754 158.778 620.109 158.95ZM620.127 157.325C620.678 157.177 621.152 156.928 621.547 156.577C621.939 156.213 622.197 155.748 622.319 155.182C622.454 154.613 622.421 153.952 622.219 153.199L622.068 152.635L619.822 153.604C618.904 153.994 618.246 154.415 617.848 154.868C617.447 155.306 617.312 155.768 617.441 156.251C617.542 156.628 617.734 156.915 618.018 157.112C618.311 157.293 618.642 157.399 619.01 157.43C619.392 157.457 619.764 157.422 620.127 157.325Z",
                                fill: "#9EA1B1"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M606.499 162.381C606.351 162.421 606.226 162.411 606.123 162.352C606.018 162.28 605.947 162.176 605.911 162.042L602.378 148.858C602.342 148.724 602.354 148.605 602.413 148.503C602.468 148.388 602.57 148.31 602.718 148.27L603.786 147.984C603.92 147.948 604.04 147.966 604.146 148.039C604.249 148.098 604.318 148.194 604.354 148.329L607.541 160.222L614.253 158.424C614.401 158.384 614.528 158.4 614.634 158.473C614.736 158.532 614.807 158.635 614.847 158.783L615.063 159.59C615.099 159.724 615.089 159.849 615.033 159.965C614.974 160.067 614.871 160.138 614.723 160.177L606.499 162.381Z",
                                fill: "#9EA1B1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_10626_42003",
                        x1: "0",
                        y1: "331",
                        x2: "845.045",
                        y2: "5.30653",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.32",
                                stopColor: "#1A294D",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#1B2A40"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_10626_42003",
                        x1: "579.763",
                        y1: "178.346",
                        x2: "664.055",
                        y2: "324.343",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#01AE66",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_10626_42003",
                        x1: "590.008",
                        y1: "118.881",
                        x2: "696.582",
                        y2: "303.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#E19701"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF4451"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("clipPath", {
                        id: "clip0_10626_42003",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                            width: "843",
                            height: "331",
                            rx: "8",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
var $035d20266e4aab5d$export$2e2bcd8739ae039 = $035d20266e4aab5d$var$SecurityPostureDarkTheme;




function $2afc8d52b2677afe$var$SecurityPostureLightSvg() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: "361",
        height: "331",
        viewBox: "0 0 361 331",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                clipPath: "url(#clip0_11334_36830)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                        width: "361",
                        height: "331",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M264.805 512.811L209.159 305.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M347.048 417.811L291.402 210.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M76.2926 505.811L20.6465 298.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M17.9964 290.684C1.89526 299.366 -17.4554 317.496 -25.8631 325.747C-28.4089 328.246 -28.8794 332.128 -27.0959 335.217L42.5347 455.821C44.7438 459.647 49.6366 460.958 53.4629 458.749L540.923 177.314C544.749 175.105 546.06 170.212 543.851 166.386L456.059 14.3267C456.059 14.3267 428.013 65.1332 406.782 94.3666C386.357 122.49 374.505 138.106 349.955 161.332C317.933 191.626 291.456 196.299 258.523 225.367C229.171 251.274 231.131 301.327 189.431 299.591C165.864 298.61 151.83 278.276 127.608 272.389C81.073 261.078 55.069 270.695 17.9964 290.684Z",
                                fill: "url(#paint1_linear_11334_36830)",
                                fillOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M-30.1079 330C-30.1079 330 -3.23163 302.13 17.9964 290.684C55.069 270.695 81.073 261.078 127.608 272.389C151.83 278.276 165.864 298.61 189.431 299.591C231.131 301.327 229.171 251.274 258.523 225.367C291.456 196.299 317.933 191.626 349.955 161.332C374.505 138.106 386.357 122.49 406.782 94.3666C428.013 65.1332 456.059 14.3267 456.059 14.3267",
                                stroke: "url(#paint2_linear_11334_36830)",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "18.0266",
                                cy: "288.896",
                                r: "5",
                                transform: "rotate(-30 18.0266 288.896)",
                                fill: "#01AE66",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "206.649",
                                cy: "295.529",
                                r: "5",
                                transform: "rotate(-30 206.649 295.529)",
                                fill: "#E19701",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "288.422",
                                cy: "202.131",
                                r: "5",
                                transform: "rotate(-30 288.422 202.131)",
                                fill: "#E19701",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M302.095 214.358C308.614 214.267 315.035 215.954 320.666 219.239C326.298 222.523 330.928 227.28 334.059 232.999C337.19 238.717 338.703 245.181 338.436 251.695C338.168 258.209 336.131 264.527 332.542 269.97C332.066 270.692 331.322 271.195 330.475 271.369C329.628 271.543 328.746 271.373 328.024 270.897L327.752 270.717C326.249 269.726 325.834 267.703 326.825 266.2C329.729 261.796 331.377 256.684 331.593 251.414C331.81 246.144 330.586 240.914 328.052 236.287C325.519 231.66 321.773 227.811 317.217 225.154C312.66 222.497 307.465 221.131 302.191 221.205C296.917 221.279 291.762 222.789 287.281 225.572C282.801 228.356 279.164 232.308 276.761 237.003C274.358 241.699 273.28 246.961 273.643 252.223C274.007 257.486 275.797 262.549 278.823 266.87C279.319 267.579 279.513 268.455 279.363 269.307C279.213 270.159 278.731 270.916 278.022 271.412L277.755 271.599C276.28 272.632 274.246 272.273 273.214 270.798C269.474 265.458 267.261 259.199 266.812 252.695C266.363 246.191 267.695 239.688 270.665 233.884C273.635 228.08 278.13 223.196 283.668 219.755C289.206 216.315 295.576 214.449 302.095 214.358Z",
                                fill: "#EBECF2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M294.833 215.205C300.591 213.928 306.576 214.091 312.257 215.68C317.938 217.269 323.139 220.234 327.4 224.313C331.661 228.392 334.851 233.459 336.686 239.065C338.521 244.671 338.945 250.644 337.921 256.453C337.608 258.226 335.917 259.411 334.143 259.098L333.822 259.041C332.97 258.891 332.213 258.409 331.717 257.7C331.221 256.992 331.027 256.115 331.177 255.264C332.006 250.563 331.663 245.731 330.178 241.196C328.693 236.66 326.113 232.56 322.665 229.26C319.217 225.959 315.009 223.56 310.413 222.275C305.817 220.989 300.974 220.857 296.315 221.89C291.655 222.923 287.322 225.089 283.7 228.197C280.078 231.304 277.277 235.257 275.548 239.705C273.818 244.154 273.212 248.96 273.783 253.698C274.354 258.436 276.085 262.961 278.823 266.87C279.856 268.345 279.497 270.379 278.022 271.412L277.755 271.599C277.047 272.095 276.17 272.289 275.318 272.139C274.467 271.989 273.71 271.506 273.214 270.798C269.83 265.966 267.691 260.374 266.984 254.518C266.278 248.661 267.027 242.721 269.165 237.224C271.303 231.726 274.764 226.84 279.241 223C283.718 219.159 289.074 216.481 294.833 215.205Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M307.253 257.399C307.096 257.399 306.966 257.347 306.861 257.242C306.757 257.12 306.705 256.981 306.705 256.825C306.705 256.738 306.713 256.668 306.731 256.616C306.766 256.564 306.792 256.52 306.809 256.486L310.644 251.19C310.296 251.277 309.931 251.312 309.548 251.294C308.679 251.277 307.861 251.112 307.096 250.799C306.348 250.468 305.687 250.033 305.113 249.494C304.557 248.938 304.113 248.303 303.783 247.59C303.47 246.86 303.313 246.068 303.313 245.216C303.313 244.433 303.461 243.668 303.757 242.92C304.053 242.155 304.487 241.468 305.061 240.86C305.653 240.251 306.383 239.773 307.253 239.425C308.14 239.06 309.174 238.877 310.357 238.877C311.522 238.877 312.548 239.042 313.435 239.373C314.322 239.703 315.061 240.164 315.653 240.755C316.261 241.329 316.713 241.99 317.009 242.738C317.322 243.486 317.479 244.277 317.479 245.112C317.479 245.86 317.357 246.555 317.113 247.199C316.87 247.842 316.566 248.433 316.2 248.973C315.853 249.494 315.505 250.007 315.157 250.512L310.566 256.877C310.496 256.964 310.392 257.077 310.253 257.216C310.131 257.338 309.94 257.399 309.679 257.399H307.253ZM310.383 248.529C311.009 248.529 311.574 248.399 312.079 248.138C312.6 247.86 313.009 247.477 313.305 246.99C313.618 246.486 313.774 245.894 313.774 245.216C313.774 244.52 313.618 243.929 313.305 243.442C313.009 242.938 312.6 242.555 312.079 242.294C311.557 242.016 310.992 241.877 310.383 241.877C309.757 241.877 309.183 242.016 308.661 242.294C308.157 242.555 307.748 242.938 307.435 243.442C307.14 243.929 306.992 244.52 306.992 245.216C306.992 245.894 307.14 246.486 307.435 246.99C307.748 247.477 308.157 247.86 308.661 248.138C309.183 248.399 309.757 248.529 310.383 248.529Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M293.89 257.66C292.742 257.66 291.716 257.52 290.812 257.242C289.907 256.964 289.142 256.573 288.516 256.068C287.907 255.564 287.438 254.973 287.107 254.294C286.794 253.616 286.638 252.86 286.638 252.025C286.638 251.016 286.881 250.147 287.368 249.416C287.872 248.668 288.525 248.094 289.325 247.694C288.681 247.294 288.177 246.781 287.812 246.155C287.464 245.529 287.29 244.799 287.29 243.964C287.29 242.955 287.542 242.077 288.046 241.329C288.568 240.564 289.316 239.964 290.29 239.529C291.281 239.094 292.481 238.877 293.89 238.877C295.299 238.877 296.49 239.094 297.464 239.529C298.438 239.947 299.177 240.538 299.681 241.303C300.186 242.051 300.438 242.929 300.438 243.938C300.438 244.773 300.264 245.503 299.916 246.129C299.568 246.755 299.081 247.277 298.455 247.694C299.272 248.077 299.925 248.651 300.412 249.416C300.899 250.164 301.142 251.042 301.142 252.051C301.142 253.147 300.855 254.12 300.281 254.973C299.725 255.807 298.899 256.468 297.803 256.955C296.725 257.425 295.42 257.66 293.89 257.66ZM293.89 254.947C294.568 254.947 295.177 254.833 295.716 254.607C296.272 254.364 296.707 254.025 297.02 253.59C297.351 253.155 297.516 252.642 297.516 252.051C297.516 251.442 297.351 250.929 297.02 250.512C296.707 250.077 296.272 249.747 295.716 249.52C295.177 249.277 294.568 249.155 293.89 249.155C293.212 249.155 292.594 249.277 292.038 249.52C291.499 249.747 291.064 250.077 290.733 250.512C290.42 250.929 290.264 251.442 290.264 252.051C290.264 252.642 290.42 253.155 290.733 253.59C291.064 254.025 291.499 254.364 292.038 254.607C292.594 254.833 293.212 254.947 293.89 254.947ZM293.89 246.573C294.464 246.555 294.986 246.442 295.455 246.233C295.942 246.025 296.325 245.747 296.603 245.399C296.899 245.033 297.046 244.599 297.046 244.094C297.046 243.59 296.907 243.155 296.629 242.79C296.368 242.407 295.994 242.112 295.507 241.903C295.038 241.694 294.499 241.59 293.89 241.59C293.281 241.59 292.733 241.694 292.246 241.903C291.777 242.112 291.403 242.407 291.125 242.79C290.864 243.155 290.733 243.59 290.733 244.094C290.733 244.599 290.864 245.033 291.125 245.399C291.403 245.764 291.777 246.051 292.246 246.26C292.733 246.468 293.281 246.573 293.89 246.573Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M274.371 294.572C274.371 286.204 281.155 279.42 289.523 279.42H315.669C324.037 279.42 330.821 286.204 330.821 294.572C330.821 302.94 324.037 309.724 315.669 309.724H289.523C281.155 309.724 274.371 302.94 274.371 294.572Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M274.371 294.572C274.371 286.204 281.155 279.42 289.523 279.42H315.669C324.037 279.42 330.821 286.204 330.821 294.572C330.821 302.94 324.037 309.724 315.669 309.724H289.523C281.155 309.724 274.371 302.94 274.371 294.572Z",
                                stroke: "#43A34D"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M311.375 298.462C311.27 298.462 311.182 298.43 311.109 298.368C311.046 298.295 311.015 298.206 311.015 298.102V287.709C311.015 287.604 311.046 287.521 311.109 287.458C311.182 287.385 311.27 287.349 311.375 287.349H312.157C312.272 287.349 312.361 287.385 312.423 287.458C312.486 287.521 312.517 287.604 312.517 287.709V291.356C312.799 291.001 313.143 290.714 313.55 290.495C313.957 290.276 314.474 290.166 315.1 290.166C315.778 290.166 316.352 290.317 316.822 290.62C317.302 290.912 317.662 291.324 317.902 291.856C318.152 292.378 318.277 292.989 318.277 293.688V298.102C318.277 298.206 318.246 298.295 318.183 298.368C318.121 298.43 318.032 298.462 317.917 298.462H317.135C317.03 298.462 316.942 298.43 316.869 298.368C316.806 298.295 316.775 298.206 316.775 298.102V293.766C316.775 293.036 316.597 292.467 316.242 292.06C315.888 291.643 315.366 291.434 314.677 291.434C314.03 291.434 313.509 291.643 313.112 292.06C312.716 292.467 312.517 293.036 312.517 293.766V298.102C312.517 298.206 312.486 298.295 312.423 298.368C312.361 298.43 312.272 298.462 312.157 298.462H311.375Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M304.994 301.905C304.284 301.905 303.7 301.811 303.241 301.623C302.792 301.436 302.437 301.206 302.176 300.935C301.926 300.674 301.743 300.408 301.629 300.136C301.524 299.876 301.467 299.667 301.456 299.51C301.446 299.406 301.477 299.317 301.55 299.244C301.634 299.171 301.722 299.135 301.816 299.135H302.568C302.662 299.135 302.74 299.156 302.802 299.197C302.865 299.239 302.917 299.328 302.959 299.463C303.022 299.62 303.115 299.792 303.241 299.98C303.366 300.178 303.559 300.345 303.82 300.481C304.081 300.627 304.446 300.7 304.915 300.7C305.406 300.7 305.818 300.632 306.152 300.496C306.486 300.371 306.736 300.142 306.903 299.808C307.081 299.484 307.169 299.036 307.169 298.462V297.397C306.919 297.721 306.59 297.992 306.183 298.211C305.776 298.42 305.265 298.524 304.649 298.524C304.065 298.524 303.564 298.425 303.147 298.227C302.729 298.018 302.385 297.742 302.114 297.397C301.853 297.043 301.655 296.641 301.519 296.192C301.394 295.743 301.321 295.274 301.3 294.783C301.289 294.491 301.289 294.204 301.3 293.923C301.321 293.432 301.394 292.963 301.519 292.514C301.655 292.065 301.853 291.663 302.114 291.309C302.385 290.954 302.729 290.677 303.147 290.479C303.564 290.27 304.065 290.166 304.649 290.166C305.275 290.166 305.792 290.286 306.199 290.526C306.616 290.756 306.955 291.037 307.216 291.371V290.698C307.216 290.594 307.248 290.505 307.31 290.432C307.383 290.359 307.472 290.323 307.576 290.323H308.296C308.401 290.323 308.489 290.359 308.562 290.432C308.635 290.505 308.672 290.594 308.672 290.698V298.289C308.672 298.989 308.552 299.609 308.312 300.152C308.082 300.695 307.696 301.123 307.154 301.436C306.622 301.749 305.902 301.905 304.994 301.905ZM304.962 297.272C305.484 297.272 305.902 297.152 306.215 296.912C306.538 296.672 306.773 296.369 306.919 296.004C307.075 295.639 307.159 295.269 307.169 294.893C307.18 294.747 307.185 294.569 307.185 294.361C307.185 294.142 307.18 293.959 307.169 293.813C307.159 293.437 307.075 293.067 306.919 292.702C306.773 292.336 306.538 292.034 306.215 291.794C305.902 291.554 305.484 291.434 304.962 291.434C304.441 291.434 304.023 291.554 303.71 291.794C303.397 292.023 303.173 292.331 303.037 292.717C302.902 293.093 302.823 293.5 302.802 293.938C302.792 294.209 302.792 294.486 302.802 294.768C302.823 295.206 302.902 295.618 303.037 296.004C303.173 296.38 303.397 296.688 303.71 296.928C304.023 297.157 304.441 297.272 304.962 297.272Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M298.229 298.462C298.125 298.462 298.036 298.431 297.963 298.368C297.901 298.295 297.869 298.206 297.869 298.102V290.683C297.869 290.578 297.901 290.495 297.963 290.432C298.036 290.359 298.125 290.323 298.229 290.323H298.981C299.085 290.323 299.168 290.359 299.231 290.432C299.294 290.495 299.325 290.578 299.325 290.683V298.102C299.325 298.206 299.294 298.295 299.231 298.368C299.168 298.431 299.085 298.462 298.981 298.462H298.229ZM298.104 288.804C298 288.804 297.911 288.773 297.838 288.711C297.775 288.638 297.744 288.549 297.744 288.444V287.599C297.744 287.495 297.775 287.411 297.838 287.349C297.911 287.276 298 287.239 298.104 287.239H299.09C299.195 287.239 299.278 287.276 299.341 287.349C299.414 287.411 299.45 287.495 299.45 287.599V288.444C299.45 288.549 299.414 288.638 299.341 288.711C299.278 288.773 299.195 288.804 299.09 288.804H298.104Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M287.274 298.461C287.159 298.461 287.071 298.43 287.008 298.367C286.945 298.294 286.914 298.206 286.914 298.101V287.881C286.914 287.766 286.945 287.677 287.008 287.614C287.071 287.541 287.159 287.505 287.274 287.505H288.072C288.187 287.505 288.276 287.541 288.338 287.614C288.411 287.677 288.448 287.766 288.448 287.881V292.201H293.832V287.881C293.832 287.766 293.864 287.677 293.926 287.614C293.999 287.541 294.088 287.505 294.192 287.505H294.991C295.105 287.505 295.194 287.541 295.257 287.614C295.33 287.677 295.366 287.766 295.366 287.881V298.101C295.366 298.206 295.33 298.294 295.257 298.367C295.194 298.43 295.105 298.461 294.991 298.461H294.192C294.088 298.461 293.999 298.43 293.926 298.367C293.864 298.294 293.832 298.206 293.832 298.101V293.609H288.448V298.101C288.448 298.206 288.411 298.294 288.338 298.367C288.276 298.43 288.187 298.461 288.072 298.461H287.274Z",
                                fill: "#028329"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_11334_36830",
                        x1: "0",
                        y1: "0",
                        x2: "405.966",
                        y2: "69.9204",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.32",
                                stopColor: "#DFD4F4",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFD4F4",
                                stopOpacity: "0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_11334_36830",
                        x1: "171.968",
                        y1: "178.347",
                        x2: "256.26",
                        y2: "324.344",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#01AE66",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_11334_36830",
                        x1: "182.213",
                        y1: "118.881",
                        x2: "288.787",
                        y2: "303.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#E19701"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF4451"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("clipPath", {
                        id: "clip0_11334_36830",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                            x: "0.205078",
                            width: "360",
                            height: "331",
                            rx: "8",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
var $2afc8d52b2677afe$export$2e2bcd8739ae039 = $2afc8d52b2677afe$var$SecurityPostureLightSvg;




function $eb37b80a8560b679$var$SecurityPostureLightTheme() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("svg", {
        width: "843",
        height: "331",
        viewBox: "0 0 843 331",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                clipPath: "url(#clip0_10626_42063)",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                        width: "843",
                        height: "331",
                        rx: "8",
                        transform: "matrix(1 0 0 -1 0 331.293)",
                        fill: "url(#paint0_linear_10626_42063)"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.75",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M672.6 512.811L616.954 305.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M754.843 417.811L699.197 210.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M484.088 505.811L428.441 298.137",
                                stroke: "#6888B5",
                                strokeLinecap: "round",
                                strokeDasharray: "8 8"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M425.791 290.684C409.69 299.365 390.34 317.496 381.932 325.747C379.386 328.245 378.916 332.128 380.699 335.217L450.33 455.821C452.539 459.647 457.431 460.958 461.258 458.749L948.718 177.314C952.544 175.105 953.855 170.212 951.646 166.386L863.854 14.3262C863.854 14.3262 835.808 65.1327 814.576 94.3661C794.152 122.489 782.3 138.105 757.75 161.331C725.728 191.626 699.251 196.298 666.318 225.366C636.966 251.274 638.926 301.327 597.226 299.59C573.659 298.609 559.625 278.276 535.403 272.388C488.868 261.078 462.864 270.695 425.791 290.684Z",
                                fill: "url(#paint1_linear_10626_42063)",
                                fillOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M377.687 330C377.687 330 404.563 302.129 425.791 290.684C462.864 270.695 488.868 261.078 535.403 272.388C559.625 278.276 573.659 298.609 597.226 299.59C638.926 301.327 636.966 251.274 666.318 225.366C699.251 196.298 725.728 191.626 757.75 161.331C782.3 138.105 794.152 122.489 814.576 94.3661C835.808 65.1327 863.854 14.3262 863.854 14.3262",
                                stroke: "url(#paint2_linear_10626_42063)",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "425.822",
                                cy: "288.895",
                                r: "5",
                                transform: "rotate(-30 425.822 288.895)",
                                fill: "#01AE66",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "614.444",
                                cy: "295.528",
                                r: "5",
                                transform: "rotate(-30 614.444 295.528)",
                                fill: "#E19701",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "696.217",
                                cy: "202.131",
                                r: "5",
                                transform: "rotate(-30 696.217 202.131)",
                                fill: "#E19701",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("circle", {
                                cx: "377.137",
                                cy: "329.704",
                                r: "5",
                                transform: "rotate(-30 377.137 329.704)",
                                fill: "#01AE66",
                                stroke: "#F2F4F8",
                                strokeWidth: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("g", {
                        opacity: "0.5",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M530.869 108.175C537.142 106.4 543.78 106.368 550.07 108.083C556.36 109.798 562.064 113.195 566.568 117.908C571.072 122.621 574.206 128.473 575.634 134.835C577.062 141.196 576.729 147.826 574.671 154.012C574.398 154.833 573.81 155.511 573.037 155.898C572.264 156.286 571.368 156.35 570.548 156.077L570.238 155.974C568.529 155.405 567.605 153.559 568.173 151.85C569.838 146.845 570.108 141.481 568.952 136.334C567.797 131.187 565.261 126.453 561.617 122.639C557.973 118.826 553.358 116.077 548.269 114.69C543.18 113.303 537.809 113.328 532.733 114.765C527.658 116.201 523.069 118.993 519.462 122.842C515.854 126.69 513.364 131.449 512.258 136.606C511.153 141.764 511.473 147.125 513.186 152.114C514.899 157.103 517.94 161.531 521.98 164.922C522.643 165.478 523.057 166.274 523.133 167.135C523.208 167.997 522.938 168.853 522.382 169.516L522.173 169.766C521.015 171.145 518.958 171.325 517.579 170.167C512.584 165.977 508.827 160.504 506.71 154.338C504.593 148.172 504.196 141.545 505.563 135.171C506.929 128.796 510.007 122.915 514.466 118.158C518.925 113.402 524.595 109.951 530.869 108.175Z",
                                fill: "#EBECF2"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M524.072 110.873C529.305 108.149 535.128 106.758 541.026 106.822C546.925 106.887 552.716 108.405 557.888 111.242C563.06 114.079 567.452 118.148 570.675 123.088C573.899 128.028 575.854 133.687 576.368 139.564C576.525 141.358 575.198 142.939 573.404 143.096L573.079 143.125C572.218 143.2 571.361 142.93 570.699 142.374C570.036 141.818 569.622 141.022 569.546 140.16C569.131 135.406 567.548 130.827 564.94 126.83C562.332 122.833 558.779 119.541 554.594 117.246C550.41 114.95 545.724 113.722 540.952 113.67C536.179 113.618 531.468 114.743 527.234 116.947C523.001 119.151 519.376 122.365 516.682 126.304C513.987 130.243 512.306 134.786 511.786 139.53C511.266 144.275 511.925 149.074 513.703 153.503C515.481 157.932 518.324 161.854 521.98 164.922C523.36 166.079 523.54 168.136 522.382 169.516L522.173 169.766C521.617 170.428 520.82 170.843 519.959 170.918C519.097 170.993 518.241 170.723 517.579 170.167C513.06 166.376 509.546 161.528 507.348 156.054C505.15 150.58 504.337 144.649 504.979 138.785C505.621 132.921 507.699 127.306 511.03 122.438C514.36 117.569 518.84 113.597 524.072 110.873Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M546.989 148.414C546.838 148.455 546.699 148.438 546.571 148.364C546.439 148.274 546.352 148.153 546.312 148.002C546.289 147.918 546.28 147.848 546.283 147.793C546.303 147.734 546.317 147.685 546.325 147.647L548.658 141.539C548.345 141.713 548.001 141.841 547.627 141.924C546.782 142.132 545.95 142.184 545.13 142.079C544.322 141.954 543.571 141.705 542.877 141.333C542.196 140.939 541.603 140.441 541.099 139.838C540.608 139.213 540.252 138.489 540.031 137.666C539.829 136.91 539.773 136.133 539.866 135.334C539.953 134.518 540.195 133.742 540.592 133.006C541.006 132.265 541.587 131.614 542.337 131.053C543.1 130.47 544.052 130.026 545.194 129.72C546.32 129.418 547.354 129.312 548.296 129.402C549.238 129.492 550.071 129.746 550.795 130.164C551.532 130.56 552.14 131.082 552.619 131.728C553.115 132.369 553.471 133.093 553.687 133.899C553.88 134.621 553.943 135.325 553.874 136.009C553.806 136.694 553.665 137.344 553.451 137.959C553.25 138.553 553.047 139.139 552.842 139.716L550.054 147.053C550.01 147.155 549.938 147.291 549.84 147.461C549.754 147.61 549.585 147.719 549.333 147.786L546.989 148.414ZM547.717 139.037C548.322 138.874 548.834 138.602 549.254 138.22C549.686 137.816 549.982 137.341 550.141 136.794C550.313 136.225 550.311 135.614 550.136 134.959C549.956 134.287 549.651 133.756 549.223 133.367C548.807 132.956 548.313 132.692 547.742 132.575C547.166 132.442 546.584 132.453 545.996 132.611C545.391 132.773 544.873 133.056 544.441 133.46C544.021 133.842 543.725 134.318 543.553 134.886C543.394 135.433 543.404 136.042 543.584 136.714C543.76 137.369 544.056 137.902 544.472 138.313C544.9 138.702 545.394 138.966 545.953 139.104C546.525 139.221 547.113 139.199 547.717 139.037Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M534.15 152.124C533.041 152.422 532.014 152.553 531.068 152.518C530.123 152.483 529.282 152.303 528.547 151.978C527.828 151.649 527.222 151.199 526.727 150.629C526.249 150.055 525.902 149.365 525.686 148.559C525.425 147.584 525.435 146.681 525.716 145.85C526.01 144.997 526.491 144.274 527.161 143.68C526.436 143.461 525.816 143.096 525.301 142.585C524.803 142.071 524.446 141.41 524.23 140.604C523.969 139.629 523.985 138.716 524.279 137.863C524.584 136.989 525.152 136.216 525.98 135.544C526.825 134.867 527.928 134.346 529.288 133.982C530.649 133.617 531.856 133.519 532.909 133.687C533.958 133.838 534.825 134.218 535.51 134.826C536.191 135.418 536.662 136.201 536.923 137.176C537.139 137.982 537.16 138.733 536.986 139.427C536.812 140.122 536.477 140.752 535.98 141.317C536.869 141.475 537.647 141.861 538.316 142.474C538.979 143.07 539.442 143.856 539.703 144.83C539.987 145.888 539.961 146.903 539.628 147.875C539.306 148.825 538.679 149.677 537.747 150.431C536.827 151.164 535.628 151.728 534.15 152.124ZM533.447 149.504C534.103 149.328 534.661 149.062 535.123 148.704C535.598 148.324 535.93 147.884 536.12 147.383C536.327 146.878 536.353 146.34 536.2 145.768C536.043 145.18 535.751 144.728 535.323 144.41C534.908 144.071 534.403 143.864 533.807 143.79C533.223 143.694 532.604 143.734 531.948 143.91C531.293 144.085 530.728 144.363 530.254 144.742C529.792 145.1 529.457 145.532 529.251 146.037C529.056 146.521 529.038 147.057 529.195 147.645C529.348 148.217 529.632 148.672 530.047 149.011C530.479 149.345 530.987 149.56 531.571 149.656C532.167 149.73 532.792 149.679 533.447 149.504ZM531.28 141.415C531.83 141.25 532.305 141.006 532.704 140.683C533.121 140.355 533.418 139.987 533.597 139.579C533.788 139.15 533.818 138.692 533.688 138.205C533.557 137.717 533.31 137.333 532.947 137.053C532.596 136.751 532.158 136.562 531.634 136.486C531.126 136.406 530.578 136.445 529.99 136.602C529.402 136.76 528.9 137.003 528.484 137.33C528.084 137.653 527.8 138.036 527.63 138.477C527.473 138.898 527.459 139.351 527.59 139.838C527.72 140.326 527.959 140.712 528.305 140.997C528.669 141.278 529.104 141.458 529.612 141.538C530.136 141.614 530.692 141.573 531.28 141.415Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M524.849 192.831C522.684 184.748 527.481 176.44 535.564 174.274L560.819 167.507C568.902 165.341 577.21 170.138 579.376 178.221C581.542 186.304 576.745 194.613 568.662 196.778L543.407 203.545C535.324 205.711 527.015 200.914 524.849 192.831Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M524.849 192.831C522.684 184.748 527.481 176.44 535.564 174.274L560.819 167.507C568.902 165.341 577.21 170.138 579.376 178.221C581.542 186.304 576.745 194.613 568.662 196.778L543.407 203.545C535.324 205.711 527.015 200.914 524.849 192.831Z",
                                stroke: "#43A34D"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M561.599 187.011C561.498 187.038 561.404 187.031 561.318 186.989C561.238 186.935 561.185 186.858 561.158 186.757L558.468 176.718C558.441 176.617 558.45 176.528 558.494 176.452C558.546 176.362 558.622 176.304 558.723 176.277L559.479 176.074C559.59 176.045 559.685 176.057 559.764 176.111C559.841 176.156 559.893 176.228 559.92 176.329L560.863 179.852C561.044 179.436 561.302 179.07 561.639 178.753C561.975 178.436 562.445 178.196 563.05 178.034C563.705 177.859 564.299 177.856 564.831 178.027C565.37 178.185 565.824 178.49 566.194 178.942C566.571 179.381 566.85 179.938 567.031 180.614L568.173 184.877C568.2 184.978 568.193 185.072 568.151 185.158C568.107 185.235 568.03 185.288 567.919 185.318L567.163 185.521C567.062 185.548 566.968 185.54 566.881 185.499C566.802 185.444 566.749 185.367 566.722 185.266L565.6 181.078C565.411 180.372 565.092 179.869 564.644 179.568C564.193 179.256 563.635 179.19 562.97 179.368C562.345 179.536 561.895 179.872 561.62 180.378C561.343 180.874 561.298 181.474 561.487 182.18L562.61 186.368C562.637 186.469 562.629 186.562 562.588 186.649C562.543 186.726 562.466 186.779 562.355 186.809L561.599 187.011Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M556.327 191.989C555.641 192.173 555.053 192.233 554.561 192.171C554.079 192.105 553.676 191.975 553.354 191.781C553.045 191.594 552.8 191.384 552.618 191.152C552.45 190.927 552.341 190.74 552.29 190.591C552.253 190.493 552.26 190.399 552.312 190.31C552.374 190.218 552.45 190.16 552.541 190.135L553.266 189.941C553.357 189.917 553.438 189.916 553.509 189.941C553.581 189.965 553.654 190.037 553.729 190.157C553.83 190.292 553.966 190.434 554.135 190.583C554.307 190.742 554.537 190.853 554.824 190.917C555.114 190.991 555.486 190.967 555.939 190.845C556.413 190.718 556.794 190.546 557.081 190.328C557.371 190.121 557.554 189.835 557.628 189.469C557.716 189.11 557.686 188.654 557.537 188.1L557.262 187.072C557.103 187.449 556.856 187.796 556.52 188.113C556.181 188.42 555.714 188.653 555.119 188.812C554.555 188.964 554.045 188.998 553.591 188.914C553.134 188.821 552.729 188.643 552.378 188.38C552.034 188.105 551.739 187.768 551.492 187.37C551.255 186.969 551.063 186.534 550.916 186.066C550.83 185.786 550.756 185.509 550.693 185.234C550.586 184.755 550.535 184.283 550.54 183.817C550.555 183.348 550.642 182.909 550.802 182.499C550.973 182.086 551.234 181.73 551.585 181.43C551.935 181.121 552.391 180.89 552.956 180.739C553.561 180.577 554.091 180.559 554.546 180.686C555.008 180.799 555.409 180.984 555.747 181.239L555.573 180.589C555.546 180.488 555.553 180.394 555.595 180.307C555.647 180.218 555.723 180.16 555.824 180.133L556.519 179.946C556.62 179.919 556.715 179.932 556.804 179.983C556.894 180.035 556.952 180.111 556.979 180.212L558.944 187.545C559.125 188.22 559.17 188.851 559.078 189.437C558.997 190.02 558.735 190.534 558.292 190.976C557.859 191.416 557.204 191.754 556.327 191.989ZM555.097 187.522C555.601 187.387 555.974 187.163 556.214 186.85C556.464 186.535 556.613 186.181 556.659 185.791C556.716 185.398 556.701 185.018 556.613 184.653C556.586 184.509 556.545 184.336 556.491 184.135C556.434 183.923 556.382 183.748 556.334 183.609C556.227 183.249 556.05 182.913 555.804 182.601C555.569 182.286 555.264 182.054 554.889 181.906C554.525 181.755 554.09 181.748 553.586 181.883C553.082 182.018 552.71 182.242 552.47 182.554C552.227 182.857 552.09 183.213 552.059 183.621C552.025 184.019 552.055 184.432 552.148 184.861C552.208 185.125 552.28 185.392 552.363 185.662C552.496 186.08 552.679 186.458 552.91 186.796C553.138 187.123 553.434 187.363 553.799 187.513C554.161 187.654 554.593 187.657 555.097 187.522Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M548.902 190.414C548.801 190.441 548.707 190.434 548.62 190.392C548.541 190.338 548.488 190.26 548.461 190.159L546.541 182.993C546.514 182.892 546.522 182.803 546.566 182.727C546.618 182.637 546.694 182.579 546.795 182.552L547.521 182.358C547.622 182.331 547.712 182.344 547.791 182.399C547.868 182.443 547.92 182.515 547.947 182.616L549.867 189.783C549.894 189.883 549.886 189.977 549.845 190.064C549.801 190.141 549.728 190.192 549.627 190.219L548.902 190.414ZM546.281 181.118C546.18 181.145 546.087 181.138 546 181.096C545.92 181.042 545.867 180.964 545.84 180.863L545.621 180.047C545.594 179.946 545.603 179.857 545.647 179.781C545.699 179.691 545.775 179.633 545.876 179.606L546.829 179.351C546.929 179.324 547.019 179.337 547.099 179.392C547.186 179.433 547.242 179.505 547.269 179.605L547.488 180.422C547.515 180.523 547.503 180.618 547.451 180.707C547.407 180.784 547.334 180.836 547.234 180.863L546.281 181.118Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M538.32 193.249C538.209 193.279 538.116 193.271 538.039 193.227C537.96 193.173 537.906 193.095 537.879 192.994L535.234 183.122C535.204 183.011 535.212 182.917 535.256 182.84C535.297 182.754 535.374 182.695 535.484 182.666L536.256 182.459C536.366 182.429 536.462 182.442 536.541 182.496C536.628 182.538 536.686 182.614 536.716 182.725L537.834 186.897L543.035 185.504L541.916 181.331C541.887 181.22 541.894 181.126 541.938 181.05C541.99 180.96 542.066 180.902 542.167 180.875L542.938 180.668C543.049 180.639 543.144 180.651 543.223 180.705C543.31 180.747 543.368 180.823 543.398 180.934L546.043 190.807C546.07 190.907 546.058 191.003 546.007 191.092C545.962 191.169 545.885 191.222 545.774 191.252L545.003 191.458C544.902 191.485 544.808 191.478 544.721 191.436C544.642 191.382 544.589 191.304 544.562 191.204L543.399 186.865L538.198 188.258L539.361 192.597C539.388 192.698 539.376 192.793 539.324 192.883C539.28 192.959 539.202 193.012 539.091 193.042L538.32 193.249Z",
                                fill: "#028329"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M721.336 99.6344C720.126 99.9585 719.05 100.096 718.108 100.046C717.186 99.9903 716.396 99.8238 715.738 99.5464C715.08 99.2689 714.564 98.9536 714.188 98.6005C713.813 98.2473 713.577 97.9324 713.481 97.6556C713.402 97.4392 713.416 97.2517 713.525 97.0929C713.648 96.9086 713.801 96.7921 713.982 96.7435L716.371 96.1034C716.452 96.0818 716.525 96.073 716.591 96.077C716.657 96.0809 716.753 96.1198 716.881 96.1936C717.203 96.3451 717.537 96.504 717.884 96.6703C718.251 96.8312 718.661 96.9483 719.112 97.0217C719.559 97.0749 720.084 97.0205 720.689 96.8585C721.475 96.6478 722.09 96.3211 722.533 95.8783C722.991 95.4099 723.142 94.8834 722.985 94.2988C722.871 93.8755 722.659 93.5652 722.347 93.368C722.055 93.1653 721.569 93.0469 720.89 93.0128C720.206 92.9585 719.257 92.9643 718.043 93.0303C716.844 93.0707 715.817 92.9893 714.963 92.786C714.11 92.5827 713.42 92.2272 712.895 91.7197C712.37 91.2122 712 90.5553 711.784 89.7489C711.573 88.9627 711.605 88.1548 711.88 87.325C712.169 86.4696 712.715 85.6859 713.518 84.9738C714.342 84.2563 715.449 83.7112 716.84 83.3385C717.928 83.0468 718.913 82.9341 719.795 83.0002C720.672 83.0462 721.426 83.2006 722.058 83.4633C722.711 83.7206 723.235 84.0232 723.63 84.3709C724.021 84.6984 724.266 85.0107 724.367 85.3077C724.447 85.524 724.435 85.7216 724.332 85.9006C724.223 86.0593 724.078 86.163 723.897 86.2116L721.659 86.8112C721.558 86.8382 721.462 86.8423 721.371 86.8236C721.279 86.8049 721.185 86.7761 721.088 86.7372C720.813 86.5951 720.514 86.4482 720.193 86.2967C719.871 86.1452 719.497 86.0401 719.071 85.9815C718.66 85.8973 718.151 85.9362 717.547 86.0982C716.781 86.3035 716.242 86.6315 715.931 87.0822C715.614 87.5128 715.523 87.98 715.658 88.484C715.75 88.8267 715.922 89.1047 716.173 89.3182C716.44 89.5061 716.895 89.6326 717.539 89.6977C718.183 89.7628 719.132 89.7569 720.386 89.6801C721.802 89.5602 722.967 89.6367 723.883 89.9099C724.814 90.1575 725.524 90.5505 726.014 91.089C726.519 91.6019 726.871 92.2313 727.071 92.9772C727.314 93.8843 727.26 94.7736 726.911 95.6452C726.581 96.5113 725.949 97.2965 725.014 98.0007C724.094 98.6793 722.868 99.2239 721.336 99.6344Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M709.441 102.498C708.231 102.822 707.156 102.883 706.216 102.681C705.277 102.479 704.494 102.019 703.87 101.301C703.24 100.562 702.757 99.568 702.422 98.3182L700.583 91.4542L698.194 92.0943C697.993 92.1483 697.802 92.1237 697.624 92.0204C697.445 91.9171 697.328 91.7646 697.274 91.563L696.804 89.8092C696.75 89.6077 696.775 89.4174 696.878 89.2385C696.981 89.0596 697.134 88.9431 697.335 88.8891L699.724 88.249L698.379 83.2296C698.325 83.028 698.34 82.8404 698.423 82.6669C698.526 82.488 698.689 82.3688 698.91 82.3094L701.36 81.6531C701.561 81.5991 701.752 81.6238 701.93 81.7271C702.109 81.8304 702.226 81.9828 702.28 82.1844L703.625 87.2038L707.405 86.1911C707.606 86.1371 707.796 86.1617 707.975 86.265C708.154 86.3683 708.271 86.5207 708.325 86.7223L708.795 88.4761C708.849 88.6777 708.824 88.8679 708.721 89.0469C708.617 89.2258 708.465 89.3422 708.263 89.3963L704.484 90.409L706.242 96.9706C706.463 97.7971 706.777 98.4044 707.184 98.7924C707.61 99.175 708.186 99.2691 708.912 99.0746L710.999 98.5156C711.2 98.4616 711.39 98.4862 711.569 98.5895C711.748 98.6928 711.865 98.8453 711.919 99.0468L712.421 100.922C712.475 101.123 712.45 101.313 712.347 101.492C712.244 101.671 712.091 101.788 711.89 101.842L709.441 102.498Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M684.368 109.216C684.167 109.27 683.977 109.245 683.798 109.142C683.619 109.039 683.502 108.886 683.448 108.685L679.624 94.4124C679.57 94.2108 679.595 94.0205 679.698 93.8416C679.801 93.6627 679.954 93.5462 680.155 93.4922L682.635 92.8278C682.836 92.7738 683.027 92.7985 683.206 92.9018C683.385 93.0051 683.501 93.1575 683.555 93.3591L683.887 94.5988C684.238 93.8133 684.761 93.1009 685.453 92.4615C686.161 91.7965 687.12 91.302 688.329 90.9779C689.559 90.6484 690.703 90.6444 691.761 90.9658C692.814 91.267 693.718 91.8567 694.472 92.735C695.246 93.6079 695.822 94.7499 696.2 96.161L698.476 104.658C698.53 104.859 698.506 105.05 698.403 105.229C698.299 105.407 698.147 105.524 697.945 105.578L695.284 106.291C695.083 106.345 694.892 106.32 694.714 106.217C694.535 106.114 694.418 105.961 694.364 105.76L692.136 97.4443C691.823 96.2751 691.285 95.4362 690.522 94.9276C689.779 94.4136 688.864 94.3025 687.775 94.5942C686.727 94.875 685.979 95.4318 685.533 96.2645C685.086 97.0972 685.019 98.0981 685.333 99.2673L687.561 107.583C687.615 107.784 687.59 107.974 687.487 108.153C687.383 108.332 687.231 108.449 687.029 108.503L684.368 109.216Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M676.396 111.352C676.194 111.406 676.004 111.382 675.825 111.278C675.646 111.175 675.53 111.022 675.476 110.821L671.651 96.5487C671.597 96.3471 671.622 96.1569 671.725 95.978C671.829 95.799 671.981 95.6826 672.183 95.6286L674.692 94.9561C674.914 94.8967 675.104 94.9213 675.263 95.03C675.442 95.1333 675.559 95.2858 675.613 95.4873L679.437 109.76C679.491 109.961 679.466 110.151 679.363 110.33C679.28 110.504 679.127 110.62 678.906 110.68L676.396 111.352ZM671.365 93.0605C671.143 93.1199 670.946 93.1081 670.772 93.0249C670.613 92.9162 670.504 92.751 670.445 92.5293L669.861 90.3522C669.807 90.1506 669.822 89.963 669.905 89.7895C670.008 89.6106 670.171 89.4914 670.393 89.432L673.144 88.6947C673.366 88.6353 673.566 88.6572 673.745 88.7605C673.924 88.8638 674.041 89.0163 674.095 89.2179L674.678 91.395C674.737 91.6167 674.716 91.8171 674.612 91.996C674.504 92.1547 674.338 92.2638 674.117 92.3232L671.365 93.0605Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M664.812 114.78C663.199 115.212 661.763 115.295 660.503 115.027C659.263 114.754 658.213 114.182 657.353 113.311C656.513 112.434 655.869 111.321 655.421 109.972C655.304 109.614 655.175 109.174 655.034 108.65C654.894 108.125 654.785 107.679 654.708 107.311C654.416 105.898 654.427 104.61 654.742 103.445C655.071 102.255 655.704 101.232 656.642 100.376C657.599 99.5144 658.864 98.873 660.436 98.4517C662.009 98.0304 663.415 97.9561 664.655 98.2289C665.915 98.4962 666.975 99.0656 667.835 99.9371C668.709 100.783 669.374 101.891 669.827 103.26C669.944 103.617 670.073 104.058 670.214 104.582C670.354 105.106 670.463 105.553 670.54 105.921C670.826 107.313 670.815 108.602 670.506 109.786C670.217 110.966 669.594 111.986 668.636 112.848C667.699 113.704 666.424 114.348 664.812 114.78ZM664.009 111.787C665.078 111.5 665.815 110.946 666.222 110.124C666.622 109.282 666.678 108.198 666.387 106.872C666.326 106.564 666.231 106.168 666.101 105.684C665.972 105.2 665.856 104.81 665.755 104.513C665.349 103.239 664.762 102.338 663.993 101.809C663.225 101.28 662.307 101.159 661.238 101.445C660.17 101.732 659.435 102.296 659.034 103.138C658.633 103.98 658.576 105.054 658.861 106.36C658.922 106.668 659.017 107.064 659.147 107.548C659.276 108.031 659.392 108.422 659.493 108.719C659.904 110.013 660.494 110.924 661.263 111.453C662.025 111.962 662.941 112.073 664.009 111.787Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M641.497 126.861C641.295 126.915 641.105 126.89 640.926 126.787C640.747 126.684 640.631 126.531 640.577 126.33L635.213 106.312C635.159 106.111 635.184 105.92 635.287 105.742C635.39 105.563 635.543 105.446 635.744 105.392L638.133 104.752C638.355 104.693 638.545 104.717 638.704 104.826C638.883 104.929 638.999 105.082 639.053 105.283L639.377 106.493C639.688 105.718 640.18 105.014 640.853 104.38C641.526 103.746 642.447 103.272 643.616 102.959C644.684 102.673 645.657 102.595 646.535 102.728C647.413 102.86 648.201 103.178 648.898 103.683C649.589 104.167 650.192 104.805 650.707 105.596C651.221 106.387 651.639 107.302 651.96 108.339C652.072 108.676 652.177 109.026 652.274 109.389C652.371 109.752 652.459 110.118 652.536 110.486C652.786 111.499 652.885 112.477 652.836 113.419C652.78 114.342 652.567 115.198 652.195 115.989C651.839 116.755 651.316 117.424 650.627 117.998C649.938 118.571 649.059 119.001 647.991 119.287C646.902 119.579 645.924 119.636 645.055 119.458C644.181 119.26 643.416 118.904 642.759 118.388L644.598 125.252C644.652 125.454 644.628 125.644 644.524 125.823C644.441 125.996 644.289 126.113 644.067 126.172L641.497 126.861ZM646.005 116.352C646.872 116.119 647.499 115.757 647.885 115.264C648.266 114.752 648.477 114.166 648.516 113.507C648.576 112.843 648.529 112.143 648.375 111.406C648.253 110.791 648.091 110.186 647.889 109.592C647.654 108.877 647.344 108.247 646.961 107.702C646.597 107.151 646.125 106.759 645.544 106.526C644.957 106.272 644.231 106.262 643.364 106.494C642.537 106.716 641.913 107.088 641.492 107.611C641.091 108.129 640.85 108.723 640.77 109.393C640.705 110.037 640.736 110.677 640.863 111.312C640.94 111.681 641.033 112.066 641.141 112.47C641.249 112.873 641.364 113.263 641.487 113.641C641.669 114.24 641.967 114.787 642.38 115.281C642.788 115.755 643.293 116.106 643.894 116.334C644.495 116.562 645.199 116.568 646.005 116.352Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M618.262 126.929C618.081 126.977 617.913 126.957 617.76 126.869C617.601 126.76 617.497 126.615 617.449 126.434C617.427 126.353 617.423 126.257 617.436 126.145L620.268 107.562L610.773 110.106C610.551 110.165 610.351 110.143 610.172 110.04C610.013 109.931 609.907 109.776 609.853 109.575L609.286 107.458C609.226 107.236 609.238 107.039 609.321 106.865C609.424 106.686 609.587 106.567 609.809 106.508L623.083 102.951C623.305 102.891 623.495 102.916 623.654 103.025C623.833 103.128 623.952 103.291 624.011 103.512L624.514 105.387C624.589 105.669 624.624 105.919 624.617 106.137C624.626 106.329 624.617 106.537 624.59 106.76L621.787 125.206C621.764 125.364 621.697 125.555 621.584 125.779C621.486 125.978 621.296 126.116 621.014 126.191L618.262 126.929Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M604.949 129.427C604.747 129.481 604.557 129.456 604.378 129.353C604.199 129.249 604.083 129.097 604.029 128.895L602.449 122.999L596.643 124.555C596.442 124.609 596.251 124.584 596.072 124.481C595.893 124.377 595.777 124.225 595.723 124.023L595.294 122.421C595.234 122.199 595.259 122.009 595.367 121.85C595.471 121.671 595.623 121.555 595.825 121.501L601.63 119.945L600.091 114.2C600.037 113.998 600.062 113.808 600.165 113.629C600.268 113.45 600.421 113.334 600.622 113.28L602.376 112.81C602.598 112.75 602.788 112.775 602.947 112.884C603.126 112.987 603.242 113.139 603.296 113.341L604.836 119.086L610.641 117.53C610.843 117.476 611.033 117.501 611.212 117.604C611.386 117.688 611.502 117.84 611.561 118.062L611.991 119.664C612.045 119.866 612.02 120.056 611.917 120.235C611.814 120.414 611.661 120.53 611.46 120.584L605.654 122.14L607.234 128.036C607.288 128.238 607.263 128.428 607.16 128.607C607.077 128.781 606.924 128.897 606.703 128.957L604.949 129.427Z",
                                fill: "#212328"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M718.535 132.577C717.783 132.778 717.113 132.857 716.525 132.813C715.937 132.769 715.439 132.658 715.031 132.479C714.623 132.3 714.295 132.1 714.049 131.878C713.815 131.652 713.67 131.461 713.614 131.303C713.561 131.159 713.577 131.032 713.663 130.922C713.749 130.813 713.846 130.744 713.953 130.715L714.84 130.477C714.921 130.456 714.985 130.453 715.032 130.469C715.09 130.468 715.171 130.504 715.277 130.576C715.502 130.718 715.747 130.854 716.013 130.984C716.278 131.115 716.582 131.199 716.923 131.237C717.278 131.272 717.691 131.226 718.161 131.1C718.847 130.916 719.377 130.637 719.752 130.263C720.123 129.875 720.241 129.426 720.104 128.916C720.014 128.58 719.848 128.336 719.606 128.185C719.377 128.03 719.006 127.935 718.492 127.9C717.992 127.861 717.315 127.862 716.462 127.904C715.605 127.932 714.906 127.874 714.364 127.731C713.818 127.575 713.393 127.336 713.091 127.014C712.785 126.678 712.567 126.268 712.437 125.784C712.304 125.287 712.324 124.771 712.497 124.234C712.667 123.685 712.994 123.187 713.48 122.74C713.978 122.289 714.658 121.949 715.518 121.718C716.217 121.531 716.838 121.458 717.382 121.5C717.926 121.541 718.395 121.653 718.79 121.835C719.181 122.004 719.491 122.195 719.721 122.407C719.951 122.619 720.096 122.811 720.156 122.982C720.205 123.112 720.196 123.238 720.127 123.357C720.054 123.463 719.958 123.532 719.837 123.564L718.99 123.791C718.896 123.816 718.81 123.818 718.732 123.795C718.667 123.769 718.601 123.737 718.533 123.697C718.352 123.559 718.144 123.427 717.909 123.303C717.687 123.175 717.414 123.097 717.09 123.069C716.775 123.023 716.382 123.064 715.912 123.19C715.24 123.37 714.774 123.646 714.514 124.018C714.253 124.39 714.181 124.792 714.296 125.222C714.364 125.477 714.5 125.686 714.701 125.848C714.903 126.01 715.234 126.115 715.694 126.165C716.154 126.215 716.819 126.224 717.689 126.192C718.623 126.129 719.385 126.177 719.974 126.336C720.564 126.495 721.019 126.74 721.338 127.072C721.658 127.405 721.886 127.826 722.023 128.337C722.174 128.901 722.145 129.463 721.935 130.024C721.738 130.581 721.355 131.087 720.786 131.542C720.226 131.98 719.476 132.325 718.535 132.577Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M706.926 139.577C706.818 139.606 706.714 139.591 706.611 139.532C706.509 139.473 706.444 139.389 706.415 139.282C706.4 139.228 706.393 139.173 706.392 139.115C706.391 139.058 706.4 138.983 706.418 138.892L706.982 134.787L700.696 126.727C700.585 126.584 700.521 126.479 700.503 126.412C700.471 126.291 700.484 126.179 700.543 126.077C700.602 125.975 700.692 125.907 700.813 125.875L701.801 125.61C701.935 125.574 702.052 125.579 702.15 125.625C702.249 125.67 702.324 125.736 702.376 125.823L707.407 132.34L708.585 124.16C708.6 124.055 708.632 123.96 708.682 123.874C708.744 123.786 708.849 123.721 708.997 123.682L709.945 123.428C710.066 123.396 710.177 123.409 710.28 123.468C710.382 123.527 710.447 123.61 710.476 123.718C710.494 123.785 710.493 123.915 710.473 124.108L708.285 138.845C708.27 138.95 708.232 139.047 708.169 139.136C708.12 139.221 708.021 139.284 707.873 139.323L706.926 139.577Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M696.136 138.579C695.464 138.759 694.817 138.788 694.194 138.667C693.571 138.546 693.03 138.302 692.572 137.935C692.113 137.568 691.807 137.096 691.652 136.518C691.403 135.591 691.582 134.751 692.187 133.998C692.792 133.245 693.675 132.62 694.838 132.121L697.728 130.893L697.572 130.308C697.399 129.663 697.076 129.209 696.602 128.947C696.142 128.682 695.495 128.661 694.662 128.884C694.057 129.046 693.599 129.298 693.288 129.641C692.99 129.98 692.817 130.358 692.77 130.774C692.744 130.997 692.63 131.135 692.428 131.189L691.521 131.432C691.373 131.472 691.248 131.462 691.146 131.403C691.053 131.327 690.991 131.229 690.959 131.108C690.904 130.906 690.912 130.638 690.98 130.303C691.062 129.964 691.227 129.61 691.474 129.241C691.721 128.873 692.068 128.528 692.514 128.206C692.971 127.868 693.562 127.601 694.288 127.407C695.094 127.191 695.802 127.117 696.41 127.184C697.015 127.238 697.519 127.398 697.922 127.665C698.338 127.928 698.673 128.263 698.926 128.67C699.193 129.074 699.387 129.505 699.51 129.962L701.26 136.493C701.296 136.627 701.279 136.754 701.211 136.873C701.152 136.976 701.055 137.045 700.92 137.081L699.993 137.329C699.845 137.369 699.72 137.359 699.618 137.3C699.512 137.228 699.441 137.124 699.405 136.99L699.173 136.123C699.063 136.412 698.893 136.717 698.662 137.038C698.427 137.346 698.11 137.639 697.71 137.92C697.306 138.186 696.781 138.406 696.136 138.579ZM696.155 136.953C696.706 136.806 697.179 136.557 697.575 136.206C697.967 135.841 698.224 135.376 698.346 134.811C698.482 134.241 698.448 133.58 698.247 132.828L698.096 132.263L695.849 133.233C694.931 133.623 694.273 134.044 693.876 134.496C693.475 134.935 693.339 135.396 693.469 135.88C693.57 136.256 693.762 136.543 694.045 136.741C694.338 136.922 694.669 137.027 695.038 137.058C695.419 137.086 695.792 137.051 696.155 136.953Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M685.055 141.548C684.315 141.746 683.643 141.79 683.037 141.678C682.427 141.554 681.888 141.316 681.42 140.966C680.962 140.599 680.568 140.15 680.238 139.619C679.922 139.085 679.664 138.498 679.464 137.861C679.393 137.649 679.333 137.449 679.282 137.261C679.232 137.073 679.185 136.87 679.14 136.651C678.998 136.012 678.93 135.382 678.936 134.761C678.956 134.137 679.073 133.551 679.287 133.004C679.514 132.453 679.862 131.978 680.331 131.579C680.796 131.166 681.399 130.861 682.138 130.663C682.931 130.45 683.627 130.415 684.227 130.557C684.826 130.698 685.35 130.933 685.798 131.259L684.555 126.623C684.519 126.488 684.531 126.37 684.59 126.268C684.659 126.148 684.76 126.071 684.895 126.035L685.862 125.775C685.997 125.739 686.117 125.758 686.223 125.83C686.338 125.886 686.414 125.981 686.45 126.115L690.037 139.5C690.073 139.635 690.056 139.761 689.988 139.881C689.929 139.983 689.832 140.052 689.697 140.088L688.79 140.331C688.642 140.371 688.517 140.361 688.415 140.302C688.309 140.229 688.238 140.126 688.202 139.992L687.976 139.145C687.755 139.665 687.415 140.145 686.957 140.585C686.495 141.011 685.861 141.332 685.055 141.548ZM685.04 139.802C685.712 139.622 686.208 139.323 686.529 138.906C686.849 138.489 687.047 138.018 687.123 137.494C687.195 136.956 687.171 136.437 687.051 135.936C687.007 135.717 686.945 135.46 686.866 135.164C686.783 134.855 686.706 134.595 686.635 134.384C686.495 133.917 686.257 133.484 685.92 133.085C685.596 132.682 685.186 132.388 684.69 132.204C684.207 132.017 683.644 132.009 682.999 132.182C682.313 132.366 681.81 132.666 681.49 133.083C681.166 133.487 680.983 133.961 680.942 134.505C680.897 135.035 680.936 135.586 681.061 136.158C681.152 136.551 681.256 136.941 681.374 137.327C681.552 137.885 681.795 138.388 682.103 138.839C682.407 139.276 682.803 139.595 683.289 139.796C683.771 139.984 684.355 139.986 685.04 139.802Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M668.386 146.015C667.459 146.263 666.635 146.333 665.914 146.223C665.203 146.097 664.578 145.832 664.038 145.43C663.498 145.027 663.045 144.522 662.681 143.914C662.33 143.302 662.042 142.63 661.817 141.898C661.706 141.539 661.59 141.159 661.468 140.76C661.36 140.357 661.252 139.954 661.144 139.55C661.046 139.13 660.953 138.73 660.866 138.35C660.681 137.607 660.595 136.882 660.607 136.173C660.628 135.447 660.767 134.783 661.024 134.181C661.29 133.563 661.708 133.026 662.277 132.571C662.843 132.102 663.583 131.745 664.497 131.501C665.424 131.252 666.243 131.191 666.954 131.317C667.675 131.427 668.305 131.683 668.845 132.086C669.382 132.475 669.834 132.98 670.202 133.602C670.58 134.206 670.875 134.876 671.086 135.612C671.201 135.984 671.314 136.379 671.425 136.796C671.547 137.195 671.655 137.598 671.749 138.005C671.857 138.408 671.953 138.793 672.037 139.16C672.222 139.902 672.301 140.63 672.276 141.342C672.264 142.051 672.125 142.715 671.859 143.334C671.606 143.949 671.197 144.491 670.631 144.959C670.075 145.411 669.327 145.763 668.386 146.015ZM667.927 144.301C668.975 144.02 669.656 143.471 669.97 142.652C670.293 141.816 670.301 140.799 669.994 139.599C669.917 139.202 669.829 138.822 669.732 138.459C669.631 138.083 669.532 137.713 669.435 137.351C669.334 136.974 669.222 136.608 669.097 136.253C668.771 135.087 668.258 134.223 667.56 133.661C666.872 133.082 666.004 132.933 664.956 133.214C663.921 133.491 663.244 134.054 662.924 134.904C662.614 135.736 662.602 136.74 662.889 137.916C662.986 138.279 663.078 138.651 663.166 139.03C663.263 139.393 663.362 139.763 663.463 140.139C663.573 140.498 663.681 140.873 663.785 141.263C664.133 142.451 664.655 143.327 665.353 143.889C666.048 144.437 666.905 144.575 667.927 144.301Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M655.896 149.361C655.05 149.588 654.284 149.686 653.598 149.653C652.909 149.607 652.302 149.467 651.778 149.233C651.255 148.999 650.823 148.704 650.483 148.349C650.156 147.99 649.927 147.59 649.794 147.151C649.762 147.03 649.777 146.925 649.84 146.836C649.902 146.747 649.994 146.687 650.115 146.654L651.103 146.389C651.224 146.357 651.339 146.355 651.447 146.384C651.556 146.412 651.667 146.505 651.781 146.662C652.045 147.109 652.374 147.424 652.769 147.607C653.177 147.786 653.61 147.871 654.069 147.863C654.538 147.839 654.994 147.767 655.437 147.648C656.364 147.399 657.058 146.976 657.517 146.378C657.976 145.779 658.09 145.05 657.86 144.19C657.626 143.317 657.196 142.762 656.571 142.526C655.946 142.29 655.17 142.296 654.243 142.545L652.328 143.058C652.193 143.094 652.068 143.084 651.953 143.029C651.85 142.97 651.779 142.867 651.74 142.719L651.594 142.174C651.562 142.053 651.555 141.947 651.573 141.856C651.602 141.747 651.634 141.652 651.67 141.571L654.435 136.249L648.489 137.843C648.354 137.879 648.229 137.869 648.114 137.814C648.011 137.755 647.94 137.651 647.901 137.503L647.696 136.737C647.656 136.589 647.666 136.464 647.725 136.362C647.794 136.243 647.895 136.165 648.03 136.129L656.073 133.974C656.221 133.934 656.347 133.951 656.453 134.023C656.569 134.079 656.647 134.18 656.686 134.328L656.881 135.054C656.906 135.148 656.902 135.243 656.87 135.338C656.848 135.416 656.819 135.495 656.783 135.577L654.054 140.953L654.382 140.887C655.276 140.676 656.092 140.631 656.83 140.75C657.581 140.865 658.217 141.17 658.738 141.664C659.27 142.141 659.654 142.823 659.892 143.71C660.133 144.611 660.118 145.443 659.848 146.207C659.573 146.957 659.091 147.605 658.402 148.15C657.713 148.695 656.877 149.099 655.896 149.361Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M642.603 152.707C641.85 152.909 641.201 152.931 640.655 152.775C640.106 152.606 639.653 152.288 639.298 151.821C638.938 151.341 638.662 150.738 638.467 150.013L637.041 144.691L635.469 145.112C635.335 145.148 635.209 145.138 635.094 145.083C634.988 145.01 634.917 144.907 634.881 144.773L634.697 144.087C634.661 143.953 634.673 143.835 634.732 143.732C634.801 143.613 634.902 143.535 635.037 143.499L636.609 143.078L635.707 139.712C635.671 139.577 635.683 139.459 635.742 139.357C635.811 139.237 635.912 139.16 636.047 139.124L636.994 138.87C637.128 138.834 637.248 138.852 637.354 138.924C637.47 138.98 637.546 139.075 637.582 139.209L638.484 142.576L640.984 141.906C641.118 141.87 641.238 141.888 641.344 141.961C641.46 142.016 641.535 142.111 641.571 142.245L641.755 142.931C641.791 143.065 641.775 143.192 641.706 143.311C641.647 143.413 641.55 143.483 641.416 143.519L638.916 144.188L640.304 149.369C640.473 150.001 640.714 150.469 641.026 150.774C641.339 151.08 641.77 151.158 642.321 151.011L643.551 150.681C643.685 150.645 643.805 150.664 643.911 150.736C644.027 150.791 644.103 150.886 644.139 151.021L644.333 151.746C644.369 151.881 644.353 152.008 644.284 152.127C644.225 152.229 644.128 152.298 643.994 152.334L642.603 152.707Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M631.937 155.781C631.184 155.983 630.514 156.061 629.926 156.017C629.338 155.973 628.84 155.862 628.432 155.683C628.024 155.504 627.697 155.304 627.45 155.082C627.217 154.856 627.072 154.665 627.015 154.507C626.962 154.363 626.978 154.236 627.064 154.126C627.15 154.017 627.247 153.948 627.354 153.919L628.241 153.681C628.322 153.66 628.386 153.657 628.434 153.673C628.491 153.672 628.573 153.708 628.678 153.78C628.904 153.922 629.149 154.058 629.414 154.188C629.68 154.319 629.983 154.403 630.325 154.441C630.68 154.476 631.092 154.43 631.563 154.304C632.248 154.12 632.778 153.841 633.153 153.467C633.525 153.08 633.642 152.63 633.505 152.12C633.415 151.784 633.249 151.54 633.007 151.389C632.778 151.234 632.407 151.139 631.894 151.104C631.393 151.065 630.717 151.066 629.864 151.108C629.007 151.136 628.307 151.078 627.765 150.936C627.219 150.779 626.795 150.54 626.492 150.218C626.186 149.882 625.968 149.472 625.839 148.989C625.706 148.491 625.726 147.975 625.899 147.438C626.068 146.889 626.396 146.391 626.881 145.944C627.38 145.493 628.059 145.153 628.919 144.922C629.618 144.735 630.239 144.662 630.784 144.704C631.328 144.745 631.797 144.857 632.191 145.039C632.582 145.208 632.893 145.399 633.122 145.611C633.352 145.823 633.497 146.015 633.557 146.186C633.607 146.317 633.597 146.442 633.528 146.561C633.456 146.667 633.359 146.736 633.238 146.768L632.391 146.995C632.297 147.02 632.211 147.022 632.133 146.999C632.069 146.974 632.002 146.941 631.934 146.902C631.753 146.763 631.545 146.631 631.31 146.507C631.088 146.379 630.815 146.301 630.491 146.273C630.176 146.227 629.784 146.268 629.313 146.394C628.642 146.574 628.175 146.85 627.915 147.222C627.655 147.595 627.582 147.996 627.697 148.426C627.766 148.681 627.901 148.89 628.103 149.052C628.305 149.214 628.635 149.32 629.095 149.369C629.555 149.419 630.22 149.428 631.09 149.396C632.024 149.333 632.786 149.381 633.376 149.54C633.966 149.699 634.42 149.944 634.74 150.277C635.059 150.609 635.287 151.03 635.424 151.541C635.575 152.105 635.546 152.668 635.336 153.228C635.14 153.785 634.757 154.291 634.187 154.746C633.628 155.184 632.877 155.529 631.937 155.781Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M620.109 158.95C619.437 159.13 618.79 159.16 618.167 159.039C617.544 158.918 617.003 158.674 616.544 158.307C616.086 157.94 615.779 157.467 615.625 156.889C615.376 155.962 615.554 155.122 616.159 154.37C616.764 153.617 617.648 152.991 618.811 152.492L621.701 151.264L621.544 150.68C621.371 150.035 621.048 149.581 620.575 149.319C620.115 149.053 619.468 149.032 618.635 149.255C618.03 149.418 617.572 149.67 617.26 150.013C616.962 150.352 616.79 150.729 616.743 151.145C616.716 151.368 616.602 151.507 616.401 151.561L615.493 151.804C615.346 151.844 615.221 151.834 615.118 151.775C615.026 151.699 614.964 151.6 614.931 151.479C614.877 151.278 614.884 151.009 614.953 150.674C615.035 150.335 615.2 149.981 615.447 149.613C615.693 149.244 616.04 148.899 616.487 148.578C616.944 148.239 617.535 147.973 618.261 147.779C619.067 147.562 619.774 147.488 620.383 147.556C620.988 147.609 621.492 147.77 621.895 148.036C622.311 148.299 622.646 148.635 622.899 149.042C623.165 149.446 623.36 149.876 623.482 150.333L625.232 156.865C625.268 156.999 625.252 157.126 625.183 157.245C625.124 157.347 625.027 157.416 624.893 157.452L623.966 157.701C623.818 157.741 623.693 157.731 623.591 157.672C623.485 157.599 623.414 157.496 623.378 157.361L623.146 156.495C623.036 156.783 622.865 157.088 622.635 157.409C622.4 157.717 622.083 158.011 621.682 158.291C621.279 158.558 620.754 158.778 620.109 158.95ZM620.127 157.325C620.678 157.177 621.152 156.928 621.547 156.577C621.939 156.213 622.197 155.748 622.319 155.182C622.454 154.613 622.421 153.952 622.219 153.199L622.068 152.635L619.822 153.604C618.904 153.994 618.246 154.415 617.848 154.868C617.447 155.306 617.312 155.768 617.441 156.251C617.542 156.628 617.734 156.915 618.018 157.112C618.311 157.293 618.642 157.399 619.01 157.43C619.392 157.457 619.764 157.422 620.127 157.325Z",
                                fill: "#717385"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                                d: "M606.499 162.381C606.351 162.421 606.226 162.411 606.123 162.352C606.018 162.28 605.947 162.176 605.911 162.042L602.378 148.858C602.342 148.724 602.354 148.605 602.413 148.503C602.468 148.388 602.57 148.31 602.718 148.27L603.786 147.984C603.92 147.948 604.04 147.966 604.146 148.039C604.249 148.098 604.318 148.194 604.354 148.329L607.541 160.222L614.253 158.424C614.401 158.384 614.528 158.4 614.634 158.473C614.736 158.532 614.807 158.635 614.847 158.783L615.063 159.59C615.099 159.724 615.089 159.849 615.033 159.965C614.974 160.067 614.871 160.138 614.723 160.177L606.499 162.381Z",
                                fill: "#717385"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint0_linear_10626_42063",
                        x1: "0",
                        y1: "331",
                        x2: "845.045",
                        y2: "5.30653",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.32",
                                stopColor: "#CFD9E9",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#CFD9E9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint1_linear_10626_42063",
                        x1: "579.763",
                        y1: "178.346",
                        x2: "664.055",
                        y2: "324.343",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#01AE66",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("linearGradient", {
                        id: "paint2_linear_10626_42063",
                        x1: "590.008",
                        y1: "118.881",
                        x2: "696.582",
                        y2: "303.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                stopColor: "#01AE66"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#E19701"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF4451"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("clipPath", {
                        id: "clip0_10626_42063",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("rect", {
                            width: "843",
                            height: "331",
                            rx: "8",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
var $eb37b80a8560b679$export$2e2bcd8739ae039 = $eb37b80a8560b679$var$SecurityPostureLightTheme;



function $962626994e07d893$var$RenderSecurityPostureSvgForSmallerDevice({ theme: theme }) {
    return theme ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SecurityPostureDarkSvg",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $4c772b0940250d83$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SecurityPostureLightSvg",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $2afc8d52b2677afe$export$2e2bcd8739ae039), {})
    });
}
function $962626994e07d893$var$RenderSecurityPostureSvgForLargerDevice({ theme: theme }) {
    return theme ? /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SecurityPostureDarkTheme",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $035d20266e4aab5d$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SecurityPostureLightTheme",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $eb37b80a8560b679$export$2e2bcd8739ae039), {})
    });
}
function $962626994e07d893$var$SecurityPosture({ isAnimate: isAnimate }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const [windowWidth, setWindowWidth] = (0, $cURGa$useState)(window.innerWidth);
    (0, $cURGa$useEffect)(()=>{
        const handleResize = ()=>{
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const isSmallScreen = windowWidth <= 1100 && !isAnimate;
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-SecurityPosture-container",
        children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: (0, $cURGa$classnames)("Ispm-SecurityPosture-container-wrapper", {
                animateIn: isAnimate
            }),
            children: [
                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-SecurityPosture-container-securityPosture",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-SecurityPosture-container-comingSoonPosture",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body1",
                                lineLimit: 1,
                                color: "--color-foreground-info-medium",
                                children: l("COMING SOON")
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "h1",
                                lineLimit: 1,
                                color: "--color-foreground-neutral-bold",
                                children: l("Security Posture Index")
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-SecurityPosture-container-insightsPosture",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body2",
                                color: "--color-foreground-neutral-medium",
                                children: l("Get insights into your organization\u2019s security health to help strengthen your defenses. An index score will give you a quick look at your organization\u2019s overall security posture.")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: `Ispm-SecurityPosture-container-themePosture-${isSmallScreen ? "small" : "large"}`,
                    children: isSmallScreen ? /*#__PURE__*/ (0, $cURGa$jsx)($962626994e07d893$var$RenderSecurityPostureSvgForSmallerDevice, {
                        theme: theme
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)($962626994e07d893$var$RenderSecurityPostureSvgForLargerDevice, {
                        theme: theme
                    })
                })
            ]
        })
    });
}
var $962626994e07d893$export$2e2bcd8739ae039 = $962626994e07d893$var$SecurityPosture;


/* eslint-disable jsx-a11y/anchor-is-valid */ 



/* eslint-disable react/jsx-curly-newline */ 
















const $465279be07379876$var$PopoverTrigger = /*#__PURE__*/ (0, $cURGa$memo)(({ onHover: onHover, text: text })=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
        role: "button",
        tabIndex: 0,
        onMouseEnter: onHover,
        className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle-popoverCell",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $8ff2252602deef38$export$881f1645f5c6e7a7), {
            htmlString: text || ""
        })
    }));
const $465279be07379876$var$PopoverContent = /*#__PURE__*/ (0, $cURGa$memo)(({ label: label, text: text, tooltipProps: tooltipProps, onCopy: onCopy, onClose: onClose })=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
        className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle-popoverCell-wrapper",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle-popoverCell-header",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        lineLimit: 1,
                        kind: "h3",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                        className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle-popoverCell-iconsWrapper",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                text: tooltipProps.text,
                                placement: tooltipProps.placement,
                                closeDelayAfterClick: tooltipProps.closeDelayAfterClick,
                                onClose: tooltipProps.onClose,
                                isDisabled: tooltipProps.text === (0, $8ff2252602deef38$export$fac9e12d2d376b6),
                                trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                    dataTestId: "WidgetTableModalPopoverCopyButton",
                                    kind: "icon",
                                    size: "medium",
                                    type: "ghost",
                                    leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: tooltipProps.text === (0, $8ff2252602deef38$export$fac9e12d2d376b6) ? "check" : (0, $8ff2252602deef38$export$29d95a5fba76aeb4),
                                        size: "medium"
                                    }),
                                    onClick: onCopy
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                                dataTestId: "WidgetTableModalPopoverCloseButton",
                                size: "small",
                                kind: "ghost",
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: "close",
                                    size: "small"
                                }),
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                kind: "body2",
                color: "--color-foreground-neutral-bold",
                className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle",
                children: String(text ?? "")
            })
        ]
    }));
const $465279be07379876$var$EnhancedPopover = /*#__PURE__*/ (0, $cURGa$memo)(({ rowIndex: rowIndex, text: text, label: label })=>{
    const [activePopoverRow, setActivePopoverRow] = (0, $cURGa$useState)(null);
    const { tooltipText: tooltipText, handleTooltipTriggerClick: handleTooltipTriggerClick, handleTooltipClose: handleTooltipClose, tooltipCloseDelayAfterClick: tooltipCloseDelayAfterClick } = (0, $cURGa$useTooltipText)({
        initialText: (0, $8ff2252602deef38$export$29d95a5fba76aeb4),
        updatedText: (0, $8ff2252602deef38$export$fac9e12d2d376b6),
        closeDelayAfterClick: (0, $8ff2252602deef38$export$631fa4d8cbe19f59)
    });
    const tooltipProps = {
        text: tooltipText,
        placement: "bottom",
        closeDelayAfterClick: tooltipCloseDelayAfterClick,
        onClose: handleTooltipClose,
        isDisabled: tooltipText === (0, $8ff2252602deef38$export$fac9e12d2d376b6)
    };
    const handleCopyToClipboard = (0, $cURGa$useCallback)(async ()=>{
        if (!text) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("No query to copy to clipboard");
            return;
        }
        try {
            await navigator.clipboard.writeText(text);
        } catch (error) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to copy text to clipboard:", error);
        }
    }, [
        text
    ]);
    const handleCopy = (0, $cURGa$useCallback)(async ()=>{
        handleTooltipTriggerClick();
        await handleCopyToClipboard();
    }, [
        handleTooltipTriggerClick,
        handleCopyToClipboard
    ]);
    const handleClose = ()=>setActivePopoverRow(null);
    const handleHover = ()=>setActivePopoverRow(activePopoverRow === rowIndex ? null : rowIndex);
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Popover), {
        trigger: /*#__PURE__*/ (0, $cURGa$jsx)($465279be07379876$var$PopoverTrigger, {
            onHover: handleHover,
            text: text
        }),
        popoverContent: /*#__PURE__*/ (0, $cURGa$jsx)($465279be07379876$var$PopoverContent, {
            label: label,
            text: text,
            tooltipProps: tooltipProps,
            onCopy: ()=>{
                handleCopy().catch((err)=>{
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Copy failed", err);
                });
            },
            onClose: handleClose
        }),
        isOpen: activePopoverRow === rowIndex,
        setIsOpen: (open)=>!open && handleClose(),
        isOpenOnHover: true,
        isCloseOnHover: false
    });
});
var $465279be07379876$export$2e2bcd8739ae039 = $465279be07379876$var$EnhancedPopover;


function $2bbed70e11e39719$var$EnhancedTableSortable({ widgetTableData: widgetTableData }) {
    const isValidRows = (rows)=>Array.isArray(rows) && rows.every((r)=>typeof r === "object" && r !== null);
    const isValidColumns = (columns)=>Array.isArray(columns) && columns.every((col)=>typeof col === "object" && col !== null && typeof col.key === "string" && typeof col.label === "string");
    const rawColumns = widgetTableData.columns;
    const rawRows = widgetTableData.rows;
    const initialColumns = isValidColumns(rawColumns) ? rawColumns.map((col)=>({
            ...col,
            value: col.key,
            hasImage: col.hasImage ?? false,
            isSortable: false,
            width: "-webkit-fill-available",
            minWidth: "10rem",
            maxWidth: "30rem",
            isChecked: true
        })) : [];
    const [columns, setColumns] = (0, $cURGa$useState)(initialColumns);
    const data = (0, $cURGa$useMemo)(()=>{
        const safeRows = isValidRows(rawRows) ? rawRows : [];
        return safeRows.map((row, rowIndex)=>{
            const formattedRow = columns.reduce((acc, col)=>{
                const cellData = row[col.key];
                if (!cellData) {
                    acc[col.key] = null;
                    return acc;
                }
                if (typeof cellData === "object" && cellData !== null) {
                    const { text: text, subText: subText, imageId: imageId } = cellData;
                    const imageUrl = typeof imageId === "string" ? (0, $8ff2252602deef38$export$9c04fe193594da37)(imageId) : null;
                    let showAvatar = null;
                    if (imageUrl) showAvatar = imageUrl;
                    else if (col.label.toLowerCase() === "user") showAvatar = "default";
                    const renderText = ()=>{
                        if (text && text.toString().length > 500) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body2",
                            className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle-popoverCell",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $465279be07379876$export$2e2bcd8739ae039), {
                                rowIndex: rowIndex,
                                text: text.toString(),
                                label: col.label
                            }, `${col.key}_popover`)
                        });
                        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            lineLimit: col.label.toLowerCase() === "user" ? 1 : 2,
                            kind: "body2",
                            className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userTitle",
                            children: String(text ?? "")
                        });
                    };
                    acc[col.key] = /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                        className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper",
                        children: [
                            showAvatar && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                                size: "small",
                                src: imageUrl ?? "",
                                alt: `${String(col.key)} avatar`,
                                className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userImage"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-titleWrapper",
                                children: [
                                    renderText(),
                                    (typeof subText === "string" || typeof subText === "number") && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        lineLimit: 1,
                                        kind: "body2",
                                        className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper-userSubtitle",
                                        children: subText
                                    })
                                ]
                            })
                        ]
                    });
                } else acc[col.key] = /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-Dashboard-TableModal-wrapper-table-userCellWrapper"
                });
                return acc;
            }, {});
            return {
                ...row,
                ...formattedRow
            };
        });
    }, [
        rawRows,
        columns
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TableSortable), {
        data: data,
        columns: columns,
        setColumns: setColumns,
        tableHeight: 560,
        isWindowScroll: false,
        isVirtualizationEnabled: false,
        columnConfigs: {
            isHeaderSticky: true,
            isHorizontalScroll: true,
            isDndDisabled: true
        },
        className: "Ispm-Dashboard-TableModal-wrapper-table",
        dataTestId: "Ispm-EnhancedTableSortable"
    });
}
var $2bbed70e11e39719$export$2e2bcd8739ae039 = $2bbed70e11e39719$var$EnhancedTableSortable;



function $59205e558dccad86$var$DashboardWidgetTableModal({ getTableModalClassName: getTableModalClassName = "", widgetTableDataLoading: widgetTableDataLoading = false, widgetTableDataError: widgetTableDataError = false, widgetTableData: widgetTableData = null, handleWidgetTableButton: handleWidgetTableButton, showWidgetMainModal: showWidgetMainModal, closeWidgetMainModal: closeWidgetMainModal, isTopList: isTopList = false, infoTooltipText: infoTooltipText = "", showTakeAction: showTakeAction = false }) {
    const [sanitizedData, setSanitizedData] = (0, $cURGa$useState)({
        rows: [],
        columns: []
    });
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const sanitizeTableData = (rows, columns)=>{
        const safeRows = Array.isArray(rows) ? rows : [];
        const safeColumns = Array.isArray(columns) ? columns.map((col)=>({
                key: col.key ?? "",
                label: col.label ?? "",
                value: col.key ?? "",
                hasImage: col.hasImage ?? false
            })) : [];
        return {
            rows: safeRows.slice(0, (0, $8ff2252602deef38$export$50c4654fc4355968)),
            columns: safeColumns
        };
    };
    (0, $cURGa$useEffect)(()=>{
        setSanitizedData(sanitizeTableData(widgetTableData?.rows, widgetTableData?.columns));
    }, [
        widgetTableData
    ]);
    const renderModalBodyContent = ()=>{
        const isEmpty = !widgetTableData?.rows?.length;
        if (!widgetTableDataLoading && widgetTableDataError && isEmpty) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {});
        if (widgetTableDataLoading || isEmpty) return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
            className: "Certs-Loader",
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "loop",
                format: "main",
                color: "brand",
                dataTestId: "widgetTableLoader"
            })
        });
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $2bbed70e11e39719$export$2e2bcd8739ae039), {
            widgetTableData: sanitizedData
        });
    };
    const renderModalHeaderContent = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Dashboard-TableModal-wrapper-header",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                    className: "Ispm-Dashboard-TableModal-wrapper-header-title",
                    children: [
                        !isTopList && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            className: "Ispm-Dashboard-TableModal-wrapper-header-title-backButton",
                            onClick: closeWidgetMainModal,
                            leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "ChevronLeft",
                                size: "medium"
                            })
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "h1",
                            lineLimit: 1,
                            children: !widgetTableDataLoading ? widgetTableData?.tableTitle : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                    className: "Ispm-Dashboard-TableModal-wrapper-header-actions",
                    children: [
                        !widgetTableDataLoading && widgetTableData?.tableTitle && showTakeAction && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                    dataTestId: "ispm-widget-tableModal-rightArrow",
                                    type: "button",
                                    kind: "filled",
                                    size: "small",
                                    isDisabled: !widgetTableData.controlUrl,
                                    rightIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "ArrowRight",
                                        size: "medium"
                                    }),
                                    onClick: ()=>handleWidgetTableButton(widgetTableData.controlUrl || ""),
                                    children: l("Take Action")
                                }),
                                widgetTableData.controlUrl && infoTooltipText && /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                                    className: "Ispm-Certs-RevocationEffectiveness-header-infoTooltip",
                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: "AlertInfoFilled",
                                            color: "info-600",
                                            size: "small"
                                        }),
                                        text: infoTooltipText,
                                        placement: "left-start"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                            dataTestId: "ispm-widget-tableModal-closeReviewModal",
                            size: "medium",
                            kind: "ghost",
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "close",
                                color: "neutral-100",
                                size: "smallMedium"
                            }),
                            onClick: closeWidgetMainModal
                        })
                    ]
                })
            ]
        });
    const renderModalContent = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Dashboard-TableModal-wrapper",
            children: [
                renderModalHeaderContent(),
                renderModalBodyContent()
            ]
        });
    if (!showWidgetMainModal) return null;
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        className: (0, $cURGa$classnames)("Ispm-Dashboard-TableModal", getTableModalClassName),
        onClose: closeWidgetMainModal,
        isOpen: showWidgetMainModal,
        contentBody: renderModalContent(),
        isShellMode: true,
        isOutsideClickEnabled: isTopList
    });
}
$59205e558dccad86$var$DashboardWidgetTableModal.defaultProps = {
    getTableModalClassName: "",
    widgetTableDataLoading: false,
    widgetTableDataError: null,
    widgetTableData: null,
    isTopList: false,
    infoTooltipText: ""
};
var $59205e558dccad86$export$2e2bcd8739ae039 = $59205e558dccad86$var$DashboardWidgetTableModal;

















function $e6284d375063ab5b$var$RecommendationsItemContent({ item: item, iconMap: iconMap, handleReviewButtonClick: handleReviewButtonClick, isBackButtonEnabled: isBackButtonEnabled }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const iconData = iconMap[item.module || "IGA"];
    const getIcon = iconData.icon || "Entitlement";
    const getFillColor = iconData.fillColor || "--color-foreground-savi-medium";
    const noIssueItems = (item.timeSeriesData?.[0]?.value ?? 0) === 0;
    const itemDisabled = item.isModuleDisabled;
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-Recommendations-Content-item",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                className: (0, $cURGa$classnames)("Ispm-Recommendations-Content-Icon", itemDisabled && "--isDisabled"),
                size: "xsmall",
                kind: getIcon,
                color: getFillColor
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                className: (0, $cURGa$classnames)("Ispm-Recommendations-Content-item-text", itemDisabled && "--isDisabled"),
                kind: "body2",
                lineLimit: 1,
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $8ff2252602deef38$export$881f1645f5c6e7a7), {
                    htmlString: item.displayText ?? ""
                })
            }),
            itemDisabled && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InlineMessage), {
                text: l("The feature for this data is not set up."),
                colorTheme: "info",
                size: "medium",
                leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "AlertInfoFilled"
                })
            }),
            !itemDisabled && noIssueItems && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InlineMessage), {
                className: "Ispm-Recommendations-Content-item-zeroIssues",
                text: l("Great job, no issues were detected"),
                colorTheme: "success",
                size: "medium",
                leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "CheckCircleFilled"
                })
            }),
            !itemDisabled && !noIssueItems && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                kind: "subtle",
                dataTestId: `ispm-dashboard-reviewButton${item.id ?? ""}`,
                className: "Ispm-Recommendations-Content-item--isReviewButton",
                isDisabled: item.controlUrl === "",
                onClick: ()=>handleReviewButtonClick(item, isBackButtonEnabled),
                children: l("Review")
            })
        ]
    }, item.id);
}
var $e6284d375063ab5b$export$2e2bcd8739ae039 = $e6284d375063ab5b$var$RecommendationsItemContent;









function $b101284c99752365$var$RecommendationsList({ checkShowAll: checkShowAll, handleShowAllClose: handleShowAllClose, groupedData: groupedData, iconMap: iconMap, handleReviewButtonClick: handleReviewButtonClick }) {
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const getShowAllRecommendationsContent = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
            className: "Ispm-Recommendations-showAll-modal-content",
            children: Object.keys(groupedData.default).length > 0 && groupedData.default.map((item)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e6284d375063ab5b$export$2e2bcd8739ae039), {
                    item: item,
                    iconMap: iconMap,
                    handleReviewButtonClick: handleReviewButtonClick,
                    isBackButtonEnabled: true
                }))
        });
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ModalIsland), {
        isOpen: checkShowAll,
        onClose: handleShowAllClose,
        title: l("Additional Recommendations"),
        contentBody: getShowAllRecommendationsContent(),
        className: "Ispm-Recommendations-showAll-modal",
        isOutsideClickEnabled: true
    });
}
var $b101284c99752365$export$2e2bcd8739ae039 = $b101284c99752365$var$RecommendationsList;



function $84bbf42c3b253c28$var$Recommendations() {
    const [showAll, setShowAll] = (0, $cURGa$useState)(false);
    const [showReviewModal, setShowReviewModal] = (0, $cURGa$useState)(false);
    const [reviewDataId, setReviewDataId] = (0, $cURGa$useState)("");
    const [isTopRecommendation, setIsTopRecommendation] = (0, $cURGa$useState)(false);
    const { data: recommendationsData, isLoading: isRecommendationsLoading, error: isRecommendationsError } = (0, $3ac793aa418a359a$export$9e04cd9a8ab60f8e)();
    const { permission: ispmEicRecommendationsAction } = (0, $f368c544e3051320$export$2e2bcd8739ae039)((0, $e93470e5e98f2427$export$e08c7aae438e15b4).EIC_RECOMMENDATIONS_ACTION);
    const { data: reviewData, isLoading: isReviewDataLoading, error: isReviewDataError } = (0, $3ac793aa418a359a$export$df2883877f8bfced)(reviewDataId);
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    const handleReviewModal = (0, $cURGa$useCallback)((id = "", isTop = false)=>{
        setReviewDataId(id);
        setIsTopRecommendation(isTop);
        setShowReviewModal((prev)=>!prev);
    }, []);
    const handleReviewButton = (0, $cURGa$useCallback)((url)=>{
        if (!url || typeof url !== "string" || !url.startsWith("/")) {
            (0, $cURGa$Logger).warn("Invalid or missing URL:", url);
            return;
        }
        try {
            const newTab = window.open(`/ECM${url}`, "_blank", "noopener,origin");
            if (!newTab) (0, $cURGa$Logger).warn("Popup blocked");
        } catch (error) {
            (0, $cURGa$Logger).error("Failed to open review:", error);
        }
    }, []);
    const handleReviewButtonClick = (0, $cURGa$useCallback)((item, isTopRecommendations)=>{
        const { controlUrl: controlUrl, id: id } = item;
        if (controlUrl) handleReviewButton(controlUrl);
        else if (controlUrl === null) handleReviewModal(id ?? "", isTopRecommendations ?? false);
    }, [
        handleReviewButton,
        handleReviewModal
    ]);
    const recommendationsJsonData = (0, $cURGa$useMemo)(()=>Array.isArray(recommendationsData?.value) ? {
            default: recommendationsData.value
        } : {
            default: []
        }, [
        recommendationsData?.value
    ]);
    const recommendationsJsonTopData = (0, $cURGa$useMemo)(()=>Array.isArray(recommendationsData?.value) ? recommendationsData.value.slice(0, (0, $31415264ab98c97b$export$f1165a238165ad91)).filter(Boolean) : [], [
        recommendationsData?.value
    ]);
    const allItemsZero = (0, $cURGa$useMemo)(()=>Object.values(recommendationsJsonData).every((items)=>items.every((item)=>item.timeSeriesData?.every((data)=>data.value === 0))), [
        recommendationsJsonData
    ]);
    const totalItemsCount = (0, $cURGa$useMemo)(()=>Object.values(recommendationsJsonData).reduce((count, items)=>count + items.filter((item)=>item.id).length, 0), [
        recommendationsJsonData
    ]);
    const renderInfoText = ()=>{
        if (!isRecommendationsLoading && recommendationsData?.value?.length && allItemsZero) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
            className: "Ispm-Recommendations-Content-buttonWrapper",
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InlineMessage), {
                text: l("Great job! There weren\u2019t any issues detected for all recommendations."),
                colorTheme: "success",
                size: "medium",
                leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: "ThumbsUp"
                })
            })
        });
        return null;
    };
    const renderTopRecommendations = ()=>recommendationsJsonTopData.map((item)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $e6284d375063ab5b$export$2e2bcd8739ae039), {
                iconMap: (0, $31415264ab98c97b$export$d133d6e26bb0f6fe),
                handleReviewButtonClick: handleReviewButtonClick,
                item: item,
                isBackButtonEnabled: false
            }, item.id));
    const renderRecommendationsList = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $b101284c99752365$export$2e2bcd8739ae039), {
            groupedData: recommendationsJsonData,
            checkShowAll: showAll,
            handleShowAllClose: ()=>setShowAll(false),
            iconMap: (0, $31415264ab98c97b$export$d133d6e26bb0f6fe),
            handleReviewButtonClick: handleReviewButtonClick
        });
    const renderContent = ()=>{
        if (!isRecommendationsError && isRecommendationsLoading && !recommendationsData?.value?.length) return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
            className: "Ispm-Recommendations-Content-loaderWrapper",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                    kind: "dots",
                    format: "inline",
                    color: "inverse",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    kind: "body2",
                    color: "--color-foreground-neutral-subtle",
                    children: l("Loading recommendation items")
                })
            ]
        });
        if (!isRecommendationsLoading && isRecommendationsError && !recommendationsData?.value?.length) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $72d4b5f37be62507$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
            children: [
                renderTopRecommendations(),
                renderInfoText(),
                showAll && !showReviewModal && renderRecommendationsList(),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $59205e558dccad86$export$2e2bcd8739ae039), {
                    getTableModalClassName: "Ispm-Dashboard-Recommendations-TableModal",
                    widgetTableDataLoading: isReviewDataLoading,
                    widgetTableDataError: isReviewDataError,
                    widgetTableData: reviewData,
                    showWidgetMainModal: showReviewModal,
                    closeWidgetMainModal: ()=>setShowReviewModal(false),
                    handleWidgetTableButton: handleReviewButton,
                    isTopList: isTopRecommendation,
                    infoTooltipText: l("Filtering and sorting will be available in Control Center after you click `Take Action\u2019."),
                    showTakeAction: ispmEicRecommendationsAction?.enabled ?? false
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-Recommendations",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-Recommendations-titleWrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h1",
                        lineLimit: 2,
                        className: "Ispm-Recommendations-titleWrapper-heading",
                        children: l("Recommendations")
                    }),
                    !isRecommendationsError && recommendationsData?.value?.length && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                        "data-testid": "RecommendationsShowAllButton",
                        kind: "button",
                        url: "#",
                        onClick: ()=>setShowAll(true),
                        text: `${l("Show All")} (${totalItemsCount})`,
                        size: "medium",
                        suffixIconKind: "ArrowRight",
                        className: "Ispm-Recommendations-titleWrapper-showAllButton"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-Recommendations-Content",
                children: renderContent()
            })
        ]
    });
}
var $84bbf42c3b253c28$export$2e2bcd8739ae039 = $84bbf42c3b253c28$var$Recommendations;







/**
 * IspmDashboard Functional Component
 *
 * Renders the dashboard for ISP Management including access and certification insights,
 * theme toggle, analytics, recommendations, and more.
 *
 * @returns {JSX.Element} The rendered dashboard.
 */ function $32db130348998fd2$var$IspmDashboard() {
    // Hook for localization with inverted messages
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    // State for managing the current tab name and the active tab value
    const [tabName, setTabName] = (0, $cURGa$useState)((0, $31415264ab98c97b$export$5eb0c58c8af5c758));
    const [activeTab, setActiveTab] = (0, $cURGa$useState)(1);
    // State for toggling animations in child components (e.g., SecurityPosture)
    const [isAnimate, setIsAnimate] = (0, $cURGa$useState)(false);
    // Hook for theme management; theme (true = dark, false = light)
    const { theme: theme, setTheme: setTheme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    /**
   * Memoized computation to determine whether the Governance tab should be highlighted.
   * It checks the user's permission metadata to decide if the advanced tier indicator is needed.
   */ const { permission: governanceDashboardPermission } = (0, $f368c544e3051320$export$2e2bcd8739ae039)((0, $e93470e5e98f2427$export$e08c7aae438e15b4).POSTURE_INSIGHTS_GOVERNANCE_DASHBOARD_VIEW);
    /**
   * Determines if the advanced tier icon should be displayed for a given tab.
   *
   * @param {Object} tab - The tab object containing its type.
   * @returns {boolean} True if the tab is a governance tab and the highlight flag is set.
   */ const showAdvanceTierOnGovernance = (0, $cURGa$useCallback)((tab)=>tab.label === "Governance" && governanceDashboardPermission?.licenseDisplayMetadata?.showPlanHighlightLabel, [
        governanceDashboardPermission?.licenseDisplayMetadata?.showPlanHighlightLabel
    ]);
    /**
   * Handles the tab change event.
   *
   * Updates the active tab and sets the tabName based on the selected tab.
   *
   * @param {number} tabValue - The value identifier for the tab.
   */ const handleChange = (tabValue)=>{
        setActiveTab(tabValue);
        // Use find to locate the specific tab instead of filter for clarity and safety.
        const selectedTab = (0, $31415264ab98c97b$export$6025e095d3a5b8e).find((tab)=>tab.value === tabValue);
        if (selectedTab) setTabName(selectedTab.label);
    };
    /**
   * Renders the respective component based on the current tab name.
   *
   * @param {string} value - The label of the active tab.
   * @returns {JSX.Element} The component corresponding to the active tab.
   */ const renderTabs = (value)=>{
        switch(value){
            case 0, $31415264ab98c97b$export$5eb0c58c8af5c758:
                return /*#__PURE__*/ (0, $cURGa$jsx)((0, $7fc2d8fe52aa8ca9$export$2e2bcd8739ae039), {});
            case 0, $31415264ab98c97b$export$282a633f41834647:
                return /*#__PURE__*/ (0, $cURGa$jsx)((0, $c42a2e2fbc5d9d56$export$2e2bcd8739ae039), {});
            default:
                return /*#__PURE__*/ (0, $cURGa$jsx)("div", {});
        }
    };
    /**
   * Toggles the theme between dark and light mode.
   *
   * Updates the theme state using the useTheme hook.
   */ const handleToggleTheme = ()=>{
        setTheme(!theme);
    };
    // Retrieve the left navigation pinned state from localStorage.
    // Defaults to "false" if not set.
    const leftNavPinned = localStorage.getItem("gen2.layout.isMenuPinned") || "false";
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: (0, $cURGa$classnames)("Ispm-Ootb", {
            // Apply 'leftNavPinned' class if leftNavPinned value is "true"
            leftNavPinned: leftNavPinned === "true"
        }),
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Ootb-Section1",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Ootb-Section1-Cockpit",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "h1",
                                lineLimit: 1,
                                children: l("Dashboard")
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Switch), {
                                className: "Ispm-Ootb-Section1-Cockpit-themeSwitch",
                                isChecked: theme,
                                onChange: handleToggleTheme,
                                label: "Dark Mode",
                                dataTestId: "ispm-dashboard-themeToggle"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $4880d7c2b4a903d4$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Ootb-Section2",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Ootb-Section2-LeftContainer",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $84bbf42c3b253c28$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $962626994e07d893$export$2e2bcd8739ae039), {
                                isAnimate: isAnimate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Ootb-Section2-RightContainer",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $d91b157793f73623$export$2e2bcd8739ae039), {
                            setIsAnimate: setIsAnimate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("span", {
                className: `Ispm-Ootb-tabs ${isAnimate ? "animateIn" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h1",
                        className: "Ispm-Ootb-tabs-text",
                        children: l("Posture Insights")
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("section", {
                        className: "Ispm-Ootb-tabs-posture-insights-tabs",
                        children: (0, $31415264ab98c97b$export$6025e095d3a5b8e).map((tab)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                                className: `Ispm-Ootb-tabs-posture-insights-tab-${tab.type}`,
                                // Only show tooltip text for governance tabs when advanced tier is active.
                                text: showAdvanceTierOnGovernance(tab) ? governanceDashboardPermission?.licenseDisplayMetadata?.planHighlightLabelValue : "",
                                placement: tab.type === "access" ? "top" : "right",
                                trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                                    className: (0, $cURGa$classnames)(`Ispm-Ootb-tabs-posture-insights-tabs-items-${tab.type}`, {
                                        "Ispm-Ootb-tabs-posture-insights-tabs-items-active": activeTab === tab.value
                                    }),
                                    kind: "outlined",
                                    // Conditionally display the AdvancedTier icon for governance tabs.
                                    leftIcon: showAdvanceTierOnGovernance(tab) ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                        kind: "AdvancedTier"
                                    }) : undefined,
                                    isDisabled: tab.disabled,
                                    dataTestId: `ispm-dashboard-${tab.label}`,
                                    onClick: ()=>handleChange(tab.value),
                                    children: tab.label
                                })
                            }, tab.value))
                    })
                ]
            }),
            renderTabs(tabName)
        ]
    });
}
var $32db130348998fd2$export$2e2bcd8739ae039 = $32db130348998fd2$var$IspmDashboard;


$4fe09d13d8d4dc72$var$ChatOrDashboard.default = {
    testId: ""
};
function $4fe09d13d8d4dc72$var$ChatOrDashboard() {
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Insight Dashboard --> ChatOrDashboard component");
    const { ispmState: ispmState } = (0, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed)();
    (0, $cURGa$useEffect)(()=>{
        // lock the body overflow to prevent scrolling
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, []);
    return ispmState.isChatOverlayVisible ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $dbc835d97b11e0c7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $12c51e736b1437e7$export$2e2bcd8739ae039), {})
        ]
    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $670c946906b8a505$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$OverlayProvider), {
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $32db130348998fd2$export$2e2bcd8739ae039), {})
        })
    });
}
var $4fe09d13d8d4dc72$export$2e2bcd8739ae039 = $4fe09d13d8d4dc72$var$ChatOrDashboard;


var $868b73c74bf28a1e$export$2e2bcd8739ae039 = (0, $4fe09d13d8d4dc72$export$2e2bcd8739ae039);



/**
 * Dashboard Component
 *
 * contains dashboard and Chat overlay
 * @returns
 */ function $870713baf8c12df0$var$Dashboard() {
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Loading Insight Dashboard");
    const dispatch = (0, $cURGa$useDispatch)();
    const { permission: copilotPermission } = (0, $f368c544e3051320$export$2e2bcd8739ae039)((0, $e93470e5e98f2427$export$e08c7aae438e15b4).COPILOT);
    (0, $cURGa$useEffect)(()=>{
        dispatch((0, $e7b59df9ea8eb4ea$export$6607a8b96012a46d)(copilotPermission?.enabled ?? false));
        return ()=>{
            dispatch((0, $e7b59df9ea8eb4ea$export$6607a8b96012a46d)(false));
        };
    }, [
        copilotPermission?.enabled,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)("section", {
        className: "Ispm-Dashboard",
        "data-testid": (0, $b673ba598f0efd75$export$5e613fde55f77105),
        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $4402fe0eef725aae$export$c2ba84d3b46f6625), {
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $12a238da3b06d4cc$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $868b73c74bf28a1e$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $870713baf8c12df0$export$2e2bcd8739ae039 = $870713baf8c12df0$var$Dashboard;
















const $891f55c18f10aed6$export$d3c2f6c31128e311 = ()=>{
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("Setting classes to hide elements from host app.");
    document.getElementById("root")?.classList.add("hideHostLoader");
};
const $891f55c18f10aed6$export$5a88c3c2439cce55 = ()=>{
    document.getElementById("root")?.classList.remove("hideHostLoader");
};
const $891f55c18f10aed6$export$9bc070677037150b = ()=>{
    const dynamicBodyEle = document.getElementsByClassName("dynamicModules")[0];
    if (dynamicBodyEle) dynamicBodyEle.classList.remove("d-block");
};










function $a72e27c476852c06$var$PageLoader({ message: message = "Loading", subtext: subtext = "This may take several seconds." }) {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "ISPM-PageLoader",
        "data-testid": "ISPM-PageLoader",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                kind: "loop",
                format: "main",
                color: "brand",
                "data-testid": "ISPM-Loader"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-PageLoader-textContainer",
                "data-testid": "ISPM-PageLoader-textContainer",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        className: "ISPM-PageLoader-title",
                        kind: "h1",
                        color: "--color-foreground-neutral-bold",
                        "data-testid": "ISPM-PageLoader-title",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        className: "ISPM-PageLoader-subtitle",
                        kind: "body1",
                        color: "--color-foreground-secondary-medium",
                        "data-testid": "ISPM-PageLoader-subtitle",
                        children: subtext
                    })
                ]
            })
        ]
    });
}
$a72e27c476852c06$var$PageLoader.defaultProps = {
    message: "Loading",
    subtext: "This may take several seconds."
};
var $a72e27c476852c06$export$2e2bcd8739ae039 = $a72e27c476852c06$var$PageLoader;











function $ab96b7bbd3fb8daa$var$InfiniteScrollError({ message: message }) {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "ISPM-InfiniteScrollError",
        role: "presentation",
        "data-testid": "infinite-scroll-error",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InlineMessage), {
            colorTheme: "critical",
            size: "medium",
            leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                kind: "AlertCriticalFilled"
            }),
            text: message
        })
    });
}
var $ab96b7bbd3fb8daa$export$2e2bcd8739ae039 = $ab96b7bbd3fb8daa$var$InfiniteScrollError;
$ab96b7bbd3fb8daa$var$InfiniteScrollError.defaultProps = {
    message: "Unable to load more items."
};





function $91fec4c33abf7941$var$SkeletonLoader({ itemCount: itemCount = 5 }) {
    const skeletonItemKeys = (0, $cURGa$useMemo)(()=>Array.from({
            length: Math.max(0, itemCount)
        }, (_placeholder, itemIndex)=>`skeleton-loader-item-${itemIndex}`), [
        itemCount
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "ISPM-SkeletonLoader",
        children: skeletonItemKeys.map((key)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-SkeletonLoader-card",
                "data-testid": "skeleton-card",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "ISPM-SkeletonLoader-circle",
                        "data-testid": "skeleton-circle"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "ISPM-SkeletonLoader-content",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "ISPM-SkeletonLoader-line",
                                "data-testid": "skeleton-line"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "ISPM-SkeletonLoader-line",
                                "data-testid": "skeleton-line"
                            })
                        ]
                    })
                ]
            }, key))
    });
}
var $91fec4c33abf7941$export$2e2bcd8739ae039 = $91fec4c33abf7941$var$SkeletonLoader;
$91fec4c33abf7941$var$SkeletonLoader.defaultProps = {
    itemCount: 5
};




function $a925d1f723de0eb3$var$useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $cURGa$useState)(value);
    (0, $cURGa$useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>clearTimeout(handler);
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $a925d1f723de0eb3$export$2e2bcd8739ae039 = $a925d1f723de0eb3$var$useDebounce;





function $48814d96dbb576d5$var$isGetIdentityByIdResponse(data) {
    return typeof data === "object" && data !== null;
}
// Function to fetch ISPM suggestions
const $48814d96dbb576d5$var$getIdentityById = async (userId)=>{
    const { USER_IDENTITY_BY_ID_URL: USER_IDENTITY_BY_ID_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const identityByIdUrl = USER_IDENTITY_BY_ID_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId);
    const config = {
        timeout: 30000,
        method: "GET"
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(identityByIdUrl, config, $48814d96dbb576d5$var$isGetIdentityByIdResponse);
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("getUserTimeline - ", {
        identityByIdUrl: identityByIdUrl,
        config: config,
        isGetIdentityByIdResponse: $48814d96dbb576d5$var$isGetIdentityByIdResponse
    });
    return response;
};
var $48814d96dbb576d5$export$2e2bcd8739ae039 = $48814d96dbb576d5$var$getIdentityById;





const $c49aa0f374b6c6e6$export$70072cbb5af69ff9 = `<svg width="589" height="176" viewBox="0 0 589 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="588" height="175" rx="7.5" fill="white"/>
<rect x="0.5" y="0.5" width="588" height="175" rx="7.5" stroke="#6888B5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M56 25.1429C43.3763 25.1429 33.1429 35.3763 33.1429 48C33.1429 60.6236 43.3763 70.8571 56 70.8571C68.6236 70.8571 78.8571 60.6236 78.8571 48C78.8571 35.3763 68.6236 25.1429 56 25.1429ZM24 48C24 30.3269 38.3269 16 56 16C73.6731 16 88 30.3269 88 48C88 65.6731 73.6731 80 56 80C38.3269 80 24 65.6731 24 48Z" fill="#0294F7"/>
<path d="M56 26.1429H57V25.1429V16V15H56C37.7746 15 23 29.7746 23 48C23 66.2254 37.7746 81 56 81H57V80V70.8571V69.8571H56C43.9286 69.8571 34.1429 60.0714 34.1429 48C34.1429 35.9286 43.9286 26.1429 56 26.1429Z" fill="#D057FF" stroke="white" stroke-width="2"/>
<path d="M56.0003 26.1429H57.0003V25.1429V16V15H56.0003C42.0896 15 30.2027 23.6052 25.3458 35.7615L24.9748 36.6901L25.9034 37.0611L34.3937 40.4533L35.3223 40.8243L35.6933 39.8957C38.9168 31.8277 46.8011 26.1429 56.0003 26.1429Z" fill="#FC3DA6" stroke="white" stroke-width="2"/>
<path d="M109.255 59C109.02 59 108.828 58.9253 108.679 58.776C108.551 58.6267 108.487 58.4453 108.487 58.232V41.656L103.623 45.4C103.431 45.528 103.239 45.5813 103.047 45.56C102.855 45.5173 102.684 45.4 102.535 45.208L101.191 43.48C101.063 43.288 101.009 43.0853 101.031 42.872C101.073 42.6587 101.191 42.488 101.383 42.36L108.551 36.824C108.679 36.7173 108.807 36.6533 108.935 36.632C109.063 36.6107 109.201 36.6 109.351 36.6H112.167C112.38 36.6 112.561 36.6747 112.711 36.824C112.86 36.9733 112.935 37.1547 112.935 37.368V58.232C112.935 58.4453 112.86 58.6267 112.711 58.776C112.561 58.9253 112.38 59 112.167 59H109.255ZM117.411 59C117.198 59 117.016 58.9253 116.867 58.776C116.718 58.6267 116.643 58.4453 116.643 58.232V56.6C116.643 56.408 116.686 56.184 116.771 55.928C116.878 55.6507 117.102 55.3733 117.443 55.096L122.499 50.072C123.907 48.9627 125.038 48.024 125.891 47.256C126.766 46.4667 127.395 45.752 127.779 45.112C128.184 44.4507 128.387 43.8 128.387 43.16C128.387 42.2 128.12 41.4213 127.587 40.824C127.075 40.2267 126.254 39.928 125.123 39.928C124.376 39.928 123.747 40.088 123.235 40.408C122.723 40.7067 122.318 41.112 122.019 41.624C121.742 42.136 121.55 42.7013 121.443 43.32C121.4 43.5973 121.283 43.7893 121.091 43.896C120.899 44.0027 120.707 44.056 120.515 44.056H117.667C117.475 44.056 117.315 43.992 117.187 43.864C117.059 43.736 116.995 43.5867 116.995 43.416C117.016 42.4987 117.208 41.6133 117.571 40.76C117.934 39.8853 118.456 39.1173 119.139 38.456C119.843 37.7733 120.696 37.2293 121.699 36.824C122.702 36.4187 123.832 36.216 125.091 36.216C126.862 36.216 128.323 36.5147 129.475 37.112C130.648 37.7093 131.523 38.52 132.099 39.544C132.696 40.568 132.995 41.72 132.995 43C132.995 44.0027 132.803 44.9307 132.419 45.784C132.035 46.616 131.48 47.4267 130.755 48.216C130.03 48.984 129.155 49.7733 128.131 50.584L123.587 55.192H132.707C132.942 55.192 133.123 55.2667 133.251 55.416C133.4 55.544 133.475 55.7253 133.475 55.96V58.232C133.475 58.4453 133.4 58.6267 133.251 58.776C133.123 58.9253 132.942 59 132.707 59H117.411ZM137.704 59C137.49 59 137.309 58.9253 137.16 58.776C137.01 58.6267 136.936 58.4453 136.936 58.232V55.064C136.936 54.8293 137.01 54.6373 137.16 54.488C137.309 54.3387 137.49 54.264 137.704 54.264H140.904C141.117 54.264 141.298 54.3387 141.448 54.488C141.597 54.6373 141.672 54.8293 141.672 55.064V58.232C141.672 58.4453 141.597 58.6267 141.448 58.776C141.298 58.9253 141.117 59 140.904 59H137.704ZM153.536 59.32C151.701 59.32 150.123 58.9787 148.8 58.296C147.477 57.592 146.453 56.6533 145.728 55.48C145.003 54.2853 144.64 52.952 144.64 51.48C144.64 50.8187 144.725 50.1787 144.896 49.56C145.067 48.9413 145.291 48.3547 145.568 47.8C145.845 47.2453 146.112 46.7547 146.368 46.328C146.645 45.88 146.891 45.528 147.104 45.272L152.96 37.24C153.045 37.1333 153.173 37.0053 153.344 36.856C153.515 36.6853 153.749 36.6 154.048 36.6H157.024C157.216 36.6 157.376 36.6747 157.504 36.824C157.632 36.952 157.696 37.112 157.696 37.304C157.696 37.3893 157.675 37.4747 157.632 37.56C157.611 37.624 157.579 37.6773 157.536 37.72L153.056 43.928C153.248 43.864 153.472 43.8213 153.728 43.8C153.984 43.7787 154.219 43.768 154.432 43.768C155.499 43.7893 156.512 44.0027 157.472 44.408C158.432 44.792 159.275 45.3253 160 46.008C160.725 46.6907 161.291 47.4907 161.696 48.408C162.123 49.3253 162.336 50.328 162.336 51.416C162.336 52.824 161.984 54.136 161.28 55.352C160.576 56.5467 159.563 57.5067 158.24 58.232C156.939 58.9573 155.371 59.32 153.536 59.32ZM153.504 55.64C154.272 55.64 154.976 55.48 155.616 55.16C156.277 54.84 156.811 54.3707 157.216 53.752C157.621 53.1333 157.824 52.3653 157.824 51.448C157.824 50.552 157.621 49.7947 157.216 49.176C156.811 48.5573 156.277 48.088 155.616 47.768C154.976 47.448 154.272 47.288 153.504 47.288C152.736 47.288 152.021 47.448 151.36 47.768C150.72 48.088 150.197 48.5573 149.792 49.176C149.387 49.7947 149.184 50.552 149.184 51.448C149.184 52.3653 149.387 53.1333 149.792 53.752C150.197 54.3707 150.72 54.84 151.36 55.16C152.021 55.48 152.736 55.64 153.504 55.64ZM166.655 59C166.441 59 166.26 58.9253 166.111 58.776C165.961 58.6267 165.887 58.4453 165.887 58.232V37.4C165.887 37.1653 165.961 36.9733 166.111 36.824C166.26 36.6747 166.441 36.6 166.655 36.6H169.471C169.705 36.6 169.897 36.6747 170.047 36.824C170.196 36.9733 170.271 37.1653 170.271 37.4V44.888L177.503 37.176C177.588 37.0693 177.727 36.952 177.919 36.824C178.132 36.6747 178.409 36.6 178.751 36.6H181.919C182.089 36.6 182.239 36.664 182.367 36.792C182.516 36.92 182.591 37.08 182.591 37.272C182.591 37.4213 182.548 37.5493 182.463 37.656L173.663 47.32L183.071 57.912C183.177 58.04 183.231 58.1787 183.231 58.328C183.231 58.52 183.156 58.68 183.007 58.808C182.879 58.936 182.729 59 182.559 59H179.263C178.9 59 178.612 58.9253 178.399 58.776C178.207 58.6053 178.079 58.488 178.015 58.424L170.271 49.944V58.232C170.271 58.4453 170.196 58.6267 170.047 58.776C169.897 58.9253 169.705 59 169.471 59H166.655Z" fill="#00245B"/>
<path d="M193.76 58C193.643 58 193.552 57.968 193.488 57.904C193.424 57.8293 193.392 57.7387 193.392 57.632V47.168C193.392 47.0613 193.424 46.976 193.488 46.912C193.552 46.8373 193.643 46.8 193.76 46.8H194.608C194.725 46.8 194.816 46.8373 194.88 46.912C194.944 46.976 194.976 47.0613 194.976 47.168V57.632C194.976 57.7387 194.944 57.8293 194.88 57.904C194.816 57.968 194.725 58 194.608 58H193.76ZM200.599 58.16C200.012 58.16 199.506 58.0587 199.079 57.856C198.652 57.6427 198.3 57.36 198.023 57.008C197.756 56.6453 197.554 56.2347 197.415 55.776C197.287 55.3173 197.212 54.832 197.191 54.32C197.18 54.1493 197.175 53.9893 197.175 53.84C197.175 53.6907 197.18 53.5307 197.191 53.36C197.212 52.8587 197.287 52.3787 197.415 51.92C197.554 51.4613 197.756 51.0507 198.023 50.688C198.3 50.3253 198.652 50.0427 199.079 49.84C199.506 49.6267 200.012 49.52 200.599 49.52C201.228 49.52 201.751 49.632 202.167 49.856C202.583 50.08 202.924 50.3573 203.191 50.688V47.008C203.191 46.9013 203.223 46.816 203.287 46.752C203.362 46.6773 203.452 46.64 203.559 46.64H204.327C204.434 46.64 204.519 46.6773 204.583 46.752C204.658 46.816 204.695 46.9013 204.695 47.008V57.632C204.695 57.7387 204.658 57.8293 204.583 57.904C204.519 57.968 204.434 58 204.327 58H203.607C203.49 58 203.399 57.968 203.335 57.904C203.271 57.8293 203.239 57.7387 203.239 57.632V56.96C202.972 57.3013 202.626 57.5893 202.199 57.824C201.772 58.048 201.239 58.16 200.599 58.16ZM200.935 56.864C201.468 56.864 201.895 56.7413 202.215 56.496C202.535 56.2507 202.775 55.9413 202.935 55.568C203.095 55.184 203.18 54.7947 203.191 54.4C203.202 54.2293 203.207 54.0267 203.207 53.792C203.207 53.5467 203.202 53.3387 203.191 53.168C203.18 52.7947 203.09 52.4267 202.919 52.064C202.759 51.7013 202.514 51.4027 202.183 51.168C201.863 50.9333 201.447 50.816 200.935 50.816C200.391 50.816 199.959 50.9387 199.639 51.184C199.319 51.4187 199.09 51.7333 198.951 52.128C198.812 52.512 198.732 52.928 198.711 53.376C198.7 53.6853 198.7 53.9947 198.711 54.304C198.732 54.752 198.812 55.1733 198.951 55.568C199.09 55.952 199.319 56.2667 199.639 56.512C199.959 56.7467 200.391 56.864 200.935 56.864ZM210.403 58.16C209.293 58.16 208.413 57.824 207.763 57.152C207.112 56.4693 206.755 55.5413 206.691 54.368C206.68 54.2293 206.675 54.0533 206.675 53.84C206.675 53.616 206.68 53.4347 206.691 53.296C206.733 52.5387 206.909 51.8773 207.219 51.312C207.528 50.736 207.949 50.2933 208.483 49.984C209.027 49.6747 209.661 49.52 210.387 49.52C211.197 49.52 211.875 49.6907 212.419 50.032C212.973 50.3733 213.395 50.8587 213.683 51.488C213.971 52.1173 214.115 52.8533 214.115 53.696V53.968C214.115 54.0853 214.077 54.176 214.003 54.24C213.939 54.304 213.853 54.336 213.747 54.336H208.211C208.211 54.3467 208.211 54.368 208.211 54.4C208.211 54.432 208.211 54.4587 208.211 54.48C208.232 54.9173 208.328 55.328 208.499 55.712C208.669 56.0853 208.915 56.3893 209.235 56.624C209.565 56.8587 209.949 56.976 210.387 56.976C210.771 56.976 211.091 56.9173 211.347 56.8C211.603 56.6827 211.811 56.5547 211.971 56.416C212.131 56.2667 212.237 56.1493 212.291 56.064C212.387 55.936 212.461 55.8613 212.515 55.84C212.568 55.808 212.653 55.792 212.771 55.792H213.555C213.651 55.792 213.731 55.824 213.795 55.888C213.869 55.9413 213.901 56.0213 213.891 56.128C213.88 56.288 213.795 56.4853 213.635 56.72C213.475 56.944 213.245 57.168 212.947 57.392C212.659 57.616 212.296 57.8027 211.859 57.952C211.432 58.0907 210.947 58.16 210.403 58.16ZM208.211 53.232H212.595V53.184C212.595 52.704 212.504 52.2773 212.323 51.904C212.152 51.5307 211.901 51.2373 211.571 51.024C211.24 50.8 210.845 50.688 210.387 50.688C209.928 50.688 209.533 50.8 209.203 51.024C208.883 51.2373 208.637 51.5307 208.467 51.904C208.296 52.2773 208.211 52.704 208.211 53.184V53.232ZM216.396 58C216.289 58 216.198 57.968 216.124 57.904C216.06 57.8293 216.028 57.7387 216.028 57.632V50.048C216.028 49.9413 216.06 49.856 216.124 49.792C216.198 49.7173 216.289 49.68 216.396 49.68H217.148C217.254 49.68 217.34 49.7173 217.404 49.792C217.478 49.856 217.516 49.9413 217.516 50.048V50.752C217.793 50.3893 218.14 50.096 218.556 49.872C218.982 49.6373 219.526 49.52 220.188 49.52C220.881 49.52 221.468 49.6747 221.948 49.984C222.438 50.2827 222.806 50.704 223.052 51.248C223.308 51.7813 223.436 52.4053 223.436 53.12V57.632C223.436 57.7387 223.398 57.8293 223.324 57.904C223.26 57.968 223.174 58 223.068 58H222.268C222.161 58 222.07 57.968 221.996 57.904C221.932 57.8293 221.9 57.7387 221.9 57.632V53.2C221.9 52.4533 221.718 51.872 221.356 51.456C220.993 51.0293 220.46 50.816 219.756 50.816C219.094 50.816 218.561 51.0293 218.156 51.456C217.761 51.872 217.564 52.4533 217.564 53.2V57.632C217.564 57.7387 217.526 57.8293 217.452 57.904C217.388 57.968 217.302 58 217.196 58H216.396ZM228.87 58C228.272 58 227.787 57.888 227.414 57.664C227.04 57.4293 226.768 57.104 226.598 56.688C226.427 56.2613 226.342 55.76 226.342 55.184V50.96H225.094C224.987 50.96 224.896 50.928 224.822 50.864C224.758 50.7893 224.726 50.6987 224.726 50.592V50.048C224.726 49.9413 224.758 49.856 224.822 49.792C224.896 49.7173 224.987 49.68 225.094 49.68H226.342V47.008C226.342 46.9013 226.374 46.816 226.438 46.752C226.512 46.6773 226.603 46.64 226.71 46.64H227.462C227.568 46.64 227.654 46.6773 227.718 46.752C227.792 46.816 227.83 46.9013 227.83 47.008V49.68H229.814C229.931 49.68 230.022 49.7173 230.086 49.792C230.15 49.856 230.182 49.9413 230.182 50.048V50.592C230.182 50.6987 230.15 50.7893 230.086 50.864C230.022 50.928 229.931 50.96 229.814 50.96H227.83V55.072C227.83 55.5733 227.915 55.968 228.086 56.256C228.256 56.544 228.56 56.688 228.998 56.688H229.974C230.08 56.688 230.166 56.7253 230.23 56.8C230.304 56.864 230.342 56.9493 230.342 57.056V57.632C230.342 57.7387 230.304 57.8293 230.23 57.904C230.166 57.968 230.08 58 229.974 58H228.87ZM232.24 58C232.133 58 232.042 57.968 231.968 57.904C231.904 57.8293 231.872 57.7387 231.872 57.632V50.048C231.872 49.9413 231.904 49.856 231.968 49.792C232.042 49.7173 232.133 49.68 232.24 49.68H233.008C233.114 49.68 233.2 49.7173 233.264 49.792C233.338 49.856 233.376 49.9413 233.376 50.048V57.632C233.376 57.7387 233.338 57.8293 233.264 57.904C233.2 57.968 233.114 58 233.008 58H232.24ZM232.112 48.128C232.005 48.128 231.914 48.096 231.84 48.032C231.776 47.9573 231.743 47.8667 231.743 47.76V46.896C231.743 46.7893 231.776 46.6987 231.84 46.624C231.914 46.5493 232.005 46.512 232.112 46.512H233.12C233.226 46.512 233.317 46.5493 233.392 46.624C233.466 46.6987 233.504 46.7893 233.504 46.896V47.76C233.504 47.8667 233.466 47.9573 233.392 48.032C233.317 48.096 233.226 48.128 233.12 48.128H232.112ZM238.995 58C238.397 58 237.912 57.888 237.539 57.664C237.165 57.4293 236.893 57.104 236.723 56.688C236.552 56.2613 236.467 55.76 236.467 55.184V50.96H235.219C235.112 50.96 235.021 50.928 234.947 50.864C234.883 50.7893 234.851 50.6987 234.851 50.592V50.048C234.851 49.9413 234.883 49.856 234.947 49.792C235.021 49.7173 235.112 49.68 235.219 49.68H236.467V47.008C236.467 46.9013 236.499 46.816 236.562 46.752C236.637 46.6773 236.728 46.64 236.835 46.64H237.587C237.693 46.64 237.779 46.6773 237.843 46.752C237.917 46.816 237.955 46.9013 237.955 47.008V49.68H239.939C240.056 49.68 240.147 49.7173 240.211 49.792C240.275 49.856 240.307 49.9413 240.307 50.048V50.592C240.307 50.6987 240.275 50.7893 240.211 50.864C240.147 50.928 240.056 50.96 239.939 50.96H237.955V55.072C237.955 55.5733 238.04 55.968 238.211 56.256C238.381 56.544 238.685 56.688 239.123 56.688H240.099C240.205 56.688 240.291 56.7253 240.355 56.8C240.429 56.864 240.467 56.9493 240.467 57.056V57.632C240.467 57.7387 240.429 57.8293 240.355 57.904C240.291 57.968 240.205 58 240.099 58H238.995ZM242.365 58C242.258 58 242.167 57.968 242.093 57.904C242.029 57.8293 241.997 57.7387 241.997 57.632V50.048C241.997 49.9413 242.029 49.856 242.093 49.792C242.167 49.7173 242.258 49.68 242.365 49.68H243.133C243.239 49.68 243.325 49.7173 243.389 49.792C243.463 49.856 243.501 49.9413 243.501 50.048V57.632C243.501 57.7387 243.463 57.8293 243.389 57.904C243.325 57.968 243.239 58 243.133 58H242.365ZM242.237 48.128C242.13 48.128 242.039 48.096 241.965 48.032C241.901 47.9573 241.868 47.8667 241.868 47.76V46.896C241.868 46.7893 241.901 46.6987 241.965 46.624C242.039 46.5493 242.13 46.512 242.237 46.512H243.245C243.351 46.512 243.442 46.5493 243.517 46.624C243.591 46.6987 243.629 46.7893 243.629 46.896V47.76C243.629 47.8667 243.591 47.9573 243.517 48.032C243.442 48.096 243.351 48.128 243.245 48.128H242.237ZM249.2 58.16C248.09 58.16 247.21 57.824 246.56 57.152C245.909 56.4693 245.552 55.5413 245.488 54.368C245.477 54.2293 245.472 54.0533 245.472 53.84C245.472 53.616 245.477 53.4347 245.488 53.296C245.53 52.5387 245.706 51.8773 246.016 51.312C246.325 50.736 246.746 50.2933 247.28 49.984C247.824 49.6747 248.458 49.52 249.184 49.52C249.994 49.52 250.672 49.6907 251.216 50.032C251.77 50.3733 252.192 50.8587 252.48 51.488C252.768 52.1173 252.911 52.8533 252.911 53.696V53.968C252.911 54.0853 252.874 54.176 252.8 54.24C252.736 54.304 252.65 54.336 252.544 54.336H247.008C247.008 54.3467 247.008 54.368 247.008 54.4C247.008 54.432 247.008 54.4587 247.008 54.48C247.029 54.9173 247.125 55.328 247.296 55.712C247.466 56.0853 247.712 56.3893 248.032 56.624C248.362 56.8587 248.746 56.976 249.184 56.976C249.568 56.976 249.888 56.9173 250.144 56.8C250.4 56.6827 250.608 56.5547 250.768 56.416C250.928 56.2667 251.034 56.1493 251.088 56.064C251.184 55.936 251.258 55.8613 251.312 55.84C251.365 55.808 251.45 55.792 251.568 55.792H252.352C252.448 55.792 252.528 55.824 252.592 55.888C252.666 55.9413 252.698 56.0213 252.688 56.128C252.677 56.288 252.592 56.4853 252.432 56.72C252.272 56.944 252.042 57.168 251.744 57.392C251.456 57.616 251.093 57.8027 250.656 57.952C250.229 58.0907 249.744 58.16 249.2 58.16ZM247.008 53.232H251.392V53.184C251.392 52.704 251.301 52.2773 251.12 51.904C250.949 51.5307 250.698 51.2373 250.368 51.024C250.037 50.8 249.642 50.688 249.184 50.688C248.725 50.688 248.33 50.8 248 51.024C247.68 51.2373 247.434 51.5307 247.264 51.904C247.093 52.2773 247.008 52.704 247.008 53.184V53.232ZM257.705 58.16C257.107 58.16 256.595 58.0853 256.169 57.936C255.742 57.7867 255.395 57.6053 255.129 57.392C254.862 57.1787 254.659 56.9653 254.521 56.752C254.393 56.5387 254.323 56.368 254.313 56.24C254.302 56.1227 254.339 56.032 254.425 55.968C254.51 55.904 254.595 55.872 254.681 55.872H255.401C255.454 55.872 255.497 55.8827 255.529 55.904C255.571 55.9147 255.625 55.9573 255.689 56.032C255.827 56.1813 255.982 56.3307 256.153 56.48C256.323 56.6293 256.531 56.752 256.777 56.848C257.033 56.944 257.347 56.992 257.721 56.992C258.265 56.992 258.713 56.8907 259.065 56.688C259.417 56.4747 259.593 56.1653 259.593 55.76C259.593 55.4933 259.518 55.28 259.369 55.12C259.23 54.96 258.974 54.816 258.601 54.688C258.238 54.56 257.737 54.4267 257.097 54.288C256.457 54.1387 255.95 53.9573 255.577 53.744C255.203 53.52 254.937 53.2587 254.777 52.96C254.617 52.6507 254.537 52.304 254.537 51.92C254.537 51.5253 254.654 51.1467 254.889 50.784C255.123 50.4107 255.465 50.1067 255.913 49.872C256.371 49.6373 256.942 49.52 257.625 49.52C258.179 49.52 258.654 49.5893 259.049 49.728C259.443 49.8667 259.769 50.0427 260.025 50.256C260.281 50.4587 260.473 50.6613 260.601 50.864C260.729 51.0667 260.798 51.2373 260.809 51.376C260.819 51.4827 260.787 51.5733 260.713 51.648C260.638 51.712 260.553 51.744 260.457 51.744H259.785C259.71 51.744 259.646 51.728 259.593 51.696C259.55 51.664 259.507 51.6267 259.465 51.584C259.358 51.4453 259.23 51.3067 259.081 51.168C258.942 51.0293 258.755 50.9173 258.521 50.832C258.297 50.736 257.998 50.688 257.625 50.688C257.091 50.688 256.691 50.8 256.425 51.024C256.158 51.248 256.025 51.5307 256.025 51.872C256.025 52.0747 256.083 52.256 256.201 52.416C256.318 52.576 256.542 52.72 256.873 52.848C257.203 52.976 257.694 53.1147 258.345 53.264C259.049 53.4027 259.603 53.5893 260.009 53.824C260.414 54.0587 260.702 54.3307 260.873 54.64C261.043 54.9493 261.129 55.3067 261.129 55.712C261.129 56.16 261.001 56.5707 260.745 56.944C260.489 57.3173 260.105 57.616 259.593 57.84C259.081 58.0533 258.451 58.16 257.705 58.16Z" fill="#717385"/>
<rect x="24" y="103" width="2" height="46" rx="1" fill="#0294F7"/>
<path d="M39.104 120.16C38.1867 120.16 37.3973 119.989 36.736 119.648C36.0747 119.296 35.5627 118.827 35.2 118.24C34.8373 117.643 34.656 116.976 34.656 116.24C34.656 115.909 34.6987 115.589 34.784 115.28C34.8693 114.971 34.9813 114.677 35.12 114.4C35.2587 114.123 35.392 113.877 35.52 113.664C35.6587 113.44 35.7813 113.264 35.888 113.136L38.816 109.12C38.8587 109.067 38.9227 109.003 39.008 108.928C39.0933 108.843 39.2107 108.8 39.36 108.8H40.848C40.944 108.8 41.024 108.837 41.088 108.912C41.152 108.976 41.184 109.056 41.184 109.152C41.184 109.195 41.1733 109.237 41.152 109.28C41.1413 109.312 41.1253 109.339 41.104 109.36L38.864 112.464C38.96 112.432 39.072 112.411 39.2 112.4C39.328 112.389 39.4453 112.384 39.552 112.384C40.0853 112.395 40.592 112.501 41.072 112.704C41.552 112.896 41.9733 113.163 42.336 113.504C42.6987 113.845 42.9813 114.245 43.184 114.704C43.3973 115.163 43.504 115.664 43.504 116.208C43.504 116.912 43.328 117.568 42.976 118.176C42.624 118.773 42.1173 119.253 41.456 119.616C40.8053 119.979 40.0213 120.16 39.104 120.16ZM39.088 118.32C39.472 118.32 39.824 118.24 40.144 118.08C40.4747 117.92 40.7413 117.685 40.944 117.376C41.1467 117.067 41.248 116.683 41.248 116.224C41.248 115.776 41.1467 115.397 40.944 115.088C40.7413 114.779 40.4747 114.544 40.144 114.384C39.824 114.224 39.472 114.144 39.088 114.144C38.704 114.144 38.3467 114.224 38.016 114.384C37.696 114.544 37.4347 114.779 37.232 115.088C37.0293 115.397 36.928 115.776 36.928 116.224C36.928 116.683 37.0293 117.067 37.232 117.376C37.4347 117.685 37.696 117.92 38.016 118.08C38.3467 118.24 38.704 118.32 39.088 118.32ZM45.3753 120C45.2686 120 45.1779 119.963 45.1033 119.888C45.0286 119.813 44.9913 119.723 44.9913 119.616V118.032C44.9913 117.915 45.0286 117.819 45.1033 117.744C45.1779 117.669 45.2686 117.632 45.3753 117.632H46.9753C47.0819 117.632 47.1726 117.669 47.2473 117.744C47.3219 117.819 47.3593 117.915 47.3593 118.032V119.616C47.3593 119.723 47.3219 119.813 47.2473 119.888C47.1726 119.963 47.0819 120 46.9753 120H45.3753ZM53.2885 120.16C52.5418 120.16 51.8965 120.069 51.3525 119.888C50.8085 119.707 50.3552 119.472 49.9925 119.184C49.6405 118.885 49.3738 118.565 49.1925 118.224C49.0112 117.872 48.9152 117.525 48.9045 117.184C48.9045 117.088 48.9365 117.013 49.0005 116.96C49.0752 116.896 49.1605 116.864 49.2565 116.864H50.6965C50.8032 116.864 50.8938 116.885 50.9685 116.928C51.0432 116.971 51.1072 117.056 51.1605 117.184C51.2565 117.472 51.4112 117.701 51.6245 117.872C51.8485 118.043 52.1045 118.165 52.3925 118.24C52.6805 118.304 52.9845 118.336 53.3045 118.336C53.9445 118.336 54.4512 118.187 54.8245 117.888C55.2085 117.579 55.4005 117.141 55.4005 116.576C55.4005 116.011 55.2245 115.605 54.8725 115.36C54.5205 115.104 54.0298 114.976 53.4005 114.976H51.7525C51.6352 114.976 51.5392 114.944 51.4645 114.88C51.3898 114.805 51.3525 114.709 51.3525 114.592V113.92C51.3525 113.813 51.3738 113.723 51.4165 113.648C51.4698 113.563 51.5232 113.493 51.5765 113.44L54.4405 110.64H49.8645C49.7472 110.64 49.6512 110.603 49.5765 110.528C49.5125 110.453 49.4805 110.363 49.4805 110.256V109.2C49.4805 109.083 49.5125 108.987 49.5765 108.912C49.6512 108.837 49.7472 108.8 49.8645 108.8H56.7285C56.8458 108.8 56.9418 108.837 57.0165 108.912C57.0912 108.987 57.1285 109.083 57.1285 109.2V110.16C57.1285 110.256 57.1072 110.341 57.0645 110.416C57.0218 110.491 56.9738 110.555 56.9205 110.608L54.1525 113.456L54.3445 113.472C54.9952 113.525 55.5712 113.675 56.0725 113.92C56.5845 114.155 56.9792 114.501 57.2565 114.96C57.5445 115.419 57.6885 115.995 57.6885 116.688C57.6885 117.413 57.4965 118.037 57.1125 118.56C56.7392 119.072 56.2218 119.467 55.5605 119.744C54.8992 120.021 54.1418 120.16 53.2885 120.16ZM60.0226 120C59.916 120 59.8253 119.963 59.7506 119.888C59.676 119.813 59.6386 119.723 59.6386 119.616V109.2C59.6386 109.083 59.676 108.987 59.7506 108.912C59.8253 108.837 59.916 108.8 60.0226 108.8H61.4306C61.548 108.8 61.644 108.837 61.7186 108.912C61.7933 108.987 61.8306 109.083 61.8306 109.2V112.944L65.4466 109.088C65.4893 109.035 65.5586 108.976 65.6546 108.912C65.7613 108.837 65.9 108.8 66.0706 108.8H67.6546C67.74 108.8 67.8146 108.832 67.8786 108.896C67.9533 108.96 67.9906 109.04 67.9906 109.136C67.9906 109.211 67.9693 109.275 67.9266 109.328L63.5266 114.16L68.2306 119.456C68.284 119.52 68.3106 119.589 68.3106 119.664C68.3106 119.76 68.2733 119.84 68.1986 119.904C68.1346 119.968 68.06 120 67.9746 120H66.3266C66.1453 120 66.0013 119.963 65.8946 119.888C65.7986 119.803 65.7346 119.744 65.7026 119.712L61.8306 115.472V119.616C61.8306 119.723 61.7933 119.813 61.7186 119.888C61.644 119.963 61.548 120 61.4306 120H60.0226Z" fill="#212328"/>
<path d="M76.7029 122.544C76.0095 122.544 75.4229 122.395 74.9429 122.096C74.4629 121.808 74.0789 121.36 73.7909 120.752C73.5029 120.144 73.2895 119.371 73.1509 118.432C73.0229 117.483 72.9589 116.357 72.9589 115.056C72.9589 113.755 73.0229 112.629 73.1509 111.68C73.2895 110.731 73.5029 109.957 73.7909 109.36C74.0789 108.752 74.4629 108.304 74.9429 108.016C75.4229 107.728 76.0095 107.584 76.7029 107.584C76.8095 107.584 76.8949 107.621 76.9589 107.696C77.0335 107.771 77.0709 107.856 77.0709 107.952V108.512C77.0709 108.608 77.0335 108.693 76.9589 108.768C76.8949 108.843 76.8255 108.88 76.7509 108.88C76.3029 108.891 75.9242 109.008 75.6149 109.232C75.3162 109.445 75.0709 109.792 74.8789 110.272C74.6975 110.752 74.5642 111.387 74.4789 112.176C74.4042 112.955 74.3669 113.915 74.3669 115.056C74.3669 116.197 74.4042 117.163 74.4789 117.952C74.5642 118.731 74.6975 119.36 74.8789 119.84C75.0709 120.32 75.3162 120.672 75.6149 120.896C75.9242 121.12 76.3029 121.237 76.7509 121.248C76.8255 121.248 76.8949 121.28 76.9589 121.344C77.0335 121.419 77.0709 121.509 77.0709 121.616V122.176C77.0709 122.272 77.0335 122.357 76.9589 122.432C76.8949 122.507 76.8095 122.544 76.7029 122.544ZM81.922 120.16C81.0793 120.16 80.3647 120.016 79.778 119.728C79.202 119.429 78.7593 119.045 78.45 118.576C78.1513 118.107 77.9913 117.611 77.97 117.088C77.9593 116.992 77.986 116.917 78.05 116.864C78.114 116.8 78.194 116.768 78.29 116.768H79.154C79.25 116.768 79.3353 116.795 79.41 116.848C79.4847 116.891 79.5433 116.981 79.586 117.12C79.6927 117.515 79.8633 117.84 80.098 118.096C80.3433 118.341 80.6207 118.523 80.93 118.64C81.25 118.747 81.5807 118.8 81.922 118.8C82.3807 118.8 82.7967 118.709 83.17 118.528C83.554 118.336 83.858 118.059 84.082 117.696C84.306 117.323 84.418 116.875 84.418 116.352C84.418 115.872 84.306 115.461 84.082 115.12C83.8687 114.768 83.57 114.501 83.186 114.32C82.8127 114.128 82.3913 114.032 81.922 114.032C81.57 114.032 81.282 114.075 81.058 114.16C80.834 114.245 80.642 114.347 80.482 114.464C80.3327 114.581 80.194 114.683 80.066 114.768C79.9487 114.853 79.8153 114.896 79.666 114.896H78.834C78.738 114.896 78.6527 114.864 78.578 114.8C78.5033 114.725 78.4713 114.64 78.482 114.544L78.994 109.2C79.0047 109.072 79.042 108.976 79.106 108.912C79.1807 108.837 79.2767 108.8 79.394 108.8H84.978C85.0847 108.8 85.17 108.837 85.234 108.912C85.3087 108.976 85.346 109.061 85.346 109.168V109.792C85.346 109.909 85.3087 110 85.234 110.064C85.17 110.128 85.0847 110.16 84.978 110.16H80.37L80.066 113.312C80.226 113.216 80.466 113.104 80.786 112.976C81.1167 112.837 81.57 112.768 82.146 112.768C82.6793 112.768 83.1753 112.848 83.634 113.008C84.1033 113.168 84.514 113.403 84.866 113.712C85.2287 114.021 85.5113 114.4 85.714 114.848C85.9167 115.285 86.018 115.792 86.018 116.368C86.018 117.179 85.842 117.867 85.49 118.432C85.138 118.997 84.6527 119.429 84.034 119.728C83.4153 120.016 82.7113 120.16 81.922 120.16ZM91.822 120.16C91.086 120.16 90.462 120.048 89.95 119.824C89.4487 119.589 89.038 119.269 88.718 118.864C88.398 118.459 88.1633 117.995 88.014 117.472C87.8753 116.949 87.7953 116.395 87.774 115.808C87.7633 115.52 87.7527 115.216 87.742 114.896C87.742 114.576 87.742 114.251 87.742 113.92C87.7527 113.589 87.7633 113.275 87.774 112.976C87.7847 112.389 87.8647 111.835 88.014 111.312C88.174 110.789 88.414 110.331 88.734 109.936C89.054 109.531 89.4647 109.216 89.966 108.992C90.478 108.757 91.0967 108.64 91.822 108.64C92.558 108.64 93.1767 108.757 93.678 108.992C94.19 109.216 94.606 109.531 94.926 109.936C95.246 110.331 95.4807 110.789 95.63 111.312C95.79 111.835 95.8753 112.389 95.886 112.976C95.8967 113.275 95.902 113.589 95.902 113.92C95.9127 114.251 95.9127 114.576 95.902 114.896C95.902 115.216 95.8967 115.52 95.886 115.808C95.8753 116.395 95.79 116.949 95.63 117.472C95.4807 117.995 95.246 118.459 94.926 118.864C94.6167 119.269 94.206 119.589 93.694 119.824C93.1927 120.048 92.5687 120.16 91.822 120.16ZM91.822 118.784C92.654 118.784 93.2673 118.512 93.662 117.968C94.0673 117.424 94.2753 116.677 94.286 115.728C94.3073 115.419 94.318 115.12 94.318 114.832C94.318 114.533 94.318 114.24 94.318 113.952C94.318 113.653 94.3073 113.36 94.286 113.072C94.2753 112.144 94.0673 111.403 93.662 110.848C93.2673 110.283 92.654 110 91.822 110C91.0007 110 90.3873 110.283 89.982 110.848C89.5873 111.403 89.3793 112.144 89.358 113.072C89.358 113.36 89.3527 113.653 89.342 113.952C89.342 114.24 89.342 114.533 89.342 114.832C89.3527 115.12 89.358 115.419 89.358 115.728C89.3793 116.677 89.5927 117.424 89.998 117.968C90.4033 118.512 91.0113 118.784 91.822 118.784ZM98.6503 120C98.4263 120 98.3143 119.893 98.3143 119.68C98.3143 119.616 98.3356 119.557 98.3783 119.504L106.282 109.104C106.357 109.008 106.426 108.933 106.49 108.88C106.565 108.827 106.672 108.8 106.81 108.8H107.338C107.562 108.8 107.674 108.907 107.674 109.12C107.674 109.184 107.653 109.243 107.61 109.296L99.7223 119.696C99.6476 119.792 99.5729 119.867 99.4983 119.92C99.4343 119.973 99.3276 120 99.1783 120H98.6503ZM105.978 120.096C105.285 120.096 104.736 119.899 104.33 119.504C103.936 119.109 103.717 118.592 103.674 117.952C103.664 117.675 103.658 117.44 103.658 117.248C103.658 117.045 103.664 116.795 103.674 116.496C103.717 115.856 103.925 115.339 104.298 114.944C104.682 114.539 105.242 114.336 105.978 114.336C106.725 114.336 107.285 114.539 107.658 114.944C108.042 115.339 108.256 115.856 108.298 116.496C108.32 116.795 108.33 117.045 108.33 117.248C108.33 117.44 108.32 117.675 108.298 117.952C108.256 118.592 108.032 119.109 107.626 119.504C107.232 119.899 106.682 120.096 105.978 120.096ZM105.978 119.04C106.266 119.04 106.49 118.981 106.65 118.864C106.81 118.747 106.928 118.603 107.002 118.432C107.077 118.251 107.12 118.069 107.13 117.888C107.152 117.6 107.162 117.371 107.162 117.2C107.162 117.029 107.152 116.816 107.13 116.56C107.12 116.272 107.029 116.005 106.858 115.76C106.688 115.515 106.394 115.392 105.978 115.392C105.573 115.392 105.285 115.515 105.114 115.76C104.954 116.005 104.864 116.272 104.842 116.56C104.832 116.816 104.826 117.029 104.826 117.2C104.826 117.371 104.832 117.6 104.842 117.888C104.864 118.069 104.906 118.251 104.97 118.432C105.045 118.603 105.162 118.747 105.322 118.864C105.493 118.981 105.712 119.04 105.978 119.04ZM99.9943 114.416C99.2903 114.416 98.7409 114.229 98.3463 113.856C97.9516 113.483 97.7329 112.976 97.6903 112.336C97.6796 112.059 97.6743 111.824 97.6743 111.632C97.6743 111.429 97.6796 111.179 97.6903 110.88C97.7223 110.24 97.9303 109.723 98.3143 109.328C98.6983 108.923 99.2583 108.72 99.9943 108.72C100.741 108.72 101.301 108.923 101.674 109.328C102.058 109.723 102.266 110.24 102.298 110.88C102.32 111.179 102.33 111.429 102.33 111.632C102.33 111.824 102.32 112.059 102.298 112.336C102.266 112.976 102.048 113.483 101.642 113.856C101.248 114.229 100.698 114.416 99.9943 114.416ZM99.9943 113.424C100.272 113.424 100.49 113.365 100.65 113.248C100.821 113.131 100.944 112.987 101.018 112.816C101.093 112.635 101.136 112.453 101.146 112.272C101.168 111.984 101.178 111.76 101.178 111.6C101.178 111.429 101.168 111.211 101.146 110.944C101.136 110.656 101.04 110.389 100.858 110.144C100.688 109.899 100.4 109.776 99.9943 109.776C99.5889 109.776 99.3009 109.899 99.1303 110.144C98.9703 110.389 98.8796 110.656 98.8583 110.944C98.8476 111.211 98.8423 111.429 98.8423 111.6C98.8423 111.76 98.8476 111.984 98.8583 112.272C98.8796 112.453 98.9223 112.635 98.9863 112.816C99.0609 112.987 99.1783 113.131 99.3383 113.248C99.4983 113.365 99.7169 113.424 99.9943 113.424ZM109.83 122.544C109.734 122.544 109.649 122.507 109.574 122.432C109.499 122.357 109.462 122.272 109.462 122.176V121.616C109.462 121.509 109.494 121.419 109.558 121.344C109.633 121.28 109.713 121.248 109.798 121.248C110.246 121.237 110.619 121.12 110.918 120.896C111.227 120.672 111.473 120.32 111.654 119.84C111.835 119.36 111.969 118.731 112.054 117.952C112.139 117.163 112.182 116.197 112.182 115.056C112.182 113.915 112.139 112.955 112.054 112.176C111.969 111.387 111.835 110.752 111.654 110.272C111.473 109.792 111.227 109.445 110.918 109.232C110.619 109.008 110.246 108.891 109.798 108.88C109.713 108.88 109.633 108.843 109.558 108.768C109.494 108.693 109.462 108.608 109.462 108.512V107.952C109.462 107.856 109.499 107.771 109.574 107.696C109.649 107.621 109.734 107.584 109.83 107.584C110.523 107.584 111.11 107.728 111.59 108.016C112.07 108.304 112.454 108.752 112.742 109.36C113.041 109.957 113.254 110.731 113.382 111.68C113.51 112.629 113.574 113.755 113.574 115.056C113.574 116.357 113.51 117.483 113.382 118.432C113.254 119.371 113.041 120.144 112.742 120.752C112.454 121.36 112.07 121.808 111.59 122.096C111.11 122.395 110.523 122.544 109.83 122.544Z" fill="#717385"/>
<path d="M36.87 144C36.7487 144 36.6507 143.967 36.576 143.902C36.5107 143.837 36.464 143.743 36.436 143.622L34.63 134.634C34.6207 134.597 34.616 134.564 34.616 134.536C34.616 134.508 34.616 134.489 34.616 134.48C34.616 134.405 34.644 134.34 34.7 134.284C34.756 134.228 34.8213 134.2 34.896 134.2H35.624C35.82 134.2 35.932 134.279 35.96 134.438L37.388 141.662L38.9 136.706C38.928 136.622 38.9747 136.547 39.04 136.482C39.1147 136.407 39.2173 136.37 39.348 136.37H39.866C40.006 136.37 40.1087 136.407 40.174 136.482C40.2393 136.547 40.2813 136.622 40.3 136.706L41.826 141.662L43.24 134.438C43.268 134.279 43.3847 134.2 43.59 134.2H44.318C44.3927 134.2 44.458 134.228 44.514 134.284C44.57 134.34 44.598 134.405 44.598 134.48C44.598 134.489 44.5933 134.508 44.584 134.536C44.584 134.564 44.584 134.597 44.584 134.634L42.778 143.622C42.75 143.743 42.6987 143.837 42.624 143.902C42.5587 143.967 42.4653 144 42.344 144H41.798C41.6673 144 41.5647 143.967 41.49 143.902C41.4153 143.837 41.364 143.753 41.336 143.65L39.6 138.316L37.878 143.65C37.8407 143.753 37.7847 143.837 37.71 143.902C37.6447 143.967 37.5467 144 37.416 144H36.87ZM48.9282 144.14C48.2188 144.14 47.6262 144.005 47.1502 143.734C46.6742 143.463 46.3102 143.09 46.0582 142.614C45.8062 142.129 45.6662 141.578 45.6382 140.962C45.6288 140.803 45.6242 140.603 45.6242 140.36C45.6242 140.108 45.6288 139.907 45.6382 139.758C45.6662 139.133 45.8062 138.582 46.0582 138.106C46.3195 137.63 46.6882 137.257 47.1642 136.986C47.6402 136.715 48.2282 136.58 48.9282 136.58C49.6282 136.58 50.2162 136.715 50.6922 136.986C51.1682 137.257 51.5322 137.63 51.7842 138.106C52.0455 138.582 52.1902 139.133 52.2182 139.758C52.2275 139.907 52.2322 140.108 52.2322 140.36C52.2322 140.603 52.2275 140.803 52.2182 140.962C52.1902 141.578 52.0502 142.129 51.7982 142.614C51.5462 143.09 51.1822 143.463 50.7062 143.734C50.2302 144.005 49.6375 144.14 48.9282 144.14ZM48.9282 143.062C49.5068 143.062 49.9688 142.88 50.3142 142.516C50.6595 142.143 50.8462 141.601 50.8742 140.892C50.8835 140.752 50.8882 140.575 50.8882 140.36C50.8882 140.145 50.8835 139.968 50.8742 139.828C50.8462 139.119 50.6595 138.582 50.3142 138.218C49.9688 137.845 49.5068 137.658 48.9282 137.658C48.3495 137.658 47.8828 137.845 47.5282 138.218C47.1828 138.582 47.0008 139.119 46.9822 139.828C46.9728 139.968 46.9682 140.145 46.9682 140.36C46.9682 140.575 46.9728 140.752 46.9822 140.892C47.0008 141.601 47.1828 142.143 47.5282 142.516C47.8828 142.88 48.3495 143.062 48.9282 143.062ZM54.3072 144C54.2139 144 54.1346 143.972 54.0692 143.916C54.0132 143.851 53.9852 143.771 53.9852 143.678V137.056C53.9852 136.963 54.0132 136.883 54.0692 136.818C54.1346 136.753 54.2139 136.72 54.3072 136.72H54.9512C55.0446 136.72 55.1239 136.753 55.1892 136.818C55.2546 136.883 55.2872 136.963 55.2872 137.056V137.672C55.4739 137.355 55.7306 137.117 56.0572 136.958C56.3839 136.799 56.7806 136.72 57.2472 136.72H57.7932C57.8866 136.72 57.9612 136.753 58.0172 136.818C58.0826 136.874 58.1152 136.949 58.1152 137.042V137.616C58.1152 137.709 58.0826 137.784 58.0172 137.84C57.9612 137.896 57.8866 137.924 57.7932 137.924H56.9532C56.4492 137.924 56.0526 138.073 55.7632 138.372C55.4739 138.661 55.3292 139.058 55.3292 139.562V143.678C55.3292 143.771 55.2966 143.851 55.2312 143.916C55.1659 143.972 55.0866 144 54.9932 144H54.3072ZM59.6396 144C59.5462 144 59.4669 143.972 59.4016 143.916C59.3456 143.851 59.3176 143.771 59.3176 143.678V134.382C59.3176 134.289 59.3456 134.214 59.4016 134.158C59.4669 134.093 59.5462 134.06 59.6396 134.06H60.2976C60.3909 134.06 60.4656 134.093 60.5216 134.158C60.5869 134.214 60.6196 134.289 60.6196 134.382V139.254L63.3776 136.958C63.4896 136.865 63.5736 136.804 63.6296 136.776C63.6949 136.739 63.7976 136.72 63.9376 136.72H64.6796C64.7636 136.72 64.8336 136.748 64.8896 136.804C64.9456 136.86 64.9736 136.93 64.9736 137.014C64.9736 137.051 64.9596 137.093 64.9316 137.14C64.9129 137.187 64.8709 137.233 64.8056 137.28L61.5716 139.968L65.1556 143.454C65.2676 143.547 65.3236 143.631 65.3236 143.706C65.3236 143.79 65.2956 143.86 65.2396 143.916C65.1836 143.972 65.1136 144 65.0296 144H64.3016C64.1616 144 64.0589 143.986 63.9936 143.958C63.9282 143.921 63.8442 143.855 63.7416 143.762L60.6196 140.78V143.678C60.6196 143.771 60.5869 143.851 60.5216 143.916C60.4656 143.972 60.3909 144 60.2976 144H59.6396ZM67.5723 144C67.479 144 67.3997 143.972 67.3343 143.916C67.2783 143.851 67.2503 143.771 67.2503 143.678V137.84H66.0603C65.967 137.84 65.8877 137.812 65.8223 137.756C65.7663 137.691 65.7383 137.611 65.7383 137.518V137.042C65.7383 136.949 65.7663 136.874 65.8223 136.818C65.8877 136.753 65.967 136.72 66.0603 136.72H67.2503V136.02C67.2503 135.544 67.3297 135.129 67.4883 134.774C67.647 134.41 67.899 134.13 68.2443 133.934C68.599 133.738 69.0703 133.64 69.6583 133.64H70.4983C70.5917 133.64 70.6663 133.673 70.7223 133.738C70.7877 133.794 70.8203 133.869 70.8203 133.962V134.438C70.8203 134.531 70.7877 134.611 70.7223 134.676C70.6663 134.732 70.5917 134.76 70.4983 134.76H69.6863C69.2477 134.76 68.949 134.877 68.7903 135.11C68.6317 135.334 68.5523 135.661 68.5523 136.09V136.72H70.3583C70.4517 136.72 70.5263 136.753 70.5823 136.818C70.6477 136.874 70.6803 136.949 70.6803 137.042V137.518C70.6803 137.611 70.6477 137.691 70.5823 137.756C70.5263 137.812 70.4517 137.84 70.3583 137.84H68.5523V143.678C68.5523 143.771 68.5197 143.851 68.4543 143.916C68.3983 143.972 68.3237 144 68.2303 144H67.5723ZM74.7543 144.14C74.045 144.14 73.4523 144.005 72.9763 143.734C72.5003 143.463 72.1363 143.09 71.8843 142.614C71.6323 142.129 71.4923 141.578 71.4643 140.962C71.455 140.803 71.4503 140.603 71.4503 140.36C71.4503 140.108 71.455 139.907 71.4643 139.758C71.4923 139.133 71.6323 138.582 71.8843 138.106C72.1457 137.63 72.5143 137.257 72.9903 136.986C73.4663 136.715 74.0543 136.58 74.7543 136.58C75.4543 136.58 76.0423 136.715 76.5183 136.986C76.9943 137.257 77.3583 137.63 77.6103 138.106C77.8717 138.582 78.0163 139.133 78.0443 139.758C78.0537 139.907 78.0583 140.108 78.0583 140.36C78.0583 140.603 78.0537 140.803 78.0443 140.962C78.0163 141.578 77.8763 142.129 77.6243 142.614C77.3723 143.09 77.0083 143.463 76.5323 143.734C76.0563 144.005 75.4637 144.14 74.7543 144.14ZM74.7543 143.062C75.333 143.062 75.795 142.88 76.1403 142.516C76.4857 142.143 76.6723 141.601 76.7003 140.892C76.7097 140.752 76.7143 140.575 76.7143 140.36C76.7143 140.145 76.7097 139.968 76.7003 139.828C76.6723 139.119 76.4857 138.582 76.1403 138.218C75.795 137.845 75.333 137.658 74.7543 137.658C74.1757 137.658 73.709 137.845 73.3543 138.218C73.009 138.582 72.827 139.119 72.8083 139.828C72.799 139.968 72.7943 140.145 72.7943 140.36C72.7943 140.575 72.799 140.752 72.8083 140.892C72.827 141.601 73.009 142.143 73.3543 142.516C73.709 142.88 74.1757 143.062 74.7543 143.062ZM80.1334 144C80.0401 144 79.9607 143.972 79.8954 143.916C79.8394 143.851 79.8114 143.771 79.8114 143.678V137.056C79.8114 136.963 79.8394 136.883 79.8954 136.818C79.9607 136.753 80.0401 136.72 80.1334 136.72H80.7774C80.8707 136.72 80.9501 136.753 81.0154 136.818C81.0807 136.883 81.1134 136.963 81.1134 137.056V137.672C81.3001 137.355 81.5567 137.117 81.8834 136.958C82.2101 136.799 82.6067 136.72 83.0734 136.72H83.6194C83.7127 136.72 83.7874 136.753 83.8434 136.818C83.9087 136.874 83.9414 136.949 83.9414 137.042V137.616C83.9414 137.709 83.9087 137.784 83.8434 137.84C83.7874 137.896 83.7127 137.924 83.6194 137.924H82.7794C82.2754 137.924 81.8787 138.073 81.5894 138.372C81.3001 138.661 81.1554 139.058 81.1554 139.562V143.678C81.1554 143.771 81.1227 143.851 81.0574 143.916C80.9921 143.972 80.9127 144 80.8194 144H80.1334ZM87.933 144.14C87.2704 144.14 86.6964 144.014 86.211 143.762C85.735 143.501 85.3664 143.132 85.105 142.656C84.8437 142.171 84.7037 141.592 84.685 140.92C84.6757 140.78 84.671 140.593 84.671 140.36C84.671 140.127 84.6757 139.94 84.685 139.8C84.7037 139.128 84.8437 138.554 85.105 138.078C85.3664 137.593 85.735 137.224 86.211 136.972C86.6964 136.711 87.2704 136.58 87.933 136.58C88.4744 136.58 88.9364 136.655 89.319 136.804C89.711 136.953 90.033 137.145 90.285 137.378C90.537 137.611 90.7237 137.863 90.845 138.134C90.9757 138.405 91.0457 138.661 91.055 138.904C91.0644 138.997 91.0364 139.072 90.971 139.128C90.9057 139.184 90.8264 139.212 90.733 139.212H90.061C89.9677 139.212 89.8977 139.193 89.851 139.156C89.8044 139.109 89.7577 139.035 89.711 138.932C89.543 138.475 89.3144 138.153 89.025 137.966C88.7357 137.779 88.3764 137.686 87.947 137.686C87.387 137.686 86.9297 137.859 86.575 138.204C86.2297 138.549 86.043 139.105 86.015 139.87C86.0057 140.206 86.0057 140.533 86.015 140.85C86.043 141.625 86.2297 142.185 86.575 142.53C86.9297 142.866 87.387 143.034 87.947 143.034C88.3764 143.034 88.7357 142.941 89.025 142.754C89.3144 142.567 89.543 142.245 89.711 141.788C89.7577 141.685 89.8044 141.611 89.851 141.564C89.8977 141.517 89.9677 141.494 90.061 141.494H90.733C90.8264 141.494 90.9057 141.527 90.971 141.592C91.0364 141.648 91.0644 141.723 91.055 141.816C91.0457 142.012 91.0037 142.213 90.929 142.418C90.8544 142.623 90.733 142.833 90.565 143.048C90.4064 143.253 90.2057 143.44 89.963 143.608C89.7204 143.767 89.431 143.897 89.095 144C88.759 144.093 88.3717 144.14 87.933 144.14ZM95.6296 144.14C94.659 144.14 93.889 143.846 93.3196 143.258C92.7503 142.661 92.4376 141.849 92.3816 140.822C92.3723 140.701 92.3676 140.547 92.3676 140.36C92.3676 140.164 92.3723 140.005 92.3816 139.884C92.419 139.221 92.573 138.643 92.8436 138.148C93.1143 137.644 93.483 137.257 93.9496 136.986C94.4256 136.715 94.981 136.58 95.6156 136.58C96.325 136.58 96.9176 136.729 97.3936 137.028C97.879 137.327 98.2476 137.751 98.4996 138.302C98.7516 138.853 98.8776 139.497 98.8776 140.234V140.472C98.8776 140.575 98.845 140.654 98.7796 140.71C98.7236 140.766 98.649 140.794 98.5556 140.794H93.7116C93.7116 140.803 93.7116 140.822 93.7116 140.85C93.7116 140.878 93.7116 140.901 93.7116 140.92C93.7303 141.303 93.8143 141.662 93.9636 141.998C94.113 142.325 94.3276 142.591 94.6076 142.796C94.897 143.001 95.233 143.104 95.6156 143.104C95.9516 143.104 96.2316 143.053 96.4556 142.95C96.6796 142.847 96.8616 142.735 97.0016 142.614C97.1416 142.483 97.235 142.381 97.2816 142.306C97.3656 142.194 97.431 142.129 97.4776 142.11C97.5243 142.082 97.599 142.068 97.7016 142.068H98.3876C98.4716 142.068 98.5416 142.096 98.5976 142.152C98.663 142.199 98.691 142.269 98.6816 142.362C98.6723 142.502 98.5976 142.675 98.4576 142.88C98.3176 143.076 98.117 143.272 97.8556 143.468C97.6036 143.664 97.2863 143.827 96.9036 143.958C96.5303 144.079 96.1056 144.14 95.6296 144.14ZM93.7116 139.828H97.5476V139.786C97.5476 139.366 97.4683 138.993 97.3096 138.666C97.1603 138.339 96.941 138.083 96.6516 137.896C96.3623 137.7 96.017 137.602 95.6156 137.602C95.2143 137.602 94.869 137.7 94.5796 137.896C94.2996 138.083 94.085 138.339 93.9356 138.666C93.7863 138.993 93.7116 139.366 93.7116 139.786V139.828Z" fill="#006BB5"/>
<rect x="209.333" y="103" width="2" height="46" rx="1" fill="#D057FF"/>
<path d="M224.309 120.16C223.562 120.16 222.917 120.069 222.373 119.888C221.829 119.707 221.376 119.472 221.013 119.184C220.661 118.885 220.394 118.565 220.213 118.224C220.032 117.872 219.936 117.525 219.925 117.184C219.925 117.088 219.957 117.013 220.021 116.96C220.096 116.896 220.181 116.864 220.277 116.864H221.717C221.824 116.864 221.914 116.885 221.989 116.928C222.064 116.971 222.128 117.056 222.181 117.184C222.277 117.472 222.432 117.701 222.645 117.872C222.869 118.043 223.125 118.165 223.413 118.24C223.701 118.304 224.005 118.336 224.325 118.336C224.965 118.336 225.472 118.187 225.845 117.888C226.229 117.579 226.421 117.141 226.421 116.576C226.421 116.011 226.245 115.605 225.893 115.36C225.541 115.104 225.05 114.976 224.421 114.976H222.773C222.656 114.976 222.56 114.944 222.485 114.88C222.41 114.805 222.373 114.709 222.373 114.592V113.92C222.373 113.813 222.394 113.723 222.437 113.648C222.49 113.563 222.544 113.493 222.597 113.44L225.461 110.64H220.885C220.768 110.64 220.672 110.603 220.597 110.528C220.533 110.453 220.501 110.363 220.501 110.256V109.2C220.501 109.083 220.533 108.987 220.597 108.912C220.672 108.837 220.768 108.8 220.885 108.8H227.749C227.866 108.8 227.962 108.837 228.037 108.912C228.112 108.987 228.149 109.083 228.149 109.2V110.16C228.149 110.256 228.128 110.341 228.085 110.416C228.042 110.491 227.994 110.555 227.941 110.608L225.173 113.456L225.365 113.472C226.016 113.525 226.592 113.675 227.093 113.92C227.605 114.155 228 114.501 228.277 114.96C228.565 115.419 228.709 115.995 228.709 116.688C228.709 117.413 228.517 118.037 228.133 118.56C227.76 119.072 227.242 119.467 226.581 119.744C225.92 120.021 225.162 120.16 224.309 120.16ZM230.755 120C230.648 120 230.558 119.963 230.483 119.888C230.408 119.813 230.371 119.723 230.371 119.616V118.032C230.371 117.915 230.408 117.819 230.483 117.744C230.558 117.669 230.648 117.632 230.755 117.632H232.355C232.462 117.632 232.552 117.669 232.627 117.744C232.702 117.819 232.739 117.915 232.739 118.032V119.616C232.739 119.723 232.702 119.813 232.627 119.888C232.552 119.963 232.462 120 232.355 120H230.755ZM235.949 120C235.853 120 235.773 119.968 235.709 119.904C235.645 119.829 235.613 119.744 235.613 119.648C235.613 119.595 235.618 119.552 235.629 119.52C235.65 119.488 235.666 119.461 235.677 119.44L238.029 116.192C237.826 116.245 237.608 116.267 237.373 116.256C236.829 116.245 236.322 116.144 235.853 115.952C235.394 115.749 234.989 115.483 234.637 115.152C234.296 114.811 234.024 114.421 233.821 113.984C233.629 113.536 233.533 113.051 233.533 112.528C233.533 112.048 233.624 111.579 233.805 111.12C233.986 110.651 234.253 110.229 234.605 109.856C234.968 109.483 235.416 109.189 235.949 108.976C236.493 108.752 237.128 108.64 237.853 108.64C238.568 108.64 239.197 108.741 239.741 108.944C240.285 109.147 240.738 109.429 241.101 109.792C241.474 110.144 241.752 110.549 241.933 111.008C242.125 111.467 242.221 111.952 242.221 112.464C242.221 112.923 242.146 113.349 241.997 113.744C241.848 114.139 241.661 114.501 241.437 114.832C241.224 115.152 241.01 115.467 240.797 115.776L237.981 119.68C237.938 119.733 237.874 119.803 237.789 119.888C237.714 119.963 237.597 120 237.437 120H235.949ZM237.869 114.56C238.253 114.56 238.6 114.48 238.909 114.32C239.229 114.149 239.48 113.915 239.661 113.616C239.853 113.307 239.949 112.944 239.949 112.528C239.949 112.101 239.853 111.739 239.661 111.44C239.48 111.131 239.229 110.896 238.909 110.736C238.589 110.565 238.242 110.48 237.869 110.48C237.485 110.48 237.133 110.565 236.813 110.736C236.504 110.896 236.253 111.131 236.061 111.44C235.88 111.739 235.789 112.101 235.789 112.528C235.789 112.944 235.88 113.307 236.061 113.616C236.253 113.915 236.504 114.149 236.813 114.32C237.133 114.48 237.485 114.56 237.869 114.56ZM244.512 120C244.405 120 244.315 119.963 244.24 119.888C244.165 119.813 244.128 119.723 244.128 119.616V109.2C244.128 109.083 244.165 108.987 244.24 108.912C244.315 108.837 244.405 108.8 244.512 108.8H245.92C246.037 108.8 246.133 108.837 246.208 108.912C246.283 108.987 246.32 109.083 246.32 109.2V112.944L249.936 109.088C249.979 109.035 250.048 108.976 250.144 108.912C250.251 108.837 250.389 108.8 250.56 108.8H252.144C252.229 108.8 252.304 108.832 252.368 108.896C252.443 108.96 252.48 109.04 252.48 109.136C252.48 109.211 252.459 109.275 252.416 109.328L248.016 114.16L252.72 119.456C252.773 119.52 252.8 119.589 252.8 119.664C252.8 119.76 252.763 119.84 252.688 119.904C252.624 119.968 252.549 120 252.464 120H250.816C250.635 120 250.491 119.963 250.384 119.888C250.288 119.803 250.224 119.744 250.192 119.712L246.32 115.472V119.616C246.32 119.723 246.283 119.813 246.208 119.888C246.133 119.963 246.037 120 245.92 120H244.512Z" fill="#212328"/>
<path d="M261.192 122.544C260.499 122.544 259.912 122.395 259.432 122.096C258.952 121.808 258.568 121.36 258.28 120.752C257.992 120.144 257.779 119.371 257.64 118.432C257.512 117.483 257.448 116.357 257.448 115.056C257.448 113.755 257.512 112.629 257.64 111.68C257.779 110.731 257.992 109.957 258.28 109.36C258.568 108.752 258.952 108.304 259.432 108.016C259.912 107.728 260.499 107.584 261.192 107.584C261.299 107.584 261.384 107.621 261.448 107.696C261.523 107.771 261.56 107.856 261.56 107.952V108.512C261.56 108.608 261.523 108.693 261.448 108.768C261.384 108.843 261.315 108.88 261.24 108.88C260.792 108.891 260.413 109.008 260.104 109.232C259.805 109.445 259.56 109.792 259.368 110.272C259.187 110.752 259.053 111.387 258.968 112.176C258.893 112.955 258.856 113.915 258.856 115.056C258.856 116.197 258.893 117.163 258.968 117.952C259.053 118.731 259.187 119.36 259.368 119.84C259.56 120.32 259.805 120.672 260.104 120.896C260.413 121.12 260.792 121.237 261.24 121.248C261.315 121.248 261.384 121.28 261.448 121.344C261.523 121.419 261.56 121.509 261.56 121.616V122.176C261.56 122.272 261.523 122.357 261.448 122.432C261.384 122.507 261.299 122.544 261.192 122.544ZM266.726 120.16C266.054 120.16 265.467 120.08 264.966 119.92C264.465 119.749 264.043 119.525 263.702 119.248C263.361 118.971 263.099 118.667 262.918 118.336C262.747 117.995 262.657 117.653 262.646 117.312C262.646 117.216 262.678 117.141 262.742 117.088C262.806 117.024 262.886 116.992 262.982 116.992H263.766C263.862 116.992 263.947 117.019 264.022 117.072C264.107 117.115 264.171 117.205 264.214 117.344C264.321 117.728 264.502 118.027 264.758 118.24C265.025 118.453 265.329 118.603 265.67 118.688C266.022 118.763 266.374 118.8 266.726 118.8C267.462 118.8 268.059 118.624 268.518 118.272C268.977 117.92 269.206 117.403 269.206 116.72C269.206 116.027 268.998 115.531 268.582 115.232C268.166 114.933 267.59 114.784 266.854 114.784H265.334C265.227 114.784 265.137 114.752 265.062 114.688C264.998 114.624 264.966 114.533 264.966 114.416V113.984C264.966 113.888 264.982 113.808 265.014 113.744C265.057 113.669 265.099 113.605 265.142 113.552L268.246 110.16H263.526C263.419 110.16 263.329 110.128 263.254 110.064C263.19 110 263.158 109.909 263.158 109.792V109.184C263.158 109.067 263.19 108.976 263.254 108.912C263.329 108.837 263.419 108.8 263.526 108.8H269.91C270.027 108.8 270.118 108.837 270.182 108.912C270.257 108.976 270.294 109.067 270.294 109.184V109.76C270.294 109.835 270.273 109.904 270.23 109.968C270.198 110.021 270.161 110.075 270.118 110.128L267.03 113.568L267.286 113.584C267.99 113.605 268.603 113.733 269.126 113.968C269.659 114.203 270.07 114.555 270.358 115.024C270.657 115.483 270.806 116.064 270.806 116.768C270.806 117.483 270.63 118.091 270.278 118.592C269.926 119.093 269.441 119.483 268.822 119.76C268.214 120.027 267.515 120.16 266.726 120.16ZM275.702 120C275.595 120 275.505 119.968 275.43 119.904C275.366 119.829 275.334 119.739 275.334 119.632V110.672L272.678 112.72C272.593 112.784 272.502 112.811 272.406 112.8C272.31 112.789 272.23 112.741 272.166 112.656L271.75 112.128C271.686 112.032 271.659 111.936 271.67 111.84C271.691 111.744 271.745 111.664 271.83 111.6L275.318 108.912C275.393 108.859 275.462 108.827 275.526 108.816C275.59 108.805 275.659 108.8 275.734 108.8H276.55C276.657 108.8 276.742 108.837 276.806 108.912C276.881 108.976 276.918 109.061 276.918 109.168V119.632C276.918 119.739 276.881 119.829 276.806 119.904C276.742 119.968 276.657 120 276.55 120H275.702ZM279.874 120C279.65 120 279.538 119.893 279.538 119.68C279.538 119.616 279.559 119.557 279.602 119.504L287.506 109.104C287.581 109.008 287.65 108.933 287.714 108.88C287.789 108.827 287.895 108.8 288.034 108.8H288.562C288.786 108.8 288.898 108.907 288.898 109.12C288.898 109.184 288.877 109.243 288.834 109.296L280.946 119.696C280.871 119.792 280.797 119.867 280.722 119.92C280.658 119.973 280.551 120 280.402 120H279.874ZM287.202 120.096C286.509 120.096 285.959 119.899 285.554 119.504C285.159 119.109 284.941 118.592 284.898 117.952C284.887 117.675 284.882 117.44 284.882 117.248C284.882 117.045 284.887 116.795 284.898 116.496C284.941 115.856 285.149 115.339 285.522 114.944C285.906 114.539 286.466 114.336 287.202 114.336C287.949 114.336 288.509 114.539 288.882 114.944C289.266 115.339 289.479 115.856 289.522 116.496C289.543 116.795 289.554 117.045 289.554 117.248C289.554 117.44 289.543 117.675 289.522 117.952C289.479 118.592 289.255 119.109 288.85 119.504C288.455 119.899 287.906 120.096 287.202 120.096ZM287.202 119.04C287.49 119.04 287.714 118.981 287.874 118.864C288.034 118.747 288.151 118.603 288.226 118.432C288.301 118.251 288.343 118.069 288.354 117.888C288.375 117.6 288.386 117.371 288.386 117.2C288.386 117.029 288.375 116.816 288.354 116.56C288.343 116.272 288.253 116.005 288.082 115.76C287.911 115.515 287.618 115.392 287.202 115.392C286.797 115.392 286.509 115.515 286.338 115.76C286.178 116.005 286.087 116.272 286.066 116.56C286.055 116.816 286.05 117.029 286.05 117.2C286.05 117.371 286.055 117.6 286.066 117.888C286.087 118.069 286.13 118.251 286.194 118.432C286.269 118.603 286.386 118.747 286.546 118.864C286.717 118.981 286.935 119.04 287.202 119.04ZM281.218 114.416C280.514 114.416 279.965 114.229 279.57 113.856C279.175 113.483 278.957 112.976 278.914 112.336C278.903 112.059 278.898 111.824 278.898 111.632C278.898 111.429 278.903 111.179 278.914 110.88C278.946 110.24 279.154 109.723 279.538 109.328C279.922 108.923 280.482 108.72 281.218 108.72C281.965 108.72 282.525 108.923 282.898 109.328C283.282 109.723 283.49 110.24 283.522 110.88C283.543 111.179 283.554 111.429 283.554 111.632C283.554 111.824 283.543 112.059 283.522 112.336C283.49 112.976 283.271 113.483 282.866 113.856C282.471 114.229 281.922 114.416 281.218 114.416ZM281.218 113.424C281.495 113.424 281.714 113.365 281.874 113.248C282.045 113.131 282.167 112.987 282.242 112.816C282.317 112.635 282.359 112.453 282.37 112.272C282.391 111.984 282.402 111.76 282.402 111.6C282.402 111.429 282.391 111.211 282.37 110.944C282.359 110.656 282.263 110.389 282.082 110.144C281.911 109.899 281.623 109.776 281.218 109.776C280.813 109.776 280.525 109.899 280.354 110.144C280.194 110.389 280.103 110.656 280.082 110.944C280.071 111.211 280.066 111.429 280.066 111.6C280.066 111.76 280.071 111.984 280.082 112.272C280.103 112.453 280.146 112.635 280.21 112.816C280.285 112.987 280.402 113.131 280.562 113.248C280.722 113.365 280.941 113.424 281.218 113.424ZM291.054 122.544C290.958 122.544 290.872 122.507 290.798 122.432C290.723 122.357 290.686 122.272 290.686 122.176V121.616C290.686 121.509 290.718 121.419 290.782 121.344C290.856 121.28 290.936 121.248 291.022 121.248C291.47 121.237 291.843 121.12 292.142 120.896C292.451 120.672 292.696 120.32 292.878 119.84C293.059 119.36 293.192 118.731 293.278 117.952C293.363 117.163 293.406 116.197 293.406 115.056C293.406 113.915 293.363 112.955 293.278 112.176C293.192 111.387 293.059 110.752 292.878 110.272C292.696 109.792 292.451 109.445 292.142 109.232C291.843 109.008 291.47 108.891 291.022 108.88C290.936 108.88 290.856 108.843 290.782 108.768C290.718 108.693 290.686 108.608 290.686 108.512V107.952C290.686 107.856 290.723 107.771 290.798 107.696C290.872 107.621 290.958 107.584 291.054 107.584C291.747 107.584 292.334 107.728 292.814 108.016C293.294 108.304 293.678 108.752 293.966 109.36C294.264 109.957 294.478 110.731 294.606 111.68C294.734 112.629 294.798 113.755 294.798 115.056C294.798 116.357 294.734 117.483 294.606 118.432C294.478 119.371 294.264 120.144 293.966 120.752C293.678 121.36 293.294 121.808 292.814 122.096C292.334 122.395 291.747 122.544 291.054 122.544Z" fill="#717385"/>
<path d="M220.873 144C220.77 144 220.691 143.972 220.635 143.916C220.579 143.851 220.551 143.771 220.551 143.678V134.536C220.551 134.433 220.579 134.354 220.635 134.298C220.691 134.233 220.77 134.2 220.873 134.2H226.655C226.758 134.2 226.837 134.233 226.893 134.298C226.949 134.354 226.977 134.433 226.977 134.536V135.068C226.977 135.171 226.949 135.25 226.893 135.306C226.837 135.362 226.758 135.39 226.655 135.39H221.895V138.456H226.347C226.45 138.456 226.529 138.489 226.585 138.554C226.641 138.61 226.669 138.689 226.669 138.792V139.31C226.669 139.403 226.641 139.483 226.585 139.548C226.529 139.604 226.45 139.632 226.347 139.632H221.895V142.81H226.767C226.87 142.81 226.949 142.838 227.005 142.894C227.061 142.95 227.089 143.029 227.089 143.132V143.678C227.089 143.771 227.061 143.851 227.005 143.916C226.949 143.972 226.87 144 226.767 144H220.873ZM228.523 144C228.449 144 228.379 143.972 228.313 143.916C228.257 143.86 228.229 143.79 228.229 143.706C228.229 143.678 228.234 143.645 228.243 143.608C228.262 143.561 228.29 143.51 228.327 143.454L230.763 140.276L228.481 137.266C228.444 137.21 228.416 137.163 228.397 137.126C228.388 137.089 228.383 137.051 228.383 137.014C228.383 136.93 228.411 136.86 228.467 136.804C228.523 136.748 228.593 136.72 228.677 136.72H229.391C229.494 136.72 229.573 136.748 229.629 136.804C229.685 136.851 229.727 136.897 229.755 136.944L231.617 139.366L233.479 136.958C233.517 136.911 233.559 136.86 233.605 136.804C233.661 136.748 233.741 136.72 233.843 136.72H234.529C234.613 136.72 234.683 136.748 234.739 136.804C234.795 136.86 234.823 136.93 234.823 137.014C234.823 137.051 234.814 137.089 234.795 137.126C234.786 137.163 234.763 137.21 234.725 137.266L232.415 140.304L234.851 143.454C234.889 143.51 234.912 143.557 234.921 143.594C234.94 143.631 234.949 143.669 234.949 143.706C234.949 143.79 234.921 143.86 234.865 143.916C234.809 143.972 234.739 144 234.655 144H233.913C233.82 144 233.745 143.977 233.689 143.93C233.633 143.883 233.587 143.837 233.549 143.79L231.589 141.228L229.601 143.79C229.564 143.827 229.517 143.874 229.461 143.93C229.415 143.977 229.34 144 229.237 144H228.523ZM239.248 144C238.725 144 238.301 143.902 237.974 143.706C237.647 143.501 237.409 143.216 237.26 142.852C237.111 142.479 237.036 142.04 237.036 141.536V137.84H235.944C235.851 137.84 235.771 137.812 235.706 137.756C235.65 137.691 235.622 137.611 235.622 137.518V137.042C235.622 136.949 235.65 136.874 235.706 136.818C235.771 136.753 235.851 136.72 235.944 136.72H237.036V134.382C237.036 134.289 237.064 134.214 237.12 134.158C237.185 134.093 237.265 134.06 237.358 134.06H238.016C238.109 134.06 238.184 134.093 238.24 134.158C238.305 134.214 238.338 134.289 238.338 134.382V136.72H240.074C240.177 136.72 240.256 136.753 240.312 136.818C240.368 136.874 240.396 136.949 240.396 137.042V137.518C240.396 137.611 240.368 137.691 240.312 137.756C240.256 137.812 240.177 137.84 240.074 137.84H238.338V141.438C238.338 141.877 238.413 142.222 238.562 142.474C238.711 142.726 238.977 142.852 239.36 142.852H240.214C240.307 142.852 240.382 142.885 240.438 142.95C240.503 143.006 240.536 143.081 240.536 143.174V143.678C240.536 143.771 240.503 143.851 240.438 143.916C240.382 143.972 240.307 144 240.214 144H239.248ZM244.787 144.14C243.816 144.14 243.046 143.846 242.477 143.258C241.908 142.661 241.595 141.849 241.539 140.822C241.53 140.701 241.525 140.547 241.525 140.36C241.525 140.164 241.53 140.005 241.539 139.884C241.576 139.221 241.73 138.643 242.001 138.148C242.272 137.644 242.64 137.257 243.107 136.986C243.583 136.715 244.138 136.58 244.773 136.58C245.482 136.58 246.075 136.729 246.551 137.028C247.036 137.327 247.405 137.751 247.657 138.302C247.909 138.853 248.035 139.497 248.035 140.234V140.472C248.035 140.575 248.002 140.654 247.937 140.71C247.881 140.766 247.806 140.794 247.713 140.794H242.869C242.869 140.803 242.869 140.822 242.869 140.85C242.869 140.878 242.869 140.901 242.869 140.92C242.888 141.303 242.972 141.662 243.121 141.998C243.27 142.325 243.485 142.591 243.765 142.796C244.054 143.001 244.39 143.104 244.773 143.104C245.109 143.104 245.389 143.053 245.613 142.95C245.837 142.847 246.019 142.735 246.159 142.614C246.299 142.483 246.392 142.381 246.439 142.306C246.523 142.194 246.588 142.129 246.635 142.11C246.682 142.082 246.756 142.068 246.859 142.068H247.545C247.629 142.068 247.699 142.096 247.755 142.152C247.82 142.199 247.848 142.269 247.839 142.362C247.83 142.502 247.755 142.675 247.615 142.88C247.475 143.076 247.274 143.272 247.013 143.468C246.761 143.664 246.444 143.827 246.061 143.958C245.688 144.079 245.263 144.14 244.787 144.14ZM242.869 139.828H246.705V139.786C246.705 139.366 246.626 138.993 246.467 138.666C246.318 138.339 246.098 138.083 245.809 137.896C245.52 137.7 245.174 137.602 244.773 137.602C244.372 137.602 244.026 137.7 243.737 137.896C243.457 138.083 243.242 138.339 243.093 138.666C242.944 138.993 242.869 139.366 242.869 139.786V139.828ZM250.031 144C249.938 144 249.858 143.972 249.793 143.916C249.737 143.851 249.709 143.771 249.709 143.678V137.056C249.709 136.963 249.737 136.883 249.793 136.818C249.858 136.753 249.938 136.72 250.031 136.72H250.675C250.768 136.72 250.848 136.753 250.913 136.818C250.978 136.883 251.011 136.963 251.011 137.056V137.672C251.198 137.355 251.454 137.117 251.781 136.958C252.108 136.799 252.504 136.72 252.971 136.72H253.517C253.61 136.72 253.685 136.753 253.741 136.818C253.806 136.874 253.839 136.949 253.839 137.042V137.616C253.839 137.709 253.806 137.784 253.741 137.84C253.685 137.896 253.61 137.924 253.517 137.924H252.677C252.173 137.924 251.776 138.073 251.487 138.372C251.198 138.661 251.053 139.058 251.053 139.562V143.678C251.053 143.771 251.02 143.851 250.955 143.916C250.89 143.972 250.81 144 250.717 144H250.031ZM255.349 144C255.256 144 255.177 143.972 255.111 143.916C255.055 143.851 255.027 143.771 255.027 143.678V137.042C255.027 136.949 255.055 136.874 255.111 136.818C255.177 136.753 255.256 136.72 255.349 136.72H256.007C256.101 136.72 256.175 136.753 256.231 136.818C256.297 136.874 256.329 136.949 256.329 137.042V137.658C256.572 137.341 256.875 137.084 257.239 136.888C257.613 136.683 258.089 136.58 258.667 136.58C259.274 136.58 259.787 136.715 260.207 136.986C260.637 137.247 260.959 137.616 261.173 138.092C261.397 138.559 261.509 139.105 261.509 139.73V143.678C261.509 143.771 261.477 143.851 261.411 143.916C261.355 143.972 261.281 144 261.187 144H260.487C260.394 144 260.315 143.972 260.249 143.916C260.193 143.851 260.165 143.771 260.165 143.678V139.8C260.165 139.147 260.007 138.638 259.689 138.274C259.372 137.901 258.905 137.714 258.289 137.714C257.711 137.714 257.244 137.901 256.889 138.274C256.544 138.638 256.371 139.147 256.371 139.8V143.678C256.371 143.771 256.339 143.851 256.273 143.916C256.217 143.972 256.143 144 256.049 144H255.349ZM265.547 144.14C265.081 144.14 264.656 144.047 264.273 143.86C263.891 143.673 263.583 143.421 263.349 143.104C263.116 142.787 262.999 142.427 262.999 142.026C262.999 141.382 263.261 140.869 263.783 140.486C264.306 140.103 264.987 139.851 265.827 139.73L267.913 139.436V139.03C267.913 138.582 267.783 138.232 267.521 137.98C267.269 137.728 266.854 137.602 266.275 137.602C265.865 137.602 265.529 137.686 265.267 137.854C265.006 138.022 264.824 138.237 264.721 138.498C264.665 138.638 264.567 138.708 264.427 138.708H263.797C263.695 138.708 263.615 138.68 263.559 138.624C263.513 138.559 263.489 138.484 263.489 138.4C263.489 138.26 263.541 138.087 263.643 137.882C263.755 137.677 263.923 137.476 264.147 137.28C264.371 137.084 264.656 136.921 265.001 136.79C265.356 136.65 265.785 136.58 266.289 136.58C266.849 136.58 267.321 136.655 267.703 136.804C268.086 136.944 268.385 137.135 268.599 137.378C268.823 137.621 268.982 137.896 269.075 138.204C269.178 138.512 269.229 138.825 269.229 139.142V143.678C269.229 143.771 269.197 143.851 269.131 143.916C269.075 143.972 269.001 144 268.907 144H268.263C268.161 144 268.081 143.972 268.025 143.916C267.969 143.851 267.941 143.771 267.941 143.678V143.076C267.82 143.244 267.657 143.412 267.451 143.58C267.246 143.739 266.989 143.874 266.681 143.986C266.373 144.089 265.995 144.14 265.547 144.14ZM265.841 143.09C266.224 143.09 266.574 143.011 266.891 142.852C267.209 142.684 267.456 142.427 267.633 142.082C267.82 141.737 267.913 141.303 267.913 140.78V140.388L266.289 140.626C265.627 140.719 265.127 140.878 264.791 141.102C264.455 141.317 264.287 141.592 264.287 141.928C264.287 142.189 264.362 142.409 264.511 142.586C264.67 142.754 264.866 142.88 265.099 142.964C265.342 143.048 265.589 143.09 265.841 143.09ZM271.578 144C271.485 144 271.405 143.972 271.34 143.916C271.284 143.851 271.256 143.771 271.256 143.678V134.382C271.256 134.289 271.284 134.214 271.34 134.158C271.405 134.093 271.485 134.06 271.578 134.06H272.236C272.339 134.06 272.418 134.093 272.474 134.158C272.53 134.214 272.558 134.289 272.558 134.382V143.678C272.558 143.771 272.53 143.851 272.474 143.916C272.418 143.972 272.339 144 272.236 144H271.578Z" fill="#A800E0"/>
<rect x="394.667" y="103" width="2" height="46" rx="1" fill="#FC3DA6"/>
<path d="M405.771 120C405.664 120 405.574 119.963 405.499 119.888C405.424 119.813 405.387 119.723 405.387 119.616V118.8C405.387 118.704 405.408 118.592 405.451 118.464C405.504 118.325 405.616 118.187 405.787 118.048L408.315 115.536C409.019 114.981 409.584 114.512 410.011 114.128C410.448 113.733 410.763 113.376 410.955 113.056C411.158 112.725 411.259 112.4 411.259 112.08C411.259 111.6 411.126 111.211 410.859 110.912C410.603 110.613 410.192 110.464 409.627 110.464C409.254 110.464 408.939 110.544 408.683 110.704C408.427 110.853 408.224 111.056 408.075 111.312C407.936 111.568 407.84 111.851 407.787 112.16C407.766 112.299 407.707 112.395 407.611 112.448C407.515 112.501 407.419 112.528 407.323 112.528H405.899C405.803 112.528 405.723 112.496 405.659 112.432C405.595 112.368 405.563 112.293 405.563 112.208C405.574 111.749 405.67 111.307 405.851 110.88C406.032 110.443 406.294 110.059 406.635 109.728C406.987 109.387 407.414 109.115 407.915 108.912C408.416 108.709 408.982 108.608 409.611 108.608C410.496 108.608 411.227 108.757 411.803 109.056C412.39 109.355 412.827 109.76 413.115 110.272C413.414 110.784 413.563 111.36 413.563 112C413.563 112.501 413.467 112.965 413.275 113.392C413.083 113.808 412.806 114.213 412.443 114.608C412.08 114.992 411.643 115.387 411.131 115.792L408.859 118.096H413.419C413.536 118.096 413.627 118.133 413.691 118.208C413.766 118.272 413.803 118.363 413.803 118.48V119.616C413.803 119.723 413.766 119.813 413.691 119.888C413.627 119.963 413.536 120 413.419 120H405.771ZM415.917 120C415.811 120 415.72 119.963 415.645 119.888C415.571 119.813 415.533 119.723 415.533 119.616V118.032C415.533 117.915 415.571 117.819 415.645 117.744C415.72 117.669 415.811 117.632 415.917 117.632H417.517C417.624 117.632 417.715 117.669 417.789 117.744C417.864 117.819 417.901 117.915 417.901 118.032V119.616C417.901 119.723 417.864 119.813 417.789 119.888C417.715 119.963 417.624 120 417.517 120H415.917ZM423.83 120.16C423.084 120.16 422.438 120.069 421.894 119.888C421.35 119.707 420.897 119.472 420.534 119.184C420.182 118.885 419.916 118.565 419.734 118.224C419.553 117.872 419.457 117.525 419.446 117.184C419.446 117.088 419.478 117.013 419.542 116.96C419.617 116.896 419.702 116.864 419.798 116.864H421.238C421.345 116.864 421.436 116.885 421.51 116.928C421.585 116.971 421.649 117.056 421.702 117.184C421.798 117.472 421.953 117.701 422.166 117.872C422.39 118.043 422.646 118.165 422.934 118.24C423.222 118.304 423.526 118.336 423.846 118.336C424.486 118.336 424.993 118.187 425.366 117.888C425.75 117.579 425.942 117.141 425.942 116.576C425.942 116.011 425.766 115.605 425.414 115.36C425.062 115.104 424.572 114.976 423.942 114.976H422.294C422.177 114.976 422.081 114.944 422.006 114.88C421.932 114.805 421.894 114.709 421.894 114.592V113.92C421.894 113.813 421.916 113.723 421.958 113.648C422.012 113.563 422.065 113.493 422.118 113.44L424.982 110.64H420.406C420.289 110.64 420.193 110.603 420.118 110.528C420.054 110.453 420.022 110.363 420.022 110.256V109.2C420.022 109.083 420.054 108.987 420.118 108.912C420.193 108.837 420.289 108.8 420.406 108.8H427.27C427.388 108.8 427.484 108.837 427.558 108.912C427.633 108.987 427.67 109.083 427.67 109.2V110.16C427.67 110.256 427.649 110.341 427.606 110.416C427.564 110.491 427.516 110.555 427.462 110.608L424.694 113.456L424.886 113.472C425.537 113.525 426.113 113.675 426.614 113.92C427.126 114.155 427.521 114.501 427.798 114.96C428.086 115.419 428.23 115.995 428.23 116.688C428.23 117.413 428.038 118.037 427.654 118.56C427.281 119.072 426.764 119.467 426.102 119.744C425.441 120.021 424.684 120.16 423.83 120.16ZM430.565 120C430.458 120 430.367 119.963 430.293 119.888C430.218 119.813 430.181 119.723 430.181 119.616V109.2C430.181 109.083 430.218 108.987 430.293 108.912C430.367 108.837 430.458 108.8 430.565 108.8H431.973C432.09 108.8 432.186 108.837 432.261 108.912C432.335 108.987 432.373 109.083 432.373 109.2V112.944L435.989 109.088C436.031 109.035 436.101 108.976 436.197 108.912C436.303 108.837 436.442 108.8 436.613 108.8H438.197C438.282 108.8 438.357 108.832 438.421 108.896C438.495 108.96 438.533 109.04 438.533 109.136C438.533 109.211 438.511 109.275 438.469 109.328L434.069 114.16L438.773 119.456C438.826 119.52 438.853 119.589 438.853 119.664C438.853 119.76 438.815 119.84 438.741 119.904C438.677 119.968 438.602 120 438.517 120H436.869C436.687 120 436.543 119.963 436.437 119.888C436.341 119.803 436.277 119.744 436.245 119.712L432.373 115.472V119.616C432.373 119.723 432.335 119.813 432.261 119.888C432.186 119.963 432.09 120 431.973 120H430.565Z" fill="#212328"/>
<path d="M447.245 122.544C446.552 122.544 445.965 122.395 445.485 122.096C445.005 121.808 444.621 121.36 444.333 120.752C444.045 120.144 443.832 119.371 443.693 118.432C443.565 117.483 443.501 116.357 443.501 115.056C443.501 113.755 443.565 112.629 443.693 111.68C443.832 110.731 444.045 109.957 444.333 109.36C444.621 108.752 445.005 108.304 445.485 108.016C445.965 107.728 446.552 107.584 447.245 107.584C447.352 107.584 447.437 107.621 447.501 107.696C447.576 107.771 447.613 107.856 447.613 107.952V108.512C447.613 108.608 447.576 108.693 447.501 108.768C447.437 108.843 447.368 108.88 447.293 108.88C446.845 108.891 446.466 109.008 446.157 109.232C445.858 109.445 445.613 109.792 445.421 110.272C445.24 110.752 445.106 111.387 445.021 112.176C444.946 112.955 444.909 113.915 444.909 115.056C444.909 116.197 444.946 117.163 445.021 117.952C445.106 118.731 445.24 119.36 445.421 119.84C445.613 120.32 445.858 120.672 446.157 120.896C446.466 121.12 446.845 121.237 447.293 121.248C447.368 121.248 447.437 121.28 447.501 121.344C447.576 121.419 447.613 121.509 447.613 121.616V122.176C447.613 122.272 447.576 122.357 447.501 122.432C447.437 122.507 447.352 122.544 447.245 122.544ZM451.88 120C451.773 120 451.683 119.968 451.608 119.904C451.544 119.829 451.512 119.739 451.512 119.632V110.672L448.856 112.72C448.771 112.784 448.68 112.811 448.584 112.8C448.488 112.789 448.408 112.741 448.344 112.656L447.928 112.128C447.864 112.032 447.837 111.936 447.848 111.84C447.869 111.744 447.923 111.664 448.008 111.6L451.496 108.912C451.571 108.859 451.64 108.827 451.704 108.816C451.768 108.805 451.837 108.8 451.912 108.8H452.728C452.835 108.8 452.92 108.837 452.984 108.912C453.059 108.976 453.096 109.061 453.096 109.168V119.632C453.096 119.739 453.059 119.829 452.984 119.904C452.92 119.968 452.835 120 452.728 120H451.88ZM457.396 120C457.3 120 457.22 119.968 457.156 119.904C457.102 119.829 457.076 119.744 457.076 119.648C457.076 119.595 457.081 119.552 457.092 119.52C457.113 119.488 457.129 119.461 457.14 119.44L459.588 116.032C459.321 116.096 459.033 116.128 458.724 116.128C458.137 116.117 457.604 116.011 457.124 115.808C456.654 115.605 456.254 115.333 455.924 114.992C455.593 114.64 455.342 114.245 455.172 113.808C455.001 113.371 454.916 112.912 454.916 112.432C454.916 111.963 454.996 111.504 455.156 111.056C455.326 110.608 455.577 110.203 455.908 109.84C456.249 109.477 456.67 109.189 457.172 108.976C457.684 108.752 458.276 108.64 458.948 108.64C459.62 108.64 460.206 108.747 460.708 108.96C461.22 109.163 461.646 109.445 461.988 109.808C462.34 110.16 462.596 110.56 462.756 111.008C462.926 111.456 463.012 111.92 463.012 112.4C463.012 112.837 462.948 113.237 462.82 113.6C462.692 113.963 462.537 114.288 462.356 114.576C462.185 114.864 462.02 115.131 461.86 115.376L458.772 119.68C458.729 119.733 458.67 119.803 458.596 119.888C458.521 119.963 458.409 120 458.26 120H457.396ZM458.948 114.832C459.396 114.832 459.806 114.736 460.18 114.544C460.564 114.341 460.868 114.064 461.092 113.712C461.316 113.349 461.428 112.917 461.428 112.416C461.428 111.915 461.316 111.488 461.092 111.136C460.868 110.773 460.564 110.496 460.18 110.304C459.806 110.101 459.396 110 458.948 110C458.51 110 458.105 110.101 457.732 110.304C457.358 110.496 457.06 110.773 456.836 111.136C456.612 111.488 456.5 111.915 456.5 112.416C456.5 112.917 456.612 113.349 456.836 113.712C457.06 114.064 457.358 114.341 457.732 114.544C458.105 114.736 458.51 114.832 458.948 114.832ZM465.536 120C465.312 120 465.2 119.893 465.2 119.68C465.2 119.616 465.221 119.557 465.264 119.504L473.168 109.104C473.243 109.008 473.312 108.933 473.376 108.88C473.451 108.827 473.557 108.8 473.696 108.8H474.224C474.448 108.8 474.56 108.907 474.56 109.12C474.56 109.184 474.539 109.243 474.496 109.296L466.608 119.696C466.533 119.792 466.459 119.867 466.384 119.92C466.32 119.973 466.213 120 466.064 120H465.536ZM472.864 120.096C472.171 120.096 471.621 119.899 471.216 119.504C470.821 119.109 470.603 118.592 470.56 117.952C470.549 117.675 470.544 117.44 470.544 117.248C470.544 117.045 470.549 116.795 470.56 116.496C470.603 115.856 470.811 115.339 471.184 114.944C471.568 114.539 472.128 114.336 472.864 114.336C473.611 114.336 474.171 114.539 474.544 114.944C474.928 115.339 475.141 115.856 475.184 116.496C475.205 116.795 475.216 117.045 475.216 117.248C475.216 117.44 475.205 117.675 475.184 117.952C475.141 118.592 474.917 119.109 474.512 119.504C474.117 119.899 473.568 120.096 472.864 120.096ZM472.864 119.04C473.152 119.04 473.376 118.981 473.536 118.864C473.696 118.747 473.813 118.603 473.888 118.432C473.963 118.251 474.005 118.069 474.016 117.888C474.037 117.6 474.048 117.371 474.048 117.2C474.048 117.029 474.037 116.816 474.016 116.56C474.005 116.272 473.915 116.005 473.744 115.76C473.573 115.515 473.28 115.392 472.864 115.392C472.459 115.392 472.171 115.515 472 115.76C471.84 116.005 471.749 116.272 471.728 116.56C471.717 116.816 471.712 117.029 471.712 117.2C471.712 117.371 471.717 117.6 471.728 117.888C471.749 118.069 471.792 118.251 471.856 118.432C471.931 118.603 472.048 118.747 472.208 118.864C472.379 118.981 472.597 119.04 472.864 119.04ZM466.88 114.416C466.176 114.416 465.627 114.229 465.232 113.856C464.837 113.483 464.619 112.976 464.576 112.336C464.565 112.059 464.56 111.824 464.56 111.632C464.56 111.429 464.565 111.179 464.576 110.88C464.608 110.24 464.816 109.723 465.2 109.328C465.584 108.923 466.144 108.72 466.88 108.72C467.627 108.72 468.187 108.923 468.56 109.328C468.944 109.723 469.152 110.24 469.184 110.88C469.205 111.179 469.216 111.429 469.216 111.632C469.216 111.824 469.205 112.059 469.184 112.336C469.152 112.976 468.933 113.483 468.528 113.856C468.133 114.229 467.584 114.416 466.88 114.416ZM466.88 113.424C467.157 113.424 467.376 113.365 467.536 113.248C467.707 113.131 467.829 112.987 467.904 112.816C467.979 112.635 468.021 112.453 468.032 112.272C468.053 111.984 468.064 111.76 468.064 111.6C468.064 111.429 468.053 111.211 468.032 110.944C468.021 110.656 467.925 110.389 467.744 110.144C467.573 109.899 467.285 109.776 466.88 109.776C466.475 109.776 466.187 109.899 466.016 110.144C465.856 110.389 465.765 110.656 465.744 110.944C465.733 111.211 465.728 111.429 465.728 111.6C465.728 111.76 465.733 111.984 465.744 112.272C465.765 112.453 465.808 112.635 465.872 112.816C465.947 112.987 466.064 113.131 466.224 113.248C466.384 113.365 466.603 113.424 466.88 113.424ZM476.716 122.544C476.62 122.544 476.535 122.507 476.46 122.432C476.385 122.357 476.348 122.272 476.348 122.176V121.616C476.348 121.509 476.38 121.419 476.444 121.344C476.519 121.28 476.599 121.248 476.684 121.248C477.132 121.237 477.505 121.12 477.804 120.896C478.113 120.672 478.359 120.32 478.54 119.84C478.721 119.36 478.855 118.731 478.94 117.952C479.025 117.163 479.068 116.197 479.068 115.056C479.068 113.915 479.025 112.955 478.94 112.176C478.855 111.387 478.721 110.752 478.54 110.272C478.359 109.792 478.113 109.445 477.804 109.232C477.505 109.008 477.132 108.891 476.684 108.88C476.599 108.88 476.519 108.843 476.444 108.768C476.38 108.693 476.348 108.608 476.348 108.512V107.952C476.348 107.856 476.385 107.771 476.46 107.696C476.535 107.621 476.62 107.584 476.716 107.584C477.409 107.584 477.996 107.728 478.476 108.016C478.956 108.304 479.34 108.752 479.628 109.36C479.927 109.957 480.14 110.731 480.268 111.68C480.396 112.629 480.46 113.755 480.46 115.056C480.46 116.357 480.396 117.483 480.268 118.432C480.14 119.371 479.927 120.144 479.628 120.752C479.34 121.36 478.956 121.808 478.476 122.096C477.996 122.395 477.409 122.544 476.716 122.544Z" fill="#717385"/>
<path d="M406.207 144C406.114 144 406.034 143.972 405.969 143.916C405.913 143.851 405.885 143.771 405.885 143.678V134.536C405.885 134.433 405.913 134.354 405.969 134.298C406.034 134.233 406.114 134.2 406.207 134.2H406.907C407.019 134.2 407.103 134.228 407.159 134.284C407.215 134.34 407.252 134.387 407.271 134.424L410.225 140.08L413.207 134.424C413.226 134.387 413.258 134.34 413.305 134.284C413.361 134.228 413.445 134.2 413.557 134.2H414.243C414.346 134.2 414.425 134.233 414.481 134.298C414.546 134.354 414.579 134.433 414.579 134.536V143.678C414.579 143.771 414.546 143.851 414.481 143.916C414.425 143.972 414.346 144 414.243 144H413.557C413.464 144 413.384 143.972 413.319 143.916C413.263 143.851 413.235 143.771 413.235 143.678V136.79L410.897 141.354C410.86 141.447 410.804 141.522 410.729 141.578C410.654 141.625 410.561 141.648 410.449 141.648H410.015C409.894 141.648 409.8 141.625 409.735 141.578C409.67 141.522 409.614 141.447 409.567 141.354L407.215 136.79V143.678C407.215 143.771 407.182 143.851 407.117 143.916C407.061 143.972 406.986 144 406.893 144H406.207ZM418.848 144.14C418.382 144.14 417.957 144.047 417.574 143.86C417.192 143.673 416.884 143.421 416.65 143.104C416.417 142.787 416.3 142.427 416.3 142.026C416.3 141.382 416.562 140.869 417.084 140.486C417.607 140.103 418.288 139.851 419.128 139.73L421.214 139.436V139.03C421.214 138.582 421.084 138.232 420.822 137.98C420.57 137.728 420.155 137.602 419.576 137.602C419.166 137.602 418.83 137.686 418.568 137.854C418.307 138.022 418.125 138.237 418.022 138.498C417.966 138.638 417.868 138.708 417.728 138.708H417.098C416.996 138.708 416.916 138.68 416.86 138.624C416.814 138.559 416.79 138.484 416.79 138.4C416.79 138.26 416.842 138.087 416.944 137.882C417.056 137.677 417.224 137.476 417.448 137.28C417.672 137.084 417.957 136.921 418.302 136.79C418.657 136.65 419.086 136.58 419.59 136.58C420.15 136.58 420.622 136.655 421.004 136.804C421.387 136.944 421.686 137.135 421.9 137.378C422.124 137.621 422.283 137.896 422.376 138.204C422.479 138.512 422.53 138.825 422.53 139.142V143.678C422.53 143.771 422.498 143.851 422.432 143.916C422.376 143.972 422.302 144 422.208 144H421.564C421.462 144 421.382 143.972 421.326 143.916C421.27 143.851 421.242 143.771 421.242 143.678V143.076C421.121 143.244 420.958 143.412 420.752 143.58C420.547 143.739 420.29 143.874 419.982 143.986C419.674 144.089 419.296 144.14 418.848 144.14ZM419.142 143.09C419.525 143.09 419.875 143.011 420.192 142.852C420.51 142.684 420.757 142.427 420.934 142.082C421.121 141.737 421.214 141.303 421.214 140.78V140.388L419.59 140.626C418.928 140.719 418.428 140.878 418.092 141.102C417.756 141.317 417.588 141.592 417.588 141.928C417.588 142.189 417.663 142.409 417.812 142.586C417.971 142.754 418.167 142.88 418.4 142.964C418.643 143.048 418.89 143.09 419.142 143.09ZM427.483 144.14C426.82 144.14 426.246 144.014 425.761 143.762C425.285 143.501 424.916 143.132 424.655 142.656C424.394 142.171 424.254 141.592 424.235 140.92C424.226 140.78 424.221 140.593 424.221 140.36C424.221 140.127 424.226 139.94 424.235 139.8C424.254 139.128 424.394 138.554 424.655 138.078C424.916 137.593 425.285 137.224 425.761 136.972C426.246 136.711 426.82 136.58 427.483 136.58C428.024 136.58 428.486 136.655 428.869 136.804C429.261 136.953 429.583 137.145 429.835 137.378C430.087 137.611 430.274 137.863 430.395 138.134C430.526 138.405 430.596 138.661 430.605 138.904C430.614 138.997 430.586 139.072 430.521 139.128C430.456 139.184 430.376 139.212 430.283 139.212H429.611C429.518 139.212 429.448 139.193 429.401 139.156C429.354 139.109 429.308 139.035 429.261 138.932C429.093 138.475 428.864 138.153 428.575 137.966C428.286 137.779 427.926 137.686 427.497 137.686C426.937 137.686 426.48 137.859 426.125 138.204C425.78 138.549 425.593 139.105 425.565 139.87C425.556 140.206 425.556 140.533 425.565 140.85C425.593 141.625 425.78 142.185 426.125 142.53C426.48 142.866 426.937 143.034 427.497 143.034C427.926 143.034 428.286 142.941 428.575 142.754C428.864 142.567 429.093 142.245 429.261 141.788C429.308 141.685 429.354 141.611 429.401 141.564C429.448 141.517 429.518 141.494 429.611 141.494H430.283C430.376 141.494 430.456 141.527 430.521 141.592C430.586 141.648 430.614 141.723 430.605 141.816C430.596 142.012 430.554 142.213 430.479 142.418C430.404 142.623 430.283 142.833 430.115 143.048C429.956 143.253 429.756 143.44 429.513 143.608C429.27 143.767 428.981 143.897 428.645 144C428.309 144.093 427.922 144.14 427.483 144.14ZM432.603 144C432.51 144 432.431 143.972 432.365 143.916C432.309 143.851 432.281 143.771 432.281 143.678V134.382C432.281 134.289 432.309 134.214 432.365 134.158C432.431 134.093 432.51 134.06 432.603 134.06H433.303C433.406 134.06 433.485 134.093 433.541 134.158C433.597 134.214 433.625 134.289 433.625 134.382V137.644C433.877 137.327 434.185 137.07 434.549 136.874C434.913 136.678 435.375 136.58 435.935 136.58C436.542 136.58 437.055 136.715 437.475 136.986C437.905 137.247 438.227 137.616 438.441 138.092C438.665 138.559 438.777 139.105 438.777 139.73V143.678C438.777 143.771 438.749 143.851 438.693 143.916C438.637 143.972 438.558 144 438.455 144H437.755C437.662 144 437.583 143.972 437.517 143.916C437.461 143.851 437.433 143.771 437.433 143.678V139.8C437.433 139.147 437.275 138.638 436.957 138.274C436.64 137.901 436.173 137.714 435.557 137.714C434.979 137.714 434.512 137.901 434.157 138.274C433.803 138.638 433.625 139.147 433.625 139.8V143.678C433.625 143.771 433.597 143.851 433.541 143.916C433.485 143.972 433.406 144 433.303 144H432.603ZM441.121 144C441.027 144 440.948 143.972 440.883 143.916C440.827 143.851 440.799 143.771 440.799 143.678V137.042C440.799 136.949 440.827 136.874 440.883 136.818C440.948 136.753 441.027 136.72 441.121 136.72H441.793C441.886 136.72 441.961 136.753 442.017 136.818C442.082 136.874 442.115 136.949 442.115 137.042V143.678C442.115 143.771 442.082 143.851 442.017 143.916C441.961 143.972 441.886 144 441.793 144H441.121ZM441.009 135.362C440.915 135.362 440.836 135.334 440.771 135.278C440.715 135.213 440.687 135.133 440.687 135.04V134.284C440.687 134.191 440.715 134.111 440.771 134.046C440.836 133.981 440.915 133.948 441.009 133.948H441.891C441.984 133.948 442.063 133.981 442.129 134.046C442.194 134.111 442.227 134.191 442.227 134.284V135.04C442.227 135.133 442.194 135.213 442.129 135.278C442.063 135.334 441.984 135.362 441.891 135.362H441.009ZM444.511 144C444.418 144 444.339 143.972 444.273 143.916C444.217 143.851 444.189 143.771 444.189 143.678V137.042C444.189 136.949 444.217 136.874 444.273 136.818C444.339 136.753 444.418 136.72 444.511 136.72H445.169C445.263 136.72 445.337 136.753 445.393 136.818C445.459 136.874 445.491 136.949 445.491 137.042V137.658C445.734 137.341 446.037 137.084 446.401 136.888C446.775 136.683 447.251 136.58 447.829 136.58C448.436 136.58 448.949 136.715 449.369 136.986C449.799 137.247 450.121 137.616 450.335 138.092C450.559 138.559 450.671 139.105 450.671 139.73V143.678C450.671 143.771 450.639 143.851 450.573 143.916C450.517 143.972 450.443 144 450.349 144H449.649C449.556 144 449.477 143.972 449.411 143.916C449.355 143.851 449.327 143.771 449.327 143.678V139.8C449.327 139.147 449.169 138.638 448.851 138.274C448.534 137.901 448.067 137.714 447.451 137.714C446.873 137.714 446.406 137.901 446.051 138.274C445.706 138.638 445.533 139.147 445.533 139.8V143.678C445.533 143.771 445.501 143.851 445.435 143.916C445.379 143.972 445.305 144 445.211 144H444.511ZM455.592 144.14C454.621 144.14 453.851 143.846 453.282 143.258C452.712 142.661 452.4 141.849 452.344 140.822C452.334 140.701 452.33 140.547 452.33 140.36C452.33 140.164 452.334 140.005 452.344 139.884C452.381 139.221 452.535 138.643 452.806 138.148C453.076 137.644 453.445 137.257 453.912 136.986C454.388 136.715 454.943 136.58 455.578 136.58C456.287 136.58 456.88 136.729 457.356 137.028C457.841 137.327 458.21 137.751 458.462 138.302C458.714 138.853 458.84 139.497 458.84 140.234V140.472C458.84 140.575 458.807 140.654 458.742 140.71C458.686 140.766 458.611 140.794 458.518 140.794H453.674C453.674 140.803 453.674 140.822 453.674 140.85C453.674 140.878 453.674 140.901 453.674 140.92C453.692 141.303 453.776 141.662 453.926 141.998C454.075 142.325 454.29 142.591 454.57 142.796C454.859 143.001 455.195 143.104 455.578 143.104C455.914 143.104 456.194 143.053 456.418 142.95C456.642 142.847 456.824 142.735 456.964 142.614C457.104 142.483 457.197 142.381 457.244 142.306C457.328 142.194 457.393 142.129 457.44 142.11C457.486 142.082 457.561 142.068 457.664 142.068H458.35C458.434 142.068 458.504 142.096 458.56 142.152C458.625 142.199 458.653 142.269 458.644 142.362C458.634 142.502 458.56 142.675 458.42 142.88C458.28 143.076 458.079 143.272 457.818 143.468C457.566 143.664 457.248 143.827 456.866 143.958C456.492 144.079 456.068 144.14 455.592 144.14ZM453.674 139.828H457.51V139.786C457.51 139.366 457.43 138.993 457.272 138.666C457.122 138.339 456.903 138.083 456.614 137.896C456.324 137.7 455.979 137.602 455.578 137.602C455.176 137.602 454.831 137.7 454.542 137.896C454.262 138.083 454.047 138.339 453.898 138.666C453.748 138.993 453.674 139.366 453.674 139.786V139.828ZM463.034 144.14C462.511 144.14 462.063 144.075 461.69 143.944C461.316 143.813 461.013 143.655 460.78 143.468C460.546 143.281 460.369 143.095 460.248 142.908C460.136 142.721 460.075 142.572 460.066 142.46C460.056 142.357 460.089 142.278 460.164 142.222C460.238 142.166 460.313 142.138 460.388 142.138H461.018C461.064 142.138 461.102 142.147 461.13 142.166C461.167 142.175 461.214 142.213 461.27 142.278C461.391 142.409 461.526 142.539 461.676 142.67C461.825 142.801 462.007 142.908 462.222 142.992C462.446 143.076 462.721 143.118 463.048 143.118C463.524 143.118 463.916 143.029 464.224 142.852C464.532 142.665 464.686 142.395 464.686 142.04C464.686 141.807 464.62 141.62 464.49 141.48C464.368 141.34 464.144 141.214 463.818 141.102C463.5 140.99 463.062 140.873 462.502 140.752C461.942 140.621 461.498 140.463 461.172 140.276C460.845 140.08 460.612 139.851 460.472 139.59C460.332 139.319 460.262 139.016 460.262 138.68C460.262 138.335 460.364 138.003 460.57 137.686C460.775 137.359 461.074 137.093 461.466 136.888C461.867 136.683 462.366 136.58 462.964 136.58C463.449 136.58 463.864 136.641 464.21 136.762C464.555 136.883 464.84 137.037 465.064 137.224C465.288 137.401 465.456 137.579 465.568 137.756C465.68 137.933 465.74 138.083 465.75 138.204C465.759 138.297 465.731 138.377 465.666 138.442C465.6 138.498 465.526 138.526 465.442 138.526H464.854C464.788 138.526 464.732 138.512 464.686 138.484C464.648 138.456 464.611 138.423 464.574 138.386C464.48 138.265 464.368 138.143 464.238 138.022C464.116 137.901 463.953 137.803 463.748 137.728C463.552 137.644 463.29 137.602 462.964 137.602C462.497 137.602 462.147 137.7 461.914 137.896C461.68 138.092 461.564 138.339 461.564 138.638C461.564 138.815 461.615 138.974 461.718 139.114C461.82 139.254 462.016 139.38 462.306 139.492C462.595 139.604 463.024 139.725 463.594 139.856C464.21 139.977 464.695 140.141 465.05 140.346C465.404 140.551 465.656 140.789 465.806 141.06C465.955 141.331 466.03 141.643 466.03 141.998C466.03 142.39 465.918 142.749 465.694 143.076C465.47 143.403 465.134 143.664 464.686 143.86C464.238 144.047 463.687 144.14 463.034 144.14Z" fill="#C20181"/>
</svg>
`;
const $c49aa0f374b6c6e6$export$b7c5c27680c06eac = `<svg width="589" height="176" viewBox="0 0 589 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="588" height="175" rx="7.5" fill="#131D2D"/>
<rect x="0.5" y="0.5" width="588" height="175" rx="7.5" stroke="#576883"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M56 25.1429C43.3763 25.1429 33.1429 35.3763 33.1429 48C33.1429 60.6236 43.3763 70.8571 56 70.8571C68.6236 70.8571 78.8571 60.6236 78.8571 48C78.8571 35.3763 68.6236 25.1429 56 25.1429ZM24 48C24 30.3269 38.3269 16 56 16C73.6731 16 88 30.3269 88 48C88 65.6731 73.6731 80 56 80C38.3269 80 24 65.6731 24 48Z" fill="#0294F7"/>
<path d="M56 26.1429H57V25.1429V16V15H56C37.7746 15 23 29.7746 23 48C23 66.2254 37.7746 81 56 81H57V80V70.8571V69.8571H56C43.9286 69.8571 34.1429 60.0714 34.1429 48C34.1429 35.9286 43.9286 26.1429 56 26.1429Z" fill="#D057FF" stroke="#131D2D" stroke-width="2"/>
<path d="M56.0003 26.1429H57.0003V25.1429V16V15H56.0003C42.0896 15 30.2027 23.6052 25.3458 35.7615L24.9748 36.6901L25.9034 37.0611L34.3937 40.4533L35.3223 40.8243L35.6933 39.8957C38.9168 31.8277 46.8011 26.1429 56.0003 26.1429Z" fill="#FC3DA6" stroke="#131D2D" stroke-width="2"/>
<path d="M109.255 59C109.02 59 108.828 58.9253 108.679 58.776C108.551 58.6267 108.487 58.4453 108.487 58.232V41.656L103.623 45.4C103.431 45.528 103.239 45.5813 103.047 45.56C102.855 45.5173 102.684 45.4 102.535 45.208L101.191 43.48C101.063 43.288 101.009 43.0853 101.031 42.872C101.073 42.6587 101.191 42.488 101.383 42.36L108.551 36.824C108.679 36.7173 108.807 36.6533 108.935 36.632C109.063 36.6107 109.201 36.6 109.351 36.6H112.167C112.38 36.6 112.561 36.6747 112.711 36.824C112.86 36.9733 112.935 37.1547 112.935 37.368V58.232C112.935 58.4453 112.86 58.6267 112.711 58.776C112.561 58.9253 112.38 59 112.167 59H109.255ZM117.411 59C117.198 59 117.016 58.9253 116.867 58.776C116.718 58.6267 116.643 58.4453 116.643 58.232V56.6C116.643 56.408 116.686 56.184 116.771 55.928C116.878 55.6507 117.102 55.3733 117.443 55.096L122.499 50.072C123.907 48.9627 125.038 48.024 125.891 47.256C126.766 46.4667 127.395 45.752 127.779 45.112C128.184 44.4507 128.387 43.8 128.387 43.16C128.387 42.2 128.12 41.4213 127.587 40.824C127.075 40.2267 126.254 39.928 125.123 39.928C124.376 39.928 123.747 40.088 123.235 40.408C122.723 40.7067 122.318 41.112 122.019 41.624C121.742 42.136 121.55 42.7013 121.443 43.32C121.4 43.5973 121.283 43.7893 121.091 43.896C120.899 44.0027 120.707 44.056 120.515 44.056H117.667C117.475 44.056 117.315 43.992 117.187 43.864C117.059 43.736 116.995 43.5867 116.995 43.416C117.016 42.4987 117.208 41.6133 117.571 40.76C117.934 39.8853 118.456 39.1173 119.139 38.456C119.843 37.7733 120.696 37.2293 121.699 36.824C122.702 36.4187 123.832 36.216 125.091 36.216C126.862 36.216 128.323 36.5147 129.475 37.112C130.648 37.7093 131.523 38.52 132.099 39.544C132.696 40.568 132.995 41.72 132.995 43C132.995 44.0027 132.803 44.9307 132.419 45.784C132.035 46.616 131.48 47.4267 130.755 48.216C130.03 48.984 129.155 49.7733 128.131 50.584L123.587 55.192H132.707C132.942 55.192 133.123 55.2667 133.251 55.416C133.4 55.544 133.475 55.7253 133.475 55.96V58.232C133.475 58.4453 133.4 58.6267 133.251 58.776C133.123 58.9253 132.942 59 132.707 59H117.411ZM137.704 59C137.49 59 137.309 58.9253 137.16 58.776C137.01 58.6267 136.936 58.4453 136.936 58.232V55.064C136.936 54.8293 137.01 54.6373 137.16 54.488C137.309 54.3387 137.49 54.264 137.704 54.264H140.904C141.117 54.264 141.298 54.3387 141.448 54.488C141.597 54.6373 141.672 54.8293 141.672 55.064V58.232C141.672 58.4453 141.597 58.6267 141.448 58.776C141.298 58.9253 141.117 59 140.904 59H137.704ZM153.536 59.32C151.701 59.32 150.123 58.9787 148.8 58.296C147.477 57.592 146.453 56.6533 145.728 55.48C145.003 54.2853 144.64 52.952 144.64 51.48C144.64 50.8187 144.725 50.1787 144.896 49.56C145.067 48.9413 145.291 48.3547 145.568 47.8C145.845 47.2453 146.112 46.7547 146.368 46.328C146.645 45.88 146.891 45.528 147.104 45.272L152.96 37.24C153.045 37.1333 153.173 37.0053 153.344 36.856C153.515 36.6853 153.749 36.6 154.048 36.6H157.024C157.216 36.6 157.376 36.6747 157.504 36.824C157.632 36.952 157.696 37.112 157.696 37.304C157.696 37.3893 157.675 37.4747 157.632 37.56C157.611 37.624 157.579 37.6773 157.536 37.72L153.056 43.928C153.248 43.864 153.472 43.8213 153.728 43.8C153.984 43.7787 154.219 43.768 154.432 43.768C155.499 43.7893 156.512 44.0027 157.472 44.408C158.432 44.792 159.275 45.3253 160 46.008C160.725 46.6907 161.291 47.4907 161.696 48.408C162.123 49.3253 162.336 50.328 162.336 51.416C162.336 52.824 161.984 54.136 161.28 55.352C160.576 56.5467 159.563 57.5067 158.24 58.232C156.939 58.9573 155.371 59.32 153.536 59.32ZM153.504 55.64C154.272 55.64 154.976 55.48 155.616 55.16C156.277 54.84 156.811 54.3707 157.216 53.752C157.621 53.1333 157.824 52.3653 157.824 51.448C157.824 50.552 157.621 49.7947 157.216 49.176C156.811 48.5573 156.277 48.088 155.616 47.768C154.976 47.448 154.272 47.288 153.504 47.288C152.736 47.288 152.021 47.448 151.36 47.768C150.72 48.088 150.197 48.5573 149.792 49.176C149.387 49.7947 149.184 50.552 149.184 51.448C149.184 52.3653 149.387 53.1333 149.792 53.752C150.197 54.3707 150.72 54.84 151.36 55.16C152.021 55.48 152.736 55.64 153.504 55.64ZM166.655 59C166.441 59 166.26 58.9253 166.111 58.776C165.961 58.6267 165.887 58.4453 165.887 58.232V37.4C165.887 37.1653 165.961 36.9733 166.111 36.824C166.26 36.6747 166.441 36.6 166.655 36.6H169.471C169.705 36.6 169.897 36.6747 170.047 36.824C170.196 36.9733 170.271 37.1653 170.271 37.4V44.888L177.503 37.176C177.588 37.0693 177.727 36.952 177.919 36.824C178.132 36.6747 178.409 36.6 178.751 36.6H181.919C182.089 36.6 182.239 36.664 182.367 36.792C182.516 36.92 182.591 37.08 182.591 37.272C182.591 37.4213 182.548 37.5493 182.463 37.656L173.663 47.32L183.071 57.912C183.177 58.04 183.231 58.1787 183.231 58.328C183.231 58.52 183.156 58.68 183.007 58.808C182.879 58.936 182.729 59 182.559 59H179.263C178.9 59 178.612 58.9253 178.399 58.776C178.207 58.6053 178.079 58.488 178.015 58.424L170.271 49.944V58.232C170.271 58.4453 170.196 58.6267 170.047 58.776C169.897 58.9253 169.705 59 169.471 59H166.655Z" fill="#F3F4F7"/>
<path d="M193.76 58C193.643 58 193.552 57.968 193.488 57.904C193.424 57.8293 193.392 57.7387 193.392 57.632V47.168C193.392 47.0613 193.424 46.976 193.488 46.912C193.552 46.8373 193.643 46.8 193.76 46.8H194.608C194.725 46.8 194.816 46.8373 194.88 46.912C194.944 46.976 194.976 47.0613 194.976 47.168V57.632C194.976 57.7387 194.944 57.8293 194.88 57.904C194.816 57.968 194.725 58 194.608 58H193.76ZM200.599 58.16C200.012 58.16 199.506 58.0587 199.079 57.856C198.652 57.6427 198.3 57.36 198.023 57.008C197.756 56.6453 197.554 56.2347 197.415 55.776C197.287 55.3173 197.212 54.832 197.191 54.32C197.18 54.1493 197.175 53.9893 197.175 53.84C197.175 53.6907 197.18 53.5307 197.191 53.36C197.212 52.8587 197.287 52.3787 197.415 51.92C197.554 51.4613 197.756 51.0507 198.023 50.688C198.3 50.3253 198.652 50.0427 199.079 49.84C199.506 49.6267 200.012 49.52 200.599 49.52C201.228 49.52 201.751 49.632 202.167 49.856C202.583 50.08 202.924 50.3573 203.191 50.688V47.008C203.191 46.9013 203.223 46.816 203.287 46.752C203.362 46.6773 203.452 46.64 203.559 46.64H204.327C204.434 46.64 204.519 46.6773 204.583 46.752C204.658 46.816 204.695 46.9013 204.695 47.008V57.632C204.695 57.7387 204.658 57.8293 204.583 57.904C204.519 57.968 204.434 58 204.327 58H203.607C203.49 58 203.399 57.968 203.335 57.904C203.271 57.8293 203.239 57.7387 203.239 57.632V56.96C202.972 57.3013 202.626 57.5893 202.199 57.824C201.772 58.048 201.239 58.16 200.599 58.16ZM200.935 56.864C201.468 56.864 201.895 56.7413 202.215 56.496C202.535 56.2507 202.775 55.9413 202.935 55.568C203.095 55.184 203.18 54.7947 203.191 54.4C203.202 54.2293 203.207 54.0267 203.207 53.792C203.207 53.5467 203.202 53.3387 203.191 53.168C203.18 52.7947 203.09 52.4267 202.919 52.064C202.759 51.7013 202.514 51.4027 202.183 51.168C201.863 50.9333 201.447 50.816 200.935 50.816C200.391 50.816 199.959 50.9387 199.639 51.184C199.319 51.4187 199.09 51.7333 198.951 52.128C198.812 52.512 198.732 52.928 198.711 53.376C198.7 53.6853 198.7 53.9947 198.711 54.304C198.732 54.752 198.812 55.1733 198.951 55.568C199.09 55.952 199.319 56.2667 199.639 56.512C199.959 56.7467 200.391 56.864 200.935 56.864ZM210.403 58.16C209.293 58.16 208.413 57.824 207.763 57.152C207.112 56.4693 206.755 55.5413 206.691 54.368C206.68 54.2293 206.675 54.0533 206.675 53.84C206.675 53.616 206.68 53.4347 206.691 53.296C206.733 52.5387 206.909 51.8773 207.219 51.312C207.528 50.736 207.949 50.2933 208.483 49.984C209.027 49.6747 209.661 49.52 210.387 49.52C211.197 49.52 211.875 49.6907 212.419 50.032C212.973 50.3733 213.395 50.8587 213.683 51.488C213.971 52.1173 214.115 52.8533 214.115 53.696V53.968C214.115 54.0853 214.077 54.176 214.003 54.24C213.939 54.304 213.853 54.336 213.747 54.336H208.211C208.211 54.3467 208.211 54.368 208.211 54.4C208.211 54.432 208.211 54.4587 208.211 54.48C208.232 54.9173 208.328 55.328 208.499 55.712C208.669 56.0853 208.915 56.3893 209.235 56.624C209.565 56.8587 209.949 56.976 210.387 56.976C210.771 56.976 211.091 56.9173 211.347 56.8C211.603 56.6827 211.811 56.5547 211.971 56.416C212.131 56.2667 212.237 56.1493 212.291 56.064C212.387 55.936 212.461 55.8613 212.515 55.84C212.568 55.808 212.653 55.792 212.771 55.792H213.555C213.651 55.792 213.731 55.824 213.795 55.888C213.869 55.9413 213.901 56.0213 213.891 56.128C213.88 56.288 213.795 56.4853 213.635 56.72C213.475 56.944 213.245 57.168 212.947 57.392C212.659 57.616 212.296 57.8027 211.859 57.952C211.432 58.0907 210.947 58.16 210.403 58.16ZM208.211 53.232H212.595V53.184C212.595 52.704 212.504 52.2773 212.323 51.904C212.152 51.5307 211.901 51.2373 211.571 51.024C211.24 50.8 210.845 50.688 210.387 50.688C209.928 50.688 209.533 50.8 209.203 51.024C208.883 51.2373 208.637 51.5307 208.467 51.904C208.296 52.2773 208.211 52.704 208.211 53.184V53.232ZM216.396 58C216.289 58 216.198 57.968 216.124 57.904C216.06 57.8293 216.028 57.7387 216.028 57.632V50.048C216.028 49.9413 216.06 49.856 216.124 49.792C216.198 49.7173 216.289 49.68 216.396 49.68H217.148C217.254 49.68 217.34 49.7173 217.404 49.792C217.478 49.856 217.516 49.9413 217.516 50.048V50.752C217.793 50.3893 218.14 50.096 218.556 49.872C218.982 49.6373 219.526 49.52 220.188 49.52C220.881 49.52 221.468 49.6747 221.948 49.984C222.438 50.2827 222.806 50.704 223.052 51.248C223.308 51.7813 223.436 52.4053 223.436 53.12V57.632C223.436 57.7387 223.398 57.8293 223.324 57.904C223.26 57.968 223.174 58 223.068 58H222.268C222.161 58 222.07 57.968 221.996 57.904C221.932 57.8293 221.9 57.7387 221.9 57.632V53.2C221.9 52.4533 221.718 51.872 221.356 51.456C220.993 51.0293 220.46 50.816 219.756 50.816C219.094 50.816 218.561 51.0293 218.156 51.456C217.761 51.872 217.564 52.4533 217.564 53.2V57.632C217.564 57.7387 217.526 57.8293 217.452 57.904C217.388 57.968 217.302 58 217.196 58H216.396ZM228.87 58C228.272 58 227.787 57.888 227.414 57.664C227.04 57.4293 226.768 57.104 226.598 56.688C226.427 56.2613 226.342 55.76 226.342 55.184V50.96H225.094C224.987 50.96 224.896 50.928 224.822 50.864C224.758 50.7893 224.726 50.6987 224.726 50.592V50.048C224.726 49.9413 224.758 49.856 224.822 49.792C224.896 49.7173 224.987 49.68 225.094 49.68H226.342V47.008C226.342 46.9013 226.374 46.816 226.438 46.752C226.512 46.6773 226.603 46.64 226.71 46.64H227.462C227.568 46.64 227.654 46.6773 227.718 46.752C227.792 46.816 227.83 46.9013 227.83 47.008V49.68H229.814C229.931 49.68 230.022 49.7173 230.086 49.792C230.15 49.856 230.182 49.9413 230.182 50.048V50.592C230.182 50.6987 230.15 50.7893 230.086 50.864C230.022 50.928 229.931 50.96 229.814 50.96H227.83V55.072C227.83 55.5733 227.915 55.968 228.086 56.256C228.256 56.544 228.56 56.688 228.998 56.688H229.974C230.08 56.688 230.166 56.7253 230.23 56.8C230.304 56.864 230.342 56.9493 230.342 57.056V57.632C230.342 57.7387 230.304 57.8293 230.23 57.904C230.166 57.968 230.08 58 229.974 58H228.87ZM232.24 58C232.133 58 232.042 57.968 231.968 57.904C231.904 57.8293 231.872 57.7387 231.872 57.632V50.048C231.872 49.9413 231.904 49.856 231.968 49.792C232.042 49.7173 232.133 49.68 232.24 49.68H233.008C233.114 49.68 233.2 49.7173 233.264 49.792C233.338 49.856 233.376 49.9413 233.376 50.048V57.632C233.376 57.7387 233.338 57.8293 233.264 57.904C233.2 57.968 233.114 58 233.008 58H232.24ZM232.112 48.128C232.005 48.128 231.914 48.096 231.84 48.032C231.776 47.9573 231.743 47.8667 231.743 47.76V46.896C231.743 46.7893 231.776 46.6987 231.84 46.624C231.914 46.5493 232.005 46.512 232.112 46.512H233.12C233.226 46.512 233.317 46.5493 233.392 46.624C233.466 46.6987 233.504 46.7893 233.504 46.896V47.76C233.504 47.8667 233.466 47.9573 233.392 48.032C233.317 48.096 233.226 48.128 233.12 48.128H232.112ZM238.995 58C238.397 58 237.912 57.888 237.539 57.664C237.165 57.4293 236.893 57.104 236.723 56.688C236.552 56.2613 236.467 55.76 236.467 55.184V50.96H235.219C235.112 50.96 235.021 50.928 234.947 50.864C234.883 50.7893 234.851 50.6987 234.851 50.592V50.048C234.851 49.9413 234.883 49.856 234.947 49.792C235.021 49.7173 235.112 49.68 235.219 49.68H236.467V47.008C236.467 46.9013 236.499 46.816 236.562 46.752C236.637 46.6773 236.728 46.64 236.835 46.64H237.587C237.693 46.64 237.779 46.6773 237.843 46.752C237.917 46.816 237.955 46.9013 237.955 47.008V49.68H239.939C240.056 49.68 240.147 49.7173 240.211 49.792C240.275 49.856 240.307 49.9413 240.307 50.048V50.592C240.307 50.6987 240.275 50.7893 240.211 50.864C240.147 50.928 240.056 50.96 239.939 50.96H237.955V55.072C237.955 55.5733 238.04 55.968 238.211 56.256C238.381 56.544 238.685 56.688 239.123 56.688H240.099C240.205 56.688 240.291 56.7253 240.355 56.8C240.429 56.864 240.467 56.9493 240.467 57.056V57.632C240.467 57.7387 240.429 57.8293 240.355 57.904C240.291 57.968 240.205 58 240.099 58H238.995ZM242.365 58C242.258 58 242.167 57.968 242.093 57.904C242.029 57.8293 241.997 57.7387 241.997 57.632V50.048C241.997 49.9413 242.029 49.856 242.093 49.792C242.167 49.7173 242.258 49.68 242.365 49.68H243.133C243.239 49.68 243.325 49.7173 243.389 49.792C243.463 49.856 243.501 49.9413 243.501 50.048V57.632C243.501 57.7387 243.463 57.8293 243.389 57.904C243.325 57.968 243.239 58 243.133 58H242.365ZM242.237 48.128C242.13 48.128 242.039 48.096 241.965 48.032C241.901 47.9573 241.868 47.8667 241.868 47.76V46.896C241.868 46.7893 241.901 46.6987 241.965 46.624C242.039 46.5493 242.13 46.512 242.237 46.512H243.245C243.351 46.512 243.442 46.5493 243.517 46.624C243.591 46.6987 243.629 46.7893 243.629 46.896V47.76C243.629 47.8667 243.591 47.9573 243.517 48.032C243.442 48.096 243.351 48.128 243.245 48.128H242.237ZM249.2 58.16C248.09 58.16 247.21 57.824 246.56 57.152C245.909 56.4693 245.552 55.5413 245.488 54.368C245.477 54.2293 245.472 54.0533 245.472 53.84C245.472 53.616 245.477 53.4347 245.488 53.296C245.53 52.5387 245.706 51.8773 246.016 51.312C246.325 50.736 246.746 50.2933 247.28 49.984C247.824 49.6747 248.458 49.52 249.184 49.52C249.994 49.52 250.672 49.6907 251.216 50.032C251.77 50.3733 252.192 50.8587 252.48 51.488C252.768 52.1173 252.911 52.8533 252.911 53.696V53.968C252.911 54.0853 252.874 54.176 252.8 54.24C252.736 54.304 252.65 54.336 252.544 54.336H247.008C247.008 54.3467 247.008 54.368 247.008 54.4C247.008 54.432 247.008 54.4587 247.008 54.48C247.029 54.9173 247.125 55.328 247.296 55.712C247.466 56.0853 247.712 56.3893 248.032 56.624C248.362 56.8587 248.746 56.976 249.184 56.976C249.568 56.976 249.888 56.9173 250.144 56.8C250.4 56.6827 250.608 56.5547 250.768 56.416C250.928 56.2667 251.034 56.1493 251.088 56.064C251.184 55.936 251.258 55.8613 251.312 55.84C251.365 55.808 251.45 55.792 251.568 55.792H252.352C252.448 55.792 252.528 55.824 252.592 55.888C252.666 55.9413 252.698 56.0213 252.688 56.128C252.677 56.288 252.592 56.4853 252.432 56.72C252.272 56.944 252.042 57.168 251.744 57.392C251.456 57.616 251.093 57.8027 250.656 57.952C250.229 58.0907 249.744 58.16 249.2 58.16ZM247.008 53.232H251.392V53.184C251.392 52.704 251.301 52.2773 251.12 51.904C250.949 51.5307 250.698 51.2373 250.368 51.024C250.037 50.8 249.642 50.688 249.184 50.688C248.725 50.688 248.33 50.8 248 51.024C247.68 51.2373 247.434 51.5307 247.264 51.904C247.093 52.2773 247.008 52.704 247.008 53.184V53.232ZM257.705 58.16C257.107 58.16 256.595 58.0853 256.169 57.936C255.742 57.7867 255.395 57.6053 255.129 57.392C254.862 57.1787 254.659 56.9653 254.521 56.752C254.393 56.5387 254.323 56.368 254.313 56.24C254.302 56.1227 254.339 56.032 254.425 55.968C254.51 55.904 254.595 55.872 254.681 55.872H255.401C255.454 55.872 255.497 55.8827 255.529 55.904C255.571 55.9147 255.625 55.9573 255.689 56.032C255.827 56.1813 255.982 56.3307 256.153 56.48C256.323 56.6293 256.531 56.752 256.777 56.848C257.033 56.944 257.347 56.992 257.721 56.992C258.265 56.992 258.713 56.8907 259.065 56.688C259.417 56.4747 259.593 56.1653 259.593 55.76C259.593 55.4933 259.518 55.28 259.369 55.12C259.23 54.96 258.974 54.816 258.601 54.688C258.238 54.56 257.737 54.4267 257.097 54.288C256.457 54.1387 255.95 53.9573 255.577 53.744C255.203 53.52 254.937 53.2587 254.777 52.96C254.617 52.6507 254.537 52.304 254.537 51.92C254.537 51.5253 254.654 51.1467 254.889 50.784C255.123 50.4107 255.465 50.1067 255.913 49.872C256.371 49.6373 256.942 49.52 257.625 49.52C258.179 49.52 258.654 49.5893 259.049 49.728C259.443 49.8667 259.769 50.0427 260.025 50.256C260.281 50.4587 260.473 50.6613 260.601 50.864C260.729 51.0667 260.798 51.2373 260.809 51.376C260.819 51.4827 260.787 51.5733 260.713 51.648C260.638 51.712 260.553 51.744 260.457 51.744H259.785C259.71 51.744 259.646 51.728 259.593 51.696C259.55 51.664 259.507 51.6267 259.465 51.584C259.358 51.4453 259.23 51.3067 259.081 51.168C258.942 51.0293 258.755 50.9173 258.521 50.832C258.297 50.736 257.998 50.688 257.625 50.688C257.091 50.688 256.691 50.8 256.425 51.024C256.158 51.248 256.025 51.5307 256.025 51.872C256.025 52.0747 256.083 52.256 256.201 52.416C256.318 52.576 256.542 52.72 256.873 52.848C257.203 52.976 257.694 53.1147 258.345 53.264C259.049 53.4027 259.603 53.5893 260.009 53.824C260.414 54.0587 260.702 54.3307 260.873 54.64C261.043 54.9493 261.129 55.3067 261.129 55.712C261.129 56.16 261.001 56.5707 260.745 56.944C260.489 57.3173 260.105 57.616 259.593 57.84C259.081 58.0533 258.451 58.16 257.705 58.16Z" fill="#9EA1B1"/>
<rect x="24" y="103" width="2" height="46" rx="1" fill="#0294F7"/>
<path d="M39.104 120.16C38.1867 120.16 37.3973 119.989 36.736 119.648C36.0747 119.296 35.5627 118.827 35.2 118.24C34.8373 117.643 34.656 116.976 34.656 116.24C34.656 115.909 34.6987 115.589 34.784 115.28C34.8693 114.971 34.9813 114.677 35.12 114.4C35.2587 114.123 35.392 113.877 35.52 113.664C35.6587 113.44 35.7813 113.264 35.888 113.136L38.816 109.12C38.8587 109.067 38.9227 109.003 39.008 108.928C39.0933 108.843 39.2107 108.8 39.36 108.8H40.848C40.944 108.8 41.024 108.837 41.088 108.912C41.152 108.976 41.184 109.056 41.184 109.152C41.184 109.195 41.1733 109.237 41.152 109.28C41.1413 109.312 41.1253 109.339 41.104 109.36L38.864 112.464C38.96 112.432 39.072 112.411 39.2 112.4C39.328 112.389 39.4453 112.384 39.552 112.384C40.0853 112.395 40.592 112.501 41.072 112.704C41.552 112.896 41.9733 113.163 42.336 113.504C42.6987 113.845 42.9813 114.245 43.184 114.704C43.3973 115.163 43.504 115.664 43.504 116.208C43.504 116.912 43.328 117.568 42.976 118.176C42.624 118.773 42.1173 119.253 41.456 119.616C40.8053 119.979 40.0213 120.16 39.104 120.16ZM39.088 118.32C39.472 118.32 39.824 118.24 40.144 118.08C40.4747 117.92 40.7413 117.685 40.944 117.376C41.1467 117.067 41.248 116.683 41.248 116.224C41.248 115.776 41.1467 115.397 40.944 115.088C40.7413 114.779 40.4747 114.544 40.144 114.384C39.824 114.224 39.472 114.144 39.088 114.144C38.704 114.144 38.3467 114.224 38.016 114.384C37.696 114.544 37.4347 114.779 37.232 115.088C37.0293 115.397 36.928 115.776 36.928 116.224C36.928 116.683 37.0293 117.067 37.232 117.376C37.4347 117.685 37.696 117.92 38.016 118.08C38.3467 118.24 38.704 118.32 39.088 118.32ZM45.3753 120C45.2686 120 45.1779 119.963 45.1033 119.888C45.0286 119.813 44.9913 119.723 44.9913 119.616V118.032C44.9913 117.915 45.0286 117.819 45.1033 117.744C45.1779 117.669 45.2686 117.632 45.3753 117.632H46.9753C47.0819 117.632 47.1726 117.669 47.2473 117.744C47.3219 117.819 47.3593 117.915 47.3593 118.032V119.616C47.3593 119.723 47.3219 119.813 47.2473 119.888C47.1726 119.963 47.0819 120 46.9753 120H45.3753ZM53.2885 120.16C52.5418 120.16 51.8965 120.069 51.3525 119.888C50.8085 119.707 50.3552 119.472 49.9925 119.184C49.6405 118.885 49.3738 118.565 49.1925 118.224C49.0112 117.872 48.9152 117.525 48.9045 117.184C48.9045 117.088 48.9365 117.013 49.0005 116.96C49.0752 116.896 49.1605 116.864 49.2565 116.864H50.6965C50.8032 116.864 50.8938 116.885 50.9685 116.928C51.0432 116.971 51.1072 117.056 51.1605 117.184C51.2565 117.472 51.4112 117.701 51.6245 117.872C51.8485 118.043 52.1045 118.165 52.3925 118.24C52.6805 118.304 52.9845 118.336 53.3045 118.336C53.9445 118.336 54.4512 118.187 54.8245 117.888C55.2085 117.579 55.4005 117.141 55.4005 116.576C55.4005 116.011 55.2245 115.605 54.8725 115.36C54.5205 115.104 54.0298 114.976 53.4005 114.976H51.7525C51.6352 114.976 51.5392 114.944 51.4645 114.88C51.3898 114.805 51.3525 114.709 51.3525 114.592V113.92C51.3525 113.813 51.3738 113.723 51.4165 113.648C51.4698 113.563 51.5232 113.493 51.5765 113.44L54.4405 110.64H49.8645C49.7472 110.64 49.6512 110.603 49.5765 110.528C49.5125 110.453 49.4805 110.363 49.4805 110.256V109.2C49.4805 109.083 49.5125 108.987 49.5765 108.912C49.6512 108.837 49.7472 108.8 49.8645 108.8H56.7285C56.8458 108.8 56.9418 108.837 57.0165 108.912C57.0912 108.987 57.1285 109.083 57.1285 109.2V110.16C57.1285 110.256 57.1072 110.341 57.0645 110.416C57.0218 110.491 56.9738 110.555 56.9205 110.608L54.1525 113.456L54.3445 113.472C54.9952 113.525 55.5712 113.675 56.0725 113.92C56.5845 114.155 56.9792 114.501 57.2565 114.96C57.5445 115.419 57.6885 115.995 57.6885 116.688C57.6885 117.413 57.4965 118.037 57.1125 118.56C56.7392 119.072 56.2218 119.467 55.5605 119.744C54.8992 120.021 54.1418 120.16 53.2885 120.16ZM60.0226 120C59.916 120 59.8253 119.963 59.7506 119.888C59.676 119.813 59.6386 119.723 59.6386 119.616V109.2C59.6386 109.083 59.676 108.987 59.7506 108.912C59.8253 108.837 59.916 108.8 60.0226 108.8H61.4306C61.548 108.8 61.644 108.837 61.7186 108.912C61.7933 108.987 61.8306 109.083 61.8306 109.2V112.944L65.4466 109.088C65.4893 109.035 65.5586 108.976 65.6546 108.912C65.7613 108.837 65.9 108.8 66.0706 108.8H67.6546C67.74 108.8 67.8146 108.832 67.8786 108.896C67.9533 108.96 67.9906 109.04 67.9906 109.136C67.9906 109.211 67.9693 109.275 67.9266 109.328L63.5266 114.16L68.2306 119.456C68.284 119.52 68.3106 119.589 68.3106 119.664C68.3106 119.76 68.2733 119.84 68.1986 119.904C68.1346 119.968 68.06 120 67.9746 120H66.3266C66.1453 120 66.0013 119.963 65.8946 119.888C65.7986 119.803 65.7346 119.744 65.7026 119.712L61.8306 115.472V119.616C61.8306 119.723 61.7933 119.813 61.7186 119.888C61.644 119.963 61.548 120 61.4306 120H60.0226Z" fill="white"/>
<path d="M76.7029 122.544C76.0095 122.544 75.4229 122.395 74.9429 122.096C74.4629 121.808 74.0789 121.36 73.7909 120.752C73.5029 120.144 73.2895 119.371 73.1509 118.432C73.0229 117.483 72.9589 116.357 72.9589 115.056C72.9589 113.755 73.0229 112.629 73.1509 111.68C73.2895 110.731 73.5029 109.957 73.7909 109.36C74.0789 108.752 74.4629 108.304 74.9429 108.016C75.4229 107.728 76.0095 107.584 76.7029 107.584C76.8095 107.584 76.8949 107.621 76.9589 107.696C77.0335 107.771 77.0709 107.856 77.0709 107.952V108.512C77.0709 108.608 77.0335 108.693 76.9589 108.768C76.8949 108.843 76.8255 108.88 76.7509 108.88C76.3029 108.891 75.9242 109.008 75.6149 109.232C75.3162 109.445 75.0709 109.792 74.8789 110.272C74.6975 110.752 74.5642 111.387 74.4789 112.176C74.4042 112.955 74.3669 113.915 74.3669 115.056C74.3669 116.197 74.4042 117.163 74.4789 117.952C74.5642 118.731 74.6975 119.36 74.8789 119.84C75.0709 120.32 75.3162 120.672 75.6149 120.896C75.9242 121.12 76.3029 121.237 76.7509 121.248C76.8255 121.248 76.8949 121.28 76.9589 121.344C77.0335 121.419 77.0709 121.509 77.0709 121.616V122.176C77.0709 122.272 77.0335 122.357 76.9589 122.432C76.8949 122.507 76.8095 122.544 76.7029 122.544ZM81.922 120.16C81.0793 120.16 80.3647 120.016 79.778 119.728C79.202 119.429 78.7593 119.045 78.45 118.576C78.1513 118.107 77.9913 117.611 77.97 117.088C77.9593 116.992 77.986 116.917 78.05 116.864C78.114 116.8 78.194 116.768 78.29 116.768H79.154C79.25 116.768 79.3353 116.795 79.41 116.848C79.4847 116.891 79.5433 116.981 79.586 117.12C79.6927 117.515 79.8633 117.84 80.098 118.096C80.3433 118.341 80.6207 118.523 80.93 118.64C81.25 118.747 81.5807 118.8 81.922 118.8C82.3807 118.8 82.7967 118.709 83.17 118.528C83.554 118.336 83.858 118.059 84.082 117.696C84.306 117.323 84.418 116.875 84.418 116.352C84.418 115.872 84.306 115.461 84.082 115.12C83.8687 114.768 83.57 114.501 83.186 114.32C82.8127 114.128 82.3913 114.032 81.922 114.032C81.57 114.032 81.282 114.075 81.058 114.16C80.834 114.245 80.642 114.347 80.482 114.464C80.3327 114.581 80.194 114.683 80.066 114.768C79.9487 114.853 79.8153 114.896 79.666 114.896H78.834C78.738 114.896 78.6527 114.864 78.578 114.8C78.5033 114.725 78.4713 114.64 78.482 114.544L78.994 109.2C79.0047 109.072 79.042 108.976 79.106 108.912C79.1807 108.837 79.2767 108.8 79.394 108.8H84.978C85.0847 108.8 85.17 108.837 85.234 108.912C85.3087 108.976 85.346 109.061 85.346 109.168V109.792C85.346 109.909 85.3087 110 85.234 110.064C85.17 110.128 85.0847 110.16 84.978 110.16H80.37L80.066 113.312C80.226 113.216 80.466 113.104 80.786 112.976C81.1167 112.837 81.57 112.768 82.146 112.768C82.6793 112.768 83.1753 112.848 83.634 113.008C84.1033 113.168 84.514 113.403 84.866 113.712C85.2287 114.021 85.5113 114.4 85.714 114.848C85.9167 115.285 86.018 115.792 86.018 116.368C86.018 117.179 85.842 117.867 85.49 118.432C85.138 118.997 84.6527 119.429 84.034 119.728C83.4153 120.016 82.7113 120.16 81.922 120.16ZM91.822 120.16C91.086 120.16 90.462 120.048 89.95 119.824C89.4487 119.589 89.038 119.269 88.718 118.864C88.398 118.459 88.1633 117.995 88.014 117.472C87.8753 116.949 87.7953 116.395 87.774 115.808C87.7633 115.52 87.7527 115.216 87.742 114.896C87.742 114.576 87.742 114.251 87.742 113.92C87.7527 113.589 87.7633 113.275 87.774 112.976C87.7847 112.389 87.8647 111.835 88.014 111.312C88.174 110.789 88.414 110.331 88.734 109.936C89.054 109.531 89.4647 109.216 89.966 108.992C90.478 108.757 91.0967 108.64 91.822 108.64C92.558 108.64 93.1767 108.757 93.678 108.992C94.19 109.216 94.606 109.531 94.926 109.936C95.246 110.331 95.4807 110.789 95.63 111.312C95.79 111.835 95.8753 112.389 95.886 112.976C95.8967 113.275 95.902 113.589 95.902 113.92C95.9127 114.251 95.9127 114.576 95.902 114.896C95.902 115.216 95.8967 115.52 95.886 115.808C95.8753 116.395 95.79 116.949 95.63 117.472C95.4807 117.995 95.246 118.459 94.926 118.864C94.6167 119.269 94.206 119.589 93.694 119.824C93.1927 120.048 92.5687 120.16 91.822 120.16ZM91.822 118.784C92.654 118.784 93.2673 118.512 93.662 117.968C94.0673 117.424 94.2753 116.677 94.286 115.728C94.3073 115.419 94.318 115.12 94.318 114.832C94.318 114.533 94.318 114.24 94.318 113.952C94.318 113.653 94.3073 113.36 94.286 113.072C94.2753 112.144 94.0673 111.403 93.662 110.848C93.2673 110.283 92.654 110 91.822 110C91.0007 110 90.3873 110.283 89.982 110.848C89.5873 111.403 89.3793 112.144 89.358 113.072C89.358 113.36 89.3527 113.653 89.342 113.952C89.342 114.24 89.342 114.533 89.342 114.832C89.3527 115.12 89.358 115.419 89.358 115.728C89.3793 116.677 89.5927 117.424 89.998 117.968C90.4033 118.512 91.0113 118.784 91.822 118.784ZM98.6503 120C98.4263 120 98.3143 119.893 98.3143 119.68C98.3143 119.616 98.3356 119.557 98.3783 119.504L106.282 109.104C106.357 109.008 106.426 108.933 106.49 108.88C106.565 108.827 106.672 108.8 106.81 108.8H107.338C107.562 108.8 107.674 108.907 107.674 109.12C107.674 109.184 107.653 109.243 107.61 109.296L99.7223 119.696C99.6476 119.792 99.5729 119.867 99.4983 119.92C99.4343 119.973 99.3276 120 99.1783 120H98.6503ZM105.978 120.096C105.285 120.096 104.736 119.899 104.33 119.504C103.936 119.109 103.717 118.592 103.674 117.952C103.664 117.675 103.658 117.44 103.658 117.248C103.658 117.045 103.664 116.795 103.674 116.496C103.717 115.856 103.925 115.339 104.298 114.944C104.682 114.539 105.242 114.336 105.978 114.336C106.725 114.336 107.285 114.539 107.658 114.944C108.042 115.339 108.256 115.856 108.298 116.496C108.32 116.795 108.33 117.045 108.33 117.248C108.33 117.44 108.32 117.675 108.298 117.952C108.256 118.592 108.032 119.109 107.626 119.504C107.232 119.899 106.682 120.096 105.978 120.096ZM105.978 119.04C106.266 119.04 106.49 118.981 106.65 118.864C106.81 118.747 106.928 118.603 107.002 118.432C107.077 118.251 107.12 118.069 107.13 117.888C107.152 117.6 107.162 117.371 107.162 117.2C107.162 117.029 107.152 116.816 107.13 116.56C107.12 116.272 107.029 116.005 106.858 115.76C106.688 115.515 106.394 115.392 105.978 115.392C105.573 115.392 105.285 115.515 105.114 115.76C104.954 116.005 104.864 116.272 104.842 116.56C104.832 116.816 104.826 117.029 104.826 117.2C104.826 117.371 104.832 117.6 104.842 117.888C104.864 118.069 104.906 118.251 104.97 118.432C105.045 118.603 105.162 118.747 105.322 118.864C105.493 118.981 105.712 119.04 105.978 119.04ZM99.9943 114.416C99.2903 114.416 98.7409 114.229 98.3463 113.856C97.9516 113.483 97.7329 112.976 97.6903 112.336C97.6796 112.059 97.6743 111.824 97.6743 111.632C97.6743 111.429 97.6796 111.179 97.6903 110.88C97.7223 110.24 97.9303 109.723 98.3143 109.328C98.6983 108.923 99.2583 108.72 99.9943 108.72C100.741 108.72 101.301 108.923 101.674 109.328C102.058 109.723 102.266 110.24 102.298 110.88C102.32 111.179 102.33 111.429 102.33 111.632C102.33 111.824 102.32 112.059 102.298 112.336C102.266 112.976 102.048 113.483 101.642 113.856C101.248 114.229 100.698 114.416 99.9943 114.416ZM99.9943 113.424C100.272 113.424 100.49 113.365 100.65 113.248C100.821 113.131 100.944 112.987 101.018 112.816C101.093 112.635 101.136 112.453 101.146 112.272C101.168 111.984 101.178 111.76 101.178 111.6C101.178 111.429 101.168 111.211 101.146 110.944C101.136 110.656 101.04 110.389 100.858 110.144C100.688 109.899 100.4 109.776 99.9943 109.776C99.5889 109.776 99.3009 109.899 99.1303 110.144C98.9703 110.389 98.8796 110.656 98.8583 110.944C98.8476 111.211 98.8423 111.429 98.8423 111.6C98.8423 111.76 98.8476 111.984 98.8583 112.272C98.8796 112.453 98.9223 112.635 98.9863 112.816C99.0609 112.987 99.1783 113.131 99.3383 113.248C99.4983 113.365 99.7169 113.424 99.9943 113.424ZM109.83 122.544C109.734 122.544 109.649 122.507 109.574 122.432C109.499 122.357 109.462 122.272 109.462 122.176V121.616C109.462 121.509 109.494 121.419 109.558 121.344C109.633 121.28 109.713 121.248 109.798 121.248C110.246 121.237 110.619 121.12 110.918 120.896C111.227 120.672 111.473 120.32 111.654 119.84C111.835 119.36 111.969 118.731 112.054 117.952C112.139 117.163 112.182 116.197 112.182 115.056C112.182 113.915 112.139 112.955 112.054 112.176C111.969 111.387 111.835 110.752 111.654 110.272C111.473 109.792 111.227 109.445 110.918 109.232C110.619 109.008 110.246 108.891 109.798 108.88C109.713 108.88 109.633 108.843 109.558 108.768C109.494 108.693 109.462 108.608 109.462 108.512V107.952C109.462 107.856 109.499 107.771 109.574 107.696C109.649 107.621 109.734 107.584 109.83 107.584C110.523 107.584 111.11 107.728 111.59 108.016C112.07 108.304 112.454 108.752 112.742 109.36C113.041 109.957 113.254 110.731 113.382 111.68C113.51 112.629 113.574 113.755 113.574 115.056C113.574 116.357 113.51 117.483 113.382 118.432C113.254 119.371 113.041 120.144 112.742 120.752C112.454 121.36 112.07 121.808 111.59 122.096C111.11 122.395 110.523 122.544 109.83 122.544Z" fill="#9EA1B1"/>
<path d="M36.87 144C36.7487 144 36.6507 143.967 36.576 143.902C36.5107 143.837 36.464 143.743 36.436 143.622L34.63 134.634C34.6207 134.597 34.616 134.564 34.616 134.536C34.616 134.508 34.616 134.489 34.616 134.48C34.616 134.405 34.644 134.34 34.7 134.284C34.756 134.228 34.8213 134.2 34.896 134.2H35.624C35.82 134.2 35.932 134.279 35.96 134.438L37.388 141.662L38.9 136.706C38.928 136.622 38.9747 136.547 39.04 136.482C39.1147 136.407 39.2173 136.37 39.348 136.37H39.866C40.006 136.37 40.1087 136.407 40.174 136.482C40.2393 136.547 40.2813 136.622 40.3 136.706L41.826 141.662L43.24 134.438C43.268 134.279 43.3847 134.2 43.59 134.2H44.318C44.3927 134.2 44.458 134.228 44.514 134.284C44.57 134.34 44.598 134.405 44.598 134.48C44.598 134.489 44.5933 134.508 44.584 134.536C44.584 134.564 44.584 134.597 44.584 134.634L42.778 143.622C42.75 143.743 42.6987 143.837 42.624 143.902C42.5587 143.967 42.4653 144 42.344 144H41.798C41.6673 144 41.5647 143.967 41.49 143.902C41.4153 143.837 41.364 143.753 41.336 143.65L39.6 138.316L37.878 143.65C37.8407 143.753 37.7847 143.837 37.71 143.902C37.6447 143.967 37.5467 144 37.416 144H36.87ZM48.9282 144.14C48.2188 144.14 47.6262 144.005 47.1502 143.734C46.6742 143.463 46.3102 143.09 46.0582 142.614C45.8062 142.129 45.6662 141.578 45.6382 140.962C45.6288 140.803 45.6242 140.603 45.6242 140.36C45.6242 140.108 45.6288 139.907 45.6382 139.758C45.6662 139.133 45.8062 138.582 46.0582 138.106C46.3195 137.63 46.6882 137.257 47.1642 136.986C47.6402 136.715 48.2282 136.58 48.9282 136.58C49.6282 136.58 50.2162 136.715 50.6922 136.986C51.1682 137.257 51.5322 137.63 51.7842 138.106C52.0455 138.582 52.1902 139.133 52.2182 139.758C52.2275 139.907 52.2322 140.108 52.2322 140.36C52.2322 140.603 52.2275 140.803 52.2182 140.962C52.1902 141.578 52.0502 142.129 51.7982 142.614C51.5462 143.09 51.1822 143.463 50.7062 143.734C50.2302 144.005 49.6375 144.14 48.9282 144.14ZM48.9282 143.062C49.5068 143.062 49.9688 142.88 50.3142 142.516C50.6595 142.143 50.8462 141.601 50.8742 140.892C50.8835 140.752 50.8882 140.575 50.8882 140.36C50.8882 140.145 50.8835 139.968 50.8742 139.828C50.8462 139.119 50.6595 138.582 50.3142 138.218C49.9688 137.845 49.5068 137.658 48.9282 137.658C48.3495 137.658 47.8828 137.845 47.5282 138.218C47.1828 138.582 47.0008 139.119 46.9822 139.828C46.9728 139.968 46.9682 140.145 46.9682 140.36C46.9682 140.575 46.9728 140.752 46.9822 140.892C47.0008 141.601 47.1828 142.143 47.5282 142.516C47.8828 142.88 48.3495 143.062 48.9282 143.062ZM54.3072 144C54.2139 144 54.1346 143.972 54.0692 143.916C54.0132 143.851 53.9852 143.771 53.9852 143.678V137.056C53.9852 136.963 54.0132 136.883 54.0692 136.818C54.1346 136.753 54.2139 136.72 54.3072 136.72H54.9512C55.0446 136.72 55.1239 136.753 55.1892 136.818C55.2546 136.883 55.2872 136.963 55.2872 137.056V137.672C55.4739 137.355 55.7306 137.117 56.0572 136.958C56.3839 136.799 56.7806 136.72 57.2472 136.72H57.7932C57.8866 136.72 57.9612 136.753 58.0172 136.818C58.0826 136.874 58.1152 136.949 58.1152 137.042V137.616C58.1152 137.709 58.0826 137.784 58.0172 137.84C57.9612 137.896 57.8866 137.924 57.7932 137.924H56.9532C56.4492 137.924 56.0526 138.073 55.7632 138.372C55.4739 138.661 55.3292 139.058 55.3292 139.562V143.678C55.3292 143.771 55.2966 143.851 55.2312 143.916C55.1659 143.972 55.0866 144 54.9932 144H54.3072ZM59.6396 144C59.5462 144 59.4669 143.972 59.4016 143.916C59.3456 143.851 59.3176 143.771 59.3176 143.678V134.382C59.3176 134.289 59.3456 134.214 59.4016 134.158C59.4669 134.093 59.5462 134.06 59.6396 134.06H60.2976C60.3909 134.06 60.4656 134.093 60.5216 134.158C60.5869 134.214 60.6196 134.289 60.6196 134.382V139.254L63.3776 136.958C63.4896 136.865 63.5736 136.804 63.6296 136.776C63.6949 136.739 63.7976 136.72 63.9376 136.72H64.6796C64.7636 136.72 64.8336 136.748 64.8896 136.804C64.9456 136.86 64.9736 136.93 64.9736 137.014C64.9736 137.051 64.9596 137.093 64.9316 137.14C64.9129 137.187 64.8709 137.233 64.8056 137.28L61.5716 139.968L65.1556 143.454C65.2676 143.547 65.3236 143.631 65.3236 143.706C65.3236 143.79 65.2956 143.86 65.2396 143.916C65.1836 143.972 65.1136 144 65.0296 144H64.3016C64.1616 144 64.0589 143.986 63.9936 143.958C63.9282 143.921 63.8442 143.855 63.7416 143.762L60.6196 140.78V143.678C60.6196 143.771 60.5869 143.851 60.5216 143.916C60.4656 143.972 60.3909 144 60.2976 144H59.6396ZM67.5723 144C67.479 144 67.3997 143.972 67.3343 143.916C67.2783 143.851 67.2503 143.771 67.2503 143.678V137.84H66.0603C65.967 137.84 65.8877 137.812 65.8223 137.756C65.7663 137.691 65.7383 137.611 65.7383 137.518V137.042C65.7383 136.949 65.7663 136.874 65.8223 136.818C65.8877 136.753 65.967 136.72 66.0603 136.72H67.2503V136.02C67.2503 135.544 67.3297 135.129 67.4883 134.774C67.647 134.41 67.899 134.13 68.2443 133.934C68.599 133.738 69.0703 133.64 69.6583 133.64H70.4983C70.5917 133.64 70.6663 133.673 70.7223 133.738C70.7877 133.794 70.8203 133.869 70.8203 133.962V134.438C70.8203 134.531 70.7877 134.611 70.7223 134.676C70.6663 134.732 70.5917 134.76 70.4983 134.76H69.6863C69.2477 134.76 68.949 134.877 68.7903 135.11C68.6317 135.334 68.5523 135.661 68.5523 136.09V136.72H70.3583C70.4517 136.72 70.5263 136.753 70.5823 136.818C70.6477 136.874 70.6803 136.949 70.6803 137.042V137.518C70.6803 137.611 70.6477 137.691 70.5823 137.756C70.5263 137.812 70.4517 137.84 70.3583 137.84H68.5523V143.678C68.5523 143.771 68.5197 143.851 68.4543 143.916C68.3983 143.972 68.3237 144 68.2303 144H67.5723ZM74.7543 144.14C74.045 144.14 73.4523 144.005 72.9763 143.734C72.5003 143.463 72.1363 143.09 71.8843 142.614C71.6323 142.129 71.4923 141.578 71.4643 140.962C71.455 140.803 71.4503 140.603 71.4503 140.36C71.4503 140.108 71.455 139.907 71.4643 139.758C71.4923 139.133 71.6323 138.582 71.8843 138.106C72.1457 137.63 72.5143 137.257 72.9903 136.986C73.4663 136.715 74.0543 136.58 74.7543 136.58C75.4543 136.58 76.0423 136.715 76.5183 136.986C76.9943 137.257 77.3583 137.63 77.6103 138.106C77.8717 138.582 78.0163 139.133 78.0443 139.758C78.0537 139.907 78.0583 140.108 78.0583 140.36C78.0583 140.603 78.0537 140.803 78.0443 140.962C78.0163 141.578 77.8763 142.129 77.6243 142.614C77.3723 143.09 77.0083 143.463 76.5323 143.734C76.0563 144.005 75.4637 144.14 74.7543 144.14ZM74.7543 143.062C75.333 143.062 75.795 142.88 76.1403 142.516C76.4857 142.143 76.6723 141.601 76.7003 140.892C76.7097 140.752 76.7143 140.575 76.7143 140.36C76.7143 140.145 76.7097 139.968 76.7003 139.828C76.6723 139.119 76.4857 138.582 76.1403 138.218C75.795 137.845 75.333 137.658 74.7543 137.658C74.1757 137.658 73.709 137.845 73.3543 138.218C73.009 138.582 72.827 139.119 72.8083 139.828C72.799 139.968 72.7943 140.145 72.7943 140.36C72.7943 140.575 72.799 140.752 72.8083 140.892C72.827 141.601 73.009 142.143 73.3543 142.516C73.709 142.88 74.1757 143.062 74.7543 143.062ZM80.1334 144C80.0401 144 79.9607 143.972 79.8954 143.916C79.8394 143.851 79.8114 143.771 79.8114 143.678V137.056C79.8114 136.963 79.8394 136.883 79.8954 136.818C79.9607 136.753 80.0401 136.72 80.1334 136.72H80.7774C80.8707 136.72 80.9501 136.753 81.0154 136.818C81.0807 136.883 81.1134 136.963 81.1134 137.056V137.672C81.3001 137.355 81.5567 137.117 81.8834 136.958C82.2101 136.799 82.6067 136.72 83.0734 136.72H83.6194C83.7127 136.72 83.7874 136.753 83.8434 136.818C83.9087 136.874 83.9414 136.949 83.9414 137.042V137.616C83.9414 137.709 83.9087 137.784 83.8434 137.84C83.7874 137.896 83.7127 137.924 83.6194 137.924H82.7794C82.2754 137.924 81.8787 138.073 81.5894 138.372C81.3001 138.661 81.1554 139.058 81.1554 139.562V143.678C81.1554 143.771 81.1227 143.851 81.0574 143.916C80.9921 143.972 80.9127 144 80.8194 144H80.1334ZM87.933 144.14C87.2704 144.14 86.6964 144.014 86.211 143.762C85.735 143.501 85.3664 143.132 85.105 142.656C84.8437 142.171 84.7037 141.592 84.685 140.92C84.6757 140.78 84.671 140.593 84.671 140.36C84.671 140.127 84.6757 139.94 84.685 139.8C84.7037 139.128 84.8437 138.554 85.105 138.078C85.3664 137.593 85.735 137.224 86.211 136.972C86.6964 136.711 87.2704 136.58 87.933 136.58C88.4744 136.58 88.9364 136.655 89.319 136.804C89.711 136.953 90.033 137.145 90.285 137.378C90.537 137.611 90.7237 137.863 90.845 138.134C90.9757 138.405 91.0457 138.661 91.055 138.904C91.0644 138.997 91.0364 139.072 90.971 139.128C90.9057 139.184 90.8264 139.212 90.733 139.212H90.061C89.9677 139.212 89.8977 139.193 89.851 139.156C89.8044 139.109 89.7577 139.035 89.711 138.932C89.543 138.475 89.3144 138.153 89.025 137.966C88.7357 137.779 88.3764 137.686 87.947 137.686C87.387 137.686 86.9297 137.859 86.575 138.204C86.2297 138.549 86.043 139.105 86.015 139.87C86.0057 140.206 86.0057 140.533 86.015 140.85C86.043 141.625 86.2297 142.185 86.575 142.53C86.9297 142.866 87.387 143.034 87.947 143.034C88.3764 143.034 88.7357 142.941 89.025 142.754C89.3144 142.567 89.543 142.245 89.711 141.788C89.7577 141.685 89.8044 141.611 89.851 141.564C89.8977 141.517 89.9677 141.494 90.061 141.494H90.733C90.8264 141.494 90.9057 141.527 90.971 141.592C91.0364 141.648 91.0644 141.723 91.055 141.816C91.0457 142.012 91.0037 142.213 90.929 142.418C90.8544 142.623 90.733 142.833 90.565 143.048C90.4064 143.253 90.2057 143.44 89.963 143.608C89.7204 143.767 89.431 143.897 89.095 144C88.759 144.093 88.3717 144.14 87.933 144.14ZM95.6296 144.14C94.659 144.14 93.889 143.846 93.3196 143.258C92.7503 142.661 92.4376 141.849 92.3816 140.822C92.3723 140.701 92.3676 140.547 92.3676 140.36C92.3676 140.164 92.3723 140.005 92.3816 139.884C92.419 139.221 92.573 138.643 92.8436 138.148C93.1143 137.644 93.483 137.257 93.9496 136.986C94.4256 136.715 94.981 136.58 95.6156 136.58C96.325 136.58 96.9176 136.729 97.3936 137.028C97.879 137.327 98.2476 137.751 98.4996 138.302C98.7516 138.853 98.8776 139.497 98.8776 140.234V140.472C98.8776 140.575 98.845 140.654 98.7796 140.71C98.7236 140.766 98.649 140.794 98.5556 140.794H93.7116C93.7116 140.803 93.7116 140.822 93.7116 140.85C93.7116 140.878 93.7116 140.901 93.7116 140.92C93.7303 141.303 93.8143 141.662 93.9636 141.998C94.113 142.325 94.3276 142.591 94.6076 142.796C94.897 143.001 95.233 143.104 95.6156 143.104C95.9516 143.104 96.2316 143.053 96.4556 142.95C96.6796 142.847 96.8616 142.735 97.0016 142.614C97.1416 142.483 97.235 142.381 97.2816 142.306C97.3656 142.194 97.431 142.129 97.4776 142.11C97.5243 142.082 97.599 142.068 97.7016 142.068H98.3876C98.4716 142.068 98.5416 142.096 98.5976 142.152C98.663 142.199 98.691 142.269 98.6816 142.362C98.6723 142.502 98.5976 142.675 98.4576 142.88C98.3176 143.076 98.117 143.272 97.8556 143.468C97.6036 143.664 97.2863 143.827 96.9036 143.958C96.5303 144.079 96.1056 144.14 95.6296 144.14ZM93.7116 139.828H97.5476V139.786C97.5476 139.366 97.4683 138.993 97.3096 138.666C97.1603 138.339 96.941 138.083 96.6516 137.896C96.3623 137.7 96.017 137.602 95.6156 137.602C95.2143 137.602 94.869 137.7 94.5796 137.896C94.2996 138.083 94.085 138.339 93.9356 138.666C93.7863 138.993 93.7116 139.366 93.7116 139.786V139.828Z" fill="#9AC2FE"/>
<rect x="209.333" y="103" width="2" height="46" rx="1" fill="#D057FF"/>
<path d="M224.309 120.16C223.562 120.16 222.917 120.069 222.373 119.888C221.829 119.707 221.376 119.472 221.013 119.184C220.661 118.885 220.394 118.565 220.213 118.224C220.032 117.872 219.936 117.525 219.925 117.184C219.925 117.088 219.957 117.013 220.021 116.96C220.096 116.896 220.181 116.864 220.277 116.864H221.717C221.824 116.864 221.914 116.885 221.989 116.928C222.064 116.971 222.128 117.056 222.181 117.184C222.277 117.472 222.432 117.701 222.645 117.872C222.869 118.043 223.125 118.165 223.413 118.24C223.701 118.304 224.005 118.336 224.325 118.336C224.965 118.336 225.472 118.187 225.845 117.888C226.229 117.579 226.421 117.141 226.421 116.576C226.421 116.011 226.245 115.605 225.893 115.36C225.541 115.104 225.05 114.976 224.421 114.976H222.773C222.656 114.976 222.56 114.944 222.485 114.88C222.41 114.805 222.373 114.709 222.373 114.592V113.92C222.373 113.813 222.394 113.723 222.437 113.648C222.49 113.563 222.544 113.493 222.597 113.44L225.461 110.64H220.885C220.768 110.64 220.672 110.603 220.597 110.528C220.533 110.453 220.501 110.363 220.501 110.256V109.2C220.501 109.083 220.533 108.987 220.597 108.912C220.672 108.837 220.768 108.8 220.885 108.8H227.749C227.866 108.8 227.962 108.837 228.037 108.912C228.112 108.987 228.149 109.083 228.149 109.2V110.16C228.149 110.256 228.128 110.341 228.085 110.416C228.042 110.491 227.994 110.555 227.941 110.608L225.173 113.456L225.365 113.472C226.016 113.525 226.592 113.675 227.093 113.92C227.605 114.155 228 114.501 228.277 114.96C228.565 115.419 228.709 115.995 228.709 116.688C228.709 117.413 228.517 118.037 228.133 118.56C227.76 119.072 227.242 119.467 226.581 119.744C225.92 120.021 225.162 120.16 224.309 120.16ZM230.755 120C230.648 120 230.558 119.963 230.483 119.888C230.408 119.813 230.371 119.723 230.371 119.616V118.032C230.371 117.915 230.408 117.819 230.483 117.744C230.558 117.669 230.648 117.632 230.755 117.632H232.355C232.462 117.632 232.552 117.669 232.627 117.744C232.702 117.819 232.739 117.915 232.739 118.032V119.616C232.739 119.723 232.702 119.813 232.627 119.888C232.552 119.963 232.462 120 232.355 120H230.755ZM235.949 120C235.853 120 235.773 119.968 235.709 119.904C235.645 119.829 235.613 119.744 235.613 119.648C235.613 119.595 235.618 119.552 235.629 119.52C235.65 119.488 235.666 119.461 235.677 119.44L238.029 116.192C237.826 116.245 237.608 116.267 237.373 116.256C236.829 116.245 236.322 116.144 235.853 115.952C235.394 115.749 234.989 115.483 234.637 115.152C234.296 114.811 234.024 114.421 233.821 113.984C233.629 113.536 233.533 113.051 233.533 112.528C233.533 112.048 233.624 111.579 233.805 111.12C233.986 110.651 234.253 110.229 234.605 109.856C234.968 109.483 235.416 109.189 235.949 108.976C236.493 108.752 237.128 108.64 237.853 108.64C238.568 108.64 239.197 108.741 239.741 108.944C240.285 109.147 240.738 109.429 241.101 109.792C241.474 110.144 241.752 110.549 241.933 111.008C242.125 111.467 242.221 111.952 242.221 112.464C242.221 112.923 242.146 113.349 241.997 113.744C241.848 114.139 241.661 114.501 241.437 114.832C241.224 115.152 241.01 115.467 240.797 115.776L237.981 119.68C237.938 119.733 237.874 119.803 237.789 119.888C237.714 119.963 237.597 120 237.437 120H235.949ZM237.869 114.56C238.253 114.56 238.6 114.48 238.909 114.32C239.229 114.149 239.48 113.915 239.661 113.616C239.853 113.307 239.949 112.944 239.949 112.528C239.949 112.101 239.853 111.739 239.661 111.44C239.48 111.131 239.229 110.896 238.909 110.736C238.589 110.565 238.242 110.48 237.869 110.48C237.485 110.48 237.133 110.565 236.813 110.736C236.504 110.896 236.253 111.131 236.061 111.44C235.88 111.739 235.789 112.101 235.789 112.528C235.789 112.944 235.88 113.307 236.061 113.616C236.253 113.915 236.504 114.149 236.813 114.32C237.133 114.48 237.485 114.56 237.869 114.56ZM244.512 120C244.405 120 244.315 119.963 244.24 119.888C244.165 119.813 244.128 119.723 244.128 119.616V109.2C244.128 109.083 244.165 108.987 244.24 108.912C244.315 108.837 244.405 108.8 244.512 108.8H245.92C246.037 108.8 246.133 108.837 246.208 108.912C246.283 108.987 246.32 109.083 246.32 109.2V112.944L249.936 109.088C249.979 109.035 250.048 108.976 250.144 108.912C250.251 108.837 250.389 108.8 250.56 108.8H252.144C252.229 108.8 252.304 108.832 252.368 108.896C252.443 108.96 252.48 109.04 252.48 109.136C252.48 109.211 252.459 109.275 252.416 109.328L248.016 114.16L252.72 119.456C252.773 119.52 252.8 119.589 252.8 119.664C252.8 119.76 252.763 119.84 252.688 119.904C252.624 119.968 252.549 120 252.464 120H250.816C250.635 120 250.491 119.963 250.384 119.888C250.288 119.803 250.224 119.744 250.192 119.712L246.32 115.472V119.616C246.32 119.723 246.283 119.813 246.208 119.888C246.133 119.963 246.037 120 245.92 120H244.512Z" fill="white"/>
<path d="M261.192 122.544C260.499 122.544 259.912 122.395 259.432 122.096C258.952 121.808 258.568 121.36 258.28 120.752C257.992 120.144 257.779 119.371 257.64 118.432C257.512 117.483 257.448 116.357 257.448 115.056C257.448 113.755 257.512 112.629 257.64 111.68C257.779 110.731 257.992 109.957 258.28 109.36C258.568 108.752 258.952 108.304 259.432 108.016C259.912 107.728 260.499 107.584 261.192 107.584C261.299 107.584 261.384 107.621 261.448 107.696C261.523 107.771 261.56 107.856 261.56 107.952V108.512C261.56 108.608 261.523 108.693 261.448 108.768C261.384 108.843 261.315 108.88 261.24 108.88C260.792 108.891 260.413 109.008 260.104 109.232C259.805 109.445 259.56 109.792 259.368 110.272C259.187 110.752 259.053 111.387 258.968 112.176C258.893 112.955 258.856 113.915 258.856 115.056C258.856 116.197 258.893 117.163 258.968 117.952C259.053 118.731 259.187 119.36 259.368 119.84C259.56 120.32 259.805 120.672 260.104 120.896C260.413 121.12 260.792 121.237 261.24 121.248C261.315 121.248 261.384 121.28 261.448 121.344C261.523 121.419 261.56 121.509 261.56 121.616V122.176C261.56 122.272 261.523 122.357 261.448 122.432C261.384 122.507 261.299 122.544 261.192 122.544ZM266.726 120.16C266.054 120.16 265.467 120.08 264.966 119.92C264.465 119.749 264.043 119.525 263.702 119.248C263.361 118.971 263.099 118.667 262.918 118.336C262.747 117.995 262.657 117.653 262.646 117.312C262.646 117.216 262.678 117.141 262.742 117.088C262.806 117.024 262.886 116.992 262.982 116.992H263.766C263.862 116.992 263.947 117.019 264.022 117.072C264.107 117.115 264.171 117.205 264.214 117.344C264.321 117.728 264.502 118.027 264.758 118.24C265.025 118.453 265.329 118.603 265.67 118.688C266.022 118.763 266.374 118.8 266.726 118.8C267.462 118.8 268.059 118.624 268.518 118.272C268.977 117.92 269.206 117.403 269.206 116.72C269.206 116.027 268.998 115.531 268.582 115.232C268.166 114.933 267.59 114.784 266.854 114.784H265.334C265.227 114.784 265.137 114.752 265.062 114.688C264.998 114.624 264.966 114.533 264.966 114.416V113.984C264.966 113.888 264.982 113.808 265.014 113.744C265.057 113.669 265.099 113.605 265.142 113.552L268.246 110.16H263.526C263.419 110.16 263.329 110.128 263.254 110.064C263.19 110 263.158 109.909 263.158 109.792V109.184C263.158 109.067 263.19 108.976 263.254 108.912C263.329 108.837 263.419 108.8 263.526 108.8H269.91C270.027 108.8 270.118 108.837 270.182 108.912C270.257 108.976 270.294 109.067 270.294 109.184V109.76C270.294 109.835 270.273 109.904 270.23 109.968C270.198 110.021 270.161 110.075 270.118 110.128L267.03 113.568L267.286 113.584C267.99 113.605 268.603 113.733 269.126 113.968C269.659 114.203 270.07 114.555 270.358 115.024C270.657 115.483 270.806 116.064 270.806 116.768C270.806 117.483 270.63 118.091 270.278 118.592C269.926 119.093 269.441 119.483 268.822 119.76C268.214 120.027 267.515 120.16 266.726 120.16ZM275.702 120C275.595 120 275.505 119.968 275.43 119.904C275.366 119.829 275.334 119.739 275.334 119.632V110.672L272.678 112.72C272.593 112.784 272.502 112.811 272.406 112.8C272.31 112.789 272.23 112.741 272.166 112.656L271.75 112.128C271.686 112.032 271.659 111.936 271.67 111.84C271.691 111.744 271.745 111.664 271.83 111.6L275.318 108.912C275.393 108.859 275.462 108.827 275.526 108.816C275.59 108.805 275.659 108.8 275.734 108.8H276.55C276.657 108.8 276.742 108.837 276.806 108.912C276.881 108.976 276.918 109.061 276.918 109.168V119.632C276.918 119.739 276.881 119.829 276.806 119.904C276.742 119.968 276.657 120 276.55 120H275.702ZM279.874 120C279.65 120 279.538 119.893 279.538 119.68C279.538 119.616 279.559 119.557 279.602 119.504L287.506 109.104C287.581 109.008 287.65 108.933 287.714 108.88C287.789 108.827 287.895 108.8 288.034 108.8H288.562C288.786 108.8 288.898 108.907 288.898 109.12C288.898 109.184 288.877 109.243 288.834 109.296L280.946 119.696C280.871 119.792 280.797 119.867 280.722 119.92C280.658 119.973 280.551 120 280.402 120H279.874ZM287.202 120.096C286.509 120.096 285.959 119.899 285.554 119.504C285.159 119.109 284.941 118.592 284.898 117.952C284.887 117.675 284.882 117.44 284.882 117.248C284.882 117.045 284.887 116.795 284.898 116.496C284.941 115.856 285.149 115.339 285.522 114.944C285.906 114.539 286.466 114.336 287.202 114.336C287.949 114.336 288.509 114.539 288.882 114.944C289.266 115.339 289.479 115.856 289.522 116.496C289.543 116.795 289.554 117.045 289.554 117.248C289.554 117.44 289.543 117.675 289.522 117.952C289.479 118.592 289.255 119.109 288.85 119.504C288.455 119.899 287.906 120.096 287.202 120.096ZM287.202 119.04C287.49 119.04 287.714 118.981 287.874 118.864C288.034 118.747 288.151 118.603 288.226 118.432C288.301 118.251 288.343 118.069 288.354 117.888C288.375 117.6 288.386 117.371 288.386 117.2C288.386 117.029 288.375 116.816 288.354 116.56C288.343 116.272 288.253 116.005 288.082 115.76C287.911 115.515 287.618 115.392 287.202 115.392C286.797 115.392 286.509 115.515 286.338 115.76C286.178 116.005 286.087 116.272 286.066 116.56C286.055 116.816 286.05 117.029 286.05 117.2C286.05 117.371 286.055 117.6 286.066 117.888C286.087 118.069 286.13 118.251 286.194 118.432C286.269 118.603 286.386 118.747 286.546 118.864C286.717 118.981 286.935 119.04 287.202 119.04ZM281.218 114.416C280.514 114.416 279.965 114.229 279.57 113.856C279.175 113.483 278.957 112.976 278.914 112.336C278.903 112.059 278.898 111.824 278.898 111.632C278.898 111.429 278.903 111.179 278.914 110.88C278.946 110.24 279.154 109.723 279.538 109.328C279.922 108.923 280.482 108.72 281.218 108.72C281.965 108.72 282.525 108.923 282.898 109.328C283.282 109.723 283.49 110.24 283.522 110.88C283.543 111.179 283.554 111.429 283.554 111.632C283.554 111.824 283.543 112.059 283.522 112.336C283.49 112.976 283.271 113.483 282.866 113.856C282.471 114.229 281.922 114.416 281.218 114.416ZM281.218 113.424C281.495 113.424 281.714 113.365 281.874 113.248C282.045 113.131 282.167 112.987 282.242 112.816C282.317 112.635 282.359 112.453 282.37 112.272C282.391 111.984 282.402 111.76 282.402 111.6C282.402 111.429 282.391 111.211 282.37 110.944C282.359 110.656 282.263 110.389 282.082 110.144C281.911 109.899 281.623 109.776 281.218 109.776C280.813 109.776 280.525 109.899 280.354 110.144C280.194 110.389 280.103 110.656 280.082 110.944C280.071 111.211 280.066 111.429 280.066 111.6C280.066 111.76 280.071 111.984 280.082 112.272C280.103 112.453 280.146 112.635 280.21 112.816C280.285 112.987 280.402 113.131 280.562 113.248C280.722 113.365 280.941 113.424 281.218 113.424ZM291.054 122.544C290.958 122.544 290.872 122.507 290.798 122.432C290.723 122.357 290.686 122.272 290.686 122.176V121.616C290.686 121.509 290.718 121.419 290.782 121.344C290.856 121.28 290.936 121.248 291.022 121.248C291.47 121.237 291.843 121.12 292.142 120.896C292.451 120.672 292.696 120.32 292.878 119.84C293.059 119.36 293.192 118.731 293.278 117.952C293.363 117.163 293.406 116.197 293.406 115.056C293.406 113.915 293.363 112.955 293.278 112.176C293.192 111.387 293.059 110.752 292.878 110.272C292.696 109.792 292.451 109.445 292.142 109.232C291.843 109.008 291.47 108.891 291.022 108.88C290.936 108.88 290.856 108.843 290.782 108.768C290.718 108.693 290.686 108.608 290.686 108.512V107.952C290.686 107.856 290.723 107.771 290.798 107.696C290.872 107.621 290.958 107.584 291.054 107.584C291.747 107.584 292.334 107.728 292.814 108.016C293.294 108.304 293.678 108.752 293.966 109.36C294.264 109.957 294.478 110.731 294.606 111.68C294.734 112.629 294.798 113.755 294.798 115.056C294.798 116.357 294.734 117.483 294.606 118.432C294.478 119.371 294.264 120.144 293.966 120.752C293.678 121.36 293.294 121.808 292.814 122.096C292.334 122.395 291.747 122.544 291.054 122.544Z" fill="#9EA1B1"/>
<path d="M220.873 144C220.77 144 220.691 143.972 220.635 143.916C220.579 143.851 220.551 143.771 220.551 143.678V134.536C220.551 134.433 220.579 134.354 220.635 134.298C220.691 134.233 220.77 134.2 220.873 134.2H226.655C226.758 134.2 226.837 134.233 226.893 134.298C226.949 134.354 226.977 134.433 226.977 134.536V135.068C226.977 135.171 226.949 135.25 226.893 135.306C226.837 135.362 226.758 135.39 226.655 135.39H221.895V138.456H226.347C226.45 138.456 226.529 138.489 226.585 138.554C226.641 138.61 226.669 138.689 226.669 138.792V139.31C226.669 139.403 226.641 139.483 226.585 139.548C226.529 139.604 226.45 139.632 226.347 139.632H221.895V142.81H226.767C226.87 142.81 226.949 142.838 227.005 142.894C227.061 142.95 227.089 143.029 227.089 143.132V143.678C227.089 143.771 227.061 143.851 227.005 143.916C226.949 143.972 226.87 144 226.767 144H220.873ZM228.523 144C228.449 144 228.379 143.972 228.313 143.916C228.257 143.86 228.229 143.79 228.229 143.706C228.229 143.678 228.234 143.645 228.243 143.608C228.262 143.561 228.29 143.51 228.327 143.454L230.763 140.276L228.481 137.266C228.444 137.21 228.416 137.163 228.397 137.126C228.388 137.089 228.383 137.051 228.383 137.014C228.383 136.93 228.411 136.86 228.467 136.804C228.523 136.748 228.593 136.72 228.677 136.72H229.391C229.494 136.72 229.573 136.748 229.629 136.804C229.685 136.851 229.727 136.897 229.755 136.944L231.617 139.366L233.479 136.958C233.517 136.911 233.559 136.86 233.605 136.804C233.661 136.748 233.741 136.72 233.843 136.72H234.529C234.613 136.72 234.683 136.748 234.739 136.804C234.795 136.86 234.823 136.93 234.823 137.014C234.823 137.051 234.814 137.089 234.795 137.126C234.786 137.163 234.763 137.21 234.725 137.266L232.415 140.304L234.851 143.454C234.889 143.51 234.912 143.557 234.921 143.594C234.94 143.631 234.949 143.669 234.949 143.706C234.949 143.79 234.921 143.86 234.865 143.916C234.809 143.972 234.739 144 234.655 144H233.913C233.82 144 233.745 143.977 233.689 143.93C233.633 143.883 233.587 143.837 233.549 143.79L231.589 141.228L229.601 143.79C229.564 143.827 229.517 143.874 229.461 143.93C229.415 143.977 229.34 144 229.237 144H228.523ZM239.248 144C238.725 144 238.301 143.902 237.974 143.706C237.647 143.501 237.409 143.216 237.26 142.852C237.111 142.479 237.036 142.04 237.036 141.536V137.84H235.944C235.851 137.84 235.771 137.812 235.706 137.756C235.65 137.691 235.622 137.611 235.622 137.518V137.042C235.622 136.949 235.65 136.874 235.706 136.818C235.771 136.753 235.851 136.72 235.944 136.72H237.036V134.382C237.036 134.289 237.064 134.214 237.12 134.158C237.185 134.093 237.265 134.06 237.358 134.06H238.016C238.109 134.06 238.184 134.093 238.24 134.158C238.305 134.214 238.338 134.289 238.338 134.382V136.72H240.074C240.177 136.72 240.256 136.753 240.312 136.818C240.368 136.874 240.396 136.949 240.396 137.042V137.518C240.396 137.611 240.368 137.691 240.312 137.756C240.256 137.812 240.177 137.84 240.074 137.84H238.338V141.438C238.338 141.877 238.413 142.222 238.562 142.474C238.711 142.726 238.977 142.852 239.36 142.852H240.214C240.307 142.852 240.382 142.885 240.438 142.95C240.503 143.006 240.536 143.081 240.536 143.174V143.678C240.536 143.771 240.503 143.851 240.438 143.916C240.382 143.972 240.307 144 240.214 144H239.248ZM244.787 144.14C243.816 144.14 243.046 143.846 242.477 143.258C241.908 142.661 241.595 141.849 241.539 140.822C241.53 140.701 241.525 140.547 241.525 140.36C241.525 140.164 241.53 140.005 241.539 139.884C241.576 139.221 241.73 138.643 242.001 138.148C242.272 137.644 242.64 137.257 243.107 136.986C243.583 136.715 244.138 136.58 244.773 136.58C245.482 136.58 246.075 136.729 246.551 137.028C247.036 137.327 247.405 137.751 247.657 138.302C247.909 138.853 248.035 139.497 248.035 140.234V140.472C248.035 140.575 248.002 140.654 247.937 140.71C247.881 140.766 247.806 140.794 247.713 140.794H242.869C242.869 140.803 242.869 140.822 242.869 140.85C242.869 140.878 242.869 140.901 242.869 140.92C242.888 141.303 242.972 141.662 243.121 141.998C243.27 142.325 243.485 142.591 243.765 142.796C244.054 143.001 244.39 143.104 244.773 143.104C245.109 143.104 245.389 143.053 245.613 142.95C245.837 142.847 246.019 142.735 246.159 142.614C246.299 142.483 246.392 142.381 246.439 142.306C246.523 142.194 246.588 142.129 246.635 142.11C246.682 142.082 246.756 142.068 246.859 142.068H247.545C247.629 142.068 247.699 142.096 247.755 142.152C247.82 142.199 247.848 142.269 247.839 142.362C247.83 142.502 247.755 142.675 247.615 142.88C247.475 143.076 247.274 143.272 247.013 143.468C246.761 143.664 246.444 143.827 246.061 143.958C245.688 144.079 245.263 144.14 244.787 144.14ZM242.869 139.828H246.705V139.786C246.705 139.366 246.626 138.993 246.467 138.666C246.318 138.339 246.098 138.083 245.809 137.896C245.52 137.7 245.174 137.602 244.773 137.602C244.372 137.602 244.026 137.7 243.737 137.896C243.457 138.083 243.242 138.339 243.093 138.666C242.944 138.993 242.869 139.366 242.869 139.786V139.828ZM250.031 144C249.938 144 249.858 143.972 249.793 143.916C249.737 143.851 249.709 143.771 249.709 143.678V137.056C249.709 136.963 249.737 136.883 249.793 136.818C249.858 136.753 249.938 136.72 250.031 136.72H250.675C250.768 136.72 250.848 136.753 250.913 136.818C250.978 136.883 251.011 136.963 251.011 137.056V137.672C251.198 137.355 251.454 137.117 251.781 136.958C252.108 136.799 252.504 136.72 252.971 136.72H253.517C253.61 136.72 253.685 136.753 253.741 136.818C253.806 136.874 253.839 136.949 253.839 137.042V137.616C253.839 137.709 253.806 137.784 253.741 137.84C253.685 137.896 253.61 137.924 253.517 137.924H252.677C252.173 137.924 251.776 138.073 251.487 138.372C251.198 138.661 251.053 139.058 251.053 139.562V143.678C251.053 143.771 251.02 143.851 250.955 143.916C250.89 143.972 250.81 144 250.717 144H250.031ZM255.349 144C255.256 144 255.177 143.972 255.111 143.916C255.055 143.851 255.027 143.771 255.027 143.678V137.042C255.027 136.949 255.055 136.874 255.111 136.818C255.177 136.753 255.256 136.72 255.349 136.72H256.007C256.101 136.72 256.175 136.753 256.231 136.818C256.297 136.874 256.329 136.949 256.329 137.042V137.658C256.572 137.341 256.875 137.084 257.239 136.888C257.613 136.683 258.089 136.58 258.667 136.58C259.274 136.58 259.787 136.715 260.207 136.986C260.637 137.247 260.959 137.616 261.173 138.092C261.397 138.559 261.509 139.105 261.509 139.73V143.678C261.509 143.771 261.477 143.851 261.411 143.916C261.355 143.972 261.281 144 261.187 144H260.487C260.394 144 260.315 143.972 260.249 143.916C260.193 143.851 260.165 143.771 260.165 143.678V139.8C260.165 139.147 260.007 138.638 259.689 138.274C259.372 137.901 258.905 137.714 258.289 137.714C257.711 137.714 257.244 137.901 256.889 138.274C256.544 138.638 256.371 139.147 256.371 139.8V143.678C256.371 143.771 256.339 143.851 256.273 143.916C256.217 143.972 256.143 144 256.049 144H255.349ZM265.547 144.14C265.081 144.14 264.656 144.047 264.273 143.86C263.891 143.673 263.583 143.421 263.349 143.104C263.116 142.787 262.999 142.427 262.999 142.026C262.999 141.382 263.261 140.869 263.783 140.486C264.306 140.103 264.987 139.851 265.827 139.73L267.913 139.436V139.03C267.913 138.582 267.783 138.232 267.521 137.98C267.269 137.728 266.854 137.602 266.275 137.602C265.865 137.602 265.529 137.686 265.267 137.854C265.006 138.022 264.824 138.237 264.721 138.498C264.665 138.638 264.567 138.708 264.427 138.708H263.797C263.695 138.708 263.615 138.68 263.559 138.624C263.513 138.559 263.489 138.484 263.489 138.4C263.489 138.26 263.541 138.087 263.643 137.882C263.755 137.677 263.923 137.476 264.147 137.28C264.371 137.084 264.656 136.921 265.001 136.79C265.356 136.65 265.785 136.58 266.289 136.58C266.849 136.58 267.321 136.655 267.703 136.804C268.086 136.944 268.385 137.135 268.599 137.378C268.823 137.621 268.982 137.896 269.075 138.204C269.178 138.512 269.229 138.825 269.229 139.142V143.678C269.229 143.771 269.197 143.851 269.131 143.916C269.075 143.972 269.001 144 268.907 144H268.263C268.161 144 268.081 143.972 268.025 143.916C267.969 143.851 267.941 143.771 267.941 143.678V143.076C267.82 143.244 267.657 143.412 267.451 143.58C267.246 143.739 266.989 143.874 266.681 143.986C266.373 144.089 265.995 144.14 265.547 144.14ZM265.841 143.09C266.224 143.09 266.574 143.011 266.891 142.852C267.209 142.684 267.456 142.427 267.633 142.082C267.82 141.737 267.913 141.303 267.913 140.78V140.388L266.289 140.626C265.627 140.719 265.127 140.878 264.791 141.102C264.455 141.317 264.287 141.592 264.287 141.928C264.287 142.189 264.362 142.409 264.511 142.586C264.67 142.754 264.866 142.88 265.099 142.964C265.342 143.048 265.589 143.09 265.841 143.09ZM271.578 144C271.485 144 271.405 143.972 271.34 143.916C271.284 143.851 271.256 143.771 271.256 143.678V134.382C271.256 134.289 271.284 134.214 271.34 134.158C271.405 134.093 271.485 134.06 271.578 134.06H272.236C272.339 134.06 272.418 134.093 272.474 134.158C272.53 134.214 272.558 134.289 272.558 134.382V143.678C272.558 143.771 272.53 143.851 272.474 143.916C272.418 143.972 272.339 144 272.236 144H271.578Z" fill="#E9A8FF"/>
<rect x="394.667" y="103" width="2" height="46" rx="1" fill="#FC3DA6"/>
<path d="M405.771 120C405.664 120 405.574 119.963 405.499 119.888C405.424 119.813 405.387 119.723 405.387 119.616V118.8C405.387 118.704 405.408 118.592 405.451 118.464C405.504 118.325 405.616 118.187 405.787 118.048L408.315 115.536C409.019 114.981 409.584 114.512 410.011 114.128C410.448 113.733 410.763 113.376 410.955 113.056C411.158 112.725 411.259 112.4 411.259 112.08C411.259 111.6 411.126 111.211 410.859 110.912C410.603 110.613 410.192 110.464 409.627 110.464C409.254 110.464 408.939 110.544 408.683 110.704C408.427 110.853 408.224 111.056 408.075 111.312C407.936 111.568 407.84 111.851 407.787 112.16C407.766 112.299 407.707 112.395 407.611 112.448C407.515 112.501 407.419 112.528 407.323 112.528H405.899C405.803 112.528 405.723 112.496 405.659 112.432C405.595 112.368 405.563 112.293 405.563 112.208C405.574 111.749 405.67 111.307 405.851 110.88C406.032 110.443 406.294 110.059 406.635 109.728C406.987 109.387 407.414 109.115 407.915 108.912C408.416 108.709 408.982 108.608 409.611 108.608C410.496 108.608 411.227 108.757 411.803 109.056C412.39 109.355 412.827 109.76 413.115 110.272C413.414 110.784 413.563 111.36 413.563 112C413.563 112.501 413.467 112.965 413.275 113.392C413.083 113.808 412.806 114.213 412.443 114.608C412.08 114.992 411.643 115.387 411.131 115.792L408.859 118.096H413.419C413.536 118.096 413.627 118.133 413.691 118.208C413.766 118.272 413.803 118.363 413.803 118.48V119.616C413.803 119.723 413.766 119.813 413.691 119.888C413.627 119.963 413.536 120 413.419 120H405.771ZM415.917 120C415.811 120 415.72 119.963 415.645 119.888C415.571 119.813 415.533 119.723 415.533 119.616V118.032C415.533 117.915 415.571 117.819 415.645 117.744C415.72 117.669 415.811 117.632 415.917 117.632H417.517C417.624 117.632 417.715 117.669 417.789 117.744C417.864 117.819 417.901 117.915 417.901 118.032V119.616C417.901 119.723 417.864 119.813 417.789 119.888C417.715 119.963 417.624 120 417.517 120H415.917ZM423.83 120.16C423.084 120.16 422.438 120.069 421.894 119.888C421.35 119.707 420.897 119.472 420.534 119.184C420.182 118.885 419.916 118.565 419.734 118.224C419.553 117.872 419.457 117.525 419.446 117.184C419.446 117.088 419.478 117.013 419.542 116.96C419.617 116.896 419.702 116.864 419.798 116.864H421.238C421.345 116.864 421.436 116.885 421.51 116.928C421.585 116.971 421.649 117.056 421.702 117.184C421.798 117.472 421.953 117.701 422.166 117.872C422.39 118.043 422.646 118.165 422.934 118.24C423.222 118.304 423.526 118.336 423.846 118.336C424.486 118.336 424.993 118.187 425.366 117.888C425.75 117.579 425.942 117.141 425.942 116.576C425.942 116.011 425.766 115.605 425.414 115.36C425.062 115.104 424.572 114.976 423.942 114.976H422.294C422.177 114.976 422.081 114.944 422.006 114.88C421.932 114.805 421.894 114.709 421.894 114.592V113.92C421.894 113.813 421.916 113.723 421.958 113.648C422.012 113.563 422.065 113.493 422.118 113.44L424.982 110.64H420.406C420.289 110.64 420.193 110.603 420.118 110.528C420.054 110.453 420.022 110.363 420.022 110.256V109.2C420.022 109.083 420.054 108.987 420.118 108.912C420.193 108.837 420.289 108.8 420.406 108.8H427.27C427.388 108.8 427.484 108.837 427.558 108.912C427.633 108.987 427.67 109.083 427.67 109.2V110.16C427.67 110.256 427.649 110.341 427.606 110.416C427.564 110.491 427.516 110.555 427.462 110.608L424.694 113.456L424.886 113.472C425.537 113.525 426.113 113.675 426.614 113.92C427.126 114.155 427.521 114.501 427.798 114.96C428.086 115.419 428.23 115.995 428.23 116.688C428.23 117.413 428.038 118.037 427.654 118.56C427.281 119.072 426.764 119.467 426.102 119.744C425.441 120.021 424.684 120.16 423.83 120.16ZM430.565 120C430.458 120 430.367 119.963 430.293 119.888C430.218 119.813 430.181 119.723 430.181 119.616V109.2C430.181 109.083 430.218 108.987 430.293 108.912C430.367 108.837 430.458 108.8 430.565 108.8H431.973C432.09 108.8 432.186 108.837 432.261 108.912C432.335 108.987 432.373 109.083 432.373 109.2V112.944L435.989 109.088C436.031 109.035 436.101 108.976 436.197 108.912C436.303 108.837 436.442 108.8 436.613 108.8H438.197C438.282 108.8 438.357 108.832 438.421 108.896C438.495 108.96 438.533 109.04 438.533 109.136C438.533 109.211 438.511 109.275 438.469 109.328L434.069 114.16L438.773 119.456C438.826 119.52 438.853 119.589 438.853 119.664C438.853 119.76 438.815 119.84 438.741 119.904C438.677 119.968 438.602 120 438.517 120H436.869C436.687 120 436.543 119.963 436.437 119.888C436.341 119.803 436.277 119.744 436.245 119.712L432.373 115.472V119.616C432.373 119.723 432.335 119.813 432.261 119.888C432.186 119.963 432.09 120 431.973 120H430.565Z" fill="white"/>
<path d="M447.245 122.544C446.552 122.544 445.965 122.395 445.485 122.096C445.005 121.808 444.621 121.36 444.333 120.752C444.045 120.144 443.832 119.371 443.693 118.432C443.565 117.483 443.501 116.357 443.501 115.056C443.501 113.755 443.565 112.629 443.693 111.68C443.832 110.731 444.045 109.957 444.333 109.36C444.621 108.752 445.005 108.304 445.485 108.016C445.965 107.728 446.552 107.584 447.245 107.584C447.352 107.584 447.437 107.621 447.501 107.696C447.576 107.771 447.613 107.856 447.613 107.952V108.512C447.613 108.608 447.576 108.693 447.501 108.768C447.437 108.843 447.368 108.88 447.293 108.88C446.845 108.891 446.466 109.008 446.157 109.232C445.858 109.445 445.613 109.792 445.421 110.272C445.24 110.752 445.106 111.387 445.021 112.176C444.946 112.955 444.909 113.915 444.909 115.056C444.909 116.197 444.946 117.163 445.021 117.952C445.106 118.731 445.24 119.36 445.421 119.84C445.613 120.32 445.858 120.672 446.157 120.896C446.466 121.12 446.845 121.237 447.293 121.248C447.368 121.248 447.437 121.28 447.501 121.344C447.576 121.419 447.613 121.509 447.613 121.616V122.176C447.613 122.272 447.576 122.357 447.501 122.432C447.437 122.507 447.352 122.544 447.245 122.544ZM451.88 120C451.773 120 451.683 119.968 451.608 119.904C451.544 119.829 451.512 119.739 451.512 119.632V110.672L448.856 112.72C448.771 112.784 448.68 112.811 448.584 112.8C448.488 112.789 448.408 112.741 448.344 112.656L447.928 112.128C447.864 112.032 447.837 111.936 447.848 111.84C447.869 111.744 447.923 111.664 448.008 111.6L451.496 108.912C451.571 108.859 451.64 108.827 451.704 108.816C451.768 108.805 451.837 108.8 451.912 108.8H452.728C452.835 108.8 452.92 108.837 452.984 108.912C453.059 108.976 453.096 109.061 453.096 109.168V119.632C453.096 119.739 453.059 119.829 452.984 119.904C452.92 119.968 452.835 120 452.728 120H451.88ZM457.396 120C457.3 120 457.22 119.968 457.156 119.904C457.102 119.829 457.076 119.744 457.076 119.648C457.076 119.595 457.081 119.552 457.092 119.52C457.113 119.488 457.129 119.461 457.14 119.44L459.588 116.032C459.321 116.096 459.033 116.128 458.724 116.128C458.137 116.117 457.604 116.011 457.124 115.808C456.654 115.605 456.254 115.333 455.924 114.992C455.593 114.64 455.342 114.245 455.172 113.808C455.001 113.371 454.916 112.912 454.916 112.432C454.916 111.963 454.996 111.504 455.156 111.056C455.326 110.608 455.577 110.203 455.908 109.84C456.249 109.477 456.67 109.189 457.172 108.976C457.684 108.752 458.276 108.64 458.948 108.64C459.62 108.64 460.206 108.747 460.708 108.96C461.22 109.163 461.646 109.445 461.988 109.808C462.34 110.16 462.596 110.56 462.756 111.008C462.926 111.456 463.012 111.92 463.012 112.4C463.012 112.837 462.948 113.237 462.82 113.6C462.692 113.963 462.537 114.288 462.356 114.576C462.185 114.864 462.02 115.131 461.86 115.376L458.772 119.68C458.729 119.733 458.67 119.803 458.596 119.888C458.521 119.963 458.409 120 458.26 120H457.396ZM458.948 114.832C459.396 114.832 459.806 114.736 460.18 114.544C460.564 114.341 460.868 114.064 461.092 113.712C461.316 113.349 461.428 112.917 461.428 112.416C461.428 111.915 461.316 111.488 461.092 111.136C460.868 110.773 460.564 110.496 460.18 110.304C459.806 110.101 459.396 110 458.948 110C458.51 110 458.105 110.101 457.732 110.304C457.358 110.496 457.06 110.773 456.836 111.136C456.612 111.488 456.5 111.915 456.5 112.416C456.5 112.917 456.612 113.349 456.836 113.712C457.06 114.064 457.358 114.341 457.732 114.544C458.105 114.736 458.51 114.832 458.948 114.832ZM465.536 120C465.312 120 465.2 119.893 465.2 119.68C465.2 119.616 465.221 119.557 465.264 119.504L473.168 109.104C473.243 109.008 473.312 108.933 473.376 108.88C473.451 108.827 473.557 108.8 473.696 108.8H474.224C474.448 108.8 474.56 108.907 474.56 109.12C474.56 109.184 474.539 109.243 474.496 109.296L466.608 119.696C466.533 119.792 466.459 119.867 466.384 119.92C466.32 119.973 466.213 120 466.064 120H465.536ZM472.864 120.096C472.171 120.096 471.621 119.899 471.216 119.504C470.821 119.109 470.603 118.592 470.56 117.952C470.549 117.675 470.544 117.44 470.544 117.248C470.544 117.045 470.549 116.795 470.56 116.496C470.603 115.856 470.811 115.339 471.184 114.944C471.568 114.539 472.128 114.336 472.864 114.336C473.611 114.336 474.171 114.539 474.544 114.944C474.928 115.339 475.141 115.856 475.184 116.496C475.205 116.795 475.216 117.045 475.216 117.248C475.216 117.44 475.205 117.675 475.184 117.952C475.141 118.592 474.917 119.109 474.512 119.504C474.117 119.899 473.568 120.096 472.864 120.096ZM472.864 119.04C473.152 119.04 473.376 118.981 473.536 118.864C473.696 118.747 473.813 118.603 473.888 118.432C473.963 118.251 474.005 118.069 474.016 117.888C474.037 117.6 474.048 117.371 474.048 117.2C474.048 117.029 474.037 116.816 474.016 116.56C474.005 116.272 473.915 116.005 473.744 115.76C473.573 115.515 473.28 115.392 472.864 115.392C472.459 115.392 472.171 115.515 472 115.76C471.84 116.005 471.749 116.272 471.728 116.56C471.717 116.816 471.712 117.029 471.712 117.2C471.712 117.371 471.717 117.6 471.728 117.888C471.749 118.069 471.792 118.251 471.856 118.432C471.931 118.603 472.048 118.747 472.208 118.864C472.379 118.981 472.597 119.04 472.864 119.04ZM466.88 114.416C466.176 114.416 465.627 114.229 465.232 113.856C464.837 113.483 464.619 112.976 464.576 112.336C464.565 112.059 464.56 111.824 464.56 111.632C464.56 111.429 464.565 111.179 464.576 110.88C464.608 110.24 464.816 109.723 465.2 109.328C465.584 108.923 466.144 108.72 466.88 108.72C467.627 108.72 468.187 108.923 468.56 109.328C468.944 109.723 469.152 110.24 469.184 110.88C469.205 111.179 469.216 111.429 469.216 111.632C469.216 111.824 469.205 112.059 469.184 112.336C469.152 112.976 468.933 113.483 468.528 113.856C468.133 114.229 467.584 114.416 466.88 114.416ZM466.88 113.424C467.157 113.424 467.376 113.365 467.536 113.248C467.707 113.131 467.829 112.987 467.904 112.816C467.979 112.635 468.021 112.453 468.032 112.272C468.053 111.984 468.064 111.76 468.064 111.6C468.064 111.429 468.053 111.211 468.032 110.944C468.021 110.656 467.925 110.389 467.744 110.144C467.573 109.899 467.285 109.776 466.88 109.776C466.475 109.776 466.187 109.899 466.016 110.144C465.856 110.389 465.765 110.656 465.744 110.944C465.733 111.211 465.728 111.429 465.728 111.6C465.728 111.76 465.733 111.984 465.744 112.272C465.765 112.453 465.808 112.635 465.872 112.816C465.947 112.987 466.064 113.131 466.224 113.248C466.384 113.365 466.603 113.424 466.88 113.424ZM476.716 122.544C476.62 122.544 476.535 122.507 476.46 122.432C476.385 122.357 476.348 122.272 476.348 122.176V121.616C476.348 121.509 476.38 121.419 476.444 121.344C476.519 121.28 476.599 121.248 476.684 121.248C477.132 121.237 477.505 121.12 477.804 120.896C478.113 120.672 478.359 120.32 478.54 119.84C478.721 119.36 478.855 118.731 478.94 117.952C479.025 117.163 479.068 116.197 479.068 115.056C479.068 113.915 479.025 112.955 478.94 112.176C478.855 111.387 478.721 110.752 478.54 110.272C478.359 109.792 478.113 109.445 477.804 109.232C477.505 109.008 477.132 108.891 476.684 108.88C476.599 108.88 476.519 108.843 476.444 108.768C476.38 108.693 476.348 108.608 476.348 108.512V107.952C476.348 107.856 476.385 107.771 476.46 107.696C476.535 107.621 476.62 107.584 476.716 107.584C477.409 107.584 477.996 107.728 478.476 108.016C478.956 108.304 479.34 108.752 479.628 109.36C479.927 109.957 480.14 110.731 480.268 111.68C480.396 112.629 480.46 113.755 480.46 115.056C480.46 116.357 480.396 117.483 480.268 118.432C480.14 119.371 479.927 120.144 479.628 120.752C479.34 121.36 478.956 121.808 478.476 122.096C477.996 122.395 477.409 122.544 476.716 122.544Z" fill="#9EA1B1"/>
<path d="M406.207 144C406.114 144 406.034 143.972 405.969 143.916C405.913 143.851 405.885 143.771 405.885 143.678V134.536C405.885 134.433 405.913 134.354 405.969 134.298C406.034 134.233 406.114 134.2 406.207 134.2H406.907C407.019 134.2 407.103 134.228 407.159 134.284C407.215 134.34 407.252 134.387 407.271 134.424L410.225 140.08L413.207 134.424C413.226 134.387 413.258 134.34 413.305 134.284C413.361 134.228 413.445 134.2 413.557 134.2H414.243C414.346 134.2 414.425 134.233 414.481 134.298C414.546 134.354 414.579 134.433 414.579 134.536V143.678C414.579 143.771 414.546 143.851 414.481 143.916C414.425 143.972 414.346 144 414.243 144H413.557C413.464 144 413.384 143.972 413.319 143.916C413.263 143.851 413.235 143.771 413.235 143.678V136.79L410.897 141.354C410.86 141.447 410.804 141.522 410.729 141.578C410.654 141.625 410.561 141.648 410.449 141.648H410.015C409.894 141.648 409.8 141.625 409.735 141.578C409.67 141.522 409.614 141.447 409.567 141.354L407.215 136.79V143.678C407.215 143.771 407.182 143.851 407.117 143.916C407.061 143.972 406.986 144 406.893 144H406.207ZM418.848 144.14C418.382 144.14 417.957 144.047 417.574 143.86C417.192 143.673 416.884 143.421 416.65 143.104C416.417 142.787 416.3 142.427 416.3 142.026C416.3 141.382 416.562 140.869 417.084 140.486C417.607 140.103 418.288 139.851 419.128 139.73L421.214 139.436V139.03C421.214 138.582 421.084 138.232 420.822 137.98C420.57 137.728 420.155 137.602 419.576 137.602C419.166 137.602 418.83 137.686 418.568 137.854C418.307 138.022 418.125 138.237 418.022 138.498C417.966 138.638 417.868 138.708 417.728 138.708H417.098C416.996 138.708 416.916 138.68 416.86 138.624C416.814 138.559 416.79 138.484 416.79 138.4C416.79 138.26 416.842 138.087 416.944 137.882C417.056 137.677 417.224 137.476 417.448 137.28C417.672 137.084 417.957 136.921 418.302 136.79C418.657 136.65 419.086 136.58 419.59 136.58C420.15 136.58 420.622 136.655 421.004 136.804C421.387 136.944 421.686 137.135 421.9 137.378C422.124 137.621 422.283 137.896 422.376 138.204C422.479 138.512 422.53 138.825 422.53 139.142V143.678C422.53 143.771 422.498 143.851 422.432 143.916C422.376 143.972 422.302 144 422.208 144H421.564C421.462 144 421.382 143.972 421.326 143.916C421.27 143.851 421.242 143.771 421.242 143.678V143.076C421.121 143.244 420.958 143.412 420.752 143.58C420.547 143.739 420.29 143.874 419.982 143.986C419.674 144.089 419.296 144.14 418.848 144.14ZM419.142 143.09C419.525 143.09 419.875 143.011 420.192 142.852C420.51 142.684 420.757 142.427 420.934 142.082C421.121 141.737 421.214 141.303 421.214 140.78V140.388L419.59 140.626C418.928 140.719 418.428 140.878 418.092 141.102C417.756 141.317 417.588 141.592 417.588 141.928C417.588 142.189 417.663 142.409 417.812 142.586C417.971 142.754 418.167 142.88 418.4 142.964C418.643 143.048 418.89 143.09 419.142 143.09ZM427.483 144.14C426.82 144.14 426.246 144.014 425.761 143.762C425.285 143.501 424.916 143.132 424.655 142.656C424.394 142.171 424.254 141.592 424.235 140.92C424.226 140.78 424.221 140.593 424.221 140.36C424.221 140.127 424.226 139.94 424.235 139.8C424.254 139.128 424.394 138.554 424.655 138.078C424.916 137.593 425.285 137.224 425.761 136.972C426.246 136.711 426.82 136.58 427.483 136.58C428.024 136.58 428.486 136.655 428.869 136.804C429.261 136.953 429.583 137.145 429.835 137.378C430.087 137.611 430.274 137.863 430.395 138.134C430.526 138.405 430.596 138.661 430.605 138.904C430.614 138.997 430.586 139.072 430.521 139.128C430.456 139.184 430.376 139.212 430.283 139.212H429.611C429.518 139.212 429.448 139.193 429.401 139.156C429.354 139.109 429.308 139.035 429.261 138.932C429.093 138.475 428.864 138.153 428.575 137.966C428.286 137.779 427.926 137.686 427.497 137.686C426.937 137.686 426.48 137.859 426.125 138.204C425.78 138.549 425.593 139.105 425.565 139.87C425.556 140.206 425.556 140.533 425.565 140.85C425.593 141.625 425.78 142.185 426.125 142.53C426.48 142.866 426.937 143.034 427.497 143.034C427.926 143.034 428.286 142.941 428.575 142.754C428.864 142.567 429.093 142.245 429.261 141.788C429.308 141.685 429.354 141.611 429.401 141.564C429.448 141.517 429.518 141.494 429.611 141.494H430.283C430.376 141.494 430.456 141.527 430.521 141.592C430.586 141.648 430.614 141.723 430.605 141.816C430.596 142.012 430.554 142.213 430.479 142.418C430.404 142.623 430.283 142.833 430.115 143.048C429.956 143.253 429.756 143.44 429.513 143.608C429.27 143.767 428.981 143.897 428.645 144C428.309 144.093 427.922 144.14 427.483 144.14ZM432.603 144C432.51 144 432.431 143.972 432.365 143.916C432.309 143.851 432.281 143.771 432.281 143.678V134.382C432.281 134.289 432.309 134.214 432.365 134.158C432.431 134.093 432.51 134.06 432.603 134.06H433.303C433.406 134.06 433.485 134.093 433.541 134.158C433.597 134.214 433.625 134.289 433.625 134.382V137.644C433.877 137.327 434.185 137.07 434.549 136.874C434.913 136.678 435.375 136.58 435.935 136.58C436.542 136.58 437.055 136.715 437.475 136.986C437.905 137.247 438.227 137.616 438.441 138.092C438.665 138.559 438.777 139.105 438.777 139.73V143.678C438.777 143.771 438.749 143.851 438.693 143.916C438.637 143.972 438.558 144 438.455 144H437.755C437.662 144 437.583 143.972 437.517 143.916C437.461 143.851 437.433 143.771 437.433 143.678V139.8C437.433 139.147 437.275 138.638 436.957 138.274C436.64 137.901 436.173 137.714 435.557 137.714C434.979 137.714 434.512 137.901 434.157 138.274C433.803 138.638 433.625 139.147 433.625 139.8V143.678C433.625 143.771 433.597 143.851 433.541 143.916C433.485 143.972 433.406 144 433.303 144H432.603ZM441.121 144C441.027 144 440.948 143.972 440.883 143.916C440.827 143.851 440.799 143.771 440.799 143.678V137.042C440.799 136.949 440.827 136.874 440.883 136.818C440.948 136.753 441.027 136.72 441.121 136.72H441.793C441.886 136.72 441.961 136.753 442.017 136.818C442.082 136.874 442.115 136.949 442.115 137.042V143.678C442.115 143.771 442.082 143.851 442.017 143.916C441.961 143.972 441.886 144 441.793 144H441.121ZM441.009 135.362C440.915 135.362 440.836 135.334 440.771 135.278C440.715 135.213 440.687 135.133 440.687 135.04V134.284C440.687 134.191 440.715 134.111 440.771 134.046C440.836 133.981 440.915 133.948 441.009 133.948H441.891C441.984 133.948 442.063 133.981 442.129 134.046C442.194 134.111 442.227 134.191 442.227 134.284V135.04C442.227 135.133 442.194 135.213 442.129 135.278C442.063 135.334 441.984 135.362 441.891 135.362H441.009ZM444.511 144C444.418 144 444.339 143.972 444.273 143.916C444.217 143.851 444.189 143.771 444.189 143.678V137.042C444.189 136.949 444.217 136.874 444.273 136.818C444.339 136.753 444.418 136.72 444.511 136.72H445.169C445.263 136.72 445.337 136.753 445.393 136.818C445.459 136.874 445.491 136.949 445.491 137.042V137.658C445.734 137.341 446.037 137.084 446.401 136.888C446.775 136.683 447.251 136.58 447.829 136.58C448.436 136.58 448.949 136.715 449.369 136.986C449.799 137.247 450.121 137.616 450.335 138.092C450.559 138.559 450.671 139.105 450.671 139.73V143.678C450.671 143.771 450.639 143.851 450.573 143.916C450.517 143.972 450.443 144 450.349 144H449.649C449.556 144 449.477 143.972 449.411 143.916C449.355 143.851 449.327 143.771 449.327 143.678V139.8C449.327 139.147 449.169 138.638 448.851 138.274C448.534 137.901 448.067 137.714 447.451 137.714C446.873 137.714 446.406 137.901 446.051 138.274C445.706 138.638 445.533 139.147 445.533 139.8V143.678C445.533 143.771 445.501 143.851 445.435 143.916C445.379 143.972 445.305 144 445.211 144H444.511ZM455.592 144.14C454.621 144.14 453.851 143.846 453.282 143.258C452.712 142.661 452.4 141.849 452.344 140.822C452.334 140.701 452.33 140.547 452.33 140.36C452.33 140.164 452.334 140.005 452.344 139.884C452.381 139.221 452.535 138.643 452.806 138.148C453.076 137.644 453.445 137.257 453.912 136.986C454.388 136.715 454.943 136.58 455.578 136.58C456.287 136.58 456.88 136.729 457.356 137.028C457.841 137.327 458.21 137.751 458.462 138.302C458.714 138.853 458.84 139.497 458.84 140.234V140.472C458.84 140.575 458.807 140.654 458.742 140.71C458.686 140.766 458.611 140.794 458.518 140.794H453.674C453.674 140.803 453.674 140.822 453.674 140.85C453.674 140.878 453.674 140.901 453.674 140.92C453.692 141.303 453.776 141.662 453.926 141.998C454.075 142.325 454.29 142.591 454.57 142.796C454.859 143.001 455.195 143.104 455.578 143.104C455.914 143.104 456.194 143.053 456.418 142.95C456.642 142.847 456.824 142.735 456.964 142.614C457.104 142.483 457.197 142.381 457.244 142.306C457.328 142.194 457.393 142.129 457.44 142.11C457.486 142.082 457.561 142.068 457.664 142.068H458.35C458.434 142.068 458.504 142.096 458.56 142.152C458.625 142.199 458.653 142.269 458.644 142.362C458.634 142.502 458.56 142.675 458.42 142.88C458.28 143.076 458.079 143.272 457.818 143.468C457.566 143.664 457.248 143.827 456.866 143.958C456.492 144.079 456.068 144.14 455.592 144.14ZM453.674 139.828H457.51V139.786C457.51 139.366 457.43 138.993 457.272 138.666C457.122 138.339 456.903 138.083 456.614 137.896C456.324 137.7 455.979 137.602 455.578 137.602C455.176 137.602 454.831 137.7 454.542 137.896C454.262 138.083 454.047 138.339 453.898 138.666C453.748 138.993 453.674 139.366 453.674 139.786V139.828ZM463.034 144.14C462.511 144.14 462.063 144.075 461.69 143.944C461.316 143.813 461.013 143.655 460.78 143.468C460.546 143.281 460.369 143.095 460.248 142.908C460.136 142.721 460.075 142.572 460.066 142.46C460.056 142.357 460.089 142.278 460.164 142.222C460.238 142.166 460.313 142.138 460.388 142.138H461.018C461.064 142.138 461.102 142.147 461.13 142.166C461.167 142.175 461.214 142.213 461.27 142.278C461.391 142.409 461.526 142.539 461.676 142.67C461.825 142.801 462.007 142.908 462.222 142.992C462.446 143.076 462.721 143.118 463.048 143.118C463.524 143.118 463.916 143.029 464.224 142.852C464.532 142.665 464.686 142.395 464.686 142.04C464.686 141.807 464.62 141.62 464.49 141.48C464.368 141.34 464.144 141.214 463.818 141.102C463.5 140.99 463.062 140.873 462.502 140.752C461.942 140.621 461.498 140.463 461.172 140.276C460.845 140.08 460.612 139.851 460.472 139.59C460.332 139.319 460.262 139.016 460.262 138.68C460.262 138.335 460.364 138.003 460.57 137.686C460.775 137.359 461.074 137.093 461.466 136.888C461.867 136.683 462.366 136.58 462.964 136.58C463.449 136.58 463.864 136.641 464.21 136.762C464.555 136.883 464.84 137.037 465.064 137.224C465.288 137.401 465.456 137.579 465.568 137.756C465.68 137.933 465.74 138.083 465.75 138.204C465.759 138.297 465.731 138.377 465.666 138.442C465.6 138.498 465.526 138.526 465.442 138.526H464.854C464.788 138.526 464.732 138.512 464.686 138.484C464.648 138.456 464.611 138.423 464.574 138.386C464.48 138.265 464.368 138.143 464.238 138.022C464.116 137.901 463.953 137.803 463.748 137.728C463.552 137.644 463.29 137.602 462.964 137.602C462.497 137.602 462.147 137.7 461.914 137.896C461.68 138.092 461.564 138.339 461.564 138.638C461.564 138.815 461.615 138.974 461.718 139.114C461.82 139.254 462.016 139.38 462.306 139.492C462.595 139.604 463.024 139.725 463.594 139.856C464.21 139.977 464.695 140.141 465.05 140.346C465.404 140.551 465.656 140.789 465.806 141.06C465.955 141.331 466.03 141.643 466.03 141.998C466.03 142.39 465.918 142.749 465.694 143.076C465.47 143.403 465.134 143.664 464.686 143.86C464.238 144.047 463.687 144.14 463.034 144.14Z" fill="#FFA4D2"/>
</svg>
`;
const $c49aa0f374b6c6e6$export$9a660bb013053fb1 = `<svg width="295" height="176" viewBox="0 0 295 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="293.5" height="175" rx="7.5" fill="white"/>
<rect x="0.5" y="0.5" width="293.5" height="175" rx="7.5" stroke="#6888B5"/>
<path d="M17.428 33C17.3347 33 17.2553 32.9673 17.19 32.902C17.1247 32.8367 17.092 32.7573 17.092 32.664V23.536C17.092 23.4427 17.1247 23.3633 17.19 23.298C17.2553 23.2327 17.3347 23.2 17.428 23.2H18.744C18.8467 23.2 18.926 23.2327 18.982 23.298C19.0473 23.3633 19.08 23.4427 19.08 23.536V32.664C19.08 32.7573 19.0473 32.8367 18.982 32.902C18.926 32.9673 18.8467 33 18.744 33H17.428ZM23.8096 33.14C23.3243 33.14 22.8949 33.0607 22.5216 32.902C22.1576 32.734 21.8543 32.5007 21.6116 32.202C21.3689 31.9033 21.1823 31.5533 21.0516 31.152C20.9209 30.7413 20.8463 30.2933 20.8276 29.808C20.8183 29.64 20.8136 29.4907 20.8136 29.36C20.8136 29.22 20.8183 29.066 20.8276 28.898C20.8463 28.4313 20.9163 27.9973 21.0376 27.596C21.1683 27.1947 21.3549 26.8447 21.5976 26.546C21.8496 26.238 22.1576 26 22.5216 25.832C22.8949 25.664 23.3243 25.58 23.8096 25.58C24.3136 25.58 24.7383 25.6687 25.0836 25.846C25.4383 26.014 25.7323 26.2333 25.9656 26.504V23.396C25.9656 23.3027 25.9936 23.2233 26.0496 23.158C26.1149 23.0927 26.1989 23.06 26.3016 23.06H27.4916C27.5849 23.06 27.6643 23.0927 27.7296 23.158C27.7949 23.2233 27.8276 23.3027 27.8276 23.396V32.664C27.8276 32.7573 27.7949 32.8367 27.7296 32.902C27.6643 32.9673 27.5849 33 27.4916 33H26.3856C26.2829 33 26.1989 32.9673 26.1336 32.902C26.0776 32.8367 26.0496 32.7573 26.0496 32.664V32.146C25.8163 32.4353 25.5176 32.6733 25.1536 32.86C24.7989 33.0467 24.3509 33.14 23.8096 33.14ZM24.3276 31.642C24.7196 31.642 25.0323 31.5533 25.2656 31.376C25.4989 31.1987 25.6716 30.9747 25.7836 30.704C25.8956 30.424 25.9563 30.1393 25.9656 29.85C25.9749 29.682 25.9796 29.5047 25.9796 29.318C25.9796 29.122 25.9749 28.94 25.9656 28.772C25.9563 28.492 25.8909 28.226 25.7696 27.974C25.6483 27.7127 25.4709 27.498 25.2376 27.33C25.0043 27.162 24.7009 27.078 24.3276 27.078C23.9356 27.078 23.6229 27.1667 23.3896 27.344C23.1656 27.512 23.0023 27.736 22.8996 28.016C22.7969 28.296 22.7363 28.604 22.7176 28.94C22.7083 29.22 22.7083 29.5 22.7176 29.78C22.7363 30.116 22.7969 30.424 22.8996 30.704C23.0023 30.984 23.1656 31.2127 23.3896 31.39C23.6229 31.558 23.9356 31.642 24.3276 31.642ZM32.8295 33.14C31.7935 33.14 30.9722 32.8413 30.3655 32.244C29.7589 31.6467 29.4322 30.7973 29.3855 29.696C29.3762 29.6027 29.3715 29.486 29.3715 29.346C29.3715 29.1967 29.3762 29.08 29.3855 28.996C29.4229 28.2867 29.5815 27.68 29.8615 27.176C30.1509 26.6627 30.5475 26.2707 31.0515 26C31.5555 25.72 32.1482 25.58 32.8295 25.58C33.5855 25.58 34.2202 25.7387 34.7335 26.056C35.2469 26.364 35.6342 26.798 35.8955 27.358C36.1569 27.9087 36.2875 28.548 36.2875 29.276V29.57C36.2875 29.6633 36.2549 29.7427 36.1895 29.808C36.1242 29.8733 36.0402 29.906 35.9375 29.906H31.2895C31.2895 29.906 31.2895 29.92 31.2895 29.948C31.2895 29.976 31.2895 29.9993 31.2895 30.018C31.2989 30.3447 31.3595 30.648 31.4715 30.928C31.5929 31.1987 31.7655 31.418 31.9895 31.586C32.2229 31.754 32.4982 31.838 32.8155 31.838C33.0769 31.838 33.2962 31.8007 33.4735 31.726C33.6509 31.642 33.7955 31.5487 33.9075 31.446C34.0195 31.3433 34.0989 31.2593 34.1455 31.194C34.2295 31.082 34.2949 31.0167 34.3415 30.998C34.3975 30.97 34.4769 30.956 34.5795 30.956H35.7835C35.8769 30.956 35.9515 30.984 36.0075 31.04C36.0729 31.096 36.1009 31.166 36.0915 31.25C36.0822 31.3993 36.0029 31.5813 35.8535 31.796C35.7135 32.0107 35.5082 32.2207 35.2375 32.426C34.9669 32.6313 34.6262 32.804 34.2155 32.944C33.8142 33.0747 33.3522 33.14 32.8295 33.14ZM31.2895 28.73H34.3835V28.688C34.3835 28.324 34.3229 28.0067 34.2015 27.736C34.0802 27.456 33.9029 27.2413 33.6695 27.092C33.4362 26.9333 33.1562 26.854 32.8295 26.854C32.5029 26.854 32.2229 26.9333 31.9895 27.092C31.7562 27.2413 31.5789 27.456 31.4575 27.736C31.3455 28.0067 31.2895 28.324 31.2895 28.688V28.73ZM38.1096 33C38.0163 33 37.9369 32.9673 37.8716 32.902C37.8063 32.8367 37.7736 32.7573 37.7736 32.664V26.056C37.7736 25.9627 37.8063 25.8833 37.8716 25.818C37.9369 25.7527 38.0163 25.72 38.1096 25.72H39.2576C39.3509 25.72 39.4303 25.7527 39.4956 25.818C39.5609 25.8833 39.5936 25.9627 39.5936 26.056V26.63C39.8363 26.3313 40.1443 26.084 40.5176 25.888C40.9003 25.6827 41.3716 25.58 41.9316 25.58C42.5009 25.58 42.9956 25.7107 43.4156 25.972C43.8356 26.224 44.1576 26.5833 44.3816 27.05C44.6149 27.5167 44.7316 28.0767 44.7316 28.73V32.664C44.7316 32.7573 44.6989 32.8367 44.6336 32.902C44.5683 32.9673 44.4889 33 44.3956 33H43.1636C43.0703 33 42.9909 32.9673 42.9256 32.902C42.8603 32.8367 42.8276 32.7573 42.8276 32.664V28.814C42.8276 28.2727 42.6923 27.848 42.4216 27.54C42.1603 27.232 41.7776 27.078 41.2736 27.078C40.7883 27.078 40.4009 27.232 40.1116 27.54C39.8223 27.848 39.6776 28.2727 39.6776 28.814V32.664C39.6776 32.7573 39.6449 32.8367 39.5796 32.902C39.5143 32.9673 39.4349 33 39.3416 33H38.1096ZM49.7179 33C49.1579 33 48.6866 32.902 48.3039 32.706C47.9212 32.51 47.6366 32.2207 47.4499 31.838C47.2632 31.446 47.1699 30.9607 47.1699 30.382V27.204H46.0639C45.9706 27.204 45.8912 27.1713 45.8259 27.106C45.7606 27.0407 45.7279 26.9567 45.7279 26.854V26.056C45.7279 25.9627 45.7606 25.8833 45.8259 25.818C45.8912 25.7527 45.9706 25.72 46.0639 25.72H47.1699V23.396C47.1699 23.3027 47.1979 23.2233 47.2539 23.158C47.3192 23.0927 47.4032 23.06 47.5059 23.06H48.6399C48.7332 23.06 48.8126 23.0927 48.8779 23.158C48.9432 23.2233 48.9759 23.3027 48.9759 23.396V25.72H50.7259C50.8192 25.72 50.8986 25.7527 50.9639 25.818C51.0292 25.8833 51.0619 25.9627 51.0619 26.056V26.854C51.0619 26.9567 51.0292 27.0407 50.9639 27.106C50.8986 27.1713 50.8192 27.204 50.7259 27.204H48.9759V30.242C48.9759 30.6247 49.0412 30.9233 49.1719 31.138C49.3119 31.3527 49.5499 31.46 49.8859 31.46H50.8519C50.9452 31.46 51.0246 31.4927 51.0899 31.558C51.1552 31.6233 51.1879 31.7027 51.1879 31.796V32.664C51.1879 32.7573 51.1552 32.8367 51.0899 32.902C51.0246 32.9673 50.9452 33 50.8519 33H49.7179ZM52.7659 33C52.6725 33 52.5932 32.9673 52.5279 32.902C52.4625 32.8367 52.4299 32.7573 52.4299 32.664V26.056C52.4299 25.9627 52.4625 25.8833 52.5279 25.818C52.5932 25.7527 52.6725 25.72 52.7659 25.72H53.9279C54.0305 25.72 54.1099 25.7527 54.1659 25.818C54.2312 25.8833 54.2639 25.9627 54.2639 26.056V32.664C54.2639 32.7573 54.2312 32.8367 54.1659 32.902C54.1099 32.9673 54.0305 33 53.9279 33H52.7659ZM52.7099 24.516C52.6165 24.516 52.5372 24.4833 52.4719 24.418C52.4065 24.3527 52.3739 24.2733 52.3739 24.18V23.172C52.3739 23.0787 52.4065 22.9993 52.4719 22.934C52.5372 22.8687 52.6165 22.836 52.7099 22.836H53.9839C54.0865 22.836 54.1705 22.8687 54.2359 22.934C54.3012 22.9993 54.3339 23.0787 54.3339 23.172V24.18C54.3339 24.2733 54.3012 24.3527 54.2359 24.418C54.1705 24.4833 54.0865 24.516 53.9839 24.516H52.7099ZM59.4113 33C58.8513 33 58.3799 32.902 57.9973 32.706C57.6146 32.51 57.3299 32.2207 57.1433 31.838C56.9566 31.446 56.8633 30.9607 56.8633 30.382V27.204H55.7573C55.6639 27.204 55.5846 27.1713 55.5193 27.106C55.4539 27.0407 55.4213 26.9567 55.4213 26.854V26.056C55.4213 25.9627 55.4539 25.8833 55.5193 25.818C55.5846 25.7527 55.6639 25.72 55.7573 25.72H56.8633V23.396C56.8633 23.3027 56.8913 23.2233 56.9473 23.158C57.0126 23.0927 57.0966 23.06 57.1993 23.06H58.3333C58.4266 23.06 58.5059 23.0927 58.5713 23.158C58.6366 23.2233 58.6693 23.3027 58.6693 23.396V25.72H60.4193C60.5126 25.72 60.5919 25.7527 60.6573 25.818C60.7226 25.8833 60.7553 25.9627 60.7553 26.056V26.854C60.7553 26.9567 60.7226 27.0407 60.6573 27.106C60.5919 27.1713 60.5126 27.204 60.4193 27.204H58.6693V30.242C58.6693 30.6247 58.7346 30.9233 58.8653 31.138C59.0053 31.3527 59.2433 31.46 59.5793 31.46H60.5453C60.6386 31.46 60.7179 31.4927 60.7833 31.558C60.8486 31.6233 60.8813 31.7027 60.8813 31.796V32.664C60.8813 32.7573 60.8486 32.8367 60.7833 32.902C60.7179 32.9673 60.6386 33 60.5453 33H59.4113ZM63.4392 35.66C63.3646 35.66 63.2992 35.632 63.2432 35.576C63.1872 35.52 63.1592 35.4547 63.1592 35.38C63.1592 35.3427 63.1592 35.3053 63.1592 35.268C63.1686 35.24 63.1872 35.2027 63.2152 35.156L64.3072 32.566L61.6192 26.224C61.5819 26.1307 61.5632 26.0653 61.5632 26.028C61.5726 25.944 61.6052 25.874 61.6612 25.818C61.7172 25.7527 61.7872 25.72 61.8712 25.72H63.0052C63.1172 25.72 63.2012 25.748 63.2572 25.804C63.3132 25.86 63.3552 25.9207 63.3832 25.986L65.2452 30.564L67.1632 25.986C67.1912 25.9113 67.2332 25.8507 67.2892 25.804C67.3452 25.748 67.4292 25.72 67.5412 25.72H68.6612C68.7359 25.72 68.8012 25.748 68.8572 25.804C68.9226 25.86 68.9552 25.9253 68.9552 26C68.9552 26.056 68.9366 26.1307 68.8992 26.224L64.9372 35.394C64.8999 35.4687 64.8532 35.5293 64.7972 35.576C64.7412 35.632 64.6572 35.66 64.5452 35.66H63.4392ZM76.5624 33.14C75.6944 33.14 74.9664 33.014 74.3784 32.762C73.7997 32.5007 73.3564 32.1647 73.0484 31.754C72.7497 31.334 72.591 30.8953 72.5724 30.438C72.5724 30.354 72.6004 30.284 72.6564 30.228C72.7124 30.172 72.7824 30.144 72.8664 30.144H74.1124C74.2337 30.144 74.3224 30.172 74.3784 30.228C74.4437 30.2747 74.4997 30.3353 74.5464 30.41C74.6024 30.5873 74.7097 30.7647 74.8684 30.942C75.027 31.11 75.2417 31.25 75.5124 31.362C75.7924 31.474 76.1424 31.53 76.5624 31.53C77.2344 31.53 77.7337 31.418 78.0604 31.194C78.3964 30.97 78.5644 30.6667 78.5644 30.284C78.5644 30.0133 78.4757 29.7987 78.2984 29.64C78.121 29.472 77.8457 29.3227 77.4724 29.192C77.1084 29.052 76.623 28.9073 76.0164 28.758C75.3164 28.59 74.7284 28.3893 74.2524 28.156C73.7857 27.9133 73.431 27.61 73.1884 27.246C72.955 26.882 72.8384 26.42 72.8384 25.86C72.8384 25.3187 72.983 24.838 73.2724 24.418C73.571 23.998 73.991 23.6667 74.5324 23.424C75.083 23.1813 75.7364 23.06 76.4924 23.06C77.099 23.06 77.6357 23.144 78.1024 23.312C78.569 23.4707 78.9564 23.6853 79.2644 23.956C79.5724 24.2173 79.8057 24.502 79.9644 24.81C80.1324 25.1087 80.221 25.4027 80.2304 25.692C80.2304 25.7667 80.2024 25.8367 80.1464 25.902C80.0997 25.958 80.0297 25.986 79.9364 25.986H78.6344C78.5597 25.986 78.485 25.9673 78.4104 25.93C78.3357 25.8927 78.275 25.8227 78.2284 25.72C78.1724 25.4307 77.9904 25.1833 77.6824 24.978C77.3744 24.7727 76.9777 24.67 76.4924 24.67C75.9884 24.67 75.5824 24.7633 75.2744 24.95C74.9664 25.1367 74.8124 25.426 74.8124 25.818C74.8124 26.0793 74.887 26.2987 75.0364 26.476C75.195 26.644 75.4424 26.7933 75.7784 26.924C76.1237 27.0547 76.5764 27.1947 77.1364 27.344C77.9297 27.5213 78.5784 27.7267 79.0824 27.96C79.5864 28.1933 79.955 28.492 80.1884 28.856C80.4217 29.2107 80.5384 29.6633 80.5384 30.214C80.5384 30.83 80.3704 31.3573 80.0344 31.796C79.7077 32.2253 79.2457 32.5567 78.6484 32.79C78.051 33.0233 77.3557 33.14 76.5624 33.14ZM85.1948 33.14C84.4481 33.14 83.8181 33.0093 83.3048 32.748C82.8008 32.4867 82.4134 32.118 82.1428 31.642C81.8814 31.166 81.7321 30.6107 81.6948 29.976C81.6854 29.808 81.6808 29.6027 81.6808 29.36C81.6808 29.1173 81.6854 28.912 81.6948 28.744C81.7321 28.1 81.8861 27.5447 82.1568 27.078C82.4368 26.602 82.8288 26.2333 83.3328 25.972C83.8461 25.7107 84.4668 25.58 85.1948 25.58C85.9228 25.58 86.5388 25.7107 87.0428 25.972C87.5561 26.2333 87.9481 26.602 88.2188 27.078C88.4988 27.5447 88.6574 28.1 88.6948 28.744C88.7041 28.912 88.7088 29.1173 88.7088 29.36C88.7088 29.6027 88.7041 29.808 88.6948 29.976C88.6574 30.6107 88.5034 31.166 88.2328 31.642C87.9714 32.118 87.5841 32.4867 87.0708 32.748C86.5668 33.0093 85.9414 33.14 85.1948 33.14ZM85.1948 31.754C85.6894 31.754 86.0721 31.6 86.3428 31.292C86.6134 30.9747 86.7628 30.5127 86.7908 29.906C86.8001 29.766 86.8048 29.584 86.8048 29.36C86.8048 29.136 86.8001 28.954 86.7908 28.814C86.7628 28.2073 86.6134 27.75 86.3428 27.442C86.0721 27.1247 85.6894 26.966 85.1948 26.966C84.7001 26.966 84.3174 27.1247 84.0468 27.442C83.7761 27.75 83.6268 28.2073 83.5988 28.814C83.5894 28.954 83.5848 29.136 83.5848 29.36C83.5848 29.584 83.5894 29.766 83.5988 29.906C83.6268 30.5127 83.7761 30.9747 84.0468 31.292C84.3174 31.6 84.7001 31.754 85.1948 31.754ZM92.9619 33.14C92.3926 33.14 91.8979 33.014 91.4779 32.762C91.0673 32.5007 90.7499 32.1367 90.5259 31.67C90.3019 31.194 90.1899 30.634 90.1899 29.99V26.056C90.1899 25.9627 90.2226 25.8833 90.2879 25.818C90.3533 25.7527 90.4326 25.72 90.5259 25.72H91.7579C91.8606 25.72 91.9399 25.7527 91.9959 25.818C92.0613 25.8833 92.0939 25.9627 92.0939 26.056V29.906C92.0939 31.0633 92.6026 31.642 93.6199 31.642C94.1053 31.642 94.4879 31.488 94.7679 31.18C95.0573 30.872 95.2019 30.4473 95.2019 29.906V26.056C95.2019 25.9627 95.2346 25.8833 95.2999 25.818C95.3653 25.7527 95.4446 25.72 95.5379 25.72H96.7699C96.8633 25.72 96.9426 25.7527 97.0079 25.818C97.0733 25.8833 97.1059 25.9627 97.1059 26.056V32.664C97.1059 32.7573 97.0733 32.8367 97.0079 32.902C96.9426 32.9673 96.8633 33 96.7699 33H95.6359C95.5333 33 95.4493 32.9673 95.3839 32.902C95.3279 32.8367 95.2999 32.7573 95.2999 32.664V32.09C95.0479 32.4167 94.7353 32.6733 94.3619 32.86C93.9886 33.0467 93.5219 33.14 92.9619 33.14ZM99.2913 33C99.1979 33 99.1186 32.9673 99.0533 32.902C98.9879 32.8367 98.9552 32.7573 98.9552 32.664V26.07C98.9552 25.9673 98.9879 25.8833 99.0533 25.818C99.1186 25.7527 99.1979 25.72 99.2913 25.72H100.425C100.519 25.72 100.598 25.7527 100.663 25.818C100.738 25.8833 100.775 25.9673 100.775 26.07V26.644C100.99 26.3453 101.265 26.1167 101.601 25.958C101.947 25.7993 102.343 25.72 102.791 25.72H103.365C103.468 25.72 103.547 25.7527 103.603 25.818C103.669 25.8833 103.701 25.9627 103.701 26.056V27.064C103.701 27.1573 103.669 27.2367 103.603 27.302C103.547 27.3673 103.468 27.4 103.365 27.4H102.273C101.825 27.4 101.475 27.526 101.223 27.778C100.981 28.0207 100.859 28.366 100.859 28.814V32.664C100.859 32.7573 100.827 32.8367 100.761 32.902C100.696 32.9673 100.612 33 100.509 33H99.2913ZM107.847 33.14C107.175 33.14 106.583 33.014 106.069 32.762C105.565 32.51 105.169 32.146 104.879 31.67C104.599 31.1847 104.445 30.6013 104.417 29.92C104.408 29.78 104.403 29.598 104.403 29.374C104.403 29.1407 104.408 28.9493 104.417 28.8C104.445 28.1187 104.599 27.54 104.879 27.064C105.169 26.5787 105.565 26.21 106.069 25.958C106.583 25.706 107.175 25.58 107.847 25.58C108.445 25.58 108.953 25.664 109.373 25.832C109.793 25.9907 110.139 26.2007 110.409 26.462C110.68 26.714 110.881 26.98 111.011 27.26C111.151 27.5307 111.226 27.778 111.235 28.002C111.245 28.1047 111.212 28.1887 111.137 28.254C111.072 28.31 110.993 28.338 110.899 28.338H109.667C109.574 28.338 109.499 28.3147 109.443 28.268C109.397 28.2213 109.35 28.1513 109.303 28.058C109.163 27.6847 108.977 27.4233 108.743 27.274C108.519 27.1153 108.23 27.036 107.875 27.036C107.409 27.036 107.035 27.1853 106.755 27.484C106.485 27.7733 106.34 28.2353 106.321 28.87C106.303 29.2247 106.303 29.5513 106.321 29.85C106.34 30.494 106.485 30.9607 106.755 31.25C107.035 31.5393 107.409 31.684 107.875 31.684C108.239 31.684 108.533 31.6093 108.757 31.46C108.981 31.3013 109.163 31.0353 109.303 30.662C109.35 30.5687 109.397 30.4987 109.443 30.452C109.499 30.4053 109.574 30.382 109.667 30.382H110.899C110.993 30.382 111.072 30.4147 111.137 30.48C111.212 30.536 111.245 30.6153 111.235 30.718C111.226 30.886 111.179 31.0773 111.095 31.292C111.021 31.4973 110.895 31.712 110.717 31.936C110.549 32.1507 110.335 32.3513 110.073 32.538C109.812 32.7153 109.495 32.86 109.121 32.972C108.757 33.084 108.333 33.14 107.847 33.14ZM115.831 33.14C114.795 33.14 113.974 32.8413 113.367 32.244C112.761 31.6467 112.434 30.7973 112.387 29.696C112.378 29.6027 112.373 29.486 112.373 29.346C112.373 29.1967 112.378 29.08 112.387 28.996C112.425 28.2867 112.583 27.68 112.863 27.176C113.153 26.6627 113.549 26.2707 114.053 26C114.557 25.72 115.15 25.58 115.831 25.58C116.587 25.58 117.222 25.7387 117.735 26.056C118.249 26.364 118.636 26.798 118.897 27.358C119.159 27.9087 119.289 28.548 119.289 29.276V29.57C119.289 29.6633 119.257 29.7427 119.191 29.808C119.126 29.8733 119.042 29.906 118.939 29.906H114.291C114.291 29.906 114.291 29.92 114.291 29.948C114.291 29.976 114.291 29.9993 114.291 30.018C114.301 30.3447 114.361 30.648 114.473 30.928C114.595 31.1987 114.767 31.418 114.991 31.586C115.225 31.754 115.5 31.838 115.817 31.838C116.079 31.838 116.298 31.8007 116.475 31.726C116.653 31.642 116.797 31.5487 116.909 31.446C117.021 31.3433 117.101 31.2593 117.147 31.194C117.231 31.082 117.297 31.0167 117.343 30.998C117.399 30.97 117.479 30.956 117.581 30.956H118.785C118.879 30.956 118.953 30.984 119.009 31.04C119.075 31.096 119.103 31.166 119.093 31.25C119.084 31.3993 119.005 31.5813 118.855 31.796C118.715 32.0107 118.51 32.2207 118.239 32.426C117.969 32.6313 117.628 32.804 117.217 32.944C116.816 33.0747 116.354 33.14 115.831 33.14ZM114.291 28.73H117.385V28.688C117.385 28.324 117.325 28.0067 117.203 27.736C117.082 27.456 116.905 27.2413 116.671 27.092C116.438 26.9333 116.158 26.854 115.831 26.854C115.505 26.854 115.225 26.9333 114.991 27.092C114.758 27.2413 114.581 27.456 114.459 27.736C114.347 28.0067 114.291 28.324 114.291 28.688V28.73ZM123.534 33.14C122.974 33.14 122.493 33.0747 122.092 32.944C121.7 32.8133 121.378 32.65 121.126 32.454C120.874 32.258 120.687 32.062 120.566 31.866C120.444 31.67 120.379 31.5067 120.37 31.376C120.36 31.2733 120.388 31.194 120.454 31.138C120.528 31.0727 120.608 31.04 120.692 31.04H121.798C121.835 31.04 121.868 31.0447 121.896 31.054C121.924 31.0633 121.961 31.0913 122.008 31.138C122.129 31.2407 122.255 31.348 122.386 31.46C122.526 31.572 122.689 31.67 122.876 31.754C123.062 31.8287 123.296 31.866 123.576 31.866C123.94 31.866 124.243 31.796 124.486 31.656C124.738 31.5067 124.864 31.2967 124.864 31.026C124.864 30.83 124.808 30.6713 124.696 30.55C124.593 30.4287 124.397 30.3213 124.108 30.228C123.818 30.1253 123.408 30.018 122.876 29.906C122.353 29.7847 121.919 29.6307 121.574 29.444C121.228 29.2573 120.972 29.024 120.804 28.744C120.636 28.464 120.552 28.1373 120.552 27.764C120.552 27.4 120.659 27.0547 120.874 26.728C121.098 26.392 121.424 26.1167 121.854 25.902C122.292 25.6873 122.834 25.58 123.478 25.58C123.982 25.58 124.42 25.6453 124.794 25.776C125.167 25.8973 125.475 26.0513 125.718 26.238C125.97 26.4247 126.161 26.616 126.292 26.812C126.422 26.9987 126.492 27.162 126.502 27.302C126.511 27.4047 126.483 27.4887 126.418 27.554C126.352 27.61 126.278 27.638 126.194 27.638H125.158C125.111 27.638 125.069 27.6287 125.032 27.61C124.994 27.5913 124.957 27.568 124.92 27.54C124.817 27.4467 124.705 27.3487 124.584 27.246C124.462 27.134 124.313 27.0407 124.136 26.966C123.968 26.8913 123.744 26.854 123.464 26.854C123.109 26.854 122.838 26.9333 122.652 27.092C122.465 27.2413 122.372 27.4327 122.372 27.666C122.372 27.8247 122.414 27.9647 122.498 28.086C122.591 28.198 122.773 28.3053 123.044 28.408C123.314 28.5107 123.725 28.618 124.276 28.73C124.901 28.842 125.396 29.01 125.76 29.234C126.133 29.4487 126.394 29.7007 126.544 29.99C126.702 30.27 126.782 30.5827 126.782 30.928C126.782 31.348 126.656 31.726 126.404 32.062C126.161 32.398 125.797 32.664 125.312 32.86C124.836 33.0467 124.243 33.14 123.534 33.14Z" fill="#00245B"/>
<rect x="15" y="56.3333" width="22" height="22" rx="11" stroke="#0294F7" stroke-width="2"/>
<path d="M36 67.3333C36 72.8561 31.5228 77.3333 26 77.3333C20.4772 77.3333 16 72.8561 16 67.3333C16 61.8104 20.4772 57.3333 26 57.3333C31.5228 57.3333 36 61.8104 36 67.3333Z" fill="#005CB9"/>
<path d="M30.7471 64.7239C30.3878 63.776 29.7486 62.96 28.9144 62.3841C28.0803 61.8082 27.0906 61.4998 26.077 61.4998C25.0633 61.4998 24.0737 61.8082 23.2395 62.3841C22.4054 62.96 21.7662 63.776 21.4069 64.7239C21.3708 64.8052 21.3559 64.8943 21.3637 64.9829C21.3714 65.0715 21.4014 65.1567 21.451 65.2305C21.519 65.3207 21.6096 65.3914 21.7136 65.4354C21.8176 65.4794 21.9313 65.4953 22.0434 65.4813C22.1555 65.4674 22.2619 65.4242 22.3519 65.356C22.442 65.2878 22.5124 65.1971 22.5563 65.093C22.8321 64.3835 23.3158 63.7739 23.9441 63.344C24.5724 62.9142 25.3158 62.6842 26.0771 62.6842C26.8383 62.6842 27.5818 62.9142 28.2101 63.344C28.8384 63.7739 29.3221 64.3835 29.5979 65.093C29.6418 65.1969 29.7123 65.2874 29.8022 65.3554C29.8922 65.4234 29.9984 65.4665 30.1103 65.4805C30.2222 65.4944 30.3358 65.4786 30.4397 65.4348C30.5435 65.3909 30.634 65.3205 30.7021 65.2305C30.7519 65.1568 30.7821 65.0716 30.7899 64.983C30.7977 64.8943 30.7828 64.8052 30.7467 64.7239" fill="#F37D02"/>
<path d="M29.2194 72.9228C29.1979 72.9994 29.15 73.0659 29.0842 73.1105C29.0183 73.1551 28.9389 73.175 28.8598 73.1666H27.7179C27.5304 73.1666 27.4367 73.1124 27.3908 72.9228L26.3112 68.783C26.2108 68.3224 26.1373 67.8564 26.0912 67.3872C26.0561 67.8576 25.9833 68.3243 25.8735 68.783L24.7954 72.9226C24.7763 73.0002 24.7292 73.0681 24.6631 73.1131C24.5971 73.1581 24.5167 73.1772 24.4375 73.1666H23.2787C23.0912 73.1666 22.9969 73.1124 22.9502 72.9228L21.3723 66.9699C21.3586 66.9314 21.3547 66.8901 21.361 66.8497C21.3674 66.8093 21.3837 66.7712 21.4086 66.7387C21.4334 66.7063 21.466 66.6806 21.5033 66.6639C21.5406 66.6473 21.5815 66.6403 21.6223 66.6435H22.3571C22.3986 66.6369 22.4411 66.6388 22.4819 66.649C22.5227 66.6592 22.561 66.6776 22.5945 66.703C22.6281 66.7283 22.6561 66.7602 22.6771 66.7967C22.698 66.8332 22.7113 66.8736 22.7162 66.9153L23.7173 71.1653C23.8083 71.6436 23.8709 72.1269 23.9048 72.6126C23.9831 72.1666 24.0452 71.6391 24.1694 71.1787L25.2804 66.9028C25.3017 66.822 25.3513 66.7515 25.4201 66.7041C25.4888 66.6566 25.5723 66.6353 25.6554 66.6441H26.5625C26.6489 66.6377 26.7349 66.6613 26.8061 66.7108C26.8772 66.7603 26.9292 66.8327 26.9533 66.916L28.0783 71.1787C28.192 71.6509 28.2755 72.1298 28.3283 72.6126C28.3908 72.1666 28.4533 71.6391 28.5479 71.1787L29.4696 66.9028C29.4888 66.8208 29.5378 66.7489 29.6071 66.7011C29.6765 66.6532 29.7611 66.6329 29.8446 66.6441H30.5321C30.5719 66.639 30.6124 66.6442 30.6497 66.6593C30.687 66.6744 30.7197 66.6988 30.7448 66.7302C30.7699 66.7615 30.7865 66.7988 30.7931 66.8385C30.7996 66.8781 30.7958 66.9188 30.7821 66.9566L29.2196 72.9233" fill="white"/>
<path d="M46.87 66.3333C46.7487 66.3333 46.6507 66.3006 46.576 66.2353C46.5107 66.1699 46.464 66.0766 46.436 65.9553L44.63 56.9673C44.6207 56.9299 44.616 56.8973 44.616 56.8693C44.616 56.8413 44.616 56.8226 44.616 56.8133C44.616 56.7386 44.644 56.6733 44.7 56.6173C44.756 56.5613 44.8213 56.5333 44.896 56.5333H45.624C45.82 56.5333 45.932 56.6126 45.96 56.7713L47.388 63.9953L48.9 59.0393C48.928 58.9553 48.9747 58.8806 49.04 58.8153C49.1147 58.7406 49.2173 58.7033 49.348 58.7033H49.866C50.006 58.7033 50.1087 58.7406 50.174 58.8153C50.2393 58.8806 50.2813 58.9553 50.3 59.0393L51.826 63.9953L53.24 56.7713C53.268 56.6126 53.3847 56.5333 53.59 56.5333H54.318C54.3927 56.5333 54.458 56.5613 54.514 56.6173C54.57 56.6733 54.598 56.7386 54.598 56.8133C54.598 56.8226 54.5933 56.8413 54.584 56.8693C54.584 56.8973 54.584 56.9299 54.584 56.9673L52.778 65.9553C52.75 66.0766 52.6987 66.1699 52.624 66.2353C52.5587 66.3006 52.4653 66.3333 52.344 66.3333H51.798C51.6673 66.3333 51.5647 66.3006 51.49 66.2353C51.4153 66.1699 51.364 66.0859 51.336 65.9833L49.6 60.6493L47.878 65.9833C47.8407 66.0859 47.7847 66.1699 47.71 66.2353C47.6447 66.3006 47.5467 66.3333 47.416 66.3333H46.87ZM58.9282 66.4733C58.2188 66.4733 57.6262 66.3379 57.1502 66.0673C56.6742 65.7966 56.3102 65.4233 56.0582 64.9473C55.8062 64.4619 55.6662 63.9113 55.6382 63.2953C55.6288 63.1366 55.6242 62.9359 55.6242 62.6933C55.6242 62.4413 55.6288 62.2406 55.6382 62.0913C55.6662 61.4659 55.8062 60.9153 56.0582 60.4393C56.3195 59.9633 56.6882 59.5899 57.1642 59.3193C57.6402 59.0486 58.2282 58.9133 58.9282 58.9133C59.6282 58.9133 60.2162 59.0486 60.6922 59.3193C61.1682 59.5899 61.5322 59.9633 61.7842 60.4393C62.0455 60.9153 62.1902 61.4659 62.2182 62.0913C62.2275 62.2406 62.2322 62.4413 62.2322 62.6933C62.2322 62.9359 62.2275 63.1366 62.2182 63.2953C62.1902 63.9113 62.0502 64.4619 61.7982 64.9473C61.5462 65.4233 61.1822 65.7966 60.7062 66.0673C60.2302 66.3379 59.6375 66.4733 58.9282 66.4733ZM58.9282 65.3953C59.5068 65.3953 59.9688 65.2133 60.3142 64.8493C60.6595 64.4759 60.8462 63.9346 60.8742 63.2253C60.8835 63.0853 60.8882 62.9079 60.8882 62.6933C60.8882 62.4786 60.8835 62.3013 60.8742 62.1613C60.8462 61.4519 60.6595 60.9153 60.3142 60.5513C59.9688 60.1779 59.5068 59.9913 58.9282 59.9913C58.3495 59.9913 57.8828 60.1779 57.5282 60.5513C57.1828 60.9153 57.0008 61.4519 56.9822 62.1613C56.9728 62.3013 56.9682 62.4786 56.9682 62.6933C56.9682 62.9079 56.9728 63.0853 56.9822 63.2253C57.0008 63.9346 57.1828 64.4759 57.5282 64.8493C57.8828 65.2133 58.3495 65.3953 58.9282 65.3953ZM64.3072 66.3333C64.2139 66.3333 64.1346 66.3053 64.0692 66.2493C64.0132 66.1839 63.9852 66.1046 63.9852 66.0113V59.3893C63.9852 59.2959 64.0132 59.2166 64.0692 59.1513C64.1346 59.0859 64.2139 59.0533 64.3072 59.0533H64.9512C65.0446 59.0533 65.1239 59.0859 65.1892 59.1513C65.2546 59.2166 65.2872 59.2959 65.2872 59.3893V60.0053C65.4739 59.6879 65.7306 59.4499 66.0572 59.2913C66.3839 59.1326 66.7806 59.0533 67.2472 59.0533H67.7932C67.8866 59.0533 67.9612 59.0859 68.0172 59.1513C68.0826 59.2073 68.1152 59.2819 68.1152 59.3753V59.9493C68.1152 60.0426 68.0826 60.1173 68.0172 60.1733C67.9612 60.2293 67.8866 60.2573 67.7932 60.2573H66.9532C66.4492 60.2573 66.0526 60.4066 65.7632 60.7053C65.4739 60.9946 65.3292 61.3913 65.3292 61.8953V66.0113C65.3292 66.1046 65.2966 66.1839 65.2312 66.2493C65.1659 66.3053 65.0866 66.3333 64.9932 66.3333H64.3072ZM69.6396 66.3333C69.5462 66.3333 69.4669 66.3053 69.4016 66.2493C69.3456 66.1839 69.3176 66.1046 69.3176 66.0113V56.7153C69.3176 56.6219 69.3456 56.5473 69.4016 56.4913C69.4669 56.4259 69.5462 56.3933 69.6396 56.3933H70.2976C70.3909 56.3933 70.4656 56.4259 70.5216 56.4913C70.5869 56.5473 70.6196 56.6219 70.6196 56.7153V61.5873L73.3776 59.2913C73.4896 59.1979 73.5736 59.1373 73.6296 59.1093C73.6949 59.0719 73.7976 59.0533 73.9376 59.0533H74.6796C74.7636 59.0533 74.8336 59.0813 74.8896 59.1373C74.9456 59.1933 74.9736 59.2633 74.9736 59.3473C74.9736 59.3846 74.9596 59.4266 74.9316 59.4733C74.9129 59.5199 74.8709 59.5666 74.8056 59.6133L71.5716 62.3013L75.1556 65.7873C75.2676 65.8806 75.3236 65.9646 75.3236 66.0393C75.3236 66.1233 75.2956 66.1933 75.2396 66.2493C75.1836 66.3053 75.1136 66.3333 75.0296 66.3333H74.3016C74.1616 66.3333 74.0589 66.3193 73.9936 66.2913C73.9282 66.2539 73.8442 66.1886 73.7416 66.0953L70.6196 63.1133V66.0113C70.6196 66.1046 70.5869 66.1839 70.5216 66.2493C70.4656 66.3053 70.3909 66.3333 70.2976 66.3333H69.6396ZM78.8405 66.4733C78.3272 66.4733 77.8839 66.3846 77.5105 66.2073C77.1372 66.0206 76.8292 65.7733 76.5865 65.4653C76.3532 65.1479 76.1759 64.7886 76.0545 64.3873C75.9425 63.9859 75.8772 63.5613 75.8585 63.1133C75.8492 62.9639 75.8445 62.8239 75.8445 62.6933C75.8445 62.5626 75.8492 62.4226 75.8585 62.2733C75.8772 61.8346 75.9425 61.4146 76.0545 61.0133C76.1759 60.6119 76.3532 60.2526 76.5865 59.9353C76.8292 59.6179 77.1372 59.3706 77.5105 59.1933C77.8839 59.0066 78.3272 58.9133 78.8405 58.9133C79.3912 58.9133 79.8485 59.0113 80.2125 59.2073C80.5765 59.4033 80.8752 59.6459 81.1085 59.9353V56.7153C81.1085 56.6219 81.1365 56.5473 81.1925 56.4913C81.2579 56.4259 81.3372 56.3933 81.4305 56.3933H82.1025C82.1959 56.3933 82.2705 56.4259 82.3265 56.4913C82.3919 56.5473 82.4245 56.6219 82.4245 56.7153V66.0113C82.4245 66.1046 82.3919 66.1839 82.3265 66.2493C82.2705 66.3053 82.1959 66.3333 82.1025 66.3333H81.4725C81.3699 66.3333 81.2905 66.3053 81.2345 66.2493C81.1785 66.1839 81.1505 66.1046 81.1505 66.0113V65.4233C80.9172 65.7219 80.6139 65.9739 80.2405 66.1793C79.8672 66.3753 79.4005 66.4733 78.8405 66.4733ZM79.1345 65.3393C79.6012 65.3393 79.9745 65.2319 80.2545 65.0173C80.5345 64.8026 80.7445 64.5319 80.8845 64.2053C81.0245 63.8693 81.0992 63.5286 81.1085 63.1833C81.1179 63.0339 81.1225 62.8566 81.1225 62.6513C81.1225 62.4366 81.1179 62.2546 81.1085 62.1053C81.0992 61.7786 81.0199 61.4566 80.8705 61.1393C80.7305 60.8219 80.5159 60.5606 80.2265 60.3553C79.9465 60.1499 79.5825 60.0473 79.1345 60.0473C78.6585 60.0473 78.2805 60.1546 78.0005 60.3693C77.7205 60.5746 77.5199 60.8499 77.3985 61.1953C77.2772 61.5313 77.2072 61.8953 77.1885 62.2873C77.1792 62.5579 77.1792 62.8286 77.1885 63.0993C77.2072 63.4913 77.2772 63.8599 77.3985 64.2053C77.5199 64.5413 77.7205 64.8166 78.0005 65.0313C78.2805 65.2366 78.6585 65.3393 79.1345 65.3393ZM86.5367 66.4733C86.07 66.4733 85.6454 66.3799 85.2627 66.1933C84.88 66.0066 84.572 65.7546 84.3387 65.4373C84.1054 65.1199 83.9887 64.7606 83.9887 64.3593C83.9887 63.7153 84.25 63.2019 84.7727 62.8193C85.2954 62.4366 85.9767 62.1846 86.8167 62.0633L88.9027 61.7693V61.3633C88.9027 60.9153 88.772 60.5653 88.5107 60.3133C88.2587 60.0613 87.8434 59.9353 87.2647 59.9353C86.854 59.9353 86.518 60.0193 86.2567 60.1873C85.9954 60.3553 85.8134 60.5699 85.7107 60.8313C85.6547 60.9713 85.5567 61.0413 85.4167 61.0413H84.7867C84.684 61.0413 84.6047 61.0133 84.5487 60.9573C84.502 60.8919 84.4787 60.8173 84.4787 60.7333C84.4787 60.5933 84.53 60.4206 84.6327 60.2153C84.7447 60.0099 84.9127 59.8093 85.1367 59.6133C85.3607 59.4173 85.6454 59.2539 85.9907 59.1233C86.3454 58.9833 86.7747 58.9133 87.2787 58.9133C87.8387 58.9133 88.31 58.9879 88.6927 59.1373C89.0754 59.2773 89.374 59.4686 89.5887 59.7113C89.8127 59.9539 89.9714 60.2293 90.0647 60.5373C90.1674 60.8453 90.2187 61.1579 90.2187 61.4753V66.0113C90.2187 66.1046 90.186 66.1839 90.1207 66.2493C90.0647 66.3053 89.99 66.3333 89.8967 66.3333H89.2527C89.15 66.3333 89.0707 66.3053 89.0147 66.2493C88.9587 66.1839 88.9307 66.1046 88.9307 66.0113V65.4093C88.8094 65.5773 88.646 65.7453 88.4407 65.9133C88.2354 66.0719 87.9787 66.2073 87.6707 66.3193C87.3627 66.4219 86.9847 66.4733 86.5367 66.4733ZM86.8307 65.4233C87.2134 65.4233 87.5634 65.3439 87.8807 65.1853C88.198 65.0173 88.4454 64.7606 88.6227 64.4153C88.8094 64.0699 88.9027 63.6359 88.9027 63.1133V62.7213L87.2787 62.9593C86.616 63.0526 86.1167 63.2113 85.7807 63.4353C85.4447 63.6499 85.2767 63.9253 85.2767 64.2613C85.2767 64.5226 85.3514 64.7419 85.5007 64.9193C85.6594 65.0873 85.8554 65.2133 86.0887 65.2973C86.3314 65.3813 86.5787 65.4233 86.8307 65.4233ZM93.3549 68.9933C93.2803 68.9933 93.2149 68.9653 93.1589 68.9093C93.1029 68.8533 93.0749 68.7879 93.0749 68.7133C93.0749 68.6759 93.0796 68.6386 93.0889 68.6013C93.0983 68.5639 93.1169 68.5173 93.1449 68.4613L94.2229 65.8993L91.5489 59.5853C91.5023 59.4733 91.4789 59.3939 91.4789 59.3473C91.4789 59.2633 91.5069 59.1933 91.5629 59.1373C91.6189 59.0813 91.6889 59.0533 91.7729 59.0533H92.4589C92.5616 59.0533 92.6363 59.0766 92.6829 59.1233C92.7389 59.1699 92.7763 59.2259 92.7949 59.2913L94.9229 64.3873L97.1069 59.2913C97.1349 59.2259 97.1723 59.1699 97.2189 59.1233C97.2749 59.0766 97.3543 59.0533 97.4569 59.0533H98.1149C98.1989 59.0533 98.2689 59.0813 98.3249 59.1373C98.3809 59.1933 98.4089 59.2586 98.4089 59.3333C98.4089 59.3799 98.3856 59.4639 98.3389 59.5853L94.3629 68.7553C94.3349 68.8206 94.2929 68.8766 94.2369 68.9233C94.1903 68.9699 94.1156 68.9933 94.0129 68.9933H93.3549Z" fill="#212328"/>
<path d="M47.08 80.4333C46.5267 80.4333 46.0567 80.3233 45.67 80.1033C45.2833 79.8766 44.9867 79.5833 44.78 79.2233C44.58 78.8566 44.48 78.4599 44.48 78.0333C44.48 77.8333 44.5033 77.6433 44.55 77.4633C44.6033 77.2766 44.6667 77.1033 44.74 76.9433C44.82 76.7766 44.8967 76.6299 44.97 76.5033C45.05 76.3699 45.12 76.2633 45.18 76.1833L47.08 73.5333C47.1133 73.4999 47.1533 73.4599 47.2 73.4133C47.2467 73.3599 47.3167 73.3333 47.41 73.3333H47.94C48 73.3333 48.0467 73.3566 48.08 73.4033C48.12 73.4433 48.14 73.4933 48.14 73.5533C48.14 73.5799 48.1367 73.6066 48.13 73.6333C48.1233 73.6533 48.1133 73.6699 48.1 73.6833L46.64 75.7233C46.72 75.6966 46.8133 75.6799 46.92 75.6733C47.0267 75.6599 47.1233 75.6533 47.21 75.6533C47.5767 75.6599 47.91 75.7266 48.21 75.8533C48.51 75.9799 48.7667 76.1533 48.98 76.3733C49.2 76.5866 49.3667 76.8366 49.48 77.1233C49.5933 77.4033 49.65 77.7033 49.65 78.0233C49.65 78.4433 49.55 78.8366 49.35 79.2033C49.15 79.5699 48.8567 79.8666 48.47 80.0933C48.09 80.3199 47.6267 80.4333 47.08 80.4333ZM47.07 79.5833C47.35 79.5833 47.61 79.5233 47.85 79.4033C48.09 79.2833 48.2833 79.1099 48.43 78.8833C48.5833 78.6499 48.66 78.3633 48.66 78.0233C48.66 77.6899 48.5867 77.4099 48.44 77.1833C48.2933 76.9499 48.0967 76.7766 47.85 76.6633C47.61 76.5433 47.35 76.4833 47.07 76.4833C46.79 76.4833 46.53 76.5433 46.29 76.6633C46.05 76.7766 45.8533 76.9499 45.7 77.1833C45.5533 77.4099 45.48 77.6899 45.48 78.0233C45.48 78.3633 45.5533 78.6499 45.7 78.8833C45.8533 79.1099 46.05 79.2833 46.29 79.4033C46.53 79.5233 46.79 79.5833 47.07 79.5833ZM50.9254 80.3333C50.8587 80.3333 50.8021 80.3133 50.7554 80.2733C50.7154 80.2266 50.6954 80.1699 50.6954 80.1033V79.3833C50.6954 79.3166 50.7154 79.2633 50.7554 79.2233C50.8021 79.1766 50.8587 79.1533 50.9254 79.1533H51.6454C51.7121 79.1533 51.7687 79.1766 51.8154 79.2233C51.8621 79.2633 51.8854 79.3166 51.8854 79.3833V80.1033C51.8854 80.1699 51.8621 80.2266 51.8154 80.2733C51.7687 80.3133 51.7121 80.3333 51.6454 80.3333H50.9254ZM54.6311 80.3333C54.5644 80.3333 54.5078 80.3133 54.4611 80.2733C54.4211 80.2266 54.4011 80.1699 54.4011 80.1033V74.5033L52.7411 75.7833C52.6878 75.8233 52.6311 75.8399 52.5711 75.8333C52.5111 75.8266 52.4611 75.7966 52.4211 75.7433L52.1611 75.4133C52.1211 75.3533 52.1044 75.2933 52.1111 75.2333C52.1244 75.1733 52.1578 75.1233 52.2111 75.0833L54.3911 73.4033C54.4378 73.3699 54.4811 73.3499 54.5211 73.3433C54.5611 73.3366 54.6044 73.3333 54.6511 73.3333H55.1611C55.2278 73.3333 55.2811 73.3566 55.3211 73.4033C55.3678 73.4433 55.3911 73.4966 55.3911 73.5633V80.1033C55.3911 80.1699 55.3678 80.2266 55.3211 80.2733C55.2811 80.3133 55.2278 80.3333 55.1611 80.3333H54.6311ZM57.2484 80.3333C57.1751 80.3333 57.1184 80.3133 57.0784 80.2733C57.0384 80.2266 57.0184 80.1699 57.0184 80.1033V73.5733C57.0184 73.4999 57.0384 73.4433 57.0784 73.4033C57.1184 73.3566 57.1751 73.3333 57.2484 73.3333H57.7484C57.8218 73.3333 57.8784 73.3566 57.9184 73.4033C57.9651 73.4433 57.9884 73.4999 57.9884 73.5733V76.0533L60.6584 73.4933C60.6851 73.4666 60.7284 73.4333 60.7884 73.3933C60.8551 73.3533 60.9418 73.3333 61.0484 73.3333H61.5884C61.6418 73.3333 61.6884 73.3533 61.7284 73.3933C61.7684 73.4333 61.7884 73.4799 61.7884 73.5333C61.7884 73.5866 61.7751 73.6299 61.7484 73.6633L58.6584 76.6833L61.9484 79.9933C61.9818 80.0333 61.9984 80.0799 61.9984 80.1333C61.9984 80.1866 61.9784 80.2333 61.9384 80.2733C61.8984 80.3133 61.8518 80.3333 61.7984 80.3333H61.2384C61.1251 80.3333 61.0384 80.3133 60.9784 80.2733C60.9184 80.2266 60.8751 80.1899 60.8484 80.1633L57.9884 77.3533V80.1033C57.9884 80.1699 57.9651 80.2266 57.9184 80.2733C57.8784 80.3133 57.8218 80.3333 57.7484 80.3333H57.2484ZM68.0178 80.4333C67.4578 80.4333 66.9745 80.3333 66.5678 80.1333C66.1678 79.9333 65.8578 79.6299 65.6378 79.2233C65.4245 78.8099 65.3178 78.2799 65.3178 77.6333V73.5733C65.3178 73.4999 65.3378 73.4433 65.3778 73.4033C65.4178 73.3566 65.4745 73.3333 65.5478 73.3333H66.0578C66.1311 73.3333 66.1878 73.3566 66.2278 73.4033C66.2745 73.4433 66.2978 73.4999 66.2978 73.5733V77.6533C66.2978 78.3066 66.4511 78.7899 66.7578 79.1033C67.0645 79.4166 67.4845 79.5733 68.0178 79.5733C68.5445 79.5733 68.9611 79.4166 69.2678 79.1033C69.5811 78.7899 69.7378 78.3066 69.7378 77.6533V73.5733C69.7378 73.4999 69.7578 73.4433 69.7978 73.4033C69.8445 73.3566 69.9011 73.3333 69.9678 73.3333H70.4878C70.5545 73.3333 70.6078 73.3566 70.6478 73.4033C70.6945 73.4433 70.7178 73.4999 70.7178 73.5733V77.6333C70.7178 78.2799 70.6078 78.8099 70.3878 79.2233C70.1745 79.6299 69.8678 79.9333 69.4678 80.1333C69.0678 80.3333 68.5845 80.4333 68.0178 80.4333ZM74.0205 80.4333C73.6471 80.4333 73.3271 80.3866 73.0605 80.2933C72.7938 80.1999 72.5771 80.0866 72.4105 79.9533C72.2438 79.8199 72.1171 79.6866 72.0305 79.5533C71.9505 79.4199 71.9071 79.3133 71.9005 79.2333C71.8938 79.1599 71.9171 79.1033 71.9705 79.0633C72.0238 79.0233 72.0771 79.0033 72.1305 79.0033H72.5805C72.6138 79.0033 72.6405 79.0099 72.6605 79.0233C72.6871 79.0299 72.7205 79.0566 72.7605 79.1033C72.8471 79.1966 72.9438 79.2899 73.0505 79.3833C73.1571 79.4766 73.2871 79.5533 73.4405 79.6133C73.6005 79.6733 73.7971 79.7033 74.0305 79.7033C74.3705 79.7033 74.6505 79.6399 74.8705 79.5133C75.0905 79.3799 75.2005 79.1866 75.2005 78.9333C75.2005 78.7666 75.1538 78.6333 75.0605 78.5333C74.9738 78.4333 74.8138 78.3433 74.5805 78.2633C74.3538 78.1833 74.0405 78.0999 73.6405 78.0133C73.2405 77.9199 72.9238 77.8066 72.6905 77.6733C72.4571 77.5333 72.2905 77.3699 72.1905 77.1833C72.0905 76.9899 72.0405 76.7733 72.0405 76.5333C72.0405 76.2866 72.1138 76.0499 72.2605 75.8233C72.4071 75.5899 72.6205 75.3999 72.9005 75.2533C73.1871 75.1066 73.5438 75.0333 73.9705 75.0333C74.3171 75.0333 74.6138 75.0766 74.8605 75.1633C75.1071 75.2499 75.3105 75.3599 75.4705 75.4933C75.6305 75.6199 75.7505 75.7466 75.8305 75.8733C75.9105 75.9999 75.9538 76.1066 75.9605 76.1933C75.9671 76.2599 75.9471 76.3166 75.9005 76.3633C75.8538 76.4033 75.8005 76.4233 75.7405 76.4233H75.3205C75.2738 76.4233 75.2338 76.4133 75.2005 76.3933C75.1738 76.3733 75.1471 76.3499 75.1205 76.3233C75.0538 76.2366 74.9738 76.1499 74.8805 76.0633C74.7938 75.9766 74.6771 75.9066 74.5305 75.8533C74.3905 75.7933 74.2038 75.7633 73.9705 75.7633C73.6371 75.7633 73.3871 75.8333 73.2205 75.9733C73.0538 76.1133 72.9705 76.2899 72.9705 76.5033C72.9705 76.6299 73.0071 76.7433 73.0805 76.8433C73.1538 76.9433 73.2938 77.0333 73.5005 77.1133C73.7071 77.1933 74.0138 77.2799 74.4205 77.3733C74.8605 77.4599 75.2071 77.5766 75.4605 77.7233C75.7138 77.8699 75.8938 78.0399 76.0005 78.2333C76.1071 78.4266 76.1605 78.6499 76.1605 78.9033C76.1605 79.1833 76.0805 79.4399 75.9205 79.6733C75.7605 79.9066 75.5205 80.0933 75.2005 80.2333C74.8805 80.3666 74.4871 80.4333 74.0205 80.4333ZM79.3981 80.4333C78.7048 80.4333 78.1548 80.2233 77.7481 79.8033C77.3415 79.3766 77.1181 78.7966 77.0781 78.0633C77.0715 77.9766 77.0681 77.8666 77.0681 77.7333C77.0681 77.5933 77.0715 77.4799 77.0781 77.3933C77.1048 76.9199 77.2148 76.5066 77.4081 76.1533C77.6015 75.7933 77.8648 75.5166 78.1981 75.3233C78.5381 75.1299 78.9348 75.0333 79.3881 75.0333C79.8948 75.0333 80.3181 75.1399 80.6581 75.3533C81.0048 75.5666 81.2681 75.8699 81.4481 76.2633C81.6281 76.6566 81.7181 77.1166 81.7181 77.6433V77.8133C81.7181 77.8866 81.6948 77.9433 81.6481 77.9833C81.6081 78.0233 81.5548 78.0433 81.4881 78.0433H78.0281C78.0281 78.0499 78.0281 78.0633 78.0281 78.0833C78.0281 78.1033 78.0281 78.1199 78.0281 78.1333C78.0415 78.4066 78.1015 78.6633 78.2081 78.9033C78.3148 79.1366 78.4681 79.3266 78.6681 79.4733C78.8748 79.6199 79.1148 79.6933 79.3881 79.6933C79.6281 79.6933 79.8281 79.6566 79.9881 79.5833C80.1481 79.5099 80.2781 79.4299 80.3781 79.3433C80.4781 79.2499 80.5448 79.1766 80.5781 79.1233C80.6381 79.0433 80.6848 78.9966 80.7181 78.9833C80.7515 78.9633 80.8048 78.9533 80.8781 78.9533H81.3681C81.4281 78.9533 81.4781 78.9733 81.5181 79.0133C81.5648 79.0466 81.5848 79.0966 81.5781 79.1633C81.5715 79.2633 81.5181 79.3866 81.4181 79.5333C81.3181 79.6733 81.1748 79.8133 80.9881 79.9533C80.8081 80.0933 80.5815 80.2099 80.3081 80.3033C80.0415 80.3899 79.7381 80.4333 79.3981 80.4333ZM78.0281 77.3533H80.7681V77.3233C80.7681 77.0233 80.7115 76.7566 80.5981 76.5233C80.4915 76.2899 80.3348 76.1066 80.1281 75.9733C79.9215 75.8333 79.6748 75.7633 79.3881 75.7633C79.1015 75.7633 78.8548 75.8333 78.6481 75.9733C78.4481 76.1066 78.2948 76.2899 78.1881 76.5233C78.0815 76.7566 78.0281 77.0233 78.0281 77.3233V77.3533ZM83.1438 80.3333C83.0772 80.3333 83.0205 80.3133 82.9738 80.2733C82.9338 80.2266 82.9138 80.1699 82.9138 80.1033V75.3733C82.9138 75.3066 82.9338 75.2499 82.9738 75.2033C83.0205 75.1566 83.0772 75.1333 83.1438 75.1333H83.6038C83.6705 75.1333 83.7272 75.1566 83.7738 75.2033C83.8205 75.2499 83.8438 75.3066 83.8438 75.3733V75.8133C83.9772 75.5866 84.1605 75.4166 84.3938 75.3033C84.6272 75.1899 84.9105 75.1333 85.2438 75.1333H85.6338C85.7005 75.1333 85.7538 75.1566 85.7938 75.2033C85.8405 75.2433 85.8638 75.2966 85.8638 75.3633V75.7733C85.8638 75.8399 85.8405 75.8933 85.7938 75.9333C85.7538 75.9733 85.7005 75.9933 85.6338 75.9933H85.0338C84.6738 75.9933 84.3905 76.0999 84.1838 76.3133C83.9772 76.5199 83.8738 76.8033 83.8738 77.1633V80.1033C83.8738 80.1699 83.8505 80.2266 83.8038 80.2733C83.7572 80.3133 83.7005 80.3333 83.6338 80.3333H83.1438ZM88.5127 80.4333C88.1393 80.4333 87.8193 80.3866 87.5527 80.2933C87.286 80.1999 87.0693 80.0866 86.9027 79.9533C86.736 79.8199 86.6093 79.6866 86.5227 79.5533C86.4427 79.4199 86.3993 79.3133 86.3927 79.2333C86.386 79.1599 86.4093 79.1033 86.4627 79.0633C86.516 79.0233 86.5693 79.0033 86.6227 79.0033H87.0727C87.106 79.0033 87.1327 79.0099 87.1527 79.0233C87.1793 79.0299 87.2127 79.0566 87.2527 79.1033C87.3393 79.1966 87.436 79.2899 87.5427 79.3833C87.6493 79.4766 87.7793 79.5533 87.9327 79.6133C88.0927 79.6733 88.2893 79.7033 88.5227 79.7033C88.8627 79.7033 89.1427 79.6399 89.3627 79.5133C89.5827 79.3799 89.6927 79.1866 89.6927 78.9333C89.6927 78.7666 89.646 78.6333 89.5527 78.5333C89.466 78.4333 89.306 78.3433 89.0727 78.2633C88.846 78.1833 88.5327 78.0999 88.1327 78.0133C87.7327 77.9199 87.416 77.8066 87.1827 77.6733C86.9493 77.5333 86.7827 77.3699 86.6827 77.1833C86.5827 76.9899 86.5327 76.7733 86.5327 76.5333C86.5327 76.2866 86.606 76.0499 86.7527 75.8233C86.8993 75.5899 87.1127 75.3999 87.3927 75.2533C87.6793 75.1066 88.036 75.0333 88.4627 75.0333C88.8093 75.0333 89.106 75.0766 89.3527 75.1633C89.5993 75.2499 89.8027 75.3599 89.9627 75.4933C90.1227 75.6199 90.2427 75.7466 90.3227 75.8733C90.4027 75.9999 90.446 76.1066 90.4527 76.1933C90.4593 76.2599 90.4393 76.3166 90.3927 76.3633C90.346 76.4033 90.2927 76.4233 90.2327 76.4233H89.8127C89.766 76.4233 89.726 76.4133 89.6927 76.3933C89.666 76.3733 89.6393 76.3499 89.6127 76.3233C89.546 76.2366 89.466 76.1499 89.3727 76.0633C89.286 75.9766 89.1693 75.9066 89.0227 75.8533C88.8827 75.7933 88.696 75.7633 88.4627 75.7633C88.1293 75.7633 87.8793 75.8333 87.7127 75.9733C87.546 76.1133 87.4627 76.2899 87.4627 76.5033C87.4627 76.6299 87.4993 76.7433 87.5727 76.8433C87.646 76.9433 87.786 77.0333 87.9927 77.1133C88.1993 77.1933 88.506 77.2799 88.9127 77.3733C89.3527 77.4599 89.6993 77.5766 89.9527 77.7233C90.206 77.8699 90.386 78.0399 90.4927 78.2333C90.5993 78.4266 90.6527 78.6499 90.6527 78.9033C90.6527 79.1833 90.5727 79.4399 90.4127 79.6733C90.2527 79.9066 90.0127 80.0933 89.6927 80.2333C89.3727 80.3666 88.9793 80.4333 88.5127 80.4333Z" fill="#717385"/>
<path d="M130.88 74.5333C129.733 74.5333 128.747 74.3199 127.92 73.8933C127.093 73.4533 126.453 72.8666 126 72.1333C125.547 71.3866 125.32 70.5533 125.32 69.6333C125.32 69.2199 125.373 68.8199 125.48 68.4333C125.587 68.0466 125.727 67.6799 125.9 67.3333C126.073 66.9866 126.24 66.6799 126.4 66.4133C126.573 66.1333 126.727 65.9133 126.86 65.7533L130.52 60.7333C130.573 60.6666 130.653 60.5866 130.76 60.4933C130.867 60.3866 131.013 60.3333 131.2 60.3333H133.06C133.18 60.3333 133.28 60.3799 133.36 60.4733C133.44 60.5533 133.48 60.6533 133.48 60.7733C133.48 60.8266 133.467 60.8799 133.44 60.9333C133.427 60.9733 133.407 61.0066 133.38 61.0333L130.58 64.9133C130.7 64.8733 130.84 64.8466 131 64.8333C131.16 64.8199 131.307 64.8133 131.44 64.8133C132.107 64.8266 132.74 64.9599 133.34 65.2133C133.94 65.4533 134.467 65.7866 134.92 66.2133C135.373 66.6399 135.727 67.1399 135.98 67.7133C136.247 68.2866 136.38 68.9133 136.38 69.5933C136.38 70.4733 136.16 71.2933 135.72 72.0533C135.28 72.7999 134.647 73.3999 133.82 73.8533C133.007 74.3066 132.027 74.5333 130.88 74.5333ZM130.86 72.2333C131.34 72.2333 131.78 72.1333 132.18 71.9333C132.593 71.7333 132.927 71.4399 133.18 71.0533C133.433 70.6666 133.56 70.1866 133.56 69.6133C133.56 69.0533 133.433 68.5799 133.18 68.1933C132.927 67.8066 132.593 67.5133 132.18 67.3133C131.78 67.1133 131.34 67.0133 130.86 67.0133C130.38 67.0133 129.933 67.1133 129.52 67.3133C129.12 67.5133 128.793 67.8066 128.54 68.1933C128.287 68.5799 128.16 69.0533 128.16 69.6133C128.16 70.1866 128.287 70.6666 128.54 71.0533C128.793 71.4399 129.12 71.7333 129.52 71.9333C129.933 72.1333 130.38 72.2333 130.86 72.2333ZM143.599 74.5333C142.652 74.5333 141.846 74.3933 141.179 74.1133C140.512 73.8333 139.966 73.4466 139.539 72.9533C139.112 72.4599 138.792 71.8933 138.579 71.2533C138.366 70.5999 138.239 69.9066 138.199 69.1733C138.186 68.8133 138.172 68.4199 138.159 67.9933C138.159 67.5533 138.159 67.1133 138.159 66.6733C138.172 66.2333 138.186 65.8266 138.199 65.4533C138.226 64.7199 138.352 64.0333 138.579 63.3933C138.806 62.7399 139.132 62.1733 139.559 61.6933C139.999 61.2133 140.552 60.8333 141.219 60.5533C141.886 60.2733 142.679 60.1333 143.599 60.1333C144.532 60.1333 145.332 60.2733 145.999 60.5533C146.666 60.8333 147.212 61.2133 147.639 61.6933C148.079 62.1733 148.406 62.7399 148.619 63.3933C148.846 64.0333 148.972 64.7199 148.999 65.4533C149.026 65.8266 149.039 66.2333 149.039 66.6733C149.039 67.1133 149.039 67.5533 149.039 67.9933C149.039 68.4199 149.026 68.8133 148.999 69.1733C148.972 69.9066 148.852 70.5999 148.639 71.2533C148.426 71.8933 148.106 72.4599 147.679 72.9533C147.252 73.4466 146.699 73.8333 146.019 74.1133C145.352 74.3933 144.546 74.5333 143.599 74.5333ZM143.599 72.2333C144.466 72.2333 145.099 71.9533 145.499 71.3933C145.912 70.8199 146.126 70.0466 146.139 69.0733C146.166 68.6866 146.179 68.2999 146.179 67.9133C146.179 67.5133 146.179 67.1133 146.179 66.7133C146.179 66.3133 146.166 65.9333 146.139 65.5733C146.126 64.6266 145.912 63.8666 145.499 63.2933C145.099 62.7066 144.466 62.4133 143.599 62.4133C142.746 62.4133 142.112 62.7066 141.699 63.2933C141.299 63.8666 141.086 64.6266 141.059 65.5733C141.059 65.9333 141.052 66.3133 141.039 66.7133C141.039 67.1133 141.039 67.5133 141.039 67.9133C141.052 68.2999 141.059 68.6866 141.059 69.0733C141.086 70.0466 141.306 70.8199 141.719 71.3933C142.132 71.9533 142.759 72.2333 143.599 72.2333ZM152.384 74.3333C152.104 74.3333 151.964 74.1999 151.964 73.9333C151.964 73.8533 151.99 73.7799 152.044 73.7133L161.904 60.7133C161.997 60.5933 162.09 60.4999 162.184 60.4333C162.277 60.3666 162.41 60.3333 162.584 60.3333H163.644C163.924 60.3333 164.064 60.4666 164.064 60.7333C164.064 60.8133 164.037 60.8866 163.984 60.9533L154.124 73.9533C154.03 74.0733 153.937 74.1666 153.844 74.2333C153.764 74.2999 153.63 74.3333 153.444 74.3333H152.384ZM162.004 74.4533C161.11 74.4533 160.404 74.2066 159.884 73.7133C159.364 73.2199 159.077 72.5733 159.024 71.7733C159.01 71.4266 159.004 71.1266 159.004 70.8733C159.004 70.6199 159.01 70.3066 159.024 69.9333C159.077 69.1333 159.35 68.4866 159.844 67.9933C160.35 67.4999 161.07 67.2533 162.004 67.2533C162.95 67.2533 163.67 67.4999 164.164 67.9933C164.67 68.4866 164.944 69.1333 164.984 69.9333C165.01 70.3066 165.024 70.6199 165.024 70.8733C165.024 71.1266 165.01 71.4266 164.984 71.7733C164.944 72.5733 164.657 73.2199 164.124 73.7133C163.604 74.2066 162.897 74.4533 162.004 74.4533ZM162.004 72.8933C162.297 72.8933 162.524 72.8333 162.684 72.7133C162.857 72.5933 162.984 72.4399 163.064 72.2533C163.144 72.0666 163.184 71.8799 163.184 71.6933C163.21 71.3599 163.224 71.0799 163.224 70.8533C163.224 70.6133 163.21 70.3399 163.184 70.0333C163.17 69.7133 163.077 69.4266 162.904 69.1733C162.73 68.9199 162.43 68.7933 162.004 68.7933C161.59 68.7933 161.297 68.9199 161.124 69.1733C160.95 69.4266 160.85 69.7133 160.824 70.0333C160.81 70.3399 160.804 70.6133 160.804 70.8533C160.804 71.0799 160.81 71.3599 160.824 71.6933C160.85 71.8799 160.897 72.0666 160.964 72.2533C161.044 72.4399 161.164 72.5933 161.324 72.7133C161.497 72.8333 161.724 72.8933 162.004 72.8933ZM154.024 67.3733C153.13 67.3733 152.424 67.1399 151.904 66.6733C151.384 66.2066 151.097 65.5733 151.044 64.7733C151.03 64.4266 151.024 64.1266 151.024 63.8733C151.024 63.6066 151.03 63.2866 151.044 62.9133C151.097 62.1133 151.37 61.4666 151.864 60.9733C152.37 60.4799 153.09 60.2333 154.024 60.2333C154.97 60.2333 155.69 60.4799 156.184 60.9733C156.69 61.4666 156.964 62.1133 157.004 62.9133C157.03 63.2866 157.044 63.6066 157.044 63.8733C157.044 64.1266 157.03 64.4266 157.004 64.7733C156.964 65.5733 156.677 66.2066 156.144 66.6733C155.624 67.1399 154.917 67.3733 154.024 67.3733ZM154.024 65.8933C154.317 65.8933 154.544 65.8333 154.704 65.7133C154.877 65.5933 155.004 65.4399 155.084 65.2533C155.164 65.0666 155.204 64.8733 155.204 64.6733C155.23 64.3399 155.244 64.0599 155.244 63.8333C155.244 63.5933 155.23 63.3199 155.204 63.0133C155.19 62.7066 155.097 62.4266 154.924 62.1733C154.75 61.9199 154.45 61.7933 154.024 61.7933C153.61 61.7933 153.317 61.9199 153.144 62.1733C152.97 62.4266 152.877 62.7066 152.864 63.0133C152.85 63.3199 152.844 63.5933 152.844 63.8333C152.844 64.0599 152.85 64.3399 152.864 64.6733C152.877 64.8733 152.917 65.0666 152.984 65.2533C153.064 65.4399 153.184 65.5933 153.344 65.7133C153.517 65.8333 153.744 65.8933 154.024 65.8933Z" fill="#212328"/>
<rect x="15" y="95" width="22" height="22" rx="11" stroke="#D057FF" stroke-width="2"/>
<g clip-path="url(#clip0_2438_30649)">
<path d="M36 106C36 111.523 31.5228 116 26 116C20.4772 116 16 111.523 16 106C16 100.477 20.4772 96 26 96C31.5228 96 36 100.477 36 106Z" fill="#EA7314"/>
<path d="M21 100.167H30.8068L26.2415 106L30.8068 111.833H21V100.167Z" fill="white"/>
</g>
<path d="M45.54 105C45.4373 105 45.358 104.972 45.302 104.916C45.246 104.851 45.218 104.771 45.218 104.678V95.536C45.218 95.4333 45.246 95.354 45.302 95.298C45.358 95.2327 45.4373 95.2 45.54 95.2H46.24C46.3427 95.2 46.422 95.2327 46.478 95.298C46.5433 95.354 46.576 95.4333 46.576 95.536V99.008L50.314 95.424C50.3513 95.3867 50.412 95.34 50.496 95.284C50.5893 95.228 50.7107 95.2 50.86 95.2H51.616C51.6907 95.2 51.756 95.228 51.812 95.284C51.868 95.34 51.896 95.4053 51.896 95.48C51.896 95.5547 51.8773 95.6153 51.84 95.662L47.514 99.89L52.12 104.524C52.1667 104.58 52.19 104.645 52.19 104.72C52.19 104.795 52.162 104.86 52.106 104.916C52.05 104.972 51.9847 105 51.91 105H51.126C50.9673 105 50.846 104.972 50.762 104.916C50.678 104.851 50.6173 104.799 50.58 104.762L46.576 100.828V104.678C46.576 104.771 46.5433 104.851 46.478 104.916C46.422 104.972 46.3427 105 46.24 105H45.54ZM55.3785 105.14C54.9118 105.14 54.4872 105.047 54.1045 104.86C53.7218 104.673 53.4138 104.421 53.1805 104.104C52.9472 103.787 52.8305 103.427 52.8305 103.026C52.8305 102.382 53.0918 101.869 53.6145 101.486C54.1372 101.103 54.8185 100.851 55.6585 100.73L57.7445 100.436V100.03C57.7445 99.582 57.6138 99.232 57.3525 98.98C57.1005 98.728 56.6852 98.602 56.1065 98.602C55.6958 98.602 55.3598 98.686 55.0985 98.854C54.8372 99.022 54.6552 99.2367 54.5525 99.498C54.4965 99.638 54.3985 99.708 54.2585 99.708H53.6285C53.5258 99.708 53.4465 99.68 53.3905 99.624C53.3438 99.5587 53.3205 99.484 53.3205 99.4C53.3205 99.26 53.3718 99.0873 53.4745 98.882C53.5865 98.6767 53.7545 98.476 53.9785 98.28C54.2025 98.084 54.4872 97.9207 54.8325 97.79C55.1872 97.65 55.6165 97.58 56.1205 97.58C56.6805 97.58 57.1518 97.6547 57.5345 97.804C57.9172 97.944 58.2158 98.1353 58.4305 98.378C58.6545 98.6207 58.8132 98.896 58.9065 99.204C59.0092 99.512 59.0605 99.8247 59.0605 100.142V104.678C59.0605 104.771 59.0278 104.851 58.9625 104.916C58.9065 104.972 58.8318 105 58.7385 105H58.0945C57.9918 105 57.9125 104.972 57.8565 104.916C57.8005 104.851 57.7725 104.771 57.7725 104.678V104.076C57.6512 104.244 57.4878 104.412 57.2825 104.58C57.0772 104.739 56.8205 104.874 56.5125 104.986C56.2045 105.089 55.8265 105.14 55.3785 105.14ZM55.6725 104.09C56.0552 104.09 56.4052 104.011 56.7225 103.852C57.0398 103.684 57.2872 103.427 57.4645 103.082C57.6512 102.737 57.7445 102.303 57.7445 101.78V101.388L56.1205 101.626C55.4578 101.719 54.9585 101.878 54.6225 102.102C54.2865 102.317 54.1185 102.592 54.1185 102.928C54.1185 103.189 54.1932 103.409 54.3425 103.586C54.5012 103.754 54.6972 103.88 54.9305 103.964C55.1732 104.048 55.4205 104.09 55.6725 104.09ZM61.3951 105C61.3018 105 61.2224 104.972 61.1571 104.916C61.1011 104.851 61.0731 104.771 61.0731 104.678V98.042C61.0731 97.9487 61.1011 97.874 61.1571 97.818C61.2224 97.7527 61.3018 97.72 61.3951 97.72H62.0531C62.1464 97.72 62.2211 97.7527 62.2771 97.818C62.3424 97.874 62.3751 97.9487 62.3751 98.042V98.658C62.6178 98.3407 62.9211 98.084 63.2851 97.888C63.6584 97.6827 64.1344 97.58 64.7131 97.58C65.3198 97.58 65.8331 97.7153 66.2531 97.986C66.6824 98.2473 67.0044 98.616 67.2191 99.092C67.4431 99.5587 67.5551 100.105 67.5551 100.73V104.678C67.5551 104.771 67.5224 104.851 67.4571 104.916C67.4011 104.972 67.3264 105 67.2331 105H66.5331C66.4398 105 66.3604 104.972 66.2951 104.916C66.2391 104.851 66.2111 104.771 66.2111 104.678V100.8C66.2111 100.147 66.0524 99.638 65.7351 99.274C65.4178 98.9007 64.9511 98.714 64.3351 98.714C63.7564 98.714 63.2898 98.9007 62.9351 99.274C62.5898 99.638 62.4171 100.147 62.4171 100.8V104.678C62.4171 104.771 62.3844 104.851 62.3191 104.916C62.2631 104.972 62.1884 105 62.0951 105H61.3951ZM72.3096 105C71.787 105 71.3623 104.902 71.0356 104.706C70.709 104.501 70.471 104.216 70.3216 103.852C70.1723 103.479 70.0976 103.04 70.0976 102.536V98.84H69.0056C68.9123 98.84 68.833 98.812 68.7676 98.756C68.7116 98.6907 68.6836 98.6113 68.6836 98.518V98.042C68.6836 97.9487 68.7116 97.874 68.7676 97.818C68.833 97.7527 68.9123 97.72 69.0056 97.72H70.0976V95.382C70.0976 95.2887 70.1256 95.214 70.1816 95.158C70.247 95.0927 70.3263 95.06 70.4196 95.06H71.0776C71.171 95.06 71.2456 95.0927 71.3016 95.158C71.367 95.214 71.3996 95.2887 71.3996 95.382V97.72H73.1356C73.2383 97.72 73.3176 97.7527 73.3736 97.818C73.4296 97.874 73.4576 97.9487 73.4576 98.042V98.518C73.4576 98.6113 73.4296 98.6907 73.3736 98.756C73.3176 98.812 73.2383 98.84 73.1356 98.84H71.3996V102.438C71.3996 102.877 71.4743 103.222 71.6236 103.474C71.773 103.726 72.039 103.852 72.4216 103.852H73.2756C73.369 103.852 73.4436 103.885 73.4996 103.95C73.565 104.006 73.5976 104.081 73.5976 104.174V104.678C73.5976 104.771 73.565 104.851 73.4996 104.916C73.4436 104.972 73.369 105 73.2756 105H72.3096ZM76.9664 105.14C76.4997 105.14 76.0751 105.047 75.6924 104.86C75.3097 104.673 75.0017 104.421 74.7684 104.104C74.5351 103.787 74.4184 103.427 74.4184 103.026C74.4184 102.382 74.6797 101.869 75.2024 101.486C75.7251 101.103 76.4064 100.851 77.2464 100.73L79.3324 100.436V100.03C79.3324 99.582 79.2017 99.232 78.9404 98.98C78.6884 98.728 78.2731 98.602 77.6944 98.602C77.2837 98.602 76.9477 98.686 76.6864 98.854C76.4251 99.022 76.2431 99.2367 76.1404 99.498C76.0844 99.638 75.9864 99.708 75.8464 99.708H75.2164C75.1137 99.708 75.0344 99.68 74.9784 99.624C74.9317 99.5587 74.9084 99.484 74.9084 99.4C74.9084 99.26 74.9597 99.0873 75.0624 98.882C75.1744 98.6767 75.3424 98.476 75.5664 98.28C75.7904 98.084 76.0751 97.9207 76.4204 97.79C76.7751 97.65 77.2044 97.58 77.7084 97.58C78.2684 97.58 78.7397 97.6547 79.1224 97.804C79.5051 97.944 79.8037 98.1353 80.0184 98.378C80.2424 98.6207 80.4011 98.896 80.4944 99.204C80.5971 99.512 80.6484 99.8247 80.6484 100.142V104.678C80.6484 104.771 80.6157 104.851 80.5504 104.916C80.4944 104.972 80.4197 105 80.3264 105H79.6824C79.5797 105 79.5004 104.972 79.4444 104.916C79.3884 104.851 79.3604 104.771 79.3604 104.678V104.076C79.2391 104.244 79.0757 104.412 78.8704 104.58C78.6651 104.739 78.4084 104.874 78.1004 104.986C77.7924 105.089 77.4144 105.14 76.9664 105.14ZM77.2604 104.09C77.6431 104.09 77.9931 104.011 78.3104 103.852C78.6277 103.684 78.8751 103.427 79.0524 103.082C79.2391 102.737 79.3324 102.303 79.3324 101.78V101.388L77.7084 101.626C77.0457 101.719 76.5464 101.878 76.2104 102.102C75.8744 102.317 75.7064 102.592 75.7064 102.928C75.7064 103.189 75.7811 103.409 75.9304 103.586C76.0891 103.754 76.2851 103.88 76.5184 103.964C76.7611 104.048 77.0084 104.09 77.2604 104.09ZM85.4346 105C84.912 105 84.4873 104.902 84.1606 104.706C83.834 104.501 83.596 104.216 83.4466 103.852C83.2973 103.479 83.2226 103.04 83.2226 102.536V98.84H82.1306C82.0373 98.84 81.958 98.812 81.8926 98.756C81.8366 98.6907 81.8086 98.6113 81.8086 98.518V98.042C81.8086 97.9487 81.8366 97.874 81.8926 97.818C81.958 97.7527 82.0373 97.72 82.1306 97.72H83.2226V95.382C83.2226 95.2887 83.2506 95.214 83.3066 95.158C83.372 95.0927 83.4513 95.06 83.5446 95.06H84.2026C84.296 95.06 84.3706 95.0927 84.4266 95.158C84.492 95.214 84.5246 95.2887 84.5246 95.382V97.72H86.2606C86.3633 97.72 86.4426 97.7527 86.4986 97.818C86.5546 97.874 86.5826 97.9487 86.5826 98.042V98.518C86.5826 98.6113 86.5546 98.6907 86.4986 98.756C86.4426 98.812 86.3633 98.84 86.2606 98.84H84.5246V102.438C84.5246 102.877 84.5993 103.222 84.7486 103.474C84.898 103.726 85.164 103.852 85.5466 103.852H86.4006C86.494 103.852 86.5686 103.885 86.6246 103.95C86.69 104.006 86.7226 104.081 86.7226 104.174V104.678C86.7226 104.771 86.69 104.851 86.6246 104.916C86.5686 104.972 86.494 105 86.4006 105H85.4346ZM90.0914 105.14C89.6247 105.14 89.2001 105.047 88.8174 104.86C88.4347 104.673 88.1267 104.421 87.8934 104.104C87.6601 103.787 87.5434 103.427 87.5434 103.026C87.5434 102.382 87.8047 101.869 88.3274 101.486C88.8501 101.103 89.5314 100.851 90.3714 100.73L92.4574 100.436V100.03C92.4574 99.582 92.3267 99.232 92.0654 98.98C91.8134 98.728 91.3981 98.602 90.8194 98.602C90.4087 98.602 90.0727 98.686 89.8114 98.854C89.5501 99.022 89.3681 99.2367 89.2654 99.498C89.2094 99.638 89.1114 99.708 88.9714 99.708H88.3414C88.2387 99.708 88.1594 99.68 88.1034 99.624C88.0567 99.5587 88.0334 99.484 88.0334 99.4C88.0334 99.26 88.0847 99.0873 88.1874 98.882C88.2994 98.6767 88.4674 98.476 88.6914 98.28C88.9154 98.084 89.2001 97.9207 89.5454 97.79C89.9001 97.65 90.3294 97.58 90.8334 97.58C91.3934 97.58 91.8647 97.6547 92.2474 97.804C92.6301 97.944 92.9287 98.1353 93.1434 98.378C93.3674 98.6207 93.5261 98.896 93.6194 99.204C93.7221 99.512 93.7734 99.8247 93.7734 100.142V104.678C93.7734 104.771 93.7407 104.851 93.6754 104.916C93.6194 104.972 93.5447 105 93.4514 105H92.8074C92.7047 105 92.6254 104.972 92.5694 104.916C92.5134 104.851 92.4854 104.771 92.4854 104.678V104.076C92.3641 104.244 92.2007 104.412 91.9954 104.58C91.7901 104.739 91.5334 104.874 91.2254 104.986C90.9174 105.089 90.5394 105.14 90.0914 105.14ZM90.3854 104.09C90.7681 104.09 91.1181 104.011 91.4354 103.852C91.7527 103.684 92.0001 103.427 92.1774 103.082C92.3641 102.737 92.4574 102.303 92.4574 101.78V101.388L90.8334 101.626C90.1707 101.719 89.6714 101.878 89.3354 102.102C88.9994 102.317 88.8314 102.592 88.8314 102.928C88.8314 103.189 88.9061 103.409 89.0554 103.586C89.2141 103.754 89.4101 103.88 89.6434 103.964C89.8861 104.048 90.1334 104.09 90.3854 104.09Z" fill="#212328"/>
<path d="M46.98 119.1C46.56 119.1 46.1933 119.05 45.88 118.95C45.5667 118.843 45.3033 118.703 45.09 118.53C44.8767 118.357 44.7133 118.167 44.6 117.96C44.4933 117.747 44.4367 117.533 44.43 117.32C44.43 117.26 44.45 117.213 44.49 117.18C44.53 117.14 44.58 117.12 44.64 117.12H45.13C45.19 117.12 45.2433 117.137 45.29 117.17C45.3433 117.197 45.3833 117.253 45.41 117.34C45.4767 117.58 45.59 117.767 45.75 117.9C45.9167 118.033 46.1067 118.127 46.32 118.18C46.54 118.227 46.76 118.25 46.98 118.25C47.44 118.25 47.8133 118.14 48.1 117.92C48.3867 117.7 48.53 117.377 48.53 116.95C48.53 116.517 48.4 116.207 48.14 116.02C47.88 115.833 47.52 115.74 47.06 115.74H46.11C46.0433 115.74 45.9867 115.72 45.94 115.68C45.9 115.64 45.88 115.583 45.88 115.51V115.24C45.88 115.18 45.89 115.13 45.91 115.09C45.9367 115.043 45.9633 115.003 45.99 114.97L47.93 112.85H44.98C44.9133 112.85 44.8567 112.83 44.81 112.79C44.77 112.75 44.75 112.693 44.75 112.62V112.24C44.75 112.167 44.77 112.11 44.81 112.07C44.8567 112.023 44.9133 112 44.98 112H48.97C49.0433 112 49.1 112.023 49.14 112.07C49.1867 112.11 49.21 112.167 49.21 112.24V112.6C49.21 112.647 49.1967 112.69 49.17 112.73C49.15 112.763 49.1267 112.797 49.1 112.83L47.17 114.98L47.33 114.99C47.77 115.003 48.1533 115.083 48.48 115.23C48.8133 115.377 49.07 115.597 49.25 115.89C49.4367 116.177 49.53 116.54 49.53 116.98C49.53 117.427 49.42 117.807 49.2 118.12C48.98 118.433 48.6767 118.677 48.29 118.85C47.91 119.017 47.4733 119.1 46.98 119.1ZM51.1059 119C51.0325 119 50.9759 118.98 50.9359 118.94C50.8959 118.893 50.8759 118.837 50.8759 118.77V112.24C50.8759 112.167 50.8959 112.11 50.9359 112.07C50.9759 112.023 51.0325 112 51.1059 112H51.6059C51.6792 112 51.7359 112.023 51.7759 112.07C51.8225 112.11 51.8459 112.167 51.8459 112.24V114.72L54.5159 112.16C54.5425 112.133 54.5859 112.1 54.6459 112.06C54.7125 112.02 54.7992 112 54.9059 112H55.4459C55.4992 112 55.5459 112.02 55.5859 112.06C55.6259 112.1 55.6459 112.147 55.6459 112.2C55.6459 112.253 55.6325 112.297 55.6059 112.33L52.5159 115.35L55.8059 118.66C55.8392 118.7 55.8559 118.747 55.8559 118.8C55.8559 118.853 55.8359 118.9 55.7959 118.94C55.7559 118.98 55.7092 119 55.6559 119H55.0959C54.9825 119 54.8959 118.98 54.8359 118.94C54.7759 118.893 54.7325 118.857 54.7059 118.83L51.8459 116.02V118.77C51.8459 118.837 51.8225 118.893 51.7759 118.94C51.7359 118.98 51.6792 119 51.6059 119H51.1059ZM61.8752 119.1C61.3152 119.1 60.8319 119 60.4252 118.8C60.0252 118.6 59.7152 118.297 59.4952 117.89C59.2819 117.477 59.1752 116.947 59.1752 116.3V112.24C59.1752 112.167 59.1952 112.11 59.2352 112.07C59.2752 112.023 59.3319 112 59.4052 112H59.9152C59.9886 112 60.0452 112.023 60.0852 112.07C60.1319 112.11 60.1552 112.167 60.1552 112.24V116.32C60.1552 116.973 60.3086 117.457 60.6152 117.77C60.9219 118.083 61.3419 118.24 61.8752 118.24C62.4019 118.24 62.8186 118.083 63.1252 117.77C63.4386 117.457 63.5952 116.973 63.5952 116.32V112.24C63.5952 112.167 63.6152 112.11 63.6552 112.07C63.7019 112.023 63.7586 112 63.8252 112H64.3452C64.4119 112 64.4652 112.023 64.5052 112.07C64.5519 112.11 64.5752 112.167 64.5752 112.24V116.3C64.5752 116.947 64.4652 117.477 64.2452 117.89C64.0319 118.297 63.7252 118.6 63.3252 118.8C62.9252 119 62.4419 119.1 61.8752 119.1ZM67.8779 119.1C67.5046 119.1 67.1846 119.053 66.9179 118.96C66.6512 118.867 66.4346 118.753 66.2679 118.62C66.1012 118.487 65.9746 118.353 65.8879 118.22C65.8079 118.087 65.7646 117.98 65.7579 117.9C65.7512 117.827 65.7746 117.77 65.8279 117.73C65.8812 117.69 65.9346 117.67 65.9879 117.67H66.4379C66.4712 117.67 66.4979 117.677 66.5179 117.69C66.5446 117.697 66.5779 117.723 66.6179 117.77C66.7046 117.863 66.8012 117.957 66.9079 118.05C67.0146 118.143 67.1446 118.22 67.2979 118.28C67.4579 118.34 67.6546 118.37 67.8879 118.37C68.2279 118.37 68.5079 118.307 68.7279 118.18C68.9479 118.047 69.0579 117.853 69.0579 117.6C69.0579 117.433 69.0112 117.3 68.9179 117.2C68.8312 117.1 68.6712 117.01 68.4379 116.93C68.2112 116.85 67.8979 116.767 67.4979 116.68C67.0979 116.587 66.7812 116.473 66.5479 116.34C66.3146 116.2 66.1479 116.037 66.0479 115.85C65.9479 115.657 65.8979 115.44 65.8979 115.2C65.8979 114.953 65.9712 114.717 66.1179 114.49C66.2646 114.257 66.4779 114.067 66.7579 113.92C67.0446 113.773 67.4012 113.7 67.8279 113.7C68.1746 113.7 68.4712 113.743 68.7179 113.83C68.9646 113.917 69.1679 114.027 69.3279 114.16C69.4879 114.287 69.6079 114.413 69.6879 114.54C69.7679 114.667 69.8112 114.773 69.8179 114.86C69.8246 114.927 69.8046 114.983 69.7579 115.03C69.7112 115.07 69.6579 115.09 69.5979 115.09H69.1779C69.1312 115.09 69.0912 115.08 69.0579 115.06C69.0312 115.04 69.0046 115.017 68.9779 114.99C68.9112 114.903 68.8312 114.817 68.7379 114.73C68.6512 114.643 68.5346 114.573 68.3879 114.52C68.2479 114.46 68.0612 114.43 67.8279 114.43C67.4946 114.43 67.2446 114.5 67.0779 114.64C66.9112 114.78 66.8279 114.957 66.8279 115.17C66.8279 115.297 66.8646 115.41 66.9379 115.51C67.0112 115.61 67.1512 115.7 67.3579 115.78C67.5646 115.86 67.8712 115.947 68.2779 116.04C68.7179 116.127 69.0646 116.243 69.3179 116.39C69.5712 116.537 69.7512 116.707 69.8579 116.9C69.9646 117.093 70.0179 117.317 70.0179 117.57C70.0179 117.85 69.9379 118.107 69.7779 118.34C69.6179 118.573 69.3779 118.76 69.0579 118.9C68.7379 119.033 68.3446 119.1 67.8779 119.1ZM73.2555 119.1C72.5622 119.1 72.0122 118.89 71.6055 118.47C71.1989 118.043 70.9755 117.463 70.9355 116.73C70.9289 116.643 70.9255 116.533 70.9255 116.4C70.9255 116.26 70.9289 116.147 70.9355 116.06C70.9622 115.587 71.0722 115.173 71.2655 114.82C71.4589 114.46 71.7222 114.183 72.0555 113.99C72.3955 113.797 72.7922 113.7 73.2455 113.7C73.7522 113.7 74.1755 113.807 74.5155 114.02C74.8622 114.233 75.1255 114.537 75.3055 114.93C75.4855 115.323 75.5755 115.783 75.5755 116.31V116.48C75.5755 116.553 75.5522 116.61 75.5055 116.65C75.4655 116.69 75.4122 116.71 75.3455 116.71H71.8855C71.8855 116.717 71.8855 116.73 71.8855 116.75C71.8855 116.77 71.8855 116.787 71.8855 116.8C71.8989 117.073 71.9589 117.33 72.0655 117.57C72.1722 117.803 72.3255 117.993 72.5255 118.14C72.7322 118.287 72.9722 118.36 73.2455 118.36C73.4855 118.36 73.6855 118.323 73.8455 118.25C74.0055 118.177 74.1355 118.097 74.2355 118.01C74.3355 117.917 74.4022 117.843 74.4355 117.79C74.4955 117.71 74.5422 117.663 74.5755 117.65C74.6089 117.63 74.6622 117.62 74.7355 117.62H75.2255C75.2855 117.62 75.3355 117.64 75.3755 117.68C75.4222 117.713 75.4422 117.763 75.4355 117.83C75.4289 117.93 75.3755 118.053 75.2755 118.2C75.1755 118.34 75.0322 118.48 74.8455 118.62C74.6655 118.76 74.4389 118.877 74.1655 118.97C73.8989 119.057 73.5955 119.1 73.2555 119.1ZM71.8855 116.02H74.6255V115.99C74.6255 115.69 74.5689 115.423 74.4555 115.19C74.3489 114.957 74.1922 114.773 73.9855 114.64C73.7789 114.5 73.5322 114.43 73.2455 114.43C72.9589 114.43 72.7122 114.5 72.5055 114.64C72.3055 114.773 72.1522 114.957 72.0455 115.19C71.9389 115.423 71.8855 115.69 71.8855 115.99V116.02ZM77.0013 119C76.9346 119 76.8779 118.98 76.8313 118.94C76.7913 118.893 76.7713 118.837 76.7713 118.77V114.04C76.7713 113.973 76.7913 113.917 76.8313 113.87C76.8779 113.823 76.9346 113.8 77.0013 113.8H77.4613C77.5279 113.8 77.5846 113.823 77.6313 113.87C77.6779 113.917 77.7013 113.973 77.7013 114.04V114.48C77.8346 114.253 78.0179 114.083 78.2513 113.97C78.4846 113.857 78.7679 113.8 79.1013 113.8H79.4913C79.5579 113.8 79.6113 113.823 79.6513 113.87C79.6979 113.91 79.7213 113.963 79.7213 114.03V114.44C79.7213 114.507 79.6979 114.56 79.6513 114.6C79.6113 114.64 79.5579 114.66 79.4913 114.66H78.8913C78.5313 114.66 78.2479 114.767 78.0413 114.98C77.8346 115.187 77.7313 115.47 77.7313 115.83V118.77C77.7313 118.837 77.7079 118.893 77.6613 118.94C77.6146 118.98 77.5579 119 77.4913 119H77.0013ZM82.3701 119.1C81.9967 119.1 81.6767 119.053 81.4101 118.96C81.1434 118.867 80.9267 118.753 80.7601 118.62C80.5934 118.487 80.4667 118.353 80.3801 118.22C80.3001 118.087 80.2567 117.98 80.2501 117.9C80.2434 117.827 80.2667 117.77 80.3201 117.73C80.3734 117.69 80.4267 117.67 80.4801 117.67H80.9301C80.9634 117.67 80.9901 117.677 81.0101 117.69C81.0367 117.697 81.0701 117.723 81.1101 117.77C81.1967 117.863 81.2934 117.957 81.4001 118.05C81.5067 118.143 81.6367 118.22 81.7901 118.28C81.9501 118.34 82.1467 118.37 82.3801 118.37C82.7201 118.37 83.0001 118.307 83.2201 118.18C83.4401 118.047 83.5501 117.853 83.5501 117.6C83.5501 117.433 83.5034 117.3 83.4101 117.2C83.3234 117.1 83.1634 117.01 82.9301 116.93C82.7034 116.85 82.3901 116.767 81.9901 116.68C81.5901 116.587 81.2734 116.473 81.0401 116.34C80.8067 116.2 80.6401 116.037 80.5401 115.85C80.4401 115.657 80.3901 115.44 80.3901 115.2C80.3901 114.953 80.4634 114.717 80.6101 114.49C80.7567 114.257 80.9701 114.067 81.2501 113.92C81.5367 113.773 81.8934 113.7 82.3201 113.7C82.6667 113.7 82.9634 113.743 83.2101 113.83C83.4567 113.917 83.6601 114.027 83.8201 114.16C83.9801 114.287 84.1001 114.413 84.1801 114.54C84.2601 114.667 84.3034 114.773 84.3101 114.86C84.3167 114.927 84.2967 114.983 84.2501 115.03C84.2034 115.07 84.1501 115.09 84.0901 115.09H83.6701C83.6234 115.09 83.5834 115.08 83.5501 115.06C83.5234 115.04 83.4967 115.017 83.4701 114.99C83.4034 114.903 83.3234 114.817 83.2301 114.73C83.1434 114.643 83.0267 114.573 82.8801 114.52C82.7401 114.46 82.5534 114.43 82.3201 114.43C81.9867 114.43 81.7367 114.5 81.5701 114.64C81.4034 114.78 81.3201 114.957 81.3201 115.17C81.3201 115.297 81.3567 115.41 81.4301 115.51C81.5034 115.61 81.6434 115.7 81.8501 115.78C82.0567 115.86 82.3634 115.947 82.7701 116.04C83.2101 116.127 83.5567 116.243 83.8101 116.39C84.0634 116.537 84.2434 116.707 84.3501 116.9C84.4567 117.093 84.5101 117.317 84.5101 117.57C84.5101 117.85 84.4301 118.107 84.2701 118.34C84.1101 118.573 83.8701 118.76 83.5501 118.9C83.2301 119.033 82.8367 119.1 82.3701 119.1Z" fill="#717385"/>
<path d="M130.72 113.2C129.787 113.2 128.98 113.087 128.3 112.86C127.62 112.633 127.053 112.34 126.6 111.98C126.16 111.607 125.827 111.207 125.6 110.78C125.373 110.34 125.253 109.907 125.24 109.48C125.24 109.36 125.28 109.267 125.36 109.2C125.453 109.12 125.56 109.08 125.68 109.08H127.48C127.613 109.08 127.727 109.107 127.82 109.16C127.913 109.213 127.993 109.32 128.06 109.48C128.18 109.84 128.373 110.127 128.64 110.34C128.92 110.553 129.24 110.707 129.6 110.8C129.96 110.88 130.34 110.92 130.74 110.92C131.54 110.92 132.173 110.733 132.64 110.36C133.12 109.973 133.36 109.427 133.36 108.72C133.36 108.013 133.14 107.507 132.7 107.2C132.26 106.88 131.647 106.72 130.86 106.72H128.8C128.653 106.72 128.533 106.68 128.44 106.6C128.347 106.507 128.3 106.387 128.3 106.24V105.4C128.3 105.267 128.327 105.153 128.38 105.06C128.447 104.953 128.513 104.867 128.58 104.8L132.16 101.3H126.44C126.293 101.3 126.173 101.253 126.08 101.16C126 101.067 125.96 100.953 125.96 100.82V99.5C125.96 99.3533 126 99.2333 126.08 99.14C126.173 99.0467 126.293 99 126.44 99H135.02C135.167 99 135.287 99.0467 135.38 99.14C135.473 99.2333 135.52 99.3533 135.52 99.5V100.7C135.52 100.82 135.493 100.927 135.44 101.02C135.387 101.113 135.327 101.193 135.26 101.26L131.8 104.82L132.04 104.84C132.853 104.907 133.573 105.093 134.2 105.4C134.84 105.693 135.333 106.127 135.68 106.7C136.04 107.273 136.22 107.993 136.22 108.86C136.22 109.767 135.98 110.547 135.5 111.2C135.033 111.84 134.387 112.333 133.56 112.68C132.733 113.027 131.787 113.2 130.72 113.2ZM143.658 113.2C142.711 113.2 141.904 113.06 141.238 112.78C140.571 112.5 140.024 112.113 139.598 111.62C139.171 111.127 138.851 110.56 138.638 109.92C138.424 109.267 138.298 108.573 138.258 107.84C138.244 107.48 138.231 107.087 138.218 106.66C138.218 106.22 138.218 105.78 138.218 105.34C138.231 104.9 138.244 104.493 138.258 104.12C138.284 103.387 138.411 102.7 138.638 102.06C138.864 101.407 139.191 100.84 139.618 100.36C140.058 99.88 140.611 99.5 141.278 99.22C141.944 98.94 142.738 98.8 143.658 98.8C144.591 98.8 145.391 98.94 146.058 99.22C146.724 99.5 147.271 99.88 147.698 100.36C148.138 100.84 148.464 101.407 148.678 102.06C148.904 102.7 149.031 103.387 149.058 104.12C149.084 104.493 149.098 104.9 149.098 105.34C149.098 105.78 149.098 106.22 149.098 106.66C149.098 107.087 149.084 107.48 149.058 107.84C149.031 108.573 148.911 109.267 148.698 109.92C148.484 110.56 148.164 111.127 147.738 111.62C147.311 112.113 146.758 112.5 146.078 112.78C145.411 113.06 144.604 113.2 143.658 113.2ZM143.658 110.9C144.524 110.9 145.158 110.62 145.558 110.06C145.971 109.487 146.184 108.713 146.198 107.74C146.224 107.353 146.238 106.967 146.238 106.58C146.238 106.18 146.238 105.78 146.238 105.38C146.238 104.98 146.224 104.6 146.198 104.24C146.184 103.293 145.971 102.533 145.558 101.96C145.158 101.373 144.524 101.08 143.658 101.08C142.804 101.08 142.171 101.373 141.758 101.96C141.358 102.533 141.144 103.293 141.118 104.24C141.118 104.6 141.111 104.98 141.098 105.38C141.098 105.78 141.098 106.18 141.098 106.58C141.111 106.967 141.118 107.353 141.118 107.74C141.144 108.713 141.364 109.487 141.778 110.06C142.191 110.62 142.818 110.9 143.658 110.9ZM152.442 113C152.162 113 152.022 112.867 152.022 112.6C152.022 112.52 152.049 112.447 152.102 112.38L161.962 99.38C162.056 99.26 162.149 99.1667 162.242 99.1C162.336 99.0333 162.469 99 162.642 99H163.702C163.982 99 164.122 99.1333 164.122 99.4C164.122 99.48 164.096 99.5533 164.042 99.62L154.182 112.62C154.089 112.74 153.996 112.833 153.902 112.9C153.822 112.967 153.689 113 153.502 113H152.442ZM162.062 113.12C161.169 113.12 160.462 112.873 159.942 112.38C159.422 111.887 159.136 111.24 159.082 110.44C159.069 110.093 159.062 109.793 159.062 109.54C159.062 109.287 159.069 108.973 159.082 108.6C159.136 107.8 159.409 107.153 159.902 106.66C160.409 106.167 161.129 105.92 162.062 105.92C163.009 105.92 163.729 106.167 164.222 106.66C164.729 107.153 165.002 107.8 165.042 108.6C165.069 108.973 165.082 109.287 165.082 109.54C165.082 109.793 165.069 110.093 165.042 110.44C165.002 111.24 164.716 111.887 164.182 112.38C163.662 112.873 162.956 113.12 162.062 113.12ZM162.062 111.56C162.356 111.56 162.582 111.5 162.742 111.38C162.916 111.26 163.042 111.107 163.122 110.92C163.202 110.733 163.242 110.547 163.242 110.36C163.269 110.027 163.282 109.747 163.282 109.52C163.282 109.28 163.269 109.007 163.242 108.7C163.229 108.38 163.136 108.093 162.962 107.84C162.789 107.587 162.489 107.46 162.062 107.46C161.649 107.46 161.356 107.587 161.182 107.84C161.009 108.093 160.909 108.38 160.882 108.7C160.869 109.007 160.862 109.28 160.862 109.52C160.862 109.747 160.869 110.027 160.882 110.36C160.909 110.547 160.956 110.733 161.022 110.92C161.102 111.107 161.222 111.26 161.382 111.38C161.556 111.5 161.782 111.56 162.062 111.56ZM154.082 106.04C153.189 106.04 152.482 105.807 151.962 105.34C151.442 104.873 151.156 104.24 151.102 103.44C151.089 103.093 151.082 102.793 151.082 102.54C151.082 102.273 151.089 101.953 151.102 101.58C151.156 100.78 151.429 100.133 151.922 99.64C152.429 99.1467 153.149 98.9 154.082 98.9C155.029 98.9 155.749 99.1467 156.242 99.64C156.749 100.133 157.022 100.78 157.062 101.58C157.089 101.953 157.102 102.273 157.102 102.54C157.102 102.793 157.089 103.093 157.062 103.44C157.022 104.24 156.736 104.873 156.202 105.34C155.682 105.807 154.976 106.04 154.082 106.04ZM154.082 104.56C154.376 104.56 154.602 104.5 154.762 104.38C154.936 104.26 155.062 104.107 155.142 103.92C155.222 103.733 155.262 103.54 155.262 103.34C155.289 103.007 155.302 102.727 155.302 102.5C155.302 102.26 155.289 101.987 155.262 101.68C155.249 101.373 155.156 101.093 154.982 100.84C154.809 100.587 154.509 100.46 154.082 100.46C153.669 100.46 153.376 100.587 153.202 100.84C153.029 101.093 152.936 101.373 152.922 101.68C152.909 101.987 152.902 102.26 152.902 102.5C152.902 102.727 152.909 103.007 152.922 103.34C152.936 103.54 152.976 103.733 153.042 103.92C153.122 104.107 153.242 104.26 153.402 104.38C153.576 104.5 153.802 104.56 154.082 104.56Z" fill="#212328"/>
<rect x="15" y="133.667" width="22" height="22" rx="11" stroke="#E19701" stroke-width="2"/>
<g clip-path="url(#clip1_2438_30649)">
<path d="M26 154.667C31.5228 154.667 36 150.189 36 144.667C36 139.144 31.5228 134.667 26 134.667C20.4772 134.667 16 139.144 16 144.667C16 150.189 20.4772 154.667 26 154.667Z" fill="#1976D2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M30.1198 141.877H28.3169L28.3229 146.117L26.7531 141.875H25.1965L23.8565 145.417C23.714 144.515 22.7821 144.204 22.0487 143.971C21.5646 143.816 21.0506 143.588 21.0558 143.335C21.0598 143.126 21.3308 142.935 21.8683 142.963C22.3283 142.977 22.7788 143.098 23.1833 143.318L23.8083 142.23C23.1729 141.924 22.4783 141.76 21.7731 141.75H21.7692C21.441 141.734 21.113 141.784 20.8044 141.897C20.4958 142.01 20.2128 142.183 19.9719 142.406C19.6983 142.687 19.544 143.062 19.5417 143.454C19.5264 143.699 19.5754 143.943 19.6836 144.163C19.7918 144.383 19.9556 144.571 20.1587 144.708C20.5335 144.959 20.9461 145.147 21.3808 145.267C21.8796 145.422 22.2869 145.556 22.2819 145.842C22.2786 145.947 22.2364 146.047 22.1635 146.123C22.0838 146.19 21.9916 146.24 21.8922 146.271C21.7929 146.303 21.6883 146.314 21.5846 146.305C21.0562 146.325 20.535 146.176 20.0971 145.88L19.5417 146.982C20.1384 147.325 20.816 147.502 21.5042 147.495L21.6671 147.494C22.224 147.512 22.7703 147.339 23.2158 147.004C23.2392 146.985 23.26 146.967 23.2817 146.948L23.2135 147.299L24.7344 147.294L25.0073 146.596C25.3167 146.698 25.6408 146.75 25.9669 146.748C26.285 146.75 26.6014 146.701 26.9044 146.604L27.0946 147.294L29.8237 147.297L29.8304 145.704H30.4104C31.8142 145.704 32.644 144.99 32.644 143.792C32.644 142.458 31.8367 141.877 30.1198 141.877ZM25.9671 145.502C25.7708 145.503 25.5758 145.469 25.3917 145.401L25.9606 143.604H25.9717L26.5315 145.406C26.3501 145.47 26.1593 145.502 25.9671 145.502ZM30.2252 144.469H29.8294V143.021H30.2252C30.7529 143.021 31.1744 143.197 31.1744 143.735C31.1744 144.293 30.7529 144.469 30.2252 144.469Z" fill="white"/>
</g>
<path d="M48.368 143.807C47.556 143.807 46.8747 143.681 46.324 143.429C45.7733 143.177 45.3487 142.855 45.05 142.463C44.7607 142.061 44.6067 141.641 44.588 141.203C44.588 141.128 44.616 141.063 44.672 141.007C44.7373 140.941 44.812 140.909 44.896 140.909H45.61C45.722 140.909 45.806 140.937 45.862 140.993C45.918 141.049 45.9553 141.114 45.974 141.189C46.03 141.413 46.1467 141.637 46.324 141.861C46.5013 142.075 46.7533 142.257 47.08 142.407C47.416 142.547 47.8453 142.617 48.368 142.617C49.1707 142.617 49.7587 142.477 50.132 142.197C50.5147 141.907 50.706 141.525 50.706 141.049C50.706 140.722 50.6033 140.461 50.398 140.265C50.202 140.059 49.8987 139.877 49.488 139.719C49.0773 139.56 48.5453 139.387 47.892 139.201C47.2107 139.005 46.646 138.79 46.198 138.557C45.75 138.323 45.414 138.034 45.19 137.689C44.9753 137.343 44.868 136.905 44.868 136.373C44.868 135.869 45.0033 135.421 45.274 135.029C45.5447 134.627 45.9367 134.31 46.45 134.077C46.9633 133.843 47.5793 133.727 48.298 133.727C48.8767 133.727 49.3807 133.806 49.81 133.965C50.2487 134.114 50.6127 134.319 50.902 134.581C51.1913 134.833 51.4107 135.108 51.56 135.407C51.7093 135.696 51.7887 135.981 51.798 136.261C51.798 136.326 51.7747 136.391 51.728 136.457C51.6813 136.513 51.6067 136.541 51.504 136.541H50.762C50.6967 136.541 50.6267 136.522 50.552 136.485C50.4867 136.447 50.4353 136.377 50.398 136.275C50.342 135.892 50.1273 135.57 49.754 135.309C49.3807 135.047 48.8953 134.917 48.298 134.917C47.6913 134.917 47.1967 135.033 46.814 135.267C46.4407 135.5 46.254 135.864 46.254 136.359C46.254 136.676 46.3427 136.942 46.52 137.157C46.6973 137.362 46.9773 137.544 47.36 137.703C47.7427 137.861 48.242 138.029 48.858 138.207C49.6047 138.412 50.216 138.631 50.692 138.865C51.168 139.089 51.518 139.373 51.742 139.719C51.9753 140.055 52.092 140.489 52.092 141.021C52.092 141.609 51.938 142.113 51.63 142.533C51.322 142.943 50.888 143.261 50.328 143.485C49.7773 143.699 49.124 143.807 48.368 143.807ZM53.1323 143.667C53.0576 143.667 52.9923 143.639 52.9363 143.583C52.8803 143.527 52.8523 143.461 52.8523 143.387C52.8523 143.34 52.8569 143.289 52.8663 143.233L56.3383 134.175C56.3756 134.081 56.4269 134.007 56.4923 133.951C56.5576 133.895 56.6556 133.867 56.7863 133.867H57.7383C57.8689 133.867 57.9669 133.895 58.0323 133.951C58.0976 134.007 58.1489 134.081 58.1863 134.175L61.6443 143.233C61.6629 143.289 61.6723 143.34 61.6723 143.387C61.6723 143.461 61.6443 143.527 61.5883 143.583C61.5323 143.639 61.4669 143.667 61.3923 143.667H60.6783C60.5663 143.667 60.4823 143.639 60.4263 143.583C60.3796 143.527 60.3469 143.475 60.3283 143.429L59.5583 141.441H54.9663L54.1963 143.429C54.1869 143.475 54.1543 143.527 54.0983 143.583C54.0423 143.639 53.9583 143.667 53.8463 143.667H53.1323ZM55.3723 140.237H59.1523L57.2623 135.267L55.3723 140.237ZM63.4912 143.667C63.3885 143.667 63.3092 143.639 63.2532 143.583C63.1972 143.517 63.1692 143.438 63.1692 143.345V134.203C63.1692 134.1 63.1972 134.021 63.2532 133.965C63.3092 133.899 63.3885 133.867 63.4912 133.867H67.0472C67.7378 133.867 68.3352 133.979 68.8392 134.203C69.3525 134.427 69.7492 134.763 70.0292 135.211C70.3092 135.649 70.4492 136.2 70.4492 136.863C70.4492 137.525 70.3092 138.076 70.0292 138.515C69.7492 138.953 69.3525 139.285 68.8392 139.509C68.3352 139.733 67.7378 139.845 67.0472 139.845H64.5692V143.345C64.5692 143.438 64.5365 143.517 64.4712 143.583C64.4152 143.639 64.3358 143.667 64.2332 143.667H63.4912ZM64.5552 138.669H66.9772C67.6678 138.669 68.1858 138.515 68.5312 138.207C68.8765 137.899 69.0492 137.451 69.0492 136.863C69.0492 136.284 68.8812 135.836 68.5452 135.519C68.2092 135.201 67.6865 135.043 66.9772 135.043H64.5552V138.669Z" fill="black"/>
<path d="M46.76 157.667C46.6933 157.667 46.6367 157.647 46.59 157.607C46.55 157.56 46.53 157.503 46.53 157.437V151.837L44.87 153.117C44.8167 153.157 44.76 153.173 44.7 153.167C44.64 153.16 44.59 153.13 44.55 153.077L44.29 152.747C44.25 152.687 44.2333 152.627 44.24 152.567C44.2533 152.507 44.2867 152.457 44.34 152.417L46.52 150.737C46.5667 150.703 46.61 150.683 46.65 150.677C46.69 150.67 46.7333 150.667 46.78 150.667H47.29C47.3567 150.667 47.41 150.69 47.45 150.737C47.4967 150.777 47.52 150.83 47.52 150.897V157.437C47.52 157.503 47.4967 157.56 47.45 157.607C47.41 157.647 47.3567 157.667 47.29 157.667H46.76ZM49.3773 157.667C49.304 157.667 49.2473 157.647 49.2073 157.607C49.1673 157.56 49.1473 157.503 49.1473 157.437V150.907C49.1473 150.833 49.1673 150.777 49.2073 150.737C49.2473 150.69 49.304 150.667 49.3773 150.667H49.8773C49.9507 150.667 50.0073 150.69 50.0473 150.737C50.094 150.777 50.1173 150.833 50.1173 150.907V153.387L52.7873 150.827C52.814 150.8 52.8573 150.767 52.9173 150.727C52.984 150.687 53.0707 150.667 53.1773 150.667H53.7173C53.7707 150.667 53.8173 150.687 53.8573 150.727C53.8973 150.767 53.9173 150.813 53.9173 150.867C53.9173 150.92 53.904 150.963 53.8773 150.997L50.7873 154.017L54.0773 157.327C54.1107 157.367 54.1273 157.413 54.1273 157.467C54.1273 157.52 54.1073 157.567 54.0673 157.607C54.0273 157.647 53.9807 157.667 53.9273 157.667H53.3673C53.254 157.667 53.1673 157.647 53.1073 157.607C53.0473 157.56 53.004 157.523 52.9773 157.497L50.1173 154.687V157.437C50.1173 157.503 50.094 157.56 50.0473 157.607C50.0073 157.647 49.9507 157.667 49.8773 157.667H49.3773ZM60.1467 157.767C59.5867 157.767 59.1034 157.667 58.6967 157.467C58.2967 157.267 57.9867 156.963 57.7667 156.557C57.5534 156.143 57.4467 155.613 57.4467 154.967V150.907C57.4467 150.833 57.4667 150.777 57.5067 150.737C57.5467 150.69 57.6034 150.667 57.6767 150.667H58.1867C58.2601 150.667 58.3167 150.69 58.3567 150.737C58.4034 150.777 58.4267 150.833 58.4267 150.907V154.987C58.4267 155.64 58.5801 156.123 58.8867 156.437C59.1934 156.75 59.6134 156.907 60.1467 156.907C60.6734 156.907 61.0901 156.75 61.3967 156.437C61.7101 156.123 61.8667 155.64 61.8667 154.987V150.907C61.8667 150.833 61.8867 150.777 61.9267 150.737C61.9734 150.69 62.0301 150.667 62.0967 150.667H62.6167C62.6834 150.667 62.7367 150.69 62.7767 150.737C62.8234 150.777 62.8467 150.833 62.8467 150.907V154.967C62.8467 155.613 62.7367 156.143 62.5167 156.557C62.3034 156.963 61.9967 157.267 61.5967 157.467C61.1967 157.667 60.7134 157.767 60.1467 157.767ZM66.1494 157.767C65.776 157.767 65.456 157.72 65.1894 157.627C64.9227 157.533 64.706 157.42 64.5394 157.287C64.3727 157.153 64.246 157.02 64.1594 156.887C64.0794 156.753 64.036 156.647 64.0294 156.567C64.0227 156.493 64.046 156.437 64.0994 156.397C64.1527 156.357 64.206 156.337 64.2594 156.337H64.7094C64.7427 156.337 64.7694 156.343 64.7894 156.357C64.816 156.363 64.8494 156.39 64.8894 156.437C64.976 156.53 65.0727 156.623 65.1794 156.717C65.286 156.81 65.416 156.887 65.5694 156.947C65.7294 157.007 65.926 157.037 66.1594 157.037C66.4994 157.037 66.7794 156.973 66.9994 156.847C67.2194 156.713 67.3294 156.52 67.3294 156.267C67.3294 156.1 67.2827 155.967 67.1894 155.867C67.1027 155.767 66.9427 155.677 66.7094 155.597C66.4827 155.517 66.1694 155.433 65.7694 155.347C65.3694 155.253 65.0527 155.14 64.8194 155.007C64.586 154.867 64.4194 154.703 64.3194 154.517C64.2194 154.323 64.1694 154.107 64.1694 153.867C64.1694 153.62 64.2427 153.383 64.3894 153.157C64.536 152.923 64.7494 152.733 65.0294 152.587C65.316 152.44 65.6727 152.367 66.0994 152.367C66.446 152.367 66.7427 152.41 66.9894 152.497C67.236 152.583 67.4394 152.693 67.5994 152.827C67.7594 152.953 67.8794 153.08 67.9594 153.207C68.0394 153.333 68.0827 153.44 68.0894 153.527C68.096 153.593 68.076 153.65 68.0294 153.697C67.9827 153.737 67.9294 153.757 67.8694 153.757H67.4494C67.4027 153.757 67.3627 153.747 67.3294 153.727C67.3027 153.707 67.276 153.683 67.2494 153.657C67.1827 153.57 67.1027 153.483 67.0094 153.397C66.9227 153.31 66.806 153.24 66.6594 153.187C66.5194 153.127 66.3327 153.097 66.0994 153.097C65.766 153.097 65.516 153.167 65.3494 153.307C65.1827 153.447 65.0994 153.623 65.0994 153.837C65.0994 153.963 65.136 154.077 65.2094 154.177C65.2827 154.277 65.4227 154.367 65.6294 154.447C65.836 154.527 66.1427 154.613 66.5494 154.707C66.9894 154.793 67.336 154.91 67.5894 155.057C67.8427 155.203 68.0227 155.373 68.1294 155.567C68.236 155.76 68.2894 155.983 68.2894 156.237C68.2894 156.517 68.2094 156.773 68.0494 157.007C67.8894 157.24 67.6494 157.427 67.3294 157.567C67.0094 157.7 66.616 157.767 66.1494 157.767ZM71.527 157.767C70.8337 157.767 70.2837 157.557 69.877 157.137C69.4704 156.71 69.247 156.13 69.207 155.397C69.2004 155.31 69.197 155.2 69.197 155.067C69.197 154.927 69.2004 154.813 69.207 154.727C69.2337 154.253 69.3437 153.84 69.537 153.487C69.7304 153.127 69.9937 152.85 70.327 152.657C70.667 152.463 71.0637 152.367 71.517 152.367C72.0237 152.367 72.447 152.473 72.787 152.687C73.1337 152.9 73.397 153.203 73.577 153.597C73.757 153.99 73.847 154.45 73.847 154.977V155.147C73.847 155.22 73.8237 155.277 73.777 155.317C73.737 155.357 73.6837 155.377 73.617 155.377H70.157C70.157 155.383 70.157 155.397 70.157 155.417C70.157 155.437 70.157 155.453 70.157 155.467C70.1704 155.74 70.2304 155.997 70.337 156.237C70.4437 156.47 70.597 156.66 70.797 156.807C71.0037 156.953 71.2437 157.027 71.517 157.027C71.757 157.027 71.957 156.99 72.117 156.917C72.277 156.843 72.407 156.763 72.507 156.677C72.607 156.583 72.6737 156.51 72.707 156.457C72.767 156.377 72.8137 156.33 72.847 156.317C72.8804 156.297 72.9337 156.287 73.007 156.287H73.497C73.557 156.287 73.607 156.307 73.647 156.347C73.6937 156.38 73.7137 156.43 73.707 156.497C73.7004 156.597 73.647 156.72 73.547 156.867C73.447 157.007 73.3037 157.147 73.117 157.287C72.937 157.427 72.7104 157.543 72.437 157.637C72.1704 157.723 71.867 157.767 71.527 157.767ZM70.157 154.687H72.897V154.657C72.897 154.357 72.8404 154.09 72.727 153.857C72.6204 153.623 72.4637 153.44 72.257 153.307C72.0504 153.167 71.8037 153.097 71.517 153.097C71.2304 153.097 70.9837 153.167 70.777 153.307C70.577 153.44 70.4237 153.623 70.317 153.857C70.2104 154.09 70.157 154.357 70.157 154.657V154.687ZM75.2727 157.667C75.2061 157.667 75.1494 157.647 75.1027 157.607C75.0627 157.56 75.0427 157.503 75.0427 157.437V152.707C75.0427 152.64 75.0627 152.583 75.1027 152.537C75.1494 152.49 75.2061 152.467 75.2727 152.467H75.7327C75.7994 152.467 75.8561 152.49 75.9027 152.537C75.9494 152.583 75.9727 152.64 75.9727 152.707V153.147C76.1061 152.92 76.2894 152.75 76.5227 152.637C76.7561 152.523 77.0394 152.467 77.3727 152.467H77.7627C77.8294 152.467 77.8827 152.49 77.9227 152.537C77.9694 152.577 77.9927 152.63 77.9927 152.697V153.107C77.9927 153.173 77.9694 153.227 77.9227 153.267C77.8827 153.307 77.8294 153.327 77.7627 153.327H77.1627C76.8027 153.327 76.5194 153.433 76.3127 153.647C76.1061 153.853 76.0027 154.137 76.0027 154.497V157.437C76.0027 157.503 75.9794 157.56 75.9327 157.607C75.8861 157.647 75.8294 157.667 75.7627 157.667H75.2727ZM80.6416 157.767C80.2682 157.767 79.9482 157.72 79.6816 157.627C79.4149 157.533 79.1982 157.42 79.0316 157.287C78.8649 157.153 78.7382 157.02 78.6516 156.887C78.5716 156.753 78.5282 156.647 78.5216 156.567C78.5149 156.493 78.5382 156.437 78.5916 156.397C78.6449 156.357 78.6982 156.337 78.7516 156.337H79.2016C79.2349 156.337 79.2616 156.343 79.2816 156.357C79.3082 156.363 79.3416 156.39 79.3816 156.437C79.4682 156.53 79.5649 156.623 79.6716 156.717C79.7782 156.81 79.9082 156.887 80.0616 156.947C80.2216 157.007 80.4182 157.037 80.6516 157.037C80.9916 157.037 81.2716 156.973 81.4916 156.847C81.7116 156.713 81.8216 156.52 81.8216 156.267C81.8216 156.1 81.7749 155.967 81.6816 155.867C81.5949 155.767 81.4349 155.677 81.2016 155.597C80.9749 155.517 80.6616 155.433 80.2616 155.347C79.8616 155.253 79.5449 155.14 79.3116 155.007C79.0782 154.867 78.9116 154.703 78.8116 154.517C78.7116 154.323 78.6616 154.107 78.6616 153.867C78.6616 153.62 78.7349 153.383 78.8816 153.157C79.0282 152.923 79.2416 152.733 79.5216 152.587C79.8082 152.44 80.1649 152.367 80.5916 152.367C80.9382 152.367 81.2349 152.41 81.4816 152.497C81.7282 152.583 81.9316 152.693 82.0916 152.827C82.2516 152.953 82.3716 153.08 82.4516 153.207C82.5316 153.333 82.5749 153.44 82.5816 153.527C82.5882 153.593 82.5682 153.65 82.5216 153.697C82.4749 153.737 82.4216 153.757 82.3616 153.757H81.9416C81.8949 153.757 81.8549 153.747 81.8216 153.727C81.7949 153.707 81.7682 153.683 81.7416 153.657C81.6749 153.57 81.5949 153.483 81.5016 153.397C81.4149 153.31 81.2982 153.24 81.1516 153.187C81.0116 153.127 80.8249 153.097 80.5916 153.097C80.2582 153.097 80.0082 153.167 79.8416 153.307C79.6749 153.447 79.5916 153.623 79.5916 153.837C79.5916 153.963 79.6282 154.077 79.7016 154.177C79.7749 154.277 79.9149 154.367 80.1216 154.447C80.3282 154.527 80.6349 154.613 81.0416 154.707C81.4816 154.793 81.8282 154.91 82.0816 155.057C82.3349 155.203 82.5149 155.373 82.6216 155.567C82.7282 155.76 82.7816 155.983 82.7816 156.237C82.7816 156.517 82.7016 156.773 82.5416 157.007C82.3816 157.24 82.1416 157.427 81.8216 157.567C81.5016 157.7 81.1082 157.767 80.6416 157.767Z" fill="#717385"/>
<path d="M133.04 151.667C132.893 151.667 132.773 151.62 132.68 151.527C132.6 151.433 132.56 151.32 132.56 151.187V140.827L129.52 143.167C129.4 143.247 129.28 143.28 129.16 143.267C129.04 143.24 128.933 143.167 128.84 143.047L128 141.967C127.92 141.847 127.887 141.72 127.9 141.587C127.927 141.453 128 141.347 128.12 141.267L132.6 137.807C132.68 137.74 132.76 137.7 132.84 137.687C132.92 137.673 133.007 137.667 133.1 137.667H134.86C134.993 137.667 135.107 137.713 135.2 137.807C135.293 137.9 135.34 138.013 135.34 138.147V151.187C135.34 151.32 135.293 151.433 135.2 151.527C135.107 151.62 134.993 151.667 134.86 151.667H133.04ZM143.318 151.867C142.371 151.867 141.564 151.727 140.898 151.447C140.231 151.167 139.684 150.78 139.258 150.287C138.831 149.793 138.511 149.227 138.298 148.587C138.084 147.933 137.958 147.24 137.918 146.507C137.904 146.147 137.891 145.753 137.878 145.327C137.878 144.887 137.878 144.447 137.878 144.007C137.891 143.567 137.904 143.16 137.918 142.787C137.944 142.053 138.071 141.367 138.298 140.727C138.524 140.073 138.851 139.507 139.278 139.027C139.718 138.547 140.271 138.167 140.938 137.887C141.604 137.607 142.398 137.467 143.318 137.467C144.251 137.467 145.051 137.607 145.718 137.887C146.384 138.167 146.931 138.547 147.358 139.027C147.798 139.507 148.124 140.073 148.338 140.727C148.564 141.367 148.691 142.053 148.718 142.787C148.744 143.16 148.758 143.567 148.758 144.007C148.758 144.447 148.758 144.887 148.758 145.327C148.758 145.753 148.744 146.147 148.718 146.507C148.691 147.24 148.571 147.933 148.358 148.587C148.144 149.227 147.824 149.793 147.398 150.287C146.971 150.78 146.418 151.167 145.738 151.447C145.071 151.727 144.264 151.867 143.318 151.867ZM143.318 149.567C144.184 149.567 144.818 149.287 145.218 148.727C145.631 148.153 145.844 147.38 145.858 146.407C145.884 146.02 145.898 145.633 145.898 145.247C145.898 144.847 145.898 144.447 145.898 144.047C145.898 143.647 145.884 143.267 145.858 142.907C145.844 141.96 145.631 141.2 145.218 140.627C144.818 140.04 144.184 139.747 143.318 139.747C142.464 139.747 141.831 140.04 141.418 140.627C141.018 141.2 140.804 141.96 140.778 142.907C140.778 143.267 140.771 143.647 140.758 144.047C140.758 144.447 140.758 144.847 140.758 145.247C140.771 145.633 140.778 146.02 140.778 146.407C140.804 147.38 141.024 148.153 141.438 148.727C141.851 149.287 142.478 149.567 143.318 149.567ZM152.102 151.667C151.822 151.667 151.682 151.533 151.682 151.267C151.682 151.187 151.709 151.113 151.762 151.047L161.622 138.047C161.716 137.927 161.809 137.833 161.902 137.767C161.996 137.7 162.129 137.667 162.302 137.667H163.362C163.642 137.667 163.782 137.8 163.782 138.067C163.782 138.147 163.756 138.22 163.702 138.287L153.842 151.287C153.749 151.407 153.656 151.5 153.562 151.567C153.482 151.633 153.349 151.667 153.162 151.667H152.102ZM161.722 151.787C160.829 151.787 160.122 151.54 159.602 151.047C159.082 150.553 158.796 149.907 158.742 149.107C158.729 148.76 158.722 148.46 158.722 148.207C158.722 147.953 158.729 147.64 158.742 147.267C158.796 146.467 159.069 145.82 159.562 145.327C160.069 144.833 160.789 144.587 161.722 144.587C162.669 144.587 163.389 144.833 163.882 145.327C164.389 145.82 164.662 146.467 164.702 147.267C164.729 147.64 164.742 147.953 164.742 148.207C164.742 148.46 164.729 148.76 164.702 149.107C164.662 149.907 164.376 150.553 163.842 151.047C163.322 151.54 162.616 151.787 161.722 151.787ZM161.722 150.227C162.016 150.227 162.242 150.167 162.402 150.047C162.576 149.927 162.702 149.773 162.782 149.587C162.862 149.4 162.902 149.213 162.902 149.027C162.929 148.693 162.942 148.413 162.942 148.187C162.942 147.947 162.929 147.673 162.902 147.367C162.889 147.047 162.796 146.76 162.622 146.507C162.449 146.253 162.149 146.127 161.722 146.127C161.309 146.127 161.016 146.253 160.842 146.507C160.669 146.76 160.569 147.047 160.542 147.367C160.529 147.673 160.522 147.947 160.522 148.187C160.522 148.413 160.529 148.693 160.542 149.027C160.569 149.213 160.616 149.4 160.682 149.587C160.762 149.773 160.882 149.927 161.042 150.047C161.216 150.167 161.442 150.227 161.722 150.227ZM153.742 144.707C152.849 144.707 152.142 144.473 151.622 144.007C151.102 143.54 150.816 142.907 150.762 142.107C150.749 141.76 150.742 141.46 150.742 141.207C150.742 140.94 150.749 140.62 150.762 140.247C150.816 139.447 151.089 138.8 151.582 138.307C152.089 137.813 152.809 137.567 153.742 137.567C154.689 137.567 155.409 137.813 155.902 138.307C156.409 138.8 156.682 139.447 156.722 140.247C156.749 140.62 156.762 140.94 156.762 141.207C156.762 141.46 156.749 141.76 156.722 142.107C156.682 142.907 156.396 143.54 155.862 144.007C155.342 144.473 154.636 144.707 153.742 144.707ZM153.742 143.227C154.036 143.227 154.262 143.167 154.422 143.047C154.596 142.927 154.722 142.773 154.802 142.587C154.882 142.4 154.922 142.207 154.922 142.007C154.949 141.673 154.962 141.393 154.962 141.167C154.962 140.927 154.949 140.653 154.922 140.347C154.909 140.04 154.816 139.76 154.642 139.507C154.469 139.253 154.169 139.127 153.742 139.127C153.329 139.127 153.036 139.253 152.862 139.507C152.689 139.76 152.596 140.04 152.582 140.347C152.569 140.653 152.562 140.927 152.562 141.167C152.562 141.393 152.569 141.673 152.582 142.007C152.596 142.207 152.636 142.4 152.702 142.587C152.782 142.773 152.902 142.927 153.062 143.047C153.236 143.167 153.462 143.227 153.742 143.227Z" fill="#212328"/>
<g clip-path="url(#clip2_2438_30649)">
<rect x="182.5" y="52" width="96" height="62.9939" fill="#0294F7"/>
<rect x="182.5" y="115.994" width="96" height="24.2849" fill="#D057FF"/>
<rect x="182.5" y="141.279" width="96" height="18.7212" fill="#E19701"/>
</g>
<defs>
<clipPath id="clip0_2438_30649">
<rect x="16" y="96" width="20" height="20" rx="10" fill="white"/>
</clipPath>
<clipPath id="clip1_2438_30649">
<rect width="20" height="20" fill="white" transform="translate(16 134.667)"/>
</clipPath>
<clipPath id="clip2_2438_30649">
<rect x="182.5" y="52" width="96" height="108" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $c49aa0f374b6c6e6$export$f6c885235639e0c1 = `<svg width="295" height="176" viewBox="0 0 295 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="293.5" height="175" rx="7.5" fill="#131D2D"/>
<rect x="0.5" y="0.5" width="293.5" height="175" rx="7.5" stroke="#576883"/>
<path d="M17.428 33C17.3347 33 17.2553 32.9673 17.19 32.902C17.1247 32.8367 17.092 32.7573 17.092 32.664V23.536C17.092 23.4427 17.1247 23.3633 17.19 23.298C17.2553 23.2327 17.3347 23.2 17.428 23.2H18.744C18.8467 23.2 18.926 23.2327 18.982 23.298C19.0473 23.3633 19.08 23.4427 19.08 23.536V32.664C19.08 32.7573 19.0473 32.8367 18.982 32.902C18.926 32.9673 18.8467 33 18.744 33H17.428ZM23.8096 33.14C23.3243 33.14 22.8949 33.0607 22.5216 32.902C22.1576 32.734 21.8543 32.5007 21.6116 32.202C21.3689 31.9033 21.1823 31.5533 21.0516 31.152C20.9209 30.7413 20.8463 30.2933 20.8276 29.808C20.8183 29.64 20.8136 29.4907 20.8136 29.36C20.8136 29.22 20.8183 29.066 20.8276 28.898C20.8463 28.4313 20.9163 27.9973 21.0376 27.596C21.1683 27.1947 21.3549 26.8447 21.5976 26.546C21.8496 26.238 22.1576 26 22.5216 25.832C22.8949 25.664 23.3243 25.58 23.8096 25.58C24.3136 25.58 24.7383 25.6687 25.0836 25.846C25.4383 26.014 25.7323 26.2333 25.9656 26.504V23.396C25.9656 23.3027 25.9936 23.2233 26.0496 23.158C26.1149 23.0927 26.1989 23.06 26.3016 23.06H27.4916C27.5849 23.06 27.6643 23.0927 27.7296 23.158C27.7949 23.2233 27.8276 23.3027 27.8276 23.396V32.664C27.8276 32.7573 27.7949 32.8367 27.7296 32.902C27.6643 32.9673 27.5849 33 27.4916 33H26.3856C26.2829 33 26.1989 32.9673 26.1336 32.902C26.0776 32.8367 26.0496 32.7573 26.0496 32.664V32.146C25.8163 32.4353 25.5176 32.6733 25.1536 32.86C24.7989 33.0467 24.3509 33.14 23.8096 33.14ZM24.3276 31.642C24.7196 31.642 25.0323 31.5533 25.2656 31.376C25.4989 31.1987 25.6716 30.9747 25.7836 30.704C25.8956 30.424 25.9563 30.1393 25.9656 29.85C25.9749 29.682 25.9796 29.5047 25.9796 29.318C25.9796 29.122 25.9749 28.94 25.9656 28.772C25.9563 28.492 25.8909 28.226 25.7696 27.974C25.6483 27.7127 25.4709 27.498 25.2376 27.33C25.0043 27.162 24.7009 27.078 24.3276 27.078C23.9356 27.078 23.6229 27.1667 23.3896 27.344C23.1656 27.512 23.0023 27.736 22.8996 28.016C22.7969 28.296 22.7363 28.604 22.7176 28.94C22.7083 29.22 22.7083 29.5 22.7176 29.78C22.7363 30.116 22.7969 30.424 22.8996 30.704C23.0023 30.984 23.1656 31.2127 23.3896 31.39C23.6229 31.558 23.9356 31.642 24.3276 31.642ZM32.8295 33.14C31.7935 33.14 30.9722 32.8413 30.3655 32.244C29.7589 31.6467 29.4322 30.7973 29.3855 29.696C29.3762 29.6027 29.3715 29.486 29.3715 29.346C29.3715 29.1967 29.3762 29.08 29.3855 28.996C29.4229 28.2867 29.5815 27.68 29.8615 27.176C30.1509 26.6627 30.5475 26.2707 31.0515 26C31.5555 25.72 32.1482 25.58 32.8295 25.58C33.5855 25.58 34.2202 25.7387 34.7335 26.056C35.2469 26.364 35.6342 26.798 35.8955 27.358C36.1569 27.9087 36.2875 28.548 36.2875 29.276V29.57C36.2875 29.6633 36.2549 29.7427 36.1895 29.808C36.1242 29.8733 36.0402 29.906 35.9375 29.906H31.2895C31.2895 29.906 31.2895 29.92 31.2895 29.948C31.2895 29.976 31.2895 29.9993 31.2895 30.018C31.2989 30.3447 31.3595 30.648 31.4715 30.928C31.5929 31.1987 31.7655 31.418 31.9895 31.586C32.2229 31.754 32.4982 31.838 32.8155 31.838C33.0769 31.838 33.2962 31.8007 33.4735 31.726C33.6509 31.642 33.7955 31.5487 33.9075 31.446C34.0195 31.3433 34.0989 31.2593 34.1455 31.194C34.2295 31.082 34.2949 31.0167 34.3415 30.998C34.3975 30.97 34.4769 30.956 34.5795 30.956H35.7835C35.8769 30.956 35.9515 30.984 36.0075 31.04C36.0729 31.096 36.1009 31.166 36.0915 31.25C36.0822 31.3993 36.0029 31.5813 35.8535 31.796C35.7135 32.0107 35.5082 32.2207 35.2375 32.426C34.9669 32.6313 34.6262 32.804 34.2155 32.944C33.8142 33.0747 33.3522 33.14 32.8295 33.14ZM31.2895 28.73H34.3835V28.688C34.3835 28.324 34.3229 28.0067 34.2015 27.736C34.0802 27.456 33.9029 27.2413 33.6695 27.092C33.4362 26.9333 33.1562 26.854 32.8295 26.854C32.5029 26.854 32.2229 26.9333 31.9895 27.092C31.7562 27.2413 31.5789 27.456 31.4575 27.736C31.3455 28.0067 31.2895 28.324 31.2895 28.688V28.73ZM38.1096 33C38.0163 33 37.9369 32.9673 37.8716 32.902C37.8063 32.8367 37.7736 32.7573 37.7736 32.664V26.056C37.7736 25.9627 37.8063 25.8833 37.8716 25.818C37.9369 25.7527 38.0163 25.72 38.1096 25.72H39.2576C39.3509 25.72 39.4303 25.7527 39.4956 25.818C39.5609 25.8833 39.5936 25.9627 39.5936 26.056V26.63C39.8363 26.3313 40.1443 26.084 40.5176 25.888C40.9003 25.6827 41.3716 25.58 41.9316 25.58C42.5009 25.58 42.9956 25.7107 43.4156 25.972C43.8356 26.224 44.1576 26.5833 44.3816 27.05C44.6149 27.5167 44.7316 28.0767 44.7316 28.73V32.664C44.7316 32.7573 44.6989 32.8367 44.6336 32.902C44.5683 32.9673 44.4889 33 44.3956 33H43.1636C43.0703 33 42.9909 32.9673 42.9256 32.902C42.8603 32.8367 42.8276 32.7573 42.8276 32.664V28.814C42.8276 28.2727 42.6923 27.848 42.4216 27.54C42.1603 27.232 41.7776 27.078 41.2736 27.078C40.7883 27.078 40.4009 27.232 40.1116 27.54C39.8223 27.848 39.6776 28.2727 39.6776 28.814V32.664C39.6776 32.7573 39.6449 32.8367 39.5796 32.902C39.5143 32.9673 39.4349 33 39.3416 33H38.1096ZM49.7179 33C49.1579 33 48.6866 32.902 48.3039 32.706C47.9212 32.51 47.6366 32.2207 47.4499 31.838C47.2632 31.446 47.1699 30.9607 47.1699 30.382V27.204H46.0639C45.9706 27.204 45.8912 27.1713 45.8259 27.106C45.7606 27.0407 45.7279 26.9567 45.7279 26.854V26.056C45.7279 25.9627 45.7606 25.8833 45.8259 25.818C45.8912 25.7527 45.9706 25.72 46.0639 25.72H47.1699V23.396C47.1699 23.3027 47.1979 23.2233 47.2539 23.158C47.3192 23.0927 47.4032 23.06 47.5059 23.06H48.6399C48.7332 23.06 48.8126 23.0927 48.8779 23.158C48.9432 23.2233 48.9759 23.3027 48.9759 23.396V25.72H50.7259C50.8192 25.72 50.8986 25.7527 50.9639 25.818C51.0292 25.8833 51.0619 25.9627 51.0619 26.056V26.854C51.0619 26.9567 51.0292 27.0407 50.9639 27.106C50.8986 27.1713 50.8192 27.204 50.7259 27.204H48.9759V30.242C48.9759 30.6247 49.0412 30.9233 49.1719 31.138C49.3119 31.3527 49.5499 31.46 49.8859 31.46H50.8519C50.9452 31.46 51.0246 31.4927 51.0899 31.558C51.1552 31.6233 51.1879 31.7027 51.1879 31.796V32.664C51.1879 32.7573 51.1552 32.8367 51.0899 32.902C51.0246 32.9673 50.9452 33 50.8519 33H49.7179ZM52.7659 33C52.6725 33 52.5932 32.9673 52.5279 32.902C52.4625 32.8367 52.4299 32.7573 52.4299 32.664V26.056C52.4299 25.9627 52.4625 25.8833 52.5279 25.818C52.5932 25.7527 52.6725 25.72 52.7659 25.72H53.9279C54.0305 25.72 54.1099 25.7527 54.1659 25.818C54.2312 25.8833 54.2639 25.9627 54.2639 26.056V32.664C54.2639 32.7573 54.2312 32.8367 54.1659 32.902C54.1099 32.9673 54.0305 33 53.9279 33H52.7659ZM52.7099 24.516C52.6165 24.516 52.5372 24.4833 52.4719 24.418C52.4065 24.3527 52.3739 24.2733 52.3739 24.18V23.172C52.3739 23.0787 52.4065 22.9993 52.4719 22.934C52.5372 22.8687 52.6165 22.836 52.7099 22.836H53.9839C54.0865 22.836 54.1705 22.8687 54.2359 22.934C54.3012 22.9993 54.3339 23.0787 54.3339 23.172V24.18C54.3339 24.2733 54.3012 24.3527 54.2359 24.418C54.1705 24.4833 54.0865 24.516 53.9839 24.516H52.7099ZM59.4113 33C58.8513 33 58.3799 32.902 57.9973 32.706C57.6146 32.51 57.3299 32.2207 57.1433 31.838C56.9566 31.446 56.8633 30.9607 56.8633 30.382V27.204H55.7573C55.6639 27.204 55.5846 27.1713 55.5193 27.106C55.4539 27.0407 55.4213 26.9567 55.4213 26.854V26.056C55.4213 25.9627 55.4539 25.8833 55.5193 25.818C55.5846 25.7527 55.6639 25.72 55.7573 25.72H56.8633V23.396C56.8633 23.3027 56.8913 23.2233 56.9473 23.158C57.0126 23.0927 57.0966 23.06 57.1993 23.06H58.3333C58.4266 23.06 58.5059 23.0927 58.5713 23.158C58.6366 23.2233 58.6693 23.3027 58.6693 23.396V25.72H60.4193C60.5126 25.72 60.5919 25.7527 60.6573 25.818C60.7226 25.8833 60.7553 25.9627 60.7553 26.056V26.854C60.7553 26.9567 60.7226 27.0407 60.6573 27.106C60.5919 27.1713 60.5126 27.204 60.4193 27.204H58.6693V30.242C58.6693 30.6247 58.7346 30.9233 58.8653 31.138C59.0053 31.3527 59.2433 31.46 59.5793 31.46H60.5453C60.6386 31.46 60.7179 31.4927 60.7833 31.558C60.8486 31.6233 60.8813 31.7027 60.8813 31.796V32.664C60.8813 32.7573 60.8486 32.8367 60.7833 32.902C60.7179 32.9673 60.6386 33 60.5453 33H59.4113ZM63.4392 35.66C63.3646 35.66 63.2992 35.632 63.2432 35.576C63.1872 35.52 63.1592 35.4547 63.1592 35.38C63.1592 35.3427 63.1592 35.3053 63.1592 35.268C63.1686 35.24 63.1872 35.2027 63.2152 35.156L64.3072 32.566L61.6192 26.224C61.5819 26.1307 61.5632 26.0653 61.5632 26.028C61.5726 25.944 61.6052 25.874 61.6612 25.818C61.7172 25.7527 61.7872 25.72 61.8712 25.72H63.0052C63.1172 25.72 63.2012 25.748 63.2572 25.804C63.3132 25.86 63.3552 25.9207 63.3832 25.986L65.2452 30.564L67.1632 25.986C67.1912 25.9113 67.2332 25.8507 67.2892 25.804C67.3452 25.748 67.4292 25.72 67.5412 25.72H68.6612C68.7359 25.72 68.8012 25.748 68.8572 25.804C68.9226 25.86 68.9552 25.9253 68.9552 26C68.9552 26.056 68.9366 26.1307 68.8992 26.224L64.9372 35.394C64.8999 35.4687 64.8532 35.5293 64.7972 35.576C64.7412 35.632 64.6572 35.66 64.5452 35.66H63.4392ZM76.5624 33.14C75.6944 33.14 74.9664 33.014 74.3784 32.762C73.7997 32.5007 73.3564 32.1647 73.0484 31.754C72.7497 31.334 72.591 30.8953 72.5724 30.438C72.5724 30.354 72.6004 30.284 72.6564 30.228C72.7124 30.172 72.7824 30.144 72.8664 30.144H74.1124C74.2337 30.144 74.3224 30.172 74.3784 30.228C74.4437 30.2747 74.4997 30.3353 74.5464 30.41C74.6024 30.5873 74.7097 30.7647 74.8684 30.942C75.027 31.11 75.2417 31.25 75.5124 31.362C75.7924 31.474 76.1424 31.53 76.5624 31.53C77.2344 31.53 77.7337 31.418 78.0604 31.194C78.3964 30.97 78.5644 30.6667 78.5644 30.284C78.5644 30.0133 78.4757 29.7987 78.2984 29.64C78.121 29.472 77.8457 29.3227 77.4724 29.192C77.1084 29.052 76.623 28.9073 76.0164 28.758C75.3164 28.59 74.7284 28.3893 74.2524 28.156C73.7857 27.9133 73.431 27.61 73.1884 27.246C72.955 26.882 72.8384 26.42 72.8384 25.86C72.8384 25.3187 72.983 24.838 73.2724 24.418C73.571 23.998 73.991 23.6667 74.5324 23.424C75.083 23.1813 75.7364 23.06 76.4924 23.06C77.099 23.06 77.6357 23.144 78.1024 23.312C78.569 23.4707 78.9564 23.6853 79.2644 23.956C79.5724 24.2173 79.8057 24.502 79.9644 24.81C80.1324 25.1087 80.221 25.4027 80.2304 25.692C80.2304 25.7667 80.2024 25.8367 80.1464 25.902C80.0997 25.958 80.0297 25.986 79.9364 25.986H78.6344C78.5597 25.986 78.485 25.9673 78.4104 25.93C78.3357 25.8927 78.275 25.8227 78.2284 25.72C78.1724 25.4307 77.9904 25.1833 77.6824 24.978C77.3744 24.7727 76.9777 24.67 76.4924 24.67C75.9884 24.67 75.5824 24.7633 75.2744 24.95C74.9664 25.1367 74.8124 25.426 74.8124 25.818C74.8124 26.0793 74.887 26.2987 75.0364 26.476C75.195 26.644 75.4424 26.7933 75.7784 26.924C76.1237 27.0547 76.5764 27.1947 77.1364 27.344C77.9297 27.5213 78.5784 27.7267 79.0824 27.96C79.5864 28.1933 79.955 28.492 80.1884 28.856C80.4217 29.2107 80.5384 29.6633 80.5384 30.214C80.5384 30.83 80.3704 31.3573 80.0344 31.796C79.7077 32.2253 79.2457 32.5567 78.6484 32.79C78.051 33.0233 77.3557 33.14 76.5624 33.14ZM85.1948 33.14C84.4481 33.14 83.8181 33.0093 83.3048 32.748C82.8008 32.4867 82.4134 32.118 82.1428 31.642C81.8814 31.166 81.7321 30.6107 81.6948 29.976C81.6854 29.808 81.6808 29.6027 81.6808 29.36C81.6808 29.1173 81.6854 28.912 81.6948 28.744C81.7321 28.1 81.8861 27.5447 82.1568 27.078C82.4368 26.602 82.8288 26.2333 83.3328 25.972C83.8461 25.7107 84.4668 25.58 85.1948 25.58C85.9228 25.58 86.5388 25.7107 87.0428 25.972C87.5561 26.2333 87.9481 26.602 88.2188 27.078C88.4988 27.5447 88.6574 28.1 88.6948 28.744C88.7041 28.912 88.7088 29.1173 88.7088 29.36C88.7088 29.6027 88.7041 29.808 88.6948 29.976C88.6574 30.6107 88.5034 31.166 88.2328 31.642C87.9714 32.118 87.5841 32.4867 87.0708 32.748C86.5668 33.0093 85.9414 33.14 85.1948 33.14ZM85.1948 31.754C85.6894 31.754 86.0721 31.6 86.3428 31.292C86.6134 30.9747 86.7628 30.5127 86.7908 29.906C86.8001 29.766 86.8048 29.584 86.8048 29.36C86.8048 29.136 86.8001 28.954 86.7908 28.814C86.7628 28.2073 86.6134 27.75 86.3428 27.442C86.0721 27.1247 85.6894 26.966 85.1948 26.966C84.7001 26.966 84.3174 27.1247 84.0468 27.442C83.7761 27.75 83.6268 28.2073 83.5988 28.814C83.5894 28.954 83.5848 29.136 83.5848 29.36C83.5848 29.584 83.5894 29.766 83.5988 29.906C83.6268 30.5127 83.7761 30.9747 84.0468 31.292C84.3174 31.6 84.7001 31.754 85.1948 31.754ZM92.9619 33.14C92.3926 33.14 91.8979 33.014 91.4779 32.762C91.0673 32.5007 90.7499 32.1367 90.5259 31.67C90.3019 31.194 90.1899 30.634 90.1899 29.99V26.056C90.1899 25.9627 90.2226 25.8833 90.2879 25.818C90.3533 25.7527 90.4326 25.72 90.5259 25.72H91.7579C91.8606 25.72 91.9399 25.7527 91.9959 25.818C92.0613 25.8833 92.0939 25.9627 92.0939 26.056V29.906C92.0939 31.0633 92.6026 31.642 93.6199 31.642C94.1053 31.642 94.4879 31.488 94.7679 31.18C95.0573 30.872 95.2019 30.4473 95.2019 29.906V26.056C95.2019 25.9627 95.2346 25.8833 95.2999 25.818C95.3653 25.7527 95.4446 25.72 95.5379 25.72H96.7699C96.8633 25.72 96.9426 25.7527 97.0079 25.818C97.0733 25.8833 97.1059 25.9627 97.1059 26.056V32.664C97.1059 32.7573 97.0733 32.8367 97.0079 32.902C96.9426 32.9673 96.8633 33 96.7699 33H95.6359C95.5333 33 95.4493 32.9673 95.3839 32.902C95.3279 32.8367 95.2999 32.7573 95.2999 32.664V32.09C95.0479 32.4167 94.7353 32.6733 94.3619 32.86C93.9886 33.0467 93.5219 33.14 92.9619 33.14ZM99.2913 33C99.1979 33 99.1186 32.9673 99.0533 32.902C98.9879 32.8367 98.9552 32.7573 98.9552 32.664V26.07C98.9552 25.9673 98.9879 25.8833 99.0533 25.818C99.1186 25.7527 99.1979 25.72 99.2913 25.72H100.425C100.519 25.72 100.598 25.7527 100.663 25.818C100.738 25.8833 100.775 25.9673 100.775 26.07V26.644C100.99 26.3453 101.265 26.1167 101.601 25.958C101.947 25.7993 102.343 25.72 102.791 25.72H103.365C103.468 25.72 103.547 25.7527 103.603 25.818C103.669 25.8833 103.701 25.9627 103.701 26.056V27.064C103.701 27.1573 103.669 27.2367 103.603 27.302C103.547 27.3673 103.468 27.4 103.365 27.4H102.273C101.825 27.4 101.475 27.526 101.223 27.778C100.981 28.0207 100.859 28.366 100.859 28.814V32.664C100.859 32.7573 100.827 32.8367 100.761 32.902C100.696 32.9673 100.612 33 100.509 33H99.2913ZM107.847 33.14C107.175 33.14 106.583 33.014 106.069 32.762C105.565 32.51 105.169 32.146 104.879 31.67C104.599 31.1847 104.445 30.6013 104.417 29.92C104.408 29.78 104.403 29.598 104.403 29.374C104.403 29.1407 104.408 28.9493 104.417 28.8C104.445 28.1187 104.599 27.54 104.879 27.064C105.169 26.5787 105.565 26.21 106.069 25.958C106.583 25.706 107.175 25.58 107.847 25.58C108.445 25.58 108.953 25.664 109.373 25.832C109.793 25.9907 110.139 26.2007 110.409 26.462C110.68 26.714 110.881 26.98 111.011 27.26C111.151 27.5307 111.226 27.778 111.235 28.002C111.245 28.1047 111.212 28.1887 111.137 28.254C111.072 28.31 110.993 28.338 110.899 28.338H109.667C109.574 28.338 109.499 28.3147 109.443 28.268C109.397 28.2213 109.35 28.1513 109.303 28.058C109.163 27.6847 108.977 27.4233 108.743 27.274C108.519 27.1153 108.23 27.036 107.875 27.036C107.409 27.036 107.035 27.1853 106.755 27.484C106.485 27.7733 106.34 28.2353 106.321 28.87C106.303 29.2247 106.303 29.5513 106.321 29.85C106.34 30.494 106.485 30.9607 106.755 31.25C107.035 31.5393 107.409 31.684 107.875 31.684C108.239 31.684 108.533 31.6093 108.757 31.46C108.981 31.3013 109.163 31.0353 109.303 30.662C109.35 30.5687 109.397 30.4987 109.443 30.452C109.499 30.4053 109.574 30.382 109.667 30.382H110.899C110.993 30.382 111.072 30.4147 111.137 30.48C111.212 30.536 111.245 30.6153 111.235 30.718C111.226 30.886 111.179 31.0773 111.095 31.292C111.021 31.4973 110.895 31.712 110.717 31.936C110.549 32.1507 110.335 32.3513 110.073 32.538C109.812 32.7153 109.495 32.86 109.121 32.972C108.757 33.084 108.333 33.14 107.847 33.14ZM115.831 33.14C114.795 33.14 113.974 32.8413 113.367 32.244C112.761 31.6467 112.434 30.7973 112.387 29.696C112.378 29.6027 112.373 29.486 112.373 29.346C112.373 29.1967 112.378 29.08 112.387 28.996C112.425 28.2867 112.583 27.68 112.863 27.176C113.153 26.6627 113.549 26.2707 114.053 26C114.557 25.72 115.15 25.58 115.831 25.58C116.587 25.58 117.222 25.7387 117.735 26.056C118.249 26.364 118.636 26.798 118.897 27.358C119.159 27.9087 119.289 28.548 119.289 29.276V29.57C119.289 29.6633 119.257 29.7427 119.191 29.808C119.126 29.8733 119.042 29.906 118.939 29.906H114.291C114.291 29.906 114.291 29.92 114.291 29.948C114.291 29.976 114.291 29.9993 114.291 30.018C114.301 30.3447 114.361 30.648 114.473 30.928C114.595 31.1987 114.767 31.418 114.991 31.586C115.225 31.754 115.5 31.838 115.817 31.838C116.079 31.838 116.298 31.8007 116.475 31.726C116.653 31.642 116.797 31.5487 116.909 31.446C117.021 31.3433 117.101 31.2593 117.147 31.194C117.231 31.082 117.297 31.0167 117.343 30.998C117.399 30.97 117.479 30.956 117.581 30.956H118.785C118.879 30.956 118.953 30.984 119.009 31.04C119.075 31.096 119.103 31.166 119.093 31.25C119.084 31.3993 119.005 31.5813 118.855 31.796C118.715 32.0107 118.51 32.2207 118.239 32.426C117.969 32.6313 117.628 32.804 117.217 32.944C116.816 33.0747 116.354 33.14 115.831 33.14ZM114.291 28.73H117.385V28.688C117.385 28.324 117.325 28.0067 117.203 27.736C117.082 27.456 116.905 27.2413 116.671 27.092C116.438 26.9333 116.158 26.854 115.831 26.854C115.505 26.854 115.225 26.9333 114.991 27.092C114.758 27.2413 114.581 27.456 114.459 27.736C114.347 28.0067 114.291 28.324 114.291 28.688V28.73ZM123.534 33.14C122.974 33.14 122.493 33.0747 122.092 32.944C121.7 32.8133 121.378 32.65 121.126 32.454C120.874 32.258 120.687 32.062 120.566 31.866C120.444 31.67 120.379 31.5067 120.37 31.376C120.36 31.2733 120.388 31.194 120.454 31.138C120.528 31.0727 120.608 31.04 120.692 31.04H121.798C121.835 31.04 121.868 31.0447 121.896 31.054C121.924 31.0633 121.961 31.0913 122.008 31.138C122.129 31.2407 122.255 31.348 122.386 31.46C122.526 31.572 122.689 31.67 122.876 31.754C123.062 31.8287 123.296 31.866 123.576 31.866C123.94 31.866 124.243 31.796 124.486 31.656C124.738 31.5067 124.864 31.2967 124.864 31.026C124.864 30.83 124.808 30.6713 124.696 30.55C124.593 30.4287 124.397 30.3213 124.108 30.228C123.818 30.1253 123.408 30.018 122.876 29.906C122.353 29.7847 121.919 29.6307 121.574 29.444C121.228 29.2573 120.972 29.024 120.804 28.744C120.636 28.464 120.552 28.1373 120.552 27.764C120.552 27.4 120.659 27.0547 120.874 26.728C121.098 26.392 121.424 26.1167 121.854 25.902C122.292 25.6873 122.834 25.58 123.478 25.58C123.982 25.58 124.42 25.6453 124.794 25.776C125.167 25.8973 125.475 26.0513 125.718 26.238C125.97 26.4247 126.161 26.616 126.292 26.812C126.422 26.9987 126.492 27.162 126.502 27.302C126.511 27.4047 126.483 27.4887 126.418 27.554C126.352 27.61 126.278 27.638 126.194 27.638H125.158C125.111 27.638 125.069 27.6287 125.032 27.61C124.994 27.5913 124.957 27.568 124.92 27.54C124.817 27.4467 124.705 27.3487 124.584 27.246C124.462 27.134 124.313 27.0407 124.136 26.966C123.968 26.8913 123.744 26.854 123.464 26.854C123.109 26.854 122.838 26.9333 122.652 27.092C122.465 27.2413 122.372 27.4327 122.372 27.666C122.372 27.8247 122.414 27.9647 122.498 28.086C122.591 28.198 122.773 28.3053 123.044 28.408C123.314 28.5107 123.725 28.618 124.276 28.73C124.901 28.842 125.396 29.01 125.76 29.234C126.133 29.4487 126.394 29.7007 126.544 29.99C126.702 30.27 126.782 30.5827 126.782 30.928C126.782 31.348 126.656 31.726 126.404 32.062C126.161 32.398 125.797 32.664 125.312 32.86C124.836 33.0467 124.243 33.14 123.534 33.14Z" fill="#F3F4F7"/>
<rect x="15" y="56.3333" width="22" height="22" rx="11" stroke="#0294F7" stroke-width="2"/>
<path d="M36 67.3333C36 72.8561 31.5228 77.3333 26 77.3333C20.4772 77.3333 16 72.8561 16 67.3333C16 61.8104 20.4772 57.3333 26 57.3333C31.5228 57.3333 36 61.8104 36 67.3333Z" fill="#005CB9"/>
<path d="M30.7471 64.7239C30.3878 63.776 29.7486 62.96 28.9144 62.3841C28.0803 61.8082 27.0906 61.4998 26.077 61.4998C25.0633 61.4998 24.0737 61.8082 23.2395 62.3841C22.4054 62.96 21.7662 63.776 21.4069 64.7239C21.3708 64.8052 21.3559 64.8943 21.3637 64.9829C21.3714 65.0715 21.4014 65.1567 21.451 65.2305C21.519 65.3207 21.6096 65.3914 21.7136 65.4354C21.8176 65.4794 21.9313 65.4953 22.0434 65.4813C22.1555 65.4674 22.2619 65.4242 22.3519 65.356C22.442 65.2878 22.5124 65.1971 22.5563 65.093C22.8321 64.3835 23.3158 63.7739 23.9441 63.344C24.5724 62.9142 25.3158 62.6842 26.0771 62.6842C26.8383 62.6842 27.5818 62.9142 28.2101 63.344C28.8384 63.7739 29.3221 64.3835 29.5979 65.093C29.6418 65.1969 29.7123 65.2874 29.8022 65.3554C29.8922 65.4234 29.9984 65.4665 30.1103 65.4805C30.2222 65.4944 30.3358 65.4786 30.4397 65.4348C30.5435 65.3909 30.634 65.3205 30.7021 65.2305C30.7519 65.1568 30.7821 65.0716 30.7899 64.983C30.7977 64.8943 30.7828 64.8052 30.7467 64.7239" fill="#F37D02"/>
<path d="M29.2194 72.9228C29.1979 72.9994 29.15 73.0659 29.0842 73.1105C29.0183 73.1551 28.9389 73.175 28.8598 73.1666H27.7179C27.5304 73.1666 27.4367 73.1124 27.3908 72.9228L26.3112 68.783C26.2108 68.3224 26.1373 67.8564 26.0912 67.3872C26.0561 67.8576 25.9833 68.3243 25.8735 68.783L24.7954 72.9226C24.7763 73.0002 24.7292 73.0681 24.6631 73.1131C24.5971 73.1581 24.5167 73.1772 24.4375 73.1666H23.2787C23.0912 73.1666 22.9969 73.1124 22.9502 72.9228L21.3723 66.9699C21.3586 66.9314 21.3547 66.8901 21.361 66.8497C21.3674 66.8093 21.3837 66.7712 21.4086 66.7387C21.4334 66.7063 21.466 66.6806 21.5033 66.6639C21.5406 66.6473 21.5815 66.6403 21.6223 66.6435H22.3571C22.3986 66.6369 22.4411 66.6388 22.4819 66.649C22.5227 66.6592 22.561 66.6776 22.5945 66.703C22.6281 66.7283 22.6561 66.7602 22.6771 66.7967C22.698 66.8332 22.7113 66.8736 22.7162 66.9153L23.7173 71.1653C23.8083 71.6436 23.8709 72.1269 23.9048 72.6126C23.9831 72.1666 24.0452 71.6391 24.1694 71.1787L25.2804 66.9028C25.3017 66.822 25.3513 66.7515 25.4201 66.7041C25.4888 66.6566 25.5723 66.6353 25.6554 66.6441H26.5625C26.6489 66.6377 26.7349 66.6613 26.8061 66.7108C26.8772 66.7603 26.9292 66.8327 26.9533 66.916L28.0783 71.1787C28.192 71.6509 28.2755 72.1298 28.3283 72.6126C28.3908 72.1666 28.4533 71.6391 28.5479 71.1787L29.4696 66.9028C29.4888 66.8208 29.5378 66.7489 29.6071 66.7011C29.6765 66.6532 29.7611 66.6329 29.8446 66.6441H30.5321C30.5719 66.639 30.6124 66.6442 30.6497 66.6593C30.687 66.6744 30.7197 66.6988 30.7448 66.7302C30.7699 66.7615 30.7865 66.7988 30.7931 66.8385C30.7996 66.8781 30.7958 66.9188 30.7821 66.9566L29.2196 72.9233" fill="white"/>
<path d="M46.87 66.3333C46.7487 66.3333 46.6507 66.3006 46.576 66.2353C46.5107 66.1699 46.464 66.0766 46.436 65.9553L44.63 56.9673C44.6207 56.9299 44.616 56.8973 44.616 56.8693C44.616 56.8413 44.616 56.8226 44.616 56.8133C44.616 56.7386 44.644 56.6733 44.7 56.6173C44.756 56.5613 44.8213 56.5333 44.896 56.5333H45.624C45.82 56.5333 45.932 56.6126 45.96 56.7713L47.388 63.9953L48.9 59.0393C48.928 58.9553 48.9747 58.8806 49.04 58.8153C49.1147 58.7406 49.2173 58.7033 49.348 58.7033H49.866C50.006 58.7033 50.1087 58.7406 50.174 58.8153C50.2393 58.8806 50.2813 58.9553 50.3 59.0393L51.826 63.9953L53.24 56.7713C53.268 56.6126 53.3847 56.5333 53.59 56.5333H54.318C54.3927 56.5333 54.458 56.5613 54.514 56.6173C54.57 56.6733 54.598 56.7386 54.598 56.8133C54.598 56.8226 54.5933 56.8413 54.584 56.8693C54.584 56.8973 54.584 56.9299 54.584 56.9673L52.778 65.9553C52.75 66.0766 52.6987 66.1699 52.624 66.2353C52.5587 66.3006 52.4653 66.3333 52.344 66.3333H51.798C51.6673 66.3333 51.5647 66.3006 51.49 66.2353C51.4153 66.1699 51.364 66.0859 51.336 65.9833L49.6 60.6493L47.878 65.9833C47.8407 66.0859 47.7847 66.1699 47.71 66.2353C47.6447 66.3006 47.5467 66.3333 47.416 66.3333H46.87ZM58.9282 66.4733C58.2188 66.4733 57.6262 66.3379 57.1502 66.0673C56.6742 65.7966 56.3102 65.4233 56.0582 64.9473C55.8062 64.4619 55.6662 63.9113 55.6382 63.2953C55.6288 63.1366 55.6242 62.9359 55.6242 62.6933C55.6242 62.4413 55.6288 62.2406 55.6382 62.0913C55.6662 61.4659 55.8062 60.9153 56.0582 60.4393C56.3195 59.9633 56.6882 59.5899 57.1642 59.3193C57.6402 59.0486 58.2282 58.9133 58.9282 58.9133C59.6282 58.9133 60.2162 59.0486 60.6922 59.3193C61.1682 59.5899 61.5322 59.9633 61.7842 60.4393C62.0455 60.9153 62.1902 61.4659 62.2182 62.0913C62.2275 62.2406 62.2322 62.4413 62.2322 62.6933C62.2322 62.9359 62.2275 63.1366 62.2182 63.2953C62.1902 63.9113 62.0502 64.4619 61.7982 64.9473C61.5462 65.4233 61.1822 65.7966 60.7062 66.0673C60.2302 66.3379 59.6375 66.4733 58.9282 66.4733ZM58.9282 65.3953C59.5068 65.3953 59.9688 65.2133 60.3142 64.8493C60.6595 64.4759 60.8462 63.9346 60.8742 63.2253C60.8835 63.0853 60.8882 62.9079 60.8882 62.6933C60.8882 62.4786 60.8835 62.3013 60.8742 62.1613C60.8462 61.4519 60.6595 60.9153 60.3142 60.5513C59.9688 60.1779 59.5068 59.9913 58.9282 59.9913C58.3495 59.9913 57.8828 60.1779 57.5282 60.5513C57.1828 60.9153 57.0008 61.4519 56.9822 62.1613C56.9728 62.3013 56.9682 62.4786 56.9682 62.6933C56.9682 62.9079 56.9728 63.0853 56.9822 63.2253C57.0008 63.9346 57.1828 64.4759 57.5282 64.8493C57.8828 65.2133 58.3495 65.3953 58.9282 65.3953ZM64.3072 66.3333C64.2139 66.3333 64.1346 66.3053 64.0692 66.2493C64.0132 66.1839 63.9852 66.1046 63.9852 66.0113V59.3893C63.9852 59.2959 64.0132 59.2166 64.0692 59.1513C64.1346 59.0859 64.2139 59.0533 64.3072 59.0533H64.9512C65.0446 59.0533 65.1239 59.0859 65.1892 59.1513C65.2546 59.2166 65.2872 59.2959 65.2872 59.3893V60.0053C65.4739 59.6879 65.7306 59.4499 66.0572 59.2913C66.3839 59.1326 66.7806 59.0533 67.2472 59.0533H67.7932C67.8866 59.0533 67.9612 59.0859 68.0172 59.1513C68.0826 59.2073 68.1152 59.2819 68.1152 59.3753V59.9493C68.1152 60.0426 68.0826 60.1173 68.0172 60.1733C67.9612 60.2293 67.8866 60.2573 67.7932 60.2573H66.9532C66.4492 60.2573 66.0526 60.4066 65.7632 60.7053C65.4739 60.9946 65.3292 61.3913 65.3292 61.8953V66.0113C65.3292 66.1046 65.2966 66.1839 65.2312 66.2493C65.1659 66.3053 65.0866 66.3333 64.9932 66.3333H64.3072ZM69.6396 66.3333C69.5462 66.3333 69.4669 66.3053 69.4016 66.2493C69.3456 66.1839 69.3176 66.1046 69.3176 66.0113V56.7153C69.3176 56.6219 69.3456 56.5473 69.4016 56.4913C69.4669 56.4259 69.5462 56.3933 69.6396 56.3933H70.2976C70.3909 56.3933 70.4656 56.4259 70.5216 56.4913C70.5869 56.5473 70.6196 56.6219 70.6196 56.7153V61.5873L73.3776 59.2913C73.4896 59.1979 73.5736 59.1373 73.6296 59.1093C73.6949 59.0719 73.7976 59.0533 73.9376 59.0533H74.6796C74.7636 59.0533 74.8336 59.0813 74.8896 59.1373C74.9456 59.1933 74.9736 59.2633 74.9736 59.3473C74.9736 59.3846 74.9596 59.4266 74.9316 59.4733C74.9129 59.5199 74.8709 59.5666 74.8056 59.6133L71.5716 62.3013L75.1556 65.7873C75.2676 65.8806 75.3236 65.9646 75.3236 66.0393C75.3236 66.1233 75.2956 66.1933 75.2396 66.2493C75.1836 66.3053 75.1136 66.3333 75.0296 66.3333H74.3016C74.1616 66.3333 74.0589 66.3193 73.9936 66.2913C73.9282 66.2539 73.8442 66.1886 73.7416 66.0953L70.6196 63.1133V66.0113C70.6196 66.1046 70.5869 66.1839 70.5216 66.2493C70.4656 66.3053 70.3909 66.3333 70.2976 66.3333H69.6396ZM78.8405 66.4733C78.3272 66.4733 77.8839 66.3846 77.5105 66.2073C77.1372 66.0206 76.8292 65.7733 76.5865 65.4653C76.3532 65.1479 76.1759 64.7886 76.0545 64.3873C75.9425 63.9859 75.8772 63.5613 75.8585 63.1133C75.8492 62.9639 75.8445 62.8239 75.8445 62.6933C75.8445 62.5626 75.8492 62.4226 75.8585 62.2733C75.8772 61.8346 75.9425 61.4146 76.0545 61.0133C76.1759 60.6119 76.3532 60.2526 76.5865 59.9353C76.8292 59.6179 77.1372 59.3706 77.5105 59.1933C77.8839 59.0066 78.3272 58.9133 78.8405 58.9133C79.3912 58.9133 79.8485 59.0113 80.2125 59.2073C80.5765 59.4033 80.8752 59.6459 81.1085 59.9353V56.7153C81.1085 56.6219 81.1365 56.5473 81.1925 56.4913C81.2579 56.4259 81.3372 56.3933 81.4305 56.3933H82.1025C82.1959 56.3933 82.2705 56.4259 82.3265 56.4913C82.3919 56.5473 82.4245 56.6219 82.4245 56.7153V66.0113C82.4245 66.1046 82.3919 66.1839 82.3265 66.2493C82.2705 66.3053 82.1959 66.3333 82.1025 66.3333H81.4725C81.3699 66.3333 81.2905 66.3053 81.2345 66.2493C81.1785 66.1839 81.1505 66.1046 81.1505 66.0113V65.4233C80.9172 65.7219 80.6139 65.9739 80.2405 66.1793C79.8672 66.3753 79.4005 66.4733 78.8405 66.4733ZM79.1345 65.3393C79.6012 65.3393 79.9745 65.2319 80.2545 65.0173C80.5345 64.8026 80.7445 64.5319 80.8845 64.2053C81.0245 63.8693 81.0992 63.5286 81.1085 63.1833C81.1179 63.0339 81.1225 62.8566 81.1225 62.6513C81.1225 62.4366 81.1179 62.2546 81.1085 62.1053C81.0992 61.7786 81.0199 61.4566 80.8705 61.1393C80.7305 60.8219 80.5159 60.5606 80.2265 60.3553C79.9465 60.1499 79.5825 60.0473 79.1345 60.0473C78.6585 60.0473 78.2805 60.1546 78.0005 60.3693C77.7205 60.5746 77.5199 60.8499 77.3985 61.1953C77.2772 61.5313 77.2072 61.8953 77.1885 62.2873C77.1792 62.5579 77.1792 62.8286 77.1885 63.0993C77.2072 63.4913 77.2772 63.8599 77.3985 64.2053C77.5199 64.5413 77.7205 64.8166 78.0005 65.0313C78.2805 65.2366 78.6585 65.3393 79.1345 65.3393ZM86.5367 66.4733C86.07 66.4733 85.6454 66.3799 85.2627 66.1933C84.88 66.0066 84.572 65.7546 84.3387 65.4373C84.1054 65.1199 83.9887 64.7606 83.9887 64.3593C83.9887 63.7153 84.25 63.2019 84.7727 62.8193C85.2954 62.4366 85.9767 62.1846 86.8167 62.0633L88.9027 61.7693V61.3633C88.9027 60.9153 88.772 60.5653 88.5107 60.3133C88.2587 60.0613 87.8434 59.9353 87.2647 59.9353C86.854 59.9353 86.518 60.0193 86.2567 60.1873C85.9954 60.3553 85.8134 60.5699 85.7107 60.8313C85.6547 60.9713 85.5567 61.0413 85.4167 61.0413H84.7867C84.684 61.0413 84.6047 61.0133 84.5487 60.9573C84.502 60.8919 84.4787 60.8173 84.4787 60.7333C84.4787 60.5933 84.53 60.4206 84.6327 60.2153C84.7447 60.0099 84.9127 59.8093 85.1367 59.6133C85.3607 59.4173 85.6454 59.2539 85.9907 59.1233C86.3454 58.9833 86.7747 58.9133 87.2787 58.9133C87.8387 58.9133 88.31 58.9879 88.6927 59.1373C89.0754 59.2773 89.374 59.4686 89.5887 59.7113C89.8127 59.9539 89.9714 60.2293 90.0647 60.5373C90.1674 60.8453 90.2187 61.1579 90.2187 61.4753V66.0113C90.2187 66.1046 90.186 66.1839 90.1207 66.2493C90.0647 66.3053 89.99 66.3333 89.8967 66.3333H89.2527C89.15 66.3333 89.0707 66.3053 89.0147 66.2493C88.9587 66.1839 88.9307 66.1046 88.9307 66.0113V65.4093C88.8094 65.5773 88.646 65.7453 88.4407 65.9133C88.2354 66.0719 87.9787 66.2073 87.6707 66.3193C87.3627 66.4219 86.9847 66.4733 86.5367 66.4733ZM86.8307 65.4233C87.2134 65.4233 87.5634 65.3439 87.8807 65.1853C88.198 65.0173 88.4454 64.7606 88.6227 64.4153C88.8094 64.0699 88.9027 63.6359 88.9027 63.1133V62.7213L87.2787 62.9593C86.616 63.0526 86.1167 63.2113 85.7807 63.4353C85.4447 63.6499 85.2767 63.9253 85.2767 64.2613C85.2767 64.5226 85.3514 64.7419 85.5007 64.9193C85.6594 65.0873 85.8554 65.2133 86.0887 65.2973C86.3314 65.3813 86.5787 65.4233 86.8307 65.4233ZM93.3549 68.9933C93.2803 68.9933 93.2149 68.9653 93.1589 68.9093C93.1029 68.8533 93.0749 68.7879 93.0749 68.7133C93.0749 68.6759 93.0796 68.6386 93.0889 68.6013C93.0983 68.5639 93.1169 68.5173 93.1449 68.4613L94.2229 65.8993L91.5489 59.5853C91.5023 59.4733 91.4789 59.3939 91.4789 59.3473C91.4789 59.2633 91.5069 59.1933 91.5629 59.1373C91.6189 59.0813 91.6889 59.0533 91.7729 59.0533H92.4589C92.5616 59.0533 92.6363 59.0766 92.6829 59.1233C92.7389 59.1699 92.7763 59.2259 92.7949 59.2913L94.9229 64.3873L97.1069 59.2913C97.1349 59.2259 97.1723 59.1699 97.2189 59.1233C97.2749 59.0766 97.3543 59.0533 97.4569 59.0533H98.1149C98.1989 59.0533 98.2689 59.0813 98.3249 59.1373C98.3809 59.1933 98.4089 59.2586 98.4089 59.3333C98.4089 59.3799 98.3856 59.4639 98.3389 59.5853L94.3629 68.7553C94.3349 68.8206 94.2929 68.8766 94.2369 68.9233C94.1903 68.9699 94.1156 68.9933 94.0129 68.9933H93.3549Z" fill="white"/>
<path d="M47.08 80.4333C46.5267 80.4333 46.0567 80.3233 45.67 80.1033C45.2833 79.8766 44.9867 79.5833 44.78 79.2233C44.58 78.8566 44.48 78.4599 44.48 78.0333C44.48 77.8333 44.5033 77.6433 44.55 77.4633C44.6033 77.2766 44.6667 77.1033 44.74 76.9433C44.82 76.7766 44.8967 76.6299 44.97 76.5033C45.05 76.3699 45.12 76.2633 45.18 76.1833L47.08 73.5333C47.1133 73.4999 47.1533 73.4599 47.2 73.4133C47.2467 73.3599 47.3167 73.3333 47.41 73.3333H47.94C48 73.3333 48.0467 73.3566 48.08 73.4033C48.12 73.4433 48.14 73.4933 48.14 73.5533C48.14 73.5799 48.1367 73.6066 48.13 73.6333C48.1233 73.6533 48.1133 73.6699 48.1 73.6833L46.64 75.7233C46.72 75.6966 46.8133 75.6799 46.92 75.6733C47.0267 75.6599 47.1233 75.6533 47.21 75.6533C47.5767 75.6599 47.91 75.7266 48.21 75.8533C48.51 75.9799 48.7667 76.1533 48.98 76.3733C49.2 76.5866 49.3667 76.8366 49.48 77.1233C49.5933 77.4033 49.65 77.7033 49.65 78.0233C49.65 78.4433 49.55 78.8366 49.35 79.2033C49.15 79.5699 48.8567 79.8666 48.47 80.0933C48.09 80.3199 47.6267 80.4333 47.08 80.4333ZM47.07 79.5833C47.35 79.5833 47.61 79.5233 47.85 79.4033C48.09 79.2833 48.2833 79.1099 48.43 78.8833C48.5833 78.6499 48.66 78.3633 48.66 78.0233C48.66 77.6899 48.5867 77.4099 48.44 77.1833C48.2933 76.9499 48.0967 76.7766 47.85 76.6633C47.61 76.5433 47.35 76.4833 47.07 76.4833C46.79 76.4833 46.53 76.5433 46.29 76.6633C46.05 76.7766 45.8533 76.9499 45.7 77.1833C45.5533 77.4099 45.48 77.6899 45.48 78.0233C45.48 78.3633 45.5533 78.6499 45.7 78.8833C45.8533 79.1099 46.05 79.2833 46.29 79.4033C46.53 79.5233 46.79 79.5833 47.07 79.5833ZM50.9254 80.3333C50.8587 80.3333 50.8021 80.3133 50.7554 80.2733C50.7154 80.2266 50.6954 80.1699 50.6954 80.1033V79.3833C50.6954 79.3166 50.7154 79.2633 50.7554 79.2233C50.8021 79.1766 50.8587 79.1533 50.9254 79.1533H51.6454C51.7121 79.1533 51.7687 79.1766 51.8154 79.2233C51.8621 79.2633 51.8854 79.3166 51.8854 79.3833V80.1033C51.8854 80.1699 51.8621 80.2266 51.8154 80.2733C51.7687 80.3133 51.7121 80.3333 51.6454 80.3333H50.9254ZM54.6311 80.3333C54.5644 80.3333 54.5078 80.3133 54.4611 80.2733C54.4211 80.2266 54.4011 80.1699 54.4011 80.1033V74.5033L52.7411 75.7833C52.6878 75.8233 52.6311 75.8399 52.5711 75.8333C52.5111 75.8266 52.4611 75.7966 52.4211 75.7433L52.1611 75.4133C52.1211 75.3533 52.1044 75.2933 52.1111 75.2333C52.1244 75.1733 52.1578 75.1233 52.2111 75.0833L54.3911 73.4033C54.4378 73.3699 54.4811 73.3499 54.5211 73.3433C54.5611 73.3366 54.6044 73.3333 54.6511 73.3333H55.1611C55.2278 73.3333 55.2811 73.3566 55.3211 73.4033C55.3678 73.4433 55.3911 73.4966 55.3911 73.5633V80.1033C55.3911 80.1699 55.3678 80.2266 55.3211 80.2733C55.2811 80.3133 55.2278 80.3333 55.1611 80.3333H54.6311ZM57.2484 80.3333C57.1751 80.3333 57.1184 80.3133 57.0784 80.2733C57.0384 80.2266 57.0184 80.1699 57.0184 80.1033V73.5733C57.0184 73.4999 57.0384 73.4433 57.0784 73.4033C57.1184 73.3566 57.1751 73.3333 57.2484 73.3333H57.7484C57.8218 73.3333 57.8784 73.3566 57.9184 73.4033C57.9651 73.4433 57.9884 73.4999 57.9884 73.5733V76.0533L60.6584 73.4933C60.6851 73.4666 60.7284 73.4333 60.7884 73.3933C60.8551 73.3533 60.9418 73.3333 61.0484 73.3333H61.5884C61.6418 73.3333 61.6884 73.3533 61.7284 73.3933C61.7684 73.4333 61.7884 73.4799 61.7884 73.5333C61.7884 73.5866 61.7751 73.6299 61.7484 73.6633L58.6584 76.6833L61.9484 79.9933C61.9818 80.0333 61.9984 80.0799 61.9984 80.1333C61.9984 80.1866 61.9784 80.2333 61.9384 80.2733C61.8984 80.3133 61.8518 80.3333 61.7984 80.3333H61.2384C61.1251 80.3333 61.0384 80.3133 60.9784 80.2733C60.9184 80.2266 60.8751 80.1899 60.8484 80.1633L57.9884 77.3533V80.1033C57.9884 80.1699 57.9651 80.2266 57.9184 80.2733C57.8784 80.3133 57.8218 80.3333 57.7484 80.3333H57.2484ZM68.0178 80.4333C67.4578 80.4333 66.9745 80.3333 66.5678 80.1333C66.1678 79.9333 65.8578 79.6299 65.6378 79.2233C65.4245 78.8099 65.3178 78.2799 65.3178 77.6333V73.5733C65.3178 73.4999 65.3378 73.4433 65.3778 73.4033C65.4178 73.3566 65.4745 73.3333 65.5478 73.3333H66.0578C66.1311 73.3333 66.1878 73.3566 66.2278 73.4033C66.2745 73.4433 66.2978 73.4999 66.2978 73.5733V77.6533C66.2978 78.3066 66.4511 78.7899 66.7578 79.1033C67.0645 79.4166 67.4845 79.5733 68.0178 79.5733C68.5445 79.5733 68.9611 79.4166 69.2678 79.1033C69.5811 78.7899 69.7378 78.3066 69.7378 77.6533V73.5733C69.7378 73.4999 69.7578 73.4433 69.7978 73.4033C69.8445 73.3566 69.9011 73.3333 69.9678 73.3333H70.4878C70.5545 73.3333 70.6078 73.3566 70.6478 73.4033C70.6945 73.4433 70.7178 73.4999 70.7178 73.5733V77.6333C70.7178 78.2799 70.6078 78.8099 70.3878 79.2233C70.1745 79.6299 69.8678 79.9333 69.4678 80.1333C69.0678 80.3333 68.5845 80.4333 68.0178 80.4333ZM74.0205 80.4333C73.6471 80.4333 73.3271 80.3866 73.0605 80.2933C72.7938 80.1999 72.5771 80.0866 72.4105 79.9533C72.2438 79.8199 72.1171 79.6866 72.0305 79.5533C71.9505 79.4199 71.9071 79.3133 71.9005 79.2333C71.8938 79.1599 71.9171 79.1033 71.9705 79.0633C72.0238 79.0233 72.0771 79.0033 72.1305 79.0033H72.5805C72.6138 79.0033 72.6405 79.0099 72.6605 79.0233C72.6871 79.0299 72.7205 79.0566 72.7605 79.1033C72.8471 79.1966 72.9438 79.2899 73.0505 79.3833C73.1571 79.4766 73.2871 79.5533 73.4405 79.6133C73.6005 79.6733 73.7971 79.7033 74.0305 79.7033C74.3705 79.7033 74.6505 79.6399 74.8705 79.5133C75.0905 79.3799 75.2005 79.1866 75.2005 78.9333C75.2005 78.7666 75.1538 78.6333 75.0605 78.5333C74.9738 78.4333 74.8138 78.3433 74.5805 78.2633C74.3538 78.1833 74.0405 78.0999 73.6405 78.0133C73.2405 77.9199 72.9238 77.8066 72.6905 77.6733C72.4571 77.5333 72.2905 77.3699 72.1905 77.1833C72.0905 76.9899 72.0405 76.7733 72.0405 76.5333C72.0405 76.2866 72.1138 76.0499 72.2605 75.8233C72.4071 75.5899 72.6205 75.3999 72.9005 75.2533C73.1871 75.1066 73.5438 75.0333 73.9705 75.0333C74.3171 75.0333 74.6138 75.0766 74.8605 75.1633C75.1071 75.2499 75.3105 75.3599 75.4705 75.4933C75.6305 75.6199 75.7505 75.7466 75.8305 75.8733C75.9105 75.9999 75.9538 76.1066 75.9605 76.1933C75.9671 76.2599 75.9471 76.3166 75.9005 76.3633C75.8538 76.4033 75.8005 76.4233 75.7405 76.4233H75.3205C75.2738 76.4233 75.2338 76.4133 75.2005 76.3933C75.1738 76.3733 75.1471 76.3499 75.1205 76.3233C75.0538 76.2366 74.9738 76.1499 74.8805 76.0633C74.7938 75.9766 74.6771 75.9066 74.5305 75.8533C74.3905 75.7933 74.2038 75.7633 73.9705 75.7633C73.6371 75.7633 73.3871 75.8333 73.2205 75.9733C73.0538 76.1133 72.9705 76.2899 72.9705 76.5033C72.9705 76.6299 73.0071 76.7433 73.0805 76.8433C73.1538 76.9433 73.2938 77.0333 73.5005 77.1133C73.7071 77.1933 74.0138 77.2799 74.4205 77.3733C74.8605 77.4599 75.2071 77.5766 75.4605 77.7233C75.7138 77.8699 75.8938 78.0399 76.0005 78.2333C76.1071 78.4266 76.1605 78.6499 76.1605 78.9033C76.1605 79.1833 76.0805 79.4399 75.9205 79.6733C75.7605 79.9066 75.5205 80.0933 75.2005 80.2333C74.8805 80.3666 74.4871 80.4333 74.0205 80.4333ZM79.3981 80.4333C78.7048 80.4333 78.1548 80.2233 77.7481 79.8033C77.3415 79.3766 77.1181 78.7966 77.0781 78.0633C77.0715 77.9766 77.0681 77.8666 77.0681 77.7333C77.0681 77.5933 77.0715 77.4799 77.0781 77.3933C77.1048 76.9199 77.2148 76.5066 77.4081 76.1533C77.6015 75.7933 77.8648 75.5166 78.1981 75.3233C78.5381 75.1299 78.9348 75.0333 79.3881 75.0333C79.8948 75.0333 80.3181 75.1399 80.6581 75.3533C81.0048 75.5666 81.2681 75.8699 81.4481 76.2633C81.6281 76.6566 81.7181 77.1166 81.7181 77.6433V77.8133C81.7181 77.8866 81.6948 77.9433 81.6481 77.9833C81.6081 78.0233 81.5548 78.0433 81.4881 78.0433H78.0281C78.0281 78.0499 78.0281 78.0633 78.0281 78.0833C78.0281 78.1033 78.0281 78.1199 78.0281 78.1333C78.0415 78.4066 78.1015 78.6633 78.2081 78.9033C78.3148 79.1366 78.4681 79.3266 78.6681 79.4733C78.8748 79.6199 79.1148 79.6933 79.3881 79.6933C79.6281 79.6933 79.8281 79.6566 79.9881 79.5833C80.1481 79.5099 80.2781 79.4299 80.3781 79.3433C80.4781 79.2499 80.5448 79.1766 80.5781 79.1233C80.6381 79.0433 80.6848 78.9966 80.7181 78.9833C80.7515 78.9633 80.8048 78.9533 80.8781 78.9533H81.3681C81.4281 78.9533 81.4781 78.9733 81.5181 79.0133C81.5648 79.0466 81.5848 79.0966 81.5781 79.1633C81.5715 79.2633 81.5181 79.3866 81.4181 79.5333C81.3181 79.6733 81.1748 79.8133 80.9881 79.9533C80.8081 80.0933 80.5815 80.2099 80.3081 80.3033C80.0415 80.3899 79.7381 80.4333 79.3981 80.4333ZM78.0281 77.3533H80.7681V77.3233C80.7681 77.0233 80.7115 76.7566 80.5981 76.5233C80.4915 76.2899 80.3348 76.1066 80.1281 75.9733C79.9215 75.8333 79.6748 75.7633 79.3881 75.7633C79.1015 75.7633 78.8548 75.8333 78.6481 75.9733C78.4481 76.1066 78.2948 76.2899 78.1881 76.5233C78.0815 76.7566 78.0281 77.0233 78.0281 77.3233V77.3533ZM83.1438 80.3333C83.0772 80.3333 83.0205 80.3133 82.9738 80.2733C82.9338 80.2266 82.9138 80.1699 82.9138 80.1033V75.3733C82.9138 75.3066 82.9338 75.2499 82.9738 75.2033C83.0205 75.1566 83.0772 75.1333 83.1438 75.1333H83.6038C83.6705 75.1333 83.7272 75.1566 83.7738 75.2033C83.8205 75.2499 83.8438 75.3066 83.8438 75.3733V75.8133C83.9772 75.5866 84.1605 75.4166 84.3938 75.3033C84.6272 75.1899 84.9105 75.1333 85.2438 75.1333H85.6338C85.7005 75.1333 85.7538 75.1566 85.7938 75.2033C85.8405 75.2433 85.8638 75.2966 85.8638 75.3633V75.7733C85.8638 75.8399 85.8405 75.8933 85.7938 75.9333C85.7538 75.9733 85.7005 75.9933 85.6338 75.9933H85.0338C84.6738 75.9933 84.3905 76.0999 84.1838 76.3133C83.9772 76.5199 83.8738 76.8033 83.8738 77.1633V80.1033C83.8738 80.1699 83.8505 80.2266 83.8038 80.2733C83.7572 80.3133 83.7005 80.3333 83.6338 80.3333H83.1438ZM88.5127 80.4333C88.1393 80.4333 87.8193 80.3866 87.5527 80.2933C87.286 80.1999 87.0693 80.0866 86.9027 79.9533C86.736 79.8199 86.6093 79.6866 86.5227 79.5533C86.4427 79.4199 86.3993 79.3133 86.3927 79.2333C86.386 79.1599 86.4093 79.1033 86.4627 79.0633C86.516 79.0233 86.5693 79.0033 86.6227 79.0033H87.0727C87.106 79.0033 87.1327 79.0099 87.1527 79.0233C87.1793 79.0299 87.2127 79.0566 87.2527 79.1033C87.3393 79.1966 87.436 79.2899 87.5427 79.3833C87.6493 79.4766 87.7793 79.5533 87.9327 79.6133C88.0927 79.6733 88.2893 79.7033 88.5227 79.7033C88.8627 79.7033 89.1427 79.6399 89.3627 79.5133C89.5827 79.3799 89.6927 79.1866 89.6927 78.9333C89.6927 78.7666 89.646 78.6333 89.5527 78.5333C89.466 78.4333 89.306 78.3433 89.0727 78.2633C88.846 78.1833 88.5327 78.0999 88.1327 78.0133C87.7327 77.9199 87.416 77.8066 87.1827 77.6733C86.9493 77.5333 86.7827 77.3699 86.6827 77.1833C86.5827 76.9899 86.5327 76.7733 86.5327 76.5333C86.5327 76.2866 86.606 76.0499 86.7527 75.8233C86.8993 75.5899 87.1127 75.3999 87.3927 75.2533C87.6793 75.1066 88.036 75.0333 88.4627 75.0333C88.8093 75.0333 89.106 75.0766 89.3527 75.1633C89.5993 75.2499 89.8027 75.3599 89.9627 75.4933C90.1227 75.6199 90.2427 75.7466 90.3227 75.8733C90.4027 75.9999 90.446 76.1066 90.4527 76.1933C90.4593 76.2599 90.4393 76.3166 90.3927 76.3633C90.346 76.4033 90.2927 76.4233 90.2327 76.4233H89.8127C89.766 76.4233 89.726 76.4133 89.6927 76.3933C89.666 76.3733 89.6393 76.3499 89.6127 76.3233C89.546 76.2366 89.466 76.1499 89.3727 76.0633C89.286 75.9766 89.1693 75.9066 89.0227 75.8533C88.8827 75.7933 88.696 75.7633 88.4627 75.7633C88.1293 75.7633 87.8793 75.8333 87.7127 75.9733C87.546 76.1133 87.4627 76.2899 87.4627 76.5033C87.4627 76.6299 87.4993 76.7433 87.5727 76.8433C87.646 76.9433 87.786 77.0333 87.9927 77.1133C88.1993 77.1933 88.506 77.2799 88.9127 77.3733C89.3527 77.4599 89.6993 77.5766 89.9527 77.7233C90.206 77.8699 90.386 78.0399 90.4927 78.2333C90.5993 78.4266 90.6527 78.6499 90.6527 78.9033C90.6527 79.1833 90.5727 79.4399 90.4127 79.6733C90.2527 79.9066 90.0127 80.0933 89.6927 80.2333C89.3727 80.3666 88.9793 80.4333 88.5127 80.4333Z" fill="#9EA1B1"/>
<path d="M130.88 74.5333C129.733 74.5333 128.747 74.3199 127.92 73.8933C127.093 73.4533 126.453 72.8666 126 72.1333C125.547 71.3866 125.32 70.5533 125.32 69.6333C125.32 69.2199 125.373 68.8199 125.48 68.4333C125.587 68.0466 125.727 67.6799 125.9 67.3333C126.073 66.9866 126.24 66.6799 126.4 66.4133C126.573 66.1333 126.727 65.9133 126.86 65.7533L130.52 60.7333C130.573 60.6666 130.653 60.5866 130.76 60.4933C130.867 60.3866 131.013 60.3333 131.2 60.3333H133.06C133.18 60.3333 133.28 60.3799 133.36 60.4733C133.44 60.5533 133.48 60.6533 133.48 60.7733C133.48 60.8266 133.467 60.8799 133.44 60.9333C133.427 60.9733 133.407 61.0066 133.38 61.0333L130.58 64.9133C130.7 64.8733 130.84 64.8466 131 64.8333C131.16 64.8199 131.307 64.8133 131.44 64.8133C132.107 64.8266 132.74 64.9599 133.34 65.2133C133.94 65.4533 134.467 65.7866 134.92 66.2133C135.373 66.6399 135.727 67.1399 135.98 67.7133C136.247 68.2866 136.38 68.9133 136.38 69.5933C136.38 70.4733 136.16 71.2933 135.72 72.0533C135.28 72.7999 134.647 73.3999 133.82 73.8533C133.007 74.3066 132.027 74.5333 130.88 74.5333ZM130.86 72.2333C131.34 72.2333 131.78 72.1333 132.18 71.9333C132.593 71.7333 132.927 71.4399 133.18 71.0533C133.433 70.6666 133.56 70.1866 133.56 69.6133C133.56 69.0533 133.433 68.5799 133.18 68.1933C132.927 67.8066 132.593 67.5133 132.18 67.3133C131.78 67.1133 131.34 67.0133 130.86 67.0133C130.38 67.0133 129.933 67.1133 129.52 67.3133C129.12 67.5133 128.793 67.8066 128.54 68.1933C128.287 68.5799 128.16 69.0533 128.16 69.6133C128.16 70.1866 128.287 70.6666 128.54 71.0533C128.793 71.4399 129.12 71.7333 129.52 71.9333C129.933 72.1333 130.38 72.2333 130.86 72.2333ZM143.599 74.5333C142.652 74.5333 141.846 74.3933 141.179 74.1133C140.512 73.8333 139.966 73.4466 139.539 72.9533C139.112 72.4599 138.792 71.8933 138.579 71.2533C138.366 70.5999 138.239 69.9066 138.199 69.1733C138.186 68.8133 138.172 68.4199 138.159 67.9933C138.159 67.5533 138.159 67.1133 138.159 66.6733C138.172 66.2333 138.186 65.8266 138.199 65.4533C138.226 64.7199 138.352 64.0333 138.579 63.3933C138.806 62.7399 139.132 62.1733 139.559 61.6933C139.999 61.2133 140.552 60.8333 141.219 60.5533C141.886 60.2733 142.679 60.1333 143.599 60.1333C144.532 60.1333 145.332 60.2733 145.999 60.5533C146.666 60.8333 147.212 61.2133 147.639 61.6933C148.079 62.1733 148.406 62.7399 148.619 63.3933C148.846 64.0333 148.972 64.7199 148.999 65.4533C149.026 65.8266 149.039 66.2333 149.039 66.6733C149.039 67.1133 149.039 67.5533 149.039 67.9933C149.039 68.4199 149.026 68.8133 148.999 69.1733C148.972 69.9066 148.852 70.5999 148.639 71.2533C148.426 71.8933 148.106 72.4599 147.679 72.9533C147.252 73.4466 146.699 73.8333 146.019 74.1133C145.352 74.3933 144.546 74.5333 143.599 74.5333ZM143.599 72.2333C144.466 72.2333 145.099 71.9533 145.499 71.3933C145.912 70.8199 146.126 70.0466 146.139 69.0733C146.166 68.6866 146.179 68.2999 146.179 67.9133C146.179 67.5133 146.179 67.1133 146.179 66.7133C146.179 66.3133 146.166 65.9333 146.139 65.5733C146.126 64.6266 145.912 63.8666 145.499 63.2933C145.099 62.7066 144.466 62.4133 143.599 62.4133C142.746 62.4133 142.112 62.7066 141.699 63.2933C141.299 63.8666 141.086 64.6266 141.059 65.5733C141.059 65.9333 141.052 66.3133 141.039 66.7133C141.039 67.1133 141.039 67.5133 141.039 67.9133C141.052 68.2999 141.059 68.6866 141.059 69.0733C141.086 70.0466 141.306 70.8199 141.719 71.3933C142.132 71.9533 142.759 72.2333 143.599 72.2333ZM152.384 74.3333C152.104 74.3333 151.964 74.1999 151.964 73.9333C151.964 73.8533 151.99 73.7799 152.044 73.7133L161.904 60.7133C161.997 60.5933 162.09 60.4999 162.184 60.4333C162.277 60.3666 162.41 60.3333 162.584 60.3333H163.644C163.924 60.3333 164.064 60.4666 164.064 60.7333C164.064 60.8133 164.037 60.8866 163.984 60.9533L154.124 73.9533C154.03 74.0733 153.937 74.1666 153.844 74.2333C153.764 74.2999 153.63 74.3333 153.444 74.3333H152.384ZM162.004 74.4533C161.11 74.4533 160.404 74.2066 159.884 73.7133C159.364 73.2199 159.077 72.5733 159.024 71.7733C159.01 71.4266 159.004 71.1266 159.004 70.8733C159.004 70.6199 159.01 70.3066 159.024 69.9333C159.077 69.1333 159.35 68.4866 159.844 67.9933C160.35 67.4999 161.07 67.2533 162.004 67.2533C162.95 67.2533 163.67 67.4999 164.164 67.9933C164.67 68.4866 164.944 69.1333 164.984 69.9333C165.01 70.3066 165.024 70.6199 165.024 70.8733C165.024 71.1266 165.01 71.4266 164.984 71.7733C164.944 72.5733 164.657 73.2199 164.124 73.7133C163.604 74.2066 162.897 74.4533 162.004 74.4533ZM162.004 72.8933C162.297 72.8933 162.524 72.8333 162.684 72.7133C162.857 72.5933 162.984 72.4399 163.064 72.2533C163.144 72.0666 163.184 71.8799 163.184 71.6933C163.21 71.3599 163.224 71.0799 163.224 70.8533C163.224 70.6133 163.21 70.3399 163.184 70.0333C163.17 69.7133 163.077 69.4266 162.904 69.1733C162.73 68.9199 162.43 68.7933 162.004 68.7933C161.59 68.7933 161.297 68.9199 161.124 69.1733C160.95 69.4266 160.85 69.7133 160.824 70.0333C160.81 70.3399 160.804 70.6133 160.804 70.8533C160.804 71.0799 160.81 71.3599 160.824 71.6933C160.85 71.8799 160.897 72.0666 160.964 72.2533C161.044 72.4399 161.164 72.5933 161.324 72.7133C161.497 72.8333 161.724 72.8933 162.004 72.8933ZM154.024 67.3733C153.13 67.3733 152.424 67.1399 151.904 66.6733C151.384 66.2066 151.097 65.5733 151.044 64.7733C151.03 64.4266 151.024 64.1266 151.024 63.8733C151.024 63.6066 151.03 63.2866 151.044 62.9133C151.097 62.1133 151.37 61.4666 151.864 60.9733C152.37 60.4799 153.09 60.2333 154.024 60.2333C154.97 60.2333 155.69 60.4799 156.184 60.9733C156.69 61.4666 156.964 62.1133 157.004 62.9133C157.03 63.2866 157.044 63.6066 157.044 63.8733C157.044 64.1266 157.03 64.4266 157.004 64.7733C156.964 65.5733 156.677 66.2066 156.144 66.6733C155.624 67.1399 154.917 67.3733 154.024 67.3733ZM154.024 65.8933C154.317 65.8933 154.544 65.8333 154.704 65.7133C154.877 65.5933 155.004 65.4399 155.084 65.2533C155.164 65.0666 155.204 64.8733 155.204 64.6733C155.23 64.3399 155.244 64.0599 155.244 63.8333C155.244 63.5933 155.23 63.3199 155.204 63.0133C155.19 62.7066 155.097 62.4266 154.924 62.1733C154.75 61.9199 154.45 61.7933 154.024 61.7933C153.61 61.7933 153.317 61.9199 153.144 62.1733C152.97 62.4266 152.877 62.7066 152.864 63.0133C152.85 63.3199 152.844 63.5933 152.844 63.8333C152.844 64.0599 152.85 64.3399 152.864 64.6733C152.877 64.8733 152.917 65.0666 152.984 65.2533C153.064 65.4399 153.184 65.5933 153.344 65.7133C153.517 65.8333 153.744 65.8933 154.024 65.8933Z" fill="white"/>
<rect x="15" y="95" width="22" height="22" rx="11" stroke="#D057FF" stroke-width="2"/>
<g clip-path="url(#clip0_2788_35203)">
<path d="M36 106C36 111.523 31.5228 116 26 116C20.4772 116 16 111.523 16 106C16 100.477 20.4772 96 26 96C31.5228 96 36 100.477 36 106Z" fill="#EA7314"/>
<path d="M21 100.167H30.8068L26.2415 106L30.8068 111.833H21V100.167Z" fill="white"/>
</g>
<path d="M45.54 105C45.4373 105 45.358 104.972 45.302 104.916C45.246 104.851 45.218 104.771 45.218 104.678V95.536C45.218 95.4333 45.246 95.354 45.302 95.298C45.358 95.2327 45.4373 95.2 45.54 95.2H46.24C46.3427 95.2 46.422 95.2327 46.478 95.298C46.5433 95.354 46.576 95.4333 46.576 95.536V99.008L50.314 95.424C50.3513 95.3867 50.412 95.34 50.496 95.284C50.5893 95.228 50.7107 95.2 50.86 95.2H51.616C51.6907 95.2 51.756 95.228 51.812 95.284C51.868 95.34 51.896 95.4053 51.896 95.48C51.896 95.5547 51.8773 95.6153 51.84 95.662L47.514 99.89L52.12 104.524C52.1667 104.58 52.19 104.645 52.19 104.72C52.19 104.795 52.162 104.86 52.106 104.916C52.05 104.972 51.9847 105 51.91 105H51.126C50.9673 105 50.846 104.972 50.762 104.916C50.678 104.851 50.6173 104.799 50.58 104.762L46.576 100.828V104.678C46.576 104.771 46.5433 104.851 46.478 104.916C46.422 104.972 46.3427 105 46.24 105H45.54ZM55.3785 105.14C54.9118 105.14 54.4872 105.047 54.1045 104.86C53.7218 104.673 53.4138 104.421 53.1805 104.104C52.9472 103.787 52.8305 103.427 52.8305 103.026C52.8305 102.382 53.0918 101.869 53.6145 101.486C54.1372 101.103 54.8185 100.851 55.6585 100.73L57.7445 100.436V100.03C57.7445 99.582 57.6138 99.232 57.3525 98.98C57.1005 98.728 56.6852 98.602 56.1065 98.602C55.6958 98.602 55.3598 98.686 55.0985 98.854C54.8372 99.022 54.6552 99.2367 54.5525 99.498C54.4965 99.638 54.3985 99.708 54.2585 99.708H53.6285C53.5258 99.708 53.4465 99.68 53.3905 99.624C53.3438 99.5587 53.3205 99.484 53.3205 99.4C53.3205 99.26 53.3718 99.0873 53.4745 98.882C53.5865 98.6767 53.7545 98.476 53.9785 98.28C54.2025 98.084 54.4872 97.9207 54.8325 97.79C55.1872 97.65 55.6165 97.58 56.1205 97.58C56.6805 97.58 57.1518 97.6547 57.5345 97.804C57.9172 97.944 58.2158 98.1353 58.4305 98.378C58.6545 98.6207 58.8132 98.896 58.9065 99.204C59.0092 99.512 59.0605 99.8247 59.0605 100.142V104.678C59.0605 104.771 59.0278 104.851 58.9625 104.916C58.9065 104.972 58.8318 105 58.7385 105H58.0945C57.9918 105 57.9125 104.972 57.8565 104.916C57.8005 104.851 57.7725 104.771 57.7725 104.678V104.076C57.6512 104.244 57.4878 104.412 57.2825 104.58C57.0772 104.739 56.8205 104.874 56.5125 104.986C56.2045 105.089 55.8265 105.14 55.3785 105.14ZM55.6725 104.09C56.0552 104.09 56.4052 104.011 56.7225 103.852C57.0398 103.684 57.2872 103.427 57.4645 103.082C57.6512 102.737 57.7445 102.303 57.7445 101.78V101.388L56.1205 101.626C55.4578 101.719 54.9585 101.878 54.6225 102.102C54.2865 102.317 54.1185 102.592 54.1185 102.928C54.1185 103.189 54.1932 103.409 54.3425 103.586C54.5012 103.754 54.6972 103.88 54.9305 103.964C55.1732 104.048 55.4205 104.09 55.6725 104.09ZM61.3951 105C61.3018 105 61.2224 104.972 61.1571 104.916C61.1011 104.851 61.0731 104.771 61.0731 104.678V98.042C61.0731 97.9487 61.1011 97.874 61.1571 97.818C61.2224 97.7527 61.3018 97.72 61.3951 97.72H62.0531C62.1464 97.72 62.2211 97.7527 62.2771 97.818C62.3424 97.874 62.3751 97.9487 62.3751 98.042V98.658C62.6178 98.3407 62.9211 98.084 63.2851 97.888C63.6584 97.6827 64.1344 97.58 64.7131 97.58C65.3198 97.58 65.8331 97.7153 66.2531 97.986C66.6824 98.2473 67.0044 98.616 67.2191 99.092C67.4431 99.5587 67.5551 100.105 67.5551 100.73V104.678C67.5551 104.771 67.5224 104.851 67.4571 104.916C67.4011 104.972 67.3264 105 67.2331 105H66.5331C66.4398 105 66.3604 104.972 66.2951 104.916C66.2391 104.851 66.2111 104.771 66.2111 104.678V100.8C66.2111 100.147 66.0524 99.638 65.7351 99.274C65.4178 98.9007 64.9511 98.714 64.3351 98.714C63.7564 98.714 63.2898 98.9007 62.9351 99.274C62.5898 99.638 62.4171 100.147 62.4171 100.8V104.678C62.4171 104.771 62.3844 104.851 62.3191 104.916C62.2631 104.972 62.1884 105 62.0951 105H61.3951ZM72.3096 105C71.787 105 71.3623 104.902 71.0356 104.706C70.709 104.501 70.471 104.216 70.3216 103.852C70.1723 103.479 70.0976 103.04 70.0976 102.536V98.84H69.0056C68.9123 98.84 68.833 98.812 68.7676 98.756C68.7116 98.6907 68.6836 98.6113 68.6836 98.518V98.042C68.6836 97.9487 68.7116 97.874 68.7676 97.818C68.833 97.7527 68.9123 97.72 69.0056 97.72H70.0976V95.382C70.0976 95.2887 70.1256 95.214 70.1816 95.158C70.247 95.0927 70.3263 95.06 70.4196 95.06H71.0776C71.171 95.06 71.2456 95.0927 71.3016 95.158C71.367 95.214 71.3996 95.2887 71.3996 95.382V97.72H73.1356C73.2383 97.72 73.3176 97.7527 73.3736 97.818C73.4296 97.874 73.4576 97.9487 73.4576 98.042V98.518C73.4576 98.6113 73.4296 98.6907 73.3736 98.756C73.3176 98.812 73.2383 98.84 73.1356 98.84H71.3996V102.438C71.3996 102.877 71.4743 103.222 71.6236 103.474C71.773 103.726 72.039 103.852 72.4216 103.852H73.2756C73.369 103.852 73.4436 103.885 73.4996 103.95C73.565 104.006 73.5976 104.081 73.5976 104.174V104.678C73.5976 104.771 73.565 104.851 73.4996 104.916C73.4436 104.972 73.369 105 73.2756 105H72.3096ZM76.9664 105.14C76.4997 105.14 76.0751 105.047 75.6924 104.86C75.3097 104.673 75.0017 104.421 74.7684 104.104C74.5351 103.787 74.4184 103.427 74.4184 103.026C74.4184 102.382 74.6797 101.869 75.2024 101.486C75.7251 101.103 76.4064 100.851 77.2464 100.73L79.3324 100.436V100.03C79.3324 99.582 79.2017 99.232 78.9404 98.98C78.6884 98.728 78.2731 98.602 77.6944 98.602C77.2837 98.602 76.9477 98.686 76.6864 98.854C76.4251 99.022 76.2431 99.2367 76.1404 99.498C76.0844 99.638 75.9864 99.708 75.8464 99.708H75.2164C75.1137 99.708 75.0344 99.68 74.9784 99.624C74.9317 99.5587 74.9084 99.484 74.9084 99.4C74.9084 99.26 74.9597 99.0873 75.0624 98.882C75.1744 98.6767 75.3424 98.476 75.5664 98.28C75.7904 98.084 76.0751 97.9207 76.4204 97.79C76.7751 97.65 77.2044 97.58 77.7084 97.58C78.2684 97.58 78.7397 97.6547 79.1224 97.804C79.5051 97.944 79.8037 98.1353 80.0184 98.378C80.2424 98.6207 80.4011 98.896 80.4944 99.204C80.5971 99.512 80.6484 99.8247 80.6484 100.142V104.678C80.6484 104.771 80.6157 104.851 80.5504 104.916C80.4944 104.972 80.4197 105 80.3264 105H79.6824C79.5797 105 79.5004 104.972 79.4444 104.916C79.3884 104.851 79.3604 104.771 79.3604 104.678V104.076C79.2391 104.244 79.0757 104.412 78.8704 104.58C78.6651 104.739 78.4084 104.874 78.1004 104.986C77.7924 105.089 77.4144 105.14 76.9664 105.14ZM77.2604 104.09C77.6431 104.09 77.9931 104.011 78.3104 103.852C78.6277 103.684 78.8751 103.427 79.0524 103.082C79.2391 102.737 79.3324 102.303 79.3324 101.78V101.388L77.7084 101.626C77.0457 101.719 76.5464 101.878 76.2104 102.102C75.8744 102.317 75.7064 102.592 75.7064 102.928C75.7064 103.189 75.7811 103.409 75.9304 103.586C76.0891 103.754 76.2851 103.88 76.5184 103.964C76.7611 104.048 77.0084 104.09 77.2604 104.09ZM85.4346 105C84.912 105 84.4873 104.902 84.1606 104.706C83.834 104.501 83.596 104.216 83.4466 103.852C83.2973 103.479 83.2226 103.04 83.2226 102.536V98.84H82.1306C82.0373 98.84 81.958 98.812 81.8926 98.756C81.8366 98.6907 81.8086 98.6113 81.8086 98.518V98.042C81.8086 97.9487 81.8366 97.874 81.8926 97.818C81.958 97.7527 82.0373 97.72 82.1306 97.72H83.2226V95.382C83.2226 95.2887 83.2506 95.214 83.3066 95.158C83.372 95.0927 83.4513 95.06 83.5446 95.06H84.2026C84.296 95.06 84.3706 95.0927 84.4266 95.158C84.492 95.214 84.5246 95.2887 84.5246 95.382V97.72H86.2606C86.3633 97.72 86.4426 97.7527 86.4986 97.818C86.5546 97.874 86.5826 97.9487 86.5826 98.042V98.518C86.5826 98.6113 86.5546 98.6907 86.4986 98.756C86.4426 98.812 86.3633 98.84 86.2606 98.84H84.5246V102.438C84.5246 102.877 84.5993 103.222 84.7486 103.474C84.898 103.726 85.164 103.852 85.5466 103.852H86.4006C86.494 103.852 86.5686 103.885 86.6246 103.95C86.69 104.006 86.7226 104.081 86.7226 104.174V104.678C86.7226 104.771 86.69 104.851 86.6246 104.916C86.5686 104.972 86.494 105 86.4006 105H85.4346ZM90.0914 105.14C89.6247 105.14 89.2001 105.047 88.8174 104.86C88.4347 104.673 88.1267 104.421 87.8934 104.104C87.6601 103.787 87.5434 103.427 87.5434 103.026C87.5434 102.382 87.8047 101.869 88.3274 101.486C88.8501 101.103 89.5314 100.851 90.3714 100.73L92.4574 100.436V100.03C92.4574 99.582 92.3267 99.232 92.0654 98.98C91.8134 98.728 91.3981 98.602 90.8194 98.602C90.4087 98.602 90.0727 98.686 89.8114 98.854C89.5501 99.022 89.3681 99.2367 89.2654 99.498C89.2094 99.638 89.1114 99.708 88.9714 99.708H88.3414C88.2387 99.708 88.1594 99.68 88.1034 99.624C88.0567 99.5587 88.0334 99.484 88.0334 99.4C88.0334 99.26 88.0847 99.0873 88.1874 98.882C88.2994 98.6767 88.4674 98.476 88.6914 98.28C88.9154 98.084 89.2001 97.9207 89.5454 97.79C89.9001 97.65 90.3294 97.58 90.8334 97.58C91.3934 97.58 91.8647 97.6547 92.2474 97.804C92.6301 97.944 92.9287 98.1353 93.1434 98.378C93.3674 98.6207 93.5261 98.896 93.6194 99.204C93.7221 99.512 93.7734 99.8247 93.7734 100.142V104.678C93.7734 104.771 93.7407 104.851 93.6754 104.916C93.6194 104.972 93.5447 105 93.4514 105H92.8074C92.7047 105 92.6254 104.972 92.5694 104.916C92.5134 104.851 92.4854 104.771 92.4854 104.678V104.076C92.3641 104.244 92.2007 104.412 91.9954 104.58C91.7901 104.739 91.5334 104.874 91.2254 104.986C90.9174 105.089 90.5394 105.14 90.0914 105.14ZM90.3854 104.09C90.7681 104.09 91.1181 104.011 91.4354 103.852C91.7527 103.684 92.0001 103.427 92.1774 103.082C92.3641 102.737 92.4574 102.303 92.4574 101.78V101.388L90.8334 101.626C90.1707 101.719 89.6714 101.878 89.3354 102.102C88.9994 102.317 88.8314 102.592 88.8314 102.928C88.8314 103.189 88.9061 103.409 89.0554 103.586C89.2141 103.754 89.4101 103.88 89.6434 103.964C89.8861 104.048 90.1334 104.09 90.3854 104.09Z" fill="white"/>
<path d="M46.98 119.1C46.56 119.1 46.1933 119.05 45.88 118.95C45.5667 118.843 45.3033 118.703 45.09 118.53C44.8767 118.357 44.7133 118.167 44.6 117.96C44.4933 117.747 44.4367 117.533 44.43 117.32C44.43 117.26 44.45 117.213 44.49 117.18C44.53 117.14 44.58 117.12 44.64 117.12H45.13C45.19 117.12 45.2433 117.137 45.29 117.17C45.3433 117.197 45.3833 117.253 45.41 117.34C45.4767 117.58 45.59 117.767 45.75 117.9C45.9167 118.033 46.1067 118.127 46.32 118.18C46.54 118.227 46.76 118.25 46.98 118.25C47.44 118.25 47.8133 118.14 48.1 117.92C48.3867 117.7 48.53 117.377 48.53 116.95C48.53 116.517 48.4 116.207 48.14 116.02C47.88 115.833 47.52 115.74 47.06 115.74H46.11C46.0433 115.74 45.9867 115.72 45.94 115.68C45.9 115.64 45.88 115.583 45.88 115.51V115.24C45.88 115.18 45.89 115.13 45.91 115.09C45.9367 115.043 45.9633 115.003 45.99 114.97L47.93 112.85H44.98C44.9133 112.85 44.8567 112.83 44.81 112.79C44.77 112.75 44.75 112.693 44.75 112.62V112.24C44.75 112.167 44.77 112.11 44.81 112.07C44.8567 112.023 44.9133 112 44.98 112H48.97C49.0433 112 49.1 112.023 49.14 112.07C49.1867 112.11 49.21 112.167 49.21 112.24V112.6C49.21 112.647 49.1967 112.69 49.17 112.73C49.15 112.763 49.1267 112.797 49.1 112.83L47.17 114.98L47.33 114.99C47.77 115.003 48.1533 115.083 48.48 115.23C48.8133 115.377 49.07 115.597 49.25 115.89C49.4367 116.177 49.53 116.54 49.53 116.98C49.53 117.427 49.42 117.807 49.2 118.12C48.98 118.433 48.6767 118.677 48.29 118.85C47.91 119.017 47.4733 119.1 46.98 119.1ZM51.1059 119C51.0325 119 50.9759 118.98 50.9359 118.94C50.8959 118.893 50.8759 118.837 50.8759 118.77V112.24C50.8759 112.167 50.8959 112.11 50.9359 112.07C50.9759 112.023 51.0325 112 51.1059 112H51.6059C51.6792 112 51.7359 112.023 51.7759 112.07C51.8225 112.11 51.8459 112.167 51.8459 112.24V114.72L54.5159 112.16C54.5425 112.133 54.5859 112.1 54.6459 112.06C54.7125 112.02 54.7992 112 54.9059 112H55.4459C55.4992 112 55.5459 112.02 55.5859 112.06C55.6259 112.1 55.6459 112.147 55.6459 112.2C55.6459 112.253 55.6325 112.297 55.6059 112.33L52.5159 115.35L55.8059 118.66C55.8392 118.7 55.8559 118.747 55.8559 118.8C55.8559 118.853 55.8359 118.9 55.7959 118.94C55.7559 118.98 55.7092 119 55.6559 119H55.0959C54.9825 119 54.8959 118.98 54.8359 118.94C54.7759 118.893 54.7325 118.857 54.7059 118.83L51.8459 116.02V118.77C51.8459 118.837 51.8225 118.893 51.7759 118.94C51.7359 118.98 51.6792 119 51.6059 119H51.1059ZM61.8752 119.1C61.3152 119.1 60.8319 119 60.4252 118.8C60.0252 118.6 59.7152 118.297 59.4952 117.89C59.2819 117.477 59.1752 116.947 59.1752 116.3V112.24C59.1752 112.167 59.1952 112.11 59.2352 112.07C59.2752 112.023 59.3319 112 59.4052 112H59.9152C59.9886 112 60.0452 112.023 60.0852 112.07C60.1319 112.11 60.1552 112.167 60.1552 112.24V116.32C60.1552 116.973 60.3086 117.457 60.6152 117.77C60.9219 118.083 61.3419 118.24 61.8752 118.24C62.4019 118.24 62.8186 118.083 63.1252 117.77C63.4386 117.457 63.5952 116.973 63.5952 116.32V112.24C63.5952 112.167 63.6152 112.11 63.6552 112.07C63.7019 112.023 63.7586 112 63.8252 112H64.3452C64.4119 112 64.4652 112.023 64.5052 112.07C64.5519 112.11 64.5752 112.167 64.5752 112.24V116.3C64.5752 116.947 64.4652 117.477 64.2452 117.89C64.0319 118.297 63.7252 118.6 63.3252 118.8C62.9252 119 62.4419 119.1 61.8752 119.1ZM67.8779 119.1C67.5046 119.1 67.1846 119.053 66.9179 118.96C66.6512 118.867 66.4346 118.753 66.2679 118.62C66.1012 118.487 65.9746 118.353 65.8879 118.22C65.8079 118.087 65.7646 117.98 65.7579 117.9C65.7512 117.827 65.7746 117.77 65.8279 117.73C65.8812 117.69 65.9346 117.67 65.9879 117.67H66.4379C66.4712 117.67 66.4979 117.677 66.5179 117.69C66.5446 117.697 66.5779 117.723 66.6179 117.77C66.7046 117.863 66.8012 117.957 66.9079 118.05C67.0146 118.143 67.1446 118.22 67.2979 118.28C67.4579 118.34 67.6546 118.37 67.8879 118.37C68.2279 118.37 68.5079 118.307 68.7279 118.18C68.9479 118.047 69.0579 117.853 69.0579 117.6C69.0579 117.433 69.0112 117.3 68.9179 117.2C68.8312 117.1 68.6712 117.01 68.4379 116.93C68.2112 116.85 67.8979 116.767 67.4979 116.68C67.0979 116.587 66.7812 116.473 66.5479 116.34C66.3146 116.2 66.1479 116.037 66.0479 115.85C65.9479 115.657 65.8979 115.44 65.8979 115.2C65.8979 114.953 65.9712 114.717 66.1179 114.49C66.2646 114.257 66.4779 114.067 66.7579 113.92C67.0446 113.773 67.4012 113.7 67.8279 113.7C68.1746 113.7 68.4712 113.743 68.7179 113.83C68.9646 113.917 69.1679 114.027 69.3279 114.16C69.4879 114.287 69.6079 114.413 69.6879 114.54C69.7679 114.667 69.8112 114.773 69.8179 114.86C69.8246 114.927 69.8046 114.983 69.7579 115.03C69.7112 115.07 69.6579 115.09 69.5979 115.09H69.1779C69.1312 115.09 69.0912 115.08 69.0579 115.06C69.0312 115.04 69.0046 115.017 68.9779 114.99C68.9112 114.903 68.8312 114.817 68.7379 114.73C68.6512 114.643 68.5346 114.573 68.3879 114.52C68.2479 114.46 68.0612 114.43 67.8279 114.43C67.4946 114.43 67.2446 114.5 67.0779 114.64C66.9112 114.78 66.8279 114.957 66.8279 115.17C66.8279 115.297 66.8646 115.41 66.9379 115.51C67.0112 115.61 67.1512 115.7 67.3579 115.78C67.5646 115.86 67.8712 115.947 68.2779 116.04C68.7179 116.127 69.0646 116.243 69.3179 116.39C69.5712 116.537 69.7512 116.707 69.8579 116.9C69.9646 117.093 70.0179 117.317 70.0179 117.57C70.0179 117.85 69.9379 118.107 69.7779 118.34C69.6179 118.573 69.3779 118.76 69.0579 118.9C68.7379 119.033 68.3446 119.1 67.8779 119.1ZM73.2555 119.1C72.5622 119.1 72.0122 118.89 71.6055 118.47C71.1989 118.043 70.9755 117.463 70.9355 116.73C70.9289 116.643 70.9255 116.533 70.9255 116.4C70.9255 116.26 70.9289 116.147 70.9355 116.06C70.9622 115.587 71.0722 115.173 71.2655 114.82C71.4589 114.46 71.7222 114.183 72.0555 113.99C72.3955 113.797 72.7922 113.7 73.2455 113.7C73.7522 113.7 74.1755 113.807 74.5155 114.02C74.8622 114.233 75.1255 114.537 75.3055 114.93C75.4855 115.323 75.5755 115.783 75.5755 116.31V116.48C75.5755 116.553 75.5522 116.61 75.5055 116.65C75.4655 116.69 75.4122 116.71 75.3455 116.71H71.8855C71.8855 116.717 71.8855 116.73 71.8855 116.75C71.8855 116.77 71.8855 116.787 71.8855 116.8C71.8989 117.073 71.9589 117.33 72.0655 117.57C72.1722 117.803 72.3255 117.993 72.5255 118.14C72.7322 118.287 72.9722 118.36 73.2455 118.36C73.4855 118.36 73.6855 118.323 73.8455 118.25C74.0055 118.177 74.1355 118.097 74.2355 118.01C74.3355 117.917 74.4022 117.843 74.4355 117.79C74.4955 117.71 74.5422 117.663 74.5755 117.65C74.6089 117.63 74.6622 117.62 74.7355 117.62H75.2255C75.2855 117.62 75.3355 117.64 75.3755 117.68C75.4222 117.713 75.4422 117.763 75.4355 117.83C75.4289 117.93 75.3755 118.053 75.2755 118.2C75.1755 118.34 75.0322 118.48 74.8455 118.62C74.6655 118.76 74.4389 118.877 74.1655 118.97C73.8989 119.057 73.5955 119.1 73.2555 119.1ZM71.8855 116.02H74.6255V115.99C74.6255 115.69 74.5689 115.423 74.4555 115.19C74.3489 114.957 74.1922 114.773 73.9855 114.64C73.7789 114.5 73.5322 114.43 73.2455 114.43C72.9589 114.43 72.7122 114.5 72.5055 114.64C72.3055 114.773 72.1522 114.957 72.0455 115.19C71.9389 115.423 71.8855 115.69 71.8855 115.99V116.02ZM77.0013 119C76.9346 119 76.8779 118.98 76.8313 118.94C76.7913 118.893 76.7713 118.837 76.7713 118.77V114.04C76.7713 113.973 76.7913 113.917 76.8313 113.87C76.8779 113.823 76.9346 113.8 77.0013 113.8H77.4613C77.5279 113.8 77.5846 113.823 77.6313 113.87C77.6779 113.917 77.7013 113.973 77.7013 114.04V114.48C77.8346 114.253 78.0179 114.083 78.2513 113.97C78.4846 113.857 78.7679 113.8 79.1013 113.8H79.4913C79.5579 113.8 79.6113 113.823 79.6513 113.87C79.6979 113.91 79.7213 113.963 79.7213 114.03V114.44C79.7213 114.507 79.6979 114.56 79.6513 114.6C79.6113 114.64 79.5579 114.66 79.4913 114.66H78.8913C78.5313 114.66 78.2479 114.767 78.0413 114.98C77.8346 115.187 77.7313 115.47 77.7313 115.83V118.77C77.7313 118.837 77.7079 118.893 77.6613 118.94C77.6146 118.98 77.5579 119 77.4913 119H77.0013ZM82.3701 119.1C81.9967 119.1 81.6767 119.053 81.4101 118.96C81.1434 118.867 80.9267 118.753 80.7601 118.62C80.5934 118.487 80.4667 118.353 80.3801 118.22C80.3001 118.087 80.2567 117.98 80.2501 117.9C80.2434 117.827 80.2667 117.77 80.3201 117.73C80.3734 117.69 80.4267 117.67 80.4801 117.67H80.9301C80.9634 117.67 80.9901 117.677 81.0101 117.69C81.0367 117.697 81.0701 117.723 81.1101 117.77C81.1967 117.863 81.2934 117.957 81.4001 118.05C81.5067 118.143 81.6367 118.22 81.7901 118.28C81.9501 118.34 82.1467 118.37 82.3801 118.37C82.7201 118.37 83.0001 118.307 83.2201 118.18C83.4401 118.047 83.5501 117.853 83.5501 117.6C83.5501 117.433 83.5034 117.3 83.4101 117.2C83.3234 117.1 83.1634 117.01 82.9301 116.93C82.7034 116.85 82.3901 116.767 81.9901 116.68C81.5901 116.587 81.2734 116.473 81.0401 116.34C80.8067 116.2 80.6401 116.037 80.5401 115.85C80.4401 115.657 80.3901 115.44 80.3901 115.2C80.3901 114.953 80.4634 114.717 80.6101 114.49C80.7567 114.257 80.9701 114.067 81.2501 113.92C81.5367 113.773 81.8934 113.7 82.3201 113.7C82.6667 113.7 82.9634 113.743 83.2101 113.83C83.4567 113.917 83.6601 114.027 83.8201 114.16C83.9801 114.287 84.1001 114.413 84.1801 114.54C84.2601 114.667 84.3034 114.773 84.3101 114.86C84.3167 114.927 84.2967 114.983 84.2501 115.03C84.2034 115.07 84.1501 115.09 84.0901 115.09H83.6701C83.6234 115.09 83.5834 115.08 83.5501 115.06C83.5234 115.04 83.4967 115.017 83.4701 114.99C83.4034 114.903 83.3234 114.817 83.2301 114.73C83.1434 114.643 83.0267 114.573 82.8801 114.52C82.7401 114.46 82.5534 114.43 82.3201 114.43C81.9867 114.43 81.7367 114.5 81.5701 114.64C81.4034 114.78 81.3201 114.957 81.3201 115.17C81.3201 115.297 81.3567 115.41 81.4301 115.51C81.5034 115.61 81.6434 115.7 81.8501 115.78C82.0567 115.86 82.3634 115.947 82.7701 116.04C83.2101 116.127 83.5567 116.243 83.8101 116.39C84.0634 116.537 84.2434 116.707 84.3501 116.9C84.4567 117.093 84.5101 117.317 84.5101 117.57C84.5101 117.85 84.4301 118.107 84.2701 118.34C84.1101 118.573 83.8701 118.76 83.5501 118.9C83.2301 119.033 82.8367 119.1 82.3701 119.1Z" fill="#9EA1B1"/>
<path d="M130.72 113.2C129.787 113.2 128.98 113.087 128.3 112.86C127.62 112.633 127.053 112.34 126.6 111.98C126.16 111.607 125.827 111.207 125.6 110.78C125.373 110.34 125.253 109.907 125.24 109.48C125.24 109.36 125.28 109.267 125.36 109.2C125.453 109.12 125.56 109.08 125.68 109.08H127.48C127.613 109.08 127.727 109.107 127.82 109.16C127.913 109.213 127.993 109.32 128.06 109.48C128.18 109.84 128.373 110.127 128.64 110.34C128.92 110.553 129.24 110.707 129.6 110.8C129.96 110.88 130.34 110.92 130.74 110.92C131.54 110.92 132.173 110.733 132.64 110.36C133.12 109.973 133.36 109.427 133.36 108.72C133.36 108.013 133.14 107.507 132.7 107.2C132.26 106.88 131.647 106.72 130.86 106.72H128.8C128.653 106.72 128.533 106.68 128.44 106.6C128.347 106.507 128.3 106.387 128.3 106.24V105.4C128.3 105.267 128.327 105.153 128.38 105.06C128.447 104.953 128.513 104.867 128.58 104.8L132.16 101.3H126.44C126.293 101.3 126.173 101.253 126.08 101.16C126 101.067 125.96 100.953 125.96 100.82V99.5C125.96 99.3533 126 99.2333 126.08 99.14C126.173 99.0467 126.293 99 126.44 99H135.02C135.167 99 135.287 99.0467 135.38 99.14C135.473 99.2333 135.52 99.3533 135.52 99.5V100.7C135.52 100.82 135.493 100.927 135.44 101.02C135.387 101.113 135.327 101.193 135.26 101.26L131.8 104.82L132.04 104.84C132.853 104.907 133.573 105.093 134.2 105.4C134.84 105.693 135.333 106.127 135.68 106.7C136.04 107.273 136.22 107.993 136.22 108.86C136.22 109.767 135.98 110.547 135.5 111.2C135.033 111.84 134.387 112.333 133.56 112.68C132.733 113.027 131.787 113.2 130.72 113.2ZM143.658 113.2C142.711 113.2 141.904 113.06 141.238 112.78C140.571 112.5 140.024 112.113 139.598 111.62C139.171 111.127 138.851 110.56 138.638 109.92C138.424 109.267 138.298 108.573 138.258 107.84C138.244 107.48 138.231 107.087 138.218 106.66C138.218 106.22 138.218 105.78 138.218 105.34C138.231 104.9 138.244 104.493 138.258 104.12C138.284 103.387 138.411 102.7 138.638 102.06C138.864 101.407 139.191 100.84 139.618 100.36C140.058 99.88 140.611 99.5 141.278 99.22C141.944 98.94 142.738 98.8 143.658 98.8C144.591 98.8 145.391 98.94 146.058 99.22C146.724 99.5 147.271 99.88 147.698 100.36C148.138 100.84 148.464 101.407 148.678 102.06C148.904 102.7 149.031 103.387 149.058 104.12C149.084 104.493 149.098 104.9 149.098 105.34C149.098 105.78 149.098 106.22 149.098 106.66C149.098 107.087 149.084 107.48 149.058 107.84C149.031 108.573 148.911 109.267 148.698 109.92C148.484 110.56 148.164 111.127 147.738 111.62C147.311 112.113 146.758 112.5 146.078 112.78C145.411 113.06 144.604 113.2 143.658 113.2ZM143.658 110.9C144.524 110.9 145.158 110.62 145.558 110.06C145.971 109.487 146.184 108.713 146.198 107.74C146.224 107.353 146.238 106.967 146.238 106.58C146.238 106.18 146.238 105.78 146.238 105.38C146.238 104.98 146.224 104.6 146.198 104.24C146.184 103.293 145.971 102.533 145.558 101.96C145.158 101.373 144.524 101.08 143.658 101.08C142.804 101.08 142.171 101.373 141.758 101.96C141.358 102.533 141.144 103.293 141.118 104.24C141.118 104.6 141.111 104.98 141.098 105.38C141.098 105.78 141.098 106.18 141.098 106.58C141.111 106.967 141.118 107.353 141.118 107.74C141.144 108.713 141.364 109.487 141.778 110.06C142.191 110.62 142.818 110.9 143.658 110.9ZM152.442 113C152.162 113 152.022 112.867 152.022 112.6C152.022 112.52 152.049 112.447 152.102 112.38L161.962 99.38C162.056 99.26 162.149 99.1667 162.242 99.1C162.336 99.0333 162.469 99 162.642 99H163.702C163.982 99 164.122 99.1333 164.122 99.4C164.122 99.48 164.096 99.5533 164.042 99.62L154.182 112.62C154.089 112.74 153.996 112.833 153.902 112.9C153.822 112.967 153.689 113 153.502 113H152.442ZM162.062 113.12C161.169 113.12 160.462 112.873 159.942 112.38C159.422 111.887 159.136 111.24 159.082 110.44C159.069 110.093 159.062 109.793 159.062 109.54C159.062 109.287 159.069 108.973 159.082 108.6C159.136 107.8 159.409 107.153 159.902 106.66C160.409 106.167 161.129 105.92 162.062 105.92C163.009 105.92 163.729 106.167 164.222 106.66C164.729 107.153 165.002 107.8 165.042 108.6C165.069 108.973 165.082 109.287 165.082 109.54C165.082 109.793 165.069 110.093 165.042 110.44C165.002 111.24 164.716 111.887 164.182 112.38C163.662 112.873 162.956 113.12 162.062 113.12ZM162.062 111.56C162.356 111.56 162.582 111.5 162.742 111.38C162.916 111.26 163.042 111.107 163.122 110.92C163.202 110.733 163.242 110.547 163.242 110.36C163.269 110.027 163.282 109.747 163.282 109.52C163.282 109.28 163.269 109.007 163.242 108.7C163.229 108.38 163.136 108.093 162.962 107.84C162.789 107.587 162.489 107.46 162.062 107.46C161.649 107.46 161.356 107.587 161.182 107.84C161.009 108.093 160.909 108.38 160.882 108.7C160.869 109.007 160.862 109.28 160.862 109.52C160.862 109.747 160.869 110.027 160.882 110.36C160.909 110.547 160.956 110.733 161.022 110.92C161.102 111.107 161.222 111.26 161.382 111.38C161.556 111.5 161.782 111.56 162.062 111.56ZM154.082 106.04C153.189 106.04 152.482 105.807 151.962 105.34C151.442 104.873 151.156 104.24 151.102 103.44C151.089 103.093 151.082 102.793 151.082 102.54C151.082 102.273 151.089 101.953 151.102 101.58C151.156 100.78 151.429 100.133 151.922 99.64C152.429 99.1467 153.149 98.9 154.082 98.9C155.029 98.9 155.749 99.1467 156.242 99.64C156.749 100.133 157.022 100.78 157.062 101.58C157.089 101.953 157.102 102.273 157.102 102.54C157.102 102.793 157.089 103.093 157.062 103.44C157.022 104.24 156.736 104.873 156.202 105.34C155.682 105.807 154.976 106.04 154.082 106.04ZM154.082 104.56C154.376 104.56 154.602 104.5 154.762 104.38C154.936 104.26 155.062 104.107 155.142 103.92C155.222 103.733 155.262 103.54 155.262 103.34C155.289 103.007 155.302 102.727 155.302 102.5C155.302 102.26 155.289 101.987 155.262 101.68C155.249 101.373 155.156 101.093 154.982 100.84C154.809 100.587 154.509 100.46 154.082 100.46C153.669 100.46 153.376 100.587 153.202 100.84C153.029 101.093 152.936 101.373 152.922 101.68C152.909 101.987 152.902 102.26 152.902 102.5C152.902 102.727 152.909 103.007 152.922 103.34C152.936 103.54 152.976 103.733 153.042 103.92C153.122 104.107 153.242 104.26 153.402 104.38C153.576 104.5 153.802 104.56 154.082 104.56Z" fill="white"/>
<rect x="15" y="133.667" width="22" height="22" rx="11" stroke="#E19701" stroke-width="2"/>
<g clip-path="url(#clip1_2788_35203)">
<path d="M26 154.667C31.5228 154.667 36 150.189 36 144.667C36 139.144 31.5228 134.667 26 134.667C20.4772 134.667 16 139.144 16 144.667C16 150.189 20.4772 154.667 26 154.667Z" fill="#1976D2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M30.1198 141.877H28.3169L28.3229 146.117L26.7531 141.875H25.1965L23.8565 145.417C23.714 144.515 22.7821 144.204 22.0487 143.971C21.5646 143.816 21.0506 143.588 21.0558 143.335C21.0598 143.126 21.3308 142.935 21.8683 142.963C22.3283 142.977 22.7788 143.098 23.1833 143.318L23.8083 142.23C23.1729 141.924 22.4783 141.76 21.7731 141.75H21.7692C21.441 141.734 21.113 141.784 20.8044 141.897C20.4958 142.01 20.2128 142.183 19.9719 142.406C19.6983 142.687 19.544 143.062 19.5417 143.454C19.5264 143.699 19.5754 143.943 19.6836 144.163C19.7918 144.383 19.9556 144.571 20.1587 144.708C20.5335 144.959 20.9461 145.147 21.3808 145.267C21.8796 145.422 22.2869 145.556 22.2819 145.842C22.2786 145.947 22.2364 146.047 22.1635 146.123C22.0838 146.19 21.9916 146.24 21.8922 146.271C21.7929 146.303 21.6883 146.314 21.5846 146.305C21.0562 146.325 20.535 146.176 20.0971 145.88L19.5417 146.982C20.1384 147.325 20.816 147.502 21.5042 147.495L21.6671 147.494C22.224 147.512 22.7703 147.339 23.2158 147.004C23.2392 146.985 23.26 146.967 23.2817 146.948L23.2135 147.299L24.7344 147.294L25.0073 146.596C25.3167 146.698 25.6408 146.75 25.9669 146.748C26.285 146.75 26.6014 146.701 26.9044 146.604L27.0946 147.294L29.8237 147.297L29.8304 145.704H30.4104C31.8142 145.704 32.644 144.99 32.644 143.792C32.644 142.458 31.8367 141.877 30.1198 141.877ZM25.9671 145.502C25.7708 145.503 25.5758 145.469 25.3917 145.401L25.9606 143.604H25.9717L26.5315 145.406C26.3501 145.47 26.1593 145.502 25.9671 145.502ZM30.2252 144.469H29.8294V143.021H30.2252C30.7529 143.021 31.1744 143.197 31.1744 143.735C31.1744 144.293 30.7529 144.469 30.2252 144.469Z" fill="white"/>
</g>
<path d="M48.368 143.807C47.556 143.807 46.8747 143.681 46.324 143.429C45.7733 143.177 45.3487 142.855 45.05 142.463C44.7607 142.061 44.6067 141.641 44.588 141.203C44.588 141.128 44.616 141.063 44.672 141.007C44.7373 140.941 44.812 140.909 44.896 140.909H45.61C45.722 140.909 45.806 140.937 45.862 140.993C45.918 141.049 45.9553 141.114 45.974 141.189C46.03 141.413 46.1467 141.637 46.324 141.861C46.5013 142.075 46.7533 142.257 47.08 142.407C47.416 142.547 47.8453 142.617 48.368 142.617C49.1707 142.617 49.7587 142.477 50.132 142.197C50.5147 141.907 50.706 141.525 50.706 141.049C50.706 140.722 50.6033 140.461 50.398 140.265C50.202 140.059 49.8987 139.877 49.488 139.719C49.0773 139.56 48.5453 139.387 47.892 139.201C47.2107 139.005 46.646 138.79 46.198 138.557C45.75 138.323 45.414 138.034 45.19 137.689C44.9753 137.343 44.868 136.905 44.868 136.373C44.868 135.869 45.0033 135.421 45.274 135.029C45.5447 134.627 45.9367 134.31 46.45 134.077C46.9633 133.843 47.5793 133.727 48.298 133.727C48.8767 133.727 49.3807 133.806 49.81 133.965C50.2487 134.114 50.6127 134.319 50.902 134.581C51.1913 134.833 51.4107 135.108 51.56 135.407C51.7093 135.696 51.7887 135.981 51.798 136.261C51.798 136.326 51.7747 136.391 51.728 136.457C51.6813 136.513 51.6067 136.541 51.504 136.541H50.762C50.6967 136.541 50.6267 136.522 50.552 136.485C50.4867 136.447 50.4353 136.377 50.398 136.275C50.342 135.892 50.1273 135.57 49.754 135.309C49.3807 135.047 48.8953 134.917 48.298 134.917C47.6913 134.917 47.1967 135.033 46.814 135.267C46.4407 135.5 46.254 135.864 46.254 136.359C46.254 136.676 46.3427 136.942 46.52 137.157C46.6973 137.362 46.9773 137.544 47.36 137.703C47.7427 137.861 48.242 138.029 48.858 138.207C49.6047 138.412 50.216 138.631 50.692 138.865C51.168 139.089 51.518 139.373 51.742 139.719C51.9753 140.055 52.092 140.489 52.092 141.021C52.092 141.609 51.938 142.113 51.63 142.533C51.322 142.943 50.888 143.261 50.328 143.485C49.7773 143.699 49.124 143.807 48.368 143.807ZM53.1323 143.667C53.0576 143.667 52.9923 143.639 52.9363 143.583C52.8803 143.527 52.8523 143.461 52.8523 143.387C52.8523 143.34 52.8569 143.289 52.8663 143.233L56.3383 134.175C56.3756 134.081 56.4269 134.007 56.4923 133.951C56.5576 133.895 56.6556 133.867 56.7863 133.867H57.7383C57.8689 133.867 57.9669 133.895 58.0323 133.951C58.0976 134.007 58.1489 134.081 58.1863 134.175L61.6443 143.233C61.6629 143.289 61.6723 143.34 61.6723 143.387C61.6723 143.461 61.6443 143.527 61.5883 143.583C61.5323 143.639 61.4669 143.667 61.3923 143.667H60.6783C60.5663 143.667 60.4823 143.639 60.4263 143.583C60.3796 143.527 60.3469 143.475 60.3283 143.429L59.5583 141.441H54.9663L54.1963 143.429C54.1869 143.475 54.1543 143.527 54.0983 143.583C54.0423 143.639 53.9583 143.667 53.8463 143.667H53.1323ZM55.3723 140.237H59.1523L57.2623 135.267L55.3723 140.237ZM63.4912 143.667C63.3885 143.667 63.3092 143.639 63.2532 143.583C63.1972 143.517 63.1692 143.438 63.1692 143.345V134.203C63.1692 134.1 63.1972 134.021 63.2532 133.965C63.3092 133.899 63.3885 133.867 63.4912 133.867H67.0472C67.7378 133.867 68.3352 133.979 68.8392 134.203C69.3525 134.427 69.7492 134.763 70.0292 135.211C70.3092 135.649 70.4492 136.2 70.4492 136.863C70.4492 137.525 70.3092 138.076 70.0292 138.515C69.7492 138.953 69.3525 139.285 68.8392 139.509C68.3352 139.733 67.7378 139.845 67.0472 139.845H64.5692V143.345C64.5692 143.438 64.5365 143.517 64.4712 143.583C64.4152 143.639 64.3358 143.667 64.2332 143.667H63.4912ZM64.5552 138.669H66.9772C67.6678 138.669 68.1858 138.515 68.5312 138.207C68.8765 137.899 69.0492 137.451 69.0492 136.863C69.0492 136.284 68.8812 135.836 68.5452 135.519C68.2092 135.201 67.6865 135.043 66.9772 135.043H64.5552V138.669Z" fill="white"/>
<path d="M46.76 157.667C46.6933 157.667 46.6367 157.647 46.59 157.607C46.55 157.56 46.53 157.503 46.53 157.437V151.837L44.87 153.117C44.8167 153.157 44.76 153.173 44.7 153.167C44.64 153.16 44.59 153.13 44.55 153.077L44.29 152.747C44.25 152.687 44.2333 152.627 44.24 152.567C44.2533 152.507 44.2867 152.457 44.34 152.417L46.52 150.737C46.5667 150.703 46.61 150.683 46.65 150.677C46.69 150.67 46.7333 150.667 46.78 150.667H47.29C47.3567 150.667 47.41 150.69 47.45 150.737C47.4967 150.777 47.52 150.83 47.52 150.897V157.437C47.52 157.503 47.4967 157.56 47.45 157.607C47.41 157.647 47.3567 157.667 47.29 157.667H46.76ZM49.3773 157.667C49.304 157.667 49.2473 157.647 49.2073 157.607C49.1673 157.56 49.1473 157.503 49.1473 157.437V150.907C49.1473 150.833 49.1673 150.777 49.2073 150.737C49.2473 150.69 49.304 150.667 49.3773 150.667H49.8773C49.9507 150.667 50.0073 150.69 50.0473 150.737C50.094 150.777 50.1173 150.833 50.1173 150.907V153.387L52.7873 150.827C52.814 150.8 52.8573 150.767 52.9173 150.727C52.984 150.687 53.0707 150.667 53.1773 150.667H53.7173C53.7707 150.667 53.8173 150.687 53.8573 150.727C53.8973 150.767 53.9173 150.813 53.9173 150.867C53.9173 150.92 53.904 150.963 53.8773 150.997L50.7873 154.017L54.0773 157.327C54.1107 157.367 54.1273 157.413 54.1273 157.467C54.1273 157.52 54.1073 157.567 54.0673 157.607C54.0273 157.647 53.9807 157.667 53.9273 157.667H53.3673C53.254 157.667 53.1673 157.647 53.1073 157.607C53.0473 157.56 53.004 157.523 52.9773 157.497L50.1173 154.687V157.437C50.1173 157.503 50.094 157.56 50.0473 157.607C50.0073 157.647 49.9507 157.667 49.8773 157.667H49.3773ZM60.1467 157.767C59.5867 157.767 59.1034 157.667 58.6967 157.467C58.2967 157.267 57.9867 156.963 57.7667 156.557C57.5534 156.143 57.4467 155.613 57.4467 154.967V150.907C57.4467 150.833 57.4667 150.777 57.5067 150.737C57.5467 150.69 57.6034 150.667 57.6767 150.667H58.1867C58.2601 150.667 58.3167 150.69 58.3567 150.737C58.4034 150.777 58.4267 150.833 58.4267 150.907V154.987C58.4267 155.64 58.5801 156.123 58.8867 156.437C59.1934 156.75 59.6134 156.907 60.1467 156.907C60.6734 156.907 61.0901 156.75 61.3967 156.437C61.7101 156.123 61.8667 155.64 61.8667 154.987V150.907C61.8667 150.833 61.8867 150.777 61.9267 150.737C61.9734 150.69 62.0301 150.667 62.0967 150.667H62.6167C62.6834 150.667 62.7367 150.69 62.7767 150.737C62.8234 150.777 62.8467 150.833 62.8467 150.907V154.967C62.8467 155.613 62.7367 156.143 62.5167 156.557C62.3034 156.963 61.9967 157.267 61.5967 157.467C61.1967 157.667 60.7134 157.767 60.1467 157.767ZM66.1494 157.767C65.776 157.767 65.456 157.72 65.1894 157.627C64.9227 157.533 64.706 157.42 64.5394 157.287C64.3727 157.153 64.246 157.02 64.1594 156.887C64.0794 156.753 64.036 156.647 64.0294 156.567C64.0227 156.493 64.046 156.437 64.0994 156.397C64.1527 156.357 64.206 156.337 64.2594 156.337H64.7094C64.7427 156.337 64.7694 156.343 64.7894 156.357C64.816 156.363 64.8494 156.39 64.8894 156.437C64.976 156.53 65.0727 156.623 65.1794 156.717C65.286 156.81 65.416 156.887 65.5694 156.947C65.7294 157.007 65.926 157.037 66.1594 157.037C66.4994 157.037 66.7794 156.973 66.9994 156.847C67.2194 156.713 67.3294 156.52 67.3294 156.267C67.3294 156.1 67.2827 155.967 67.1894 155.867C67.1027 155.767 66.9427 155.677 66.7094 155.597C66.4827 155.517 66.1694 155.433 65.7694 155.347C65.3694 155.253 65.0527 155.14 64.8194 155.007C64.586 154.867 64.4194 154.703 64.3194 154.517C64.2194 154.323 64.1694 154.107 64.1694 153.867C64.1694 153.62 64.2427 153.383 64.3894 153.157C64.536 152.923 64.7494 152.733 65.0294 152.587C65.316 152.44 65.6727 152.367 66.0994 152.367C66.446 152.367 66.7427 152.41 66.9894 152.497C67.236 152.583 67.4394 152.693 67.5994 152.827C67.7594 152.953 67.8794 153.08 67.9594 153.207C68.0394 153.333 68.0827 153.44 68.0894 153.527C68.096 153.593 68.076 153.65 68.0294 153.697C67.9827 153.737 67.9294 153.757 67.8694 153.757H67.4494C67.4027 153.757 67.3627 153.747 67.3294 153.727C67.3027 153.707 67.276 153.683 67.2494 153.657C67.1827 153.57 67.1027 153.483 67.0094 153.397C66.9227 153.31 66.806 153.24 66.6594 153.187C66.5194 153.127 66.3327 153.097 66.0994 153.097C65.766 153.097 65.516 153.167 65.3494 153.307C65.1827 153.447 65.0994 153.623 65.0994 153.837C65.0994 153.963 65.136 154.077 65.2094 154.177C65.2827 154.277 65.4227 154.367 65.6294 154.447C65.836 154.527 66.1427 154.613 66.5494 154.707C66.9894 154.793 67.336 154.91 67.5894 155.057C67.8427 155.203 68.0227 155.373 68.1294 155.567C68.236 155.76 68.2894 155.983 68.2894 156.237C68.2894 156.517 68.2094 156.773 68.0494 157.007C67.8894 157.24 67.6494 157.427 67.3294 157.567C67.0094 157.7 66.616 157.767 66.1494 157.767ZM71.527 157.767C70.8337 157.767 70.2837 157.557 69.877 157.137C69.4704 156.71 69.247 156.13 69.207 155.397C69.2004 155.31 69.197 155.2 69.197 155.067C69.197 154.927 69.2004 154.813 69.207 154.727C69.2337 154.253 69.3437 153.84 69.537 153.487C69.7304 153.127 69.9937 152.85 70.327 152.657C70.667 152.463 71.0637 152.367 71.517 152.367C72.0237 152.367 72.447 152.473 72.787 152.687C73.1337 152.9 73.397 153.203 73.577 153.597C73.757 153.99 73.847 154.45 73.847 154.977V155.147C73.847 155.22 73.8237 155.277 73.777 155.317C73.737 155.357 73.6837 155.377 73.617 155.377H70.157C70.157 155.383 70.157 155.397 70.157 155.417C70.157 155.437 70.157 155.453 70.157 155.467C70.1704 155.74 70.2304 155.997 70.337 156.237C70.4437 156.47 70.597 156.66 70.797 156.807C71.0037 156.953 71.2437 157.027 71.517 157.027C71.757 157.027 71.957 156.99 72.117 156.917C72.277 156.843 72.407 156.763 72.507 156.677C72.607 156.583 72.6737 156.51 72.707 156.457C72.767 156.377 72.8137 156.33 72.847 156.317C72.8804 156.297 72.9337 156.287 73.007 156.287H73.497C73.557 156.287 73.607 156.307 73.647 156.347C73.6937 156.38 73.7137 156.43 73.707 156.497C73.7004 156.597 73.647 156.72 73.547 156.867C73.447 157.007 73.3037 157.147 73.117 157.287C72.937 157.427 72.7104 157.543 72.437 157.637C72.1704 157.723 71.867 157.767 71.527 157.767ZM70.157 154.687H72.897V154.657C72.897 154.357 72.8404 154.09 72.727 153.857C72.6204 153.623 72.4637 153.44 72.257 153.307C72.0504 153.167 71.8037 153.097 71.517 153.097C71.2304 153.097 70.9837 153.167 70.777 153.307C70.577 153.44 70.4237 153.623 70.317 153.857C70.2104 154.09 70.157 154.357 70.157 154.657V154.687ZM75.2727 157.667C75.2061 157.667 75.1494 157.647 75.1027 157.607C75.0627 157.56 75.0427 157.503 75.0427 157.437V152.707C75.0427 152.64 75.0627 152.583 75.1027 152.537C75.1494 152.49 75.2061 152.467 75.2727 152.467H75.7327C75.7994 152.467 75.8561 152.49 75.9027 152.537C75.9494 152.583 75.9727 152.64 75.9727 152.707V153.147C76.1061 152.92 76.2894 152.75 76.5227 152.637C76.7561 152.523 77.0394 152.467 77.3727 152.467H77.7627C77.8294 152.467 77.8827 152.49 77.9227 152.537C77.9694 152.577 77.9927 152.63 77.9927 152.697V153.107C77.9927 153.173 77.9694 153.227 77.9227 153.267C77.8827 153.307 77.8294 153.327 77.7627 153.327H77.1627C76.8027 153.327 76.5194 153.433 76.3127 153.647C76.1061 153.853 76.0027 154.137 76.0027 154.497V157.437C76.0027 157.503 75.9794 157.56 75.9327 157.607C75.8861 157.647 75.8294 157.667 75.7627 157.667H75.2727ZM80.6416 157.767C80.2682 157.767 79.9482 157.72 79.6816 157.627C79.4149 157.533 79.1982 157.42 79.0316 157.287C78.8649 157.153 78.7382 157.02 78.6516 156.887C78.5716 156.753 78.5282 156.647 78.5216 156.567C78.5149 156.493 78.5382 156.437 78.5916 156.397C78.6449 156.357 78.6982 156.337 78.7516 156.337H79.2016C79.2349 156.337 79.2616 156.343 79.2816 156.357C79.3082 156.363 79.3416 156.39 79.3816 156.437C79.4682 156.53 79.5649 156.623 79.6716 156.717C79.7782 156.81 79.9082 156.887 80.0616 156.947C80.2216 157.007 80.4182 157.037 80.6516 157.037C80.9916 157.037 81.2716 156.973 81.4916 156.847C81.7116 156.713 81.8216 156.52 81.8216 156.267C81.8216 156.1 81.7749 155.967 81.6816 155.867C81.5949 155.767 81.4349 155.677 81.2016 155.597C80.9749 155.517 80.6616 155.433 80.2616 155.347C79.8616 155.253 79.5449 155.14 79.3116 155.007C79.0782 154.867 78.9116 154.703 78.8116 154.517C78.7116 154.323 78.6616 154.107 78.6616 153.867C78.6616 153.62 78.7349 153.383 78.8816 153.157C79.0282 152.923 79.2416 152.733 79.5216 152.587C79.8082 152.44 80.1649 152.367 80.5916 152.367C80.9382 152.367 81.2349 152.41 81.4816 152.497C81.7282 152.583 81.9316 152.693 82.0916 152.827C82.2516 152.953 82.3716 153.08 82.4516 153.207C82.5316 153.333 82.5749 153.44 82.5816 153.527C82.5882 153.593 82.5682 153.65 82.5216 153.697C82.4749 153.737 82.4216 153.757 82.3616 153.757H81.9416C81.8949 153.757 81.8549 153.747 81.8216 153.727C81.7949 153.707 81.7682 153.683 81.7416 153.657C81.6749 153.57 81.5949 153.483 81.5016 153.397C81.4149 153.31 81.2982 153.24 81.1516 153.187C81.0116 153.127 80.8249 153.097 80.5916 153.097C80.2582 153.097 80.0082 153.167 79.8416 153.307C79.6749 153.447 79.5916 153.623 79.5916 153.837C79.5916 153.963 79.6282 154.077 79.7016 154.177C79.7749 154.277 79.9149 154.367 80.1216 154.447C80.3282 154.527 80.6349 154.613 81.0416 154.707C81.4816 154.793 81.8282 154.91 82.0816 155.057C82.3349 155.203 82.5149 155.373 82.6216 155.567C82.7282 155.76 82.7816 155.983 82.7816 156.237C82.7816 156.517 82.7016 156.773 82.5416 157.007C82.3816 157.24 82.1416 157.427 81.8216 157.567C81.5016 157.7 81.1082 157.767 80.6416 157.767Z" fill="#9EA1B1"/>
<path d="M133.04 151.667C132.893 151.667 132.773 151.62 132.68 151.527C132.6 151.433 132.56 151.32 132.56 151.187V140.827L129.52 143.167C129.4 143.247 129.28 143.28 129.16 143.267C129.04 143.24 128.933 143.167 128.84 143.047L128 141.967C127.92 141.847 127.887 141.72 127.9 141.587C127.927 141.453 128 141.347 128.12 141.267L132.6 137.807C132.68 137.74 132.76 137.7 132.84 137.687C132.92 137.673 133.007 137.667 133.1 137.667H134.86C134.993 137.667 135.107 137.713 135.2 137.807C135.293 137.9 135.34 138.013 135.34 138.147V151.187C135.34 151.32 135.293 151.433 135.2 151.527C135.107 151.62 134.993 151.667 134.86 151.667H133.04ZM143.318 151.867C142.371 151.867 141.564 151.727 140.898 151.447C140.231 151.167 139.684 150.78 139.258 150.287C138.831 149.793 138.511 149.227 138.298 148.587C138.084 147.933 137.958 147.24 137.918 146.507C137.904 146.147 137.891 145.753 137.878 145.327C137.878 144.887 137.878 144.447 137.878 144.007C137.891 143.567 137.904 143.16 137.918 142.787C137.944 142.053 138.071 141.367 138.298 140.727C138.524 140.073 138.851 139.507 139.278 139.027C139.718 138.547 140.271 138.167 140.938 137.887C141.604 137.607 142.398 137.467 143.318 137.467C144.251 137.467 145.051 137.607 145.718 137.887C146.384 138.167 146.931 138.547 147.358 139.027C147.798 139.507 148.124 140.073 148.338 140.727C148.564 141.367 148.691 142.053 148.718 142.787C148.744 143.16 148.758 143.567 148.758 144.007C148.758 144.447 148.758 144.887 148.758 145.327C148.758 145.753 148.744 146.147 148.718 146.507C148.691 147.24 148.571 147.933 148.358 148.587C148.144 149.227 147.824 149.793 147.398 150.287C146.971 150.78 146.418 151.167 145.738 151.447C145.071 151.727 144.264 151.867 143.318 151.867ZM143.318 149.567C144.184 149.567 144.818 149.287 145.218 148.727C145.631 148.153 145.844 147.38 145.858 146.407C145.884 146.02 145.898 145.633 145.898 145.247C145.898 144.847 145.898 144.447 145.898 144.047C145.898 143.647 145.884 143.267 145.858 142.907C145.844 141.96 145.631 141.2 145.218 140.627C144.818 140.04 144.184 139.747 143.318 139.747C142.464 139.747 141.831 140.04 141.418 140.627C141.018 141.2 140.804 141.96 140.778 142.907C140.778 143.267 140.771 143.647 140.758 144.047C140.758 144.447 140.758 144.847 140.758 145.247C140.771 145.633 140.778 146.02 140.778 146.407C140.804 147.38 141.024 148.153 141.438 148.727C141.851 149.287 142.478 149.567 143.318 149.567ZM152.102 151.667C151.822 151.667 151.682 151.533 151.682 151.267C151.682 151.187 151.709 151.113 151.762 151.047L161.622 138.047C161.716 137.927 161.809 137.833 161.902 137.767C161.996 137.7 162.129 137.667 162.302 137.667H163.362C163.642 137.667 163.782 137.8 163.782 138.067C163.782 138.147 163.756 138.22 163.702 138.287L153.842 151.287C153.749 151.407 153.656 151.5 153.562 151.567C153.482 151.633 153.349 151.667 153.162 151.667H152.102ZM161.722 151.787C160.829 151.787 160.122 151.54 159.602 151.047C159.082 150.553 158.796 149.907 158.742 149.107C158.729 148.76 158.722 148.46 158.722 148.207C158.722 147.953 158.729 147.64 158.742 147.267C158.796 146.467 159.069 145.82 159.562 145.327C160.069 144.833 160.789 144.587 161.722 144.587C162.669 144.587 163.389 144.833 163.882 145.327C164.389 145.82 164.662 146.467 164.702 147.267C164.729 147.64 164.742 147.953 164.742 148.207C164.742 148.46 164.729 148.76 164.702 149.107C164.662 149.907 164.376 150.553 163.842 151.047C163.322 151.54 162.616 151.787 161.722 151.787ZM161.722 150.227C162.016 150.227 162.242 150.167 162.402 150.047C162.576 149.927 162.702 149.773 162.782 149.587C162.862 149.4 162.902 149.213 162.902 149.027C162.929 148.693 162.942 148.413 162.942 148.187C162.942 147.947 162.929 147.673 162.902 147.367C162.889 147.047 162.796 146.76 162.622 146.507C162.449 146.253 162.149 146.127 161.722 146.127C161.309 146.127 161.016 146.253 160.842 146.507C160.669 146.76 160.569 147.047 160.542 147.367C160.529 147.673 160.522 147.947 160.522 148.187C160.522 148.413 160.529 148.693 160.542 149.027C160.569 149.213 160.616 149.4 160.682 149.587C160.762 149.773 160.882 149.927 161.042 150.047C161.216 150.167 161.442 150.227 161.722 150.227ZM153.742 144.707C152.849 144.707 152.142 144.473 151.622 144.007C151.102 143.54 150.816 142.907 150.762 142.107C150.749 141.76 150.742 141.46 150.742 141.207C150.742 140.94 150.749 140.62 150.762 140.247C150.816 139.447 151.089 138.8 151.582 138.307C152.089 137.813 152.809 137.567 153.742 137.567C154.689 137.567 155.409 137.813 155.902 138.307C156.409 138.8 156.682 139.447 156.722 140.247C156.749 140.62 156.762 140.94 156.762 141.207C156.762 141.46 156.749 141.76 156.722 142.107C156.682 142.907 156.396 143.54 155.862 144.007C155.342 144.473 154.636 144.707 153.742 144.707ZM153.742 143.227C154.036 143.227 154.262 143.167 154.422 143.047C154.596 142.927 154.722 142.773 154.802 142.587C154.882 142.4 154.922 142.207 154.922 142.007C154.949 141.673 154.962 141.393 154.962 141.167C154.962 140.927 154.949 140.653 154.922 140.347C154.909 140.04 154.816 139.76 154.642 139.507C154.469 139.253 154.169 139.127 153.742 139.127C153.329 139.127 153.036 139.253 152.862 139.507C152.689 139.76 152.596 140.04 152.582 140.347C152.569 140.653 152.562 140.927 152.562 141.167C152.562 141.393 152.569 141.673 152.582 142.007C152.596 142.207 152.636 142.4 152.702 142.587C152.782 142.773 152.902 142.927 153.062 143.047C153.236 143.167 153.462 143.227 153.742 143.227Z" fill="white"/>
<g clip-path="url(#clip2_2788_35203)">
<rect x="182.5" y="52" width="96" height="62.9939" fill="#0294F7"/>
<rect x="182.5" y="115.994" width="96" height="24.2849" fill="#D057FF"/>
<rect x="182.5" y="141.279" width="96" height="18.7212" fill="#E19701"/>
</g>
<defs>
<clipPath id="clip0_2788_35203">
<rect x="16" y="96" width="20" height="20" rx="10" fill="white"/>
</clipPath>
<clipPath id="clip1_2788_35203">
<rect width="20" height="20" fill="white" transform="translate(16 134.667)"/>
</clipPath>
<clipPath id="clip2_2788_35203">
<rect x="182.5" y="52" width="96" height="108" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $c49aa0f374b6c6e6$export$f452b0b7b391032f = `<svg width="295" height="176" viewBox="0 0 295 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="0.5" width="293.5" height="175" rx="7.5" fill="white"/>
<rect x="1" y="0.5" width="293.5" height="175" rx="7.5" stroke="#6888B5"/>
<path d="M21.498 33.14C20.686 33.14 19.9813 33.0047 19.384 32.734C18.7867 32.454 18.3247 32.0293 17.998 31.46C17.6713 30.8813 17.508 30.144 17.508 29.248V23.55C17.508 23.4473 17.5407 23.3633 17.606 23.298C17.6713 23.2327 17.7507 23.2 17.844 23.2H19.118C19.2207 23.2 19.3 23.2327 19.356 23.298C19.4213 23.3633 19.454 23.4473 19.454 23.55V29.248C19.454 30.0133 19.636 30.5827 20 30.956C20.364 31.32 20.8633 31.502 21.498 31.502C22.1327 31.502 22.6273 31.32 22.982 30.956C23.346 30.5827 23.528 30.0133 23.528 29.248V23.55C23.528 23.4473 23.5607 23.3633 23.626 23.298C23.6913 23.2327 23.7753 23.2 23.878 23.2H25.138C25.2407 23.2 25.32 23.2327 25.376 23.298C25.4413 23.3633 25.474 23.4473 25.474 23.55V29.248C25.474 30.144 25.3107 30.8813 24.984 31.46C24.6667 32.0293 24.2093 32.454 23.612 32.734C23.024 33.0047 22.3193 33.14 21.498 33.14ZM30.1215 33.14C29.5615 33.14 29.0808 33.0747 28.6795 32.944C28.2875 32.8133 27.9655 32.65 27.7135 32.454C27.4615 32.258 27.2748 32.062 27.1535 31.866C27.0321 31.67 26.9668 31.5067 26.9575 31.376C26.9481 31.2733 26.9761 31.194 27.0415 31.138C27.1161 31.0727 27.1955 31.04 27.2795 31.04H28.3855C28.4228 31.04 28.4555 31.0447 28.4835 31.054C28.5115 31.0633 28.5488 31.0913 28.5955 31.138C28.7168 31.2407 28.8428 31.348 28.9735 31.46C29.1135 31.572 29.2768 31.67 29.4635 31.754C29.6501 31.8287 29.8835 31.866 30.1635 31.866C30.5275 31.866 30.8308 31.796 31.0735 31.656C31.3255 31.5067 31.4515 31.2967 31.4515 31.026C31.4515 30.83 31.3955 30.6713 31.2835 30.55C31.1808 30.4287 30.9848 30.3213 30.6955 30.228C30.4061 30.1253 29.9955 30.018 29.4635 29.906C28.9408 29.7847 28.5068 29.6307 28.1615 29.444C27.8161 29.2573 27.5595 29.024 27.3915 28.744C27.2235 28.464 27.1395 28.1373 27.1395 27.764C27.1395 27.4 27.2468 27.0547 27.4615 26.728C27.6855 26.392 28.0121 26.1167 28.4415 25.902C28.8801 25.6873 29.4215 25.58 30.0655 25.58C30.5695 25.58 31.0081 25.6453 31.3815 25.776C31.7548 25.8973 32.0628 26.0513 32.3055 26.238C32.5575 26.4247 32.7488 26.616 32.8795 26.812C33.0101 26.9987 33.0801 27.162 33.0895 27.302C33.0988 27.4047 33.0708 27.4887 33.0055 27.554C32.9401 27.61 32.8655 27.638 32.7815 27.638H31.7455C31.6988 27.638 31.6568 27.6287 31.6195 27.61C31.5821 27.5913 31.5448 27.568 31.5075 27.54C31.4048 27.4467 31.2928 27.3487 31.1715 27.246C31.0501 27.134 30.9008 27.0407 30.7235 26.966C30.5555 26.8913 30.3315 26.854 30.0515 26.854C29.6968 26.854 29.4261 26.9333 29.2395 27.092C29.0528 27.2413 28.9595 27.4327 28.9595 27.666C28.9595 27.8247 29.0015 27.9647 29.0855 28.086C29.1788 28.198 29.3608 28.3053 29.6315 28.408C29.9021 28.5107 30.3128 28.618 30.8635 28.73C31.4888 28.842 31.9835 29.01 32.3475 29.234C32.7208 29.4487 32.9821 29.7007 33.1315 29.99C33.2901 30.27 33.3695 30.5827 33.3695 30.928C33.3695 31.348 33.2435 31.726 32.9915 32.062C32.7488 32.398 32.3848 32.664 31.8995 32.86C31.4235 33.0467 30.8308 33.14 30.1215 33.14ZM37.9506 33.14C36.9146 33.14 36.0933 32.8413 35.4866 32.244C34.88 31.6467 34.5533 30.7973 34.5066 29.696C34.4973 29.6027 34.4926 29.486 34.4926 29.346C34.4926 29.1967 34.4973 29.08 34.5066 28.996C34.544 28.2867 34.7026 27.68 34.9826 27.176C35.272 26.6627 35.6686 26.2707 36.1726 26C36.6766 25.72 37.2693 25.58 37.9506 25.58C38.7066 25.58 39.3413 25.7387 39.8546 26.056C40.368 26.364 40.7553 26.798 41.0166 27.358C41.278 27.9087 41.4086 28.548 41.4086 29.276V29.57C41.4086 29.6633 41.376 29.7427 41.3106 29.808C41.2453 29.8733 41.1613 29.906 41.0586 29.906H36.4106C36.4106 29.906 36.4106 29.92 36.4106 29.948C36.4106 29.976 36.4106 29.9993 36.4106 30.018C36.42 30.3447 36.4806 30.648 36.5926 30.928C36.714 31.1987 36.8866 31.418 37.1106 31.586C37.344 31.754 37.6193 31.838 37.9366 31.838C38.198 31.838 38.4173 31.8007 38.5946 31.726C38.772 31.642 38.9166 31.5487 39.0286 31.446C39.1406 31.3433 39.22 31.2593 39.2666 31.194C39.3506 31.082 39.416 31.0167 39.4626 30.998C39.5186 30.97 39.598 30.956 39.7006 30.956H40.9046C40.998 30.956 41.0726 30.984 41.1286 31.04C41.194 31.096 41.222 31.166 41.2126 31.25C41.2033 31.3993 41.124 31.5813 40.9746 31.796C40.8346 32.0107 40.6293 32.2207 40.3586 32.426C40.088 32.6313 39.7473 32.804 39.3366 32.944C38.9353 33.0747 38.4733 33.14 37.9506 33.14ZM36.4106 28.73H39.5046V28.688C39.5046 28.324 39.444 28.0067 39.3226 27.736C39.2013 27.456 39.024 27.2413 38.7906 27.092C38.5573 26.9333 38.2773 26.854 37.9506 26.854C37.624 26.854 37.344 26.9333 37.1106 27.092C36.8773 27.2413 36.7 27.456 36.5786 27.736C36.4666 28.0067 36.4106 28.324 36.4106 28.688V28.73ZM43.2307 33C43.1374 33 43.058 32.9673 42.9927 32.902C42.9274 32.8367 42.8947 32.7573 42.8947 32.664V26.07C42.8947 25.9673 42.9274 25.8833 42.9927 25.818C43.058 25.7527 43.1374 25.72 43.2307 25.72H44.3647C44.458 25.72 44.5374 25.7527 44.6027 25.818C44.6774 25.8833 44.7147 25.9673 44.7147 26.07V26.644C44.9294 26.3453 45.2047 26.1167 45.5407 25.958C45.886 25.7993 46.2827 25.72 46.7307 25.72H47.3047C47.4074 25.72 47.4867 25.7527 47.5427 25.818C47.608 25.8833 47.6407 25.9627 47.6407 26.056V27.064C47.6407 27.1573 47.608 27.2367 47.5427 27.302C47.4867 27.3673 47.4074 27.4 47.3047 27.4H46.2127C45.7647 27.4 45.4147 27.526 45.1627 27.778C44.92 28.0207 44.7987 28.366 44.7987 28.814V32.664C44.7987 32.7573 44.766 32.8367 44.7007 32.902C44.6354 32.9673 44.5514 33 44.4487 33H43.2307ZM51.4906 33.14C50.9306 33.14 50.4499 33.0747 50.0486 32.944C49.6566 32.8133 49.3346 32.65 49.0826 32.454C48.8306 32.258 48.6439 32.062 48.5226 31.866C48.4013 31.67 48.3359 31.5067 48.3266 31.376C48.3173 31.2733 48.3453 31.194 48.4106 31.138C48.4853 31.0727 48.5646 31.04 48.6486 31.04H49.7546C49.7919 31.04 49.8246 31.0447 49.8526 31.054C49.8806 31.0633 49.9179 31.0913 49.9646 31.138C50.0859 31.2407 50.2119 31.348 50.3426 31.46C50.4826 31.572 50.6459 31.67 50.8326 31.754C51.0193 31.8287 51.2526 31.866 51.5326 31.866C51.8966 31.866 52.1999 31.796 52.4426 31.656C52.6946 31.5067 52.8206 31.2967 52.8206 31.026C52.8206 30.83 52.7646 30.6713 52.6526 30.55C52.5499 30.4287 52.3539 30.3213 52.0646 30.228C51.7753 30.1253 51.3646 30.018 50.8326 29.906C50.3099 29.7847 49.8759 29.6307 49.5306 29.444C49.1853 29.2573 48.9286 29.024 48.7606 28.744C48.5926 28.464 48.5086 28.1373 48.5086 27.764C48.5086 27.4 48.6159 27.0547 48.8306 26.728C49.0546 26.392 49.3813 26.1167 49.8106 25.902C50.2493 25.6873 50.7906 25.58 51.4346 25.58C51.9386 25.58 52.3773 25.6453 52.7506 25.776C53.1239 25.8973 53.4319 26.0513 53.6746 26.238C53.9266 26.4247 54.1179 26.616 54.2486 26.812C54.3793 26.9987 54.4493 27.162 54.4586 27.302C54.4679 27.4047 54.4399 27.4887 54.3746 27.554C54.3093 27.61 54.2346 27.638 54.1506 27.638H53.1146C53.0679 27.638 53.0259 27.6287 52.9886 27.61C52.9513 27.5913 52.9139 27.568 52.8766 27.54C52.7739 27.4467 52.6619 27.3487 52.5406 27.246C52.4193 27.134 52.2699 27.0407 52.0926 26.966C51.9246 26.8913 51.7006 26.854 51.4206 26.854C51.0659 26.854 50.7953 26.9333 50.6086 27.092C50.4219 27.2413 50.3286 27.4327 50.3286 27.666C50.3286 27.8247 50.3706 27.9647 50.4546 28.086C50.5479 28.198 50.7299 28.3053 51.0006 28.408C51.2713 28.5107 51.6819 28.618 52.2326 28.73C52.8579 28.842 53.3526 29.01 53.7166 29.234C54.0899 29.4487 54.3513 29.7007 54.5006 29.99C54.6593 30.27 54.7386 30.5827 54.7386 30.928C54.7386 31.348 54.6126 31.726 54.3606 32.062C54.1179 32.398 53.7539 32.664 53.2686 32.86C52.7926 33.0467 52.1999 33.14 51.4906 33.14ZM58.5798 33C58.5052 33 58.4352 32.972 58.3698 32.916C58.3138 32.86 58.2858 32.79 58.2858 32.706C58.2858 32.6687 58.2952 32.6267 58.3138 32.58L61.6878 23.55C61.7158 23.4567 61.7672 23.3773 61.8418 23.312C61.9258 23.2373 62.0378 23.2 62.1778 23.2H63.7038C63.8438 23.2 63.9512 23.2373 64.0258 23.312C64.1005 23.3773 64.1565 23.4567 64.1938 23.55L67.5678 32.58C67.5772 32.6267 67.5818 32.6687 67.5818 32.706C67.5818 32.79 67.5538 32.86 67.4978 32.916C67.4418 32.972 67.3765 33 67.3018 33H66.0838C65.9532 33 65.8552 32.972 65.7898 32.916C65.7338 32.8507 65.6965 32.79 65.6778 32.734L65.0198 31.026H60.8618L60.2038 32.734C60.1852 32.79 60.1432 32.8507 60.0778 32.916C60.0218 32.972 59.9285 33 59.7978 33H58.5798ZM61.3518 29.416H64.5298L62.9338 25.09L61.3518 29.416ZM71.3408 33.14C70.8555 33.14 70.4262 33.0607 70.0528 32.902C69.6888 32.734 69.3855 32.5007 69.1428 32.202C68.9002 31.9033 68.7135 31.5533 68.5828 31.152C68.4522 30.7413 68.3775 30.2933 68.3588 29.808C68.3495 29.64 68.3448 29.4907 68.3448 29.36C68.3448 29.22 68.3495 29.066 68.3588 28.898C68.3775 28.4313 68.4475 27.9973 68.5688 27.596C68.6995 27.1947 68.8862 26.8447 69.1288 26.546C69.3808 26.238 69.6888 26 70.0528 25.832C70.4262 25.664 70.8555 25.58 71.3408 25.58C71.8448 25.58 72.2695 25.6687 72.6148 25.846C72.9695 26.014 73.2635 26.2333 73.4968 26.504V23.396C73.4968 23.3027 73.5248 23.2233 73.5808 23.158C73.6462 23.0927 73.7302 23.06 73.8328 23.06H75.0228C75.1162 23.06 75.1955 23.0927 75.2608 23.158C75.3262 23.2233 75.3588 23.3027 75.3588 23.396V32.664C75.3588 32.7573 75.3262 32.8367 75.2608 32.902C75.1955 32.9673 75.1162 33 75.0228 33H73.9168C73.8142 33 73.7302 32.9673 73.6648 32.902C73.6088 32.8367 73.5808 32.7573 73.5808 32.664V32.146C73.3475 32.4353 73.0488 32.6733 72.6848 32.86C72.3302 33.0467 71.8822 33.14 71.3408 33.14ZM71.8588 31.642C72.2508 31.642 72.5635 31.5533 72.7968 31.376C73.0302 31.1987 73.2028 30.9747 73.3148 30.704C73.4268 30.424 73.4875 30.1393 73.4968 29.85C73.5062 29.682 73.5108 29.5047 73.5108 29.318C73.5108 29.122 73.5062 28.94 73.4968 28.772C73.4875 28.492 73.4222 28.226 73.3008 27.974C73.1795 27.7127 73.0022 27.498 72.7688 27.33C72.5355 27.162 72.2322 27.078 71.8588 27.078C71.4668 27.078 71.1542 27.1667 70.9208 27.344C70.6968 27.512 70.5335 27.736 70.4308 28.016C70.3282 28.296 70.2675 28.604 70.2488 28.94C70.2395 29.22 70.2395 29.5 70.2488 29.78C70.2675 30.116 70.3282 30.424 70.4308 30.704C70.5335 30.984 70.6968 31.2127 70.9208 31.39C71.1542 31.558 71.4668 31.642 71.8588 31.642ZM79.9268 33.14C79.4414 33.14 79.0121 33.0607 78.6388 32.902C78.2748 32.734 77.9714 32.5007 77.7288 32.202C77.4861 31.9033 77.2994 31.5533 77.1688 31.152C77.0381 30.7413 76.9634 30.2933 76.9448 29.808C76.9354 29.64 76.9308 29.4907 76.9308 29.36C76.9308 29.22 76.9354 29.066 76.9448 28.898C76.9634 28.4313 77.0334 27.9973 77.1548 27.596C77.2854 27.1947 77.4721 26.8447 77.7148 26.546C77.9668 26.238 78.2748 26 78.6388 25.832C79.0121 25.664 79.4414 25.58 79.9268 25.58C80.4308 25.58 80.8554 25.6687 81.2008 25.846C81.5554 26.014 81.8494 26.2333 82.0828 26.504V23.396C82.0828 23.3027 82.1108 23.2233 82.1668 23.158C82.2321 23.0927 82.3161 23.06 82.4188 23.06H83.6088C83.7021 23.06 83.7814 23.0927 83.8468 23.158C83.9121 23.2233 83.9448 23.3027 83.9448 23.396V32.664C83.9448 32.7573 83.9121 32.8367 83.8468 32.902C83.7814 32.9673 83.7021 33 83.6088 33H82.5028C82.4001 33 82.3161 32.9673 82.2508 32.902C82.1948 32.8367 82.1668 32.7573 82.1668 32.664V32.146C81.9334 32.4353 81.6348 32.6733 81.2708 32.86C80.9161 33.0467 80.4681 33.14 79.9268 33.14ZM80.4448 31.642C80.8368 31.642 81.1494 31.5533 81.3828 31.376C81.6161 31.1987 81.7888 30.9747 81.9008 30.704C82.0128 30.424 82.0734 30.1393 82.0828 29.85C82.0921 29.682 82.0968 29.5047 82.0968 29.318C82.0968 29.122 82.0921 28.94 82.0828 28.772C82.0734 28.492 82.0081 28.226 81.8868 27.974C81.7654 27.7127 81.5881 27.498 81.3548 27.33C81.1214 27.162 80.8181 27.078 80.4448 27.078C80.0528 27.078 79.7401 27.1667 79.5068 27.344C79.2828 27.512 79.1194 27.736 79.0168 28.016C78.9141 28.296 78.8534 28.604 78.8348 28.94C78.8254 29.22 78.8254 29.5 78.8348 29.78C78.8534 30.116 78.9141 30.424 79.0168 30.704C79.1194 30.984 79.2828 31.2127 79.5068 31.39C79.7401 31.558 80.0528 31.642 80.4448 31.642ZM88.9467 33.14C87.9107 33.14 87.0894 32.8413 86.4827 32.244C85.8761 31.6467 85.5494 30.7973 85.5027 29.696C85.4934 29.6027 85.4887 29.486 85.4887 29.346C85.4887 29.1967 85.4934 29.08 85.5027 28.996C85.5401 28.2867 85.6987 27.68 85.9787 27.176C86.2681 26.6627 86.6647 26.2707 87.1687 26C87.6727 25.72 88.2654 25.58 88.9467 25.58C89.7027 25.58 90.3374 25.7387 90.8507 26.056C91.3641 26.364 91.7514 26.798 92.0127 27.358C92.2741 27.9087 92.4047 28.548 92.4047 29.276V29.57C92.4047 29.6633 92.3721 29.7427 92.3067 29.808C92.2414 29.8733 92.1574 29.906 92.0547 29.906H87.4067C87.4067 29.906 87.4067 29.92 87.4067 29.948C87.4067 29.976 87.4067 29.9993 87.4067 30.018C87.4161 30.3447 87.4767 30.648 87.5887 30.928C87.7101 31.1987 87.8827 31.418 88.1067 31.586C88.3401 31.754 88.6154 31.838 88.9327 31.838C89.1941 31.838 89.4134 31.8007 89.5907 31.726C89.7681 31.642 89.9127 31.5487 90.0247 31.446C90.1367 31.3433 90.2161 31.2593 90.2627 31.194C90.3467 31.082 90.4121 31.0167 90.4587 30.998C90.5147 30.97 90.5941 30.956 90.6967 30.956H91.9007C91.9941 30.956 92.0687 30.984 92.1247 31.04C92.1901 31.096 92.2181 31.166 92.2087 31.25C92.1994 31.3993 92.1201 31.5813 91.9707 31.796C91.8307 32.0107 91.6254 32.2207 91.3547 32.426C91.0841 32.6313 90.7434 32.804 90.3327 32.944C89.9314 33.0747 89.4694 33.14 88.9467 33.14ZM87.4067 28.73H90.5007V28.688C90.5007 28.324 90.4401 28.0067 90.3187 27.736C90.1974 27.456 90.0201 27.2413 89.7867 27.092C89.5534 26.9333 89.2734 26.854 88.9467 26.854C88.6201 26.854 88.3401 26.9333 88.1067 27.092C87.8734 27.2413 87.6961 27.456 87.5747 27.736C87.4627 28.0067 87.4067 28.324 87.4067 28.688V28.73ZM96.5928 33.14C96.1075 33.14 95.6781 33.0607 95.3048 32.902C94.9408 32.734 94.6375 32.5007 94.3948 32.202C94.1521 31.9033 93.9655 31.5533 93.8348 31.152C93.7041 30.7413 93.6295 30.2933 93.6108 29.808C93.6015 29.64 93.5968 29.4907 93.5968 29.36C93.5968 29.22 93.6015 29.066 93.6108 28.898C93.6295 28.4313 93.6995 27.9973 93.8208 27.596C93.9515 27.1947 94.1381 26.8447 94.3808 26.546C94.6328 26.238 94.9408 26 95.3048 25.832C95.6781 25.664 96.1075 25.58 96.5928 25.58C97.0968 25.58 97.5215 25.6687 97.8668 25.846C98.2215 26.014 98.5155 26.2333 98.7488 26.504V23.396C98.7488 23.3027 98.7768 23.2233 98.8328 23.158C98.8981 23.0927 98.9821 23.06 99.0848 23.06H100.275C100.368 23.06 100.447 23.0927 100.513 23.158C100.578 23.2233 100.611 23.3027 100.611 23.396V32.664C100.611 32.7573 100.578 32.8367 100.513 32.902C100.447 32.9673 100.368 33 100.275 33H99.1688C99.0661 33 98.9821 32.9673 98.9168 32.902C98.8608 32.8367 98.8328 32.7573 98.8328 32.664V32.146C98.5995 32.4353 98.3008 32.6733 97.9368 32.86C97.5821 33.0467 97.1341 33.14 96.5928 33.14ZM97.1108 31.642C97.5028 31.642 97.8155 31.5533 98.0488 31.376C98.2821 31.1987 98.4548 30.9747 98.5668 30.704C98.6788 30.424 98.7395 30.1393 98.7488 29.85C98.7581 29.682 98.7628 29.5047 98.7628 29.318C98.7628 29.122 98.7581 28.94 98.7488 28.772C98.7395 28.492 98.6741 28.226 98.5528 27.974C98.4315 27.7127 98.2541 27.498 98.0208 27.33C97.7875 27.162 97.4841 27.078 97.1108 27.078C96.7188 27.078 96.4061 27.1667 96.1728 27.344C95.9488 27.512 95.7855 27.736 95.6828 28.016C95.5801 28.296 95.5195 28.604 95.5008 28.94C95.4915 29.22 95.4915 29.5 95.5008 29.78C95.5195 30.116 95.5801 30.424 95.6828 30.704C95.7855 30.984 95.9488 31.2127 96.1728 31.39C96.4061 31.558 96.7188 31.642 97.1108 31.642Z" fill="#00245B"/>
<path d="M25.364 91C25.1293 91 24.9373 90.9253 24.788 90.776C24.66 90.6267 24.596 90.4453 24.596 90.232V73.656L19.732 77.4C19.54 77.528 19.348 77.5813 19.156 77.56C18.964 77.5173 18.7933 77.4 18.644 77.208L17.3 75.48C17.172 75.288 17.1187 75.0853 17.14 74.872C17.1827 74.6587 17.3 74.488 17.492 74.36L24.66 68.824C24.788 68.7173 24.916 68.6533 25.044 68.632C25.172 68.6107 25.3107 68.6 25.46 68.6H28.276C28.4893 68.6 28.6707 68.6747 28.82 68.824C28.9693 68.9733 29.044 69.1547 29.044 69.368V90.232C29.044 90.4453 28.9693 90.6267 28.82 90.776C28.6707 90.9253 28.4893 91 28.276 91H25.364ZM33.5205 91C33.3072 91 33.1258 90.9253 32.9765 90.776C32.8272 90.6267 32.7525 90.4453 32.7525 90.232V88.6C32.7525 88.408 32.7952 88.184 32.8805 87.928C32.9872 87.6507 33.2112 87.3733 33.5525 87.096L38.6085 82.072C40.0165 80.9627 41.1472 80.024 42.0005 79.256C42.8752 78.4667 43.5045 77.752 43.8885 77.112C44.2938 76.4507 44.4965 75.8 44.4965 75.16C44.4965 74.2 44.2298 73.4213 43.6965 72.824C43.1845 72.2267 42.3632 71.928 41.2325 71.928C40.4858 71.928 39.8565 72.088 39.3445 72.408C38.8325 72.7067 38.4272 73.112 38.1285 73.624C37.8512 74.136 37.6592 74.7013 37.5525 75.32C37.5098 75.5973 37.3925 75.7893 37.2005 75.896C37.0085 76.0027 36.8165 76.056 36.6245 76.056H33.7765C33.5845 76.056 33.4245 75.992 33.2965 75.864C33.1685 75.736 33.1045 75.5867 33.1045 75.416C33.1258 74.4987 33.3178 73.6133 33.6805 72.76C34.0432 71.8853 34.5658 71.1173 35.2485 70.456C35.9525 69.7733 36.8058 69.2293 37.8085 68.824C38.8112 68.4187 39.9418 68.216 41.2005 68.216C42.9712 68.216 44.4325 68.5147 45.5845 69.112C46.7578 69.7093 47.6325 70.52 48.2085 71.544C48.8058 72.568 49.1045 73.72 49.1045 75C49.1045 76.0027 48.9125 76.9307 48.5285 77.784C48.1445 78.616 47.5898 79.4267 46.8645 80.216C46.1392 80.984 45.2645 81.7733 44.2405 82.584L39.6965 87.192H48.8165C49.0512 87.192 49.2325 87.2667 49.3605 87.416C49.5098 87.544 49.5845 87.7253 49.5845 87.96V90.232C49.5845 90.4453 49.5098 90.6267 49.3605 90.776C49.2325 90.9253 49.0512 91 48.8165 91H33.5205Z" fill="#212328"/>
<path d="M21.6411 120.472C21.5345 120.472 21.4438 120.44 21.3691 120.376C21.3051 120.301 21.2731 120.211 21.2731 120.104V116.776H17.9931C17.8865 116.776 17.7958 116.744 17.7211 116.68C17.6571 116.605 17.6251 116.515 17.6251 116.408V115.896C17.6251 115.789 17.6571 115.704 17.7211 115.64C17.7958 115.565 17.8865 115.528 17.9931 115.528H21.2731V112.296C21.2731 112.189 21.3051 112.104 21.3691 112.04C21.4438 111.965 21.5345 111.928 21.6411 111.928H22.2011C22.3078 111.928 22.3931 111.965 22.4571 112.04C22.5318 112.104 22.5691 112.189 22.5691 112.296V115.528H25.8651C25.9718 115.528 26.0571 115.565 26.1211 115.64C26.1958 115.704 26.2331 115.789 26.2331 115.896V116.408C26.2331 116.515 26.1958 116.605 26.1211 116.68C26.0571 116.744 25.9718 116.776 25.8651 116.776H22.5691V120.104C22.5691 120.211 22.5318 120.301 22.4571 120.376C22.3931 120.44 22.3078 120.472 22.2011 120.472H21.6411ZM31.4868 121.16C30.8148 121.16 30.2281 121.08 29.7268 120.92C29.2254 120.749 28.8041 120.525 28.4628 120.248C28.1214 119.971 27.8601 119.667 27.6788 119.336C27.5081 118.995 27.4174 118.653 27.4068 118.312C27.4068 118.216 27.4388 118.141 27.5028 118.088C27.5668 118.024 27.6468 117.992 27.7428 117.992H28.5268C28.6228 117.992 28.7081 118.019 28.7828 118.072C28.8681 118.115 28.9321 118.205 28.9748 118.344C29.0814 118.728 29.2628 119.027 29.5188 119.24C29.7854 119.453 30.0894 119.603 30.4308 119.688C30.7828 119.763 31.1348 119.8 31.4868 119.8C32.2228 119.8 32.8201 119.624 33.2788 119.272C33.7374 118.92 33.9668 118.403 33.9668 117.72C33.9668 117.027 33.7588 116.531 33.3428 116.232C32.9268 115.933 32.3508 115.784 31.6148 115.784H30.0948C29.9881 115.784 29.8974 115.752 29.8228 115.688C29.7588 115.624 29.7268 115.533 29.7268 115.416V114.984C29.7268 114.888 29.7428 114.808 29.7748 114.744C29.8174 114.669 29.8601 114.605 29.9028 114.552L33.0068 111.16H28.2868C28.1801 111.16 28.0894 111.128 28.0148 111.064C27.9508 111 27.9188 110.909 27.9188 110.792V110.184C27.9188 110.067 27.9508 109.976 28.0148 109.912C28.0894 109.837 28.1801 109.8 28.2868 109.8H34.6708C34.7881 109.8 34.8788 109.837 34.9427 109.912C35.0174 109.976 35.0548 110.067 35.0548 110.184V110.76C35.0548 110.835 35.0334 110.904 34.9908 110.968C34.9588 111.021 34.9214 111.075 34.8788 111.128L31.7908 114.568L32.0468 114.584C32.7508 114.605 33.3641 114.733 33.8868 114.968C34.4201 115.203 34.8308 115.555 35.1188 116.024C35.4174 116.483 35.5668 117.064 35.5668 117.768C35.5668 118.483 35.3908 119.091 35.0388 119.592C34.6868 120.093 34.2014 120.483 33.5828 120.76C32.9748 121.027 32.2761 121.16 31.4868 121.16ZM38.0721 121C37.8481 121 37.7361 120.893 37.7361 120.68C37.7361 120.616 37.7575 120.557 37.8001 120.504L45.7041 110.104C45.7788 110.008 45.8481 109.933 45.9121 109.88C45.9868 109.827 46.0935 109.8 46.2321 109.8H46.7601C46.9841 109.8 47.0961 109.907 47.0961 110.12C47.0961 110.184 47.0748 110.243 47.0321 110.296L39.1441 120.696C39.0695 120.792 38.9948 120.867 38.9201 120.92C38.8561 120.973 38.7495 121 38.6001 121H38.0721ZM45.4001 121.096C44.7068 121.096 44.1575 120.899 43.7521 120.504C43.3575 120.109 43.1388 119.592 43.0961 118.952C43.0855 118.675 43.0801 118.44 43.0801 118.248C43.0801 118.045 43.0855 117.795 43.0961 117.496C43.1388 116.856 43.3468 116.339 43.7201 115.944C44.1041 115.539 44.6641 115.336 45.4001 115.336C46.1468 115.336 46.7068 115.539 47.0801 115.944C47.4641 116.339 47.6775 116.856 47.7201 117.496C47.7415 117.795 47.7521 118.045 47.7521 118.248C47.7521 118.44 47.7415 118.675 47.7201 118.952C47.6775 119.592 47.4535 120.109 47.0481 120.504C46.6535 120.899 46.1041 121.096 45.4001 121.096ZM45.4001 120.04C45.6881 120.04 45.9121 119.981 46.0721 119.864C46.2321 119.747 46.3495 119.603 46.4241 119.432C46.4988 119.251 46.5415 119.069 46.5521 118.888C46.5735 118.6 46.5841 118.371 46.5841 118.2C46.5841 118.029 46.5735 117.816 46.5521 117.56C46.5415 117.272 46.4508 117.005 46.2801 116.76C46.1095 116.515 45.8161 116.392 45.4001 116.392C44.9948 116.392 44.7068 116.515 44.5361 116.76C44.3761 117.005 44.2855 117.272 44.2641 117.56C44.2535 117.816 44.2481 118.029 44.2481 118.2C44.2481 118.371 44.2535 118.6 44.2641 118.888C44.2855 119.069 44.3281 119.251 44.3921 119.432C44.4668 119.603 44.5841 119.747 44.7441 119.864C44.9148 119.981 45.1335 120.04 45.4001 120.04ZM39.4161 115.416C38.7121 115.416 38.1628 115.229 37.7681 114.856C37.3735 114.483 37.1548 113.976 37.1121 113.336C37.1015 113.059 37.0961 112.824 37.0961 112.632C37.0961 112.429 37.1015 112.179 37.1121 111.88C37.1441 111.24 37.3521 110.723 37.7361 110.328C38.1201 109.923 38.6801 109.72 39.4161 109.72C40.1628 109.72 40.7228 109.923 41.0961 110.328C41.4801 110.723 41.6881 111.24 41.7201 111.88C41.7415 112.179 41.7521 112.429 41.7521 112.632C41.7521 112.824 41.7415 113.059 41.7201 113.336C41.6881 113.976 41.4695 114.483 41.0641 114.856C40.6695 115.229 40.1201 115.416 39.4161 115.416ZM39.4161 114.424C39.6935 114.424 39.9121 114.365 40.0721 114.248C40.2428 114.131 40.3655 113.987 40.4401 113.816C40.5148 113.635 40.5575 113.453 40.5681 113.272C40.5895 112.984 40.6001 112.76 40.6001 112.6C40.6001 112.429 40.5895 112.211 40.5681 111.944C40.5575 111.656 40.4615 111.389 40.2801 111.144C40.1095 110.899 39.8215 110.776 39.4161 110.776C39.0108 110.776 38.7228 110.899 38.5521 111.144C38.3921 111.389 38.3015 111.656 38.2801 111.944C38.2695 112.211 38.2641 112.429 38.2641 112.6C38.2641 112.76 38.2695 112.984 38.2801 113.272C38.3015 113.453 38.3441 113.635 38.4081 113.816C38.4828 113.987 38.6001 114.131 38.7601 114.248C38.9201 114.365 39.1388 114.424 39.4161 114.424Z" fill="#A800E0"/>
<rect x="52.5" y="104" width="24" height="24" rx="12" fill="#F1CDFC"/>
<path d="M62.5878 110.333C62.5878 110.149 62.7371 110 62.9212 110H70.1664C70.2517 110 70.3372 110.033 70.4023 110.098C70.4701 110.165 70.5025 110.255 70.4998 110.344V117.579C70.4998 117.763 70.3505 117.912 70.1664 117.912C69.9823 117.912 69.8331 117.763 69.8331 117.579V111.138L62.7029 118.268C62.5728 118.399 62.3617 118.399 62.2315 118.268C62.1014 118.138 62.1014 117.927 62.2315 117.797L69.3619 110.667H62.9212C62.7371 110.667 62.5878 110.517 62.5878 110.333Z" fill="#A800E0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M60.1667 118.667C59.2462 118.667 58.5 119.413 58.5 120.333C58.5 121.254 59.2462 122 60.1667 122C61.0871 122 61.8333 121.254 61.8333 120.333C61.8333 119.413 61.0871 118.667 60.1667 118.667ZM59.1667 120.333C59.1667 119.781 59.6144 119.333 60.1667 119.333C60.719 119.333 61.1667 119.781 61.1667 120.333C61.1667 120.886 60.719 121.333 60.1667 121.333C59.6144 121.333 59.1667 120.886 59.1667 120.333Z" fill="#A800E0"/>
<path d="M20.868 147.14C20.056 147.14 19.3747 147.014 18.824 146.762C18.2733 146.51 17.8487 146.188 17.55 145.796C17.2607 145.395 17.1067 144.975 17.088 144.536C17.088 144.461 17.116 144.396 17.172 144.34C17.2373 144.275 17.312 144.242 17.396 144.242H18.11C18.222 144.242 18.306 144.27 18.362 144.326C18.418 144.382 18.4553 144.447 18.474 144.522C18.53 144.746 18.6467 144.97 18.824 145.194C19.0013 145.409 19.2533 145.591 19.58 145.74C19.916 145.88 20.3453 145.95 20.868 145.95C21.6707 145.95 22.2587 145.81 22.632 145.53C23.0147 145.241 23.206 144.858 23.206 144.382C23.206 144.055 23.1033 143.794 22.898 143.598C22.702 143.393 22.3987 143.211 21.988 143.052C21.5773 142.893 21.0453 142.721 20.392 142.534C19.7107 142.338 19.146 142.123 18.698 141.89C18.25 141.657 17.914 141.367 17.69 141.022C17.4753 140.677 17.368 140.238 17.368 139.706C17.368 139.202 17.5033 138.754 17.774 138.362C18.0447 137.961 18.4367 137.643 18.95 137.41C19.4633 137.177 20.0793 137.06 20.798 137.06C21.3767 137.06 21.8807 137.139 22.31 137.298C22.7487 137.447 23.1127 137.653 23.402 137.914C23.6913 138.166 23.9107 138.441 24.06 138.74C24.2093 139.029 24.2887 139.314 24.298 139.594C24.298 139.659 24.2747 139.725 24.228 139.79C24.1813 139.846 24.1067 139.874 24.004 139.874H23.262C23.1967 139.874 23.1267 139.855 23.052 139.818C22.9867 139.781 22.9353 139.711 22.898 139.608C22.842 139.225 22.6273 138.903 22.254 138.642C21.8807 138.381 21.3953 138.25 20.798 138.25C20.1913 138.25 19.6967 138.367 19.314 138.6C18.9407 138.833 18.754 139.197 18.754 139.692C18.754 140.009 18.8427 140.275 19.02 140.49C19.1973 140.695 19.4773 140.877 19.86 141.036C20.2427 141.195 20.742 141.363 21.358 141.54C22.1047 141.745 22.716 141.965 23.192 142.198C23.668 142.422 24.018 142.707 24.242 143.052C24.4753 143.388 24.592 143.822 24.592 144.354C24.592 144.942 24.438 145.446 24.13 145.866C23.822 146.277 23.388 146.594 22.828 146.818C22.2773 147.033 21.624 147.14 20.868 147.14ZM26.567 147C26.4737 147 26.3943 146.972 26.329 146.916C26.273 146.851 26.245 146.771 26.245 146.678V140.042C26.245 139.949 26.273 139.874 26.329 139.818C26.3943 139.753 26.4737 139.72 26.567 139.72H27.239C27.3323 139.72 27.407 139.753 27.463 139.818C27.5283 139.874 27.561 139.949 27.561 140.042V146.678C27.561 146.771 27.5283 146.851 27.463 146.916C27.407 146.972 27.3323 147 27.239 147H26.567ZM26.455 138.362C26.3617 138.362 26.2823 138.334 26.217 138.278C26.161 138.213 26.133 138.133 26.133 138.04V137.284C26.133 137.191 26.161 137.111 26.217 137.046C26.2823 136.981 26.3617 136.948 26.455 136.948H27.337C27.4303 136.948 27.5097 136.981 27.575 137.046C27.6403 137.111 27.673 137.191 27.673 137.284V138.04C27.673 138.133 27.6403 138.213 27.575 138.278C27.5097 138.334 27.4303 138.362 27.337 138.362H26.455ZM29.9576 147C29.8643 147 29.7849 146.972 29.7196 146.916C29.6636 146.851 29.6356 146.771 29.6356 146.678V140.042C29.6356 139.949 29.6636 139.874 29.7196 139.818C29.7849 139.753 29.8643 139.72 29.9576 139.72H30.6156C30.7089 139.72 30.7836 139.753 30.8396 139.818C30.9049 139.874 30.9376 139.949 30.9376 140.042V140.658C31.1803 140.341 31.4836 140.084 31.8476 139.888C32.2209 139.683 32.6969 139.58 33.2756 139.58C33.8823 139.58 34.3956 139.715 34.8156 139.986C35.2449 140.247 35.5669 140.616 35.7816 141.092C36.0056 141.559 36.1176 142.105 36.1176 142.73V146.678C36.1176 146.771 36.0849 146.851 36.0196 146.916C35.9636 146.972 35.8889 147 35.7956 147H35.0956C35.0023 147 34.9229 146.972 34.8576 146.916C34.8016 146.851 34.7736 146.771 34.7736 146.678V142.8C34.7736 142.147 34.6149 141.638 34.2976 141.274C33.9803 140.901 33.5136 140.714 32.8976 140.714C32.3189 140.714 31.8523 140.901 31.4976 141.274C31.1523 141.638 30.9796 142.147 30.9796 142.8V146.678C30.9796 146.771 30.9469 146.851 30.8816 146.916C30.8256 146.972 30.7509 147 30.6576 147H29.9576ZM41.0658 147.14C40.4032 147.14 39.8292 147.014 39.3438 146.762C38.8678 146.501 38.4992 146.132 38.2378 145.656C37.9765 145.171 37.8365 144.592 37.8178 143.92C37.8085 143.78 37.8038 143.593 37.8038 143.36C37.8038 143.127 37.8085 142.94 37.8178 142.8C37.8365 142.128 37.9765 141.554 38.2378 141.078C38.4992 140.593 38.8678 140.224 39.3438 139.972C39.8292 139.711 40.4032 139.58 41.0658 139.58C41.6072 139.58 42.0692 139.655 42.4518 139.804C42.8438 139.953 43.1658 140.145 43.4178 140.378C43.6698 140.611 43.8565 140.863 43.9778 141.134C44.1085 141.405 44.1785 141.661 44.1878 141.904C44.1972 141.997 44.1692 142.072 44.1038 142.128C44.0385 142.184 43.9592 142.212 43.8658 142.212H43.1938C43.1005 142.212 43.0305 142.193 42.9838 142.156C42.9372 142.109 42.8905 142.035 42.8438 141.932C42.6758 141.475 42.4472 141.153 42.1578 140.966C41.8685 140.779 41.5092 140.686 41.0798 140.686C40.5198 140.686 40.0625 140.859 39.7078 141.204C39.3625 141.549 39.1758 142.105 39.1478 142.87C39.1385 143.206 39.1385 143.533 39.1478 143.85C39.1758 144.625 39.3625 145.185 39.7078 145.53C40.0625 145.866 40.5198 146.034 41.0798 146.034C41.5092 146.034 41.8685 145.941 42.1578 145.754C42.4472 145.567 42.6758 145.245 42.8438 144.788C42.8905 144.685 42.9372 144.611 42.9838 144.564C43.0305 144.517 43.1005 144.494 43.1938 144.494H43.8658C43.9592 144.494 44.0385 144.527 44.1038 144.592C44.1692 144.648 44.1972 144.723 44.1878 144.816C44.1785 145.012 44.1365 145.213 44.0618 145.418C43.9872 145.623 43.8658 145.833 43.6978 146.048C43.5392 146.253 43.3385 146.44 43.0958 146.608C42.8532 146.767 42.5638 146.897 42.2278 147C41.8918 147.093 41.5045 147.14 41.0658 147.14ZM48.7625 147.14C47.7918 147.14 47.0218 146.846 46.4525 146.258C45.8831 145.661 45.5705 144.849 45.5145 143.822C45.5051 143.701 45.5005 143.547 45.5005 143.36C45.5005 143.164 45.5051 143.005 45.5145 142.884C45.5518 142.221 45.7058 141.643 45.9765 141.148C46.2471 140.644 46.6158 140.257 47.0825 139.986C47.5585 139.715 48.1138 139.58 48.7485 139.58C49.4578 139.58 50.0505 139.729 50.5265 140.028C51.0118 140.327 51.3805 140.751 51.6325 141.302C51.8845 141.853 52.0105 142.497 52.0105 143.234V143.472C52.0105 143.575 51.9778 143.654 51.9125 143.71C51.8565 143.766 51.7818 143.794 51.6885 143.794H46.8445C46.8445 143.803 46.8445 143.822 46.8445 143.85C46.8445 143.878 46.8445 143.901 46.8445 143.92C46.8631 144.303 46.9471 144.662 47.0965 144.998C47.2458 145.325 47.4605 145.591 47.7405 145.796C48.0298 146.001 48.3658 146.104 48.7485 146.104C49.0845 146.104 49.3645 146.053 49.5885 145.95C49.8125 145.847 49.9945 145.735 50.1345 145.614C50.2745 145.483 50.3678 145.381 50.4145 145.306C50.4985 145.194 50.5638 145.129 50.6105 145.11C50.6571 145.082 50.7318 145.068 50.8345 145.068H51.5205C51.6045 145.068 51.6745 145.096 51.7305 145.152C51.7958 145.199 51.8238 145.269 51.8145 145.362C51.8051 145.502 51.7305 145.675 51.5905 145.88C51.4505 146.076 51.2498 146.272 50.9885 146.468C50.7365 146.664 50.4191 146.827 50.0365 146.958C49.6631 147.079 49.2385 147.14 48.7625 147.14ZM46.8445 142.828H50.6805V142.786C50.6805 142.366 50.6011 141.993 50.4425 141.666C50.2931 141.339 50.0738 141.083 49.7845 140.896C49.4951 140.7 49.1498 140.602 48.7485 140.602C48.3471 140.602 48.0018 140.7 47.7125 140.896C47.4325 141.083 47.2178 141.339 47.0685 141.666C46.9191 141.993 46.8445 142.366 46.8445 142.786V142.828ZM57.4521 147C57.3587 147 57.2794 146.972 57.2141 146.916C57.1581 146.851 57.1301 146.771 57.1301 146.678V137.382C57.1301 137.289 57.1581 137.214 57.2141 137.158C57.2794 137.093 57.3587 137.06 57.4521 137.06H58.1101C58.2127 137.06 58.2921 137.093 58.3481 137.158C58.4041 137.214 58.4321 137.289 58.4321 137.382V146.678C58.4321 146.771 58.4041 146.851 58.3481 146.916C58.2921 146.972 58.2127 147 58.1101 147H57.4521ZM62.5504 147.14C62.0837 147.14 61.659 147.047 61.2764 146.86C60.8937 146.673 60.5857 146.421 60.3524 146.104C60.119 145.787 60.0024 145.427 60.0024 145.026C60.0024 144.382 60.2637 143.869 60.7864 143.486C61.309 143.103 61.9904 142.851 62.8304 142.73L64.9164 142.436V142.03C64.9164 141.582 64.7857 141.232 64.5244 140.98C64.2724 140.728 63.857 140.602 63.2784 140.602C62.8677 140.602 62.5317 140.686 62.2704 140.854C62.009 141.022 61.827 141.237 61.7244 141.498C61.6684 141.638 61.5704 141.708 61.4304 141.708H60.8004C60.6977 141.708 60.6184 141.68 60.5624 141.624C60.5157 141.559 60.4924 141.484 60.4924 141.4C60.4924 141.26 60.5437 141.087 60.6464 140.882C60.7584 140.677 60.9264 140.476 61.1504 140.28C61.3744 140.084 61.659 139.921 62.0044 139.79C62.359 139.65 62.7884 139.58 63.2924 139.58C63.8524 139.58 64.3237 139.655 64.7064 139.804C65.089 139.944 65.3877 140.135 65.6024 140.378C65.8264 140.621 65.985 140.896 66.0784 141.204C66.181 141.512 66.2324 141.825 66.2324 142.142V146.678C66.2324 146.771 66.1997 146.851 66.1344 146.916C66.0784 146.972 66.0037 147 65.9104 147H65.2664C65.1637 147 65.0844 146.972 65.0284 146.916C64.9724 146.851 64.9444 146.771 64.9444 146.678V146.076C64.823 146.244 64.6597 146.412 64.4544 146.58C64.249 146.739 63.9924 146.874 63.6844 146.986C63.3764 147.089 62.9984 147.14 62.5504 147.14ZM62.8444 146.09C63.227 146.09 63.577 146.011 63.8944 145.852C64.2117 145.684 64.459 145.427 64.6364 145.082C64.823 144.737 64.9164 144.303 64.9164 143.78V143.388L63.2924 143.626C62.6297 143.719 62.1304 143.878 61.7944 144.102C61.4584 144.317 61.2904 144.592 61.2904 144.928C61.2904 145.189 61.365 145.409 61.5144 145.586C61.673 145.754 61.869 145.88 62.1024 145.964C62.345 146.048 62.5924 146.09 62.8444 146.09ZM70.765 147.14C70.2423 147.14 69.7943 147.075 69.421 146.944C69.0477 146.813 68.7443 146.655 68.511 146.468C68.2777 146.281 68.1003 146.095 67.979 145.908C67.867 145.721 67.8063 145.572 67.797 145.46C67.7877 145.357 67.8203 145.278 67.895 145.222C67.9697 145.166 68.0443 145.138 68.119 145.138H68.749C68.7957 145.138 68.833 145.147 68.861 145.166C68.8983 145.175 68.945 145.213 69.001 145.278C69.1223 145.409 69.2577 145.539 69.407 145.67C69.5563 145.801 69.7383 145.908 69.953 145.992C70.177 146.076 70.4523 146.118 70.779 146.118C71.255 146.118 71.647 146.029 71.955 145.852C72.263 145.665 72.417 145.395 72.417 145.04C72.417 144.807 72.3517 144.62 72.221 144.48C72.0997 144.34 71.8757 144.214 71.549 144.102C71.2317 143.99 70.793 143.873 70.233 143.752C69.673 143.621 69.2297 143.463 68.903 143.276C68.5763 143.08 68.343 142.851 68.203 142.59C68.063 142.319 67.993 142.016 67.993 141.68C67.993 141.335 68.0957 141.003 68.301 140.686C68.5063 140.359 68.805 140.093 69.197 139.888C69.5983 139.683 70.0977 139.58 70.695 139.58C71.1803 139.58 71.5957 139.641 71.941 139.762C72.2863 139.883 72.571 140.037 72.795 140.224C73.019 140.401 73.187 140.579 73.299 140.756C73.411 140.933 73.4717 141.083 73.481 141.204C73.4903 141.297 73.4623 141.377 73.397 141.442C73.3317 141.498 73.257 141.526 73.173 141.526H72.585C72.5197 141.526 72.4637 141.512 72.417 141.484C72.3797 141.456 72.3423 141.423 72.305 141.386C72.2117 141.265 72.0997 141.143 71.969 141.022C71.8477 140.901 71.6843 140.803 71.479 140.728C71.283 140.644 71.0217 140.602 70.695 140.602C70.2283 140.602 69.8783 140.7 69.645 140.896C69.4117 141.092 69.295 141.339 69.295 141.638C69.295 141.815 69.3463 141.974 69.449 142.114C69.5517 142.254 69.7477 142.38 70.037 142.492C70.3263 142.604 70.7557 142.725 71.325 142.856C71.941 142.977 72.4263 143.141 72.781 143.346C73.1357 143.551 73.3877 143.789 73.537 144.06C73.6863 144.331 73.761 144.643 73.761 144.998C73.761 145.39 73.649 145.749 73.425 146.076C73.201 146.403 72.865 146.664 72.417 146.86C71.969 147.047 71.4183 147.14 70.765 147.14ZM78.21 147C77.6874 147 77.2627 146.902 76.936 146.706C76.6094 146.501 76.3714 146.216 76.222 145.852C76.0727 145.479 75.998 145.04 75.998 144.536V140.84H74.906C74.8127 140.84 74.7334 140.812 74.668 140.756C74.612 140.691 74.584 140.611 74.584 140.518V140.042C74.584 139.949 74.612 139.874 74.668 139.818C74.7334 139.753 74.8127 139.72 74.906 139.72H75.998V137.382C75.998 137.289 76.026 137.214 76.082 137.158C76.1474 137.093 76.2267 137.06 76.32 137.06H76.978C77.0714 137.06 77.146 137.093 77.202 137.158C77.2674 137.214 77.3 137.289 77.3 137.382V139.72H79.036C79.1387 139.72 79.218 139.753 79.274 139.818C79.33 139.874 79.358 139.949 79.358 140.042V140.518C79.358 140.611 79.33 140.691 79.274 140.756C79.218 140.812 79.1387 140.84 79.036 140.84H77.3V144.438C77.3 144.877 77.3747 145.222 77.524 145.474C77.6734 145.726 77.9394 145.852 78.322 145.852H79.176C79.2694 145.852 79.344 145.885 79.4 145.95C79.4654 146.006 79.498 146.081 79.498 146.174V146.678C79.498 146.771 79.4654 146.851 79.4 146.916C79.344 146.972 79.2694 147 79.176 147H78.21ZM84.5904 147C84.4971 147 84.4178 146.972 84.3524 146.916C84.2964 146.851 84.2684 146.771 84.2684 146.678V140.042C84.2684 139.949 84.2964 139.874 84.3524 139.818C84.4178 139.753 84.4971 139.72 84.5904 139.72H85.2204C85.3138 139.72 85.3884 139.753 85.4444 139.818C85.5098 139.874 85.5424 139.949 85.5424 140.042V140.532C85.7571 140.243 86.0278 140.014 86.3544 139.846C86.6811 139.669 87.0731 139.58 87.5304 139.58C88.5851 139.571 89.3318 140 89.7704 140.868C89.9851 140.476 90.2978 140.163 90.7084 139.93C91.1191 139.697 91.5858 139.58 92.1084 139.58C92.5938 139.58 93.0324 139.692 93.4244 139.916C93.8258 140.14 94.1384 140.481 94.3624 140.938C94.5958 141.386 94.7124 141.951 94.7124 142.632V146.678C94.7124 146.771 94.6798 146.851 94.6144 146.916C94.5584 146.972 94.4838 147 94.3904 147H93.7324C93.6391 147 93.5598 146.972 93.4944 146.916C93.4384 146.851 93.4104 146.771 93.4104 146.678V142.758C93.4104 142.235 93.3358 141.825 93.1864 141.526C93.0371 141.227 92.8364 141.017 92.5844 140.896C92.3324 140.775 92.0571 140.714 91.7584 140.714C91.5158 140.714 91.2684 140.775 91.0164 140.896C90.7644 141.017 90.5544 141.227 90.3864 141.526C90.2278 141.825 90.1484 142.235 90.1484 142.758V146.678C90.1484 146.771 90.1158 146.851 90.0504 146.916C89.9944 146.972 89.9198 147 89.8264 147H89.1684C89.0751 147 88.9958 146.972 88.9304 146.916C88.8744 146.851 88.8464 146.771 88.8464 146.678V142.758C88.8464 142.235 88.7671 141.825 88.6084 141.526C88.4498 141.227 88.2444 141.017 87.9924 140.896C87.7404 140.775 87.4744 140.714 87.1944 140.714C86.9518 140.714 86.7044 140.775 86.4524 140.896C86.2004 141.017 85.9904 141.227 85.8224 141.526C85.6638 141.825 85.5844 142.231 85.5844 142.744V146.678C85.5844 146.771 85.5518 146.851 85.4864 146.916C85.4304 146.972 85.3558 147 85.2624 147H84.5904ZM99.6918 147.14C98.9825 147.14 98.3898 147.005 97.9138 146.734C97.4378 146.463 97.0738 146.09 96.8218 145.614C96.5698 145.129 96.4298 144.578 96.4018 143.962C96.3925 143.803 96.3878 143.603 96.3878 143.36C96.3878 143.108 96.3925 142.907 96.4018 142.758C96.4298 142.133 96.5698 141.582 96.8218 141.106C97.0832 140.63 97.4518 140.257 97.9278 139.986C98.4038 139.715 98.9918 139.58 99.6918 139.58C100.392 139.58 100.98 139.715 101.456 139.986C101.932 140.257 102.296 140.63 102.548 141.106C102.809 141.582 102.954 142.133 102.982 142.758C102.991 142.907 102.996 143.108 102.996 143.36C102.996 143.603 102.991 143.803 102.982 143.962C102.954 144.578 102.814 145.129 102.562 145.614C102.31 146.09 101.946 146.463 101.47 146.734C100.994 147.005 100.401 147.14 99.6918 147.14ZM99.6918 146.062C100.27 146.062 100.732 145.88 101.078 145.516C101.423 145.143 101.61 144.601 101.638 143.892C101.647 143.752 101.652 143.575 101.652 143.36C101.652 143.145 101.647 142.968 101.638 142.828C101.61 142.119 101.423 141.582 101.078 141.218C100.732 140.845 100.27 140.658 99.6918 140.658C99.1132 140.658 98.6465 140.845 98.2918 141.218C97.9465 141.582 97.7645 142.119 97.7458 142.828C97.7365 142.968 97.7318 143.145 97.7318 143.36C97.7318 143.575 97.7365 143.752 97.7458 143.892C97.7645 144.601 97.9465 145.143 98.2918 145.516C98.6465 145.88 99.1132 146.062 99.6918 146.062ZM105.071 147C104.978 147 104.898 146.972 104.833 146.916C104.777 146.851 104.749 146.771 104.749 146.678V140.042C104.749 139.949 104.777 139.874 104.833 139.818C104.898 139.753 104.978 139.72 105.071 139.72H105.729C105.822 139.72 105.897 139.753 105.953 139.818C106.018 139.874 106.051 139.949 106.051 140.042V140.658C106.294 140.341 106.597 140.084 106.961 139.888C107.334 139.683 107.81 139.58 108.389 139.58C108.996 139.58 109.509 139.715 109.929 139.986C110.358 140.247 110.68 140.616 110.895 141.092C111.119 141.559 111.231 142.105 111.231 142.73V146.678C111.231 146.771 111.198 146.851 111.133 146.916C111.077 146.972 111.002 147 110.909 147H110.209C110.116 147 110.036 146.972 109.971 146.916C109.915 146.851 109.887 146.771 109.887 146.678V142.8C109.887 142.147 109.728 141.638 109.411 141.274C109.094 140.901 108.627 140.714 108.011 140.714C107.432 140.714 106.966 140.901 106.611 141.274C106.266 141.638 106.093 142.147 106.093 142.8V146.678C106.093 146.771 106.06 146.851 105.995 146.916C105.939 146.972 105.864 147 105.771 147H105.071ZM115.985 147C115.463 147 115.038 146.902 114.711 146.706C114.385 146.501 114.147 146.216 113.997 145.852C113.848 145.479 113.773 145.04 113.773 144.536V140.84H112.681C112.588 140.84 112.509 140.812 112.443 140.756C112.387 140.691 112.359 140.611 112.359 140.518V140.042C112.359 139.949 112.387 139.874 112.443 139.818C112.509 139.753 112.588 139.72 112.681 139.72H113.773V137.382C113.773 137.289 113.801 137.214 113.857 137.158C113.923 137.093 114.002 137.06 114.095 137.06H114.753C114.847 137.06 114.921 137.093 114.977 137.158C115.043 137.214 115.075 137.289 115.075 137.382V139.72H116.811C116.914 139.72 116.993 139.753 117.049 139.818C117.105 139.874 117.133 139.949 117.133 140.042V140.518C117.133 140.611 117.105 140.691 117.049 140.756C116.993 140.812 116.914 140.84 116.811 140.84H115.075V144.438C115.075 144.877 115.15 145.222 115.299 145.474C115.449 145.726 115.715 145.852 116.097 145.852H116.951C117.045 145.852 117.119 145.885 117.175 145.95C117.241 146.006 117.273 146.081 117.273 146.174V146.678C117.273 146.771 117.241 146.851 117.175 146.916C117.119 146.972 117.045 147 116.951 147H115.985ZM118.948 147C118.855 147 118.776 146.972 118.71 146.916C118.654 146.851 118.626 146.771 118.626 146.678V137.382C118.626 137.289 118.654 137.214 118.71 137.158C118.776 137.093 118.855 137.06 118.948 137.06H119.648C119.751 137.06 119.83 137.093 119.886 137.158C119.942 137.214 119.97 137.289 119.97 137.382V140.644C120.222 140.327 120.53 140.07 120.894 139.874C121.258 139.678 121.72 139.58 122.28 139.58C122.887 139.58 123.4 139.715 123.82 139.986C124.25 140.247 124.572 140.616 124.786 141.092C125.01 141.559 125.122 142.105 125.122 142.73V146.678C125.122 146.771 125.094 146.851 125.038 146.916C124.982 146.972 124.903 147 124.8 147H124.1C124.007 147 123.928 146.972 123.862 146.916C123.806 146.851 123.778 146.771 123.778 146.678V142.8C123.778 142.147 123.62 141.638 123.302 141.274C122.985 140.901 122.518 140.714 121.902 140.714C121.324 140.714 120.857 140.901 120.502 141.274C120.148 141.638 119.97 142.147 119.97 142.8V146.678C119.97 146.771 119.942 146.851 119.886 146.916C119.83 146.972 119.751 147 119.648 147H118.948Z" fill="#717385"/>
<rect x="153.75" y="49" width="25.3125" height="111" rx="4" fill="url(#paint0_linear_2438_30650)"/>
<rect x="187.062" y="56" width="25.3125" height="104" rx="4" fill="url(#paint1_linear_2438_30650)"/>
<rect x="220.375" y="101" width="25.3125" height="59" rx="4" fill="url(#paint2_linear_2438_30650)"/>
<rect x="253.688" y="86" width="25.3125" height="74" rx="4" fill="url(#paint3_linear_2438_30650)"/>
<defs>
<linearGradient id="paint0_linear_2438_30650" x1="166.406" y1="160" x2="166.406" y2="49" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint1_linear_2438_30650" x1="199.719" y1="160" x2="199.719" y2="50.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint2_linear_2438_30650" x1="233.031" y1="160" x2="233.031" y2="50.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint3_linear_2438_30650" x1="266.344" y1="160" x2="266.344" y2="55.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
</defs>
</svg>
`;
const $c49aa0f374b6c6e6$export$c526750474512544 = `<svg width="295" height="176" viewBox="0 0 295 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="0.5" width="293.5" height="175" rx="7.5" fill="#131D2D"/>
<rect x="1" y="0.5" width="293.5" height="175" rx="7.5" stroke="#576883"/>
<path d="M21.498 33.14C20.686 33.14 19.9813 33.0047 19.384 32.734C18.7867 32.454 18.3247 32.0293 17.998 31.46C17.6713 30.8813 17.508 30.144 17.508 29.248V23.55C17.508 23.4473 17.5407 23.3633 17.606 23.298C17.6713 23.2327 17.7507 23.2 17.844 23.2H19.118C19.2207 23.2 19.3 23.2327 19.356 23.298C19.4213 23.3633 19.454 23.4473 19.454 23.55V29.248C19.454 30.0133 19.636 30.5827 20 30.956C20.364 31.32 20.8633 31.502 21.498 31.502C22.1327 31.502 22.6273 31.32 22.982 30.956C23.346 30.5827 23.528 30.0133 23.528 29.248V23.55C23.528 23.4473 23.5607 23.3633 23.626 23.298C23.6913 23.2327 23.7753 23.2 23.878 23.2H25.138C25.2407 23.2 25.32 23.2327 25.376 23.298C25.4413 23.3633 25.474 23.4473 25.474 23.55V29.248C25.474 30.144 25.3107 30.8813 24.984 31.46C24.6667 32.0293 24.2093 32.454 23.612 32.734C23.024 33.0047 22.3193 33.14 21.498 33.14ZM30.1215 33.14C29.5615 33.14 29.0808 33.0747 28.6795 32.944C28.2875 32.8133 27.9655 32.65 27.7135 32.454C27.4615 32.258 27.2748 32.062 27.1535 31.866C27.0321 31.67 26.9668 31.5067 26.9575 31.376C26.9481 31.2733 26.9761 31.194 27.0415 31.138C27.1161 31.0727 27.1955 31.04 27.2795 31.04H28.3855C28.4228 31.04 28.4555 31.0447 28.4835 31.054C28.5115 31.0633 28.5488 31.0913 28.5955 31.138C28.7168 31.2407 28.8428 31.348 28.9735 31.46C29.1135 31.572 29.2768 31.67 29.4635 31.754C29.6501 31.8287 29.8835 31.866 30.1635 31.866C30.5275 31.866 30.8308 31.796 31.0735 31.656C31.3255 31.5067 31.4515 31.2967 31.4515 31.026C31.4515 30.83 31.3955 30.6713 31.2835 30.55C31.1808 30.4287 30.9848 30.3213 30.6955 30.228C30.4061 30.1253 29.9955 30.018 29.4635 29.906C28.9408 29.7847 28.5068 29.6307 28.1615 29.444C27.8161 29.2573 27.5595 29.024 27.3915 28.744C27.2235 28.464 27.1395 28.1373 27.1395 27.764C27.1395 27.4 27.2468 27.0547 27.4615 26.728C27.6855 26.392 28.0121 26.1167 28.4415 25.902C28.8801 25.6873 29.4215 25.58 30.0655 25.58C30.5695 25.58 31.0081 25.6453 31.3815 25.776C31.7548 25.8973 32.0628 26.0513 32.3055 26.238C32.5575 26.4247 32.7488 26.616 32.8795 26.812C33.0101 26.9987 33.0801 27.162 33.0895 27.302C33.0988 27.4047 33.0708 27.4887 33.0055 27.554C32.9401 27.61 32.8655 27.638 32.7815 27.638H31.7455C31.6988 27.638 31.6568 27.6287 31.6195 27.61C31.5821 27.5913 31.5448 27.568 31.5075 27.54C31.4048 27.4467 31.2928 27.3487 31.1715 27.246C31.0501 27.134 30.9008 27.0407 30.7235 26.966C30.5555 26.8913 30.3315 26.854 30.0515 26.854C29.6968 26.854 29.4261 26.9333 29.2395 27.092C29.0528 27.2413 28.9595 27.4327 28.9595 27.666C28.9595 27.8247 29.0015 27.9647 29.0855 28.086C29.1788 28.198 29.3608 28.3053 29.6315 28.408C29.9021 28.5107 30.3128 28.618 30.8635 28.73C31.4888 28.842 31.9835 29.01 32.3475 29.234C32.7208 29.4487 32.9821 29.7007 33.1315 29.99C33.2901 30.27 33.3695 30.5827 33.3695 30.928C33.3695 31.348 33.2435 31.726 32.9915 32.062C32.7488 32.398 32.3848 32.664 31.8995 32.86C31.4235 33.0467 30.8308 33.14 30.1215 33.14ZM37.9506 33.14C36.9146 33.14 36.0933 32.8413 35.4866 32.244C34.88 31.6467 34.5533 30.7973 34.5066 29.696C34.4973 29.6027 34.4926 29.486 34.4926 29.346C34.4926 29.1967 34.4973 29.08 34.5066 28.996C34.544 28.2867 34.7026 27.68 34.9826 27.176C35.272 26.6627 35.6686 26.2707 36.1726 26C36.6766 25.72 37.2693 25.58 37.9506 25.58C38.7066 25.58 39.3413 25.7387 39.8546 26.056C40.368 26.364 40.7553 26.798 41.0166 27.358C41.278 27.9087 41.4086 28.548 41.4086 29.276V29.57C41.4086 29.6633 41.376 29.7427 41.3106 29.808C41.2453 29.8733 41.1613 29.906 41.0586 29.906H36.4106C36.4106 29.906 36.4106 29.92 36.4106 29.948C36.4106 29.976 36.4106 29.9993 36.4106 30.018C36.42 30.3447 36.4806 30.648 36.5926 30.928C36.714 31.1987 36.8866 31.418 37.1106 31.586C37.344 31.754 37.6193 31.838 37.9366 31.838C38.198 31.838 38.4173 31.8007 38.5946 31.726C38.772 31.642 38.9166 31.5487 39.0286 31.446C39.1406 31.3433 39.22 31.2593 39.2666 31.194C39.3506 31.082 39.416 31.0167 39.4626 30.998C39.5186 30.97 39.598 30.956 39.7006 30.956H40.9046C40.998 30.956 41.0726 30.984 41.1286 31.04C41.194 31.096 41.222 31.166 41.2126 31.25C41.2033 31.3993 41.124 31.5813 40.9746 31.796C40.8346 32.0107 40.6293 32.2207 40.3586 32.426C40.088 32.6313 39.7473 32.804 39.3366 32.944C38.9353 33.0747 38.4733 33.14 37.9506 33.14ZM36.4106 28.73H39.5046V28.688C39.5046 28.324 39.444 28.0067 39.3226 27.736C39.2013 27.456 39.024 27.2413 38.7906 27.092C38.5573 26.9333 38.2773 26.854 37.9506 26.854C37.624 26.854 37.344 26.9333 37.1106 27.092C36.8773 27.2413 36.7 27.456 36.5786 27.736C36.4666 28.0067 36.4106 28.324 36.4106 28.688V28.73ZM43.2307 33C43.1374 33 43.058 32.9673 42.9927 32.902C42.9274 32.8367 42.8947 32.7573 42.8947 32.664V26.07C42.8947 25.9673 42.9274 25.8833 42.9927 25.818C43.058 25.7527 43.1374 25.72 43.2307 25.72H44.3647C44.458 25.72 44.5374 25.7527 44.6027 25.818C44.6774 25.8833 44.7147 25.9673 44.7147 26.07V26.644C44.9294 26.3453 45.2047 26.1167 45.5407 25.958C45.886 25.7993 46.2827 25.72 46.7307 25.72H47.3047C47.4074 25.72 47.4867 25.7527 47.5427 25.818C47.608 25.8833 47.6407 25.9627 47.6407 26.056V27.064C47.6407 27.1573 47.608 27.2367 47.5427 27.302C47.4867 27.3673 47.4074 27.4 47.3047 27.4H46.2127C45.7647 27.4 45.4147 27.526 45.1627 27.778C44.92 28.0207 44.7987 28.366 44.7987 28.814V32.664C44.7987 32.7573 44.766 32.8367 44.7007 32.902C44.6354 32.9673 44.5514 33 44.4487 33H43.2307ZM51.4906 33.14C50.9306 33.14 50.4499 33.0747 50.0486 32.944C49.6566 32.8133 49.3346 32.65 49.0826 32.454C48.8306 32.258 48.6439 32.062 48.5226 31.866C48.4013 31.67 48.3359 31.5067 48.3266 31.376C48.3173 31.2733 48.3453 31.194 48.4106 31.138C48.4853 31.0727 48.5646 31.04 48.6486 31.04H49.7546C49.7919 31.04 49.8246 31.0447 49.8526 31.054C49.8806 31.0633 49.9179 31.0913 49.9646 31.138C50.0859 31.2407 50.2119 31.348 50.3426 31.46C50.4826 31.572 50.6459 31.67 50.8326 31.754C51.0193 31.8287 51.2526 31.866 51.5326 31.866C51.8966 31.866 52.1999 31.796 52.4426 31.656C52.6946 31.5067 52.8206 31.2967 52.8206 31.026C52.8206 30.83 52.7646 30.6713 52.6526 30.55C52.5499 30.4287 52.3539 30.3213 52.0646 30.228C51.7753 30.1253 51.3646 30.018 50.8326 29.906C50.3099 29.7847 49.8759 29.6307 49.5306 29.444C49.1853 29.2573 48.9286 29.024 48.7606 28.744C48.5926 28.464 48.5086 28.1373 48.5086 27.764C48.5086 27.4 48.6159 27.0547 48.8306 26.728C49.0546 26.392 49.3813 26.1167 49.8106 25.902C50.2493 25.6873 50.7906 25.58 51.4346 25.58C51.9386 25.58 52.3773 25.6453 52.7506 25.776C53.1239 25.8973 53.4319 26.0513 53.6746 26.238C53.9266 26.4247 54.1179 26.616 54.2486 26.812C54.3793 26.9987 54.4493 27.162 54.4586 27.302C54.4679 27.4047 54.4399 27.4887 54.3746 27.554C54.3093 27.61 54.2346 27.638 54.1506 27.638H53.1146C53.0679 27.638 53.0259 27.6287 52.9886 27.61C52.9513 27.5913 52.9139 27.568 52.8766 27.54C52.7739 27.4467 52.6619 27.3487 52.5406 27.246C52.4193 27.134 52.2699 27.0407 52.0926 26.966C51.9246 26.8913 51.7006 26.854 51.4206 26.854C51.0659 26.854 50.7953 26.9333 50.6086 27.092C50.4219 27.2413 50.3286 27.4327 50.3286 27.666C50.3286 27.8247 50.3706 27.9647 50.4546 28.086C50.5479 28.198 50.7299 28.3053 51.0006 28.408C51.2713 28.5107 51.6819 28.618 52.2326 28.73C52.8579 28.842 53.3526 29.01 53.7166 29.234C54.0899 29.4487 54.3513 29.7007 54.5006 29.99C54.6593 30.27 54.7386 30.5827 54.7386 30.928C54.7386 31.348 54.6126 31.726 54.3606 32.062C54.1179 32.398 53.7539 32.664 53.2686 32.86C52.7926 33.0467 52.1999 33.14 51.4906 33.14ZM58.5798 33C58.5052 33 58.4352 32.972 58.3698 32.916C58.3138 32.86 58.2858 32.79 58.2858 32.706C58.2858 32.6687 58.2952 32.6267 58.3138 32.58L61.6878 23.55C61.7158 23.4567 61.7672 23.3773 61.8418 23.312C61.9258 23.2373 62.0378 23.2 62.1778 23.2H63.7038C63.8438 23.2 63.9512 23.2373 64.0258 23.312C64.1005 23.3773 64.1565 23.4567 64.1938 23.55L67.5678 32.58C67.5772 32.6267 67.5818 32.6687 67.5818 32.706C67.5818 32.79 67.5538 32.86 67.4978 32.916C67.4418 32.972 67.3765 33 67.3018 33H66.0838C65.9532 33 65.8552 32.972 65.7898 32.916C65.7338 32.8507 65.6965 32.79 65.6778 32.734L65.0198 31.026H60.8618L60.2038 32.734C60.1852 32.79 60.1432 32.8507 60.0778 32.916C60.0218 32.972 59.9285 33 59.7978 33H58.5798ZM61.3518 29.416H64.5298L62.9338 25.09L61.3518 29.416ZM71.3408 33.14C70.8555 33.14 70.4262 33.0607 70.0528 32.902C69.6888 32.734 69.3855 32.5007 69.1428 32.202C68.9002 31.9033 68.7135 31.5533 68.5828 31.152C68.4522 30.7413 68.3775 30.2933 68.3588 29.808C68.3495 29.64 68.3448 29.4907 68.3448 29.36C68.3448 29.22 68.3495 29.066 68.3588 28.898C68.3775 28.4313 68.4475 27.9973 68.5688 27.596C68.6995 27.1947 68.8862 26.8447 69.1288 26.546C69.3808 26.238 69.6888 26 70.0528 25.832C70.4262 25.664 70.8555 25.58 71.3408 25.58C71.8448 25.58 72.2695 25.6687 72.6148 25.846C72.9695 26.014 73.2635 26.2333 73.4968 26.504V23.396C73.4968 23.3027 73.5248 23.2233 73.5808 23.158C73.6462 23.0927 73.7302 23.06 73.8328 23.06H75.0228C75.1162 23.06 75.1955 23.0927 75.2608 23.158C75.3262 23.2233 75.3588 23.3027 75.3588 23.396V32.664C75.3588 32.7573 75.3262 32.8367 75.2608 32.902C75.1955 32.9673 75.1162 33 75.0228 33H73.9168C73.8142 33 73.7302 32.9673 73.6648 32.902C73.6088 32.8367 73.5808 32.7573 73.5808 32.664V32.146C73.3475 32.4353 73.0488 32.6733 72.6848 32.86C72.3302 33.0467 71.8822 33.14 71.3408 33.14ZM71.8588 31.642C72.2508 31.642 72.5635 31.5533 72.7968 31.376C73.0302 31.1987 73.2028 30.9747 73.3148 30.704C73.4268 30.424 73.4875 30.1393 73.4968 29.85C73.5062 29.682 73.5108 29.5047 73.5108 29.318C73.5108 29.122 73.5062 28.94 73.4968 28.772C73.4875 28.492 73.4222 28.226 73.3008 27.974C73.1795 27.7127 73.0022 27.498 72.7688 27.33C72.5355 27.162 72.2322 27.078 71.8588 27.078C71.4668 27.078 71.1542 27.1667 70.9208 27.344C70.6968 27.512 70.5335 27.736 70.4308 28.016C70.3282 28.296 70.2675 28.604 70.2488 28.94C70.2395 29.22 70.2395 29.5 70.2488 29.78C70.2675 30.116 70.3282 30.424 70.4308 30.704C70.5335 30.984 70.6968 31.2127 70.9208 31.39C71.1542 31.558 71.4668 31.642 71.8588 31.642ZM79.9268 33.14C79.4414 33.14 79.0121 33.0607 78.6388 32.902C78.2748 32.734 77.9714 32.5007 77.7288 32.202C77.4861 31.9033 77.2994 31.5533 77.1688 31.152C77.0381 30.7413 76.9634 30.2933 76.9448 29.808C76.9354 29.64 76.9308 29.4907 76.9308 29.36C76.9308 29.22 76.9354 29.066 76.9448 28.898C76.9634 28.4313 77.0334 27.9973 77.1548 27.596C77.2854 27.1947 77.4721 26.8447 77.7148 26.546C77.9668 26.238 78.2748 26 78.6388 25.832C79.0121 25.664 79.4414 25.58 79.9268 25.58C80.4308 25.58 80.8554 25.6687 81.2008 25.846C81.5554 26.014 81.8494 26.2333 82.0828 26.504V23.396C82.0828 23.3027 82.1108 23.2233 82.1668 23.158C82.2321 23.0927 82.3161 23.06 82.4188 23.06H83.6088C83.7021 23.06 83.7814 23.0927 83.8468 23.158C83.9121 23.2233 83.9448 23.3027 83.9448 23.396V32.664C83.9448 32.7573 83.9121 32.8367 83.8468 32.902C83.7814 32.9673 83.7021 33 83.6088 33H82.5028C82.4001 33 82.3161 32.9673 82.2508 32.902C82.1948 32.8367 82.1668 32.7573 82.1668 32.664V32.146C81.9334 32.4353 81.6348 32.6733 81.2708 32.86C80.9161 33.0467 80.4681 33.14 79.9268 33.14ZM80.4448 31.642C80.8368 31.642 81.1494 31.5533 81.3828 31.376C81.6161 31.1987 81.7888 30.9747 81.9008 30.704C82.0128 30.424 82.0734 30.1393 82.0828 29.85C82.0921 29.682 82.0968 29.5047 82.0968 29.318C82.0968 29.122 82.0921 28.94 82.0828 28.772C82.0734 28.492 82.0081 28.226 81.8868 27.974C81.7654 27.7127 81.5881 27.498 81.3548 27.33C81.1214 27.162 80.8181 27.078 80.4448 27.078C80.0528 27.078 79.7401 27.1667 79.5068 27.344C79.2828 27.512 79.1194 27.736 79.0168 28.016C78.9141 28.296 78.8534 28.604 78.8348 28.94C78.8254 29.22 78.8254 29.5 78.8348 29.78C78.8534 30.116 78.9141 30.424 79.0168 30.704C79.1194 30.984 79.2828 31.2127 79.5068 31.39C79.7401 31.558 80.0528 31.642 80.4448 31.642ZM88.9467 33.14C87.9107 33.14 87.0894 32.8413 86.4827 32.244C85.8761 31.6467 85.5494 30.7973 85.5027 29.696C85.4934 29.6027 85.4887 29.486 85.4887 29.346C85.4887 29.1967 85.4934 29.08 85.5027 28.996C85.5401 28.2867 85.6987 27.68 85.9787 27.176C86.2681 26.6627 86.6647 26.2707 87.1687 26C87.6727 25.72 88.2654 25.58 88.9467 25.58C89.7027 25.58 90.3374 25.7387 90.8507 26.056C91.3641 26.364 91.7514 26.798 92.0127 27.358C92.2741 27.9087 92.4047 28.548 92.4047 29.276V29.57C92.4047 29.6633 92.3721 29.7427 92.3067 29.808C92.2414 29.8733 92.1574 29.906 92.0547 29.906H87.4067C87.4067 29.906 87.4067 29.92 87.4067 29.948C87.4067 29.976 87.4067 29.9993 87.4067 30.018C87.4161 30.3447 87.4767 30.648 87.5887 30.928C87.7101 31.1987 87.8827 31.418 88.1067 31.586C88.3401 31.754 88.6154 31.838 88.9327 31.838C89.1941 31.838 89.4134 31.8007 89.5907 31.726C89.7681 31.642 89.9127 31.5487 90.0247 31.446C90.1367 31.3433 90.2161 31.2593 90.2627 31.194C90.3467 31.082 90.4121 31.0167 90.4587 30.998C90.5147 30.97 90.5941 30.956 90.6967 30.956H91.9007C91.9941 30.956 92.0687 30.984 92.1247 31.04C92.1901 31.096 92.2181 31.166 92.2087 31.25C92.1994 31.3993 92.1201 31.5813 91.9707 31.796C91.8307 32.0107 91.6254 32.2207 91.3547 32.426C91.0841 32.6313 90.7434 32.804 90.3327 32.944C89.9314 33.0747 89.4694 33.14 88.9467 33.14ZM87.4067 28.73H90.5007V28.688C90.5007 28.324 90.4401 28.0067 90.3187 27.736C90.1974 27.456 90.0201 27.2413 89.7867 27.092C89.5534 26.9333 89.2734 26.854 88.9467 26.854C88.6201 26.854 88.3401 26.9333 88.1067 27.092C87.8734 27.2413 87.6961 27.456 87.5747 27.736C87.4627 28.0067 87.4067 28.324 87.4067 28.688V28.73ZM96.5928 33.14C96.1075 33.14 95.6781 33.0607 95.3048 32.902C94.9408 32.734 94.6375 32.5007 94.3948 32.202C94.1521 31.9033 93.9655 31.5533 93.8348 31.152C93.7041 30.7413 93.6295 30.2933 93.6108 29.808C93.6015 29.64 93.5968 29.4907 93.5968 29.36C93.5968 29.22 93.6015 29.066 93.6108 28.898C93.6295 28.4313 93.6995 27.9973 93.8208 27.596C93.9515 27.1947 94.1381 26.8447 94.3808 26.546C94.6328 26.238 94.9408 26 95.3048 25.832C95.6781 25.664 96.1075 25.58 96.5928 25.58C97.0968 25.58 97.5215 25.6687 97.8668 25.846C98.2215 26.014 98.5155 26.2333 98.7488 26.504V23.396C98.7488 23.3027 98.7768 23.2233 98.8328 23.158C98.8981 23.0927 98.9821 23.06 99.0848 23.06H100.275C100.368 23.06 100.447 23.0927 100.513 23.158C100.578 23.2233 100.611 23.3027 100.611 23.396V32.664C100.611 32.7573 100.578 32.8367 100.513 32.902C100.447 32.9673 100.368 33 100.275 33H99.1688C99.0661 33 98.9821 32.9673 98.9168 32.902C98.8608 32.8367 98.8328 32.7573 98.8328 32.664V32.146C98.5995 32.4353 98.3008 32.6733 97.9368 32.86C97.5821 33.0467 97.1341 33.14 96.5928 33.14ZM97.1108 31.642C97.5028 31.642 97.8155 31.5533 98.0488 31.376C98.2821 31.1987 98.4548 30.9747 98.5668 30.704C98.6788 30.424 98.7395 30.1393 98.7488 29.85C98.7581 29.682 98.7628 29.5047 98.7628 29.318C98.7628 29.122 98.7581 28.94 98.7488 28.772C98.7395 28.492 98.6741 28.226 98.5528 27.974C98.4315 27.7127 98.2541 27.498 98.0208 27.33C97.7875 27.162 97.4841 27.078 97.1108 27.078C96.7188 27.078 96.4061 27.1667 96.1728 27.344C95.9488 27.512 95.7855 27.736 95.6828 28.016C95.5801 28.296 95.5195 28.604 95.5008 28.94C95.4915 29.22 95.4915 29.5 95.5008 29.78C95.5195 30.116 95.5801 30.424 95.6828 30.704C95.7855 30.984 95.9488 31.2127 96.1728 31.39C96.4061 31.558 96.7188 31.642 97.1108 31.642Z" fill="#F3F4F7"/>
<path d="M25.364 91C25.1293 91 24.9373 90.9253 24.788 90.776C24.66 90.6267 24.596 90.4453 24.596 90.232V73.656L19.732 77.4C19.54 77.528 19.348 77.5813 19.156 77.56C18.964 77.5173 18.7933 77.4 18.644 77.208L17.3 75.48C17.172 75.288 17.1187 75.0853 17.14 74.872C17.1827 74.6587 17.3 74.488 17.492 74.36L24.66 68.824C24.788 68.7173 24.916 68.6533 25.044 68.632C25.172 68.6107 25.3107 68.6 25.46 68.6H28.276C28.4893 68.6 28.6707 68.6747 28.82 68.824C28.9693 68.9733 29.044 69.1547 29.044 69.368V90.232C29.044 90.4453 28.9693 90.6267 28.82 90.776C28.6707 90.9253 28.4893 91 28.276 91H25.364ZM33.5205 91C33.3072 91 33.1258 90.9253 32.9765 90.776C32.8272 90.6267 32.7525 90.4453 32.7525 90.232V88.6C32.7525 88.408 32.7952 88.184 32.8805 87.928C32.9872 87.6507 33.2112 87.3733 33.5525 87.096L38.6085 82.072C40.0165 80.9627 41.1472 80.024 42.0005 79.256C42.8752 78.4667 43.5045 77.752 43.8885 77.112C44.2938 76.4507 44.4965 75.8 44.4965 75.16C44.4965 74.2 44.2298 73.4213 43.6965 72.824C43.1845 72.2267 42.3632 71.928 41.2325 71.928C40.4858 71.928 39.8565 72.088 39.3445 72.408C38.8325 72.7067 38.4272 73.112 38.1285 73.624C37.8512 74.136 37.6592 74.7013 37.5525 75.32C37.5098 75.5973 37.3925 75.7893 37.2005 75.896C37.0085 76.0027 36.8165 76.056 36.6245 76.056H33.7765C33.5845 76.056 33.4245 75.992 33.2965 75.864C33.1685 75.736 33.1045 75.5867 33.1045 75.416C33.1258 74.4987 33.3178 73.6133 33.6805 72.76C34.0432 71.8853 34.5658 71.1173 35.2485 70.456C35.9525 69.7733 36.8058 69.2293 37.8085 68.824C38.8112 68.4187 39.9418 68.216 41.2005 68.216C42.9712 68.216 44.4325 68.5147 45.5845 69.112C46.7578 69.7093 47.6325 70.52 48.2085 71.544C48.8058 72.568 49.1045 73.72 49.1045 75C49.1045 76.0027 48.9125 76.9307 48.5285 77.784C48.1445 78.616 47.5898 79.4267 46.8645 80.216C46.1392 80.984 45.2645 81.7733 44.2405 82.584L39.6965 87.192H48.8165C49.0512 87.192 49.2325 87.2667 49.3605 87.416C49.5098 87.544 49.5845 87.7253 49.5845 87.96V90.232C49.5845 90.4453 49.5098 90.6267 49.3605 90.776C49.2325 90.9253 49.0512 91 48.8165 91H33.5205Z" fill="white"/>
<path d="M21.6411 120.472C21.5345 120.472 21.4438 120.44 21.3691 120.376C21.3051 120.301 21.2731 120.211 21.2731 120.104V116.776H17.9931C17.8865 116.776 17.7958 116.744 17.7211 116.68C17.6571 116.605 17.6251 116.515 17.6251 116.408V115.896C17.6251 115.789 17.6571 115.704 17.7211 115.64C17.7958 115.565 17.8865 115.528 17.9931 115.528H21.2731V112.296C21.2731 112.189 21.3051 112.104 21.3691 112.04C21.4438 111.965 21.5345 111.928 21.6411 111.928H22.2011C22.3078 111.928 22.3931 111.965 22.4571 112.04C22.5318 112.104 22.5691 112.189 22.5691 112.296V115.528H25.8651C25.9718 115.528 26.0571 115.565 26.1211 115.64C26.1958 115.704 26.2331 115.789 26.2331 115.896V116.408C26.2331 116.515 26.1958 116.605 26.1211 116.68C26.0571 116.744 25.9718 116.776 25.8651 116.776H22.5691V120.104C22.5691 120.211 22.5318 120.301 22.4571 120.376C22.3931 120.44 22.3078 120.472 22.2011 120.472H21.6411ZM31.4868 121.16C30.8148 121.16 30.2281 121.08 29.7268 120.92C29.2254 120.749 28.8041 120.525 28.4628 120.248C28.1214 119.971 27.8601 119.667 27.6788 119.336C27.5081 118.995 27.4174 118.653 27.4068 118.312C27.4068 118.216 27.4388 118.141 27.5028 118.088C27.5668 118.024 27.6468 117.992 27.7428 117.992H28.5268C28.6228 117.992 28.7081 118.019 28.7828 118.072C28.8681 118.115 28.9321 118.205 28.9748 118.344C29.0814 118.728 29.2628 119.027 29.5188 119.24C29.7854 119.453 30.0894 119.603 30.4308 119.688C30.7828 119.763 31.1348 119.8 31.4868 119.8C32.2228 119.8 32.8201 119.624 33.2788 119.272C33.7374 118.92 33.9668 118.403 33.9668 117.72C33.9668 117.027 33.7588 116.531 33.3428 116.232C32.9268 115.933 32.3508 115.784 31.6148 115.784H30.0948C29.9881 115.784 29.8974 115.752 29.8228 115.688C29.7588 115.624 29.7268 115.533 29.7268 115.416V114.984C29.7268 114.888 29.7428 114.808 29.7748 114.744C29.8174 114.669 29.8601 114.605 29.9028 114.552L33.0068 111.16H28.2868C28.1801 111.16 28.0894 111.128 28.0148 111.064C27.9508 111 27.9188 110.909 27.9188 110.792V110.184C27.9188 110.067 27.9508 109.976 28.0148 109.912C28.0894 109.837 28.1801 109.8 28.2868 109.8H34.6708C34.7881 109.8 34.8788 109.837 34.9427 109.912C35.0174 109.976 35.0548 110.067 35.0548 110.184V110.76C35.0548 110.835 35.0334 110.904 34.9908 110.968C34.9588 111.021 34.9214 111.075 34.8788 111.128L31.7908 114.568L32.0468 114.584C32.7508 114.605 33.3641 114.733 33.8868 114.968C34.4201 115.203 34.8308 115.555 35.1188 116.024C35.4174 116.483 35.5668 117.064 35.5668 117.768C35.5668 118.483 35.3908 119.091 35.0388 119.592C34.6868 120.093 34.2014 120.483 33.5828 120.76C32.9748 121.027 32.2761 121.16 31.4868 121.16ZM38.0721 121C37.8481 121 37.7361 120.893 37.7361 120.68C37.7361 120.616 37.7575 120.557 37.8001 120.504L45.7041 110.104C45.7788 110.008 45.8481 109.933 45.9121 109.88C45.9868 109.827 46.0935 109.8 46.2321 109.8H46.7601C46.9841 109.8 47.0961 109.907 47.0961 110.12C47.0961 110.184 47.0748 110.243 47.0321 110.296L39.1441 120.696C39.0695 120.792 38.9948 120.867 38.9201 120.92C38.8561 120.973 38.7495 121 38.6001 121H38.0721ZM45.4001 121.096C44.7068 121.096 44.1575 120.899 43.7521 120.504C43.3575 120.109 43.1388 119.592 43.0961 118.952C43.0855 118.675 43.0801 118.44 43.0801 118.248C43.0801 118.045 43.0855 117.795 43.0961 117.496C43.1388 116.856 43.3468 116.339 43.7201 115.944C44.1041 115.539 44.6641 115.336 45.4001 115.336C46.1468 115.336 46.7068 115.539 47.0801 115.944C47.4641 116.339 47.6775 116.856 47.7201 117.496C47.7415 117.795 47.7521 118.045 47.7521 118.248C47.7521 118.44 47.7415 118.675 47.7201 118.952C47.6775 119.592 47.4535 120.109 47.0481 120.504C46.6535 120.899 46.1041 121.096 45.4001 121.096ZM45.4001 120.04C45.6881 120.04 45.9121 119.981 46.0721 119.864C46.2321 119.747 46.3495 119.603 46.4241 119.432C46.4988 119.251 46.5415 119.069 46.5521 118.888C46.5735 118.6 46.5841 118.371 46.5841 118.2C46.5841 118.029 46.5735 117.816 46.5521 117.56C46.5415 117.272 46.4508 117.005 46.2801 116.76C46.1095 116.515 45.8161 116.392 45.4001 116.392C44.9948 116.392 44.7068 116.515 44.5361 116.76C44.3761 117.005 44.2855 117.272 44.2641 117.56C44.2535 117.816 44.2481 118.029 44.2481 118.2C44.2481 118.371 44.2535 118.6 44.2641 118.888C44.2855 119.069 44.3281 119.251 44.3921 119.432C44.4668 119.603 44.5841 119.747 44.7441 119.864C44.9148 119.981 45.1335 120.04 45.4001 120.04ZM39.4161 115.416C38.7121 115.416 38.1628 115.229 37.7681 114.856C37.3735 114.483 37.1548 113.976 37.1121 113.336C37.1015 113.059 37.0961 112.824 37.0961 112.632C37.0961 112.429 37.1015 112.179 37.1121 111.88C37.1441 111.24 37.3521 110.723 37.7361 110.328C38.1201 109.923 38.6801 109.72 39.4161 109.72C40.1628 109.72 40.7228 109.923 41.0961 110.328C41.4801 110.723 41.6881 111.24 41.7201 111.88C41.7415 112.179 41.7521 112.429 41.7521 112.632C41.7521 112.824 41.7415 113.059 41.7201 113.336C41.6881 113.976 41.4695 114.483 41.0641 114.856C40.6695 115.229 40.1201 115.416 39.4161 115.416ZM39.4161 114.424C39.6935 114.424 39.9121 114.365 40.0721 114.248C40.2428 114.131 40.3655 113.987 40.4401 113.816C40.5148 113.635 40.5575 113.453 40.5681 113.272C40.5895 112.984 40.6001 112.76 40.6001 112.6C40.6001 112.429 40.5895 112.211 40.5681 111.944C40.5575 111.656 40.4615 111.389 40.2801 111.144C40.1095 110.899 39.8215 110.776 39.4161 110.776C39.0108 110.776 38.7228 110.899 38.5521 111.144C38.3921 111.389 38.3015 111.656 38.2801 111.944C38.2695 112.211 38.2641 112.429 38.2641 112.6C38.2641 112.76 38.2695 112.984 38.2801 113.272C38.3015 113.453 38.3441 113.635 38.4081 113.816C38.4828 113.987 38.6001 114.131 38.7601 114.248C38.9201 114.365 39.1388 114.424 39.4161 114.424Z" fill="#E9A8FF"/>
<rect x="52.5" y="104" width="24" height="24" rx="12" fill="#5D017D"/>
<path d="M62.5878 110.333C62.5878 110.149 62.7371 110 62.9212 110H70.1664C70.2517 110 70.3372 110.033 70.4023 110.098C70.4701 110.165 70.5025 110.255 70.4998 110.344V117.579C70.4998 117.763 70.3505 117.912 70.1664 117.912C69.9823 117.912 69.8331 117.763 69.8331 117.579V111.138L62.7029 118.268C62.5728 118.399 62.3617 118.399 62.2315 118.268C62.1014 118.138 62.1014 117.927 62.2315 117.797L69.3619 110.667H62.9212C62.7371 110.667 62.5878 110.517 62.5878 110.333Z" fill="#E9A8FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M60.1667 118.667C59.2462 118.667 58.5 119.413 58.5 120.333C58.5 121.254 59.2462 122 60.1667 122C61.0871 122 61.8333 121.254 61.8333 120.333C61.8333 119.413 61.0871 118.667 60.1667 118.667ZM59.1667 120.333C59.1667 119.781 59.6144 119.333 60.1667 119.333C60.719 119.333 61.1667 119.781 61.1667 120.333C61.1667 120.886 60.719 121.333 60.1667 121.333C59.6144 121.333 59.1667 120.886 59.1667 120.333Z" fill="#E9A8FF"/>
<path d="M20.868 147.14C20.056 147.14 19.3747 147.014 18.824 146.762C18.2733 146.51 17.8487 146.188 17.55 145.796C17.2607 145.395 17.1067 144.975 17.088 144.536C17.088 144.461 17.116 144.396 17.172 144.34C17.2373 144.275 17.312 144.242 17.396 144.242H18.11C18.222 144.242 18.306 144.27 18.362 144.326C18.418 144.382 18.4553 144.447 18.474 144.522C18.53 144.746 18.6467 144.97 18.824 145.194C19.0013 145.409 19.2533 145.591 19.58 145.74C19.916 145.88 20.3453 145.95 20.868 145.95C21.6707 145.95 22.2587 145.81 22.632 145.53C23.0147 145.241 23.206 144.858 23.206 144.382C23.206 144.055 23.1033 143.794 22.898 143.598C22.702 143.393 22.3987 143.211 21.988 143.052C21.5773 142.893 21.0453 142.721 20.392 142.534C19.7107 142.338 19.146 142.123 18.698 141.89C18.25 141.657 17.914 141.367 17.69 141.022C17.4753 140.677 17.368 140.238 17.368 139.706C17.368 139.202 17.5033 138.754 17.774 138.362C18.0447 137.961 18.4367 137.643 18.95 137.41C19.4633 137.177 20.0793 137.06 20.798 137.06C21.3767 137.06 21.8807 137.139 22.31 137.298C22.7487 137.447 23.1127 137.653 23.402 137.914C23.6913 138.166 23.9107 138.441 24.06 138.74C24.2093 139.029 24.2887 139.314 24.298 139.594C24.298 139.659 24.2747 139.725 24.228 139.79C24.1813 139.846 24.1067 139.874 24.004 139.874H23.262C23.1967 139.874 23.1267 139.855 23.052 139.818C22.9867 139.781 22.9353 139.711 22.898 139.608C22.842 139.225 22.6273 138.903 22.254 138.642C21.8807 138.381 21.3953 138.25 20.798 138.25C20.1913 138.25 19.6967 138.367 19.314 138.6C18.9407 138.833 18.754 139.197 18.754 139.692C18.754 140.009 18.8427 140.275 19.02 140.49C19.1973 140.695 19.4773 140.877 19.86 141.036C20.2427 141.195 20.742 141.363 21.358 141.54C22.1047 141.745 22.716 141.965 23.192 142.198C23.668 142.422 24.018 142.707 24.242 143.052C24.4753 143.388 24.592 143.822 24.592 144.354C24.592 144.942 24.438 145.446 24.13 145.866C23.822 146.277 23.388 146.594 22.828 146.818C22.2773 147.033 21.624 147.14 20.868 147.14ZM26.567 147C26.4737 147 26.3943 146.972 26.329 146.916C26.273 146.851 26.245 146.771 26.245 146.678V140.042C26.245 139.949 26.273 139.874 26.329 139.818C26.3943 139.753 26.4737 139.72 26.567 139.72H27.239C27.3323 139.72 27.407 139.753 27.463 139.818C27.5283 139.874 27.561 139.949 27.561 140.042V146.678C27.561 146.771 27.5283 146.851 27.463 146.916C27.407 146.972 27.3323 147 27.239 147H26.567ZM26.455 138.362C26.3617 138.362 26.2823 138.334 26.217 138.278C26.161 138.213 26.133 138.133 26.133 138.04V137.284C26.133 137.191 26.161 137.111 26.217 137.046C26.2823 136.981 26.3617 136.948 26.455 136.948H27.337C27.4303 136.948 27.5097 136.981 27.575 137.046C27.6403 137.111 27.673 137.191 27.673 137.284V138.04C27.673 138.133 27.6403 138.213 27.575 138.278C27.5097 138.334 27.4303 138.362 27.337 138.362H26.455ZM29.9576 147C29.8643 147 29.7849 146.972 29.7196 146.916C29.6636 146.851 29.6356 146.771 29.6356 146.678V140.042C29.6356 139.949 29.6636 139.874 29.7196 139.818C29.7849 139.753 29.8643 139.72 29.9576 139.72H30.6156C30.7089 139.72 30.7836 139.753 30.8396 139.818C30.9049 139.874 30.9376 139.949 30.9376 140.042V140.658C31.1803 140.341 31.4836 140.084 31.8476 139.888C32.2209 139.683 32.6969 139.58 33.2756 139.58C33.8823 139.58 34.3956 139.715 34.8156 139.986C35.2449 140.247 35.5669 140.616 35.7816 141.092C36.0056 141.559 36.1176 142.105 36.1176 142.73V146.678C36.1176 146.771 36.0849 146.851 36.0196 146.916C35.9636 146.972 35.8889 147 35.7956 147H35.0956C35.0023 147 34.9229 146.972 34.8576 146.916C34.8016 146.851 34.7736 146.771 34.7736 146.678V142.8C34.7736 142.147 34.6149 141.638 34.2976 141.274C33.9803 140.901 33.5136 140.714 32.8976 140.714C32.3189 140.714 31.8523 140.901 31.4976 141.274C31.1523 141.638 30.9796 142.147 30.9796 142.8V146.678C30.9796 146.771 30.9469 146.851 30.8816 146.916C30.8256 146.972 30.7509 147 30.6576 147H29.9576ZM41.0658 147.14C40.4032 147.14 39.8292 147.014 39.3438 146.762C38.8678 146.501 38.4992 146.132 38.2378 145.656C37.9765 145.171 37.8365 144.592 37.8178 143.92C37.8085 143.78 37.8038 143.593 37.8038 143.36C37.8038 143.127 37.8085 142.94 37.8178 142.8C37.8365 142.128 37.9765 141.554 38.2378 141.078C38.4992 140.593 38.8678 140.224 39.3438 139.972C39.8292 139.711 40.4032 139.58 41.0658 139.58C41.6072 139.58 42.0692 139.655 42.4518 139.804C42.8438 139.953 43.1658 140.145 43.4178 140.378C43.6698 140.611 43.8565 140.863 43.9778 141.134C44.1085 141.405 44.1785 141.661 44.1878 141.904C44.1972 141.997 44.1692 142.072 44.1038 142.128C44.0385 142.184 43.9592 142.212 43.8658 142.212H43.1938C43.1005 142.212 43.0305 142.193 42.9838 142.156C42.9372 142.109 42.8905 142.035 42.8438 141.932C42.6758 141.475 42.4472 141.153 42.1578 140.966C41.8685 140.779 41.5092 140.686 41.0798 140.686C40.5198 140.686 40.0625 140.859 39.7078 141.204C39.3625 141.549 39.1758 142.105 39.1478 142.87C39.1385 143.206 39.1385 143.533 39.1478 143.85C39.1758 144.625 39.3625 145.185 39.7078 145.53C40.0625 145.866 40.5198 146.034 41.0798 146.034C41.5092 146.034 41.8685 145.941 42.1578 145.754C42.4472 145.567 42.6758 145.245 42.8438 144.788C42.8905 144.685 42.9372 144.611 42.9838 144.564C43.0305 144.517 43.1005 144.494 43.1938 144.494H43.8658C43.9592 144.494 44.0385 144.527 44.1038 144.592C44.1692 144.648 44.1972 144.723 44.1878 144.816C44.1785 145.012 44.1365 145.213 44.0618 145.418C43.9872 145.623 43.8658 145.833 43.6978 146.048C43.5392 146.253 43.3385 146.44 43.0958 146.608C42.8532 146.767 42.5638 146.897 42.2278 147C41.8918 147.093 41.5045 147.14 41.0658 147.14ZM48.7625 147.14C47.7918 147.14 47.0218 146.846 46.4525 146.258C45.8831 145.661 45.5705 144.849 45.5145 143.822C45.5051 143.701 45.5005 143.547 45.5005 143.36C45.5005 143.164 45.5051 143.005 45.5145 142.884C45.5518 142.221 45.7058 141.643 45.9765 141.148C46.2471 140.644 46.6158 140.257 47.0825 139.986C47.5585 139.715 48.1138 139.58 48.7485 139.58C49.4578 139.58 50.0505 139.729 50.5265 140.028C51.0118 140.327 51.3805 140.751 51.6325 141.302C51.8845 141.853 52.0105 142.497 52.0105 143.234V143.472C52.0105 143.575 51.9778 143.654 51.9125 143.71C51.8565 143.766 51.7818 143.794 51.6885 143.794H46.8445C46.8445 143.803 46.8445 143.822 46.8445 143.85C46.8445 143.878 46.8445 143.901 46.8445 143.92C46.8631 144.303 46.9471 144.662 47.0965 144.998C47.2458 145.325 47.4605 145.591 47.7405 145.796C48.0298 146.001 48.3658 146.104 48.7485 146.104C49.0845 146.104 49.3645 146.053 49.5885 145.95C49.8125 145.847 49.9945 145.735 50.1345 145.614C50.2745 145.483 50.3678 145.381 50.4145 145.306C50.4985 145.194 50.5638 145.129 50.6105 145.11C50.6571 145.082 50.7318 145.068 50.8345 145.068H51.5205C51.6045 145.068 51.6745 145.096 51.7305 145.152C51.7958 145.199 51.8238 145.269 51.8145 145.362C51.8051 145.502 51.7305 145.675 51.5905 145.88C51.4505 146.076 51.2498 146.272 50.9885 146.468C50.7365 146.664 50.4191 146.827 50.0365 146.958C49.6631 147.079 49.2385 147.14 48.7625 147.14ZM46.8445 142.828H50.6805V142.786C50.6805 142.366 50.6011 141.993 50.4425 141.666C50.2931 141.339 50.0738 141.083 49.7845 140.896C49.4951 140.7 49.1498 140.602 48.7485 140.602C48.3471 140.602 48.0018 140.7 47.7125 140.896C47.4325 141.083 47.2178 141.339 47.0685 141.666C46.9191 141.993 46.8445 142.366 46.8445 142.786V142.828ZM57.4521 147C57.3587 147 57.2794 146.972 57.2141 146.916C57.1581 146.851 57.1301 146.771 57.1301 146.678V137.382C57.1301 137.289 57.1581 137.214 57.2141 137.158C57.2794 137.093 57.3587 137.06 57.4521 137.06H58.1101C58.2127 137.06 58.2921 137.093 58.3481 137.158C58.4041 137.214 58.4321 137.289 58.4321 137.382V146.678C58.4321 146.771 58.4041 146.851 58.3481 146.916C58.2921 146.972 58.2127 147 58.1101 147H57.4521ZM62.5504 147.14C62.0837 147.14 61.659 147.047 61.2764 146.86C60.8937 146.673 60.5857 146.421 60.3524 146.104C60.119 145.787 60.0024 145.427 60.0024 145.026C60.0024 144.382 60.2637 143.869 60.7864 143.486C61.309 143.103 61.9904 142.851 62.8304 142.73L64.9164 142.436V142.03C64.9164 141.582 64.7857 141.232 64.5244 140.98C64.2724 140.728 63.857 140.602 63.2784 140.602C62.8677 140.602 62.5317 140.686 62.2704 140.854C62.009 141.022 61.827 141.237 61.7244 141.498C61.6684 141.638 61.5704 141.708 61.4304 141.708H60.8004C60.6977 141.708 60.6184 141.68 60.5624 141.624C60.5157 141.559 60.4924 141.484 60.4924 141.4C60.4924 141.26 60.5437 141.087 60.6464 140.882C60.7584 140.677 60.9264 140.476 61.1504 140.28C61.3744 140.084 61.659 139.921 62.0044 139.79C62.359 139.65 62.7884 139.58 63.2924 139.58C63.8524 139.58 64.3237 139.655 64.7064 139.804C65.089 139.944 65.3877 140.135 65.6024 140.378C65.8264 140.621 65.985 140.896 66.0784 141.204C66.181 141.512 66.2324 141.825 66.2324 142.142V146.678C66.2324 146.771 66.1997 146.851 66.1344 146.916C66.0784 146.972 66.0037 147 65.9104 147H65.2664C65.1637 147 65.0844 146.972 65.0284 146.916C64.9724 146.851 64.9444 146.771 64.9444 146.678V146.076C64.823 146.244 64.6597 146.412 64.4544 146.58C64.249 146.739 63.9924 146.874 63.6844 146.986C63.3764 147.089 62.9984 147.14 62.5504 147.14ZM62.8444 146.09C63.227 146.09 63.577 146.011 63.8944 145.852C64.2117 145.684 64.459 145.427 64.6364 145.082C64.823 144.737 64.9164 144.303 64.9164 143.78V143.388L63.2924 143.626C62.6297 143.719 62.1304 143.878 61.7944 144.102C61.4584 144.317 61.2904 144.592 61.2904 144.928C61.2904 145.189 61.365 145.409 61.5144 145.586C61.673 145.754 61.869 145.88 62.1024 145.964C62.345 146.048 62.5924 146.09 62.8444 146.09ZM70.765 147.14C70.2423 147.14 69.7943 147.075 69.421 146.944C69.0477 146.813 68.7443 146.655 68.511 146.468C68.2777 146.281 68.1003 146.095 67.979 145.908C67.867 145.721 67.8063 145.572 67.797 145.46C67.7877 145.357 67.8203 145.278 67.895 145.222C67.9697 145.166 68.0443 145.138 68.119 145.138H68.749C68.7957 145.138 68.833 145.147 68.861 145.166C68.8983 145.175 68.945 145.213 69.001 145.278C69.1223 145.409 69.2577 145.539 69.407 145.67C69.5563 145.801 69.7383 145.908 69.953 145.992C70.177 146.076 70.4523 146.118 70.779 146.118C71.255 146.118 71.647 146.029 71.955 145.852C72.263 145.665 72.417 145.395 72.417 145.04C72.417 144.807 72.3517 144.62 72.221 144.48C72.0997 144.34 71.8757 144.214 71.549 144.102C71.2317 143.99 70.793 143.873 70.233 143.752C69.673 143.621 69.2297 143.463 68.903 143.276C68.5763 143.08 68.343 142.851 68.203 142.59C68.063 142.319 67.993 142.016 67.993 141.68C67.993 141.335 68.0957 141.003 68.301 140.686C68.5063 140.359 68.805 140.093 69.197 139.888C69.5983 139.683 70.0977 139.58 70.695 139.58C71.1803 139.58 71.5957 139.641 71.941 139.762C72.2863 139.883 72.571 140.037 72.795 140.224C73.019 140.401 73.187 140.579 73.299 140.756C73.411 140.933 73.4717 141.083 73.481 141.204C73.4903 141.297 73.4623 141.377 73.397 141.442C73.3317 141.498 73.257 141.526 73.173 141.526H72.585C72.5197 141.526 72.4637 141.512 72.417 141.484C72.3797 141.456 72.3423 141.423 72.305 141.386C72.2117 141.265 72.0997 141.143 71.969 141.022C71.8477 140.901 71.6843 140.803 71.479 140.728C71.283 140.644 71.0217 140.602 70.695 140.602C70.2283 140.602 69.8783 140.7 69.645 140.896C69.4117 141.092 69.295 141.339 69.295 141.638C69.295 141.815 69.3463 141.974 69.449 142.114C69.5517 142.254 69.7477 142.38 70.037 142.492C70.3263 142.604 70.7557 142.725 71.325 142.856C71.941 142.977 72.4263 143.141 72.781 143.346C73.1357 143.551 73.3877 143.789 73.537 144.06C73.6863 144.331 73.761 144.643 73.761 144.998C73.761 145.39 73.649 145.749 73.425 146.076C73.201 146.403 72.865 146.664 72.417 146.86C71.969 147.047 71.4183 147.14 70.765 147.14ZM78.21 147C77.6874 147 77.2627 146.902 76.936 146.706C76.6094 146.501 76.3714 146.216 76.222 145.852C76.0727 145.479 75.998 145.04 75.998 144.536V140.84H74.906C74.8127 140.84 74.7334 140.812 74.668 140.756C74.612 140.691 74.584 140.611 74.584 140.518V140.042C74.584 139.949 74.612 139.874 74.668 139.818C74.7334 139.753 74.8127 139.72 74.906 139.72H75.998V137.382C75.998 137.289 76.026 137.214 76.082 137.158C76.1474 137.093 76.2267 137.06 76.32 137.06H76.978C77.0714 137.06 77.146 137.093 77.202 137.158C77.2674 137.214 77.3 137.289 77.3 137.382V139.72H79.036C79.1387 139.72 79.218 139.753 79.274 139.818C79.33 139.874 79.358 139.949 79.358 140.042V140.518C79.358 140.611 79.33 140.691 79.274 140.756C79.218 140.812 79.1387 140.84 79.036 140.84H77.3V144.438C77.3 144.877 77.3747 145.222 77.524 145.474C77.6734 145.726 77.9394 145.852 78.322 145.852H79.176C79.2694 145.852 79.344 145.885 79.4 145.95C79.4654 146.006 79.498 146.081 79.498 146.174V146.678C79.498 146.771 79.4654 146.851 79.4 146.916C79.344 146.972 79.2694 147 79.176 147H78.21ZM84.5904 147C84.4971 147 84.4178 146.972 84.3524 146.916C84.2964 146.851 84.2684 146.771 84.2684 146.678V140.042C84.2684 139.949 84.2964 139.874 84.3524 139.818C84.4178 139.753 84.4971 139.72 84.5904 139.72H85.2204C85.3138 139.72 85.3884 139.753 85.4444 139.818C85.5098 139.874 85.5424 139.949 85.5424 140.042V140.532C85.7571 140.243 86.0278 140.014 86.3544 139.846C86.6811 139.669 87.0731 139.58 87.5304 139.58C88.5851 139.571 89.3318 140 89.7704 140.868C89.9851 140.476 90.2978 140.163 90.7084 139.93C91.1191 139.697 91.5858 139.58 92.1084 139.58C92.5938 139.58 93.0324 139.692 93.4244 139.916C93.8258 140.14 94.1384 140.481 94.3624 140.938C94.5958 141.386 94.7124 141.951 94.7124 142.632V146.678C94.7124 146.771 94.6798 146.851 94.6144 146.916C94.5584 146.972 94.4838 147 94.3904 147H93.7324C93.6391 147 93.5598 146.972 93.4944 146.916C93.4384 146.851 93.4104 146.771 93.4104 146.678V142.758C93.4104 142.235 93.3358 141.825 93.1864 141.526C93.0371 141.227 92.8364 141.017 92.5844 140.896C92.3324 140.775 92.0571 140.714 91.7584 140.714C91.5158 140.714 91.2684 140.775 91.0164 140.896C90.7644 141.017 90.5544 141.227 90.3864 141.526C90.2278 141.825 90.1484 142.235 90.1484 142.758V146.678C90.1484 146.771 90.1158 146.851 90.0504 146.916C89.9944 146.972 89.9198 147 89.8264 147H89.1684C89.0751 147 88.9958 146.972 88.9304 146.916C88.8744 146.851 88.8464 146.771 88.8464 146.678V142.758C88.8464 142.235 88.7671 141.825 88.6084 141.526C88.4498 141.227 88.2444 141.017 87.9924 140.896C87.7404 140.775 87.4744 140.714 87.1944 140.714C86.9518 140.714 86.7044 140.775 86.4524 140.896C86.2004 141.017 85.9904 141.227 85.8224 141.526C85.6638 141.825 85.5844 142.231 85.5844 142.744V146.678C85.5844 146.771 85.5518 146.851 85.4864 146.916C85.4304 146.972 85.3558 147 85.2624 147H84.5904ZM99.6918 147.14C98.9825 147.14 98.3898 147.005 97.9138 146.734C97.4378 146.463 97.0738 146.09 96.8218 145.614C96.5698 145.129 96.4298 144.578 96.4018 143.962C96.3925 143.803 96.3878 143.603 96.3878 143.36C96.3878 143.108 96.3925 142.907 96.4018 142.758C96.4298 142.133 96.5698 141.582 96.8218 141.106C97.0832 140.63 97.4518 140.257 97.9278 139.986C98.4038 139.715 98.9918 139.58 99.6918 139.58C100.392 139.58 100.98 139.715 101.456 139.986C101.932 140.257 102.296 140.63 102.548 141.106C102.809 141.582 102.954 142.133 102.982 142.758C102.991 142.907 102.996 143.108 102.996 143.36C102.996 143.603 102.991 143.803 102.982 143.962C102.954 144.578 102.814 145.129 102.562 145.614C102.31 146.09 101.946 146.463 101.47 146.734C100.994 147.005 100.401 147.14 99.6918 147.14ZM99.6918 146.062C100.27 146.062 100.732 145.88 101.078 145.516C101.423 145.143 101.61 144.601 101.638 143.892C101.647 143.752 101.652 143.575 101.652 143.36C101.652 143.145 101.647 142.968 101.638 142.828C101.61 142.119 101.423 141.582 101.078 141.218C100.732 140.845 100.27 140.658 99.6918 140.658C99.1132 140.658 98.6465 140.845 98.2918 141.218C97.9465 141.582 97.7645 142.119 97.7458 142.828C97.7365 142.968 97.7318 143.145 97.7318 143.36C97.7318 143.575 97.7365 143.752 97.7458 143.892C97.7645 144.601 97.9465 145.143 98.2918 145.516C98.6465 145.88 99.1132 146.062 99.6918 146.062ZM105.071 147C104.978 147 104.898 146.972 104.833 146.916C104.777 146.851 104.749 146.771 104.749 146.678V140.042C104.749 139.949 104.777 139.874 104.833 139.818C104.898 139.753 104.978 139.72 105.071 139.72H105.729C105.822 139.72 105.897 139.753 105.953 139.818C106.018 139.874 106.051 139.949 106.051 140.042V140.658C106.294 140.341 106.597 140.084 106.961 139.888C107.334 139.683 107.81 139.58 108.389 139.58C108.996 139.58 109.509 139.715 109.929 139.986C110.358 140.247 110.68 140.616 110.895 141.092C111.119 141.559 111.231 142.105 111.231 142.73V146.678C111.231 146.771 111.198 146.851 111.133 146.916C111.077 146.972 111.002 147 110.909 147H110.209C110.116 147 110.036 146.972 109.971 146.916C109.915 146.851 109.887 146.771 109.887 146.678V142.8C109.887 142.147 109.728 141.638 109.411 141.274C109.094 140.901 108.627 140.714 108.011 140.714C107.432 140.714 106.966 140.901 106.611 141.274C106.266 141.638 106.093 142.147 106.093 142.8V146.678C106.093 146.771 106.06 146.851 105.995 146.916C105.939 146.972 105.864 147 105.771 147H105.071ZM115.985 147C115.463 147 115.038 146.902 114.711 146.706C114.385 146.501 114.147 146.216 113.997 145.852C113.848 145.479 113.773 145.04 113.773 144.536V140.84H112.681C112.588 140.84 112.509 140.812 112.443 140.756C112.387 140.691 112.359 140.611 112.359 140.518V140.042C112.359 139.949 112.387 139.874 112.443 139.818C112.509 139.753 112.588 139.72 112.681 139.72H113.773V137.382C113.773 137.289 113.801 137.214 113.857 137.158C113.923 137.093 114.002 137.06 114.095 137.06H114.753C114.847 137.06 114.921 137.093 114.977 137.158C115.043 137.214 115.075 137.289 115.075 137.382V139.72H116.811C116.914 139.72 116.993 139.753 117.049 139.818C117.105 139.874 117.133 139.949 117.133 140.042V140.518C117.133 140.611 117.105 140.691 117.049 140.756C116.993 140.812 116.914 140.84 116.811 140.84H115.075V144.438C115.075 144.877 115.15 145.222 115.299 145.474C115.449 145.726 115.715 145.852 116.097 145.852H116.951C117.045 145.852 117.119 145.885 117.175 145.95C117.241 146.006 117.273 146.081 117.273 146.174V146.678C117.273 146.771 117.241 146.851 117.175 146.916C117.119 146.972 117.045 147 116.951 147H115.985ZM118.948 147C118.855 147 118.776 146.972 118.71 146.916C118.654 146.851 118.626 146.771 118.626 146.678V137.382C118.626 137.289 118.654 137.214 118.71 137.158C118.776 137.093 118.855 137.06 118.948 137.06H119.648C119.751 137.06 119.83 137.093 119.886 137.158C119.942 137.214 119.97 137.289 119.97 137.382V140.644C120.222 140.327 120.53 140.07 120.894 139.874C121.258 139.678 121.72 139.58 122.28 139.58C122.887 139.58 123.4 139.715 123.82 139.986C124.25 140.247 124.572 140.616 124.786 141.092C125.01 141.559 125.122 142.105 125.122 142.73V146.678C125.122 146.771 125.094 146.851 125.038 146.916C124.982 146.972 124.903 147 124.8 147H124.1C124.007 147 123.928 146.972 123.862 146.916C123.806 146.851 123.778 146.771 123.778 146.678V142.8C123.778 142.147 123.62 141.638 123.302 141.274C122.985 140.901 122.518 140.714 121.902 140.714C121.324 140.714 120.857 140.901 120.502 141.274C120.148 141.638 119.97 142.147 119.97 142.8V146.678C119.97 146.771 119.942 146.851 119.886 146.916C119.83 146.972 119.751 147 119.648 147H118.948Z" fill="#9EA1B1"/>
<rect x="153.75" y="49" width="25.3125" height="111" rx="4" fill="url(#paint0_linear_2788_35204)"/>
<rect x="187.062" y="56" width="25.3125" height="104" rx="4" fill="url(#paint1_linear_2788_35204)"/>
<rect x="220.375" y="101" width="25.3125" height="59" rx="4" fill="url(#paint2_linear_2788_35204)"/>
<rect x="253.688" y="86" width="25.3125" height="74" rx="4" fill="url(#paint3_linear_2788_35204)"/>
<defs>
<linearGradient id="paint0_linear_2788_35204" x1="166.406" y1="160" x2="166.406" y2="49" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint1_linear_2788_35204" x1="199.719" y1="160" x2="199.719" y2="50.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint2_linear_2788_35204" x1="233.031" y1="160" x2="233.031" y2="50.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
<linearGradient id="paint3_linear_2788_35204" x1="266.344" y1="160" x2="266.344" y2="55.5" gradientUnits="userSpaceOnUse">
<stop offset="0.08" stop-color="#0294F7"/>
<stop offset="0.92" stop-color="#D057FF"/>
</linearGradient>
</defs>
</svg>
`;
const $c49aa0f374b6c6e6$export$27d86da24a8a6ed6 = `<svg width="1210" height="176" viewBox="0 0 1210 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2553_40478)">
<rect width="1210" height="176" rx="8" transform="matrix(1 0 0 -1 0 176)" fill="url(#paint0_linear_2553_40478)"/>
<g opacity="0.75">
<path fill-rule="evenodd" clip-rule="evenodd" d="M803.88 42.7271C786.335 47.4283 775.923 65.4624 780.624 83.0075C785.326 100.553 803.36 110.965 820.905 106.263C838.45 101.562 848.862 83.528 844.161 65.983C839.459 48.438 821.425 38.026 803.88 42.7271ZM767.917 86.4124C761.335 61.8493 775.912 36.6015 800.475 30.0199C825.038 23.4382 850.286 38.0151 856.868 62.5781C863.449 87.1412 848.873 112.389 824.31 118.971C799.747 125.552 774.499 110.975 767.917 86.4124Z" fill="#0294F7"/>
<path d="M804.139 43.6931L805.105 43.4342L804.846 42.4683L801.441 29.7611L801.182 28.7951L800.216 29.054C775.12 35.7786 760.227 61.5747 766.951 86.6712C773.676 111.768 799.472 126.661 824.568 119.937L825.534 119.678L825.276 118.712L821.871 106.005L821.612 105.039L820.646 105.297C803.634 109.856 786.149 99.7602 781.59 82.7487C777.032 65.7371 787.127 48.2513 804.139 43.6931Z" fill="#D057FF" stroke="white" stroke-width="2"/>
<path d="M804.139 43.693L805.104 43.4342L804.846 42.4683L801.441 29.761L801.182 28.7951L800.216 29.0539C781.062 34.1864 767.867 50.4211 765.665 68.9533L765.547 69.9463L766.54 70.0643L779.603 71.6171L780.596 71.7351L780.714 70.7421C782.21 58.1559 791.174 47.1669 804.139 43.693Z" fill="#FC3DA6" stroke="white" stroke-width="2"/>
<path d="M970.281 48.5745C969.985 48.654 969.705 48.6177 969.442 48.4658C969.179 48.3138 969.008 48.0896 968.928 47.7931L961.17 18.8397C961.083 18.5135 961.115 18.2189 961.267 17.9557C961.419 17.6925 961.643 17.5212 961.939 17.4418L965.853 16.3931C966.179 16.3057 966.474 16.3379 966.737 16.4899C967 16.6418 967.176 16.8809 967.263 17.207L970.052 27.6143L977.231 14.2024C977.31 14.0224 977.459 13.8077 977.678 13.5583C977.919 13.2713 978.277 13.0642 978.751 12.9371L983.154 11.7573C983.391 11.6937 983.623 11.7271 983.848 11.8573C984.104 11.9796 984.267 12.1742 984.338 12.441C984.394 12.6486 984.382 12.8424 984.304 13.0224L975.672 29.7312L992.692 40.9489C992.888 41.0871 993.014 41.2599 993.069 41.4675C993.141 41.7343 993.097 41.9845 992.937 42.218C992.807 42.4436 992.623 42.5882 992.386 42.6517L987.805 43.8792C987.301 44.0142 986.873 44.0177 986.52 43.8896C986.19 43.7239 985.968 43.6085 985.856 43.5434L971.935 34.6414L975.021 46.1605C975.101 46.457 975.064 46.7368 974.912 47C974.76 47.2631 974.521 47.4384 974.195 47.5258L970.281 48.5745Z" fill="#00245B"/>
<path d="M952.169 53.9047C949.619 54.5879 947.298 54.7014 945.205 54.2452C943.105 53.7593 941.332 52.8361 939.887 51.4754C938.434 50.0851 937.433 48.367 936.885 46.3212C936.639 45.402 936.519 44.4807 936.526 43.5573C936.533 42.6339 936.626 41.7351 936.805 40.8609C936.983 39.9867 937.171 39.2055 937.368 38.5171C937.587 37.7912 937.797 37.2106 937.998 36.7753L943.146 23.4312C943.225 23.2512 943.355 23.0256 943.536 22.7545C943.71 22.4537 944.004 22.2477 944.419 22.1365L948.556 21.0282C948.823 20.9567 949.073 21.0009 949.306 21.1608C949.532 21.291 949.68 21.4896 949.752 21.7564C949.784 21.875 949.786 22.0016 949.758 22.136C949.752 22.2329 949.728 22.319 949.684 22.3942L945.77 32.6908C946.013 32.5303 946.308 32.3876 946.656 32.2626C947.004 32.1376 947.326 32.0354 947.623 31.956C949.113 31.5884 950.601 31.5075 952.086 31.7134C953.563 31.8895 954.933 32.317 956.196 32.9957C957.458 33.6744 958.542 34.5757 959.447 35.6997C960.381 36.8158 961.051 38.1299 961.456 39.6421C961.981 41.599 961.98 43.5535 961.454 45.5058C960.921 47.4284 959.87 49.14 958.302 50.6407C956.763 52.1334 954.719 53.2214 952.169 53.9047ZM950.754 48.8019C951.822 48.5159 952.74 48.0314 953.511 47.3483C954.311 46.6572 954.877 45.8063 955.21 44.7955C955.543 43.7847 955.539 42.6418 955.197 41.3668C954.863 40.1215 954.3 39.1444 953.506 38.4355C952.712 37.7266 951.796 37.2729 950.758 37.0745C949.749 36.8681 948.711 36.9078 947.644 37.1939C946.576 37.4799 945.643 37.9684 944.843 38.6594C944.072 39.3425 943.521 40.1895 943.188 41.2003C942.855 42.2111 942.855 43.3392 943.189 44.5845C943.53 45.8594 944.098 46.8514 944.892 47.5603C945.686 48.2692 946.587 48.7268 947.596 48.9332C948.634 49.1317 949.687 49.0879 950.754 48.8019Z" fill="#00245B"/>
<path d="M930.045 59.3564C929.749 59.4358 929.469 59.3996 929.206 59.2477C928.942 59.0957 928.771 58.8715 928.692 58.575L927.512 54.1719C927.424 53.8458 927.457 53.5511 927.609 53.288C927.761 53.0248 927.985 52.8535 928.281 52.774L932.729 51.5823C933.025 51.5029 933.305 51.5391 933.568 51.6911C933.831 51.843 934.007 52.0821 934.094 52.4082L935.274 56.8113C935.353 57.1078 935.317 57.3876 935.165 57.6508C935.013 57.9139 934.789 58.0852 934.493 58.1647L930.045 59.3564Z" fill="#00245B"/>
<path d="M901.841 66.9132C901.545 66.9926 901.265 66.9564 901.002 66.8044C900.739 66.6525 900.568 66.4283 900.488 66.1318L899.88 63.8635C899.809 63.5967 899.785 63.2694 899.808 62.8819C899.853 62.4567 900.061 61.9878 900.432 61.4753L905.588 52.6097C907.132 50.5435 908.354 48.8179 909.254 47.4327C910.176 46.0099 910.784 44.7822 911.079 43.7497C911.397 42.6796 911.436 41.6998 911.198 40.8103C910.84 39.476 910.179 38.4931 909.216 37.8615C908.282 37.222 907.029 37.1127 905.457 37.5338C904.42 37.8119 903.605 38.2686 903.012 38.9041C902.412 39.5098 901.999 40.2241 901.775 41.047C901.58 41.8619 901.524 42.7191 901.606 43.6187C901.65 44.02 901.558 44.3306 901.331 44.5503C901.104 44.7701 900.857 44.9157 900.59 44.9872L896.632 46.0478C896.365 46.1193 896.119 46.09 895.893 45.9597C895.668 45.8295 895.523 45.6458 895.46 45.4086C895.148 44.1257 895.085 42.8237 895.271 41.5026C895.449 40.1519 895.89 38.8898 896.592 37.7165C897.317 36.5055 898.3 35.4316 899.543 34.4948C900.785 33.5581 902.281 32.8553 904.031 32.3866C906.492 31.7272 908.634 31.5981 910.457 31.9993C912.311 32.3925 913.828 33.1935 915.01 34.4022C916.222 35.6029 917.066 37.0928 917.542 38.8718C917.916 40.2654 917.995 41.6267 917.779 42.9557C917.555 44.2551 917.086 45.5883 916.372 46.9555C915.65 48.2931 914.728 49.7158 913.606 51.2239L909.007 59.3206L921.683 55.9242C922.009 55.8368 922.289 55.8731 922.522 56.0329C922.777 56.1552 922.949 56.3795 923.036 56.7056L923.882 59.8634C923.962 60.1599 923.925 60.4397 923.773 60.7029C923.651 60.9581 923.427 61.1294 923.101 61.2168L901.841 66.9132Z" fill="#00245B"/>
<path d="M890.504 69.9509C890.178 70.0383 889.883 70.006 889.62 69.8541C889.387 69.6942 889.23 69.466 889.151 69.1695L882.978 46.1313L877.612 53.1463C877.392 53.3957 877.145 53.5413 876.871 53.5832C876.588 53.5954 876.307 53.4959 876.028 53.2846L873.517 51.3835C873.267 51.1643 873.117 50.9025 873.068 50.598C873.048 50.2856 873.147 50.0047 873.366 49.7553L881.267 39.3917C881.405 39.1958 881.559 39.0591 881.729 38.9818C881.899 38.9045 882.088 38.838 882.296 38.7824L886.209 37.7337C886.506 37.6543 886.786 37.6905 887.049 37.8424C887.312 37.9944 887.483 38.2186 887.563 38.5151L895.333 67.513C895.412 67.8095 895.376 68.0894 895.224 68.3525C895.072 68.6157 894.848 68.787 894.551 68.8665L890.504 69.9509Z" fill="#00245B"/>
<path d="M1096.52 13.4994C1095.69 13.7218 1094.95 13.8087 1094.3 13.76C1093.65 13.7114 1093.1 13.5885 1092.65 13.3913C1092.2 13.1941 1091.84 12.9731 1091.57 12.7282C1091.31 12.4794 1091.15 12.268 1091.09 12.094C1091.03 11.9349 1091.05 11.795 1091.14 11.6743C1091.24 11.5536 1091.34 11.4773 1091.46 11.4455L1092.46 11.1774C1092.54 11.1575 1092.6 11.1565 1092.65 11.1742C1092.72 11.1731 1092.81 11.2126 1092.92 11.2925C1093.17 11.4484 1093.44 11.5984 1093.73 11.7424C1094.03 11.8864 1094.36 11.9794 1094.74 12.0215C1095.13 12.0595 1095.58 12.0091 1096.1 11.87C1096.86 11.6675 1097.44 11.3598 1097.86 10.947C1098.27 10.5194 1098.4 10.0239 1098.25 9.46059C1098.15 9.08996 1097.96 8.82127 1097.7 8.6545C1097.44 8.48377 1097.04 8.37897 1096.47 8.3401C1095.92 8.29726 1095.17 8.29864 1094.23 8.34426C1093.28 8.37505 1092.51 8.31171 1091.91 8.15424C1091.31 7.98195 1090.84 7.71804 1090.51 7.36252C1090.17 6.99218 1089.93 6.54016 1089.79 6.00645C1089.64 5.45792 1089.66 4.88794 1089.86 4.29649C1090.04 3.69022 1090.4 3.14059 1090.94 2.64759C1091.49 2.15063 1092.24 1.77503 1093.19 1.5208C1093.96 1.31423 1094.64 1.23383 1095.24 1.27958C1095.84 1.32533 1096.36 1.44878 1096.8 1.64995C1097.23 1.83629 1097.57 2.04646 1097.82 2.28047C1098.08 2.51448 1098.24 2.72586 1098.3 2.91462C1098.36 3.05889 1098.35 3.19683 1098.27 3.32841C1098.19 3.44517 1098.09 3.52142 1097.95 3.55717L1097.02 3.80743C1096.91 3.83524 1096.82 3.83683 1096.73 3.81222C1096.66 3.78363 1096.59 3.74764 1096.51 3.70423C1096.31 3.55122 1096.08 3.40616 1095.83 3.26905C1095.58 3.12796 1095.28 3.04182 1094.92 3.01061C1094.57 2.9606 1094.14 3.00512 1093.62 3.14415C1092.88 3.34277 1092.37 3.6474 1092.08 4.05803C1091.79 4.46867 1091.71 4.91119 1091.84 5.38559C1091.92 5.66727 1092.06 5.89745 1092.29 6.07613C1092.51 6.25481 1092.87 6.37153 1093.38 6.42629C1093.89 6.48105 1094.62 6.49104 1095.58 6.45628C1096.61 6.38683 1097.45 6.4397 1098.1 6.61491C1098.75 6.79011 1099.26 7.0609 1099.61 7.42727C1099.96 7.79364 1100.21 8.2585 1100.36 8.82186C1100.53 9.44451 1100.51 10.0629 1100.29 10.6772C1100.07 11.2914 1099.65 11.8495 1099.02 12.3515C1098.39 12.8387 1097.55 13.2213 1096.52 13.4994Z" fill="#717385"/>
<path d="M1084.69 16.6669C1083.15 17.08 1081.8 16.9407 1080.65 16.2491C1079.49 15.5426 1078.65 14.3859 1078.12 12.7789C1078.06 12.5902 1077.98 12.3476 1077.9 12.051C1077.82 11.7397 1077.76 11.4857 1077.72 11.289C1077.5 10.2205 1077.5 9.23584 1077.72 8.33491C1077.93 7.41915 1078.35 6.647 1078.98 6.01845C1079.62 5.38593 1080.45 4.93461 1081.45 4.66449C1082.58 4.36259 1083.59 4.34754 1084.47 4.61936C1085.37 4.8872 1086.13 5.40483 1086.77 6.17226C1087.4 6.93969 1087.88 7.90899 1088.19 9.08018L1088.29 9.45822C1088.34 9.6213 1088.32 9.76121 1088.24 9.87797C1088.17 9.99075 1088.07 10.067 1087.92 10.1067L1080.22 12.1684C1080.23 12.1832 1080.24 12.2129 1080.25 12.2573C1080.26 12.3018 1080.27 12.3389 1080.28 12.3685C1080.47 12.9684 1080.76 13.5034 1081.14 13.9736C1081.51 14.4289 1081.97 14.7601 1082.5 14.967C1083.05 15.17 1083.62 15.1901 1084.23 15.0272C1084.76 14.8842 1085.19 14.6835 1085.5 14.4251C1085.81 14.1667 1086.05 13.9113 1086.22 13.659C1086.39 13.3919 1086.5 13.1891 1086.54 13.0506C1086.62 12.837 1086.7 12.7054 1086.77 12.6559C1086.83 12.5915 1086.94 12.5375 1087.1 12.4938L1088.19 12.2019C1088.33 12.1661 1088.45 12.1808 1088.56 12.2459C1088.69 12.2922 1088.76 12.3915 1088.78 12.5437C1088.83 12.7701 1088.78 13.0761 1088.65 13.4619C1088.51 13.8328 1088.28 14.2295 1087.94 14.6521C1087.63 15.0706 1087.19 15.4651 1086.64 15.8356C1086.1 16.1872 1085.45 16.4643 1084.69 16.6669ZM1079.81 10.634L1085.91 9.00135L1085.89 8.93463C1085.71 8.2675 1085.42 7.70827 1085.03 7.25692C1084.66 6.8016 1084.2 6.48726 1083.66 6.3139C1083.12 6.12571 1082.53 6.11703 1081.89 6.28784C1081.25 6.45865 1080.74 6.76129 1080.37 7.19576C1080 7.61144 1079.77 8.11049 1079.67 8.69293C1079.58 9.27537 1079.62 9.90015 1079.79 10.5673L1079.81 10.634Z" fill="#717385"/>
<path d="M1075.14 18.9897C1074.99 19.0294 1074.85 19.0187 1074.72 18.9576C1074.61 18.8776 1074.53 18.7635 1074.49 18.6153L1071.66 8.07462C1071.62 7.92637 1071.64 7.79585 1071.7 7.68307C1071.78 7.55149 1071.89 7.46583 1072.04 7.42611L1073.11 7.1401C1073.25 7.10037 1073.39 7.12048 1073.5 7.20042C1073.63 7.26157 1073.71 7.36627 1073.75 7.51452L1076.58 18.0552C1076.62 18.2034 1076.6 18.3433 1076.52 18.4749C1076.46 18.5877 1076.35 18.664 1076.2 18.7037L1075.14 18.9897ZM1071.28 5.31672C1071.13 5.35645 1071 5.34574 1070.87 5.28459C1070.75 5.20465 1070.67 5.09055 1070.63 4.9423L1070.31 3.74147C1070.27 3.59322 1070.28 3.45529 1070.34 3.32768C1070.42 3.19609 1070.53 3.11044 1070.68 3.07072L1072.08 2.69533C1072.23 2.6556 1072.37 2.67373 1072.5 2.7497C1072.63 2.82567 1072.72 2.93777 1072.76 3.08603L1073.08 4.28686C1073.12 4.43511 1073.1 4.57503 1073.03 4.70661C1072.95 4.82337 1072.83 4.90161 1072.68 4.94133L1071.28 5.31672Z" fill="#717385"/>
<path d="M1070.45 20.2445C1069.62 20.467 1068.91 20.492 1068.3 20.3197C1067.7 20.1326 1067.2 19.7818 1066.81 19.2671C1066.41 18.7377 1066.1 18.0727 1065.89 17.2721L1064.32 11.4014L1062.58 11.8661C1062.43 11.9059 1062.3 11.8952 1062.17 11.834C1062.05 11.7541 1061.97 11.64 1061.93 11.4917L1061.73 10.7356C1061.69 10.5874 1061.7 10.4569 1061.77 10.3441C1061.85 10.2125 1061.96 10.1269 1062.11 10.0871L1063.84 9.62237L1062.84 5.90867C1062.81 5.76042 1062.82 5.62991 1062.88 5.51712C1062.96 5.38554 1063.07 5.29989 1063.22 5.26016L1064.26 4.98011C1064.41 4.94038 1064.55 4.96049 1064.66 5.04044C1064.79 5.10158 1064.87 5.20628 1064.91 5.35453L1065.91 9.06822L1068.67 8.32936C1068.83 8.28566 1068.97 8.30379 1069.09 8.38373C1069.2 8.44884 1069.27 8.55553 1069.31 8.70378L1069.52 9.45986C1069.56 9.60811 1069.55 9.74604 1069.48 9.87365C1069.42 9.98644 1069.31 10.0647 1069.14 10.1084L1066.38 10.8472L1067.92 16.5623C1068.1 17.2591 1068.37 17.7758 1068.71 18.1126C1069.06 18.4493 1069.53 18.5362 1070.14 18.3733L1071.5 18.0099C1071.65 17.9702 1071.78 17.9903 1071.9 18.0702C1072.02 18.1313 1072.11 18.236 1072.15 18.3843L1072.36 19.1849C1072.4 19.3331 1072.38 19.473 1072.31 19.6046C1072.24 19.7174 1072.13 19.7936 1071.99 19.8334L1070.45 20.2445Z" fill="#717385"/>
<path d="M1061.06 22.7605C1060.92 22.8002 1060.78 22.7895 1060.65 22.7283C1060.53 22.6484 1060.46 22.5343 1060.42 22.386L1057.59 11.8454C1057.55 11.6971 1057.56 11.5666 1057.63 11.4538C1057.71 11.3222 1057.82 11.2366 1057.97 11.1969L1059.03 10.9108C1059.18 10.8711 1059.31 10.8912 1059.43 10.9712C1059.56 11.0323 1059.64 11.137 1059.68 11.2853L1062.51 21.8259C1062.55 21.9742 1062.53 22.1141 1062.45 22.2457C1062.39 22.3585 1062.28 22.4347 1062.13 22.4744L1061.06 22.7605ZM1057.21 9.08747C1057.06 9.1272 1056.92 9.11649 1056.8 9.05534C1056.68 8.9754 1056.6 8.86131 1056.56 8.71305L1056.24 7.51222C1056.2 7.36397 1056.21 7.22604 1056.27 7.09843C1056.35 6.96685 1056.46 6.88119 1056.61 6.84147L1058.01 6.46608C1058.16 6.42636 1058.3 6.44448 1058.43 6.52045C1058.56 6.59642 1058.65 6.70853 1058.69 6.85678L1059.01 8.05761C1059.05 8.20586 1059.03 8.34578 1058.95 8.47736C1058.87 8.59412 1058.76 8.67236 1058.61 8.71208L1057.21 9.08747Z" fill="#717385"/>
<path d="M1056.38 24.015C1055.55 24.2375 1054.83 24.2625 1054.23 24.0903C1053.62 23.9031 1053.13 23.5523 1052.73 23.0376C1052.34 22.5082 1052.03 21.8432 1051.82 21.0426L1050.24 15.1719L1048.51 15.6367C1048.36 15.6764 1048.22 15.6657 1048.1 15.6045C1047.98 15.5246 1047.9 15.4105 1047.86 15.2622L1047.66 14.5062C1047.62 14.3579 1047.63 14.2274 1047.7 14.1146C1047.77 13.983 1047.88 13.8974 1048.03 13.8576L1049.77 13.3929L1048.77 9.67918C1048.73 9.53093 1048.75 9.40041 1048.81 9.28763C1048.89 9.15605 1049 9.07039 1049.15 9.03067L1050.19 8.75062C1050.34 8.71089 1050.47 8.731 1050.59 8.81094C1050.72 8.87209 1050.8 8.97679 1050.84 9.12504L1051.84 12.8387L1054.59 12.0999C1054.76 12.0562 1054.9 12.0743 1055.01 12.1542C1055.13 12.2194 1055.2 12.326 1055.24 12.4743L1055.44 13.2304C1055.48 13.3786 1055.47 13.5166 1055.41 13.6442C1055.35 13.7569 1055.23 13.8352 1055.07 13.8789L1052.31 14.6177L1053.84 20.3328C1054.03 21.0296 1054.3 21.5464 1054.64 21.8831C1054.99 22.2198 1055.46 22.3067 1056.07 22.1439L1057.43 21.7804C1057.57 21.7407 1057.71 21.7608 1057.82 21.8407C1057.95 21.9019 1058.03 22.0066 1058.07 22.1548L1058.29 22.9554C1058.33 23.1036 1058.31 23.2435 1058.23 23.3751C1058.17 23.4879 1058.06 23.5641 1057.91 23.6039L1056.38 24.015Z" fill="#717385"/>
<path d="M1039.04 28.6609C1038.89 28.7006 1038.76 28.6899 1038.63 28.6288C1038.51 28.5488 1038.43 28.4347 1038.39 28.2865L1035.57 17.7458C1035.53 17.5976 1035.54 17.467 1035.61 17.3543C1035.68 17.2227 1035.8 17.137 1035.94 17.0973L1036.99 16.8172C1037.14 16.7775 1037.27 16.7976 1037.39 16.8776C1037.51 16.9387 1037.6 17.0434 1037.64 17.1917L1037.9 18.1701C1038.15 17.5628 1038.52 17.026 1039.02 16.5597C1039.52 16.0747 1040.24 15.709 1041.15 15.4627C1042.12 15.2045 1042.99 15.201 1043.77 15.4522C1044.57 15.6846 1045.24 16.1331 1045.78 16.7978C1046.33 17.4437 1046.74 18.2633 1047.01 19.2566L1048.69 25.5277C1048.73 25.6759 1048.71 25.8158 1048.64 25.9474C1048.57 26.0602 1048.46 26.1364 1048.32 26.1762L1047.2 26.4741C1047.06 26.5138 1046.92 26.5031 1046.79 26.442C1046.67 26.362 1046.59 26.2479 1046.56 26.0997L1044.9 19.9398C1044.63 18.9021 1044.16 18.1616 1043.5 17.7185C1042.84 17.2606 1042.02 17.1627 1041.04 17.4249C1040.12 17.6712 1039.46 18.1663 1039.05 18.9102C1038.66 19.6354 1038.6 20.5168 1038.88 21.5546L1040.53 27.7144C1040.57 27.8627 1040.55 28.0026 1040.47 28.1342C1040.41 28.247 1040.3 28.3232 1040.15 28.363L1039.04 28.6609Z" fill="#717385"/>
<path d="M1030.77 31.1151C1029.23 31.5282 1027.88 31.389 1026.73 30.6973C1025.57 29.9908 1024.73 28.8341 1024.2 27.2272C1024.13 27.0384 1024.06 26.7958 1023.98 26.4993C1023.9 26.188 1023.84 25.9339 1023.8 25.7373C1023.58 24.6688 1023.58 23.6841 1023.8 22.7831C1024.01 21.8674 1024.43 21.0952 1025.06 20.4667C1025.7 19.8342 1026.52 19.3829 1027.53 19.1127C1028.66 18.8108 1029.66 18.7958 1030.55 19.0676C1031.45 19.3354 1032.21 19.8531 1032.85 20.6205C1033.48 21.3879 1033.95 22.3572 1034.27 23.5284L1034.37 23.9065C1034.41 24.0695 1034.4 24.2095 1034.32 24.3262C1034.25 24.439 1034.14 24.5152 1034 24.555L1026.3 26.6166C1026.31 26.6315 1026.31 26.6611 1026.33 26.7056C1026.34 26.7501 1026.35 26.7871 1026.36 26.8168C1026.55 27.4167 1026.83 27.9517 1027.21 28.4218C1027.59 28.8771 1028.04 29.2083 1028.58 29.4153C1029.12 29.6183 1029.7 29.6384 1030.31 29.4755C1030.84 29.3325 1031.27 29.1318 1031.58 28.8734C1031.89 28.6149 1032.13 28.3596 1032.3 28.1073C1032.47 27.8401 1032.57 27.6373 1032.62 27.4989C1032.7 27.2852 1032.78 27.1536 1032.84 27.1041C1032.91 27.0398 1033.02 26.9858 1033.18 26.9421L1034.27 26.6501C1034.4 26.6144 1034.53 26.629 1034.64 26.6942C1034.76 26.7405 1034.84 26.8397 1034.86 26.992C1034.91 27.2183 1034.86 27.5244 1034.73 27.9101C1034.59 28.281 1034.35 28.6777 1034.02 29.1003C1033.7 29.5189 1033.27 29.9134 1032.72 30.2838C1032.18 30.6354 1031.53 30.9125 1030.77 31.1151ZM1025.89 25.0822L1031.98 23.4496L1031.97 23.3829C1031.79 22.7157 1031.5 22.1565 1031.11 21.7052C1030.73 21.2498 1030.28 20.9355 1029.74 20.7621C1029.19 20.574 1028.6 20.5653 1027.97 20.7361C1027.33 20.9069 1026.82 21.2095 1026.45 21.644C1026.08 22.0597 1025.85 22.5587 1025.75 23.1412C1025.65 23.7236 1025.69 24.3484 1025.87 25.0155L1025.89 25.0822Z" fill="#717385"/>
<path d="M1017.15 34.7658C1016.33 34.9843 1015.59 35.0321 1014.92 34.9093C1014.25 34.7717 1013.65 34.5099 1013.14 34.124C1012.63 33.7193 1012.2 33.224 1011.83 32.6381C1011.49 32.0483 1011.2 31.4016 1010.98 30.6979C1010.9 30.4647 1010.84 30.2443 1010.78 30.0367C1010.72 29.8292 1010.67 29.6048 1010.62 29.3637C1010.47 28.6589 1010.39 27.964 1010.4 27.2788C1010.42 26.5897 1010.55 25.9435 1010.78 25.3401C1011.04 24.7328 1011.42 24.2088 1011.94 23.7683C1012.45 23.3129 1013.11 22.9759 1013.93 22.7574C1014.8 22.5231 1015.57 22.4841 1016.23 22.6405C1016.9 22.7969 1017.47 23.0552 1017.97 23.4155L1016.6 18.3008C1016.56 18.1526 1016.57 18.0221 1016.64 17.9093C1016.71 17.7777 1016.82 17.692 1016.97 17.6523L1018.04 17.3663C1018.19 17.3266 1018.32 17.3467 1018.44 17.4266C1018.56 17.4878 1018.65 17.5925 1018.69 17.7407L1022.64 32.5065C1022.68 32.6548 1022.67 32.7947 1022.59 32.9263C1022.52 33.0391 1022.42 33.1153 1022.27 33.1551L1021.27 33.4232C1021.11 33.4669 1020.97 33.4562 1020.85 33.3911C1020.74 33.3111 1020.66 33.197 1020.62 33.0488L1020.37 32.1148C1020.13 32.6885 1019.75 33.2179 1019.25 33.7029C1018.74 34.1732 1018.04 34.5274 1017.15 34.7658ZM1017.13 32.8394C1017.87 32.6408 1018.42 32.3114 1018.77 31.8512C1019.13 31.3911 1019.35 30.8718 1019.43 30.2933C1019.51 29.7 1019.48 29.1271 1019.35 28.5746C1019.3 28.3335 1019.23 28.0498 1019.15 27.7236C1019.05 27.3827 1018.97 27.0956 1018.89 26.8623C1018.74 26.3474 1018.47 25.8697 1018.1 25.4292C1017.74 24.9848 1017.29 24.661 1016.75 24.458C1016.21 24.251 1015.59 24.2429 1014.88 24.4336C1014.12 24.6361 1013.57 24.9675 1013.22 25.4277C1012.86 25.873 1012.66 26.3957 1012.61 26.9959C1012.56 27.5813 1012.6 28.1892 1012.74 28.8198C1012.84 29.2537 1012.96 29.6837 1013.09 30.1096C1013.28 30.7243 1013.55 31.2801 1013.89 31.777C1014.23 32.2591 1014.66 32.611 1015.2 32.8328C1015.73 33.0398 1016.38 33.042 1017.13 32.8394Z" fill="#717385"/>
<path d="M1007.58 37.0907C1007.42 37.1344 1007.28 37.1237 1007.17 37.0586C1007.05 36.9786 1006.97 36.8645 1006.93 36.7163L1003.04 22.1728C1003 22.0246 1003.01 21.8941 1003.08 21.7813C1003.14 21.6537 1003.25 21.568 1003.41 21.5243L1004.59 21.2085C1004.75 21.1648 1004.89 21.183 1005.01 21.2629C1005.12 21.328 1005.2 21.4347 1005.24 21.5829L1009.14 36.1264C1009.18 36.2746 1009.16 36.4126 1009.1 36.5402C1009.04 36.653 1008.92 36.7312 1008.76 36.7749L1007.58 37.0907Z" fill="#717385"/>
<rect x="788.399" y="162.854" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 788.399 162.854)" fill="#0294F7"/>
<path d="M914.968 158.054C914.835 158.09 914.703 158.07 914.571 157.994C914.439 157.918 914.356 157.813 914.32 157.679L914.111 156.901C914.072 156.753 914.082 156.615 914.144 156.487C914.223 156.371 914.323 156.296 914.441 156.265C915.06 156.083 915.535 155.781 915.867 155.358C916.213 154.932 916.423 154.351 916.497 153.616C916.57 152.882 916.521 151.957 916.349 150.843C916.174 149.715 915.874 148.357 915.449 146.771C915.024 145.184 914.607 143.866 914.198 142.816C913.786 141.75 913.364 140.918 912.933 140.318C912.503 139.719 912.032 139.328 911.523 139.147C911.025 138.947 910.462 138.923 909.835 139.075C909.717 139.107 909.592 139.084 909.46 139.009C909.343 138.929 909.267 138.822 909.231 138.688L909.023 137.91C908.987 137.777 909.007 137.644 909.083 137.513C909.159 137.381 909.264 137.297 909.397 137.262C910.361 137.003 911.23 136.985 912.004 137.207C912.779 137.428 913.479 137.908 914.106 138.646C914.743 139.365 915.328 140.36 915.859 141.632C916.391 142.903 916.899 144.444 917.383 146.252C917.868 148.061 918.198 149.649 918.374 151.016C918.546 152.368 918.537 153.523 918.348 154.479C918.175 155.431 917.808 156.197 917.248 156.776C916.692 157.37 915.932 157.796 914.968 158.054Z" fill="#717385"/>
<path d="M898.484 158.681C898.173 158.765 897.977 158.658 897.898 158.362C897.874 158.273 897.882 158.183 897.921 158.093L905.034 140.695C905.102 140.534 905.17 140.404 905.239 140.306C905.323 140.204 905.462 140.128 905.654 140.076L906.388 139.879C906.699 139.796 906.895 139.903 906.974 140.199C906.998 140.288 906.99 140.377 906.951 140.467L899.861 157.86C899.793 158.021 899.717 158.152 899.633 158.254C899.564 158.352 899.425 158.429 899.218 158.485L898.484 158.681ZM908.705 156.086C907.741 156.344 906.904 156.274 906.194 155.877C905.498 155.475 905.002 154.837 904.704 153.964C904.586 153.582 904.491 153.258 904.42 152.991C904.344 152.71 904.258 152.359 904.162 151.94C903.983 151.035 904.079 150.238 904.451 149.551C904.834 148.844 905.537 148.354 906.56 148.08C907.597 147.802 908.451 147.875 909.121 148.3C909.802 148.705 910.291 149.345 910.588 150.218C910.729 150.625 910.837 150.97 910.913 151.251C910.984 151.518 911.057 151.848 911.131 152.242C911.31 153.147 911.191 153.95 910.775 154.649C910.373 155.345 909.683 155.824 908.705 156.086ZM908.311 154.618C908.712 154.511 909.001 154.346 909.18 154.123C909.359 153.9 909.468 153.657 909.508 153.392C909.544 153.112 909.536 152.844 909.483 152.588C909.406 152.18 909.335 151.857 909.272 151.62C909.208 151.383 909.114 151.09 908.989 150.742C908.867 150.346 908.642 150.009 908.313 149.732C907.984 149.454 907.531 149.393 906.953 149.548C906.389 149.699 906.035 149.977 905.889 150.381C905.758 150.782 905.731 151.186 905.809 151.594C905.889 151.954 905.961 152.252 906.025 152.49C906.089 152.727 906.181 153.044 906.303 153.44C906.401 153.684 906.528 153.92 906.684 154.148C906.851 154.358 907.068 154.514 907.334 154.618C907.615 154.717 907.941 154.717 908.311 154.618ZM898.272 150.42C897.294 150.682 896.461 150.627 895.773 150.255C895.086 149.883 894.593 149.261 894.296 148.387C894.178 148.005 894.083 147.681 894.011 147.414C893.936 147.133 893.85 146.782 893.753 146.363C893.56 145.462 893.656 144.665 894.043 143.974C894.425 143.268 895.128 142.777 896.151 142.503C897.189 142.225 898.043 142.298 898.713 142.723C899.393 143.128 899.875 143.77 900.158 144.647C900.299 145.054 900.407 145.399 900.482 145.681C900.554 145.947 900.626 146.277 900.7 146.671C900.894 147.572 900.779 148.358 900.354 149.028C899.945 149.694 899.251 150.158 898.272 150.42ZM897.903 149.041C898.288 148.938 898.571 148.775 898.749 148.552C898.943 148.326 899.06 148.08 899.1 147.815C899.136 147.535 899.128 147.267 899.075 147.011C898.998 146.603 898.929 146.287 898.869 146.065C898.806 145.828 898.71 145.528 898.581 145.165C898.458 144.769 898.226 144.434 897.882 144.161C897.554 143.883 897.108 143.82 896.544 143.971C895.981 144.122 895.627 144.4 895.481 144.804C895.35 145.205 895.323 145.609 895.401 146.017C895.485 146.392 895.559 146.698 895.623 146.935C895.682 147.157 895.773 147.467 895.895 147.863C895.992 148.107 896.119 148.343 896.276 148.571C896.443 148.781 896.66 148.937 896.926 149.041C897.192 149.144 897.518 149.144 897.903 149.041Z" fill="#717385"/>
<path d="M889.054 161.447C888.031 161.721 887.122 161.797 886.327 161.677C885.542 161.537 884.852 161.245 884.257 160.801C883.661 160.357 883.162 159.8 882.76 159.129C882.373 158.454 882.055 157.713 881.807 156.905C881.685 156.509 881.557 156.091 881.423 155.65C881.303 155.205 881.182 154.753 881.059 154.293C880.951 153.83 880.848 153.388 880.752 152.969C880.548 152.15 880.453 151.349 880.466 150.567C880.494 149.781 880.656 149.054 880.954 148.387C881.248 147.704 881.702 147.114 882.315 146.616C882.939 146.099 883.755 145.706 884.763 145.435C885.786 145.161 886.69 145.094 887.474 145.233C888.269 145.354 888.964 145.637 889.56 146.081C890.152 146.51 890.649 147.06 891.051 147.731C891.468 148.398 891.793 149.137 892.027 149.948C892.153 150.359 892.277 150.795 892.4 151.254C892.538 151.71 892.659 152.162 892.764 152.611C892.883 153.056 892.989 153.48 893.081 153.884C893.285 154.704 893.373 155.506 893.345 156.292C893.332 157.075 893.179 157.807 892.885 158.489C892.606 159.168 892.154 159.766 891.53 160.282C890.917 160.78 890.091 161.168 889.054 161.447ZM888.541 159.534C889.697 159.224 890.449 158.618 890.795 157.715C891.155 156.808 891.166 155.692 890.828 154.369C890.742 153.931 890.646 153.512 890.538 153.112C890.427 152.697 890.318 152.289 890.211 151.889C890.099 151.474 889.975 151.07 889.838 150.678C889.478 149.392 888.913 148.439 888.143 147.819C887.384 147.18 886.426 147.016 885.27 147.326C884.128 147.631 883.381 148.253 883.028 149.189C882.686 150.107 882.673 151.215 882.989 152.513C883.097 152.913 883.198 153.323 883.295 153.742C883.402 154.142 883.511 154.55 883.623 154.965C883.745 155.361 883.863 155.774 883.978 156.204C884.362 157.516 884.936 158.474 885.702 159.079C886.468 159.684 887.414 159.836 888.541 159.534Z" fill="#717385"/>
<path d="M875.293 165.134C874.122 165.447 873.075 165.513 872.152 165.332C871.24 165.131 870.482 164.762 869.877 164.225C869.288 163.684 868.88 163.054 868.656 162.336C868.606 162.206 868.615 162.092 868.684 161.995C868.749 161.882 868.848 161.807 868.982 161.772L870.183 161.45C870.316 161.414 870.444 161.419 870.568 161.466C870.688 161.497 870.803 161.601 870.914 161.778C871.209 162.287 871.568 162.676 871.989 162.944C872.421 163.194 872.874 163.342 873.348 163.39C873.833 163.419 874.312 163.37 874.786 163.243C875.424 163.073 875.968 162.792 876.42 162.401C876.882 161.991 877.201 161.492 877.377 160.905C877.55 160.302 877.538 159.638 877.344 158.911C877.165 158.244 876.856 157.715 876.418 157.324C875.99 156.914 875.476 156.655 874.875 156.546C874.284 156.418 873.663 156.442 873.011 156.616C872.522 156.748 872.137 156.914 871.858 157.116C871.578 157.318 871.349 157.531 871.17 157.753C871.006 157.972 870.851 158.164 870.705 158.331C870.574 158.493 870.405 158.602 870.197 158.657L869.041 158.967C868.907 159.003 868.777 158.99 868.649 158.929C868.517 158.853 868.441 158.747 868.42 158.609L867.142 150.991C867.109 150.809 867.125 150.662 867.19 150.549C867.266 150.418 867.386 150.33 867.549 150.286L875.31 148.207C875.458 148.167 875.59 148.187 875.707 148.267C875.835 148.328 875.918 148.433 875.958 148.581L876.191 149.448C876.234 149.611 876.216 149.751 876.136 149.868C876.071 149.981 875.964 150.057 875.816 150.097L869.412 151.813L870.163 156.307C870.35 156.114 870.642 155.869 871.039 155.572C871.447 155.256 872.051 154.991 872.851 154.776C873.593 154.578 874.312 154.504 875.009 154.556C875.721 154.603 876.379 154.777 876.983 155.075C877.603 155.37 878.136 155.791 878.585 156.338C879.029 156.871 879.359 157.537 879.574 158.338C879.875 159.465 879.887 160.486 879.608 161.403C879.33 162.32 878.816 163.101 878.067 163.747C877.315 164.377 876.39 164.84 875.293 165.134Z" fill="#717385"/>
<path d="M868.927 170.391C867.964 170.649 867.093 170.66 866.314 170.423C865.54 170.202 864.839 169.722 864.213 168.984C863.586 168.247 863.001 167.251 862.459 165.998C861.928 164.727 861.42 163.186 860.935 161.378C860.45 159.569 860.12 157.981 859.945 156.614C859.784 155.243 859.792 154.089 859.97 153.151C860.144 152.199 860.511 151.433 861.071 150.854C861.631 150.275 862.392 149.857 863.356 149.598C863.504 149.559 863.637 149.579 863.753 149.659C863.885 149.735 863.969 149.839 864.004 149.973L864.213 150.751C864.249 150.885 864.229 151.017 864.153 151.149C864.092 151.276 864.009 151.354 863.905 151.382C863.287 151.563 862.804 151.868 862.458 152.294C862.122 152.702 861.91 153.275 861.822 154.014C861.749 154.748 861.8 155.68 861.975 156.809C862.161 157.919 862.467 159.267 862.892 160.853C863.317 162.44 863.728 163.767 864.126 164.837C864.535 165.887 864.954 166.712 865.385 167.312C865.831 167.907 866.303 168.305 866.801 168.505C867.315 168.701 867.885 168.723 868.511 168.571C868.615 168.544 868.723 168.562 868.836 168.627C868.968 168.703 869.053 168.816 869.093 168.964L869.302 169.742C869.337 169.876 869.317 170.008 869.241 170.14C869.18 170.267 869.075 170.351 868.927 170.391Z" fill="#717385"/>
<path d="M844.796 173.067C844.648 173.107 844.508 173.089 844.377 173.013C844.245 172.937 844.16 172.824 844.12 172.676L840.241 158.199C840.197 158.036 840.213 157.889 840.289 157.758C840.365 157.626 840.477 157.54 840.626 157.501L842.582 156.976C842.745 156.932 842.893 156.949 843.024 157.025C843.156 157.101 843.244 157.22 843.287 157.383L844.682 162.587L848.271 155.881C848.311 155.791 848.385 155.684 848.495 155.559C848.615 155.415 848.794 155.312 849.031 155.248L851.233 154.658C851.351 154.627 851.467 154.643 851.58 154.708C851.708 154.769 851.789 154.867 851.825 155C851.853 155.104 851.847 155.201 851.808 155.291L847.492 163.645L856.002 169.254C856.1 169.323 856.163 169.41 856.19 169.513C856.226 169.647 856.204 169.772 856.124 169.889C856.059 170.001 855.967 170.074 855.849 170.106L853.558 170.719C853.306 170.787 853.092 170.789 852.916 170.724C852.751 170.642 852.64 170.584 852.584 170.551L845.623 166.1L847.166 171.86C847.206 172.008 847.188 172.148 847.112 172.28C847.036 172.411 846.916 172.499 846.753 172.543L844.796 173.067Z" fill="#212328"/>
<path d="M835.496 175.797C834.458 176.075 833.527 176.189 832.704 176.14C831.88 176.09 831.162 175.933 830.551 175.668C829.951 175.384 829.461 175.038 829.082 174.632C828.699 174.21 828.436 173.764 828.294 173.293C828.258 173.16 828.275 173.044 828.344 172.946C828.424 172.83 828.531 172.753 828.664 172.718L830.666 172.181C830.814 172.142 830.948 172.137 831.067 172.169C831.187 172.2 831.308 172.295 831.43 172.453C831.67 172.818 831.971 173.079 832.331 173.237C832.706 173.39 833.107 173.466 833.535 173.462C833.959 173.444 834.394 173.375 834.839 173.256C835.728 173.018 836.377 172.621 836.784 172.067C837.203 171.494 837.307 170.815 837.096 170.029C836.886 169.243 836.49 168.746 835.91 168.536C835.325 168.311 834.595 168.316 833.721 168.55L831.43 169.164C831.267 169.208 831.122 169.199 830.994 169.138C830.863 169.062 830.775 168.942 830.731 168.779L830.481 167.845C830.441 167.697 830.437 167.563 830.469 167.443C830.511 167.305 830.559 167.189 830.614 167.095L833.551 162.137L827.191 163.841C827.028 163.884 826.881 163.868 826.749 163.792C826.633 163.712 826.554 163.598 826.515 163.45L826.121 161.982C826.078 161.819 826.086 161.674 826.148 161.546C826.224 161.415 826.343 161.327 826.506 161.283L836.046 158.727C836.209 158.683 836.356 158.7 836.488 158.776C836.62 158.852 836.707 158.971 836.751 159.134L837.109 160.468C837.144 160.602 837.146 160.728 837.115 160.848C837.083 160.968 837.041 161.074 836.986 161.168L834.2 166.158L834.473 166.108C835.397 165.94 836.253 165.933 837.041 166.087C837.84 166.223 838.518 166.558 839.074 167.092C839.645 167.622 840.06 168.369 840.318 169.333C840.588 170.341 840.554 171.28 840.215 172.149C839.886 173 839.314 173.741 838.498 174.373C837.683 175.004 836.682 175.479 835.496 175.797Z" fill="#212328"/>
<path d="M824.438 178.522C824.29 178.561 824.15 178.543 824.018 178.467C823.887 178.391 823.801 178.279 823.761 178.131L823.171 175.929C823.128 175.766 823.144 175.619 823.22 175.487C823.296 175.356 823.408 175.27 823.556 175.231L825.78 174.635C825.928 174.595 826.068 174.613 826.2 174.689C826.331 174.765 826.419 174.885 826.463 175.048L827.052 177.249C827.092 177.397 827.074 177.537 826.998 177.669C826.922 177.8 826.81 177.886 826.662 177.926L824.438 178.522Z" fill="#212328"/>
<path d="M815.783 181.079C814.508 181.421 813.347 181.478 812.301 181.25C811.251 181.007 810.364 180.545 809.642 179.865C808.915 179.17 808.415 178.31 808.141 177.288C808.018 176.828 807.958 176.367 807.961 175.906C807.965 175.444 808.011 174.995 808.101 174.557C808.19 174.12 808.284 173.73 808.382 173.386C808.492 173.023 808.597 172.732 808.697 172.515L811.271 165.843C811.311 165.753 811.376 165.64 811.466 165.504C811.553 165.354 811.7 165.251 811.908 165.195L813.976 164.641C814.11 164.605 814.235 164.627 814.351 164.707C814.464 164.772 814.538 164.872 814.574 165.005C814.59 165.064 814.591 165.128 814.577 165.195C814.574 165.243 814.562 165.286 814.54 165.324L812.583 170.472C812.705 170.392 812.852 170.321 813.026 170.258C813.2 170.196 813.361 170.145 813.51 170.105C814.255 169.921 814.999 169.881 815.741 169.984C816.48 170.072 817.165 170.285 817.796 170.625C818.427 170.964 818.969 171.415 819.421 171.977C819.889 172.535 820.224 173.192 820.426 173.948C820.689 174.926 820.688 175.904 820.425 176.88C820.159 177.841 819.633 178.697 818.849 179.447C818.08 180.194 817.058 180.738 815.783 181.079ZM815.075 178.528C815.609 178.385 816.068 178.143 816.454 177.801C816.854 177.456 817.137 177.03 817.303 176.525C817.47 176.019 817.468 175.448 817.297 174.81C817.13 174.188 816.848 173.699 816.451 173.345C816.054 172.99 815.596 172.763 815.077 172.664C814.573 172.561 814.054 172.581 813.52 172.724C812.986 172.867 812.52 173.111 812.12 173.457C811.734 173.798 811.459 174.222 811.292 174.727C811.126 175.233 811.126 175.797 811.293 176.419C811.463 177.057 811.747 177.553 812.144 177.907C812.541 178.262 812.992 178.49 813.496 178.594C814.015 178.693 814.542 178.671 815.075 178.528Z" fill="#212328"/>
<rect x="941.284" y="121.889" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 941.284 121.889)" fill="#D057FF"/>
<path d="M1062.14 118.619C1062.01 118.655 1061.88 118.634 1061.74 118.558C1061.61 118.483 1061.53 118.378 1061.49 118.244L1061.28 117.466C1061.24 117.318 1061.26 117.18 1061.32 117.052C1061.4 116.936 1061.5 116.861 1061.61 116.829C1062.23 116.648 1062.71 116.346 1063.04 115.923C1063.39 115.497 1063.6 114.916 1063.67 114.181C1063.74 113.447 1063.69 112.522 1063.52 111.408C1063.35 110.28 1063.05 108.922 1062.62 107.336C1062.2 105.749 1061.78 104.431 1061.37 103.381C1060.96 102.315 1060.54 101.483 1060.11 100.883C1059.68 100.284 1059.21 99.8932 1058.7 99.7119C1058.2 99.5118 1057.63 99.4877 1057.01 99.6397C1056.89 99.6715 1056.76 99.6494 1056.63 99.5735C1056.52 99.4935 1056.44 99.3868 1056.4 99.2534L1056.2 98.4751C1056.16 98.3417 1056.18 98.2092 1056.26 98.0776C1056.33 97.946 1056.44 97.8623 1056.57 97.8266C1057.53 97.5684 1058.4 97.55 1059.18 97.7716C1059.95 97.9931 1060.65 98.4727 1061.28 99.2105C1061.92 99.9295 1062.5 100.925 1063.03 102.197C1063.56 103.468 1064.07 105.009 1064.56 106.817C1065.04 108.626 1065.37 110.214 1065.55 111.581C1065.72 112.933 1065.71 114.087 1065.52 115.044C1065.35 115.996 1064.98 116.762 1064.42 117.341C1063.86 117.935 1063.1 118.361 1062.14 118.619Z" fill="#717385"/>
<path d="M1045.65 119.247C1045.34 119.33 1045.15 119.224 1045.07 118.927C1045.04 118.838 1045.05 118.749 1045.09 118.659L1052.2 101.261C1052.27 101.099 1052.34 100.97 1052.41 100.872C1052.49 100.77 1052.63 100.693 1052.83 100.641L1053.56 100.445C1053.87 100.361 1054.07 100.468 1054.15 100.764C1054.17 100.853 1054.16 100.943 1054.12 101.033L1047.03 118.425C1046.96 118.586 1046.89 118.718 1046.8 118.82C1046.73 118.918 1046.6 118.994 1046.39 119.05L1045.65 119.247ZM1055.88 116.651C1054.91 116.909 1054.07 116.84 1053.36 116.442C1052.67 116.04 1052.17 115.403 1051.87 114.529C1051.76 114.148 1051.66 113.824 1051.59 113.557C1051.51 113.275 1051.43 112.925 1051.33 112.506C1051.15 111.6 1051.25 110.804 1051.62 110.116C1052 109.41 1052.71 108.92 1053.73 108.646C1054.77 108.367 1055.62 108.441 1056.29 108.865C1056.97 109.27 1057.46 109.91 1057.76 110.784C1057.9 111.191 1058.01 111.535 1058.08 111.817C1058.16 112.084 1058.23 112.414 1058.3 112.807C1058.48 113.713 1058.36 114.515 1057.95 115.215C1057.54 115.91 1056.85 116.389 1055.88 116.651ZM1055.48 115.183C1055.88 115.076 1056.17 114.911 1056.35 114.689C1056.53 114.466 1056.64 114.222 1056.68 113.957C1056.72 113.677 1056.71 113.409 1056.65 113.153C1056.58 112.745 1056.51 112.422 1056.44 112.185C1056.38 111.948 1056.28 111.655 1056.16 111.308C1056.04 110.911 1055.81 110.574 1055.48 110.297C1055.16 110.02 1054.7 109.958 1054.12 110.113C1053.56 110.264 1053.21 110.542 1053.06 110.946C1052.93 111.347 1052.9 111.751 1052.98 112.16C1053.06 112.519 1053.13 112.818 1053.2 113.055C1053.26 113.292 1053.35 113.609 1053.47 114.005C1053.57 114.249 1053.7 114.486 1053.85 114.714C1054.02 114.923 1054.24 115.08 1054.5 115.183C1054.79 115.283 1055.11 115.283 1055.48 115.183ZM1045.44 110.985C1044.46 111.247 1043.63 111.193 1042.94 110.821C1042.26 110.449 1041.76 109.826 1041.47 108.952C1041.35 108.571 1041.25 108.247 1041.18 107.98C1041.11 107.698 1041.02 107.348 1040.92 106.929C1040.73 106.027 1040.83 105.231 1041.21 104.539C1041.6 103.833 1042.3 103.343 1043.32 103.069C1044.36 102.791 1045.21 102.864 1045.88 103.288C1046.56 103.694 1047.05 104.335 1047.33 105.213C1047.47 105.62 1047.58 105.964 1047.65 106.246C1047.72 106.513 1047.8 106.843 1047.87 107.236C1048.06 108.138 1047.95 108.923 1047.53 109.593C1047.12 110.259 1046.42 110.723 1045.44 110.985ZM1045.07 109.607C1045.46 109.503 1045.74 109.34 1045.92 109.118C1046.11 108.891 1046.23 108.645 1046.27 108.38C1046.31 108.1 1046.3 107.832 1046.25 107.576C1046.17 107.168 1046.1 106.853 1046.04 106.63C1045.98 106.393 1045.88 106.093 1045.75 105.731C1045.63 105.334 1045.4 104.999 1045.05 104.726C1044.72 104.449 1044.28 104.385 1043.72 104.536C1043.15 104.687 1042.8 104.965 1042.65 105.37C1042.52 105.77 1042.49 106.174 1042.57 106.583C1042.66 106.957 1042.73 107.263 1042.79 107.5C1042.85 107.723 1042.94 108.032 1043.07 108.428C1043.16 108.673 1043.29 108.909 1043.45 109.137C1043.61 109.346 1043.83 109.503 1044.1 109.606C1044.36 109.71 1044.69 109.71 1045.07 109.607Z" fill="#717385"/>
<path d="M1039.86 120.8C1039.71 120.84 1039.57 120.829 1039.45 120.768C1039.33 120.688 1039.25 120.574 1039.21 120.426L1035.87 107.973L1032.95 111.808C1032.85 111.929 1032.73 112 1032.6 112.021C1032.46 112.041 1032.33 112.005 1032.21 111.91L1031.43 111.331C1031.31 111.221 1031.24 111.098 1031.22 110.96C1031.21 110.819 1031.25 110.688 1031.35 110.567L1035.2 105.532C1035.28 105.43 1035.36 105.36 1035.45 105.321C1035.53 105.283 1035.63 105.25 1035.73 105.222L1036.87 104.918C1037.01 104.878 1037.15 104.898 1037.26 104.978C1037.39 105.039 1037.48 105.144 1037.52 105.292L1041.41 119.836C1041.45 119.984 1041.43 120.124 1041.36 120.255C1041.29 120.368 1041.19 120.445 1041.04 120.484L1039.86 120.8Z" fill="#717385"/>
<path d="M1027.44 124.366C1026.51 124.616 1025.66 124.723 1024.91 124.687C1024.15 124.637 1023.48 124.482 1022.9 124.224C1022.32 123.966 1021.84 123.641 1021.47 123.249C1021.11 122.838 1020.85 122.397 1020.71 121.927C1020.67 121.793 1020.69 121.678 1020.76 121.58C1020.83 121.467 1020.92 121.393 1021.06 121.357L1022.15 121.065C1022.28 121.029 1022.41 121.034 1022.53 121.081C1022.67 121.108 1022.79 121.21 1022.9 121.387C1023.19 121.881 1023.56 122.229 1023.99 122.43C1024.44 122.627 1024.92 122.721 1025.43 122.713C1025.94 122.686 1026.45 122.606 1026.93 122.475C1027.96 122.201 1028.72 121.734 1029.23 121.074C1029.74 120.414 1029.86 119.61 1029.61 118.661C1029.35 117.697 1028.87 117.085 1028.19 116.825C1027.5 116.565 1026.64 116.572 1025.62 116.846L1023.5 117.412C1023.36 117.452 1023.22 117.441 1023.09 117.38C1022.98 117.315 1022.9 117.201 1022.86 117.038L1022.7 116.437C1022.66 116.304 1022.65 116.187 1022.67 116.086C1022.7 115.966 1022.74 115.861 1022.78 115.771L1025.83 109.901L1019.27 111.659C1019.12 111.698 1018.98 111.688 1018.86 111.627C1018.74 111.561 1018.66 111.447 1018.62 111.284L1018.39 110.439C1018.35 110.276 1018.36 110.138 1018.43 110.025C1018.5 109.894 1018.61 109.808 1018.76 109.768L1027.64 107.391C1027.8 107.347 1027.94 107.365 1028.06 107.445C1028.18 107.507 1028.27 107.619 1028.31 107.782L1028.53 108.582C1028.55 108.686 1028.55 108.79 1028.52 108.895C1028.49 108.981 1028.46 109.069 1028.42 109.159L1025.41 115.09L1025.77 115.017C1026.76 114.785 1027.66 114.734 1028.47 114.866C1029.3 114.993 1030 115.33 1030.58 115.875C1031.16 116.401 1031.59 117.153 1031.85 118.132C1032.11 119.125 1032.1 120.036 1031.79 120.863C1031.49 121.691 1030.96 122.413 1030.21 123.029C1029.46 123.626 1028.54 124.072 1027.44 124.366Z" fill="#717385"/>
<path d="M1020.64 129.739C1019.68 129.998 1018.8 130.009 1018.03 129.772C1017.25 129.551 1016.55 129.071 1015.92 128.333C1015.3 127.596 1014.71 126.6 1014.17 125.347C1013.64 124.075 1013.13 122.535 1012.65 120.727C1012.16 118.918 1011.83 117.33 1011.66 115.963C1011.5 114.592 1011.5 113.438 1011.68 112.5C1011.86 111.548 1012.22 110.782 1012.78 110.203C1013.34 109.624 1014.1 109.205 1015.07 108.947C1015.22 108.908 1015.35 108.928 1015.47 109.008C1015.6 109.084 1015.68 109.188 1015.72 109.322L1015.92 110.1C1015.96 110.233 1015.94 110.366 1015.86 110.498C1015.8 110.625 1015.72 110.703 1015.62 110.731C1015 110.912 1014.52 111.216 1014.17 111.643C1013.83 112.051 1013.62 112.624 1013.53 113.362C1013.46 114.097 1013.51 115.029 1013.69 116.158C1013.87 117.268 1014.18 118.616 1014.6 120.202C1015.03 121.788 1015.44 123.116 1015.84 124.186C1016.25 125.236 1016.67 126.061 1017.1 126.661C1017.54 127.256 1018.01 127.654 1018.51 127.854C1019.03 128.05 1019.6 128.072 1020.22 127.92C1020.33 127.893 1020.44 127.911 1020.55 127.976C1020.68 128.052 1020.77 128.164 1020.81 128.313L1021.01 129.091C1021.05 129.224 1021.03 129.357 1020.95 129.488C1020.89 129.616 1020.79 129.7 1020.64 129.739Z" fill="#717385"/>
<path d="M996.508 132.416C996.36 132.455 996.22 132.437 996.089 132.361C995.957 132.285 995.871 132.173 995.832 132.025L991.953 117.548C991.909 117.385 991.925 117.238 992.001 117.106C992.077 116.975 992.189 116.889 992.337 116.849L994.294 116.325C994.457 116.281 994.605 116.297 994.736 116.373C994.868 116.449 994.956 116.569 994.999 116.732L996.394 121.935L999.983 115.23C1000.02 115.139 1000.1 115.032 1000.21 114.907C1000.33 114.764 1000.51 114.66 1000.74 114.597L1002.94 114.007C1003.06 113.975 1003.18 113.992 1003.29 114.057C1003.42 114.118 1003.5 114.215 1003.54 114.349C1003.56 114.453 1003.56 114.549 1003.52 114.639L999.204 122.994L1007.71 128.603C1007.81 128.672 1007.87 128.758 1007.9 128.862C1007.94 128.995 1007.92 129.121 1007.84 129.237C1007.77 129.35 1007.68 129.422 1007.56 129.454L1005.27 130.068C1005.02 130.135 1004.8 130.137 1004.63 130.073C1004.46 129.99 1004.35 129.933 1004.3 129.9L997.335 125.449L998.878 131.209C998.918 131.357 998.9 131.497 998.824 131.628C998.748 131.76 998.628 131.848 998.465 131.891L996.508 132.416Z" fill="#212328"/>
<path d="M984.605 135.605C984.472 135.64 984.349 135.626 984.236 135.561C984.119 135.481 984.043 135.374 984.007 135.24C983.987 135.166 983.979 135.105 983.982 135.057C983.999 135.004 984.012 134.961 984.018 134.928L986.078 129.537C985.816 129.687 985.52 129.798 985.19 129.871C984.43 130.058 983.688 130.106 982.964 130.014C982.251 129.903 981.589 129.684 980.976 129.355C980.375 129.008 979.852 128.568 979.407 128.036C978.973 127.485 978.659 126.846 978.465 126.119C978.286 125.452 978.237 124.766 978.318 124.061C978.395 123.341 978.609 122.656 978.959 122.006C979.324 121.352 979.838 120.778 980.5 120.283C981.172 119.769 982.013 119.377 983.021 119.107C984.014 118.841 984.926 118.747 985.758 118.826C986.59 118.905 987.325 119.129 987.964 119.498C988.614 119.848 989.15 120.309 989.573 120.879C990.011 121.444 990.325 122.083 990.516 122.795C990.687 123.432 990.742 124.053 990.681 124.657C990.621 125.261 990.496 125.835 990.308 126.378C990.131 126.902 989.951 127.419 989.77 127.928L987.31 134.403C987.271 134.493 987.208 134.613 987.121 134.764C987.045 134.895 986.896 134.991 986.673 135.05L984.605 135.605ZM985.248 127.329C985.781 127.186 986.233 126.945 986.604 126.608C986.985 126.252 987.246 125.832 987.387 125.349C987.538 124.848 987.537 124.308 987.382 123.73C987.223 123.137 986.954 122.669 986.576 122.325C986.209 121.963 985.773 121.73 985.269 121.627C984.761 121.509 984.247 121.519 983.728 121.658C983.195 121.801 982.737 122.051 982.356 122.407C981.986 122.745 981.725 123.164 981.573 123.666C981.432 124.148 981.441 124.686 981.6 125.279C981.755 125.857 982.016 126.328 982.383 126.69C982.761 127.034 983.197 127.266 983.691 127.388C984.195 127.492 984.714 127.472 985.248 127.329Z" fill="#212328"/>
<path d="M977.388 137.539C977.24 137.579 977.1 137.56 976.968 137.484C976.837 137.408 976.751 137.296 976.712 137.148L976.122 134.947C976.078 134.783 976.094 134.636 976.17 134.505C976.246 134.373 976.358 134.287 976.506 134.248L978.73 133.652C978.878 133.612 979.018 133.63 979.15 133.706C979.281 133.782 979.369 133.902 979.413 134.065L980.003 136.266C980.042 136.414 980.024 136.554 979.948 136.686C979.872 136.818 979.76 136.903 979.612 136.943L977.388 137.539Z" fill="#212328"/>
<path d="M968.489 140.162C967.451 140.44 966.52 140.554 965.697 140.505C964.873 140.455 964.156 140.298 963.544 140.033C962.944 139.749 962.454 139.403 962.075 138.997C961.692 138.575 961.429 138.129 961.287 137.658C961.252 137.525 961.268 137.409 961.337 137.311C961.417 137.195 961.524 137.118 961.657 137.083L963.659 136.546C963.807 136.507 963.941 136.502 964.061 136.534C964.18 136.565 964.301 136.66 964.423 136.818C964.664 137.183 964.964 137.444 965.324 137.602C965.699 137.755 966.1 137.831 966.528 137.827C966.953 137.809 967.387 137.74 967.832 137.621C968.721 137.383 969.37 136.986 969.777 136.432C970.196 135.859 970.3 135.18 970.089 134.394C969.879 133.608 969.483 133.111 968.903 132.901C968.318 132.676 967.589 132.681 966.714 132.915L964.423 133.529C964.26 133.573 964.115 133.564 963.987 133.503C963.856 133.427 963.768 133.307 963.724 133.144L963.474 132.21C963.434 132.062 963.43 131.928 963.462 131.808C963.504 131.67 963.552 131.554 963.607 131.46L966.545 126.502L960.185 128.206C960.021 128.249 959.874 128.233 959.743 128.157C959.626 128.077 959.548 127.963 959.508 127.815L959.115 126.347C959.071 126.184 959.08 126.039 959.141 125.911C959.217 125.78 959.336 125.692 959.499 125.648L969.039 123.092C969.202 123.048 969.35 123.065 969.481 123.141C969.613 123.217 969.7 123.336 969.744 123.499L970.102 124.833C970.137 124.967 970.14 125.093 970.108 125.213C970.077 125.333 970.034 125.439 969.979 125.533L967.193 130.523L967.466 130.473C968.39 130.305 969.246 130.298 970.034 130.452C970.833 130.588 971.511 130.923 972.067 131.457C972.638 131.987 973.053 132.734 973.311 133.698C973.581 134.706 973.547 135.645 973.208 136.514C972.879 137.365 972.307 138.106 971.492 138.738C970.676 139.369 969.675 139.844 968.489 140.162Z" fill="#212328"/>
<path d="M1043.06 155.693C1042.93 155.728 1042.81 155.718 1042.7 155.665C1042.6 155.595 1042.53 155.495 1042.49 155.365L1039.03 142.445C1039 142.315 1039.01 142.201 1039.07 142.102C1039.13 141.987 1039.23 141.912 1039.36 141.878L1040.28 141.633C1040.42 141.594 1040.54 141.61 1040.64 141.68C1040.74 141.737 1040.81 141.83 1040.84 141.96L1044.3 154.88C1044.34 155.01 1044.33 155.131 1044.28 155.242C1044.22 155.341 1044.12 155.41 1043.98 155.448L1043.06 155.693Z" fill="#A800E0"/>
<path d="M1034.73 158.133C1034.09 158.307 1033.46 158.336 1032.86 158.219C1032.26 158.102 1031.74 157.866 1031.29 157.512C1030.85 157.158 1030.55 156.702 1030.41 156.144C1030.17 155.249 1030.34 154.438 1030.92 153.712C1031.51 152.985 1032.36 152.381 1033.48 151.9L1036.27 150.714L1036.12 150.15C1035.95 149.527 1035.64 149.09 1035.18 148.837C1034.74 148.58 1034.11 148.56 1033.31 148.775C1032.74 148.928 1032.3 149.17 1032 149.501C1031.7 149.832 1031.53 150.198 1031.48 150.599C1031.46 150.815 1031.35 150.949 1031.15 151.001L1030.28 151.235C1030.14 151.274 1030.02 151.264 1029.92 151.207C1029.83 151.134 1029.77 151.039 1029.74 150.922C1029.68 150.727 1029.69 150.468 1029.76 150.145C1029.84 149.818 1029.99 149.476 1030.23 149.12C1030.47 148.764 1030.81 148.431 1031.24 148.121C1031.68 147.795 1032.25 147.537 1032.95 147.35C1033.73 147.141 1034.41 147.069 1035 147.134C1035.58 147.187 1036.07 147.341 1036.46 147.599C1036.86 147.852 1037.18 148.176 1037.43 148.569C1037.68 148.959 1037.87 149.375 1037.99 149.816L1039.68 156.12C1039.71 156.25 1039.7 156.372 1039.63 156.487C1039.57 156.586 1039.48 156.653 1039.35 156.687L1038.46 156.927C1038.31 156.966 1038.19 156.956 1038.09 156.899C1037.99 156.829 1037.92 156.729 1037.89 156.6L1037.66 155.763C1037.56 156.042 1037.39 156.336 1037.17 156.646C1036.95 156.943 1036.64 157.227 1036.25 157.497C1035.86 157.754 1035.36 157.967 1034.73 158.133ZM1034.75 156.565C1035.28 156.422 1035.74 156.181 1036.12 155.843C1036.5 155.491 1036.75 155.042 1036.87 154.496C1037 153.947 1036.97 153.309 1036.77 152.582L1036.62 152.037L1034.46 152.973C1033.57 153.35 1032.94 153.756 1032.55 154.193C1032.16 154.616 1032.03 155.061 1032.16 155.528C1032.26 155.891 1032.44 156.168 1032.72 156.359C1033 156.534 1033.32 156.636 1033.67 156.666C1034.04 156.692 1034.4 156.658 1034.75 156.565Z" fill="#A800E0"/>
<path d="M1020.51 161.736C1020.38 161.771 1020.26 161.762 1020.15 161.708C1020.04 161.638 1019.98 161.538 1019.94 161.409L1017.47 152.186C1017.43 152.056 1017.45 151.942 1017.5 151.843C1017.57 151.728 1017.67 151.653 1017.8 151.618L1018.71 151.373C1018.84 151.338 1018.96 151.356 1019.06 151.426C1019.17 151.479 1019.24 151.571 1019.28 151.701L1019.51 152.557C1019.73 152.025 1020.05 151.556 1020.49 151.148C1020.93 150.723 1021.55 150.403 1022.36 150.188C1023.2 149.962 1023.96 149.959 1024.65 150.179C1025.34 150.382 1025.93 150.774 1026.4 151.356C1026.89 151.921 1027.25 152.638 1027.48 153.508L1028.95 158.995C1028.98 159.124 1028.97 159.247 1028.9 159.362C1028.84 159.461 1028.75 159.527 1028.62 159.562L1027.65 159.823C1027.52 159.858 1027.4 159.848 1027.29 159.795C1027.18 159.725 1027.12 159.625 1027.08 159.495L1025.64 154.105C1025.39 153.197 1024.98 152.549 1024.41 152.162C1023.83 151.761 1023.11 151.675 1022.25 151.905C1021.45 152.12 1020.87 152.553 1020.52 153.204C1020.17 153.839 1020.12 154.61 1020.36 155.518L1021.81 160.908C1021.84 161.038 1021.83 161.16 1021.76 161.275C1021.7 161.374 1021.61 161.441 1021.48 161.476L1020.51 161.736Z" fill="#A800E0"/>
<path d="M1013.12 163.717C1012.99 163.751 1012.87 163.742 1012.75 163.689C1012.65 163.619 1012.58 163.519 1012.55 163.389L1010.08 154.185C1010.05 154.056 1010.06 153.935 1010.11 153.823C1010.18 153.708 1010.27 153.633 1010.4 153.599L1011.3 153.359C1011.43 153.324 1011.55 153.34 1011.67 153.406C1011.78 153.473 1011.86 153.571 1011.89 153.701L1012.12 154.557C1012.26 154.046 1012.53 153.62 1012.93 153.278C1013.32 152.935 1013.84 152.677 1014.49 152.504L1015.25 152.3C1015.38 152.266 1015.5 152.283 1015.6 152.353C1015.71 152.407 1015.78 152.498 1015.82 152.628L1016.03 153.426C1016.07 153.555 1016.05 153.671 1015.98 153.774C1015.92 153.872 1015.83 153.939 1015.7 153.974L1014.53 154.287C1013.83 154.474 1013.33 154.83 1013.04 155.352C1012.75 155.862 1012.7 156.467 1012.88 157.168L1014.42 162.889C1014.45 163.018 1014.44 163.141 1014.37 163.256C1014.3 163.358 1014.2 163.427 1014.07 163.461L1013.12 163.717Z" fill="#A800E0"/>
<path d="M1005.88 165.865C1004.53 166.226 1003.35 166.104 1002.34 165.499C1001.33 164.881 1000.59 163.869 1000.13 162.463C1000.07 162.298 1000.01 162.085 999.937 161.826C999.864 161.554 999.811 161.331 999.779 161.159C999.584 160.224 999.583 159.363 999.775 158.574C999.963 157.773 1000.33 157.097 1000.88 156.547C1001.44 155.994 1002.16 155.599 1003.04 155.363C1004.03 155.099 1004.91 155.085 1005.68 155.323C1006.47 155.558 1007.14 156.01 1007.69 156.682C1008.25 157.353 1008.66 158.202 1008.94 159.226L1009.03 159.557C1009.06 159.7 1009.05 159.822 1008.98 159.924C1008.92 160.023 1008.83 160.09 1008.7 160.125L1001.97 161.929C1001.97 161.942 1001.98 161.968 1001.99 162.006C1002 162.045 1002.01 162.078 1002.01 162.104C1002.18 162.629 1002.43 163.097 1002.77 163.508C1003.09 163.907 1003.49 164.196 1003.96 164.377C1004.44 164.555 1004.94 164.573 1005.47 164.43C1005.94 164.305 1006.31 164.129 1006.58 163.903C1006.86 163.677 1007.07 163.454 1007.22 163.233C1007.36 162.999 1007.45 162.822 1007.49 162.701C1007.57 162.514 1007.63 162.398 1007.69 162.355C1007.75 162.299 1007.84 162.252 1007.99 162.213L1008.94 161.958C1009.06 161.927 1009.16 161.939 1009.26 161.996C1009.37 162.037 1009.44 162.124 1009.46 162.257C1009.5 162.455 1009.46 162.723 1009.34 163.06C1009.22 163.385 1009.01 163.732 1008.72 164.102C1008.44 164.468 1008.06 164.813 1007.58 165.137C1007.11 165.445 1006.54 165.688 1005.88 165.865ZM1001.61 160.586L1006.94 159.157L1006.92 159.099C1006.77 158.515 1006.52 158.026 1006.17 157.631C1005.85 157.233 1005.45 156.958 1004.97 156.806C1004.5 156.641 1003.98 156.634 1003.42 156.783C1002.87 156.933 1002.42 157.197 1002.09 157.578C1001.77 157.941 1001.57 158.378 1001.49 158.888C1001.4 159.397 1001.43 159.944 1001.59 160.528L1001.61 160.586Z" fill="#A800E0"/>
<path d="M998.13 167.733C997.404 167.927 996.777 167.949 996.25 167.798C995.719 167.635 995.283 167.328 994.939 166.877C994.593 166.414 994.326 165.832 994.138 165.132L992.762 159.995L991.244 160.402C991.114 160.436 990.994 160.427 990.882 160.373C990.78 160.303 990.711 160.204 990.676 160.074L990.499 159.412C990.464 159.283 990.476 159.168 990.533 159.07C990.599 158.955 990.697 158.88 990.827 158.845L992.345 158.438L991.474 155.189C991.439 155.059 991.45 154.945 991.507 154.846C991.574 154.731 991.672 154.656 991.801 154.621L992.716 154.376C992.846 154.342 992.962 154.359 993.064 154.429C993.175 154.483 993.249 154.574 993.283 154.704L994.154 157.953L996.567 157.307C996.71 157.269 996.832 157.284 996.934 157.354C997.033 157.411 997.1 157.505 997.134 157.634L997.312 158.296C997.346 158.426 997.337 158.546 997.284 158.658C997.227 158.757 997.127 158.825 996.984 158.864L994.571 159.51L995.911 164.511C996.075 165.12 996.307 165.573 996.608 165.867C996.91 166.162 997.326 166.238 997.858 166.095L999.045 165.777C999.175 165.743 999.291 165.76 999.393 165.83C999.505 165.884 999.578 165.975 999.613 166.105L999.8 166.805C999.835 166.935 999.819 167.058 999.753 167.173C999.696 167.271 999.602 167.338 999.473 167.373L998.13 167.733Z" fill="#A800E0"/>
<path d="M983.224 171.726C983.12 171.754 983.013 171.741 982.901 171.688C982.802 171.631 982.737 171.544 982.706 171.427C982.696 171.388 982.69 171.341 982.689 171.286C982.698 171.214 982.717 171.132 982.749 171.041L984.951 165.716L980.658 162.383C980.585 162.319 980.529 162.264 980.489 162.219C980.462 162.171 980.442 162.121 980.428 162.069C980.397 161.952 980.41 161.845 980.467 161.746C980.524 161.647 980.61 161.582 980.727 161.551L981.72 161.285C981.862 161.247 981.983 161.256 982.082 161.313C982.177 161.357 982.253 161.406 982.309 161.461L985.799 164.134L987.49 160.093C987.524 160.015 987.564 159.928 987.608 159.832C987.665 159.734 987.764 159.665 987.907 159.627L988.861 159.372C988.977 159.34 989.085 159.353 989.184 159.41C989.282 159.467 989.347 159.554 989.379 159.671C989.393 159.723 989.394 159.778 989.381 159.837C989.382 159.892 989.367 159.966 989.336 160.057L987.257 165.14L991.816 168.611C991.889 168.675 991.938 168.731 991.965 168.779C992.005 168.824 992.032 168.873 992.046 168.925C992.077 169.041 992.064 169.149 992.007 169.248C991.95 169.347 991.864 169.412 991.747 169.443L990.716 169.719C990.586 169.754 990.473 169.749 990.378 169.705C990.283 169.661 990.201 169.614 990.131 169.563L986.453 166.732L984.644 171.033C984.606 171.099 984.559 171.181 984.502 171.28C984.454 171.362 984.359 171.422 984.217 171.461L983.224 171.726Z" fill="#A800E0"/>
<path d="M972.59 174.576C972.448 174.614 972.327 174.605 972.228 174.548C972.126 174.478 972.058 174.378 972.023 174.248L968.618 161.542C968.58 161.399 968.589 161.279 968.646 161.18C968.7 161.068 968.798 160.994 968.941 160.955L976.977 158.802C977.12 158.764 977.242 158.78 977.344 158.85C977.443 158.907 977.511 159.006 977.549 159.149L977.748 159.888C977.786 160.031 977.776 160.152 977.72 160.251C977.663 160.349 977.563 160.418 977.42 160.456L970.804 162.229L971.946 166.49L978.134 164.832C978.276 164.794 978.399 164.81 978.501 164.88C978.6 164.936 978.668 165.036 978.706 165.179L978.899 165.899C978.934 166.029 978.925 166.149 978.871 166.261C978.814 166.36 978.714 166.428 978.572 166.466L972.384 168.124L973.568 172.541L980.339 170.727C980.482 170.689 980.602 170.698 980.701 170.755C980.8 170.812 980.868 170.912 980.906 171.055L981.11 171.813C981.144 171.943 981.135 172.064 981.082 172.175C981.025 172.274 980.925 172.343 980.782 172.381L972.59 174.576Z" fill="#A800E0"/>
<rect x="1094.17" y="80.9241" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 1094.17 80.9241)" fill="#FC3DA6"/>
<path d="M1215.48 77.5317C1215.35 77.5674 1215.22 77.5473 1215.08 77.4713C1214.95 77.3953 1214.87 77.2907 1214.83 77.1572L1214.63 76.3789C1214.59 76.2307 1214.6 76.0927 1214.66 75.9651C1214.74 75.8484 1214.84 75.7741 1214.96 75.7423C1215.57 75.5606 1216.05 75.2585 1216.38 74.836C1216.73 74.4095 1216.94 73.8289 1217.01 73.0942C1217.08 72.3595 1217.03 71.4352 1216.86 70.3212C1216.69 69.1924 1216.39 67.8348 1215.96 66.2485C1215.54 64.6622 1215.12 63.3438 1214.71 62.2934C1214.3 61.2281 1213.88 60.3957 1213.45 59.7961C1213.02 59.1965 1212.55 58.806 1212.04 58.6247C1211.54 58.4246 1210.98 58.4006 1210.35 58.5526C1210.23 58.5844 1210.11 58.5623 1209.97 58.4863C1209.86 58.4064 1209.78 58.2997 1209.75 58.1662L1209.54 57.3879C1209.5 57.2545 1209.52 57.122 1209.6 56.9904C1209.67 56.8588 1209.78 56.7752 1209.91 56.7394C1210.87 56.4812 1211.74 56.4629 1212.52 56.6844C1213.29 56.9059 1213.99 57.3856 1214.62 58.1233C1215.26 58.8423 1215.84 59.8377 1216.37 61.1095C1216.9 62.3812 1217.41 63.9214 1217.9 65.7301C1218.38 67.5388 1218.71 69.1267 1218.89 70.4938C1219.06 71.846 1219.05 73.0003 1218.86 73.9566C1218.69 74.9089 1218.32 75.6745 1217.76 76.2536C1217.21 76.8474 1216.45 77.2734 1215.48 77.5317Z" fill="#717385"/>
<path d="M1198.99 78.1593C1198.68 78.2427 1198.49 78.1362 1198.41 77.8397C1198.38 77.7507 1198.39 77.6613 1198.43 77.5712L1205.54 60.1732C1205.61 60.012 1205.68 59.8824 1205.75 59.7844C1205.83 59.6825 1205.97 59.6057 1206.16 59.5541L1206.9 59.3574C1207.21 59.274 1207.41 59.3806 1207.48 59.6771C1207.51 59.766 1207.5 59.8555 1207.46 59.9455L1200.37 77.3376C1200.3 77.4988 1200.23 77.6304 1200.14 77.7323C1200.07 77.8303 1199.94 77.9071 1199.73 77.9627L1198.99 78.1593ZM1209.22 75.5637C1208.25 75.8219 1207.41 75.7522 1206.7 75.3546C1206.01 74.9531 1205.51 74.3155 1205.21 73.4419C1205.1 73.0604 1205 72.7362 1204.93 72.4694C1204.85 72.1877 1204.77 71.8373 1204.67 71.4183C1204.49 70.5129 1204.59 69.7164 1204.96 69.0288C1205.34 68.3225 1206.05 67.8322 1207.07 67.5581C1208.11 67.2801 1208.96 67.3532 1209.63 67.7775C1210.31 68.1831 1210.8 68.8226 1211.1 69.6962C1211.24 70.1034 1211.35 70.4478 1211.42 70.7295C1211.5 70.9963 1211.57 71.3265 1211.64 71.7199C1211.82 72.6253 1211.7 73.4277 1211.29 74.1272C1210.88 74.8227 1210.19 75.3015 1209.22 75.5637ZM1208.82 74.096C1209.22 73.9888 1209.51 73.8238 1209.69 73.6012C1209.87 73.3785 1209.98 73.1347 1210.02 72.8696C1210.06 72.5898 1210.05 72.3219 1209.99 72.0659C1209.92 71.6577 1209.85 71.335 1209.78 71.0978C1209.72 70.8606 1209.62 70.568 1209.5 70.2202C1209.38 69.8239 1209.15 69.487 1208.82 69.2096C1208.5 68.9322 1208.04 68.8709 1207.46 69.0258C1206.9 69.1768 1206.55 69.4545 1206.4 69.8591C1206.27 70.2596 1206.24 70.664 1206.32 71.0722C1206.4 71.432 1206.47 71.7305 1206.54 71.9677C1206.6 72.2049 1206.69 72.5217 1206.81 72.918C1206.91 73.1621 1207.04 73.3982 1207.19 73.6264C1207.36 73.8358 1207.58 73.9922 1207.84 74.0957C1208.13 74.1952 1208.45 74.1953 1208.82 74.096ZM1198.78 69.8978C1197.8 70.16 1196.97 70.1052 1196.28 69.7333C1195.6 69.3614 1195.1 68.7386 1194.81 67.865C1194.69 67.4835 1194.59 67.1593 1194.52 66.8925C1194.45 66.6108 1194.36 66.2604 1194.26 65.8413C1194.07 64.9399 1194.17 64.1434 1194.55 63.4519C1194.94 62.7455 1195.64 62.2553 1196.66 61.9812C1197.7 61.7032 1198.55 61.7763 1199.22 62.2006C1199.9 62.6061 1200.39 63.2477 1200.67 64.1253C1200.81 64.5324 1200.92 64.8769 1200.99 65.1585C1201.06 65.4254 1201.14 65.7555 1201.21 66.1489C1201.4 67.0503 1201.29 67.836 1200.87 68.5058C1200.46 69.1716 1199.76 69.6357 1198.78 69.8978ZM1198.41 68.5191C1198.8 68.4158 1199.08 68.2528 1199.26 68.0302C1199.45 67.8036 1199.57 67.5577 1199.61 67.2927C1199.65 67.0129 1199.64 66.745 1199.59 66.489C1199.51 66.0807 1199.44 65.7654 1199.38 65.5431C1199.32 65.3059 1199.22 65.0059 1199.09 64.6432C1198.97 64.2469 1198.74 63.9121 1198.39 63.6386C1198.06 63.3612 1197.62 63.298 1197.06 63.4489C1196.49 63.5999 1196.14 63.8776 1195.99 64.2821C1195.86 64.6827 1195.83 65.0871 1195.91 65.4953C1196 65.8699 1196.07 66.1758 1196.13 66.413C1196.19 66.6354 1196.28 66.9447 1196.41 67.341C1196.5 67.5851 1196.63 67.8213 1196.79 68.0495C1196.95 68.2589 1197.17 68.4153 1197.44 68.5188C1197.7 68.6223 1198.03 68.6224 1198.41 68.5191Z" fill="#717385"/>
<path d="M1187.68 81.1909C1187.55 81.2266 1187.42 81.2119 1187.31 81.1468C1187.21 81.0629 1187.14 80.9542 1187.11 80.8208C1187.09 80.7467 1187.08 80.6854 1187.08 80.6369C1187.1 80.5845 1187.11 80.5415 1187.12 80.5079L1189.25 74.8596C1188.9 75.0479 1188.52 75.1996 1188.09 75.3148C1187.27 75.5184 1186.48 75.5688 1185.74 75.4659C1185.01 75.359 1184.36 75.1299 1183.77 74.7787C1183.18 74.4126 1182.68 73.9574 1182.28 73.4131C1181.88 72.8688 1181.59 72.2631 1181.42 71.596C1181.24 70.9437 1181.18 70.2764 1181.24 69.5942C1181.31 68.908 1181.51 68.2513 1181.83 67.6241C1182.17 66.9929 1182.65 66.4357 1183.26 65.9525C1183.89 65.4505 1184.67 65.0744 1185.61 64.8241C1186.54 64.5739 1187.4 64.5036 1188.17 64.6134C1188.96 64.7044 1189.66 64.9384 1190.27 65.3154C1190.89 65.6735 1191.39 66.1341 1191.78 66.6972C1192.19 67.2563 1192.48 67.8694 1192.66 68.5365C1192.82 69.1443 1192.88 69.7241 1192.84 70.2758C1192.79 70.8276 1192.7 71.3373 1192.56 71.8051C1192.43 72.269 1192.29 72.7012 1192.16 73.1017L1189.47 80.2337C1189.44 80.3237 1189.38 80.4419 1189.31 80.5883C1189.23 80.7199 1189.09 80.8135 1188.88 80.8691L1187.68 81.1909ZM1187.91 73.4301C1188.54 73.2633 1189.07 72.9769 1189.52 72.571C1189.98 72.1463 1190.3 71.6477 1190.48 71.075C1190.65 70.4875 1190.65 69.8454 1190.46 69.1486C1190.27 68.4519 1189.96 67.9006 1189.52 67.4948C1189.07 67.0741 1188.54 66.8019 1187.94 66.678C1187.35 66.5354 1186.74 66.5475 1186.11 66.7143C1185.51 66.8772 1184.98 67.169 1184.54 67.5897C1184.09 67.9956 1183.78 68.4923 1183.6 69.0797C1183.42 69.6524 1183.42 70.2871 1183.61 70.9839C1183.8 71.6807 1184.11 72.2394 1184.56 72.66C1185 73.0658 1185.52 73.34 1186.12 73.4827C1186.71 73.6105 1187.31 73.593 1187.91 73.4301Z" fill="#717385"/>
<path d="M1180.02 83.2449C1179.87 83.2846 1179.73 83.2739 1179.6 83.2127C1179.49 83.1328 1179.41 83.0187 1179.37 82.8705L1176.03 70.4174L1173.1 74.2529C1173.01 74.3736 1172.89 74.4445 1172.75 74.4654C1172.62 74.4863 1172.49 74.4494 1172.37 74.3546L1171.59 73.7757C1171.47 73.6661 1171.39 73.5426 1171.37 73.4052C1171.37 73.2638 1171.41 73.1328 1171.51 73.0121L1175.35 67.9772C1175.44 67.8752 1175.52 67.8049 1175.61 67.7663C1175.69 67.7276 1175.79 67.6944 1175.89 67.6666L1177.02 67.3627C1177.17 67.323 1177.3 67.3431 1177.42 67.423C1177.55 67.4842 1177.63 67.5889 1177.67 67.7371L1181.57 82.2806C1181.61 82.4288 1181.59 82.5687 1181.51 82.7003C1181.45 82.8131 1181.34 82.8893 1181.19 82.9291L1180.02 83.2449Z" fill="#717385"/>
<path d="M1174.52 88.5068C1173.56 88.765 1172.69 88.7759 1171.91 88.5396C1171.13 88.3181 1170.43 87.8384 1169.81 87.1007C1169.18 86.3629 1168.6 85.3675 1168.05 84.1145C1167.52 82.8428 1167.01 81.3025 1166.53 79.4939C1166.05 77.6852 1165.71 76.0973 1165.54 74.7302C1165.38 73.3592 1165.39 72.2049 1165.56 71.2674C1165.74 70.3151 1166.11 69.5495 1166.67 68.9704C1167.23 68.3914 1167.99 67.9728 1168.95 67.7146C1169.1 67.6749 1169.23 67.695 1169.35 67.7749C1169.48 67.8509 1169.56 67.9556 1169.6 68.089L1169.81 68.8673C1169.84 69.0007 1169.82 69.1333 1169.75 69.2648C1169.69 69.3924 1169.6 69.4702 1169.5 69.498C1168.88 69.6796 1168.4 69.9837 1168.05 70.4102C1167.72 70.818 1167.5 71.3912 1167.42 72.1298C1167.34 72.8644 1167.39 73.7962 1167.57 74.925C1167.76 76.0351 1168.06 77.3832 1168.49 78.9695C1168.91 80.5558 1169.32 81.8836 1169.72 82.9528C1170.13 84.0033 1170.55 84.8283 1170.98 85.4279C1171.43 86.0235 1171.9 86.4214 1172.4 86.6215C1172.91 86.8176 1173.48 86.8397 1174.11 86.6877C1174.21 86.6599 1174.32 86.6785 1174.43 86.7436C1174.56 86.8196 1174.65 86.9317 1174.69 87.08L1174.9 87.8583C1174.93 87.9917 1174.91 88.1242 1174.84 88.2558C1174.77 88.3834 1174.67 88.4671 1174.52 88.5068Z" fill="#717385"/>
<path d="M1150.39 91.1831C1150.24 91.2229 1150.1 91.2047 1149.97 91.1288C1149.84 91.0528 1149.76 90.9407 1149.72 90.7924L1145.84 76.3157C1145.79 76.1526 1145.81 76.0053 1145.88 75.8737C1145.96 75.7421 1146.07 75.6565 1146.22 75.6168L1148.18 75.0924C1148.34 75.0487 1148.49 75.0648 1148.62 75.1408C1148.75 75.2168 1148.84 75.3363 1148.88 75.4994L1150.28 80.703L1153.87 73.9971C1153.91 73.9071 1153.98 73.7997 1154.09 73.675C1154.21 73.5315 1154.39 73.428 1154.63 73.3644L1156.83 72.7745C1156.95 72.7427 1157.06 72.7594 1157.18 72.8245C1157.3 72.8857 1157.38 72.983 1157.42 73.1164C1157.45 73.2202 1157.44 73.3171 1157.4 73.4071L1153.09 81.7615L1161.6 87.3703C1161.7 87.4394 1161.76 87.5258 1161.79 87.6296C1161.82 87.763 1161.8 87.8881 1161.72 88.0049C1161.65 88.1177 1161.56 88.19 1161.44 88.2217L1159.15 88.8355C1158.9 88.903 1158.69 88.9047 1158.51 88.8407C1158.35 88.7578 1158.24 88.7001 1158.18 88.6676L1151.22 84.2166L1152.76 89.9761C1152.8 90.1244 1152.78 90.2643 1152.71 90.3959C1152.63 90.5274 1152.51 90.6151 1152.35 90.6588L1150.39 91.1831Z" fill="#212328"/>
<path d="M1141.09 93.9132C1140.05 94.1913 1139.12 94.3056 1138.3 94.2561C1137.48 94.2067 1136.76 94.0494 1136.15 93.7842C1135.55 93.5001 1135.06 93.1547 1134.68 92.7478C1134.29 92.3261 1134.03 91.8801 1133.89 91.4096C1133.85 91.2762 1133.87 91.1605 1133.94 91.0625C1134.02 90.9458 1134.13 90.8695 1134.26 90.8338L1136.26 90.2975C1136.41 90.2578 1136.54 90.2537 1136.66 90.2852C1136.78 90.3167 1136.9 90.4114 1137.03 90.5695C1137.27 90.934 1137.57 91.1951 1137.93 91.3529C1138.3 91.5067 1138.7 91.5818 1139.13 91.5783C1139.56 91.56 1139.99 91.4913 1140.43 91.3721C1141.32 91.1338 1141.97 90.7375 1142.38 90.1834C1142.8 89.6105 1142.9 88.9311 1142.69 88.1454C1142.48 87.3597 1142.09 86.8619 1141.51 86.652C1140.92 86.4273 1140.19 86.4321 1139.32 86.6665L1137.03 87.2802C1136.86 87.3239 1136.72 87.3152 1136.59 87.254C1136.46 87.1781 1136.37 87.0585 1136.33 86.8955L1136.08 85.9615C1136.04 85.8132 1136.03 85.6793 1136.06 85.5596C1136.11 85.4211 1136.15 85.3049 1136.21 85.2109L1139.15 80.2528L1132.79 81.9569C1132.62 82.0006 1132.48 81.9845 1132.35 81.9085C1132.23 81.8285 1132.15 81.7145 1132.11 81.5662L1131.72 80.0985C1131.67 79.9354 1131.68 79.7901 1131.74 79.6625C1131.82 79.5309 1131.94 79.4433 1132.1 79.3996L1141.64 76.8433C1141.8 76.7996 1141.95 76.8158 1142.08 76.8918C1142.22 76.9677 1142.3 77.0872 1142.35 77.2503L1142.7 78.5846C1142.74 78.718 1142.74 78.8446 1142.71 78.9642C1142.68 79.0839 1142.64 79.1907 1142.58 79.2847L1139.8 84.2738L1140.07 84.2246C1140.99 84.0564 1141.85 84.0494 1142.64 84.2037C1143.44 84.3392 1144.11 84.674 1144.67 85.2082C1145.24 85.7384 1145.66 86.4854 1145.91 87.449C1146.18 88.4571 1146.15 89.3959 1145.81 90.2653C1145.48 91.116 1144.91 91.8571 1144.09 92.4889C1143.28 93.1206 1142.28 93.5954 1141.09 93.9132Z" fill="#212328"/>
<path d="M1130.03 96.6379C1129.89 96.6776 1129.75 96.6595 1129.61 96.5835C1129.48 96.5076 1129.4 96.3955 1129.36 96.2472L1128.77 94.0457C1128.72 93.8826 1128.74 93.7353 1128.82 93.6037C1128.89 93.4721 1129 93.3865 1129.15 93.3467L1131.38 92.7509C1131.52 92.7112 1131.66 92.7293 1131.8 92.8053C1131.93 92.8812 1132.01 93.0007 1132.06 93.1638L1132.65 95.3653C1132.69 95.5136 1132.67 95.6535 1132.59 95.7851C1132.52 95.9167 1132.41 96.0023 1132.26 96.0421L1130.03 96.6379Z" fill="#212328"/>
<path d="M1115.93 100.416C1115.78 100.456 1115.64 100.438 1115.51 100.362C1115.38 100.286 1115.29 100.174 1115.25 100.026L1114.95 98.8915C1114.91 98.7581 1114.9 98.5944 1114.91 98.4007C1114.94 98.1881 1115.04 97.9536 1115.23 97.6973L1117.8 93.2646C1118.58 92.2315 1119.19 91.3686 1119.64 90.676C1120.1 89.9647 1120.4 89.3508 1120.55 88.8346C1120.71 88.2995 1120.73 87.8096 1120.61 87.3649C1120.43 86.6977 1120.1 86.2063 1119.62 85.8905C1119.15 85.5707 1118.52 85.5161 1117.74 85.7266C1117.22 85.8657 1116.81 86.094 1116.52 86.4117C1116.22 86.7146 1116.01 87.0718 1115.9 87.4832C1115.8 87.8906 1115.77 88.3193 1115.81 88.7691C1115.83 88.9697 1115.79 89.125 1115.68 89.2349C1115.56 89.3448 1115.44 89.4176 1115.3 89.4533L1113.33 89.9836C1113.19 90.0194 1113.07 90.0047 1112.96 89.9396C1112.84 89.8745 1112.77 89.7826 1112.74 89.664C1112.58 89.0226 1112.55 88.3716 1112.65 87.711C1112.73 87.0357 1112.95 86.4046 1113.31 85.8179C1113.67 85.2125 1114.16 84.6755 1114.78 84.2071C1115.4 83.7388 1116.15 83.3874 1117.03 83.153C1118.26 82.8233 1119.33 82.7588 1120.24 82.9593C1121.17 83.156 1121.92 83.5565 1122.51 84.1608C1123.12 84.7612 1123.54 85.5061 1123.78 86.3956C1123.97 87.0924 1124.01 87.7731 1123.9 88.4376C1123.79 89.0873 1123.55 89.7539 1123.2 90.4375C1122.83 91.1062 1122.37 91.8176 1121.81 92.5717L1119.51 96.62L1125.85 94.9218C1126.01 94.8781 1126.15 94.8962 1126.27 94.9762C1126.4 95.0373 1126.48 95.1494 1126.53 95.3125L1126.95 96.8914C1126.99 97.0396 1126.97 97.1796 1126.9 97.3111C1126.84 97.4388 1126.72 97.5244 1126.56 97.5681L1115.93 100.416Z" fill="#212328"/>
<path d="M1204.51 112.643C1203.78 112.837 1203.13 112.913 1202.57 112.871C1202 112.828 1201.52 112.721 1201.13 112.548C1200.73 112.376 1200.42 112.182 1200.18 111.968C1199.95 111.75 1199.81 111.565 1199.76 111.413C1199.71 111.274 1199.72 111.151 1199.8 111.046C1199.89 110.94 1199.98 110.873 1200.08 110.846L1200.96 110.611C1201.03 110.594 1201.08 110.593 1201.13 110.608C1201.18 110.607 1201.26 110.642 1201.36 110.712C1201.58 110.848 1201.82 110.979 1202.07 111.105C1202.33 111.231 1202.62 111.313 1202.95 111.349C1203.29 111.383 1203.69 111.339 1204.15 111.217C1204.81 111.04 1205.32 110.77 1205.68 110.409C1206.04 110.035 1206.15 109.602 1206.02 109.109C1205.94 108.784 1205.77 108.549 1205.54 108.403C1205.32 108.254 1204.96 108.162 1204.47 108.128C1203.98 108.091 1203.33 108.092 1202.51 108.132C1201.68 108.159 1201 108.103 1200.48 107.966C1199.95 107.815 1199.54 107.584 1199.25 107.273C1198.96 106.949 1198.75 106.553 1198.62 106.086C1198.49 105.606 1198.51 105.108 1198.68 104.59C1198.84 104.06 1199.16 103.579 1199.63 103.147C1200.11 102.712 1200.77 102.384 1201.6 102.161C1202.27 101.981 1202.87 101.91 1203.39 101.95C1203.92 101.99 1204.37 102.098 1204.75 102.274C1205.13 102.437 1205.43 102.621 1205.65 102.826C1205.87 103.031 1206.01 103.216 1206.07 103.381C1206.12 103.507 1206.11 103.628 1206.04 103.743C1205.97 103.845 1205.88 103.912 1205.76 103.943L1204.95 104.162C1204.86 104.187 1204.77 104.188 1204.7 104.166C1204.64 104.141 1204.57 104.11 1204.51 104.072C1204.33 103.938 1204.13 103.811 1203.9 103.691C1203.69 103.568 1203.43 103.492 1203.11 103.465C1202.81 103.421 1202.43 103.46 1201.98 103.582C1201.33 103.756 1200.88 104.022 1200.63 104.381C1200.37 104.741 1200.3 105.128 1200.42 105.543C1200.48 105.79 1200.61 105.991 1200.81 106.147C1201 106.304 1201.32 106.406 1201.77 106.454C1202.21 106.502 1202.85 106.51 1203.69 106.48C1204.59 106.419 1205.33 106.465 1205.9 106.619C1206.47 106.772 1206.91 107.009 1207.21 107.33C1207.52 107.65 1207.74 108.057 1207.87 108.55C1208.02 109.095 1208 109.636 1207.81 110.173C1207.62 110.711 1207.25 111.199 1206.7 111.638C1206.15 112.065 1205.42 112.399 1204.51 112.643Z" fill="#C20181"/>
<path d="M1194.16 115.414C1192.82 115.776 1191.64 115.654 1190.63 115.049C1189.61 114.43 1188.87 113.418 1188.41 112.012C1188.36 111.847 1188.29 111.635 1188.22 111.375C1188.15 111.103 1188.1 110.881 1188.07 110.708C1187.87 109.774 1187.87 108.912 1188.06 108.124C1188.25 107.322 1188.62 106.647 1189.17 106.097C1189.73 105.543 1190.45 105.148 1191.33 104.912C1192.32 104.648 1193.19 104.635 1193.97 104.873C1194.75 105.107 1195.42 105.56 1195.98 106.231C1196.53 106.903 1196.95 107.751 1197.22 108.776L1197.31 109.107C1197.35 109.249 1197.34 109.372 1197.27 109.474C1197.21 109.572 1197.11 109.639 1196.99 109.674L1190.25 111.478C1190.26 111.491 1190.26 111.517 1190.27 111.556C1190.28 111.595 1190.29 111.627 1190.3 111.653C1190.47 112.178 1190.72 112.646 1191.05 113.057C1191.38 113.456 1191.78 113.746 1192.24 113.927C1192.72 114.104 1193.23 114.122 1193.76 113.979C1194.23 113.854 1194.6 113.679 1194.87 113.453C1195.14 113.226 1195.35 113.003 1195.5 112.782C1195.65 112.548 1195.74 112.371 1195.78 112.25C1195.85 112.063 1195.92 111.948 1195.98 111.904C1196.03 111.848 1196.13 111.801 1196.27 111.763L1197.23 111.507C1197.34 111.476 1197.45 111.489 1197.55 111.546C1197.66 111.586 1197.72 111.673 1197.74 111.806C1197.78 112.004 1197.74 112.272 1197.63 112.61C1197.5 112.934 1197.3 113.281 1197.01 113.651C1196.73 114.017 1196.35 114.363 1195.87 114.687C1195.39 114.994 1194.83 115.237 1194.16 115.414ZM1189.89 110.135L1195.22 108.707L1195.21 108.648C1195.05 108.065 1194.8 107.575 1194.46 107.18C1194.13 106.782 1193.73 106.507 1193.26 106.355C1192.78 106.191 1192.27 106.183 1191.71 106.332C1191.15 106.482 1190.71 106.747 1190.38 107.127C1190.06 107.491 1189.86 107.927 1189.77 108.437C1189.69 108.947 1189.72 109.493 1189.88 110.077L1189.89 110.135Z" fill="#C20181"/>
<path d="M1178.71 119.346C1178.58 119.381 1178.46 119.371 1178.35 119.318C1178.25 119.248 1178.18 119.148 1178.15 119.018L1175.67 109.795C1175.64 109.665 1175.65 109.551 1175.71 109.453C1175.77 109.337 1175.87 109.262 1176 109.228L1176.92 108.983C1177.05 108.948 1177.16 108.966 1177.26 109.035C1177.38 109.089 1177.45 109.181 1177.48 109.31L1177.71 110.166C1177.93 109.635 1178.26 109.165 1178.69 108.757C1179.13 108.333 1179.76 108.013 1180.56 107.798C1181.41 107.572 1182.17 107.568 1182.85 107.788C1183.55 107.992 1184.13 108.384 1184.61 108.966C1185.09 109.531 1185.45 110.248 1185.69 111.117L1187.16 116.604C1187.19 116.734 1187.17 116.856 1187.11 116.972C1187.05 117.07 1186.96 117.137 1186.83 117.172L1185.85 117.432C1185.73 117.467 1185.6 117.458 1185.49 117.404C1185.39 117.334 1185.32 117.235 1185.29 117.105L1183.84 111.715C1183.6 110.807 1183.19 110.159 1182.61 109.771C1182.03 109.371 1181.32 109.285 1180.46 109.514C1179.65 109.73 1179.08 110.163 1178.72 110.814C1178.38 111.449 1178.33 112.22 1178.57 113.128L1180.01 118.518C1180.05 118.647 1180.03 118.77 1179.97 118.885C1179.91 118.984 1179.82 119.05 1179.69 119.085L1178.71 119.346Z" fill="#C20181"/>
<path d="M1174 120.609C1173.87 120.643 1173.75 120.634 1173.64 120.58C1173.54 120.51 1173.47 120.411 1173.43 120.281L1170.96 111.058C1170.93 110.928 1170.94 110.814 1171 110.715C1171.06 110.6 1171.16 110.525 1171.29 110.49L1172.22 110.24C1172.35 110.205 1172.47 110.223 1172.57 110.293C1172.68 110.346 1172.76 110.438 1172.79 110.568L1175.26 119.791C1175.3 119.921 1175.28 120.043 1175.21 120.158C1175.16 120.257 1175.06 120.323 1174.93 120.358L1174 120.609ZM1170.63 108.645C1170.5 108.679 1170.38 108.67 1170.27 108.617C1170.16 108.547 1170.1 108.447 1170.06 108.317L1169.78 107.266C1169.74 107.137 1169.75 107.016 1169.81 106.904C1169.87 106.789 1169.97 106.714 1170.1 106.679L1171.33 106.351C1171.46 106.316 1171.58 106.332 1171.69 106.399C1171.81 106.465 1171.89 106.563 1171.92 106.693L1172.2 107.744C1172.24 107.873 1172.22 107.996 1172.15 108.111C1172.08 108.213 1171.98 108.281 1171.85 108.316L1170.63 108.645Z" fill="#C20181"/>
<path d="M1162.16 123.78C1162.03 123.815 1161.91 123.806 1161.8 123.752C1161.7 123.682 1161.63 123.583 1161.6 123.453L1158.13 110.533C1158.1 110.403 1158.11 110.289 1158.17 110.19C1158.23 110.075 1158.33 110 1158.46 109.965L1159.43 109.705C1159.58 109.666 1159.7 109.682 1159.8 109.752C1159.9 109.809 1159.97 109.902 1160 110.032L1161.22 114.566C1161.45 114.031 1161.78 113.56 1162.21 113.152C1162.65 112.744 1163.25 112.435 1164.03 112.227C1164.87 112.001 1165.64 111.998 1166.32 112.218C1167.02 112.421 1167.6 112.813 1168.08 113.395C1168.56 113.96 1168.92 114.677 1169.15 115.547L1170.62 121.034C1170.66 121.163 1170.65 121.284 1170.6 121.396C1170.54 121.494 1170.44 121.563 1170.3 121.601L1169.32 121.862C1169.19 121.897 1169.07 121.887 1168.96 121.834C1168.86 121.764 1168.79 121.664 1168.76 121.534L1167.31 116.144C1167.07 115.236 1166.66 114.588 1166.08 114.201C1165.5 113.8 1164.78 113.714 1163.93 113.944C1163.12 114.159 1162.54 114.592 1162.19 115.243C1161.83 115.881 1161.78 116.654 1162.02 117.562L1163.46 122.952C1163.5 123.082 1163.49 123.203 1163.44 123.314C1163.38 123.413 1163.28 123.482 1163.14 123.52L1162.16 123.78Z" fill="#C20181"/>
<path d="M1155.1 125.882C1154.18 126.129 1153.33 126.167 1152.56 125.998C1151.81 125.812 1151.16 125.437 1150.61 124.872C1150.07 124.295 1149.66 123.543 1149.38 122.616C1149.32 122.425 1149.24 122.167 1149.16 121.843C1149.07 121.519 1149.01 121.258 1148.97 121.059C1148.74 120.119 1148.72 119.269 1148.91 118.51C1149.09 117.738 1149.47 117.088 1150.04 116.561C1150.61 116.017 1151.36 115.621 1152.28 115.375C1153.04 115.173 1153.71 115.105 1154.29 115.17C1154.89 115.231 1155.41 115.377 1155.85 115.608C1156.29 115.838 1156.64 116.119 1156.91 116.45C1157.19 116.777 1157.38 117.108 1157.49 117.442C1157.54 117.568 1157.52 117.682 1157.45 117.785C1157.38 117.887 1157.28 117.955 1157.15 117.99L1156.22 118.24C1156.09 118.275 1155.99 118.275 1155.91 118.241C1155.83 118.193 1155.73 118.107 1155.63 117.981C1155.23 117.408 1154.79 117.046 1154.32 116.894C1153.84 116.743 1153.31 116.747 1152.71 116.907C1151.94 117.115 1151.36 117.525 1151 118.137C1150.65 118.746 1150.6 119.587 1150.84 120.661C1150.95 121.132 1151.08 121.586 1151.21 122.024C1151.53 123.09 1152 123.799 1152.61 124.15C1153.23 124.485 1153.93 124.548 1154.71 124.339C1155.3 124.18 1155.77 123.916 1156.1 123.549C1156.43 123.182 1156.63 122.649 1156.69 121.951C1156.72 121.791 1156.76 121.67 1156.8 121.587C1156.85 121.505 1156.94 121.447 1157.07 121.412L1158 121.162C1158.13 121.127 1158.26 121.143 1158.37 121.209C1158.48 121.263 1158.55 121.356 1158.57 121.489C1158.63 121.765 1158.65 122.06 1158.62 122.373C1158.59 122.686 1158.5 123.023 1158.35 123.384C1158.21 123.728 1158 124.063 1157.72 124.386C1157.44 124.697 1157.09 124.987 1156.66 125.255C1156.23 125.509 1155.71 125.718 1155.1 125.882Z" fill="#C20181"/>
<path d="M1143.1 129.098C1142.45 129.272 1141.82 129.3 1141.22 129.183C1140.62 129.066 1140.1 128.831 1139.66 128.476C1139.21 128.122 1138.92 127.666 1138.77 127.108C1138.53 126.213 1138.7 125.403 1139.28 124.676C1139.87 123.95 1140.72 123.346 1141.84 122.864L1144.63 121.679L1144.48 121.114C1144.32 120.492 1144 120.054 1143.55 119.801C1143.1 119.545 1142.48 119.524 1141.67 119.74C1141.1 119.893 1140.67 120.135 1140.37 120.465C1140.07 120.796 1139.89 121.162 1139.85 121.564C1139.82 121.779 1139.71 121.913 1139.52 121.965L1138.64 122.2C1138.5 122.238 1138.38 122.229 1138.28 122.172C1138.19 122.098 1138.13 122.003 1138.1 121.886C1138.05 121.692 1138.05 121.433 1138.12 121.109C1138.2 120.782 1138.36 120.441 1138.6 120.085C1138.83 119.729 1139.17 119.396 1139.6 119.086C1140.04 118.759 1140.61 118.502 1141.31 118.314C1142.09 118.106 1142.77 118.034 1143.36 118.099C1143.95 118.151 1144.43 118.306 1144.82 118.563C1145.22 118.817 1145.55 119.14 1145.79 119.534C1146.05 119.924 1146.23 120.339 1146.35 120.78L1148.04 127.084C1148.08 127.214 1148.06 127.337 1147.99 127.452C1147.94 127.55 1147.84 127.617 1147.71 127.652L1146.82 127.892C1146.68 127.93 1146.56 127.921 1146.46 127.864C1146.36 127.794 1146.29 127.694 1146.25 127.564L1146.03 126.727C1145.92 127.006 1145.76 127.3 1145.53 127.61C1145.31 127.907 1145 128.191 1144.62 128.461C1144.23 128.719 1143.72 128.931 1143.1 129.098ZM1143.11 127.529C1143.65 127.386 1144.1 127.146 1144.49 126.807C1144.86 126.455 1145.11 126.007 1145.23 125.461C1145.36 124.911 1145.33 124.273 1145.13 123.547L1144.99 123.002L1142.82 123.937C1141.93 124.314 1141.3 124.72 1140.91 125.157C1140.53 125.58 1140.4 126.026 1140.52 126.493C1140.62 126.856 1140.8 127.133 1141.08 127.324C1141.36 127.498 1141.68 127.6 1142.04 127.63C1142.4 127.656 1142.76 127.623 1143.11 127.529Z" fill="#C20181"/>
<path d="M1125.48 133.611C1125.35 133.646 1125.22 133.636 1125.11 133.583C1125.01 133.513 1124.94 133.413 1124.91 133.283L1121.5 120.577C1121.46 120.434 1121.47 120.314 1121.53 120.215C1121.6 120.1 1121.7 120.025 1121.83 119.99L1122.8 119.73C1122.95 119.688 1123.08 119.695 1123.18 119.752C1123.28 119.809 1123.35 119.86 1123.39 119.905L1129.6 126.666L1131.64 117.695C1131.65 117.636 1131.68 117.559 1131.72 117.464C1131.78 117.365 1131.89 117.295 1132.04 117.253L1132.99 116.998C1133.14 116.959 1133.26 116.975 1133.36 117.045C1133.47 117.099 1133.55 117.197 1133.59 117.339L1136.99 130.045C1137.03 130.175 1137.01 130.298 1136.94 130.413C1136.89 130.511 1136.79 130.58 1136.64 130.618L1135.69 130.874C1135.56 130.908 1135.44 130.899 1135.33 130.845C1135.23 130.775 1135.16 130.676 1135.12 130.546L1132.56 120.973L1131.01 128.187C1130.99 128.33 1130.94 128.455 1130.86 128.561C1130.77 128.653 1130.65 128.72 1130.49 128.762L1129.89 128.924C1129.72 128.969 1129.58 128.971 1129.48 128.931C1129.36 128.877 1129.26 128.794 1129.16 128.682L1124.19 123.215L1126.76 132.788C1126.79 132.918 1126.78 133.04 1126.71 133.155C1126.65 133.254 1126.56 133.321 1126.43 133.355L1125.48 133.611Z" fill="#C20181"/>
</g>
</g>
<defs>
<linearGradient id="paint0_linear_2553_40478" x1="0" y1="0" x2="839.539" y2="-476.589" gradientUnits="userSpaceOnUse">
<stop offset="0.32" stop-color="#DFD4F4" stop-opacity="0"/>
<stop offset="1" stop-color="#DFD4F4" stop-opacity="0.5"/>
</linearGradient>
<clipPath id="clip0_2553_40478">
<rect width="1210" height="176" rx="8" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $c49aa0f374b6c6e6$export$8c1a92ef10d2822b = `<svg width="1210" height="176" viewBox="0 0 1210 176" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3008_32468)">
<rect width="1210" height="176" rx="8" transform="matrix(1 0 0 -1 0 176)" fill="url(#paint0_linear_3008_32468)"/>
<g opacity="0.75">
<path fill-rule="evenodd" clip-rule="evenodd" d="M803.88 42.7271C786.335 47.4283 775.923 65.4624 780.624 83.0075C785.326 100.553 803.36 110.965 820.905 106.263C838.45 101.562 848.862 83.528 844.161 65.983C839.459 48.438 821.425 38.026 803.88 42.7271ZM767.917 86.4124C761.335 61.8493 775.912 36.6015 800.475 30.0199C825.038 23.4382 850.286 38.0151 856.868 62.5781C863.449 87.1412 848.873 112.389 824.31 118.971C799.747 125.552 774.499 110.975 767.917 86.4124Z" fill="#0294F7"/>
<path d="M804.139 43.6931L805.105 43.4342L804.846 42.4683L801.441 29.7611L801.182 28.7951L800.216 29.054C775.12 35.7786 760.227 61.5747 766.951 86.6712C773.676 111.768 799.472 126.661 824.568 119.937L825.534 119.678L825.276 118.712L821.871 106.005L821.612 105.039L820.646 105.297C803.634 109.856 786.149 99.7602 781.59 82.7487C777.032 65.7371 787.127 48.2513 804.139 43.6931Z" fill="#D057FF" stroke="#131D2D" stroke-width="2"/>
<path d="M804.139 43.693L805.104 43.4342L804.846 42.4683L801.441 29.761L801.182 28.7951L800.216 29.0539C781.062 34.1864 767.867 50.4211 765.665 68.9533L765.547 69.9463L766.54 70.0643L779.603 71.6171L780.596 71.7351L780.714 70.7421C782.21 58.1559 791.174 47.1669 804.139 43.693Z" fill="#FC3DA6" stroke="#131D2D" stroke-width="2"/>
<path d="M970.281 48.5745C969.985 48.654 969.705 48.6177 969.442 48.4658C969.179 48.3138 969.008 48.0896 968.928 47.7931L961.17 18.8397C961.083 18.5135 961.115 18.2189 961.267 17.9557C961.419 17.6925 961.643 17.5212 961.939 17.4418L965.853 16.3931C966.179 16.3057 966.474 16.3379 966.737 16.4899C967 16.6418 967.176 16.8809 967.263 17.207L970.052 27.6143L977.231 14.2024C977.31 14.0224 977.459 13.8077 977.678 13.5583C977.919 13.2713 978.277 13.0642 978.751 12.9371L983.154 11.7573C983.391 11.6937 983.623 11.7271 983.848 11.8573C984.104 11.9796 984.267 12.1742 984.338 12.441C984.394 12.6486 984.382 12.8424 984.304 13.0224L975.672 29.7312L992.692 40.9489C992.888 41.0871 993.014 41.2599 993.069 41.4675C993.141 41.7343 993.097 41.9845 992.937 42.218C992.807 42.4436 992.623 42.5882 992.386 42.6517L987.805 43.8792C987.301 44.0142 986.873 44.0177 986.52 43.8896C986.19 43.7239 985.968 43.6085 985.856 43.5434L971.935 34.6414L975.021 46.1605C975.101 46.457 975.064 46.7368 974.912 47C974.76 47.2631 974.521 47.4384 974.195 47.5258L970.281 48.5745Z" fill="#F3F4F7"/>
<path d="M952.169 53.9047C949.619 54.5879 947.298 54.7014 945.205 54.2452C943.105 53.7593 941.332 52.8361 939.887 51.4754C938.434 50.0851 937.433 48.367 936.885 46.3212C936.639 45.402 936.519 44.4807 936.526 43.5573C936.533 42.6339 936.626 41.7351 936.805 40.8609C936.983 39.9867 937.171 39.2055 937.368 38.5171C937.587 37.7912 937.797 37.2106 937.998 36.7753L943.146 23.4312C943.225 23.2512 943.355 23.0256 943.536 22.7545C943.71 22.4537 944.004 22.2477 944.419 22.1365L948.556 21.0282C948.823 20.9567 949.073 21.0009 949.306 21.1608C949.532 21.291 949.68 21.4896 949.752 21.7564C949.784 21.875 949.786 22.0016 949.758 22.136C949.752 22.2329 949.728 22.319 949.684 22.3942L945.77 32.6908C946.013 32.5303 946.308 32.3876 946.656 32.2626C947.004 32.1376 947.326 32.0354 947.623 31.956C949.113 31.5884 950.601 31.5075 952.086 31.7134C953.563 31.8895 954.933 32.317 956.196 32.9957C957.458 33.6744 958.542 34.5757 959.447 35.6997C960.381 36.8158 961.051 38.1299 961.456 39.6421C961.981 41.599 961.98 43.5535 961.454 45.5058C960.921 47.4284 959.87 49.14 958.302 50.6407C956.763 52.1334 954.719 53.2214 952.169 53.9047ZM950.754 48.8019C951.822 48.5159 952.74 48.0314 953.511 47.3483C954.311 46.6572 954.877 45.8063 955.21 44.7955C955.543 43.7847 955.539 42.6418 955.197 41.3668C954.863 40.1215 954.3 39.1444 953.506 38.4355C952.712 37.7266 951.796 37.2729 950.758 37.0745C949.749 36.8681 948.711 36.9078 947.644 37.1939C946.576 37.4799 945.643 37.9684 944.843 38.6594C944.072 39.3425 943.521 40.1895 943.188 41.2003C942.855 42.2111 942.855 43.3392 943.189 44.5845C943.53 45.8594 944.098 46.8514 944.892 47.5603C945.686 48.2692 946.587 48.7268 947.596 48.9332C948.634 49.1317 949.687 49.0879 950.754 48.8019Z" fill="#F3F4F7"/>
<path d="M930.045 59.3564C929.749 59.4358 929.469 59.3996 929.206 59.2477C928.942 59.0957 928.771 58.8715 928.692 58.575L927.512 54.1719C927.424 53.8458 927.457 53.5511 927.609 53.288C927.761 53.0248 927.985 52.8535 928.281 52.774L932.729 51.5823C933.025 51.5029 933.305 51.5391 933.568 51.6911C933.831 51.843 934.007 52.0821 934.094 52.4082L935.274 56.8113C935.353 57.1078 935.317 57.3876 935.165 57.6508C935.013 57.9139 934.789 58.0852 934.493 58.1647L930.045 59.3564Z" fill="#F3F4F7"/>
<path d="M901.841 66.9132C901.545 66.9926 901.265 66.9564 901.002 66.8044C900.739 66.6525 900.568 66.4283 900.488 66.1318L899.88 63.8635C899.809 63.5967 899.785 63.2694 899.808 62.8819C899.853 62.4567 900.061 61.9878 900.432 61.4753L905.588 52.6097C907.132 50.5435 908.354 48.8179 909.254 47.4327C910.176 46.0099 910.784 44.7822 911.079 43.7497C911.397 42.6796 911.436 41.6998 911.198 40.8103C910.84 39.476 910.179 38.4931 909.216 37.8615C908.282 37.222 907.029 37.1127 905.457 37.5338C904.42 37.8119 903.605 38.2686 903.012 38.9041C902.412 39.5098 901.999 40.2241 901.775 41.047C901.58 41.8619 901.524 42.7191 901.606 43.6187C901.65 44.02 901.558 44.3306 901.331 44.5503C901.104 44.7701 900.857 44.9157 900.59 44.9872L896.632 46.0478C896.365 46.1193 896.119 46.09 895.893 45.9597C895.668 45.8295 895.523 45.6458 895.46 45.4086C895.148 44.1257 895.085 42.8237 895.271 41.5026C895.449 40.1519 895.89 38.8898 896.592 37.7165C897.317 36.5055 898.3 35.4316 899.543 34.4948C900.785 33.5581 902.281 32.8553 904.031 32.3866C906.492 31.7272 908.634 31.5981 910.457 31.9993C912.311 32.3925 913.828 33.1935 915.01 34.4022C916.222 35.6029 917.066 37.0928 917.542 38.8718C917.916 40.2654 917.995 41.6267 917.779 42.9557C917.555 44.2551 917.086 45.5883 916.372 46.9555C915.65 48.2931 914.728 49.7158 913.606 51.2239L909.007 59.3206L921.683 55.9242C922.009 55.8368 922.289 55.8731 922.522 56.0329C922.777 56.1552 922.949 56.3795 923.036 56.7056L923.882 59.8634C923.962 60.1599 923.925 60.4397 923.773 60.7029C923.651 60.9581 923.427 61.1294 923.101 61.2168L901.841 66.9132Z" fill="#F3F4F7"/>
<path d="M890.504 69.9509C890.178 70.0383 889.883 70.006 889.62 69.8541C889.387 69.6942 889.23 69.466 889.151 69.1695L882.978 46.1313L877.612 53.1463C877.392 53.3957 877.145 53.5413 876.871 53.5832C876.588 53.5954 876.307 53.4959 876.028 53.2846L873.517 51.3835C873.267 51.1643 873.117 50.9025 873.068 50.598C873.048 50.2856 873.147 50.0047 873.366 49.7553L881.267 39.3917C881.405 39.1958 881.559 39.0591 881.729 38.9818C881.899 38.9045 882.088 38.838 882.296 38.7824L886.209 37.7337C886.506 37.6543 886.786 37.6905 887.049 37.8424C887.312 37.9944 887.483 38.2186 887.563 38.5151L895.333 67.513C895.412 67.8095 895.376 68.0894 895.224 68.3525C895.072 68.6157 894.848 68.787 894.551 68.8665L890.504 69.9509Z" fill="#F3F4F7"/>
<path d="M1096.52 13.4994C1095.69 13.7218 1094.95 13.8087 1094.3 13.76C1093.65 13.7114 1093.1 13.5885 1092.65 13.3913C1092.2 13.1941 1091.84 12.9731 1091.57 12.7282C1091.31 12.4794 1091.15 12.268 1091.09 12.094C1091.03 11.9349 1091.05 11.795 1091.14 11.6743C1091.24 11.5536 1091.34 11.4773 1091.46 11.4455L1092.46 11.1774C1092.54 11.1575 1092.6 11.1565 1092.65 11.1742C1092.72 11.1731 1092.81 11.2126 1092.92 11.2925C1093.17 11.4484 1093.44 11.5984 1093.73 11.7424C1094.03 11.8864 1094.36 11.9794 1094.74 12.0215C1095.13 12.0595 1095.58 12.0091 1096.1 11.87C1096.86 11.6675 1097.44 11.3598 1097.86 10.947C1098.27 10.5194 1098.4 10.0239 1098.25 9.46059C1098.15 9.08996 1097.96 8.82127 1097.7 8.6545C1097.44 8.48377 1097.04 8.37897 1096.47 8.3401C1095.92 8.29726 1095.17 8.29864 1094.23 8.34426C1093.28 8.37505 1092.51 8.31171 1091.91 8.15424C1091.31 7.98195 1090.84 7.71804 1090.51 7.36252C1090.17 6.99218 1089.93 6.54016 1089.79 6.00645C1089.64 5.45792 1089.66 4.88794 1089.86 4.29649C1090.04 3.69022 1090.4 3.14059 1090.94 2.64759C1091.49 2.15063 1092.24 1.77503 1093.19 1.5208C1093.96 1.31423 1094.64 1.23383 1095.24 1.27958C1095.84 1.32533 1096.36 1.44878 1096.8 1.64995C1097.23 1.83629 1097.57 2.04646 1097.82 2.28047C1098.08 2.51448 1098.24 2.72586 1098.3 2.91462C1098.36 3.05889 1098.35 3.19683 1098.27 3.32841C1098.19 3.44517 1098.09 3.52142 1097.95 3.55717L1097.02 3.80743C1096.91 3.83524 1096.82 3.83683 1096.73 3.81222C1096.66 3.78363 1096.59 3.74764 1096.51 3.70423C1096.31 3.55122 1096.08 3.40616 1095.83 3.26905C1095.58 3.12796 1095.28 3.04182 1094.92 3.01061C1094.57 2.9606 1094.14 3.00512 1093.62 3.14415C1092.88 3.34277 1092.37 3.6474 1092.08 4.05803C1091.79 4.46867 1091.71 4.91119 1091.84 5.38559C1091.92 5.66727 1092.06 5.89745 1092.29 6.07613C1092.51 6.25481 1092.87 6.37153 1093.38 6.42629C1093.89 6.48105 1094.62 6.49104 1095.58 6.45628C1096.61 6.38683 1097.45 6.4397 1098.1 6.61491C1098.75 6.79011 1099.26 7.0609 1099.61 7.42727C1099.96 7.79364 1100.21 8.2585 1100.36 8.82186C1100.53 9.44451 1100.51 10.0629 1100.29 10.6772C1100.07 11.2914 1099.65 11.8495 1099.02 12.3515C1098.39 12.8387 1097.55 13.2213 1096.52 13.4994Z" fill="#9EA1B1"/>
<path d="M1084.69 16.6669C1083.15 17.08 1081.8 16.9407 1080.65 16.2491C1079.49 15.5426 1078.65 14.3859 1078.12 12.7789C1078.06 12.5902 1077.98 12.3476 1077.9 12.051C1077.82 11.7397 1077.76 11.4857 1077.72 11.289C1077.5 10.2205 1077.5 9.23584 1077.72 8.33491C1077.93 7.41915 1078.35 6.647 1078.98 6.01845C1079.62 5.38593 1080.45 4.93461 1081.45 4.66449C1082.58 4.36259 1083.59 4.34754 1084.47 4.61936C1085.37 4.8872 1086.13 5.40483 1086.77 6.17226C1087.4 6.93969 1087.88 7.90899 1088.19 9.08018L1088.29 9.45822C1088.34 9.6213 1088.32 9.76121 1088.24 9.87797C1088.17 9.99075 1088.07 10.067 1087.92 10.1067L1080.22 12.1684C1080.23 12.1832 1080.24 12.2129 1080.25 12.2573C1080.26 12.3018 1080.27 12.3389 1080.28 12.3685C1080.47 12.9684 1080.76 13.5034 1081.14 13.9736C1081.51 14.4289 1081.97 14.7601 1082.5 14.967C1083.05 15.17 1083.62 15.1901 1084.23 15.0272C1084.76 14.8842 1085.19 14.6835 1085.5 14.4251C1085.81 14.1667 1086.05 13.9113 1086.22 13.659C1086.39 13.3919 1086.5 13.1891 1086.54 13.0506C1086.62 12.837 1086.7 12.7054 1086.77 12.6559C1086.83 12.5915 1086.94 12.5375 1087.1 12.4938L1088.19 12.2019C1088.33 12.1661 1088.45 12.1808 1088.56 12.2459C1088.69 12.2922 1088.76 12.3915 1088.78 12.5437C1088.83 12.7701 1088.78 13.0761 1088.65 13.4619C1088.51 13.8328 1088.28 14.2295 1087.94 14.6521C1087.63 15.0706 1087.19 15.4651 1086.64 15.8356C1086.1 16.1872 1085.45 16.4643 1084.69 16.6669ZM1079.81 10.634L1085.91 9.00135L1085.89 8.93463C1085.71 8.2675 1085.42 7.70827 1085.03 7.25692C1084.66 6.8016 1084.2 6.48726 1083.66 6.3139C1083.12 6.12571 1082.53 6.11703 1081.89 6.28784C1081.25 6.45865 1080.74 6.76129 1080.37 7.19576C1080 7.61144 1079.77 8.11049 1079.67 8.69293C1079.58 9.27537 1079.62 9.90015 1079.79 10.5673L1079.81 10.634Z" fill="#9EA1B1"/>
<path d="M1075.14 18.9897C1074.99 19.0294 1074.85 19.0187 1074.72 18.9576C1074.61 18.8776 1074.53 18.7635 1074.49 18.6153L1071.66 8.07462C1071.62 7.92637 1071.64 7.79585 1071.7 7.68307C1071.78 7.55149 1071.89 7.46583 1072.04 7.42611L1073.11 7.1401C1073.25 7.10037 1073.39 7.12048 1073.5 7.20042C1073.63 7.26157 1073.71 7.36627 1073.75 7.51452L1076.58 18.0552C1076.62 18.2034 1076.6 18.3433 1076.52 18.4749C1076.46 18.5877 1076.35 18.664 1076.2 18.7037L1075.14 18.9897ZM1071.28 5.31672C1071.13 5.35645 1071 5.34574 1070.87 5.28459C1070.75 5.20465 1070.67 5.09055 1070.63 4.9423L1070.31 3.74147C1070.27 3.59322 1070.28 3.45529 1070.34 3.32768C1070.42 3.19609 1070.53 3.11044 1070.68 3.07072L1072.08 2.69533C1072.23 2.6556 1072.37 2.67373 1072.5 2.7497C1072.63 2.82567 1072.72 2.93777 1072.76 3.08603L1073.08 4.28686C1073.12 4.43511 1073.1 4.57503 1073.03 4.70661C1072.95 4.82337 1072.83 4.90161 1072.68 4.94133L1071.28 5.31672Z" fill="#9EA1B1"/>
<path d="M1070.45 20.2445C1069.62 20.467 1068.91 20.492 1068.3 20.3197C1067.7 20.1326 1067.2 19.7818 1066.81 19.2671C1066.41 18.7377 1066.1 18.0727 1065.89 17.2721L1064.32 11.4014L1062.58 11.8661C1062.43 11.9059 1062.3 11.8952 1062.17 11.834C1062.05 11.7541 1061.97 11.64 1061.93 11.4917L1061.73 10.7356C1061.69 10.5874 1061.7 10.4569 1061.77 10.3441C1061.85 10.2125 1061.96 10.1269 1062.11 10.0871L1063.84 9.62237L1062.84 5.90867C1062.81 5.76042 1062.82 5.62991 1062.88 5.51712C1062.96 5.38554 1063.07 5.29989 1063.22 5.26016L1064.26 4.98011C1064.41 4.94038 1064.55 4.96049 1064.66 5.04044C1064.79 5.10158 1064.87 5.20628 1064.91 5.35453L1065.91 9.06822L1068.67 8.32936C1068.83 8.28566 1068.97 8.30379 1069.09 8.38373C1069.2 8.44884 1069.27 8.55553 1069.31 8.70378L1069.52 9.45986C1069.56 9.60811 1069.55 9.74604 1069.48 9.87365C1069.42 9.98644 1069.31 10.0647 1069.14 10.1084L1066.38 10.8472L1067.92 16.5623C1068.1 17.2591 1068.37 17.7758 1068.71 18.1126C1069.06 18.4493 1069.53 18.5362 1070.14 18.3733L1071.5 18.0099C1071.65 17.9702 1071.78 17.9903 1071.9 18.0702C1072.02 18.1313 1072.11 18.236 1072.15 18.3843L1072.36 19.1849C1072.4 19.3331 1072.38 19.473 1072.31 19.6046C1072.24 19.7174 1072.13 19.7936 1071.99 19.8334L1070.45 20.2445Z" fill="#9EA1B1"/>
<path d="M1061.06 22.7605C1060.92 22.8002 1060.78 22.7895 1060.65 22.7283C1060.53 22.6484 1060.46 22.5343 1060.42 22.386L1057.59 11.8454C1057.55 11.6971 1057.56 11.5666 1057.63 11.4538C1057.71 11.3222 1057.82 11.2366 1057.97 11.1969L1059.03 10.9108C1059.18 10.8711 1059.31 10.8912 1059.43 10.9712C1059.56 11.0323 1059.64 11.137 1059.68 11.2853L1062.51 21.8259C1062.55 21.9742 1062.53 22.1141 1062.45 22.2457C1062.39 22.3585 1062.28 22.4347 1062.13 22.4744L1061.06 22.7605ZM1057.21 9.08747C1057.06 9.1272 1056.92 9.11649 1056.8 9.05534C1056.68 8.9754 1056.6 8.86131 1056.56 8.71305L1056.24 7.51222C1056.2 7.36397 1056.21 7.22604 1056.27 7.09843C1056.35 6.96685 1056.46 6.88119 1056.61 6.84147L1058.01 6.46608C1058.16 6.42636 1058.3 6.44448 1058.43 6.52045C1058.56 6.59642 1058.65 6.70853 1058.69 6.85678L1059.01 8.05761C1059.05 8.20586 1059.03 8.34578 1058.95 8.47736C1058.87 8.59412 1058.76 8.67236 1058.61 8.71208L1057.21 9.08747Z" fill="#9EA1B1"/>
<path d="M1056.38 24.015C1055.55 24.2375 1054.83 24.2625 1054.23 24.0903C1053.62 23.9031 1053.13 23.5523 1052.73 23.0376C1052.34 22.5082 1052.03 21.8432 1051.82 21.0426L1050.24 15.1719L1048.51 15.6367C1048.36 15.6764 1048.22 15.6657 1048.1 15.6045C1047.98 15.5246 1047.9 15.4105 1047.86 15.2622L1047.66 14.5062C1047.62 14.3579 1047.63 14.2274 1047.7 14.1146C1047.77 13.983 1047.88 13.8974 1048.03 13.8576L1049.77 13.3929L1048.77 9.67918C1048.73 9.53093 1048.75 9.40041 1048.81 9.28763C1048.89 9.15605 1049 9.07039 1049.15 9.03067L1050.19 8.75062C1050.34 8.71089 1050.47 8.731 1050.59 8.81094C1050.72 8.87209 1050.8 8.97679 1050.84 9.12504L1051.84 12.8387L1054.59 12.0999C1054.76 12.0562 1054.9 12.0743 1055.01 12.1542C1055.13 12.2194 1055.2 12.326 1055.24 12.4743L1055.44 13.2304C1055.48 13.3786 1055.47 13.5166 1055.41 13.6442C1055.35 13.7569 1055.23 13.8352 1055.07 13.8789L1052.31 14.6177L1053.84 20.3328C1054.03 21.0296 1054.3 21.5464 1054.64 21.8831C1054.99 22.2198 1055.46 22.3067 1056.07 22.1439L1057.43 21.7804C1057.57 21.7407 1057.71 21.7608 1057.82 21.8407C1057.95 21.9019 1058.03 22.0066 1058.07 22.1548L1058.29 22.9554C1058.33 23.1036 1058.31 23.2435 1058.23 23.3751C1058.17 23.4879 1058.06 23.5641 1057.91 23.6039L1056.38 24.015Z" fill="#9EA1B1"/>
<path d="M1039.04 28.6609C1038.89 28.7006 1038.76 28.6899 1038.63 28.6288C1038.51 28.5488 1038.43 28.4347 1038.39 28.2865L1035.57 17.7458C1035.53 17.5976 1035.54 17.467 1035.61 17.3543C1035.68 17.2227 1035.8 17.137 1035.94 17.0973L1036.99 16.8172C1037.14 16.7775 1037.27 16.7976 1037.39 16.8776C1037.51 16.9387 1037.6 17.0434 1037.64 17.1917L1037.9 18.1701C1038.15 17.5628 1038.52 17.026 1039.02 16.5597C1039.52 16.0747 1040.24 15.709 1041.15 15.4627C1042.12 15.2045 1042.99 15.201 1043.77 15.4522C1044.57 15.6846 1045.24 16.1331 1045.78 16.7978C1046.33 17.4437 1046.74 18.2633 1047.01 19.2566L1048.69 25.5277C1048.73 25.6759 1048.71 25.8158 1048.64 25.9474C1048.57 26.0602 1048.46 26.1364 1048.32 26.1762L1047.2 26.4741C1047.06 26.5138 1046.92 26.5031 1046.79 26.442C1046.67 26.362 1046.59 26.2479 1046.56 26.0997L1044.9 19.9398C1044.63 18.9021 1044.16 18.1616 1043.5 17.7185C1042.84 17.2606 1042.02 17.1627 1041.04 17.4249C1040.12 17.6712 1039.46 18.1663 1039.05 18.9102C1038.66 19.6354 1038.6 20.5168 1038.88 21.5546L1040.53 27.7144C1040.57 27.8627 1040.55 28.0026 1040.47 28.1342C1040.41 28.247 1040.3 28.3232 1040.15 28.363L1039.04 28.6609Z" fill="#9EA1B1"/>
<path d="M1030.77 31.1151C1029.23 31.5282 1027.88 31.389 1026.73 30.6973C1025.57 29.9908 1024.73 28.8341 1024.2 27.2272C1024.13 27.0384 1024.06 26.7958 1023.98 26.4993C1023.9 26.188 1023.84 25.9339 1023.8 25.7373C1023.58 24.6688 1023.58 23.6841 1023.8 22.7831C1024.01 21.8674 1024.43 21.0952 1025.06 20.4667C1025.7 19.8342 1026.52 19.3829 1027.53 19.1127C1028.66 18.8108 1029.66 18.7958 1030.55 19.0676C1031.45 19.3354 1032.21 19.8531 1032.85 20.6205C1033.48 21.3879 1033.95 22.3572 1034.27 23.5284L1034.37 23.9065C1034.41 24.0695 1034.4 24.2095 1034.32 24.3262C1034.25 24.439 1034.14 24.5152 1034 24.555L1026.3 26.6166C1026.31 26.6315 1026.31 26.6611 1026.33 26.7056C1026.34 26.7501 1026.35 26.7871 1026.36 26.8168C1026.55 27.4167 1026.83 27.9517 1027.21 28.4218C1027.59 28.8771 1028.04 29.2083 1028.58 29.4153C1029.12 29.6183 1029.7 29.6384 1030.31 29.4755C1030.84 29.3325 1031.27 29.1318 1031.58 28.8734C1031.89 28.6149 1032.13 28.3596 1032.3 28.1073C1032.47 27.8401 1032.57 27.6373 1032.62 27.4989C1032.7 27.2852 1032.78 27.1536 1032.84 27.1041C1032.91 27.0398 1033.02 26.9858 1033.18 26.9421L1034.27 26.6501C1034.4 26.6144 1034.53 26.629 1034.64 26.6942C1034.76 26.7405 1034.84 26.8397 1034.86 26.992C1034.91 27.2183 1034.86 27.5244 1034.73 27.9101C1034.59 28.281 1034.35 28.6777 1034.02 29.1003C1033.7 29.5189 1033.27 29.9134 1032.72 30.2838C1032.18 30.6354 1031.53 30.9125 1030.77 31.1151ZM1025.89 25.0822L1031.98 23.4496L1031.97 23.3829C1031.79 22.7157 1031.5 22.1565 1031.11 21.7052C1030.73 21.2498 1030.28 20.9355 1029.74 20.7621C1029.19 20.574 1028.6 20.5653 1027.97 20.7361C1027.33 20.9069 1026.82 21.2095 1026.45 21.644C1026.08 22.0597 1025.85 22.5587 1025.75 23.1412C1025.65 23.7236 1025.69 24.3484 1025.87 25.0155L1025.89 25.0822Z" fill="#9EA1B1"/>
<path d="M1017.15 34.7658C1016.33 34.9843 1015.59 35.0321 1014.92 34.9093C1014.25 34.7717 1013.65 34.5099 1013.14 34.124C1012.63 33.7193 1012.2 33.224 1011.83 32.6381C1011.49 32.0483 1011.2 31.4016 1010.98 30.6979C1010.9 30.4647 1010.84 30.2443 1010.78 30.0367C1010.72 29.8292 1010.67 29.6048 1010.62 29.3637C1010.47 28.6589 1010.39 27.964 1010.4 27.2788C1010.42 26.5897 1010.55 25.9435 1010.78 25.3401C1011.04 24.7328 1011.42 24.2088 1011.94 23.7683C1012.45 23.3129 1013.11 22.9759 1013.93 22.7574C1014.8 22.5231 1015.57 22.4841 1016.23 22.6405C1016.9 22.7969 1017.47 23.0552 1017.97 23.4155L1016.6 18.3008C1016.56 18.1526 1016.57 18.0221 1016.64 17.9093C1016.71 17.7777 1016.82 17.692 1016.97 17.6523L1018.04 17.3663C1018.19 17.3266 1018.32 17.3467 1018.44 17.4266C1018.56 17.4878 1018.65 17.5925 1018.69 17.7407L1022.64 32.5065C1022.68 32.6548 1022.67 32.7947 1022.59 32.9263C1022.52 33.0391 1022.42 33.1153 1022.27 33.1551L1021.27 33.4232C1021.11 33.4669 1020.97 33.4562 1020.85 33.3911C1020.74 33.3111 1020.66 33.197 1020.62 33.0488L1020.37 32.1148C1020.13 32.6885 1019.75 33.2179 1019.25 33.7029C1018.74 34.1732 1018.04 34.5274 1017.15 34.7658ZM1017.13 32.8394C1017.87 32.6408 1018.42 32.3114 1018.77 31.8512C1019.13 31.3911 1019.35 30.8718 1019.43 30.2933C1019.51 29.7 1019.48 29.1271 1019.35 28.5746C1019.3 28.3335 1019.23 28.0498 1019.15 27.7236C1019.05 27.3827 1018.97 27.0956 1018.89 26.8623C1018.74 26.3474 1018.47 25.8697 1018.1 25.4292C1017.74 24.9848 1017.29 24.661 1016.75 24.458C1016.21 24.251 1015.59 24.2429 1014.88 24.4336C1014.12 24.6361 1013.57 24.9675 1013.22 25.4277C1012.86 25.873 1012.66 26.3957 1012.61 26.9959C1012.56 27.5813 1012.6 28.1892 1012.74 28.8198C1012.84 29.2537 1012.96 29.6837 1013.09 30.1096C1013.28 30.7243 1013.55 31.2801 1013.89 31.777C1014.23 32.2591 1014.66 32.611 1015.2 32.8328C1015.73 33.0398 1016.38 33.042 1017.13 32.8394Z" fill="#9EA1B1"/>
<path d="M1007.58 37.0907C1007.42 37.1344 1007.28 37.1237 1007.17 37.0586C1007.05 36.9786 1006.97 36.8645 1006.93 36.7163L1003.04 22.1728C1003 22.0246 1003.01 21.8941 1003.08 21.7813C1003.14 21.6537 1003.25 21.568 1003.41 21.5243L1004.59 21.2085C1004.75 21.1648 1004.89 21.183 1005.01 21.2629C1005.12 21.328 1005.2 21.4347 1005.24 21.5829L1009.14 36.1264C1009.18 36.2746 1009.16 36.4126 1009.1 36.5402C1009.04 36.653 1008.92 36.7312 1008.76 36.7749L1007.58 37.0907Z" fill="#9EA1B1"/>
<rect x="788.399" y="162.854" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 788.399 162.854)" fill="#0294F7"/>
<path d="M914.968 158.054C914.835 158.089 914.703 158.069 914.571 157.993C914.439 157.917 914.356 157.813 914.32 157.679L914.111 156.901C914.072 156.753 914.082 156.615 914.144 156.487C914.223 156.37 914.323 156.296 914.441 156.264C915.06 156.083 915.535 155.781 915.867 155.358C916.213 154.932 916.423 154.351 916.497 153.616C916.57 152.882 916.521 151.957 916.349 150.843C916.174 149.714 915.874 148.357 915.449 146.771C915.024 145.184 914.607 143.866 914.198 142.815C913.786 141.75 913.364 140.918 912.933 140.318C912.503 139.719 912.032 139.328 911.523 139.147C911.025 138.947 910.462 138.923 909.835 139.075C909.717 139.106 909.592 139.084 909.46 139.008C909.343 138.928 909.267 138.822 909.231 138.688L909.023 137.91C908.987 137.777 909.007 137.644 909.083 137.513C909.159 137.381 909.264 137.297 909.397 137.262C910.361 137.003 911.23 136.985 912.004 137.206C912.779 137.428 913.479 137.908 914.106 138.645C914.743 139.364 915.328 140.36 915.859 141.632C916.391 142.903 916.899 144.444 917.383 146.252C917.868 148.061 918.198 149.649 918.374 151.016C918.546 152.368 918.537 153.522 918.348 154.479C918.175 155.431 917.808 156.197 917.248 156.776C916.692 157.37 915.932 157.796 914.968 158.054Z" fill="#9EA1B1"/>
<path d="M898.484 158.681C898.173 158.765 897.977 158.658 897.898 158.362C897.874 158.273 897.882 158.183 897.921 158.093L905.034 140.695C905.102 140.534 905.17 140.404 905.239 140.306C905.323 140.204 905.462 140.128 905.654 140.076L906.388 139.879C906.699 139.796 906.895 139.902 906.974 140.199C906.998 140.288 906.99 140.377 906.951 140.467L899.861 157.859C899.793 158.021 899.717 158.152 899.633 158.254C899.564 158.352 899.425 158.429 899.218 158.485L898.484 158.681ZM908.705 156.086C907.741 156.344 906.904 156.274 906.194 155.876C905.498 155.475 905.002 154.837 904.704 153.964C904.586 153.582 904.491 153.258 904.42 152.991C904.344 152.71 904.258 152.359 904.162 151.94C903.983 151.035 904.079 150.238 904.451 149.551C904.834 148.844 905.537 148.354 906.56 148.08C907.597 147.802 908.451 147.875 909.121 148.299C909.802 148.705 910.291 149.344 910.588 150.218C910.729 150.625 910.837 150.97 910.913 151.251C910.984 151.518 911.057 151.848 911.131 152.242C911.31 153.147 911.191 153.95 910.775 154.649C910.373 155.345 909.683 155.823 908.705 156.086ZM908.311 154.618C908.712 154.511 909.001 154.346 909.18 154.123C909.359 153.9 909.468 153.657 909.508 153.391C909.544 153.112 909.536 152.844 909.483 152.588C909.406 152.18 909.335 151.857 909.272 151.62C909.208 151.382 909.114 151.09 908.989 150.742C908.867 150.346 908.642 150.009 908.313 149.731C907.984 149.454 907.531 149.393 906.953 149.548C906.389 149.699 906.035 149.976 905.889 150.381C905.758 150.781 905.731 151.186 905.809 151.594C905.889 151.954 905.961 152.252 906.025 152.49C906.089 152.727 906.181 153.044 906.303 153.44C906.401 153.684 906.528 153.92 906.684 154.148C906.851 154.358 907.068 154.514 907.334 154.618C907.615 154.717 907.941 154.717 908.311 154.618ZM898.272 150.42C897.294 150.682 896.461 150.627 895.773 150.255C895.086 149.883 894.593 149.26 894.296 148.387C894.178 148.005 894.083 147.681 894.011 147.414C893.936 147.133 893.85 146.782 893.753 146.363C893.56 145.462 893.656 144.665 894.043 143.974C894.425 143.267 895.128 142.777 896.151 142.503C897.189 142.225 898.043 142.298 898.713 142.722C899.393 143.128 899.875 143.77 900.158 144.647C900.299 145.054 900.407 145.399 900.482 145.68C900.554 145.947 900.626 146.277 900.7 146.671C900.894 147.572 900.779 148.358 900.354 149.028C899.945 149.693 899.251 150.158 898.272 150.42ZM897.903 149.041C898.288 148.938 898.571 148.775 898.749 148.552C898.943 148.325 899.06 148.08 899.1 147.815C899.136 147.535 899.128 147.267 899.075 147.011C898.998 146.603 898.929 146.287 898.869 146.065C898.806 145.828 898.71 145.528 898.581 145.165C898.458 144.769 898.226 144.434 897.882 144.16C897.554 143.883 897.108 143.82 896.544 143.971C895.981 144.122 895.627 144.399 895.481 144.804C895.35 145.205 895.323 145.609 895.401 146.017C895.485 146.392 895.559 146.698 895.623 146.935C895.682 147.157 895.773 147.467 895.895 147.863C895.992 148.107 896.119 148.343 896.276 148.571C896.443 148.781 896.66 148.937 896.926 149.041C897.192 149.144 897.518 149.144 897.903 149.041Z" fill="#9EA1B1"/>
<path d="M889.054 161.446C888.031 161.721 887.122 161.797 886.327 161.677C885.542 161.537 884.852 161.245 884.257 160.801C883.661 160.357 883.162 159.799 882.76 159.129C882.373 158.454 882.055 157.713 881.807 156.905C881.685 156.509 881.557 156.09 881.423 155.65C881.303 155.205 881.182 154.753 881.059 154.293C880.951 153.83 880.848 153.388 880.752 152.969C880.548 152.15 880.453 151.349 880.466 150.567C880.494 149.781 880.656 149.054 880.954 148.387C881.248 147.704 881.702 147.114 882.315 146.616C882.939 146.099 883.755 145.705 884.763 145.435C885.786 145.161 886.69 145.094 887.474 145.233C888.269 145.354 888.964 145.636 889.56 146.081C890.152 146.51 890.649 147.06 891.051 147.731C891.468 148.398 891.793 149.137 892.027 149.948C892.153 150.359 892.277 150.795 892.4 151.254C892.538 151.71 892.659 152.162 892.764 152.611C892.883 153.056 892.989 153.48 893.081 153.884C893.285 154.704 893.373 155.506 893.345 156.292C893.332 157.074 893.179 157.807 892.885 158.489C892.606 159.168 892.154 159.765 891.53 160.282C890.917 160.78 890.091 161.168 889.054 161.446ZM888.541 159.534C889.697 159.224 890.449 158.618 890.795 157.715C891.155 156.808 891.166 155.692 890.828 154.369C890.742 153.931 890.646 153.512 890.538 153.112C890.427 152.697 890.318 152.289 890.211 151.889C890.099 151.474 889.975 151.07 889.838 150.677C889.478 149.392 888.913 148.439 888.143 147.819C887.384 147.18 886.426 147.016 885.27 147.325C884.128 147.631 883.381 148.253 883.028 149.189C882.686 150.107 882.673 151.215 882.989 152.513C883.097 152.913 883.198 153.323 883.295 153.742C883.402 154.142 883.511 154.55 883.623 154.965C883.745 155.361 883.863 155.774 883.978 156.204C884.362 157.516 884.936 158.474 885.702 159.079C886.468 159.684 887.414 159.836 888.541 159.534Z" fill="#9EA1B1"/>
<path d="M875.293 165.134C874.122 165.447 873.075 165.513 872.152 165.332C871.24 165.131 870.482 164.762 869.877 164.225C869.288 163.684 868.88 163.054 868.656 162.336C868.606 162.206 868.615 162.092 868.684 161.995C868.749 161.882 868.848 161.807 868.982 161.772L870.183 161.45C870.316 161.414 870.444 161.419 870.568 161.466C870.688 161.497 870.803 161.601 870.914 161.778C871.209 162.287 871.568 162.676 871.989 162.944C872.421 163.194 872.874 163.342 873.348 163.39C873.833 163.419 874.312 163.37 874.786 163.243C875.424 163.073 875.968 162.792 876.42 162.401C876.882 161.991 877.201 161.492 877.377 160.905C877.55 160.302 877.538 159.638 877.344 158.911C877.165 158.244 876.856 157.715 876.418 157.324C875.99 156.914 875.476 156.655 874.875 156.546C874.284 156.418 873.663 156.442 873.011 156.616C872.522 156.748 872.137 156.914 871.858 157.116C871.578 157.318 871.349 157.531 871.17 157.753C871.006 157.972 870.851 158.164 870.705 158.331C870.574 158.493 870.405 158.602 870.197 158.657L869.041 158.967C868.907 159.003 868.777 158.99 868.649 158.929C868.517 158.853 868.441 158.747 868.42 158.609L867.142 150.991C867.109 150.809 867.125 150.662 867.19 150.549C867.266 150.418 867.386 150.33 867.549 150.286L875.31 148.207C875.458 148.167 875.59 148.187 875.707 148.267C875.835 148.328 875.918 148.433 875.958 148.581L876.191 149.448C876.234 149.611 876.216 149.751 876.136 149.868C876.071 149.981 875.964 150.057 875.816 150.097L869.412 151.813L870.163 156.307C870.35 156.114 870.642 155.869 871.039 155.572C871.447 155.256 872.051 154.991 872.851 154.776C873.593 154.578 874.312 154.504 875.009 154.556C875.721 154.603 876.379 154.777 876.983 155.075C877.603 155.37 878.136 155.791 878.585 156.338C879.029 156.871 879.359 157.537 879.574 158.338C879.875 159.465 879.887 160.486 879.608 161.403C879.33 162.32 878.816 163.101 878.067 163.747C877.315 164.377 876.39 164.84 875.293 165.134Z" fill="#9EA1B1"/>
<path d="M868.927 170.39C867.964 170.649 867.093 170.66 866.314 170.423C865.54 170.202 864.839 169.722 864.213 168.984C863.586 168.247 863.001 167.251 862.459 165.998C861.928 164.726 861.42 163.186 860.935 161.378C860.45 159.569 860.12 157.981 859.945 156.614C859.784 155.243 859.792 154.089 859.97 153.151C860.144 152.199 860.511 151.433 861.071 150.854C861.631 150.275 862.392 149.856 863.356 149.598C863.504 149.559 863.637 149.579 863.753 149.659C863.885 149.735 863.969 149.839 864.004 149.973L864.213 150.751C864.249 150.884 864.229 151.017 864.153 151.149C864.092 151.276 864.009 151.354 863.905 151.382C863.287 151.563 862.804 151.867 862.458 152.294C862.122 152.702 861.91 153.275 861.822 154.013C861.749 154.748 861.8 155.68 861.975 156.809C862.161 157.919 862.467 159.267 862.892 160.853C863.317 162.439 863.728 163.767 864.126 164.837C864.535 165.887 864.954 166.712 865.385 167.312C865.831 167.907 866.303 168.305 866.801 168.505C867.315 168.701 867.885 168.723 868.511 168.571C868.615 168.544 868.723 168.562 868.836 168.627C868.968 168.703 869.053 168.815 869.093 168.964L869.302 169.742C869.337 169.875 869.317 170.008 869.241 170.139C869.18 170.267 869.075 170.351 868.927 170.39Z" fill="#9EA1B1"/>
<path d="M844.796 173.067C844.648 173.106 844.508 173.088 844.377 173.012C844.245 172.936 844.16 172.824 844.12 172.676L840.241 158.199C840.197 158.036 840.213 157.889 840.289 157.757C840.365 157.626 840.477 157.54 840.626 157.5L842.582 156.976C842.745 156.932 842.893 156.948 843.024 157.024C843.156 157.1 843.244 157.22 843.287 157.383L844.682 162.587L848.271 155.881C848.311 155.791 848.385 155.683 848.495 155.559C848.615 155.415 848.794 155.312 849.031 155.248L851.233 154.658C851.351 154.626 851.467 154.643 851.58 154.708C851.708 154.769 851.789 154.867 851.825 155C851.853 155.104 851.847 155.201 851.808 155.291L847.492 163.645L856.002 169.254C856.1 169.323 856.163 169.409 856.19 169.513C856.226 169.647 856.204 169.772 856.124 169.888C856.059 170.001 855.967 170.073 855.849 170.105L853.558 170.719C853.306 170.787 853.092 170.788 852.916 170.724C852.751 170.641 852.64 170.584 852.584 170.551L845.623 166.1L847.166 171.86C847.206 172.008 847.188 172.148 847.112 172.279C847.036 172.411 846.916 172.499 846.753 172.542L844.796 173.067Z" fill="white"/>
<path d="M835.496 175.797C834.458 176.075 833.527 176.189 832.704 176.14C831.88 176.09 831.162 175.933 830.551 175.668C829.951 175.384 829.461 175.038 829.082 174.631C828.699 174.21 828.436 173.764 828.294 173.293C828.258 173.16 828.275 173.044 828.344 172.946C828.424 172.829 828.531 172.753 828.664 172.717L830.666 172.181C830.814 172.141 830.948 172.137 831.067 172.169C831.187 172.2 831.308 172.295 831.43 172.453C831.67 172.818 831.971 173.079 832.331 173.237C832.706 173.39 833.107 173.465 833.535 173.462C833.959 173.444 834.394 173.375 834.839 173.256C835.728 173.017 836.377 172.621 836.784 172.067C837.203 171.494 837.307 170.815 837.096 170.029C836.886 169.243 836.49 168.746 835.91 168.536C835.325 168.311 834.595 168.316 833.721 168.55L831.43 169.164C831.267 169.208 831.122 169.199 830.994 169.138C830.863 169.062 830.775 168.942 830.731 168.779L830.481 167.845C830.441 167.697 830.437 167.563 830.469 167.443C830.511 167.305 830.559 167.189 830.614 167.095L833.551 162.136L827.191 163.841C827.028 163.884 826.881 163.868 826.749 163.792C826.633 163.712 826.554 163.598 826.515 163.45L826.121 161.982C826.078 161.819 826.086 161.674 826.148 161.546C826.224 161.415 826.343 161.327 826.506 161.283L836.046 158.727C836.209 158.683 836.356 158.699 836.488 158.775C836.62 158.851 836.707 158.971 836.751 159.134L837.109 160.468C837.144 160.602 837.146 160.728 837.115 160.848C837.083 160.968 837.041 161.074 836.986 161.168L834.2 166.158L834.473 166.108C835.397 165.94 836.253 165.933 837.041 166.087C837.84 166.223 838.518 166.558 839.074 167.092C839.645 167.622 840.06 168.369 840.318 169.333C840.588 170.341 840.554 171.28 840.215 172.149C839.886 173 839.314 173.741 838.498 174.373C837.683 175.004 836.682 175.479 835.496 175.797Z" fill="white"/>
<path d="M824.438 178.522C824.29 178.561 824.15 178.543 824.018 178.467C823.887 178.391 823.801 178.279 823.761 178.131L823.171 175.929C823.128 175.766 823.144 175.619 823.22 175.487C823.296 175.356 823.408 175.27 823.556 175.23L825.78 174.635C825.928 174.595 826.068 174.613 826.2 174.689C826.331 174.765 826.419 174.884 826.463 175.047L827.052 177.249C827.092 177.397 827.074 177.537 826.998 177.669C826.922 177.8 826.81 177.886 826.662 177.926L824.438 178.522Z" fill="white"/>
<path d="M815.783 181.079C814.508 181.421 813.347 181.478 812.301 181.25C811.251 181.007 810.364 180.545 809.642 179.865C808.915 179.17 808.415 178.31 808.141 177.288C808.018 176.828 807.958 176.367 807.961 175.906C807.965 175.444 808.011 174.995 808.101 174.557C808.19 174.12 808.284 173.73 808.382 173.386C808.492 173.023 808.597 172.732 808.697 172.515L811.271 165.843C811.311 165.753 811.376 165.64 811.466 165.504C811.553 165.354 811.7 165.251 811.908 165.195L813.976 164.641C814.11 164.605 814.235 164.627 814.351 164.707C814.464 164.772 814.538 164.872 814.574 165.005C814.59 165.064 814.591 165.128 814.577 165.195C814.574 165.243 814.562 165.286 814.54 165.324L812.583 170.472C812.705 170.392 812.852 170.321 813.026 170.258C813.2 170.196 813.361 170.145 813.51 170.105C814.255 169.921 814.999 169.881 815.741 169.984C816.48 170.072 817.165 170.285 817.796 170.625C818.427 170.964 818.969 171.415 819.421 171.977C819.889 172.535 820.224 173.192 820.426 173.948C820.689 174.926 820.688 175.904 820.425 176.88C820.159 177.841 819.633 178.697 818.849 179.447C818.08 180.194 817.058 180.738 815.783 181.079ZM815.075 178.528C815.609 178.385 816.068 178.143 816.454 177.801C816.854 177.456 817.137 177.03 817.303 176.525C817.47 176.019 817.468 175.448 817.297 174.81C817.13 174.188 816.848 173.699 816.451 173.345C816.054 172.99 815.596 172.763 815.077 172.664C814.573 172.561 814.054 172.581 813.52 172.724C812.986 172.867 812.52 173.111 812.12 173.457C811.734 173.798 811.459 174.222 811.292 174.727C811.126 175.233 811.126 175.797 811.293 176.419C811.463 177.057 811.747 177.553 812.144 177.907C812.541 178.262 812.992 178.49 813.496 178.594C814.015 178.693 814.542 178.671 815.075 178.528Z" fill="white"/>
<rect x="941.284" y="121.889" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 941.284 121.889)" fill="#D057FF"/>
<path d="M1062.14 118.619C1062.01 118.654 1061.88 118.634 1061.74 118.558C1061.61 118.482 1061.53 118.378 1061.49 118.244L1061.28 117.466C1061.24 117.318 1061.26 117.18 1061.32 117.052C1061.4 116.935 1061.5 116.861 1061.61 116.829C1062.23 116.648 1062.71 116.345 1063.04 115.923C1063.39 115.496 1063.6 114.916 1063.67 114.181C1063.74 113.446 1063.69 112.522 1063.52 111.408C1063.35 110.279 1063.05 108.922 1062.62 107.335C1062.2 105.749 1061.78 104.431 1061.37 103.38C1060.96 102.315 1060.54 101.483 1060.11 100.883C1059.68 100.283 1059.21 99.8929 1058.7 99.7116C1058.2 99.5115 1057.63 99.4875 1057.01 99.6395C1056.89 99.6713 1056.76 99.6492 1056.63 99.5732C1056.52 99.4933 1056.44 99.3866 1056.4 99.2532L1056.2 98.4748C1056.16 98.3414 1056.18 98.2089 1056.26 98.0773C1056.33 97.9458 1056.44 97.8621 1056.57 97.8263C1057.53 97.5681 1058.4 97.5498 1059.18 97.7713C1059.95 97.9928 1060.65 98.4725 1061.28 99.2103C1061.92 99.9292 1062.5 100.925 1063.03 102.196C1063.56 103.468 1064.07 105.008 1064.56 106.817C1065.04 108.626 1065.37 110.214 1065.55 111.581C1065.72 112.933 1065.71 114.087 1065.52 115.043C1065.35 115.996 1064.98 116.761 1064.42 117.34C1063.86 117.934 1063.1 118.36 1062.14 118.619Z" fill="#9EA1B1"/>
<path d="M1045.65 119.246C1045.34 119.33 1045.15 119.223 1045.07 118.927C1045.04 118.838 1045.05 118.748 1045.09 118.658L1052.2 101.26C1052.27 101.099 1052.34 100.97 1052.41 100.872C1052.49 100.77 1052.63 100.693 1052.83 100.641L1053.56 100.445C1053.87 100.361 1054.07 100.468 1054.15 100.764C1054.17 100.853 1054.16 100.943 1054.12 101.033L1047.03 118.425C1046.96 118.586 1046.89 118.718 1046.8 118.819C1046.73 118.917 1046.6 118.994 1046.39 119.05L1045.65 119.246ZM1055.88 116.651C1054.91 116.909 1054.07 116.839 1053.36 116.442C1052.67 116.04 1052.17 115.403 1051.87 114.529C1051.76 114.148 1051.66 113.823 1051.59 113.557C1051.51 113.275 1051.43 112.925 1051.33 112.505C1051.15 111.6 1051.25 110.804 1051.62 110.116C1052 109.41 1052.71 108.919 1053.73 108.645C1054.77 108.367 1055.62 108.44 1056.29 108.865C1056.97 109.27 1057.46 109.91 1057.76 110.783C1057.9 111.191 1058.01 111.535 1058.08 111.817C1058.16 112.084 1058.23 112.414 1058.3 112.807C1058.48 113.712 1058.36 114.515 1057.95 115.214C1057.54 115.91 1056.85 116.389 1055.88 116.651ZM1055.48 115.183C1055.88 115.076 1056.17 114.911 1056.35 114.688C1056.53 114.466 1056.64 114.222 1056.68 113.957C1056.72 113.677 1056.71 113.409 1056.65 113.153C1056.58 112.745 1056.51 112.422 1056.44 112.185C1056.38 111.948 1056.28 111.655 1056.16 111.307C1056.04 110.911 1055.81 110.574 1055.48 110.297C1055.16 110.019 1054.7 109.958 1054.12 110.113C1053.56 110.264 1053.21 110.542 1053.06 110.946C1052.93 111.347 1052.9 111.751 1052.98 112.159C1053.06 112.519 1053.13 112.818 1053.2 113.055C1053.26 113.292 1053.35 113.609 1053.47 114.005C1053.57 114.249 1053.7 114.485 1053.85 114.714C1054.02 114.923 1054.24 115.079 1054.5 115.183C1054.79 115.282 1055.11 115.282 1055.48 115.183ZM1045.44 110.985C1044.46 111.247 1043.63 111.192 1042.94 110.82C1042.26 110.449 1041.76 109.826 1041.47 108.952C1041.35 108.571 1041.25 108.246 1041.18 107.98C1041.11 107.698 1041.02 107.348 1040.92 106.929C1040.73 106.027 1040.83 105.231 1041.21 104.539C1041.6 103.833 1042.3 103.342 1043.32 103.068C1044.36 102.79 1045.21 102.863 1045.88 103.288C1046.56 103.693 1047.05 104.335 1047.33 105.212C1047.47 105.62 1047.58 105.964 1047.65 106.246C1047.72 106.513 1047.8 106.843 1047.87 107.236C1048.06 108.137 1047.95 108.923 1047.53 109.593C1047.12 110.259 1046.42 110.723 1045.44 110.985ZM1045.07 109.606C1045.46 109.503 1045.74 109.34 1045.92 109.117C1046.11 108.891 1046.23 108.645 1046.27 108.38C1046.31 108.1 1046.3 107.832 1046.25 107.576C1046.17 107.168 1046.1 106.853 1046.04 106.63C1045.98 106.393 1045.88 106.093 1045.75 105.73C1045.63 105.334 1045.4 104.999 1045.05 104.726C1044.72 104.448 1044.28 104.385 1043.72 104.536C1043.15 104.687 1042.8 104.965 1042.65 105.369C1042.52 105.77 1042.49 106.174 1042.57 106.582C1042.66 106.957 1042.73 107.263 1042.79 107.5C1042.85 107.723 1042.94 108.032 1043.07 108.428C1043.16 108.672 1043.29 108.908 1043.45 109.137C1043.61 109.346 1043.83 109.502 1044.1 109.606C1044.36 109.709 1044.69 109.71 1045.07 109.606Z" fill="#9EA1B1"/>
<path d="M1039.86 120.8C1039.71 120.84 1039.57 120.829 1039.45 120.768C1039.33 120.688 1039.25 120.574 1039.21 120.426L1035.87 107.972L1032.95 111.808C1032.85 111.929 1032.73 112 1032.6 112.02C1032.46 112.041 1032.33 112.004 1032.21 111.91L1031.43 111.331C1031.31 111.221 1031.24 111.098 1031.22 110.96C1031.21 110.819 1031.25 110.688 1031.35 110.567L1035.2 105.532C1035.28 105.43 1035.36 105.36 1035.45 105.321C1035.53 105.283 1035.63 105.249 1035.73 105.222L1036.87 104.918C1037.01 104.878 1037.15 104.898 1037.26 104.978C1037.39 105.039 1037.48 105.144 1037.52 105.292L1041.41 119.836C1041.45 119.984 1041.43 120.124 1041.36 120.255C1041.29 120.368 1041.19 120.444 1041.04 120.484L1039.86 120.8Z" fill="#9EA1B1"/>
<path d="M1027.44 124.365C1026.51 124.616 1025.66 124.723 1024.91 124.687C1024.15 124.637 1023.48 124.482 1022.9 124.224C1022.32 123.966 1021.84 123.64 1021.47 123.248C1021.11 122.838 1020.85 122.397 1020.71 121.927C1020.67 121.793 1020.69 121.677 1020.76 121.579C1020.83 121.467 1020.92 121.392 1021.06 121.357L1022.15 121.065C1022.28 121.029 1022.41 121.034 1022.53 121.081C1022.67 121.108 1022.79 121.21 1022.9 121.387C1023.19 121.881 1023.56 122.229 1023.99 122.43C1024.44 122.627 1024.92 122.721 1025.43 122.713C1025.94 122.685 1026.45 122.606 1026.93 122.475C1027.96 122.201 1028.72 121.734 1029.23 121.074C1029.74 120.414 1029.86 119.61 1029.61 118.661C1029.35 117.697 1028.87 117.085 1028.19 116.825C1027.5 116.565 1026.64 116.572 1025.62 116.846L1023.5 117.412C1023.36 117.452 1023.22 117.441 1023.09 117.38C1022.98 117.315 1022.9 117.201 1022.86 117.038L1022.7 116.437C1022.66 116.304 1022.65 116.187 1022.67 116.086C1022.7 115.966 1022.74 115.861 1022.78 115.771L1025.83 109.901L1019.27 111.659C1019.12 111.698 1018.98 111.688 1018.86 111.626C1018.74 111.561 1018.66 111.447 1018.62 111.284L1018.39 110.439C1018.35 110.276 1018.36 110.138 1018.43 110.025C1018.5 109.894 1018.61 109.808 1018.76 109.768L1027.64 107.391C1027.8 107.347 1027.94 107.365 1028.06 107.445C1028.18 107.506 1028.27 107.619 1028.31 107.782L1028.53 108.582C1028.55 108.686 1028.55 108.79 1028.52 108.895C1028.49 108.981 1028.46 109.069 1028.42 109.159L1025.41 115.09L1025.77 115.017C1026.76 114.785 1027.66 114.734 1028.47 114.866C1029.3 114.993 1030 115.329 1030.58 115.874C1031.16 116.401 1031.59 117.153 1031.85 118.132C1032.11 119.125 1032.1 120.035 1031.79 120.863C1031.49 121.691 1030.96 122.413 1030.21 123.029C1029.46 123.626 1028.54 124.071 1027.44 124.365Z" fill="#9EA1B1"/>
<path d="M1020.64 129.739C1019.68 129.998 1018.8 130.008 1018.03 129.772C1017.25 129.551 1016.55 129.071 1015.92 128.333C1015.3 127.595 1014.71 126.6 1014.17 125.347C1013.64 124.075 1013.13 122.535 1012.65 120.726C1012.16 118.918 1011.83 117.33 1011.66 115.963C1011.5 114.592 1011.5 113.437 1011.68 112.5C1011.86 111.548 1012.22 110.782 1012.78 110.203C1013.34 109.624 1014.1 109.205 1015.07 108.947C1015.22 108.907 1015.35 108.928 1015.47 109.007C1015.6 109.083 1015.68 109.188 1015.72 109.322L1015.92 110.1C1015.96 110.233 1015.94 110.366 1015.86 110.497C1015.8 110.625 1015.72 110.703 1015.62 110.731C1015 110.912 1014.52 111.216 1014.17 111.643C1013.83 112.051 1013.62 112.624 1013.53 113.362C1013.46 114.097 1013.51 115.029 1013.69 116.158C1013.87 117.268 1014.18 118.616 1014.6 120.202C1015.03 121.788 1015.44 123.116 1015.84 124.185C1016.25 125.236 1016.67 126.061 1017.1 126.66C1017.54 127.256 1018.01 127.654 1018.51 127.854C1019.03 128.05 1019.6 128.072 1020.22 127.92C1020.33 127.892 1020.44 127.911 1020.55 127.976C1020.68 128.052 1020.77 128.164 1020.81 128.313L1021.01 129.091C1021.05 129.224 1021.03 129.357 1020.95 129.488C1020.89 129.616 1020.79 129.7 1020.64 129.739Z" fill="#9EA1B1"/>
<path d="M996.508 132.415C996.36 132.455 996.22 132.437 996.089 132.361C995.957 132.285 995.871 132.173 995.832 132.025L991.953 117.548C991.909 117.385 991.925 117.238 992.001 117.106C992.077 116.974 992.189 116.889 992.337 116.849L994.294 116.325C994.457 116.281 994.605 116.297 994.736 116.373C994.868 116.449 994.956 116.569 994.999 116.732L996.394 121.935L999.983 115.229C1000.02 115.139 1000.1 115.032 1000.21 114.907C1000.33 114.764 1000.51 114.66 1000.74 114.597L1002.94 114.007C1003.06 113.975 1003.18 113.992 1003.29 114.057C1003.42 114.118 1003.5 114.215 1003.54 114.349C1003.56 114.452 1003.56 114.549 1003.52 114.639L999.204 122.994L1007.71 128.603C1007.81 128.672 1007.87 128.758 1007.9 128.862C1007.94 128.995 1007.92 129.12 1007.84 129.237C1007.77 129.35 1007.68 129.422 1007.56 129.454L1005.27 130.068C1005.02 130.135 1004.8 130.137 1004.63 130.073C1004.46 129.99 1004.35 129.932 1004.3 129.9L997.335 125.449L998.878 131.208C998.918 131.357 998.9 131.497 998.824 131.628C998.748 131.76 998.628 131.847 998.465 131.891L996.508 132.415Z" fill="white"/>
<path d="M984.605 135.604C984.472 135.64 984.349 135.626 984.236 135.56C984.119 135.48 984.043 135.374 984.007 135.24C983.987 135.166 983.979 135.105 983.982 135.057C983.999 135.004 984.012 134.961 984.018 134.927L986.078 129.537C985.816 129.687 985.52 129.798 985.19 129.871C984.43 130.058 983.688 130.106 982.964 130.014C982.251 129.903 981.589 129.684 980.976 129.355C980.375 129.008 979.852 128.568 979.407 128.036C978.973 127.484 978.659 126.846 978.465 126.119C978.286 125.452 978.237 124.766 978.318 124.061C978.395 123.341 978.609 122.656 978.959 122.006C979.324 121.352 979.838 120.778 980.5 120.283C981.172 119.769 982.013 119.377 983.021 119.107C984.014 118.84 984.926 118.747 985.758 118.826C986.59 118.905 987.325 119.129 987.964 119.498C988.614 119.848 989.15 120.308 989.573 120.878C990.011 121.444 990.325 122.083 990.516 122.795C990.687 123.432 990.742 124.053 990.681 124.657C990.621 125.261 990.496 125.835 990.308 126.378C990.131 126.902 989.951 127.419 989.77 127.928L987.31 134.403C987.271 134.493 987.208 134.613 987.121 134.764C987.045 134.895 986.896 134.991 986.673 135.05L984.605 135.604ZM985.248 127.329C985.781 127.186 986.233 126.945 986.604 126.608C986.985 126.251 987.246 125.832 987.387 125.349C987.538 124.848 987.537 124.308 987.382 123.73C987.223 123.137 986.954 122.669 986.576 122.325C986.209 121.963 985.773 121.73 985.269 121.627C984.761 121.508 984.247 121.519 983.728 121.658C983.195 121.801 982.737 122.051 982.356 122.407C981.986 122.745 981.725 123.164 981.573 123.666C981.432 124.148 981.441 124.686 981.6 125.279C981.755 125.857 982.016 126.328 982.383 126.69C982.761 127.034 983.197 127.266 983.691 127.388C984.195 127.492 984.714 127.472 985.248 127.329Z" fill="white"/>
<path d="M977.388 137.539C977.24 137.578 977.1 137.56 976.968 137.484C976.837 137.408 976.751 137.296 976.712 137.148L976.122 134.946C976.078 134.783 976.094 134.636 976.17 134.504C976.246 134.373 976.358 134.287 976.506 134.247L978.73 133.652C978.878 133.612 979.018 133.63 979.15 133.706C979.281 133.782 979.369 133.902 979.413 134.065L980.003 136.266C980.042 136.414 980.024 136.554 979.948 136.686C979.872 136.817 979.76 136.903 979.612 136.943L977.388 137.539Z" fill="white"/>
<path d="M968.489 140.162C967.451 140.44 966.52 140.554 965.697 140.505C964.873 140.455 964.156 140.298 963.544 140.033C962.944 139.749 962.454 139.403 962.075 138.996C961.692 138.575 961.429 138.129 961.287 137.658C961.252 137.525 961.268 137.409 961.337 137.311C961.417 137.194 961.524 137.118 961.657 137.082L963.659 136.546C963.807 136.506 963.941 136.502 964.061 136.534C964.18 136.565 964.301 136.66 964.423 136.818C964.664 137.183 964.964 137.444 965.324 137.602C965.699 137.755 966.1 137.83 966.528 137.827C966.953 137.809 967.387 137.74 967.832 137.621C968.721 137.382 969.37 136.986 969.777 136.432C970.196 135.859 970.3 135.18 970.089 134.394C969.879 133.608 969.483 133.111 968.903 132.901C968.318 132.676 967.589 132.681 966.714 132.915L964.423 133.529C964.26 133.573 964.115 133.564 963.987 133.503C963.856 133.427 963.768 133.307 963.724 133.144L963.474 132.21C963.434 132.062 963.43 131.928 963.462 131.808C963.504 131.67 963.552 131.554 963.607 131.46L966.545 126.501L960.185 128.206C960.021 128.249 959.874 128.233 959.743 128.157C959.626 128.077 959.548 127.963 959.508 127.815L959.115 126.347C959.071 126.184 959.08 126.039 959.141 125.911C959.217 125.78 959.336 125.692 959.499 125.648L969.039 123.092C969.202 123.048 969.35 123.064 969.481 123.14C969.613 123.216 969.7 123.336 969.744 123.499L970.102 124.833C970.137 124.967 970.14 125.093 970.108 125.213C970.077 125.333 970.034 125.439 969.979 125.533L967.193 130.522L967.466 130.473C968.39 130.305 969.246 130.298 970.034 130.452C970.833 130.588 971.511 130.923 972.067 131.457C972.638 131.987 973.053 132.734 973.311 133.698C973.581 134.706 973.547 135.645 973.208 136.514C972.879 137.365 972.307 138.106 971.492 138.738C970.676 139.369 969.675 139.844 968.489 140.162Z" fill="white"/>
<path d="M1043.06 155.693C1042.93 155.728 1042.81 155.718 1042.7 155.665C1042.6 155.595 1042.53 155.495 1042.49 155.365L1039.03 142.445C1039 142.315 1039.01 142.201 1039.07 142.103C1039.13 141.987 1039.23 141.913 1039.36 141.878L1040.28 141.633C1040.42 141.594 1040.54 141.61 1040.64 141.68C1040.74 141.737 1040.81 141.831 1040.84 141.96L1044.3 154.88C1044.34 155.01 1044.33 155.131 1044.28 155.242C1044.22 155.341 1044.12 155.41 1043.98 155.448L1043.06 155.693Z" fill="#E9A8FF"/>
<path d="M1034.73 158.133C1034.09 158.307 1033.46 158.336 1032.86 158.219C1032.26 158.102 1031.74 157.866 1031.29 157.512C1030.85 157.158 1030.55 156.702 1030.41 156.144C1030.17 155.249 1030.34 154.438 1030.92 153.712C1031.51 152.985 1032.36 152.381 1033.48 151.9L1036.27 150.714L1036.12 150.15C1035.95 149.528 1035.64 149.09 1035.18 148.837C1034.74 148.58 1034.11 148.56 1033.31 148.775C1032.74 148.928 1032.3 149.17 1032 149.501C1031.7 149.832 1031.53 150.198 1031.48 150.6C1031.46 150.815 1031.35 150.949 1031.15 151.001L1030.28 151.236C1030.14 151.274 1030.02 151.264 1029.92 151.207C1029.83 151.134 1029.77 151.039 1029.74 150.922C1029.68 150.728 1029.69 150.468 1029.76 150.145C1029.84 149.818 1029.99 149.476 1030.23 149.12C1030.47 148.765 1030.81 148.432 1031.24 148.121C1031.68 147.795 1032.25 147.538 1032.95 147.35C1033.73 147.141 1034.41 147.07 1035 147.135C1035.58 147.187 1036.07 147.341 1036.46 147.599C1036.86 147.853 1037.18 148.176 1037.43 148.569C1037.68 148.959 1037.87 149.375 1037.99 149.816L1039.68 156.12C1039.71 156.25 1039.7 156.372 1039.63 156.487C1039.57 156.586 1039.48 156.653 1039.35 156.688L1038.46 156.927C1038.31 156.966 1038.19 156.956 1038.09 156.899C1037.99 156.829 1037.92 156.73 1037.89 156.6L1037.66 155.763C1037.56 156.042 1037.39 156.336 1037.17 156.646C1036.95 156.943 1036.64 157.227 1036.25 157.497C1035.86 157.755 1035.36 157.967 1034.73 158.133ZM1034.75 156.565C1035.28 156.422 1035.74 156.182 1036.12 155.843C1036.5 155.491 1036.75 155.042 1036.87 154.496C1037 153.947 1036.97 153.309 1036.77 152.582L1036.62 152.038L1034.46 152.973C1033.57 153.35 1032.94 153.756 1032.55 154.193C1032.16 154.616 1032.03 155.061 1032.16 155.528C1032.26 155.892 1032.44 156.169 1032.72 156.359C1033 156.534 1033.32 156.636 1033.67 156.666C1034.04 156.692 1034.4 156.658 1034.75 156.565Z" fill="#E9A8FF"/>
<path d="M1020.51 161.736C1020.38 161.771 1020.26 161.762 1020.15 161.708C1020.04 161.638 1019.98 161.538 1019.94 161.409L1017.47 152.186C1017.43 152.056 1017.45 151.942 1017.5 151.843C1017.57 151.728 1017.67 151.653 1017.8 151.618L1018.71 151.373C1018.84 151.338 1018.96 151.356 1019.06 151.426C1019.17 151.479 1019.24 151.571 1019.28 151.701L1019.51 152.557C1019.73 152.026 1020.05 151.556 1020.49 151.148C1020.93 150.723 1021.55 150.404 1022.36 150.188C1023.2 149.962 1023.96 149.959 1024.65 150.179C1025.34 150.382 1025.93 150.775 1026.4 151.356C1026.89 151.921 1027.25 152.639 1027.48 153.508L1028.95 158.995C1028.98 159.125 1028.97 159.247 1028.9 159.362C1028.84 159.461 1028.75 159.527 1028.62 159.562L1027.65 159.823C1027.52 159.858 1027.4 159.848 1027.29 159.795C1027.18 159.725 1027.12 159.625 1027.08 159.495L1025.64 154.105C1025.39 153.197 1024.98 152.55 1024.41 152.162C1023.83 151.761 1023.11 151.675 1022.25 151.905C1021.45 152.12 1020.87 152.554 1020.52 153.205C1020.17 153.839 1020.12 154.61 1020.36 155.518L1021.81 160.908C1021.84 161.038 1021.83 161.16 1021.76 161.276C1021.7 161.374 1021.61 161.441 1021.48 161.476L1020.51 161.736Z" fill="#E9A8FF"/>
<path d="M1013.12 163.717C1012.99 163.752 1012.87 163.742 1012.75 163.689C1012.65 163.619 1012.58 163.519 1012.55 163.389L1010.08 154.186C1010.05 154.056 1010.06 153.935 1010.11 153.824C1010.18 153.709 1010.27 153.634 1010.4 153.599L1011.3 153.359C1011.43 153.324 1011.55 153.34 1011.67 153.407C1011.78 153.473 1011.86 153.571 1011.89 153.701L1012.12 154.557C1012.26 154.046 1012.53 153.62 1012.93 153.278C1013.32 152.936 1013.84 152.678 1014.49 152.504L1015.25 152.301C1015.38 152.266 1015.5 152.283 1015.6 152.353C1015.71 152.407 1015.78 152.499 1015.82 152.628L1016.03 153.426C1016.07 153.556 1016.05 153.672 1015.98 153.774C1015.92 153.873 1015.83 153.939 1015.7 153.974L1014.53 154.287C1013.83 154.475 1013.33 154.83 1013.04 155.353C1012.75 155.863 1012.7 156.468 1012.88 157.168L1014.42 162.889C1014.45 163.019 1014.44 163.141 1014.37 163.256C1014.3 163.358 1014.2 163.427 1014.07 163.462L1013.12 163.717Z" fill="#E9A8FF"/>
<path d="M1005.88 165.865C1004.53 166.226 1003.35 166.105 1002.34 165.499C1001.33 164.881 1000.59 163.869 1000.13 162.463C1000.07 162.298 1000.01 162.085 999.937 161.826C999.864 161.554 999.811 161.331 999.779 161.159C999.584 160.224 999.583 159.363 999.775 158.574C999.963 157.773 1000.33 157.097 1000.88 156.548C1001.44 155.994 1002.16 155.599 1003.04 155.363C1004.03 155.099 1004.91 155.085 1005.68 155.323C1006.47 155.558 1007.14 156.011 1007.69 156.682C1008.25 157.354 1008.66 158.202 1008.94 159.227L1009.03 159.557C1009.06 159.7 1009.05 159.822 1008.98 159.925C1008.92 160.023 1008.83 160.09 1008.7 160.125L1001.97 161.929C1001.97 161.942 1001.98 161.968 1001.99 162.007C1002 162.045 1002.01 162.078 1002.01 162.104C1002.18 162.629 1002.43 163.097 1002.77 163.508C1003.09 163.907 1003.49 164.196 1003.96 164.378C1004.44 164.555 1004.94 164.573 1005.47 164.43C1005.94 164.305 1006.31 164.129 1006.58 163.903C1006.86 163.677 1007.07 163.454 1007.22 163.233C1007.36 162.999 1007.45 162.822 1007.49 162.701C1007.57 162.514 1007.63 162.399 1007.69 162.355C1007.75 162.299 1007.84 162.252 1007.99 162.213L1008.94 161.958C1009.06 161.927 1009.16 161.94 1009.26 161.997C1009.37 162.037 1009.44 162.124 1009.46 162.257C1009.5 162.455 1009.46 162.723 1009.34 163.06C1009.22 163.385 1009.01 163.732 1008.72 164.102C1008.44 164.468 1008.06 164.813 1007.58 165.137C1007.11 165.445 1006.54 165.688 1005.88 165.865ZM1001.61 160.586L1006.94 159.158L1006.92 159.099C1006.77 158.515 1006.52 158.026 1006.17 157.631C1005.85 157.233 1005.45 156.958 1004.97 156.806C1004.5 156.641 1003.98 156.634 1003.42 156.783C1002.87 156.933 1002.42 157.198 1002.09 157.578C1001.77 157.941 1001.57 158.378 1001.49 158.888C1001.4 159.397 1001.43 159.944 1001.59 160.528L1001.61 160.586Z" fill="#E9A8FF"/>
<path d="M998.13 167.733C997.404 167.927 996.777 167.949 996.25 167.799C995.719 167.635 995.283 167.328 994.939 166.878C994.593 166.414 994.326 165.832 994.138 165.132L992.762 159.995L991.244 160.402C991.114 160.436 990.994 160.427 990.882 160.374C990.78 160.304 990.711 160.204 990.676 160.074L990.499 159.412C990.464 159.283 990.476 159.169 990.533 159.07C990.599 158.955 990.697 158.88 990.827 158.845L992.345 158.438L991.474 155.189C991.439 155.059 991.45 154.945 991.507 154.846C991.574 154.731 991.672 154.656 991.801 154.621L992.716 154.376C992.846 154.342 992.962 154.359 993.064 154.429C993.175 154.483 993.249 154.574 993.283 154.704L994.154 157.953L996.567 157.307C996.71 157.269 996.832 157.285 996.934 157.355C997.033 157.412 997.1 157.505 997.134 157.635L997.312 158.296C997.346 158.426 997.337 158.547 997.284 158.658C997.227 158.757 997.127 158.825 996.984 158.864L994.571 159.51L995.911 164.511C996.075 165.121 996.307 165.573 996.608 165.867C996.91 166.162 997.326 166.238 997.858 166.095L999.045 165.777C999.175 165.743 999.291 165.76 999.393 165.83C999.505 165.884 999.578 165.975 999.613 166.105L999.8 166.806C999.835 166.935 999.819 167.058 999.753 167.173C999.696 167.272 999.602 167.338 999.473 167.373L998.13 167.733Z" fill="#E9A8FF"/>
<path d="M983.224 171.727C983.12 171.754 983.013 171.742 982.901 171.688C982.802 171.631 982.737 171.544 982.706 171.427C982.696 171.389 982.69 171.341 982.689 171.286C982.698 171.214 982.717 171.132 982.749 171.041L984.951 165.717L980.658 162.383C980.585 162.319 980.529 162.265 980.489 162.22C980.462 162.171 980.442 162.121 980.428 162.069C980.397 161.952 980.41 161.845 980.467 161.746C980.524 161.647 980.61 161.582 980.727 161.551L981.72 161.285C981.862 161.247 981.983 161.256 982.082 161.313C982.177 161.357 982.253 161.406 982.309 161.461L985.799 164.134L987.49 160.094C987.524 160.015 987.564 159.928 987.608 159.833C987.665 159.734 987.764 159.665 987.907 159.627L988.861 159.372C988.977 159.34 989.085 159.353 989.184 159.41C989.282 159.467 989.347 159.554 989.379 159.671C989.393 159.723 989.394 159.778 989.381 159.837C989.382 159.892 989.367 159.966 989.336 160.058L987.257 165.14L991.816 168.611C991.889 168.675 991.938 168.731 991.965 168.78C992.005 168.825 992.032 168.873 992.046 168.925C992.077 169.042 992.064 169.149 992.007 169.248C991.95 169.347 991.864 169.412 991.747 169.443L990.716 169.719C990.586 169.754 990.473 169.749 990.378 169.705C990.283 169.661 990.201 169.614 990.131 169.563L986.453 166.732L984.644 171.033C984.606 171.099 984.559 171.181 984.502 171.28C984.454 171.362 984.359 171.422 984.217 171.461L983.224 171.727Z" fill="#E9A8FF"/>
<path d="M972.59 174.576C972.448 174.614 972.327 174.605 972.228 174.548C972.126 174.478 972.058 174.378 972.023 174.248L968.618 161.542C968.58 161.4 968.589 161.279 968.646 161.18C968.7 161.069 968.798 160.994 968.941 160.955L976.977 158.802C977.12 158.764 977.242 158.78 977.344 158.85C977.443 158.907 977.511 159.007 977.549 159.149L977.748 159.889C977.786 160.031 977.776 160.152 977.72 160.251C977.663 160.349 977.563 160.418 977.42 160.456L970.804 162.229L971.946 166.49L978.134 164.832C978.276 164.794 978.399 164.81 978.501 164.88C978.6 164.937 978.668 165.036 978.706 165.179L978.899 165.899C978.934 166.029 978.925 166.149 978.871 166.261C978.814 166.36 978.714 166.428 978.572 166.467L972.384 168.124L973.568 172.541L980.339 170.727C980.482 170.689 980.602 170.698 980.701 170.755C980.8 170.812 980.868 170.912 980.906 171.055L981.11 171.814C981.144 171.943 981.135 172.064 981.082 172.176C981.025 172.274 980.925 172.343 980.782 172.381L972.59 174.576Z" fill="#E9A8FF"/>
<rect x="1094.17" y="80.9241" width="2.87776" height="66.1887" rx="1.43888" transform="rotate(-15 1094.17 80.9241)" fill="#FC3DA6"/>
<path d="M1215.48 77.5317C1215.35 77.5674 1215.22 77.5473 1215.08 77.4713C1214.95 77.3953 1214.87 77.2907 1214.83 77.1572L1214.63 76.3789C1214.59 76.2307 1214.6 76.0927 1214.66 75.9651C1214.74 75.8484 1214.84 75.7741 1214.96 75.7423C1215.57 75.5606 1216.05 75.2585 1216.38 74.836C1216.73 74.4095 1216.94 73.8289 1217.01 73.0942C1217.08 72.3595 1217.03 71.4352 1216.86 70.3212C1216.69 69.1924 1216.39 67.8348 1215.96 66.2485C1215.54 64.6622 1215.12 63.3438 1214.71 62.2934C1214.3 61.2281 1213.88 60.3957 1213.45 59.7961C1213.02 59.1965 1212.55 58.806 1212.04 58.6247C1211.54 58.4246 1210.98 58.4006 1210.35 58.5526C1210.23 58.5844 1210.11 58.5623 1209.97 58.4863C1209.86 58.4064 1209.78 58.2997 1209.75 58.1662L1209.54 57.3879C1209.5 57.2545 1209.52 57.122 1209.6 56.9904C1209.67 56.8588 1209.78 56.7752 1209.91 56.7394C1210.87 56.4812 1211.74 56.4629 1212.52 56.6844C1213.29 56.9059 1213.99 57.3856 1214.62 58.1233C1215.26 58.8423 1215.84 59.8377 1216.37 61.1095C1216.9 62.3812 1217.41 63.9214 1217.9 65.7301C1218.38 67.5388 1218.71 69.1267 1218.89 70.4938C1219.06 71.846 1219.05 73.0003 1218.86 73.9566C1218.69 74.9089 1218.32 75.6745 1217.76 76.2536C1217.21 76.8474 1216.45 77.2734 1215.48 77.5317Z" fill="#9EA1B1"/>
<path d="M1198.99 78.1593C1198.68 78.2427 1198.49 78.1362 1198.41 77.8397C1198.38 77.7507 1198.39 77.6613 1198.43 77.5712L1205.54 60.1732C1205.61 60.012 1205.68 59.8824 1205.75 59.7844C1205.83 59.6825 1205.97 59.6057 1206.16 59.5541L1206.9 59.3574C1207.21 59.274 1207.41 59.3806 1207.48 59.6771C1207.51 59.766 1207.5 59.8555 1207.46 59.9455L1200.37 77.3376C1200.3 77.4988 1200.23 77.6304 1200.14 77.7323C1200.07 77.8303 1199.94 77.9071 1199.73 77.9627L1198.99 78.1593ZM1209.22 75.5637C1208.25 75.8219 1207.41 75.7522 1206.7 75.3546C1206.01 74.9531 1205.51 74.3155 1205.21 73.4419C1205.1 73.0604 1205 72.7362 1204.93 72.4694C1204.85 72.1877 1204.77 71.8373 1204.67 71.4183C1204.49 70.5129 1204.59 69.7164 1204.96 69.0288C1205.34 68.3225 1206.05 67.8322 1207.07 67.5581C1208.11 67.2801 1208.96 67.3532 1209.63 67.7775C1210.31 68.1831 1210.8 68.8226 1211.1 69.6962C1211.24 70.1034 1211.35 70.4478 1211.42 70.7295C1211.5 70.9963 1211.57 71.3265 1211.64 71.7199C1211.82 72.6253 1211.7 73.4277 1211.29 74.1272C1210.88 74.8227 1210.19 75.3015 1209.22 75.5637ZM1208.82 74.096C1209.22 73.9888 1209.51 73.8238 1209.69 73.6012C1209.87 73.3785 1209.98 73.1347 1210.02 72.8696C1210.06 72.5898 1210.05 72.3219 1209.99 72.0659C1209.92 71.6577 1209.85 71.335 1209.78 71.0978C1209.72 70.8606 1209.62 70.568 1209.5 70.2202C1209.38 69.8239 1209.15 69.487 1208.82 69.2096C1208.5 68.9322 1208.04 68.8709 1207.46 69.0258C1206.9 69.1768 1206.55 69.4545 1206.4 69.8591C1206.27 70.2596 1206.24 70.664 1206.32 71.0722C1206.4 71.432 1206.47 71.7305 1206.54 71.9677C1206.6 72.2049 1206.69 72.5217 1206.81 72.918C1206.91 73.1621 1207.04 73.3982 1207.19 73.6264C1207.36 73.8358 1207.58 73.9922 1207.84 74.0957C1208.13 74.1952 1208.45 74.1953 1208.82 74.096ZM1198.78 69.8978C1197.8 70.16 1196.97 70.1052 1196.28 69.7333C1195.6 69.3614 1195.1 68.7386 1194.81 67.865C1194.69 67.4835 1194.59 67.1593 1194.52 66.8925C1194.45 66.6108 1194.36 66.2604 1194.26 65.8413C1194.07 64.9399 1194.17 64.1434 1194.55 63.4519C1194.94 62.7455 1195.64 62.2553 1196.66 61.9812C1197.7 61.7032 1198.55 61.7763 1199.22 62.2006C1199.9 62.6061 1200.39 63.2477 1200.67 64.1253C1200.81 64.5324 1200.92 64.8769 1200.99 65.1585C1201.06 65.4254 1201.14 65.7555 1201.21 66.1489C1201.4 67.0503 1201.29 67.836 1200.87 68.5058C1200.46 69.1716 1199.76 69.6357 1198.78 69.8978ZM1198.41 68.5191C1198.8 68.4158 1199.08 68.2528 1199.26 68.0302C1199.45 67.8036 1199.57 67.5577 1199.61 67.2927C1199.65 67.0129 1199.64 66.745 1199.59 66.489C1199.51 66.0807 1199.44 65.7654 1199.38 65.5431C1199.32 65.3059 1199.22 65.0059 1199.09 64.6432C1198.97 64.2469 1198.74 63.9121 1198.39 63.6386C1198.06 63.3612 1197.62 63.298 1197.06 63.4489C1196.49 63.5999 1196.14 63.8776 1195.99 64.2821C1195.86 64.6827 1195.83 65.0871 1195.91 65.4953C1196 65.8699 1196.07 66.1758 1196.13 66.413C1196.19 66.6354 1196.28 66.9447 1196.41 67.341C1196.5 67.5851 1196.63 67.8213 1196.79 68.0495C1196.95 68.2589 1197.17 68.4153 1197.44 68.5188C1197.7 68.6223 1198.03 68.6224 1198.41 68.5191Z" fill="#9EA1B1"/>
<path d="M1187.68 81.1909C1187.55 81.2266 1187.42 81.2119 1187.31 81.1468C1187.21 81.0629 1187.14 80.9542 1187.11 80.8208C1187.09 80.7467 1187.08 80.6854 1187.08 80.6369C1187.1 80.5845 1187.11 80.5415 1187.12 80.5079L1189.25 74.8596C1188.9 75.0479 1188.52 75.1996 1188.09 75.3148C1187.27 75.5184 1186.48 75.5688 1185.74 75.4659C1185.01 75.359 1184.36 75.1299 1183.77 74.7787C1183.18 74.4126 1182.68 73.9574 1182.28 73.4131C1181.88 72.8688 1181.59 72.2631 1181.42 71.596C1181.24 70.9437 1181.18 70.2764 1181.24 69.5942C1181.31 68.908 1181.51 68.2513 1181.83 67.6241C1182.17 66.9929 1182.65 66.4357 1183.26 65.9525C1183.89 65.4505 1184.67 65.0744 1185.61 64.8241C1186.54 64.5739 1187.4 64.5036 1188.17 64.6134C1188.96 64.7044 1189.66 64.9384 1190.27 65.3154C1190.89 65.6735 1191.39 66.1341 1191.78 66.6972C1192.19 67.2563 1192.48 67.8694 1192.66 68.5365C1192.82 69.1443 1192.88 69.7241 1192.84 70.2758C1192.79 70.8276 1192.7 71.3373 1192.56 71.8051C1192.43 72.269 1192.29 72.7012 1192.16 73.1017L1189.47 80.2337C1189.44 80.3237 1189.38 80.4419 1189.31 80.5883C1189.23 80.7199 1189.09 80.8135 1188.88 80.8691L1187.68 81.1909ZM1187.91 73.4301C1188.54 73.2633 1189.07 72.9769 1189.52 72.571C1189.98 72.1463 1190.3 71.6477 1190.48 71.075C1190.65 70.4875 1190.65 69.8454 1190.46 69.1486C1190.27 68.4519 1189.96 67.9006 1189.52 67.4948C1189.07 67.0741 1188.54 66.8019 1187.94 66.678C1187.35 66.5354 1186.74 66.5475 1186.11 66.7143C1185.51 66.8772 1184.98 67.169 1184.54 67.5897C1184.09 67.9956 1183.78 68.4923 1183.6 69.0797C1183.42 69.6524 1183.42 70.2871 1183.61 70.9839C1183.8 71.6807 1184.11 72.2394 1184.56 72.66C1185 73.0658 1185.52 73.34 1186.12 73.4827C1186.71 73.6105 1187.31 73.593 1187.91 73.4301Z" fill="#9EA1B1"/>
<path d="M1180.02 83.2449C1179.87 83.2846 1179.73 83.2739 1179.6 83.2127C1179.49 83.1328 1179.41 83.0187 1179.37 82.8705L1176.03 70.4174L1173.1 74.2529C1173.01 74.3736 1172.89 74.4445 1172.75 74.4654C1172.62 74.4863 1172.49 74.4494 1172.37 74.3546L1171.59 73.7757C1171.47 73.6661 1171.39 73.5426 1171.37 73.4052C1171.37 73.2638 1171.41 73.1328 1171.51 73.0121L1175.35 67.9772C1175.44 67.8752 1175.52 67.8049 1175.61 67.7663C1175.69 67.7276 1175.79 67.6944 1175.89 67.6666L1177.02 67.3627C1177.17 67.323 1177.3 67.3431 1177.42 67.423C1177.55 67.4842 1177.63 67.5889 1177.67 67.7371L1181.57 82.2806C1181.61 82.4288 1181.59 82.5687 1181.51 82.7003C1181.45 82.8131 1181.34 82.8893 1181.19 82.9291L1180.02 83.2449Z" fill="#9EA1B1"/>
<path d="M1174.52 88.5068C1173.56 88.765 1172.69 88.7759 1171.91 88.5396C1171.13 88.3181 1170.43 87.8384 1169.81 87.1007C1169.18 86.3629 1168.6 85.3675 1168.05 84.1145C1167.52 82.8428 1167.01 81.3025 1166.53 79.4939C1166.05 77.6852 1165.71 76.0973 1165.54 74.7302C1165.38 73.3592 1165.39 72.2049 1165.56 71.2674C1165.74 70.3151 1166.11 69.5495 1166.67 68.9704C1167.23 68.3914 1167.99 67.9728 1168.95 67.7146C1169.1 67.6749 1169.23 67.695 1169.35 67.7749C1169.48 67.8509 1169.56 67.9556 1169.6 68.089L1169.81 68.8673C1169.84 69.0007 1169.82 69.1333 1169.75 69.2648C1169.69 69.3924 1169.6 69.4702 1169.5 69.498C1168.88 69.6796 1168.4 69.9837 1168.05 70.4102C1167.72 70.818 1167.5 71.3912 1167.42 72.1298C1167.34 72.8644 1167.39 73.7962 1167.57 74.925C1167.76 76.0351 1168.06 77.3832 1168.49 78.9695C1168.91 80.5558 1169.32 81.8836 1169.72 82.9528C1170.13 84.0033 1170.55 84.8283 1170.98 85.4279C1171.43 86.0235 1171.9 86.4214 1172.4 86.6215C1172.91 86.8176 1173.48 86.8397 1174.11 86.6877C1174.21 86.6599 1174.32 86.6785 1174.43 86.7436C1174.56 86.8196 1174.65 86.9317 1174.69 87.08L1174.9 87.8583C1174.93 87.9917 1174.91 88.1242 1174.84 88.2558C1174.77 88.3834 1174.67 88.4671 1174.52 88.5068Z" fill="#9EA1B1"/>
<path d="M1150.39 91.1831C1150.24 91.2229 1150.1 91.2047 1149.97 91.1288C1149.84 91.0528 1149.76 90.9407 1149.72 90.7924L1145.84 76.3157C1145.79 76.1526 1145.81 76.0053 1145.88 75.8737C1145.96 75.7421 1146.07 75.6565 1146.22 75.6168L1148.18 75.0924C1148.34 75.0487 1148.49 75.0648 1148.62 75.1408C1148.75 75.2168 1148.84 75.3363 1148.88 75.4994L1150.28 80.703L1153.87 73.9971C1153.91 73.9071 1153.98 73.7997 1154.09 73.675C1154.21 73.5315 1154.39 73.428 1154.63 73.3644L1156.83 72.7745C1156.95 72.7427 1157.06 72.7594 1157.18 72.8245C1157.3 72.8857 1157.38 72.983 1157.42 73.1164C1157.45 73.2202 1157.44 73.3171 1157.4 73.4071L1153.09 81.7615L1161.6 87.3703C1161.7 87.4394 1161.76 87.5258 1161.79 87.6296C1161.82 87.763 1161.8 87.8881 1161.72 88.0049C1161.65 88.1177 1161.56 88.19 1161.44 88.2217L1159.15 88.8355C1158.9 88.903 1158.69 88.9047 1158.51 88.8407C1158.35 88.7578 1158.24 88.7001 1158.18 88.6676L1151.22 84.2166L1152.76 89.9761C1152.8 90.1244 1152.78 90.2643 1152.71 90.3959C1152.63 90.5274 1152.51 90.6151 1152.35 90.6588L1150.39 91.1831Z" fill="white"/>
<path d="M1141.09 93.9132C1140.05 94.1913 1139.12 94.3056 1138.3 94.2561C1137.48 94.2067 1136.76 94.0494 1136.15 93.7842C1135.55 93.5001 1135.06 93.1547 1134.68 92.7478C1134.29 92.3261 1134.03 91.8801 1133.89 91.4096C1133.85 91.2762 1133.87 91.1605 1133.94 91.0625C1134.02 90.9458 1134.13 90.8695 1134.26 90.8338L1136.26 90.2975C1136.41 90.2578 1136.54 90.2537 1136.66 90.2852C1136.78 90.3167 1136.9 90.4114 1137.03 90.5695C1137.27 90.934 1137.57 91.1951 1137.93 91.3529C1138.3 91.5067 1138.7 91.5818 1139.13 91.5783C1139.56 91.56 1139.99 91.4913 1140.43 91.3721C1141.32 91.1338 1141.97 90.7375 1142.38 90.1834C1142.8 89.6105 1142.9 88.9311 1142.69 88.1454C1142.48 87.3597 1142.09 86.8619 1141.51 86.652C1140.92 86.4273 1140.19 86.4321 1139.32 86.6665L1137.03 87.2802C1136.86 87.3239 1136.72 87.3152 1136.59 87.254C1136.46 87.1781 1136.37 87.0585 1136.33 86.8955L1136.08 85.9615C1136.04 85.8132 1136.03 85.6793 1136.06 85.5596C1136.11 85.4211 1136.15 85.3049 1136.21 85.2109L1139.15 80.2528L1132.79 81.9569C1132.62 82.0006 1132.48 81.9845 1132.35 81.9085C1132.23 81.8285 1132.15 81.7145 1132.11 81.5662L1131.72 80.0985C1131.67 79.9354 1131.68 79.7901 1131.74 79.6625C1131.82 79.5309 1131.94 79.4433 1132.1 79.3996L1141.64 76.8433C1141.8 76.7996 1141.95 76.8158 1142.08 76.8918C1142.22 76.9677 1142.3 77.0872 1142.35 77.2503L1142.7 78.5846C1142.74 78.718 1142.74 78.8446 1142.71 78.9642C1142.68 79.0839 1142.64 79.1907 1142.58 79.2847L1139.8 84.2738L1140.07 84.2246C1140.99 84.0564 1141.85 84.0494 1142.64 84.2037C1143.44 84.3392 1144.11 84.674 1144.67 85.2082C1145.24 85.7384 1145.66 86.4854 1145.91 87.449C1146.18 88.4571 1146.15 89.3959 1145.81 90.2653C1145.48 91.116 1144.91 91.8571 1144.09 92.4889C1143.28 93.1206 1142.28 93.5954 1141.09 93.9132Z" fill="white"/>
<path d="M1130.03 96.6379C1129.89 96.6776 1129.75 96.6595 1129.61 96.5835C1129.48 96.5076 1129.4 96.3955 1129.36 96.2472L1128.77 94.0457C1128.72 93.8826 1128.74 93.7353 1128.82 93.6037C1128.89 93.4721 1129 93.3865 1129.15 93.3467L1131.38 92.7509C1131.52 92.7112 1131.66 92.7293 1131.8 92.8053C1131.93 92.8812 1132.01 93.0007 1132.06 93.1638L1132.65 95.3653C1132.69 95.5136 1132.67 95.6535 1132.59 95.7851C1132.52 95.9167 1132.41 96.0023 1132.26 96.0421L1130.03 96.6379Z" fill="white"/>
<path d="M1115.93 100.416C1115.78 100.456 1115.64 100.438 1115.51 100.362C1115.38 100.286 1115.29 100.174 1115.25 100.026L1114.95 98.8915C1114.91 98.7581 1114.9 98.5944 1114.91 98.4007C1114.94 98.1881 1115.04 97.9536 1115.23 97.6973L1117.8 93.2646C1118.58 92.2315 1119.19 91.3686 1119.64 90.676C1120.1 89.9647 1120.4 89.3508 1120.55 88.8346C1120.71 88.2995 1120.73 87.8096 1120.61 87.3649C1120.43 86.6977 1120.1 86.2063 1119.62 85.8905C1119.15 85.5707 1118.52 85.5161 1117.74 85.7266C1117.22 85.8657 1116.81 86.094 1116.52 86.4117C1116.22 86.7146 1116.01 87.0718 1115.9 87.4832C1115.8 87.8906 1115.77 88.3193 1115.81 88.7691C1115.83 88.9697 1115.79 89.125 1115.68 89.2349C1115.56 89.3448 1115.44 89.4176 1115.3 89.4533L1113.33 89.9836C1113.19 90.0194 1113.07 90.0047 1112.96 89.9396C1112.84 89.8745 1112.77 89.7826 1112.74 89.664C1112.58 89.0226 1112.55 88.3716 1112.65 87.711C1112.73 87.0357 1112.95 86.4046 1113.31 85.8179C1113.67 85.2125 1114.16 84.6755 1114.78 84.2071C1115.4 83.7388 1116.15 83.3874 1117.03 83.153C1118.26 82.8233 1119.33 82.7588 1120.24 82.9593C1121.17 83.156 1121.92 83.5565 1122.51 84.1608C1123.12 84.7612 1123.54 85.5061 1123.78 86.3956C1123.97 87.0924 1124.01 87.7731 1123.9 88.4376C1123.79 89.0873 1123.55 89.7539 1123.2 90.4375C1122.83 91.1062 1122.37 91.8176 1121.81 92.5717L1119.51 96.62L1125.85 94.9218C1126.01 94.8781 1126.15 94.8962 1126.27 94.9762C1126.4 95.0373 1126.48 95.1494 1126.53 95.3125L1126.95 96.8914C1126.99 97.0396 1126.97 97.1796 1126.9 97.3111C1126.84 97.4388 1126.72 97.5244 1126.56 97.5681L1115.93 100.416Z" fill="white"/>
<path d="M1204.51 112.643C1203.78 112.837 1203.13 112.913 1202.57 112.871C1202 112.828 1201.52 112.721 1201.13 112.548C1200.73 112.376 1200.42 112.182 1200.18 111.968C1199.95 111.75 1199.81 111.565 1199.76 111.413C1199.71 111.274 1199.72 111.151 1199.8 111.046C1199.89 110.94 1199.98 110.873 1200.08 110.846L1200.96 110.611C1201.03 110.594 1201.08 110.593 1201.13 110.608C1201.18 110.607 1201.26 110.642 1201.36 110.712C1201.58 110.848 1201.82 110.979 1202.07 111.105C1202.33 111.231 1202.62 111.313 1202.95 111.349C1203.29 111.383 1203.69 111.339 1204.15 111.217C1204.81 111.04 1205.32 110.77 1205.68 110.409C1206.04 110.035 1206.15 109.602 1206.02 109.109C1205.94 108.784 1205.77 108.549 1205.54 108.403C1205.32 108.254 1204.96 108.162 1204.47 108.128C1203.98 108.091 1203.33 108.092 1202.51 108.132C1201.68 108.159 1201 108.103 1200.48 107.966C1199.95 107.815 1199.54 107.584 1199.25 107.273C1198.96 106.949 1198.75 106.553 1198.62 106.086C1198.49 105.606 1198.51 105.108 1198.68 104.59C1198.84 104.06 1199.16 103.579 1199.63 103.147C1200.11 102.712 1200.77 102.384 1201.6 102.161C1202.27 101.981 1202.87 101.91 1203.39 101.95C1203.92 101.99 1204.37 102.098 1204.75 102.274C1205.13 102.437 1205.43 102.621 1205.65 102.826C1205.87 103.031 1206.01 103.216 1206.07 103.381C1206.12 103.507 1206.11 103.628 1206.04 103.743C1205.97 103.845 1205.88 103.912 1205.76 103.943L1204.95 104.162C1204.86 104.187 1204.77 104.188 1204.7 104.166C1204.64 104.141 1204.57 104.11 1204.51 104.072C1204.33 103.938 1204.13 103.811 1203.9 103.691C1203.69 103.568 1203.43 103.492 1203.11 103.465C1202.81 103.421 1202.43 103.46 1201.98 103.582C1201.33 103.756 1200.88 104.022 1200.63 104.381C1200.37 104.741 1200.3 105.128 1200.42 105.543C1200.48 105.79 1200.61 105.991 1200.81 106.147C1201 106.304 1201.32 106.406 1201.77 106.454C1202.21 106.502 1202.85 106.51 1203.69 106.48C1204.59 106.419 1205.33 106.465 1205.9 106.619C1206.47 106.772 1206.91 107.009 1207.21 107.33C1207.52 107.65 1207.74 108.057 1207.87 108.55C1208.02 109.095 1208 109.636 1207.81 110.173C1207.62 110.711 1207.25 111.199 1206.7 111.638C1206.15 112.065 1205.42 112.399 1204.51 112.643Z" fill="#FFA4D2"/>
<path d="M1194.16 115.414C1192.82 115.775 1191.64 115.654 1190.63 115.048C1189.61 114.43 1188.87 113.418 1188.41 112.012C1188.36 111.847 1188.29 111.635 1188.22 111.375C1188.15 111.103 1188.1 110.88 1188.07 110.708C1187.87 109.773 1187.87 108.912 1188.06 108.123C1188.25 107.322 1188.62 106.647 1189.17 106.097C1189.73 105.543 1190.45 105.148 1191.33 104.912C1192.32 104.648 1193.19 104.635 1193.97 104.872C1194.75 105.107 1195.42 105.56 1195.98 106.231C1196.53 106.903 1196.95 107.751 1197.22 108.776L1197.31 109.106C1197.35 109.249 1197.34 109.372 1197.27 109.474C1197.21 109.572 1197.11 109.639 1196.99 109.674L1190.25 111.478C1190.26 111.491 1190.26 111.517 1190.27 111.556C1190.28 111.595 1190.29 111.627 1190.3 111.653C1190.47 112.178 1190.72 112.646 1191.05 113.057C1191.38 113.456 1191.78 113.745 1192.24 113.927C1192.72 114.104 1193.23 114.122 1193.76 113.979C1194.23 113.854 1194.6 113.679 1194.87 113.452C1195.14 113.226 1195.35 113.003 1195.5 112.782C1195.65 112.548 1195.74 112.371 1195.78 112.25C1195.85 112.063 1195.92 111.948 1195.98 111.904C1196.03 111.848 1196.13 111.801 1196.27 111.763L1197.23 111.507C1197.34 111.476 1197.45 111.489 1197.55 111.546C1197.66 111.586 1197.72 111.673 1197.74 111.806C1197.78 112.004 1197.74 112.272 1197.63 112.61C1197.5 112.934 1197.3 113.281 1197.01 113.651C1196.73 114.017 1196.35 114.362 1195.87 114.687C1195.39 114.994 1194.83 115.237 1194.16 115.414ZM1189.89 110.135L1195.22 108.707L1195.21 108.648C1195.05 108.065 1194.8 107.575 1194.46 107.18C1194.13 106.782 1193.73 106.507 1193.26 106.355C1192.78 106.19 1192.27 106.183 1191.71 106.332C1191.15 106.482 1190.71 106.747 1190.38 107.127C1190.06 107.49 1189.86 107.927 1189.77 108.437C1189.69 108.946 1189.72 109.493 1189.88 110.077L1189.89 110.135Z" fill="#FFA4D2"/>
<path d="M1178.71 119.346C1178.58 119.38 1178.46 119.371 1178.35 119.318C1178.25 119.248 1178.18 119.148 1178.15 119.018L1175.67 109.795C1175.64 109.665 1175.65 109.551 1175.71 109.452C1175.77 109.337 1175.87 109.262 1176 109.227L1176.92 108.982C1177.05 108.948 1177.16 108.965 1177.26 109.035C1177.38 109.089 1177.45 109.18 1177.48 109.31L1177.71 110.166C1177.93 109.635 1178.26 109.165 1178.69 108.757C1179.13 108.333 1179.76 108.013 1180.56 107.797C1181.41 107.571 1182.17 107.568 1182.85 107.788C1183.55 107.991 1184.13 108.384 1184.61 108.965C1185.09 109.531 1185.45 110.248 1185.69 111.117L1187.16 116.604C1187.19 116.734 1187.17 116.856 1187.11 116.971C1187.05 117.07 1186.96 117.137 1186.83 117.172L1185.85 117.432C1185.73 117.467 1185.6 117.458 1185.49 117.404C1185.39 117.334 1185.32 117.234 1185.29 117.105L1183.84 111.715C1183.6 110.807 1183.19 110.159 1182.61 109.771C1182.03 109.37 1181.32 109.285 1180.46 109.514C1179.65 109.73 1179.08 110.163 1178.72 110.814C1178.38 111.448 1178.33 112.22 1178.57 113.128L1180.01 118.518C1180.05 118.647 1180.03 118.77 1179.97 118.885C1179.91 118.983 1179.82 119.05 1179.69 119.085L1178.71 119.346Z" fill="#FFA4D2"/>
<path d="M1174 120.608C1173.87 120.643 1173.75 120.634 1173.64 120.58C1173.54 120.51 1173.47 120.41 1173.43 120.281L1170.96 111.058C1170.93 110.928 1170.94 110.814 1171 110.715C1171.06 110.6 1171.16 110.525 1171.29 110.49L1172.22 110.24C1172.35 110.205 1172.47 110.223 1172.57 110.293C1172.68 110.346 1172.76 110.438 1172.79 110.568L1175.26 119.791C1175.3 119.92 1175.28 120.043 1175.21 120.158C1175.16 120.257 1175.06 120.323 1174.93 120.358L1174 120.608ZM1170.63 108.645C1170.5 108.679 1170.38 108.67 1170.27 108.616C1170.16 108.546 1170.1 108.447 1170.06 108.317L1169.78 107.266C1169.74 107.136 1169.75 107.016 1169.81 106.904C1169.87 106.789 1169.97 106.714 1170.1 106.679L1171.33 106.351C1171.46 106.316 1171.58 106.332 1171.69 106.398C1171.81 106.465 1171.89 106.563 1171.92 106.693L1172.2 107.743C1172.24 107.873 1172.22 107.996 1172.15 108.111C1172.08 108.213 1171.98 108.281 1171.85 108.316L1170.63 108.645Z" fill="#FFA4D2"/>
<path d="M1162.16 123.78C1162.03 123.815 1161.91 123.806 1161.8 123.752C1161.7 123.682 1161.63 123.582 1161.6 123.453L1158.13 110.533C1158.1 110.403 1158.11 110.289 1158.17 110.19C1158.23 110.075 1158.33 110 1158.46 109.965L1159.43 109.704C1159.58 109.666 1159.7 109.682 1159.8 109.752C1159.9 109.809 1159.97 109.902 1160 110.032L1161.22 114.566C1161.45 114.031 1161.78 113.559 1162.21 113.152C1162.65 112.744 1163.25 112.435 1164.03 112.227C1164.87 112.001 1165.64 111.998 1166.32 112.217C1167.02 112.421 1167.6 112.813 1168.08 113.395C1168.56 113.96 1168.92 114.677 1169.15 115.546L1170.62 121.034C1170.66 121.163 1170.65 121.284 1170.6 121.396C1170.54 121.494 1170.44 121.563 1170.3 121.601L1169.32 121.862C1169.19 121.896 1169.07 121.887 1168.96 121.834C1168.86 121.764 1168.79 121.664 1168.76 121.534L1167.31 116.144C1167.07 115.236 1166.66 114.588 1166.08 114.201C1165.5 113.8 1164.78 113.714 1163.93 113.944C1163.12 114.159 1162.54 114.592 1162.19 115.243C1161.83 115.881 1161.78 116.654 1162.02 117.562L1163.46 122.952C1163.5 123.082 1163.49 123.203 1163.44 123.314C1163.38 123.413 1163.28 123.481 1163.14 123.52L1162.16 123.78Z" fill="#FFA4D2"/>
<path d="M1155.1 125.882C1154.18 126.129 1153.33 126.167 1152.56 125.998C1151.81 125.812 1151.16 125.437 1150.61 124.872C1150.07 124.295 1149.66 123.543 1149.38 122.616C1149.32 122.425 1149.24 122.167 1149.16 121.843C1149.07 121.519 1149.01 121.257 1148.97 121.059C1148.74 120.118 1148.72 119.269 1148.91 118.51C1149.09 117.738 1149.47 117.088 1150.04 116.561C1150.61 116.017 1151.36 115.621 1152.28 115.374C1153.04 115.173 1153.71 115.105 1154.29 115.17C1154.89 115.231 1155.41 115.377 1155.85 115.608C1156.29 115.838 1156.64 116.119 1156.91 116.45C1157.19 116.777 1157.38 117.108 1157.49 117.442C1157.54 117.568 1157.52 117.682 1157.45 117.784C1157.38 117.887 1157.28 117.955 1157.15 117.99L1156.22 118.24C1156.09 118.275 1155.99 118.275 1155.91 118.24C1155.83 118.193 1155.73 118.107 1155.63 117.981C1155.23 117.408 1154.79 117.046 1154.32 116.894C1153.84 116.742 1153.31 116.747 1152.71 116.906C1151.94 117.115 1151.36 117.525 1151 118.137C1150.65 118.746 1150.6 119.587 1150.84 120.661C1150.95 121.132 1151.08 121.586 1151.21 122.023C1151.53 123.09 1152 123.798 1152.61 124.15C1153.23 124.485 1153.93 124.548 1154.71 124.339C1155.3 124.179 1155.77 123.916 1156.1 123.549C1156.43 123.182 1156.63 122.649 1156.69 121.951C1156.72 121.791 1156.76 121.669 1156.8 121.587C1156.85 121.505 1156.94 121.446 1157.07 121.412L1158 121.161C1158.13 121.127 1158.26 121.143 1158.37 121.209C1158.48 121.263 1158.55 121.356 1158.57 121.489C1158.63 121.765 1158.65 122.059 1158.62 122.373C1158.59 122.686 1158.5 123.023 1158.35 123.384C1158.21 123.728 1158 124.062 1157.72 124.386C1157.44 124.697 1157.09 124.987 1156.66 125.254C1156.23 125.509 1155.71 125.718 1155.1 125.882Z" fill="#FFA4D2"/>
<path d="M1143.1 129.098C1142.45 129.271 1141.82 129.3 1141.22 129.183C1140.62 129.066 1140.1 128.83 1139.66 128.476C1139.21 128.122 1138.92 127.666 1138.77 127.108C1138.53 126.213 1138.7 125.402 1139.28 124.676C1139.87 123.949 1140.72 123.346 1141.84 122.864L1144.63 121.679L1144.48 121.114C1144.32 120.492 1144 120.054 1143.55 119.801C1143.1 119.545 1142.48 119.524 1141.67 119.74C1141.1 119.893 1140.67 120.134 1140.37 120.465C1140.07 120.796 1139.89 121.162 1139.85 121.564C1139.82 121.779 1139.71 121.913 1139.52 121.965L1138.64 122.2C1138.5 122.238 1138.38 122.228 1138.28 122.171C1138.19 122.098 1138.13 122.003 1138.1 121.886C1138.05 121.692 1138.05 121.433 1138.12 121.109C1138.2 120.782 1138.36 120.44 1138.6 120.085C1138.83 119.729 1139.17 119.396 1139.6 119.085C1140.04 118.759 1140.61 118.502 1141.31 118.314C1142.09 118.105 1142.77 118.034 1143.36 118.099C1143.95 118.151 1144.43 118.305 1144.82 118.563C1145.22 118.817 1145.55 119.14 1145.79 119.534C1146.05 119.923 1146.23 120.339 1146.35 120.78L1148.04 127.084C1148.08 127.214 1148.06 127.336 1147.99 127.452C1147.94 127.55 1147.84 127.617 1147.71 127.652L1146.82 127.892C1146.68 127.93 1146.56 127.92 1146.46 127.863C1146.36 127.793 1146.29 127.694 1146.25 127.564L1146.03 126.727C1145.92 127.006 1145.76 127.3 1145.53 127.61C1145.31 127.907 1145 128.191 1144.62 128.461C1144.23 128.719 1143.72 128.931 1143.1 129.098ZM1143.11 127.529C1143.65 127.386 1144.1 127.146 1144.49 126.807C1144.86 126.455 1145.11 126.006 1145.23 125.46C1145.36 124.911 1145.33 124.273 1145.13 123.547L1144.99 123.002L1142.82 123.937C1141.93 124.314 1141.3 124.72 1140.91 125.157C1140.53 125.58 1140.4 126.025 1140.52 126.492C1140.62 126.856 1140.8 127.133 1141.08 127.324C1141.36 127.498 1141.68 127.6 1142.04 127.63C1142.4 127.656 1142.76 127.623 1143.11 127.529Z" fill="#FFA4D2"/>
<path d="M1125.48 133.611C1125.35 133.645 1125.22 133.636 1125.11 133.582C1125.01 133.512 1124.94 133.413 1124.91 133.283L1121.5 120.577C1121.46 120.434 1121.47 120.313 1121.53 120.215C1121.6 120.1 1121.7 120.025 1121.83 119.99L1122.8 119.729C1122.95 119.688 1123.08 119.695 1123.18 119.752C1123.28 119.809 1123.35 119.86 1123.39 119.905L1129.6 126.666L1131.64 117.694C1131.65 117.636 1131.68 117.559 1131.72 117.463C1131.78 117.365 1131.89 117.294 1132.04 117.253L1132.99 116.997C1133.14 116.959 1133.26 116.975 1133.36 117.045C1133.47 117.098 1133.55 117.196 1133.59 117.339L1136.99 130.045C1137.03 130.175 1137.01 130.297 1136.94 130.412C1136.89 130.511 1136.79 130.58 1136.64 130.618L1135.69 130.873C1135.56 130.908 1135.44 130.899 1135.33 130.845C1135.23 130.775 1135.16 130.675 1135.12 130.546L1132.56 120.972L1131.01 128.186C1130.99 128.33 1130.94 128.455 1130.86 128.56C1130.77 128.653 1130.65 128.72 1130.49 128.762L1129.89 128.923C1129.72 128.969 1129.58 128.971 1129.48 128.93C1129.36 128.877 1129.26 128.794 1129.16 128.682L1124.19 123.214L1126.76 132.788C1126.79 132.917 1126.78 133.04 1126.71 133.155C1126.65 133.254 1126.56 133.32 1126.43 133.355L1125.48 133.611Z" fill="#FFA4D2"/>
</g>
</g>
<defs>
<linearGradient id="paint0_linear_3008_32468" x1="0" y1="0" x2="839.539" y2="-476.589" gradientUnits="userSpaceOnUse">
<stop offset="0.32" stop-color="#332196" stop-opacity="0"/>
<stop offset="1" stop-color="#332196" stop-opacity="0.5"/>
</linearGradient>
<clipPath id="clip0_3008_32468">
<rect width="1210" height="176" rx="8" fill="white"/>
</clipPath>
</defs>
</svg>
`;
var $c49aa0f374b6c6e6$export$e6b27403e36c0bbe;
(function(MenuOptionValue) {
    MenuOptionValue["USER_TIMELINE"] = "user_timeline";
    MenuOptionValue["COMING_SOON"] = "coming_soon";
    MenuOptionValue["ACCESS_MAP"] = "access_map";
    MenuOptionValue["COMPARE_ACCESS_WITH_OTHERS"] = "compare_access_with_others";
})($c49aa0f374b6c6e6$export$e6b27403e36c0bbe || ($c49aa0f374b6c6e6$export$e6b27403e36c0bbe = {}));
var $c49aa0f374b6c6e6$export$80bb308b2adda3e8;
(function(TabValues) {
    TabValues[TabValues["All"] = 1] = "All";
    TabValues[TabValues["Workforce"] = 2] = "Workforce";
    TabValues[TabValues["External"] = 3] = "External";
    TabValues[TabValues["Machine"] = 4] = "Machine";
    TabValues[TabValues["Privileged"] = 5] = "Privileged";
})($c49aa0f374b6c6e6$export$80bb308b2adda3e8 || ($c49aa0f374b6c6e6$export$80bb308b2adda3e8 = {}));
const $c49aa0f374b6c6e6$export$518ce1a62fea87d6 = [
    {
        label: "All",
        value: 1,
        iconKind: "UserManagement",
        isDisabled: false
    },
    {
        label: "Workforce",
        value: 2,
        iconKind: "UserIdentity",
        isDisabled: false
    },
    {
        label: "External",
        value: 3,
        iconKind: "Workbench",
        isDisabled: true
    },
    {
        label: "Machines",
        value: 4,
        iconKind: "MachineIdentity",
        isDisabled: true
    },
    {
        label: "Privileged",
        value: 5,
        iconKind: "PrivilgedAccess",
        isDisabled: true
    }
];
var $c49aa0f374b6c6e6$export$bded93a4898e26f7;
(function(CustomizeViewTabValues) {
    CustomizeViewTabValues[CustomizeViewTabValues["Humans"] = 1] = "Humans";
    CustomizeViewTabValues[CustomizeViewTabValues["Machines"] = 2] = "Machines";
})($c49aa0f374b6c6e6$export$bded93a4898e26f7 || ($c49aa0f374b6c6e6$export$bded93a4898e26f7 = {}));
const $c49aa0f374b6c6e6$export$35b3990805152d9b = [
    {
        label: "Humans",
        value: 1,
        iconKind: "User",
        isDisabled: false
    },
    {
        label: "Machines",
        value: 2,
        iconKind: "MachineIdentity",
        isDisabled: true
    }
];
const $c49aa0f374b6c6e6$export$7dac1d63a1a3adff = (str)=>str.split(" ").map((word)=>word ? word.charAt(0).toUpperCase() + word.slice(1) : "").join(" ");
const $c49aa0f374b6c6e6$export$5821853e0b155507 = [
    {
        label: "A to Z",
        value: "Asc",
        isChecked: false,
        icon: "ArrowUp"
    },
    {
        label: "Z to A",
        value: "Desc",
        isChecked: false,
        icon: "ArrowDown"
    }
];
const $c49aa0f374b6c6e6$export$2e40ba47c9674fe4 = [
    {
        label: "Oldest",
        value: "ASC",
        isChecked: false,
        icon: "ArrowUp"
    },
    {
        label: "Latest",
        value: "DESC",
        isChecked: false,
        icon: "ArrowDown"
    }
];
const $c49aa0f374b6c6e6$export$9c04fe193594da37 = (imageId)=>{
    if (!imageId || typeof imageId !== "string") return null; // Handle undefined, null, or non-string values
    return imageId.startsWith("http") ? imageId : `${0, $8ff2252602deef38$export$ca6dda5263526f75}${imageId}`;
};
const $c49aa0f374b6c6e6$export$aa787302ec03bf2a = (filters)=>{
    const filterMap = {};
    filters.forEach((filter)=>{
        const { field: field, operator: operator, values: values } = filter;
        if (!filterMap[field]) filterMap[field] = {
            field: field,
            operator: operator,
            values: new Set(values)
        };
        else // Merge values into existing field entry
        values.forEach((value)=>filterMap[field].values.add(value));
    });
    // Convert Sets back to arrays
    return Object.values(filterMap).map((filter)=>({
            ...filter,
            values: Array.from(filter.values)
        }));
};
const $c49aa0f374b6c6e6$export$7f8c82ac21d17eac = ()=>({
        USER_TIMELINE: {
            label: "User Timeline",
            value: "user_timeline"
        },
        ACCESS_MAP: {
            label: "Access Path",
            value: "access_path"
        },
        COMING_SOON: {
            label: "Coming Soon",
            value: "coming_soon"
        },
        COMPARE_ACCESS: {
            label: "Compare Access with Others",
            value: "compare_access_with_others"
        }
    });


function $c2a667d49c01f235$var$isIdentityResponse(data) {
    if (typeof data !== "object" || data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("API Response Validation Failed: Data is not an object or is null");
        return false;
    }
    const response = data;
    // Check if "data" key exists and is an object
    if (!response.data) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error('API Response Validation Failed: "data" key missing or not an object');
        return false;
    }
    // Validate "identities" as an array
    if (!Array.isArray(response.data.identities)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error('API Response Validation Failed: "identities" should be an array');
        return false;
    }
    // Validate each identity object
    const identityErrors = response.data.identities.some((identity, index)=>{
        if (typeof identity.id !== "string" || typeof identity.name !== "string") {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`API Response Validation Failed: Invalid structure in identity at index ${index}`, identity);
            return true;
        }
        if (typeof identity.email !== "string" || typeof identity.jobTitle !== "string" || typeof identity.department !== "string" || typeof identity.status !== "string") (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn(`API Response Validation Failed: Invalid structure in identity at index ${index}`, identity);
        return false;
    });
    if (identityErrors) return false;
    // Optional: Validate nextPageToken if it exists
    if ("nextPageToken" in response.data && response.data.nextPageToken !== undefined && typeof response.data.nextPageToken !== "string") {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn('API Response Validation Failed: "nextPageToken" should be a string if present');
        return false;
    }
    return true;
}
// Function to fetch ISPM suggestions
const $c2a667d49c01f235$var$getUserIdentities = async ({ pageSize: pageSize, nextPageToken: nextPageToken, params: params })=>{
    let { USER_IDENTITY_URL: USER_IDENTITY_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    // Append query parameters conditionally
    const queryParams = new URLSearchParams({
        pageSize: pageSize.toString()
    });
    if (nextPageToken) queryParams.append("nextPageToken", nextPageToken);
    if (params?.sortDirection && params.sortDirection.trim() !== "") queryParams.append("sortDirection", params.sortDirection);
    USER_IDENTITY_URL = `${USER_IDENTITY_URL}?${queryParams.toString()}`;
    const requestBody = {
        searchText: params?.searchText ?? "",
        filters: (0, $c49aa0f374b6c6e6$export$aa787302ec03bf2a)(params?.filters ?? [])
    };
    const config = {
        method: "POST",
        timeout: 30000,
        headers: {
            "Content-Type": "application/json"
        },
        data: requestBody
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(USER_IDENTITY_URL, config, $c2a667d49c01f235$var$isIdentityResponse);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching identities data: ", {
            error: error
        });
        throw error;
    }
};
var $c2a667d49c01f235$export$2e2bcd8739ae039 = $c2a667d49c01f235$var$getUserIdentities;




function $0151190a1090cf08$var$isIdentityAccessResponse(data) {
    return typeof data === "object" && data !== null;
}
// Function to fetch ISPM suggestions
const $0151190a1090cf08$var$getIdentityAccessSummary = async (userId)=>{
    const { IDENTITY_ACCESS_SUMMARY_URL: IDENTITY_ACCESS_SUMMARY_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const identityAccessUrl = IDENTITY_ACCESS_SUMMARY_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId); // Replace the hardcoded userId with the dynamic one
    const config = {
        timeout: 30000
    };
    const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(identityAccessUrl, config, $0151190a1090cf08$var$isIdentityAccessResponse);
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("getIdentityAccessSummary - ", {
        identityAccessUrl: identityAccessUrl,
        config: config,
        isIdentityAccessResponse: $0151190a1090cf08$var$isIdentityAccessResponse
    });
    return response;
};
var $0151190a1090cf08$export$2e2bcd8739ae039 = $0151190a1090cf08$var$getIdentityAccessSummary;







function $4bad9e443f6affb7$export$261a85e74baa8d2b(data) {
    if (typeof data !== "object" || data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isTimelineResponse - Invalid response: Expected an object.");
        return false;
    }
    const response = data; // Cast `data` safely
    if (!Array.isArray(response.value)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isTimelineResponse - Timeline API response is not valid. 'value' must be an array.");
        return false;
    }
    if ("nextPageToken" in response && typeof response.nextPageToken !== "string") {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isTimelineResponse - Invalid 'nextPageToken': Expected a string.");
        return false;
    }
    const isInvalidEvent = response.value.some((event, index)=>{
        if (typeof event !== "object") {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid event at index ${index}: Expected an object.`);
            return true;
        }
        const eventData = event; // Safe type assertion
        if (typeof eventData.type !== "string") {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid event at index ${index}: Missing or invalid 'type' property.`);
            return true;
        }
        switch(eventData.type){
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).ACCESS_REQUEST:
                if (!eventData.request || typeof eventData.request !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid ACCESS_REQUEST event at index ${index}: 'request' property is missing or invalid.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).CERTIFICATION:
                if (!eventData.certificationDetails || typeof eventData.certificationDetails !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid CERTIFICATION event at index ${index}: 'certificationDetails' property is missing or invalid.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).RULE_TRIGGER:
                if (!eventData.ruleDetails || typeof eventData.ruleDetails !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid RULE_TRIGGER event at index ${index}: 'ruleDetails' property must be an array.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).ACCESS:
                if (!eventData.accessDetails || typeof eventData.accessDetails !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid ACCESS event at index ${index}: 'accessDetails' property is missing or invalid.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_APPLICATION_CHANGE:
                if (!eventData.appOwnerChanges || typeof eventData.appOwnerChanges !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid OWNER_APPLICATION_CHANGE event at index ${index}: 'appOwnerChanges' property must be an array.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).OWNER_ENTITLEMENT_CHANGE:
                if (!eventData.entitlementOwnerChanges || typeof eventData.entitlementOwnerChanges !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid OWNER_ENTITLEMENT_CHANGE event at index ${index}: 'entitlementOwnerChanges' property must be an array.`);
                    return true;
                }
                break;
            case (0, $1d3288d13a1a1df7$export$bd8b1d638ec01b5f).USER_ATTRIBUTES_CHANGE:
                if (!eventData.attributeChanges || typeof eventData.attributeChanges !== "object") {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Invalid USER_ATTRIBUTES_CHANGE event at index ${index}: 'attributeChanges' property must be an array.`);
                    return true;
                }
                break;
            default:
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`isTimelineResponse - Unknown event type at index ${index}: '${String(eventData.type)}'`);
                return true;
        }
        return false;
    });
    return !isInvalidEvent;
}
const $4bad9e443f6affb7$var$getUserTimeline = async ({ pageSize: pageSize, nextPageToken: nextPageToken, params: params, userId: userId })=>{
    const { USER_TIMELINE_URL: USER_TIMELINE_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    let timelineUrl = USER_TIMELINE_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId);
    const queryParams = new URLSearchParams();
    if (pageSize) queryParams.append("pageSize", pageSize.toString());
    if (nextPageToken) queryParams.append("nextPageToken", nextPageToken);
    else if (params?.sortDirection && params.sortDirection.trim() !== "") {
        // We have to create base64 next page token for the sort direction. only do it if nextpagetoken is not already there
        const sortNextPageToken = (0, $10a04991e0e365ed$export$8fb536984ec8b4d7)(`{"sortField":"${params.sortField ?? "timestamp"}","sortOrder":"${params.sortDirection}"}`);
        queryParams.append("nextPageToken", sortNextPageToken);
    }
    if (queryParams.toString()) timelineUrl += `?${queryParams.toString()}`;
    const requestBody = {
        searchText: params?.searchText ?? "",
        filters: (0, $c49aa0f374b6c6e6$export$aa787302ec03bf2a)(params?.filters ?? []),
        startDate: params?.startDate ?? null,
        endDate: params?.endDate ?? null
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(timelineUrl, {
            timeout: 30000,
            method: "POST",
            data: requestBody
        }, $4bad9e443f6affb7$export$261a85e74baa8d2b);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching timeline data:", {
            error: error
        });
        throw error;
    }
};
var $4bad9e443f6affb7$export$2e2bcd8739ae039 = $4bad9e443f6affb7$var$getUserTimeline;




const $ef1666d1a8579d02$export$569070b09cb0ade9 = (options)=>{
    const [timelineData, setTimelineData] = (0, $cURGa$useState)({
        value: [],
        nextPageToken: ""
    });
    const [isLoadingMore, setIsLoadingMore] = (0, $cURGa$useState)(false);
    const [isErrorWhilePagination, setIsErrorWhilePagination] = (0, $cURGa$useState)(false);
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $4bad9e443f6affb7$export$2e2bcd8739ae039), [
        options
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (data) setTimelineData(data);
    }, [
        data
    ]);
    const loadMoreTimelineData = (0, $cURGa$useCallback)(async ()=>{
        if (!timelineData.nextPageToken || isLoadingMore) return;
        setIsLoadingMore(true);
        setIsErrorWhilePagination(false);
        try {
            const newData = await (0, $4bad9e443f6affb7$export$2e2bcd8739ae039)({
                ...options,
                nextPageToken: timelineData.nextPageToken
            });
            setTimelineData((prev)=>({
                    value: [
                        ...prev.value,
                        ...newData.value
                    ],
                    nextPageToken: newData.nextPageToken || ""
                }));
        } catch (fetchError) {
            setIsErrorWhilePagination(true);
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to load more timeline data:", fetchError);
        } finally{
            setIsLoadingMore(false);
        }
    }, [
        timelineData.nextPageToken,
        isLoadingMore,
        options
    ]);
    return {
        timelineData: timelineData,
        isLoading: isLoading,
        error: error,
        loadMoreTimelineData: loadMoreTimelineData,
        isLoadingMore: isLoadingMore,
        setIsLoadingMore: setIsLoadingMore,
        isErrorWhilePagination: isErrorWhilePagination
    };
};
const $ef1666d1a8579d02$export$4fe23b82bcf2d5d1 = (userId)=>{
    // Call the useFetch hook with getUserTimeline API and the userId parameter
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $0151190a1090cf08$export$2e2bcd8739ae039), [
        userId
    ] // Pass userId as a parameter in an array
    );
    return {
        data: data,
        isLoading: isLoading,
        error: error
    }; // Return the API response, loading state, and error
};
const $ef1666d1a8579d02$export$d560c080e248adcd = (options)=>{
    const [identityData, setIdentityData] = (0, $cURGa$useState)({
        data: {
            identities: [],
            nextPageToken: ""
        }
    });
    const [isLoadingMore, setIsLoadingMore] = (0, $cURGa$useState)(false);
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $c2a667d49c01f235$export$2e2bcd8739ae039), [
        options
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (data) setIdentityData(data);
    }, [
        data
    ]);
    const loadMoreIdentitiesData = (0, $cURGa$useCallback)(async ()=>{
        if (!identityData.data.nextPageToken || isLoadingMore) return;
        setIsLoadingMore(true);
        try {
            const newData = await (0, $c2a667d49c01f235$export$2e2bcd8739ae039)({
                ...options,
                nextPageToken: identityData.data.nextPageToken
            });
            setIdentityData((prev)=>({
                    data: {
                        identities: [
                            ...prev.data.identities,
                            ...newData.data.identities
                        ],
                        nextPageToken: newData.data.nextPageToken || ""
                    }
                }));
        } catch (fetchError) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to load more timeline data:", fetchError);
            throw fetchError;
        } finally{
            setIsLoadingMore(false);
        }
    }, [
        identityData.data.nextPageToken,
        isLoadingMore,
        options
    ]);
    return {
        identityData: identityData,
        isLoading: isLoading,
        error: error,
        loadMoreIdentitiesData: loadMoreIdentitiesData,
        isLoadingMore: isLoadingMore,
        setIsLoadingMore: setIsLoadingMore
    };
};
const $ef1666d1a8579d02$export$8ef2730b11d678cb = (userId)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $48814d96dbb576d5$export$2e2bcd8739ae039), [
        userId,
        undefined,
        undefined
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
















function $159e77d9f19e9b9d$var$IdentityCard({ identity: identity }) {
    const { id: id, name: name, username: username, imageUrl: imageUrl, application: application, jobTitle: jobTitle, employeeId: employeeId, employeeType: employeeType } = identity;
    const avatar = imageUrl ? (0, $c49aa0f374b6c6e6$export$9c04fe193594da37)(imageUrl) : null;
    const platformIcon = application?.imageId ? (0, $c49aa0f374b6c6e6$export$9c04fe193594da37)(application.imageId) : null;
    const platform = application ? application.applicationName : "";
    const history = (0, $cURGa$useHistory)();
    const dispatch = (0, $cURGa$useDispatch)();
    const customizeViewFields = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.customizeViewFields.humans);
    const { permission: timelinePermission } = (0, $f368c544e3051320$export$2e2bcd8739ae039)((0, $e93470e5e98f2427$export$e08c7aae438e15b4).HUMAN_IDENTITY_TIMELINE_VIEW);
    const showAdvanceTierTooltip = timelinePermission?.licenseDisplayMetadata?.showPlanHighlightLabel;
    const MENU_ITEMS = (0, $c49aa0f374b6c6e6$export$7f8c82ac21d17eac)();
    const menuOptions = (0, $cURGa$useMemo)(()=>[
            {
                ...MENU_ITEMS.USER_TIMELINE,
                id: id,
                suffixIcon: showAdvanceTierTooltip ? "AdvancedTier" : "",
                isDisabled: !timelinePermission?.enabled,
                tooltip: {
                    isShow: showAdvanceTierTooltip ?? false,
                    value: timelinePermission?.licenseDisplayMetadata?.planHighlightLabelValue ?? ""
                }
            },
            {
                ...MENU_ITEMS.ACCESS_MAP,
                icon: "",
                id: id
            },
            {
                ...MENU_ITEMS.COMING_SOON,
                prefixIcon: "Party",
                isDisabled: true,
                id: id
            },
            {
                ...MENU_ITEMS.COMPARE_ACCESS,
                icon: "",
                isDisabled: true,
                id: id
            }
        ], [
        MENU_ITEMS.ACCESS_MAP,
        MENU_ITEMS.COMING_SOON,
        MENU_ITEMS.COMPARE_ACCESS,
        MENU_ITEMS.USER_TIMELINE,
        id,
        showAdvanceTierTooltip,
        timelinePermission?.enabled,
        timelinePermission?.licenseDisplayMetadata?.planHighlightLabelValue
    ]);
    const getMenuItem = (option, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$MenuItem), {
            option: option,
            onClick: ()=>!option.isDisabled && handleKebabMenuClick(option),
            tabIndex: index,
            prefixIcon: option.prefixIcon ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                kind: option.prefixIcon,
                renderBare: true
            }) : undefined,
            suffixIcon: option.suffixIcon ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                kind: option.suffixIcon,
                renderBare: true
            }) : undefined,
            className: option.value
        }, option.value);
    const getCustomKebabMenuItems = (options)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Fragment), {
            children: options.map((option, index)=>option.tooltip?.isShow ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                    isPortalEnabled: true,
                    className: `Ispm-IdentityCard-${option.value}`,
                    text: option.tooltip.value,
                    placement: "left-start",
                    trigger: getMenuItem(option, index)
                }, option.value) : getMenuItem(option, index))
        });
    const handleKebabMenuClick = (selectedOption)=>{
        dispatch((0, $8939fb7be58f56d0$export$6d06ea42ee2ef64)(identity));
        switch(selectedOption.value){
            case MENU_ITEMS.USER_TIMELINE.value:
                history.push(`${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}/${selectedOption.id}/timeline`);
                break;
            case MENU_ITEMS.ACCESS_MAP.value:
                history.push(`${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}/${selectedOption.id}/accessPath`);
                break;
            default:
                break;
        }
    };
    const trigger = /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
        size: "medium",
        kind: "ghost",
        "data-testid": "menu-trigger",
        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
            kind: "MoreVertical",
            color: "neutral-100",
            size: "medium"
        })
    });
    const dynamicFields = [
        {
            label: (0, $f618e3351c7ca235$export$98e7b536029f5094).EMPLOYEE_ID,
            value: employeeId
        },
        {
            label: (0, $f618e3351c7ca235$export$98e7b536029f5094).JOB_TITLE,
            value: jobTitle
        },
        {
            label: (0, $f618e3351c7ca235$export$98e7b536029f5094).EMPLOYEE_TYPE,
            value: employeeType
        }
    ];
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentityCard",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-IdentityCard-left",
                children: [
                    avatar ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                        size: "medium",
                        src: avatar,
                        alt: `${name}'s avatar`
                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                kind: "h3",
                                color: "--color-foreground-neutral-bold",
                                children: [
                                    name,
                                    customizeViewFields.includes("Username") && username && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                                className: "Ispm-IdentityCard-dot"
                                            }),
                                            " ",
                                            username
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-IdentityCard-applicationWrapper",
                                children: [
                                    customizeViewFields.includes("Identity Source") && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body2",
                                                color: "--color-foreground-neutral-subtle",
                                                children: "Identity Source:"
                                            }),
                                            platformIcon ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                                                size: "small",
                                                src: platformIcon,
                                                alt: `${platform}'s avatar`
                                            }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ApplicationIcon), {
                                                size: "small"
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body2",
                                                color: "--color-foreground-neutral-bold",
                                                children: platform.toUpperCase()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-IdentityCard-aboutUser",
                                        children: dynamicFields.filter(({ label: label })=>customizeViewFields.includes(label)).map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                                                children: [
                                                    value && index > 0 && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body2",
                                                        color: "--color-foreground-neutral-bold",
                                                        children: "\u2022"
                                                    }),
                                                    label === (0, $f618e3351c7ca235$export$98e7b536029f5094).EMPLOYEE_ID ? /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                                kind: "body2",
                                                                color: "--color-foreground-neutral-subtle",
                                                                children: [
                                                                    label,
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                kind: "body2",
                                                                color: "--color-foreground-neutral-bold",
                                                                children: value
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body2",
                                                        color: "--color-foreground-neutral-bold",
                                                        children: value
                                                    })
                                                ]
                                            }, label))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityCard-right",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-IdentityCard-menu",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Menu), {
                        options: menuOptions,
                        onChange: handleKebabMenuClick,
                        trigger: trigger,
                        CustomMenuItems: getCustomKebabMenuItems(menuOptions),
                        dataTestId: "ispm-identities-kebabMenu"
                    })
                })
            })
        ]
    }, id);
}
var $159e77d9f19e9b9d$export$2e2bcd8739ae039 = $159e77d9f19e9b9d$var$IdentityCard;



function $c3778e4b2e2822ac$var$IdentityList({ searchQuery: searchQuery, sortDirection: sortDirection, selectedFilters: selectedFilters }) {
    const dispatch = (0, $cURGa$useDispatch)();
    const observer = (0, $cURGa$useRef)(null);
    const debouncedSearch = (0, $a925d1f723de0eb3$export$2e2bcd8739ae039)(searchQuery, 500);
    const debouncedFilters = (0, $a925d1f723de0eb3$export$2e2bcd8739ae039)(selectedFilters, 500);
    const [infiniteScrollError, setInfiniteScrollError] = (0, $cURGa$useState)(false);
    const { identityData: identityData, isLoading: isLoading, error: identitiesError, loadMoreIdentitiesData: loadMoreIdentitiesData, isLoadingMore: isLoadingMore } = (0, $ef1666d1a8579d02$export$d560c080e248adcd)({
        pageSize: (0, $8ff2252602deef38$export$6a9978fc3f20cdf0),
        params: {
            searchText: debouncedSearch,
            sortDirection: sortDirection,
            filters: debouncedFilters
        }
    });
    const lastElementRef = (0, $cURGa$useCallback)((node)=>{
        if (!node || isLoading || infiniteScrollError) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) loadMoreIdentitiesData().catch((error)=>{
                setInfiniteScrollError(true);
                if (error instanceof Error) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to fetch more data:", {
                    error: error
                });
                else (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("An unknown error occurred:", {
                    error: error
                });
            });
        });
        observer.current.observe(node);
    }, [
        isLoading,
        loadMoreIdentitiesData,
        infiniteScrollError
    ]);
    (0, $cURGa$useEffect)(()=>{
        // Reset the selected user
        dispatch((0, $8939fb7be58f56d0$export$a48d3e6407bbda0d)());
    }, [
        dispatch
    ]);
    (0, $cURGa$useEffect)(()=>{
        window.scrollTo({
            top: 0,
            behavior: "auto"
        });
    }, []);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentityList",
        children: [
            identitiesError && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039), {}),
            isLoading && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityList-loader",
                "data-testid": "skeleton-loader",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $91fec4c33abf7941$export$2e2bcd8739ae039), {
                    itemCount: 10
                })
            }),
            !identitiesError && identityData.data.identities.length === 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityList-noData",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                    children: "No data found."
                })
            }),
            identityData.data.identities.map((identity, index, identArr)=>{
                const isLastElement = index === identArr.length - 1;
                return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    ref: isLastElement ? lastElementRef : null,
                    className: "Ispm-IdentityList-card",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $159e77d9f19e9b9d$export$2e2bcd8739ae039), {
                        identity: identity
                    })
                }, identity.id);
            }),
            isLoadingMore && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityList-loader",
                "data-testid": "loader-loop",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                    kind: "loop",
                    format: "main",
                    color: "brand"
                })
            }),
            infiniteScrollError && /*#__PURE__*/ (0, $cURGa$jsx)((0, $ab96b7bbd3fb8daa$export$2e2bcd8739ae039), {})
        ]
    });
}
var $c3778e4b2e2822ac$export$2e2bcd8739ae039 = $c3778e4b2e2822ac$var$IdentityList;










function $ccb738ec0ad1653d$var$DarkIdentitiesTypeComingSoonWidget() {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: (0, $c49aa0f374b6c6e6$export$8c1a92ef10d2822b)
        }
    });
}
function $ccb738ec0ad1653d$var$IdentitiesTypeComingSoonWidgetSvg() {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: (0, $c49aa0f374b6c6e6$export$27d86da24a8a6ed6)
        }
    });
}
function $ccb738ec0ad1653d$var$IspmComingSoon({ onSeeMoreClick: onSeeMoreClick }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-ComingSoon",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-ComingSoon-BackgroundImages",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-ComingSoon-BackgroundImage",
                    children: theme ? /*#__PURE__*/ (0, $cURGa$jsx)($ccb738ec0ad1653d$var$DarkIdentitiesTypeComingSoonWidget, {}) : /*#__PURE__*/ (0, $cURGa$jsx)($ccb738ec0ad1653d$var$IdentitiesTypeComingSoonWidgetSvg, {})
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-ComingSoon-ForegroundContent",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                        kind: "body2",
                        color: "--color-foreground-info-medium",
                        children: [
                            " ",
                            "COMING SOON"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h2",
                        color: "--color-foreground-neutral-bold",
                        children: "Identity Metrics"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body3",
                        color: "--color-foreground-neutral-medium",
                        children: "Gain a clearer view of your organization\u2019s identities with new dashboard elements."
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "filled",
                        size: "small",
                        rightIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "ArrowRight",
                            size: "medium",
                            color: "Indigo-700"
                        }),
                        className: "Ispm-ComingSoon-seeMoreButton",
                        onClick: onSeeMoreClick,
                        dataTestId: "ispm-identities-seemore",
                        children: "See More"
                    })
                ]
            })
        ]
    });
}
var $ccb738ec0ad1653d$export$2e2bcd8739ae039 = $ccb738ec0ad1653d$var$IspmComingSoon;








function $9694cc6340be20f1$var$MetricsPreview({ onClose: onClose }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: `Ispm-MetricsPreview ${theme ? "Ispm-MetricsPreview-Dark" : "Ispm-MetricsPreview-Light"}`,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-MetricsCardWrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "MetricCard",
                        "data-testid": "metric-card",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: theme ? (0, $c49aa0f374b6c6e6$export$b7c5c27680c06eac) : (0, $c49aa0f374b6c6e6$export$70072cbb5af69ff9)
                                }
                            }),
                            text: `Get a high-level view of your organization's identity landscape, including workforce, external, and machine identities.`,
                            maxWidth: "18rem"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "MetricCard",
                        "data-testid": "metric-card",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: theme ? (0, $c49aa0f374b6c6e6$export$f6c885235639e0c1) : (0, $c49aa0f374b6c6e6$export$9a660bb013053fb1)
                                }
                            }),
                            text: "See where your identities originate by tracking which sources connect them to your organization.",
                            maxWidth: "18rem"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "MetricCard",
                        "data-testid": "metric-card",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Tooltip), {
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: theme ? (0, $c49aa0f374b6c6e6$export$c526750474512544) : (0, $c49aa0f374b6c6e6$export$f452b0b7b391032f)
                                }
                            }),
                            text: "Monitor identity trends by tracking how many users were added or removed over time.",
                            maxWidth: "18rem"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-MetricCard-ComingSoonClose",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-MetricCard-ComingSoonChipTextWrapper",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                label: "COMING SOON",
                                className: "Ispm-MetricCard-comingSoonChip",
                                color: "--color-foreground-info-medium"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                kind: "body2",
                                color: "--color-foreground-info-medium",
                                children: "You\u2019re viewing sample data for demonstration purposes."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "filled",
                        size: "small",
                        onClick: onClose,
                        className: "Ispm-MetricsPreview-Close",
                        dataTestId: "ispm-identities-metrics-preview-close",
                        children: "Close"
                    })
                ]
            })
        ]
    });
}
var $9694cc6340be20f1$export$2e2bcd8739ae039 = $9694cc6340be20f1$var$MetricsPreview;














const $f7e82addde74b75c$var$optionsData = {
    humans: [
        (0, $f618e3351c7ca235$export$98e7b536029f5094).USERNAME,
        (0, $f618e3351c7ca235$export$98e7b536029f5094).IDENTITY_SOURCE,
        (0, $f618e3351c7ca235$export$98e7b536029f5094).EMPLOYEE_ID,
        (0, $f618e3351c7ca235$export$98e7b536029f5094).JOB_TITLE,
        (0, $f618e3351c7ca235$export$98e7b536029f5094).EMPLOYEE_TYPE
    ],
    machines: [
        (0, $f618e3351c7ca235$export$33936cb096312b35).RESOURCE,
        (0, $f618e3351c7ca235$export$33936cb096312b35).OWNER,
        (0, $f618e3351c7ca235$export$33936cb096312b35).TRUST
    ]
};
function $f7e82addde74b75c$var$CustomizeView({ onClose: onClose }) {
    const [activeTab, setActiveTab] = (0, $cURGa$useState)((0, $c49aa0f374b6c6e6$export$bded93a4898e26f7).Humans);
    const selectedTab = (0, $c49aa0f374b6c6e6$export$35b3990805152d9b).find((tab)=>tab.value === activeTab);
    const tabName = selectedTab?.label ?? "Humans";
    const wrapperRef = (0, $cURGa$useRef)(null);
    const dispatch = (0, $cURGa$useDispatch)();
    const selectedValues = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.customizeViewFields);
    (0, $cURGa$useEffect)(()=>{
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) onClose();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        onClose
    ]);
    const key = activeTab === (0, $c49aa0f374b6c6e6$export$bded93a4898e26f7).Humans ? (0, $f618e3351c7ca235$export$5d73826f230727a6).HUMANS : (0, $f618e3351c7ca235$export$5d73826f230727a6).MACHINES;
    const handleCheckboxToggle = (field)=>{
        const updated = new Set(selectedValues[key]);
        if (updated.has(field)) updated.delete(field);
        else updated.add(field);
        dispatch((0, $8939fb7be58f56d0$export$618dc9a39f8a471c)({
            tab: key,
            fields: Array.from(updated)
        }));
    };
    const handleSelectAll = ()=>{
        dispatch((0, $8939fb7be58f56d0$export$618dc9a39f8a471c)({
            tab: key,
            fields: $f7e82addde74b75c$var$optionsData[key]
        }));
    };
    const handleReset = ()=>{
        dispatch((0, $8939fb7be58f56d0$export$d5d220339cb95d48)());
    };
    const handleChange = (value)=>{
        setActiveTab(value);
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "ISPM-Identities-customizeView",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-Identities-customizeView-header",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "h3",
                        color: "--color-foreground-neutral-bold",
                        children: "Customize View"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                        kind: "ghost",
                        size: "small",
                        onClick: onClose,
                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Close",
                            size: "medium"
                        }),
                        dataTestId: "ispm-identities-customizeView-close"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "ISPM-Identities-customizeView-TabGroup",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButtonGroup), {
                    selection: activeTab,
                    setSelection: handleChange,
                    children: (0, $c49aa0f374b6c6e6$export$35b3990805152d9b).map((tab)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                            label: tab.label,
                            isDisabled: tab.isDisabled,
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: tab.iconKind,
                                size: "medium",
                                color: "Neutral-1000"
                            })
                        }, tab.value))
                })
            }),
            (0, $c49aa0f374b6c6e6$export$35b3990805152d9b).map((tab)=>{
                const tabKey = tab.value === (0, $c49aa0f374b6c6e6$export$bded93a4898e26f7).Humans ? (0, $f618e3351c7ca235$export$5d73826f230727a6).HUMANS : (0, $f618e3351c7ca235$export$5d73826f230727a6).MACHINES;
                const tabValuesSet = new Set(selectedValues[tabKey]);
                return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TabContent), {
                    value: tabName,
                    tabValue: tab.label,
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "ISPM-Identities-customize-checkbox-list",
                        children: $f7e82addde74b75c$var$optionsData[tabKey].map((field, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Checkbox), {
                                name: `checkbox-${index}`,
                                kind: "text",
                                isChecked: tabValuesSet.has(field),
                                onChange: ()=>handleCheckboxToggle(field),
                                label: field,
                                textPosition: "after"
                            }, field))
                    })
                }, tab.label);
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-Identities-customizeView-footer",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        className: "ISPM-Identities-customizeView-selectallButton",
                        type: "button",
                        kind: "ghost",
                        size: "small",
                        onClick: handleSelectAll,
                        dataTestId: "ispm-identities-customizeView-selectAll",
                        children: "Select All"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        className: "ISPM-Identities-customizeView-resetButton",
                        type: "button",
                        kind: "ghost",
                        size: "small",
                        onClick: handleReset,
                        dataTestId: "ispm-identities-customizeView-reset",
                        children: "Reset to default"
                    })
                ]
            })
        ]
    });
}
var $f7e82addde74b75c$export$2e2bcd8739ae039 = $f7e82addde74b75c$var$CustomizeView;



$cbb5fe21dd3e2706$var$IdentitiesToolbar.defaultProps = {
    isViewFeatureAvailable: true,
    isSortFeatureAvailable: true,
    searchInputPlaceholder: "Search identities",
    sortOptions: (0, $c49aa0f374b6c6e6$export$5821853e0b155507),
    isFilterOptionsSelected: false
};
function $cbb5fe21dd3e2706$var$IdentitiesToolbar({ searchValue: searchValue, setSearchValue: setSearchValue, handleFilterClick: handleFilterClick, isFilterOpen: isFilterOpen, toggleSortDirection: toggleSortDirection, isViewFeatureAvailable: isViewFeatureAvailable, isSortFeatureAvailable: isSortFeatureAvailable, searchInputPlaceholder: searchInputPlaceholder, sortOptions: sortOptions, isFilterOptionsSelected: isFilterOptionsSelected, dataTestId: dataTestId, isDateFilterSelected: isDateFilterSelected }) {
    const [options, setOptions] = (0, $cURGa$useState)(sortOptions ?? (0, $c49aa0f374b6c6e6$export$5821853e0b155507));
    const [isViewOpen, setIsViewOpen] = (0, $cURGa$useState)(false);
    const handleSortButtonChange = (selectedOption)=>{
        if (!selectedOption.value) return;
        const alreadyChecked = options.find((option)=>option.value === selectedOption.value && option.isChecked);
        const updatedOptions = options.map((option)=>({
                ...option,
                isChecked: option.value === selectedOption.value ? !option.isChecked : false
            }));
        setOptions(updatedOptions);
        const sortValue = alreadyChecked ? "" : selectedOption.value;
        toggleSortDirection(sortValue);
    };
    const handleViewClick = ()=>{
        setIsViewOpen(!isViewOpen);
    };
    // const handleSearchInputClick
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "ISPM-Identities-toolbar",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "ISPM-Identities-toolbar-search",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$InputField), {
                    name: "searchIdentities",
                    placeholder: searchInputPlaceholder ?? "Search identities",
                    label: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "Search",
                        htmlFor: "searchIdentities",
                        color: "Neutral-600",
                        children: searchInputPlaceholder ?? "Search identities"
                    }),
                    kind: "search",
                    prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "search",
                        color: "Neutral-600",
                        size: "smallMedium"
                    }),
                    value: searchValue,
                    setValue: setSearchValue,
                    size: "medium",
                    dataTestId: `${dataTestId}-search`
                })
            }),
            isSortFeatureAvailable && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "ISPM-Identities-toolbar-sort",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Menu), {
                    options: options,
                    onChange: handleSortButtonChange,
                    trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                        label: "Sort",
                        size: "medium",
                        prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Sort",
                            color: "Neutral-600"
                        })
                    }),
                    dataTestId: `${dataTestId}-sort`
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "ISPM-Identities-toolbar-filter",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                    label: "Filter",
                    onClick: handleFilterClick,
                    isOpen: isFilterOpen,
                    size: "medium",
                    BadgeComp: isFilterOptionsSelected || isDateFilterSelected ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                        kind: "dot",
                        color: "primary",
                        size: "small"
                    }) : undefined,
                    prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: "Filter",
                        color: "Neutral-600"
                    }),
                    dataTestId: `${dataTestId}-filter`
                })
            }),
            isViewFeatureAvailable && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "ISPM-Identities-toolbar-view",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                        label: "View",
                        onClick: handleViewClick,
                        isOpen: isViewOpen,
                        size: "medium",
                        prefixIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "list",
                            color: "Neutral-600"
                        }),
                        dataTestId: `${dataTestId}-view`
                    }),
                    isViewOpen && /*#__PURE__*/ (0, $cURGa$jsx)((0, $f7e82addde74b75c$export$2e2bcd8739ae039), {
                        onClose: ()=>handleViewClick()
                    })
                ]
            })
        ]
    });
}
var $cbb5fe21dd3e2706$export$2e2bcd8739ae039 = $cbb5fe21dd3e2706$var$IdentitiesToolbar;





/* Verify Response Shape for Filters */ function $c4ff51708924255d$var$isGetIdentityFiltersResponse(data) {
    return typeof data === "object" && data !== null && Array.isArray(data.data);
}
/* API Response Validation */ function $c4ff51708924255d$var$isFilterValueResponse(data) {
    return typeof data === "object" && data !== null && "data" in data && Array.isArray(data.data) && data.data.every((item)=>typeof item.id === "string" && typeof item.name === "string");
}
const $c4ff51708924255d$export$bdc4491a79e598ef = async (params)=>{
    const { IDENTITY_FILTERS_URL: IDENTITY_FILTERS_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const config = {
        timeout: 30000,
        params: params
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(IDENTITY_FILTERS_URL, config, $c4ff51708924255d$var$isGetIdentityFiltersResponse);
        return response.data;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`getIdentityFilters - Failed: ${String(error)}`);
        throw new Error(`Error fetching identity filters: ${String(error)}`);
    }
};
const $c4ff51708924255d$export$99855e8db1bc4b8d = async (page, field)=>{
    const { IDENTITY_FILTER_VALUES_URL: IDENTITY_FILTER_VALUES_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const config = {
        timeout: 30000,
        params: {
            page: page,
            field: field
        }
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(IDENTITY_FILTER_VALUES_URL, config, $c4ff51708924255d$var$isFilterValueResponse);
        if (!$c4ff51708924255d$var$isFilterValueResponse(response)) throw new Error("Invalid API response format");
        return response.data.map(({ id: id, name: name, disable: disable })=>({
                id: id,
                label: name ?? "Unknown",
                value: id,
                isDisabled: disable ?? false
            }));
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`getFilterValues - Failed to fetch values for "${field}": ${errorMessage}`);
        throw new Error(`Error fetching filter values for ${field}: ${errorMessage}`);
    }
};
var $c4ff51708924255d$export$2e2bcd8739ae039 = $c4ff51708924255d$export$99855e8db1bc4b8d;



const $bb59f85df5b01b35$var$useIdentityFilters = (page)=>{
    const [filterOptions, setFilterOptions] = (0, $cURGa$useState)({});
    const [setters, setSetters] = (0, $cURGa$useState)({});
    const [isLoading, setIsLoading] = (0, $cURGa$useState)(true);
    const [error, setError] = (0, $cURGa$useState)(null);
    const [filtersData, setFiltersData] = (0, $cURGa$useState)([]);
    const fetchFilters = (0, $cURGa$useCallback)(async ()=>{
        try {
            const filters = await (0, $c4ff51708924255d$export$bdc4491a79e598ef)({
                page: page
            });
            setFiltersData(filters); // Store filters in state
            if (!Array.isArray(filters)) throw new Error("Invalid API response format");
            const newFilterOptions = {};
            const newSetters = {};
            const results = await Promise.allSettled(filters.map(async (filter)=>{
                try {
                    const values = await (0, $c4ff51708924255d$export$99855e8db1bc4b8d)(page, filter.field);
                    return {
                        field: filter.field,
                        values: values
                    };
                } catch (fetchError) {
                    return {
                        field: filter.field,
                        error: fetchError
                    };
                }
            }));
            results.forEach((result)=>{
                if (result.status === "fulfilled" && result.value.values) {
                    const { field: field, values: values } = result.value;
                    newFilterOptions[field] = values.map((item)=>({
                            field: field,
                            label: item.label ?? "Unknown",
                            value: item.value ?? item.id,
                            isChecked: false,
                            isDisabled: item.isDisabled ?? false
                        }));
                    newSetters[field] = (value)=>setFilterOptions((prev)=>({
                                ...prev,
                                [field]: typeof value === "function" ? value(prev[field] || []) : value
                            }));
                } else if (result.status === "rejected") {
                    const errorField = result.reason.field ?? "unknown";
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`Error fetching values for ${errorField}`);
                }
            });
            setFilterOptions(newFilterOptions);
            setSetters(newSetters);
        } catch (mainError) {
            setError(`Error fetching filters: ${String(mainError)}`);
        } finally{
            setIsLoading(false);
        }
    }, [
        page
    ]);
    (0, $cURGa$useEffect)(()=>{
        fetchFilters().catch((unexpectedError)=>{
            setError(`Unexpected error in useEffect: ${String(unexpectedError)}`);
        });
    }, [
        fetchFilters
    ]);
    return {
        filterOptions: filterOptions,
        setters: setters,
        isLoading: isLoading,
        error: error,
        filtersData: filtersData
    };
};
var $bb59f85df5b01b35$export$2e2bcd8739ae039 = $bb59f85df5b01b35$var$useIdentityFilters;




function $6f9384697d20a6b1$var$Identities() {
    const [activeTab, setActiveTab] = (0, $cURGa$useState)((0, $c49aa0f374b6c6e6$export$80bb308b2adda3e8).All);
    const [tabName, setTabName] = (0, $cURGa$useState)("All");
    const [isOpen, setFilterToolboxIsOpen] = (0, $cURGa$useState)(false);
    const [sortDirection, setSortDirection] = (0, $cURGa$useState)("");
    const [selectedFilters, setSelectedFilters] = (0, $cURGa$useState)([]);
    const [searchValue, setSearchValue] = (0, $cURGa$useState)("");
    const [showPreview, setShowPreview] = (0, $cURGa$useState)(false);
    const { filterOptions: filterOptions, setters: setters, isLoading: isLoading, filtersData: filtersData } = (0, $bb59f85df5b01b35$export$2e2bcd8739ae039)("identitiesPage");
    // preventing white edges from showing during vertical or horizontal scroll.
    (0, $cURGa$useEffect)(()=>{
        document.body.classList.add("Ispm-Identities-dark-mode-fix");
        return ()=>{
            document.body.classList.remove("Ispm-Identities-dark-mode-fix");
        };
    }, []);
    const handleChangeFilter = (setter, field)=>(selectedOptions)=>{
            if (!selectedOptions) return;
            setter((prev)=>prev.map((option)=>({
                        ...option,
                        isChecked: selectedOptions.some((selected)=>selected.value === option.value)
                    })));
            // Update selected filters state correctly
            setSelectedFilters((prevFilters)=>{
                const newFilters = selectedOptions.map((option)=>({
                        field: field,
                        operator: "IN",
                        values: [
                            option.value
                        ]
                    }));
                return [
                    ...prevFilters.filter((f)=>f.field !== field),
                    ...newFilters
                ];
            });
        };
    const filterConfigs = Object.keys(filterOptions).map((key)=>{
        const foundFilter = filtersData.find((filter)=>filter.field === key);
        return {
            label: foundFilter?.name ?? key,
            options: filterOptions[key] ?? [],
            setter: setters[key],
            key: key
        };
    });
    const handleChange = (value)=>{
        setActiveTab(value);
        const selectedTab = (0, $c49aa0f374b6c6e6$export$518ce1a62fea87d6).find((tab)=>tab.value === value);
        if (selectedTab) setTabName(selectedTab.label);
    };
    const handleToolboxClick = ()=>{
        setFilterToolboxIsOpen((currOpen)=>!currOpen);
    };
    const formatSelectedItems = (label, selectedOptions)=>{
        if (selectedOptions.length === 0) return label;
         // No selection, return default label
        if (selectedOptions.length === 1) return `${label}: ${selectedOptions[0]}`;
        // If more than 1 selected, apply "+n" format
        return `${label}: ${selectedOptions[0]} + ${selectedOptions.length - 1}`;
    };
    // Function to toggle sorting order
    const toggleSortDirection = (value)=>{
        setSortDirection(value);
    };
    const handleClearAll = ()=>{
        Object.keys(setters).forEach((field)=>{
            setters[field]((prev)=>prev.map((option)=>({
                        ...option,
                        isChecked: false
                    })));
        });
        setSelectedFilters([]);
    };
    if (isLoading) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $a72e27c476852c06$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-Identities",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        className: "Ispm-Identities-heading",
                        color: "--color-foreground-neutral-bold",
                        kind: "h1",
                        children: "Identities"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButtonGroup), {
                        selection: activeTab,
                        setSelection: handleChange,
                        children: (0, $c49aa0f374b6c6e6$export$518ce1a62fea87d6).map((tab)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                                label: tab.label,
                                isDisabled: tab.isDisabled,
                                icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                    kind: tab.iconKind,
                                    size: "medium",
                                    color: "Neutral-1000"
                                })
                            }, tab.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-Identities-tab-content",
                children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$TabContent), {
                    value: tabName,
                    tabValue: tabName,
                    children: [
                        !showPreview ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $ccb738ec0ad1653d$export$2e2bcd8739ae039), {
                            onSeeMoreClick: ()=>setShowPreview(true)
                        }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $9694cc6340be20f1$export$2e2bcd8739ae039), {
                            onClose: ()=>setShowPreview(false)
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cbb5fe21dd3e2706$export$2e2bcd8739ae039), {
                            searchValue: searchValue,
                            setSearchValue: setSearchValue,
                            handleFilterClick: handleToolboxClick,
                            isFilterOpen: isOpen,
                            toggleSortDirection: toggleSortDirection,
                            isFilterOptionsSelected: selectedFilters.length > 0,
                            dataTestId: "ispm-identities",
                            isDateFilterSelected: false
                        }),
                        isOpen && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                            className: "Ispm-Identities-filter-toolbox",
                            children: [
                                filterConfigs.map(({ label: label, options: options, setter: setter, key: key })=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$MenuMulti), {
                                        options: options,
                                        label: formatSelectedItems(label, options.filter((option)=>option.isChecked).map((opt)=>opt.label)),
                                        onChange: handleChangeFilter(setter, key),
                                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                                            kind: "pill",
                                            label: "",
                                            BadgeComp: selectedFilters.find((filter)=>filter.field === key) && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                                                kind: "dot",
                                                color: "primary",
                                                size: "small"
                                            }),
                                            dataTestId: "identities-filter-toolbox-button"
                                        }),
                                        dataTestId: `ispm-identities-filter-${key}`,
                                        minOptionsForFooter: 1,
                                        appendLabelsToButton: false,
                                        sortOnCheck: false,
                                        heightToShowScrollbar: "8rem",
                                        // TODO: Search is not working on the filter. So making below prop higher to hide the filter. Need to fix it.
                                        // JIRA - https://saviyntars.atlassian.net/browse/ISPM-658
                                        minOptionsForSearch: 1000,
                                        maxOptionsToDisplay: 100
                                    }, key)),
                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                                    className: "Ispm-TimelineControlToolbar-ClearFilters",
                                    text: "Clear",
                                    kind: "button",
                                    onClick: handleClearAll,
                                    dataTestId: "ispm-identities-ClearFilters"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $c3778e4b2e2822ac$export$2e2bcd8739ae039), {
                            searchQuery: searchValue,
                            sortDirection: sortDirection,
                            selectedFilters: selectedFilters
                        })
                    ]
                })
            })
        ]
    });
}
var $6f9384697d20a6b1$export$2e2bcd8739ae039 = $6f9384697d20a6b1$var$Identities;













const $2b309ef89c44b128$export$bfe4ac50319c1d9b = (timestamp)=>{
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
};
const $2b309ef89c44b128$export$b0aca466e7158400 = (severity)=>{
    switch(severity){
        case (0, $3b7091d4a3b49a26$export$b718b0d2e31b8ab7).critical:
            return "Critical-1100";
        case (0, $3b7091d4a3b49a26$export$b718b0d2e31b8ab7).High:
            return "Warning-1100";
        case (0, $3b7091d4a3b49a26$export$b718b0d2e31b8ab7).Medium:
            return "Success-1100";
        default:
            return "#000000"; // Default color for undefined severity
    }
};
const $2b309ef89c44b128$export$de9bdbce6502b027 = (fullName)=>{
    const parts = fullName.split(" ");
    const firstNameInitial = parts[0] ? parts[0][0].toUpperCase() : "";
    const lastNameInitial = parts[1] ? parts[1][0].toUpperCase() : "";
    return `${firstNameInitial}${lastNameInitial}`;
};
function $2b309ef89c44b128$export$daf4c137c5f56404(input) {
    let hash = 5381; // Large prime for better distribution
    for(let i = 0; i < input.length; i += 1){
        const char = input.charCodeAt(i);
        hash = (hash * 33 + char) % 2 ** 32; // Keep it within 32-bit range
    }
    return hash.toString(16);
}




function $019b865f2fa53a6c$export$61fc7d43ac8f84b0(fn, wait) {
    let timeout = null;
    return (...args)=>{
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn(...args);
        }, wait);
    };
}
function $019b865f2fa53a6c$export$93bf571733ed38db(accessPath) {
    const { nodes: nodes, links: links } = accessPath;
    const nodeMap = new Map(nodes.map((node)=>[
            node.id,
            node
        ]));
    const paths = [];
    const targetIds = new Set(links.map((link)=>link.target));
    const roots = nodes.filter((node)=>!targetIds.has(node.id));
    let lastRootId = null;
    let lastChildId = null;
    roots.forEach((root)=>{
        const children = links.filter((link)=>link.source === root.id).map((link)=>nodeMap.get(link.target)).filter((node)=>node !== undefined);
        if (children.length === 0) {
            // Handle case where only root exists
            const path = {
                root: root
            };
            paths.push(path);
            return;
        }
        children.forEach((child)=>{
            const grandchildren = links.filter((link)=>link.source === child.id).map((link)=>nodeMap.get(link.target)).filter((node)=>node !== undefined);
            if (grandchildren.length === 0) {
                const path = {};
                if (lastRootId !== root.id) {
                    path.root = root;
                    lastRootId = root.id;
                }
                if (lastChildId !== child.id) {
                    path.child = child;
                    lastChildId = child.id;
                }
                paths.push(path);
            } else grandchildren.forEach((grandchild)=>{
                const path = {};
                if (lastRootId !== root.id) {
                    path.root = root;
                    lastRootId = root.id;
                }
                if (lastChildId !== child.id) {
                    path.child = child;
                    lastChildId = child.id;
                }
                path.grandchild = grandchild;
                paths.push(path);
            });
        });
        // Reset for next root chain
        lastRootId = null;
        lastChildId = null;
    });
    return {
        paths: paths,
        links: links
    };
}
function $019b865f2fa53a6c$export$50df9b33ca0f5f5a(...values) {
    return values.find((v)=>v?.trim()) ?? "";
}
// Counter for unique IDs
let $019b865f2fa53a6c$var$idCounter = 0;
function $019b865f2fa53a6c$export$b55af78ba9436d12(newData) {
    const generateId = (prefix)=>{
        const id = `${prefix}_${$019b865f2fa53a6c$var$idCounter}`;
        $019b865f2fa53a6c$var$idCounter += 1;
        return id;
    };
    // Track nodes and links to prevent duplicates
    const nodeMap = new Map(); // ID → Node
    const linkSet = new Set(); // Serialized link for uniqueness
    // Process accounts
    const accountNodes = newData.accounts.map((account)=>{
        const uniqueId = generateId("account");
        const node = {
            id: uniqueId,
            account: account,
            nodeVariation: (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ACCOUNT
        };
        nodeMap.set(uniqueId, node);
        return node;
    });
    // Process entitlements and privileges
    const entitlementData = newData.accounts.flatMap((account, accountIndex)=>{
        const accountId = accountNodes[accountIndex].id;
        if (!Array.isArray(account.entitlements)) return [];
        return account.entitlements.map((entitlement)=>({
                accountId: accountId,
                entitlement: entitlement
            }));
    });
    const entitlementNodes = [];
    const entitlementLinks = [];
    entitlementData.forEach(({ accountId: accountId, entitlement: entitlement })=>{
        if (!entitlement.entitlementId) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Skipping entitlement with missing ID", {
                entitlement: entitlement
            });
            return;
        }
        const uniqueEntitlementId = generateId("entitlement");
        const node = {
            id: uniqueEntitlementId,
            entitlement: entitlement,
            nodeVariation: (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT
        };
        if (!nodeMap.has(uniqueEntitlementId)) {
            nodeMap.set(uniqueEntitlementId, node);
            entitlementNodes.push(node);
        }
        const linkKey = `${accountId}\u{2192}${uniqueEntitlementId}`;
        if (!linkSet.has(linkKey)) {
            linkSet.add(linkKey);
            entitlementLinks.push({
                source: accountId,
                target: uniqueEntitlementId,
                relationship: "reviewed"
            });
        }
        // Process privileges
        if (Array.isArray(entitlement.privileges)) entitlement.privileges.forEach((privilege)=>{
            if (!privilege.attributeName) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Skipping privilege with missing attributeName", {
                    privilege: privilege
                });
                return;
            }
            const uniquePrivilegeId = generateId("privilege");
            const privilegeNode = {
                id: uniquePrivilegeId,
                privileges: privilege,
                nodeVariation: (0, $e2b7858b7b737466$export$fd53012187cd5fa6).PRIVILLEGES
            };
            if (!nodeMap.has(uniquePrivilegeId)) {
                nodeMap.set(uniquePrivilegeId, privilegeNode);
                entitlementNodes.push(privilegeNode);
            }
            const privilegeLinkKey = `${uniqueEntitlementId}\u{2192}${uniquePrivilegeId}`;
            if (!linkSet.has(privilegeLinkKey)) {
                linkSet.add(privilegeLinkKey);
                entitlementLinks.push({
                    source: uniqueEntitlementId,
                    target: uniquePrivilegeId,
                    relationship: "spawned"
                });
            }
        });
    });
    // Process roles
    const roleData = newData.accounts.flatMap((account, accountIndex)=>{
        const accountId = accountNodes[accountIndex].id;
        if (!Array.isArray(account.roles)) return [];
        return account.roles.map((role)=>({
                accountId: accountId,
                role: role
            }));
    });
    const roleNodes = [];
    const roleLinks = [];
    roleData.forEach(({ accountId: accountId, role: role })=>{
        if (!role.roleName) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).warn("Skipping role with missing roleName", {
                role: role
            });
            return;
        }
        const uniqueRoleId = generateId("role");
        const node = {
            id: uniqueRoleId,
            role: role,
            nodeVariation: (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ROLE
        };
        if (!nodeMap.has(uniqueRoleId)) {
            nodeMap.set(uniqueRoleId, node);
            roleNodes.push(node);
        }
        const linkKey = `${accountId}\u{2192}${uniqueRoleId}`;
        if (!linkSet.has(linkKey)) {
            linkSet.add(linkKey);
            roleLinks.push({
                source: accountId,
                target: uniqueRoleId,
                relationship: "spawned"
            });
        }
    });
    // Combine all nodes and links
    const nodes = [
        ...accountNodes,
        ...entitlementNodes,
        ...roleNodes
    ];
    const links = [
        ...entitlementLinks,
        ...roleLinks
    ];
    return {
        nodes: nodes,
        links: links
    };
}



const $7afe4de656d6d2aa$export$dfe4e68f4640448c = (container, nodeRefs, links)=>{
    if (!container) return [];
    const containerRect = container.getBoundingClientRect();
    const isMobile = window.innerWidth <= 500;
    const newLinkData = links.map((link, index)=>{
        const sourceNode = nodeRefs.get(link.source);
        const targetNode = nodeRefs.get(link.target);
        if (!sourceNode || !targetNode) return null;
        const sourceRect = sourceNode.getBoundingClientRect();
        const targetRect = targetNode.getBoundingClientRect();
        if (isMobile) {
            const offsetX = (index % 3 - 1) * 20;
            const sourceX = sourceRect.left + sourceRect.width / 2 + offsetX - containerRect.left;
            const sourceY = sourceRect.bottom - containerRect.top;
            const targetX = targetRect.left + sourceRect.width / 2 + offsetX - containerRect.left;
            const targetY = targetRect.top - containerRect.top;
            return {
                source: {
                    x: sourceX,
                    y: sourceY
                },
                target: {
                    x: targetX,
                    y: targetY
                },
                id: `${link.source}-${link.target}-${index}`
            };
        }
        const sourceX = sourceRect.right - containerRect.left;
        const sourceY = sourceRect.top + sourceRect.height / 2 - containerRect.top;
        const targetX = targetRect.left - containerRect.left;
        const targetY = targetRect.top + targetRect.height / 2 - containerRect.top;
        return {
            source: {
                x: sourceX,
                y: sourceY
            },
            target: {
                x: targetX,
                y: targetY
            },
            id: `${link.source}-${link.target}-${index}`
        };
    }).filter((d)=>d !== null);
    return newLinkData;
};
const $7afe4de656d6d2aa$export$a484e31e13c53240 = (svgElement, container, nodeRefs, links, connectedIds, isFirstRender, containerSize)=>{
    let newLinkData = [];
    let newContainerSize = containerSize;
    let newIsFirstRender = isFirstRender;
    if (!svgElement || !container) return {
        newLinkData: newLinkData,
        newContainerSize: newContainerSize,
        newIsFirstRender: newIsFirstRender
    };
    const svg = $cURGa$select(svgElement);
    const containerRect = container.getBoundingClientRect();
    svg.attr("width", containerRect.width).attr("height", containerRect.height).style("position", "absolute").style("top", 0).style("left", 0).style("pointer-events", "none");
    newContainerSize = {
        width: containerRect.width,
        height: containerRect.height
    };
    newLinkData = $7afe4de656d6d2aa$export$dfe4e68f4640448c(container, nodeRefs, links);
    // 💡 Custom path generator with adaptive curvature
    const generateRoundedPath = (source, target, cornerRadius = 12)=>{
        const midX = (source.x + target.x) / 2;
        const radius = Math.min(cornerRadius, Math.abs(source.y - target.y) / 2, Math.abs(source.x - target.x) / 2);
        return [
            `M ${source.x},${source.y}`,
            `L ${midX - radius},${source.y}`,
            `Q ${midX},${source.y} ${midX},${source.y < target.y ? source.y + radius : source.y - radius}`,
            `L ${midX},${target.y < source.y ? target.y + radius : target.y - radius}`,
            `Q ${midX},${target.y} ${midX + radius},${target.y}`,
            `L ${target.x},${target.y}`
        ].join(" ");
    };
    const lines = svg.selectAll(".link").data(newLinkData, (d)=>d.id).join((enter)=>enter.append("path").attr("class", "link").attr("fill", "none"), (update)=>update, (exit)=>exit.remove()).attr("d", (d)=>generateRoundedPath(d.source, d.target)).attr("stroke", (d)=>connectedIds.links.has(d.id) ? "var(--color-border-focus, #6E7FFF)" : "var(--color-border-neutral-subtlest, #CECFD9)").attr("stroke-width", "1px");
    lines.exit().remove();
    // Source circles
    const sourceCircles = svg.selectAll(".link-source-circle").data(newLinkData, (d)=>d.id);
    sourceCircles.enter().append("circle").attr("class", "link-source-circle").attr("r", 4.5).merge(sourceCircles).attr("cx", (d)=>d.source.x).attr("cy", (d)=>d.source.y).attr("fill", (d)=>connectedIds.links.has(d.id) ? "var(--color-border-focus, #6E7FFF)" : "var(--color-foreground-secondary-subtle, #6888B5)").attr("stroke", "var(--color-background-neutral-subtlest, #FFF)").attr("stroke-width", "3px");
    sourceCircles.exit().remove();
    // Target circles
    const targetCircles = svg.selectAll(".link-target-circle").data(newLinkData, (d)=>d.id);
    targetCircles.enter().append("circle").attr("class", "link-target-circle").attr("r", 4.5).merge(targetCircles).attr("cx", (d)=>d.target.x).attr("cy", (d)=>d.target.y).attr("fill", (d)=>connectedIds.links.has(d.id) ? "var(--color-border-focus, #6E7FFF)" : "var(--color-foreground-secondary-subtle, #6888B5)").attr("stroke", "var(--color-background-neutral-subtlest, #FFF)").attr("stroke-width", "3px");
    targetCircles.exit().remove();
    newIsFirstRender = false;
    return {
        newLinkData: newLinkData,
        newContainerSize: newContainerSize,
        newIsFirstRender: newIsFirstRender
    };
};






function $626595b11c595afa$export$d1904052946ae4f4(node) {
    return node ? node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ACCOUNT : false;
}
function $626595b11c595afa$export$f4d63e109cef908a(node) {
    return node ? node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT : false;
}
function $626595b11c595afa$export$d8504890a75bb0f8(node) {
    return node ? node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).PRIVILLEGES : false;
}
function $626595b11c595afa$export$4d7820c7ee90a9ef(node) {
    return node ? node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ROLE : false;
}







function $897a5a25ff8c9cbc$var$NodeComponent({ node: node, nodeRef: nodeRef, onClick: onClick, isSelected: isSelected, onHeightChange: onHeightChange }) {
    const [isExpanded, setIsExpanded] = (0, $cURGa$useState)(false);
    const divRef = (0, $cURGa$useRef)(null);
    const isClickable = (0, $cURGa$useMemo)(()=>{
        if (node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT && Array.isArray(node.entitlement.childEntitlements) && node.entitlement.childEntitlements.length > 0) return true;
        if (node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ACCOUNT) return true;
        return false;
    }, [
        node
    ]);
    // Toggle expansion on click
    const handleNodeClick = ()=>{
        if (node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT && Array.isArray(node.entitlement.childEntitlements) && node.entitlement.childEntitlements.length > 0) setIsExpanded((prev)=>!prev);
        onClick();
    };
    // Notify parent of height change after expansion
    (0, $cURGa$useEffect)(()=>{
        if (divRef.current) onHeightChange(); // Call the callback after DOM updates
    }, [
        isExpanded,
        onHeightChange
    ]);
    // TODO: Move this logic to convertToAccessPath. We don't need these specific props here related to access path as it will be a common compoenent
    const getNodeDetails = (0, $cURGa$useCallback)((nodeAttr)=>{
        const variation = nodeAttr.nodeVariation;
        let heading = " \xb7 ";
        let subHeading = " \xb7 ";
        let iconKind = "";
        let iconColor = "purple";
        if (variation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).PRIVILLEGES) {
            heading = nodeAttr.privileges.attributeName || " \xb7 ";
            subHeading = nodeAttr.privileges.attributeValue || " \xb7 ";
            iconKind = "RequestAccess";
            iconColor = "pink";
        } else if (variation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ACCOUNT) {
            // setIsClickable(true);
            heading = [
                nodeAttr.account.applicationName,
                nodeAttr.account.endpointName
            ].filter(Boolean).join(" \xb7 ") || " \xb7 ";
            subHeading = nodeAttr.account.displayName || nodeAttr.account.accountId;
            iconKind = "application";
        } else if (variation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT) {
            heading = nodeAttr.entitlement.entitlementName || " \xb7 ";
            subHeading = nodeAttr.entitlement.entitlementId || " \xb7 ";
            iconKind = "Entitlement";
            Array.isArray(nodeAttr.entitlement.childEntitlements) && nodeAttr.entitlement.childEntitlements.length;
        } else {
            heading = nodeAttr.role.roleType || " \xb7 ";
            subHeading = nodeAttr.role.roleName || " \xb7 ";
            if (heading.toLowerCase() === "application") iconKind = "application";
            else iconKind = "EnterpriseRole";
        }
        return {
            heading: heading,
            subHeading: subHeading,
            iconKind: iconKind,
            iconColor: iconColor
        };
    }, []);
    const nodeDetails = getNodeDetails(node);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        ref: (el)=>{
            divRef.current = el;
            nodeRef(el); // Set the ref for AccessPathPage
        },
        className: `Ispm-NodeComponent ${isSelected ? "selected" : ""} ${isClickable ? "Ispm-NodeComponent--clickable" : ""}`,
        onClick: handleNodeClick,
        role: "presentation",
        "data-testid": `ispm-NodeComponent-${node.id}`,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleNodeClick();
            }
        },
        "data-node-id": node.id,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: `Ispm-NodeComponent-iconWrapper access-icon-${nodeDetails.iconColor}`,
                children: nodeDetails.iconKind === "application" ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ApplicationIcon), {
                    size: "small"
                }) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                    kind: nodeDetails.iconKind,
                    size: "xSmall",
                    color: `--color-foreground-${nodeDetails.iconColor}-medium`
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-NodeComponent-nodeText",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-NodeComponent-nodeTitle",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body3",
                            lineLimit: 1,
                            color: "--color-foreground-secondary-medium",
                            children: nodeDetails.heading.length > 0 ? nodeDetails.heading : nodeDetails.subHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-NodeComponent-nodeSubtitle",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body2",
                            lineLimit: 1,
                            color: "--color-foreground-neutral-bold",
                            children: nodeDetails.subHeading
                        })
                    })
                ]
            }),
            node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT && Array.isArray(node.entitlement.childEntitlements) && node.entitlement.childEntitlements.length > 0 && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-NodeComponent-badge",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                        kind: "number",
                        size: "small",
                        number: node.entitlement.meta.totalChildEntitlements
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                        className: "ButtonSelect-chevron",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "ChevronDownSmall",
                            size: "medium",
                            rotate: isExpanded ? "180" : "0",
                            dataTestId: "Ispm-NodeComponentchevron"
                        })
                    })
                ]
            }),
            isExpanded && node.nodeVariation === (0, $e2b7858b7b737466$export$fd53012187cd5fa6).ENTITILEMENT && Array.isArray(node.entitlement.childEntitlements) && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-NodeComponent-expandedContent",
                        children: node.entitlement.childEntitlements.map((child)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-NodeComponent-expandedContent-child",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: `Ispm-NodeComponent-iconWrapper access-icon-${nodeDetails.iconColor}`,
                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                            kind: nodeDetails.iconKind,
                                            size: "xxSmall",
                                            color: `--color-foreground-${nodeDetails.iconColor}-medium`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-NodeComponent-nodeText",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                className: "Ispm-NodeComponent-nodeTitle",
                                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body4",
                                                    lineLimit: 1,
                                                    color: "--color-foreground-secondary-medium",
                                                    children: child.entitlementName
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                className: "Ispm-NodeComponent-nodeSubtitle",
                                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                    kind: "body3",
                                                    lineLimit: 1,
                                                    color: "--color-foreground-neutral-bold",
                                                    children: child.entitlementId
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }))
                    }),
                    node.entitlement.meta.totalChildEntitlements - node.entitlement.childEntitlements.length > 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-NodeComponent-moreInfo",
                        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                            kind: "body3",
                            lineLimit: 1,
                            color: "--color-foreground-primary-medium",
                            children: [
                                "+",
                                " ",
                                node.entitlement.meta.totalChildEntitlements - node.entitlement.childEntitlements.length,
                                " ",
                                "More"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $897a5a25ff8c9cbc$export$2e2bcd8739ae039 = $897a5a25ff8c9cbc$var$NodeComponent;



/**
 * Renders a single row in the access path table.
 * @param {Object} props - The component props.
 * @param {number} props.index - The index of the row.
 * @param {React.CSSProperties} props.style - The style object for positioning the row.
 * @param {PathEntry[]} props.paths - The array of path entries.
 * @param {ConnectedIds} props.connectedIds - The connected nodes and links for highlighting.
 * @param {(nodeId: string) => (element: HTMLDivElement | null) => void} props.setNodeRef - Function to set node refs.
 * @param {(nodeId: string) => void} props.handleAccountClick - Function to handle account clicks.
 * @returns {JSX.Element} The rendered row.
 */ function $ce18377f159dc158$var$AccessPathRow({ index: index, style: style, paths: paths, connectedIds: connectedIds, setNodeRef: setNodeRef, handleAccountClick: handleAccountClick, onHeightChange: onHeightChange, currentRoot: currentRoot, currentChild: currentChild }) {
    const path = paths[index];
    const nextPath = paths[index + 1];
    const isLastRow = !nextPath;
    const isLastForCurrentRoot = isLastRow || !!nextPath.root;
    // Callback to handle height change from NodeComponent
    const handleHeightChange = (0, $cURGa$useCallback)(()=>{
        onHeightChange();
    }, [
        onHeightChange
    ]);
    const totalChildNodeLeftOut = (0, $cURGa$useMemo)(()=>{
        if (isLastForCurrentRoot && (0, $626595b11c595afa$export$d1904052946ae4f4)(currentRoot)) {
            const { account: account } = currentRoot;
            const totalNodes = account.totalEntitlements + account.totalRoles;
            const displayedEntitlementNode = Array.isArray(account.entitlements) ? account.entitlements.length : 0;
            const displayedRoleNode = Array.isArray(account.roles) ? account.roles.length : 0;
            const leftNodes = totalNodes - displayedEntitlementNode - displayedRoleNode;
            return leftNodes;
        }
        return 0;
    }, [
        currentRoot,
        isLastForCurrentRoot
    ]);
    const isLastForCurrentChild = isLastRow || !!nextPath.child;
    const totalGrandChildLeftOut = (0, $cURGa$useMemo)(()=>{
        if (isLastForCurrentChild && (0, $626595b11c595afa$export$f4d63e109cef908a)(currentChild)) {
            const total = currentChild.entitlement.meta.totalPrivileges || 0;
            const displayed = Array.isArray(currentChild.entitlement.privileges) ? currentChild.entitlement.privileges.length : 0;
            return total - displayed;
        }
        return 0;
    }, [
        isLastForCurrentChild,
        currentChild
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-AccessPathRow",
        style: style,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-AccessPathRow-flowBox accounts",
                children: path.root && /*#__PURE__*/ (0, $cURGa$jsx)((0, $897a5a25ff8c9cbc$export$2e2bcd8739ae039), {
                    node: path.root,
                    nodeRef: setNodeRef(path.root.id),
                    onClick: ()=>path.root && handleAccountClick(path.root.id),
                    isSelected: connectedIds.nodes.has(path.root.id),
                    onHeightChange: handleHeightChange
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-AccessPathRow-arrow"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-AccessPathRow-flowBox access",
                children: [
                    path.child && /*#__PURE__*/ (0, $cURGa$jsx)((0, $897a5a25ff8c9cbc$export$2e2bcd8739ae039), {
                        node: path.child,
                        nodeRef: setNodeRef(path.child.id),
                        isSelected: connectedIds.nodes.has(path.child.id),
                        onClick: ()=>{},
                        onHeightChange: handleHeightChange
                    }),
                    totalChildNodeLeftOut > 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-AccessPathRow-showMore",
                        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                            kind: "body3-bold",
                            lineLimit: 1,
                            color: "--color-foreground-primary-medium",
                            children: [
                                "+ ",
                                totalChildNodeLeftOut,
                                " More"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-AccessPathRow-arrow"
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-AccessPathRow-flowBox  privileges",
                children: [
                    path.grandchild && /*#__PURE__*/ (0, $cURGa$jsx)((0, $897a5a25ff8c9cbc$export$2e2bcd8739ae039), {
                        node: path.grandchild,
                        nodeRef: setNodeRef(path.grandchild.id),
                        isSelected: connectedIds.nodes.has(path.grandchild.id),
                        onClick: ()=>{},
                        onHeightChange: handleHeightChange
                    }),
                    totalGrandChildLeftOut > 0 && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-AccessPathRow-showMore",
                        children: /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                            kind: "body3-bold",
                            lineLimit: 1,
                            color: "--color-foreground-primary-medium",
                            children: [
                                "+ ",
                                totalGrandChildLeftOut,
                                " More"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $ce18377f159dc158$export$2e2bcd8739ae039 = $ce18377f159dc158$var$AccessPathRow;





function $826147e8addfbd0d$var$FlowHeader() {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-FlowHeader",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-FlowHeader-flowBox accounts",
                children: "ACCOUNTS"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-FlowHeader-arrow",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "49",
                    height: "8",
                    viewBox: "0 0 49 8",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M48.6866 4.36735C48.8818 4.17209 48.8818 3.8555 48.6866 3.66024L45.5046 0.47826C45.3093 0.282998 44.9927 0.282998 44.7975 0.47826C44.6022 0.673522 44.6022 0.990105 44.7975 1.18537L47.6259 4.01379L44.7975 6.84222C44.6022 7.03748 44.6022 7.35407 44.7975 7.54933C44.9927 7.74459 45.3093 7.74459 45.5046 7.54933L48.6866 4.36735ZM0.333008 4.51379H48.333V3.51379H0.333008V4.51379Z",
                        fill: "#CECFD9"
                    })
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-FlowHeader-flowBox access",
                children: "ACCESS"
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-FlowHeader-arrow",
                children: /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "49",
                    height: "8",
                    viewBox: "0 0 49 8",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)("path", {
                        d: "M48.6866 4.36735C48.8818 4.17209 48.8818 3.8555 48.6866 3.66024L45.5046 0.47826C45.3093 0.282998 44.9927 0.282998 44.7975 0.47826C44.6022 0.673522 44.6022 0.990105 44.7975 1.18537L47.6259 4.01379L44.7975 6.84222C44.6022 7.03748 44.6022 7.35407 44.7975 7.54933C44.9927 7.74459 45.3093 7.74459 45.5046 7.54933L48.6866 4.36735ZM0.333008 4.51379H48.333V3.51379H0.333008V4.51379Z",
                        fill: "#CECFD9"
                    })
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-FlowHeader-flowBox  privileges",
                children: "PRIVILEGES"
            })
        ]
    });
}
var $826147e8addfbd0d$export$2e2bcd8739ae039 = $826147e8addfbd0d$var$FlowHeader;



/**
 * Renders a visual representation of an access path as a hierarchical table with connecting lines.
 * The component displays nodes in three columns (Account, Access, Privilege) and draws lines between
 * them to show relationships. It supports both desktop and mobile layouts, with lines adjusting based
 * on the screen size. Users can click on nodes to highlight connected paths.
 *
 * @param {AccessPathPageProps} props - The component props.
 * @returns {JSX.Element} The rendered access path visualization.
 */ function $7f5b958d3ff3d1db$var$AccessPathPage({ userId: userId, accessMap: accessMap }) {
    const svgRef = (0, $cURGa$useRef)(null);
    const containerRef = (0, $cURGa$useRef)(null);
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info("In Access Path page", {
        userId: userId
    });
    const { paths: paths, links: links } = accessMap;
    /** Tracks DOM element references for each access node */ const nodeRefs = (0, $cURGa$useRef)(new Map());
    /** Tracks which account node is selected for highlighting */ const [selectedAccount, setSelectedAccount] = (0, $cURGa$useState)(null);
    /** Stores container size from last draw to detect resize */ const containerSize = (0, $cURGa$useRef)(null);
    /** Tracks if it's the first render for animation/drawing logic */ const isFirstRender = (0, $cURGa$useRef)(true);
    /** Stores calculated heights for each row (dynamically updated) */ const [rowHeights, setRowHeights] = (0, $cURGa$useState)(paths.map(()=>50));
    /** Hash of connectedIds to detect when the graph needs to be redrawn */ const lastConnectedIdsHash = (0, $cURGa$useRef)(null);
    /** Whether the last draw operation was triggered by a resize event */ const lastDrawWasResize = (0, $cURGa$useRef)(false);
    /**
   * Handles setting and unsetting DOM node refs for line drawing.
   * @param {string} nodeId - ID of the node
   * @returns {function} Ref callback function
   */ const setNodeRef = (0, $cURGa$useCallback)((nodeId)=>(element)=>{
            if (element) nodeRefs.current.set(nodeId, element);
            else nodeRefs.current.delete(nodeId);
        }, []);
    /**
   * Toggles selection of a clicked account node.
   * @param {string} nodeId - ID of the clicked node
   */ const handleAccountClick = (0, $cURGa$useCallback)((nodeId)=>{
        setSelectedAccount((prev)=>prev === nodeId ? null : nodeId);
    }, []);
    /**
   * Computes which nodes and links are connected to the selected account.
   */ const connectedIds = (0, $cURGa$useMemo)(()=>{
        if (!selectedAccount) return {
            nodes: new Set(),
            links: new Set()
        };
        const nodes = new Set([
            selectedAccount
        ]);
        const linkIds = new Set();
        links.forEach((link, index)=>{
            if (nodes.has(link.source)) {
                nodes.add(link.target);
                linkIds.add(`${link.source}-${link.target}-${index}`);
            } else if (nodes.has(link.target)) {
                nodes.add(link.source);
                linkIds.add(`${link.source}-${link.target}-${index}`);
            }
        });
        return {
            nodes: nodes,
            links: linkIds
        };
    }, [
        selectedAccount,
        links
    ]);
    /**
   * Generates a stable hash of the connected node and link IDs.
   * Used to detect meaningful graph changes and prevent unnecessary redraws.
   */ const connectedIdsHash = (0, $cURGa$useMemo)(()=>{
        const nodesArray = Array.from(connectedIds.nodes).sort();
        const linksArray = Array.from(connectedIds.links).sort();
        return (0, $2b309ef89c44b128$export$daf4c137c5f56404)(JSON.stringify({
            nodes: nodesArray,
            links: linksArray
        }));
    }, [
        connectedIds
    ]);
    /**
   * Calculates and updates the height for each access path row based on the
   * actual rendered DOM element heights. This ensures the rows have enough space
   * when their child components (like entitlements or privileges) expand or collapse.
   *
   * It considers the height of the root, child, and grandchild nodes in each row,
   * and chooses the maximum of the three to determine the required space.
   *
   * It also adds a small fixed spacing (10px) as padding between rows.
   *
   * This function prevents unnecessary re-renders by only updating state
   * if the new row heights differ from the current state.
   */ const updateRowHeights = (0, $cURGa$useCallback)(()=>{
        const newHeights = paths.map((path)=>{
            // Retrieve DOM elements for root, child, and grandchild nodes (if they exist)
            const rootNode = path.root ? nodeRefs.current.get(path.root.id) : null;
            const childNode = path.child ? nodeRefs.current.get(path.child.id) : null;
            const grandchildNode = path.grandchild ? nodeRefs.current.get(path.grandchild.id) : null;
            // Get the actual rendered height of each node, fallback to 0 if not mounted yet
            const rootHeight = rootNode?.getBoundingClientRect().height ?? 0;
            const childHeight = childNode?.getBoundingClientRect().height ?? 0;
            const grandchildHeight = grandchildNode?.getBoundingClientRect().height ?? 0;
            // Choose the largest node height for the row
            const baseHeight = Math.max(rootHeight, childHeight, grandchildHeight, 50); // Default to 50 if all are 0
            // Add fixed extra spacing to ensure visual padding between rows
            const extraSpacing = 10;
            return baseHeight + extraSpacing;
        });
        // Only update the state if the height has actually changed for any row
        setRowHeights((prevHeights)=>{
            const isSame = newHeights.every((h, i)=>h === prevHeights[i]);
            return isSame ? prevHeights : newHeights;
        });
    }, [
        paths
    ]);
    /**
   * Draws connecting lines using D3 between node elements.
   * Skips drawing if nothing has changed unless forced by resize.
   */ const handleDrawLines = (0, $cURGa$useCallback)((isResize = false)=>{
        if (!isResize && lastConnectedIdsHash.current === connectedIdsHash && !lastDrawWasResize.current) return;
        const { newContainerSize: newContainerSize, newIsFirstRender: newIsFirstRender } = (0, $7afe4de656d6d2aa$export$a484e31e13c53240)(svgRef.current, containerRef.current, nodeRefs.current, links, connectedIds, isFirstRender.current, containerSize.current);
        containerSize.current = newContainerSize;
        isFirstRender.current = newIsFirstRender;
        if (!isResize) lastConnectedIdsHash.current = connectedIdsHash;
        lastDrawWasResize.current = isResize;
    }, [
        connectedIdsHash,
        connectedIds,
        links
    ]);
    /**
   * Debounced drawLines function to avoid performance bottlenecks on rapid updates.
   */ const debouncedHandleDrawLines = (0, $cURGa$useCallback)((isResize)=>{
        const debounced = (0, $019b865f2fa53a6c$export$61fc7d43ac8f84b0)((resize)=>{
            handleDrawLines(resize);
        }, 100);
        debounced(isResize);
    }, [
        handleDrawLines
    ]);
    /**
   * Triggers row height and line updates after mount or resize.
   */ (0, $cURGa$useEffect)(()=>{
        const timer = setTimeout(updateRowHeights, 0);
        const resizeObserver = new ResizeObserver((0, $019b865f2fa53a6c$export$61fc7d43ac8f84b0)(()=>{
            updateRowHeights();
            setTimeout(()=>{
                debouncedHandleDrawLines(true);
            }, 0);
        }, 200));
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>{
            clearTimeout(timer);
            resizeObserver.disconnect();
        };
    }, [
        updateRowHeights,
        debouncedHandleDrawLines
    ]);
    /**
   * Redraw lines on any change in connected IDs.
   */ (0, $cURGa$useEffect)(()=>{
        debouncedHandleDrawLines(false);
    }, [
        debouncedHandleDrawLines
    ]);
    /**
   * Callback triggered when a row’s height changes.
   */ const handleHeightChange = (0, $cURGa$useCallback)(()=>{
        updateRowHeights();
        requestAnimationFrame(()=>{
            debouncedHandleDrawLines(false);
        });
    }, [
        updateRowHeights,
        debouncedHandleDrawLines
    ]);
    /**
   * Tracks the latest root node for each row to manage duplicate suppression.
   */ const currentRoots = (0, $cURGa$useMemo)(()=>{
        const result = [];
        let lastSeenRoot;
        paths.forEach((path)=>{
            if (path.root) lastSeenRoot = path.root;
            result.push(lastSeenRoot);
        });
        return result;
    }, [
        paths
    ]);
    /**
   * Tracks the latest child node for each row to manage duplicate suppression.
   */ const currentChildren = (0, $cURGa$useMemo)(()=>{
        const result = [];
        let lastSeenChild;
        paths.forEach((path)=>{
            if (path.child) lastSeenChild = path.child;
            result.push(lastSeenChild);
        });
        return result;
    }, [
        paths
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-AccessPathPage",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("svg", {
                ref: svgRef
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $826147e8addfbd0d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-AccessPathPage-rows",
                children: paths.map((path, index)=>{
                    const hasRoot = !!path.root;
                    const rowStyle = {
                        minHeight: `${rowHeights[index]}px`,
                        ...hasRoot && {
                            marginTop: "1.5rem"
                        }
                    };
                    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $ce18377f159dc158$export$2e2bcd8739ae039), {
                        index: index,
                        style: rowStyle,
                        paths: paths,
                        connectedIds: connectedIds,
                        setNodeRef: setNodeRef,
                        handleAccountClick: handleAccountClick,
                        onHeightChange: handleHeightChange,
                        currentRoot: currentRoots[index],
                        currentChild: currentChildren[index]
                    }, (0, $2b309ef89c44b128$export$daf4c137c5f56404)(JSON.stringify(path)));
                })
            })
        ]
    });
}
var $7f5b958d3ff3d1db$export$2e2bcd8739ae039 = $7f5b958d3ff3d1db$var$AccessPathPage;














function $633ad6a5aa39819e$var$HeaderCard({ userId: userId }) {
    const { data: accessSummaryData } = (0, $ef1666d1a8579d02$export$4fe23b82bcf2d5d1)(userId);
    const dispatch = (0, $cURGa$useDispatch)();
    const history = (0, $cURGa$useHistory)();
    const selectedUser = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.selectedUser);
    const { data: identity } = (0, $ef1666d1a8579d02$export$8ef2730b11d678cb)(userId);
    (0, $cURGa$useEffect)(()=>{
        if (!selectedUser && identity) dispatch((0, $8939fb7be58f56d0$export$6d06ea42ee2ef64)(identity.data)); // Store in Redux
    }, [
        dispatch,
        identity,
        selectedUser
    ]);
    const summaryInsightData = (0, $cURGa$useMemo)(()=>{
        if (accessSummaryData) return {
            resources: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.applications.count),
            roles: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.roles.count),
            accounts: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.accounts.count),
            entitilements: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.entitlements.count)
        };
        return {};
    }, [
        accessSummaryData
    ]);
    const navigateToIdentities = ()=>{
        history.push(`${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}`);
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-HeaderCard",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-HeaderCard-userInfo",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "ChevronLeft"
                        }),
                        onClick: navigateToIdentities,
                        dataTestId: "ispm-AccessPath-backToIdentities"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                        size: "large",
                        src: selectedUser?.imageUrl,
                        alt: `${selectedUser?.name ?? "User Name"}'s avatar`
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-HeaderCard-userDetails",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-HeaderCard-userDetails-userName",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "h1",
                                    lineLimit: 1,
                                    color: "--color-foreground-neutral-bold",
                                    children: selectedUser?.name ?? ""
                                })
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-HeaderCard-userDetails-userTitle",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "body2",
                                    lineLimit: 1,
                                    color: "--color-foreground-secondary-bold",
                                    children: selectedUser?.jobTitle ?? ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-HeaderCard-statContainer",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)($633ad6a5aa39819e$var$StatBox, {
                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Account"
                        }),
                        label: "Accounts",
                        count: summaryInsightData.accounts
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)($633ad6a5aa39819e$var$StatBox, {
                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Entitlement"
                        }),
                        label: "Entitlements",
                        count: summaryInsightData.entitilements
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)($633ad6a5aa39819e$var$StatBox, {
                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Role"
                        }),
                        label: "Roles",
                        count: summaryInsightData.roles
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)($633ad6a5aa39819e$var$StatBox, {
                        icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "Object"
                        }),
                        label: "Resources",
                        count: summaryInsightData.resources,
                        isLast: true
                    })
                ]
            })
        ]
    });
}
function $633ad6a5aa39819e$var$StatBox({ icon: icon, label: label, count: count, isLast: isLast = false }) {
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: `stat-box ${isLast ? "no-border" : ""}`,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "stat-icon",
                children: icon
            }),
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "stat-text",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "stat-label",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "body2",
                            lineLimit: 1,
                            color: "--color-foreground-neutral-subtle",
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "stat-count",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                            kind: "h3",
                            lineLimit: 1,
                            color: "--color-foreground-secondary-bold",
                            children: count
                        })
                    })
                ]
            })
        ]
    });
}
var $633ad6a5aa39819e$export$2e2bcd8739ae039 = $633ad6a5aa39819e$var$HeaderCard;




function* $22d7fa0fe76113dc$export$2e2bcd8739ae039(userId, accountIds) {
    let index = 0;
    while(index < accountIds.length){
        const accountId = accountIds[index];
        yield (async ()=>{
            const detail = await (0, $02f35f2692bf806b$export$2e2bcd8739ae039)({
                userId: userId,
                accountId: accountId
            });
            const accessGraph = (0, $019b865f2fa53a6c$export$b55af78ba9436d12)({
                accounts: [
                    detail
                ]
            });
            return (0, $019b865f2fa53a6c$export$93bf571733ed38db)(accessGraph);
        })();
        index += 1;
    }
}





function $1bb0284f656be9ad$var$IdentitiesaccessPath({ userId: userId }) {
    const [accessMap, setAccessMap] = (0, $cURGa$useState)({
        paths: [],
        links: []
    });
    const [isLoading, setIsLoading] = (0, $cURGa$useState)(true);
    const [isLoadingNext, setIsLoadingNext] = (0, $cURGa$useState)(false);
    const [error, setError] = (0, $cURGa$useState)(null);
    const [loadMoreerror, setLoadMoreError] = (0, $cURGa$useState)(null);
    const [hasMore, setHasMore] = (0, $cURGa$useState)(true);
    const [accountIds, setAccountIds] = (0, $cURGa$useState)([]);
    const loaderRef = (0, $cURGa$useRef)(null);
    const generatorRef = (0, $cURGa$useRef)(null);
    // Merge incoming access map data
    const mergeData = (existing, incoming)=>({
            paths: [
                ...existing.paths,
                ...incoming.paths
            ],
            links: [
                ...existing.links,
                ...incoming.links
            ]
        });
    // Load next account
    const loadNext = (0, $cURGa$useCallback)(async ()=>{
        if (!generatorRef.current) return;
        setIsLoadingNext(true);
        try {
            const next = generatorRef.current.next();
            if (next.done) {
                setHasMore(false);
                return;
            }
            const mapData = await next.value;
            setAccessMap((prev)=>mergeData(prev, mapData));
            setIsLoadingNext(false);
        } catch (err) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error loading account detail", {
                error: err
            });
            setLoadMoreError(err instanceof Error ? err : new Error("Failed to load account details"));
        } finally{
            setIsLoadingNext(false);
        }
    }, []);
    // Initialize account IDs and generator
    (0, $cURGa$useEffect)(()=>{
        (async ()=>{
            setIsLoading(true);
            try {
                const response = await (0, $8365263162b965b7$export$2e2bcd8739ae039)({
                    userId: userId
                });
                const ids = response.accounts;
                setAccountIds(ids);
                if (ids.length === 0) setHasMore(false);
                else {
                    generatorRef.current = (0, $22d7fa0fe76113dc$export$2e2bcd8739ae039)(userId, ids);
                    await loadNext(); // Load first account
                }
            } catch (err) {
                (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching account list", {
                    error: err
                });
                setError(err instanceof Error ? err : new Error("Failed to fetch account list"));
            } finally{
                setIsLoading(false);
            }
        })().catch((err)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error while accountDetailGenerator ", {
                err: err
            }));
    }, [
        userId,
        loadNext
    ]);
    // IntersectionObserver for lazy loading
    (0, $cURGa$useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting && hasMore && !isLoading && !isLoadingNext) loadNext().catch((err)=>(0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error while loadNext ", {
                    err: err
                }));
        }, {
            threshold: 1.0
        });
        const el = loaderRef.current;
        if (el) observer.observe(el);
        return ()=>{
            if (el) observer.unobserve(el);
        };
    }, [
        hasMore,
        isLoading,
        isLoadingNext,
        loadNext
    ]);
    (0, $cURGa$useEffect)(()=>{
        document.body.classList.add("Ispm-rootBody-IdentitiesAccessPath");
        window.scrollTo(0, 0); // Reset scroll position to the top
        return ()=>{
            document.body.classList.remove("Ispm-rootBody-IdentitiesAccessPath");
        };
    }, []);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentitiesaccessPath",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $633ad6a5aa39819e$export$2e2bcd8739ae039), {
                userId: userId
            }),
            accountIds.length === 0 && !isLoading && !error && /*#__PURE__*/ (0, $cURGa$jsx)((0, $b632ad964f82823d$export$2e2bcd8739ae039), {
                isDisplayIcon: true,
                iconKind: "Error"
            }),
            error && /*#__PURE__*/ (0, $cURGa$jsx)((0, $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039), {}),
            isLoading && /*#__PURE__*/ (0, $cURGa$jsx)((0, $a72e27c476852c06$export$2e2bcd8739ae039), {}),
            accessMap.paths.length > 0 && /*#__PURE__*/ (0, $cURGa$jsx)((0, $7f5b958d3ff3d1db$export$2e2bcd8739ae039), {
                userId: userId,
                accessMap: accessMap
            }),
            loadMoreerror && /*#__PURE__*/ (0, $cURGa$jsx)((0, $ab96b7bbd3fb8daa$export$2e2bcd8739ae039), {}),
            hasMore && !isLoading && !error && !loadMoreerror && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                ref: loaderRef,
                style: {
                    height: "20px"
                }
            }),
            isLoadingNext && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentitiesaccessPath-loader",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                    kind: "loop",
                    format: "main",
                    color: "brand"
                })
            })
        ]
    });
}
var $1bb0284f656be9ad$export$2e2bcd8739ae039 = $1bb0284f656be9ad$var$IdentitiesaccessPath;

























function $3aa0bc22242434a1$var$TimelineContent({ item: item, isEventClickable: isEventClickable }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const numberOfColumns = item.numberOfColumns ?? (0, $f618e3351c7ca235$export$be7a380669c72f48);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: `Ispm-TimelineContent ${isEventClickable ? "Ispm-TimelineContent--clickable" : ""}`,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-TimelineContent-title",
                children: item.data.eventType
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-TimelineContent-details",
                style: {
                    gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`
                },
                children: Array(numberOfColumns).fill(null).map((_, colIndex)=>{
                    const columnNumber = colIndex + 1; // Columns start from 1
                    const sections = item.data.sections.filter((s)=>s.column === columnNumber);
                    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-TimelineContent-column",
                        children: sections.length > 0 ? sections.map((section)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-TimelineContent-item",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-TimelineContent-item-label",
                                        children: (0, $c49aa0f374b6c6e6$export$7dac1d63a1a3adff)(section.heading)
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                        className: "Ispm-TimelineContent-item-value",
                                        children: $3aa0bc22242434a1$var$renderDetails(section.details, theme)
                                    })
                                ]
                            }, (0, $2b309ef89c44b128$export$daf4c137c5f56404)(JSON.stringify(section)))) : /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-TimelineContent-placeholder"
                        }) // Keeps spacing
                    }, columnNumber);
                })
            })
        ]
    });
}
/**
 * Renders details dynamically based on type (string[] or DetailWithIcon[])
 */ function $3aa0bc22242434a1$var$renderDetails(details, theme) {
    if (typeof details[0] === "string") {
        // If details are plain strings
        const detailsText = details.join(", ");
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
            kind: "body2",
            lineLimit: 1,
            color: "--color-foreground-neutral-bold",
            children: detailsText
        });
    }
    // If details contain icons
    return details.map(({ icon: icon, text: text })=>{
        const iconColor = theme ? (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[icon].colorDark : (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[icon].colorLight;
        return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Ispm-TimelineContent-pendingDetails",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: `timeline-icon ${iconColor}`,
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[icon].icon,
                        size: "xSmall",
                        color: iconColor
                    })
                }, text),
                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                    className: "Ispm-TimelineContent-item-value",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        kind: "body3",
                        color: "--color-foreground-neutral-bold",
                        className: (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[icon].icon === "check" ? "action-completed" : "",
                        children: text
                    })
                })
            ]
        }, (0, $2b309ef89c44b128$export$daf4c137c5f56404)(icon.toString() + text));
    });
}
var $3aa0bc22242434a1$export$2e2bcd8739ae039 = $3aa0bc22242434a1$var$TimelineContent;





function $ffbe3cbe5614a789$var$TimelineDivider() {
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-TimelineDivider"
    });
}
var $ffbe3cbe5614a789$export$2e2bcd8739ae039 = $ffbe3cbe5614a789$var$TimelineDivider;






function $e05bc634557d0c48$var$TimelineHeader({ date: date, summary: summary, toggleExpand: toggleExpand, isOpen: isOpen }) {
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleExpand();
        }
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-timelineHeader",
        role: "button",
        tabIndex: 0,
        onClick: toggleExpand,
        onKeyDown: handleKeyDown,
        "aria-expanded": isOpen,
        "aria-label": `Timeline for ${date}`,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-timelineHeader-content",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                        className: "Ispm-timelineHeader-date",
                        children: date
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                        className: "Ispm-timelineHeader-summary",
                        children: summary
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-timelineHeader-button",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                    kind: "ghost",
                    size: "small",
                    "aria-label": isOpen ? "Collapse" : "Expand",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                        kind: isOpen ? "ChevronUp" : "ChevronDown",
                        dataTestId: "timeline-header-button",
                        color: "neutral-1000"
                    })
                })
            })
        ]
    });
}
var $e05bc634557d0c48$export$2e2bcd8739ae039 = $e05bc634557d0c48$var$TimelineHeader;








$a1d2976b03453ee4$var$TimelineIcon.defaultProps = {
    iconSize: "smallMedium"
};
function $a1d2976b03453ee4$var$TimelineIcon({ iconType: iconType, isDottedConnector: isDottedConnector, iconSize: iconSize }) {
    const { theme: theme } = (0, $670c946906b8a505$export$93d4e7f90805808f)();
    const iconKind = (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[iconType].icon;
    const iconColor = theme ? (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[iconType].colorDark : (0, $413a08a89bb5cfa8$export$e75cf43d5d0a9444)[iconType].colorLight;
    const backgroundColor = isDottedConnector ? "" : iconColor; // Handling BG for Pending
    const strokeColor = isDottedConnector ? iconColor : ""; // Handling stroke color for Pending
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: `Ispm-TimelineIcon ${isDottedConnector ? `Ispm-TimelineIcon--isDottedConnector Ispm-TimelineIcon--isDottedConnector--${iconColor}` : ""} ${backgroundColor}`,
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
            kind: iconKind,
            size: iconSize ?? "smallMedium",
            color: strokeColor
        })
    });
}
var $a1d2976b03453ee4$export$2e2bcd8739ae039 = $a1d2976b03453ee4$var$TimelineIcon;








function $4716356063be0eb7$var$getSanitizedDataAttributes(data) {
    return Object.fromEntries(Object.entries(data).filter(([key, value])=>key.startsWith("data-") && typeof value === "string"));
}
function $4716356063be0eb7$var$TimelineItem({ item: item, isLast: isLast, isLastGroup: isLastGroup, dataAttributes: dataAttributes, activeElementClassName: activeElementClassName, isEventClickable: isEventClickable }) {
    const sanitizedDataAttributes = $4716356063be0eb7$var$getSanitizedDataAttributes(dataAttributes);
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: `${(0, $f618e3351c7ca235$export$65cf17a55b364e8)} ${isLast ? "last-item" : ""} ${isLastGroup ? "last-group" : ""}`,
        ...sanitizedDataAttributes,
        "data-eventType": item.data.eventType,
        "data-testid": `ispm-identities-timeline-${item.data.eventType.toLowerCase().replace(/\s+/g, "-")}`,
        "data-icon": item.timelineIcon,
        "data-isDottedConnector": item.isDottedConnector,
        role: "button",
        tabIndex: 0,
        onKeyDown: (event)=>{
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                event.target.click();
            }
        },
        "data-timestamp": item.timestamp,
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: `Ispm-TimelineItem-iconWrapper Ispm-TimelineItem-iconWrapper${item.isDottedConnector ? "--dotted" : ""}`,
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $a1d2976b03453ee4$export$2e2bcd8739ae039), {
                    iconType: item.timelineIcon,
                    isDottedConnector: item.isDottedConnector
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: `Ispm-TimelineItem-details ${activeElementClassName}`,
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $3aa0bc22242434a1$export$2e2bcd8739ae039), {
                    item: item,
                    isEventClickable: isEventClickable
                })
            })
        ]
    });
}
var $4716356063be0eb7$export$2e2bcd8739ae039 = $4716356063be0eb7$var$TimelineItem;





function $6645b9b17ab0d3d1$var$TimelineSkeletonLoader({ itemCount: itemCount = 3 }) {
    const skeletonItemKeys = (0, $cURGa$useMemo)(()=>Array.from({
            length: Math.max(0, itemCount)
        }, (_placeholder, itemIndex)=>`skeleton-loader-item-${itemIndex}`), [
        itemCount
    ]);
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-timeline-skeleton-wrapper",
        children: skeletonItemKeys.map((key)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-timeline-skeleton",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "timeline-left",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-timeline-skeleton-circle"
                        })
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-timeline-skeleton-container timeline-right",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-timeline-skeleton-short"
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-timeline-skeleton-long"
                            })
                        ]
                    })
                ]
            }, key))
    });
}
var $6645b9b17ab0d3d1$export$2e2bcd8739ae039 = $6645b9b17ab0d3d1$var$TimelineSkeletonLoader;
$6645b9b17ab0d3d1$var$TimelineSkeletonLoader.defaultProps = {
    itemCount: 3
};







/**
 * Parses a given API response to create a TimelineDataPoint array
 */ const $7f39fd185641657a$var$parseTimelineResponse = (response, l)=>{
    const groupedResponse = (0, $10a04991e0e365ed$export$701bdd18c9155fab)(response.value);
    const timelineData = Object.entries(groupedResponse).reduce((acc, [date, events])=>{
        acc[date] = {
            // TODO: Update below once we receive the description from BE.
            // It will display summary of all events happening on the date.
            description: ``,
            events: events.reduce((filteredEvents, event)=>{
                const isPendingApproval = (0, $413a08a89bb5cfa8$export$43ff05505a0d6eed)(event);
                const timestamp = event.timestamp.toString();
                const eventDetails = (0, $10a04991e0e365ed$export$cded5b49f4b8d5db)(event, isPendingApproval, l);
                if (!eventDetails) {
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`Missing event details for event on date: ${date}`, event);
                    return filteredEvents; // Skip this event
                }
                filteredEvents.push({
                    timestamp: timestamp,
                    timelineIcon: eventDetails.icon,
                    isDottedConnector: isPendingApproval,
                    data: {
                        eventType: eventDetails.label,
                        sections: eventDetails.section
                    },
                    // Add each of the metadata in each event to handle click event
                    metadata: {
                        "data-userid": event.userId,
                        "data-eventid": event.eventId,
                        "data-eventtypename": event.type
                    }
                });
                return filteredEvents;
            }, [])
        };
        return acc;
    }, {});
    return timelineData;
};
var $7f39fd185641657a$export$2e2bcd8739ae039 = $7f39fd185641657a$var$parseTimelineResponse;














/**
 * Checks whether relevant activities should be hidden based on event type.
 * @param eventType - The event type from main timeline event.
 * @returns boolean
 */ const $d71824b5698c7ec3$var$shouldHideRelevantActivities = (eventType)=>(0, $8f460a89aa4ee4ee$export$8bb82470130b1445).includes(eventType);
var $d71824b5698c7ec3$export$2e2bcd8739ae039 = $d71824b5698c7ec3$var$shouldHideRelevantActivities;












function $6b1a92bb5e7139e7$export$8b6a1dcf28c78831(response) {
    if (typeof response !== "object" || response === null || !("data" in response) || response.data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isSideCarActivitiesResponse - Invalid response: Expected response and response.data to be object.");
        return false;
    }
    if (typeof response.data !== "object" || !("activities" in response.data) || !Array.isArray(response.data.activities)) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isSideCarActivitiesResponse - Invalid response: Expected response.data and response.data.activities to be object.");
        return false;
    }
    return true;
}
const $6b1a92bb5e7139e7$var$getSideCarActivities = async (args)=>{
    const { SIDE_CAR_ACTIVITIES_URL: SIDE_CAR_ACTIVITIES_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const sideCarActivityUrl = SIDE_CAR_ACTIVITIES_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), args.userId).replace((0, $8ff2252602deef38$export$89bbc91416db6670), args.eventId);
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(sideCarActivityUrl, {
            timeout: 30000,
            method: "GET"
        }, $6b1a92bb5e7139e7$export$8b6a1dcf28c78831);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching side car activites data:", error);
        throw error;
    }
};
var $6b1a92bb5e7139e7$export$2e2bcd8739ae039 = $6b1a92bb5e7139e7$var$getSideCarActivities;





function $81047c419c0d9eb6$export$c4bd768199c44bfb(response) {
    if (typeof response !== "object" || response === null || !("data" in response) || response.data === null) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("isSideCarSummaryResponse - Invalid response: Expected response and response.data to be object.");
        return false;
    }
    return true;
}
const $81047c419c0d9eb6$var$getSideCarSummary = async (args)=>{
    const { SIDE_CAR_SUMMARY_URL: SIDE_CAR_SUMMARY_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    const sideCarSummaryUrl = SIDE_CAR_SUMMARY_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), args.userId).replace((0, $8ff2252602deef38$export$89bbc91416db6670), args.eventId);
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(sideCarSummaryUrl, {
            timeout: 30000,
            method: "GET"
        }, $81047c419c0d9eb6$export$c4bd768199c44bfb);
        return response;
    } catch (error) {
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Error fetching sideCar summary data:", error);
        throw error;
    }
};
var $81047c419c0d9eb6$export$2e2bcd8739ae039 = $81047c419c0d9eb6$var$getSideCarSummary;



const $2dfba5096f4994ae$export$fafd0cc35c238f29 = (eventDetails)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $6b1a92bb5e7139e7$export$2e2bcd8739ae039), [
        eventDetails
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};
const $2dfba5096f4994ae$export$dcaa81903ea39141 = (eventDetails)=>{
    const { data: data, isLoading: isLoading, error: error } = (0, $bc60925424d51d08$export$2e2bcd8739ae039)((0, $81047c419c0d9eb6$export$2e2bcd8739ae039), [
        eventDetails
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};





function $950eb120ca9f455f$export$2e2bcd8739ae039(response) {
    return response.data.activities.filter((activity)=>{
        if (activity.title && activity.title.length > 0) return true;
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("parseSideCarRelevantActivities - Title is not there in response. Skipping the event.", {
            activity: activity
        });
        return false;
    }).map((activity)=>{
        const title = activity.title ?? "";
        let timelineIcon = "added";
        const lowercaseTitle = title.toLowerCase();
        const isDottedConnector = lowercaseTitle.includes("pending");
        if (lowercaseTitle.includes("remove")) timelineIcon = lowercaseTitle.includes("pending") ? "pendingDelete" : "removed";
        else if (lowercaseTitle.includes("error")) timelineIcon = "error";
        else if (lowercaseTitle.includes("fail")) timelineIcon = "failed";
        else if (lowercaseTitle.includes("trigger")) timelineIcon = "trigger";
        else if (lowercaseTitle.includes("reject")) timelineIcon = "reject";
        else if (lowercaseTitle.includes("add")) timelineIcon = lowercaseTitle.includes("pending") ? "pendingAdd" : "added";
        else if (lowercaseTitle.includes("certification")) timelineIcon = lowercaseTitle.includes("pending") ? "certificationPending" : "certificationCompleted";
        else if (lowercaseTitle.includes("de-provision")) timelineIcon = lowercaseTitle.includes("pending") ? "pendingDelete" : "removed";
        else if (lowercaseTitle.includes("provision")) timelineIcon = lowercaseTitle.includes("pending") ? "pendingAdd" : "added";
        else if (lowercaseTitle.includes("revoke")) timelineIcon = lowercaseTitle.includes("pending") ? "pendingDelete" : "removed";
        else timelineIcon = "added";
        const sections = [];
        let column = 1;
        if (activity.attributes) Object.entries(activity.attributes).forEach(([key, value])=>{
            sections.push({
                heading: key,
                details: [
                    String(value)
                ],
                column: column,
                className: ""
            });
            column = column === 1 ? 2 : 1; // Alternate columns
        });
        return {
            key: $950eb120ca9f455f$var$createUniqueKey(activity),
            timestamp: "",
            timelineIcon: timelineIcon,
            isDottedConnector: isDottedConnector,
            data: {
                eventType: title,
                sections: sections
            },
            numberOfColumns: 2
        };
    });
}
const $950eb120ca9f455f$var$createUniqueKey = (activity)=>{
    // Generate a unique key using multiple attributes
    const keySource = [
        activity.title,
        activity.attributes?.["Task ID"],
        activity.attributes?.["Request ID"],
        activity.attributes?.["Approved On"],
        activity.attributes?.["Certification Start Date"],
        activity.attributes?.["Certification End Date"],
        JSON.stringify(activity.attributes)
    ].filter(Boolean) // Remove undefined values
    .join("-"); // Concatenate with a separator
    const uniqueKey = (0, $2b309ef89c44b128$export$daf4c137c5f56404)(keySource);
    return uniqueKey;
};



function $2747226a6a7f4ccc$var$RelevantActivitiesTimeline({ userId: userId, eventId: eventId }) {
    const { data: response, isLoading: isLoading, error: error } = (0, $2dfba5096f4994ae$export$fafd0cc35c238f29)({
        userId: userId,
        eventId: eventId
    });
    if (isLoading) return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-RelevantActivitiesTimeline-loader",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
            kind: "loop",
            format: "main",
            color: "brand"
        })
    });
    /**
   * TODO: Localization needed here
   */ if (error) {
        let is404Error = false;
        if ((0, $cURGa$axios).isAxiosError(error)) is404Error = Number(error.status) === 404;
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039), {
            title: is404Error ? "Coming Soon !!!" : "Unable to Load Relevant Activities",
            description: is404Error ? "" : "We encountered an issue while loading the relevant activies. Please try refreshing the page.",
            iconKind: "ErrorSign"
        });
    }
    if (response?.data.activities.length === 0) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $b632ad964f82823d$export$2e2bcd8739ae039), {});
    const timelineData = response ? (0, $950eb120ca9f455f$export$2e2bcd8739ae039)(response) : [];
    return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        children: Array.isArray(timelineData) && timelineData.map((item, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $4716356063be0eb7$export$2e2bcd8739ae039), {
                item: item,
                isLast: index === timelineData.length - 1,
                isLastGroup: true,
                isEventClickable: false,
                dataAttributes: {
                    ...item.metadata
                },
                activeElementClassName: ""
            }, item.key ?? JSON.stringify(item)))
    });
}
var $2747226a6a7f4ccc$export$2e2bcd8739ae039 = $2747226a6a7f4ccc$var$RelevantActivitiesTimeline;












// eslint-disable-next-line react/function-component-definition
const $80ac3b52506fce4b$var$SideCarSummary = ({ userId: userId, eventId: eventId })=>{
    const { data: summaryResponse, isLoading: isLoading, error: error } = (0, $2dfba5096f4994ae$export$dcaa81903ea39141)({
        userId: userId,
        eventId: eventId
    });
    const [expandedEntitlements, setExpandedEntitlements] = (0, $cURGa$useState)({});
    const [expandedSection, setExpandedSection] = (0, $cURGa$useState)({});
    const toggleEntitlement = (key)=>{
        setExpandedEntitlements((prev)=>({
                ...prev,
                [key]: !prev[key]
            }));
    };
    const toggleSection = (key)=>{
        setExpandedSection((prev)=>({
                ...prev,
                [key]: !prev[key]
            }));
    };
    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info({
        toggleEntitlement: toggleEntitlement,
        expandedSection: expandedSection,
        expandedEntitlements: expandedEntitlements
    });
    if (isLoading) return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-SideCarSummary-loader",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
            kind: "loop",
            format: "main",
            color: "brand"
        })
    });
    if (error) {
        let is404Error = false;
        if ((0, $cURGa$axios).isAxiosError(error)) is404Error = Number(error.status) === 404;
        return /*#__PURE__*/ (0, $cURGa$jsx)((0, $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039), {
            title: is404Error ? "Coming Soon !!!" : "Unable to Load Summary",
            description: is404Error ? "" : "We encountered an issue while loading the summary. Please try refreshing the page.",
            iconKind: "ErrorSign"
        });
    }
    if (!summaryResponse?.data.access && !summaryResponse?.data.attributes) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $b632ad964f82823d$export$2e2bcd8739ae039), {});
    const { access: access, attributes: attributes, owners: owners, attributesUpdated: attributesUpdated } = summaryResponse.data;
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-SideCarSummary",
        children: [
            attributes && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                        color: "--color-foreground-neutral-bold",
                        kind: "h1",
                        children: "Event Attributes"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Ispm-SideCarSummary-attributes",
                        children: Object.entries(attributes).map(([key, value])=>/*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                className: "Ispm-SideCarSummary-attributeRow",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        color: "--color-foreground-neutral-subtle",
                                        kind: "body3",
                                        children: key
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        kind: key === "Request ID" || key === "Request Status" ? "body2-bold" : "body2",
                                        className: "Ispm-SideCarSummary-attributeValue",
                                        children: value
                                    })
                                ]
                            }, key))
                    })
                ]
            }),
            access && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-SideCarSummary-accessList",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                        kind: "h4",
                        color: "--color-foreground-neutral-bold",
                        className: "Ispm-SideCarSummary-sectionTitle",
                        children: [
                            access.title,
                            " (",
                            access.count,
                            ")"
                        ]
                    }),
                    Array.isArray(access.roles) && access.roles.map((role, roleIndex)=>{
                        const roleKey = `roleSection-${roleIndex}-${eventId}`;
                        const isRoleExpanded = expandedSection[roleKey];
                        return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    role: "presentation",
                                    className: "Ispm-SideCarSummary-roleItem",
                                    onClick: ()=>toggleSection(roleKey),
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                            className: "Ispm-SideCarSummary-roleHeader",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                    kind: "body2-bold",
                                                    className: "Ispm-SideCarSummary-roleName",
                                                    children: [
                                                        role.name,
                                                        " ",
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                                            size: "xSmall",
                                                            label: "Role",
                                                            color: "neutral"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                                    className: "ButtonSelect-chevron",
                                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                        kind: "ChevronDownSmall",
                                                        size: "medium",
                                                        rotate: isRoleExpanded ? "180" : "0"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                            className: "Ispm-SideCarSummary-roleDescription",
                                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                kind: "body3",
                                                color: "--color-foreground-neutral-subtle",
                                                children: role.description
                                            })
                                        })
                                    ]
                                }),
                                isRoleExpanded && Array.isArray(role.applications) && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-SideCarSummary-roleApplications",
                                    children: role.applications.map((app, appIndex)=>{
                                        const appKey = `roleAppSection-${roleIndex}-${appIndex}-${eventId}`;
                                        const isAppExpanded = expandedSection[appKey];
                                        return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: "Ispm-SideCarSummary-roleApplication",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                    role: "presentation",
                                                    className: "Ispm-SideCarSummary-roleApplication-header",
                                                    onClick: ()=>toggleSection(appKey),
                                                    children: [
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ApplicationIcon), {}),
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                            kind: "body2-bold",
                                                            children: app.name
                                                        }),
                                                        /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                                            className: "ButtonSelect-chevron",
                                                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                                kind: "ChevronDownSmall",
                                                                size: "medium",
                                                                rotate: isAppExpanded ? "180" : "0"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isAppExpanded && Array.isArray(app.accounts) && app.accounts.map((account, accIndex)=>{
                                                    const accKey = `roleAppSection-${roleIndex}-${appIndex}-${accIndex}-${eventId}`;
                                                    const isAccExpanded = expandedSection[accKey];
                                                    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                                role: "presentation",
                                                                className: "Ispm-SideCarSummary-roleAccount-header",
                                                                onClick: ()=>toggleSection(accKey),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                        kind: "body2-bold",
                                                                        children: account.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                                                        size: "xSmall",
                                                                        label: "Account",
                                                                        color: "neutral"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                                                        className: "ButtonSelect-chevron",
                                                                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                                            kind: "ChevronDownSmall",
                                                                            size: "medium",
                                                                            rotate: isAccExpanded ? "180" : "0"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            isAccExpanded && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                                className: "Ispm-SideCarSummary-roleAccount",
                                                                children: Array.isArray(account.entitlements) && account.entitlements.map((ent)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                                        className: "Ispm-SideCarSummary-roleEntitlement",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                                                kind: "body2-bold",
                                                                                className: "Ispm-SideCarSummary-roleEntitlement-header",
                                                                                children: [
                                                                                    ent.accessName,
                                                                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                                                                        size: "xSmall",
                                                                                        label: "Entitlement ",
                                                                                        color: "neutral"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                                kind: "body2",
                                                                                children: ent.description
                                                                            })
                                                                        ]
                                                                    }, ent.accessName))
                                                            })
                                                        ]
                                                    }, account.name);
                                                })
                                            ]
                                        }, app.name);
                                    })
                                })
                            ]
                        }, role.name);
                    }),
                    Array.isArray(access.applications) && access.applications.map((application, appIndex)=>{
                        const key = `applicationSection-${appIndex}-${eventId}`;
                        const isExpanded = expandedSection[key];
                        const isAccountAvailable = Array.isArray(application.accounts) && application.accounts.length > 0;
                        return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$react).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                    role: "presentation",
                                    className: "Ispm-SideCarSummary-accessItem",
                                    onClick: ()=>toggleSection(key),
                                    children: [
                                        /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                                            className: "Ispm-SideCarSummary-accessHeader",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                    className: "Ispm-SideCarSummary-accessHeader-title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ApplicationIcon), {}),
                                                        /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                            kind: "body2-bold",
                                                            className: "Ispm-SideCarSummary-accessName",
                                                            children: [
                                                                application.name,
                                                                " ",
                                                                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                                                    size: "xSmall",
                                                                    label: "Application",
                                                                    color: "neutral"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                                    className: "Ispm-SideCarSummary-accessDescription",
                                                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                        kind: "body3",
                                                        color: "--color-foreground-neutral-subtle",
                                                        children: application.description
                                                    })
                                                })
                                            ]
                                        }),
                                        isAccountAvailable && /*#__PURE__*/ (0, $cURGa$jsx)("span", {
                                            className: "Ispm-SideCarSummary-ButtonSelect-chevron",
                                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                                kind: "ChevronDownSmall",
                                                size: "medium",
                                                rotate: isExpanded ? "180" : "0",
                                                dataTestId: "Ispm-NodeComponentchevron-app"
                                            })
                                        })
                                    ]
                                }),
                                isExpanded && isAccountAvailable && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                    className: "Ispm-SideCarSummary-accounts",
                                    children: Array.isArray(application.accounts) && application.accounts.map((account)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                            className: "Ispm-SideCarSummary-accounts-container",
                                            children: [
                                                /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                    className: "Ispm-SideCarSummary-accounts-container-header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                            kind: "body2-bold",
                                                            color: "--color-foreground-neutral-bold",
                                                            className: "Ispm-SideCarSummary-accounts-container-header-text",
                                                            children: account.name
                                                        }),
                                                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Chip), {
                                                            size: "xSmall",
                                                            label: "Account",
                                                            color: "neutral",
                                                            className: "Ispm-SideCarSummary-accounts-container-header-chip"
                                                        })
                                                    ]
                                                }),
                                                Array.isArray(account.entitlements) && account.entitlements.map((entitlement)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                                        className: "Ispm-SideCarSummary-accounts-container-entitlement",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                kind: "body2-bold",
                                                                color: "--color-foreground-neutral-bold",
                                                                children: entitlement.accessName
                                                            }),
                                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                                                kind: "body2",
                                                                color: "--color-foreground-neutral-bold",
                                                                children: entitlement.description
                                                            })
                                                        ]
                                                    }))
                                            ]
                                        }, account.name))
                                })
                            ]
                        }, application.name);
                    })
                ]
            }),
            owners && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-SideCarSummary-ownersList",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                        kind: "h4",
                        color: "--color-foreground-neutral-bold",
                        className: "Ispm-SideCarSummary-sectionTitle",
                        children: [
                            "Owners (",
                            owners.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SideCarSummary-ownerBoxes",
                        children: owners.map((owner)=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-SideCarSummary-ownerCard",
                                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                    kind: "h4",
                                    color: "--color-foreground-secondary-bold",
                                    className: "Ispm-SideCarSummary-ownerName",
                                    children: (0, $c49aa0f374b6c6e6$export$7dac1d63a1a3adff)(owner)
                                })
                            }, owner))
                    })
                ]
            }),
            attributesUpdated?.length && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-SideCarSummary-attributesUpdatedList",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                        kind: "h4",
                        color: "--color-foreground-neutral-bold",
                        className: "Ispm-SideCarSummary-sectionTitle",
                        children: [
                            "Attributes Updated (",
                            attributesUpdated.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-SideCarSummary-attributesUpdatedBoxes",
                        children: attributesUpdated.map((attr)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-SideCarSummary-attributesUpdatedCard",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        kind: "h4",
                                        color: "--color-foreground-neutral-bold",
                                        className: "Ispm-SideCarSummary-ownerName",
                                        children: (0, $c49aa0f374b6c6e6$export$7dac1d63a1a3adff)(attr.name)
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Typography), {
                                        className: "Ispm-SideCarSummary-attributeUpdatedValue",
                                        kind: "body2",
                                        color: "--color-foreground-neutral-medium",
                                        children: `${attr.previousValue ?? " \xb7 "} -> ${attr.newValue ?? " \xb7 "}`
                                    })
                                ]
                            }, attr.name))
                    })
                ]
            })
        ]
    });
};
var $80ac3b52506fce4b$export$2e2bcd8739ae039 = $80ac3b52506fce4b$var$SideCarSummary;



function $e8806f5a70b50cfa$var$IdentitiesTimeline({ timelineData: timelineData, fetchMoreData: fetchMoreData }) {
    const dispatch = (0, $cURGa$useDispatch)();
    const [expandedDates, setExpandedDates] = (0, $cURGa$useState)({});
    const observer = (0, $cURGa$useRef)(null);
    const [sideCarHeading, setSideCarHeading] = (0, $cURGa$useState)("");
    const [isSideCarPendingEvent, setIsSideCarPendingEvent] = (0, $cURGa$useState)(false);
    const [sideCarHeadingIcon, setSideCarHeadingIcon] = (0, $cURGa$useState)((0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).added);
    const [activeElement, setActiveElement] = (0, $cURGa$useState)(null);
    const [isOpen, setIsOpen] = (0, $cURGa$useState)(false);
    const [activeTab, setActiveTab] = (0, $cURGa$useState)("1");
    const [mediaQueryValue, setMediaQueryValue] = (0, $cURGa$useState)(0);
    const sidepanelRef = (0, $cURGa$useRef)(null);
    const [selectedUserId, setSelectedUserId] = (0, $cURGa$useState)("");
    const [selectedEventId, setSelectedEventId] = (0, $cURGa$useState)("");
    const selectedUser = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.selectedUser);
    const isRelevantActivitiesHidden = (0, $cURGa$useSelector)((state)=>state.identityTimelineSideCar.isRelevantActivitiesHidden);
    (0, $cURGa$useEffect)(()=>{
        document.body.classList.add("Ispm-body-IdentitiesTimeline");
    }, []);
    // Initialize all dates as expanded on mount
    (0, $cURGa$useEffect)(()=>{
        const initialExpanded = Object.keys(timelineData).reduce((acc, date)=>{
            acc[date] = true;
            return acc;
        }, {});
        setExpandedDates((prev)=>({
                ...initialExpanded,
                ...prev
            }));
    }, [
        timelineData
    ]);
    (0, $cURGa$useEffect)(()=>{
        if (isRelevantActivitiesHidden) setActiveTab("1");
    }, [
        isRelevantActivitiesHidden
    ]);
    const toggleExpand = (date)=>{
        setExpandedDates((prev)=>({
                ...prev,
                [date]: !prev[date]
            }));
    };
    (0, $cURGa$useEffect)(()=>{
        const handleResize = ()=>{
            // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
            const sidePanel = document.querySelector(".Example-SidePanel");
            if (sidePanel) {
                const sidePanelWidth = sidePanel.offsetWidth;
                const offset = sidePanelWidth - 52;
                document.documentElement.style.setProperty("--side-panel-width", `${offset}px`);
            }
        };
        handleResize(); // on mount
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        isOpen
    ]); // run only when panel is open
    (0, $cURGa$useEffect)(()=>{
        const activeItem = document.querySelector(".Ispm-TimelineItem-details.timeline-item.active.joined-border");
        const tabGroup = document.querySelector(".Ispm-TimelineControlToolbar");
        const onScroll = ()=>{
            if (!activeItem || !tabGroup) return;
            const tabGroupRect = tabGroup.getBoundingClientRect();
            const activeItemRect = activeItem.getBoundingClientRect();
            // When Active Item crosses tab header
            if (activeItemRect.top <= tabGroupRect.bottom) activeItem.classList.add("hide-border");
            else activeItem.classList.remove("hide-border");
        };
        window.addEventListener("scroll", onScroll);
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, [
        activeElement
    ]);
    // Infinite scroll observer setup
    const lastElementRef = (0, $cURGa$useCallback)((node)=>{
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) fetchMoreData().catch((error)=>{
                if (error instanceof Error) (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("Failed to fetch more data:", error.message);
                else (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error("An unknown error occurred:", error);
            });
        });
        if (node) observer.current.observe(node);
    }, [
        fetchMoreData
    ]);
    // Event handler for delegated clicks
    const openSideCar = (event)=>{
        const target = event.target.closest(`.${(0, $f618e3351c7ca235$export$65cf17a55b364e8)}`);
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log("handle event", {
            event: event
        });
        if (!target) return;
        const eventId = target.getAttribute("data-eventid");
        if (eventId) setActiveElement(eventId); // Store clicked element ID
        // Open the side car
        setIsOpen(true);
        // TODO: Delete below
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).info({
            sideCarHeadingIcon: sideCarHeadingIcon
        });
        const userId = target.getAttribute("data-userid");
        const sidePanelHeading = target.getAttribute("data-eventType") ?? "";
        const isPending = target.getAttribute("data-isDottedConnector") === "true";
        const rawIcon = target.getAttribute("data-icon");
        const selectedEventType = target.getAttribute("data-eventtypename") ?? "";
        const isToHide = (0, $d71824b5698c7ec3$export$2e2bcd8739ae039)(selectedEventType);
        const sideCarIcon = (0, $10a04991e0e365ed$export$9cf498f669120905)(rawIcon) ? rawIcon : (0, $1d3288d13a1a1df7$export$bb115dbb5c52277f).added;
        setSideCarHeading(sidePanelHeading);
        setSideCarHeadingIcon(sideCarIcon);
        setIsSideCarPendingEvent(isPending);
        dispatch((0, $ec34473eca2d3d1f$export$aebfc16d2f2ef6de)(isToHide));
        if (userId && eventId) {
            (0, $68023e09bcf60e96$export$2e2bcd8739ae039).log(`Clicked timeline item - User ID: ${userId}, Event ID: ${eventId}`);
            setSelectedUserId(userId);
            setSelectedEventId(eventId);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    (0, $cURGa$useResponsiveValueState)(setMediaQueryValue, (0, $f618e3351c7ca235$export$12bfde30afe7dcf1));
    const handleChange = (value)=>setActiveTab(value);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const tabletMediumQuery = (0, $f618e3351c7ca235$export$12bfde30afe7dcf1).find(// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    (item)=>item.label === "TabletMedium");
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const mobileXlargeQuery = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (0, $f618e3351c7ca235$export$12bfde30afe7dcf1).find((item)=>item.label === "MobileXLarge");
    // Safe member access
    const isTabletMediumWidth = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    tabletMediumQuery?.value !== undefined ? tabletMediumQuery.value <= mediaQueryValue : false;
    const isMobileXlargeWidth = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    mobileXlargeQuery?.value !== undefined ? mobileXlargeQuery.value <= mediaQueryValue : false;
    const getIpsum = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $80ac3b52506fce4b$export$2e2bcd8739ae039), {
            userId: selectedUserId,
            eventId: selectedEventId
        });
    const getRelevantActivitiesTimeline = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $2747226a6a7f4ccc$export$2e2bcd8739ae039), {
            userId: selectedUserId,
            eventId: selectedEventId
        });
    const getHeaderIcon = ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $a1d2976b03453ee4$export$2e2bcd8739ae039), {
            iconType: sideCarHeadingIcon,
            isDottedConnector: isSideCarPendingEvent,
            iconSize: "xxLarge"
        });
    const sampleLayout = ()=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
            className: "Example-SidePanel-layoutWidth",
            children: [
                /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$TabGroup), {
                    moreContainerRef: sidepanelRef,
                    value: activeTab,
                    onChange: handleChange,
                    isVerticalWithOverflow: isMobileXlargeWidth,
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TabItem), {
                            label: "Summary",
                            value: "1",
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "Document",
                                size: "medium"
                            }),
                            dataTestId: "ispm-identities-timeline-sidecar-summary"
                        }),
                        !isRelevantActivitiesHidden && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TabItem), {
                            label: "Relevant Activities",
                            value: "2",
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "RequestHistory",
                                size: "medium"
                            }),
                            dataTestId: "ispm-identities-timeline-sidecar-relevantActivities"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TabContent), {
                    className: "Example-SidePanel-tabContent",
                    value: activeTab,
                    tabValue: "1",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Fragment), {
                        children: getIpsum()
                    })
                }),
                !isRelevantActivitiesHidden && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$TabContent), {
                    className: "Example-SidePanel-tabContent",
                    value: activeTab,
                    tabValue: "2",
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                        className: "Example-SidePanel-tabContentHeader",
                        children: getRelevantActivitiesTimeline()
                    })
                })
            ]
        });
    const handleCloseSideCar = ()=>{
        setIsOpen(false);
        setActiveElement("");
        dispatch((0, $ec34473eca2d3d1f$export$225eff1920d91399)());
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentitiesTimeline",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Box), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$SidePanel), {
                    ref: sidepanelRef,
                    header: {
                        title: sideCarHeading,
                        description: `Activity of ${selectedUser?.name ?? "User"}`
                    },
                    layout: sampleLayout(),
                    isOpen: isOpen,
                    onClose: handleCloseSideCar,
                    isSidePanelNavigatingList: true,
                    isPreviousDisabled: true,
                    isNextDisabled: true,
                    isMobileWidth: isMobileXlargeWidth,
                    isTabletWidth: isTabletMediumWidth,
                    className: "Example-SidePanel",
                    layoutClassName: "Example-SidePanel-layout",
                    headerIconElement: getHeaderIcon()
                })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                onClick: openSideCar,
                onKeyDown: openSideCar,
                role: "presentation",
                children: Object.entries(timelineData).map(([date, { description: description, events: events }], groupIndex, timelineArr)=>{
                    const isExpanded = expandedDates[date] ?? false;
                    const isLastGroup = groupIndex === timelineArr.length - 1;
                    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-Timeline",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $e05bc634557d0c48$export$2e2bcd8739ae039), {
                                date: date,
                                summary: description ?? "",
                                toggleExpand: ()=>toggleExpand(date),
                                isOpen: isExpanded
                            }),
                            isExpanded && events.map((item, index)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $4716356063be0eb7$export$2e2bcd8739ae039), {
                                    item: item,
                                    isLast: index === events.length - 1,
                                    isLastGroup: isLastGroup,
                                    isEventClickable: true,
                                    dataAttributes: {
                                        ...item.metadata
                                    },
                                    activeElementClassName: `timeline-item ${// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                                    activeElement === String(item.metadata?.["data-eventid"]) ? "active joined-border" : ""}`
                                }, (0, $2b309ef89c44b128$export$daf4c137c5f56404)(JSON.stringify(item)))),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                ref: lastElementRef,
                                style: {
                                    height: "1px"
                                }
                            })
                        ]
                    }, date);
                })
            })
        ]
    });
}
var $e8806f5a70b50cfa$export$2e2bcd8739ae039 = $e8806f5a70b50cfa$var$IdentitiesTimeline;


function $872ef97b9e01b266$var$IdentitiesTimelineContent({ userId: userId }) {
    const sortDirection = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedSortDirection);
    const selectedFilter = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedFilters);
    const searchValue = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.userSearchInput);
    const { startDate: startDate, endDate: endDate } = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedDateFilter);
    const debouncedSearch = (0, $a925d1f723de0eb3$export$2e2bcd8739ae039)(searchValue, 500);
    const debouncedFilters = (0, $a925d1f723de0eb3$export$2e2bcd8739ae039)(selectedFilter, 500);
    const { timelineData: timelineData, isLoading: isLoading, error: error, loadMoreTimelineData: loadMoreTimelineData, isLoadingMore: isLoadingMore } = (0, $ef1666d1a8579d02$export$569070b09cb0ade9)({
        userId: userId,
        params: {
            filters: debouncedFilters,
            sortDirection: sortDirection,
            searchText: debouncedSearch,
            startDate: startDate,
            endDate: endDate
        }
    });
    const l = (0, $10bf676d992f37e7$export$b544502b42f276ba)((0, $806e6a38034fc517$export$223b8efb77cb35fb));
    if (isLoading) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $6645b9b17ab0d3d1$export$2e2bcd8739ae039), {
        itemCount: 3
    });
    if (error) // TODO: Update localization
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $e2ea88e8ee0cb0f8$export$2e2bcd8739ae039), {
        title: "Unable to Load Timeline",
        description: "We encountered an issue while loading the timeline. Please try refreshing the page.",
        iconKind: "ErrorSign"
    });
    const isEmpty = !Array.isArray(timelineData.value) || timelineData.value.length === 0;
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Fragment), {
        children: [
            isEmpty ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $b632ad964f82823d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cURGa$jsx)((0, $e8806f5a70b50cfa$export$2e2bcd8739ae039), {
                timelineData: (0, $7f39fd185641657a$export$2e2bcd8739ae039)(timelineData, l),
                fetchMoreData: loadMoreTimelineData
            }),
            isLoadingMore && /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityList-loader",
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Loader), {
                    kind: "loop",
                    format: "main",
                    color: "brand"
                })
            })
        ]
    });
}
var $872ef97b9e01b266$export$2e2bcd8739ae039 = $872ef97b9e01b266$var$IdentitiesTimelineContent;












function $4ab10c3296396cb3$var$IdentityAccessSummary({ userId: userId }) {
    const { data: accessSummaryData } = (0, $ef1666d1a8579d02$export$4fe23b82bcf2d5d1)(userId);
    const dispatch = (0, $cURGa$useDispatch)();
    const history = (0, $cURGa$useHistory)();
    const selectedUser = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.selectedUser);
    const { data: identity } = (0, $ef1666d1a8579d02$export$8ef2730b11d678cb)(userId);
    (0, $cURGa$useEffect)(()=>{
        if (!selectedUser && identity) dispatch((0, $8939fb7be58f56d0$export$6d06ea42ee2ef64)(identity.data)); // Store in Redux
    }, [
        dispatch,
        identity,
        selectedUser
    ]);
    const summaryInsightData = (0, $cURGa$useMemo)(()=>{
        if (accessSummaryData) return [
            {
                name: "Resources",
                value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.applications.count)
            },
            {
                name: "Roles",
                value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.roles.count)
            },
            {
                name: "Accounts",
                value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.accounts.count)
            },
            {
                name: "Entitlements",
                value: (0, $8ff2252602deef38$export$6dbb2be3cc20ac53)(accessSummaryData.data.entitlements.count)
            }
        ];
        return [];
    }, [
        accessSummaryData
    ]);
    const navigateToIdentities = ()=>{
        history.push(`${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}`);
    };
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentityAccessSummary",
        children: [
            selectedUser && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                className: "Ispm-IdentityAccessSummary-wrapper",
                children: [
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        leftIcon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                            kind: "ChevronLeft"
                        }),
                        onClick: navigateToIdentities,
                        dataTestId: "ispm-identityAccessSummary-backToIdentities"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Avatar), {
                        size: "medium",
                        className: "Ispm-IdentityAccessSummary-profileImage",
                        src: selectedUser.imageUrl,
                        alt: `${selectedUser.name}'s avatar`
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-IdentityAccessSummary-profileDescription",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityAccessSummary-profileDescription-name",
                                children: selectedUser.name
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityAccessSummary-profileDescription-title",
                                children: selectedUser.jobTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentityAccessSummary-data",
                children: summaryInsightData.map((ele)=>/*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        className: "Ispm-IdentityAccessSummary-data-content",
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityAccessSummary-data-content-accessValue",
                                children: ele.value
                            }),
                            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                                className: "Ispm-IdentityAccessSummary-data-content-accessName",
                                children: ele.name
                            })
                        ]
                    }, ele.name))
            })
        ]
    });
}
var $4ab10c3296396cb3$export$2e2bcd8739ae039 = $4ab10c3296396cb3$var$IdentityAccessSummary;


/* eslint-disable jsx-a11y/anchor-is-valid */ 









function $f2822ede152672e2$var$isFilterValueResponse(data) {
    return typeof data === "object" && data !== null && "data" in data && Array.isArray(data.data) && data.data.every((item)=>typeof item.id === "string" && typeof item.name === "string");
}
const $f2822ede152672e2$export$b5c4ff3e5f174c93 = async ({ field: field, userId: userId, startDate: startDate, endDate: endDate, limit: limit })=>{
    const { TIMELINE_FILTER_VALUES_URL: TIMELINE_FILTER_VALUES_URL } = (0, $8ff2252602deef38$export$b370277fd33ab630)();
    let timelineFilterValuesUrl = TIMELINE_FILTER_VALUES_URL.replace((0, $8ff2252602deef38$export$d57962bd0a7623ea), userId).replace((0, $8ff2252602deef38$export$cd4e913e17de0f), field);
    // Append query parameters (startDate & endDate)
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("startDate", startDate.toString());
    if (endDate) queryParams.append("endDate", endDate.toString());
    // If there are query params, append to URL
    if (queryParams.toString()) timelineFilterValuesUrl += `?${queryParams.toString()}`;
    const config = {
        timeout: 30000,
        method: "GET"
    };
    try {
        const response = await (0, $09eb0c2e34916250$export$adb4bb4243526aef)(timelineFilterValuesUrl, config, $f2822ede152672e2$var$isFilterValueResponse);
        // TODO: Ask backend team to give paginated API's
        if (limit && limit > 0) response.data = response.data.slice(0, limit);
        if (!$f2822ede152672e2$var$isFilterValueResponse(response)) throw new Error("Invalid API response format");
        return response.data.map(({ id: id, name: name })=>({
                id: id,
                label: name ?? "Unknown",
                value: id
            }));
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`getFilterValues - Failed to fetch values for "${field}": ${errorMessage}`);
        throw new Error(`Error fetching filter values for ${field}: ${errorMessage}`);
    }
};



const $c410bbbe91a98fdd$var$useTimelineFilters = (page)=>{
    const [filterOptions, setFilterOptions] = (0, $cURGa$useState)({});
    /**
   * This setter we are creating to have a function reference of all the Values of each filters. Any value can be updated by calling their setters function
   */ const [setters, setSetters] = (0, $cURGa$useState)({});
    const [isLoading, setIsLoading] = (0, $cURGa$useState)(true);
    const [error, setError] = (0, $cURGa$useState)(null);
    const [filtersData, setFiltersData] = (0, $cURGa$useState)([]);
    const userId = (0, $cURGa$useSelector)((state)=>state.ispmIdentity.selectedUser?.id);
    const startDate = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedDateFilter.startDate);
    const endDate = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedDateFilter.endDate);
    const fetchFilters = (0, $cURGa$useCallback)(async ()=>{
        try {
            const filters = await (0, $c4ff51708924255d$export$bdc4491a79e598ef)({
                page: page
            });
            setFiltersData(filters); // Store filters in state
            if (!Array.isArray(filters)) throw new Error("Invalid API response format");
            const newFilterOptions = {};
            const newSetters = {};
            const results = await Promise.allSettled(filters.map(async (filter)=>{
                try {
                    const values = userId ? await (0, $f2822ede152672e2$export$b5c4ff3e5f174c93)({
                        field: filter.field,
                        userId: userId,
                        startDate: startDate,
                        endDate: endDate
                    }) : [];
                    return {
                        field: filter.field,
                        values: values
                    };
                } catch (fetchError) {
                    return {
                        field: filter.field,
                        error: fetchError
                    };
                }
            }));
            results.forEach((result)=>{
                if (result.status === "fulfilled" && result.value.values) {
                    const { field: field, values: values } = result.value;
                    newFilterOptions[field] = values.map((item)=>({
                            field: field,
                            label: item.label ?? "Unknown",
                            value: item.value ?? item.id,
                            isChecked: false
                        }));
                    newSetters[field] = (value)=>setFilterOptions((prev)=>({
                                ...prev,
                                [field]: typeof value === "function" ? value(prev[field] || []) : value
                            }));
                } else if (result.status === "rejected") {
                    const errorField = result.reason.field ?? "unknown";
                    (0, $68023e09bcf60e96$export$2e2bcd8739ae039).error(`Error fetching values for ${errorField}`);
                }
            });
            setFilterOptions(newFilterOptions);
            setSetters(newSetters);
        } catch (mainError) {
            setError(`Error fetching filters: ${String(mainError)}`);
        } finally{
            setIsLoading(false);
        }
    }, [
        endDate,
        page,
        startDate,
        userId
    ]);
    (0, $cURGa$useEffect)(()=>{
        fetchFilters().catch((unexpectedError)=>{
            setError(`Unexpected error in useEffect: ${String(unexpectedError)}`);
        });
    }, [
        fetchFilters
    ]);
    return {
        filterOptions: filterOptions,
        setters: setters,
        isLoading: isLoading,
        error: error,
        filtersData: filtersData
    };
};
var $c410bbbe91a98fdd$export$2e2bcd8739ae039 = $c410bbbe91a98fdd$var$useTimelineFilters;







function $6652ee60ec918231$var$TimelineControlToolbar() {
    const dispatch = (0, $cURGa$useDispatch)();
    const selectedFilter = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedFilters);
    const searchValue = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.userSearchInput);
    const dateFilter = (0, $cURGa$useSelector)((state)=>state.ispmIdentityTimeline.selectedDateFilter);
    const [isFilterToolboxOpen, setIsFilterToolboxOpen] = (0, $cURGa$useState)(false);
    const [addFilterOptions, setAddFilterOptions] = (0, $cURGa$useState)();
    const [isDateFilterOpen, setIsDateFilterOpen] = (0, $cURGa$useState)(false);
    const [calendarStartDate, setCalendarStartDate] = (0, $cURGa$useState)(new Date(dateFilter.startDate));
    const [calendarEndDate, setCalendarEndDate] = (0, $cURGa$useState)(new Date(dateFilter.endDate));
    const dateFilterRef = (0, $cURGa$useRef)(null);
    const { filterOptions: filterOptions, setters: setters, filtersData: filtersData } = (0, $c410bbbe91a98fdd$export$2e2bcd8739ae039)("timelinePage");
    const handleToolboxClick = ()=>{
        setIsFilterToolboxOpen((currOpen)=>!currOpen);
    };
    const toggleSortDirection = (value)=>{
        dispatch((0, $270ea330992dc44e$export$7ffaa548ac035555)(value));
    };
    const [visibleFilters, setVisibleFilters] = (0, $cURGa$useState)([]);
    // Default to showing only first 3 filters
    const [tabs, setTabs] = (0, $cURGa$useState)([]);
    const [selection, setSelection] = (0, $cURGa$useState)(1);
    (0, $cURGa$useEffect)(()=>{
        setTabs([
            "Timeline",
            "Access"
        ]);
    }, []);
    (0, $cURGa$useEffect)(()=>{
        setVisibleFilters(filtersData.slice(0, (0, $f618e3351c7ca235$export$d95b5f8ae12844bf)).map((f)=>f.field));
    }, [
        filtersData
    ]);
    (0, $cURGa$useEffect)(()=>{
        dispatch((0, $270ea330992dc44e$export$edef0fcdb8e4fa90)());
    }, [
        dispatch
    ]);
    (0, $cURGa$useEffect)(()=>{
        setCalendarEndDate(new Date(dateFilter.endDate));
        setCalendarStartDate(new Date(dateFilter.startDate));
    }, [
        dateFilter.endDate,
        dateFilter.startDate
    ]);
    /**
   * Create below filterConfig to keep track of active and inactive filter pills and there values.
   */ const filterConfigs = visibleFilters.map((key)=>{
        const foundFilter = filtersData.find((filter)=>filter.field === key);
        return {
            label: foundFilter?.name ?? key,
            options: filterOptions[key] || [],
            setter: setters[key],
            key: key
        };
    });
    /**
   * Handles the click of filter values
   * @param setter
   * @param field
   * @returns
   */ const handleFilterValueChange = (setter, field)=>(selectedOptions)=>{
            if (!selectedOptions) return;
            /**
       * This setter will check ad uncheck in filterOPtions variable and dynamically update filter config
       */ setter((prev)=>prev.map((option)=>({
                        ...option,
                        isChecked: selectedOptions.some((selected)=>selected.value === option.value)
                    })));
            const newFilters = selectedOptions.map((option)=>({
                    field: field,
                    operator: "IN",
                    values: [
                        option.value
                    ]
                }));
            // TODO: update format of filter in userParam here only. we are unnecessarly going throught he loop again in getUserTimeline method
            if (Array.isArray(selectedFilter)) dispatch((0, $270ea330992dc44e$export$c086c216e40488ac)([
                ...selectedFilter.filter((f)=>f.field !== field),
                ...newFilters
            ]));
            else // Update selected filters state correctly
            dispatch((0, $270ea330992dc44e$export$c086c216e40488ac)(newFilters));
        };
    /**
   * Update + icon list which holds all filter chips data
   */ (0, $cURGa$useEffect)(()=>{
        const listOfFilterOptions = filtersData.map((filterData)=>({
                label: filterData.name,
                value: filterData.field,
                isDisabled: !filterData.show,
                isChecked: !visibleFilters.includes(filterData.field),
                // TODO: Localization
                category: "Filter Group"
            }));
        setAddFilterOptions(listOfFilterOptions);
    }, [
        filtersData,
        visibleFilters
    ]);
    const handleAddFilterChange = (selectedOption)=>{
        setVisibleFilters((currentFilters)=>{
            if (currentFilters.includes(selectedOption.value)) return currentFilters.filter((filter)=>filter !== selectedOption.value);
            return [
                ...currentFilters,
                selectedOption.value
            ];
        });
    };
    const handleClearAll = ()=>{
        // Reset all filterOptions (uncheck all values)
        Object.keys(setters).forEach((field)=>{
            setters[field]((prev)=>prev.map((option)=>({
                        ...option,
                        isChecked: false
                    })));
        });
        // Clear filters from Redux store
        dispatch((0, $270ea330992dc44e$export$c086c216e40488ac)([]));
        dispatch((0, $270ea330992dc44e$export$edef0fcdb8e4fa90)());
        // Reset visible filters to default (only first 3)
        setVisibleFilters(filtersData.slice(0, 3).map((f)=>f.field));
    };
    const handleClickOutsideDateFilter = (event)=>{
        if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) setIsDateFilterOpen(false);
    };
    const handleApplyDateFilter = ()=>{
        if (calendarEndDate && calendarStartDate) dispatch((0, $270ea330992dc44e$export$c687fcc9fc793779)({
            startDate: (0, $10a04991e0e365ed$export$bcd63b170efd80b4)(calendarStartDate, true).getTime(),
            endDate: (0, $10a04991e0e365ed$export$bcd63b170efd80b4)(calendarEndDate, false).getTime()
        }));
    };
    const handleClearDateFilter = ()=>{
        dispatch((0, $270ea330992dc44e$export$edef0fcdb8e4fa90)());
    };
    (0, $cURGa$useEffect)(()=>{
        if (isDateFilterOpen) document.addEventListener("mousedown", handleClickOutsideDateFilter);
        else document.removeEventListener("mousedown", handleClickOutsideDateFilter);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutsideDateFilter);
        };
    }, [
        isDateFilterOpen
    ]);
    const selectedDateFilterLabel = dateFilter.startDate && dateFilter.endDate ? `Date :${(0, $10a04991e0e365ed$export$3ae94a2503e890a1)(dateFilter.startDate)} to ${(0, $10a04991e0e365ed$export$3ae94a2503e890a1)(dateFilter.endDate)}` : "Date";
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const bounds = (0, $10a04991e0e365ed$export$463c4185935d5f9b)(calendarStartDate, calendarEndDate);
    // Sync with validated values if needed
    (0, $cURGa$useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (calendarStartDate !== bounds.validatedStartDate) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        setCalendarStartDate(bounds.validatedStartDate);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (calendarEndDate !== bounds.validatedEndDate) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        setCalendarEndDate(bounds.validatedEndDate);
    }, [
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        bounds.validatedStartDate,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        bounds.validatedEndDate,
        calendarStartDate,
        calendarEndDate
    ]);
    const timelineTab = "Ispm-timeline-tab";
    const accessTab = "Ispm-access-tab";
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
        className: "Ispm-TimelineControlToolbar",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButtonGroup), {
                selection: selection,
                setSelection: setSelection,
                className: "Ispm-IdentitiesTimeline-body-tabGroup",
                children: tabs.map((tab)=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ToggleButton), {
                        label: tab,
                        isDisabled: selection === 1,
                        className: tab === "Timeline" ? timelineTab : accessTab
                    }, tab))
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cbb5fe21dd3e2706$export$2e2bcd8739ae039), {
                searchValue: searchValue ?? "",
                setSearchValue: (value)=>dispatch((0, $270ea330992dc44e$export$3688e9a8427cc7de)(value)),
                handleFilterClick: handleToolboxClick,
                isFilterOpen: isFilterToolboxOpen,
                toggleSortDirection: toggleSortDirection,
                isViewFeatureAvailable: false,
                // TODO: Localization needed
                searchInputPlaceholder: "Search by application, account, entitlement, etc.",
                sortOptions: (0, $c49aa0f374b6c6e6$export$2e40ba47c9674fe4),
                isFilterOptionsSelected: Array.isArray(selectedFilter) && selectedFilter.length > 0,
                dataTestId: "ispm-identities-timeline",
                isDateFilterSelected: !!(dateFilter.startDate && dateFilter.endDate)
            }),
            isFilterToolboxOpen && /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Box), {
                className: "Ispm-Identities-filter-toolbox",
                children: [
                    filterConfigs.map(({ label: label, options: options, setter: setter, key: key })=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$MenuMulti), {
                            // TODO: move it to constants
                            options: options,
                            label: label,
                            onChange: handleFilterValueChange(setter, key),
                            trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                                kind: "pill",
                                label: label,
                                BadgeComp: selectedFilter.find((filter)=>filter.field === key) && /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                                    kind: "dot",
                                    color: "primary",
                                    size: "small"
                                })
                            }),
                            minOptionsForFooter: 1,
                            maxOptionsToDisplay: 100,
                            dataTestId: `ispm-identities-timeline-filter-${key}`,
                            heightToShowScrollbar: "8rem"
                        }, key + label)),
                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                        ref: dateFilterRef,
                        style: {
                            position: "relative",
                            display: "inline-block"
                        },
                        children: [
                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonSelect), {
                                kind: "pill",
                                label: selectedDateFilterLabel,
                                onClick: ()=>setIsDateFilterOpen(!isDateFilterOpen),
                                isOpen: isDateFilterOpen,
                                size: "medium",
                                dataTestId: "ispm-identities-timeline-dateFilter",
                                BadgeComp: dateFilter.startDate && dateFilter.endDate ? /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Badge), {
                                    kind: "dot",
                                    color: "primary",
                                    size: "small"
                                }) : null
                            }),
                            isDateFilterOpen && /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                className: "Ispm-TimelineControlToolbar-dateFilter",
                                children: [
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-TimelineControlToolbar-startDateEndDateWrapper",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$DateAndTimePicker), {
                                                kind: "dateStart",
                                                label: "Start Date",
                                                startDate: calendarStartDate,
                                                setStartDate: setCalendarStartDate,
                                                endDate: calendarEndDate,
                                                setEndDate: setCalendarEndDate,
                                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                                                maxDate: bounds.startDateMax,
                                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                                                minDate: bounds.startDateMin
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Typography), {
                                                color: "--color-foreground-neutral-bold",
                                                kind: "body2",
                                                className: "Ispm-TimelineControlToolbar-to",
                                                children: [
                                                    " ",
                                                    "to"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$DateAndTimePicker), {
                                                kind: "dateEnd",
                                                label: "End Date",
                                                startDate: calendarStartDate,
                                                setStartDate: setCalendarStartDate,
                                                endDate: calendarEndDate,
                                                setEndDate: setCalendarEndDate,
                                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                                                maxDate: bounds.endDateMax,
                                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                                                minDate: bounds.endDateMin
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                                        className: "Ispm-TimelineControlToolbar-dateFilter-applyClear ",
                                        children: [
                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Button), {
                                                onClick: handleApplyDateFilter,
                                                type: "button",
                                                kind: "ghost",
                                                size: "small",
                                                className: "Ispm-TimelineControlToolbar-dateFilter-apply",
                                                dataTestId: "ispm-identities-timeline-dateFilter-apply",
                                                children: [
                                                    " ",
                                                    "Apply",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Button), {
                                                className: "Ispm-TimelineControlToolbar-dateFilter-clear",
                                                onClick: handleClearDateFilter,
                                                type: "button",
                                                kind: "ghost",
                                                size: "small",
                                                dataTestId: "ispm-identities-timeline-dateFilter-clear",
                                                children: [
                                                    " ",
                                                    "Clear",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Menu), {
                        kind: "addAndRemove",
                        label: "Add or Remove Filters",
                        options: addFilterOptions,
                        onChange: handleAddFilterChange,
                        trigger: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$ButtonIcon), {
                            kind: "outlinedNeutral",
                            size: "medium",
                            icon: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Icon), {
                                kind: "Add",
                                size: "xSmall"
                            })
                        }),
                        shouldCloseMenuOnItemClick: false,
                        dataTestId: "ispm-identities-timeline-addOrRemoveFilter",
                        className: "Ispm-identities-timeline-addOrRemoveFilter"
                    }),
                    /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Link), {
                        className: "ispm-identities-timeline-ClearFilters",
                        text: "Clear",
                        kind: "button",
                        onClick: handleClearAll,
                        dataTestId: "ispm-identities-timeline-ClearFilters"
                    })
                ]
            })
        ]
    });
}
var $6652ee60ec918231$export$2e2bcd8739ae039 = $6652ee60ec918231$var$TimelineControlToolbar;






function $4a886bd7812487f1$var$IdentitiesTimeline({ userId: userId }) {
    const dispatch = (0, $cURGa$useDispatch)();
    const { permission: timelinePermission, isLoading: isPermissionLoading } = (0, $f368c544e3051320$export$2e2bcd8739ae039)((0, $e93470e5e98f2427$export$e08c7aae438e15b4).HUMAN_IDENTITY_TIMELINE_VIEW);
    (0, $cURGa$useEffect)(()=>{
        dispatch((0, $270ea330992dc44e$export$b4016158c566c11c)());
        dispatch((0, $270ea330992dc44e$export$81a10a2fce3a5072)());
        dispatch((0, $270ea330992dc44e$export$8f4b8c896e5a0519)());
    }, [
        dispatch
    ]);
    (0, $cURGa$useEffect)(()=>{
        document.body.classList.add("Ispm-Identities-dark-mode-fix");
        window.scrollTo(0, 0); // Reset scroll position to the top
        return ()=>{
            document.body.classList.remove("Ispm-Identities-dark-mode-fix");
        };
    }, []);
    if (isPermissionLoading) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $a72e27c476852c06$export$2e2bcd8739ae039), {});
    if (!timelinePermission?.enabled) return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Global404), {});
    return /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
        className: "Ispm-IdentitiesTimeline",
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $4ab10c3296396cb3$export$2e2bcd8739ae039), {
                userId: userId
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                className: "Ispm-IdentitiesTimeline-body",
                children: /*#__PURE__*/ (0, $cURGa$jsxs)("div", {
                    className: "Ispm-IdentitiesTimeline-body-activityTab TabContent",
                    children: [
                        /*#__PURE__*/ (0, $cURGa$jsx)((0, $6652ee60ec918231$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $cURGa$jsx)("div", {
                            className: "Ispm-IdentitiesTimeline-data-activityTab-chart",
                            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $872ef97b9e01b266$export$2e2bcd8739ae039), {
                                userId: userId
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $4a886bd7812487f1$export$2e2bcd8739ae039 = $4a886bd7812487f1$var$IdentitiesTimeline;



const $30427897bfe14b4e$var$queryClient = new (0, $cURGa$QueryClient)({
    defaultOptions: {
        queries: {
            staleTime: (0, $8ff2252602deef38$export$8fec9643a87f15ca),
            retry: (failureCount, error)=>{
                // Don't retry if my custom retry logic already exhausted. fetchApi already retrying for 429
                if (error instanceof (0, $78cc6b7b57a4e4aa$export$2e2bcd8739ae039)) return false;
                // Otherwise, allow a few retries
                return failureCount < 3;
            }
        }
    }
});
function $30427897bfe14b4e$var$PagesRoute() {
    // Get the ispm enable service from host app store values
    const ISPM_SERVICES_ENABLED = (0, $cURGa$useSelector)((state)=>state.user?.domainInfo?.ISPM_SERVICES_ENABLED ?? false);
    (0, $cURGa$useEffect)(()=>{
        /* hide host app elements not needed for Gen2 UI */ (0, $891f55c18f10aed6$export$d3c2f6c31128e311)();
        (0, $891f55c18f10aed6$export$9bc070677037150b)();
        return ()=>{
            (0, $891f55c18f10aed6$export$5a88c3c2439cce55)();
        };
    }, []);
    /**
   * If ISPM services is not enabled, return 404
   */ if (!ISPM_SERVICES_ENABLED) return /*#__PURE__*/ (0, $cURGa$jsx)("div", {
        className: "Ispm-Global404",
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Global404), {})
    });
    return /*#__PURE__*/ (0, $cURGa$jsxs)((0, $cURGa$Switch1), {
        children: [
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Route), {
                exact: true,
                path: (0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES,
                render: ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $6f9384697d20a6b1$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Route), {
                exact: true,
                path: [
                    `${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_DASHBOARD}/dashboard`,
                    `${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_DASHBOARD}`
                ],
                render: ()=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $870713baf8c12df0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Route), {
                exact: true,
                path: `${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}/:userId/timeline`,
                render: ({ match: match })=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $4a886bd7812487f1$export$2e2bcd8739ae039), {
                        userId: match.params.userId
                    })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Route), {
                exact: true,
                path: `${(0, $8f460a89aa4ee4ee$export$2e2bcd8739ae039).URL_ISPM_IDENTITIES}/:userId/accessPath`,
                render: ({ match: match })=>/*#__PURE__*/ (0, $cURGa$jsx)((0, $1bb0284f656be9ad$export$2e2bcd8739ae039), {
                        userId: match.params.userId
                    })
            }),
            /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Route), {
                exact: true,
                path: "*",
                render: ()=>/*#__PURE__*/ (0, $cURGa$jsx)("div", {
                        className: "Ispm-Global404",
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$Global404), {})
                    })
            })
        ]
    });
}
function $30427897bfe14b4e$var$PagesRouteWrapper() {
    return /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$react).StrictMode, {
        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$QueryClientProvider), {
            client: $30427897bfe14b4e$var$queryClient,
            children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $08bb17136b599311$export$88fc6c4dc1f0adcc), {
                children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $a66d5c0d230a0c38$export$895d3cdbd46a9ff6), {
                    children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $670c946906b8a505$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $cURGa$jsx)((0, $cURGa$OverlayProvider), {
                            children: /*#__PURE__*/ (0, $cURGa$jsx)($30427897bfe14b4e$var$PagesRoute, {})
                        })
                    })
                })
            })
        })
    });
}
var $30427897bfe14b4e$export$2e2bcd8739ae039 = $30427897bfe14b4e$var$PagesRouteWrapper;





const $8f94b94ae1bae3c8$export$5ef3b0fd904bab84 = [
    {
        reducerPath: "ispm",
        reducer: (0, $e7b59df9ea8eb4ea$export$2e2bcd8739ae039)
    },
    {
        reducerPath: "ispmIdentity",
        reducer: (0, $8939fb7be58f56d0$export$2e2bcd8739ae039)
    },
    {
        reducerPath: "ispmCopilot",
        reducer: (0, $27fb994cf82006a6$export$2e2bcd8739ae039)
    },
    {
        reducerPath: "ispmIdentityTimeline",
        reducer: (0, $270ea330992dc44e$export$2e2bcd8739ae039)
    },
    {
        reducerPath: "identityTimelineSideCar",
        reducer: (0, $ec34473eca2d3d1f$export$2e2bcd8739ae039)
    }
];


export {$8f94b94ae1bae3c8$export$5ef3b0fd904bab84 as ispmSlices, $842e7eb45efe0ce1$export$2e2bcd8739ae039 as SaviInputField, $928329e8d2562c97$export$2e2bcd8739ae039 as SaviMenuIconButton, $12a238da3b06d4cc$export$2e2bcd8739ae039 as SaviSuggestions, $870713baf8c12df0$export$2e2bcd8739ae039 as IspmDashboard, $30427897bfe14b4e$export$2e2bcd8739ae039 as IspmRoute, $12c51e736b1437e7$export$2e2bcd8739ae039 as SaviChatOverlay, $0d5b88fa22f3ae70$export$980acd09afd54813 as IspmProvider, $0d5b88fa22f3ae70$export$1c36bb3ceee805ed as useIspmContext, $8ff2252602deef38$export$9e36388f371f5829 as initializeISPMConfig};
//# sourceMappingURL=module.js.map
